(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.UltravisorWebinterface = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports={
    "name": "fable-serviceproviderbase",
    "version": "3.0.19",
    "description": "Simple base classes for fable services.",
    "main": "source/Fable-ServiceProviderBase.js",
    "scripts": {
        "start": "node source/Fable-ServiceProviderBase.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ./tsconfig.build.json",
        "check": "tsc -p . --noEmit"
    },
    "types": "types/source/Fable-ServiceProviderBase.d.ts",
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase.git"
    },
    "keywords": [
        "entity",
        "behavior"
    ],
    "author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/fable-serviceproviderbase/issues"
    },
    "homepage": "https://github.com/stevenvelozo/fable-serviceproviderbase",
    "devDependencies": {
        "@types/mocha": "^10.0.10",
        "fable": "^3.1.62",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    }
}

},{}],2:[function(require,module,exports){
/**
* Fable Service Base
* @author <steven@velozo.com>
*/

const libPackage = require('../package.json');

class FableServiceProviderBase
{
	/**
	 * The constructor can be used in two ways:
	 * 1) With a fable, options object and service hash (the options object and service hash are optional)a
	 * 2) With an object or nothing as the first parameter, where it will be treated as the options object
	 *
	 * @param {import('fable')|Record<string, any>} [pFable] - (optional) The fable instance, or the options object if there is no fable
	 * @param {Record<string, any>|string} [pOptions] - (optional) The options object, or the service hash if there is no fable
	 * @param {string} [pServiceHash] - (optional) The service hash to identify this service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		/** @type {import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {Record<string, any>} */
		this.services;
		/** @type {Record<string, any>} */
		this.servicesMap;

		// Check if a fable was passed in; connect it if so
		if ((typeof(pFable) === 'object') && pFable.isFable)
		{
			this.connectFable(pFable);
		}
		else
		{
			this.fable = false;
		}

		// Initialize the services map if it wasn't passed in
		/** @type {Record<string, any>} */
		this._PackageFableServiceProvider = libPackage;

		// initialize options and UUID based on whether the fable was passed in or not.
		if (this.fable)
		{
			this.UUID = pFable.getUUID();
			this.options = (typeof(pOptions) === 'object') ? pOptions
							: {};
		}
		else
		{
			// With no fable, check to see if there was an object passed into either of the first two
			// Parameters, and if so, treat it as the options object
			this.options = ((typeof(pFable) === 'object') && !pFable.isFable) ? pFable
							: (typeof(pOptions) === 'object') ? pOptions
							: {};
			this.UUID = `CORE-SVC-${Math.floor((Math.random() * (99999 - 10000)) + 10000)}`
		}

		// It's expected that the deriving class will set this
		this.serviceType = `Unknown-${this.UUID}`;

		// The service hash is used to identify the specific instantiation of the service in the services map
		this.Hash = (typeof(pServiceHash) === 'string') ? pServiceHash 
					: (!this.fable && (typeof(pOptions) === 'string')) ? pOptions
					: `${this.UUID}`;
	}

	/**
	 * @param {import('fable')} pFable
	 */
	connectFable(pFable)
	{
		if ((typeof(pFable) !== 'object') || (!pFable.isFable))
		{
			let tmpErrorMessage = `Fable Service Provider Base: Cannot connect to Fable, invalid Fable object passed in.  The pFable parameter was a [${typeof(pFable)}].}`;
			console.log(tmpErrorMessage);
			return new Error(tmpErrorMessage);
		}

		if (!this.fable)
		{
			this.fable = pFable;
		}

		if (!this.log)
		{
			this.log = this.fable.Logging;
		}
		if (!this.services)
		{
			this.services = this.fable.services;
		}

		if (!this.servicesMap)
		{
			this.servicesMap = this.fable.servicesMap;
		}

		return true;
	}

	static isFableService = true;
}

module.exports = FableServiceProviderBase;

// This is left here in case we want to go back to having different code/base class for "core" services
module.exports.CoreServiceProviderBase = FableServiceProviderBase;

},{"../package.json":1}],3:[function(require,module,exports){
/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
 * Copyright (C) 2020 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.9"
/*!
 * lunr.utils
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function () {
    return this
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2020 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.empty

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2020 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
      // AMD. Register as an anonymous module.
      define(factory)
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();

},{}],4:[function(require,module,exports){
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.marked = {}));
})(this, (function (exports) { 'use strict';

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  function getDefaults() {
    return {
      async: false,
      baseUrl: null,
      breaks: false,
      extensions: null,
      gfm: true,
      headerIds: true,
      headerPrefix: '',
      highlight: null,
      hooks: null,
      langPrefix: 'language-',
      mangle: true,
      pedantic: false,
      renderer: null,
      sanitize: false,
      sanitizer: null,
      silent: false,
      smartypants: false,
      tokenizer: null,
      walkTokens: null,
      xhtml: false
    };
  }
  exports.defaults = getDefaults();
  function changeDefaults(newDefaults) {
    exports.defaults = newDefaults;
  }

  /**
   * Helpers
   */
  var escapeTest = /[&<>"']/;
  var escapeReplace = new RegExp(escapeTest.source, 'g');
  var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
  var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
  var escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };
  var getEscapeReplacement = function getEscapeReplacement(ch) {
    return escapeReplacements[ch];
  };
  function escape(html, encode) {
    if (encode) {
      if (escapeTest.test(html)) {
        return html.replace(escapeReplace, getEscapeReplacement);
      }
    } else {
      if (escapeTestNoEncode.test(html)) {
        return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
      }
    }
    return html;
  }
  var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

  /**
   * @param {string} html
   */
  function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(unescapeTest, function (_, n) {
      n = n.toLowerCase();
      if (n === 'colon') return ':';
      if (n.charAt(0) === '#') {
        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
      }
      return '';
    });
  }
  var caret = /(^|[^\[])\^/g;

  /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */
  function edit(regex, opt) {
    regex = typeof regex === 'string' ? regex : regex.source;
    opt = opt || '';
    var obj = {
      replace: function replace(name, val) {
        val = val.source || val;
        val = val.replace(caret, '$1');
        regex = regex.replace(name, val);
        return obj;
      },
      getRegex: function getRegex() {
        return new RegExp(regex, opt);
      }
    };
    return obj;
  }
  var nonWordAndColonTest = /[^\w:]/g;
  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

  /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */
  function cleanUrl(sanitize, base, href) {
    if (sanitize) {
      var prot;
      try {
        prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
      } catch (e) {
        return null;
      }
      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
        return null;
      }
    }
    if (base && !originIndependentUrl.test(href)) {
      href = resolveUrl(base, href);
    }
    try {
      href = encodeURI(href).replace(/%25/g, '%');
    } catch (e) {
      return null;
    }
    return href;
  }
  var baseUrls = {};
  var justDomain = /^[^:]+:\/*[^/]*$/;
  var protocol = /^([^:]+:)[\s\S]*$/;
  var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

  /**
   * @param {string} base
   * @param {string} href
   */
  function resolveUrl(base, href) {
    if (!baseUrls[' ' + base]) {
      // we can ignore everything in base after the last slash of its path component,
      // but we might need to add _that_
      // https://tools.ietf.org/html/rfc3986#section-3
      if (justDomain.test(base)) {
        baseUrls[' ' + base] = base + '/';
      } else {
        baseUrls[' ' + base] = rtrim(base, '/', true);
      }
    }
    base = baseUrls[' ' + base];
    var relativeBase = base.indexOf(':') === -1;
    if (href.substring(0, 2) === '//') {
      if (relativeBase) {
        return href;
      }
      return base.replace(protocol, '$1') + href;
    } else if (href.charAt(0) === '/') {
      if (relativeBase) {
        return href;
      }
      return base.replace(domain, '$1') + href;
    } else {
      return base + href;
    }
  }
  var noopTest = {
    exec: function noopTest() {}
  };
  function splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    var row = tableRow.replace(/\|/g, function (match, offset, str) {
        var escaped = false,
          curr = offset;
        while (--curr >= 0 && str[curr] === '\\') {
          escaped = !escaped;
        }
        if (escaped) {
          // odd number of slashes means | is escaped
          // so we leave it alone
          return '|';
        } else {
          // add space before unescaped |
          return ' |';
        }
      }),
      cells = row.split(/ \|/);
    var i = 0;

    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) {
      cells.shift();
    }
    if (cells.length > 0 && !cells[cells.length - 1].trim()) {
      cells.pop();
    }
    if (cells.length > count) {
      cells.splice(count);
    } else {
      while (cells.length < count) {
        cells.push('');
      }
    }
    for (; i < cells.length; i++) {
      // leading or trailing whitespace is ignored per the gfm spec
      cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    }
    return cells;
  }

  /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */
  function rtrim(str, c, invert) {
    var l = str.length;
    if (l === 0) {
      return '';
    }

    // Length of suffix matching the invert condition.
    var suffLen = 0;

    // Step left until we fail to match the invert condition.
    while (suffLen < l) {
      var currChar = str.charAt(l - suffLen - 1);
      if (currChar === c && !invert) {
        suffLen++;
      } else if (currChar !== c && invert) {
        suffLen++;
      } else {
        break;
      }
    }
    return str.slice(0, l - suffLen);
  }
  function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) {
      return -1;
    }
    var l = str.length;
    var level = 0,
      i = 0;
    for (; i < l; i++) {
      if (str[i] === '\\') {
        i++;
      } else if (str[i] === b[0]) {
        level++;
      } else if (str[i] === b[1]) {
        level--;
        if (level < 0) {
          return i;
        }
      }
    }
    return -1;
  }
  function checkSanitizeDeprecation(opt) {
    if (opt && opt.sanitize && !opt.silent) {
      console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
  }

  // copied from https://stackoverflow.com/a/5450113/806777
  /**
   * @param {string} pattern
   * @param {number} count
   */
  function repeatString(pattern, count) {
    if (count < 1) {
      return '';
    }
    var result = '';
    while (count > 1) {
      if (count & 1) {
        result += pattern;
      }
      count >>= 1;
      pattern += pattern;
    }
    return result + pattern;
  }

  function outputLink(cap, link, raw, lexer) {
    var href = link.href;
    var title = link.title ? escape(link.title) : null;
    var text = cap[1].replace(/\\([\[\]])/g, '$1');
    if (cap[0].charAt(0) !== '!') {
      lexer.state.inLink = true;
      var token = {
        type: 'link',
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer.inlineTokens(text)
      };
      lexer.state.inLink = false;
      return token;
    }
    return {
      type: 'image',
      raw: raw,
      href: href,
      title: title,
      text: escape(text)
    };
  }
  function indentCodeCompensation(raw, text) {
    var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) {
      return text;
    }
    var indentToCode = matchIndentToCode[1];
    return text.split('\n').map(function (node) {
      var matchIndentInNode = node.match(/^\s+/);
      if (matchIndentInNode === null) {
        return node;
      }
      var indentInNode = matchIndentInNode[0];
      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }
      return node;
    }).join('\n');
  }

  /**
   * Tokenizer
   */
  var Tokenizer = /*#__PURE__*/function () {
    function Tokenizer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Tokenizer.prototype;
    _proto.space = function space(src) {
      var cap = this.rules.block.newline.exec(src);
      if (cap && cap[0].length > 0) {
        return {
          type: 'space',
          raw: cap[0]
        };
      }
    };
    _proto.code = function code(src) {
      var cap = this.rules.block.code.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ {1,4}/gm, '');
        return {
          type: 'code',
          raw: cap[0],
          codeBlockStyle: 'indented',
          text: !this.options.pedantic ? rtrim(text, '\n') : text
        };
      }
    };
    _proto.fences = function fences(src) {
      var cap = this.rules.block.fences.exec(src);
      if (cap) {
        var raw = cap[0];
        var text = indentCodeCompensation(raw, cap[3] || '');
        return {
          type: 'code',
          raw: raw,
          lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
          text: text
        };
      }
    };
    _proto.heading = function heading(src) {
      var cap = this.rules.block.heading.exec(src);
      if (cap) {
        var text = cap[2].trim();

        // remove trailing #s
        if (/#$/.test(text)) {
          var trimmed = rtrim(text, '#');
          if (this.options.pedantic) {
            text = trimmed.trim();
          } else if (!trimmed || / $/.test(trimmed)) {
            // CommonMark requires space before trailing #s
            text = trimmed.trim();
          }
        }
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[1].length,
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.hr = function hr(src) {
      var cap = this.rules.block.hr.exec(src);
      if (cap) {
        return {
          type: 'hr',
          raw: cap[0]
        };
      }
    };
    _proto.blockquote = function blockquote(src) {
      var cap = this.rules.block.blockquote.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ *>[ \t]?/gm, '');
        var top = this.lexer.state.top;
        this.lexer.state.top = true;
        var tokens = this.lexer.blockTokens(text);
        this.lexer.state.top = top;
        return {
          type: 'blockquote',
          raw: cap[0],
          tokens: tokens,
          text: text
        };
      }
    };
    _proto.list = function list(src) {
      var cap = this.rules.block.list.exec(src);
      if (cap) {
        var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
        var bull = cap[1].trim();
        var isordered = bull.length > 1;
        var list = {
          type: 'list',
          raw: '',
          ordered: isordered,
          start: isordered ? +bull.slice(0, -1) : '',
          loose: false,
          items: []
        };
        bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
        if (this.options.pedantic) {
          bull = isordered ? bull : '[*+-]';
        }

        // Get next list item
        var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[\t ][^\\n]*)?(?:\\n|$))");

        // Check if current bullet point can start a new List Item
        while (src) {
          endEarly = false;
          if (!(cap = itemRegex.exec(src))) {
            break;
          }
          if (this.rules.block.hr.test(src)) {
            // End list if bullet was actually HR (possibly move into itemRegex?)
            break;
          }
          raw = cap[0];
          src = src.substring(raw.length);
          line = cap[2].split('\n', 1)[0].replace(/^\t+/, function (t) {
            return ' '.repeat(3 * t.length);
          });
          nextLine = src.split('\n', 1)[0];
          if (this.options.pedantic) {
            indent = 2;
            itemContents = line.trimLeft();
          } else {
            indent = cap[2].search(/[^ ]/); // Find first non-space char
            indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
            itemContents = line.slice(indent);
            indent += cap[1].length;
          }
          blankLine = false;
          if (!line && /^ *$/.test(nextLine)) {
            // Items begin with at most one blank line
            raw += nextLine + '\n';
            src = src.substring(nextLine.length + 1);
            endEarly = true;
          }
          if (!endEarly) {
            var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))");
            var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
            var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
            var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");

            // Check if following lines should be included in List Item
            while (src) {
              rawLine = src.split('\n', 1)[0];
              nextLine = rawLine;

              // Re-align to follow commonmark nesting rules
              if (this.options.pedantic) {
                nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
              }

              // End list item if found code fences
              if (fencesBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new heading
              if (headingBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new bullet
              if (nextBulletRegex.test(nextLine)) {
                break;
              }

              // Horizontal rule found
              if (hrRegex.test(src)) {
                break;
              }
              if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) {
                // Dedent if possible
                itemContents += '\n' + nextLine.slice(indent);
              } else {
                // not enough indentation
                if (blankLine) {
                  break;
                }

                // paragraph continuation unless last line was a different block level element
                if (line.search(/[^ ]/) >= 4) {
                  // indented code block
                  break;
                }
                if (fencesBeginRegex.test(line)) {
                  break;
                }
                if (headingBeginRegex.test(line)) {
                  break;
                }
                if (hrRegex.test(line)) {
                  break;
                }
                itemContents += '\n' + nextLine;
              }
              if (!blankLine && !nextLine.trim()) {
                // Check if current line is blank
                blankLine = true;
              }
              raw += rawLine + '\n';
              src = src.substring(rawLine.length + 1);
              line = nextLine.slice(indent);
            }
          }
          if (!list.loose) {
            // If the previous item ended with a blank line, the list is loose
            if (endsWithBlankLine) {
              list.loose = true;
            } else if (/\n *\n *$/.test(raw)) {
              endsWithBlankLine = true;
            }
          }

          // Check for task list items
          if (this.options.gfm) {
            istask = /^\[[ xX]\] /.exec(itemContents);
            if (istask) {
              ischecked = istask[0] !== '[ ] ';
              itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
            }
          }
          list.items.push({
            type: 'list_item',
            raw: raw,
            task: !!istask,
            checked: ischecked,
            loose: false,
            text: itemContents
          });
          list.raw += raw;
        }

        // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
        list.items[list.items.length - 1].raw = raw.trimRight();
        list.items[list.items.length - 1].text = itemContents.trimRight();
        list.raw = list.raw.trimRight();
        var l = list.items.length;

        // Item child tokens handled here at end because we needed to have the final item to trim it first
        for (i = 0; i < l; i++) {
          this.lexer.state.top = false;
          list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
          if (!list.loose) {
            // Check if list should be loose
            var spacers = list.items[i].tokens.filter(function (t) {
              return t.type === 'space';
            });
            var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function (t) {
              return /\n.*\n/.test(t.raw);
            });
            list.loose = hasMultipleLineBreaks;
          }
        }

        // Set all items to loose if list is loose
        if (list.loose) {
          for (i = 0; i < l; i++) {
            list.items[i].loose = true;
          }
        }
        return list;
      }
    };
    _proto.html = function html(src) {
      var cap = this.rules.block.html.exec(src);
      if (cap) {
        var token = {
          type: 'html',
          raw: cap[0],
          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
          text: cap[0]
        };
        if (this.options.sanitize) {
          var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
          token.type = 'paragraph';
          token.text = text;
          token.tokens = this.lexer.inline(text);
        }
        return token;
      }
    };
    _proto.def = function def(src) {
      var cap = this.rules.block.def.exec(src);
      if (cap) {
        var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
        var href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
        var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
        return {
          type: 'def',
          tag: tag,
          raw: cap[0],
          href: href,
          title: title
        };
      }
    };
    _proto.table = function table(src) {
      var cap = this.rules.block.table.exec(src);
      if (cap) {
        var item = {
          type: 'table',
          header: splitCells(cap[1]).map(function (c) {
            return {
              text: c
            };
          }),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
        };
        if (item.header.length === item.align.length) {
          item.raw = cap[0];
          var l = item.align.length;
          var i, j, k, row;
          for (i = 0; i < l; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }
          l = item.rows.length;
          for (i = 0; i < l; i++) {
            item.rows[i] = splitCells(item.rows[i], item.header.length).map(function (c) {
              return {
                text: c
              };
            });
          }

          // parse child tokens inside headers and cells

          // header child tokens
          l = item.header.length;
          for (j = 0; j < l; j++) {
            item.header[j].tokens = this.lexer.inline(item.header[j].text);
          }

          // cell child tokens
          l = item.rows.length;
          for (j = 0; j < l; j++) {
            row = item.rows[j];
            for (k = 0; k < row.length; k++) {
              row[k].tokens = this.lexer.inline(row[k].text);
            }
          }
          return item;
        }
      }
    };
    _proto.lheading = function lheading(src) {
      var cap = this.rules.block.lheading.exec(src);
      if (cap) {
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[2].charAt(0) === '=' ? 1 : 2,
          text: cap[1],
          tokens: this.lexer.inline(cap[1])
        };
      }
    };
    _proto.paragraph = function paragraph(src) {
      var cap = this.rules.block.paragraph.exec(src);
      if (cap) {
        var text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
        return {
          type: 'paragraph',
          raw: cap[0],
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.text = function text(src) {
      var cap = this.rules.block.text.exec(src);
      if (cap) {
        return {
          type: 'text',
          raw: cap[0],
          text: cap[0],
          tokens: this.lexer.inline(cap[0])
        };
      }
    };
    _proto.escape = function escape$1(src) {
      var cap = this.rules.inline.escape.exec(src);
      if (cap) {
        return {
          type: 'escape',
          raw: cap[0],
          text: escape(cap[1])
        };
      }
    };
    _proto.tag = function tag(src) {
      var cap = this.rules.inline.tag.exec(src);
      if (cap) {
        if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
          this.lexer.state.inLink = true;
        } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
          this.lexer.state.inLink = false;
        }
        if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = true;
        } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = false;
        }
        return {
          type: this.options.sanitize ? 'text' : 'html',
          raw: cap[0],
          inLink: this.lexer.state.inLink,
          inRawBlock: this.lexer.state.inRawBlock,
          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
        };
      }
    };
    _proto.link = function link(src) {
      var cap = this.rules.inline.link.exec(src);
      if (cap) {
        var trimmedUrl = cap[2].trim();
        if (!this.options.pedantic && /^</.test(trimmedUrl)) {
          // commonmark requires matching angle brackets
          if (!/>$/.test(trimmedUrl)) {
            return;
          }

          // ending angle bracket cannot be escaped
          var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
          if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
            return;
          }
        } else {
          // find closing parenthesis
          var lastParenIndex = findClosingBracket(cap[2], '()');
          if (lastParenIndex > -1) {
            var start = cap[0].indexOf('!') === 0 ? 5 : 4;
            var linkLen = start + cap[1].length + lastParenIndex;
            cap[2] = cap[2].substring(0, lastParenIndex);
            cap[0] = cap[0].substring(0, linkLen).trim();
            cap[3] = '';
          }
        }
        var href = cap[2];
        var title = '';
        if (this.options.pedantic) {
          // split pedantic href and title
          var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
          if (link) {
            href = link[1];
            title = link[3];
          }
        } else {
          title = cap[3] ? cap[3].slice(1, -1) : '';
        }
        href = href.trim();
        if (/^</.test(href)) {
          if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
            // pedantic allows starting angle bracket without ending angle bracket
            href = href.slice(1);
          } else {
            href = href.slice(1, -1);
          }
        }
        return outputLink(cap, {
          href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
          title: title ? title.replace(this.rules.inline._escapes, '$1') : title
        }, cap[0], this.lexer);
      }
    };
    _proto.reflink = function reflink(src, links) {
      var cap;
      if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
        var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
        link = links[link.toLowerCase()];
        if (!link) {
          var text = cap[0].charAt(0);
          return {
            type: 'text',
            raw: text,
            text: text
          };
        }
        return outputLink(cap, link, cap[0], this.lexer);
      }
    };
    _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
      if (prevChar === void 0) {
        prevChar = '';
      }
      var match = this.rules.inline.emStrong.lDelim.exec(src);
      if (!match) return;

      // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
      if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
      var nextChar = match[1] || match[2] || '';
      if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
        var lLength = match[0].length - 1;
        var rDelim,
          rLength,
          delimTotal = lLength,
          midDelimTotal = 0;
        var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
        endReg.lastIndex = 0;

        // Clip maskedSrc to same section of string as src (move to lexer?)
        maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
        while ((match = endReg.exec(maskedSrc)) != null) {
          rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
          if (!rDelim) continue; // skip single * in __abc*abc__

          rLength = rDelim.length;
          if (match[3] || match[4]) {
            // found another Left Delim
            delimTotal += rLength;
            continue;
          } else if (match[5] || match[6]) {
            // either Left or Right Delim
            if (lLength % 3 && !((lLength + rLength) % 3)) {
              midDelimTotal += rLength;
              continue; // CommonMark Emphasis Rules 9-10
            }
          }

          delimTotal -= rLength;
          if (delimTotal > 0) continue; // Haven't found enough closing delimiters

          // Remove extra characters. *a*** -> *a*
          rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
          var raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);

          // Create `em` if smallest delimiter has odd char count. *a***
          if (Math.min(lLength, rLength) % 2) {
            var _text = raw.slice(1, -1);
            return {
              type: 'em',
              raw: raw,
              text: _text,
              tokens: this.lexer.inlineTokens(_text)
            };
          }

          // Create 'strong' if smallest delimiter has even char count. **a***
          var text = raw.slice(2, -2);
          return {
            type: 'strong',
            raw: raw,
            text: text,
            tokens: this.lexer.inlineTokens(text)
          };
        }
      }
    };
    _proto.codespan = function codespan(src) {
      var cap = this.rules.inline.code.exec(src);
      if (cap) {
        var text = cap[2].replace(/\n/g, ' ');
        var hasNonSpaceChars = /[^ ]/.test(text);
        var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
        if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
          text = text.substring(1, text.length - 1);
        }
        text = escape(text, true);
        return {
          type: 'codespan',
          raw: cap[0],
          text: text
        };
      }
    };
    _proto.br = function br(src) {
      var cap = this.rules.inline.br.exec(src);
      if (cap) {
        return {
          type: 'br',
          raw: cap[0]
        };
      }
    };
    _proto.del = function del(src) {
      var cap = this.rules.inline.del.exec(src);
      if (cap) {
        return {
          type: 'del',
          raw: cap[0],
          text: cap[2],
          tokens: this.lexer.inlineTokens(cap[2])
        };
      }
    };
    _proto.autolink = function autolink(src, mangle) {
      var cap = this.rules.inline.autolink.exec(src);
      if (cap) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
          href = 'mailto:' + text;
        } else {
          text = escape(cap[1]);
          href = text;
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.url = function url(src, mangle) {
      var cap;
      if (cap = this.rules.inline.url.exec(src)) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
          href = 'mailto:' + text;
        } else {
          // do extended autolink path validation
          var prevCapZero;
          do {
            prevCapZero = cap[0];
            cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
          } while (prevCapZero !== cap[0]);
          text = escape(cap[0]);
          if (cap[1] === 'www.') {
            href = 'http://' + cap[0];
          } else {
            href = cap[0];
          }
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.inlineText = function inlineText(src, smartypants) {
      var cap = this.rules.inline.text.exec(src);
      if (cap) {
        var text;
        if (this.lexer.state.inRawBlock) {
          text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
        } else {
          text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
        }
        return {
          type: 'text',
          raw: cap[0],
          text: text
        };
      }
    };
    return Tokenizer;
  }();

  /**
   * Block-Level Grammar
   */
  var block = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
    hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
    html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
    def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
    table: noopTest,
    lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
    text: /^[^\n]+/
  };
  block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
  block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
  block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
  block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
  block._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
  block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
  block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
  block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();

  /**
   * Normal Block Grammar
   */

  block.normal = _extends({}, block);

  /**
   * GFM Block Grammar
   */

  block.gfm = _extends({}, block.normal, {
    table: '^ *([^\\n ].*\\|.*)\\n' // Header
    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
  });

  block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();
  block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('table', block.gfm.table) // interrupt paragraphs with table
  .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */

  block.pedantic = _extends({}, block.normal, {
    html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
  });

  /**
   * Inline-Level Grammar
   */
  var inline = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noopTest,
    tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
    // CDATA section
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(ref)\]/,
    nolink: /^!?\[(ref)\](?:\[\])?/,
    reflinkSearch: 'reflink|nolink(?!\\()',
    emStrong: {
      lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
      //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
      //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
      rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
      rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
    },

    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noopTest,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^([\spunctuation])/
  };

  // list of punctuation marks from CommonMark spec
  // without * and _ to handle the different emphasis markers * and _
  inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
  inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();

  // sequences em should skip over [title](link), `code`, <html>
  inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
  // lookbehind is not available on Safari as of version 16
  // inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
  inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
  inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
  inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g').replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g').replace(/punct/g, inline._punctuation).getRegex();
  inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
  inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
  inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
  inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
  inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
  inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
  inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
  inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
  inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
  inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();

  /**
   * Normal Inline Grammar
   */

  inline.normal = _extends({}, inline);

  /**
   * Pedantic Inline Grammar
   */

  inline.pedantic = _extends({}, inline.normal, {
    strong: {
      start: /^__|\*\*/,
      middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
      endAst: /\*\*(?!\*)/g,
      endUnd: /__(?!_)/g
    },
    em: {
      start: /^_|\*/,
      middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
      endAst: /\*(?!\*)/g,
      endUnd: /_(?!_)/g
    },
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
  });

  /**
   * GFM Inline Grammar
   */

  inline.gfm = _extends({}, inline.normal, {
    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
  });
  inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
  /**
   * GFM + Line Breaks Inline Grammar
   */

  inline.breaks = _extends({}, inline.gfm, {
    br: edit(inline.br).replace('{2,}', '*').getRegex(),
    text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
  });

  /**
   * smartypants text replacement
   * @param {string} text
   */
  function smartypants(text) {
    return text
    // em-dashes
    .replace(/---/g, "\u2014")
    // en-dashes
    .replace(/--/g, "\u2013")
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")
    // closing singles & apostrophes
    .replace(/'/g, "\u2019")
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")
    // closing doubles
    .replace(/"/g, "\u201D")
    // ellipses
    .replace(/\.{3}/g, "\u2026");
  }

  /**
   * mangle email addresses
   * @param {string} text
   */
  function mangle(text) {
    var out = '',
      i,
      ch;
    var l = text.length;
    for (i = 0; i < l; i++) {
      ch = text.charCodeAt(i);
      if (Math.random() > 0.5) {
        ch = 'x' + ch.toString(16);
      }
      out += '&#' + ch + ';';
    }
    return out;
  }

  /**
   * Block Lexer
   */
  var Lexer = /*#__PURE__*/function () {
    function Lexer(options) {
      this.tokens = [];
      this.tokens.links = Object.create(null);
      this.options = options || exports.defaults;
      this.options.tokenizer = this.options.tokenizer || new Tokenizer();
      this.tokenizer = this.options.tokenizer;
      this.tokenizer.options = this.options;
      this.tokenizer.lexer = this;
      this.inlineQueue = [];
      this.state = {
        inLink: false,
        inRawBlock: false,
        top: true
      };
      var rules = {
        block: block.normal,
        inline: inline.normal
      };
      if (this.options.pedantic) {
        rules.block = block.pedantic;
        rules.inline = inline.pedantic;
      } else if (this.options.gfm) {
        rules.block = block.gfm;
        if (this.options.breaks) {
          rules.inline = inline.breaks;
        } else {
          rules.inline = inline.gfm;
        }
      }
      this.tokenizer.rules = rules;
    }

    /**
     * Expose Rules
     */
    /**
     * Static Lex Method
     */
    Lexer.lex = function lex(src, options) {
      var lexer = new Lexer(options);
      return lexer.lex(src);
    }

    /**
     * Static Lex Inline Method
     */;
    Lexer.lexInline = function lexInline(src, options) {
      var lexer = new Lexer(options);
      return lexer.inlineTokens(src);
    }

    /**
     * Preprocessing
     */;
    var _proto = Lexer.prototype;
    _proto.lex = function lex(src) {
      src = src.replace(/\r\n|\r/g, '\n');
      this.blockTokens(src, this.tokens);
      var next;
      while (next = this.inlineQueue.shift()) {
        this.inlineTokens(next.src, next.tokens);
      }
      return this.tokens;
    }

    /**
     * Lexing
     */;
    _proto.blockTokens = function blockTokens(src, tokens) {
      var _this = this;
      if (tokens === void 0) {
        tokens = [];
      }
      if (this.options.pedantic) {
        src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
      } else {
        src = src.replace(/^( *)(\t+)/gm, function (_, leading, tabs) {
          return leading + '    '.repeat(tabs.length);
        });
      }
      var token, lastToken, cutSrc, lastParagraphClipped;
      while (src) {
        if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          continue;
        }

        // newline
        if (token = this.tokenizer.space(src)) {
          src = src.substring(token.raw.length);
          if (token.raw.length === 1 && tokens.length > 0) {
            // if there's a single \n as a spacer, it's terminating the last line,
            // so move it there so that we don't get unecessary paragraph tags
            tokens[tokens.length - 1].raw += '\n';
          } else {
            tokens.push(token);
          }
          continue;
        }

        // code
        if (token = this.tokenizer.code(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          // An indented code block cannot interrupt a paragraph.
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // fences
        if (token = this.tokenizer.fences(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // heading
        if (token = this.tokenizer.heading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // hr
        if (token = this.tokenizer.hr(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // blockquote
        if (token = this.tokenizer.blockquote(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // list
        if (token = this.tokenizer.list(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // html
        if (token = this.tokenizer.html(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // def
        if (token = this.tokenizer.def(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.raw;
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else if (!this.tokens.links[token.tag]) {
            this.tokens.links[token.tag] = {
              href: token.href,
              title: token.title
            };
          }
          continue;
        }

        // table (gfm)
        if (token = this.tokenizer.table(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // lheading
        if (token = this.tokenizer.lheading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // top-level paragraph
        // prevent paragraph consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (this.options.extensions && this.options.extensions.startBlock) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;
            _this.options.extensions.startBlock.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call({
                lexer: this
              }, tempSrc);
              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }
        if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
          lastToken = tokens[tokens.length - 1];
          if (lastParagraphClipped && lastToken.type === 'paragraph') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue.pop();
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          lastParagraphClipped = cutSrc.length !== src.length;
          src = src.substring(token.raw.length);
          continue;
        }

        // text
        if (token = this.tokenizer.text(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            this.inlineQueue.pop();
            this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          continue;
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }
      this.state.top = true;
      return tokens;
    };
    _proto.inline = function inline(src, tokens) {
      if (tokens === void 0) {
        tokens = [];
      }
      this.inlineQueue.push({
        src: src,
        tokens: tokens
      });
      return tokens;
    }

    /**
     * Lexing/Compiling
     */;
    _proto.inlineTokens = function inlineTokens(src, tokens) {
      var _this2 = this;
      if (tokens === void 0) {
        tokens = [];
      }
      var token, lastToken, cutSrc;

      // String with links masked to avoid interference with em and strong
      var maskedSrc = src;
      var match;
      var keepPrevChar, prevChar;

      // Mask out reflinks
      if (this.tokens.links) {
        var links = Object.keys(this.tokens.links);
        if (links.length > 0) {
          while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
            if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
              maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
          }
        }
      }
      // Mask out other blocks
      while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
      }

      // Mask out escaped em & strong delimiters
      while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
      }
      while (src) {
        if (!keepPrevChar) {
          prevChar = '';
        }
        keepPrevChar = false;

        // extensions
        if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this2
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          continue;
        }

        // escape
        if (token = this.tokenizer.escape(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // tag
        if (token = this.tokenizer.tag(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // link
        if (token = this.tokenizer.link(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // reflink, nolink
        if (token = this.tokenizer.reflink(src, this.tokens.links)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }

        // em & strong
        if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // code
        if (token = this.tokenizer.codespan(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // br
        if (token = this.tokenizer.br(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // del (gfm)
        if (token = this.tokenizer.del(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // autolink
        if (token = this.tokenizer.autolink(src, mangle)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // url (gfm)
        if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        }

        // text
        // prevent inlineText consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (this.options.extensions && this.options.extensions.startInline) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;
            _this2.options.extensions.startInline.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call({
                lexer: this
              }, tempSrc);
              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });
            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }
        if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
          src = src.substring(token.raw.length);
          if (token.raw.slice(-1) !== '_') {
            // Track prevChar before string of ____ started
            prevChar = token.raw.slice(-1);
          }
          keepPrevChar = true;
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          continue;
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }
      return tokens;
    };
    _createClass(Lexer, null, [{
      key: "rules",
      get: function get() {
        return {
          block: block,
          inline: inline
        };
      }
    }]);
    return Lexer;
  }();

  /**
   * Renderer
   */
  var Renderer = /*#__PURE__*/function () {
    function Renderer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Renderer.prototype;
    _proto.code = function code(_code, infostring, escaped) {
      var lang = (infostring || '').match(/\S*/)[0];
      if (this.options.highlight) {
        var out = this.options.highlight(_code, lang);
        if (out != null && out !== _code) {
          escaped = true;
          _code = out;
        }
      }
      _code = _code.replace(/\n$/, '') + '\n';
      if (!lang) {
        return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
      }
      return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
    }

    /**
     * @param {string} quote
     */;
    _proto.blockquote = function blockquote(quote) {
      return "<blockquote>\n" + quote + "</blockquote>\n";
    };
    _proto.html = function html(_html) {
      return _html;
    }

    /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */;
    _proto.heading = function heading(text, level, raw, slugger) {
      if (this.options.headerIds) {
        var id = this.options.headerPrefix + slugger.slug(raw);
        return "<h" + level + " id=\"" + id + "\">" + text + "</h" + level + ">\n";
      }

      // ignore IDs
      return "<h" + level + ">" + text + "</h" + level + ">\n";
    };
    _proto.hr = function hr() {
      return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
    };
    _proto.list = function list(body, ordered, start) {
      var type = ordered ? 'ol' : 'ul',
        startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
      return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
    }

    /**
     * @param {string} text
     */;
    _proto.listitem = function listitem(text) {
      return "<li>" + text + "</li>\n";
    };
    _proto.checkbox = function checkbox(checked) {
      return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
    }

    /**
     * @param {string} text
     */;
    _proto.paragraph = function paragraph(text) {
      return "<p>" + text + "</p>\n";
    }

    /**
     * @param {string} header
     * @param {string} body
     */;
    _proto.table = function table(header, body) {
      if (body) body = "<tbody>" + body + "</tbody>";
      return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
    }

    /**
     * @param {string} content
     */;
    _proto.tablerow = function tablerow(content) {
      return "<tr>\n" + content + "</tr>\n";
    };
    _proto.tablecell = function tablecell(content, flags) {
      var type = flags.header ? 'th' : 'td';
      var tag = flags.align ? "<" + type + " align=\"" + flags.align + "\">" : "<" + type + ">";
      return tag + content + ("</" + type + ">\n");
    }

    /**
     * span level renderer
     * @param {string} text
     */;
    _proto.strong = function strong(text) {
      return "<strong>" + text + "</strong>";
    }

    /**
     * @param {string} text
     */;
    _proto.em = function em(text) {
      return "<em>" + text + "</em>";
    }

    /**
     * @param {string} text
     */;
    _proto.codespan = function codespan(text) {
      return "<code>" + text + "</code>";
    };
    _proto.br = function br() {
      return this.options.xhtml ? '<br/>' : '<br>';
    }

    /**
     * @param {string} text
     */;
    _proto.del = function del(text) {
      return "<del>" + text + "</del>";
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.link = function link(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = '<a href="' + href + '"';
      if (title) {
        out += ' title="' + title + '"';
      }
      out += '>' + text + '</a>';
      return out;
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.image = function image(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = "<img src=\"" + href + "\" alt=\"" + text + "\"";
      if (title) {
        out += " title=\"" + title + "\"";
      }
      out += this.options.xhtml ? '/>' : '>';
      return out;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    return Renderer;
  }();

  /**
   * TextRenderer
   * returns only the textual part of the token
   */
  var TextRenderer = /*#__PURE__*/function () {
    function TextRenderer() {}
    var _proto = TextRenderer.prototype;
    // no need for block level renderers
    _proto.strong = function strong(text) {
      return text;
    };
    _proto.em = function em(text) {
      return text;
    };
    _proto.codespan = function codespan(text) {
      return text;
    };
    _proto.del = function del(text) {
      return text;
    };
    _proto.html = function html(text) {
      return text;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    _proto.link = function link(href, title, text) {
      return '' + text;
    };
    _proto.image = function image(href, title, text) {
      return '' + text;
    };
    _proto.br = function br() {
      return '';
    };
    return TextRenderer;
  }();

  /**
   * Slugger generates header id
   */
  var Slugger = /*#__PURE__*/function () {
    function Slugger() {
      this.seen = {};
    }

    /**
     * @param {string} value
     */
    var _proto = Slugger.prototype;
    _proto.serialize = function serialize(value) {
      return value.toLowerCase().trim()
      // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '')
      // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
    }

    /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */;
    _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
      var slug = originalSlug;
      var occurenceAccumulator = 0;
      if (this.seen.hasOwnProperty(slug)) {
        occurenceAccumulator = this.seen[originalSlug];
        do {
          occurenceAccumulator++;
          slug = originalSlug + '-' + occurenceAccumulator;
        } while (this.seen.hasOwnProperty(slug));
      }
      if (!isDryRun) {
        this.seen[originalSlug] = occurenceAccumulator;
        this.seen[slug] = 0;
      }
      return slug;
    }

    /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */;
    _proto.slug = function slug(value, options) {
      if (options === void 0) {
        options = {};
      }
      var slug = this.serialize(value);
      return this.getNextSafeSlug(slug, options.dryrun);
    };
    return Slugger;
  }();

  /**
   * Parsing & Compiling
   */
  var Parser = /*#__PURE__*/function () {
    function Parser(options) {
      this.options = options || exports.defaults;
      this.options.renderer = this.options.renderer || new Renderer();
      this.renderer = this.options.renderer;
      this.renderer.options = this.options;
      this.textRenderer = new TextRenderer();
      this.slugger = new Slugger();
    }

    /**
     * Static Parse Method
     */
    Parser.parse = function parse(tokens, options) {
      var parser = new Parser(options);
      return parser.parse(tokens);
    }

    /**
     * Static Parse Inline Method
     */;
    Parser.parseInline = function parseInline(tokens, options) {
      var parser = new Parser(options);
      return parser.parseInline(tokens);
    }

    /**
     * Parse Loop
     */;
    var _proto = Parser.prototype;
    _proto.parse = function parse(tokens, top) {
      if (top === void 0) {
        top = true;
      }
      var out = '',
        i,
        j,
        k,
        l2,
        l3,
        row,
        cell,
        header,
        body,
        token,
        ordered,
        start,
        loose,
        itemBody,
        item,
        checked,
        task,
        checkbox,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'space':
            {
              continue;
            }
          case 'hr':
            {
              out += this.renderer.hr();
              continue;
            }
          case 'heading':
            {
              out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
              continue;
            }
          case 'code':
            {
              out += this.renderer.code(token.text, token.lang, token.escaped);
              continue;
            }
          case 'table':
            {
              header = '';

              // header
              cell = '';
              l2 = token.header.length;
              for (j = 0; j < l2; j++) {
                cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                  header: true,
                  align: token.align[j]
                });
              }
              header += this.renderer.tablerow(cell);
              body = '';
              l2 = token.rows.length;
              for (j = 0; j < l2; j++) {
                row = token.rows[j];
                cell = '';
                l3 = row.length;
                for (k = 0; k < l3; k++) {
                  cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                    header: false,
                    align: token.align[k]
                  });
                }
                body += this.renderer.tablerow(cell);
              }
              out += this.renderer.table(header, body);
              continue;
            }
          case 'blockquote':
            {
              body = this.parse(token.tokens);
              out += this.renderer.blockquote(body);
              continue;
            }
          case 'list':
            {
              ordered = token.ordered;
              start = token.start;
              loose = token.loose;
              l2 = token.items.length;
              body = '';
              for (j = 0; j < l2; j++) {
                item = token.items[j];
                checked = item.checked;
                task = item.task;
                itemBody = '';
                if (item.task) {
                  checkbox = this.renderer.checkbox(checked);
                  if (loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                      item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                      if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                      }
                    } else {
                      item.tokens.unshift({
                        type: 'text',
                        text: checkbox
                      });
                    }
                  } else {
                    itemBody += checkbox;
                  }
                }
                itemBody += this.parse(item.tokens, loose);
                body += this.renderer.listitem(itemBody, task, checked);
              }
              out += this.renderer.list(body, ordered, start);
              continue;
            }
          case 'html':
            {
              // TODO parse inline content if parameter markdown=1
              out += this.renderer.html(token.text);
              continue;
            }
          case 'paragraph':
            {
              out += this.renderer.paragraph(this.parseInline(token.tokens));
              continue;
            }
          case 'text':
            {
              body = token.tokens ? this.parseInline(token.tokens) : token.text;
              while (i + 1 < l && tokens[i + 1].type === 'text') {
                token = tokens[++i];
                body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
              }
              out += top ? this.renderer.paragraph(body) : body;
              continue;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    }

    /**
     * Parse Inline Tokens
     */;
    _proto.parseInline = function parseInline(tokens, renderer) {
      renderer = renderer || this.renderer;
      var out = '',
        i,
        token,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'escape':
            {
              out += renderer.text(token.text);
              break;
            }
          case 'html':
            {
              out += renderer.html(token.text);
              break;
            }
          case 'link':
            {
              out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
              break;
            }
          case 'image':
            {
              out += renderer.image(token.href, token.title, token.text);
              break;
            }
          case 'strong':
            {
              out += renderer.strong(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'em':
            {
              out += renderer.em(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'codespan':
            {
              out += renderer.codespan(token.text);
              break;
            }
          case 'br':
            {
              out += renderer.br();
              break;
            }
          case 'del':
            {
              out += renderer.del(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'text':
            {
              out += renderer.text(token.text);
              break;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    };
    return Parser;
  }();

  var Hooks = /*#__PURE__*/function () {
    function Hooks(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Hooks.prototype;
    /**
     * Process markdown before marked
     */
    _proto.preprocess = function preprocess(markdown) {
      return markdown;
    }

    /**
     * Process HTML after marked is finished
     */;
    _proto.postprocess = function postprocess(html) {
      return html;
    };
    return Hooks;
  }();
  Hooks.passThroughHooks = new Set(['preprocess', 'postprocess']);

  function onError(silent, async, callback) {
    return function (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
      if (silent) {
        var msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
        if (async) {
          return Promise.resolve(msg);
        }
        if (callback) {
          callback(null, msg);
          return;
        }
        return msg;
      }
      if (async) {
        return Promise.reject(e);
      }
      if (callback) {
        callback(e);
        return;
      }
      throw e;
    };
  }
  function parseMarkdown(lexer, parser) {
    return function (src, opt, callback) {
      if (typeof opt === 'function') {
        callback = opt;
        opt = null;
      }
      var origOpt = _extends({}, opt);
      opt = _extends({}, marked.defaults, origOpt);
      var throwError = onError(opt.silent, opt.async, callback);

      // throw error in case of non string input
      if (typeof src === 'undefined' || src === null) {
        return throwError(new Error('marked(): input parameter is undefined or null'));
      }
      if (typeof src !== 'string') {
        return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
      }
      checkSanitizeDeprecation(opt);
      if (opt.hooks) {
        opt.hooks.options = opt;
      }
      if (callback) {
        var highlight = opt.highlight;
        var tokens;
        try {
          if (opt.hooks) {
            src = opt.hooks.preprocess(src);
          }
          tokens = lexer(src, opt);
        } catch (e) {
          return throwError(e);
        }
        var done = function done(err) {
          var out;
          if (!err) {
            try {
              if (opt.walkTokens) {
                marked.walkTokens(tokens, opt.walkTokens);
              }
              out = parser(tokens, opt);
              if (opt.hooks) {
                out = opt.hooks.postprocess(out);
              }
            } catch (e) {
              err = e;
            }
          }
          opt.highlight = highlight;
          return err ? throwError(err) : callback(null, out);
        };
        if (!highlight || highlight.length < 3) {
          return done();
        }
        delete opt.highlight;
        if (!tokens.length) return done();
        var pending = 0;
        marked.walkTokens(tokens, function (token) {
          if (token.type === 'code') {
            pending++;
            setTimeout(function () {
              highlight(token.text, token.lang, function (err, code) {
                if (err) {
                  return done(err);
                }
                if (code != null && code !== token.text) {
                  token.text = code;
                  token.escaped = true;
                }
                pending--;
                if (pending === 0) {
                  done();
                }
              });
            }, 0);
          }
        });
        if (pending === 0) {
          done();
        }
        return;
      }
      if (opt.async) {
        return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function (src) {
          return lexer(src, opt);
        }).then(function (tokens) {
          return opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(function () {
            return tokens;
          }) : tokens;
        }).then(function (tokens) {
          return parser(tokens, opt);
        }).then(function (html) {
          return opt.hooks ? opt.hooks.postprocess(html) : html;
        })["catch"](throwError);
      }
      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        var _tokens = lexer(src, opt);
        if (opt.walkTokens) {
          marked.walkTokens(_tokens, opt.walkTokens);
        }
        var html = parser(_tokens, opt);
        if (opt.hooks) {
          html = opt.hooks.postprocess(html);
        }
        return html;
      } catch (e) {
        return throwError(e);
      }
    };
  }

  /**
   * Marked
   */
  function marked(src, opt, callback) {
    return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
  }

  /**
   * Options
   */

  marked.options = marked.setOptions = function (opt) {
    marked.defaults = _extends({}, marked.defaults, opt);
    changeDefaults(marked.defaults);
    return marked;
  };
  marked.getDefaults = getDefaults;
  marked.defaults = exports.defaults;

  /**
   * Use Extension
   */

  marked.use = function () {
    var extensions = marked.defaults.extensions || {
      renderers: {},
      childTokens: {}
    };
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    args.forEach(function (pack) {
      // copy options to new object
      var opts = _extends({}, pack);

      // set async to true if it was set to true before
      opts.async = marked.defaults.async || opts.async || false;

      // ==-- Parse "addon" extensions --== //
      if (pack.extensions) {
        pack.extensions.forEach(function (ext) {
          if (!ext.name) {
            throw new Error('extension name required');
          }
          if (ext.renderer) {
            // Renderer extensions
            var prevRenderer = extensions.renderers[ext.name];
            if (prevRenderer) {
              // Replace extension with func to run new extension but fall back if false
              extensions.renderers[ext.name] = function () {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = arguments[_key2];
                }
                var ret = ext.renderer.apply(this, args);
                if (ret === false) {
                  ret = prevRenderer.apply(this, args);
                }
                return ret;
              };
            } else {
              extensions.renderers[ext.name] = ext.renderer;
            }
          }
          if (ext.tokenizer) {
            // Tokenizer Extensions
            if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') {
              throw new Error("extension level must be 'block' or 'inline'");
            }
            if (extensions[ext.level]) {
              extensions[ext.level].unshift(ext.tokenizer);
            } else {
              extensions[ext.level] = [ext.tokenizer];
            }
            if (ext.start) {
              // Function to check for start of token
              if (ext.level === 'block') {
                if (extensions.startBlock) {
                  extensions.startBlock.push(ext.start);
                } else {
                  extensions.startBlock = [ext.start];
                }
              } else if (ext.level === 'inline') {
                if (extensions.startInline) {
                  extensions.startInline.push(ext.start);
                } else {
                  extensions.startInline = [ext.start];
                }
              }
            }
          }
          if (ext.childTokens) {
            // Child tokens to be visited by walkTokens
            extensions.childTokens[ext.name] = ext.childTokens;
          }
        });
        opts.extensions = extensions;
      }

      // ==-- Parse "overwrite" extensions --== //
      if (pack.renderer) {
        (function () {
          var renderer = marked.defaults.renderer || new Renderer();
          var _loop = function _loop(prop) {
            var prevRenderer = renderer[prop];
            // Replace renderer with func to run extension, but fall back if false
            renderer[prop] = function () {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }
              var ret = pack.renderer[prop].apply(renderer, args);
              if (ret === false) {
                ret = prevRenderer.apply(renderer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.renderer) {
            _loop(prop);
          }
          opts.renderer = renderer;
        })();
      }
      if (pack.tokenizer) {
        (function () {
          var tokenizer = marked.defaults.tokenizer || new Tokenizer();
          var _loop2 = function _loop2(prop) {
            var prevTokenizer = tokenizer[prop];
            // Replace tokenizer with func to run extension, but fall back if false
            tokenizer[prop] = function () {
              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }
              var ret = pack.tokenizer[prop].apply(tokenizer, args);
              if (ret === false) {
                ret = prevTokenizer.apply(tokenizer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.tokenizer) {
            _loop2(prop);
          }
          opts.tokenizer = tokenizer;
        })();
      }

      // ==-- Parse Hooks extensions --== //
      if (pack.hooks) {
        (function () {
          var hooks = marked.defaults.hooks || new Hooks();
          var _loop3 = function _loop3(prop) {
            var prevHook = hooks[prop];
            if (Hooks.passThroughHooks.has(prop)) {
              hooks[prop] = function (arg) {
                if (marked.defaults.async) {
                  return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(function (ret) {
                    return prevHook.call(hooks, ret);
                  });
                }
                var ret = pack.hooks[prop].call(hooks, arg);
                return prevHook.call(hooks, ret);
              };
            } else {
              hooks[prop] = function () {
                for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = arguments[_key5];
                }
                var ret = pack.hooks[prop].apply(hooks, args);
                if (ret === false) {
                  ret = prevHook.apply(hooks, args);
                }
                return ret;
              };
            }
          };
          for (var prop in pack.hooks) {
            _loop3(prop);
          }
          opts.hooks = hooks;
        })();
      }

      // ==-- Parse WalkTokens extensions --== //
      if (pack.walkTokens) {
        var _walkTokens = marked.defaults.walkTokens;
        opts.walkTokens = function (token) {
          var values = [];
          values.push(pack.walkTokens.call(this, token));
          if (_walkTokens) {
            values = values.concat(_walkTokens.call(this, token));
          }
          return values;
        };
      }
      marked.setOptions(opts);
    });
  };

  /**
   * Run callback for every token
   */

  marked.walkTokens = function (tokens, callback) {
    var values = [];
    var _loop4 = function _loop4() {
      var token = _step.value;
      values = values.concat(callback.call(marked, token));
      switch (token.type) {
        case 'table':
          {
            for (var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;) {
              var cell = _step2.value;
              values = values.concat(marked.walkTokens(cell.tokens, callback));
            }
            for (var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;) {
              var row = _step3.value;
              for (var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;) {
                var _cell = _step4.value;
                values = values.concat(marked.walkTokens(_cell.tokens, callback));
              }
            }
            break;
          }
        case 'list':
          {
            values = values.concat(marked.walkTokens(token.items, callback));
            break;
          }
        default:
          {
            if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) {
              // Walk any extensions
              marked.defaults.extensions.childTokens[token.type].forEach(function (childTokens) {
                values = values.concat(marked.walkTokens(token[childTokens], callback));
              });
            } else if (token.tokens) {
              values = values.concat(marked.walkTokens(token.tokens, callback));
            }
          }
      }
    };
    for (var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;) {
      _loop4();
    }
    return values;
  };

  /**
   * Parse Inline
   * @param {string} src
   */
  marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);

  /**
   * Expose
   */
  marked.Parser = Parser;
  marked.parser = Parser.parse;
  marked.Renderer = Renderer;
  marked.TextRenderer = TextRenderer;
  marked.Lexer = Lexer;
  marked.lexer = Lexer.lex;
  marked.Tokenizer = Tokenizer;
  marked.Slugger = Slugger;
  marked.Hooks = Hooks;
  marked.parse = marked;
  var options = marked.options;
  var setOptions = marked.setOptions;
  var use = marked.use;
  var walkTokens = marked.walkTokens;
  var parseInline = marked.parseInline;
  var parse = marked;
  var parser = Parser.parse;
  var lexer = Lexer.lex;

  exports.Hooks = Hooks;
  exports.Lexer = Lexer;
  exports.Parser = Parser;
  exports.Renderer = Renderer;
  exports.Slugger = Slugger;
  exports.TextRenderer = TextRenderer;
  exports.Tokenizer = Tokenizer;
  exports.getDefaults = getDefaults;
  exports.lexer = lexer;
  exports.marked = marked;
  exports.options = options;
  exports.parse = parse;
  exports.parseInline = parseInline;
  exports.parser = parser;
  exports.setOptions = setOptions;
  exports.use = use;
  exports.walkTokens = walkTokens;

}));

},{}],5:[function(require,module,exports){
!function(t,n){"object"==typeof exports&&"object"==typeof module?module.exports=n():"function"==typeof define&&define.amd?define("Navigo",[],n):"object"==typeof exports?exports.Navigo=n():t.Navigo=n()}("undefined"!=typeof self?self:this,(function(){return function(){"use strict";var t={407:function(t,n,e){e.d(n,{default:function(){return N}});var o=/([:*])(\w+)/g,r=/\*/g,i=/\/\?/g;function a(t){return void 0===t&&(t="/"),v()?location.pathname+location.search+location.hash:t}function s(t){return t.replace(/\/+$/,"").replace(/^\/+/,"")}function c(t){return"string"==typeof t}function u(t){return t&&t.indexOf("#")>=0&&t.split("#").pop()||""}function h(t){var n=s(t).split(/\?(.*)?$/);return[s(n[0]),n.slice(1).join("")]}function f(t){for(var n={},e=t.split("&"),o=0;o<e.length;o++){var r=e[o].split("=");if(""!==r[0]){var i=decodeURIComponent(r[0]);n[i]?(Array.isArray(n[i])||(n[i]=[n[i]]),n[i].push(decodeURIComponent(r[1]||""))):n[i]=decodeURIComponent(r[1]||"")}}return n}function l(t,n){var e,a=h(s(t.currentLocationPath)),l=a[0],p=a[1],d=""===p?null:f(p),v=[];if(c(n.path)){if(e="(?:/^|^)"+s(n.path).replace(o,(function(t,n,e){return v.push(e),"([^/]+)"})).replace(r,"?(?:.*)").replace(i,"/?([^/]+|)")+"$",""===s(n.path)&&""===s(l))return{url:l,queryString:p,hashString:u(t.to),route:n,data:null,params:d}}else e=n.path;var g=new RegExp(e,""),m=l.match(g);if(m){var y=c(n.path)?function(t,n){return 0===n.length?null:t?t.slice(1,t.length).reduce((function(t,e,o){return null===t&&(t={}),t[n[o]]=decodeURIComponent(e),t}),null):null}(m,v):m.groups?m.groups:m.slice(1);return{url:s(l.replace(new RegExp("^"+t.instance.root),"")),queryString:p,hashString:u(t.to),route:n,data:y,params:d}}return!1}function p(){return!("undefined"==typeof window||!window.history||!window.history.pushState)}function d(t,n){return void 0===t[n]||!0===t[n]}function v(){return"undefined"!=typeof window}function g(t,n){return void 0===t&&(t=[]),void 0===n&&(n={}),t.filter((function(t){return t})).forEach((function(t){["before","after","already","leave"].forEach((function(e){t[e]&&(n[e]||(n[e]=[]),n[e].push(t[e]))}))})),n}function m(t,n,e){var o=n||{},r=0;!function n(){t[r]?Array.isArray(t[r])?(t.splice.apply(t,[r,1].concat(t[r][0](o)?t[r][1]:t[r][2])),n()):t[r](o,(function(t){void 0===t||!0===t?(r+=1,n()):e&&e(o)})):e&&e(o)}()}function y(t,n){void 0===t.currentLocationPath&&(t.currentLocationPath=t.to=a(t.instance.root)),t.currentLocationPath=t.instance._checkForAHash(t.currentLocationPath),n()}function _(t,n){for(var e=0;e<t.instance.routes.length;e++){var o=l(t,t.instance.routes[e]);if(o&&(t.matches||(t.matches=[]),t.matches.push(o),"ONE"===t.resolveOptions.strategy))return void n()}n()}function k(t,n){t.navigateOptions&&(void 0!==t.navigateOptions.shouldResolve&&console.warn('"shouldResolve" is deprecated. Please check the documentation.'),void 0!==t.navigateOptions.silent&&console.warn('"silent" is deprecated. Please check the documentation.')),n()}function O(t,n){!0===t.navigateOptions.force?(t.instance._setCurrent([t.instance._pathToMatchObject(t.to)]),n(!1)):n()}m.if=function(t,n,e){return Array.isArray(n)||(n=[n]),Array.isArray(e)||(e=[e]),[t,n,e]};var w=v(),L=p();function b(t,n){if(d(t.navigateOptions,"updateBrowserURL")){var e=("/"+t.to).replace(/\/\//g,"/"),o=w&&t.resolveOptions&&!0===t.resolveOptions.hash;L?(history[t.navigateOptions.historyAPIMethod||"pushState"](t.navigateOptions.stateObj||{},t.navigateOptions.title||"",o?"#"+e:e),location&&location.hash&&(t.instance.__freezeListening=!0,setTimeout((function(){if(!o){var n=location.hash;location.hash="",location.hash=n}t.instance.__freezeListening=!1}),1))):w&&(window.location.href=t.to)}n()}function A(t,n){var e=t.instance;e.lastResolved()?m(e.lastResolved().map((function(n){return function(e,o){if(n.route.hooks&&n.route.hooks.leave){var r=!1,i=t.instance.matchLocation(n.route.path,t.currentLocationPath,!1);r="*"!==n.route.path?!i:!(t.matches&&t.matches.find((function(t){return n.route.path===t.route.path}))),d(t.navigateOptions,"callHooks")&&r?m(n.route.hooks.leave.map((function(n){return function(e,o){return n((function(n){!1===n?t.instance.__markAsClean(t):o()}),t.matches&&t.matches.length>0?1===t.matches.length?t.matches[0]:t.matches:void 0)}})).concat([function(){return o()}])):o()}else o()}})),{},(function(){return n()})):n()}function P(t,n){d(t.navigateOptions,"updateState")&&t.instance._setCurrent(t.matches),n()}var R=[function(t,n){var e=t.instance.lastResolved();if(e&&e[0]&&e[0].route===t.match.route&&e[0].url===t.match.url&&e[0].queryString===t.match.queryString)return e.forEach((function(n){n.route.hooks&&n.route.hooks.already&&d(t.navigateOptions,"callHooks")&&n.route.hooks.already.forEach((function(n){return n(t.match)}))})),void n(!1);n()},function(t,n){t.match.route.hooks&&t.match.route.hooks.before&&d(t.navigateOptions,"callHooks")?m(t.match.route.hooks.before.map((function(n){return function(e,o){return n((function(n){!1===n?t.instance.__markAsClean(t):o()}),t.match)}})).concat([function(){return n()}])):n()},function(t,n){d(t.navigateOptions,"callHandler")&&t.match.route.handler(t.match),t.instance.updatePageLinks(),n()},function(t,n){t.match.route.hooks&&t.match.route.hooks.after&&d(t.navigateOptions,"callHooks")&&t.match.route.hooks.after.forEach((function(n){return n(t.match)})),n()}],S=[A,function(t,n){var e=t.instance._notFoundRoute;if(e){t.notFoundHandled=!0;var o=h(t.currentLocationPath),r=o[0],i=o[1],a=u(t.to);e.path=s(r);var c={url:e.path,queryString:i,hashString:a,data:null,route:e,params:""!==i?f(i):null};t.matches=[c],t.match=c}n()},m.if((function(t){return t.notFoundHandled}),R.concat([P]),[function(t,n){t.resolveOptions&&!1!==t.resolveOptions.noMatchWarning&&void 0!==t.resolveOptions.noMatchWarning||console.warn('Navigo: "'+t.currentLocationPath+"\" didn't match any of the registered routes."),n()},function(t,n){t.instance._setCurrent(null),n()}])];function E(){return(E=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t}).apply(this,arguments)}function x(t,n){var e=0;A(t,(function o(){e!==t.matches.length?m(R,E({},t,{match:t.matches[e]}),(function(){e+=1,o()})):P(t,n)}))}function H(t){t.instance.__markAsClean(t)}function j(){return(j=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t}).apply(this,arguments)}var C="[data-navigo]";function N(t,n){var e,o=n||{strategy:"ONE",hash:!1,noMatchWarning:!1,linksSelector:C},r=this,i="/",d=null,w=[],L=!1,A=p(),P=v();function R(t){return t.indexOf("#")>=0&&(t=!0===o.hash?t.split("#")[1]||"/":t.split("#")[0]),t}function E(t){return s(i+"/"+s(t))}function N(t,n,e,o){return t=c(t)?E(t):t,{name:o||s(String(t)),path:t,handler:n,hooks:g(e)}}function U(t,n){if(!r.__dirty){r.__dirty=!0,t=t?s(i)+"/"+s(t):void 0;var e={instance:r,to:t,currentLocationPath:t,navigateOptions:{},resolveOptions:j({},o,n)};return m([y,_,m.if((function(t){var n=t.matches;return n&&n.length>0}),x,S)],e,H),!!e.matches&&e.matches}r.__waiting.push((function(){return r.resolve(t,n)}))}function q(t,n){if(r.__dirty)r.__waiting.push((function(){return r.navigate(t,n)}));else{r.__dirty=!0,t=s(i)+"/"+s(t);var e={instance:r,to:t,navigateOptions:n||{},resolveOptions:n&&n.resolveOptions?n.resolveOptions:o,currentLocationPath:R(t)};m([k,O,_,m.if((function(t){var n=t.matches;return n&&n.length>0}),x,S),b,H],e,H)}}function F(){if(P)return(P?[].slice.call(document.querySelectorAll(o.linksSelector||C)):[]).forEach((function(t){"false"!==t.getAttribute("data-navigo")&&"_blank"!==t.getAttribute("target")?t.hasListenerAttached||(t.hasListenerAttached=!0,t.navigoHandler=function(n){if((n.ctrlKey||n.metaKey)&&"a"===n.target.tagName.toLowerCase())return!1;var e=t.getAttribute("href");if(null==e)return!1;if(e.match(/^(http|https)/)&&"undefined"!=typeof URL)try{var o=new URL(e);e=o.pathname+o.search}catch(t){}var i=function(t){if(!t)return{};var n,e=t.split(","),o={};return e.forEach((function(t){var e=t.split(":").map((function(t){return t.replace(/(^ +| +$)/g,"")}));switch(e[0]){case"historyAPIMethod":o.historyAPIMethod=e[1];break;case"resolveOptionsStrategy":n||(n={}),n.strategy=e[1];break;case"resolveOptionsHash":n||(n={}),n.hash="true"===e[1];break;case"updateBrowserURL":case"callHandler":case"updateState":case"force":o[e[0]]="true"===e[1]}})),n&&(o.resolveOptions=n),o}(t.getAttribute("data-navigo-options"));L||(n.preventDefault(),n.stopPropagation(),r.navigate(s(e),i))},t.addEventListener("click",t.navigoHandler)):t.hasListenerAttached&&t.removeEventListener("click",t.navigoHandler)})),r}function I(t,n,e){var o=w.find((function(n){return n.name===t})),r=null;if(o){if(r=o.path,n)for(var a in n)r=r.replace(":"+a,n[a]);r=r.match(/^\//)?r:"/"+r}return r&&e&&!e.includeRoot&&(r=r.replace(new RegExp("^/"+i),"")),r}function M(t){var n=h(s(t)),o=n[0],r=n[1],i=""===r?null:f(r);return{url:o,queryString:r,hashString:u(t),route:N(o,(function(){}),[e],o),data:null,params:i}}function T(t,n,e){return"string"==typeof n&&(n=z(n)),n?(n.hooks[t]||(n.hooks[t]=[]),n.hooks[t].push(e),function(){n.hooks[t]=n.hooks[t].filter((function(t){return t!==e}))}):(console.warn("Route doesn't exists: "+n),function(){})}function z(t){return"string"==typeof t?w.find((function(n){return n.name===E(t)})):w.find((function(n){return n.handler===t}))}t?i=s(t):console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'),this.root=i,this.routes=w,this.destroyed=L,this.current=d,this.__freezeListening=!1,this.__waiting=[],this.__dirty=!1,this.__markAsClean=function(t){t.instance.__dirty=!1,t.instance.__waiting.length>0&&t.instance.__waiting.shift()()},this.on=function(t,n,o){var r=this;return"object"!=typeof t||t instanceof RegExp?("function"==typeof t&&(o=n,n=t,t=i),w.push(N(t,n,[e,o])),this):(Object.keys(t).forEach((function(n){if("function"==typeof t[n])r.on(n,t[n]);else{var o=t[n],i=o.uses,a=o.as,s=o.hooks;w.push(N(n,i,[e,s],a))}})),this)},this.off=function(t){return this.routes=w=w.filter((function(n){return c(t)?s(n.path)!==s(t):"function"==typeof t?t!==n.handler:String(n.path)!==String(t)})),this},this.resolve=U,this.navigate=q,this.navigateByName=function(t,n,e){var o=I(t,n);return null!==o&&(q(o.replace(new RegExp("^/?"+i),""),e),!0)},this.destroy=function(){this.routes=w=[],A&&window.removeEventListener("popstate",this.__popstateListener),this.destroyed=L=!0},this.notFound=function(t,n){return r._notFoundRoute=N("*",t,[e,n],"__NOT_FOUND__"),this},this.updatePageLinks=F,this.link=function(t){return"/"+i+"/"+s(t)},this.hooks=function(t){return e=t,this},this.extractGETParameters=function(t){return h(R(t))},this.lastResolved=function(){return d},this.generate=I,this.getLinkPath=function(t){return t.getAttribute("href")},this.match=function(t){var n={instance:r,currentLocationPath:t,to:t,navigateOptions:{},resolveOptions:o};return _(n,(function(){})),!!n.matches&&n.matches},this.matchLocation=function(t,n,e){void 0===n||void 0!==e&&!e||(n=E(n));var o={instance:r,to:n,currentLocationPath:n};return y(o,(function(){})),"string"==typeof t&&(t=void 0===e||e?E(t):t),l(o,{name:String(t),path:t,handler:function(){},hooks:{}})||!1},this.getCurrentLocation=function(){return M(s(a(i)).replace(new RegExp("^"+i),""))},this.addBeforeHook=T.bind(this,"before"),this.addAfterHook=T.bind(this,"after"),this.addAlreadyHook=T.bind(this,"already"),this.addLeaveHook=T.bind(this,"leave"),this.getRoute=z,this._pathToMatchObject=M,this._clean=s,this._checkForAHash=R,this._setCurrent=function(t){return d=r.current=t},function(){A&&(this.__popstateListener=function(){r.__freezeListening||U()},window.addEventListener("popstate",this.__popstateListener))}.call(this),F.call(this)}}},n={};function e(o){if(n[o])return n[o].exports;var r=n[o]={exports:{}};return t[o](r,r.exports,e),r.exports}return e.d=function(t,n){for(var o in n)e.o(n,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:n[o]})},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e(407)}().default}));

},{}],6:[function(require,module,exports){
module.exports={
    "name": "pict-application",
    "version": "1.0.34",
    "description": "Application base class for a pict view-based application",
    "main": "source/Pict-Application.js",
    "scripts": {
        "test": "npx quack test",
        "start": "node source/Pict-Application.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-application-image:local",
        "docker-dev-run": "docker run -it -d --name pict-application-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-application\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-application-image:local",
        "docker-dev-shell": "docker exec -it pict-application-dev /bin/bash",
        "tests": "npx quack test -g",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Application.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-application.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-application/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-application#readme",
    "devDependencies": {
        "@eslint/js": "^9.28.0",
        "browser-env": "^3.3.0",
        "eslint": "^9.28.0",
        "pict": "^1.0.348",
        "pict-docuserve": "^0.1.5",
        "pict-provider": "^1.0.10",
        "pict-view": "^1.0.66",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],7:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase')

const libPackage = require('../package.json');

const defaultPictSettings = (
	{
		Name: 'DefaultPictApplication',

		// The main "viewport" is the view that is used to host our application
		MainViewportViewIdentifier: 'Default-View',
		MainViewportRenderableHash: false,
		MainViewportDestinationAddress: false,
		MainViewportDefaultDataAddress: false,

		// Whether or not we should automatically render the main viewport and other autorender views after we initialize the pict application
		AutoSolveAfterInitialize: true,
		AutoRenderMainViewportViewAfterInitialize: true,
		AutoRenderViewsAfterInitialize: false,
		AutoLoginAfterInitialize: false,
		AutoLoadDataAfterLogin: false,

		ConfigurationOnlyViews: [],

		Manifests: {},
		// The prefix to prepend on all template destination hashes
		IdentifierAddressPrefix: 'PICT-'
	});

/**
 * Base class for pict applications.
 */
class PictApplication extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpCarryOverConfiguration = (typeof(pFable.settings.PictApplicationConfiguration) === 'object') ? pFable.settings.PictApplicationConfiguration : {};
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictSettings)), tmpCarryOverConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;
		/** @type {import('pict') & import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;
		/**
		 * @type {{ [key: string]: any }}
		 */
		this.servicesMap;

		this.serviceType = 'PictApplication';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;
		// Wire in the essential Pict state
		/** @type {Record<string, any>} */
		this.AppData = this.fable.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.fable.Bundle;

		/** @type {number} */
		this.initializeTimestamp;
		/** @type {number} */
		this.lastSolvedTimestamp;
		/** @type {number} */
		this.lastLoginTimestamp;
		/** @type {number} */
		this.lastMarshalFromViewsTimestamp;
		/** @type {number} */
		this.lastMarshalToViewsTimestamp;
		/** @type {number} */
		this.lastAutoRenderTimestamp;
		/** @type {number} */
		this.lastLoadDataTimestamp;

		// Load all the manifests for the application
		let tmpManifestKeys = Object.keys(this.options.Manifests);
		if (tmpManifestKeys.length > 0)
		{
			for (let i = 0; i < tmpManifestKeys.length; i++)
			{
				// Load each manifest
				let tmpManifestKey = tmpManifestKeys[i];
				this.fable.instantiateServiceProvider('Manifest', this.options.Manifests[tmpManifestKey], tmpManifestKey);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Solve All Views                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onPreSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing solve() function...`)
		}

		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpProvidersToSolve[i].solve(tmpProvidersToSolve[i]);
		}

		this.onBeforeSolve();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoInitialize)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpViewsToSolve[i].solve();
		}
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));


		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}
		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpProvidersToSolve[i].solveAsync.bind(tmpProvidersToSolve[i]));
		}

		// Walk through any loaded views and solve them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoSolveWithApp)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToSolve[i].solveAsync.bind(tmpViewsToSolve[i]));
		}

		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application Login                        */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loginAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterLoginAsync.bind(this));

		// check and see if we should automatically trigger a data load
		if (this.options.AutoLoadDataAfterLogin)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				if (!this.isLoggedIn())
				{
					return fNext();
				}
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto loading data after login...`);
				}
				//TODO: should data load errors funnel here? this creates a weird coupling between login and data load callbacks
				this.loadDataAsync((pError) =>
				{
					fNext(pError);
				});
			});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync() complete.`);
				}
				this.lastLoginTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Check if the application state is logged in. Defaults to true. Override this method in your application based on login requirements.
	 *
	 * @return {boolean}
	 */
	isLoggedIn()
	{
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoginAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application LoadData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loadDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoadDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToLoadData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoLoadDataWithApp)
			{
				tmpProvidersToLoadData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToLoadData.sort((a, b) => { return a.options.AutoLoadDataOrdinal - b.options.AutoLoadDataOrdinal; });

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onLoadDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterLoadDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync() complete.`);
				}
				this.lastLoadDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoadDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application SaveData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	saveDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSaveDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSaveData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSaveDataWithApp)
			{
				tmpProvidersToSaveData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSaveData.sort((a, b) => { return a.options.AutoSaveDataOrdinal - b.options.AutoSaveDataOrdinal; });

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onSaveDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterSaveDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync() complete.`);
				}
				this.lastSaveDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSaveDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Initialize Application                   */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			this.onInitialize();

			// Walk through any loaded providers and initialize them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpProvidersToInitialize[i].initialize();
			}

			// Now walk through any loaded views and initialize them as well.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				tmpViewsToInitialize[i].initialize();
			}

			this.onAfterInitialize();
			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving after initialization...`);
				}
				// Solve the template synchronously
				this.solve();
			}
			// Now check and see if we should automatically render as well
			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering after initialization...`);
				}
				// Render the template synchronously
				this.render();
			}
			this.initializeTimestamp = this.fable.log.getTimeStamp();
			this.onCompletionOfInitialize();
			return true;
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync:`);
		}

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning initialization...`);
			}

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));

			// Walk through any loaded providers and solve them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpAnticipate.anticipate(tmpProvidersToInitialize[i].initializeAsync.bind(tmpProvidersToInitialize[i]));
			}

			// Now walk through any loaded views and initialize them as well.
			// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority
			// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				let tmpView = tmpViewsToInitialize[i];
				tmpAnticipate.anticipate(tmpView.initializeAsync.bind(tmpView));
			}

			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			if (this.options.AutoLoginAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto login (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.loginAsync.bind(this));
			}

			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.solveAsync.bind(this));
			}

			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.renderMainViewportAsync.bind(this));
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Error: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.fable.log.getTimeStamp();
					if (this.pict.LogNoisiness > 2)
					{
						this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialization complete.`);
					}
					return tmpCallback();
				});
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return this.onCompletionOfInitializeAsync(tmpCallback);
		}
	}

	/**
	 * @return {boolean}
	 */
	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}


	/**
	 * @return {boolean}
	 */
	onCompletionOfInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onCompletionOfInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onCompletionOfInitializeAsync(fCallback)
	{
		this.onCompletionOfInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data From All Views              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalFromViewsAsync(fCallback)
	{
		this.onBeforeMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalFromViewsAsync(fCallback)
	{
		this.onMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalFromViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalFromViews() function...`)
		}
		this.onBeforeMarshalFromViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpViewsToMarshalFromViews[i].marshalFromView();
		}
		this.onMarshalFromViews();
		this.onAfterMarshalFromViews();
		this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalFromViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewsAsync.bind(this));
		// Walk through any loaded views and marshalFromViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalFromViews[i].marshalFromViewAsync.bind(tmpViewsToMarshalFromViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalFromViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync() complete.`);
				}
				this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalFromViewsAsync(fCallback)
	{
		this.onAfterMarshalFromViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data To All Views                */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalToViewsAsync(fCallback)
	{
		this.onBeforeMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalToViewsAsync(fCallback)
	{
		this.onMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalToViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalToViews() function...`)
		}
		this.onBeforeMarshalToViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpViewsToMarshalToViews[i].marshalToView();
		}
		this.onMarshalToViews();
		this.onAfterMarshalToViews();
		this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalToViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalToViewsAsync.bind(this));
		// Walk through any loaded views and marshalToViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalToViews[i].marshalToViewAsync.bind(tmpViewsToMarshalToViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalToViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync() complete.`);
				}
				this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalToViewsAsync(fCallback)
	{
		this.onAfterMarshalToViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Render View                              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeRenderAsync(fCallback)
	{
		this.onBeforeRender();
		return fCallback();
	}

	/**
	 * @param {string} [pViewIdentifier] - The hash of the view to render. By default, the main viewport view is rendered.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string} [pTemplateDataAddress] - The address where the data for the template is stored.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	render(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] render:`);
		}

		this.onBeforeRender();

		// Now get the view (by hash) from the loaded views
		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not render from View ${tmpViewIdentifier} because it is not a valid view.`);
			return false;
		}

		this.onRender();

		tmpView.render(tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress);

		this.onAfterRender();

		return true;
	}
	/**
	 * @return {boolean}
	 */
	onRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onRenderAsync(fCallback)
	{
		this.onRender();
		return fCallback();
	}

	/**
	 * @param {string|((error?: Error) => void)} pViewIdentifier - The hash of the view to render. By default, the main viewport view is rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderableHash] - The hash of the renderable to render. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderDestinationAddress] - The address where the renderable will be rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pTemplateDataAddress] - The address where the data for the template is stored. (or the callback)
	 * @param {(error?: Error) => void} [fCallback] - The callback, if all other parameters are provided.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	renderAsync(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress, fCallback)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateDataAddress) === 'function') ? pTemplateDataAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pViewIdentifier) === 'function') ? pViewIdentifier :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] renderAsync:`);
		}

		let tmpRenderAnticipate = this.fable.newAnticipate();

		tmpRenderAnticipate.anticipate(this.onBeforeRenderAsync.bind(this));

		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			let tmpErrorMessage = `PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not asynchronously render from View ${tmpViewIdentifier} because it is not a valid view.`;
			if (this.pict.LogNoisiness > 3)
			{
				this.log.error(tmpErrorMessage);
			}
			return tmpCallback(new Error(tmpErrorMessage));
		}

		tmpRenderAnticipate.anticipate(this.onRenderAsync.bind(this));

		tmpRenderAnticipate.anticipate(
			(fNext) =>
			{
				tmpView.renderAsync.call(tmpView, tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress, fNext);
			});

		tmpRenderAnticipate.anticipate(this.onAfterRenderAsync.bind(this));

		return tmpRenderAnticipate.wait(tmpCallback);
	}

	/**
	 * @return {boolean}
	 */
	onAfterRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterRenderAsync(fCallback)
	{
		this.onAfterRender();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	renderMainViewport()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewport:`);
		}

		return this.render();
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderMainViewportAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewportAsync:`);
		}

		return this.renderAsync(fCallback);
	}
	/**
	 * @return {void}
	 */
	renderAutoViews()
	{
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViews...`);
		}
		// Now walk through any loaded views and sort them by the AutoRender ordinal
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpView.render();
			}
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderAutoViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViewsAsync...`);
		}

		// Now walk through any loaded views and sort them by the AutoRender ordinal
		// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpAnticipate.anticipate(tmpView.renderAsync.bind(tmpView));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				this.lastAutoRenderTimestamp = this.fable.log.getTimeStamp();
				if (this.pict.LogNoisiness > 0)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
				}
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	get isPictApplication()
	{
		return true;
	}
}

module.exports = PictApplication;

},{"../package.json":6,"fable-serviceproviderbase":2}],8:[function(require,module,exports){
// The container for all the Pict-Section-Content related code.

// The main content view class
module.exports = require('./views/Pict-View-Content.js');

// The content provider (markdown parsing, HTML escaping)
module.exports.PictContentProvider = require('./providers/Pict-Provider-Content.js');

},{"./providers/Pict-Provider-Content.js":9,"./views/Pict-View-Content.js":10}],9:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libCreateHighlighter = require('pict-section-code').createHighlighter;

/**
 * Content Provider for Pict Section Content
 *
 * A general-purpose markdown-to-HTML parser with support for:
 * - Headings, paragraphs, lists, blockquotes, horizontal rules
 * - Fenced code blocks with language tags (nested fence support)
 * - Syntax highlighting and line numbers for code blocks (via pict-section-code)
 * - Tables (GFM pipe syntax)
 * - Mermaid diagram blocks
 * - KaTeX math (inline and display)
 * - Bold, italic, inline code, links, images
 *
 * Link resolution is customizable via an optional callback.
 */
class PictContentProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Highlight a code string using pict-section-code's syntax highlighter.
	 * Uses a mock element to interface with the highlighter's DOM-based API.
	 *
	 * @param {string} pCode - The raw code string
	 * @param {string} pLanguage - The language identifier (e.g. "javascript", "html")
	 * @returns {string} The syntax-highlighted HTML
	 */
	highlightCode(pCode, pLanguage)
	{
		if (!pCode)
		{
			return '';
		}

		let tmpHighlighter = libCreateHighlighter(pLanguage);
		// Create a mock element to interface with the highlighter
		let tmpMockElement = { textContent: pCode, innerHTML: '' };
		tmpHighlighter(tmpMockElement);
		return tmpMockElement.innerHTML;
	}

	/**
	 * Generate line number HTML for a code block.
	 *
	 * @param {string} pCode - The raw code string
	 * @returns {string} HTML string with line number spans
	 */
	generateLineNumbers(pCode)
	{
		if (!pCode)
		{
			return '<span>1</span>';
		}

		let tmpLineCount = pCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += '<span>' + i + '</span>';
		}

		return tmpHTML;
	}

	/**
	 * Parse a markdown string into HTML.
	 *
	 * @param {string} pMarkdown - The raw markdown text
	 * @param {Function} [pLinkResolver] - Optional callback for link resolution: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback for image URL resolution: (pSrc, pAlt) => resolvedSrc or null
	 * @returns {string} The parsed HTML
	 */
	parseMarkdown(pMarkdown, pLinkResolver, pImageResolver)
	{
		if (!pMarkdown)
		{
			return '';
		}

		let tmpLines = pMarkdown.split('\n');
		let tmpHTML = [];
		let tmpInCodeBlock = false;
		let tmpCodeFenceLength = 0;
		let tmpCodeLang = '';
		let tmpCodeLines = [];
		let tmpInList = false;
		let tmpListType = '';
		let tmpInBlockquote = false;
		let tmpBlockquoteLines = [];
		let tmpInMathBlock = false;
		let tmpMathLines = [];
		let tmpParagraphLines = [];

		// Helper to flush accumulated paragraph lines into a single <p> tag
		let fFlushParagraph = () =>
		{
			if (tmpParagraphLines.length > 0)
			{
				tmpHTML.push('<p>' + tmpParagraphLines.map((pLine) => { return this.parseInline(pLine, pLinkResolver, pImageResolver); }).join(' ') + '</p>');
				tmpParagraphLines = [];
			}
		};

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			// Display math blocks ($$...$$) — skip if inside a code block
			if (!tmpInCodeBlock && tmpLine.trim().match(/^\$\$/))
			{
				if (tmpInMathBlock)
				{
					// End math block
					tmpHTML.push('<div class="pict-content-katex-display">' + tmpMathLines.join('\n') + '</div>');
					tmpInMathBlock = false;
					tmpMathLines = [];
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					tmpInMathBlock = true;
				}
				continue;
			}

			if (tmpInMathBlock)
			{
				tmpMathLines.push(tmpLine);
				continue;
			}

			// Code blocks (fenced) — track fence length so ````x```` nests around ```y```
			let tmpFenceMatch = tmpLine.match(/^(`{3,})/);
			if (tmpFenceMatch)
			{
				let tmpFenceLen = tmpFenceMatch[1].length;

				if (tmpInCodeBlock)
				{
					// Only close if the closing fence is at least as long as the opening
					if (tmpFenceLen >= tmpCodeFenceLength && tmpLine.trim() === tmpFenceMatch[1])
					{
						// End code block
						if (tmpCodeLang === 'mermaid')
						{
							// Mermaid diagrams: output raw content for client-side rendering
							tmpHTML.push('<pre class="mermaid">' + tmpCodeLines.join('\n') + '</pre>');
						}
						else
						{
							let tmpCodeText = tmpCodeLines.join('\n');
						let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
						let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
						tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code class="language-' + this.escapeHTML(tmpCodeLang) + '">' + tmpHighlightedCode + '</code></pre></div>');
						}
						tmpInCodeBlock = false;
						tmpCodeFenceLength = 0;
						tmpCodeLang = '';
						tmpCodeLines = [];
						continue;
					}
					else
					{
						// Inner fence with fewer backticks — treat as content
						tmpCodeLines.push(tmpLine);
						continue;
					}
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					// Start code block — record fence length
					tmpCodeFenceLength = tmpFenceLen;
					tmpCodeLang = tmpLine.replace(/^`{3,}/, '').trim();
					tmpInCodeBlock = true;
					continue;
				}
			}

			if (tmpInCodeBlock)
			{
				tmpCodeLines.push(tmpLine);
				continue;
			}

			// Blockquotes
			if (tmpLine.match(/^>\s?/))
			{
				if (!tmpInBlockquote)
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					tmpInBlockquote = true;
					tmpBlockquoteLines = [];
				}
				tmpBlockquoteLines.push(tmpLine.replace(/^>\s?/, ''));
				continue;
			}
			else if (tmpInBlockquote)
			{
				tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver) + '</blockquote>');
				tmpInBlockquote = false;
				tmpBlockquoteLines = [];
			}

			// Horizontal rule
			if (tmpLine.match(/^(-{3,}|\*{3,}|_{3,})\s*$/))
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				tmpHTML.push('<hr>');
				continue;
			}

			// Headings
			let tmpHeadingMatch = tmpLine.match(/^(#{1,6})\s+(.+)/);
			if (tmpHeadingMatch)
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				let tmpLevel = tmpHeadingMatch[1].length;
				let tmpText = this.parseInline(tmpHeadingMatch[2], pLinkResolver, pImageResolver);
				let tmpID = tmpHeadingMatch[2].toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
				tmpHTML.push('<h' + tmpLevel + ' id="' + tmpID + '">' + tmpText + '</h' + tmpLevel + '>');
				continue;
			}

			// Unordered list items
			let tmpULMatch = tmpLine.match(/^(\s*)[-*+]\s+(.*)/);
			if (tmpULMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ul')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ul>');
					tmpInList = true;
					tmpListType = 'ul';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpULMatch[2], pLinkResolver, pImageResolver) + '</li>');
				continue;
			}

			// Ordered list items
			let tmpOLMatch = tmpLine.match(/^(\s*)\d+\.\s+(.*)/);
			if (tmpOLMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ol')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ol>');
					tmpInList = true;
					tmpListType = 'ol';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpOLMatch[2], pLinkResolver, pImageResolver) + '</li>');
				continue;
			}

			// Close list if we've left list items
			if (tmpInList && tmpLine.trim() !== '')
			{
				tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
				tmpInList = false;
			}

			// Empty line — flush any accumulated paragraph
			if (tmpLine.trim() === '')
			{
				fFlushParagraph();
				continue;
			}

			// Table detection
			if (tmpLine.match(/^\|/) && i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|[\s-:|]+\|/))
			{
				fFlushParagraph();
				// Close any open list
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}

				let tmpTableHTML = '<table>';

				// Header row
				let tmpHeaders = tmpLine.split('|').filter((pCell) => { return pCell.trim() !== ''; });
				tmpTableHTML += '<thead><tr>';
				for (let h = 0; h < tmpHeaders.length; h++)
				{
					tmpTableHTML += '<th>' + this.parseInline(tmpHeaders[h].trim(), pLinkResolver, pImageResolver) + '</th>';
				}
				tmpTableHTML += '</tr></thead>';

				// Skip separator row
				i++;

				// Body rows
				tmpTableHTML += '<tbody>';
				while (i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|/))
				{
					i++;
					let tmpCells = tmpLines[i].split('|').filter((pCell) => { return pCell.trim() !== ''; });
					tmpTableHTML += '<tr>';
					for (let c = 0; c < tmpCells.length; c++)
					{
						tmpTableHTML += '<td>' + this.parseInline(tmpCells[c].trim(), pLinkResolver, pImageResolver) + '</td>';
					}
					tmpTableHTML += '</tr>';
				}
				tmpTableHTML += '</tbody></table>';
				tmpHTML.push(tmpTableHTML);
				continue;
			}

			// Accumulate paragraph lines — consecutive non-blank text lines
			// will be joined into a single <p> tag when flushed
			tmpParagraphLines.push(tmpLine);
		}

		// Flush any remaining accumulated paragraph
		fFlushParagraph();

		// Close any trailing open elements
		if (tmpInList)
		{
			tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
		}
		if (tmpInBlockquote)
		{
			tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver) + '</blockquote>');
		}
		if (tmpInCodeBlock)
		{
			let tmpCodeText = tmpCodeLines.join('\n');
			let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
			let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
			tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code>' + tmpHighlightedCode + '</code></pre></div>');
		}

		return tmpHTML.join('\n');
	}

	/**
	 * Parse inline markdown elements (bold, italic, code, links, images, KaTeX).
	 *
	 * @param {string} pText - The text to parse
	 * @param {Function} [pLinkResolver] - Optional callback: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback: (pSrc, pAlt) => resolvedSrc or null
	 * @returns {string} HTML with inline elements
	 */
	parseInline(pText, pLinkResolver, pImageResolver)
	{
		if (!pText)
		{
			return '';
		}

		let tmpResult = pText;

		// Extract inline code spans into placeholders so bold/italic regexes don't mangle their contents
		let tmpCodeSpans = [];
		tmpResult = tmpResult.replace(/`([^`]+)`/g, (pMatch, pCode) =>
		{
			let tmpIndex = tmpCodeSpans.length;
			tmpCodeSpans.push('<code>' + pCode + '</code>');
			return '\x00CODEINLINE' + tmpIndex + '\x00';
		});

		// Inline LaTeX equations ($...$) — must be processed before other inline patterns
		// Match single $ delimiters that aren't adjacent to spaces (to avoid false positives with currency)
		tmpResult = tmpResult.replace(/\$([^\$\s][^\$]*?[^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');
		// Also match single-character inline math like $x$
		tmpResult = tmpResult.replace(/\$([^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');

		// Images
		tmpResult = tmpResult.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (pMatch, pAlt, pSrc) =>
		{
			let tmpSrc = pSrc;
			if (typeof pImageResolver === 'function')
			{
				let tmpResolved = pImageResolver(pSrc, pAlt);
				if (tmpResolved)
				{
					tmpSrc = tmpResolved;
				}
			}
			return '<img src="' + tmpSrc + '" alt="' + pAlt + '">';
		});

		// Links
		tmpResult = tmpResult.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (pMatch, pLinkText, pHref) =>
		{
			if (typeof pLinkResolver === 'function')
			{
				let tmpResolved = pLinkResolver(pHref, pLinkText);
				if (tmpResolved)
				{
					let tmpTarget = tmpResolved.target ? ' target="' + tmpResolved.target + '"' : '';
					let tmpRel = tmpResolved.rel ? ' rel="' + tmpResolved.rel + '"' : '';
					return '<a href="' + tmpResolved.href + '"' + tmpTarget + tmpRel + '>' + pLinkText + '</a>';
				}
			}
			// Default behavior: external links open in new tab
			if (pHref.match(/^https?:\/\//))
			{
				return '<a href="' + pHref + '" target="_blank" rel="noopener">' + pLinkText + '</a>';
			}
			return '<a href="' + pHref + '">' + pLinkText + '</a>';
		});

		// Bold
		tmpResult = tmpResult.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
		tmpResult = tmpResult.replace(/__([^_]+)__/g, '<strong>$1</strong>');

		// Italic
		tmpResult = tmpResult.replace(/\*([^*]+)\*/g, '<em>$1</em>');
		tmpResult = tmpResult.replace(/_([^_]+)_/g, '<em>$1</em>');

		// Restore inline code spans from placeholders
		tmpResult = tmpResult.replace(/\x00CODEINLINE(\d+)\x00/g, (pMatch, pIndex) =>
		{
			return tmpCodeSpans[parseInt(pIndex)];
		});

		return tmpResult;
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = PictContentProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: "Pict-Content",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

},{"pict-provider":19,"pict-section-code":23}],10:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-content {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
		}
		.pict-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 200px;
			color: #8A7F72;
			font-size: 1em;
		}
		.pict-content h1 {
			font-size: 2em;
			color: #3D3229;
			border-bottom: 1px solid #DDD6CA;
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-content h2 {
			font-size: 1.5em;
			color: #3D3229;
			border-bottom: 1px solid #EAE3D8;
			padding-bottom: 0.25em;
			margin-top: 1.5em;
		}
		.pict-content h3 {
			font-size: 1.25em;
			color: #3D3229;
			margin-top: 1.25em;
		}
		.pict-content h4, .pict-content h5, .pict-content h6 {
			color: #5E5549;
			margin-top: 1em;
		}
		.pict-content p {
			line-height: 1.7;
			color: #423D37;
			margin: 0.75em 0;
		}
		.pict-content a {
			color: #2E7D74;
			text-decoration: none;
		}
		.pict-content a:hover {
			text-decoration: underline;
		}
		.pict-content-code-wrap {
			position: relative;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace;
			font-size: 14px;
			line-height: 1.5;
			border-radius: 6px;
			overflow: auto;
			margin: 1em 0;
			background: #3D3229;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers {
			position: absolute;
			top: 0;
			left: 0;
			width: 40px;
			padding: 1.25em 0;
			text-align: right;
			background: #342A22;
			border-right: 1px solid #4A3F35;
			color: #8A7F72;
			font-size: 13px;
			line-height: 1.5;
			user-select: none;
			pointer-events: none;
			box-sizing: border-box;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers span {
			display: block;
			padding: 0 8px 0 0;
		}
		.pict-content-code-wrap pre {
			margin: 0;
			background: #3D3229;
			color: #E8E0D4;
			padding: 1.25em 1.25em 1.25em 52px;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: inherit;
		}
		.pict-content-code-wrap pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
			font-family: inherit;
		}
		.pict-content-code-wrap .keyword { color: #C678DD; }
		.pict-content-code-wrap .string { color: #98C379; }
		.pict-content-code-wrap .number { color: #D19A66; }
		.pict-content-code-wrap .comment { color: #7F848E; font-style: italic; }
		.pict-content-code-wrap .operator { color: #56B6C2; }
		.pict-content-code-wrap .punctuation { color: #E8E0D4; }
		.pict-content-code-wrap .function-name { color: #61AFEF; }
		.pict-content-code-wrap .property { color: #E06C75; }
		.pict-content-code-wrap .tag { color: #E06C75; }
		.pict-content-code-wrap .attr-name { color: #D19A66; }
		.pict-content-code-wrap .attr-value { color: #98C379; }
		.pict-content pre {
			background: #3D3229;
			color: #E8E0D4;
			padding: 1.25em;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.9em;
		}
		.pict-content code {
			background: #F0ECE4;
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			color: #9E6B47;
		}
		.pict-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.pict-content blockquote {
			border-left: 4px solid #2E7D74;
			margin: 1em 0;
			padding: 0.5em 1em;
			background: #F7F5F0;
			color: #5E5549;
		}
		.pict-content blockquote p {
			margin: 0.25em 0;
		}
		.pict-content ul, .pict-content ol {
			padding-left: 2em;
			line-height: 1.8;
		}
		.pict-content li {
			margin: 0.25em 0;
			color: #423D37;
		}
		.pict-content hr {
			border: none;
			border-top: 1px solid #DDD6CA;
			margin: 2em 0;
		}
		.pict-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 1em 0;
		}
		.pict-content table th {
			background: #F5F0E8;
			border: 1px solid #DDD6CA;
			padding: 0.6em 0.8em;
			text-align: left;
			font-weight: 600;
			color: #3D3229;
		}
		.pict-content table td {
			border: 1px solid #DDD6CA;
			padding: 0.5em 0.8em;
			color: #423D37;
		}
		.pict-content table tr:nth-child(even) {
			background: #F7F5F0;
		}
		.pict-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-content pre.mermaid {
			background: #fff;
			color: #3D3229;
			text-align: center;
			padding: 1em;
		}
		.pict-content .pict-content-katex-display {
			text-align: center;
			margin: 1em 0;
			padding: 0.5em;
			overflow-x: auto;
		}
		.pict-content .pict-content-katex-inline {
			display: inline;
		}
	`,

	Templates:
	[
		{
			Hash: "Pict-Content-Template",
			Template: /*html*/`
<div class="pict-content" id="Pict-Content-Body">
	<div class="pict-content-loading">Loading content...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Pict-Content-Display",
			TemplateHash: "Pict-Content-Template",
			DestinationAddress: "#Pict-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class PictContentView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	displayContent(pHTMLContent, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';

		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, pHTMLContent);

		// Scroll to top of content area
		let tmpContentContainer = document.getElementById(tmpContainerID);
		if (tmpContentContainer && tmpContentContainer.parentElement)
		{
			tmpContentContainer.parentElement.scrollTop = 0;
		}

		// Post-render: initialize Mermaid diagrams if mermaid is available
		this.renderMermaidDiagrams(tmpContainerID);

		// Post-render: render KaTeX equations if katex is available
		this.renderKaTeXEquations(tmpContainerID);
	}

	/**
	 * Render any Mermaid diagram blocks in the content area.
	 * Mermaid blocks are `<pre class="mermaid">` elements produced by parseMarkdown.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderMermaidDiagrams(pContainerID)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		let tmpMermaidElements = tmpContentBody.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// mermaid.run() will process all pre.mermaid elements in the container
		try
		{
			mermaid.run({ nodes: tmpMermaidElements });
		}
		catch (pError)
		{
			this.log.error('Mermaid rendering error: ' + pError.message);
		}
	}

	/**
	 * Render KaTeX inline and display math elements in the content area.
	 * Inline: `<span class="pict-content-katex-inline">`
	 * Display: `<div class="pict-content-katex-display">`
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderKaTeXEquations(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		// Render inline math
		let tmpInlineElements = tmpContentBody.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				this.log.warn('KaTeX inline error: ' + pError.message);
			}
		}

		// Render display math
		let tmpDisplayElements = tmpContentBody.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				this.log.warn('KaTeX display error: ' + pError.message);
			}
		}
	}

	/**
	 * Show a loading indicator.
	 *
	 * @param {string} [pMessage] - Loading message (defaults to 'Loading content...')
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	showLoading(pMessage, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpMessage = pMessage || 'Loading content...';
		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, '<div class="pict-content-loading">' + tmpMessage + '</div>');
	}
}

module.exports = PictContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],11:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libLunr = require('lunr');
const libPictSectionContent = require('pict-section-content');
const libPictContentProvider = libPictSectionContent.PictContentProvider;

/**
 * Documentation Provider for Docuserve
 *
 * Loads the Indoctrinate-generated catalog and keyword index,
 * fetches markdown documents from local paths or raw GitHub URLs,
 * and parses them into HTML for rendering.
 */
class DocuserveDocumentationProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._Catalog = null;
		this._ContentCache = {};

		// Create an instance of the content provider for markdown parsing
		this._ContentProvider = this.pict.addProvider('Pict-Content', libPictContentProvider.default_configuration, libPictContentProvider);
	}

	/**
	 * Create a link resolver closure for the content provider.
	 *
	 * Wraps docuserve-specific link resolution (catalog-aware routing,
	 * GitHub URL matching) into a callback compatible with the
	 * pict-section-content link resolver pattern.
	 *
	 * @param {string} [pCurrentGroup] - The current group key
	 * @param {string} [pCurrentModule] - The current module name
	 * @param {string} [pCurrentDocPath] - The current document path
	 * @returns {Function} A link resolver callback
	 */
	_createLinkResolver(pCurrentGroup, pCurrentModule, pCurrentDocPath)
	{
		return (pHref, pLinkText) =>
		{
			// Convert internal doc links to hash routes
			if (pHref.match(/^\//) || pHref.match(/^[^:]+\.md/))
			{
				let tmpRoute = this.convertDocLink(pHref, pCurrentGroup, pCurrentModule, pCurrentDocPath);
				return { href: tmpRoute };
			}
			// Check if this is a GitHub URL that matches a catalog module
			let tmpCatalogRoute = this.resolveGitHubURLToRoute(pHref);
			if (tmpCatalogRoute)
			{
				return { href: tmpCatalogRoute };
			}
			// Use default behavior for other links
			return null;
		};
	}

	/**
	 * Create an image resolver closure for the content provider.
	 *
	 * Resolves relative image URLs against the directory of the document
	 * being rendered, so that images referenced with relative paths in
	 * markdown (e.g. `![graph](diagram.svg)`) resolve correctly even
	 * when the page uses hash-based routing.
	 *
	 * @param {string} pDocURL - The URL the markdown document was fetched from
	 * @returns {Function} An image resolver callback: (pSrc, pAlt) => resolvedSrc
	 */
	_createImageResolver(pDocURL)
	{
		// Extract the directory portion of the document URL
		let tmpBaseDir = '';
		if (pDocURL)
		{
			let tmpLastSlash = pDocURL.lastIndexOf('/');
			if (tmpLastSlash >= 0)
			{
				tmpBaseDir = pDocURL.substring(0, tmpLastSlash + 1);
			}
		}

		return (pSrc, pAlt) =>
		{
			// Leave absolute URLs, data URIs, and root-relative paths unchanged
			if (pSrc.match(/^https?:\/\//) || pSrc.match(/^data:/) || pSrc.match(/^\//))
			{
				return pSrc;
			}
			// Prepend the document's directory to make relative paths work
			return tmpBaseDir + pSrc;
		};
	}

	/**
	 * Load all documentation data sources: catalog, _cover.md, _sidebar.md.
	 *
	 * Loads the catalog first (it provides the fallback data), then attempts
	 * to load _cover.md and _sidebar.md in parallel.  If those markdown files
	 * exist they drive the splash and sidebar views; otherwise the catalog
	 * data is used as a fallback.
	 *
	 * @param {Function} fCallback - Callback when all loading is complete
	 */
	loadCatalog(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};

		let tmpCatalogURL = this.pict.AppData.Docuserve.CatalogURL || 'retold-catalog.json';

		let tmpLoadOptionalFiles = () =>
		{
			// Load _cover.md, _sidebar.md, _topbar.md, errorpage.md and keyword index in parallel.
			// When all are done, if we still have no sidebar data, try to auto-discover
			// a README.md so the site works with plain markdown folders.
			let tmpPending = 5;
			let tmpFinish = () =>
			{
				tmpPending--;
				if (tmpPending <= 0)
				{
					// If no sidebar data was populated by catalog or _sidebar.md,
					// try to auto-discover a README.md to provide minimal navigation.
					if (!this.pict.AppData.Docuserve.SidebarGroups || this.pict.AppData.Docuserve.SidebarGroups.length < 1)
					{
						this.autoDiscoverSidebar(tmpCallback);
					}
					else
					{
						return tmpCallback();
					}
				}
			};

			this.loadCover(tmpFinish);
			this.loadSidebar(tmpFinish);
			this.loadTopbar(tmpFinish);
			this.loadErrorPage(tmpFinish);
			this.loadKeywordIndex(tmpFinish);
		};

		fetch(tmpCatalogURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					this.log.info(`Docuserve: No catalog at [${tmpCatalogURL}]; running in standalone mode.`);
					return null;
				}
				return pResponse.json();
			})
			.then((pCatalog) =>
			{
				if (pCatalog)
				{
					this._Catalog = pCatalog;
					this.pict.AppData.Docuserve.Catalog = pCatalog;
					this.pict.AppData.Docuserve.CatalogLoaded = true;

					// Build sidebar navigation data from the catalog as default
					this.buildSidebarData(pCatalog);
				}

				tmpLoadOptionalFiles();
			})
			.catch((pError) =>
			{
				this.log.info(`Docuserve: Catalog load error (${pError}); continuing in standalone mode.`);
				tmpLoadOptionalFiles();
			});
	}

	/**
	 * Auto-discover sidebar content when no catalog or _sidebar.md is available.
	 *
	 * Attempts to fetch README.md from the docs root.  If found, creates a
	 * minimal sidebar with a single "Docs" group containing a README entry.
	 * This lets pict-docuserve work with nothing but a folder of markdown.
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	autoDiscoverSidebar(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + 'README.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (pMarkdown)
				{
					// Extract a title from the first heading in the README
					let tmpTitleMatch = pMarkdown.match(/^#+\s+(.+)/m);
					let tmpTitle = tmpTitleMatch ? tmpTitleMatch[1].trim() : 'Docs';

					// Build a minimal sidebar group so the sidebar has something to show
					this.pict.AppData.Docuserve.SidebarGroups =
					[
						{
							Name: tmpTitle,
							Key: 'docs',
							Route: '#/page/README',
							Modules: []
						}
					];

					// Also set this as a fallback cover title if we have no cover
					if (!this.pict.AppData.Docuserve.CoverLoaded)
					{
						this.pict.AppData.Docuserve.Cover =
						{
							Title: tmpTitle,
							Tagline: '',
							Description: '',
							Highlights: [],
							Actions: [{ Text: 'Read the Docs', Href: 'README.md' }]
						};
						this.pict.AppData.Docuserve.CoverLoaded = true;
					}
				}
				else
				{
					this.log.info('Docuserve: No README.md found; sidebar will be empty.');
				}

				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.info(`Docuserve: README.md discovery failed (${pError}).`);
				return tmpCallback();
			});
	}

	/**
	 * Fetch and parse _cover.md into structured data for the splash view.
	 *
	 * The expected _cover.md format follows the docsify convention:
	 *   # Title
	 *   > Tagline
	 *   Description paragraph text.
	 *   - **Group** — description
	 *   [Link Text](url)
	 *
	 * Parsed result stored in this.pict.AppData.Docuserve.Cover:
	 *   { Title, Tagline, Description, Highlights: [{Label, Text}], Actions: [{Text, Href}] }
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadCover(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + '_cover.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('Docuserve: No _cover.md found; splash will use catalog data.');
					return tmpCallback();
				}

				this.pict.AppData.Docuserve.Cover = this.parseCover(pMarkdown);
				this.pict.AppData.Docuserve.CoverLoaded = true;
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading _cover.md: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Parse _cover.md markdown text into a structured object.
	 *
	 * @param {string} pMarkdown - Raw _cover.md content
	 * @returns {Object} Parsed cover data
	 */
	parseCover(pMarkdown)
	{
		let tmpCover = {
			Title: '',
			Tagline: '',
			Description: '',
			Highlights: [],
			Actions: []
		};

		let tmpLines = pMarkdown.split('\n');

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i].trim();

			if (!tmpLine)
			{
				continue;
			}

			// Heading — the title
			let tmpHeadingMatch = tmpLine.match(/^#+\s+(.+)/);
			if (tmpHeadingMatch)
			{
				tmpCover.Title = tmpHeadingMatch[1].trim();
				continue;
			}

			// Blockquote — the tagline
			let tmpBlockquoteMatch = tmpLine.match(/^>\s*(.*)/);
			if (tmpBlockquoteMatch)
			{
				tmpCover.Tagline = tmpBlockquoteMatch[1].trim();
				continue;
			}

			// Bullet list — highlights (e.g. "- **Fable** — Core ecosystem, DI, config")
			let tmpBulletMatch = tmpLine.match(/^[-*+]\s+(.*)/);
			if (tmpBulletMatch)
			{
				let tmpBulletContent = tmpBulletMatch[1];
				// Try to split on bold label: **Label** — rest
				let tmpLabelMatch = tmpBulletContent.match(/^\*\*([^*]+)\*\*\s*[-—:]\s*(.*)/);
				if (tmpLabelMatch)
				{
					tmpCover.Highlights.push({ Label: tmpLabelMatch[1].trim(), Text: tmpLabelMatch[2].trim() });
				}
				else
				{
					tmpCover.Highlights.push({ Label: '', Text: tmpBulletContent.trim() });
				}
				continue;
			}

			// Bare link — action button (e.g. "[Get Started](getting-started.md)")
			let tmpLinkMatch = tmpLine.match(/^\[([^\]]+)\]\(([^)]+)\)\s*$/);
			if (tmpLinkMatch)
			{
				tmpCover.Actions.push({ Text: tmpLinkMatch[1].trim(), Href: tmpLinkMatch[2].trim() });
				continue;
			}

			// Otherwise it's description text
			if (!tmpCover.Description)
			{
				tmpCover.Description = tmpLine;
			}
			else
			{
				tmpCover.Description += ' ' + tmpLine;
			}
		}

		return tmpCover;
	}

	/**
	 * Fetch and parse _sidebar.md into structured navigation data.
	 *
	 * The expected _sidebar.md format follows the docsify convention:
	 *   - [Home](/)
	 *   - Group Title
	 *     - [module-name](/group/module/)
	 *   - [Group Title](group.md)
	 *     - [module-name](/group/module/)
	 *
	 * If _sidebar.md is successfully loaded and parsed, its data replaces
	 * the catalog-inferred SidebarGroups in AppData.
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadSidebar(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + '_sidebar.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('Docuserve: No _sidebar.md found; sidebar will use catalog data.');
					return tmpCallback();
				}

				let tmpSidebarData = this.parseSidebarMarkdown(pMarkdown);
				if (tmpSidebarData && tmpSidebarData.length > 0)
				{
					this.pict.AppData.Docuserve.SidebarGroups = tmpSidebarData;
					this.pict.AppData.Docuserve.SidebarLoaded = true;
				}
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading _sidebar.md: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Fetch and parse _topbar.md into structured data for the top bar view.
	 *
	 * The expected _topbar.md format:
	 *   # Brand Name
	 *   - [Link Text](url)
	 *   - [Link Text](url)
	 *
	 * The heading becomes the brand/title shown on the left.  List items become
	 * navigation links.  External links (starting with http) render on the
	 * right side; internal links render in the centre nav area.
	 *
	 * Parsed result stored in this.pict.AppData.Docuserve.TopBar:
	 *   { Brand, NavLinks: [{Text, Href, External}], ExternalLinks: [{Text, Href}] }
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadTopbar(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + '_topbar.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('Docuserve: No _topbar.md found; top bar will use defaults.');
					return tmpCallback();
				}

				this.pict.AppData.Docuserve.TopBar = this.parseTopbar(pMarkdown);
				this.pict.AppData.Docuserve.TopBarLoaded = true;
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading _topbar.md: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Parse _topbar.md markdown text into a structured object.
	 *
	 * @param {string} pMarkdown - Raw _topbar.md content
	 * @returns {Object} Parsed top bar data { Brand, NavLinks, ExternalLinks }
	 */
	parseTopbar(pMarkdown)
	{
		let tmpTopBar = {
			Brand: '',
			NavLinks: [],
			ExternalLinks: []
		};

		let tmpLines = pMarkdown.split('\n');

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i].trim();

			if (!tmpLine)
			{
				continue;
			}

			// Heading — the brand name
			let tmpHeadingMatch = tmpLine.match(/^#+\s+(.+)/);
			if (tmpHeadingMatch)
			{
				tmpTopBar.Brand = tmpHeadingMatch[1].trim();
				continue;
			}

			// Bullet list item with link
			let tmpBulletMatch = tmpLine.match(/^[-*+]\s+(.*)/);
			if (tmpBulletMatch)
			{
				let tmpContent = tmpBulletMatch[1].trim();
				let tmpLinkMatch = tmpContent.match(/^\[([^\]]+)\]\(([^)]+)\)/);

				if (tmpLinkMatch)
				{
					let tmpText = tmpLinkMatch[1].trim();
					let tmpHref = tmpLinkMatch[2].trim();

					// External links (http/https) go to the right side
					if (tmpHref.match(/^https?:\/\//))
					{
						tmpTopBar.ExternalLinks.push({ Text: tmpText, Href: tmpHref });
					}
					else
					{
						// Internal link — convert to hash route
						let tmpRoute = this.convertSidebarLink(tmpHref);
						tmpTopBar.NavLinks.push({ Text: tmpText, Href: tmpRoute });
					}
				}
				continue;
			}
		}

		return tmpTopBar;
	}

	/**
	 * Fetch and parse errorpage.md into HTML for use as a custom error page.
	 *
	 * The errorpage.md is a standard markdown file.  If it contains the
	 * placeholder `{{path}}` anywhere in its source, that token will be
	 * replaced with the actual requested path at display time (via
	 * getErrorPageHTML).
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadErrorPage(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + 'errorpage.md')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					this.log.info('Docuserve: No errorpage.md found; errors will use default page.');
					return tmpCallback();
				}

				this.pict.AppData.Docuserve.ErrorPageHTML = this._ContentProvider.parseMarkdown(pMarkdown);
				this.pict.AppData.Docuserve.ErrorPageLoaded = true;
				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading errorpage.md: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Load the keyword search index (retold-keyword-index.json).
	 *
	 * If the index file exists, hydrates a lunr.Index for client-side search
	 * and stores the document metadata map.  If the file is not found, search
	 * features will simply not appear in the UI.
	 *
	 * @param {Function} fCallback - Callback when done
	 */
	loadKeywordIndex(fCallback)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';

		fetch(tmpDocsBase + 'retold-keyword-index.json')
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.json();
			})
			.then((pIndexData) =>
			{
				if (!pIndexData || !pIndexData.LunrIndex || !pIndexData.Documents)
				{
					this.log.info('Docuserve: No keyword index found; search will be unavailable.');
					return tmpCallback();
				}

				try
				{
					this._LunrIndex = libLunr.Index.load(pIndexData.LunrIndex);
					this._KeywordDocuments = pIndexData.Documents;
					this.pict.AppData.Docuserve.KeywordIndexLoaded = true;
					this.pict.AppData.Docuserve.KeywordDocumentCount = pIndexData.DocumentCount || 0;
					this.log.info(`Docuserve: Keyword index loaded (${pIndexData.DocumentCount || 0} documents).`);
				}
				catch (pError)
				{
					this.log.warn(`Docuserve: Error hydrating lunr index: ${pError}`);
				}

				return tmpCallback();
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error loading keyword index: ${pError}`);
				return tmpCallback();
			});
	}

	/**
	 * Check whether a group/module pair exists in the loaded catalog.
	 *
	 * Used by search() to decide whether a result should route to
	 * #/doc/ (catalog module → GitHub raw URL) or #/page/ (local doc).
	 *
	 * @param {string} pGroup - The group key (e.g. "fable")
	 * @param {string} pModule - The module name (e.g. "fable")
	 * @returns {boolean} True if the module is found in the catalog
	 */
	isModuleInCatalog(pGroup, pModule)
	{
		if (!this._Catalog || !this._Catalog.Groups)
		{
			return false;
		}

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			if (tmpGroup.Key !== pGroup)
			{
				continue;
			}

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Name === pModule)
				{
					return true;
				}
			}
		}

		return false;
	}

	/**
	 * Find the catalog group key that contains a given module name.
	 *
	 * Searches all groups in the catalog for a module with the given name.
	 * This is used to resolve sidebar links where the path uses a conceptual
	 * group name (e.g. "fable") that doesn't match the catalog group key
	 * (e.g. "modules").
	 *
	 * @param {string} pModuleName - The module name to find (e.g. "fable")
	 * @returns {string|null} The catalog group key (e.g. "modules") or null
	 */
	findModuleGroupKey(pModuleName)
	{
		if (!this._Catalog || !this._Catalog.Groups)
		{
			return null;
		}

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				if (tmpGroup.Modules[j].Name === pModuleName)
				{
					return tmpGroup.Key;
				}
			}
		}

		return null;
	}

	/**
	 * Check whether a group key exists in the loaded catalog.
	 *
	 * Used to dynamically validate group keys instead of hardcoding them.
	 *
	 * @param {string} pGroupKey - The group key (e.g. "fable", "example_applications")
	 * @returns {boolean} True if the group is found in the catalog
	 */
	isGroupInCatalog(pGroupKey)
	{
		if (!this._Catalog || !this._Catalog.Groups)
		{
			return false;
		}

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			if (this._Catalog.Groups[i].Key === pGroupKey)
			{
				return true;
			}
		}

		return false;
	}

	/**
	 * Search the keyword index for documents matching a query.
	 *
	 * Returns an array of result objects sorted by relevance:
	 *   [{ Key, Title, Group, Module, DocPath, Score, Route }]
	 *
	 * @param {string} pQuery - The search query
	 * @returns {Array} Search results (empty if no index or no matches)
	 */
	search(pQuery)
	{
		if (!this._LunrIndex || !this._KeywordDocuments || !pQuery || !pQuery.trim())
		{
			return [];
		}

		let tmpResults = [];

		try
		{
			let tmpLunrResults = this._LunrIndex.search(pQuery);

			for (let i = 0; i < tmpLunrResults.length; i++)
			{
				let tmpRef = tmpLunrResults[i].ref;
				let tmpScore = tmpLunrResults[i].score;
				let tmpDoc = this._KeywordDocuments[tmpRef];

				if (!tmpDoc)
				{
					continue;
				}

				// Build the hash route from the document key (group/module/docpath)
				let tmpParts = tmpRef.split('/');
				let tmpRoute = '';
				if (tmpParts.length >= 2)
				{
					// Check whether this group/module exists in the catalog.
					// If it does, route to #/doc/ which fetches from GitHub.
					// If not, fall back to #/page/ which fetches locally.
					let tmpGroup = tmpParts[0];
					let tmpModule = tmpParts[1];

					if (this.isModuleInCatalog(tmpGroup, tmpModule))
					{
						tmpRoute = '#/doc/' + tmpRef;
					}
					else
					{
						// Local document — route via #/page/ using the full ref path
						tmpRoute = '#/page/' + tmpRef;
					}
				}

				tmpResults.push({
					Key: tmpRef,
					Title: tmpDoc.Title || tmpRef,
					Group: tmpDoc.Group || '',
					Module: tmpDoc.Module || '',
					DocPath: tmpDoc.DocPath || '',
					Score: tmpScore,
					Route: tmpRoute
				});
			}
		}
		catch (pError)
		{
			this.log.warn(`Docuserve: Search error: ${pError}`);
		}

		return tmpResults;
	}

	/**
	 * Get the error page HTML for a given requested path.
	 *
	 * If a custom errorpage.md was loaded, its parsed HTML is returned with
	 * the `{{path}}` placeholder replaced by the actual requested path.
	 * Otherwise a default not-found HTML block is returned.
	 *
	 * @param {string} pRequestedPath - The path that was not found
	 * @returns {string} HTML to display
	 */
	getErrorPageHTML(pRequestedPath)
	{
		let tmpPath = pRequestedPath || 'unknown';

		if (this.pict.AppData.Docuserve.ErrorPageLoaded && this.pict.AppData.Docuserve.ErrorPageHTML)
		{
			// Replace the {{path}} placeholder with the actual requested path
			return this.pict.AppData.Docuserve.ErrorPageHTML.replace(/\{\{path\}\}/g, this._ContentProvider.escapeHTML(tmpPath));
		}

		// Default fallback
		return '<div class="docuserve-not-found">'
			+ '<h2>Page Not Found</h2>'
			+ '<p>The document <code>' + this._ContentProvider.escapeHTML(tmpPath) + '</code> could not be loaded.</p>'
			+ '<p><a href="#/Home">Return to the home page</a></p>'
			+ '</div>';
	}

	/**
	 * Parse _sidebar.md into the SidebarGroups format the sidebar view consumes.
	 *
	 * Returns an array of group objects:
	 *   [{ Name, Key, Route, Modules: [{ Name, HasDocs, Group, Route }] }]
	 *
	 * Top-level items (no indent) become groups.  Indented child items become
	 * modules within the preceding group.  The special "Home" entry is stored
	 * as a group with no modules.
	 *
	 * @param {string} pMarkdown - Raw _sidebar.md content
	 * @returns {Array} Parsed sidebar groups
	 */
	parseSidebarMarkdown(pMarkdown)
	{
		let tmpGroups = [];
		let tmpCurrentGroup = null;
		let tmpLines = pMarkdown.split('\n');

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			if (!tmpLine.trim())
			{
				continue;
			}

			// Detect indent level: child items have 2+ leading spaces
			let tmpIndentMatch = tmpLine.match(/^(\s*)/);
			let tmpIndent = tmpIndentMatch ? tmpIndentMatch[1].length : 0;
			let tmpContent = tmpLine.trim();

			// Must start with a list marker
			let tmpListMatch = tmpContent.match(/^[-*+]\s+(.*)/);
			if (!tmpListMatch)
			{
				continue;
			}

			let tmpItemContent = tmpListMatch[1].trim();

			// Parse link if present: [Text](href)
			let tmpLinkMatch = tmpItemContent.match(/^\[([^\]]+)\]\(([^)]+)\)/);

			if (tmpIndent < 2)
			{
				// Top-level item — this is a group header or standalone link
				if (tmpLinkMatch)
				{
					let tmpName = tmpLinkMatch[1].trim();
					let tmpHref = tmpLinkMatch[2].trim();

					// Derive a group key from the href or name
					let tmpKey = this.deriveGroupKey(tmpName, tmpHref);
					let tmpRoute = this.convertSidebarLink(tmpHref);

					tmpCurrentGroup = {
						Name: tmpName,
						Key: tmpKey,
						Route: tmpRoute,
						Modules: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
				else
				{
					// Plain text group header (no link)
					let tmpName = tmpItemContent;
					let tmpKey = tmpName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

					tmpCurrentGroup = {
						Name: tmpName,
						Key: tmpKey,
						Route: '',
						Modules: []
					};
					tmpGroups.push(tmpCurrentGroup);
				}
			}
			else if (tmpCurrentGroup)
			{
				// Indented item — this is a module within the current group
				if (tmpLinkMatch)
				{
					let tmpModuleName = tmpLinkMatch[1].trim();
					let tmpModuleHref = tmpLinkMatch[2].trim();
					let tmpModuleRoute = this.convertSidebarLink(tmpModuleHref);

					tmpCurrentGroup.Modules.push({
						Name: tmpModuleName,
						HasDocs: true,
						Group: tmpCurrentGroup.Key,
						Route: tmpModuleRoute
					});
				}
				else
				{
					// Plain text child entry (no docs link)
					tmpCurrentGroup.Modules.push({
						Name: tmpItemContent,
						HasDocs: false,
						Group: tmpCurrentGroup.Key,
						Route: ''
					});
				}
			}
		}

		return tmpGroups;
	}

	/**
	 * Convert a docsify-style sidebar link href into a docuserve hash route.
	 *
	 * Handles these forms:
	 *   /                        -> #/Home
	 *   /group/module/           -> #/doc/group/module
	 *   /group/module/path.md    -> #/doc/group/module/path.md
	 *   something.md             -> #/page/something
	 *
	 * @param {string} pHref - The original sidebar link href
	 * @returns {string} The converted hash route
	 */
	convertSidebarLink(pHref)
	{
		if (!pHref)
		{
			return '';
		}

		// Root home link
		if (pHref === '/')
		{
			return '#/Home';
		}

		// Bare hash link (e.g. "#fable") — docsify convention for the home/readme page.
		// Navigate to the first available content route in the sidebar, skipping
		// #/Home since the cover page is already displaying that.
		if (pHref.match(/^#[^/]/))
		{
			let tmpSidebarGroups = this.pict.AppData.Docuserve.SidebarGroups;
			if (tmpSidebarGroups)
			{
				for (let g = 0; g < tmpSidebarGroups.length; g++)
				{
					let tmpModules = tmpSidebarGroups[g].Modules;
					if (tmpModules)
					{
						for (let m = 0; m < tmpModules.length; m++)
						{
							if (tmpModules[m].HasDocs && tmpModules[m].Route && tmpModules[m].Route !== '#/Home')
							{
								return tmpModules[m].Route;
							}
						}
					}
					if (tmpSidebarGroups[g].Route && tmpSidebarGroups[g].Route !== '#/Home')
					{
						return tmpSidebarGroups[g].Route;
					}
				}
			}
			return '#/Home';
		}

		// Strip leading/trailing slashes for parsing
		let tmpPath = pHref.replace(/^\//, '').replace(/\/$/, '');

		if (!tmpPath)
		{
			return '#/Home';
		}

		let tmpParts = tmpPath.split('/');

		// Check if it's a module path (group/module) — both the group
		// AND the module must exist in the catalog, otherwise treat it
		// as a local page reference (e.g. docs subfolder).
		if (tmpParts.length >= 2)
		{
			if (this.isGroupInCatalog(tmpParts[0]) && this.isModuleInCatalog(tmpParts[0], tmpParts[1]))
			{
				return '#/doc/' + tmpPath;
			}

			// Fallback: the path may use a conceptual group name (e.g. "fable/fable")
			// where the first part isn't a catalog group key. Try to find the module
			// (second part) in any catalog group and rewrite the route.
			let tmpActualGroup = this.findModuleGroupKey(tmpParts[1]);
			if (tmpActualGroup)
			{
				let tmpRemainder = tmpParts.slice(2).join('/');
				if (tmpRemainder)
				{
					return '#/doc/' + tmpActualGroup + '/' + tmpParts[1] + '/' + tmpRemainder;
				}
				return '#/doc/' + tmpActualGroup + '/' + tmpParts[1];
			}
		}

		// Local page reference
		if (tmpPath.match(/\.md$/))
		{
			return '#/page/' + tmpPath.replace(/\.md$/, '');
		}

		return '#/page/' + tmpPath;
	}

	/**
	 * Derive a short group key from a sidebar group name or href.
	 *
	 * @param {string} pName - The display name (e.g. "Fable — Core Ecosystem")
	 * @param {string} pHref - The link href (e.g. "fable.md")
	 * @returns {string} A short key (e.g. "fable")
	 */
	deriveGroupKey(pName, pHref)
	{
		// Try href first — "fable.md" -> "fable"
		if (pHref && pHref !== '/')
		{
			let tmpFromHref = pHref.replace(/^\//, '').replace(/\.md$/, '').replace(/\/$/, '');
			if (tmpFromHref && !tmpFromHref.includes('/'))
			{
				return tmpFromHref.toLowerCase();
			}
		}

		// Fall back to first word of name lowercased
		let tmpFirstWord = pName.split(/[\s—\-:]+/)[0];
		return tmpFirstWord.toLowerCase().replace(/[^a-z0-9]/g, '');
	}

	/**
	 * Build structured sidebar data from the catalog for the sidebar view.
	 *
	 * @param {Object} pCatalog - The parsed retold-catalog.json
	 */
	buildSidebarData(pCatalog)
	{
		let tmpSidebarGroups = [];

		for (let i = 0; i < pCatalog.Groups.length; i++)
		{
			let tmpGroup = pCatalog.Groups[i];
			let tmpGroupEntry = {
				Name: tmpGroup.Name,
				Key: tmpGroup.Key,
				Description: tmpGroup.Description,
				Modules: []
			};

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				tmpGroupEntry.Modules.push({
					Name: tmpModule.Name,
					HasDocs: tmpModule.HasDocs,
					Group: tmpGroup.Key,
					Route: '#/doc/' + tmpGroup.Key + '/' + tmpModule.Name
				});
			}

			tmpSidebarGroups.push(tmpGroupEntry);
		}

		this.pict.AppData.Docuserve.SidebarGroups = tmpSidebarGroups;
	}

	/**
	 * Resolve a document URL from group/module/path to a fetchable URL.
	 *
	 * @param {string} pGroup - The group key (e.g. 'fable')
	 * @param {string} pModule - The module name (e.g. 'fable')
	 * @param {string} pPath - The document path within the module docs (e.g. 'README.md')
	 * @returns {string} The resolved URL
	 */
	resolveDocumentURL(pGroup, pModule, pPath)
	{
		if (!this._Catalog)
		{
			return null;
		}

		let tmpOrg = this._Catalog.GitHubOrg || 'stevenvelozo';
		let tmpDefaultBranch = this._Catalog.DefaultBranch || 'master';

		// Find the module in the catalog
		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			if (tmpGroup.Key !== pGroup)
			{
				continue;
			}

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Name !== pModule)
				{
					continue;
				}

				let tmpBranch = tmpModule.Branch || tmpDefaultBranch;
				let tmpDocPath = pPath || 'README.md';
				return 'https://raw.githubusercontent.com/' + tmpOrg + '/' + tmpModule.Repo + '/' + tmpBranch + '/docs/' + tmpDocPath;
			}
		}

		return null;
	}

	/**
	 * Resolve a GitHub repository URL to an internal hash route.
	 *
	 * If the URL matches a module in the loaded catalog, returns the
	 * corresponding #/doc/ route so the link navigates within docuserve
	 * instead of leaving to GitHub.
	 *
	 * @param {string} pURL - A GitHub URL (e.g. "https://github.com/stevenvelozo/fable")
	 * @returns {string|null} The hash route (e.g. "#/doc/fable/fable") or null if not a catalog module
	 */
	resolveGitHubURLToRoute(pURL)
	{
		if (!this._Catalog || !this._Catalog.Groups || !pURL)
		{
			return null;
		}

		// Match https://github.com/{org}/{repo} with optional trailing path/slash
		let tmpMatch = pURL.match(/^https?:\/\/github\.com\/([^/]+)\/([^/]+)/);
		if (!tmpMatch)
		{
			return null;
		}

		let tmpOrg = tmpMatch[1];
		let tmpRepo = tmpMatch[2];

		// Only resolve URLs that match the catalog's GitHub org
		if (tmpOrg !== this._Catalog.GitHubOrg)
		{
			return null;
		}

		// Search catalog for a module with a matching Repo
		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Repo === tmpRepo)
				{
					return '#/doc/' + tmpGroup.Key + '/' + tmpModule.Name;
				}
			}
		}

		return null;
	}

	/**
	 * Resolve the GitHub Pages documentation URL for a module.
	 *
	 * Returns a URL like https://stevenvelozo.github.io/pict-view/ if the
	 * module exists in the catalog.
	 *
	 * @param {string} pGroup - The group key
	 * @param {string} pModule - The module name
	 * @returns {string|null} The GitHub Pages URL or null
	 */
	resolveGitHubPagesURL(pGroup, pModule)
	{
		if (!this._Catalog || !this._Catalog.Groups)
		{
			return null;
		}

		let tmpOrg = this._Catalog.GitHubOrg || 'stevenvelozo';

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			if (tmpGroup.Key !== pGroup)
			{
				continue;
			}

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Name !== pModule)
				{
					continue;
				}

				if (!tmpModule.HasDocs)
				{
					return null;
				}

				return 'https://' + tmpOrg + '.github.io/' + tmpModule.Repo + '/';
			}
		}

		return null;
	}

	/**
	 * Get the module-specific sidebar entries for a given group/module.
	 *
	 * @param {string} pGroup - The group key
	 * @param {string} pModule - The module name
	 * @returns {Array|null} The sidebar entries or null
	 */
	getModuleSidebar(pGroup, pModule)
	{
		if (!this._Catalog)
		{
			return null;
		}

		for (let i = 0; i < this._Catalog.Groups.length; i++)
		{
			let tmpGroup = this._Catalog.Groups[i];
			if (tmpGroup.Key !== pGroup)
			{
				continue;
			}

			for (let j = 0; j < tmpGroup.Modules.length; j++)
			{
				let tmpModule = tmpGroup.Modules[j];
				if (tmpModule.Name !== pModule)
				{
					continue;
				}

				return tmpModule.Sidebar || null;
			}
		}

		return null;
	}

	/**
	 * Fetch a markdown document and convert it to HTML.
	 *
	 * @param {string} pURL - The URL to fetch
	 * @param {Function} fCallback - Callback receiving (error, htmlContent)
	 * @param {string} [pCurrentGroup] - The current group key for link resolution
	 * @param {string} [pCurrentModule] - The current module name for link resolution
	 * @param {string} [pCurrentDocPath] - The current document path for link resolution
	 */
	fetchDocument(pURL, fCallback, pCurrentGroup, pCurrentModule, pCurrentDocPath)
	{
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : () => {};

		if (!pURL)
		{
			return tmpCallback('No URL provided', '');
		}

		// Check cache
		if (this._ContentCache[pURL])
		{
			return tmpCallback(null, this._ContentCache[pURL]);
		}

		fetch(pURL)
			.then((pResponse) =>
			{
				if (!pResponse.ok)
				{
					return null;
				}
				return pResponse.text();
			})
			.then((pMarkdown) =>
			{
				if (!pMarkdown)
				{
					return tmpCallback('Document not found', this.getErrorPageHTML(pURL));
				}

				let tmpHTML = this._ContentProvider.parseMarkdown(pMarkdown, this._createLinkResolver(pCurrentGroup, pCurrentModule, pCurrentDocPath), this._createImageResolver(pURL));
				this._ContentCache[pURL] = tmpHTML;
				return tmpCallback(null, tmpHTML);
			})
			.catch((pError) =>
			{
				this.log.warn(`Docuserve: Error fetching document [${pURL}]: ${pError}`);
				return tmpCallback(pError, this.getErrorPageHTML(pURL));
			});
	}

	/**
	 * Fetch a local document relative to the docs folder.
	 *
	 * @param {string} pPath - The relative path (e.g. 'architecture.md')
	 * @param {Function} fCallback - Callback receiving (error, htmlContent)
	 * @param {string} [pCurrentGroup] - The current group key for link resolution
	 * @param {string} [pCurrentModule] - The current module name for link resolution
	 * @param {string} [pCurrentDocPath] - The current document path for link resolution
	 */
	fetchLocalDocument(pPath, fCallback, pCurrentGroup, pCurrentModule, pCurrentDocPath)
	{
		let tmpDocsBase = this.pict.AppData.Docuserve.DocsBaseURL || '';
		let tmpURL = tmpDocsBase + pPath;
		this.fetchDocument(tmpURL, fCallback, pCurrentGroup, pCurrentModule, pCurrentDocPath);
	}

	/**
	 * Convert a docsify-style internal link to a hash route for docuserve.
	 *
	 * When module context is provided, relative links (e.g. "api.md" or
	 * "./settings-manager.md") are resolved within the current module and
	 * document directory rather than falling back to the docs root.
	 *
	 * @param {string} pHref - The original link href
	 * @param {string} [pCurrentGroup] - The current group key (e.g. "fable")
	 * @param {string} [pCurrentModule] - The current module name (e.g. "fable")
	 * @param {string} [pCurrentDocPath] - The current document path within the module (e.g. "services/README.md")
	 * @returns {string} The converted hash route
	 */
	convertDocLink(pHref, pCurrentGroup, pCurrentModule, pCurrentDocPath)
	{
		// Strip leading ./ prefix for relative paths
		let tmpPath = pHref.replace(/^\.\//, '');
		// Remove leading slash
		tmpPath = tmpPath.replace(/^\//, '');

		// If it looks like an absolute module path (group/module/...), route directly.
		// Both the group AND the module must exist in the catalog, otherwise treat
		// as a local page reference (e.g. docs subfolder like modules/modules.md).
		let tmpParts = tmpPath.split('/');
		if (tmpParts.length >= 2)
		{
			if (this.isGroupInCatalog(tmpParts[0]) && this.isModuleInCatalog(tmpParts[0], tmpParts[1]))
			{
				return '#/doc/' + tmpPath;
			}
		}

		// If we have module context, resolve relative to current document's directory
		if (pCurrentGroup && pCurrentModule)
		{
			// Determine the directory of the current document
			let tmpDocDir = '';
			if (pCurrentDocPath)
			{
				let tmpDirParts = pCurrentDocPath.split('/');
				if (tmpDirParts.length > 1)
				{
					tmpDirParts.pop(); // Remove filename
					tmpDocDir = tmpDirParts.join('/') + '/';
				}
			}
			return '#/doc/' + pCurrentGroup + '/' + pCurrentModule + '/' + tmpDocDir + tmpPath;
		}

		// Local doc page (no module context)
		if (tmpPath.match(/\.md$/))
		{
			let tmpPageKey = tmpPath.replace(/\.md$/, '');
			return '#/page/' + tmpPageKey;
		}

		return '#/page/' + tmpPath;
	}

}

module.exports = DocuserveDocumentationProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: "Docuserve-Documentation",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

},{"lunr":3,"pict-provider":19,"pict-section-content":8}],12:[function(require,module,exports){
/**
 * Pict Provider: Theme
 *
 * Runtime theme manager for Pict applications.  Registers theme bundles
 * (token maps + CSS + SVG + image assets) and applies them by injecting
 * CSS custom properties into a single <style id="pict-theme"> element.
 *
 * Themes can be:
 *   - Single-mode (Modes.Strategy = "single")
 *   - Paired light/dark (Modes.Strategy = "paired")
 *   - System-aware (Modes.Strategy = "system" — paired + auto-pick)
 *
 * Mode is reflected as `theme-light` / `theme-dark` class on <html>.
 *
 * Token resolution path examples:
 *   provider.token('Tokens.Color.Background.Primary') -> raw current value
 *   provider.cssVar('Color.Background.Primary')       -> 'var(--theme-color-background-primary)'
 *   provider.asset('SVG', 'Logo')                     -> SVG string
 *   provider.image('Hero')                            -> image URL / data URL
 *
 * Template expressions registered (when pict has addTemplate):
 *   {~Theme:Tokens.Color.Background.Primary~}    raw value
 *   {~ThemeVar:Color.Background.Primary~}        var(--theme-...) reference
 *   {~ThemeAsset:SVG.Logo~}                      asset content
 *   {~ThemeImage:Hero~}                          image URL
 *
 * Stateless: this provider does not persist anything.  Host applications
 * decide what to apply at boot (from localStorage, server config, etc.).
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */
const libPictProvider = require('pict-provider');
const libDiagramAdapter = require('./Theme-Diagram-Adapter.js');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'Theme',
	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

const STYLE_ELEMENT_ID = 'pict-theme';
const HTML_CLASS_LIGHT = 'theme-light';
const HTML_CLASS_DARK = 'theme-dark';
const CSS_VAR_PREFIX = '--theme-';

class PictProviderTheme extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictProviderTheme';

		this._themes = {};
		this._themeOrder = [];
		this._activeHash = null;
		this._activeMode = null;
		this._resolvedMode = null;
		this._registeredCSSHashes = [];
		this._applyListeners = [];

		// Diagram adapter: helper API for plugging Mermaid (and any
		// future SVG-baking diagram engine) into the theme lifecycle.
		// Exposes the same functions as the standalone require, plus
		// `adaptMermaid(mermaid, options)` bound to this provider.
		let tmpSelf = this;
		this.diagram =
		{
			MERMAID_TOKEN_MAP:           libDiagramAdapter.MERMAID_TOKEN_MAP,
			readCSSVar:                  libDiagramAdapter.readCSSVar,
			getMermaidTokenMap:          libDiagramAdapter.getMermaidTokenMap,
			buildMermaidThemeVariables:  libDiagramAdapter.buildMermaidThemeVariables,
			initializeMermaid:           libDiagramAdapter.initializeMermaid,
			stashMermaidSource:          libDiagramAdapter.stashMermaidSource,
			refreshMermaidDiagrams:      libDiagramAdapter.refreshMermaidDiagrams,
			stripMermaidStyleImportance: libDiagramAdapter.stripMermaidStyleImportance,
			adaptMermaid: function (pMermaid, pOptions)
			{
				return libDiagramAdapter.adaptMermaid(tmpSelf, pMermaid, pOptions);
			}
		};

		// Auto-register the four theme template expressions if the host pict
		// supports addTemplate.  In bare-fable/test contexts this is skipped.
		if (this.pict && typeof this.pict.addTemplate === 'function')
		{
			try
			{
				this.pict.addTemplate(require('./templates/Pict-Template-Theme.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeVar.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeAsset.js'));
				this.pict.addTemplate(require('./templates/Pict-Template-ThemeImage.js'));
			}
			catch (pError)
			{
				if (this.log) this.log.warn('PictProviderTheme: template registration skipped: ' + pError.message);
			}
		}
	}

	// ================================================================
	// Theme registration
	// ================================================================

	/**
	 * Register a theme bundle.  Bundle is the compiled JSON shape (see
	 * the manifest schema documented in the module README and example themes).
	 *
	 * @param {object} pBundle - parsed manifest object
	 * @returns {boolean} true on success
	 */
	registerTheme(pBundle)
	{
		if (!pBundle || typeof pBundle !== 'object')
		{
			if (this.log) this.log.warn('PictProviderTheme.registerTheme: bundle is not an object');
			return false;
		}
		if (!pBundle.Hash || typeof pBundle.Hash !== 'string')
		{
			if (this.log) this.log.warn('PictProviderTheme.registerTheme: bundle missing required string Hash');
			return false;
		}

		if (!this._themes[pBundle.Hash])
		{
			this._themeOrder.push(pBundle.Hash);
		}
		this._themes[pBundle.Hash] = pBundle;
		return true;
	}

	/**
	 * Get an array of registered theme metadata for building UIs.
	 * @returns {Array<{Hash, Name, Version, Strategy, DefaultMode, Comprehensive}>}
	 */
	listThemes()
	{
		let tmpList = [];
		for (let i = 0; i < this._themeOrder.length; i++)
		{
			let tmpHash = this._themeOrder[i];
			let tmpTheme = this._themes[tmpHash];
			let tmpModes = tmpTheme.Modes || {};
			tmpList.push(
			{
				Hash: tmpTheme.Hash,
				Name: tmpTheme.Name || tmpTheme.Hash,
				Version: tmpTheme.Version || null,
				Strategy: tmpModes.Strategy || 'single',
				DefaultMode: tmpModes.Default || 'light',
				Comprehensive: tmpTheme.Comprehensive !== false
			});
		}
		return tmpList;
	}

	/**
	 * Get the raw stored bundle for a hash.
	 */
	getTheme(pHash)
	{
		return this._themes[pHash] || null;
	}

	// ================================================================
	// Apply / unapply
	// ================================================================

	/**
	 * Apply a theme by hash.  Optionally specify mode ('light', 'dark', 'system').
	 * If pMode is omitted, the theme's Modes.Default is used.
	 *
	 * @param {string} pHash
	 * @param {string} [pMode]
	 * @returns {boolean}
	 */
	applyTheme(pHash, pMode)
	{
		let tmpTheme = this._themes[pHash];
		if (!tmpTheme)
		{
			if (this.log) this.log.warn(`PictProviderTheme.applyTheme: unknown theme hash [${pHash}]`);
			return false;
		}

		// Resolve the effective theme bundle (handle BasedOn inheritance).
		let tmpEffective = this._resolveBundle(tmpTheme);

		let tmpStrategy = (tmpEffective.Modes && tmpEffective.Modes.Strategy) || 'single';
		let tmpDefaultMode = (tmpEffective.Modes && tmpEffective.Modes.Default) || 'light';

		let tmpMode = pMode || tmpDefaultMode;

		// Single-mode themes cannot be put into dark/light/system; clamp.
		if (tmpStrategy === 'single')
		{
			tmpMode = tmpDefaultMode;
		}

		this._activeHash = pHash;
		this._activeMode = tmpMode;

		// Build CSS once, regardless of mode (paired themes emit both blocks
		// and rely on the html class to switch between them).
		let tmpCSS = this._buildThemeCSS(tmpEffective);
		this._injectStyleElement(tmpCSS);

		// Register any auxiliary CSS files declared in the bundle through the
		// Pict CSS cascade so they participate in injectCSS().
		this._registerAuxiliaryCSS(tmpEffective);

		// Set the html class to drive paired-theme variable resolution.
		this._applyMode(tmpMode, tmpStrategy);

		// Notify subscribers (e.g. apps that need to re-color SVG icon palettes
		// from a bundle.IconColors block, swap chart palettes, etc.).
		this._fireApplyListeners(tmpEffective);

		return true;
	}

	/**
	 * Change mode without reapplying the theme.  No-op if no theme is active
	 * or active theme is single-mode.
	 *
	 * @param {string} pMode - 'light' | 'dark' | 'system'
	 */
	setMode(pMode)
	{
		if (!this._activeHash) return false;

		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpStrategy = (tmpTheme.Modes && tmpTheme.Modes.Strategy) || 'single';

		if (tmpStrategy === 'single') return false;

		this._activeMode = pMode;
		this._applyMode(pMode, tmpStrategy);
		this._fireApplyListeners(tmpTheme);
		return true;
	}

	// ================================================================
	// Listener subscription
	// ================================================================

	/**
	 * Subscribe to theme apply / mode-change events.  The callback is
	 * invoked with the effective (BasedOn-resolved) bundle and a context
	 * object: { Hash, Mode, ResolvedMode }.
	 *
	 * Apps use this to re-color SVG icon palettes, swap chart colors,
	 * push tokens into non-CSS consumers (canvas, WebGL), etc.
	 *
	 * Returns a dispose function for symmetry with offApply().
	 */
	onApply(fCallback)
	{
		if (typeof fCallback !== 'function') return function () {};
		this._applyListeners.push(fCallback);
		let tmpSelf = this;
		return function () { tmpSelf.offApply(fCallback); };
	}

	offApply(fCallback)
	{
		let tmpIdx = this._applyListeners.indexOf(fCallback);
		if (tmpIdx >= 0) this._applyListeners.splice(tmpIdx, 1);
	}

	_fireApplyListeners(pBundle)
	{
		if (this._applyListeners.length === 0) return;
		let tmpContext =
		{
			Hash: this._activeHash,
			Mode: this._activeMode,
			ResolvedMode: this._resolvedMode
		};
		for (let i = 0; i < this._applyListeners.length; i++)
		{
			try { this._applyListeners[i](pBundle, tmpContext); }
			catch (pError)
			{
				if (this.log) this.log.warn('PictProviderTheme: onApply listener threw: ' + pError.message);
			}
		}
	}

	/**
	 * Remove the injected style element, html class, and any auxiliary CSS.
	 */
	unapplyTheme()
	{
		if (typeof document !== 'undefined')
		{
			let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
			if (tmpStyleEl && tmpStyleEl.parentNode)
			{
				tmpStyleEl.parentNode.removeChild(tmpStyleEl);
			}
			if (document.documentElement && document.documentElement.classList)
			{
				document.documentElement.classList.remove(HTML_CLASS_LIGHT);
				document.documentElement.classList.remove(HTML_CLASS_DARK);
			}
		}

		// Unregister any auxiliary CSS we added.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.removeCSS === 'function')
		{
			for (let i = 0; i < this._registeredCSSHashes.length; i++)
			{
				this.pict.CSSMap.removeCSS(this._registeredCSSHashes[i]);
			}
		}
		this._registeredCSSHashes = [];

		this._activeHash = null;
		this._activeMode = null;
		this._resolvedMode = null;
		return true;
	}

	getActiveTheme()
	{
		// Live-read ResolvedMode so callers in system mode get the current OS
		// preference without the provider having to subscribe to media-query
		// changes.  Snapshot mode (explicit light/dark) returns as-is.
		return {
			Hash: this._activeHash,
			Mode: this._activeMode,
			ResolvedMode: this._activeHash ? this._currentResolvedMode() : null
		};
	}

	// ================================================================
	// Token / asset accessors
	// ================================================================

	/**
	 * Resolve a token by dot path against the active theme bundle.  Walks
	 * the entire bundle root, so paths can address Tokens, Brand, etc.
	 *
	 * If the value is paired ({Light, Dark}), returns the value at the
	 * currently resolved mode.
	 *
	 * @param {string} pPath - e.g. 'Tokens.Color.Background.Primary'
	 * @returns {string|number|null}
	 */
	token(pPath)
	{
		if (!this._activeHash) return null;
		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpValue = this._walkPath(tmpTheme, pPath);
		return this._resolveModedValue(tmpValue);
	}

	/**
	 * Returns a CSS `var(--theme-...)` reference for a token under Tokens.
	 * Path is given without the Tokens prefix:
	 *   cssVar('Color.Background.Primary') -> 'var(--theme-color-background-primary)'
	 *
	 * @param {string} pTokenPath
	 * @returns {string}
	 */
	cssVar(pTokenPath)
	{
		return 'var(' + this._cssVarName(pTokenPath) + ')';
	}

	/**
	 * Look up a named asset under SVG, optionally nested (e.g. 'Icons.Foo').
	 * @param {string} pCategory - 'SVG' | 'Image'
	 * @param {string} pName
	 */
	asset(pCategory, pName)
	{
		if (!this._activeHash) return null;
		let tmpTheme = this._resolveBundle(this._themes[this._activeHash]);
		let tmpRoot = tmpTheme[pCategory];
		if (!tmpRoot) return null;
		return this._walkPath(tmpRoot, pName);
	}

	image(pName)
	{
		return this.asset('Image', pName);
	}

	svg(pName)
	{
		return this.asset('SVG', pName);
	}

	// ================================================================
	// Internals
	// ================================================================

	/**
	 * Resolve a bundle's BasedOn chain into a single effective bundle by
	 * deep-merging this bundle onto its base.  Cycle-safe.
	 */
	_resolveBundle(pBundle)
	{
		let tmpChain = [];
		let tmpCurrent = pBundle;
		let tmpSeen = {};
		while (tmpCurrent)
		{
			if (tmpSeen[tmpCurrent.Hash]) break;
			tmpSeen[tmpCurrent.Hash] = true;
			tmpChain.unshift(tmpCurrent);
			let tmpBaseHash = tmpCurrent.BasedOn;
			tmpCurrent = tmpBaseHash ? this._themes[tmpBaseHash] : null;
		}
		if (tmpChain.length === 1) return tmpChain[0];

		let tmpResult = {};
		for (let i = 0; i < tmpChain.length; i++)
		{
			tmpResult = this._deepMerge(tmpResult, tmpChain[i]);
		}
		return tmpResult;
	}

	_deepMerge(pTarget, pSource)
	{
		let tmpResult = Object.assign({}, pTarget);
		let tmpKeys = Object.keys(pSource);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpVal = pSource[tmpKey];
			if (tmpVal !== null
				&& typeof tmpVal === 'object'
				&& !Array.isArray(tmpVal)
				&& tmpResult[tmpKey] !== null
				&& typeof tmpResult[tmpKey] === 'object'
				&& !Array.isArray(tmpResult[tmpKey]))
			{
				tmpResult[tmpKey] = this._deepMerge(tmpResult[tmpKey], tmpVal);
			}
			else
			{
				tmpResult[tmpKey] = tmpVal;
			}
		}
		return tmpResult;
	}

	/**
	 * Walk a dot-path from a starting object.  Returns null if any segment
	 * is missing.  Path segments are matched case-sensitively as authored.
	 */
	_walkPath(pRoot, pPath)
	{
		if (!pRoot || !pPath) return null;
		let tmpSegments = pPath.split('.');
		let tmpNode = pRoot;
		for (let i = 0; i < tmpSegments.length; i++)
		{
			if (tmpNode === null || typeof tmpNode !== 'object') return null;
			tmpNode = tmpNode[tmpSegments[i]];
			if (typeof tmpNode === 'undefined') return null;
		}
		return tmpNode;
	}

	/**
	 * If pValue is a paired-mode object {Light, Dark}, pick the value matching
	 * the current resolved mode.  Otherwise return as-is.
	 *
	 * For system mode this re-reads the OS preference on every call so the
	 * value is always live-correct — no JS listener required to keep it in
	 * sync.  Explicit modes use the snapshotted `_resolvedMode`.
	 */
	_resolveModedValue(pValue)
	{
		if (this._isPairedValue(pValue))
		{
			let tmpMode = this._currentResolvedMode();
			let tmpKey = (tmpMode === 'dark') ? 'Dark' : 'Light';
			return pValue[tmpKey];
		}
		return pValue;
	}

	_isPairedValue(pValue)
	{
		return pValue !== null
			&& typeof pValue === 'object'
			&& !Array.isArray(pValue)
			&& Object.keys(pValue).length > 0
			&& Object.keys(pValue).every((k) => k === 'Light' || k === 'Dark');
	}

	/**
	 * Build the CSS string for a theme.
	 *
	 * Single-mode themes emit one `:root { ... }` block.
	 *
	 * Paired themes emit four blocks, ordered so the CSS cascade resolves
	 * to the right mode without any JS listeners:
	 *
	 *   1) `:root { ...light... }`                                — baseline
	 *   2) `@media (prefers-color-scheme: dark) { :root { ...dark... } }`
	 *                                                            — OS-driven
	 *   3) `.theme-light { ...light... }`                         — explicit override
	 *   4) `.theme-dark  { ...dark... }`                          — explicit override
	 *
	 * Mode = 'system' is "no class on <html>" — the @media rule drives.
	 * Mode = 'light'/'dark' adds the matching class which wins on tie via
	 * source order (same specificity as :root, but later in the file).
	 *
	 * The result: OS toggle moves the page via CSS alone, no DOM listener
	 * needed, no class flipping.  Explicit setMode() flips the class to
	 * lock the page to one mode regardless of OS preference.
	 *
	 * Only values under bundle.Tokens become CSS custom properties.
	 */
	_buildThemeCSS(pTheme)
	{
		let tmpTokens = pTheme.Tokens || {};
		let tmpFlat = this._flattenTokens(tmpTokens, '');

		let tmpStrategy = (pTheme.Modes && pTheme.Modes.Strategy) || 'single';
		let tmpHasPaired = tmpFlat.some((tmpEntry) => this._isPairedValue(tmpEntry.Value));

		let tmpAliasLines = this._buildAliasLines(pTheme.Aliases);

		if (tmpStrategy === 'single' || !tmpHasPaired)
		{
			let tmpCSS = ':root {\n';
			for (let i = 0; i < tmpFlat.length; i++)
			{
				let tmpEntry = tmpFlat[i];
				let tmpVal = this._isPairedValue(tmpEntry.Value)
					? tmpEntry.Value.Light
					: tmpEntry.Value;
				tmpCSS += '\t' + this._cssVarName(tmpEntry.Path) + ': ' + this._formatCSSValue(tmpVal) + ';\n';
			}
			tmpCSS += tmpAliasLines;
			tmpCSS += '}\n';
			return tmpCSS;
		}

		// Paired theme: emit the four-block cascade.
		let tmpLightLines = '';
		let tmpDarkLines = '';
		let tmpFixedLines = '';

		for (let i = 0; i < tmpFlat.length; i++)
		{
			let tmpEntry = tmpFlat[i];
			let tmpVarName = this._cssVarName(tmpEntry.Path);
			if (this._isPairedValue(tmpEntry.Value))
			{
				if (typeof tmpEntry.Value.Light !== 'undefined')
				{
					tmpLightLines += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value.Light) + ';\n';
				}
				if (typeof tmpEntry.Value.Dark !== 'undefined')
				{
					tmpDarkLines += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value.Dark) + ';\n';
				}
			}
			else
			{
				// Non-paired tokens (spacing, typography, etc.) live in :root only.
				tmpFixedLines += '\t' + tmpVarName + ': ' + this._formatCSSValue(tmpEntry.Value) + ';\n';
			}
		}

		// Block 1: :root holds light values + every non-paired token + aliases.
		// Aliases use var() indirection, so they resolve to the active mode
		// automatically without being duplicated in the dark blocks.
		let tmpCSS = ':root {\n' + tmpLightLines + tmpFixedLines + tmpAliasLines + '}\n';

		// Block 2: @media (prefers-color-scheme: dark) — OS-driven dark override.
		// Only the paired tokens need to flip; fixed tokens and aliases stay
		// the same.  Indented one level for readability.
		let tmpMediaInner = '';
		let tmpDarkLinesIndented = tmpDarkLines.replace(/^\t/gm, '\t\t');
		tmpMediaInner += '\t:root {\n' + tmpDarkLinesIndented + '\t}\n';
		tmpCSS += '@media (prefers-color-scheme: dark) {\n' + tmpMediaInner + '}\n';

		// Block 3: .theme-light — explicit override that locks light regardless of OS.
		tmpCSS += '.' + HTML_CLASS_LIGHT + ' {\n' + tmpLightLines + '}\n';

		// Block 4: .theme-dark — explicit override that locks dark regardless of OS.
		tmpCSS += '.' + HTML_CLASS_DARK + ' {\n' + tmpDarkLines + '}\n';

		return tmpCSS;
	}

	/**
	 * Emit alias lines for legacy CSS variable names that map to token paths
	 * under Tokens.  Each alias becomes:
	 *   --legacy-name: var(--theme-color-...);
	 * Indirection-via-var means paired-mode swap propagates without
	 * needing alias entries duplicated in the .theme-dark block.
	 *
	 * Authored as: { "--legacy-name": "Color.Background.Primary", ... }
	 */
	_buildAliasLines(pAliases)
	{
		if (!pAliases || typeof pAliases !== 'object') return '';
		let tmpKeys = Object.keys(pAliases);
		let tmpOut = '';
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpAlias = tmpKeys[i];
			let tmpTarget = pAliases[tmpAlias];
			if (typeof tmpTarget !== 'string' || tmpTarget.length === 0) continue;
			tmpOut += '\t' + tmpAlias + ': var(' + this._cssVarName(tmpTarget) + ');\n';
		}
		return tmpOut;
	}

	/**
	 * Walk an arbitrary nested token tree and produce a flat list of
	 * { Path: 'color.background.primary', Value: <leaf> } entries.
	 *
	 * Paired-mode objects ({Light, Dark}) and primitive values are leaves.
	 */
	_flattenTokens(pNode, pPathPrefix)
	{
		let tmpResults = [];
		if (pNode === null || typeof pNode !== 'object' || Array.isArray(pNode))
		{
			if (pPathPrefix)
			{
				tmpResults.push({ Path: pPathPrefix, Value: pNode });
			}
			return tmpResults;
		}
		if (this._isPairedValue(pNode))
		{
			tmpResults.push({ Path: pPathPrefix, Value: pNode });
			return tmpResults;
		}
		let tmpKeys = Object.keys(pNode);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpChildPath = pPathPrefix ? (pPathPrefix + '.' + tmpKey) : tmpKey;
			let tmpChild = pNode[tmpKey];
			tmpResults = tmpResults.concat(this._flattenTokens(tmpChild, tmpChildPath));
		}
		return tmpResults;
	}

	/**
	 * 'Color.Background.Primary' -> '--theme-color-background-primary'
	 */
	_cssVarName(pTokenPath)
	{
		return CSS_VAR_PREFIX + pTokenPath.toLowerCase().replace(/\./g, '-');
	}

	_formatCSSValue(pValue)
	{
		if (pValue === null || typeof pValue === 'undefined') return '';
		if (typeof pValue === 'number') return String(pValue);
		return String(pValue);
	}

	_injectStyleElement(pCSS)
	{
		if (typeof document === 'undefined') return;
		let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
		if (!tmpStyleEl)
		{
			tmpStyleEl = document.createElement('style');
			tmpStyleEl.id = STYLE_ELEMENT_ID;
			document.head.appendChild(tmpStyleEl);
		}
		tmpStyleEl.textContent = pCSS;
	}

	_registerAuxiliaryCSS(pTheme)
	{
		// Clear previously registered auxiliary CSS so stale entries don't pile
		// up when switching themes.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.removeCSS === 'function')
		{
			for (let i = 0; i < this._registeredCSSHashes.length; i++)
			{
				this.pict.CSSMap.removeCSS(this._registeredCSSHashes[i]);
			}
		}
		this._registeredCSSHashes = [];

		if (!Array.isArray(pTheme.CSS)) return;
		if (!this.pict || !this.pict.CSSMap || typeof this.pict.CSSMap.addCSS !== 'function') return;

		for (let i = 0; i < pTheme.CSS.length; i++)
		{
			let tmpEntry = pTheme.CSS[i];
			if (!tmpEntry || !tmpEntry.Hash || typeof tmpEntry.Content !== 'string') continue;
			let tmpPriority = (typeof tmpEntry.Priority === 'number') ? tmpEntry.Priority : 500;
			this.pict.CSSMap.addCSS(tmpEntry.Hash, tmpEntry.Content, tmpPriority);
			this._registeredCSSHashes.push(tmpEntry.Hash);
		}
	}

	/**
	 * Apply the requested mode by adjusting the class on <html>.
	 *
	 *   - 'light' / 'dark': the matching class is added so the explicit
	 *     `.theme-light` / `.theme-dark` block in the injected stylesheet
	 *     overrides the @media (prefers-color-scheme) rule.
	 *   - 'system': both classes are cleared so the @media rule drives
	 *     the cascade from the OS preference, with no JS listener needed.
	 *
	 * `_resolvedMode` is snapshotted at apply time so synchronous reads
	 * via `token()` / `getActiveTheme()` return a consistent value.  In
	 * system mode it falls back to `_currentResolvedMode()` for callers
	 * that want a live read on each call.
	 */
	_applyMode(pMode, pStrategy)
	{
		if (pMode === 'system')
		{
			this._resolvedMode = this._readSystemPreference();
			this._clearHTMLClass();
		}
		else
		{
			this._resolvedMode = (pMode === 'dark') ? 'dark' : 'light';
			this._writeHTMLClass(this._resolvedMode);
		}
	}

	_writeHTMLClass(pResolvedMode)
	{
		if (typeof document === 'undefined' || !document.documentElement || !document.documentElement.classList) return;
		let tmpList = document.documentElement.classList;
		if (pResolvedMode === 'dark')
		{
			tmpList.remove(HTML_CLASS_LIGHT);
			tmpList.add(HTML_CLASS_DARK);
		}
		else
		{
			tmpList.remove(HTML_CLASS_DARK);
			tmpList.add(HTML_CLASS_LIGHT);
		}
	}

	_clearHTMLClass()
	{
		if (typeof document === 'undefined' || !document.documentElement || !document.documentElement.classList) return;
		let tmpList = document.documentElement.classList;
		tmpList.remove(HTML_CLASS_LIGHT);
		tmpList.remove(HTML_CLASS_DARK);
	}

	_readSystemPreference()
	{
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'light';
		try
		{
			return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
		}
		catch (pError)
		{
			return 'light';
		}
	}

	/**
	 * The mode currently driving the page.  Mirrors what the user sees:
	 * explicit modes return their literal value; 'system' reads the OS
	 * preference fresh so token() / getActiveTheme() never report a
	 * stale value when the OS toggles between calls.
	 *
	 * @returns {'light'|'dark'}
	 */
	_currentResolvedMode()
	{
		if (this._activeMode === 'system')
		{
			return this._readSystemPreference();
		}
		return (this._resolvedMode === 'dark') ? 'dark' : 'light';
	}
}

PictProviderTheme.default_configuration = _ProviderConfiguration;

module.exports = PictProviderTheme;
module.exports.STYLE_ELEMENT_ID = STYLE_ELEMENT_ID;
module.exports.HTML_CLASS_LIGHT = HTML_CLASS_LIGHT;
module.exports.HTML_CLASS_DARK = HTML_CLASS_DARK;
module.exports.CSS_VAR_PREFIX = CSS_VAR_PREFIX;
module.exports.DiagramAdapter = libDiagramAdapter;

},{"./Theme-Diagram-Adapter.js":13,"./templates/Pict-Template-Theme.js":14,"./templates/Pict-Template-ThemeAsset.js":15,"./templates/Pict-Template-ThemeImage.js":16,"./templates/Pict-Template-ThemeVar.js":17,"pict-provider":19}],13:[function(require,module,exports){
/**
 * Theme Diagram Adapter
 *
 * Helper utilities for plugging diagram renderers (Mermaid today,
 * Excalidraw / chart libraries next) into the pict-provider-theme
 * lifecycle.
 *
 * Why this exists:
 *   Diagram engines like Mermaid bake colors into the SVG at render
 *   time. Once rendered, CSS alone cannot recolor node fills, cluster
 *   backgrounds, or edge stroke ends — those are inline attributes on
 *   <rect>, <path>, <polygon>, etc.  Switching light/dark requires
 *   the engine to re-render with a fresh themeVariables block.
 *
 *   Pre-adapter, every view that hosted a Mermaid block had to:
 *     - read every CSS custom property by hand
 *     - mirror a 20+ key themeVariables object
 *     - wire its own onApply subscription
 *     - stash diagram source on the DOM
 *     - clear data-processed + re-run on theme change
 *
 *   The adapter centralizes all of that.  Section views call
 *   `adapter.adaptMermaid(mermaid, options)` and stop caring about the
 *   token list, the listener, and the refresh dance.
 *
 *  Public API:
 *     buildMermaidThemeVariables(pOverrides)        - read fresh tokens, return mermaid themeVariables
 *     getMermaidTokenMap()                          - canonical {mermaidKey: cssVarName} map
 *     initializeMermaid(mermaid, pOverrides)        - mermaid.initialize() with the right base + themeVariables
 *     refreshMermaidDiagrams(pSelectorOrRoot)       - restore source, clear data-processed, re-run mermaid.run
 *     stashMermaidSource(pNodes)                    - cache source on data-mermaid-source before first run
 *     adaptMermaid(provider, mermaid, pOptions)     - one-shot: initialize + subscribe + return handle
 *     readCSSVar(pName, pFallback, pRoot)           - fresh getComputedStyle read with fallback
 *
 *  All helpers are stateless and safe to call repeatedly.  Subscriptions
 *  return a dispose function the caller can hold onto for teardown.
 *
 * @author Steven Velozo <steven@velozo.com>
 * @license MIT
 */

// Canonical mapping: mermaid themeVariables key -> CSS custom property name -> fallback.
// Fallbacks match the pict-default LIGHT palette so unthemed apps look like
// the default theme rather than a third unrelated palette.
const MERMAID_TOKEN_MAP =
[
	// Primary surfaces (node fills + cluster background)
	{ Key: 'primaryColor',         Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'primaryTextColor',     Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'primaryBorderColor',   Var: '--theme-color-brand-primary',        Fallback: '#3357c7' },
	// Secondary (alt rows, alternate nodes, sequence actor bg)
	{ Key: 'secondaryColor',       Var: '--theme-color-background-secondary', Fallback: '#f5f5f5' },
	{ Key: 'secondaryTextColor',   Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'secondaryBorderColor', Var: '--theme-color-border-default',       Fallback: '#d6d6d6' },
	// Tertiary (clusters, accent groups)
	{ Key: 'tertiaryColor',        Var: '--theme-color-background-tertiary',  Fallback: '#ebebeb' },
	{ Key: 'tertiaryTextColor',    Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'tertiaryBorderColor',  Var: '--theme-color-border-light',         Fallback: '#e9e9e9' },
	// Page-level + line + note
	{ Key: 'background',           Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'mainBkg',              Var: '--theme-color-background-panel',     Fallback: '#ffffff' },
	{ Key: 'secondBkg',            Var: '--theme-color-background-secondary', Fallback: '#f5f5f5' },
	{ Key: 'lineColor',            Var: '--theme-color-text-secondary',       Fallback: '#454545' },
	{ Key: 'textColor',            Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'noteBkgColor',         Var: '--theme-color-background-tertiary',  Fallback: '#ebebeb' },
	{ Key: 'noteTextColor',        Var: '--theme-color-text-primary',         Fallback: '#1a1a1a' },
	{ Key: 'noteBorderColor',      Var: '--theme-color-border-default',       Fallback: '#d6d6d6' },
	// Status (Mermaid uses these for error/warning highlights)
	{ Key: 'errorBkgColor',        Var: '--theme-color-status-error',         Fallback: '#b62828' },
	{ Key: 'errorTextColor',       Var: '--theme-color-text-on-brand',        Fallback: '#ffffff' },
	// Typography
	{ Key: 'fontFamily',           Var: '--theme-typography-family-sans',     Fallback: 'inherit' }
];

/**
 * Read a CSS custom property off pRoot (default: documentElement).
 * Always issues a fresh getComputedStyle so the value reflects the
 * current class state on <html> (theme-light / theme-dark).
 *
 * @param {string} pName     - variable name including '--' prefix
 * @param {string} [pFallback] - returned when the variable is unset/empty
 * @param {Element} [pRoot]  - element to compute style against
 * @returns {string}
 */
function readCSSVar(pName, pFallback, pRoot)
{
	if (typeof window === 'undefined' || typeof document === 'undefined')
	{
		return pFallback || '';
	}
	let tmpRoot = pRoot || document.documentElement;
	if (!tmpRoot)
	{
		return pFallback || '';
	}
	let tmpVal = (getComputedStyle(tmpRoot).getPropertyValue(pName) || '').trim();
	return tmpVal || pFallback || '';
}

/**
 * Returns the canonical {mermaidKey: cssVarName} mapping.  Useful for
 * apps that need to inspect or extend the token list (e.g. to add
 * gantt / sequence / pie-specific tokens for a custom diagram type).
 *
 * @returns {Array<{Key, Var, Fallback}>}
 */
function getMermaidTokenMap()
{
	// Defensive copy so callers can't mutate the canonical list.
	return MERMAID_TOKEN_MAP.map((tmpEntry) => ({ Key: tmpEntry.Key, Var: tmpEntry.Var, Fallback: tmpEntry.Fallback }));
}

/**
 * Read every token in the mermaid map off the current document and
 * return an object suitable for mermaid.initialize({themeVariables}).
 *
 * @param {object} [pOverrides] - extra themeVariables keys to merge on top
 * @returns {object}
 */
function buildMermaidThemeVariables(pOverrides)
{
	let tmpVars = {};
	for (let i = 0; i < MERMAID_TOKEN_MAP.length; i++)
	{
		let tmpEntry = MERMAID_TOKEN_MAP[i];
		tmpVars[tmpEntry.Key] = readCSSVar(tmpEntry.Var, tmpEntry.Fallback);
	}
	if (pOverrides && typeof pOverrides === 'object')
	{
		let tmpKeys = Object.keys(pOverrides);
		for (let j = 0; j < tmpKeys.length; j++)
		{
			tmpVars[tmpKeys[j]] = pOverrides[tmpKeys[j]];
		}
	}
	return tmpVars;
}

/**
 * Call mermaid.initialize() with the canonical pict theme bindings.
 * Safe to call repeatedly; mermaid simply merges new config.
 *
 * @param {object} mermaid - the mermaid module / global
 * @param {object} [pOverrides] - extra themeVariables keys, or { config: ... }
 *                                to override startOnLoad / securityLevel / theme
 * @returns {boolean} true if initialize ran, false if no mermaid available
 */
function initializeMermaid(mermaid, pOverrides)
{
	if (!mermaid || typeof mermaid.initialize !== 'function') { return false; }
	let tmpOverrides = pOverrides || {};
	let tmpThemeOverrides = tmpOverrides.themeVariables;
	let tmpConfigOverrides = tmpOverrides.config || {};
	let tmpVars = buildMermaidThemeVariables(tmpThemeOverrides);
	let tmpConfig = Object.assign(
	{
		startOnLoad: false,
		theme: 'base',
		securityLevel: 'loose'
	}, tmpConfigOverrides,
	{
		themeVariables: tmpVars
	});
	mermaid.initialize(tmpConfig);
	return true;
}

/**
 * Cache each diagram's source text on data-mermaid-source so a later
 * refresh can restore it.  Mermaid replaces textContent with the
 * rendered SVG during run(); without this stash there's no way to
 * re-run.
 *
 * @param {NodeList|Array<Element>} pNodes
 */
function stashMermaidSource(pNodes)
{
	if (!pNodes || pNodes.length < 1) { return; }
	for (let i = 0; i < pNodes.length; i++)
	{
		let tmpEl = pNodes[i];
		if (!tmpEl || typeof tmpEl.getAttribute !== 'function') { continue; }
		if (!tmpEl.hasAttribute('data-mermaid-source'))
		{
			tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
		}
	}
}

/**
 * Restore each pre.mermaid[data-mermaid-source] element to its source
 * text, drop the data-processed flag (mermaid skips elements with that
 * flag set), strip the mermaid-rendered helper class if present, and
 * re-run mermaid against them.
 *
 * @param {string|Element|Document} [pSelectorOrRoot]
 *   - string: querySelectorAll target (defaults to whole document)
 *   - Element: scoped root to search inside
 *   - omitted: whole document
 * @returns {Promise|null} the mermaid.run() promise, or null if no work
 */
function refreshMermaidDiagrams(pSelectorOrRoot)
{
	if (typeof document === 'undefined') { return null; }
	let tmpMermaid = (typeof mermaid !== 'undefined') ? mermaid : null;
	if (!tmpMermaid || typeof tmpMermaid.run !== 'function') { return null; }

	let tmpRendered = _resolveMermaidNodes(pSelectorOrRoot);
	if (!tmpRendered || tmpRendered.length < 1) { return null; }

	for (let i = 0; i < tmpRendered.length; i++)
	{
		let tmpEl = tmpRendered[i];
		let tmpSrc = tmpEl.getAttribute('data-mermaid-source');
		if (tmpSrc !== null) { tmpEl.textContent = tmpSrc; }
		tmpEl.removeAttribute('data-processed');
		if (tmpEl.classList && typeof tmpEl.classList.remove === 'function')
		{
			tmpEl.classList.remove('mermaid-rendered');
		}
	}

	try
	{
		let tmpResult = tmpMermaid.run({ nodes: tmpRendered });
		// After mermaid finishes drawing, strip the !important flags it
		// bakes into per-node inline fill/stroke styles. See
		// stripMermaidStyleImportance() docs for the why.
		if (tmpResult && typeof tmpResult.then === 'function')
		{
			return tmpResult.then(function ()
			{
				stripMermaidStyleImportance(tmpRendered);
				return tmpResult;
			});
		}
		// Synchronous fallback (older mermaid versions).
		stripMermaidStyleImportance(tmpRendered);
		return tmpResult;
	}
	catch (pError)
	{
		// Surface to the caller; they're already wrapping in try/catch in
		// most cases.  Return a rejected promise so .catch() consumers fire.
		return Promise.reject(pError);
	}
}

/**
 * Mermaid 11's flowchart `style X fill:#...` directive emits the fill
 * and stroke inline with `!important`:
 *
 *   <rect class="basic label-container"
 *         style="fill:#e8f5e9 !important;stroke:#43a047 !important"/>
 *
 * Inline `!important` beats external `!important` via specificity, so
 * any theme-aware CSS we write (e.g. `.theme-dark ... { fill: theme-bg
 * !important }`) silently loses no matter how strong its selector.
 * Diagrams keep their Material pastels even in dark themes — light
 * fills with light text = unreadable.
 *
 * Strip just the `!important` flag off mermaid-emitted inline styles
 * after every render.  The fill/stroke values themselves stay intact,
 * so light mode keeps the author-intended palette; in dark mode the
 * external `.theme-dark` CSS now reaches the rect and recolors to a
 * theme-aware background.
 *
 * Must run after every mermaid render — initial + every re-render
 * triggered by a theme change.  `refreshMermaidDiagrams` calls it on
 * re-renders; the initial render in pict-section-content's view calls
 * it via the provider's `diagram.stripMermaidStyleImportance` handle.
 *
 * @param {string|Element|NodeList|Array} [pTarget]
 *   - omitted: scan the whole document
 *   - string: querySelector scope (e.g. '#Pict-Content-Body')
 *   - Element: scan within this element
 *   - NodeList/Array of `pre.mermaid` elements: scan within each
 * @returns {number} count of shapes that had !important stripped
 */
function stripMermaidStyleImportance(pTarget)
{
	if (typeof document === 'undefined') { return 0; }

	let tmpMermaids;
	if (!pTarget)
	{
		tmpMermaids = document.querySelectorAll('pre.mermaid');
	}
	else if (typeof pTarget === 'string')
	{
		let tmpScope = document.querySelector(pTarget);
		tmpMermaids = tmpScope ? tmpScope.querySelectorAll('pre.mermaid') : [];
	}
	else if (pTarget.length !== undefined)
	{
		// NodeList or Array of pre.mermaid elements
		tmpMermaids = pTarget;
	}
	else if (pTarget.querySelectorAll)
	{
		tmpMermaids = pTarget.querySelectorAll('pre.mermaid');
	}
	else
	{
		return 0;
	}

	let tmpStripped = 0;
	for (let i = 0; i < tmpMermaids.length; i++)
	{
		let tmpMerm = tmpMermaids[i];
		if (!tmpMerm || !tmpMerm.querySelectorAll) { continue; }
		let tmpShapes = tmpMerm.querySelectorAll(
			'.node rect[style*="!important"], ' +
			'.node polygon[style*="!important"], ' +
			'.node circle[style*="!important"], ' +
			'.node ellipse[style*="!important"], ' +
			'.node path[style*="!important"], ' +
			'.cluster rect[style*="!important"]'
		);
		for (let j = 0; j < tmpShapes.length; j++)
		{
			let tmpEl = tmpShapes[j];
			let tmpStyle = tmpEl.getAttribute('style') || '';
			if (tmpStyle.indexOf('!important') < 0) { continue; }
			tmpEl.setAttribute('style', tmpStyle.replace(/\s*!important\s*/gi, ''));
			tmpStripped++;
		}
	}
	return tmpStripped;
}

function _resolveMermaidNodes(pSelectorOrRoot)
{
	let tmpSelector = 'pre.mermaid[data-mermaid-source]';
	if (!pSelectorOrRoot)
	{
		return document.querySelectorAll(tmpSelector);
	}
	if (typeof pSelectorOrRoot === 'string')
	{
		// Treat the string as a scope selector; collect mermaid nodes inside it.
		let tmpScope = document.querySelector(pSelectorOrRoot);
		if (!tmpScope) { return []; }
		return tmpScope.querySelectorAll(tmpSelector);
	}
	if (pSelectorOrRoot.querySelectorAll)
	{
		return pSelectorOrRoot.querySelectorAll(tmpSelector);
	}
	return [];
}

/**
 * One-shot: initialize mermaid against the active theme, subscribe to
 * theme apply events, and return a handle the caller can use for
 * teardown / manual refresh.
 *
 *   let tmpHandle = adaptMermaid(pict.providers.Theme, mermaid, {
 *       refreshScope: '#Pict-Content-Body'
 *   });
 *   // ... later, on unload:
 *   tmpHandle.dispose();
 *
 * @param {object} pProvider - pict-provider-theme instance
 * @param {object} pMermaid  - the mermaid module / global
 * @param {object} [pOptions]
 *   @param {string|Element} [pOptions.refreshScope] - passed to refreshMermaidDiagrams
 *   @param {object} [pOptions.themeOverrides]       - extra themeVariables keys
 *   @param {object} [pOptions.configOverrides]      - extra mermaid.initialize() top-level keys
 *   @param {function} [pOptions.onBeforeRefresh]    - called before each refresh; signature (pContext)
 *   @param {function} [pOptions.onAfterRefresh]     - called after each refresh resolves; signature (pContext)
 * @returns {{ dispose: function, refresh: function, reinitialize: function, subscribed: boolean }}
 */
function adaptMermaid(pProvider, pMermaid, pOptions)
{
	let tmpOptions = pOptions || {};
	let tmpInitOverrides =
	{
		themeVariables: tmpOptions.themeOverrides,
		config: tmpOptions.configOverrides
	};

	// Always initialize, even if no provider — the static base theme should
	// still pick up whatever CSS variables the page does have.
	initializeMermaid(pMermaid, tmpInitOverrides);

	let tmpRefresh = function (pContext)
	{
		if (typeof tmpOptions.onBeforeRefresh === 'function')
		{
			try { tmpOptions.onBeforeRefresh(pContext || {}); }
			catch (e) { /* swallow; refresh must not be gated on listener errors */ }
		}
		initializeMermaid(pMermaid, tmpInitOverrides);
		let tmpResult = refreshMermaidDiagrams(tmpOptions.refreshScope);
		if (tmpResult && typeof tmpResult.then === 'function' && typeof tmpOptions.onAfterRefresh === 'function')
		{
			tmpResult.then(
				() => { try { tmpOptions.onAfterRefresh(pContext || {}); } catch (e) { /* swallow */ } },
				() => { /* error path: onAfterRefresh still fires so the UI can drop spinners */
					try { tmpOptions.onAfterRefresh(pContext || {}); } catch (e) { /* swallow */ }
				}
			);
		}
		return tmpResult;
	};

	let tmpDispose = function () {};
	let tmpSubscribed = false;
	if (pProvider && typeof pProvider.onApply === 'function')
	{
		tmpDispose = pProvider.onApply(function (pBundle, pContext)
		{
			tmpRefresh(pContext || {});
		});
		tmpSubscribed = true;
	}

	return {
		dispose: function ()
		{
			if (typeof tmpDispose === 'function') { tmpDispose(); }
		},
		refresh: tmpRefresh,
		reinitialize: function () { initializeMermaid(pMermaid, tmpInitOverrides); },
		subscribed: tmpSubscribed
	};
}

module.exports =
{
	MERMAID_TOKEN_MAP: MERMAID_TOKEN_MAP,
	readCSSVar: readCSSVar,
	getMermaidTokenMap: getMermaidTokenMap,
	buildMermaidThemeVariables: buildMermaidThemeVariables,
	initializeMermaid: initializeMermaid,
	stashMermaidSource: stashMermaidSource,
	refreshMermaidDiagrams: refreshMermaidDiagrams,
	stripMermaidStyleImportance: stripMermaidStyleImportance,
	adaptMermaid: adaptMermaid
};

},{}],14:[function(require,module,exports){
/**
 * Pict template expression: {~Theme:Path~}
 *
 * Resolves a token path against the active theme bundle and returns the
 * raw value at the currently resolved mode.  Walks from the bundle root,
 * so paths like 'Tokens.Color.Background.Primary' or 'Brand.Name' work.
 *
 * Returns an empty string if no theme is active or the path is missing.
 */
const libPictTemplate = require('pict-template');

class PictTemplateTheme extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~Theme:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.token(tmpPath);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateTheme;

},{"pict-template":237}],15:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeAsset:Category.Name~}
 *
 * Returns the contents of a named SVG (or other) asset from the active
 * theme bundle.  The first path segment is treated as the category
 * (e.g. SVG), the rest as the asset's path within that category.
 *
 *   {~ThemeAsset:SVG.Logo~}        -> bundle.SVG.Logo
 *   {~ThemeAsset:SVG.Icons.Foo~}   -> bundle.SVG.Icons.Foo
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeAsset extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeAsset:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpDot = tmpPath.indexOf('.');
		if (tmpDot < 0) return '';

		let tmpCategory = tmpPath.substring(0, tmpDot);
		let tmpName = tmpPath.substring(tmpDot + 1);

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.asset(tmpCategory, tmpName);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeAsset;

},{"pict-template":237}],16:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeImage:Name~}
 *
 * Returns the URL or data URL stored at bundle.Image[Name] in the active
 * theme bundle.  Convenience over {~ThemeAsset:Image.Name~}.
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeImage extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeImage:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpName = (pTemplateHash || '').trim();
		if (!tmpName) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';

		let tmpValue = tmpProvider.image(tmpName);
		if (tmpValue === null || typeof tmpValue === 'undefined') return '';
		return String(tmpValue);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeImage;

},{"pict-template":237}],17:[function(require,module,exports){
/**
 * Pict template expression: {~ThemeVar:Path~}
 *
 * Returns a CSS `var(--theme-...)` reference for a token path under
 * Tokens.  E.g. {~ThemeVar:Color.Background.Primary~} ->
 * `var(--theme-color-background-primary)`.
 *
 * Useful inside style attributes and in CSS-in-JS contexts where you want
 * the live custom-property reference rather than the resolved value.
 */
const libPictTemplate = require('pict-template');

class PictTemplateThemeVar extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~ThemeVar:', '~}');
	}

	render(pTemplateHash)
	{
		let tmpPath = (pTemplateHash || '').trim();
		if (!tmpPath) return '';

		let tmpProvider = this._findThemeProvider();
		if (!tmpProvider) return '';
		return tmpProvider.cssVar(tmpPath);
	}

	_findThemeProvider()
	{
		if (!this.pict || !this.pict.providers) return null;
		return this.pict.providers['Theme'] || null;
	}
}

module.exports = PictTemplateThemeVar;

},{"pict-template":237}],18:[function(require,module,exports){
module.exports={
    "name": "pict-provider",
    "version": "1.0.13",
    "description": "Pict Provider Base Class",
    "main": "source/Pict-Provider.js",
    "scripts": {
        "start": "node source/Pict-Provider.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-provider-image:local",
        "docker-dev-run": "docker run -it -d --name pict-provider-dev -p 24125:8080 -p 30027:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-provider\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-provider-image:local",
        "docker-dev-shell": "docker exec -it pict-provider-dev /bin/bash",
        "lint": "eslint source/**",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Provider.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-provider.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-provider/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-provider#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "eslint": "^9.39.1",
        "pict": "^1.0.351",
        "pict-docuserve": "^0.1.5",
        "quackage": "^1.1.0",
        "typescript": "^5.9.3"
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    }
}

},{}],19:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictProviderSettings = (
	{
		ProviderIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		AutoLoadDataWithApp: true,
		AutoLoadDataOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		Manifests: {},

		Templates: []
	});

class PictProvider extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictProviderSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.fable;
		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.pict;
		/** @type {any} */
		this.log;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		if (!this.options.ProviderIdentifier)
		{
			this.options.ProviderIdentifier = `AutoProviderID-${this.fable.getUUID()}`;
		}

		this.serviceType = 'PictProvider';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;

		// Wire in the essential Pict application state
		/** @type {Record<string, any>} */
		this.AppData = this.pict.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.pict.Bundle;

		this.initializeTimestamp = false;
		this.lastSolvedTimestamp = false;

		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpDefaultTemplate = this.options.Templates[i];

			if (!tmpDefaultTemplate.hasOwnProperty('Postfix') || !tmpDefaultTemplate.hasOwnProperty('Template'))
			{
				this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-pinitialization.
	 *
	 * @return {void}
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				(pError) =>
				{
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (pError)
					{
						this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization failed: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization complete.`);
					}
					return fCallback();
				})
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	onPreRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreRender:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-render.
	 *
	 * @return {void}
	 */
	onPreRenderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	render()
	{
		return this.onPreRender();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after render.
	 *
	 * @return {void}
	 */
	renderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreSolve:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-solve.
	 *
	 * @return {void}
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	solve()
	{
		return this.onPreSolve();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after solve.
	 *
	 * @return {void}
	 */
	solveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 *
	 * @return {void}
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 *
	 * @return {void}
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 *
	 * @return {void}
	 */
	onAfterSaveDataAsync(fCallback)
	{
		return fCallback();
	}
}

module.exports = PictProvider;

},{"../package.json":18,"fable-serviceproviderbase":2}],20:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libNavigo = require('navigo');

const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Router',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// When true, addRoute() will NOT auto-resolve after each route is added.
	// This is useful in auth-gated SPAs where routes should only resolve after
	// the DOM is ready (e.g. after login).  Can also be set globally via
	// pict.settings.RouterSkipRouteResolveOnAdd — either one enables the skip.
	SkipRouteResolveOnAdd: false
}

class PictRouter extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// Initialize the navigo router and set the base path to '/'
		this.router = new libNavigo('/', { strategy: 'ONE', hash: true });

		if (this.options.Routes)
		{
			for (let i = 0; i < this.options.Routes.length; i++)
			{
				if (this.options.Routes[i].path && this.options.Routes[i].template)
				{
					this.addRoute(this.options.Routes[i].path, this.options.Routes[i].template);
				}
				else if (this.options.Routes[i].path && this.options.Routes[i].render)
				{
					this.addRoute(this.options.Routes[i].path, this.options.Routes[i].render);
				}
				else
				{
					this.pict.log.warn(`Route ${i} is missing a render function or template string.`);
				}
			}
		}

		// This is the route to render after load
		this.afterPersistView = '/Manyfest/Overview';
	}

	get currentScope()
	{
		return this.AppData?.ManyfestRecord?.Scope ?? 'Default';
	}

	forwardToScopedRoute(pData)
	{
		this.navigate(`${pData.url}/${this.currentScope}`);
	}

	onInitializeAsync(fCallback)
	{
		return super.onInitializeAsync(fCallback);
	}

	/**
	 * Add a route to the router.
	 */
	addRoute(pRoute, pRenderable)
	{
		if (typeof(pRenderable) === 'function')
		{
			this.router.on(pRoute, pRenderable);
		}
		else if (typeof(pRenderable) === 'string')
		{
			// Run this as a template, allowing some whack things with functions in template expressions.
			this.router.on(pRoute,
				(pData) =>
				{
					this.pict.parseTemplate(pRenderable, pData, null, this.pict)
				});
		}
		else
		{
			// renderable isn't usable!
			this.pict.log.warn(`Route ${pRoute} has an invalid renderable.`);
			return;
		}

		// By default, resolve after each route is added (legacy behavior).
		// Applications can skip this by setting SkipRouteResolveOnAdd: true in
		// the provider config JSON, or globally via
		// pict.settings.RouterSkipRouteResolveOnAdd.  Either one will prevent
		// premature route resolution before views are rendered.
		if (!this.options.SkipRouteResolveOnAdd && !this.pict.settings.RouterSkipRouteResolveOnAdd)
		{
			this.resolve();
		}
	}

	/**
	 * Navigate to a given route (set the browser URL string, add to history, trigger router)
	 * 
	 * @param {string} pRoute - The route to navigate to
	 */
	navigate(pRoute)
	{
		this.router.navigate(pRoute);
	}

	/**
	 * Navigate to the route currently in the browser's location hash.
	 *
	 * This is useful in auth-gated SPAs: when the user pastes a deep-link
	 * (e.g. #/Books) and then logs in, calling navigateCurrent() will force
	 * the router to fire the handler for whatever hash is already in the URL.
	 * Unlike resolve(), navigate() always triggers the handler even if Navigo
	 * has already "consumed" that URL.
	 *
	 * If the hash is empty or just "#/", this is a no-op and returns false.
	 *
	 * @returns {boolean} true if a route was navigated to, false otherwise
	 */
	navigateCurrent()
	{
		let tmpHash = (typeof (window) !== 'undefined' && window.location) ? window.location.hash : '';
		if (tmpHash && tmpHash.length > 2 && tmpHash !== '#/')
		{
			let tmpRoute = tmpHash.replace(/^#/, '');
			this.navigate(tmpRoute);
			return true;
		}
		return false;
	}

	/**
	 * Trigger the router resolving logic; this is expected to be called after all routes are added (to go to the default route).
	 *
	 */
	resolve()
	{
		this.router.resolve();
	}
}

module.exports = PictRouter;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;
},{"navigo":5,"pict-provider":19}],21:[function(require,module,exports){
/**
 * Simple syntax highlighter for use with CodeJar.
 *
 * Provides basic keyword/string/number/comment highlighting for common languages.
 * Can be replaced with Prism.js or highlight.js for more sophisticated highlighting
 * by passing a custom highlight function to the view options.
 *
 * @module Pict-Code-Highlighter
 */

// Language definition map
const _LanguageDefinitions = (
{
	'javascript':
	{
		// Combined regex to tokenize: comments, strings, template literals, regex, then everything else
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2|(`(?:[^`\\]|\\.)*?`)|(\/(?![/*])(?:\\.|\[(?:\\.|[^\]])*\]|[^/\\\n])+\/[gimsuvy]*)/g,
		keywords: /\b(async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|export|extends|finally|for|from|function|get|if|import|in|instanceof|let|new|of|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/g,
		builtins: /\b(true|false|null|undefined|NaN|Infinity|console|window|document|Math|JSON|Array|Object|String|Number|Boolean|Date|RegExp|Map|Set|Promise|Error|Symbol|parseInt|parseFloat|require|module|exports)\b/g,
		numbers: /\b(\d+\.?\d*(?:e[+-]?\d+)?|0x[0-9a-fA-F]+|0b[01]+|0o[0-7]+)\b/g
	},
	'json':
	{
		tokenizer: /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|("(?:[^"\\]|\\.)*")/g,
		keywords: /\b(true|false|null)\b/g,
		numbers: /-?\b\d+\.?\d*(?:e[+-]?\d+)?\b/g
	},
	'html':
	{
		// Tokenizer captures: (1) comments, (2) strings, (3) tags with attributes
		tokenizer: /(<!--[\s\S]*?-->)|(["'])(?:(?!\2|\\).|\\.)*?\2|(<\/?[a-zA-Z][a-zA-Z0-9-]*(?:\s+[a-zA-Z-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*))?)*\s*\/?>)/g,
		// tagToken group index for identifying tag matches
		tagGroupIndex: 3
	},
	'css':
	{
		tokenizer: /(\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		selectors: /([.#]?[a-zA-Z_][\w-]*(?:\s*[>+~]\s*[.#]?[a-zA-Z_][\w-]*)*)\s*\{/g,
		properties: /\b([a-zA-Z-]+)\s*:/g,
		numbers: /\b(\d+\.?\d*)(px|em|rem|%|vh|vw|s|ms|deg|fr)?\b/g,
		keywords: /\b(important|inherit|initial|unset|none|auto|block|inline|flex|grid)\b/g
	},
	'sql':
	{
		tokenizer: /(--[^\n]*|\/\*[\s\S]*?\*\/)|(["'])(?:(?!\2|\\).|\\.)*?\2/g,
		keywords: /\b(SELECT|FROM|WHERE|AND|OR|INSERT|INTO|VALUES|UPDATE|SET|DELETE|CREATE|TABLE|DROP|ALTER|ADD|COLUMN|INDEX|JOIN|LEFT|RIGHT|INNER|OUTER|ON|AS|ORDER|BY|GROUP|HAVING|LIMIT|OFFSET|UNION|ALL|DISTINCT|COUNT|SUM|AVG|MIN|MAX|NOT|NULL|IS|IN|BETWEEN|LIKE|EXISTS|CASE|WHEN|THEN|ELSE|END|PRIMARY|KEY|FOREIGN|REFERENCES|CONSTRAINT|DEFAULT|CHECK|UNIQUE|CASCADE|GRANT|REVOKE|COMMIT|ROLLBACK|BEGIN|TRANSACTION|INT|VARCHAR|DATETIME|AUTO_INCREMENT|CURRENT_TIMESTAMP)\b/gi,
		numbers: /\b\d+\.?\d*\b/g
	}
});

// Alias some common language names
_LanguageDefinitions['js'] = _LanguageDefinitions['javascript'];
_LanguageDefinitions['htm'] = _LanguageDefinitions['html'];

/**
 * Escape HTML special characters to prevent XSS when inserting into innerHTML.
 *
 * @param {string} pString - The string to escape
 * @returns {string} The escaped string
 */
function escapeHTML(pString)
{
	return pString
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

/**
 * Highlight a segment of code that is NOT inside a string or comment.
 * This applies keyword, number, and structural highlighting.
 *
 * @param {string} pCode - The code segment to highlight (already HTML-escaped)
 * @param {object} pLanguageDef - The language definition
 * @returns {string} The highlighted HTML
 */
function highlightCodeSegment(pCode, pLanguageDef)
{
	let tmpResult = pCode;

	// CSS selectors
	if (pLanguageDef.selectors)
	{
		pLanguageDef.selectors.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.selectors, '<span class="function-name">$1</span>{');
	}

	// CSS properties
	if (pLanguageDef.properties)
	{
		pLanguageDef.properties.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.properties, '<span class="property">$1</span>:');
	}

	// Keywords
	if (pLanguageDef.keywords)
	{
		pLanguageDef.keywords.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.keywords, '<span class="keyword">$1</span>');
	}

	// Builtins
	if (pLanguageDef.builtins)
	{
		pLanguageDef.builtins.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.builtins, '<span class="keyword">$1</span>');
	}

	// Numbers (CSS numbers may have units as a capture group, others do not)
	if (pLanguageDef.numbers)
	{
		pLanguageDef.numbers.lastIndex = 0;
		tmpResult = tmpResult.replace(pLanguageDef.numbers, (pMatch) =>
		{
			return `<span class="number">${pMatch}</span>`;
		});
	}

	return tmpResult;
}

/**
 * Highlight an HTML tag token, applying tag name, attribute name, and attribute value colors.
 *
 * The approach: parse the raw tag into structured pieces first, then build the
 * highlighted output from those pieces. This avoids mixing raw text with HTML span
 * tags, which would cause regex replacements to match span attributes on subsequent passes.
 *
 * @param {string} pTag - The raw (unescaped) tag string
 * @returns {string} The highlighted HTML
 */
function highlightHTMLTag(pTag)
{
	let tmpResult = '';
	let tmpRest = pTag;

	// 1. Extract the opening bracket and tag name: < or </  followed by tagname
	let tmpTagNameMatch = tmpRest.match(/^(<\/?)([a-zA-Z][a-zA-Z0-9-]*)/);
	if (!tmpTagNameMatch)
	{
		// Not a recognizable tag, just escape the whole thing
		return escapeHTML(pTag);
	}

	tmpResult += escapeHTML(tmpTagNameMatch[1]);
	tmpResult += '<span class="tag">' + escapeHTML(tmpTagNameMatch[2]) + '</span>';
	tmpRest = tmpRest.substring(tmpTagNameMatch[0].length);

	// 2. Parse attributes from the remaining text (before the closing > or />)
	// Repeatedly match: whitespace + attr-name + optional =value
	let tmpAttrRegex = /^(\s+)([a-zA-Z-]+)(?:(\s*=\s*)(["'])([^"']*?)\4)?/;
	let tmpAttrMatch;

	while ((tmpAttrMatch = tmpRest.match(tmpAttrRegex)) !== null)
	{
		// Whitespace before the attribute
		tmpResult += tmpAttrMatch[1];
		// Attribute name
		tmpResult += '<span class="attr-name">' + escapeHTML(tmpAttrMatch[2]) + '</span>';

		// If there's an = value part
		if (tmpAttrMatch[3])
		{
			tmpResult += escapeHTML(tmpAttrMatch[3]);
			tmpResult += '<span class="attr-value">' + escapeHTML(tmpAttrMatch[4]) + escapeHTML(tmpAttrMatch[5]) + escapeHTML(tmpAttrMatch[4]) + '</span>';
		}

		tmpRest = tmpRest.substring(tmpAttrMatch[0].length);
	}

	// 3. Whatever remains (whitespace, />, >) — escape it all
	tmpResult += escapeHTML(tmpRest);

	return tmpResult;
}

/**
 * Create a highlight function for a given language.
 *
 * The approach: use a single tokenizer regex to split the code into protected tokens
 * (comments, strings) and code segments. Process each segment independently.
 * This avoids placeholder/sentinel issues entirely.
 *
 * @param {string} pLanguage - The language identifier (e.g. "javascript", "json", "html")
 * @returns {function} A function that takes an element and highlights its textContent
 */
function createHighlighter(pLanguage)
{
	return function highlightElement(pElement)
	{
		let tmpCode = pElement.textContent;
		let tmpLanguageName = (typeof (pLanguage) === 'string') ? pLanguage.toLowerCase() : 'javascript';
		let tmpLanguageDef = _LanguageDefinitions[tmpLanguageName];

		if (!tmpLanguageDef)
		{
			// No highlighting rules for this language; just escape and return
			pElement.innerHTML = escapeHTML(tmpCode);
			return;
		}

		if (!tmpLanguageDef.tokenizer)
		{
			// No tokenizer; just escape and apply keyword highlighting
			pElement.innerHTML = highlightCodeSegment(escapeHTML(tmpCode), tmpLanguageDef);
			return;
		}

		// Split the code into tokens using the tokenizer regex.
		// The tokenizer captures comments and strings as groups.
		// We process everything between matches as code.
		let tmpResult = '';
		let tmpLastIndex = 0;
		let tmpTagGroupIndex = tmpLanguageDef.tagGroupIndex || 0;

		tmpLanguageDef.tokenizer.lastIndex = 0;
		let tmpMatch;

		while ((tmpMatch = tmpLanguageDef.tokenizer.exec(tmpCode)) !== null)
		{
			// Add the code segment before this match
			if (tmpMatch.index > tmpLastIndex)
			{
				let tmpSegment = tmpCode.substring(tmpLastIndex, tmpMatch.index);
				tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
			}

			let tmpFullMatch = tmpMatch[0];

			// Determine token type from capture groups
			// Group 1 is always comments, Group 2+ are strings/template literals/regex
			if (tmpMatch[1])
			{
				// Comment
				tmpResult += `<span class="comment">${escapeHTML(tmpFullMatch)}</span>`;
			}
			else if (tmpTagGroupIndex > 0 && tmpMatch[tmpTagGroupIndex])
			{
				// HTML tag — highlight tag name, attributes, and values
				tmpResult += highlightHTMLTag(tmpFullMatch);
			}
			else
			{
				// String, template literal, or regex
				tmpResult += `<span class="string">${escapeHTML(tmpFullMatch)}</span>`;
			}

			tmpLastIndex = tmpLanguageDef.tokenizer.lastIndex;
		}

		// Add any remaining code after the last match
		if (tmpLastIndex < tmpCode.length)
		{
			let tmpSegment = tmpCode.substring(tmpLastIndex);
			tmpResult += highlightCodeSegment(escapeHTML(tmpSegment), tmpLanguageDef);
		}

		pElement.innerHTML = tmpResult;
	};
}

module.exports = createHighlighter;
module.exports.LanguageDefinitions = _LanguageDefinitions;

},{}],22:[function(require,module,exports){
module.exports = (
{
	"RenderOnLoad": true,

	"DefaultRenderable": "CodeEditor-Wrap",
	"DefaultDestinationAddress": "#CodeEditor-Container-Div",

	"Templates":
	[
		{
			"Hash": "CodeEditor-Container",
			"Template": "<!-- CodeEditor-Container Rendering Soon -->"
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "CodeEditor-Wrap",
			"TemplateHash": "CodeEditor-Container",
			"DestinationAddress": "#CodeEditor-Container-Div"
		}
	],

	"TargetElementAddress": "#CodeEditor-Container-Div",

	// Address in AppData or other Pict address space to read/write code content
	"CodeDataAddress": false,

	// The language for syntax highlighting (e.g. "javascript", "html", "css", "json")
	"Language": "javascript",

	// Whether the editor is read-only
	"ReadOnly": false,

	// Tab character: use tab or spaces
	"Tab": "\t",

	// Whether to indent with the same whitespace as the previous line
	"IndentOn": /[({[]$/,

	// Whether to add a closing bracket/paren/brace
	"MoveToNewLine": /^[)}\]]/,

	// Whether to handle the closing character
	"AddClosing": true,

	// Whether to preserve indentation on new lines
	"CatchTab": true,

	// Whether to show line numbers
	"LineNumbers": true,

	// Default code content if no address is provided
	"DefaultCode": "// Enter your code here\n",

	// CSS for the code editor.
	//
	// Every color/font is wired through pict-provider-theme tokens so apps
	// using pict-provider-theme get themed code editor automatically.  Each
	// var() carries its original ATOM-One-Light hex as the fallback so apps
	// without pict-provider-theme installed look exactly as before.
	"CSS": `.pict-code-editor-wrap
{
	display: flex;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
	font-size: 14px;
	line-height: 1.5;
	border: 1px solid var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	overflow: hidden;
}
.pict-code-editor-wrap .pict-code-line-numbers
{
	width: 40px;
	min-width: 40px;
	/* padding-top/bottom are stamped at runtime from the editor's
	   computed padding so row 1 of the gutter aligns with row 1 of
	   the code; only horizontal padding is stylesheet-owned. */
	padding: 0;
	text-align: right;
	background: var(--theme-color-editor-linenumber-background, var(--theme-color-background-secondary, #F5F5F5));
	border-right: 1px solid var(--theme-color-editor-gutter-border, var(--theme-color-border-default, #D0D0D0));
	color: var(--theme-color-editor-linenumber-text, var(--theme-color-text-muted, #999));
	font-size: 13px;
	/* line-height, padding-top, padding-bottom, and font-family are
	   intentionally NOT declared here.  PictSectionCode._syncGutterMetrics()
	   copies them from the editor's computed styles at init and on every
	   editor resize, so the gutter is guaranteed to track the editor.
	   Declaring them in CSS would either be redundant (when matching) or
	   actively wrong (when the editor's metrics diverge — e.g. theme scale
	   changes the editor's font-size).  See codejar-linenumbers for the
	   canonical version of this pattern. */
	user-select: none;
	pointer-events: none;
	box-sizing: border-box;
}
.pict-code-editor-wrap .pict-code-line-numbers span
{
	display: block;
	padding: 0 8px 0 0;
}
.pict-code-editor-wrap .pict-code-editor
{
	margin: 0;
	padding: 10px 10px 10px 8px;
	min-height: 100px;
	flex: 1;
	min-width: 0;
	outline: none;
	tab-size: 4;
	white-space: pre;
	overflow-wrap: normal;
	color: var(--theme-color-text-primary, #383A42);
	background: var(--theme-color-background-panel, #FAFAFA);
	caret-color: var(--theme-color-brand-primary, #526FFF);
	border-radius: 0 4px 4px 0;
}
.pict-code-editor-wrap .pict-code-editor.pict-code-no-line-numbers
{
	padding-left: 10px;
	border-radius: 4px;
}
.pict-code-editor-wrap .pict-code-editor::selection,
.pict-code-editor-wrap .pict-code-editor *::selection
{
	background: var(--theme-color-editor-selection-background, var(--theme-color-selection-background, #B3D4FC));
}
/* Syntax token colors — each class binds to a Color.Syntax.* token from
   pict-provider-theme. Fallback hexes match the One Light palette so apps
   that don't install the theme provider look the same as before. */
.pict-code-editor-wrap .pict-code-editor .keyword       { color: var(--theme-color-syntax-keyword,     #A626A4); }
.pict-code-editor-wrap .pict-code-editor .string        { color: var(--theme-color-syntax-string,      #50A14F); }
.pict-code-editor-wrap .pict-code-editor .number        { color: var(--theme-color-syntax-number,      #986801); }
.pict-code-editor-wrap .pict-code-editor .comment       { color: var(--theme-color-syntax-comment,     #A0A1A7); font-style: italic; }
.pict-code-editor-wrap .pict-code-editor .operator      { color: var(--theme-color-syntax-operator,    #0184BC); }
.pict-code-editor-wrap .pict-code-editor .punctuation   { color: var(--theme-color-syntax-punctuation, #383A42); }
.pict-code-editor-wrap .pict-code-editor .function-name { color: var(--theme-color-syntax-function,    #4078F2); }
.pict-code-editor-wrap .pict-code-editor .property      { color: var(--theme-color-syntax-property,    #E45649); }
.pict-code-editor-wrap .pict-code-editor .tag           { color: var(--theme-color-syntax-tag,         #E45649); }
.pict-code-editor-wrap .pict-code-editor .attr-name     { color: var(--theme-color-syntax-attrname,    #986801); }
.pict-code-editor-wrap .pict-code-editor .attr-value    { color: var(--theme-color-syntax-attrvalue,   #50A14F); }
.pict-code-editor-wrap .pict-code-editor .builtin       { color: var(--theme-color-syntax-builtin,     #986801); }
.pict-code-editor-wrap .pict-code-editor .type          { color: var(--theme-color-syntax-type,        #C18401); }
.pict-code-editor-wrap .pict-code-editor .variable      { color: var(--theme-color-syntax-variable,    #383A42); }

/* highlight.js class aliases — when host apps render code blocks with
   highlight.js (e.g. markdown previews via CodeJar's hljs integration),
   the output uses .hljs / .hljs-* classes rather than the bare token
   classes pict-section-code emits. Mapping them here lets one stylesheet
   theme both editor surfaces (bare classes) and hljs-rendered surfaces
   without the host needing a separate per-app github.css. Rules are
   intentionally unscoped (no .pict-code-editor-wrap parent) so they
   apply globally wherever hljs paints. */
.hljs                  { color: var(--theme-color-text-primary,         #383A42); background: transparent; }
.hljs-keyword,
.hljs-keyword.hljs-typeof,
.hljs-selector-tag,
.hljs-literal          { color: var(--theme-color-syntax-keyword,       #A626A4); }
.hljs-string,
.hljs-regexp,
.hljs-template-tag,
.hljs-template-variable { color: var(--theme-color-syntax-string,       #50A14F); }
.hljs-number,
.hljs-meta             { color: var(--theme-color-syntax-number,        #986801); }
.hljs-comment,
.hljs-quote            { color: var(--theme-color-syntax-comment,       #A0A1A7); font-style: italic; }
.hljs-operator,
.hljs-link             { color: var(--theme-color-syntax-operator,      #0184BC); }
.hljs-punctuation      { color: var(--theme-color-syntax-punctuation,   #383A42); }
.hljs-function .hljs-title,
.hljs-title.function_,
.hljs-title.class_     { color: var(--theme-color-syntax-function,      #4078F2); }
.hljs-variable,
.hljs-variable.language_,
.hljs-params           { color: var(--theme-color-syntax-variable,      #383A42); }
.hljs-type,
.hljs-class .hljs-title { color: var(--theme-color-syntax-type,         #C18401); }
.hljs-built_in,
.hljs-builtin-name     { color: var(--theme-color-syntax-builtin,       #986801); }
.hljs-attr,
.hljs-property         { color: var(--theme-color-syntax-property,      #E45649); }
.hljs-tag,
.hljs-name             { color: var(--theme-color-syntax-tag,           #E45649); }
.hljs-attribute        { color: var(--theme-color-syntax-attrname,      #986801); }
.hljs-symbol           { color: var(--theme-color-syntax-attrvalue,     #50A14F); }
.hljs-emphasis         { font-style: italic; }
.hljs-strong           { font-weight: bold; }
.hljs-deletion         { color: var(--theme-color-status-error,         #B62828); background: rgba(220, 50, 47, 0.08); }
.hljs-addition         { color: var(--theme-color-status-success,       #2E7A3A); background: rgba(80, 161, 79, 0.10); }
`
});

},{}],23:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const libCreateHighlighter = require('./Pict-Code-Highlighter.js');
const _DefaultConfiguration = require('./Pict-Section-Code-DefaultConfiguration.js');

class PictSectionCode extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// The CodeJar instance
		this.codeJar = null;

		// The highlight function (can be overridden)
		this._highlightFunction = null;

		// The current language
		this._language = this.options.Language || 'javascript';
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this._codeJarPrototype = null;
		this.targetElement = false;

		// Build the default highlight function for the configured language
		this._highlightFunction = libCreateHighlighter(this._language);

		return super.onBeforeInitialize();
	}

	/**
	 * Connect the CodeJar prototype.  If not passed explicitly, try to find it
	 * as a global (window.CodeJar) or require it from the npm package.
	 *
	 * @param {function} [pCodeJarPrototype] - The CodeJar constructor function
	 * @returns {boolean|void}
	 */
	connectCodeJarPrototype(pCodeJarPrototype)
	{
		if (typeof (pCodeJarPrototype) === 'function')
		{
			this._codeJarPrototype = pCodeJarPrototype;
			return;
		}

		// Try to find CodeJar in global scope
		if (typeof (window) !== 'undefined')
		{
			if (typeof (window.CodeJar) === 'function')
			{
				this.log.trace(`PICT-Code Found CodeJar in window.CodeJar.`);
				this._codeJarPrototype = window.CodeJar;
				return;
			}
		}

		this.log.error(`PICT-Code No CodeJar prototype found. Include codejar via script tag or call connectCodeJarPrototype(CodeJar) explicitly.`);
		return false;
	}

	onAfterRender(pRenderable)
	{
		// Ensure the CSS from all registered views is injected into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// Resolve the CodeJar prototype if not already set
		if (!this._codeJarPrototype)
		{
			this.connectCodeJarPrototype();
		}

		if (!this._codeJarPrototype)
		{
			this.log.error(`PICT-Code Cannot initialize editor; no CodeJar prototype available.`);
			return false;
		}

		if (this.codeJar)
		{
			this.log.error(`PICT-Code editor is already initialized!`);
			return false;
		}

		// Find the target element
		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			this.log.error(`PICT-Code Could not find target element [${this.options.TargetElementAddress}]!`);
			this.targetElement = false;
			return false;
		}
		this.targetElement = tmpTargetElementSet[0];

		// Build the editor DOM structure
		this._buildEditorDOM();

		// Get initial code content
		let tmpCode = this._resolveCodeContent();

		// Create the CodeJar options
		let tmpCodeJarOptions = {};
		if (this.options.Tab)
		{
			tmpCodeJarOptions.tab = this.options.Tab;
		}
		if (this.options.IndentOn)
		{
			tmpCodeJarOptions.indentOn = this.options.IndentOn;
		}
		if (this.options.MoveToNewLine)
		{
			tmpCodeJarOptions.moveToNewLine = this.options.MoveToNewLine;
		}
		if (typeof (this.options.AddClosing) !== 'undefined')
		{
			tmpCodeJarOptions.addClosing = this.options.AddClosing;
		}
		if (typeof (this.options.CatchTab) !== 'undefined')
		{
			tmpCodeJarOptions.catchTab = this.options.CatchTab;
		}

		this.customConfigureEditorOptions(tmpCodeJarOptions);

		// Instantiate CodeJar on the editor element
		let tmpEditorElement = this._editorElement;
		this.codeJar = this._codeJarPrototype(tmpEditorElement, this._highlightFunction, tmpCodeJarOptions);

		// CodeJar forces white-space:pre-wrap and overflow-wrap:break-word
		// via inline styles, which causes line wrapping that breaks the
		// line-number alignment.  Override back to non-wrapping so the
		// wrap container scrolls horizontally instead.
		this._resetEditorWrapStyles();

		// Set the initial code
		if (tmpCode)
		{
			this.codeJar.updateCode(tmpCode);
		}

		// Wire up the change handler
		this.codeJar.onUpdate((pCode) =>
		{
			this._updateLineNumbers();
			this.onCodeChange(pCode);
		});

		// Initial line number render
		this._updateLineNumbers();

		// Sync line-numbers vertical position with the editor's scroll.
		//
		// The editor element scrolls internally (CodeJar uses
		// contenteditable + overflow:auto for long content), but the
		// line-numbers div is a sibling with overflow:visible — without
		// this sync the line-numbers content stays glued at the top of
		// the wrap while the editor scrolls underneath it, so "line 1"
		// appears next to whatever line is actually showing.
		//
		// Using `transform: translateY(...)` instead of scrollTop keeps
		// the sync compositor-only (no reflow per scroll event) and
		// avoids needing to change the line-numbers element's overflow
		// from visible.  Passive listener so we don't block scrolling.
		if (this._lineNumbersElement)
		{
			let tmpLineNumbersEl = this._lineNumbersElement;
			tmpEditorElement.addEventListener('scroll', function ()
			{
				tmpLineNumbersEl.style.transform = 'translateY(-' + tmpEditorElement.scrollTop + 'px)';
			}, { passive: true });
		}

		// Sync gutter typographic metrics from the editor.  The gutter
		// must use the editor's exact line-height (and matching padding)
		// or rows drift apart cumulatively.  See _syncGutterMetrics().
		this._syncGutterMetrics();

		// Watch the editor for size changes (window resize affecting
		// flex layout, container resize) and re-sync the gutter so it
		// continues to track the editor.  ResizeObserver fires once per
		// frame at most, so the cost is negligible.
		if (this._lineNumbersElement && typeof (ResizeObserver) === 'function')
		{
			let tmpSelf = this;
			this._editorResizeObserver = new ResizeObserver(function ()
			{
				tmpSelf._syncGutterMetrics();
			});
			this._editorResizeObserver.observe(tmpEditorElement);
		}

		// Watch for direct style/class mutations on the editor.  Theme
		// providers that toggle scale by swapping a class on the editor,
		// or host code that adjusts editor typography via inline styles,
		// don't necessarily change the editor's box size — so the
		// ResizeObserver above wouldn't see them.  MutationObserver on
		// the attributes catches these cases.
		if (this._lineNumbersElement && typeof (MutationObserver) === 'function')
		{
			let tmpSelf = this;
			this._editorStyleObserver = new MutationObserver(function ()
			{
				tmpSelf._syncGutterMetrics();
			});
			this._editorStyleObserver.observe(tmpEditorElement,
				{ attributes: true, attributeFilter: ['style', 'class'] });
		}

		// Handle read-only
		if (this.options.ReadOnly)
		{
			tmpEditorElement.setAttribute('contenteditable', 'false');
		}
	}

	/**
	 * Build the editor DOM elements inside the target container.
	 */
	_buildEditorDOM()
	{
		// Clear the target
		this.targetElement.innerHTML = '';

		// Create wrapper
		let tmpWrap = document.createElement('div');
		tmpWrap.className = 'pict-code-editor-wrap';

		// Create line numbers container
		if (this.options.LineNumbers)
		{
			let tmpLineNumbers = document.createElement('div');
			tmpLineNumbers.className = 'pict-code-line-numbers';
			tmpWrap.appendChild(tmpLineNumbers);
			this._lineNumbersElement = tmpLineNumbers;
		}

		// Create the editor element (CodeJar needs a pre or div)
		let tmpEditor = document.createElement('div');
		tmpEditor.className = 'pict-code-editor language-' + this._language;
		if (!this.options.LineNumbers)
		{
			tmpEditor.className += ' pict-code-no-line-numbers';
		}
		tmpWrap.appendChild(tmpEditor);

		this.targetElement.appendChild(tmpWrap);
		this._editorElement = tmpEditor;
		this._wrapElement = tmpWrap;
	}

	/**
	 * Update the line numbers display based on current code content.
	 */
	_updateLineNumbers()
	{
		if (!this.options.LineNumbers || !this._lineNumbersElement || !this._editorElement)
		{
			return;
		}

		let tmpCode = this._editorElement.textContent || '';
		let tmpLineCount = tmpCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += `<span>${i}</span>`;
		}

		this._lineNumbersElement.innerHTML = tmpHTML;

		// Defense-in-depth: every line-count rebuild is also a natural
		// re-sync point.  Cheap (one getComputedStyle + a handful of
		// style writes) and guarantees newly-added spans use the same
		// metrics as the editor at the moment of the rebuild.
		this._syncGutterMetrics();
	}

	/**
	 * Copy typographic metrics from the editor element to the line-numbers
	 * gutter so every gutter row lines up with its corresponding code row.
	 *
	 * The gutter is a sibling element with its own font/line-height
	 * declarations — if any one diverges from the editor (unitless
	 * line-height resolving against a different font-size, host CSS
	 * overriding font-family, theme scale changing the editor's metrics),
	 * the two desync and the drift accumulates with every line.
	 *
	 * The pattern is borrowed from the canonical `codejar-linenumbers`
	 * library (julianpoemp/codejar-linenumbers), which solves the same
	 * class of bug by reading the editor's computed styles at init and
	 * stamping them onto the gutter.  We extend that here by also
	 * re-stamping whenever the editor resizes (see the ResizeObserver in
	 * onAfterInitialRender), so theme scale changes self-heal too.
	 *
	 * Public callers can invoke {@link syncMetrics} to force a re-sync
	 * after any external change that affects editor typography.
	 */
	_syncGutterMetrics()
	{
		if (!this._lineNumbersElement || !this._editorElement)
		{
			return;
		}
		if (typeof (window) === 'undefined' || typeof (window.getComputedStyle) !== 'function')
		{
			return;
		}

		let tmpEditorStyle = window.getComputedStyle(this._editorElement);
		let tmpLineHeight = tmpEditorStyle.lineHeight;

		// `normal` is the spec default — leave the gutter untouched so the
		// stylesheet's declaration wins (we have no number to copy).
		if (tmpLineHeight && tmpLineHeight !== 'normal')
		{
			this._lineNumbersElement.style.lineHeight = tmpLineHeight;
		}

		// Match the editor's vertical padding so row 1 of the gutter sits
		// at the same y-offset as row 1 of the code.
		if (tmpEditorStyle.paddingTop)
		{
			this._lineNumbersElement.style.paddingTop = tmpEditorStyle.paddingTop;
		}
		if (tmpEditorStyle.paddingBottom)
		{
			this._lineNumbersElement.style.paddingBottom = tmpEditorStyle.paddingBottom;
		}

		// Font-family must match so the visual baseline of the digits
		// aligns with the code (different monospace fonts can have
		// different x-heights even at identical line-heights).
		if (tmpEditorStyle.fontFamily)
		{
			this._lineNumbersElement.style.fontFamily = tmpEditorStyle.fontFamily;
		}

		// Dev-time sanity check.  If the gutter's resolved row height
		// disagrees with the editor's, alignment will drift cumulatively.
		// Warn loudly so the regression is caught at the next reload
		// instead of silently accumulating pixels per line.
		if (typeof (console) !== 'undefined' && console.warn)
		{
			let tmpFirstSpan = this._lineNumbersElement.querySelector('span');
			if (tmpFirstSpan)
			{
				let tmpGutterRow = tmpFirstSpan.getBoundingClientRect().height;
				let tmpEditorRow = parseFloat(tmpLineHeight);
				if (tmpGutterRow && tmpEditorRow && Math.abs(tmpGutterRow - tmpEditorRow) > 0.5)
				{
					console.warn('[pict-section-code] gutter/editor row-height mismatch: ' +
						'gutter ' + tmpGutterRow + 'px vs editor ' + tmpEditorRow + 'px — ' +
						'line numbers will drift. Check for CSS overriding ' +
						'.pict-code-line-numbers line-height.');
				}
			}
		}
	}

	/**
	 * Public hook for hosts to force a gutter metrics re-sync after
	 * external typography changes (theme scale, font-size swap, etc.).
	 * The ResizeObserver attached at init handles most cases, but call
	 * this from an app's post-theme-change hook for belt-and-suspenders
	 * coverage.
	 */
	syncMetrics()
	{
		this._syncGutterMetrics();
	}

	/**
	 * Reset inline styles that CodeJar sets on the editor element.
	 *
	 * CodeJar forces white-space:pre-wrap and overflow-wrap:break-word so
	 * long lines wrap visually.  That breaks line-number alignment because
	 * each wrapped visual row is not a logical line.  Resetting to pre /
	 * normal makes the outer .pict-code-editor-wrap scroll horizontally.
	 */
	_resetEditorWrapStyles()
	{
		if (!this._editorElement)
		{
			return;
		}
		this._editorElement.style.whiteSpace = 'pre';
		this._editorElement.style.overflowWrap = 'normal';
	}

	/**
	 * Resolve the initial code content from address or default.
	 *
	 * @returns {string} The code content
	 */
	_resolveCodeContent()
	{
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			let tmpAddressedData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.CodeDataAddress);
			if (typeof (tmpAddressedData) === 'string')
			{
				return tmpAddressedData;
			}
			else
			{
				this.log.warn(`PICT-Code Address [${this.options.CodeDataAddress}] did not return a string; it was ${typeof (tmpAddressedData)}.`);
			}
		}

		return this.options.DefaultCode || '';
	}

	/**
	 * Hook for subclasses to customize CodeJar options before instantiation.
	 *
	 * @param {object} pOptions - The CodeJar options object to modify
	 */
	customConfigureEditorOptions(pOptions)
	{
		// Override in subclass to tweak options
	}

	/**
	 * Called when the code content changes.  Override in subclasses to handle changes.
	 *
	 * @param {string} pCode - The new code content
	 */
	onCodeChange(pCode)
	{
		// Write back to data address if configured
		if (this.options.CodeDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options
			};
			this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.CodeDataAddress, pCode);
		}
	}

	// -- Public API Methods --

	/**
	 * Get the current code content.
	 *
	 * @returns {string} The current code
	 */
	getCode()
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code getCode called before editor initialized.');
			return '';
		}
		return this.codeJar.toString();
	}

	/**
	 * Set the code content.
	 *
	 * @param {string} pCode - The code to set
	 */
	setCode(pCode)
	{
		if (!this.codeJar)
		{
			this.log.warn('PICT-Code setCode called before editor initialized.');
			return;
		}
		this.codeJar.updateCode(pCode);
		this._updateLineNumbers();
	}

	/**
	 * Change the editor language and re-highlight.
	 *
	 * @param {string} pLanguage - The language identifier
	 */
	setLanguage(pLanguage)
	{
		this._language = pLanguage;
		this._highlightFunction = libCreateHighlighter(pLanguage);

		if (this._editorElement)
		{
			// Update the class
			this._editorElement.className = 'pict-code-editor language-' + pLanguage;
			if (!this.options.LineNumbers)
			{
				this._editorElement.className += ' pict-code-no-line-numbers';
			}
		}

		if (this.codeJar)
		{
			// Re-create the editor with the new highlight function
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set a custom highlight function to replace the built-in highlighter.
	 * Useful for integrating Prism.js, highlight.js, or any other library.
	 *
	 * @param {function} pHighlightFunction - A function that takes a DOM element and highlights its textContent
	 */
	setHighlightFunction(pHighlightFunction)
	{
		if (typeof (pHighlightFunction) !== 'function')
		{
			this.log.error('PICT-Code setHighlightFunction requires a function.');
			return;
		}
		this._highlightFunction = pHighlightFunction;

		if (this.codeJar)
		{
			let tmpCode = this.codeJar.toString();
			this.codeJar.destroy();
			this.codeJar = this._codeJarPrototype(this._editorElement, this._highlightFunction,
			{
				tab: this.options.Tab,
				catchTab: this.options.CatchTab,
				addClosing: this.options.AddClosing
			});
			this._resetEditorWrapStyles();
			this.codeJar.updateCode(tmpCode);
			this.codeJar.onUpdate((pCode) =>
			{
				this._updateLineNumbers();
				this.onCodeChange(pCode);
			});
		}
	}

	/**
	 * Set the read-only state of the editor.
	 *
	 * @param {boolean} pReadOnly - Whether the editor should be read-only
	 */
	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = pReadOnly;
		if (this._editorElement)
		{
			this._editorElement.setAttribute('contenteditable', pReadOnly ? 'false' : 'true');
		}
	}

	/**
	 * Destroy the editor and clean up.
	 */
	destroy()
	{
		if (this._editorResizeObserver)
		{
			this._editorResizeObserver.disconnect();
			this._editorResizeObserver = null;
		}
		if (this._editorStyleObserver)
		{
			this._editorStyleObserver.disconnect();
			this._editorStyleObserver = null;
		}
		if (this.codeJar)
		{
			this.codeJar.destroy();
			this.codeJar = null;
		}
	}

	/**
	 * Marshal code content from the data address into the view.
	 */
	marshalToView()
	{
		super.marshalToView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			let tmpCode = this._resolveCodeContent();
			if (typeof (tmpCode) === 'string')
			{
				this.codeJar.updateCode(tmpCode);
				this._updateLineNumbers();
			}
		}
	}

	/**
	 * Marshal the current code content back to the data address.
	 */
	marshalFromView()
	{
		super.marshalFromView();
		if (this.codeJar && this.options.CodeDataAddress)
		{
			this.onCodeChange(this.codeJar.toString());
		}
	}
}

module.exports = PictSectionCode;

module.exports.default_configuration = _DefaultConfiguration;
module.exports.createHighlighter = libCreateHighlighter;

// Demo bundle for pict-docuserve.  Host apps that embed docuserve and
// want pict-section-code's demos visible in their docs site call
// `require('pict-section-code').registerWithDocuserve(pict)` once at
// app boot.  Silent no-op when Docuserve-Demos isn't installed.
//
// The require here is intentionally eager: browserify needs a static
// `require()` at module-toplevel to trace and bundle the demos source.
// The apparent circular dep (demos/index.js requires THIS module to
// reach the PictSectionCode class) is benign — by the time demos/
// index.js runs, `module.exports = PictSectionCode` has already
// executed, so it sees a usable class.  The `.demos` and
// `.registerWithDocuserve` attachments below run after the require
// returns, so demos/index.js never observes them being undefined.
const libCodeDemos = require('./demos');
module.exports.demos                = libCodeDemos.demos;
module.exports.registerWithDocuserve = libCodeDemos.registerWithDocuserve;

},{"./Pict-Code-Highlighter.js":21,"./Pict-Section-Code-DefaultConfiguration.js":22,"./demos":24,"pict-view":239}],24:[function(require,module,exports){
/**
 * pict-section-code demos
 *
 * Each entry is consumed by pict-docuserve's `Docuserve-Demos` provider.
 * Hosts that want these demos to appear in their docs site call
 * `require('pict-section-code/source/demos').registerWithDocuserve(pict)`
 * once at app boot (typically inside their DocuserveApplication subclass
 * after `super(...)`).
 *
 * Each demo's Mount(pict, container, spec) signature creates a fresh
 * pict-section-code view instance inside the supplied container.  Spec
 * fields are passed through to the view config so a single demo template
 * can express "JavaScript with line numbers", "JSON read-only no
 * gutter", etc. without duplicating the wiring.
 */

const libPictSectionCode = require('../Pict-Section-Code.js');

/**
 * Internal helper: mount a pict-section-code instance into a host
 * container according to the demo spec.  Each call registers a uniquely
 * identified view so multiple demos on the same page coexist cleanly.
 */
function mountCodeEditor(pPict, pContainer, pSpec)
{
	// Tag this mount with an id we can target as the destination.
	let tmpDestId = 'demo-code-' + (pSpec.Hash || 'unnamed') + '-' + Date.now();
	pContainer.innerHTML = '<div id="' + tmpDestId + '"></div>';

	let tmpConfig =
	{
		ViewIdentifier:            'Demo-Code-' + tmpDestId,
		DefaultDestinationAddress: '#' + tmpDestId,
		Templates:
		[
			{ Hash: 'CodeEditor-Container', Template: '<!-- demo code editor renders here -->' }
		],
		Renderables:
		[
			{ RenderableHash: 'CodeEditor-Wrap', TemplateHash: 'CodeEditor-Container', DestinationAddress: '#' + tmpDestId }
		],
		TargetElementAddress: '#' + tmpDestId,
		Language:    pSpec.Language    || 'javascript',
		ReadOnly:    !!pSpec.ReadOnly,
		LineNumbers: pSpec.LineNumbers !== false,
		Tab:         pSpec.Tab         || '\t',
		AddClosing:  pSpec.AddClosing !== false,
		CatchTab:    pSpec.CatchTab   !== false,
		DefaultCode: pSpec.Code        || '// example code\n',
		// AutoRender is intentionally OFF so we can pre-wire CodeJar
		// before the first render fires.  pict-section-code looks for
		// window.CodeJar by default; most hosts bundle CodeJar under
		// window.CodeJarModules.CodeJar (e.g. retold-content-system's
		// codejar-bundle.js), so we wire it explicitly here.
		AutoRender:  false,
		RenderOnLoad: false
	};

	let tmpView = pPict.addView(tmpConfig.ViewIdentifier, tmpConfig, libPictSectionCode);
	if (!tmpView) { return null; }

	// Connect the CodeJar prototype + highlight function from the
	// CodeJarModules global if it's loaded.  Falls back to bare CodeJar
	// if the host published the prototype directly.
	if (typeof window !== 'undefined')
	{
		if (window.CodeJarModules && typeof window.CodeJarModules.CodeJar === 'function')
		{
			tmpView.connectCodeJarPrototype(window.CodeJarModules.CodeJar);
		}
		else if (typeof window.CodeJar === 'function')
		{
			tmpView.connectCodeJarPrototype(window.CodeJar);
		}

		// Wire highlight.js highlighting if the bundle exposes it.
		if (window.CodeJarModules && window.CodeJarModules.hljs)
		{
			let tmpHljs = window.CodeJarModules.hljs;
			let tmpLanguage = tmpConfig.Language;
			tmpView._highlightFunction = function (pElement)
			{
				pElement.removeAttribute('data-highlighted');
				delete pElement.dataset.highlighted;
				pElement.className = pElement.className
					.replace(/\bhljs\b/g, '')
					.replace(/\blanguage-\S+/g, '')
					.trim();
				pElement.classList.add('language-' + tmpLanguage);
				try { tmpHljs.highlightElement(pElement); }
				catch (pErr) { /* swallow — highlighting is best-effort */ }
			};
		}
	}

	try { tmpView.render(); }
	catch (pError) { /* pict-section-code logs its own errors */ }
	return tmpView;
}

const _Demos =
[
	{
		DemoSchemaVersion: 1,
		Hash:        'javascript-editor',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'JavaScript editor',
		Description: 'Default pict-section-code configuration — line numbers on, highlight.js for JavaScript, two-space tab.',
		Spec:
		{
			Hash: 'javascript-editor',
			Language: 'javascript',
			LineNumbers: true,
			Tab: '  ',
			Code:
				'// A small example — try editing me.\n' +
				'function fibonacci(n) {\n' +
				'  if (n <= 1) return n;\n' +
				'  return fibonacci(n - 1) + fibonacci(n - 2);\n' +
				'}\n' +
				'\n' +
				'for (let i = 0; i < 10; i++) {\n' +
				'  console.log(`fib(${i}) =`, fibonacci(i));\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "javascript",\n' +
					'  "LineNumbers": true,\n' +
					'  "Tab": "  ",\n' +
					'  "Code": "function fibonacci(n) { … }"\n' +
					'}'
			}
		]
	},
	{
		DemoSchemaVersion: 1,
		Hash:        'json-readonly',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'JSON viewer (read-only)',
		Description: 'Read-only mode with line numbers off — useful for embedded "show me the payload" surfaces in dashboards.',
		Spec:
		{
			Hash: 'json-readonly',
			Language: 'json',
			ReadOnly: true,
			LineNumbers: false,
			Code:
				'{\n' +
				'  "version": "1.0.7",\n' +
				'  "syntax": {\n' +
				'    "keyword":  "#A626A4",\n' +
				'    "string":   "#50A14F",\n' +
				'    "number":   "#986801",\n' +
				'    "function": "#4078F2"\n' +
				'  },\n' +
				'  "features": ["highlighting", "line-numbers", "readonly", "themed"]\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "json",\n' +
					'  "ReadOnly": true,\n' +
					'  "LineNumbers": false\n' +
					'}'
			}
		]
	},
	{
		DemoSchemaVersion: 1,
		Hash:        'css-editor',
		Group:       'pict',
		Module:      'pict-section-code',
		Name:        'CSS editor (4-space tab)',
		Description: 'CSS-flavoured highlighting with a 4-space tab and bracket auto-close turned off — leaner editing for stylesheet snippets.',
		Spec:
		{
			Hash: 'css-editor',
			Language: 'css',
			LineNumbers: true,
			Tab: '    ',
			AddClosing: false,
			Code:
				'/* Theme-aware token usage */\n' +
				'.docuserve-demo-title {\n' +
				'    color: var(--theme-color-text-primary, #3D3229);\n' +
				'    font-size: 1.5em;\n' +
				'    font-weight: 600;\n' +
				'}\n' +
				'\n' +
				'.docuserve-demo-description {\n' +
				'    color: var(--theme-color-text-secondary, #5E5549);\n' +
				'    line-height: 1.55;\n' +
				'}\n'
		},
		Mount: mountCodeEditor,
		Sources:
		[
			{
				Name: 'spec.json',
				Language: 'json',
				Content:
					'{\n' +
					'  "Language": "css",\n' +
					'  "LineNumbers": true,\n' +
					'  "Tab": "    ",\n' +
					'  "AddClosing": false\n' +
					'}'
			}
		]
	}
];

/**
 * Register every pict-section-code demo with the host docuserve app.
 *
 * @param {object} pPict - The Pict instance (typically `this.pict` inside
 *                        a DocuserveApplication subclass).
 * @returns {number} count of demos registered (0 if Docuserve-Demos
 *                   provider isn't present — silent no-op).
 */
function registerWithDocuserve(pPict)
{
	if (!pPict || !pPict.providers || !pPict.providers['Docuserve-Demos'])
	{
		return 0;
	}
	return pPict.providers['Docuserve-Demos'].registerAll(_Demos);
}

module.exports = _Demos;
module.exports.demos = _Demos;
module.exports.registerWithDocuserve = registerWithDocuserve;

},{"../Pict-Section-Code.js":23}],25:[function(require,module,exports){
arguments[4][8][0].apply(exports,arguments)
},{"./providers/Pict-Provider-Content.js":26,"./views/Pict-View-Content.js":27,"dup":8}],26:[function(require,module,exports){
arguments[4][9][0].apply(exports,arguments)
},{"dup":9,"pict-provider":19,"pict-section-code":23}],27:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-content {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
		}
		.pict-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 200px;
			color: #8A7F72;
			font-size: 1em;
		}
		.pict-content h1 {
			font-size: 2em;
			color: #3D3229;
			border-bottom: 1px solid #DDD6CA;
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-content h2 {
			font-size: 1.5em;
			color: #3D3229;
			border-bottom: 1px solid #EAE3D8;
			padding-bottom: 0.25em;
			margin-top: 1.5em;
		}
		.pict-content h3 {
			font-size: 1.25em;
			color: #3D3229;
			margin-top: 1.25em;
		}
		.pict-content h4, .pict-content h5, .pict-content h6 {
			color: #5E5549;
			margin-top: 1em;
		}
		.pict-content p {
			line-height: 1.7;
			color: #423D37;
			margin: 0.75em 0;
		}
		.pict-content a {
			color: #2E7D74;
			text-decoration: none;
		}
		.pict-content a:hover {
			text-decoration: underline;
		}
		.pict-content pre {
			background: #3D3229;
			color: #E8E0D4;
			padding: 1.25em;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.9em;
		}
		.pict-content code {
			background: #F0ECE4;
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			color: #9E6B47;
		}
		.pict-content-code-wrap {
			display: flex;
			flex-direction: row;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace;
			font-size: 14px;
			line-height: 1.5;
			border-radius: 6px;
			overflow: hidden;
			margin: 1em 0;
			background: #3D3229;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers {
			width: 40px;
			min-width: 40px;
			padding: 1.25em 0;
			text-align: right;
			background: #342A22;
			border-right: 1px solid #4A3F35;
			color: #8A7F72;
			font-size: 13px;
			line-height: 1.5;
			user-select: none;
			pointer-events: none;
			box-sizing: border-box;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers span {
			display: block;
			padding: 0 8px 0 0;
		}
		.pict-content-code-wrap pre {
			margin: 0;
			background: #3D3229;
			color: #E8E0D4;
			padding: 1.25em 1.25em 1.25em 8px;
			border-radius: 0 6px 6px 0;
			overflow-x: auto;
			line-height: 1.5;
			font-size: inherit;
			flex: 1;
			min-width: 0;
		}
		.pict-content-code-wrap pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
			font-family: inherit;
		}
		.pict-content-code-wrap .keyword { color: #C678DD; }
		.pict-content-code-wrap .string { color: #98C379; }
		.pict-content-code-wrap .number { color: #D19A66; }
		.pict-content-code-wrap .comment { color: #7F848E; font-style: italic; }
		.pict-content-code-wrap .operator { color: #56B6C2; }
		.pict-content-code-wrap .punctuation { color: #E8E0D4; }
		.pict-content-code-wrap .function-name { color: #61AFEF; }
		.pict-content-code-wrap .property { color: #E06C75; }
		.pict-content-code-wrap .tag { color: #E06C75; }
		.pict-content-code-wrap .attr-name { color: #D19A66; }
		.pict-content-code-wrap .attr-value { color: #98C379; }
		.pict-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.pict-content blockquote {
			border-left: 4px solid #2E7D74;
			margin: 1em 0;
			padding: 0.5em 1em;
			background: #F7F5F0;
			color: #5E5549;
		}
		.pict-content blockquote p {
			margin: 0.25em 0;
		}
		.pict-content ul, .pict-content ol {
			padding-left: 2em;
			line-height: 1.8;
		}
		.pict-content li {
			margin: 0.25em 0;
			color: #423D37;
		}
		.pict-content hr {
			border: none;
			border-top: 1px solid #DDD6CA;
			margin: 2em 0;
		}
		.pict-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 1em 0;
		}
		.pict-content table th {
			background: #F5F0E8;
			border: 1px solid #DDD6CA;
			padding: 0.6em 0.8em;
			text-align: left;
			font-weight: 600;
			color: #3D3229;
		}
		.pict-content table td {
			border: 1px solid #DDD6CA;
			padding: 0.5em 0.8em;
			color: #423D37;
		}
		.pict-content table tr:nth-child(even) {
			background: #F7F5F0;
		}
		.pict-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-content pre.mermaid {
			background: #fff;
			color: #3D3229;
			text-align: center;
			padding: 1em;
		}
		.pict-content .pict-content-katex-display {
			text-align: center;
			margin: 1em 0;
			padding: 0.5em;
			overflow-x: auto;
		}
		.pict-content .pict-content-katex-inline {
			display: inline;
		}
	`,

	Templates:
	[
		{
			Hash: "Pict-Content-Template",
			Template: /*html*/`
<div class="pict-content" id="Pict-Content-Body">
	<div class="pict-content-loading">Loading content...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Pict-Content-Display",
			TemplateHash: "Pict-Content-Template",
			DestinationAddress: "#Pict-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class PictContentView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	displayContent(pHTMLContent, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';

		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, pHTMLContent);

		// Scroll to top of content area
		let tmpContentContainer = document.getElementById(tmpContainerID);
		if (tmpContentContainer && tmpContentContainer.parentElement)
		{
			tmpContentContainer.parentElement.scrollTop = 0;
		}

		// Post-render: initialize Mermaid diagrams if mermaid is available
		this.renderMermaidDiagrams(tmpContainerID);

		// Post-render: render KaTeX equations if katex is available
		this.renderKaTeXEquations(tmpContainerID);
	}

	/**
	 * Render any Mermaid diagram blocks in the content area.
	 * Mermaid blocks are `<pre class="mermaid">` elements produced by parseMarkdown.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderMermaidDiagrams(pContainerID)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		let tmpMermaidElements = tmpContentBody.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// mermaid.run() will process all pre.mermaid elements in the container
		try
		{
			mermaid.run({ nodes: tmpMermaidElements });
		}
		catch (pError)
		{
			this.log.error('Mermaid rendering error: ' + pError.message);
		}
	}

	/**
	 * Render KaTeX inline and display math elements in the content area.
	 * Inline: `<span class="pict-content-katex-inline">`
	 * Display: `<div class="pict-content-katex-display">`
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderKaTeXEquations(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		// Render inline math
		let tmpInlineElements = tmpContentBody.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				this.log.warn('KaTeX inline error: ' + pError.message);
			}
		}

		// Render display math
		let tmpDisplayElements = tmpContentBody.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				this.log.warn('KaTeX display error: ' + pError.message);
			}
		}
	}

	/**
	 * Show a loading indicator.
	 *
	 * @param {string} [pMessage] - Loading message (defaults to 'Loading content...')
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	showLoading(pMessage, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpMessage = pMessage || 'Loading content...';
		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, '<div class="pict-content-loading">' + tmpMessage + '</div>');
	}
}

module.exports = PictContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],28:[function(require,module,exports){
// The container for all the Pict-Section-Flow related code.

// The main flow diagram view class
module.exports = require('./views/PictView-Flow.js');

// Node rendering view
module.exports.PictViewFlowNode = require('./views/PictView-Flow-Node.js');

// Toolbar views
module.exports.PictViewFlowToolbar = require('./views/PictView-Flow-Toolbar.js');
module.exports.PictViewFlowFloatingToolbar = require('./views/PictView-Flow-FloatingToolbar.js');

// Services
module.exports.PictServiceFlowInteractionManager = require('./services/PictService-Flow-InteractionManager.js');
module.exports.PictServiceFlowConnectionRenderer = require('./services/PictService-Flow-ConnectionRenderer.js');
module.exports.PictServiceFlowTether = require('./services/PictService-Flow-Tether.js');
module.exports.PictServiceFlowLayout = require('./services/PictService-Flow-Layout.js');
module.exports.PictServiceFlowPathGenerator = require('./services/PictService-Flow-PathGenerator.js');
module.exports.PictServiceFlowViewportManager = require('./services/PictService-Flow-ViewportManager.js');
module.exports.PictServiceFlowSelectionManager = require('./services/PictService-Flow-SelectionManager.js');
module.exports.PictServiceFlowPanelManager = require('./services/PictService-Flow-PanelManager.js');
module.exports.PictServiceFlowDataManager = require('./services/PictService-Flow-DataManager.js');
module.exports.PictServiceFlowConnectionHandleManager = require('./services/PictService-Flow-ConnectionHandleManager.js');
module.exports.PictServiceFlowRenderManager = require('./services/PictService-Flow-RenderManager.js');
module.exports.PictServiceFlowPortRenderer = require('./services/PictService-Flow-PortRenderer.js');

// Providers
module.exports.PictProviderFlowNodeTypes = require('./providers/PictProvider-Flow-NodeTypes.js');
module.exports.PictProviderFlowEventHandler = require('./providers/PictProvider-Flow-EventHandler.js');
module.exports.PictProviderFlowLayouts = require('./providers/PictProvider-Flow-Layouts.js');
module.exports.PictProviderFlowSVGHelpers = require('./providers/PictProvider-Flow-SVGHelpers.js');
module.exports.PictProviderFlowGeometry = require('./providers/PictProvider-Flow-Geometry.js');
module.exports.PictProviderFlowPanelChrome = require('./providers/PictProvider-Flow-PanelChrome.js');
module.exports.PictProviderFlowCSS = require('./providers/PictProvider-Flow-CSS.js');
module.exports.PictProviderFlowIcons = require('./providers/PictProvider-Flow-Icons.js');
module.exports.PictProviderFlowConnectorShapes = require('./providers/PictProvider-Flow-ConnectorShapes.js');

// FlowCard base class
module.exports.PictFlowCard = require('./PictFlowCard.js');

// FlowCardPropertiesPanel base class and panel types
module.exports.PictFlowCardPropertiesPanel = require('./PictFlowCardPropertiesPanel.js');
module.exports.FlowCardPropertiesPanelTemplate = require('./panels/FlowCardPropertiesPanel-Template.js');
module.exports.FlowCardPropertiesPanelMarkdown = require('./panels/FlowCardPropertiesPanel-Markdown.js');
module.exports.FlowCardPropertiesPanelForm = require('./panels/FlowCardPropertiesPanel-Form.js');
module.exports.FlowCardPropertiesPanelView = require('./panels/FlowCardPropertiesPanel-View.js');

// Properties panel renderer view
module.exports.PictViewFlowPropertiesPanel = require('./views/PictView-Flow-PropertiesPanel.js');

},{"./PictFlowCard.js":29,"./PictFlowCardPropertiesPanel.js":30,"./panels/FlowCardPropertiesPanel-Form.js":31,"./panels/FlowCardPropertiesPanel-Markdown.js":32,"./panels/FlowCardPropertiesPanel-Template.js":33,"./panels/FlowCardPropertiesPanel-View.js":34,"./providers/PictProvider-Flow-CSS.js":35,"./providers/PictProvider-Flow-ConnectorShapes.js":36,"./providers/PictProvider-Flow-EventHandler.js":37,"./providers/PictProvider-Flow-Geometry.js":38,"./providers/PictProvider-Flow-Icons.js":39,"./providers/PictProvider-Flow-Layouts.js":40,"./providers/PictProvider-Flow-NodeTypes.js":41,"./providers/PictProvider-Flow-PanelChrome.js":43,"./providers/PictProvider-Flow-SVGHelpers.js":44,"./services/PictService-Flow-ConnectionHandleManager.js":46,"./services/PictService-Flow-ConnectionRenderer.js":47,"./services/PictService-Flow-DataManager.js":48,"./services/PictService-Flow-InteractionManager.js":49,"./services/PictService-Flow-Layout.js":50,"./services/PictService-Flow-PanelManager.js":51,"./services/PictService-Flow-PathGenerator.js":52,"./services/PictService-Flow-PortRenderer.js":53,"./services/PictService-Flow-RenderManager.js":54,"./services/PictService-Flow-SelectionManager.js":55,"./services/PictService-Flow-Tether.js":56,"./services/PictService-Flow-ViewportManager.js":57,"./views/PictView-Flow-FloatingToolbar.js":58,"./views/PictView-Flow-Node.js":59,"./views/PictView-Flow-PropertiesPanel.js":60,"./views/PictView-Flow-Toolbar.js":61,"./views/PictView-Flow.js":62}],29:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictFlowCard - Base class for flow diagram cards.
 *
 * Developers create subclasses of PictFlowCard to define reusable node types
 * that appear in the flow palette. Each card describes a discrete operation
 * (e.g. "If-Then-Else", "File Read") with configurable inputs, outputs, and
 * metadata. Pict-Section-Flow uses registered cards to build a palette for
 * the user to drag onto the graph.
 *
 * Configurable properties:
 *   - Title          (string, required) - Display name shown on the node
 *   - Name           (string, optional) - Longer descriptive name
 *   - Code           (string, required) - Short identifier (e.g. "ITE", "SW")
 *   - Description    (string, optional) - Brief explanation of what the card does
 *   - Icon           (string, optional) - Icon identifier or emoji
 *   - PreviewImage   (string, optional) - URL to a preview/thumbnail image
 *   - Documentation  (string, optional) - URL or inline documentation text
 *   - Tooltip        (string, optional) - Hover tooltip text
 *   - Inputs         (array)  - Named input ports, each with:
 *       - Name                 (string)  - Port label
 *       - Side                 (string)  - Port side ('left', 'top', etc.)
 *       - MinimumInputCount    (number)  - Minimum connections accepted (default 0)
 *       - MaximumInputCount    (number)  - Maximum connections accepted (default -1, unlimited)
 *   - Outputs        (array)  - Named output ports
 *   - Enabled        (boolean) - Whether this card is available in the palette
 *   - PropertiesPanel (object, optional) - Configuration for the on-graph properties panel
 *       - PanelType      (string)  - 'Template', 'Markdown', 'Form', or 'View'
 *       - DefaultWidth   (number)  - Panel width (default 300)
 *       - DefaultHeight  (number)  - Panel height (default 200)
 *       - Title          (string)  - Panel title bar text
 *       - Configuration  (object)  - Panel-type-specific configuration
 *   - BodyContent     (object, optional) - Custom content rendered in the node body area
 *       - ContentType    (string)  - 'svg', 'html', or 'canvas'
 *       - Template       (string)  - Pict template string (html/svg only)
 *       - TemplateHash   (string)  - Registered template hash (takes precedence over Template)
 *       - Templates      (array)   - Template definitions to register [{Hash, Template}]
 *       - RenderCallback (function)- Imperative render callback (required for canvas)
 *       - Padding        (number)  - Inner padding in pixels (default 2)
 *   - ShowTypeLabel    (boolean, default true)  - Whether to show the type label/code badge on hover
 *   - PortLabelsOnHover (boolean, default false) - When true, port labels only appear on hover
 *   - PortLabelsVertical (boolean, default false) - When true, port labels render vertically
 *   - PortLabelPadding  (boolean, default false) - When true, port labels have extra padding to avoid overlapping body content
 *   - LabelsInFront     (boolean, default true)  - When true, labels render in front of body content; when false, behind
 *
 * Usage:
 *   class MyCard extends PictFlowCard {
 *     constructor(pFable, pOptions, pServiceHash) {
 *       super(pFable, pOptions, pServiceHash);
 *       this.cardTitle = 'My Card';
 *       this.cardCode = 'MC';
 *       this.cardInputs = [{ Name: 'Data', Side: 'left', MinimumInputCount: 1, MaximumInputCount: 1 }];
 *       this.cardOutputs = [{ Name: 'Result', Side: 'right' }];
 *     }
 *   }
 */
class PictFlowCard extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, PictFlowCard.default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictFlowCard';

		// --- Card metadata ---
		this.cardTitle = (tmpOptions.Title) ? tmpOptions.Title : 'Card';
		this.cardName = (tmpOptions.Name) ? tmpOptions.Name : false;
		this.cardCode = (tmpOptions.Code) ? tmpOptions.Code : '';
		this.cardDescription = (tmpOptions.Description) ? tmpOptions.Description : false;
		this.cardIcon = (tmpOptions.Icon) ? tmpOptions.Icon : false;
		this.cardPreviewImage = (tmpOptions.PreviewImage) ? tmpOptions.PreviewImage : false;
		this.cardDocumentation = (tmpOptions.Documentation) ? tmpOptions.Documentation : false;
		this.cardTooltip = (tmpOptions.Tooltip) ? tmpOptions.Tooltip : false;
		this.cardHelp = (tmpOptions.Help) ? tmpOptions.Help : false;

		// --- Card enabled state ---
		this.cardEnabled = (typeof tmpOptions.Enabled === 'boolean') ? tmpOptions.Enabled : true;

		// --- Card appearance ---
		this.cardTitleBarColor = (tmpOptions.TitleBarColor) ? tmpOptions.TitleBarColor : '#2c3e50';
		this.cardBodyStyle = (tmpOptions.BodyStyle) ? tmpOptions.BodyStyle : {};
		this.cardWidth = (typeof tmpOptions.Width === 'number') ? tmpOptions.Width : 180;
		this.cardHeight = (typeof tmpOptions.Height === 'number') ? tmpOptions.Height : 80;
		this.cardCategory = (tmpOptions.Category) ? tmpOptions.Category : 'General';

		// --- Input and Output port definitions ---
		// Inputs: [{ Name: 'In', Side: 'left', MinimumInputCount: 0, MaximumInputCount: -1 }]
		// Outputs: [{ Name: 'Out', Side: 'right' }]
		this.cardInputs = Array.isArray(tmpOptions.Inputs) ? tmpOptions.Inputs : [];
		this.cardOutputs = Array.isArray(tmpOptions.Outputs) ? tmpOptions.Outputs : [];

		// --- Properties panel configuration ---
		this.cardPropertiesPanel = (tmpOptions.PropertiesPanel && typeof tmpOptions.PropertiesPanel === 'object')
			? tmpOptions.PropertiesPanel
			: null;

		// --- Body content configuration ---
		this.cardBodyContent = (tmpOptions.BodyContent && typeof tmpOptions.BodyContent === 'object')
			? tmpOptions.BodyContent
			: null;

		// --- Label display booleans ---
		this.cardShowTypeLabel = (typeof tmpOptions.ShowTypeLabel === 'boolean') ? tmpOptions.ShowTypeLabel : true;
		this.cardPortLabelsOnHover = (typeof tmpOptions.PortLabelsOnHover === 'boolean') ? tmpOptions.PortLabelsOnHover : false;
		this.cardPortLabelsVertical = (typeof tmpOptions.PortLabelsVertical === 'boolean') ? tmpOptions.PortLabelsVertical : false;
		this.cardPortLabelPadding = (typeof tmpOptions.PortLabelPadding === 'boolean') ? tmpOptions.PortLabelPadding : false;
		this.cardPortLabelsOutside = (typeof tmpOptions.PortLabelsOutside === 'boolean') ? tmpOptions.PortLabelsOutside : false;
		this.cardLabelsInFront = (typeof tmpOptions.LabelsInFront === 'boolean') ? tmpOptions.LabelsInFront : true;
	}

	/**
	 * Generate the node type configuration object for the NodeTypes provider.
	 * This converts the card's properties into the format expected by
	 * PictProviderFlowNodeTypes.registerNodeType().
	 *
	 * @returns {Object} Node type configuration
	 */
	getNodeTypeConfiguration()
	{
		let tmpPorts = [];

		// Build input ports
		for (let i = 0; i < this.cardInputs.length; i++)
		{
			let tmpInput = this.cardInputs[i];
			let tmpPort =
				{
					Hash: null,
					Direction: 'input',
					Side: tmpInput.Side || 'left',
					Label: tmpInput.Name || `In ${i + 1}`,
					MinimumInputCount: (typeof tmpInput.MinimumInputCount === 'number') ? tmpInput.MinimumInputCount : 0,
					MaximumInputCount: (typeof tmpInput.MaximumInputCount === 'number') ? tmpInput.MaximumInputCount : -1
				};
			if (tmpInput.PortType)
			{
				tmpPort.PortType = tmpInput.PortType;
			}
			if (tmpInput.DataType)
			{
				tmpPort.DataType = tmpInput.DataType;
			}
			tmpPorts.push(tmpPort);
		}

		// Build output ports
		for (let i = 0; i < this.cardOutputs.length; i++)
		{
			let tmpOutput = this.cardOutputs[i];
			let tmpOutPort =
				{
					Hash: null,
					Direction: 'output',
					Side: tmpOutput.Side || 'right',
					Label: tmpOutput.Name || `Out ${i + 1}`
				};
			if (tmpOutput.PortType)
			{
				tmpOutPort.PortType = tmpOutput.PortType;
			}
			if (tmpOutput.DataType)
			{
				tmpOutPort.DataType = tmpOutput.DataType;
			}
			tmpPorts.push(tmpOutPort);
		}

		// If no ports were defined, provide sensible defaults
		if (tmpPorts.length === 0)
		{
			tmpPorts.push({ Hash: null, Direction: 'input', Side: 'left', Label: 'In' });
			tmpPorts.push({ Hash: null, Direction: 'output', Side: 'right', Label: 'Out' });
		}

		let tmpResult =
		{
			Hash: this.cardCode,
			Label: this.cardTitle,
			DefaultWidth: this.cardWidth,
			DefaultHeight: this.cardHeight,
			DefaultPorts: tmpPorts,
			TitleBarColor: this.cardTitleBarColor,
			BodyStyle: JSON.parse(JSON.stringify(this.cardBodyStyle)),
			// Extended FlowCard metadata stored alongside the type
			CardMetadata:
			{
				Name: this.cardName,
				Code: this.cardCode,
				Description: this.cardDescription,
				Icon: this.cardIcon,
				PreviewImage: this.cardPreviewImage,
				Documentation: this.cardDocumentation,
				Tooltip: this.cardTooltip,
				Enabled: this.cardEnabled,
				Category: this.cardCategory,
				Help: this.cardHelp
			}
		};

		// Include label display booleans
		tmpResult.ShowTypeLabel = this.cardShowTypeLabel;
		tmpResult.PortLabelsOnHover = this.cardPortLabelsOnHover;
		tmpResult.PortLabelsVertical = this.cardPortLabelsVertical;
		tmpResult.PortLabelPadding = this.cardPortLabelPadding;
		tmpResult.PortLabelsOutside = this.cardPortLabelsOutside;
		tmpResult.LabelsInFront = this.cardLabelsInFront;

		// Include properties panel config if defined
		if (this.cardPropertiesPanel)
		{
			tmpResult.PropertiesPanel = JSON.parse(JSON.stringify(this.cardPropertiesPanel));
		}

		// Include body content config if defined
		if (this.cardBodyContent)
		{
			tmpResult.BodyContent = JSON.parse(JSON.stringify(this.cardBodyContent));
			// RenderCallback cannot be serialized — preserve the original function reference
			if (typeof this.options.BodyContent.RenderCallback === 'function')
			{
				tmpResult.BodyContent.RenderCallback = this.options.BodyContent.RenderCallback;
			}
		}

		return tmpResult;
	}

	/**
	 * Register this card with a FlowView's node type provider.
	 *
	 * @param {Object} pFlowView - The PictViewFlow instance
	 * @returns {boolean} Whether registration succeeded
	 */
	registerWithFlowView(pFlowView)
	{
		if (!pFlowView || !pFlowView._NodeTypeProvider)
		{
			this.log.warn('PictFlowCard registerWithFlowView: no valid FlowView or NodeTypeProvider');
			return false;
		}

		let tmpConfig = this.getNodeTypeConfiguration();
		return pFlowView._NodeTypeProvider.registerNodeType(tmpConfig);
	}
}

module.exports = PictFlowCard;

module.exports.default_configuration =
{
	Title: 'Card',
	Name: false,
	Code: '',
	Description: false,
	Icon: false,
	PreviewImage: false,
	Documentation: false,
	Tooltip: false,
	Inputs: [],
	Outputs: [],
	Enabled: true,
	TitleBarColor: '#2c3e50',
	BodyStyle: {},
	Width: 180,
	Height: 80,
	Category: 'General',
	PropertiesPanel: null,
	BodyContent: null,
	ShowTypeLabel: true,
	PortLabelsOnHover: false,
	PortLabelsVertical: false,
	PortLabelPadding: false,
	PortLabelsOutside: false,
	LabelsInFront: true
};

},{"fable-serviceproviderbase":2}],30:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictFlowCardPropertiesPanel - Base class for flow card property panels.
 *
 * Developers create subclasses to define what UI appears when a user opens
 * the properties panel for a node on the flow graph. Four built-in panel
 * types are provided:
 *
 *   - Template  - Renders pict templates
 *   - Markdown  - Renders markdown via pict-section-content
 *   - Form      - Creates an ephemeral pict-section-form section
 *   - View      - Renders an existing registered pict-view
 *
 * Configurable properties:
 *   - PanelType      (string)  - Panel type identifier
 *   - Title          (string)  - Panel title bar text
 *   - Width          (number)  - Default panel width in pixels
 *   - Height         (number)  - Default panel height in pixels
 *   - Configuration  (object)  - Panel-type-specific configuration
 */
class PictFlowCardPropertiesPanel extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, PictFlowCardPropertiesPanel.default_configuration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel';

		// Panel metadata
		this.panelType = tmpOptions.PanelType || 'Base';
		this.panelTitle = tmpOptions.Title || 'Properties';
		this.panelWidth = (typeof tmpOptions.Width === 'number') ? tmpOptions.Width : 300;
		this.panelHeight = (typeof tmpOptions.Height === 'number') ? tmpOptions.Height : 200;

		// Reference to the flow view (set when panel is activated)
		this._FlowView = null;

		// The node data this panel is operating on (set when panel is opened)
		this._NodeData = null;

		// The DOM container element for panel content (set during render)
		this._ContentContainer = null;

		// The panel configuration (panel-type-specific)
		this._Configuration = tmpOptions.Configuration || {};
	}

	/**
	 * Render the panel's content into a DOM container element.
	 * Subclasses MUST override this.
	 *
	 * @param {HTMLElement} pContainer - The DOM element to render into
	 * @param {Object} pNodeData - The node data object (has .Data property)
	 */
	render(pContainer, pNodeData)
	{
		this._ContentContainer = pContainer;
		this._NodeData = pNodeData;
	}

	/**
	 * Marshal data FROM the node's Data object INTO the panel UI.
	 * Called when the panel opens or when data changes externally.
	 *
	 * @param {Object} pNodeData
	 */
	marshalToPanel(pNodeData)
	{
		this._NodeData = pNodeData;
	}

	/**
	 * Marshal data FROM the panel UI INTO the node's Data object.
	 * Called before saving or when the panel is about to close.
	 *
	 * @param {Object} pNodeData
	 */
	marshalFromPanel(pNodeData)
	{
		// Subclasses override
	}

	/**
	 * Called when the panel is being destroyed (closed).
	 * Subclasses should clean up resources.
	 */
	destroy()
	{
		this._ContentContainer = null;
		this._NodeData = null;
	}
}

module.exports = PictFlowCardPropertiesPanel;

module.exports.default_configuration =
{
	PanelType: 'Base',
	Title: 'Properties',
	Width: 300,
	Height: 200,
	Configuration: {}
};

},{"fable-serviceproviderbase":2}],31:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-Form
 *
 * Creates an ephemeral pict-section-form section to edit the node's Data object.
 * Uses PictViewFormMetacontroller.injectManifest() to dynamically create form
 * sections at runtime.
 *
 * Note: pict-section-form must be available in the consuming application
 * (it is an optional/peer dependency, not bundled with pict-section-flow).
 *
 * Configuration:
 *   {
 *     PanelType: 'Form',
 *     Configuration: {
 *       Manifest: {
 *         Sections: [...],
 *         Descriptors: {...}
 *       }
 *     }
 *   }
 */
class FlowCardPropertiesPanelForm extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-Form';

		this._Metacontroller = null;
		this._InjectedSectionHash = null;
	}

	/**
	 * Render the form into the panel body.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		if (!this._Configuration || !this._Configuration.Manifest)
		{
			pContainer.innerHTML = '<em>No form manifest configured</em>';
			return;
		}

		// Create a unique container ID for the form section
		let tmpContainerID = `pict-flow-panel-form-${pNodeData.Hash}`;
		pContainer.innerHTML = `<div id="${tmpContainerID}"></div>`;

		// Bind the node data to AppData.Record so the form descriptors
		// (which use addresses like Record.Data.SearchString) resolve against
		// the actual node object.
		this.fable.AppData.Record = pNodeData;

		try
		{
			// Look for an existing metacontroller or create one
			if (!this._Metacontroller)
			{
				// Try to find PictFormMetacontroller service type (check both common names)
				let tmpServiceType = null;
				if (this.fable.servicesMap.hasOwnProperty('PictFormMetacontroller'))
				{
					tmpServiceType = 'PictFormMetacontroller';
				}
				else if (this.fable.servicesMap.hasOwnProperty('PictViewFormMetacontroller'))
				{
					tmpServiceType = 'PictViewFormMetacontroller';
				}

				if (tmpServiceType)
				{
					this._Metacontroller = this.fable.instantiateServiceProviderWithoutRegistration(tmpServiceType,
						{
							ViewIdentifier: `FlowPanelForm-${pNodeData.Hash}`,
							DefaultDestinationAddress: `#${tmpContainerID}`,
							AutoRender: false,
							AutoPopulateAfterRender: true,
							AutoSolveBeforeRender: false
						});
				}
			}

			if (this._Metacontroller && typeof this._Metacontroller.injectManifestAndRender === 'function')
			{
				// Create the FormContainer div that the metacontroller's
				// updateMetatemplateInDOM() expects when adding section wrappers.
				// Normally this is created when the metacontroller renders its own
				// metatemplate, but we skip that step since we only need the
				// injected section views, not the metacontroller's own renderable.
				let tmpFormContainerID = `Pict-${this._Metacontroller.UUID}-FormContainer`;
				let tmpContainerEl = pContainer.querySelector(`#${tmpContainerID}`);
				if (tmpContainerEl)
				{
					tmpContainerEl.innerHTML = `<div id="${tmpFormContainerID}" class="pict-form"></div>`;
				}

				// Deep clone the manifest so each panel gets its own copy
				let tmpManifest = JSON.parse(JSON.stringify(this._Configuration.Manifest));
				this._InjectedSectionHash = tmpManifest.Hash || null;

				// Use injectManifestAndRender which properly creates section views,
				// updates the metatemplate in the DOM, and renders each section view
				this._Metacontroller.injectManifestAndRender(tmpManifest);
			}
			else if (this._Metacontroller && typeof this._Metacontroller.injectManifest === 'function')
			{
				// Fallback for older pict-section-form versions: inject the
				// manifest and render each section view individually
				let tmpManifest = JSON.parse(JSON.stringify(this._Configuration.Manifest));
				let tmpViewsToRender = this._Metacontroller.injectManifest(tmpManifest);
				this._InjectedSectionHash = tmpManifest.Hash || null;

				// Create container divs for each section view and render them
				let tmpContainerEl = pContainer.querySelector(`#${tmpContainerID}`);
				if (tmpContainerEl && tmpViewsToRender.length > 0)
				{
					let tmpInnerHTML = '';
					for (let i = 0; i < tmpViewsToRender.length; i++)
					{
						let tmpDestID = tmpViewsToRender[i].options.DefaultDestinationAddress;
						if (tmpDestID && tmpDestID.charAt(0) === '#')
						{
							tmpDestID = tmpDestID.substring(1);
						}
						tmpInnerHTML += `<div id="${tmpDestID}" class="pict-form-view"></div>`;
					}
					tmpContainerEl.innerHTML = tmpInnerHTML;

					for (let i = 0; i < tmpViewsToRender.length; i++)
					{
						tmpViewsToRender[i].render();
					}
				}
			}
			else
			{
				pContainer.innerHTML = '<em>pict-section-form is not available. Install it in your application to use Form panels.</em>';
			}
		}
		catch (pError)
		{
			this.log.warn(`FlowCardPropertiesPanel-Form render error: ${pError.message}`);
			pContainer.innerHTML = `<em>Form render error: ${pError.message}</em>`;
		}
	}

	marshalFromPanel(pNodeData)
	{
		if (this._Metacontroller && typeof this._Metacontroller.marshalFromView === 'function')
		{
			this._Metacontroller.marshalFromView();
		}
	}

	destroy()
	{
		this._Metacontroller = null;
		this._InjectedSectionHash = null;
		super.destroy();
	}
}

module.exports = FlowCardPropertiesPanelForm;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'Form',
		Configuration:
		{
			Manifest: null
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":30}],32:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-Markdown
 *
 * Renders markdown content into the panel body using pict-section-content's
 * PictContentProvider service.  When pict-section-content is installed and its
 * PictContentProvider service type has been registered with the pict instance,
 * full markdown rendering is available (headings, lists, tables, code blocks
 * with syntax highlighting, KaTeX equations, Mermaid diagrams, etc.).
 *
 * If PictContentProvider is not available, the panel falls back to displaying
 * the raw markdown as pre-formatted text.
 *
 * Configuration:
 *   {
 *     PanelType: 'Markdown',
 *     Configuration: {
 *       Markdown: '# Title\nSome **markdown** content'
 *     }
 *   }
 *
 * Or use an address to pull markdown from the node's data:
 *   {
 *     PanelType: 'Markdown',
 *     Configuration: {
 *       MarkdownAddress: 'Data.MarkdownContent'
 *     }
 *   }
 */
class FlowCardPropertiesPanelMarkdown extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-Markdown';

		this._ContentProvider = null;
	}

	/**
	 * Render markdown into the panel.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		this._renderMarkdown();
	}

	marshalToPanel(pNodeData)
	{
		super.marshalToPanel(pNodeData);
		this._renderMarkdown();
	}

	_renderMarkdown()
	{
		if (!this._ContentContainer || !this._Configuration) return;

		let tmpMarkdown = '';

		if (this._Configuration.MarkdownAddress && this._NodeData)
		{
			// Resolve markdown from node data using manyfest
			tmpMarkdown = this.fable.manifest.getValueByHash(this._NodeData, this._Configuration.MarkdownAddress) || '';
		}
		else if (this._Configuration.Markdown)
		{
			tmpMarkdown = this._Configuration.Markdown;
		}

		if (!tmpMarkdown)
		{
			this._ContentContainer.innerHTML = '<em>No content</em>';
			return;
		}

		// Use pict-section-content's PictContentProvider for markdown rendering.
		// The consuming application must register the PictContentProvider service
		// type (from pict-section-content) for this to work.
		try
		{
			if (!this._ContentProvider)
			{
				if (this.fable.servicesMap.hasOwnProperty('PictContentProvider'))
				{
					this._ContentProvider = this.fable.instantiateServiceProviderWithoutRegistration('PictContentProvider', {});
				}
			}

			if (this._ContentProvider && typeof this._ContentProvider.parseMarkdown === 'function')
			{
				let tmpHTML = this._ContentProvider.parseMarkdown(tmpMarkdown);
				this._ContentContainer.innerHTML = tmpHTML;

				// Post-render hooks for equations and diagrams
				if (typeof this._ContentProvider.renderKaTeXEquations === 'function')
				{
					this._ContentProvider.renderKaTeXEquations(this._ContentContainer);
				}
				if (typeof this._ContentProvider.renderMermaidDiagrams === 'function')
				{
					this._ContentProvider.renderMermaidDiagrams(this._ContentContainer);
				}
			}
			else
			{
				// PictContentProvider not registered — render as pre-formatted text
				this._ContentContainer.innerHTML = `<pre style="white-space: pre-wrap; font-family: inherit;">${this._escapeHTML(tmpMarkdown)}</pre>`;
			}
		}
		catch (pError)
		{
			this.log.warn(`FlowCardPropertiesPanel-Markdown render error: ${pError.message}`);
			this._ContentContainer.innerHTML = `<pre style="white-space: pre-wrap; font-family: inherit;">${this._escapeHTML(tmpMarkdown)}</pre>`;
		}
	}

	_escapeHTML(pText)
	{
		let tmpDiv = document.createElement('div');
		tmpDiv.textContent = pText;
		return tmpDiv.innerHTML;
	}

	destroy()
	{
		this._ContentProvider = null;
		super.destroy();
	}
}

module.exports = FlowCardPropertiesPanelMarkdown;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'Markdown',
		Configuration:
		{
			Markdown: '',
			MarkdownAddress: ''
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":30}],33:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-Template
 *
 * Renders pict templates into the panel body.
 *
 * Configuration:
 *   {
 *     PanelType: 'Template',
 *     Configuration: {
 *       Templates: [
 *         { Hash: 'my-template', Template: '<div>{~D:Record.Data.SomeValue~}</div>' }
 *       ],
 *       TemplateHash: 'my-template'
 *     }
 *   }
 */
class FlowCardPropertiesPanelTemplate extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-Template';

		this._TemplatesRegistered = false;
	}

	/**
	 * Register templates with the pict template provider and render.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		if (!this._Configuration || !this._Configuration.Templates) return;

		// Register templates with pict (only once)
		if (!this._TemplatesRegistered)
		{
			let tmpTemplates = this._Configuration.Templates;
			for (let i = 0; i < tmpTemplates.length; i++)
			{
				if (tmpTemplates[i].Hash && tmpTemplates[i].Template)
				{
					this.fable.TemplateProvider.addTemplate(tmpTemplates[i].Hash, tmpTemplates[i].Template);
				}
			}
			this._TemplatesRegistered = true;
		}

		this._renderTemplate();
	}

	marshalToPanel(pNodeData)
	{
		super.marshalToPanel(pNodeData);
		this._renderTemplate();
	}

	_renderTemplate()
	{
		if (!this._ContentContainer || !this._NodeData) return;

		let tmpTemplateHash = this._Configuration.TemplateHash;
		if (!tmpTemplateHash) return;

		let tmpRecord = this._NodeData;
		let tmpHTML = this.fable.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, [tmpRecord]);
		this._ContentContainer.innerHTML = tmpHTML;
	}
}

module.exports = FlowCardPropertiesPanelTemplate;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'Template',
		Configuration:
		{
			Templates: [],
			TemplateHash: ''
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":30}],34:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');

/**
 * FlowCardPropertiesPanel-View
 *
 * Renders an existing registered pict-view into the panel body.
 * The view's destination is temporarily overridden to render inside
 * the panel container.
 *
 * Configuration:
 *   {
 *     PanelType: 'View',
 *     Configuration: {
 *       ViewHash: 'MyCustomViewIdentifier'
 *     }
 *   }
 */
class FlowCardPropertiesPanelView extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-View';

		this._OriginalDestination = null;
		this._ViewInstance = null;
	}

	/**
	 * Render the referenced pict-view into the panel body.
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		if (!this._Configuration || !this._Configuration.ViewHash)
		{
			pContainer.innerHTML = '<em>No ViewHash configured</em>';
			return;
		}

		let tmpViewHash = this._Configuration.ViewHash;

		// Create a unique container ID
		let tmpContainerID = `pict-flow-panel-view-${pNodeData.Hash}`;
		pContainer.innerHTML = `<div id="${tmpContainerID}"></div>`;

		try
		{
			// Look up the view in the pict instance
			let tmpPict = this.pict || this.fable;
			if (tmpPict.views && tmpPict.views[tmpViewHash])
			{
				this._ViewInstance = tmpPict.views[tmpViewHash];

				// Save original destination
				this._OriginalDestination = this._ViewInstance.options.DefaultDestinationAddress;

				// Override destination to our panel container
				this._ViewInstance.options.DefaultDestinationAddress = `#${tmpContainerID}`;

				if (typeof this._ViewInstance.render === 'function')
				{
					this._ViewInstance.render();
				}
			}
			else
			{
				pContainer.innerHTML = `<em>View "${tmpViewHash}" not found</em>`;
			}
		}
		catch (pError)
		{
			this.log.warn(`FlowCardPropertiesPanel-View render error: ${pError.message}`);
			pContainer.innerHTML = `<em>View render error: ${pError.message}</em>`;
		}
	}

	marshalFromPanel(pNodeData)
	{
		if (this._ViewInstance && typeof this._ViewInstance.marshalFromView === 'function')
		{
			this._ViewInstance.marshalFromView();
		}
	}

	destroy()
	{
		// Restore original destination
		if (this._ViewInstance && this._OriginalDestination)
		{
			this._ViewInstance.options.DefaultDestinationAddress = this._OriginalDestination;
		}

		this._ViewInstance = null;
		this._OriginalDestination = null;
		super.destroy();
	}
}

module.exports = FlowCardPropertiesPanelView;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'View',
		Configuration:
		{
			ViewHash: ''
		}
	}
);

},{"../PictFlowCardPropertiesPanel.js":30}],35:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-CSS
 *
 * Centralized CSS provider for the flow diagram.
 * All flow-related CSS is organized into domain-specific getter methods,
 * providing a single source of truth and enabling future theming.
 */

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowCSS'
};

class PictProviderFlowCSS extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowCSS';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ── Container ──────────────────────────────────────────────────────────
	/**
	 * CSS for the flow container, SVG container, panning/connecting cursors, and grid pattern.
	 * @returns {string}
	 */
	getContainerCSS()
	{
		return /*css*/`
		.pict-flow-container {
			/* ── Design Tokens ─────────────────────────────────────
			   Override these custom properties to theme the flow diagram.
			   Node-type classes (.pict-flow-node-{type}) can scope-override
			   any variable for per-type variation. */

			/* Text */
			--pf-text-primary: #2c3e50;
			--pf-text-heading: #1a252f;
			--pf-text-secondary: #7f8c8d;
			--pf-text-tertiary: #8e99a4;
			--pf-text-placeholder: #95a5a6;

			/* Node */
			--pf-node-body-fill: #ffffff;
			--pf-node-body-stroke: #d0d4d8;
			--pf-node-body-stroke-hover: #b0b8c0;
			--pf-node-body-stroke-width: 1;
			--pf-node-body-radius: 8px;
			--pf-node-shadow: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.10));
			--pf-node-shadow-hover: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.15));
			--pf-node-shadow-selected: drop-shadow(0 2px 8px rgba(52, 152, 219, 0.25));
			--pf-node-shadow-dragging: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.20));
			--pf-node-title-fill: #ffffff;
			--pf-node-title-size: 11.5px;
			--pf-node-title-weight: 600;
			--pf-node-title-bar-color: #2c3e50;
			--pf-node-type-label-fill: #a0a8b0;
			--pf-node-selected-stroke: #3498db;

			/* Node Variants */
			--pf-node-start-fill: #eafaf1;
			--pf-node-start-stroke: #27ae60;
			--pf-node-end-fill: #e8f8f5;
			--pf-node-end-stroke: #1abc9c;
			--pf-node-halt-fill: #fdedec;
			--pf-node-halt-stroke: #e74c3c;
			--pf-node-decision-fill: #fff9e6;
			--pf-node-decision-stroke: #f39c12;

			/* Ports */
			--pf-port-input-fill: #3498db;
			--pf-port-output-fill: #2ecc71;
			--pf-port-stroke: #ffffff;
			--pf-port-stroke-width: 2;
			--pf-port-label-bg: rgba(255, 253, 240, 0.5);
			--pf-port-label-text: #2c3e50;

			/* Port Type Colors */
			--pf-port-event-in-fill: #3498db;
			--pf-port-event-out-fill: #2ecc71;
			--pf-port-setting-fill: #e67e22;
			--pf-port-value-fill: #f1c40f;
			--pf-port-error-fill: #e74c3c;

			/* Connection Type Colors (match source port) */
			--pf-connection-event-in-stroke: #3498db;
			--pf-connection-event-out-stroke: #2ecc71;
			--pf-connection-setting-stroke: #e67e22;
			--pf-connection-value-stroke: #f1c40f;
			--pf-connection-error-stroke: #e74c3c;

			/* Connections */
			--pf-connection-stroke: #95a5a6;
			--pf-connection-stroke-hover: #7f8c8d;
			--pf-connection-selected-stroke: #3498db;

			/* Panels */
			--pf-panel-bg: #ffffff;
			--pf-panel-border: #d0d4d8;
			--pf-panel-radius: 8px;
			--pf-panel-shadow: 0 4px 12px rgba(0,0,0,0.10), 0 1px 3px rgba(0,0,0,0.06);
			--pf-panel-titlebar-bg: #f7f8fa;
			--pf-panel-titlebar-border: #e8eaed;
			--pf-panel-title-color: #2c3e50;

			/* Tabs */
			--pf-tab-text: #8e99a4;
			--pf-tab-text-hover: #5a6a7a;
			--pf-tab-active-border: var(--pf-node-selected-stroke);
			--pf-resize-handle-hover: #e0e3e6;

			/* Forms & Inputs */
			--pf-input-border: #d5d8dc;
			--pf-input-border-focus: #3498db;
			--pf-divider-light: #ecf0f1;
			--pf-divider-medium: #e8eaed;

			/* Buttons */
			--pf-button-border: #bdc3c7;
			--pf-button-hover-border: #95a5a6;
			--pf-button-hover-bg: #ecf0f1;
			--pf-button-active-bg: #d5dbdb;
			--pf-button-danger-text: #e74c3c;
			--pf-button-danger-hover-bg: #fdedec;
			--pf-button-close-color: #b0b8c0;

			/* Badges */
			--pf-badge-category-bg: #f0f2f4;
			--pf-badge-category-text: #6b7b8d;
			--pf-badge-code-bg: #eaf2f8;
			--pf-badge-code-text: #2980b9;

			/* Info Panel */
			--pf-port-item-bg: #f8f9fa;

			/* Toolbar */
			--pf-toolbar-bg: #ffffff;
			--pf-toolbar-border: #e0e0e0;

			/* Palette Cards */
			--pf-card-border: #d5d8dc;
			--pf-card-hover-bg: #eaf2f8;
			--pf-card-hover-shadow: 0 1px 3px rgba(52, 152, 219, 0.15);

			/* Canvas */
			--pf-canvas-bg: #fafafa;
			--pf-grid-stroke: #e8e8e8;

			position: relative;
			width: 100%;
			height: 100%;
			min-height: 400px;
			overflow: hidden;
			background-color: var(--pf-canvas-bg);
			border: 1px solid var(--pf-toolbar-border);
			border-radius: 4px;
			display: flex;
			flex-direction: column;
		}
		.pict-flow-svg-container {
			flex: 1;
			min-height: 0;
			position: relative;
		}
		.pict-flow-svg {
			width: 100%;
			height: 100%;
			cursor: grab;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-svg.panning {
			cursor: grabbing;
		}
		.pict-flow-svg.connecting {
			cursor: crosshair;
		}
		.pict-flow-grid-pattern line {
			stroke: var(--pf-grid-stroke);
			stroke-width: 0.5;
		}
		`;
	}

	// ── Nodes ──────────────────────────────────────────────────────────────
	/**
	 * CSS for base node styling: body, hover/selected/dragging states, title bar, title text, type label.
	 * @returns {string}
	 */
	getNodeCSS()
	{
		return /*css*/`
		.pict-flow-node {
			cursor: pointer;
			filter: var(--pf-node-shadow);
			transition: filter 0.2s;
		}
		.pict-flow-node:hover {
			filter: var(--pf-node-shadow-hover);
		}
		.pict-flow-node:hover .pict-flow-node-body {
			stroke: var(--pf-node-body-stroke-hover);
			stroke-width: 1.5;
		}
		.pict-flow-node.selected {
			filter: var(--pf-node-shadow-selected);
		}
		.pict-flow-node.selected .pict-flow-node-body {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-node.dragging {
			opacity: 0.9;
			cursor: grabbing;
			filter: var(--pf-node-shadow-dragging);
		}
		.pict-flow-node-body {
			fill: var(--pf-node-body-fill);
			stroke: var(--pf-node-body-stroke);
			stroke-width: var(--pf-node-body-stroke-width);
			rx: var(--pf-node-body-radius);
			ry: var(--pf-node-body-radius);
			transition: stroke 0.2s, stroke-width 0.2s;
		}
		.pict-flow-node-title-bar {
			fill: var(--pf-node-title-bar-color);
			rx: var(--pf-node-body-radius);
			ry: var(--pf-node-body-radius);
		}
		.pict-flow-node-title-bar-bottom {
			fill: var(--pf-node-title-bar-color);
		}
		.pict-flow-node-title {
			fill: var(--pf-node-title-fill);
			font-size: var(--pf-node-title-size);
			font-weight: var(--pf-node-title-weight);
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			letter-spacing: 0.2px;
			pointer-events: none;
		}
		.pict-flow-node-type-label {
			fill: var(--pf-node-type-label-fill);
			font-size: 9.5px;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			text-transform: uppercase;
			letter-spacing: 0.3px;
			pointer-events: none;
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node:hover .pict-flow-node-type-label {
			opacity: 1;
		}
		.pict-flow-node-card-code {
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node:hover .pict-flow-node-card-code {
			opacity: 1;
		}
		/* Title-bar icon: invert SVG paths to white for dark title bars */
		.pict-flow-node-title-icon {
			filter: brightness(0) invert(1);
		}
		`;
	}

	// ── Body Content ──────────────────────────────────────────────────────
	/**
	 * CSS for custom body content in nodes: SVG group, foreignObject, HTML container, canvas.
	 * @returns {string}
	 */
	getBodyContentCSS()
	{
		return /*css*/`
		.pict-flow-node-body-content {
			pointer-events: none;
		}
		.pict-flow-node-body-content-fo {
			overflow: hidden;
		}
		.pict-flow-node-body-content-html {
			overflow: hidden;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 11px;
			color: var(--pf-text-primary);
			pointer-events: auto;
		}
		.pict-flow-node-body-content-canvas {
			display: block;
			pointer-events: auto;
		}
		`;
	}

	// ── Node Variants ──────────────────────────────────────────────────────
	/**
	 * CSS overrides for specific node types: start, end, halt, decision.
	 * @returns {string}
	 */
	getNodeVariantCSS()
	{
		return /*css*/`
		.pict-flow-node-decision .pict-flow-node-body {
			fill: var(--pf-node-decision-fill);
			stroke: var(--pf-node-decision-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-start .pict-flow-node-body {
			fill: var(--pf-node-start-fill);
			stroke: var(--pf-node-start-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-end .pict-flow-node-body {
			fill: var(--pf-node-end-fill);
			stroke: var(--pf-node-end-stroke);
			stroke-width: 1.5;
		}
		.pict-flow-node-halt .pict-flow-node-body {
			fill: var(--pf-node-halt-fill);
			stroke: var(--pf-node-halt-stroke);
			stroke-width: 1.5;
		}
		`;
	}

	// ── Ports ──────────────────────────────────────────────────────────────
	/**
	 * CSS for port circles: input/output coloring, hover states, labels.
	 * @returns {string}
	 */
	getPortCSS()
	{
		return /*css*/`
		.pict-flow-port {
			cursor: crosshair;
			transition: r 0.15s, filter 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.12));
		}
		.pict-flow-port.input {
			fill: var(--pf-port-input-fill);
			stroke: var(--pf-port-stroke);
			stroke-width: var(--pf-port-stroke-width);
		}
		.pict-flow-port.output {
			fill: var(--pf-port-output-fill);
			stroke: var(--pf-port-stroke);
			stroke-width: var(--pf-port-stroke-width);
		}
		.pict-flow-port:hover {
			r: 7;
			filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.20));
		}
		/* Port type color overrides */
		.pict-flow-port.port-type-event-in {
			fill: var(--pf-port-event-in-fill);
		}
		.pict-flow-port.port-type-event-out {
			fill: var(--pf-port-event-out-fill);
		}
		.pict-flow-port.port-type-setting {
			fill: var(--pf-port-setting-fill);
		}
		.pict-flow-port.port-type-value {
			fill: var(--pf-port-value-fill);
		}
		.pict-flow-port.port-type-error {
			fill: var(--pf-port-error-fill);
		}
		.pict-flow-port-label {
			font-size: 8px;
			font-weight: 600;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			pointer-events: none;
		}
		/* Port label badge background */
		.pict-flow-port-label-bg {
			pointer-events: none;
		}
		/* Port labels on hover: hidden by default, revealed on node hover */
		.pict-flow-node-port-labels-hover .pict-flow-port-label,
		.pict-flow-node-port-labels-hover .pict-flow-port-label-bg {
			opacity: 0;
			transition: opacity 0.2s;
		}
		.pict-flow-node-port-labels-hover:hover .pict-flow-port-label,
		.pict-flow-node-port-labels-hover:hover .pict-flow-port-label-bg {
			opacity: 1;
		}
		`;
	}

	// ── Connections ────────────────────────────────────────────────────────
	/**
	 * CSS for connection paths: base, hover/selected states, hitarea, drag-connection.
	 * @returns {string}
	 */
	getConnectionCSS()
	{
		return /*css*/`
		.pict-flow-connection {
			fill: none;
			stroke: var(--pf-connection-stroke);
			stroke-width: 2;
			cursor: pointer;
			transition: stroke 0.15s;
		}
		.pict-flow-connection:hover {
			stroke: var(--pf-connection-stroke-hover);
			stroke-width: 3;
		}
		.pict-flow-connection.selected {
			stroke: var(--pf-connection-selected-stroke);
			stroke-width: 3;
		}
		/* Connection type color overrides (based on source port type) */
		.pict-flow-connection.conn-type-event-in {
			stroke: var(--pf-connection-event-in-stroke);
		}
		.pict-flow-connection.conn-type-event-out {
			stroke: var(--pf-connection-event-out-stroke);
		}
		.pict-flow-connection.conn-type-setting {
			stroke: var(--pf-connection-setting-stroke);
		}
		.pict-flow-connection.conn-type-value {
			stroke: var(--pf-connection-value-stroke);
		}
		.pict-flow-connection.conn-type-error {
			stroke: var(--pf-connection-error-stroke);
		}
		.pict-flow-connection-hitarea {
			fill: none;
			stroke: transparent;
			stroke-width: 12;
			cursor: pointer;
		}
		.pict-flow-drag-connection {
			fill: none;
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			stroke-dasharray: 6 3;
			pointer-events: none;
		}
		`;
	}

	// ── Connection Handles ─────────────────────────────────────────────────
	/**
	 * CSS for connection waypoint handles and midpoint handles.
	 * @returns {string}
	 */
	getHandleCSS()
	{
		return /*css*/`
		.pict-flow-connection-handle {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-connection-handle:hover {
			r: 8;
			stroke-width: 2.5;
		}
		.pict-flow-connection-handle-midpoint {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-port-setting-fill);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-connection-handle-midpoint:hover {
			r: 8;
			stroke-width: 2.5;
		}
		`;
	}

	// ── Tethers ────────────────────────────────────────────────────────────
	/**
	 * CSS for tether lines, hitareas, handles, and midpoint handles.
	 * @returns {string}
	 */
	getTetherCSS()
	{
		return /*css*/`
		.pict-flow-tether-line {
			fill: none;
			stroke: var(--pf-connection-stroke);
			stroke-width: 1.5;
			stroke-dasharray: 6 4;
			pointer-events: visibleStroke;
			cursor: pointer;
		}
		.pict-flow-tether-line.selected {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-tether-hitarea {
			fill: none;
			stroke: transparent;
			stroke-width: 10;
			cursor: pointer;
		}
		.pict-flow-tether-handle {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-tether-handle:hover {
			r: 8;
			stroke-width: 2.5;
		}
		.pict-flow-tether-handle-midpoint {
			fill: var(--pf-panel-bg);
			stroke: var(--pf-port-setting-fill);
			stroke-width: 2;
			cursor: grab;
			transition: r 0.15s;
			filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
		}
		.pict-flow-tether-handle-midpoint:hover {
			r: 8;
			stroke-width: 2.5;
		}
		`;
	}

	// ── Panels ─────────────────────────────────────────────────────────────
	/**
	 * CSS for property panels: foreign object, panel container, titlebar, close button, body, indicator.
	 * @returns {string}
	 */
	getPanelCSS()
	{
		return /*css*/`
		.pict-flow-node-panel-indicator {
			fill: var(--pf-node-selected-stroke);
			stroke: none;
			opacity: 0.6;
			cursor: pointer;
			transition: opacity 0.15s;
		}
		.pict-flow-node-panel-indicator:hover {
			opacity: 1.0;
		}
		.pict-flow-panel-foreign-object {
			overflow: visible;
		}
		.pict-flow-panel {
			background: var(--pf-panel-bg);
			border: 1px solid var(--pf-panel-border);
			border-radius: var(--pf-panel-radius);
			box-shadow: var(--pf-panel-shadow);
			display: flex;
			flex-direction: column;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 13px;
			overflow: hidden;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
		}
		.pict-flow-panel-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 8px 12px;
			background: var(--pf-panel-titlebar-bg);
			border-bottom: 1px solid var(--pf-panel-titlebar-border);
			cursor: grab;
			user-select: none;
			-webkit-user-select: none;
			flex-shrink: 0;
		}
		.pict-flow-panel-titlebar.dragging {
			cursor: grabbing;
		}
		.pict-flow-panel-title-text {
			font-weight: 600;
			font-size: 12px;
			color: var(--pf-panel-title-color);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			letter-spacing: 0.1px;
		}
		.pict-flow-panel-close-btn {
			cursor: pointer;
			color: var(--pf-button-close-color);
			font-size: 14px;
			line-height: 1;
			padding: 4px;
			border: none;
			background: none;
			border-radius: 4px;
			transition: background-color 0.15s, color 0.15s;
		}
		.pict-flow-panel-close-btn:hover {
			color: var(--pf-button-danger-text);
			background-color: rgba(231, 76, 60, 0.08);
		}
		.pict-flow-panel-content {
			flex: 1;
			overflow-y: auto;
			min-height: 0;
			padding: 0;
		}
		.pict-flow-panel-tab-pane {
			padding: 10px 12px;
			box-sizing: border-box;
		}
		`;
	}

	// ── Info Panels ────────────────────────────────────────────────────────
	/**
	 * CSS for the info/hover panel and all sub-elements: header, description, badges, sections, ports.
	 * @returns {string}
	 */
	getInfoPanelCSS()
	{
		return /*css*/`
		.pict-flow-info-panel {
			padding: 2px 0;
			font-size: 12px;
			line-height: 1.5;
			color: var(--pf-text-primary);
		}
		.pict-flow-info-panel-header {
			font-size: 13px;
			font-weight: 600;
			margin-bottom: 6px;
			color: var(--pf-text-heading);
		}
		.pict-flow-info-panel-header.with-icon {
			font-size: 14px;
			display: flex;
			align-items: center;
			gap: 6px;
		}
		.pict-flow-info-panel-description {
			font-size: 11px;
			color: var(--pf-text-secondary);
			margin-bottom: 10px;
			line-height: 1.45;
		}
		.pict-flow-info-panel-badges {
			margin-bottom: 10px;
			display: flex;
			flex-wrap: wrap;
			gap: 4px;
		}
		.pict-flow-info-panel-badge {
			display: inline-block;
			padding: 2px 8px;
			border-radius: 4px;
			font-size: 10px;
		}
		.pict-flow-info-panel-badge.category {
			background: var(--pf-badge-category-bg);
			color: var(--pf-badge-category-text);
		}
		.pict-flow-info-panel-badge.code {
			background: var(--pf-badge-code-bg);
			color: var(--pf-badge-code-text);
			font-family: "SF Mono", "Fira Code", monospace;
		}
		.pict-flow-info-panel-section {
			margin-bottom: 8px;
		}
		.pict-flow-info-panel-section-title {
			font-size: 10px;
			font-weight: 600;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			color: var(--pf-text-tertiary);
			margin-bottom: 4px;
			padding-bottom: 2px;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-info-panel-port {
			padding: 3px 8px;
			background: var(--pf-port-item-bg);
			margin-bottom: 3px;
			font-size: 11px;
			border-radius: 3px;
		}
		.pict-flow-info-panel-port.input {
			border-left: 3px solid var(--pf-port-input-fill);
		}
		.pict-flow-info-panel-port.output {
			border-left: 3px solid var(--pf-port-output-fill);
		}
		/* Info panel port type color overrides */
		.pict-flow-info-panel-port.port-type-event-in {
			border-left-color: var(--pf-port-event-in-fill);
		}
		.pict-flow-info-panel-port.port-type-event-out {
			border-left-color: var(--pf-port-event-out-fill);
		}
		.pict-flow-info-panel-port.port-type-setting {
			border-left-color: var(--pf-port-setting-fill);
		}
		.pict-flow-info-panel-port.port-type-value {
			border-left-color: var(--pf-port-value-fill);
		}
		.pict-flow-info-panel-port.port-type-error {
			border-left-color: var(--pf-port-error-fill);
		}
		.pict-flow-info-panel-port-constraint {
			color: var(--pf-text-tertiary);
			font-size: 10px;
		}
		/* Port summary section appended below form panels */
		.pict-flow-port-summary {
			margin-top: 12px;
			padding-top: 8px;
			border-top: 1px solid var(--pf-divider-medium);
		}
		.pict-flow-info-panel-port.event {
			border-left: 3px solid var(--pf-port-event-in-fill);
		}
		.pict-flow-info-panel-port.value {
			border-left: 3px solid var(--pf-port-value-fill);
		}
		`;
	}

	// ── Node Properties Editor ────────────────────────────────────────────
	/**
	 * CSS for the node properties editor fields used in the Appearance tab.
	 * @returns {string}
	 */
	getNodePropsEditorCSS()
	{
		return /*css*/`
		.pict-flow-node-props-fields {
			display: flex;
			flex-direction: column;
			gap: 6px;
		}
		.pict-flow-node-props-field {
			display: flex;
			align-items: center;
			gap: 8px;
		}
		.pict-flow-node-props-label {
			font-size: 11px;
			color: var(--pf-text-secondary);
			min-width: 72px;
			flex-shrink: 0;
		}
		.pict-flow-node-props-input {
			flex: 1;
			padding: 3px 6px;
			border: 1px solid var(--pf-input-border);
			border-radius: 3px;
			font-size: 11px;
			outline: none;
			box-sizing: border-box;
			min-width: 0;
		}
		.pict-flow-node-props-input:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-node-props-color {
			width: 28px;
			height: 24px;
			padding: 1px;
			cursor: pointer;
			flex: 0 0 28px;
		}
		`;
	}

	// ── Panel Tabs & Resize ───────────────────────────────────────────────
	/**
	 * CSS for the tab bar, tab panes, resize handle, and help content.
	 * @returns {string}
	 */
	getPanelTabsCSS()
	{
		return /*css*/`
		.pict-flow-panel-resize-handle {
			height: 6px;
			cursor: ns-resize;
			background: transparent;
			flex-shrink: 0;
			transition: background-color 0.15s;
			border-top: 1px solid var(--pf-panel-titlebar-border);
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.pict-flow-panel-resize-handle::after {
			content: '';
			width: 24px;
			height: 2px;
			border-radius: 1px;
			background: var(--pf-resize-handle-hover);
			transition: background-color 0.15s, width 0.15s;
		}
		.pict-flow-panel-resize-handle:hover::after {
			background: var(--pf-button-hover-border);
			width: 32px;
		}
		.pict-flow-panel-tabbar {
			display: flex;
			flex-shrink: 0;
			border-top: 1px solid var(--pf-panel-titlebar-border);
			background: var(--pf-panel-titlebar-bg);
		}
		.pict-flow-panel-tab {
			flex: 1;
			padding: 5px 8px;
			font-size: 11px;
			text-align: center;
			cursor: pointer;
			color: var(--pf-tab-text);
			border-top: 2px solid transparent;
			transition: color 0.15s, border-top-color 0.15s;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-panel-tab:hover {
			color: var(--pf-tab-text-hover);
		}
		.pict-flow-panel-tab.active {
			border-top-color: var(--pf-node-selected-stroke);
			color: var(--pf-panel-title-color);
			font-weight: 600;
		}
		.pict-flow-panel-help-content {
			font-size: 12px;
			line-height: 1.5;
			color: var(--pf-text-primary);
		}
		.pict-flow-panel-help-content p {
			margin: 0 0 8px 0;
		}
		`;
	}

	// ── Fullscreen ─────────────────────────────────────────────────────────
	/**
	 * CSS for fullscreen mode.
	 * @returns {string}
	 */
	getFullscreenCSS()
	{
		return /*css*/`
		.pict-flow-fullscreen {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			z-index: 9999;
			border-radius: 0;
			border: none;
			min-height: 100vh;
		}
		.pict-flow-fullscreen .pict-flow-svg {
			min-height: calc(100vh - 50px);
		}
		`;
	}

	// ── Toolbar ────────────────────────────────────────────────────────────
	/**
	 * CSS for the toolbar: buttons, groups, labels, selects.
	 * @returns {string}
	 */
	getToolbarCSS()
	{
		return /*css*/`
		.pict-flow-toolbar {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.5em 0.75em;
			background-color: var(--pf-toolbar-bg);
			border-bottom: 1px solid var(--pf-toolbar-border);
			flex-wrap: wrap;
		}
		.pict-flow-toolbar-group {
			display: flex;
			align-items: center;
			gap: 0.25em;
			padding-right: 0.75em;
			border-right: 1px solid var(--pf-toolbar-border);
		}
		.pict-flow-toolbar-group:last-child {
			border-right: none;
			padding-right: 0;
		}
		.pict-flow-toolbar-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			gap: 0.35em;
			padding: 0.35em 0.65em;
			border: 1px solid var(--pf-button-border);
			border-radius: 4px;
			background-color: var(--pf-toolbar-bg);
			color: var(--pf-text-primary);
			font-size: 0.85em;
			cursor: pointer;
			transition: background-color 0.15s, border-color 0.15s;
			user-select: none;
			-webkit-user-select: none;
		}
		.pict-flow-toolbar-btn:focus {
			outline: none;
		}
		.pict-flow-toolbar-btn:hover {
			background-color: var(--pf-button-hover-bg);
			border-color: var(--pf-button-hover-border);
		}
		.pict-flow-toolbar-btn:active {
			background-color: var(--pf-button-active-bg);
		}
		.pict-flow-toolbar-btn-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-toolbar-btn-icon svg {
			display: block;
		}
		.pict-flow-toolbar-btn-text {
			white-space: nowrap;
		}
		.pict-flow-toolbar-btn-chevron {
			display: inline-flex;
			align-items: center;
			margin-left: 0.15em;
		}
		.pict-flow-toolbar-right {
			margin-left: auto;
			border-right: none;
			padding-right: 0;
		}
		.pict-flow-toolbar-label {
			font-size: 0.8em;
			color: var(--pf-text-secondary);
			margin-right: 0.25em;
		}
		.pict-flow-toolbar-select {
			padding: 0.3em 0.5em;
			border: 1px solid var(--pf-button-border);
			border-radius: 4px;
			font-size: 0.85em;
			background-color: var(--pf-toolbar-bg);
			color: var(--pf-text-primary);
		}
		`;
	}

	// ── Card Palette ───────────────────────────────────────────────────────
	/**
	 * CSS for the card palette: toggle, body, categories, cards, swatches.
	 * @returns {string}
	 */
	getPaletteCSS()
	{
		return /*css*/`
		.pict-flow-palette-category {
			margin-bottom: 0.5em;
		}
		.pict-flow-palette-category:last-child {
			margin-bottom: 0;
		}
		.pict-flow-palette-category-label {
			font-size: 0.7em;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			color: var(--pf-text-placeholder);
			margin-bottom: 0.35em;
			padding-bottom: 0.2em;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-palette-cards {
			display: flex;
			flex-wrap: wrap;
			gap: 0.35em;
		}
		.pict-flow-palette-card {
			display: inline-flex;
			align-items: center;
			gap: 0.35em;
			padding: 0.35em 0.6em;
			border: 1px solid var(--pf-card-border);
			border-radius: 4px;
			background-color: var(--pf-panel-bg);
			font-size: 0.8em;
			cursor: pointer;
			transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
			user-select: none;
			-webkit-user-select: none;
			position: relative;
		}
		.pict-flow-palette-card:hover {
			background-color: var(--pf-card-hover-bg);
			border-color: var(--pf-node-selected-stroke);
			box-shadow: var(--pf-card-hover-shadow);
		}
		.pict-flow-palette-card.disabled {
			opacity: 0.45;
			pointer-events: none;
			cursor: default;
		}
		.pict-flow-palette-card-icon {
			font-size: 1.1em;
			line-height: 1;
		}
		.pict-flow-palette-card-swatch {
			width: 10px;
			height: 10px;
			border-radius: 2px;
			flex-shrink: 0;
		}
		.pict-flow-palette-card-title {
			font-weight: 500;
			color: var(--pf-text-primary);
			white-space: nowrap;
		}
		.pict-flow-palette-card-code {
			font-size: 0.8em;
			color: var(--pf-text-placeholder);
			font-family: monospace;
		}
		.pict-flow-toolbar-select.layout-select {
			min-width: 120px;
			max-width: 200px;
		}
		`;
	}

	// ── Popups ────────────────────────────────────────────────────────────
	/**
	 * CSS for toolbar dropdown popups (Add Node, Cards, Layout).
	 * @returns {string}
	 */
	getPopupCSS()
	{
		return /*css*/`
		.pict-flow-toolbar-popup-anchor {
			position: relative;
		}
		.pict-flow-toolbar-popup {
			position: absolute;
			z-index: 1000;
			background: var(--pf-panel-bg);
			border: 1px solid var(--pf-card-border);
			border-radius: 6px;
			box-shadow: 0 4px 16px rgba(0,0,0,0.12);
			min-width: 240px;
			max-height: 340px;
			overflow-y: auto;
			padding: 0.35em 0;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 13px;
		}
		.pict-flow-popup-search-wrapper {
			position: relative;
			padding: 0.4em 0.5em;
			border-bottom: 1px solid var(--pf-divider-light);
		}
		.pict-flow-popup-search-icon {
			position: absolute;
			left: 0.85em;
			top: 50%;
			transform: translateY(-50%);
			pointer-events: none;
			line-height: 1;
			display: flex;
			align-items: center;
		}
		.pict-flow-popup-search {
			width: 100%;
			padding: 0.4em 0.5em 0.4em 2em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-search:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-list-item {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
		}
		.pict-flow-popup-list-item:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-list-item-icon {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			line-height: 1;
		}
		.pict-flow-popup-list-item-label {
			flex: 1;
			color: var(--pf-text-primary);
			font-weight: 500;
		}
		.pict-flow-popup-list-item-code {
			font-size: 0.8em;
			color: var(--pf-text-placeholder);
			font-family: monospace;
			background: var(--pf-badge-category-bg);
			padding: 0.1em 0.4em;
			border-radius: 3px;
		}
		.pict-flow-popup-divider {
			height: 1px;
			background: var(--pf-divider-light);
			margin: 0.25em 0;
		}
		.pict-flow-popup-list-empty {
			text-align: center;
			color: var(--pf-text-placeholder);
			padding: 1.5em 0.75em;
			font-size: 0.9em;
		}
		.pict-flow-popup-layout-save {
			display: flex;
			align-items: center;
			gap: 0.5em;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
			color: var(--pf-text-primary);
			font-weight: 500;
		}
		.pict-flow-popup-layout-save:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-layout-save-icon {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			line-height: 1;
		}
		.pict-flow-popup-layout-save-input-row {
			display: flex;
			align-items: center;
			gap: 0.35em;
			padding: 0.35em 0.5em;
		}
		.pict-flow-popup-layout-save-input {
			flex: 1;
			padding: 0.35em 0.5em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-layout-save-input:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-layout-save-confirm {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			background: var(--pf-panel-bg);
			cursor: pointer;
			flex-shrink: 0;
			transition: background-color 0.15s, border-color 0.15s;
			line-height: 1;
		}
		.pict-flow-popup-layout-save-confirm:hover {
			background-color: var(--pf-card-hover-bg);
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-layout-row {
			display: flex;
			align-items: center;
			padding: 0.45em 0.75em;
			cursor: pointer;
			transition: background-color 0.1s;
		}
		.pict-flow-popup-layout-row:hover {
			background-color: var(--pf-card-hover-bg);
		}
		.pict-flow-popup-layout-name {
			flex: 1;
			color: var(--pf-text-primary);
		}
		.pict-flow-popup-layout-delete {
			display: none;
			align-items: center;
			justify-content: center;
			border: none;
			background: none;
			color: var(--pf-button-danger-text);
			cursor: pointer;
			padding: 2px 4px;
			border-radius: 3px;
			line-height: 1;
		}
		.pict-flow-popup-layout-row:hover .pict-flow-popup-layout-delete {
			display: inline-flex;
		}
		.pict-flow-popup-layout-delete:hover {
			background-color: var(--pf-button-danger-hover-bg);
		}
		.pict-flow-popup-settings-section {
			padding: 0.5em 0.75em;
		}
		.pict-flow-popup-settings-label {
			display: block;
			font-size: 0.8em;
			font-weight: 600;
			color: var(--pf-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.05em;
			margin-bottom: 0.35em;
		}
		.pict-flow-popup-settings-select {
			width: 100%;
			padding: 0.4em 0.5em;
			border: 1px solid var(--pf-input-border);
			border-radius: 4px;
			font-size: 0.9em;
			background: var(--pf-panel-bg);
			color: var(--pf-text-primary);
			cursor: pointer;
			outline: none;
			box-sizing: border-box;
		}
		.pict-flow-popup-settings-select:focus {
			border-color: var(--pf-input-border-focus);
		}
		.pict-flow-popup-settings-slider-row {
			display: flex;
			align-items: center;
			gap: 0.5em;
		}
		.pict-flow-popup-settings-slider {
			flex: 1;
			-webkit-appearance: none;
			appearance: none;
			height: 4px;
			background: var(--pf-input-border);
			border-radius: 2px;
			outline: none;
			cursor: pointer;
		}
		.pict-flow-popup-settings-slider::-webkit-slider-thumb {
			-webkit-appearance: none;
			appearance: none;
			width: 14px;
			height: 14px;
			background: var(--pf-node-selected-stroke);
			border-radius: 50%;
			cursor: pointer;
		}
		.pict-flow-popup-settings-slider::-moz-range-thumb {
			width: 14px;
			height: 14px;
			background: var(--pf-node-selected-stroke);
			border-radius: 50%;
			cursor: pointer;
			border: none;
		}
		.pict-flow-popup-settings-slider-value {
			font-size: 0.85em;
			color: var(--pf-text-secondary);
			min-width: 2.5em;
			text-align: right;
		}
		`;
	}

	// ── Collapsed Toolbar ─────────────────────────────────────────────────
	/**
	 * CSS for the collapsed toolbar state (small expand button in corner).
	 * @returns {string}
	 */
	getCollapsedToolbarCSS()
	{
		return /*css*/`
		.pict-flow-toolbar-collapsed {
			position: absolute;
			top: 8px;
			right: 8px;
			z-index: 100;
			display: none;
		}
		.pict-flow-toolbar-collapsed.visible {
			display: block;
		}
		.pict-flow-toolbar-expand-btn {
			width: 36px;
			height: 36px;
			border-radius: 6px;
			border: 1px solid var(--pf-card-border);
			background-color: var(--pf-toolbar-bg);
			box-shadow: 0 2px 6px rgba(0,0,0,0.1);
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s, box-shadow 0.15s;
		}
		.pict-flow-toolbar-expand-btn:hover {
			background-color: var(--pf-button-hover-bg);
			box-shadow: 0 2px 8px rgba(0,0,0,0.15);
		}
		`;
	}

	// ── Floating Toolbar ──────────────────────────────────────────────────
	/**
	 * CSS for the floating draggable toolbar.
	 * @returns {string}
	 */
	getFloatingToolbarCSS()
	{
		return /*css*/`
		.pict-flow-floating-toolbar {
			position: absolute;
			z-index: 100;
			display: flex;
			flex-direction: column;
			gap: 2px;
			padding: 4px;
			border-radius: 8px;
			border: 1px solid var(--pf-card-border);
			background-color: var(--pf-toolbar-bg);
			box-shadow: 0 4px 16px rgba(0,0,0,0.12);
			pointer-events: auto;
		}
		.pict-flow-floating-grip {
			cursor: grab;
			padding: 4px;
			border-radius: 4px;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s;
		}
		.pict-flow-floating-grip:hover {
			background-color: var(--pf-button-hover-bg);
		}
		.pict-flow-floating-grip:active {
			cursor: grabbing;
		}
		.pict-flow-floating-btn {
			width: 32px;
			height: 32px;
			border: none;
			border-radius: 4px;
			background-color: transparent;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.15s;
		}
		.pict-flow-floating-btn:focus {
			outline: none;
		}
		.pict-flow-floating-btn:hover {
			background-color: var(--pf-button-hover-bg);
		}
		.pict-flow-floating-separator {
			height: 1px;
			background-color: var(--pf-divider-light);
			margin: 2px 4px;
		}
		/* Collapsed floating toolbar — grip-only draggable square */
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-btn,
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-separator {
			display: none;
		}
		.pict-flow-floating-toolbar.collapsed {
			padding: 0;
			border-radius: 6px;
		}
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-grip {
			width: 32px;
			height: 32px;
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.pict-flow-floating-toolbar.collapsed .pict-flow-floating-grip span {
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		`;
	}

	// ── Icons ─────────────────────────────────────────────────────────────
	/**
	 * CSS for inline SVG icons in palette cards, toolbar buttons, info panel headers, and panel close buttons.
	 * @returns {string}
	 */
	getIconCSS()
	{
		return /*css*/`
		.pict-flow-icon-svg {
			pointer-events: none;
		}
		.pict-flow-palette-card-icon svg {
			display: inline-block;
			vertical-align: middle;
		}
		.pict-flow-toolbar-btn-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-toolbar-btn-icon svg {
			display: block;
			vertical-align: middle;
		}
		.pict-flow-info-panel-header.with-icon svg {
			display: inline-block;
			vertical-align: middle;
			margin-right: 4px;
		}
		.pict-flow-panel-close-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
		}
		.pict-flow-panel-close-icon svg {
			display: block;
		}
		.pict-flow-palette-toggle-arrow svg {
			display: block;
		}
		`;
	}

	// ── Bracket Node CSS ──────────────────────────────────────────────────
	/**
	 * CSS for bracket-style node bodies used by sketch/blueprint themes.
	 *
	 * The bracket fill rects share class `.pict-flow-node-body` for fill
	 * inheritance, so these rules must use parent-qualified selectors
	 * (specificity ≥ 0,2,0) to override the base, variant, hover, and
	 * selected rules that set stroke and rx/ry on `.pict-flow-node-body`.
	 *
	 * @returns {string}
	 */
	getBracketNodeCSS()
	{
		return /*css*/`
		/* Bracket outline path */
		.pict-flow-node-bracket {
			fill: none;
			stroke: var(--pf-node-body-stroke);
			stroke-width: 2;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-flow-node.selected .pict-flow-node-bracket {
			stroke: var(--pf-node-selected-stroke);
			stroke-width: 2;
		}
		.pict-flow-node:hover .pict-flow-node-bracket {
			stroke: var(--pf-node-body-stroke-hover);
			stroke-width: 1.5;
		}

		/* Bracket fill rects: no stroke, no rounded corners.
		   Uses parent-qualified selectors to beat variant rules
		   (e.g. .pict-flow-node-start .pict-flow-node-body). */
		.pict-flow-node .pict-flow-node-bracket-fill,
		.pict-flow-node .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
			rx: 0;
			ry: 0;
		}
		/* Beat hover rule: .pict-flow-node:hover .pict-flow-node-body */
		.pict-flow-node:hover .pict-flow-node-bracket-fill,
		.pict-flow-node:hover .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
		}
		/* Beat selected rule: .pict-flow-node.selected .pict-flow-node-body */
		.pict-flow-node.selected .pict-flow-node-bracket-fill,
		.pict-flow-node.selected .pict-flow-node-bracket-title-fill {
			stroke: none;
			stroke-width: 0;
		}
		`;
	}

	// ── Aggregate Methods ──────────────────────────────────────────────────

	/**
	 * Concatenate all domain CSS getters into a single CSS string.
	 * Includes theme overrides if a theme provider is active.
	 * @returns {string}
	 */
	generateCSS()
	{
		let tmpBaseCSS = (
			this.getContainerCSS() +
			this.getNodeCSS() +
			this.getBodyContentCSS() +
			this.getNodeVariantCSS() +
			this.getPortCSS() +
			this.getConnectionCSS() +
			this.getHandleCSS() +
			this.getTetherCSS() +
			this.getPanelCSS() +
			this.getInfoPanelCSS() +
			this.getNodePropsEditorCSS() +
			this.getPanelTabsCSS() +
			this.getBracketNodeCSS() +
			this.getFullscreenCSS() +
			this.getToolbarCSS() +
			this.getPaletteCSS() +
			this.getPopupCSS() +
			this.getCollapsedToolbarCSS() +
			this.getFloatingToolbarCSS() +
			this.getIconCSS()
		);

		// Apply theme overrides if a theme provider exists
		if (this._FlowView && this._FlowView._ThemeProvider)
		{
			let tmpTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpTheme && tmpTheme.CSSVariables && Object.keys(tmpTheme.CSSVariables).length > 0)
			{
				let tmpOverrides = '.pict-flow-container {\n';
				for (let tmpKey in tmpTheme.CSSVariables)
				{
					tmpOverrides += '\t' + tmpKey + ': ' + tmpTheme.CSSVariables[tmpKey] + ';\n';
				}
				tmpOverrides += '}\n';
				tmpBaseCSS += tmpOverrides;
			}
			if (tmpTheme && tmpTheme.AdditionalCSS)
			{
				tmpBaseCSS += tmpTheme.AdditionalCSS;
			}
		}

		return tmpBaseCSS;
	}

	/**
	 * Register all flow CSS with pict's CSSMap service.
	 * Uses correct parameter ordering: (hash, content, priority, provider).
	 * Removes existing CSS first to allow theme re-registration,
	 * then re-injects into the DOM.
	 */
	registerCSS()
	{
		if (this.fable && this.fable.CSSMap)
		{
			// Remove existing CSS first so we can re-register with updated theme overrides
			this.fable.CSSMap.removeCSS('PictSectionFlow-CSS');
			this.fable.CSSMap.addCSS('PictSectionFlow-CSS', this.generateCSS(), 500, 'PictProviderFlowCSS');
			// Re-inject into the DOM to apply the updated CSS
			this.fable.CSSMap.injectCSS();
		}
		else
		{
			this.log.warn('PictProviderFlowCSS: CSSMap not available; CSS not registered.');
		}
	}
}

module.exports = PictProviderFlowCSS;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":2}],36:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class PictProviderFlowConnectorShapes extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowConnectorShapes';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Default shape configurations — each keyed by a shape identifier
		// _OriginalShapes stores a deep copy for reset when switching themes.
		this._DefaultShapes =
		{
			'port':
			{
				ElementType: 'circle',
				Attributes: { r: '5' },
				ClassName: 'pict-flow-port'
			},
			'panel-indicator':
			{
				ElementType: 'rect',
				Attributes: { rx: '2', ry: '2' },
				ClassName: 'pict-flow-node-panel-indicator'
			},
			'connection-path':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-connection'
			},
			'connection-hitarea':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-connection-hitarea'
			},
			'connection-handle':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-connection-handle'
			},
			'connection-handle-midpoint':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-connection-handle-midpoint'
			},
			'drag-connection':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-drag-connection'
			},
			'tether-path':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-tether-line'
			},
			'tether-hitarea':
			{
				ElementType: 'path',
				Attributes: {},
				ClassName: 'pict-flow-tether-hitarea'
			},
			'tether-handle':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-tether-handle'
			},
			'tether-handle-midpoint':
			{
				ElementType: 'circle',
				Attributes: { r: '6' },
				ClassName: 'pict-flow-tether-handle-midpoint'
			},
			'arrowhead-connection':
			{
				MarkerWidth: '5',
				MarkerHeight: '7',
				RefX: '7.5',
				RefY: '3.5',
				Points: '0 0, 5 3.5, 0 7',
				Fill: '#95a5a6'
			},
			'arrowhead-connection-selected':
			{
				MarkerWidth: '5',
				MarkerHeight: '7',
				RefX: '7.5',
				RefY: '3.5',
				Points: '0 0, 5 3.5, 0 7',
				Fill: '#3498db'
			},
			'arrowhead-tether':
			{
				MarkerWidth: '4',
				MarkerHeight: '6',
				RefX: '6',
				RefY: '3',
				Points: '0 0, 4 3, 0 6',
				Fill: '#95a5a6'
			}
		};

		// Store a deep copy for resetting when switching themes
		this._OriginalShapes = JSON.parse(JSON.stringify(this._DefaultShapes));
	}

	// ── Theme Override Methods ─────────────────────────────────────────────

	/**
	 * Apply theme-specific shape overrides.
	 * Merges the overrides into the active shape configs.
	 * @param {Object} pOverrides - Map of shape key to partial config
	 */
	applyThemeOverrides(pOverrides)
	{
		if (!pOverrides || typeof pOverrides !== 'object')
		{
			return;
		}
		for (let tmpKey in pOverrides)
		{
			if (this._DefaultShapes.hasOwnProperty(tmpKey))
			{
				Object.assign(this._DefaultShapes[tmpKey], pOverrides[tmpKey]);
			}
			else
			{
				this._DefaultShapes[tmpKey] = pOverrides[tmpKey];
			}
		}
	}

	/**
	 * Reset all shape configs to their original defaults.
	 * Called before applying new theme overrides to prevent accumulation.
	 */
	resetToDefaults()
	{
		this._DefaultShapes = JSON.parse(JSON.stringify(this._OriginalShapes));
	}

	/**
	 * Get a shape configuration by key.
	 * @param {string} pShapeKey
	 * @returns {Object|null}
	 */
	getShapeConfig(pShapeKey)
	{
		if (this._DefaultShapes.hasOwnProperty(pShapeKey))
		{
			return this._DefaultShapes[pShapeKey];
		}
		return null;
	}

	/**
	 * Override or add a shape configuration.
	 * Consumers can call this to customize connector shapes without subclassing.
	 * @param {string} pShapeKey
	 * @param {Object} pConfig
	 */
	setShapeConfig(pShapeKey, pConfig)
	{
		this._DefaultShapes[pShapeKey] = pConfig;
	}

	/**
	 * Get all registered shape keys.
	 * @returns {string[]}
	 */
	getShapeKeys()
	{
		return Object.keys(this._DefaultShapes);
	}

	// ---- Factory Methods ----

	/**
	 * Create a port SVG element.
	 * @param {Object} pPortData - Port data with Hash, Direction
	 * @param {{x: number, y: number}} pPosition - Local position within the node group
	 * @param {string} pNodeHash - The owning node hash
	 * @returns {SVGCircleElement}
	 */
	createPortElement(pPortData, pPosition, pNodeHash)
	{
		let tmpConfig = this._DefaultShapes['port'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		let tmpClassName = tmpConfig.ClassName + ' ' + pPortData.Direction;
		if (pPortData.PortType)
		{
			tmpClassName += ' port-type-' + pPortData.PortType;
		}
		tmpElement.setAttribute('class', tmpClassName);
		tmpElement.setAttribute('cx', String(pPosition.x));
		tmpElement.setAttribute('cy', String(pPosition.y));
		// Apply config attributes (r, etc.)
		for (let tmpKey in tmpConfig.Attributes)
		{
			tmpElement.setAttribute(tmpKey, tmpConfig.Attributes[tmpKey]);
		}
		tmpElement.setAttribute('data-port-hash', pPortData.Hash);
		tmpElement.setAttribute('data-node-hash', pNodeHash);
		tmpElement.setAttribute('data-port-direction', pPortData.Direction);
		if (pPortData.PortType)
		{
			tmpElement.setAttribute('data-port-type', pPortData.PortType);
		}
		tmpElement.setAttribute('data-element-type', 'port');
		return tmpElement;
	}

	/**
	 * Create a panel indicator SVG element.
	 * @param {string} pNodeHash
	 * @param {number} pX
	 * @param {number} pY
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @returns {SVGRectElement}
	 */
	createPanelIndicatorElement(pNodeHash, pX, pY, pWidth, pHeight)
	{
		let tmpConfig = this._DefaultShapes['panel-indicator'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('x', String(pX));
		tmpElement.setAttribute('y', String(pY));
		tmpElement.setAttribute('width', String(pWidth));
		tmpElement.setAttribute('height', String(pHeight));
		// Apply config attributes (rx, ry, etc.)
		for (let tmpKey in tmpConfig.Attributes)
		{
			tmpElement.setAttribute(tmpKey, tmpConfig.Attributes[tmpKey]);
		}
		tmpElement.setAttribute('data-node-hash', pNodeHash);
		tmpElement.setAttribute('data-element-type', 'panel-indicator');
		return tmpElement;
	}

	/**
	 * Create a visible connection path SVG element.
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pConnectionHash
	 * @param {boolean} pIsSelected
	 * @param {string} pViewIdentifier
	 * @returns {SVGPathElement}
	 */
	createConnectionPathElement(pPath, pConnectionHash, pIsSelected, pViewIdentifier)
	{
		let tmpConfig = this._DefaultShapes['connection-path'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName + (pIsSelected ? ' selected' : ''));
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('data-connection-hash', pConnectionHash);
		tmpElement.setAttribute('data-element-type', 'connection');

		// Arrow marker
		let tmpMarkerConfig = pIsSelected
			? this._DefaultShapes['arrowhead-connection-selected']
			: this._DefaultShapes['arrowhead-connection'];
		// The marker id follows the naming convention used in generateMarkerDefs
		let tmpMarkerId = pIsSelected
			? ('flow-arrowhead-selected-' + pViewIdentifier)
			: ('flow-arrowhead-' + pViewIdentifier);
		tmpElement.setAttribute('marker-end', 'url(#' + tmpMarkerId + ')');

		return tmpElement;
	}

	/**
	 * Create a connection hit area SVG element (wider invisible path for click targeting).
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pConnectionHash
	 * @returns {SVGPathElement}
	 */
	createConnectionHitAreaElement(pPath, pConnectionHash)
	{
		let tmpConfig = this._DefaultShapes['connection-hitarea'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('data-connection-hash', pConnectionHash);
		tmpElement.setAttribute('data-element-type', 'connection-hitarea');
		return tmpElement;
	}

	/**
	 * Create a drag handle circle element.
	 * Works for both connection handles and tether handles.
	 * @param {string} pOwnerHash - Connection hash or panel hash
	 * @param {string} pHandleType - e.g. 'ortho-corner1', 'bezier-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pShapeKey - 'connection-handle', 'connection-handle-midpoint', 'tether-handle', 'tether-handle-midpoint'
	 * @returns {SVGCircleElement}
	 */
	createHandleElement(pOwnerHash, pHandleType, pX, pY, pShapeKey)
	{
		let tmpConfig = this._DefaultShapes[pShapeKey] || this._DefaultShapes['connection-handle'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('cx', String(pX));
		tmpElement.setAttribute('cy', String(pY));
		// Apply config attributes (r, etc.)
		for (let tmpKey in tmpConfig.Attributes)
		{
			tmpElement.setAttribute(tmpKey, tmpConfig.Attributes[tmpKey]);
		}
		tmpElement.setAttribute('data-handle-type', pHandleType);
		return tmpElement;
	}

	/**
	 * Create a complete drag handle element with all data attributes set and
	 * append it to the given layer.  Unifies the handle-creation logic that
	 * was previously duplicated in ConnectionRenderer and TetherService.
	 *
	 * @param {SVGGElement} pLayer - The SVG group to append the handle to
	 * @param {string} pOwnerHash - Connection hash or panel hash
	 * @param {string} pHandleType - e.g. 'ortho-corner1', 'bezier-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pShapeKey - Shape config key ('connection-handle', 'tether-handle-midpoint', etc.)
	 * @param {string} pElementType - data-element-type value ('connection-handle' or 'tether-handle')
	 * @param {string} pOwnerAttrName - data attribute name for the owner ('data-connection-hash' or 'data-panel-hash')
	 * @returns {SVGElement}
	 */
	createFullHandle(pLayer, pOwnerHash, pHandleType, pX, pY, pShapeKey, pElementType, pOwnerAttrName)
	{
		let tmpHandle = this.createHandleElement(pOwnerHash, pHandleType, pX, pY, pShapeKey);
		tmpHandle.setAttribute('data-element-type', pElementType);
		tmpHandle.setAttribute(pOwnerAttrName, pOwnerHash);
		pLayer.appendChild(tmpHandle);
		return tmpHandle;
	}

	/**
	 * Create a temporary drag connection path element.
	 * @param {string} pPath - The SVG path d-string
	 * @returns {SVGPathElement}
	 */
	createDragConnectionElement(pPath)
	{
		let tmpConfig = this._DefaultShapes['drag-connection'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('d', pPath);
		return tmpElement;
	}

	/**
	 * Create a visible tether path SVG element.
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pPanelHash
	 * @param {boolean} pIsSelected
	 * @param {string} pViewIdentifier
	 * @returns {SVGPathElement}
	 */
	createTetherPathElement(pPath, pPanelHash, pIsSelected, pViewIdentifier)
	{
		let tmpConfig = this._DefaultShapes['tether-path'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName + (pIsSelected ? ' selected' : ''));
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('marker-end', 'url(#flow-tether-arrowhead-' + pViewIdentifier + ')');
		tmpElement.setAttribute('data-element-type', 'tether');
		tmpElement.setAttribute('data-panel-hash', pPanelHash);
		return tmpElement;
	}

	/**
	 * Create a tether hit area SVG element.
	 * @param {string} pPath - The SVG path d-string
	 * @param {string} pPanelHash
	 * @returns {SVGPathElement}
	 */
	createTetherHitAreaElement(pPath, pPanelHash)
	{
		let tmpConfig = this._DefaultShapes['tether-hitarea'];
		let tmpElement = this._FlowView._SVGHelperProvider.createSVGElement(tmpConfig.ElementType);
		tmpElement.setAttribute('class', tmpConfig.ClassName);
		tmpElement.setAttribute('d', pPath);
		tmpElement.setAttribute('data-element-type', 'tether-hitarea');
		tmpElement.setAttribute('data-panel-hash', pPanelHash);
		return tmpElement;
	}

	/**
	 * Generate SVG marker definition markup for all arrowhead types.
	 * Returns raw SVG markup to be injected into the <defs> section.
	 * @param {string} pViewIdentifier
	 * @returns {string}
	 */
	generateMarkerDefs(pViewIdentifier)
	{
		let tmpConnectionMarker = this._DefaultShapes['arrowhead-connection'];
		let tmpSelectedMarker = this._DefaultShapes['arrowhead-connection-selected'];
		let tmpTetherMarker = this._DefaultShapes['arrowhead-tether'];

		let tmpMarkup = '';

		// Normal connection arrowhead (default gray)
		tmpMarkup += '<marker id="flow-arrowhead-' + pViewIdentifier + '"'
			+ ' markerWidth="' + tmpConnectionMarker.MarkerWidth + '"'
			+ ' markerHeight="' + tmpConnectionMarker.MarkerHeight + '"'
			+ ' refX="' + tmpConnectionMarker.RefX + '"'
			+ ' refY="' + tmpConnectionMarker.RefY + '"'
			+ ' orient="auto" markerUnits="strokeWidth">'
			+ '<polygon points="' + tmpConnectionMarker.Points + '" fill="' + tmpConnectionMarker.Fill + '" />'
			+ '</marker>';

		// Per-port-type connection arrowheads
		let tmpPortTypeColors =
		{
			'event-in': '#3498db',
			'event-out': '#2ecc71',
			'setting': '#e67e22',
			'value': '#f1c40f',
			'error': '#e74c3c'
		};

		for (let tmpType in tmpPortTypeColors)
		{
			tmpMarkup += '<marker id="flow-arrowhead-' + tmpType + '-' + pViewIdentifier + '"'
				+ ' markerWidth="' + tmpConnectionMarker.MarkerWidth + '"'
				+ ' markerHeight="' + tmpConnectionMarker.MarkerHeight + '"'
				+ ' refX="' + tmpConnectionMarker.RefX + '"'
				+ ' refY="' + tmpConnectionMarker.RefY + '"'
				+ ' orient="auto" markerUnits="strokeWidth">'
				+ '<polygon points="' + tmpConnectionMarker.Points + '" fill="' + tmpPortTypeColors[tmpType] + '" />'
				+ '</marker>';
		}

		// Selected connection arrowhead
		tmpMarkup += '<marker id="flow-arrowhead-selected-' + pViewIdentifier + '"'
			+ ' markerWidth="' + tmpSelectedMarker.MarkerWidth + '"'
			+ ' markerHeight="' + tmpSelectedMarker.MarkerHeight + '"'
			+ ' refX="' + tmpSelectedMarker.RefX + '"'
			+ ' refY="' + tmpSelectedMarker.RefY + '"'
			+ ' orient="auto" markerUnits="strokeWidth">'
			+ '<polygon points="' + tmpSelectedMarker.Points + '" fill="' + tmpSelectedMarker.Fill + '" />'
			+ '</marker>';

		// Tether arrowhead
		tmpMarkup += '<marker id="flow-tether-arrowhead-' + pViewIdentifier + '"'
			+ ' markerWidth="' + tmpTetherMarker.MarkerWidth + '"'
			+ ' markerHeight="' + tmpTetherMarker.MarkerHeight + '"'
			+ ' refX="' + tmpTetherMarker.RefX + '"'
			+ ' refY="' + tmpTetherMarker.RefY + '"'
			+ ' orient="auto" markerUnits="strokeWidth">'
			+ '<polygon points="' + tmpTetherMarker.Points + '" fill="' + tmpTetherMarker.Fill + '" />'
			+ '</marker>';

		return tmpMarkup;
	}
}

module.exports = PictProviderFlowConnectorShapes;

},{"fable-serviceproviderbase":2}],37:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowEventHandler'
};

/**
 * Event handler provider for the flow diagram.
 * Provides hook points for extensibility - consumers can register handlers
 * for flow events like node selection, movement, connection creation, etc.
 *
 * Supported events:
 * - onNodeSelected(node)              - A node was selected (or null for deselection)
 * - onNodeAdded(node)                 - A new node was added
 * - onNodeRemoved(node)               - A node was removed
 * - onNodeMoved(node)                 - A node was moved to a new position
 * - onConnectionSelected(conn)        - A connection was selected
 * - onConnectionCreated(conn)         - A new connection was created
 * - onConnectionRemoved(conn)         - A connection was removed
 * - onConnectionHandleMoved(conn)     - A connection's drag handle was repositioned
 * - onConnectionModeChanged(conn)     - A connection's line mode was toggled (bezier/orthogonal)
 * - onPanelOpened(panelData)          - A properties panel was opened
 * - onPanelClosed(panelData)          - A properties panel was closed
 * - onPanelMoved(panelData)           - A properties panel was moved
 * - onTetherSelected(panelData)       - A tether line was selected (or null for deselection)
 * - onTetherHandleMoved(panelData)    - A tether's drag handle was repositioned
 * - onTetherModeChanged(panelData)    - A tether's line mode was toggled (bezier/orthogonal)
 * - onLayoutSaved(layoutData)         - A layout snapshot was saved
 * - onLayoutRestored(layoutData)      - A saved layout was restored
 * - onLayoutDeleted(layoutData)       - A saved layout was deleted
 * - onFlowChanged(flowData)           - The flow data changed (catch-all)
 */
class PictProviderFlowEventHandler extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowEventHandler';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Event handler registry
		this._Handlers = {};
	}

	/**
	 * Register an event handler
	 * @param {string} pEventName - The event name (e.g., 'onNodeSelected')
	 * @param {Function} pHandler - The handler function
	 * @param {string} [pHandlerHash] - Optional unique identifier for this handler (for later removal)
	 * @returns {string} The handler hash
	 */
	registerHandler(pEventName, pHandler, pHandlerHash)
	{
		if (typeof pHandler !== 'function')
		{
			this.log.warn(`PictProviderFlowEventHandler registerHandler: handler for '${pEventName}' is not a function`);
			return null;
		}

		if (!this._Handlers[pEventName])
		{
			this._Handlers[pEventName] = [];
		}

		let tmpHash = pHandlerHash || `handler-${this.fable.getUUID()}`;

		this._Handlers[pEventName].push({
			Hash: tmpHash,
			Handler: pHandler
		});

		this.log.trace(`PictProviderFlowEventHandler registered handler '${tmpHash}' for event '${pEventName}'`);

		return tmpHash;
	}

	/**
	 * Remove a specific event handler
	 * @param {string} pEventName - The event name
	 * @param {string} pHandlerHash - The handler hash to remove
	 * @returns {boolean}
	 */
	removeHandler(pEventName, pHandlerHash)
	{
		if (!this._Handlers[pEventName]) return false;

		let tmpIndex = this._Handlers[pEventName].findIndex((pH) => pH.Hash === pHandlerHash);
		if (tmpIndex >= 0)
		{
			this._Handlers[pEventName].splice(tmpIndex, 1);
			return true;
		}

		return false;
	}

	/**
	 * Remove all handlers for a specific event
	 * @param {string} pEventName
	 */
	removeAllHandlers(pEventName)
	{
		if (pEventName)
		{
			this._Handlers[pEventName] = [];
		}
		else
		{
			this._Handlers = {};
		}
	}

	/**
	 * Fire an event, calling all registered handlers
	 * @param {string} pEventName - The event name
	 * @param {*} pEventData - The event data to pass to handlers
	 */
	fireEvent(pEventName, pEventData)
	{
		this.log.trace(`PictProviderFlowEventHandler firing event '${pEventName}'`);

		if (!this._Handlers[pEventName] || this._Handlers[pEventName].length === 0)
		{
			return;
		}

		for (let i = 0; i < this._Handlers[pEventName].length; i++)
		{
			let tmpEntry = this._Handlers[pEventName][i];
			try
			{
				tmpEntry.Handler(pEventData, this._FlowView);
			}
			catch (pError)
			{
				this.log.error(`PictProviderFlowEventHandler error in handler '${tmpEntry.Hash}' for event '${pEventName}': ${pError.message}`);
			}
		}
	}

	/**
	 * Check if any handlers are registered for a specific event
	 * @param {string} pEventName
	 * @returns {boolean}
	 */
	hasHandlers(pEventName)
	{
		return !!(this._Handlers[pEventName] && this._Handlers[pEventName].length > 0);
	}

	/**
	 * Get the count of handlers for a specific event
	 * @param {string} pEventName
	 * @returns {number}
	 */
	getHandlerCount(pEventName)
	{
		if (!this._Handlers[pEventName]) return 0;
		return this._Handlers[pEventName].length;
	}
}

module.exports = PictProviderFlowEventHandler;

module.exports.default_configuration = _ProviderConfiguration;

},{"pict-provider":19}],38:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-Geometry
 *
 * Shared geometry utilities for the flow diagram.
 * Provides direction vectors and edge center calculations used by
 * connections, tethers, and other flow components.
 *
 * Port Side values (12 positions):
 *
 *   Top edge:    'top-left'     'top'     'top-right'
 *   Left edge:   'left-top'     'left'    'left-bottom'
 *   Right edge:  'right-top'    'right'   'right-bottom'
 *   Bottom edge: 'bottom-left'  'bottom'  'bottom-right'
 *
 * The old 4-value sides ('left', 'right', 'top', 'bottom') map to
 * the middle position on each edge for backward compatibility.
 */
class PictProviderFlowGeometry extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowGeometry';
	}

	/**
	 * Extract the edge name from a Side value.
	 *
	 * Maps all 12 positions (and the 4 legacy values) back to
	 * the edge they sit on: 'left', 'right', 'top', or 'bottom'.
	 *
	 * @param {string} pSide - Any valid Side value
	 * @returns {string} The edge: 'left', 'right', 'top', or 'bottom'
	 */
	getEdgeFromSide(pSide)
	{
		switch (pSide)
		{
			case 'left-top':
			case 'left':
			case 'left-bottom':
				return 'left';

			case 'right-top':
			case 'right':
			case 'right-bottom':
				return 'right';

			case 'top-left':
			case 'top':
			case 'top-right':
				return 'top';

			case 'bottom-left':
			case 'bottom':
			case 'bottom-right':
				return 'bottom';

			default:
				return 'right';
		}
	}

	/**
	 * Get the outward unit direction vector for a given side.
	 *
	 * All positions on the same edge share the same direction vector.
	 *
	 * @param {string} pSide - Any valid Side value (12 positions or 4 legacy)
	 * @returns {{dx: number, dy: number}}
	 */
	sideDirection(pSide)
	{
		switch (this.getEdgeFromSide(pSide))
		{
			case 'left':   return { dx: -1, dy: 0 };
			case 'right':  return { dx: 1, dy: 0 };
			case 'top':    return { dx: 0, dy: -1 };
			case 'bottom': return { dx: 0, dy: 1 };
			default:       return { dx: 1, dy: 0 };
		}
	}

	/**
	 * Get the center point of a rectangle's edge.
	 * Works for any object with X, Y, Width, Height properties
	 * (nodes, panels, or any rectangular element).
	 *
	 * @param {Object} pRectData - Object with X, Y, Width, Height
	 * @param {string} pSide - 'left', 'right', 'top', 'bottom'
	 * @returns {{x: number, y: number}}
	 */
	getEdgeCenter(pRectData, pSide)
	{
		switch (pSide)
		{
			case 'left':
				return { x: pRectData.X, y: pRectData.Y + pRectData.Height / 2 };
			case 'right':
				return { x: pRectData.X + pRectData.Width, y: pRectData.Y + pRectData.Height / 2 };
			case 'top':
				return { x: pRectData.X + pRectData.Width / 2, y: pRectData.Y };
			case 'bottom':
				return { x: pRectData.X + pRectData.Width / 2, y: pRectData.Y + pRectData.Height };
			default:
				return { x: pRectData.X + pRectData.Width, y: pRectData.Y + pRectData.Height / 2 };
		}
	}

	/**
	 * Calculate a port's local position relative to node origin.
	 *
	 * Supports 12 positions (3 zones per edge).  For left/right edges,
	 * the body area below the title bar is divided into vertical zones.
	 * For top/bottom edges, the full width is divided into horizontal zones.
	 *
	 * When pPortCountsBySide is provided, zone fractions are computed
	 * proportionally based on actual port counts (adaptive zones).
	 * Otherwise, fixed 1/3 zones are used for backward compatibility.
	 *
	 * Multiple ports sharing the same Side value distribute evenly within
	 * their zone.
	 *
	 * @param {string} pSide - Side value (any of 12 positions or 4 legacy)
	 * @param {number} pIndex - Index of this port within its Side group
	 * @param {number} pTotal - Total ports with this Side value
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pTitleBarHeight - Height of the node title bar
	 * @param {Object} [pPortCountsBySide] - Optional map of Side → port count
	 *        for all ports on the node.  Enables adaptive zone sizing.
	 * @returns {{x: number, y: number}}
	 */
	getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pTitleBarHeight, pPortCountsBySide)
	{
		let tmpEdge = this.getEdgeFromSide(pSide);
		let tmpZone = pPortCountsBySide
			? this._computeAdaptiveZone(pSide, pPortCountsBySide)
			: this._getZoneFromSide(pSide);

		// Use the fixed zone to decide alignment intent (start/center/end)
		// because adaptive zones shift boundaries when neighbouring zones
		// are empty, which would break alignment decisions.
		let tmpFixedZone = this._getZoneFromSide(pSide);

		// Minimum spacing between port centers (px)
		let tmpMinSpacing = 16;

		// Reserve space at the bottom of the body so that port badges
		// never overlap the panel-indicator icon (10×10 rect at bottom-right)
		// and always leave a visible gap above the node bottom edge.
		let tmpBottomPad = 16;

		// Determine alignment from the fixed zone position:
		//   start zone  (0.000 – 0.333) → start-align (offset 0)
		//   middle zone (0.333 – 0.667) → center
		//   end zone    (0.667 – 1.000) → end-align
		let tmpAlignment = 'start';
		if (tmpFixedZone.start >= 0.5)
		{
			tmpAlignment = 'end';
		}
		else if (tmpFixedZone.start >= 0.17)
		{
			tmpAlignment = 'center';
		}

		if (tmpEdge === 'left' || tmpEdge === 'right')
		{
			let tmpX = (tmpEdge === 'left') ? 0 : pWidth;
			let tmpBodyHeight = pHeight - pTitleBarHeight - tmpBottomPad;
			let tmpZoneStart = pTitleBarHeight + tmpBodyHeight * tmpZone.start;
			let tmpZoneHeight = tmpBodyHeight * (tmpZone.end - tmpZone.start);

			// Use fixed spacing so port gaps stay consistent across cards
			// even when one edge drives the card height beyond what the
			// other needs.
			let tmpSpacing = tmpMinSpacing;
			let tmpGroupHeight = tmpSpacing * (pTotal + 1);
			let tmpSlack = tmpZoneHeight - tmpGroupHeight;
			if (tmpSlack < 0)
			{
				tmpSlack = 0;
			}

			let tmpAlignOffset = 0;
			if (tmpAlignment === 'end')
			{
				tmpAlignOffset = tmpSlack;
			}
			else if (tmpAlignment === 'center')
			{
				tmpAlignOffset = tmpSlack / 2;
			}

			let tmpY = tmpZoneStart + tmpAlignOffset + tmpSpacing * (pIndex + 1);
			return { x: tmpX, y: tmpY };
		}

		// top or bottom
		let tmpY = (tmpEdge === 'top') ? 0 : pHeight;
		let tmpZoneStart = pWidth * tmpZone.start;
		let tmpZoneWidth = pWidth * (tmpZone.end - tmpZone.start);

		let tmpSpacing = tmpMinSpacing;
		let tmpGroupWidth = tmpSpacing * (pTotal + 1);
		let tmpSlack = tmpZoneWidth - tmpGroupWidth;
		if (tmpSlack < 0)
		{
			tmpSlack = 0;
		}

		let tmpAlignOffset = 0;
		if (tmpAlignment === 'end')
		{
			tmpAlignOffset = tmpSlack;
		}
		else if (tmpAlignment === 'center')
		{
			tmpAlignOffset = tmpSlack / 2;
		}

		let tmpX = tmpZoneStart + tmpAlignOffset + tmpSpacing * (pIndex + 1);
		return { x: tmpX, y: tmpY };
	}

	/**
	 * Get the zone fraction (start, end) for a Side value.
	 *
	 * Each edge is divided into three zones of equal size:
	 *   start:  0.0 — 0.333
	 *   middle: 0.333 — 0.667
	 *   end:    0.667 — 1.0
	 *
	 * Used as fallback when adaptive zones are not available.
	 *
	 * @param {string} pSide
	 * @returns {{start: number, end: number}}
	 */
	_getZoneFromSide(pSide)
	{
		switch (pSide)
		{
			// Left edge: top, middle, bottom
			case 'left-top':     return { start: 0.0,   end: 0.333 };
			case 'left':         return { start: 0.333, end: 0.667 };
			case 'left-bottom':  return { start: 0.667, end: 1.0 };

			// Right edge: top, middle, bottom
			case 'right-top':    return { start: 0.0,   end: 0.333 };
			case 'right':        return { start: 0.333, end: 0.667 };
			case 'right-bottom': return { start: 0.667, end: 1.0 };

			// Top edge: left, middle, right
			case 'top-left':     return { start: 0.0,   end: 0.333 };
			case 'top':          return { start: 0.333, end: 0.667 };
			case 'top-right':    return { start: 0.667, end: 1.0 };

			// Bottom edge: left, middle, right
			case 'bottom-left':  return { start: 0.0,   end: 0.333 };
			case 'bottom':       return { start: 0.333, end: 0.667 };
			case 'bottom-right': return { start: 0.667, end: 1.0 };

			// Fallback: full range (legacy behavior)
			default:             return { start: 0.0,   end: 1.0 };
		}
	}

	/**
	 * Get the three zone Side keys for a given edge, in order.
	 *
	 * @param {string} pEdge - 'left', 'right', 'top', or 'bottom'
	 * @returns {Array<string>} Three Side keys in start-to-end order
	 */
	_getZoneKeysForEdge(pEdge)
	{
		switch (pEdge)
		{
			case 'left':   return ['left-top', 'left', 'left-bottom'];
			case 'right':  return ['right-top', 'right', 'right-bottom'];
			case 'top':    return ['top-left', 'top', 'top-right'];
			case 'bottom': return ['bottom-left', 'bottom', 'bottom-right'];
			default:       return ['right-top', 'right', 'right-bottom'];
		}
	}

	/**
	 * Compute an adaptive zone fraction for a Side value based on the
	 * actual port distribution across all zones on the same edge.
	 *
	 * Instead of fixed 1/3 splits, zones are sized proportionally to the
	 * space each zone needs (minSpacing * (portCount + 1)).  Zones with
	 * zero ports collapse to zero, giving occupied zones more room.
	 *
	 * @param {string} pSide - The Side value to compute a zone for
	 * @param {Object} pPortCountsBySide - Map of Side → number of ports
	 * @returns {{start: number, end: number}}
	 */
	_computeAdaptiveZone(pSide, pPortCountsBySide)
	{
		let tmpEdge = this.getEdgeFromSide(pSide);
		let tmpZoneKeys = this._getZoneKeysForEdge(tmpEdge);

		let tmpMinSpacing = 16;

		// Compute the space each zone needs: minSpacing * (count + 1)
		// The +1 provides padding at both ends of the zone.
		let tmpTotalSpace = 0;
		let tmpSpaceByZone = {};
		for (let i = 0; i < tmpZoneKeys.length; i++)
		{
			let tmpKey = tmpZoneKeys[i];
			let tmpCount = pPortCountsBySide[tmpKey] || 0;
			let tmpSpace = (tmpCount > 0) ? (tmpMinSpacing * (tmpCount + 1)) : 0;
			tmpSpaceByZone[tmpKey] = tmpSpace;
			tmpTotalSpace += tmpSpace;
		}

		// If no ports on this edge at all, fall back to fixed zones
		if (tmpTotalSpace === 0)
		{
			return this._getZoneFromSide(pSide);
		}

		// Compute proportional start/end for the requested zone
		let tmpCumulativeStart = 0;
		for (let i = 0; i < tmpZoneKeys.length; i++)
		{
			let tmpKey = tmpZoneKeys[i];
			let tmpFraction = tmpSpaceByZone[tmpKey] / tmpTotalSpace;
			if (tmpKey === pSide)
			{
				return { start: tmpCumulativeStart, end: tmpCumulativeStart + tmpFraction };
			}
			tmpCumulativeStart += tmpFraction;
		}

		// Should not reach here; fall back to fixed zones
		return this._getZoneFromSide(pSide);
	}

	/**
	 * Build a map of Side → port count from an array of port objects.
	 *
	 * Convenience method for callers that need to pass port counts
	 * to getPortLocalPosition or computeMinimumNodeHeight.
	 *
	 * @param {Array} pPorts - Array of port objects with Side, Direction
	 * @returns {Object} Map of Side value → count
	 */
	buildPortCountsBySide(pPorts)
	{
		let tmpCounts = {};
		if (!pPorts || !Array.isArray(pPorts))
		{
			return tmpCounts;
		}
		for (let i = 0; i < pPorts.length; i++)
		{
			let tmpSide = pPorts[i].Side || (pPorts[i].Direction === 'input' ? 'left' : 'right');
			if (!tmpCounts[tmpSide])
			{
				tmpCounts[tmpSide] = 0;
			}
			tmpCounts[tmpSide]++;
		}
		return tmpCounts;
	}

	/**
	 * Compute the minimum node height required so that all ports
	 * (with their badges) fit within the node boundary.
	 *
	 * Uses adaptive zone sizing: instead of assuming each zone gets
	 * a fixed 1/3 of the body, sums the space needed by all occupied
	 * zones on each left/right edge.  This produces compact cards
	 * whose height scales linearly with total port count.
	 *
	 * @param {Array} pPorts - Array of port objects with Side, Direction
	 * @param {number} pTitleBarHeight - Height of the title bar
	 * @returns {number} Minimum node height in pixels (0 if no ports)
	 */
	computeMinimumNodeHeight(pPorts, pTitleBarHeight)
	{
		if (!pPorts || !Array.isArray(pPorts) || pPorts.length === 0)
		{
			return 0;
		}

		let tmpMinSpacing = 16;
		let tmpBottomPad = 16;

		// Count ports per Side value
		let tmpCountBySide = this.buildPortCountsBySide(pPorts);

		// Sum the space needed per edge (left, right) across all zones.
		// Each zone needs minSpacing * (count + 1) pixels.
		let tmpSpacePerEdge = {};
		for (let tmpSide in tmpCountBySide)
		{
			let tmpEdge = this.getEdgeFromSide(tmpSide);

			// Only left/right edge zones affect required height
			if (tmpEdge !== 'left' && tmpEdge !== 'right')
			{
				continue;
			}

			let tmpCount = tmpCountBySide[tmpSide];
			let tmpZoneSpace = tmpMinSpacing * (tmpCount + 1);

			if (!tmpSpacePerEdge[tmpEdge])
			{
				tmpSpacePerEdge[tmpEdge] = 0;
			}
			tmpSpacePerEdge[tmpEdge] += tmpZoneSpace;
		}

		// The minimum height is titleBar + bottomPad + max edge space
		let tmpMinHeight = 0;
		for (let tmpEdge in tmpSpacePerEdge)
		{
			let tmpRequired = pTitleBarHeight + tmpBottomPad + tmpSpacePerEdge[tmpEdge];
			if (tmpRequired > tmpMinHeight)
			{
				tmpMinHeight = tmpRequired;
			}
		}

		return Math.ceil(tmpMinHeight);
	}
}

module.exports = PictProviderFlowGeometry;

},{"fable-serviceproviderbase":2}],39:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-Icons
 *
 * Centralized SVG icon provider for the flow diagram.
 * All icons use a duotone style: 2px outline (#2c3e50) with
 * subtle filled accent shapes (#d5e8f7).
 *
 * Each icon is registered as a pict template with hash `Flow-Icon-{key}`,
 * making them individually overridable by consumers.
 */

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowIcons'
};

// ── Default Icon SVG Markup ────────────────────────────────────────────────
// All icons: viewBox="0 0 24 24", duotone style
// Accent fill: #d5e8f7, Stroke: #2c3e50, Stroke-width: 2
//
// The {FlowIconSize} placeholder is replaced at render time with the
// requested pixel size. Each template is a self-contained <svg> element.

const _DefaultIcons =
{
	// ── FlowCard Icons ─────────────────────────────────────────────────────

	'ITE': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="6" r="3" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><circle cx="6" cy="18" r="2.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><circle cx="18" cy="18" r="2.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 9v2M9.5 12.5L6 15.5M14.5 12.5L18 15.5" stroke="#2c3e50" stroke-width="2"/></svg>',

	'SW': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M3 12h5M16 12h5M14.8 9.2l3.7-5.2M14.8 14.8l3.7 5.2" stroke="#2c3e50" stroke-width="2"/></svg>',

	'EACH': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="14" y="3" width="7" height="7" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="3" y="14" width="7" height="7" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="14" y="14" width="7" height="7" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/></svg>',

	'FREAD': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M13 2v7h7" stroke="#2c3e50" stroke-width="2"/><path d="M9 13h6M9 17h4" stroke="#2c3e50" stroke-width="2"/></svg>',

	'FWRITE': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M13 2v7h7" stroke="#2c3e50" stroke-width="2"/><path d="M12 13v5M9.5 15.5L12 13l2.5 2.5" stroke="#2c3e50" stroke-width="2"/></svg>',

	'LOG': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><circle cx="7.5" cy="8" r="1" fill="#2c3e50"/><circle cx="7.5" cy="12" r="1" fill="#2c3e50"/><circle cx="7.5" cy="16" r="1" fill="#2c3e50"/><path d="M11 8h5.5M11 12h5.5M11 16h3.5" stroke="#2c3e50" stroke-width="2"/></svg>',

	'GET': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.5" cy="10.5" r="6.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M21 21l-5.15-5.15" stroke="#2c3e50" stroke-width="2"/></svg>',

	'SET': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4.5 1.5L4 16Z" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M14 6l3 3" stroke="#2c3e50" stroke-width="2"/></svg>',

	// ── UI Icons ───────────────────────────────────────────────────────────

	'fullscreen': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="M9 21H3v-6"/><path d="M21 3l-7 7"/><path d="M3 21l7-7"/></svg>',

	'exit-fullscreen': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14h6v6"/><path d="M20 10h-6V4"/><path d="M14 10l7-7"/><path d="M3 21l7-7"/></svg>',

	'close': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',

	'chevron-down': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',

	// ── Toolbar & Popup Icons ─────────────────────────────────────────────

	'search': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="#2c3e50" stroke-width="2"/></svg>',

	'cards': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="16" height="12" rx="2" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M6 7V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2" stroke="#2c3e50" stroke-width="2"/></svg>',

	'layout': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="8" height="10" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="13" y="3" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="3" y="15" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="13" y="11" width="8" height="10" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/></svg>',

	'collapse': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M8 12h8" stroke="#2c3e50" stroke-width="2"/></svg>',

	'expand': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 8v8M8 12h8" stroke="#2c3e50" stroke-width="2"/></svg>',

	'grip': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="#2c3e50"><circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/><circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/><circle cx="9" cy="19" r="1.5"/><circle cx="15" cy="19" r="1.5"/></svg>',

	'settings': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3" fill="#d5e8f7"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',

	'plus': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 8v8M8 12h8" stroke="#2c3e50" stroke-width="2"/></svg>',

	'trash': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18" stroke="#2c3e50" stroke-width="2"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="#2c3e50" stroke-width="2"/><rect x="5" y="6" width="14" height="14" rx="2" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M10 11v6M14 11v6" stroke="#2c3e50" stroke-width="2"/></svg>',

	'save': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M17 21v-8H7v8" stroke="#2c3e50" stroke-width="2"/><path d="M7 3v5h8" stroke="#2c3e50" stroke-width="2"/></svg>',

	'auto-layout': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="2" y="16" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><rect x="14" y="16" width="8" height="6" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 8v4M6 16v-4h12v4" stroke="#2c3e50" stroke-width="2"/></svg>',

	'zoom-in': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="#2c3e50" stroke-width="2"/><path d="M11 8v6M8 11h6" stroke="#2c3e50" stroke-width="2"/></svg>',

	'zoom-out': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M21 21l-4.35-4.35" stroke="#2c3e50" stroke-width="2"/><path d="M8 11h6" stroke="#2c3e50" stroke-width="2"/></svg>',

	'zoom-fit': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7V3h4"/><path d="M17 3h4v4"/><path d="M21 17v4h-4"/><path d="M7 21H3v-4"/><rect x="7" y="7" width="10" height="10" rx="1.5" fill="#d5e8f7"/></svg>',

	'dock': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="4" rx="1.5" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M12 20V11M8 14l4-4 4 4" stroke="#2c3e50" stroke-width="2"/></svg>',

	'restore': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke="#2c3e50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',

	'delete-node': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18" stroke="#2c3e50" stroke-width="2"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="#2c3e50" stroke-width="2"/><rect x="5" y="6" width="14" height="14" rx="2" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><path d="M10 11v6M14 11v6" stroke="#2c3e50" stroke-width="2"/></svg>',

	// ── Fallback ───────────────────────────────────────────────────────────

	'default': '<svg xmlns="http://www.w3.org/2000/svg" width="{FlowIconSize}" height="{FlowIconSize}" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="4" fill="#d5e8f7" stroke="#2c3e50" stroke-width="2"/><circle cx="12" cy="12" r="2.5" fill="#2c3e50"/></svg>'
};

class PictProviderFlowIcons extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowIcons';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Deep copy the default icons
		this._Icons = JSON.parse(JSON.stringify(_DefaultIcons));

		// Merge any additional icons passed via options
		if (pOptions && pOptions.AdditionalIcons && typeof pOptions.AdditionalIcons === 'object')
		{
			let tmpKeys = Object.keys(pOptions.AdditionalIcons);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				this._Icons[tmpKeys[i]] = pOptions.AdditionalIcons[tmpKeys[i]];
			}
		}
	}

	/**
	 * Register all icons as pict templates with hash Flow-Icon-{key}.
	 * Consumers can override any icon by registering a template with
	 * the same hash before the flow view renders.
	 */
	registerIconTemplates()
	{
		if (!this.fable || !this.fable.TemplateProvider)
		{
			this.log.warn('PictProviderFlowIcons: TemplateProvider not available; icon templates not registered.');
			return;
		}

		let tmpKeys = Object.keys(this._Icons);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpHash = 'Flow-Icon-' + tmpKeys[i];

			// Only register if not already present (allow consumer overrides)
			if (!this.fable.TemplateProvider.getTemplate(tmpHash))
			{
				this.fable.TemplateProvider.addTemplate(tmpHash, this._Icons[tmpKeys[i]]);
			}
		}
	}

	/**
	 * Determine if the given icon string is an emoji (legacy) or an icon key.
	 * Returns true if the string contains characters with code points above U+00FF,
	 * indicating emoji or Unicode symbol characters.
	 *
	 * @param {string} pIconValue - The icon value to check
	 * @returns {boolean}
	 */
	isEmojiIcon(pIconValue)
	{
		if (!pIconValue || typeof pIconValue !== 'string')
		{
			return false;
		}

		for (let i = 0; i < pIconValue.length; i++)
		{
			if (pIconValue.charCodeAt(i) > 255)
			{
				return true;
			}
		}

		return false;
	}

	/**
	 * Resolve the icon key to use for a given CardMetadata object.
	 * Tries Icon field first, then Code field, then falls back to 'default'.
	 *
	 * @param {Object} pCardMetadata - The CardMetadata object
	 * @returns {string} The icon key
	 */
	resolveIconKey(pCardMetadata)
	{
		if (!pCardMetadata)
		{
			return 'default';
		}

		// If Icon is a known key, use it
		if (pCardMetadata.Icon && this._Icons.hasOwnProperty(pCardMetadata.Icon))
		{
			return pCardMetadata.Icon;
		}

		// If Icon is a non-emoji string, check if it matches a registered template
		if (pCardMetadata.Icon && !this.isEmojiIcon(pCardMetadata.Icon))
		{
			return pCardMetadata.Icon;
		}

		// Fall back to Code field
		if (pCardMetadata.Code && this._Icons.hasOwnProperty(pCardMetadata.Code))
		{
			return pCardMetadata.Code;
		}

		return 'default';
	}

	/**
	 * Get the raw SVG markup string for a given icon key, with size applied.
	 *
	 * @param {string} pIconKey - The icon key
	 * @param {number} pSize - Pixel size (default 16)
	 * @returns {string} The SVG markup string
	 */
	getIconSVGMarkup(pIconKey, pSize)
	{
		let tmpSize = pSize || 16;
		let tmpKey = pIconKey || 'default';
		let tmpMarkup = this._Icons[tmpKey] || this._Icons['default'];

		// Replace the size placeholder
		return tmpMarkup.replace(/\{FlowIconSize\}/g, String(tmpSize));
	}

	/**
	 * Render an icon into an SVG canvas context using createElementNS.
	 * Creates a <g> element containing the icon paths, positioned at (pX, pY)
	 * with the given size via a scale transform.
	 *
	 * @param {string} pIconKey - The icon key
	 * @param {SVGElement} pParentGroup - The parent SVG group to append to
	 * @param {number} pX - X position (top-left of icon bounding box)
	 * @param {number} pY - Y position (top-left of icon bounding box)
	 * @param {number} pSize - Pixel size (default 16)
	 * @returns {SVGGElement|null} The created group element, or null on failure
	 */
	renderIconIntoSVGGroup(pIconKey, pParentGroup, pX, pY, pSize)
	{
		if (!pParentGroup)
		{
			return null;
		}

		let tmpSize = pSize || 16;
		let tmpScale = tmpSize / 24;
		let tmpKey = pIconKey || 'default';
		let tmpMarkup = this._Icons[tmpKey] || this._Icons['default'];

		// Replace size placeholder (for consistency, though we scale via transform)
		tmpMarkup = tmpMarkup.replace(/\{FlowIconSize\}/g, '24');

		try
		{
			// Create a temporary SVG element to parse the icon markup
			let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			tmpTempSVG.innerHTML = tmpMarkup;

			// Find the inner SVG (the icon's root <svg> element)
			let tmpInnerSVG = tmpTempSVG.querySelector('svg');
			if (!tmpInnerSVG)
			{
				return null;
			}

			// Create a group to hold the icon content
			let tmpGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
			tmpGroup.setAttribute('transform', 'translate(' + pX + ',' + pY + ') scale(' + tmpScale + ')');
			tmpGroup.setAttribute('pointer-events', 'none');
			tmpGroup.setAttribute('class', 'pict-flow-icon-svg');

			// Move all children from the parsed SVG into the group
			while (tmpInnerSVG.childNodes.length > 0)
			{
				tmpGroup.appendChild(tmpInnerSVG.childNodes[0]);
			}

			pParentGroup.appendChild(tmpGroup);
			return tmpGroup;
		}
		catch (pError)
		{
			this.log.warn('PictProviderFlowIcons renderIconIntoSVGGroup error: ' + pError.message);
			return null;
		}
	}

	/**
	 * Get all registered icon keys.
	 * @returns {Array<string>}
	 */
	getIconKeys()
	{
		return Object.keys(this._Icons);
	}

	/**
	 * Check if a given key has a registered icon.
	 * @param {string} pIconKey
	 * @returns {boolean}
	 */
	hasIcon(pIconKey)
	{
		return this._Icons.hasOwnProperty(pIconKey);
	}

	/**
	 * Register a new icon or override an existing one.
	 * @param {string} pIconKey - The icon key
	 * @param {string} pSVGMarkup - The SVG markup string (must contain {FlowIconSize} placeholders)
	 * @returns {boolean}
	 */
	registerIcon(pIconKey, pSVGMarkup)
	{
		if (!pIconKey || !pSVGMarkup)
		{
			return false;
		}

		this._Icons[pIconKey] = pSVGMarkup;

		// Also update the pict template if TemplateProvider is available
		if (this.fable && this.fable.TemplateProvider)
		{
			this.fable.TemplateProvider.addTemplate('Flow-Icon-' + pIconKey, pSVGMarkup);
		}

		return true;
	}
}

module.exports = PictProviderFlowIcons;

module.exports.default_configuration = _ProviderConfiguration;
module.exports.DefaultIcons = _DefaultIcons;

},{"fable-serviceproviderbase":2}],40:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowLayouts'
};

/**
 * Provider for managing saved flow diagram layouts.
 *
 * Layouts capture the spatial arrangement of nodes and panels on the canvas
 * without storing any card content. When a layout is restored, nodes that
 * still exist are placed at their saved positions and any new nodes are
 * auto-laid-out to the right.
 *
 * ## Persistence
 *
 * By default, layouts are persisted to the browser's `localStorage` using a
 * key derived from the flow view identifier. This means layouts survive page
 * refreshes out of the box.
 *
 * Developers can override the storage backend (e.g., to use a REST API or
 * IndexedDB) by replacing the three storage hook methods on the instance or
 * in a subclass:
 *
 *   - `storageWrite(pLayouts, fCallback)` — persist the full layout array
 *   - `storageRead(fCallback)` — load the persisted layout array
 *   - `storageDelete(fCallback)` — remove all persisted layouts
 *
 * Each callback follows the Node convention: `fCallback(pError, pResult)`.
 *
 * Saved layout data structure:
 * {
 *     Hash: "layout-<UUID>",
 *     Name: "My Layout",
 *     CreatedAt: "2026-02-26T12:00:00.000Z",
 *     NodePositions: { "node-hash": { X, Y, Width, Height } },
 *     PanelPositions: { "node-hash": { X, Y, Width, Height } },
 *     ViewState: { PanX, PanY, Zoom }
 * }
 */
class PictProviderFlowLayouts extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowLayouts';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Storage key for localStorage persistence.
		// Defaults to a key derived from the FlowView identifier, or can be
		// set via options.StorageKey.  Pass `false` to disable localStorage.
		if (pOptions && pOptions.StorageKey !== undefined)
		{
			this._StorageKey = pOptions.StorageKey;
		}
		else if (this._FlowView && this._FlowView.options && this._FlowView.options.ViewIdentifier)
		{
			this._StorageKey = `pict-flow-layouts-${this._FlowView.options.ViewIdentifier}`;
		}
		else
		{
			this._StorageKey = 'pict-flow-layouts';
		}
	}

	// ── Storage Hooks ─────────────────────────────────────────────────────
	// These three methods form the persistence contract.  The default
	// implementation uses localStorage.  Override them on the instance or
	// subclass to use a REST API, IndexedDB, or any other backend.
	//
	// All callbacks follow `fCallback(pError, pResult)`.

	/**
	 * Persist the full array of layout objects.
	 *
	 * Default implementation writes JSON to `localStorage`.
	 *
	 * @param {Array} pLayouts - The array of layout objects to persist
	 * @param {Function} fCallback - `function(pError)` called when done
	 */
	storageWrite(pLayouts, fCallback)
	{
		if (this._StorageKey === false)
		{
			return fCallback(null);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				localStorage.setItem(this._StorageKey, JSON.stringify(pLayouts));
			}
			return fCallback(null);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageWrite error: ${pError.message}`);
			return fCallback(pError);
		}
	}

	/**
	 * Load the persisted array of layout objects.
	 *
	 * Default implementation reads JSON from `localStorage`.
	 *
	 * @param {Function} fCallback - `function(pError, pLayouts)` where
	 *        pLayouts is an Array (or null/empty if nothing stored)
	 */
	storageRead(fCallback)
	{
		if (this._StorageKey === false)
		{
			return fCallback(null, []);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				let tmpRaw = localStorage.getItem(this._StorageKey);
				if (tmpRaw)
				{
					let tmpParsed = JSON.parse(tmpRaw);
					if (Array.isArray(tmpParsed))
					{
						return fCallback(null, tmpParsed);
					}
				}
			}
			return fCallback(null, []);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageRead error: ${pError.message}`);
			return fCallback(pError, []);
		}
	}

	/**
	 * Remove all persisted layout data.
	 *
	 * Default implementation removes the key from `localStorage`.
	 *
	 * @param {Function} fCallback - `function(pError)` called when done
	 */
	storageDelete(fCallback)
	{
		if (this._StorageKey === false)
		{
			return fCallback(null);
		}
		try
		{
			if (typeof localStorage !== 'undefined')
			{
				localStorage.removeItem(this._StorageKey);
			}
			return fCallback(null);
		}
		catch (pError)
		{
			this.log.warn(`PictProviderFlowLayouts storageDelete error: ${pError.message}`);
			return fCallback(pError);
		}
	}

	// ── Initialization ────────────────────────────────────────────────────

	/**
	 * Load persisted layouts and merge them into _FlowData.SavedLayouts.
	 * Layouts already present in _FlowData (e.g., from setFlowData) are
	 * kept; persisted layouts with new hashes are appended.
	 *
	 * Call this after _FlowData is populated.
	 */
	loadPersistedLayouts()
	{
		this.storageRead((pError, pLayouts) =>
		{
			if (pError || !Array.isArray(pLayouts) || pLayouts.length === 0)
			{
				return;
			}

			if (!this._FlowView || !this._FlowView._FlowData)
			{
				return;
			}

			let tmpExisting = this._FlowView._FlowData.SavedLayouts;
			let tmpExistingHashes = {};
			for (let i = 0; i < tmpExisting.length; i++)
			{
				tmpExistingHashes[tmpExisting[i].Hash] = true;
			}

			let tmpAdded = 0;
			for (let i = 0; i < pLayouts.length; i++)
			{
				if (!tmpExistingHashes[pLayouts[i].Hash])
				{
					tmpExisting.push(pLayouts[i]);
					tmpAdded++;
				}
			}

			if (tmpAdded > 0)
			{
				this.log.trace(`PictProviderFlowLayouts loaded ${tmpAdded} persisted layout(s)`);
			}
		});
	}

	// ── Public API ────────────────────────────────────────────────────────

	/**
	 * Save the current node and panel positions as a named layout.
	 * @param {string} pName - The display name for this layout
	 * @returns {Object} The saved layout entry
	 */
	saveLayout(pName)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts saveLayout: no FlowView reference');
			return null;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpLayoutHash = `layout-${this.fable.getUUID()}`;
		let tmpNodePositions = {};
		let tmpPanelPositions = {};

		// Capture node positions and per-instance overrides (Title, Style)
		for (let i = 0; i < tmpFlowData.Nodes.length; i++)
		{
			let tmpNode = tmpFlowData.Nodes[i];
			tmpNodePositions[tmpNode.Hash] =
			{
				X: tmpNode.X,
				Y: tmpNode.Y,
				Width: tmpNode.Width,
				Height: tmpNode.Height,
				Title: tmpNode.Title
			};

			// Only include Style if it has been customized
			if (tmpNode.Style && Object.keys(tmpNode.Style).length > 0)
			{
				tmpNodePositions[tmpNode.Hash].Style = JSON.parse(JSON.stringify(tmpNode.Style));
			}
		}

		// Capture panel positions keyed by NodeHash (panels get new hashes on each open)
		for (let i = 0; i < tmpFlowData.OpenPanels.length; i++)
		{
			let tmpPanel = tmpFlowData.OpenPanels[i];
			tmpPanelPositions[tmpPanel.NodeHash] =
			{
				X: tmpPanel.X,
				Y: tmpPanel.Y,
				Width: tmpPanel.Width,
				Height: tmpPanel.Height
			};
		}

		let tmpLayout =
		{
			Hash: tmpLayoutHash,
			Name: pName || 'Untitled Layout',
			CreatedAt: new Date().toISOString(),
			NodePositions: tmpNodePositions,
			PanelPositions: tmpPanelPositions,
			ViewState:
			{
				PanX: tmpFlowData.ViewState.PanX,
				PanY: tmpFlowData.ViewState.PanY,
				Zoom: tmpFlowData.ViewState.Zoom
			}
		};

		tmpFlowData.SavedLayouts.push(tmpLayout);
		this._FlowView.marshalFromView();

		// Persist to storage
		this.storageWrite(tmpFlowData.SavedLayouts, (pError) =>
		{
			if (pError)
			{
				this.log.warn(`PictProviderFlowLayouts: failed to persist after save: ${pError.message}`);
			}
		});

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutSaved', tmpLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts saved layout '${tmpLayout.Name}' (${tmpLayout.Hash})`);

		return tmpLayout;
	}

	/**
	 * Restore a saved layout by hash.
	 * Nodes present in the saved layout are placed at their saved positions.
	 * Nodes not in the saved layout are auto-laid-out to the right of the
	 * positioned nodes.
	 * @param {string} pLayoutHash - The hash of the layout to restore
	 * @returns {boolean} Whether the layout was restored
	 */
	restoreLayout(pLayoutHash)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts restoreLayout: no FlowView reference');
			return false;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpLayout = tmpFlowData.SavedLayouts.find(
			(pLayout) => pLayout.Hash === pLayoutHash
		);

		if (!tmpLayout)
		{
			this.log.warn(`PictProviderFlowLayouts restoreLayout: layout '${pLayoutHash}' not found`);
			return false;
		}

		let tmpMatchedNodes = [];
		let tmpUnmatchedNodes = [];

		// Apply saved positions to matched nodes; collect unmatched ones
		for (let i = 0; i < tmpFlowData.Nodes.length; i++)
		{
			let tmpNode = tmpFlowData.Nodes[i];
			let tmpSaved = tmpLayout.NodePositions[tmpNode.Hash];

			if (tmpSaved)
			{
				tmpNode.X = tmpSaved.X;
				tmpNode.Y = tmpSaved.Y;
				if (typeof tmpSaved.Width === 'number') tmpNode.Width = tmpSaved.Width;
				if (typeof tmpSaved.Height === 'number') tmpNode.Height = tmpSaved.Height;
				if (typeof tmpSaved.Title === 'string') tmpNode.Title = tmpSaved.Title;
				if (tmpSaved.Style && typeof tmpSaved.Style === 'object')
				{
					tmpNode.Style = JSON.parse(JSON.stringify(tmpSaved.Style));
				}
				tmpMatchedNodes.push(tmpNode);
			}
			else
			{
				tmpUnmatchedNodes.push(tmpNode);
			}
		}

		// Apply saved panel positions (keyed by NodeHash)
		if (tmpLayout.PanelPositions)
		{
			for (let i = 0; i < tmpFlowData.OpenPanels.length; i++)
			{
				let tmpPanel = tmpFlowData.OpenPanels[i];
				let tmpSavedPanel = tmpLayout.PanelPositions[tmpPanel.NodeHash];

				if (tmpSavedPanel)
				{
					tmpPanel.X = tmpSavedPanel.X;
					tmpPanel.Y = tmpSavedPanel.Y;
					if (typeof tmpSavedPanel.Width === 'number') tmpPanel.Width = tmpSavedPanel.Width;
					if (typeof tmpSavedPanel.Height === 'number') tmpPanel.Height = tmpSavedPanel.Height;
				}
			}
		}

		// Auto-layout unmatched nodes to the right of positioned nodes
		if (tmpUnmatchedNodes.length > 0 && this._FlowView._LayoutService)
		{
			this._FlowView._LayoutService.autoLayoutSubset(
				tmpUnmatchedNodes,
				tmpMatchedNodes,
				tmpFlowData.Connections
			);
		}

		// Restore view state (camera position)
		if (tmpLayout.ViewState)
		{
			if (typeof tmpLayout.ViewState.PanX === 'number')
			{
				tmpFlowData.ViewState.PanX = tmpLayout.ViewState.PanX;
			}
			if (typeof tmpLayout.ViewState.PanY === 'number')
			{
				tmpFlowData.ViewState.PanY = tmpLayout.ViewState.PanY;
			}
			if (typeof tmpLayout.ViewState.Zoom === 'number')
			{
				tmpFlowData.ViewState.Zoom = tmpLayout.ViewState.Zoom;
			}
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutRestored', tmpLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts restored layout '${tmpLayout.Name}' (${tmpLayout.Hash})`);

		return true;
	}

	/**
	 * Delete a saved layout by hash.
	 * @param {string} pLayoutHash - The hash of the layout to delete
	 * @returns {boolean} Whether the layout was deleted
	 */
	deleteLayout(pLayoutHash)
	{
		if (!this._FlowView)
		{
			this.log.warn('PictProviderFlowLayouts deleteLayout: no FlowView reference');
			return false;
		}

		let tmpFlowData = this._FlowView._FlowData;
		let tmpIndex = tmpFlowData.SavedLayouts.findIndex(
			(pLayout) => pLayout.Hash === pLayoutHash
		);

		if (tmpIndex < 0)
		{
			this.log.warn(`PictProviderFlowLayouts deleteLayout: layout '${pLayoutHash}' not found`);
			return false;
		}

		let tmpRemovedLayout = tmpFlowData.SavedLayouts.splice(tmpIndex, 1)[0];
		this._FlowView.marshalFromView();

		// Persist to storage (with the layout removed)
		this.storageWrite(tmpFlowData.SavedLayouts, (pError) =>
		{
			if (pError)
			{
				this.log.warn(`PictProviderFlowLayouts: failed to persist after delete: ${pError.message}`);
			}
		});

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onLayoutDeleted', tmpRemovedLayout);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', tmpFlowData);
		}

		this.log.trace(`PictProviderFlowLayouts deleted layout '${tmpRemovedLayout.Name}' (${tmpRemovedLayout.Hash})`);

		return true;
	}

	/**
	 * Get the list of saved layouts.
	 * @returns {Array} Array of saved layout objects
	 */
	getLayouts()
	{
		if (!this._FlowView) return [];
		return this._FlowView._FlowData.SavedLayouts;
	}

	/**
	 * Get a specific saved layout by hash.
	 * @param {string} pLayoutHash
	 * @returns {Object|null}
	 */
	getLayout(pLayoutHash)
	{
		if (!this._FlowView) return null;
		return this._FlowView._FlowData.SavedLayouts.find(
			(pLayout) => pLayout.Hash === pLayoutHash
		) || null;
	}
}

module.exports = PictProviderFlowLayouts;

module.exports.default_configuration = _ProviderConfiguration;

},{"pict-provider":19}],41:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const _DefaultNodeTypes =
{
	'default':
	{
		Hash: 'default',
		Label: 'Default',
		DefaultWidth: 180,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' },
			{ Hash: null, Direction: 'output', Side: 'right', Label: 'Out' }
		],
		TitleBarColor: '#2c3e50',
		BodyStyle: {}
	},
	'start':
	{
		Hash: 'start',
		Label: 'Start',
		DefaultWidth: 140,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'output', Side: 'right', Label: 'Out' }
		],
		TitleBarColor: '#27ae60',
		BodyStyle:
		{
			'fill': '#eafaf1',
			'stroke': '#27ae60'
		}
	},
	'end':
	{
		Hash: 'end',
		Label: 'End',
		DefaultWidth: 140,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' }
		],
		TitleBarColor: '#1abc9c',
		BodyStyle:
		{
			'fill': '#e8f8f5',
			'stroke': '#1abc9c'
		}
	},
	'halt':
	{
		Hash: 'halt',
		Label: 'Halt',
		DefaultWidth: 140,
		DefaultHeight: 80,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' }
		],
		TitleBarColor: '#e74c3c',
		BodyStyle:
		{
			'fill': '#fdedec',
			'stroke': '#e74c3c'
		}
	},
	'decision':
	{
		Hash: 'decision',
		Label: 'Decision',
		DefaultWidth: 200,
		DefaultHeight: 100,
		DefaultPorts:
		[
			{ Hash: null, Direction: 'input', Side: 'left', Label: 'In' },
			{ Hash: null, Direction: 'output', Side: 'right', Label: 'Yes' },
			{ Hash: null, Direction: 'output', Side: 'bottom', Label: 'No' }
		],
		TitleBarColor: '#f39c12',
		BodyStyle:
		{
			'fill': '#fff9e6',
			'stroke': '#f39c12'
		}
	}
};

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowNodeTypes'
};

class PictProviderFlowNodeTypes extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowNodeTypes';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Initialize with default node types unless explicitly disabled
		if (pOptions && pOptions.IncludeDefaultNodeTypes === false)
		{
			this._NodeTypes = {};
		}
		else
		{
			this._NodeTypes = JSON.parse(JSON.stringify(_DefaultNodeTypes));
		}

		// Merge any additional node types passed in via options
		if (pOptions && pOptions.AdditionalNodeTypes && typeof pOptions.AdditionalNodeTypes === 'object')
		{
			let tmpAdditionalKeys = Object.keys(pOptions.AdditionalNodeTypes);
			for (let i = 0; i < tmpAdditionalKeys.length; i++)
			{
				let tmpOriginal = pOptions.AdditionalNodeTypes[tmpAdditionalKeys[i]];
				this._NodeTypes[tmpAdditionalKeys[i]] = Object.assign(
					{},
					this._NodeTypes[tmpAdditionalKeys[i]] || {},
					JSON.parse(JSON.stringify(tmpOriginal))
				);
				// Preserve BodyContent.RenderCallback (functions are stripped by JSON serialization)
				if (tmpOriginal.BodyContent && typeof tmpOriginal.BodyContent.RenderCallback === 'function')
				{
					if (!this._NodeTypes[tmpAdditionalKeys[i]].BodyContent)
					{
						this._NodeTypes[tmpAdditionalKeys[i]].BodyContent = {};
					}
					this._NodeTypes[tmpAdditionalKeys[i]].BodyContent.RenderCallback = tmpOriginal.BodyContent.RenderCallback;
				}
			}
		}
	}

	/**
	 * Get a node type configuration by hash
	 * @param {string} pTypeHash - The node type hash
	 * @returns {Object|null} The node type configuration
	 */
	getNodeType(pTypeHash)
	{
		return this._NodeTypes[pTypeHash] || this._NodeTypes['default'];
	}

	/**
	 * Register a new node type or override an existing one
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 * @returns {boolean}
	 */
	registerNodeType(pNodeTypeConfig)
	{
		if (!pNodeTypeConfig || !pNodeTypeConfig.Hash)
		{
			this.log.warn('PictProviderFlowNodeTypes registerNodeType: invalid config (missing Hash)');
			return false;
		}

		this._NodeTypes[pNodeTypeConfig.Hash] = Object.assign(
			{},
			this._NodeTypes[pNodeTypeConfig.Hash] || {},
			pNodeTypeConfig
		);

		return true;
	}

	/**
	 * Remove a node type
	 * @param {string} pTypeHash
	 * @returns {boolean}
	 */
	removeNodeType(pTypeHash)
	{
		if (pTypeHash === 'default')
		{
			this.log.warn('PictProviderFlowNodeTypes: cannot remove the default node type');
			return false;
		}

		if (this._NodeTypes[pTypeHash])
		{
			delete this._NodeTypes[pTypeHash];
			return true;
		}

		return false;
	}

	/**
	 * Get all registered node types
	 * @returns {Object} Map of type hash to type configuration
	 */
	getNodeTypes()
	{
		return JSON.parse(JSON.stringify(this._NodeTypes));
	}

	/**
	 * Get a list of node type hashes
	 * @returns {Array<string>}
	 */
	getNodeTypeList()
	{
		return Object.keys(this._NodeTypes);
	}

	/**
	 * Get all enabled node types that have FlowCard metadata.
	 * Returns only types that are cards and whose Enabled flag is true.
	 * @returns {Array<Object>} Array of node type configurations
	 */
	getEnabledCards()
	{
		let tmpCards = [];
		let tmpKeys = Object.keys(this._NodeTypes);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpType = this._NodeTypes[tmpKeys[i]];
			if (tmpType.CardMetadata)
			{
				if (tmpType.CardMetadata.Enabled !== false)
				{
					tmpCards.push(JSON.parse(JSON.stringify(tmpType)));
				}
			}
		}
		return tmpCards;
	}

	/**
	 * Get all enabled cards grouped by category.
	 * @returns {Object} Map of category name to array of node type configurations
	 */
	getCardsByCategory()
	{
		let tmpCards = this.getEnabledCards();
		let tmpCategories = {};
		for (let i = 0; i < tmpCards.length; i++)
		{
			let tmpCategory = (tmpCards[i].CardMetadata && tmpCards[i].CardMetadata.Category)
				? tmpCards[i].CardMetadata.Category
				: 'General';
			if (!tmpCategories[tmpCategory])
			{
				tmpCategories[tmpCategory] = [];
			}
			tmpCategories[tmpCategory].push(tmpCards[i]);
		}
		return tmpCategories;
	}

	/**
	 * Check whether a node type hash refers to a FlowCard (has CardMetadata).
	 * @param {string} pTypeHash
	 * @returns {boolean}
	 */
	isFlowCard(pTypeHash)
	{
		let tmpType = this._NodeTypes[pTypeHash];
		return !!(tmpType && tmpType.CardMetadata);
	}
}

module.exports = PictProviderFlowNodeTypes;

module.exports.default_configuration = _ProviderConfiguration;
module.exports.DefaultNodeTypes = _DefaultNodeTypes;

},{"pict-provider":19}],42:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowNoise'
};

/**
 * PictProvider-Flow-Noise
 *
 * Deterministic noise/jitter generator for hand-drawn visual effects.
 *
 * Uses seeded pseudo-random number generation so that the same node or
 * connection always receives the same jitter values across re-renders,
 * preventing visual "jumping" while still looking organic.
 */
class PictProviderFlowNoise extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowNoise';
	}

	// ── Hashing / PRNG ────────────────────────────────────────────────────

	/**
	 * Convert a string to a 32-bit integer hash (djb2 algorithm).
	 * @param {string} pStr
	 * @returns {number}
	 */
	hashString(pStr)
	{
		let tmpHash = 5381;
		for (let i = 0; i < pStr.length; i++)
		{
			tmpHash = ((tmpHash << 5) + tmpHash) + pStr.charCodeAt(i);
			tmpHash = tmpHash & tmpHash; // Convert to 32-bit integer
		}
		return tmpHash >>> 0; // Ensure unsigned
	}

	/**
	 * Create a seeded pseudo-random number generator (Mulberry32).
	 * Returns a function that produces deterministic floats in [0, 1).
	 * @param {number} pSeed - 32-bit integer seed
	 * @returns {Function}
	 */
	seededRandom(pSeed)
	{
		let tmpSeed = pSeed | 0;
		return function()
		{
			tmpSeed = tmpSeed + 0x6D2B79F5 | 0;
			let t = Math.imul(tmpSeed ^ tmpSeed >>> 15, 1 | tmpSeed);
			t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
			return ((t ^ t >>> 14) >>> 0) / 4294967296;
		};
	}

	// ── Point Jitter ──────────────────────────────────────────────────────

	/**
	 * Apply random jitter to a point.
	 * @param {number} pX
	 * @param {number} pY
	 * @param {number} pAmplitude - Maximum offset in pixels
	 * @param {Function} pRNG - Seeded random function
	 * @returns {{x: number, y: number}}
	 */
	jitterPoint(pX, pY, pAmplitude, pRNG)
	{
		if (pAmplitude <= 0)
		{
			return { x: pX, y: pY };
		}
		return {
			x: pX + pAmplitude * (pRNG() - 0.5) * 2,
			y: pY + pAmplitude * (pRNG() - 0.5) * 2
		};
	}

	// ── Bracket Path Generation ───────────────────────────────────────────

	/**
	 * Generate an SVG path `d` string for a bracket-shaped node border.
	 *
	 * Draws true bracket shapes — `[` on the left and `]` on the right —
	 * with NO top/bottom connecting lines.  The serifs (horizontal turns)
	 * extend inward from each corner, giving a distinctive hand-drawn
	 * technical-diagram look that is immediately distinguishable from a
	 * regular rectangle at any zoom level.
	 *
	 * The bracket consists of:
	 * - Left bracket `[`: top serif → vertical left side → bottom serif
	 * - Right bracket `]`: top serif → vertical right side → bottom serif
	 * - Optional title divider line across the full width
	 *
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pSerifLength - Length of corner serifs in px
	 * @param {number} pTitleBarHeight - Height of title bar (0 to skip divider)
	 * @param {number} pAmplitude - Noise amplitude (0 = precise)
	 * @param {string} pSeedString - Hash string for deterministic noise
	 * @returns {string} SVG path d attribute
	 */
	generateBracketPath(pWidth, pHeight, pSerifLength, pTitleBarHeight, pAmplitude, pSeedString)
	{
		let tmpRNG = this.seededRandom(this.hashString(pSeedString || 'default'));
		let tmpS = pSerifLength || 18;
		let tmpW = pWidth;
		let tmpH = pHeight;

		let tmpJ = (pX, pY) =>
		{
			return this.jitterPoint(pX, pY, pAmplitude, tmpRNG);
		};

		// Left bracket `[`: top serif → down left side → bottom serif
		let tmpTL_serif = tmpJ(tmpS, 0);
		let tmpTL_corner = tmpJ(0, 0);
		let tmpBL_corner = tmpJ(0, tmpH);
		let tmpBL_serif = tmpJ(tmpS, tmpH);

		// Right bracket `]`: top serif → down right side → bottom serif
		let tmpTR_serif = tmpJ(tmpW - tmpS, 0);
		let tmpTR_corner = tmpJ(tmpW, 0);
		let tmpBR_corner = tmpJ(tmpW, tmpH);
		let tmpBR_serif = tmpJ(tmpW - tmpS, tmpH);

		let tmpPath = '';

		// Left bracket `[`
		tmpPath += `M ${tmpTL_serif.x.toFixed(1)} ${tmpTL_serif.y.toFixed(1)}`;
		tmpPath += ` L ${tmpTL_corner.x.toFixed(1)} ${tmpTL_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBL_corner.x.toFixed(1)} ${tmpBL_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBL_serif.x.toFixed(1)} ${tmpBL_serif.y.toFixed(1)}`;

		// Right bracket `]`
		tmpPath += ` M ${tmpTR_serif.x.toFixed(1)} ${tmpTR_serif.y.toFixed(1)}`;
		tmpPath += ` L ${tmpTR_corner.x.toFixed(1)} ${tmpTR_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBR_corner.x.toFixed(1)} ${tmpBR_corner.y.toFixed(1)}`;
		tmpPath += ` L ${tmpBR_serif.x.toFixed(1)} ${tmpBR_serif.y.toFixed(1)}`;

		// No horizontal lines — the title bar fill rect provides visual
		// separation via its background color.  The bracket outline is
		// purely the `[` and `]` shapes on the sides.

		return tmpPath;
	}

	// ── Path Jitter (for connections) ─────────────────────────────────────

	/**
	 * Apply jitter to an existing SVG path string by offsetting coordinate
	 * pairs.  The first M and last coordinate pair receive reduced jitter
	 * to keep connections aligned with their port anchors.
	 *
	 * @param {string} pPathString - SVG path d attribute
	 * @param {number} pAmplitude - Noise amplitude (0 = no change)
	 * @param {string} pSeedString - Hash string for deterministic noise
	 * @returns {string} Modified path string
	 */
	jitterPath(pPathString, pAmplitude, pSeedString)
	{
		if (pAmplitude <= 0 || !pPathString)
		{
			return pPathString;
		}

		let tmpRNG = this.seededRandom(this.hashString(pSeedString || 'path'));

		// Parse path into tokens: commands and numbers
		let tmpTokens = pPathString.match(/[MLCQZmlcqz]|[-+]?[0-9]*\.?[0-9]+/g);
		if (!tmpTokens)
		{
			return pPathString;
		}

		// Collect all numeric coordinate indices
		let tmpNumericIndices = [];
		for (let i = 0; i < tmpTokens.length; i++)
		{
			if (/^[-+]?[0-9]*\.?[0-9]+$/.test(tmpTokens[i]))
			{
				tmpNumericIndices.push(i);
			}
		}

		// Process pairs of coordinates (x, y)
		for (let i = 0; i < tmpNumericIndices.length - 1; i += 2)
		{
			let tmpXIdx = tmpNumericIndices[i];
			let tmpYIdx = tmpNumericIndices[i + 1];

			// Reduce jitter for first and last coordinate pairs (port anchors)
			let tmpLocalAmplitude = pAmplitude;
			if (i === 0 || i >= tmpNumericIndices.length - 2)
			{
				tmpLocalAmplitude = pAmplitude * 0.15; // Minimal anchor jitter
			}
			else if (i === 2 || i >= tmpNumericIndices.length - 4)
			{
				tmpLocalAmplitude = pAmplitude * 0.5; // Reduced near anchors
			}

			let tmpX = parseFloat(tmpTokens[tmpXIdx]);
			let tmpY = parseFloat(tmpTokens[tmpYIdx]);
			let tmpJittered = this.jitterPoint(tmpX, tmpY, tmpLocalAmplitude, tmpRNG);

			tmpTokens[tmpXIdx] = tmpJittered.x.toFixed(1);
			tmpTokens[tmpYIdx] = tmpJittered.y.toFixed(1);
		}

		// Reassemble path string with spaces
		let tmpResult = '';
		for (let i = 0; i < tmpTokens.length; i++)
		{
			if (i > 0 && /^[MLCQZmlcqz]$/.test(tmpTokens[i]))
			{
				tmpResult += ' ' + tmpTokens[i];
			}
			else if (i > 0)
			{
				tmpResult += ' ' + tmpTokens[i];
			}
			else
			{
				tmpResult += tmpTokens[i];
			}
		}

		return tmpResult;
	}
}

module.exports = PictProviderFlowNoise;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":2}],43:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-PanelChrome
 *
 * Template-based provider for creating the panel chrome (the foreignObject
 * wrapper, title bar, close button, and body container) for properties panels.
 *
 * Replaces the raw DOM API approach with a configuration template
 * (Flow-PanelChrome-Template) registered in the FlowView's template set.
 */
class PictProviderFlowPanelChrome extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowPanelChrome';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Create a foreignObject containing the panel chrome and empty body container.
	 *
	 * Uses the Flow-PanelChrome-Template registered in the FlowView configuration
	 * to render the inner HTML (title bar, close button, body container), then
	 * attaches event isolation listeners so pointer and wheel events inside the
	 * panel body do not propagate to the SVG interaction layer.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels (Hash, NodeHash, X, Y, Width, Height, Title)
	 * @param {SVGGElement} pPanelsLayer - The SVG <g> for panel foreignObjects
	 * @returns {HTMLDivElement} The panel body container element for content rendering
	 */
	createPanelForeignObject(pPanelData, pPanelsLayer)
	{
		let tmpSVGHelper = this._FlowView._SVGHelperProvider;

		// Create the SVG foreignObject wrapper
		let tmpFO = tmpSVGHelper.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-panel-foreign-object');
		tmpFO.setAttribute('data-panel-hash', pPanelData.Hash);
		tmpFO.setAttribute('data-node-hash', pPanelData.NodeHash);
		tmpFO.setAttribute('x', String(pPanelData.X));
		tmpFO.setAttribute('y', String(pPanelData.Y));
		tmpFO.setAttribute('width', String(pPanelData.Width));
		tmpFO.setAttribute('height', String(pPanelData.Height));

		// Render the panel chrome from the configuration template
		let tmpPict = this._FlowView.pict || this._FlowView.fable;
		let tmpTitle = pPanelData.Title || 'Properties';
		let tmpChromeHTML = tmpPict.parseTemplateByHash('Flow-PanelChrome-Template',
			{ Hash: pPanelData.Hash, Title: tmpTitle });

		tmpFO.innerHTML = tmpChromeHTML;

		// Populate the close button icon
		let tmpCloseIcon = tmpFO.querySelector('.pict-flow-panel-close-icon');
		if (tmpCloseIcon && this._FlowView && this._FlowView._IconProvider)
		{
			tmpCloseIcon.innerHTML = this._FlowView._IconProvider.getIconSVGMarkup('close', 12);
		}
		else if (tmpCloseIcon)
		{
			tmpCloseIcon.textContent = '\u2715';
		}

		// Attach event isolation to the scrollable content area so
		// pointer/wheel events inside the panel do not trigger SVG interactions
		let tmpContent = tmpFO.querySelector('.pict-flow-panel-content');
		if (tmpContent)
		{
			tmpContent.addEventListener('pointerdown', (pEvent) => { pEvent.stopPropagation(); });
			tmpContent.addEventListener('wheel', (pEvent) => { pEvent.stopPropagation(); });
		}

		// Isolate events on the tab bar
		let tmpTabbar = tmpFO.querySelector('.pict-flow-panel-tabbar');
		if (tmpTabbar)
		{
			tmpTabbar.addEventListener('pointerdown', (pEvent) => { pEvent.stopPropagation(); });
			tmpTabbar.addEventListener('wheel', (pEvent) => { pEvent.stopPropagation(); });
		}

		pPanelsLayer.appendChild(tmpFO);

		// Return the properties tab pane as the body container for content rendering
		let tmpPropertiesPane = tmpFO.querySelector('.pict-flow-panel-tab-pane[data-tab="properties"]');
		return tmpPropertiesPane;
	}
}

module.exports = PictProviderFlowPanelChrome;

},{"fable-serviceproviderbase":2}],44:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictProvider-Flow-SVGHelpers
 *
 * Shared SVG element creation utility used by all flow components
 * that need to create SVG namespace elements (nodes, connections, tethers).
 */
class PictProviderFlowSVGHelpers extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowSVGHelpers';
	}

	/**
	 * Create an SVG namespace element.
	 *
	 * @param {string} pTagName - The SVG element tag name (e.g., 'path', 'circle', 'g', 'rect', 'text')
	 * @returns {SVGElement}
	 */
	createSVGElement(pTagName)
	{
		return document.createElementNS('http://www.w3.org/2000/svg', pTagName);
	}
}

module.exports = PictProviderFlowSVGHelpers;

},{"fable-serviceproviderbase":2}],45:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'PictProviderFlowTheme'
};

/**
 * PictProvider-Flow-Theme
 *
 * Central orchestrator for the flow diagram theming system.
 *
 * Holds a registry of theme definitions, manages the active theme,
 * and provides hooks for node body rendering and path noise processing.
 *
 * ## Usage
 *
 * ```javascript
 * flowView.setTheme('sketch');       // Switch to hand-drawn style
 * flowView.setNoiseLevel(0.6);       // Increase bracket/connection wobble
 * flowView.setTheme('default');      // Restore modern style
 * ```
 *
 * ## Custom Themes
 *
 * ```javascript
 * flowView._ThemeProvider.registerTheme('custom', {
 *     Key: 'custom',
 *     Label: 'My Custom Theme',
 *     CSSVariables: { '--pf-canvas-bg': '#222' },
 *     NodeBodyMode: 'rect',
 *     NoiseConfig: { Enabled: false }
 * });
 * flowView.setTheme('custom');
 * ```
 */
class PictProviderFlowTheme extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _ProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictProviderFlowTheme';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._ActiveThemeKey = 'default';
		this._NoiseLevel = 0;
		this._Themes = {};

		this._registerBuiltInThemes();
	}

	// ── Theme Registry ────────────────────────────────────────────────────

	_registerBuiltInThemes()
	{
		// ── 1. Default (Modern) ──────────────────────────────────────
		this._Themes['default'] =
		{
			Key: 'default',
			Label: 'Modern',
			CSSVariables: {},
			AdditionalCSS: '',
			NodeBodyMode: 'rect',
			BracketConfig: null,
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides: {}
		};

		// ── 2. Sketch (Hand-drawn) ───────────────────────────────────
		this._Themes['sketch'] =
		{
			Key: 'sketch',
			Label: 'Sketch',
			CSSVariables:
			{
				'--pf-node-body-fill': '#fffef5',
				'--pf-node-body-stroke': '#444444',
				'--pf-node-body-stroke-width': '1.5',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'none',
				'--pf-node-shadow-hover': 'none',
				'--pf-node-shadow-selected': 'none',
				'--pf-node-shadow-dragging': 'none',
				'--pf-node-title-fill': '#333333',
				'--pf-node-title-size': '12px',
				'--pf-node-title-weight': '400',
				'--pf-node-title-bar-color': '#f0ece0',
				'--pf-node-type-label-fill': '#888888',
				'--pf-node-selected-stroke': '#2255aa',
				'--pf-port-input-fill': '#5577bb',
				'--pf-port-output-fill': '#55aa77',
				'--pf-port-stroke': '#fffef5',
				'--pf-connection-stroke': '#555555',
				'--pf-connection-selected-stroke': '#2255aa',
				'--pf-canvas-bg': '#fffef5',
				'--pf-grid-stroke': '#e8e4d8',
				'--pf-panel-bg': '#fffef5',
				'--pf-panel-border': '#ccccaa',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': '2px 2px 0px rgba(0,0,0,0.08)',
				'--pf-panel-titlebar-bg': '#f0ece0',
				'--pf-panel-titlebar-border': '#ccccaa',
				'--pf-panel-title-color': '#333333'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "Courier New", "Courier", monospace !important;
				}
				.pict-flow-panel-title-text,
				.pict-flow-panel-node-props-title,
				.pict-flow-info-panel {
					font-family: "Courier New", "Courier", monospace !important;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) !important;
				}
			`,
			NodeBodyMode: 'bracket',
			BracketConfig:
			{
				SerifLength: 20,
				TitleSeparator: true
			},
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 1.5,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: true,
				DefaultLevel: 0.4,
				MaxJitterPx: 4,
				AffectsNodes: true,
				AffectsConnections: true
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#555555' },
				'arrowhead-connection-selected': { Fill: '#2255aa' }
			}
		};

		// ── 3. Blueprint (Technical) ─────────────────────────────────
		this._Themes['blueprint'] =
		{
			Key: 'blueprint',
			Label: 'Blueprint',
			CSSVariables:
			{
				'--pf-node-body-fill': 'rgba(255,255,255,0.05)',
				'--pf-node-body-stroke': '#ffffff',
				'--pf-node-body-stroke-width': '1',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'none',
				'--pf-node-shadow-hover': 'none',
				'--pf-node-shadow-selected': 'none',
				'--pf-node-shadow-dragging': 'none',
				'--pf-node-title-fill': '#ffffff',
				'--pf-node-title-size': '11px',
				'--pf-node-title-weight': '400',
				'--pf-node-title-bar-color': 'rgba(255,255,255,0.1)',
				'--pf-node-type-label-fill': 'rgba(255,255,255,0.5)',
				'--pf-node-selected-stroke': '#ffdd44',
				'--pf-port-input-fill': '#88bbff',
				'--pf-port-output-fill': '#88ffbb',
				'--pf-port-stroke': '#1a3a6a',
				'--pf-connection-stroke': 'rgba(255,255,255,0.6)',
				'--pf-connection-selected-stroke': '#ffdd44',
				'--pf-canvas-bg': '#1a3a6a',
				'--pf-grid-stroke': 'rgba(255,255,255,0.08)',
				'--pf-panel-bg': '#1a3a6a',
				'--pf-panel-border': 'rgba(255,255,255,0.3)',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': 'none',
				'--pf-panel-titlebar-bg': 'rgba(255,255,255,0.05)',
				'--pf-panel-titlebar-border': 'rgba(255,255,255,0.15)',
				'--pf-panel-title-color': '#ffffff'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "Courier New", monospace !important;
					text-transform: uppercase;
					letter-spacing: 1px;
				}
				.pict-flow-container {
					border-color: #0d2244;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) invert(1) !important;
				}
				.pict-flow-toolbar {
					background-color: #142e54;
					border-bottom-color: rgba(255,255,255,0.15);
				}
				.pict-flow-toolbar-btn {
					background-color: rgba(255,255,255,0.05);
					border-color: rgba(255,255,255,0.2);
					color: #ffffff;
				}
				.pict-flow-toolbar-btn:hover {
					background-color: rgba(255,255,255,0.1);
				}
			`,
			NodeBodyMode: 'bracket',
			BracketConfig:
			{
				SerifLength: 18,
				TitleSeparator: true
			},
			ConnectionConfig:
			{
				StrokeDashArray: '8 4',
				StrokeWidth: 1,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: 'rgba(255,255,255,0.6)' },
				'arrowhead-connection-selected': { Fill: '#ffdd44' }
			}
		};

		// ── 4. Mono (Black & White) ──────────────────────────────────
		this._Themes['mono'] =
		{
			Key: 'mono',
			Label: 'Monochrome',
			CSSVariables:
			{
				'--pf-node-body-fill': '#ffffff',
				'--pf-node-body-stroke': '#000000',
				'--pf-node-body-stroke-width': '1',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'none',
				'--pf-node-shadow-hover': 'none',
				'--pf-node-shadow-selected': 'none',
				'--pf-node-shadow-dragging': 'none',
				'--pf-node-title-fill': '#ffffff',
				'--pf-node-title-size': '11px',
				'--pf-node-title-weight': '600',
				'--pf-node-title-bar-color': '#000000',
				'--pf-node-type-label-fill': '#888888',
				'--pf-node-selected-stroke': '#444444',
				'--pf-port-input-fill': '#000000',
				'--pf-port-output-fill': '#666666',
				'--pf-port-stroke': '#ffffff',
				'--pf-connection-stroke': '#000000',
				'--pf-connection-selected-stroke': '#444444',
				'--pf-canvas-bg': '#ffffff',
				'--pf-grid-stroke': '#eeeeee',
				'--pf-panel-bg': '#ffffff',
				'--pf-panel-border': '#000000',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': 'none',
				'--pf-panel-titlebar-bg': '#f0f0f0',
				'--pf-panel-titlebar-border': '#000000',
				'--pf-panel-title-color': '#000000'
			},
			AdditionalCSS: `
				.pict-flow-node-title {
					font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) invert(1) !important;
				}
			`,
			NodeBodyMode: 'rect',
			BracketConfig: null,
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 1,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#000000' },
				'arrowhead-connection-selected': { Fill: '#444444' }
			}
		};

		// ── 5. Retro 80s (Neon) ──────────────────────────────────────
		this._Themes['retro-80s'] =
		{
			Key: 'retro-80s',
			Label: '80s Retro',
			CSSVariables:
			{
				'--pf-node-body-fill': '#1a0a2e',
				'--pf-node-body-stroke': '#ff00ff',
				'--pf-node-body-stroke-width': '2',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'drop-shadow(0 0 8px rgba(255,0,255,0.4))',
				'--pf-node-shadow-hover': 'drop-shadow(0 0 12px rgba(255,0,255,0.6))',
				'--pf-node-shadow-selected': 'drop-shadow(0 0 16px rgba(0,255,255,0.5))',
				'--pf-node-shadow-dragging': 'drop-shadow(0 0 20px rgba(255,0,255,0.7))',
				'--pf-node-title-fill': '#00ffff',
				'--pf-node-title-size': '11px',
				'--pf-node-title-weight': '700',
				'--pf-node-title-bar-color': '#2a0a4e',
				'--pf-node-type-label-fill': '#ff66ff',
				'--pf-node-selected-stroke': '#00ffff',
				'--pf-port-input-fill': '#ff00ff',
				'--pf-port-output-fill': '#00ff66',
				'--pf-port-stroke': '#1a0a2e',
				'--pf-connection-stroke': '#ff00ff',
				'--pf-connection-selected-stroke': '#00ffff',
				'--pf-canvas-bg': '#0a0015',
				'--pf-grid-stroke': '#1a0a2e',
				'--pf-panel-bg': '#1a0a2e',
				'--pf-panel-border': '#ff00ff',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': '0 0 20px rgba(255,0,255,0.3)',
				'--pf-panel-titlebar-bg': '#2a0a4e',
				'--pf-panel-titlebar-border': '#ff00ff',
				'--pf-panel-title-color': '#00ffff'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "Courier New", monospace !important;
					text-transform: uppercase;
					letter-spacing: 0.5px;
				}
				.pict-flow-connection {
					filter: drop-shadow(0 0 3px rgba(255,0,255,0.4));
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) invert(1) hue-rotate(180deg) !important;
				}
				.pict-flow-toolbar {
					background-color: #1a0a2e;
					border-bottom-color: #ff00ff;
				}
				.pict-flow-toolbar-btn {
					background-color: #1a0a2e;
					border-color: #ff00ff;
					color: #00ffff;
				}
				.pict-flow-toolbar-btn:hover {
					background-color: #2a0a4e;
				}
				.pict-flow-container {
					border-color: #ff00ff;
				}
			`,
			NodeBodyMode: 'rect',
			BracketConfig: null,
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#ff00ff' },
				'arrowhead-connection-selected': { Fill: '#00ffff' }
			}
		};

		// ── 6. Retro 90s (Windows) ───────────────────────────────────
		this._Themes['retro-90s'] =
		{
			Key: 'retro-90s',
			Label: '90s Retro',
			CSSVariables:
			{
				'--pf-node-body-fill': '#c0c0c0',
				'--pf-node-body-stroke': '#808080',
				'--pf-node-body-stroke-width': '1',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'drop-shadow(2px 2px 0px #404040)',
				'--pf-node-shadow-hover': 'drop-shadow(3px 3px 0px #404040)',
				'--pf-node-shadow-selected': 'drop-shadow(2px 2px 0px #008080)',
				'--pf-node-shadow-dragging': 'drop-shadow(4px 4px 0px #404040)',
				'--pf-node-title-fill': '#ffffff',
				'--pf-node-title-size': '11px',
				'--pf-node-title-weight': '700',
				'--pf-node-title-bar-color': '#000080',
				'--pf-node-type-label-fill': '#606060',
				'--pf-node-selected-stroke': '#008080',
				'--pf-port-input-fill': '#000080',
				'--pf-port-output-fill': '#008000',
				'--pf-port-stroke': '#c0c0c0',
				'--pf-connection-stroke': '#808080',
				'--pf-connection-selected-stroke': '#008080',
				'--pf-canvas-bg': '#008080',
				'--pf-grid-stroke': 'rgba(0,0,0,0.06)',
				'--pf-panel-bg': '#c0c0c0',
				'--pf-panel-border': '#808080',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': '2px 2px 0px #404040',
				'--pf-panel-titlebar-bg': '#000080',
				'--pf-panel-titlebar-border': '#c0c0c0',
				'--pf-panel-title-color': '#ffffff'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: "MS Sans Serif", "Arial", sans-serif !important;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0) invert(1) !important;
				}
				.pict-flow-toolbar {
					background-color: #c0c0c0;
					border-bottom: 2px solid #808080;
					border-top: 1px solid #ffffff;
				}
				.pict-flow-toolbar-btn {
					background-color: #c0c0c0;
					border: 2px outset #c0c0c0;
					border-radius: 0;
					color: #000000;
				}
				.pict-flow-toolbar-btn:hover {
					background-color: #d0d0d0;
				}
				.pict-flow-toolbar-btn:active {
					border-style: inset;
				}
				.pict-flow-container {
					border: 2px outset #c0c0c0;
					border-radius: 0;
				}
			`,
			NodeBodyMode: 'rect',
			BracketConfig: null,
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#808080' },
				'arrowhead-connection-selected': { Fill: '#008080' }
			}
		};

		// ── 7. Whiteboard (Minimal brackets, no fills) ──────────────
		this._Themes['whiteboard'] =
		{
			Key: 'whiteboard',
			Label: 'Whiteboard',
			CSSVariables:
			{
				'--pf-node-body-fill': 'transparent',
				'--pf-node-body-stroke': '#555555',
				'--pf-node-body-stroke-width': '2',
				'--pf-node-body-radius': '0px',
				'--pf-node-shadow': 'none',
				'--pf-node-shadow-hover': 'none',
				'--pf-node-shadow-selected': 'none',
				'--pf-node-shadow-dragging': 'none',
				'--pf-node-title-fill': '#333333',
				'--pf-node-title-size': '12px',
				'--pf-node-title-weight': '600',
				'--pf-node-title-bar-color': 'transparent',
				'--pf-node-type-label-fill': '#999999',
				'--pf-node-selected-stroke': '#2255aa',
				'--pf-port-input-fill': '#5577bb',
				'--pf-port-output-fill': '#55aa77',
				'--pf-port-stroke': '#ffffff',
				'--pf-connection-stroke': '#888888',
				'--pf-connection-selected-stroke': '#2255aa',
				'--pf-canvas-bg': '#ffffff',
				'--pf-grid-stroke': '#f0f0f0',
				'--pf-panel-bg': '#ffffff',
				'--pf-panel-border': '#cccccc',
				'--pf-panel-radius': '0px',
				'--pf-panel-shadow': '2px 2px 0px rgba(0,0,0,0.06)',
				'--pf-panel-titlebar-bg': '#f8f8f8',
				'--pf-panel-titlebar-border': '#e0e0e0',
				'--pf-panel-title-color': '#333333'
			},
			AdditionalCSS: `
				.pict-flow-node-title,
				.pict-flow-node-type-label,
				.pict-flow-port-label,
				.pict-flow-node-card-code {
					font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
				}
				/* Node-type bracket colors — each type gets its own bracket color */
				.pict-flow-node-start .pict-flow-node-bracket { stroke: #27ae60; }
				.pict-flow-node-end .pict-flow-node-bracket { stroke: #1abc9c; }
				.pict-flow-node-halt .pict-flow-node-bracket { stroke: #e74c3c; }
				.pict-flow-node-decision .pict-flow-node-bracket { stroke: #f39c12; }
				.pict-flow-node-default .pict-flow-node-bracket { stroke: #3498db; }
				.pict-flow-node-action .pict-flow-node-bracket { stroke: #2c3e50; }
				/* Override variant rules: no fills/strokes on body rects in whiteboard */
				.pict-flow-node-decision .pict-flow-node-body,
				.pict-flow-node-start .pict-flow-node-body,
				.pict-flow-node-end .pict-flow-node-body,
				.pict-flow-node-halt .pict-flow-node-body {
					fill: transparent;
					stroke: transparent;
					stroke-width: 0;
				}
				/* Title bar fills transparent too */
				.pict-flow-node .pict-flow-node-bracket-title-fill {
					fill: transparent !important;
				}
				.pict-flow-node-title-icon {
					filter: none !important;
				}
			`,
			NodeBodyMode: 'bracket',
			BracketConfig:
			{
				SerifLength: 22,
				TitleSeparator: false
			},
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 1.5,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: true,
				DefaultLevel: 0.3,
				MaxJitterPx: 3,
				AffectsNodes: true,
				AffectsConnections: true
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#888888' },
				'arrowhead-connection-selected': { Fill: '#2255aa' }
			}
		};
	}

	// ── Public API ────────────────────────────────────────────────────────

	/**
	 * Get the active theme definition.
	 * @returns {Object}
	 */
	getActiveTheme()
	{
		return this._Themes[this._ActiveThemeKey] || this._Themes['default'];
	}

	/**
	 * Get the active theme key.
	 * @returns {string}
	 */
	getActiveThemeKey()
	{
		return this._ActiveThemeKey;
	}

	/**
	 * Switch the active theme.
	 * This updates the internal key and applies shape overrides.
	 * The caller (FlowView.setTheme) is responsible for re-registering
	 * CSS and triggering a full re-render.
	 *
	 * @param {string} pThemeKey
	 * @returns {boolean} Whether the theme was found and applied
	 */
	setTheme(pThemeKey)
	{
		if (!this._Themes[pThemeKey])
		{
			this.log.warn(`PictProviderFlowTheme: theme '${pThemeKey}' not found`);
			return false;
		}

		this._ActiveThemeKey = pThemeKey;
		let tmpTheme = this._Themes[pThemeKey];

		// Apply noise defaults from theme
		if (tmpTheme.NoiseConfig && typeof tmpTheme.NoiseConfig.DefaultLevel === 'number')
		{
			this._NoiseLevel = tmpTheme.NoiseConfig.DefaultLevel;
		}
		else
		{
			this._NoiseLevel = 0;
		}

		// Apply shape overrides
		if (this._FlowView && this._FlowView._ConnectorShapesProvider)
		{
			this._FlowView._ConnectorShapesProvider.resetToDefaults();
			if (tmpTheme.ShapeOverrides && Object.keys(tmpTheme.ShapeOverrides).length > 0)
			{
				this._FlowView._ConnectorShapesProvider.applyThemeOverrides(tmpTheme.ShapeOverrides);
			}
		}

		this.log.trace(`PictProviderFlowTheme: switched to '${pThemeKey}'`);
		return true;
	}

	/**
	 * Get the current noise level (0 to 1).
	 * @returns {number}
	 */
	getNoiseLevel()
	{
		return this._NoiseLevel;
	}

	/**
	 * Set the noise level (0 to 1).
	 * @param {number} pLevel
	 */
	setNoiseLevel(pLevel)
	{
		this._NoiseLevel = Math.max(0, Math.min(1, pLevel || 0));
	}

	/**
	 * Register a custom theme.
	 * @param {string} pKey
	 * @param {Object} pThemeDefinition
	 */
	registerTheme(pKey, pThemeDefinition)
	{
		if (!pKey || !pThemeDefinition)
		{
			this.log.warn('PictProviderFlowTheme: registerTheme requires key and definition');
			return;
		}
		pThemeDefinition.Key = pKey;
		this._Themes[pKey] = pThemeDefinition;
	}

	/**
	 * Get all registered theme keys.
	 * @returns {Array<string>}
	 */
	getThemeKeys()
	{
		return Object.keys(this._Themes);
	}

	// ── Rendering Hooks ───────────────────────────────────────────────────

	/**
	 * Post-process an SVG path string to apply noise/jitter if the
	 * active theme has noise enabled for connections.
	 *
	 * @param {string} pPathString - SVG path d attribute
	 * @param {string} pSeedString - Hash for deterministic noise
	 * @returns {string} Possibly-modified path string
	 */
	processPathString(pPathString, pSeedString)
	{
		let tmpTheme = this.getActiveTheme();
		if (!tmpTheme || !tmpTheme.NoiseConfig || !tmpTheme.NoiseConfig.Enabled || !tmpTheme.NoiseConfig.AffectsConnections)
		{
			return pPathString;
		}

		let tmpAmplitude = this._NoiseLevel * (tmpTheme.NoiseConfig.MaxJitterPx || 3);
		if (tmpAmplitude <= 0)
		{
			return pPathString;
		}

		if (this._FlowView && this._FlowView._NoiseProvider)
		{
			return this._FlowView._NoiseProvider.jitterPath(pPathString, tmpAmplitude, pSeedString);
		}

		return pPathString;
	}

	/**
	 * Get the noise amplitude for node bracket rendering.
	 * Returns 0 if noise is not enabled for nodes in the active theme.
	 * @returns {number}
	 */
	getNodeNoiseAmplitude()
	{
		let tmpTheme = this.getActiveTheme();
		if (!tmpTheme || !tmpTheme.NoiseConfig || !tmpTheme.NoiseConfig.Enabled || !tmpTheme.NoiseConfig.AffectsNodes)
		{
			return 0;
		}
		return this._NoiseLevel * (tmpTheme.NoiseConfig.MaxJitterPx || 3);
	}
}

module.exports = PictProviderFlowTheme;

module.exports.default_configuration = _ProviderConfiguration;

},{"fable-serviceproviderbase":2}],46:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-ConnectionHandleManager
 *
 * Manages connection handle lifecycle: dragging, adding, removing,
 * and resetting bezier/orthogonal handles on connections and tethers.
 *
 * Extracted from PictView-Flow.js to isolate handle CRUD operations
 * from the main view.
 */
class PictServiceFlowConnectionHandleManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowConnectionHandleManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Update a connection handle position during drag (for real-time feedback).
	 * @param {string} pConnectionHash
	 * @param {string} pHandleType - 'bezier-midpoint', 'bezier-handle-N', 'ortho-corner1', 'ortho-corner2', 'ortho-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateConnectionHandle(pConnectionHash, pHandleType, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};
		tmpConnection.Data.HandleCustomized = true;

		// Multi-handle bezier: handle type is 'bezier-handle-N'
		if (pHandleType && pHandleType.startsWith('bezier-handle-'))
		{
			let tmpIndex = parseInt(pHandleType.replace('bezier-handle-', ''), 10);
			if (!isNaN(tmpIndex) && Array.isArray(tmpConnection.Data.BezierHandles)
				&& tmpIndex < tmpConnection.Data.BezierHandles.length)
			{
				tmpConnection.Data.BezierHandles[tmpIndex].x = pX;
				tmpConnection.Data.BezierHandles[tmpIndex].y = pY;
			}
			this._FlowView._renderSingleConnection(pConnectionHash);
			return;
		}

		switch (pHandleType)
		{
			case 'bezier-midpoint':
				// Legacy single-handle: migrate to BezierHandles array
				if (!Array.isArray(tmpConnection.Data.BezierHandles)
					|| tmpConnection.Data.BezierHandles.length === 0)
				{
					tmpConnection.Data.BezierHandles = [{ x: pX, y: pY }];
				}
				else
				{
					tmpConnection.Data.BezierHandles[0].x = pX;
					tmpConnection.Data.BezierHandles[0].y = pY;
				}
				// Keep legacy fields in sync for backward compat
				tmpConnection.Data.BezierHandleX = pX;
				tmpConnection.Data.BezierHandleY = pY;
				break;

			case 'ortho-corner1':
				tmpConnection.Data.OrthoCorner1X = pX;
				tmpConnection.Data.OrthoCorner1Y = pY;
				break;

			case 'ortho-corner2':
				tmpConnection.Data.OrthoCorner2X = pX;
				tmpConnection.Data.OrthoCorner2Y = pY;
				break;

			case 'ortho-midpoint':
			{
				// Midpoint drag shifts the corridor offset
				let tmpSourcePos = this._FlowView.getPortPosition(tmpConnection.SourceNodeHash, tmpConnection.SourcePortHash);
				let tmpTargetPos = this._FlowView.getPortPosition(tmpConnection.TargetNodeHash, tmpConnection.TargetPortHash);
				if (tmpSourcePos && tmpTargetPos)
				{
					let tmpGeom = this._FlowView._ConnectionRenderer._computeDirectionalGeometry(tmpSourcePos, tmpTargetPos);
					let tmpStartDir = tmpGeom.startDir;

					// Compute offset along the corridor axis
					if (Math.abs(tmpStartDir.dx) > Math.abs(tmpStartDir.dy))
					{
						// Horizontal departure — corridor is vertical, shift is along X
						let tmpAutoMidX = (tmpGeom.departX + tmpGeom.approachX) / 2;
						tmpConnection.Data.OrthoMidOffset = pX - tmpAutoMidX;
					}
					else
					{
						// Vertical departure — corridor is horizontal, shift is along Y
						let tmpAutoMidY = (tmpGeom.departY + tmpGeom.approachY) / 2;
						tmpConnection.Data.OrthoMidOffset = pY - tmpAutoMidY;
					}
				}
				break;
			}
		}

		this._FlowView._renderSingleConnection(pConnectionHash);
	}

	/**
	 * Add a bezier handle to a connection at the specified position.
	 * The handle is inserted at the correct index based on which
	 * segment of the curve the click point is closest to.
	 *
	 * @param {string} pConnectionHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	addConnectionHandle(pConnectionHash, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};

		// Ensure BezierHandles array exists (migrate from legacy if needed)
		if (!Array.isArray(tmpConnection.Data.BezierHandles))
		{
			tmpConnection.Data.BezierHandles = [];
			if (tmpConnection.Data.BezierHandleX != null && tmpConnection.Data.BezierHandleY != null)
			{
				tmpConnection.Data.BezierHandles.push({
					x: tmpConnection.Data.BezierHandleX,
					y: tmpConnection.Data.BezierHandleY
				});
			}
		}

		// Ensure bezier mode
		tmpConnection.Data.LineMode = 'bezier';

		let tmpSourcePos = this._FlowView.getPortPosition(tmpConnection.SourceNodeHash, tmpConnection.SourcePortHash);
		let tmpTargetPos = this._FlowView.getPortPosition(tmpConnection.TargetNodeHash, tmpConnection.TargetPortHash);

		let tmpInsertIndex = 0;
		if (tmpSourcePos && tmpTargetPos && this._FlowView._ConnectionRenderer)
		{
			tmpInsertIndex = this._FlowView._ConnectionRenderer.computeInsertionIndex(
				tmpConnection.Data.BezierHandles,
				{ x: pX, y: pY },
				tmpSourcePos,
				tmpTargetPos
			);
		}

		tmpConnection.Data.BezierHandles.splice(tmpInsertIndex, 0, { x: pX, y: pY });
		tmpConnection.Data.HandleCustomized = true;

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}
	}

	/**
	 * Remove a bezier handle from a connection by index.
	 *
	 * @param {string} pConnectionHash
	 * @param {number} pIndex - Index in the BezierHandles array
	 */
	removeConnectionHandle(pConnectionHash, pIndex)
	{
		if (!this._FlowView) return;

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection || !tmpConnection.Data) return;

		if (!Array.isArray(tmpConnection.Data.BezierHandles)) return;
		if (pIndex < 0 || pIndex >= tmpConnection.Data.BezierHandles.length) return;

		tmpConnection.Data.BezierHandles.splice(pIndex, 1);

		if (tmpConnection.Data.BezierHandles.length === 0)
		{
			tmpConnection.Data.HandleCustomized = false;
			tmpConnection.Data.BezierHandleX = null;
			tmpConnection.Data.BezierHandleY = null;
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}
	}

	/**
	 * Reset handle positions for all connections/tethers involving a node.
	 * Called when a node moves. Preserves LineMode but resets handle coordinates to auto.
	 * @param {string} pNodeHash
	 */
	resetHandlesForNode(pNodeHash)
	{
		if (!this._FlowView) return;

		// Reset connection handles
		for (let i = 0; i < this._FlowView._FlowData.Connections.length; i++)
		{
			let tmpConn = this._FlowView._FlowData.Connections[i];
			if (tmpConn.SourceNodeHash === pNodeHash || tmpConn.TargetNodeHash === pNodeHash)
			{
				if (tmpConn.Data && tmpConn.Data.HandleCustomized)
				{
					tmpConn.Data.HandleCustomized = false;
					// Clear multi-handle array (current format)
					tmpConn.Data.BezierHandles = [];
					// Clear legacy single-handle fields
					tmpConn.Data.BezierHandleX = null;
					tmpConn.Data.BezierHandleY = null;
					tmpConn.Data.OrthoCorner1X = null;
					tmpConn.Data.OrthoCorner1Y = null;
					tmpConn.Data.OrthoCorner2X = null;
					tmpConn.Data.OrthoCorner2Y = null;
					tmpConn.Data.OrthoMidOffset = 0;
				}
			}
		}

		// Reset tether handles for panels attached to this node
		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.resetHandlesForNode(this._FlowView._FlowData.OpenPanels, pNodeHash);
		}
	}

	/**
	 * Reset tether handle positions for a specific panel.
	 * Called when a panel is dragged.
	 * @param {string} pPanelHash
	 */
	resetHandlesForPanel(pPanelHash)
	{
		if (!this._FlowView) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.resetHandlePositions(tmpPanel);
		}
	}
}

module.exports = PictServiceFlowConnectionHandleManager;

},{"fable-serviceproviderbase":2}],47:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class PictServiceFlowConnectionRenderer extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowConnectionRenderer';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render a connection as an SVG path with hit area and optional handles.
	 * @param {Object} pConnection - The connection data
	 * @param {SVGGElement} pConnectionsLayer - The SVG group to append to
	 * @param {boolean} pIsSelected - Whether this connection is selected
	 */
	renderConnection(pConnection, pConnectionsLayer, pIsSelected)
	{
		if (!this._FlowView) return;

		let tmpSourcePos = this._FlowView.getPortPosition(pConnection.SourceNodeHash, pConnection.SourcePortHash);
		let tmpTargetPos = this._FlowView.getPortPosition(pConnection.TargetNodeHash, pConnection.TargetPortHash);

		// Look up the source port's PortType for connection coloring
		let tmpSourcePortType = null;
		let tmpSourceNode = this._FlowView.getNode(pConnection.SourceNodeHash);
		if (tmpSourceNode && tmpSourceNode.Ports)
		{
			for (let i = 0; i < tmpSourceNode.Ports.length; i++)
			{
				if (tmpSourceNode.Ports[i].Hash === pConnection.SourcePortHash)
				{
					tmpSourcePortType = tmpSourceNode.Ports[i].PortType || null;
					break;
				}
			}
		}

		if (!tmpSourcePos || !tmpTargetPos) return;

		let tmpData = pConnection.Data || {};
		let tmpLineMode = tmpData.LineMode || 'bezier';
		let tmpPath;

		if (tmpLineMode === 'orthogonal')
		{
			let tmpCorners = null;
			if (tmpData.HandleCustomized && tmpData.OrthoCorner1X != null)
			{
				tmpCorners =
				{
					corner1: { x: tmpData.OrthoCorner1X, y: tmpData.OrthoCorner1Y },
					corner2: { x: tmpData.OrthoCorner2X, y: tmpData.OrthoCorner2Y }
				};
			}
			tmpPath = this._generateOrthogonalPath(tmpSourcePos, tmpTargetPos, tmpCorners, tmpData.OrthoMidOffset || 0);
		}
		else
		{
			let tmpHandles = this._getBezierHandles(tmpData);
			if (tmpHandles.length > 0)
			{
				tmpPath = this._generateMultiHandleBezierPath(tmpSourcePos, tmpTargetPos, tmpHandles);
			}
			else
			{
				tmpPath = this._generateDirectionalPath(tmpSourcePos, tmpTargetPos);
			}
		}

		// Apply theme noise post-processing to the path
		if (this._FlowView._ThemeProvider)
		{
			tmpPath = this._FlowView._ThemeProvider.processPathString(tmpPath, pConnection.Hash);
		}

		// Apply stroke-dasharray from theme's ConnectionConfig
		let tmpStrokeDashArray = null;
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.ConnectionConfig && tmpActiveTheme.ConnectionConfig.StrokeDashArray)
			{
				tmpStrokeDashArray = tmpActiveTheme.ConnectionConfig.StrokeDashArray;
			}
		}

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;

		// Build the port-type CSS class suffix for connection coloring
		let tmpConnTypeClass = tmpSourcePortType ? (' conn-type-' + tmpSourcePortType) : '';

		// Determine the arrowhead marker based on port type
		let tmpArrowMarkerId;
		if (pIsSelected)
		{
			tmpArrowMarkerId = 'flow-arrowhead-selected-' + tmpViewIdentifier;
		}
		else if (tmpSourcePortType)
		{
			tmpArrowMarkerId = 'flow-arrowhead-' + tmpSourcePortType + '-' + tmpViewIdentifier;
		}
		else
		{
			tmpArrowMarkerId = 'flow-arrowhead-' + tmpViewIdentifier;
		}

		// Hit area (wider invisible path for easier selection)
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		if (tmpShapeProvider)
		{
			let tmpHitArea = tmpShapeProvider.createConnectionHitAreaElement(tmpPath, pConnection.Hash);
			pConnectionsLayer.appendChild(tmpHitArea);

			let tmpPathElement = tmpShapeProvider.createConnectionPathElement(
				tmpPath, pConnection.Hash, pIsSelected, tmpViewIdentifier);
			if (tmpConnTypeClass)
			{
				tmpPathElement.setAttribute('class',
					(tmpPathElement.getAttribute('class') || '') + tmpConnTypeClass);
			}
			// Override the default arrowhead with the typed one
			tmpPathElement.setAttribute('marker-end', 'url(#' + tmpArrowMarkerId + ')');
			if (tmpStrokeDashArray)
			{
				tmpPathElement.setAttribute('stroke-dasharray', tmpStrokeDashArray);
			}
			pConnectionsLayer.appendChild(tmpPathElement);
		}
		else
		{
			let tmpHitArea = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpHitArea.setAttribute('class', 'pict-flow-connection-hitarea');
			tmpHitArea.setAttribute('d', tmpPath);
			tmpHitArea.setAttribute('data-connection-hash', pConnection.Hash);
			tmpHitArea.setAttribute('data-element-type', 'connection-hitarea');
			pConnectionsLayer.appendChild(tmpHitArea);

			let tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', `pict-flow-connection${tmpConnTypeClass} ${pIsSelected ? 'selected' : ''}`);
			tmpPathElement.setAttribute('d', tmpPath);
			tmpPathElement.setAttribute('data-connection-hash', pConnection.Hash);
			tmpPathElement.setAttribute('data-element-type', 'connection');
			tmpPathElement.setAttribute('marker-end', 'url(#' + tmpArrowMarkerId + ')');

			if (tmpStrokeDashArray)
			{
				tmpPathElement.setAttribute('stroke-dasharray', tmpStrokeDashArray);
			}

			pConnectionsLayer.appendChild(tmpPathElement);
		}

		// Render drag handles when selected
		if (pIsSelected)
		{
			this._renderHandles(pConnection, pConnectionsLayer, tmpSourcePos, tmpTargetPos);
		}
	}

	/**
	 * Compute the departure and approach points plus control points
	 * for a direction-aware bezier between two ports.
	 *
	 * This extracts the intermediate geometry from _generateDirectionalPath
	 * so it can be reused by _getAutoMidpoint and _generateBezierPathWithHandle.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{departX, departY, approachX, approachY, cp1X, cp1Y, cp2X, cp2Y, startDir, endDir}}
	 */
	_computeDirectionalGeometry(pStart, pEnd)
	{
		return this._FlowView._PathGenerator.computeDirectionalGeometry(pStart, pEnd);
	}

	/**
	 * Generate a direction-aware path between two ports.
	 *
	 * The path is composed of three segments:
	 *   1. A short straight "departure" segment leaving the source port
	 *      in its outward direction.
	 *   2. A cubic bezier curve connecting the departure point to an
	 *      "approach" point near the target port.
	 *   3. A short straight "approach" segment arriving at the target
	 *      port aligned with its inward direction.
	 *
	 * @param {{x: number, y: number, side: string}} pStart - Start port position + side
	 * @param {{x: number, y: number, side: string}} pEnd   - End port position + side
	 * @returns {string} SVG path d attribute
	 */
	_generateDirectionalPath(pStart, pEnd)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		return this._FlowView._PathGenerator.buildBezierPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			{ x: tmpGeo.cp1X, y: tmpGeo.cp1Y },
			{ x: tmpGeo.cp2X, y: tmpGeo.cp2Y },
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			{ x: pEnd.x, y: pEnd.y }
		);
	}

	/**
	 * Get the bezier handles array from connection data, with backward
	 * compatibility for the legacy BezierHandleX/Y single-handle format.
	 *
	 * @param {Object} pData - Connection.Data
	 * @returns {Array<{x: number, y: number}>} Ordered handle waypoints (may be empty)
	 */
	_getBezierHandles(pData)
	{
		if (!pData || !pData.HandleCustomized)
		{
			return [];
		}

		// New multi-handle format
		if (Array.isArray(pData.BezierHandles) && pData.BezierHandles.length > 0)
		{
			return pData.BezierHandles;
		}

		// Legacy single-handle format
		if (pData.BezierHandleX != null && pData.BezierHandleY != null)
		{
			return [{ x: pData.BezierHandleX, y: pData.BezierHandleY }];
		}

		return [];
	}

	/**
	 * Generate a multi-handle bezier path between two ports.
	 * Delegates to PathGenerator.buildMultiBezierPathString for the
	 * actual SVG path assembly with Catmull-Rom tangent continuity.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Array<{x: number, y: number}>} pHandles - Ordered waypoints
	 * @returns {string} SVG path d attribute
	 */
	_generateMultiHandleBezierPath(pStart, pEnd, pHandles)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		return this._FlowView._PathGenerator.buildMultiBezierPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			pHandles,
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			{ x: pEnd.x, y: pEnd.y },
			tmpGeo.startDir,
			tmpGeo.endDir
		);
	}

	/**
	 * Find which segment of the multi-handle bezier the given click point
	 * is closest to, returning the index at which a new handle should be
	 * inserted into the BezierHandles array.
	 *
	 * Segments are: depart→handle[0], handle[0]→handle[1], ..., handle[N-1]→approach.
	 * Returns 0 for before handle[0], 1 for between handle[0] and handle[1], etc.
	 *
	 * @param {Array<{x: number, y: number}>} pHandles - Current handles
	 * @param {{x: number, y: number}} pClickPoint - Where the user right-clicked
	 * @param {{x: number, y: number, side: string}} pStart - Source port position
	 * @param {{x: number, y: number, side: string}} pEnd - Target port position
	 * @returns {number} Insertion index
	 */
	computeInsertionIndex(pHandles, pClickPoint, pStart, pEnd)
	{
		let tmpGeo = this._computeDirectionalGeometry(pStart, pEnd);

		// Build the waypoint chain: depart, handle[0..N-1], approach
		let tmpWaypoints = [{ x: tmpGeo.departX, y: tmpGeo.departY }];
		for (let i = 0; i < pHandles.length; i++)
		{
			tmpWaypoints.push(pHandles[i]);
		}
		tmpWaypoints.push({ x: tmpGeo.approachX, y: tmpGeo.approachY });

		let tmpBestDist = Infinity;
		let tmpBestIndex = 0;

		for (let i = 0; i < tmpWaypoints.length - 1; i++)
		{
			let tmpDist = this._distanceToSegment(
				pClickPoint.x, pClickPoint.y,
				tmpWaypoints[i].x, tmpWaypoints[i].y,
				tmpWaypoints[i + 1].x, tmpWaypoints[i + 1].y
			);

			if (tmpDist < tmpBestDist)
			{
				tmpBestDist = tmpDist;
				tmpBestIndex = i;
			}
		}

		return tmpBestIndex;
	}

	/**
	 * Distance from point (px,py) to line segment (ax,ay)-(bx,by).
	 */
	_distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY)
	{
		return this._FlowView._PathGenerator.distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY);
	}

	/**
	 * Get the auto-calculated midpoint of the default bezier curve between two ports.
	 * Evaluates the cubic bezier at t=0.5.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pStart, pEnd)
	{
		return this._FlowView._PathGenerator.getAutoMidpoint(pStart, pEnd);
	}

	/**
	 * Generate an orthogonal (90-degree angles only) path between two ports.
	 *
	 * Path format: M start L depart L corner1 L corner2 L approach L end
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Object|null} pCorners - { corner1: {x,y}, corner2: {x,y} } or null for auto
	 * @param {number} pMidOffset - Offset for the auto-calculated corridor position
	 * @returns {string} SVG path d attribute
	 */
	_generateOrthogonalPath(pStart, pEnd, pCorners, pMidOffset)
	{
		let tmpDA = this._FlowView._PathGenerator.computeDepartApproach(pStart, pEnd, 20);

		let tmpCorner1, tmpCorner2;

		if (pCorners && pCorners.corner1 && pCorners.corner2)
		{
			tmpCorner1 = pCorners.corner1;
			tmpCorner2 = pCorners.corner2;
		}
		else
		{
			let tmpAutoCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(
				tmpDA.departX, tmpDA.departY,
				tmpDA.approachX, tmpDA.approachY,
				tmpDA.fromDir, tmpDA.toDir,
				pMidOffset || 0
			);
			tmpCorner1 = tmpAutoCorners.corner1;
			tmpCorner2 = tmpAutoCorners.corner2;
		}

		return this._FlowView._PathGenerator.buildOrthogonalPathString(
			{ x: pStart.x, y: pStart.y },
			{ x: tmpDA.departX, y: tmpDA.departY },
			tmpCorner1,
			tmpCorner2,
			{ x: tmpDA.approachX, y: tmpDA.approachY },
			{ x: pEnd.x, y: pEnd.y }
		);
	}

	/**
	 * Get the full orthogonal geometry for a connection (for handle positioning).
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @param {Object} pData - Connection.Data
	 * @returns {{corner1: {x,y}, corner2: {x,y}, midpoint: {x,y}}}
	 */
	getOrthogonalGeometry(pStart, pEnd, pData)
	{
		let tmpDA = this._FlowView._PathGenerator.computeDepartApproach(pStart, pEnd, 20);

		if (pData && pData.HandleCustomized && pData.OrthoCorner1X != null)
		{
			let tmpCorner1 = { x: pData.OrthoCorner1X, y: pData.OrthoCorner1Y };
			let tmpCorner2 = { x: pData.OrthoCorner2X, y: pData.OrthoCorner2Y };
			let tmpMidpoint =
			{
				x: (tmpCorner1.x + tmpCorner2.x) / 2,
				y: (tmpCorner1.y + tmpCorner2.y) / 2
			};
			return { corner1: tmpCorner1, corner2: tmpCorner2, midpoint: tmpMidpoint };
		}

		return this._FlowView._PathGenerator.computeAutoOrthogonalCorners(
			tmpDA.departX, tmpDA.departY,
			tmpDA.approachX, tmpDA.approachY,
			tmpDA.fromDir, tmpDA.toDir,
			(pData && pData.OrthoMidOffset) || 0
		);
	}

	/**
	 * Render drag handles for the selected connection.
	 *
	 * @param {Object} pConnection
	 * @param {SVGGElement} pLayer
	 * @param {{x, y, side}} pStart - Source port position
	 * @param {{x, y, side}} pEnd   - Target port position
	 */
	_renderHandles(pConnection, pLayer, pStart, pEnd)
	{
		let tmpData = pConnection.Data || {};
		let tmpLineMode = tmpData.LineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpGeometry = this.getOrthogonalGeometry(pStart, pEnd, tmpData);

			// Corner 1 handle
			this._createHandle(pLayer, pConnection.Hash, 'ortho-corner1',
				tmpGeometry.corner1.x, tmpGeometry.corner1.y, 'pict-flow-connection-handle');

			// Midpoint handle (between corners)
			this._createHandle(pLayer, pConnection.Hash, 'ortho-midpoint',
				tmpGeometry.midpoint.x, tmpGeometry.midpoint.y, 'pict-flow-connection-handle-midpoint');

			// Corner 2 handle
			this._createHandle(pLayer, pConnection.Hash, 'ortho-corner2',
				tmpGeometry.corner2.x, tmpGeometry.corner2.y, 'pict-flow-connection-handle');
		}
		else
		{
			// Bezier handles — show one handle per waypoint, or a
			// single auto-midpoint when no custom handles exist.
			let tmpHandles = this._getBezierHandles(tmpData);

			if (tmpHandles.length > 0)
			{
				for (let i = 0; i < tmpHandles.length; i++)
				{
					this._createHandle(pLayer, pConnection.Hash,
						'bezier-handle-' + i,
						tmpHandles[i].x, tmpHandles[i].y,
						'pict-flow-connection-handle');
				}
			}
			else
			{
				let tmpMidpoint = this.getAutoMidpoint(pStart, pEnd);
				this._createHandle(pLayer, pConnection.Hash, 'bezier-midpoint',
					tmpMidpoint.x, tmpMidpoint.y, 'pict-flow-connection-handle');
			}
		}
	}

	/**
	 * Create a single SVG circle handle element.
	 *
	 * @param {SVGGElement} pLayer
	 * @param {string} pConnectionHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pClassName
	 */
	_createHandle(pLayer, pConnectionHash, pHandleType, pX, pY, pClassName)
	{
		if (!this._FlowView._ConnectorShapesProvider) return;

		let tmpShapeKey = (pClassName === 'pict-flow-connection-handle-midpoint')
			? 'connection-handle-midpoint' : 'connection-handle';

		this._FlowView._ConnectorShapesProvider.createFullHandle(
			pLayer, pConnectionHash, pHandleType, pX, pY,
			tmpShapeKey, 'connection-handle', 'data-connection-hash');
	}

	/**
	 * Legacy bezier path for drag connections where we don't have side info.
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string}
	 */
	_generateBezierPath(pStart, pEnd)
	{
		// During drag operations we may not have side info; default to right->left
		let tmpStart = { x: pStart.x, y: pStart.y, side: pStart.side || 'right' };
		let tmpEnd   = { x: pEnd.x,   y: pEnd.y,   side: pEnd.side   || 'left' };
		return this._generateDirectionalPath(tmpStart, tmpEnd);
	}

	/**
	 * Render a temporary drag connection line (used during connection creation)
	 * @param {number} pStartX
	 * @param {number} pStartY
	 * @param {number} pEndX
	 * @param {number} pEndY
	 * @param {SVGGElement} pLayer - The layer to render into
	 * @param {string} [pStartSide] - The side the source port is on
	 * @returns {SVGPathElement} The created path element
	 */
	renderDragConnection(pStartX, pStartY, pEndX, pEndY, pLayer, pStartSide)
	{
		let tmpPath = this._generateDirectionalPath(
			{ x: pStartX, y: pStartY, side: pStartSide || 'right' },
			{ x: pEndX,   y: pEndY,   side: 'left' }
		);

		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		let tmpPathElement;

		if (tmpShapeProvider)
		{
			tmpPathElement = tmpShapeProvider.createDragConnectionElement(tmpPath);
		}
		else
		{
			tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', 'pict-flow-drag-connection');
			tmpPathElement.setAttribute('d', tmpPath);
		}

		pLayer.appendChild(tmpPathElement);

		return tmpPathElement;
	}

	/**
	 * Update a drag connection path
	 * @param {SVGPathElement} pPathElement
	 * @param {number} pStartX
	 * @param {number} pStartY
	 * @param {number} pEndX
	 * @param {number} pEndY
	 * @param {string} [pStartSide] - The side the source port is on
	 */
	updateDragConnection(pPathElement, pStartX, pStartY, pEndX, pEndY, pStartSide)
	{
		if (!pPathElement) return;

		let tmpPath = this._generateDirectionalPath(
			{ x: pStartX, y: pStartY, side: pStartSide || 'right' },
			{ x: pEndX,   y: pEndY,   side: 'left' }
		);

		pPathElement.setAttribute('d', tmpPath);
	}
}

module.exports = PictServiceFlowConnectionRenderer;

},{"fable-serviceproviderbase":2}],48:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-DataManager
 *
 * Manages flow data lifecycle: serialization, deserialization, and CRUD
 * operations for nodes and connections.
 *
 * Extracted from PictView-Flow.js to keep the view focused on
 * coordination and lifecycle rather than data manipulation.
 */
class PictServiceFlowDataManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowDataManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ---- Marshaling ----

	/**
	 * Marshal data from AppData into the flow view
	 */
	marshalToView()
	{
		if (!this._FlowView) return;

		if (this._FlowView.options.FlowDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this._FlowView.fable,
				Pict: this._FlowView.pict || this._FlowView.fable,
				AppData: this._FlowView.pict ? this._FlowView.pict.AppData : this._FlowView.fable.AppData,
				Bundle: this._FlowView.Bundle,
				Options: this._FlowView.options
			};
			let tmpData = this._FlowView.fable.manifest.getValueByHash(tmpAddressSpace, this._FlowView.options.FlowDataAddress);
			if (typeof tmpData === 'object' && tmpData !== null)
			{
				this.setFlowData(tmpData);
			}
		}
	}

	/**
	 * Marshal data from the flow view back to AppData
	 */
	marshalFromView()
	{
		if (!this._FlowView) return;

		if (this._FlowView.options.FlowDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this._FlowView.fable,
				Pict: this._FlowView.pict || this._FlowView.fable,
				AppData: this._FlowView.pict ? this._FlowView.pict.AppData : this._FlowView.fable.AppData,
				Bundle: this._FlowView.Bundle,
				Options: this._FlowView.options
			};
			this._FlowView.fable.manifest.setValueByHash(tmpAddressSpace, this._FlowView.options.FlowDataAddress, JSON.parse(JSON.stringify(this._FlowView._FlowData)));
		}
	}

	// ---- Flow Data Get/Set ----

	/**
	 * Get the complete flow data object
	 * @returns {Object} The flow data including nodes, connections, and view state
	 */
	getFlowData()
	{
		if (!this._FlowView) return {};
		return JSON.parse(JSON.stringify(this._FlowView._FlowData));
	}

	/**
	 * Set the complete flow data object and re-render
	 * @param {Object} pFlowData - The flow data to set
	 */
	setFlowData(pFlowData)
	{
		if (!this._FlowView) return;

		if (typeof pFlowData !== 'object' || pFlowData === null)
		{
			this._FlowView.log.warn('PictSectionFlow setFlowData received invalid data');
			return;
		}

		this._FlowView._FlowData = {
			Nodes: Array.isArray(pFlowData.Nodes) ? pFlowData.Nodes : [],
			Connections: Array.isArray(pFlowData.Connections) ? pFlowData.Connections : [],
			OpenPanels: Array.isArray(pFlowData.OpenPanels) ? pFlowData.OpenPanels : [],
			SavedLayouts: Array.isArray(pFlowData.SavedLayouts) ? pFlowData.SavedLayouts : [],
			ViewState: Object.assign(
				{ PanX: 0, PanY: 0, Zoom: 1, SelectedNodeHash: null, SelectedConnectionHash: null, SelectedTetherHash: null },
				pFlowData.ViewState || {}
			)
		};

		// Merge any browser-persisted layouts into the newly loaded data
		if (this._FlowView._LayoutProvider)
		{
			this._FlowView._LayoutProvider.loadPersistedLayouts();
		}

		if (this._FlowView.initialRenderComplete)
		{
			this._FlowView.renderFlow();
		}
	}

	// ---- Node CRUD ----

	/**
	 * Add a new node to the flow
	 * @param {string} pType - The node type hash
	 * @param {number} pX - X position
	 * @param {number} pY - Y position
	 * @param {string} [pTitle] - Optional title
	 * @param {Object} [pData] - Optional additional data
	 * @returns {Object} The created node
	 */
	addNode(pType, pX, pY, pTitle, pData)
	{
		if (!this._FlowView) return null;

		let tmpType = pType || this._FlowView.options.DefaultNodeType;
		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpType);

		let tmpNodeHash = `node-${this._FlowView.fable.getUUID()}`;
		let tmpNode =
		{
			Hash: tmpNodeHash,
			Type: tmpType,
			X: pX || 100,
			Y: pY || 100,
			Width: (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultWidth) || this._FlowView.options.DefaultNodeWidth,
			Height: (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultHeight) || this._FlowView.options.DefaultNodeHeight,
			Title: pTitle || (tmpNodeTypeConfig && tmpNodeTypeConfig.Label) || 'New Node',
			Ports: (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultPorts)
				? JSON.parse(JSON.stringify(tmpNodeTypeConfig.DefaultPorts))
				: [
					{ Hash: `port-in-${this._FlowView.fable.getUUID()}`, Direction: 'input', Side: 'left', Label: 'In' },
					{ Hash: `port-out-${this._FlowView.fable.getUUID()}`, Direction: 'output', Side: 'right', Label: 'Out' }
				],
			Data: pData || {}
		};

		// Ensure each port has a unique hash
		for (let i = 0; i < tmpNode.Ports.length; i++)
		{
			if (!tmpNode.Ports[i].Hash)
			{
				tmpNode.Ports[i].Hash = `port-${tmpNode.Ports[i].Direction}-${this._FlowView.fable.getUUID()}`;
			}
		}

		this._FlowView._FlowData.Nodes.push(tmpNode);
		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeAdded', tmpNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpNode;
	}

	/**
	 * Remove a node and all its connections
	 * @param {string} pNodeHash - The hash of the node to remove
	 * @returns {boolean} Whether the node was removed
	 */
	removeNode(pNodeHash)
	{
		if (!this._FlowView) return false;

		let tmpNodeIndex = this._FlowView._FlowData.Nodes.findIndex((pNode) => pNode.Hash === pNodeHash);
		if (tmpNodeIndex < 0)
		{
			this._FlowView.log.warn(`PictSectionFlow removeNode: node ${pNodeHash} not found`);
			return false;
		}

		let tmpRemovedNode = this._FlowView._FlowData.Nodes.splice(tmpNodeIndex, 1)[0];

		// Remove all connections involving this node
		this._FlowView._FlowData.Connections = this._FlowView._FlowData.Connections.filter((pConnection) =>
		{
			return pConnection.SourceNodeHash !== pNodeHash && pConnection.TargetNodeHash !== pNodeHash;
		});

		// Close any open panels for this node
		this._FlowView.closePanelForNode(pNodeHash);

		// Clear selection if this node was selected
		if (this._FlowView._FlowData.ViewState.SelectedNodeHash === pNodeHash)
		{
			this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		}

		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeRemoved', tmpRemovedNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}

	// ---- Connection CRUD ----

	/**
	 * Add a connection between two ports
	 * @param {string} pSourceNodeHash
	 * @param {string} pSourcePortHash
	 * @param {string} pTargetNodeHash
	 * @param {string} pTargetPortHash
	 * @param {Object} [pData] - Optional additional data
	 * @returns {Object|false} The created connection, or false if invalid
	 */
	addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData)
	{
		if (!this._FlowView) return false;

		// Validate that both nodes and ports exist
		let tmpSourceNode = this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === pSourceNodeHash);
		let tmpTargetNode = this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === pTargetNodeHash);

		if (!tmpSourceNode || !tmpTargetNode)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: source or target node not found');
			return false;
		}

		let tmpSourcePort = tmpSourceNode.Ports.find((pPort) => pPort.Hash === pSourcePortHash);
		let tmpTargetPort = tmpTargetNode.Ports.find((pPort) => pPort.Hash === pTargetPortHash);

		if (!tmpSourcePort || !tmpTargetPort)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: source or target port not found');
			return false;
		}

		// Prevent self-connections
		if (pSourceNodeHash === pTargetNodeHash)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: cannot connect a node to itself');
			return false;
		}

		// Check for duplicate connections
		let tmpDuplicate = this._FlowView._FlowData.Connections.find((pConn) =>
		{
			return pConn.SourceNodeHash === pSourceNodeHash
				&& pConn.SourcePortHash === pSourcePortHash
				&& pConn.TargetNodeHash === pTargetNodeHash
				&& pConn.TargetPortHash === pTargetPortHash;
		});
		if (tmpDuplicate)
		{
			this._FlowView.log.warn('PictSectionFlow addConnection: duplicate connection');
			return false;
		}

		let tmpConnection =
		{
			Hash: `conn-${this._FlowView.fable.getUUID()}`,
			SourceNodeHash: pSourceNodeHash,
			SourcePortHash: pSourcePortHash,
			TargetNodeHash: pTargetNodeHash,
			TargetPortHash: pTargetPortHash,
			Data: pData || {}
		};

		this._FlowView._FlowData.Connections.push(tmpConnection);
		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionCreated', tmpConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpConnection;
	}

	/**
	 * Remove a connection
	 * @param {string} pConnectionHash - The hash of the connection to remove
	 * @returns {boolean} Whether the connection was removed
	 */
	removeConnection(pConnectionHash)
	{
		if (!this._FlowView) return false;

		let tmpConnectionIndex = this._FlowView._FlowData.Connections.findIndex((pConn) => pConn.Hash === pConnectionHash);
		if (tmpConnectionIndex < 0)
		{
			this._FlowView.log.warn(`PictSectionFlow removeConnection: connection ${pConnectionHash} not found`);
			return false;
		}

		let tmpRemovedConnection = this._FlowView._FlowData.Connections.splice(tmpConnectionIndex, 1)[0];

		if (this._FlowView._FlowData.ViewState.SelectedConnectionHash === pConnectionHash)
		{
			this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;
		}

		this._FlowView.renderFlow();
		this.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionRemoved', tmpRemovedConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}
}

module.exports = PictServiceFlowDataManager;

},{"fable-serviceproviderbase":2}],49:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * Interaction states for the flow diagram
 */
const INTERACTION_STATES =
{
	IDLE: 'idle',
	DRAGGING_NODE: 'dragging-node',
	DRAGGING_PANEL: 'dragging-panel',
	DRAGGING_HANDLE: 'dragging-handle',
	CONNECTING: 'connecting',
	PANNING: 'panning',
	RESIZING_PANEL: 'resizing-panel'
};

class PictServiceFlowInteractionManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowInteractionManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._SVGElement = null;
		this._ViewportElement = null;

		// Interaction state
		this._State = INTERACTION_STATES.IDLE;

		// Drag state
		this._DragNodeHash = null;
		this._DragStartX = 0;
		this._DragStartY = 0;
		this._DragNodeStartX = 0;
		this._DragNodeStartY = 0;

		// Panel drag state
		this._DragPanelHash = null;
		this._DragPanelStartX = 0;
		this._DragPanelStartY = 0;
		this._DragPanelDataStartX = 0;
		this._DragPanelDataStartY = 0;

		// Handle drag state
		this._DragHandleConnectionHash = null;
		this._DragHandlePanelHash = null;
		this._DragHandleType = null;
		this._DragHandleIsTether = false;

		// Pan state
		this._PanStartX = 0;
		this._PanStartY = 0;
		this._PanStartPanX = 0;
		this._PanStartPanY = 0;

		// Connection drag state
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
		this._ConnectDragLine = null;

		// Double-click detection
		this._LastClickTime = 0;
		this._LastClickNodeHash = null;
		this._DoubleClickThreshold = 400;

		// Panel resize state
		this._ResizePanelHash = null;
		this._ResizeStartY = 0;
		this._ResizePanelStartHeight = 0;

		// Double-click detection for connections
		this._LastConnectionClickTime = 0;
		this._LastConnectionClickHash = null;

		// Double-click detection for tethers
		this._LastTetherClickTime = 0;
		this._LastTetherClickHash = null;

		// Double-click detection for handles
		this._LastHandleClickTime = 0;
		this._LastHandleClickHash = null;
		this._LastHandleClickType = null;

		// Bound event handlers (for removeEventListener)
		this._boundOnPointerDown = this._onPointerDown.bind(this);
		this._boundOnPointerMove = this._onPointerMove.bind(this);
		this._boundOnPointerUp = this._onPointerUp.bind(this);
		this._boundOnWheel = this._onWheel.bind(this);
		this._boundOnKeyDown = this._onKeyDown.bind(this);
	}

	/**
	 * Initialize event listeners on the SVG element
	 * @param {SVGSVGElement} pSVGElement
	 * @param {SVGGElement} pViewportElement
	 */
	initialize(pSVGElement, pViewportElement)
	{
		this._SVGElement = pSVGElement;
		this._ViewportElement = pViewportElement;

		if (!this._SVGElement) return;

		// Use pointer events for unified mouse/touch handling
		this._SVGElement.addEventListener('pointerdown', this._boundOnPointerDown);
		this._SVGElement.addEventListener('pointermove', this._boundOnPointerMove);
		this._SVGElement.addEventListener('pointerup', this._boundOnPointerUp);
		this._SVGElement.addEventListener('pointerleave', this._boundOnPointerUp);
		this._SVGElement.addEventListener('wheel', this._boundOnWheel, { passive: false });

		// Keyboard events for delete
		document.addEventListener('keydown', this._boundOnKeyDown);

		// Handle right-click: add/remove bezier handles on connections
		this._SVGElement.addEventListener('contextmenu', (pEvent) =>
		{
			pEvent.preventDefault();

			let tmpTarget = pEvent.target;
			let tmpElementType = this._getElementType(tmpTarget);

			switch (tmpElementType)
			{
				case 'connection':
				case 'connection-hitarea':
					this._addBezierHandle(tmpTarget, pEvent);
					break;

				case 'connection-handle':
					this._removeBezierHandle(tmpTarget);
					break;

				case 'tether':
				case 'tether-hitarea':
					this._addTetherBezierHandle(tmpTarget, pEvent);
					break;

				case 'tether-handle':
					this._removeTetherBezierHandle(tmpTarget);
					break;
			}
		});
	}

	/**
	 * Remove all event listeners
	 */
	destroy()
	{
		if (this._SVGElement)
		{
			this._SVGElement.removeEventListener('pointerdown', this._boundOnPointerDown);
			this._SVGElement.removeEventListener('pointermove', this._boundOnPointerMove);
			this._SVGElement.removeEventListener('pointerup', this._boundOnPointerUp);
			this._SVGElement.removeEventListener('pointerleave', this._boundOnPointerUp);
			this._SVGElement.removeEventListener('wheel', this._boundOnWheel);
		}

		document.removeEventListener('keydown', this._boundOnKeyDown);
	}

	/**
	 * Handle pointer down event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerDown(pEvent)
	{
		if (!this._FlowView) return;

		let tmpTarget = pEvent.target;
		let tmpElementType = this._getElementType(tmpTarget);

		// Check if click is inside a panel content area — let HTML handle its own events
		if (tmpTarget.closest && tmpTarget.closest('.pict-flow-panel-content'))
		{
			return;
		}

		// Capture pointer for smooth dragging (left-click only — right-click
		// needs the real target for contextmenu handle add/remove)
		if (pEvent.button === 0)
		{
			this._SVGElement.setPointerCapture(pEvent.pointerId);
		}

		switch (tmpElementType)
		{
			case 'port':
				this._startConnection(pEvent, tmpTarget);
				break;

			case 'node':
			case 'node-body':
			case 'panel-indicator':
			{
				let tmpNodeHash = this._getNodeHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same node
				if (tmpNodeHash && tmpNodeHash === this._LastClickNodeHash
					&& (tmpNow - this._LastClickTime) < this._DoubleClickThreshold)
				{
					// Double-click: toggle panel
					this._LastClickTime = 0;
					this._LastClickNodeHash = null;
					this._FlowView.togglePanel(tmpNodeHash);
				}
				else
				{
					// Single click: start node drag
					this._LastClickTime = tmpNow;
					this._LastClickNodeHash = tmpNodeHash;
					this._startNodeDrag(pEvent, tmpTarget);
				}
				break;
			}

			case 'panel-titlebar':
				this._startPanelDrag(pEvent, tmpTarget);
				break;

			case 'panel-resize':
				this._startPanelResize(pEvent, tmpTarget);
				break;

			case 'panel-close':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				if (tmpPanelHash)
				{
					this._FlowView.closePanel(tmpPanelHash);
				}
				break;
			}

			case 'connection-handle':
			{
				let tmpConnectionHash = this._getConnectionHash(tmpTarget);
				let tmpHandleType = tmpTarget.getAttribute('data-handle-type');
				let tmpNow = Date.now();

				// Check for double-click on handle to toggle mode
				if (tmpConnectionHash === this._LastHandleClickHash
					&& tmpHandleType === this._LastHandleClickType
					&& (tmpNow - this._LastHandleClickTime) < this._DoubleClickThreshold)
				{
					this._toggleConnectionLineMode(tmpConnectionHash);
					this._LastHandleClickTime = 0;
					this._LastHandleClickHash = null;
					this._LastHandleClickType = null;
				}
				else
				{
					this._LastHandleClickTime = tmpNow;
					this._LastHandleClickHash = tmpConnectionHash;
					this._LastHandleClickType = tmpHandleType;
					this._startHandleDrag(pEvent, tmpConnectionHash, null, tmpHandleType, false);
				}
				pEvent.stopPropagation();
				break;
			}

			case 'tether':
			case 'tether-hitarea':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same tether to add a handle
				if (tmpPanelHash && tmpPanelHash === this._LastTetherClickHash
					&& (tmpNow - this._LastTetherClickTime) < this._DoubleClickThreshold)
				{
					this._LastTetherClickTime = 0;
					this._LastTetherClickHash = null;
					this._addTetherBezierHandle(tmpTarget, pEvent);
				}
				else
				{
					this._LastTetherClickTime = tmpNow;
					this._LastTetherClickHash = tmpPanelHash;
					this._selectTether(tmpTarget);
				}
				break;
			}

			case 'tether-handle':
			{
				let tmpPanelHash = this._getPanelHash(tmpTarget);
				let tmpHandleType = tmpTarget.getAttribute('data-handle-type');
				let tmpNow = Date.now();

				// Check for double-click on tether handle to toggle mode
				if (tmpPanelHash === this._LastHandleClickHash
					&& tmpHandleType === this._LastHandleClickType
					&& (tmpNow - this._LastHandleClickTime) < this._DoubleClickThreshold)
				{
					this._toggleTetherLineMode(tmpPanelHash);
					this._LastHandleClickTime = 0;
					this._LastHandleClickHash = null;
					this._LastHandleClickType = null;
				}
				else
				{
					this._LastHandleClickTime = tmpNow;
					this._LastHandleClickHash = tmpPanelHash;
					this._LastHandleClickType = tmpHandleType;
					this._startHandleDrag(pEvent, null, tmpPanelHash, tmpHandleType, true);
				}
				pEvent.stopPropagation();
				break;
			}

			case 'connection':
			case 'connection-hitarea':
			{
				let tmpConnectionHash = this._getConnectionHash(tmpTarget);
				let tmpNow = Date.now();

				// Check for double-click on same connection to add a handle
				if (tmpConnectionHash && tmpConnectionHash === this._LastConnectionClickHash
					&& (tmpNow - this._LastConnectionClickTime) < this._DoubleClickThreshold)
				{
					this._LastConnectionClickTime = 0;
					this._LastConnectionClickHash = null;
					this._addBezierHandle(tmpTarget, pEvent);
				}
				else
				{
					this._LastConnectionClickTime = tmpNow;
					this._LastConnectionClickHash = tmpConnectionHash;
					this._selectConnection(tmpTarget);
				}
				break;
			}

			default:
				// Click on background - start panning or deselect
				if (pEvent.button === 0 && this._FlowView.options.EnablePanning)
				{
					this._startPanning(pEvent);
				}
				break;
		}
	}

	/**
	 * Handle pointer move event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerMove(pEvent)
	{
		if (!this._FlowView) return;

		switch (this._State)
		{
			case INTERACTION_STATES.DRAGGING_NODE:
				this._onNodeDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_PANEL:
				this._onPanelDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_HANDLE:
				this._onHandleDrag(pEvent);
				break;

			case INTERACTION_STATES.CONNECTING:
				this._onConnectionDrag(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_PANEL:
				this._onPanelResize(pEvent);
				break;

			case INTERACTION_STATES.PANNING:
				this._onPan(pEvent);
				break;
		}
	}

	/**
	 * Handle pointer up event
	 * @param {PointerEvent} pEvent
	 */
	_onPointerUp(pEvent)
	{
		if (!this._FlowView) return;

		// Release pointer capture
		if (this._SVGElement.hasPointerCapture && this._SVGElement.hasPointerCapture(pEvent.pointerId))
		{
			this._SVGElement.releasePointerCapture(pEvent.pointerId);
		}

		switch (this._State)
		{
			case INTERACTION_STATES.DRAGGING_NODE:
				this._endNodeDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_PANEL:
				this._endPanelDrag(pEvent);
				break;

			case INTERACTION_STATES.DRAGGING_HANDLE:
				this._endHandleDrag(pEvent);
				break;

			case INTERACTION_STATES.RESIZING_PANEL:
				this._endPanelResize(pEvent);
				break;

			case INTERACTION_STATES.CONNECTING:
				this._endConnection(pEvent);
				break;

			case INTERACTION_STATES.PANNING:
				this._endPanning(pEvent);
				break;
		}
	}

	/**
	 * Handle mouse wheel for zoom
	 * @param {WheelEvent} pEvent
	 */
	_onWheel(pEvent)
	{
		if (!this._FlowView || !this._FlowView.options.EnableZooming) return;

		pEvent.preventDefault();

		let tmpDelta = pEvent.deltaY > 0 ? -this._FlowView.options.ZoomStep : this._FlowView.options.ZoomStep;
		let tmpNewZoom = this._FlowView.viewState.Zoom + tmpDelta;

		// Zoom toward mouse position
		let tmpRect = this._SVGElement.getBoundingClientRect();
		let tmpMouseX = pEvent.clientX - tmpRect.left;
		let tmpMouseY = pEvent.clientY - tmpRect.top;

		this._FlowView.setZoom(tmpNewZoom, tmpMouseX, tmpMouseY);
	}

	/**
	 * Handle keyboard events
	 * @param {KeyboardEvent} pEvent
	 */
	_onKeyDown(pEvent)
	{
		if (!this._FlowView) return;

		// Only handle events when the flow is focused/visible
		if (pEvent.key === 'Delete' || pEvent.key === 'Backspace')
		{
			// Don't delete if user is typing in an input or inside a panel
			if (pEvent.target && (pEvent.target.tagName === 'INPUT' || pEvent.target.tagName === 'TEXTAREA' || pEvent.target.tagName === 'SELECT'))
			{
				return;
			}
			if (pEvent.target && pEvent.target.closest && pEvent.target.closest('.pict-flow-panel'))
			{
				return;
			}

			this._FlowView.deleteSelected();
			pEvent.preventDefault();
		}
		else if (pEvent.key === 'Escape')
		{
			if (this._State === INTERACTION_STATES.CONNECTING)
			{
				this._cancelConnection();
			}

			// Exit fullscreen if currently in fullscreen mode
			if (this._FlowView._IsFullscreen)
			{
				this._FlowView.exitFullscreen();
				// Update the toolbar button text
				if (this._FlowView._ToolbarView)
				{
					let tmpFlowViewIdentifier = this._FlowView.options.ViewIdentifier;
					let tmpBtnElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-${tmpFlowViewIdentifier}`);
					if (tmpBtnElements.length > 0)
					{
						tmpBtnElements[0].innerHTML = '&#x26F6; Fullscreen';
					}
				}
				pEvent.preventDefault();
				return;
			}

			this._FlowView.deselectAll();
		}
	}

	// ---- Node Dragging ----

	_startNodeDrag(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableNodeDragging) return;

		let tmpNodeHash = this._getNodeHash(pTarget);
		if (!tmpNodeHash) return;

		this._FlowView.selectNode(tmpNodeHash);

		let tmpNode = this._FlowView.getNode(tmpNodeHash);
		if (!tmpNode) return;

		this._State = INTERACTION_STATES.DRAGGING_NODE;
		this._DragNodeHash = tmpNodeHash;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;
		this._DragNodeStartX = tmpNode.X;
		this._DragNodeStartY = tmpNode.Y;

		this._SVGElement.classList.add('panning');

		let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${tmpNodeHash}"]`);
		if (tmpNodeGroup)
		{
			tmpNodeGroup.classList.add('dragging');
		}
	}

	_onNodeDrag(pEvent)
	{
		if (!this._DragNodeHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._DragStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._DragStartY) / tmpVS.Zoom;

		let tmpNewX = this._DragNodeStartX + tmpDX;
		let tmpNewY = this._DragNodeStartY + tmpDY;

		this._FlowView.updateNodePosition(this._DragNodeHash, tmpNewX, tmpNewY);
	}

	_endNodeDrag(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${this._DragNodeHash}"]`);
		if (tmpNodeGroup)
		{
			tmpNodeGroup.classList.remove('dragging');
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		let tmpNode = this._FlowView.getNode(this._DragNodeHash);
		if (tmpNode && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onNodeMoved', tmpNode);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._DragNodeHash = null;
	}

	// ---- Panel Dragging ----

	_startPanelDrag(pEvent, pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === tmpPanelHash);
		if (!tmpPanel) return;

		this._State = INTERACTION_STATES.DRAGGING_PANEL;
		this._DragPanelHash = tmpPanelHash;
		this._DragPanelStartX = pEvent.clientX;
		this._DragPanelStartY = pEvent.clientY;
		this._DragPanelDataStartX = tmpPanel.X;
		this._DragPanelDataStartY = tmpPanel.Y;

		this._SVGElement.classList.add('panning');
	}

	_onPanelDrag(pEvent)
	{
		if (!this._DragPanelHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDX = (pEvent.clientX - this._DragPanelStartX) / tmpVS.Zoom;
		let tmpDY = (pEvent.clientY - this._DragPanelStartY) / tmpVS.Zoom;

		let tmpNewX = this._DragPanelDataStartX + tmpDX;
		let tmpNewY = this._DragPanelDataStartY + tmpDY;

		this._FlowView.updatePanelPosition(this._DragPanelHash, tmpNewX, tmpNewY);
	}

	_endPanelDrag(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		this._FlowView.marshalFromView();

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._DragPanelHash);
		if (tmpPanel && this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelMoved', tmpPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._DragPanelHash = null;
	}

	// ---- Panel Resizing ----

	_startPanelResize(pEvent, pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === tmpPanelHash);
		if (!tmpPanel) return;

		this._State = INTERACTION_STATES.RESIZING_PANEL;
		this._ResizePanelHash = tmpPanelHash;
		this._ResizeStartY = pEvent.clientY;
		this._ResizePanelStartHeight = tmpPanel.Height;

		this._SVGElement.classList.add('panning');
	}

	_onPanelResize(pEvent)
	{
		if (!this._ResizePanelHash) return;

		let tmpVS = this._FlowView.viewState;
		let tmpDY = (pEvent.clientY - this._ResizeStartY) / tmpVS.Zoom;
		let tmpNewHeight = Math.max(120, this._ResizePanelStartHeight + tmpDY);

		// Update the panel data
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._ResizePanelHash);
		if (tmpPanel)
		{
			tmpPanel.Height = tmpNewHeight;
		}

		// Update the foreignObject height directly for smooth resizing
		if (this._FlowView._PanelsLayer)
		{
			let tmpFO = this._FlowView._PanelsLayer.querySelector('[data-panel-hash="' + this._ResizePanelHash + '"]');
			if (tmpFO)
			{
				tmpFO.setAttribute('height', String(tmpNewHeight));
			}
		}
	}

	_endPanelResize(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		// Re-render to sync tethers
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}

		this._State = INTERACTION_STATES.IDLE;
		this._ResizePanelHash = null;
	}

	// ---- Handle Dragging ----

	_startHandleDrag(pEvent, pConnectionHash, pPanelHash, pHandleType, pIsTether)
	{
		this._State = INTERACTION_STATES.DRAGGING_HANDLE;
		this._DragHandleConnectionHash = pConnectionHash;
		this._DragHandlePanelHash = pPanelHash;
		this._DragHandleType = pHandleType;
		this._DragHandleIsTether = pIsTether;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;
		this._SVGElement.classList.add('panning');
	}

	_onHandleDrag(pEvent)
	{
		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);

		if (this._DragHandleIsTether)
		{
			this._FlowView.updateTetherHandle(
				this._DragHandlePanelHash,
				this._DragHandleType,
				tmpCoords.x,
				tmpCoords.y
			);
		}
		else
		{
			this._FlowView.updateConnectionHandle(
				this._DragHandleConnectionHash,
				this._DragHandleType,
				tmpCoords.x,
				tmpCoords.y
			);
		}
	}

	_endHandleDrag(pEvent)
	{
		this._SVGElement.classList.remove('panning');

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);

			if (this._DragHandleIsTether)
			{
				let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === this._DragHandlePanelHash);
				if (tmpPanel)
				{
					this._FlowView._EventHandlerProvider.fireEvent('onTetherHandleMoved', tmpPanel);
				}
			}
			else
			{
				let tmpConnection = this._FlowView.getConnection(this._DragHandleConnectionHash);
				if (tmpConnection)
				{
					this._FlowView._EventHandlerProvider.fireEvent('onConnectionHandleMoved', tmpConnection);
				}
			}
		}

		this._State = INTERACTION_STATES.IDLE;
		this._DragHandleConnectionHash = null;
		this._DragHandlePanelHash = null;
		this._DragHandleType = null;
		this._DragHandleIsTether = false;
	}

	// ---- Right-Click Handle Add/Remove ----

	/**
	 * Add a bezier handle to a connection at the right-click position.
	 * @param {Element} pTarget - The SVG element that was right-clicked
	 * @param {MouseEvent} pEvent - The contextmenu event
	 */
	_addBezierHandle(pTarget, pEvent)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (!tmpConnectionHash) return;

		// Select the connection so handle circles are rendered after the re-render
		this._FlowView.selectConnection(tmpConnectionHash);

		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._FlowView.addConnectionHandle(tmpConnectionHash, tmpCoords.x, tmpCoords.y);
	}

	/**
	 * Remove a bezier handle from a connection.
	 * @param {Element} pTarget - The handle SVG element that was right-clicked
	 */
	_removeBezierHandle(pTarget)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (!tmpConnectionHash) return;

		let tmpHandleType = pTarget.getAttribute('data-handle-type');
		if (!tmpHandleType || !tmpHandleType.startsWith('bezier-handle-')) return;

		let tmpIndex = parseInt(tmpHandleType.replace('bezier-handle-', ''), 10);
		if (isNaN(tmpIndex)) return;

		this._FlowView.removeConnectionHandle(tmpConnectionHash, tmpIndex);
	}

	/**
	 * Add a bezier handle to a tether.
	 * @param {Element} pTarget - The tether SVG element that was right-clicked or double-clicked
	 * @param {Event} pEvent - The mouse event (for coordinate extraction)
	 */
	_addTetherBezierHandle(pTarget, pEvent)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		// Select the tether so handles render after re-render
		this._FlowView.selectTether(tmpPanelHash);

		let tmpCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);
		this._FlowView.addTetherHandle(tmpPanelHash, tmpCoords.x, tmpCoords.y);
	}

	/**
	 * Remove a bezier handle from a tether.
	 * @param {Element} pTarget - The tether handle SVG element that was right-clicked
	 */
	_removeTetherBezierHandle(pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (!tmpPanelHash) return;

		let tmpHandleType = pTarget.getAttribute('data-handle-type');
		if (!tmpHandleType || !tmpHandleType.startsWith('bezier-handle-')) return;

		let tmpIndex = parseInt(tmpHandleType.replace('bezier-handle-', ''), 10);
		if (isNaN(tmpIndex)) return;

		this._FlowView.removeTetherHandle(tmpPanelHash, tmpIndex);
	}

	// ---- Line Mode Toggling ----

	_toggleConnectionLineMode(pConnectionHash)
	{
		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		if (!tmpConnection.Data) tmpConnection.Data = {};

		let tmpCurrentMode = tmpConnection.Data.LineMode || 'bezier';
		tmpConnection.Data.LineMode = (tmpCurrentMode === 'bezier') ? 'orthogonal' : 'bezier';

		// Reset handle positions when switching modes
		tmpConnection.Data.HandleCustomized = false;
		tmpConnection.Data.BezierHandles = [];
		tmpConnection.Data.BezierHandleX = null;
		tmpConnection.Data.BezierHandleY = null;
		tmpConnection.Data.OrthoCorner1X = null;
		tmpConnection.Data.OrthoCorner1Y = null;
		tmpConnection.Data.OrthoCorner2X = null;
		tmpConnection.Data.OrthoCorner2Y = null;
		tmpConnection.Data.OrthoMidOffset = 0;

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionModeChanged', tmpConnection);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}
	}

	_toggleTetherLineMode(pPanelHash)
	{
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._FlowView._TetherService)
		{
			this._FlowView._TetherService.toggleLineMode(tmpPanel);
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onTetherModeChanged', tmpPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView.flowData);
		}
	}

	// ---- Tether Selection ----

	_selectTether(pTarget)
	{
		let tmpPanelHash = this._getPanelHash(pTarget);
		if (tmpPanelHash)
		{
			this._FlowView.selectTether(tmpPanelHash);
		}
	}

	// ---- Connection Creation ----

	_startConnection(pEvent, pTarget)
	{
		if (!this._FlowView.options.EnableConnectionCreation) return;

		let tmpNodeHash = pTarget.getAttribute('data-node-hash');
		let tmpPortHash = pTarget.getAttribute('data-port-hash');
		let tmpPortDirection = pTarget.getAttribute('data-port-direction');

		if (!tmpNodeHash || !tmpPortHash) return;

		if (tmpPortDirection !== 'output')
		{
			return;
		}

		this._State = INTERACTION_STATES.CONNECTING;
		this._ConnectSourceNodeHash = tmpNodeHash;
		this._ConnectSourcePortHash = tmpPortHash;

		this._SVGElement.classList.add('connecting');

		let tmpPortPos = this._FlowView.getPortPosition(tmpNodeHash, tmpPortHash);
		if (tmpPortPos)
		{
			this._ConnectDragLine = document.createElementNS('http://www.w3.org/2000/svg', 'path');
			this._ConnectDragLine.setAttribute('class', 'pict-flow-drag-connection');
			this._ConnectDragLine.setAttribute('d', `M ${tmpPortPos.x} ${tmpPortPos.y} L ${tmpPortPos.x} ${tmpPortPos.y}`);
			this._FlowView._ViewportElement.appendChild(this._ConnectDragLine);
		}

		pEvent.stopPropagation();
	}

	_onConnectionDrag(pEvent)
	{
		if (!this._ConnectDragLine) return;

		let tmpSourcePos = this._FlowView.getPortPosition(this._ConnectSourceNodeHash, this._ConnectSourcePortHash);
		if (!tmpSourcePos) return;

		let tmpEndCoords = this._FlowView.screenToSVGCoords(pEvent.clientX, pEvent.clientY);

		let tmpDX = Math.abs(tmpEndCoords.x - tmpSourcePos.x) * 0.5;
		let tmpPath = `M ${tmpSourcePos.x} ${tmpSourcePos.y} C ${tmpSourcePos.x + tmpDX} ${tmpSourcePos.y}, ${tmpEndCoords.x - tmpDX} ${tmpEndCoords.y}, ${tmpEndCoords.x} ${tmpEndCoords.y}`;
		this._ConnectDragLine.setAttribute('d', tmpPath);
	}

	_endConnection(pEvent)
	{
		if (this._ConnectDragLine && this._ConnectDragLine.parentNode)
		{
			this._ConnectDragLine.parentNode.removeChild(this._ConnectDragLine);
		}
		this._ConnectDragLine = null;

		this._SVGElement.classList.remove('connecting');

		let tmpTarget = document.elementFromPoint(pEvent.clientX, pEvent.clientY);
		if (tmpTarget)
		{
			let tmpTargetPortHash = tmpTarget.getAttribute('data-port-hash');
			let tmpTargetNodeHash = tmpTarget.getAttribute('data-node-hash');
			let tmpTargetPortDirection = tmpTarget.getAttribute('data-port-direction');

			if (tmpTargetPortHash && tmpTargetNodeHash && tmpTargetPortDirection === 'input')
			{
				this._FlowView.addConnection(
					this._ConnectSourceNodeHash,
					this._ConnectSourcePortHash,
					tmpTargetNodeHash,
					tmpTargetPortHash
				);
			}
		}

		this._State = INTERACTION_STATES.IDLE;
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
	}

	_cancelConnection()
	{
		if (this._ConnectDragLine && this._ConnectDragLine.parentNode)
		{
			this._ConnectDragLine.parentNode.removeChild(this._ConnectDragLine);
		}
		this._ConnectDragLine = null;

		this._SVGElement.classList.remove('connecting');

		this._State = INTERACTION_STATES.IDLE;
		this._ConnectSourceNodeHash = null;
		this._ConnectSourcePortHash = null;
	}

	// ---- Panning ----

	_startPanning(pEvent)
	{
		this._FlowView.deselectAll();

		this._State = INTERACTION_STATES.PANNING;
		this._PanStartX = pEvent.clientX;
		this._PanStartY = pEvent.clientY;
		this._PanStartPanX = this._FlowView.viewState.PanX;
		this._PanStartPanY = this._FlowView.viewState.PanY;

		this._SVGElement.classList.add('panning');
	}

	_onPan(pEvent)
	{
		let tmpDX = pEvent.clientX - this._PanStartX;
		let tmpDY = pEvent.clientY - this._PanStartY;

		this._FlowView.viewState.PanX = this._PanStartPanX + tmpDX;
		this._FlowView.viewState.PanY = this._PanStartPanY + tmpDY;

		this._FlowView.updateViewportTransform();
	}

	_endPanning(pEvent)
	{
		this._SVGElement.classList.remove('panning');
		this._State = INTERACTION_STATES.IDLE;
	}

	// ---- Connection Selection ----

	_selectConnection(pTarget)
	{
		let tmpConnectionHash = this._getConnectionHash(pTarget);
		if (tmpConnectionHash)
		{
			this._FlowView.selectConnection(tmpConnectionHash);
		}
	}

	// ---- Utilities ----

	_getElementType(pTarget)
	{
		if (!pTarget) return 'background';

		let tmpType = pTarget.getAttribute ? pTarget.getAttribute('data-element-type') : null;
		if (tmpType) return tmpType;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpType = tmpParent.getAttribute ? tmpParent.getAttribute('data-element-type') : null;
			if (tmpType) return tmpType;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return 'background';
	}

	_getNodeHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-node-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-node-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}

	_getPanelHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-panel-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-panel-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}

	_getConnectionHash(pTarget)
	{
		if (!pTarget) return null;

		let tmpHash = pTarget.getAttribute ? pTarget.getAttribute('data-connection-hash') : null;
		if (tmpHash) return tmpHash;

		let tmpParent = pTarget.parentElement;
		let tmpDepth = 0;
		while (tmpParent && tmpDepth < 5)
		{
			tmpHash = tmpParent.getAttribute ? tmpParent.getAttribute('data-connection-hash') : null;
			if (tmpHash) return tmpHash;
			tmpParent = tmpParent.parentElement;
			tmpDepth++;
		}

		return null;
	}
}

module.exports = PictServiceFlowInteractionManager;
module.exports.INTERACTION_STATES = INTERACTION_STATES;

},{"fable-serviceproviderbase":2}],50:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class PictServiceFlowLayout extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowLayout';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		// Layout configuration
		this._HorizontalSpacing = 250;
		this._VerticalSpacing = 120;
		this._StartX = 100;
		this._StartY = 100;
	}

	/**
	 * Snap a coordinate to the nearest grid point
	 * @param {number} pValue - The coordinate value
	 * @param {number} pGridSize - The grid size
	 * @returns {number}
	 */
	snapToGrid(pValue, pGridSize)
	{
		if (!pGridSize || pGridSize <= 0) return pValue;
		return Math.round(pValue / pGridSize) * pGridSize;
	}

	/**
	 * Auto-layout nodes using a simple left-to-right topological approach
	 * @param {Array} pNodes - Array of node data objects
	 * @param {Array} pConnections - Array of connection data objects
	 */
	autoLayout(pNodes, pConnections)
	{
		if (!pNodes || pNodes.length === 0) return;

		// Build adjacency information
		let tmpNodeMap = {};
		let tmpInDegree = {};
		let tmpOutEdges = {};

		for (let i = 0; i < pNodes.length; i++)
		{
			let tmpNode = pNodes[i];
			tmpNodeMap[tmpNode.Hash] = tmpNode;
			tmpInDegree[tmpNode.Hash] = 0;
			tmpOutEdges[tmpNode.Hash] = [];
		}

		for (let i = 0; i < pConnections.length; i++)
		{
			let tmpConn = pConnections[i];
			if (tmpInDegree.hasOwnProperty(tmpConn.TargetNodeHash))
			{
				tmpInDegree[tmpConn.TargetNodeHash]++;
			}
			if (tmpOutEdges.hasOwnProperty(tmpConn.SourceNodeHash))
			{
				tmpOutEdges[tmpConn.SourceNodeHash].push(tmpConn.TargetNodeHash);
			}
		}

		// Topological sort (Kahn's algorithm)
		let tmpLayers = [];
		let tmpQueue = [];
		let tmpAssigned = {};

		// Start with nodes that have no incoming edges
		for (let tmpHash in tmpInDegree)
		{
			if (tmpInDegree[tmpHash] === 0)
			{
				tmpQueue.push(tmpHash);
			}
		}

		while (tmpQueue.length > 0)
		{
			let tmpCurrentLayer = [];

			let tmpNextQueue = [];
			for (let i = 0; i < tmpQueue.length; i++)
			{
				let tmpNodeHash = tmpQueue[i];
				if (tmpAssigned[tmpNodeHash]) continue;

				tmpAssigned[tmpNodeHash] = true;
				tmpCurrentLayer.push(tmpNodeHash);

				// Process outgoing edges
				let tmpEdges = tmpOutEdges[tmpNodeHash] || [];
				for (let j = 0; j < tmpEdges.length; j++)
				{
					let tmpTargetHash = tmpEdges[j];
					tmpInDegree[tmpTargetHash]--;
					if (tmpInDegree[tmpTargetHash] <= 0 && !tmpAssigned[tmpTargetHash])
					{
						tmpNextQueue.push(tmpTargetHash);
					}
				}
			}

			if (tmpCurrentLayer.length > 0)
			{
				tmpLayers.push(tmpCurrentLayer);
			}

			tmpQueue = tmpNextQueue;
		}

		// Handle any remaining unassigned nodes (cycles or disconnected)
		let tmpRemainingNodes = [];
		for (let i = 0; i < pNodes.length; i++)
		{
			if (!tmpAssigned[pNodes[i].Hash])
			{
				tmpRemainingNodes.push(pNodes[i].Hash);
			}
		}
		if (tmpRemainingNodes.length > 0)
		{
			tmpLayers.push(tmpRemainingNodes);
		}

		// Assign positions based on layers
		let tmpCurrentX = this._StartX;

		for (let tmpLayerIndex = 0; tmpLayerIndex < tmpLayers.length; tmpLayerIndex++)
		{
			let tmpLayer = tmpLayers[tmpLayerIndex];
			let tmpMaxWidth = 0;

			// Calculate the total height for this layer to center vertically
			let tmpTotalHeight = 0;
			for (let i = 0; i < tmpLayer.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpLayer[i]];
				if (tmpNode)
				{
					tmpTotalHeight += tmpNode.Height || 80;
					if (i < tmpLayer.length - 1)
					{
						tmpTotalHeight += this._VerticalSpacing;
					}
				}
			}

			let tmpCurrentY = this._StartY;

			for (let i = 0; i < tmpLayer.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpLayer[i]];
				if (!tmpNode) continue;

				tmpNode.X = tmpCurrentX;
				tmpNode.Y = tmpCurrentY;

				let tmpWidth = tmpNode.Width || 180;
				let tmpHeight = tmpNode.Height || 80;

				tmpMaxWidth = Math.max(tmpMaxWidth, tmpWidth);
				tmpCurrentY += tmpHeight + this._VerticalSpacing;
			}

			tmpCurrentX += tmpMaxWidth + this._HorizontalSpacing;
		}
	}

	/**
	 * Auto-layout a subset of nodes, positioning them to the right of
	 * any fixed (already-positioned) nodes.
	 *
	 * Uses the same topological sort approach as autoLayout, but only
	 * repositions the nodes in pNodesToLayout. The pFixedNodes are used
	 * to compute a bounding box that the new layout avoids.
	 *
	 * @param {Array} pNodesToLayout - Nodes that need new positions
	 * @param {Array} pFixedNodes - Nodes that already have positions (read-only)
	 * @param {Array} pConnections - All connections in the flow
	 */
	autoLayoutSubset(pNodesToLayout, pFixedNodes, pConnections)
	{
		if (!pNodesToLayout || pNodesToLayout.length === 0) return;

		// Compute the starting X position to the right of all fixed nodes
		let tmpStartX = this._StartX;
		let tmpStartY = this._StartY;

		if (pFixedNodes && pFixedNodes.length > 0)
		{
			let tmpMaxX = -Infinity;

			for (let i = 0; i < pFixedNodes.length; i++)
			{
				let tmpRight = pFixedNodes[i].X + (pFixedNodes[i].Width || 180);
				if (tmpRight > tmpMaxX)
				{
					tmpMaxX = tmpRight;
				}
			}

			// Place unmatched nodes to the right of all fixed nodes
			tmpStartX = tmpMaxX + this._HorizontalSpacing;
		}

		// Build a set of nodes we are laying out for quick lookup
		let tmpNodeSet = {};
		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			tmpNodeSet[pNodesToLayout[i].Hash] = true;
		}

		// Build adjacency information only for nodes in the subset
		let tmpNodeMap = {};
		let tmpInDegree = {};
		let tmpOutEdges = {};

		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			let tmpNode = pNodesToLayout[i];
			tmpNodeMap[tmpNode.Hash] = tmpNode;
			tmpInDegree[tmpNode.Hash] = 0;
			tmpOutEdges[tmpNode.Hash] = [];
		}

		// Only count edges between nodes in the subset
		for (let i = 0; i < pConnections.length; i++)
		{
			let tmpConn = pConnections[i];
			let tmpSourceInSubset = tmpNodeSet[tmpConn.SourceNodeHash];
			let tmpTargetInSubset = tmpNodeSet[tmpConn.TargetNodeHash];

			if (tmpSourceInSubset && tmpTargetInSubset)
			{
				tmpInDegree[tmpConn.TargetNodeHash]++;
				tmpOutEdges[tmpConn.SourceNodeHash].push(tmpConn.TargetNodeHash);
			}
		}

		// Topological sort (Kahn's algorithm)
		let tmpLayers = [];
		let tmpQueue = [];
		let tmpAssigned = {};

		for (let tmpHash in tmpInDegree)
		{
			if (tmpInDegree[tmpHash] === 0)
			{
				tmpQueue.push(tmpHash);
			}
		}

		while (tmpQueue.length > 0)
		{
			let tmpCurrentLayer = [];
			let tmpNextQueue = [];

			for (let i = 0; i < tmpQueue.length; i++)
			{
				let tmpNodeHash = tmpQueue[i];
				if (tmpAssigned[tmpNodeHash]) continue;

				tmpAssigned[tmpNodeHash] = true;
				tmpCurrentLayer.push(tmpNodeHash);

				let tmpEdges = tmpOutEdges[tmpNodeHash] || [];
				for (let j = 0; j < tmpEdges.length; j++)
				{
					let tmpTargetHash = tmpEdges[j];
					tmpInDegree[tmpTargetHash]--;
					if (tmpInDegree[tmpTargetHash] <= 0 && !tmpAssigned[tmpTargetHash])
					{
						tmpNextQueue.push(tmpTargetHash);
					}
				}
			}

			if (tmpCurrentLayer.length > 0)
			{
				tmpLayers.push(tmpCurrentLayer);
			}

			tmpQueue = tmpNextQueue;
		}

		// Handle remaining unassigned nodes (cycles or disconnected)
		let tmpRemainingNodes = [];
		for (let i = 0; i < pNodesToLayout.length; i++)
		{
			if (!tmpAssigned[pNodesToLayout[i].Hash])
			{
				tmpRemainingNodes.push(pNodesToLayout[i].Hash);
			}
		}
		if (tmpRemainingNodes.length > 0)
		{
			tmpLayers.push(tmpRemainingNodes);
		}

		// Assign positions based on layers, starting from tmpStartX
		let tmpCurrentX = tmpStartX;

		for (let tmpLayerIndex = 0; tmpLayerIndex < tmpLayers.length; tmpLayerIndex++)
		{
			let tmpLayer = tmpLayers[tmpLayerIndex];
			let tmpMaxWidth = 0;
			let tmpCurrentY = tmpStartY;

			for (let i = 0; i < tmpLayer.length; i++)
			{
				let tmpNode = tmpNodeMap[tmpLayer[i]];
				if (!tmpNode) continue;

				tmpNode.X = tmpCurrentX;
				tmpNode.Y = tmpCurrentY;

				let tmpWidth = tmpNode.Width || 180;
				let tmpHeight = tmpNode.Height || 80;

				tmpMaxWidth = Math.max(tmpMaxWidth, tmpWidth);
				tmpCurrentY += tmpHeight + this._VerticalSpacing;
			}

			tmpCurrentX += tmpMaxWidth + this._HorizontalSpacing;
		}
	}

	/**
	 * Center all nodes around a given point
	 * @param {Array} pNodes
	 * @param {number} pCenterX
	 * @param {number} pCenterY
	 */
	centerNodes(pNodes, pCenterX, pCenterY)
	{
		if (!pNodes || pNodes.length === 0) return;

		let tmpMinX = Infinity, tmpMinY = Infinity;
		let tmpMaxX = -Infinity, tmpMaxY = -Infinity;

		for (let i = 0; i < pNodes.length; i++)
		{
			tmpMinX = Math.min(tmpMinX, pNodes[i].X);
			tmpMinY = Math.min(tmpMinY, pNodes[i].Y);
			tmpMaxX = Math.max(tmpMaxX, pNodes[i].X + (pNodes[i].Width || 180));
			tmpMaxY = Math.max(tmpMaxY, pNodes[i].Y + (pNodes[i].Height || 80));
		}

		let tmpCurrentCenterX = (tmpMinX + tmpMaxX) / 2;
		let tmpCurrentCenterY = (tmpMinY + tmpMaxY) / 2;
		let tmpOffsetX = pCenterX - tmpCurrentCenterX;
		let tmpOffsetY = pCenterY - tmpCurrentCenterY;

		for (let i = 0; i < pNodes.length; i++)
		{
			pNodes[i].X += tmpOffsetX;
			pNodes[i].Y += tmpOffsetY;
		}
	}
}

module.exports = PictServiceFlowLayout;

},{"fable-serviceproviderbase":2}],51:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PanelManager
 *
 * Manages the lifecycle of properties panels in the flow diagram:
 * opening, closing, toggling, and position updates for panels
 * associated with flow nodes.
 */
class PictServiceFlowPanelManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPanelManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Open a properties panel for a node.
	 * @param {string} pNodeHash - The hash of the node to open a panel for
	 * @returns {Object|false} The panel data, or false if the node was not found
	 */
	openPanel(pNodeHash)
	{
		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return false;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNode.Type);
		if (!tmpNodeTypeConfig) return false;

		// Check if a panel is already open for this node
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpExisting) return tmpExisting;

		let tmpPanelConfig = tmpNodeTypeConfig.PropertiesPanel;
		let tmpPanelHash = `panel-${this.fable.getUUID()}`;
		let tmpWidth, tmpHeight, tmpPanelType, tmpTitle;

		if (tmpPanelConfig)
		{
			tmpWidth = tmpPanelConfig.DefaultWidth || 300;
			tmpHeight = tmpPanelConfig.DefaultHeight || 200;
			tmpPanelType = tmpPanelConfig.PanelType || 'Base';
			tmpTitle = tmpPanelConfig.Title || tmpNodeTypeConfig.Label || 'Properties';
		}
		else
		{
			// No PropertiesPanel configured — open an auto-generated info panel
			tmpWidth = 240;
			tmpHeight = 180;
			tmpPanelType = 'Info';
			tmpTitle = tmpNodeTypeConfig.Label || tmpNode.Title || 'Node Info';
		}

		let tmpPanelData =
		{
			Hash: tmpPanelHash,
			NodeHash: pNodeHash,
			PanelType: tmpPanelType,
			Title: tmpTitle,
			X: tmpNode.X + tmpNode.Width + 30,
			Y: tmpNode.Y,
			Width: tmpWidth,
			Height: tmpHeight
		};

		this._FlowView._FlowData.OpenPanels.push(tmpPanelData);
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelOpened', tmpPanelData);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return tmpPanelData;
	}

	/**
	 * Close a properties panel by panel hash.
	 * @param {string} pPanelHash
	 * @returns {boolean}
	 */
	closePanel(pPanelHash)
	{
		let tmpIndex = this._FlowView._FlowData.OpenPanels.findIndex((pPanel) => pPanel.Hash === pPanelHash);
		if (tmpIndex < 0) return false;

		let tmpRemovedPanel = this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1)[0];

		// Clean up the panel instance
		if (this._FlowView._PropertiesPanelView)
		{
			this._FlowView._PropertiesPanelView.destroyPanel(pPanelHash);
		}

		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onPanelClosed', tmpRemovedPanel);
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}

		return true;
	}

	/**
	 * Close all panels for a given node.
	 * @param {string} pNodeHash
	 * @returns {boolean}
	 */
	closePanelForNode(pNodeHash)
	{
		let tmpPanelsToClose = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpPanelsToClose.length === 0) return false;

		for (let i = 0; i < tmpPanelsToClose.length; i++)
		{
			let tmpIndex = this._FlowView._FlowData.OpenPanels.indexOf(tmpPanelsToClose[i]);
			if (tmpIndex >= 0)
			{
				this._FlowView._FlowData.OpenPanels.splice(tmpIndex, 1);
			}
			if (this._FlowView._PropertiesPanelView)
			{
				this._FlowView._PropertiesPanelView.destroyPanel(tmpPanelsToClose[i].Hash);
			}
		}

		return true;
	}

	/**
	 * Toggle a properties panel for a node (open if closed, close if open).
	 * @param {string} pNodeHash
	 * @returns {Object|false}
	 */
	togglePanel(pNodeHash)
	{
		let tmpExisting = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpExisting)
		{
			this.closePanel(tmpExisting.Hash);
			return false;
		}
		return this.openPanel(pNodeHash);
	}

	/**
	 * Update a panel's position (for drag).
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updatePanelPosition(pPanelHash, pX, pY)
	{
		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		tmpPanel.X = pX;
		tmpPanel.Y = pY;

		// Reset tether handle positions when panel moves
		this._FlowView._resetHandlesForPanel(pPanelHash);

		// Update the foreignObject position directly for smooth dragging
		if (this._FlowView._PanelsLayer)
		{
			let tmpFO = this._FlowView._PanelsLayer.querySelector(`[data-panel-hash="${pPanelHash}"]`);
			if (tmpFO)
			{
				tmpFO.setAttribute('x', String(pX));
				tmpFO.setAttribute('y', String(pY));
			}
		}

		// Update the tether for this panel
		this._FlowView._renderTethersForNode(tmpPanel.NodeHash);
	}
}

module.exports = PictServiceFlowPanelManager;

},{"fable-serviceproviderbase":2}],52:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PathGenerator
 *
 * Centralizes SVG path generation for the flow diagram.
 * Provides shared building blocks used by both the ConnectionRenderer
 * (port-to-port connections) and the TetherService (panel-to-node tethers).
 *
 * Responsibilities:
 *   - Departure/approach point calculation from anchors
 *   - Auto orthogonal corner computation for right-angle paths
 *   - Cubic bezier evaluation at arbitrary parameter t
 *   - SVG path string assembly (bezier, split-bezier, orthogonal)
 */
class PictServiceFlowPathGenerator extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPathGenerator';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ---- Departure / Approach Calculation ----

	/**
	 * Compute departure and approach points from start/end anchors.
	 * The departure point extends outward from the start in its side direction,
	 * and the approach point extends outward from the end in its side direction.
	 *
	 * @param {{x: number, y: number, side: string}} pFrom - Start anchor with side
	 * @param {{x: number, y: number, side: string}} pTo - End anchor with side
	 * @param {number} pDepartDist - Distance for departure/approach straight segments
	 * @returns {{departX: number, departY: number, approachX: number, approachY: number, fromDir: {dx: number, dy: number}, toDir: {dx: number, dy: number}}}
	 */
	computeDepartApproach(pFrom, pTo, pDepartDist)
	{
		let tmpGeometry = this._FlowView._GeometryProvider;

		let tmpFromDir = tmpGeometry.sideDirection(pFrom.side || 'right');
		let tmpToDir = tmpGeometry.sideDirection(pTo.side || 'left');

		return {
			departX: pFrom.x + tmpFromDir.dx * pDepartDist,
			departY: pFrom.y + tmpFromDir.dy * pDepartDist,
			approachX: pTo.x + tmpToDir.dx * pDepartDist,
			approachY: pTo.y + tmpToDir.dy * pDepartDist,
			fromDir: tmpFromDir,
			toDir: tmpToDir
		};
	}

	// ---- Orthogonal Corner Calculation ----

	/**
	 * Compute auto orthogonal corners for an L-shaped or Z-shaped path.
	 * Determines corner placement based on departure/approach directions.
	 *
	 * Used by both connection and tether renderers for right-angle paths.
	 *
	 * @param {number} pDepartX
	 * @param {number} pDepartY
	 * @param {number} pApproachX
	 * @param {number} pApproachY
	 * @param {{dx: number, dy: number}} pFromDir - Departure direction vector
	 * @param {{dx: number, dy: number}} pToDir - Approach direction vector
	 * @param {number} pMidOffset - Offset for the corridor midpoint
	 * @returns {{corner1: {x: number, y: number}, corner2: {x: number, y: number}, midpoint: {x: number, y: number}}}
	 */
	computeAutoOrthogonalCorners(pDepartX, pDepartY, pApproachX, pApproachY, pFromDir, pToDir, pMidOffset)
	{
		let tmpOffset = pMidOffset || 0;
		let tmpFromHoriz = Math.abs(pFromDir.dx) > 0;
		let tmpToHoriz = Math.abs(pToDir.dx) > 0;

		let tmpCorner1, tmpCorner2, tmpMidpoint;

		if (tmpFromHoriz && tmpToHoriz)
		{
			// Both horizontal departure/approach: corridor is vertical
			let tmpMidX = (pDepartX + pApproachX) / 2 + tmpOffset;
			tmpCorner1 = { x: tmpMidX, y: pDepartY };
			tmpCorner2 = { x: tmpMidX, y: pApproachY };
			tmpMidpoint = { x: tmpMidX, y: (pDepartY + pApproachY) / 2 };
		}
		else if (!tmpFromHoriz && !tmpToHoriz)
		{
			// Both vertical: corridor is horizontal
			let tmpMidY = (pDepartY + pApproachY) / 2 + tmpOffset;
			tmpCorner1 = { x: pDepartX, y: tmpMidY };
			tmpCorner2 = { x: pApproachX, y: tmpMidY };
			tmpMidpoint = { x: (pDepartX + pApproachX) / 2, y: tmpMidY };
		}
		else if (tmpFromHoriz && !tmpToHoriz)
		{
			// Horizontal→Vertical: single L-bend
			tmpCorner1 = { x: pApproachX + tmpOffset, y: pDepartY };
			tmpCorner2 = { x: pApproachX + tmpOffset, y: pApproachY };
			tmpMidpoint = { x: pApproachX + tmpOffset, y: (pDepartY + pApproachY) / 2 };
		}
		else
		{
			// Vertical→Horizontal: single L-bend
			tmpCorner1 = { x: pDepartX, y: pApproachY + tmpOffset };
			tmpCorner2 = { x: pApproachX, y: pApproachY + tmpOffset };
			tmpMidpoint = { x: (pDepartX + pApproachX) / 2, y: pApproachY + tmpOffset };
		}

		return { corner1: tmpCorner1, corner2: tmpCorner2, midpoint: tmpMidpoint };
	}

	// ---- Bezier Evaluation ----

	/**
	 * Evaluate a cubic bezier curve at parameter t.
	 * B(t) = (1-t)³P0 + 3(1-t)²tP1 + 3(1-t)t²P2 + t³P3
	 *
	 * @param {{x: number, y: number}} pP0 - Start point
	 * @param {{x: number, y: number}} pP1 - First control point
	 * @param {{x: number, y: number}} pP2 - Second control point
	 * @param {{x: number, y: number}} pP3 - End point
	 * @param {number} pT - Parameter in range [0, 1]
	 * @returns {{x: number, y: number}}
	 */
	evaluateCubicBezier(pP0, pP1, pP2, pP3, pT)
	{
		let tmpOMT = 1 - pT;
		let tmpOMT2 = tmpOMT * tmpOMT;
		let tmpOMT3 = tmpOMT2 * tmpOMT;
		let tmpT2 = pT * pT;
		let tmpT3 = tmpT2 * pT;

		return {
			x: tmpOMT3 * pP0.x + 3 * tmpOMT2 * pT * pP1.x + 3 * tmpOMT * tmpT2 * pP2.x + tmpT3 * pP3.x,
			y: tmpOMT3 * pP0.y + 3 * tmpOMT2 * pT * pP1.y + 3 * tmpOMT * tmpT2 * pP2.y + tmpT3 * pP3.y
		};
	}

	// ---- SVG Path String Assembly ----

	/**
	 * Build an SVG bezier path string.
	 * Pattern: M start L depart C cp1, cp2, approach L end
	 *
	 * @param {{x: number, y: number}} pStart - Start point
	 * @param {{x: number, y: number}} pDepart - Departure point after straight segment
	 * @param {{x: number, y: number}} pCP1 - First control point
	 * @param {{x: number, y: number}} pCP2 - Second control point
	 * @param {{x: number, y: number}} pApproach - Approach point before final straight segment
	 * @param {{x: number, y: number}} pEnd - End point
	 * @returns {string} SVG path d attribute
	 */
	buildBezierPathString(pStart, pDepart, pCP1, pCP2, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} C ${pCP1.x} ${pCP1.y}, ${pCP2.x} ${pCP2.y}, ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	/**
	 * Build an SVG split bezier path string (two cubic segments through a handle point).
	 * Pattern: M start L depart C cp1a, cp1b, handle C cp2a, cp2b, approach L end
	 *
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pDepart
	 * @param {{x: number, y: number}} pCP1a - First segment's first control point
	 * @param {{x: number, y: number}} pCP1b - First segment's second control point
	 * @param {{x: number, y: number}} pHandle - Handle point where the two segments meet
	 * @param {{x: number, y: number}} pCP2a - Second segment's first control point
	 * @param {{x: number, y: number}} pCP2b - Second segment's second control point
	 * @param {{x: number, y: number}} pApproach
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string} SVG path d attribute
	 */
	buildSplitBezierPathString(pStart, pDepart, pCP1a, pCP1b, pHandle, pCP2a, pCP2b, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} C ${pCP1a.x} ${pCP1a.y}, ${pCP1b.x} ${pCP1b.y}, ${pHandle.x} ${pHandle.y} C ${pCP2a.x} ${pCP2a.y}, ${pCP2b.x} ${pCP2b.y}, ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	/**
	 * Build an SVG multi-segment bezier path string.
	 * Generates N+1 cubic bezier segments through N handle points.
	 *
	 * Pattern: M start L depart C cp,cp,handle[0] C cp,cp,handle[1] ... C cp,cp,approach L end
	 *
	 * Control points are computed using Catmull-Rom-to-Bezier conversion
	 * for C1 (smooth tangent) continuity at every handle.
	 *
	 * @param {{x: number, y: number}} pStart - Port anchor start
	 * @param {{x: number, y: number}} pDepart - Departure point after straight segment
	 * @param {Array<{x: number, y: number}>} pHandles - Ordered handle waypoints
	 * @param {{x: number, y: number}} pApproach - Approach point before final straight segment
	 * @param {{x: number, y: number}} pEnd - Port anchor end
	 * @param {{dx: number, dy: number}} pStartDir - Departure direction unit vector
	 * @param {{dx: number, dy: number}} pEndDir - Approach direction unit vector
	 * @returns {string} SVG path d attribute
	 */
	buildMultiBezierPathString(pStart, pDepart, pHandles, pApproach, pEnd, pStartDir, pEndDir)
	{
		// Build the full list of waypoints: depart, handle[0..N-1], approach
		let tmpWaypoints = [pDepart];
		for (let i = 0; i < pHandles.length; i++)
		{
			tmpWaypoints.push(pHandles[i]);
		}
		tmpWaypoints.push(pApproach);

		let tmpPath = `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y}`;

		for (let i = 0; i < tmpWaypoints.length - 1; i++)
		{
			let tmpFrom = tmpWaypoints[i];
			let tmpTo = tmpWaypoints[i + 1];

			let tmpSegDX = tmpTo.x - tmpFrom.x;
			let tmpSegDY = tmpTo.y - tmpFrom.y;
			let tmpSegLen = Math.sqrt(tmpSegDX * tmpSegDX + tmpSegDY * tmpSegDY);
			if (tmpSegLen < 1)
			{
				tmpSegLen = 1;
			}
			let tmpScale = tmpSegLen * 0.35;

			// Tangent at tmpFrom
			let tmpTanFromX, tmpTanFromY;
			if (i === 0)
			{
				// First segment: use the port departure direction
				tmpTanFromX = pStartDir.dx;
				tmpTanFromY = pStartDir.dy;
			}
			else
			{
				// Interior handle: tangent points from previous toward next waypoint
				let tmpPrev = tmpWaypoints[i - 1];
				let tmpNext = tmpWaypoints[i + 1];
				tmpTanFromX = tmpNext.x - tmpPrev.x;
				tmpTanFromY = tmpNext.y - tmpPrev.y;
				let tmpTanLen = Math.sqrt(tmpTanFromX * tmpTanFromX + tmpTanFromY * tmpTanFromY);
				if (tmpTanLen < 1) tmpTanLen = 1;
				tmpTanFromX /= tmpTanLen;
				tmpTanFromY /= tmpTanLen;
			}

			// Tangent at tmpTo
			let tmpTanToX, tmpTanToY;
			if (i === tmpWaypoints.length - 2)
			{
				// Last segment: use the port approach direction (reversed for incoming)
				tmpTanToX = -pEndDir.dx;
				tmpTanToY = -pEndDir.dy;
			}
			else
			{
				// Interior handle: tangent points from previous toward next waypoint
				let tmpPrev = tmpWaypoints[i];
				let tmpNext = tmpWaypoints[i + 2];
				tmpTanToX = tmpNext.x - tmpPrev.x;
				tmpTanToY = tmpNext.y - tmpPrev.y;
				let tmpTanLen = Math.sqrt(tmpTanToX * tmpTanToX + tmpTanToY * tmpTanToY);
				if (tmpTanLen < 1) tmpTanLen = 1;
				tmpTanToX /= tmpTanLen;
				tmpTanToY /= tmpTanLen;
			}

			let tmpCP1X = tmpFrom.x + tmpTanFromX * tmpScale;
			let tmpCP1Y = tmpFrom.y + tmpTanFromY * tmpScale;
			let tmpCP2X = tmpTo.x - tmpTanToX * tmpScale;
			let tmpCP2Y = tmpTo.y - tmpTanToY * tmpScale;

			tmpPath += ` C ${tmpCP1X} ${tmpCP1Y}, ${tmpCP2X} ${tmpCP2Y}, ${tmpTo.x} ${tmpTo.y}`;
		}

		tmpPath += ` L ${pEnd.x} ${pEnd.y}`;

		return tmpPath;
	}

	/**
	 * Build an SVG orthogonal (right-angle) path string.
	 * Pattern: M start L depart L corner1 L corner2 L approach L end
	 *
	 * @param {{x: number, y: number}} pStart
	 * @param {{x: number, y: number}} pDepart
	 * @param {{x: number, y: number}} pCorner1
	 * @param {{x: number, y: number}} pCorner2
	 * @param {{x: number, y: number}} pApproach
	 * @param {{x: number, y: number}} pEnd
	 * @returns {string} SVG path d attribute
	 */
	buildOrthogonalPathString(pStart, pDepart, pCorner1, pCorner2, pApproach, pEnd)
	{
		return `M ${pStart.x} ${pStart.y} L ${pDepart.x} ${pDepart.y} L ${pCorner1.x} ${pCorner1.y} L ${pCorner2.x} ${pCorner2.y} L ${pApproach.x} ${pApproach.y} L ${pEnd.x} ${pEnd.y}`;
	}

	// ---- Directional Geometry ----

	/**
	 * Compute full directional geometry between two port anchors, including
	 * departure/approach points and bezier control points.
	 *
	 * Uses sophisticated facing detection: when ports face each other the
	 * curve offset scales with inline distance; when ports are on the same
	 * axis but not facing, a wider offset prevents the path from collapsing;
	 * perpendicular exits use a moderate offset.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{departX: number, departY: number, approachX: number, approachY: number, cp1X: number, cp1Y: number, cp2X: number, cp2Y: number, startDir: {dx: number, dy: number}, endDir: {dx: number, dy: number}}}
	 */
	computeDirectionalGeometry(pStart, pEnd)
	{
		let tmpStartDir = this._FlowView._GeometryProvider.sideDirection(pStart.side || 'right');
		let tmpEndDir   = this._FlowView._GeometryProvider.sideDirection(pEnd.side   || 'left');

		let tmpStraightLen = 20;

		let tmpDepartX = pStart.x + tmpStartDir.dx * tmpStraightLen;
		let tmpDepartY = pStart.y + tmpStartDir.dy * tmpStraightLen;

		let tmpApproachX = pEnd.x + tmpEndDir.dx * tmpStraightLen;
		let tmpApproachY = pEnd.y + tmpEndDir.dy * tmpStraightLen;

		let tmpDX = Math.abs(tmpApproachX - tmpDepartX);
		let tmpDY = Math.abs(tmpApproachY - tmpDepartY);
		let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);

		let tmpBaseOffset = Math.max(Math.min(tmpDist * 0.4, 180), 30);

		let tmpSameAxis = (tmpStartDir.dx !== 0 && tmpEndDir.dx !== 0) ||
		                  (tmpStartDir.dy !== 0 && tmpEndDir.dy !== 0);

		let tmpFacingEachOther = false;
		if (tmpSameAxis)
		{
			if (tmpStartDir.dx === 1 && tmpEndDir.dx === -1 && pEnd.x >= pStart.x)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dx === -1 && tmpEndDir.dx === 1 && pEnd.x <= pStart.x)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dy === 1 && tmpEndDir.dy === -1 && pEnd.y >= pStart.y)
			{
				tmpFacingEachOther = true;
			}
			else if (tmpStartDir.dy === -1 && tmpEndDir.dy === 1 && pEnd.y <= pStart.y)
			{
				tmpFacingEachOther = true;
			}
		}

		let tmpCurveOffset;

		if (tmpFacingEachOther)
		{
			let tmpInlineDist = (tmpStartDir.dx !== 0) ? tmpDX : tmpDY;
			tmpCurveOffset = Math.max(tmpInlineDist * 0.35, 30);
		}
		else if (tmpSameAxis)
		{
			tmpCurveOffset = Math.max(tmpBaseOffset, 60);
		}
		else
		{
			tmpCurveOffset = Math.max(tmpBaseOffset * 0.8, 40);
		}

		let tmpCP1X = tmpDepartX + tmpStartDir.dx * tmpCurveOffset;
		let tmpCP1Y = tmpDepartY + tmpStartDir.dy * tmpCurveOffset;
		let tmpCP2X = tmpApproachX + tmpEndDir.dx * tmpCurveOffset;
		let tmpCP2Y = tmpApproachY + tmpEndDir.dy * tmpCurveOffset;

		return {
			departX: tmpDepartX, departY: tmpDepartY,
			approachX: tmpApproachX, approachY: tmpApproachY,
			cp1X: tmpCP1X, cp1Y: tmpCP1Y,
			cp2X: tmpCP2X, cp2Y: tmpCP2Y,
			startDir: tmpStartDir, endDir: tmpEndDir
		};
	}

	// ---- Distance Utilities ----

	/**
	 * Distance from point (pPX, pPY) to line segment (pAX, pAY)-(pBX, pBY).
	 * Pure math utility, no state.
	 *
	 * @param {number} pPX
	 * @param {number} pPY
	 * @param {number} pAX
	 * @param {number} pAY
	 * @param {number} pBX
	 * @param {number} pBY
	 * @returns {number}
	 */
	distanceToSegment(pPX, pPY, pAX, pAY, pBX, pBY)
	{
		let tmpDX = pBX - pAX;
		let tmpDY = pBY - pAY;
		let tmpLenSq = tmpDX * tmpDX + tmpDY * tmpDY;

		if (tmpLenSq < 0.001)
		{
			// Degenerate segment
			let tmpDPX = pPX - pAX;
			let tmpDPY = pPY - pAY;
			return Math.sqrt(tmpDPX * tmpDPX + tmpDPY * tmpDPY);
		}

		// Project point onto segment, clamped to [0, 1]
		let tmpT = ((pPX - pAX) * tmpDX + (pPY - pAY) * tmpDY) / tmpLenSq;
		if (tmpT < 0) tmpT = 0;
		if (tmpT > 1) tmpT = 1;

		let tmpClosestX = pAX + tmpT * tmpDX;
		let tmpClosestY = pAY + tmpT * tmpDY;
		let tmpDistX = pPX - tmpClosestX;
		let tmpDistY = pPY - tmpClosestY;
		return Math.sqrt(tmpDistX * tmpDistX + tmpDistY * tmpDistY);
	}

	// ---- Auto Midpoint Calculation ----

	/**
	 * Get the auto-calculated midpoint of the default bezier curve between
	 * two port anchors, using the full directional geometry (facing detection,
	 * adaptive curve offsets). Evaluates the cubic bezier at t=0.5.
	 *
	 * Used by ConnectionRenderer for connection midpoints.
	 *
	 * @param {{x: number, y: number, side: string}} pStart
	 * @param {{x: number, y: number, side: string}} pEnd
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pStart, pEnd)
	{
		let tmpGeo = this.computeDirectionalGeometry(pStart, pEnd);

		return this.evaluateCubicBezier(
			{ x: tmpGeo.departX, y: tmpGeo.departY },
			{ x: tmpGeo.cp1X, y: tmpGeo.cp1Y },
			{ x: tmpGeo.cp2X, y: tmpGeo.cp2Y },
			{ x: tmpGeo.approachX, y: tmpGeo.approachY },
			0.5
		);
	}

	/**
	 * Get the auto-calculated midpoint using simple span-based control points.
	 * Uses computeDepartApproach for basic geometry, then span * 0.4 for
	 * control point distance. Evaluates the cubic bezier at t=0.5.
	 *
	 * Used by TetherService for tether midpoints.
	 *
	 * @param {{x: number, y: number, side: string}} pFrom
	 * @param {{x: number, y: number, side: string}} pTo
	 * @param {number} pDepartDist - Departure/approach distance
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpointSimple(pFrom, pTo, pDepartDist)
	{
		let tmpDA = this.computeDepartApproach(pFrom, pTo, pDepartDist);

		let tmpSpanX = Math.abs(tmpDA.approachX - tmpDA.departX);
		let tmpSpanY = Math.abs(tmpDA.approachY - tmpDA.departY);
		let tmpSpan = Math.max(tmpSpanX, tmpSpanY, 40);
		let tmpCPDist = tmpSpan * 0.4;

		let tmpP0 = { x: tmpDA.departX, y: tmpDA.departY };
		let tmpP1 = { x: tmpDA.departX + tmpDA.fromDir.dx * tmpCPDist, y: tmpDA.departY + tmpDA.fromDir.dy * tmpCPDist };
		let tmpP2 = { x: tmpDA.approachX + tmpDA.toDir.dx * tmpCPDist, y: tmpDA.approachY + tmpDA.toDir.dy * tmpCPDist };
		let tmpP3 = { x: tmpDA.approachX, y: tmpDA.approachY };

		return this.evaluateCubicBezier(tmpP0, tmpP1, tmpP2, tmpP3, 0.5);
	}
}

module.exports = PictServiceFlowPathGenerator;

},{"fable-serviceproviderbase":2}],53:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-PortRenderer
 *
 * Renders port circles, labels, and badges for flow diagram nodes.
 *
 * Extracted from PictView-Flow-Node.js to isolate port rendering logic
 * from node body rendering and layout.
 *
 * Dependencies (all accessed via this._FlowView):
 *   - _GeometryProvider — for getEdgeFromSide, getPortLocalPosition
 *   - _ConnectorShapesProvider — for createPortElement
 *   - _SVGHelperProvider — for createSVGElement
 */
class PictServiceFlowPortRenderer extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowPortRenderer';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render ports for a node.
	 * @param {Object} pNodeData
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {Object} [pNodeTypeConfig] - Node type configuration (for label display options)
	 * @param {number} pNodeTitleBarHeight - Title bar height (for port position offset)
	 */
	renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig, pNodeTitleBarHeight)
	{
		if (!this._FlowView) return;
		if (!pNodeData.Ports || !Array.isArray(pNodeData.Ports)) return;

		let tmpPortLabelsVertical = (pNodeTypeConfig && pNodeTypeConfig.PortLabelsVertical);
		let tmpPortLabelPadding = (pNodeTypeConfig && pNodeTypeConfig.PortLabelPadding);
		let tmpPortLabelsOutside = (pNodeTypeConfig && pNodeTypeConfig.PortLabelsOutside);
		let tmpGeometryProvider = this._FlowView._GeometryProvider;

		// Group ports by their Side value (supports all 12 positions)
		let tmpPortsBySide = {};
		for (let i = 0; i < pNodeData.Ports.length; i++)
		{
			let tmpPort = pNodeData.Ports[i];
			let tmpSide = tmpPort.Side || (tmpPort.Direction === 'input' ? 'left' : 'right');
			if (!tmpPortsBySide[tmpSide])
			{
				tmpPortsBySide[tmpSide] = [];
			}
			tmpPortsBySide[tmpSide].push(tmpPort);
		}

		// Build port counts map for adaptive zone sizing
		let tmpPortCountsBySide = {};
		for (let tmpKey in tmpPortsBySide)
		{
			tmpPortCountsBySide[tmpKey] = tmpPortsBySide[tmpKey].length;
		}

		for (let tmpSide in tmpPortsBySide)
		{
			let tmpPorts = tmpPortsBySide[tmpSide];
			// Determine the edge for label positioning
			let tmpEdge = tmpGeometryProvider ? tmpGeometryProvider.getEdgeFromSide(tmpSide) : tmpSide;

			for (let i = 0; i < tmpPorts.length; i++)
			{
				let tmpPort = tmpPorts[i];
				let tmpPosition = this.getPortLocalPosition(tmpSide, i, tmpPorts.length, pWidth, pHeight, pNodeTitleBarHeight, tmpPortCountsBySide);

				// Port label badge — flush against the node edge with no
				// border on the edge side; rendered before the port circle
				// so the circle visually sits on top of the badge
				let tmpLabelElement = null;
				if (tmpPort.Label)
				{
					let tmpPortTypeColorMap =
					{
						'event-in': '#3498db',
						'event-out': '#2ecc71',
						'setting': '#e67e22',
						'value': '#f1c40f',
						'error': '#e74c3c'
					};
					let tmpBorderColor = tmpPort.PortType ? (tmpPortTypeColorMap[tmpPort.PortType] || '#95a5a6') : '#95a5a6';

					let tmpBadgeHeight = 12;
					let tmpBadgePadH = 5;
					let tmpBadgeBorderW = 2;
					let tmpEdgePad = 1;
					let tmpPortRadius = 5;

					let tmpTextLen = tmpPort.Label.length * 5;
					let tmpBadgeX, tmpBadgeY, tmpBadgeWidth;
					let tmpTextX, tmpTextAnchor;
					let tmpStripeX, tmpStripeY, tmpStripeW, tmpStripeH;
					let tmpBorderPath;

					if (tmpEdge === 'left')
					{
						tmpBadgeWidth = tmpPortRadius + tmpBadgePadH + tmpTextLen + tmpBadgePadH + tmpBadgeBorderW;
						tmpBadgeX = tmpEdgePad;
						tmpBadgeY = tmpPosition.y - tmpBadgeHeight / 2;
						tmpTextX = tmpBadgeX + tmpPortRadius + tmpBadgePadH;
						tmpTextAnchor = 'start';
						tmpStripeX = tmpBadgeX + tmpBadgeWidth - tmpBadgeBorderW;
						tmpStripeY = tmpBadgeY;
						tmpStripeW = tmpBadgeBorderW;
						tmpStripeH = tmpBadgeHeight;
						tmpBorderPath = 'M ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight);
					}
					else if (tmpEdge === 'right')
					{
						tmpBadgeWidth = tmpBadgeBorderW + tmpBadgePadH + tmpTextLen + tmpBadgePadH + tmpPortRadius;
						tmpBadgeX = pWidth - tmpBadgeWidth - tmpEdgePad;
						tmpBadgeY = tmpPosition.y - tmpBadgeHeight / 2;
						tmpTextX = tmpBadgeX + tmpBadgeBorderW + tmpBadgePadH;
						tmpTextAnchor = 'start';
						tmpStripeX = tmpBadgeX;
						tmpStripeY = tmpBadgeY;
						tmpStripeW = tmpBadgeBorderW;
						tmpStripeH = tmpBadgeHeight;
						tmpBorderPath = 'M ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY
							+ ' L ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight);
					}
					else if (tmpEdge === 'top')
					{
						tmpBadgeWidth = tmpTextLen + tmpBadgePadH * 2;
						tmpBadgeX = tmpPosition.x - tmpBadgeWidth / 2;
						tmpBadgeY = tmpEdgePad;
						tmpTextX = tmpPosition.x;
						tmpTextAnchor = 'middle';
						tmpStripeX = tmpBadgeX;
						tmpStripeY = tmpBadgeY + tmpBadgeHeight - tmpBadgeBorderW;
						tmpStripeW = tmpBadgeWidth;
						tmpStripeH = tmpBadgeBorderW;
						tmpBorderPath = 'M ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY;
					}
					else
					{
						tmpBadgeWidth = tmpTextLen + tmpBadgePadH * 2;
						tmpBadgeX = tmpPosition.x - tmpBadgeWidth / 2;
						tmpBadgeY = pHeight - tmpBadgeHeight - tmpEdgePad;
						tmpTextX = tmpPosition.x;
						tmpTextAnchor = 'middle';
						tmpStripeX = tmpBadgeX;
						tmpStripeY = tmpBadgeY;
						tmpStripeW = tmpBadgeWidth;
						tmpStripeH = tmpBadgeBorderW;
						tmpBorderPath = 'M ' + tmpBadgeX + ' ' + (tmpBadgeY + tmpBadgeHeight)
							+ ' L ' + tmpBadgeX + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + tmpBadgeY
							+ ' L ' + (tmpBadgeX + tmpBadgeWidth) + ' ' + (tmpBadgeY + tmpBadgeHeight);
					}

					// Background rect (cream, no stroke — border drawn separately)
					let tmpBgRect = this._FlowView._SVGHelperProvider.createSVGElement('rect');
					tmpBgRect.setAttribute('class', 'pict-flow-port-label-bg');
					tmpBgRect.setAttribute('x', String(tmpBadgeX));
					tmpBgRect.setAttribute('y', String(tmpBadgeY));
					tmpBgRect.setAttribute('width', String(tmpBadgeWidth));
					tmpBgRect.setAttribute('height', String(tmpBadgeHeight));
					tmpBgRect.setAttribute('fill', 'var(--pf-port-label-bg, rgba(255, 253, 240, 0.5))');
					pGroup.appendChild(tmpBgRect);

					// 3-sided border path (open on the edge-facing side)
					let tmpBorderPathEl = this._FlowView._SVGHelperProvider.createSVGElement('path');
					tmpBorderPathEl.setAttribute('class', 'pict-flow-port-label-bg');
					tmpBorderPathEl.setAttribute('d', tmpBorderPath);
					tmpBorderPathEl.setAttribute('fill', 'none');
					tmpBorderPathEl.setAttribute('stroke', tmpBorderColor);
					tmpBorderPathEl.setAttribute('stroke-width', '0.75');
					pGroup.appendChild(tmpBorderPathEl);

					// Colored stripe on the inner side
					let tmpStripe = this._FlowView._SVGHelperProvider.createSVGElement('rect');
					tmpStripe.setAttribute('class', 'pict-flow-port-label-bg');
					tmpStripe.setAttribute('x', String(tmpStripeX));
					tmpStripe.setAttribute('y', String(tmpStripeY));
					tmpStripe.setAttribute('width', String(tmpStripeW));
					tmpStripe.setAttribute('height', String(tmpStripeH));
					tmpStripe.setAttribute('fill', tmpBorderColor);
					pGroup.appendChild(tmpStripe);

					// Text label — appended after circle for z-order
					tmpLabelElement = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpLabelElement.setAttribute('class', 'pict-flow-port-label');
					tmpLabelElement.setAttribute('fill', 'var(--pf-port-label-text, #2c3e50)');
					tmpLabelElement.textContent = tmpPort.Label;
					tmpLabelElement.setAttribute('x', String(tmpTextX));
					tmpLabelElement.setAttribute('y', String(tmpBadgeY + tmpBadgeHeight / 2));
					tmpLabelElement.setAttribute('text-anchor', tmpTextAnchor);
					tmpLabelElement.setAttribute('dominant-baseline', 'central');
				}

				// Port circle (rendered on top of badge background)
				let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
				let tmpCircle;
				if (tmpShapeProvider)
				{
					tmpCircle = tmpShapeProvider.createPortElement(tmpPort, tmpPosition, pNodeData.Hash);
				}
				else
				{
					tmpCircle = this._FlowView._SVGHelperProvider.createSVGElement('circle');
					let tmpPortClass = `pict-flow-port ${tmpPort.Direction}`;
					if (tmpPort.PortType)
					{
						tmpPortClass += ` port-type-${tmpPort.PortType}`;
					}
					tmpCircle.setAttribute('class', tmpPortClass);
					tmpCircle.setAttribute('cx', String(tmpPosition.x));
					tmpCircle.setAttribute('cy', String(tmpPosition.y));
					tmpCircle.setAttribute('r', '5');
					tmpCircle.setAttribute('data-port-hash', tmpPort.Hash);
					tmpCircle.setAttribute('data-node-hash', pNodeData.Hash);
					tmpCircle.setAttribute('data-port-direction', tmpPort.Direction);
					if (tmpPort.PortType)
					{
						tmpCircle.setAttribute('data-port-type', tmpPort.PortType);
					}
					tmpCircle.setAttribute('data-element-type', 'port');
				}
				pGroup.appendChild(tmpCircle);

				// Port label text (on top of everything)
				if (tmpLabelElement)
				{
					pGroup.appendChild(tmpLabelElement);
				}
			}
		}
	}

	/**
	 * Calculate port position relative to node origin.
	 *
	 * Delegates to the geometry provider's getPortLocalPosition method.
	 *
	 * @param {string} pSide - 'left', 'right', 'top', 'bottom' (or compound sides)
	 * @param {number} pIndex - Index of this port on its side
	 * @param {number} pTotal - Total ports on this side
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {number} pNodeTitleBarHeight - Title bar height
	 * @param {Object} [pPortCountsBySide] - Optional map of Side → count for adaptive zones
	 * @returns {{x: number, y: number}}
	 */
	getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pNodeTitleBarHeight, pPortCountsBySide)
	{
		return this._FlowView._GeometryProvider.getPortLocalPosition(pSide, pIndex, pTotal, pWidth, pHeight, pNodeTitleBarHeight, pPortCountsBySide);
	}
}

module.exports = PictServiceFlowPortRenderer;

},{"fable-serviceproviderbase":2}],54:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-RenderManager
 *
 * Orchestrates rendering of the flow diagram: nodes, connections,
 * tethers, panels, SVG marker definitions, and node position updates.
 *
 * Extracted from PictView-Flow.js to isolate rendering orchestration
 * from data management and interaction handling.
 */
class PictServiceFlowRenderManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowRenderManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Render the complete flow diagram
	 */
	renderFlow()
	{
		if (!this._FlowView) return;
		if (!this._FlowView._NodesLayer || !this._FlowView._ConnectionsLayer) return;

		// Clear existing SVG content
		while (this._FlowView._NodesLayer.firstChild)
		{
			this._FlowView._NodesLayer.removeChild(this._FlowView._NodesLayer.firstChild);
		}
		while (this._FlowView._ConnectionsLayer.firstChild)
		{
			this._FlowView._ConnectionsLayer.removeChild(this._FlowView._ConnectionsLayer.firstChild);
		}

		// Render connections first (behind nodes)
		for (let i = 0; i < this._FlowView._FlowData.Connections.length; i++)
		{
			let tmpConnection = this._FlowView._FlowData.Connections[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === tmpConnection.Hash);

			this._FlowView._ConnectionRenderer.renderConnection(
				tmpConnection,
				this._FlowView._ConnectionsLayer,
				tmpIsSelected
			);
		}

		// Render nodes
		for (let i = 0; i < this._FlowView._FlowData.Nodes.length; i++)
		{
			let tmpNode = this._FlowView._FlowData.Nodes[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedNodeHash === tmpNode.Hash);
			let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNode.Type);

			// Enrich saved port data with metadata from the node type's DefaultPorts.
			// Saved flow data may not include PortType or may have stale Side values,
			// so we match each port to its DefaultPort counterpart by Label and Direction,
			// then copy over PortType and Side from the authoritative node type definition.
			if (tmpNodeTypeConfig && tmpNodeTypeConfig.DefaultPorts && tmpNode.Ports)
			{
				for (let p = 0; p < tmpNode.Ports.length; p++)
				{
					let tmpPort = tmpNode.Ports[p];
					for (let d = 0; d < tmpNodeTypeConfig.DefaultPorts.length; d++)
					{
						let tmpDefault = tmpNodeTypeConfig.DefaultPorts[d];
						if (tmpDefault.Label === tmpPort.Label && tmpDefault.Direction === tmpPort.Direction)
						{
							if (tmpDefault.PortType)
							{
								tmpPort.PortType = tmpDefault.PortType;
							}
							if (tmpDefault.Side)
							{
								tmpPort.Side = tmpDefault.Side;
							}
							break;
						}
					}
				}
			}

			this._FlowView._NodeView.renderNode(tmpNode, this._FlowView._NodesLayer, tmpIsSelected, tmpNodeTypeConfig);
		}

		// Render properties panels and tethers
		if (this._FlowView._PropertiesPanelView && this._FlowView._PanelsLayer && this._FlowView._TethersLayer)
		{
			this._FlowView._PropertiesPanelView.renderPanels(
				this._FlowView._FlowData.OpenPanels,
				this._FlowView._PanelsLayer,
				this._FlowView._TethersLayer,
				this._FlowView._FlowData.ViewState.SelectedTetherHash
			);
		}

		// Update viewport transform
		this._FlowView.updateViewportTransform();
	}

	/**
	 * Re-render a single connection (remove and re-add) for smooth drag performance.
	 * @param {string} pConnectionHash
	 */
	renderSingleConnection(pConnectionHash)
	{
		if (!this._FlowView || !this._FlowView._ConnectionsLayer) return;

		// Remove existing elements for this connection
		let tmpExisting = this._FlowView._ConnectionsLayer.querySelectorAll(`[data-connection-hash="${pConnectionHash}"]`);
		for (let i = 0; i < tmpExisting.length; i++)
		{
			tmpExisting[i].remove();
		}

		let tmpConnection = this._FlowView.getConnection(pConnectionHash);
		if (!tmpConnection) return;

		let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === pConnectionHash);
		this._FlowView._ConnectionRenderer.renderConnection(tmpConnection, this._FlowView._ConnectionsLayer, tmpIsSelected);
	}

	/**
	 * Re-render a single tether (remove and re-add) for smooth drag performance.
	 * @param {string} pPanelHash
	 */
	renderSingleTether(pPanelHash)
	{
		if (!this._FlowView || !this._FlowView._TethersLayer || !this._FlowView._TetherService) return;

		// Remove existing tether elements for this panel
		let tmpExisting = this._FlowView._TethersLayer.querySelectorAll(`[data-panel-hash="${pPanelHash}"]`);
		for (let i = 0; i < tmpExisting.length; i++)
		{
			tmpExisting[i].remove();
		}

		let tmpPanel = this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		let tmpNodeData = this._FlowView.getNode(tmpPanel.NodeHash);
		if (!tmpNodeData) return;

		let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedTetherHash === pPanelHash);
		this._FlowView._TetherService.renderTether(tmpPanel, tmpNodeData, this._FlowView._TethersLayer, tmpIsSelected, this._FlowView.options.ViewIdentifier);
	}

	/**
	 * Update a single node's position in the SVG without full re-render (for drag performance)
	 * @param {string} pNodeHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateNodePosition(pNodeHash, pX, pY)
	{
		if (!this._FlowView) return;

		let tmpNode = this._FlowView.getNode(pNodeHash);
		if (!tmpNode) return;

		if (this._FlowView.options.EnableGridSnap)
		{
			pX = this._FlowView._LayoutService.snapToGrid(pX, this._FlowView.options.GridSnapSize);
			pY = this._FlowView._LayoutService.snapToGrid(pY, this._FlowView.options.GridSnapSize);
		}

		tmpNode.X = pX;
		tmpNode.Y = pY;

		// Reset customized handle positions for connections/tethers involving this node
		this._FlowView._resetHandlesForNode(pNodeHash);

		// Update the node's SVG group transform for smooth dragging
		let tmpNodeGroup = this._FlowView._NodesLayer.querySelector(`[data-node-hash="${pNodeHash}"]`);
		if (tmpNodeGroup)
		{
			tmpNodeGroup.setAttribute('transform', `translate(${pX}, ${pY})`);
		}

		// Re-render connections that involve this node
		this.renderConnectionsForNode(pNodeHash);

		// Update tethers for any panels attached to this node
		this.renderTethersForNode(pNodeHash);
	}

	/**
	 * Re-render only connections that involve a specific node (for drag performance)
	 * @param {string} pNodeHash
	 */
	renderConnectionsForNode(pNodeHash)
	{
		if (!this._FlowView || !this._FlowView._ConnectionsLayer) return;

		let tmpAffectedConnections = this._FlowView._FlowData.Connections.filter((pConn) =>
		{
			return pConn.SourceNodeHash === pNodeHash || pConn.TargetNodeHash === pNodeHash;
		});

		for (let i = 0; i < tmpAffectedConnections.length; i++)
		{
			let tmpConn = tmpAffectedConnections[i];
			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedConnectionHash === tmpConn.Hash);

			// Remove existing connection SVG elements
			let tmpExisting = this._FlowView._ConnectionsLayer.querySelectorAll(`[data-connection-hash="${tmpConn.Hash}"]`);
			for (let j = 0; j < tmpExisting.length; j++)
			{
				tmpExisting[j].remove();
			}

			// Re-render this connection
			this._FlowView._ConnectionRenderer.renderConnection(tmpConn, this._FlowView._ConnectionsLayer, tmpIsSelected);
		}
	}

	/**
	 * Re-render tethers for panels attached to a specific node (for drag performance).
	 * @param {string} pNodeHash
	 */
	renderTethersForNode(pNodeHash)
	{
		if (!this._FlowView || !this._FlowView._TethersLayer || !this._FlowView._TetherService) return;

		let tmpAffectedPanels = this._FlowView._FlowData.OpenPanels.filter((pPanel) => pPanel.NodeHash === pNodeHash);
		if (tmpAffectedPanels.length === 0) return;

		// Remove existing tethers for these panels and re-render via TetherService
		for (let i = 0; i < tmpAffectedPanels.length; i++)
		{
			let tmpExisting = this._FlowView._TethersLayer.querySelectorAll(`[data-panel-hash="${tmpAffectedPanels[i].Hash}"]`);
			for (let j = 0; j < tmpExisting.length; j++)
			{
				tmpExisting[j].remove();
			}

			let tmpNodeData = this._FlowView.getNode(tmpAffectedPanels[i].NodeHash);
			if (!tmpNodeData) continue;

			let tmpIsSelected = (this._FlowView._FlowData.ViewState.SelectedTetherHash === tmpAffectedPanels[i].Hash);
			this._FlowView._TetherService.renderTether(tmpAffectedPanels[i], tmpNodeData, this._FlowView._TethersLayer, tmpIsSelected, this._FlowView.options.ViewIdentifier);
		}
	}

	/**
	 * Re-inject SVG marker definitions (arrowheads).
	 * Called after a theme switch to update arrowhead colors.
	 */
	reinjectMarkerDefs()
	{
		if (!this._FlowView || !this._FlowView._ConnectorShapesProvider || !this._FlowView._SVGElement) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpDefs = this._FlowView._SVGElement.querySelector('defs');
		if (!tmpDefs) return;

		// Remove existing marker elements
		let tmpExistingMarkers = tmpDefs.querySelectorAll('marker');
		for (let i = 0; i < tmpExistingMarkers.length; i++)
		{
			tmpExistingMarkers[i].remove();
		}

		// Re-generate and inject
		let tmpMarkerMarkup = this._FlowView._ConnectorShapesProvider.generateMarkerDefs(tmpViewIdentifier);
		let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		tmpTempSVG.innerHTML = tmpMarkerMarkup;
		while (tmpTempSVG.firstChild)
		{
			tmpDefs.appendChild(tmpTempSVG.firstChild);
		}
	}
}

module.exports = PictServiceFlowRenderManager;

},{"fable-serviceproviderbase":2}],55:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-SelectionManager
 *
 * Manages selection state for nodes, connections, and tethers in the flow diagram.
 * Handles selecting, deselecting, and deleting selected elements.
 */
class PictServiceFlowSelectionManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowSelectionManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	/**
	 * Select a node
	 * @param {string|null} pNodeHash - Hash of the node to select, or null to deselect
	 */
	selectNode(pNodeHash)
	{
		let tmpPreviousSelection = this._FlowView._FlowData.ViewState.SelectedNodeHash;
		this._FlowView._FlowData.ViewState.SelectedNodeHash = pNodeHash;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider && pNodeHash !== tmpPreviousSelection)
		{
			let tmpNode = pNodeHash ? this._FlowView._FlowData.Nodes.find((pNode) => pNode.Hash === pNodeHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onNodeSelected', tmpNode);
		}
	}

	/**
	 * Select a connection
	 * @param {string|null} pConnectionHash - Hash of the connection to select, or null to deselect
	 */
	selectConnection(pConnectionHash)
	{
		let tmpPreviousSelection = this._FlowView._FlowData.ViewState.SelectedConnectionHash;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = pConnectionHash;
		this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider && pConnectionHash !== tmpPreviousSelection)
		{
			let tmpConnection = pConnectionHash ? this._FlowView._FlowData.Connections.find((pConn) => pConn.Hash === pConnectionHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onConnectionSelected', tmpConnection);
		}
	}

	/**
	 * Select a tether by its panel hash.
	 * @param {string|null} pPanelHash - Hash of the panel whose tether to select, or null to deselect
	 */
	selectTether(pPanelHash)
	{
		let tmpPreviousSelection = this._FlowView._FlowData.ViewState.SelectedTetherHash;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = pPanelHash;
		this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;

		this._FlowView.renderFlow();

		if (this._FlowView._EventHandlerProvider && pPanelHash !== tmpPreviousSelection)
		{
			let tmpPanel = pPanelHash ? this._FlowView._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash) : null;
			this._FlowView._EventHandlerProvider.fireEvent('onTetherSelected', tmpPanel);
		}
	}

	/**
	 * Deselect all nodes and connections
	 */
	deselectAll()
	{
		this._FlowView._FlowData.ViewState.SelectedNodeHash = null;
		this._FlowView._FlowData.ViewState.SelectedConnectionHash = null;
		this._FlowView._FlowData.ViewState.SelectedTetherHash = null;
		this._FlowView.renderFlow();
	}

	/**
	 * Delete the currently selected node or connection
	 * @returns {boolean}
	 */
	deleteSelected()
	{
		if (this._FlowView._FlowData.ViewState.SelectedNodeHash)
		{
			return this._FlowView.removeNode(this._FlowView._FlowData.ViewState.SelectedNodeHash);
		}
		if (this._FlowView._FlowData.ViewState.SelectedConnectionHash)
		{
			return this._FlowView.removeConnection(this._FlowView._FlowData.ViewState.SelectedConnectionHash);
		}
		return false;
	}
}

module.exports = PictServiceFlowSelectionManager;

},{"fable-serviceproviderbase":2}],56:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-Tether
 *
 * Centralizes all tether geometry, path generation, handle state management,
 * and SVG rendering for the lines that connect properties panels to their nodes.
 *
 * Delegates to shared providers for:
 *   - SVG element creation (_FlowView._SVGHelperProvider)
 *   - Geometry calculations (_FlowView._GeometryProvider)
 *   - Path string building (_FlowView._PathGenerator)
 *
 * Responsibilities:
 *   - Smart 4-quadrant anchor detection (which edge of the node/panel to connect)
 *   - Bezier and orthogonal path generation
 *   - Auto-midpoint and auto-corner calculations
 *   - Handle position updates during drag
 *   - Handle reset when nodes or panels move
 *   - Line mode toggling (bezier <-> orthogonal)
 *   - SVG element creation for tether lines, hit areas, and drag handles
 */
class PictServiceFlowTether extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowTether';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;
	}

	// ---- Anchor Calculation ----

	/**
	 * Determine which node edge and panel edge to connect based on 4-quadrant detection.
	 * Uses the relative position of the panel center to the node center.
	 *
	 * @param {Object} pPanelData - Panel data with X, Y, Width, Height
	 * @param {Object} pNodeData - Node data with X, Y, Width, Height
	 * @returns {{nodeAnchor: {x,y,side}, panelAnchor: {x,y,side}}}
	 */
	getSmartAnchors(pPanelData, pNodeData)
	{
		let tmpNodeCX = pNodeData.X + pNodeData.Width / 2;
		let tmpNodeCY = pNodeData.Y + pNodeData.Height / 2;
		let tmpPanelCX = pPanelData.X + pPanelData.Width / 2;
		let tmpPanelCY = pPanelData.Y + pPanelData.Height / 2;

		let tmpDX = tmpPanelCX - tmpNodeCX;
		let tmpDY = tmpPanelCY - tmpNodeCY;

		let tmpNodeSide, tmpPanelSide;

		if (Math.abs(tmpDX) >= Math.abs(tmpDY))
		{
			// Panel is primarily to the left or right
			if (tmpDX >= 0)
			{
				tmpNodeSide = 'right';
				tmpPanelSide = 'left';
			}
			else
			{
				tmpNodeSide = 'left';
				tmpPanelSide = 'right';
			}
		}
		else
		{
			// Panel is primarily above or below
			if (tmpDY >= 0)
			{
				tmpNodeSide = 'bottom';
				tmpPanelSide = 'top';
			}
			else
			{
				tmpNodeSide = 'top';
				tmpPanelSide = 'bottom';
			}
		}

		let tmpNodeAnchor = this._FlowView._GeometryProvider.getEdgeCenter(pNodeData, tmpNodeSide);
		let tmpPanelAnchor = this._FlowView._GeometryProvider.getEdgeCenter(pPanelData, tmpPanelSide);

		return {
			nodeAnchor: Object.assign(tmpNodeAnchor, { side: tmpNodeSide }),
			panelAnchor: Object.assign(tmpPanelAnchor, { side: tmpPanelSide })
		};
	}

	// ---- Path Generation ----

	/**
	 * Generate a bezier path between two anchor points with directional departure/approach.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {number|null} pHandleX - User-set handle X or null for auto
	 * @param {number|null} pHandleY - User-set handle Y or null for auto
	 * @returns {string} SVG path d attribute
	 */
	generateBezierPath(pFrom, pTo, pHandleX, pHandleY)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepartX = pFrom.x + tmpFromDir.dx * tmpDepartDist;
		let tmpDepartY = pFrom.y + tmpFromDir.dy * tmpDepartDist;
		let tmpApproachX = pTo.x + tmpToDir.dx * tmpDepartDist;
		let tmpApproachY = pTo.y + tmpToDir.dy * tmpDepartDist;

		if (pHandleX == null || pHandleY == null)
		{
			// Auto bezier: simple cubic from depart to approach
			let tmpSpanX = Math.abs(tmpApproachX - tmpDepartX);
			let tmpSpanY = Math.abs(tmpApproachY - tmpDepartY);
			let tmpSpan = Math.max(tmpSpanX, tmpSpanY, 40);
			let tmpCPDist = tmpSpan * 0.4;

			let tmpCP1X = tmpDepartX + tmpFromDir.dx * tmpCPDist;
			let tmpCP1Y = tmpDepartY + tmpFromDir.dy * tmpCPDist;
			let tmpCP2X = tmpApproachX + tmpToDir.dx * tmpCPDist;
			let tmpCP2Y = tmpApproachY + tmpToDir.dy * tmpCPDist;

			return this._FlowView._PathGenerator.buildBezierPathString(
				{ x: pFrom.x, y: pFrom.y },
				{ x: tmpDepartX, y: tmpDepartY },
				{ x: tmpCP1X, y: tmpCP1Y },
				{ x: tmpCP2X, y: tmpCP2Y },
				{ x: tmpApproachX, y: tmpApproachY },
				{ x: pTo.x, y: pTo.y }
			);
		}

		// User-set handle: split bezier into two segments through handle
		let tmpCP1aDist = 30;
		let tmpCP1aX = tmpDepartX + tmpFromDir.dx * tmpCP1aDist;
		let tmpCP1aY = tmpDepartY + tmpFromDir.dy * tmpCP1aDist;

		let tmpCP2aDist = 30;
		let tmpCP2aX = tmpApproachX + tmpToDir.dx * tmpCP2aDist;
		let tmpCP2aY = tmpApproachY + tmpToDir.dy * tmpCP2aDist;

		// Tangent at the handle — direction from first segment end to second segment start
		let tmpTangentX = tmpApproachX - tmpDepartX;
		let tmpTangentY = tmpApproachY - tmpDepartY;
		let tmpTangentLen = Math.sqrt(tmpTangentX * tmpTangentX + tmpTangentY * tmpTangentY) || 1;
		tmpTangentX /= tmpTangentLen;
		tmpTangentY /= tmpTangentLen;
		let tmpTangentDist = 25;

		let tmpCP1bX = pHandleX - tmpTangentX * tmpTangentDist;
		let tmpCP1bY = pHandleY - tmpTangentY * tmpTangentDist;
		let tmpCP2bX = pHandleX + tmpTangentX * tmpTangentDist;
		let tmpCP2bY = pHandleY + tmpTangentY * tmpTangentDist;

		return this._FlowView._PathGenerator.buildSplitBezierPathString(
			{ x: pFrom.x, y: pFrom.y },
			{ x: tmpDepartX, y: tmpDepartY },
			{ x: tmpCP1aX, y: tmpCP1aY },
			{ x: tmpCP1bX, y: tmpCP1bY },
			{ x: pHandleX, y: pHandleY },
			{ x: tmpCP2bX, y: tmpCP2bY },
			{ x: tmpCP2aX, y: tmpCP2aY },
			{ x: tmpApproachX, y: tmpApproachY },
			{ x: pTo.x, y: pTo.y }
		);
	}

	/**
	 * Generate an orthogonal (90-degree) path between two anchor points.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {Object|null} pCorners - {corner1: {x,y}, corner2: {x,y}} or null for auto
	 * @param {number} pMidOffset - Offset for the corridor midpoint
	 * @returns {string} SVG path d attribute
	 */
	generateOrthogonalPath(pFrom, pTo, pCorners, pMidOffset)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepartX = pFrom.x + tmpFromDir.dx * tmpDepartDist;
		let tmpDepartY = pFrom.y + tmpFromDir.dy * tmpDepartDist;
		let tmpApproachX = pTo.x + tmpToDir.dx * tmpDepartDist;
		let tmpApproachY = pTo.y + tmpToDir.dy * tmpDepartDist;

		let tmpCorner1, tmpCorner2;

		if (pCorners && pCorners.corner1 && pCorners.corner2)
		{
			tmpCorner1 = pCorners.corner1;
			tmpCorner2 = pCorners.corner2;
		}
		else
		{
			// Auto-calculate corners based on direction
			let tmpAutoCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(tmpDepartX, tmpDepartY, tmpApproachX, tmpApproachY, tmpFromDir, tmpToDir, pMidOffset);
			tmpCorner1 = tmpAutoCorners.corner1;
			tmpCorner2 = tmpAutoCorners.corner2;
		}

		return this._FlowView._PathGenerator.buildOrthogonalPathString(
			{ x: pFrom.x, y: pFrom.y },
			{ x: tmpDepartX, y: tmpDepartY },
			{ x: tmpCorner1.x, y: tmpCorner1.y },
			{ x: tmpCorner2.x, y: tmpCorner2.y },
			{ x: tmpApproachX, y: tmpApproachY },
			{ x: pTo.x, y: pTo.y }
		);
	}

	// ---- Handle Position Computation ----

	/**
	 * Get auto-calculated bezier midpoint for a tether at t=0.5 on the curve.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @returns {{x: number, y: number}}
	 */
	getAutoMidpoint(pFrom, pTo)
	{
		return this._FlowView._PathGenerator.getAutoMidpointSimple(pFrom, pTo, 20);
	}

	/**
	 * Get full orthogonal geometry including corners and midpoint for handle rendering.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {Object} pPanelData - Panel data with tether handle properties
	 * @returns {{corner1: {x,y}, corner2: {x,y}, midpoint: {x,y}}}
	 */
	getOrthoGeometry(pFrom, pTo, pPanelData)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepartX = pFrom.x + tmpFromDir.dx * tmpDepartDist;
		let tmpDepartY = pFrom.y + tmpFromDir.dy * tmpDepartDist;
		let tmpApproachX = pTo.x + tmpToDir.dx * tmpDepartDist;
		let tmpApproachY = pTo.y + tmpToDir.dy * tmpDepartDist;

		let tmpCorners;
		if (pPanelData.TetherHandleCustomized && pPanelData.TetherOrthoCorner1X != null)
		{
			tmpCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(tmpDepartX, tmpDepartY, tmpApproachX, tmpApproachY, tmpFromDir, tmpToDir, pPanelData.TetherOrthoMidOffset || 0);
			tmpCorners.corner1 = { x: pPanelData.TetherOrthoCorner1X, y: pPanelData.TetherOrthoCorner1Y };
			tmpCorners.corner2 = { x: pPanelData.TetherOrthoCorner2X, y: pPanelData.TetherOrthoCorner2Y };
		}
		else
		{
			tmpCorners = this._FlowView._PathGenerator.computeAutoOrthogonalCorners(tmpDepartX, tmpDepartY, tmpApproachX, tmpApproachY, tmpFromDir, tmpToDir, pPanelData.TetherOrthoMidOffset || 0);
		}

		let tmpMidpoint =
		{
			x: (tmpCorners.corner1.x + tmpCorners.corner2.x) / 2,
			y: (tmpCorners.corner1.y + tmpCorners.corner2.y) / 2
		};

		return {
			corner1: tmpCorners.corner1,
			corner2: tmpCorners.corner2,
			midpoint: tmpMidpoint
		};
	}

	// ---- Path Generation (high-level) ----

	/**
	 * Generate the SVG path string for a tether based on its panel data and anchors.
	 * @param {Object} pPanelData - Panel data with tether handle properties
	 * @param {Object} pFrom - {x, y, side} panel anchor
	 * @param {Object} pTo - {x, y, side} node anchor
	 * @returns {string} SVG path d attribute
	 */
	generatePath(pPanelData, pFrom, pTo)
	{
		let tmpLineMode = pPanelData.TetherLineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpCorners = null;
			if (pPanelData.TetherHandleCustomized && pPanelData.TetherOrthoCorner1X != null)
			{
				tmpCorners =
				{
					corner1: { x: pPanelData.TetherOrthoCorner1X, y: pPanelData.TetherOrthoCorner1Y },
					corner2: { x: pPanelData.TetherOrthoCorner2X, y: pPanelData.TetherOrthoCorner2Y }
				};
			}
			return this.generateOrthogonalPath(pFrom, pTo, tmpCorners, pPanelData.TetherOrthoMidOffset || 0);
		}
		else
		{
			// Check for multi-handle array first
			let tmpHandles = this._getTetherBezierHandles(pPanelData);
			if (tmpHandles.length > 0)
			{
				return this.generateMultiBezierPath(pFrom, pTo, tmpHandles);
			}

			// Single-handle legacy path
			let tmpHandleX = (pPanelData.TetherHandleCustomized && pPanelData.TetherBezierHandleX != null) ? pPanelData.TetherBezierHandleX : null;
			let tmpHandleY = (pPanelData.TetherHandleCustomized && pPanelData.TetherBezierHandleY != null) ? pPanelData.TetherBezierHandleY : null;
			return this.generateBezierPath(pFrom, pTo, tmpHandleX, tmpHandleY);
		}
	}

	/**
	 * Get the bezier handles array for a tether, respecting the customized flag.
	 * @param {Object} pPanelData
	 * @returns {Array<{x: number, y: number}>}
	 */
	_getTetherBezierHandles(pPanelData)
	{
		if (!pPanelData || !pPanelData.TetherHandleCustomized)
		{
			return [];
		}

		// Multi-handle format
		if (Array.isArray(pPanelData.TetherBezierHandles) && pPanelData.TetherBezierHandles.length > 0)
		{
			return pPanelData.TetherBezierHandles;
		}

		// Legacy single-handle format
		if (pPanelData.TetherBezierHandleX != null && pPanelData.TetherBezierHandleY != null)
		{
			return [{ x: pPanelData.TetherBezierHandleX, y: pPanelData.TetherBezierHandleY }];
		}

		return [];
	}

	/**
	 * Generate a multi-handle bezier path for a tether.
	 * Delegates to PathGenerator.buildMultiBezierPathString.
	 * @param {Object} pFrom - {x, y, side}
	 * @param {Object} pTo - {x, y, side}
	 * @param {Array<{x: number, y: number}>} pHandles
	 * @returns {string} SVG path d attribute
	 */
	generateMultiBezierPath(pFrom, pTo, pHandles)
	{
		let tmpDepartDist = 20;
		let tmpFromDir = this._FlowView._GeometryProvider.sideDirection(pFrom.side);
		let tmpToDir = this._FlowView._GeometryProvider.sideDirection(pTo.side);

		let tmpDepart = {
			x: pFrom.x + tmpFromDir.dx * tmpDepartDist,
			y: pFrom.y + tmpFromDir.dy * tmpDepartDist
		};
		let tmpApproach = {
			x: pTo.x + tmpToDir.dx * tmpDepartDist,
			y: pTo.y + tmpToDir.dy * tmpDepartDist
		};

		return this._FlowView._PathGenerator.buildMultiBezierPathString(
			pFrom, tmpDepart, pFrom.side, tmpApproach, pTo.side, pTo, pHandles);
	}

	// ---- Handle State Management ----

	/**
	 * Update a tether handle position during drag.
	 * @param {Object} pPanelData - Panel data to update
	 * @param {string} pHandleType - 'bezier-midpoint', 'ortho-corner1', 'ortho-corner2', 'ortho-midpoint'
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateHandlePosition(pPanelData, pHandleType, pX, pY)
	{
		pPanelData.TetherHandleCustomized = true;

		// Multi-handle bezier: handle type is 'bezier-handle-N'
		if (pHandleType && pHandleType.startsWith('bezier-handle-'))
		{
			let tmpIndex = parseInt(pHandleType.replace('bezier-handle-', ''), 10);
			if (!isNaN(tmpIndex) && Array.isArray(pPanelData.TetherBezierHandles)
				&& tmpIndex < pPanelData.TetherBezierHandles.length)
			{
				pPanelData.TetherBezierHandles[tmpIndex].x = pX;
				pPanelData.TetherBezierHandles[tmpIndex].y = pY;
			}
			return;
		}

		switch (pHandleType)
		{
			case 'bezier-midpoint':
				// Migrate to multi-handle array
				if (!Array.isArray(pPanelData.TetherBezierHandles)
					|| pPanelData.TetherBezierHandles.length === 0)
				{
					pPanelData.TetherBezierHandles = [{ x: pX, y: pY }];
				}
				else
				{
					pPanelData.TetherBezierHandles[0].x = pX;
					pPanelData.TetherBezierHandles[0].y = pY;
				}
				// Keep legacy fields in sync
				pPanelData.TetherBezierHandleX = pX;
				pPanelData.TetherBezierHandleY = pY;
				break;

			case 'ortho-corner1':
				pPanelData.TetherOrthoCorner1X = pX;
				pPanelData.TetherOrthoCorner1Y = pY;
				break;

			case 'ortho-corner2':
				pPanelData.TetherOrthoCorner2X = pX;
				pPanelData.TetherOrthoCorner2Y = pY;
				break;

			case 'ortho-midpoint':
				// Store the desired position for offset computation
				pPanelData.TetherOrthoMidOffset = (pPanelData.TetherOrthoMidOffset || 0);
				pPanelData._TetherMidDragX = pX;
				pPanelData._TetherMidDragY = pY;
				break;
		}
	}

	/**
	 * Reset tether handle positions to auto for a single panel.
	 * Preserves TetherLineMode but clears all handle coordinates.
	 * @param {Object} pPanelData - Panel data to reset
	 */
	resetHandlePositions(pPanelData)
	{
		if (pPanelData.TetherHandleCustomized)
		{
			pPanelData.TetherHandleCustomized = false;
			pPanelData.TetherBezierHandles = [];
			pPanelData.TetherBezierHandleX = null;
			pPanelData.TetherBezierHandleY = null;
			pPanelData.TetherOrthoCorner1X = null;
			pPanelData.TetherOrthoCorner1Y = null;
			pPanelData.TetherOrthoCorner2X = null;
			pPanelData.TetherOrthoCorner2Y = null;
			pPanelData.TetherOrthoMidOffset = 0;
		}
	}

	/**
	 * Reset tether handle positions for all panels attached to a node.
	 * Called when a node moves.
	 * @param {Array} pOpenPanels - Array of all open panel data objects
	 * @param {string} pNodeHash - The node hash whose panels should be reset
	 */
	resetHandlesForNode(pOpenPanels, pNodeHash)
	{
		for (let i = 0; i < pOpenPanels.length; i++)
		{
			let tmpPanel = pOpenPanels[i];
			if (tmpPanel.NodeHash === pNodeHash)
			{
				this.resetHandlePositions(tmpPanel);
			}
		}
	}

	/**
	 * Add a bezier handle to a tether at the specified position.
	 * @param {Object} pPanelData - Panel data
	 * @param {number} pX
	 * @param {number} pY
	 * @param {Object} pFrom - Panel anchor {x, y, side}
	 * @param {Object} pTo - Node anchor {x, y, side}
	 */
	addHandle(pPanelData, pX, pY, pFrom, pTo)
	{
		// Ensure bezier mode and multi-handle array
		pPanelData.TetherLineMode = 'bezier';

		if (!Array.isArray(pPanelData.TetherBezierHandles))
		{
			pPanelData.TetherBezierHandles = [];
			// Migrate legacy single-handle if present
			if (pPanelData.TetherBezierHandleX != null && pPanelData.TetherBezierHandleY != null)
			{
				pPanelData.TetherBezierHandles.push({
					x: pPanelData.TetherBezierHandleX,
					y: pPanelData.TetherBezierHandleY
				});
			}
		}

		// Compute insertion index
		let tmpInsertIndex = 0;
		if (this._FlowView._ConnectionRenderer && pFrom && pTo)
		{
			tmpInsertIndex = this._FlowView._ConnectionRenderer.computeInsertionIndex(
				pPanelData.TetherBezierHandles,
				{ x: pX, y: pY },
				pFrom,
				pTo
			);
		}

		pPanelData.TetherBezierHandles.splice(tmpInsertIndex, 0, { x: pX, y: pY });
		pPanelData.TetherHandleCustomized = true;
	}

	/**
	 * Remove a bezier handle from a tether by index.
	 * @param {Object} pPanelData - Panel data
	 * @param {number} pIndex - Index in TetherBezierHandles array
	 */
	removeHandle(pPanelData, pIndex)
	{
		if (!Array.isArray(pPanelData.TetherBezierHandles)) return;
		if (pIndex < 0 || pIndex >= pPanelData.TetherBezierHandles.length) return;

		pPanelData.TetherBezierHandles.splice(pIndex, 1);

		if (pPanelData.TetherBezierHandles.length === 0)
		{
			pPanelData.TetherHandleCustomized = false;
			pPanelData.TetherBezierHandleX = null;
			pPanelData.TetherBezierHandleY = null;
		}
	}

	/**
	 * Toggle tether line mode between bezier and orthogonal.
	 * Resets handle positions on toggle.
	 * @param {Object} pPanelData - Panel data to toggle
	 * @returns {string} The new line mode ('bezier' or 'orthogonal')
	 */
	toggleLineMode(pPanelData)
	{
		let tmpCurrentMode = pPanelData.TetherLineMode || 'bezier';
		pPanelData.TetherLineMode = (tmpCurrentMode === 'bezier') ? 'orthogonal' : 'bezier';

		pPanelData.TetherHandleCustomized = false;
		pPanelData.TetherBezierHandles = [];
		pPanelData.TetherBezierHandleX = null;
		pPanelData.TetherBezierHandleY = null;
		pPanelData.TetherOrthoCorner1X = null;
		pPanelData.TetherOrthoCorner1Y = null;
		pPanelData.TetherOrthoCorner2X = null;
		pPanelData.TetherOrthoCorner2Y = null;
		pPanelData.TetherOrthoMidOffset = 0;

		return pPanelData.TetherLineMode;
	}

	// ---- SVG Rendering ----

	/**
	 * Render a tether from a panel to its node.
	 * Creates SVG path elements for the line and hit area, plus drag handles when selected.
	 *
	 * @param {Object} pPanelData - Panel data with position and tether properties
	 * @param {Object} pNodeData - Node data with position
	 * @param {SVGGElement} pTethersLayer - SVG group to append elements to
	 * @param {boolean} pIsSelected - Whether this tether is currently selected
	 * @param {string} pViewIdentifier - The flow view identifier (for marker URL)
	 */
	renderTether(pPanelData, pNodeData, pTethersLayer, pIsSelected, pViewIdentifier)
	{
		if (!pNodeData) return;

		let tmpAnchors = this.getSmartAnchors(pPanelData, pNodeData);
		let tmpFrom = tmpAnchors.panelAnchor;
		let tmpTo = tmpAnchors.nodeAnchor;

		let tmpPath = this.generatePath(pPanelData, tmpFrom, tmpTo);

		// Hit area and visible tether path
		let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
		if (tmpShapeProvider)
		{
			let tmpHitArea = tmpShapeProvider.createTetherHitAreaElement(tmpPath, pPanelData.Hash);
			pTethersLayer.appendChild(tmpHitArea);

			let tmpPathElement = tmpShapeProvider.createTetherPathElement(
				tmpPath, pPanelData.Hash, pIsSelected, pViewIdentifier);
			pTethersLayer.appendChild(tmpPathElement);
		}
		else
		{
			let tmpHitArea = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpHitArea.setAttribute('class', 'pict-flow-tether-hitarea');
			tmpHitArea.setAttribute('d', tmpPath);
			tmpHitArea.setAttribute('data-element-type', 'tether-hitarea');
			tmpHitArea.setAttribute('data-panel-hash', pPanelData.Hash);
			pTethersLayer.appendChild(tmpHitArea);

			let tmpPathElement = this._FlowView._SVGHelperProvider.createSVGElement('path');
			tmpPathElement.setAttribute('class', `pict-flow-tether-line${pIsSelected ? ' selected' : ''}`);
			tmpPathElement.setAttribute('d', tmpPath);
			tmpPathElement.setAttribute('marker-end', `url(#flow-tether-arrowhead-${pViewIdentifier})`);
			tmpPathElement.setAttribute('data-element-type', 'tether');
			tmpPathElement.setAttribute('data-panel-hash', pPanelData.Hash);
			pTethersLayer.appendChild(tmpPathElement);
		}

		// Render drag handles when selected
		if (pIsSelected)
		{
			this._renderHandles(pPanelData, pTethersLayer, tmpFrom, tmpTo);
		}
	}

	/**
	 * Render drag handles for a selected tether.
	 * @param {Object} pPanelData
	 * @param {SVGGElement} pTethersLayer
	 * @param {Object} pFrom - Panel anchor {x, y, side}
	 * @param {Object} pTo - Node anchor {x, y, side}
	 */
	_renderHandles(pPanelData, pTethersLayer, pFrom, pTo)
	{
		let tmpLineMode = pPanelData.TetherLineMode || 'bezier';

		if (tmpLineMode === 'orthogonal')
		{
			let tmpGeom = this.getOrthoGeometry(pFrom, pTo, pPanelData);

			// Corner 1 handle
			this._createHandle(pTethersLayer, pPanelData.Hash, 'ortho-corner1',
				tmpGeom.corner1.x, tmpGeom.corner1.y, 'pict-flow-tether-handle');

			// Midpoint handle
			this._createHandle(pTethersLayer, pPanelData.Hash, 'ortho-midpoint',
				tmpGeom.midpoint.x, tmpGeom.midpoint.y, 'pict-flow-tether-handle-midpoint');

			// Corner 2 handle
			this._createHandle(pTethersLayer, pPanelData.Hash, 'ortho-corner2',
				tmpGeom.corner2.x, tmpGeom.corner2.y, 'pict-flow-tether-handle');
		}
		else
		{
			// Bezier handles
			let tmpHandles = this._getTetherBezierHandles(pPanelData);

			if (tmpHandles.length > 0)
			{
				// Multi-handle: render each handle as a draggable circle
				for (let i = 0; i < tmpHandles.length; i++)
				{
					this._createHandle(pTethersLayer, pPanelData.Hash, 'bezier-handle-' + i,
						tmpHandles[i].x, tmpHandles[i].y, 'pict-flow-tether-handle');
				}
			}
			else
			{
				// No custom handles: show auto-computed midpoint
				let tmpMid = this.getAutoMidpoint(pFrom, pTo);
				this._createHandle(pTethersLayer, pPanelData.Hash, 'bezier-midpoint',
					tmpMid.x, tmpMid.y, 'pict-flow-tether-handle-midpoint');
			}
		}
	}

	/**
	 * Create a single tether drag handle circle.
	 * @param {SVGGElement} pLayer
	 * @param {string} pPanelHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 * @param {string} pClassName
	 */
	_createHandle(pLayer, pPanelHash, pHandleType, pX, pY, pClassName)
	{
		if (!this._FlowView._ConnectorShapesProvider) return;

		let tmpShapeKey = (pClassName === 'pict-flow-tether-handle-midpoint')
			? 'tether-handle-midpoint' : 'tether-handle';

		this._FlowView._ConnectorShapesProvider.createFullHandle(
			pLayer, pPanelHash, pHandleType, pX, pY,
			tmpShapeKey, 'tether-handle', 'data-panel-hash');
	}
}

module.exports = PictServiceFlowTether;

},{"fable-serviceproviderbase":2}],57:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/**
 * PictService-Flow-ViewportManager
 *
 * Manages viewport transforms (pan/zoom), coordinate conversion between
 * screen and SVG space, zoom-to-fit calculations, and fullscreen toggling
 * for the flow diagram.
 */
class PictServiceFlowViewportManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictServiceFlowViewportManager';

		this._FlowView = (pOptions && pOptions.FlowView) ? pOptions.FlowView : null;

		this._IsFullscreen = false;
	}

	/**
	 * Update the viewport transform (pan and zoom)
	 */
	updateViewportTransform()
	{
		if (!this._FlowView._ViewportElement) return;
		let tmpVS = this._FlowView._FlowData.ViewState;
		this._FlowView._ViewportElement.setAttribute('transform',
			`translate(${tmpVS.PanX}, ${tmpVS.PanY}) scale(${tmpVS.Zoom})`
		);
	}

	/**
	 * Set zoom level
	 * @param {number} pZoom - The zoom level
	 * @param {number} [pFocusX] - X coordinate to zoom toward (SVG space)
	 * @param {number} [pFocusY] - Y coordinate to zoom toward (SVG space)
	 */
	setZoom(pZoom, pFocusX, pFocusY)
	{
		let tmpNewZoom = Math.max(this._FlowView.options.MinZoom, Math.min(this._FlowView.options.MaxZoom, pZoom));
		let tmpOldZoom = this._FlowView._FlowData.ViewState.Zoom;

		if (typeof pFocusX === 'number' && typeof pFocusY === 'number')
		{
			// Zoom toward focus point
			let tmpVS = this._FlowView._FlowData.ViewState;
			tmpVS.PanX = pFocusX - (pFocusX - tmpVS.PanX) * (tmpNewZoom / tmpOldZoom);
			tmpVS.PanY = pFocusY - (pFocusY - tmpVS.PanY) * (tmpNewZoom / tmpOldZoom);
		}

		this._FlowView._FlowData.ViewState.Zoom = tmpNewZoom;
		this.updateViewportTransform();
	}

	/**
	 * Zoom to fit all nodes in the viewport
	 */
	zoomToFit()
	{
		if (this._FlowView._FlowData.Nodes.length === 0) return;
		if (!this._FlowView._SVGElement) return;

		let tmpMinX = Infinity, tmpMinY = Infinity;
		let tmpMaxX = -Infinity, tmpMaxY = -Infinity;

		for (let i = 0; i < this._FlowView._FlowData.Nodes.length; i++)
		{
			let tmpNode = this._FlowView._FlowData.Nodes[i];
			tmpMinX = Math.min(tmpMinX, tmpNode.X);
			tmpMinY = Math.min(tmpMinY, tmpNode.Y);
			tmpMaxX = Math.max(tmpMaxX, tmpNode.X + tmpNode.Width);
			tmpMaxY = Math.max(tmpMaxY, tmpNode.Y + tmpNode.Height);
		}

		let tmpPadding = 50;
		let tmpFlowWidth = tmpMaxX - tmpMinX + tmpPadding * 2;
		let tmpFlowHeight = tmpMaxY - tmpMinY + tmpPadding * 2;

		let tmpSVGRect = this._FlowView._SVGElement.getBoundingClientRect();
		let tmpScaleX = tmpSVGRect.width / tmpFlowWidth;
		let tmpScaleY = tmpSVGRect.height / tmpFlowHeight;
		let tmpZoom = Math.min(tmpScaleX, tmpScaleY, 1.0); // Don't zoom in past 1.0
		tmpZoom = Math.max(this._FlowView.options.MinZoom, Math.min(this._FlowView.options.MaxZoom, tmpZoom));

		let tmpCenterX = (tmpMinX + tmpMaxX) / 2;
		let tmpCenterY = (tmpMinY + tmpMaxY) / 2;

		this._FlowView._FlowData.ViewState.Zoom = tmpZoom;
		this._FlowView._FlowData.ViewState.PanX = (tmpSVGRect.width / 2) - (tmpCenterX * tmpZoom);
		this._FlowView._FlowData.ViewState.PanY = (tmpSVGRect.height / 2) - (tmpCenterY * tmpZoom);

		this.updateViewportTransform();
	}

	/**
	 * Convert screen coordinates to SVG viewport coordinates
	 * @param {number} pScreenX
	 * @param {number} pScreenY
	 * @returns {{x: number, y: number}}
	 */
	screenToSVGCoords(pScreenX, pScreenY)
	{
		if (!this._FlowView._SVGElement)
		{
			return { x: pScreenX, y: pScreenY };
		}

		let tmpPoint = this._FlowView._SVGElement.createSVGPoint();
		tmpPoint.x = pScreenX;
		tmpPoint.y = pScreenY;

		let tmpCTM = this._FlowView._SVGElement.getScreenCTM();
		if (tmpCTM)
		{
			let tmpInverse = tmpCTM.inverse();
			let tmpTransformed = tmpPoint.matrixTransform(tmpInverse);
			// Account for viewport pan/zoom
			let tmpVS = this._FlowView._FlowData.ViewState;
			return {
				x: (tmpTransformed.x - tmpVS.PanX) / tmpVS.Zoom,
				y: (tmpTransformed.y - tmpVS.PanY) / tmpVS.Zoom
			};
		}

		return { x: pScreenX, y: pScreenY };
	}

	/**
	 * Toggle fullscreen mode on the flow editor container.
	 * Uses a CSS fixed-position overlay instead of the Fullscreen API.
	 * @returns {boolean} The new fullscreen state
	 */
	toggleFullscreen()
	{
		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpContainerElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Wrapper-${tmpViewIdentifier}`);
		if (tmpContainerElements.length < 1) return this._IsFullscreen;

		let tmpContainer = tmpContainerElements[0];

		this._IsFullscreen = !this._IsFullscreen;

		if (this._IsFullscreen)
		{
			tmpContainer.classList.add('pict-flow-fullscreen');
		}
		else
		{
			tmpContainer.classList.remove('pict-flow-fullscreen');
		}

		return this._IsFullscreen;
	}

	/**
	 * Exit fullscreen mode if currently active.
	 */
	exitFullscreen()
	{
		if (!this._IsFullscreen) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		let tmpContainerElements = this._FlowView.pict.ContentAssignment.getElement(`#Flow-Wrapper-${tmpViewIdentifier}`);
		if (tmpContainerElements.length > 0)
		{
			tmpContainerElements[0].classList.remove('pict-flow-fullscreen');
		}

		this._IsFullscreen = false;
	}
}

module.exports = PictServiceFlowViewportManager;

},{"fable-serviceproviderbase":2}],58:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-FloatingToolbar',

	DefaultRenderable: 'Flow-FloatingToolbar-Content',
	DefaultDestinationAddress: '#Flow-FloatingToolbar-Container',

	AutoRender: false,

	FlowViewIdentifier: 'Pict-Flow',

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-FloatingToolbar-Template',
			Template: /*html*/`
<div class="pict-flow-floating-toolbar" id="Flow-FloatingToolbar-{~D:Record.FlowViewIdentifier~}">
	<div class="pict-flow-floating-grip" id="Flow-FloatingGrip-{~D:Record.FlowViewIdentifier~}" title="Drag to move · Double-click to collapse">
		<span id="Flow-FloatingIcon-grip-{~D:Record.FlowViewIdentifier~}"></span>
	</div>
	<button class="pict-flow-floating-btn" data-flow-action="add-node" title="Add Node">
		<span id="Flow-FloatingIcon-plus-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="cards-popup" title="Cards">
		<span id="Flow-FloatingIcon-cards-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="delete-selected" title="Delete Selected">
		<span id="Flow-FloatingIcon-trash-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-in" title="Zoom In">
		<span id="Flow-FloatingIcon-zoom-in-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-out" title="Zoom Out">
		<span id="Flow-FloatingIcon-zoom-out-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="zoom-fit" title="Fit to View">
		<span id="Flow-FloatingIcon-zoom-fit-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="auto-layout" title="Auto Layout">
		<span id="Flow-FloatingIcon-auto-layout-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="layout-popup" title="Layout">
		<span id="Flow-FloatingIcon-layout-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<button class="pict-flow-floating-btn" data-flow-action="fullscreen" title="Toggle Fullscreen">
		<span id="Flow-FloatingIcon-fullscreen-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
	<div class="pict-flow-floating-separator"></div>
	<button class="pict-flow-floating-btn" data-flow-action="dock-toolbar" title="Dock Toolbar">
		<span id="Flow-FloatingIcon-dock-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-FloatingToolbar-Content',
			TemplateHash: 'Flow-FloatingToolbar-Template',
			DestinationAddress: '#Flow-FloatingToolbar-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlowFloatingToolbar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowFloatingToolbar';

		this._ToolbarView = null;
		this._FlowView = null;

		this._IsCollapsed = false;

		this._IsDragging = false;
		this._DragStartX = 0;
		this._DragStartY = 0;
		this._DragStartLeft = 0;
		this._DragStartTop = 0;

		this._BoundMouseMove = null;
		this._BoundMouseUp = null;
	}

	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Bind click delegation for action buttons
		let tmpFloatingToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpFloatingToolbar.length > 0)
		{
			tmpFloatingToolbar[0].addEventListener('click', (pEvent) =>
			{
				let tmpTarget = pEvent.target;
				if (!tmpTarget) return;

				let tmpButton = tmpTarget.closest('[data-flow-action]');
				if (!tmpButton) return;

				let tmpAction = tmpButton.getAttribute('data-flow-action');
				if (tmpAction === 'dock-toolbar')
				{
					if (this._ToolbarView)
					{
						this._ToolbarView._setToolbarMode('docked');
					}
					return;
				}

				// Delegate all other actions to the docked toolbar
				if (this._ToolbarView)
				{
					this._ToolbarView._handleToolbarAction(tmpAction);
				}
			});
		}

		// Bind drag behavior on the grip
		let tmpGrip = this.pict.ContentAssignment.getElement(`#Flow-FloatingGrip-${tmpFlowViewIdentifier}`);
		if (tmpGrip.length > 0)
		{
			tmpGrip[0].addEventListener('mousedown', (pEvent) =>
			{
				this._startDrag(pEvent);
			});

			// Double-click grip to toggle collapsed state
			tmpGrip[0].addEventListener('dblclick', (pEvent) =>
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				this._toggleCollapse();
			});
		}

		// Populate icons
		this._populateIcons();

		// Remove buttons from DOM based on options
		if (tmpFloatingToolbar.length > 0)
		{
			if (this.options.EnableAddNode === false)
			{
				let tmpAddNodeBtn = tmpFloatingToolbar[0].querySelector('[data-flow-action="add-node"]');
				if (tmpAddNodeBtn)
				{
					tmpAddNodeBtn.remove();
				}
			}
			if (this.options.EnableCardPalette === false)
			{
				let tmpCardsBtn = tmpFloatingToolbar[0].querySelector('[data-flow-action="cards-popup"]');
				if (tmpCardsBtn)
				{
					tmpCardsBtn.remove();
				}
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Populate SVG icons into all floating toolbar button spans.
	 */
	_populateIcons()
	{
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (!tmpIconProvider) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		let tmpIconMap =
		{
			'grip': 'grip',
			'plus': 'plus',
			'trash': 'trash',
			'zoom-in': 'zoom-in',
			'zoom-out': 'zoom-out',
			'zoom-fit': 'zoom-fit',
			'auto-layout': 'auto-layout',
			'cards': 'cards',
			'layout': 'layout',
			'fullscreen': 'fullscreen',
			'dock': 'dock'
		};

		let tmpKeys = Object.keys(tmpIconMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpElementId = `Flow-FloatingIcon-${tmpKeys[i]}-${tmpFlowViewIdentifier}`;
			let tmpElements = this.pict.ContentAssignment.getElement(`#${tmpElementId}`);
			if (tmpElements.length > 0)
			{
				tmpElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpIconMap[tmpKeys[i]], 16);
			}
		}
	}

	/**
	 * Toggle the floating toolbar between expanded and collapsed (grip-only square) states.
	 */
	_toggleCollapse()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		this._IsCollapsed = !this._IsCollapsed;

		if (this._IsCollapsed)
		{
			tmpToolbar[0].classList.add('collapsed');
		}
		else
		{
			tmpToolbar[0].classList.remove('collapsed');
		}
	}

	/**
	 * Start dragging the floating toolbar.
	 * @param {MouseEvent} pEvent
	 */
	_startDrag(pEvent)
	{
		pEvent.preventDefault();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		let tmpEl = tmpToolbar[0];
		this._IsDragging = true;
		this._DragStartX = pEvent.clientX;
		this._DragStartY = pEvent.clientY;
		this._DragStartLeft = tmpEl.offsetLeft;
		this._DragStartTop = tmpEl.offsetTop;

		this._BoundMouseMove = (pMoveEvent) => { this._onDragMove(pMoveEvent); };
		this._BoundMouseUp = () => { this._onDragEnd(); };

		document.addEventListener('mousemove', this._BoundMouseMove);
		document.addEventListener('mouseup', this._BoundMouseUp);
	}

	/**
	 * Handle drag movement.
	 * @param {MouseEvent} pEvent
	 */
	_onDragMove(pEvent)
	{
		if (!this._IsDragging) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length < 1) return;

		let tmpEl = tmpToolbar[0];
		let tmpDeltaX = pEvent.clientX - this._DragStartX;
		let tmpDeltaY = pEvent.clientY - this._DragStartY;

		let tmpNewLeft = this._DragStartLeft + tmpDeltaX;
		let tmpNewTop = this._DragStartTop + tmpDeltaY;

		// Clamp to parent bounds
		let tmpParent = tmpEl.parentElement;
		if (tmpParent)
		{
			let tmpMaxLeft = tmpParent.clientWidth - tmpEl.offsetWidth;
			let tmpMaxTop = tmpParent.clientHeight - tmpEl.offsetHeight;
			tmpNewLeft = Math.max(0, Math.min(tmpNewLeft, tmpMaxLeft));
			tmpNewTop = Math.max(0, Math.min(tmpNewTop, tmpMaxTop));
		}

		tmpEl.style.left = tmpNewLeft + 'px';
		tmpEl.style.top = tmpNewTop + 'px';
	}

	/**
	 * End dragging.
	 */
	_onDragEnd()
	{
		this._IsDragging = false;

		if (this._BoundMouseMove)
		{
			document.removeEventListener('mousemove', this._BoundMouseMove);
			this._BoundMouseMove = null;
		}
		if (this._BoundMouseUp)
		{
			document.removeEventListener('mouseup', this._BoundMouseUp);
			this._BoundMouseUp = null;
		}

		// Save position
		if (this._ToolbarView)
		{
			let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
			let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
			if (tmpToolbar.length > 0)
			{
				this._ToolbarView._FloatingPosition.X = tmpToolbar[0].offsetLeft;
				this._ToolbarView._FloatingPosition.Y = tmpToolbar[0].offsetTop;
			}
		}
	}

	/**
	 * Show the floating toolbar at the saved position.
	 */
	show()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpContainer = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`);
		if (tmpContainer.length > 0)
		{
			tmpContainer[0].style.display = 'block';
		}

		let tmpToolbar = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-${tmpFlowViewIdentifier}`);
		if (tmpToolbar.length > 0 && this._ToolbarView)
		{
			tmpToolbar[0].style.left = this._ToolbarView._FloatingPosition.X + 'px';
			tmpToolbar[0].style.top = this._ToolbarView._FloatingPosition.Y + 'px';
		}

		// Restore expanded state when showing
		if (this._IsCollapsed && tmpToolbar.length > 0)
		{
			this._IsCollapsed = false;
			tmpToolbar[0].classList.remove('collapsed');
		}
	}

	/**
	 * Hide the floating toolbar.
	 */
	hide()
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpContainer = this.pict.ContentAssignment.getElement(`#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`);
		if (tmpContainer.length > 0)
		{
			tmpContainer[0].style.display = 'none';
		}
	}
}

module.exports = PictViewFlowFloatingToolbar;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":239}],59:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-NodeRenderer',

	AutoRender: false,

	// Title bar height for nodes
	NodeTitleBarHeight: 22
};

class PictViewFlowNode extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowNode';

		this._FlowView = null;
	}

	/**
	 * Render a node into the nodes SVG layer
	 * @param {Object} pNodeData - The node data object
	 * @param {SVGGElement} pNodesLayer - The SVG <g> element to append to
	 * @param {boolean} pIsSelected - Whether this node is selected
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 */
	renderNode(pNodeData, pNodesLayer, pIsSelected, pNodeTypeConfig)
	{
		let tmpGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');

		// Build CSS class list with optional per-type modifier classes
		let tmpClassList = `pict-flow-node ${pIsSelected ? 'selected' : ''} pict-flow-node-${pNodeData.Type || 'default'}`;
		if (pNodeTypeConfig)
		{
			if (pNodeTypeConfig.PortLabelsOnHover) tmpClassList += ' pict-flow-node-port-labels-hover';
			if (pNodeTypeConfig.PortLabelsVertical) tmpClassList += ' pict-flow-node-port-labels-vertical';
		}
		tmpGroup.setAttribute('class', tmpClassList);
		tmpGroup.setAttribute('transform', `translate(${pNodeData.X}, ${pNodeData.Y})`);
		tmpGroup.setAttribute('data-node-hash', pNodeData.Hash);
		tmpGroup.setAttribute('data-element-type', 'node');

		let tmpWidth = pNodeData.Width || 180;
		let tmpHeight = pNodeData.Height || 80;
		let tmpTitleBarHeight = this.options.NodeTitleBarHeight;

		// Ensure node is tall enough for all ports in their zones
		let tmpGeomProvider = this._FlowView._GeometryProvider;
		if (tmpGeomProvider && pNodeData.Ports && pNodeData.Ports.length > 0)
		{
			let tmpMinHeight = tmpGeomProvider.computeMinimumNodeHeight(pNodeData.Ports, tmpTitleBarHeight);
			if (tmpMinHeight > tmpHeight)
			{
				tmpHeight = tmpMinHeight;
			}
		}

		// Write the adjusted dimensions back to the node data so that
		// connection rendering (which reads pNodeData.Width/Height to
		// compute port positions) uses the same values we render with.
		pNodeData.Width = tmpWidth;
		pNodeData.Height = tmpHeight;

		// Determine node body mode from theme (bracket vs rect)
		let tmpNodeBodyMode = 'rect';
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.NodeBodyMode)
			{
				tmpNodeBodyMode = tmpActiveTheme.NodeBodyMode;
			}
		}

		if (tmpNodeBodyMode === 'bracket')
		{
			this._renderBracketNodeBody(tmpGroup, pNodeData, tmpWidth, tmpHeight, tmpTitleBarHeight, pNodeTypeConfig);
		}
		else
		{
			this._renderRectNodeBody(tmpGroup, pNodeData, tmpWidth, tmpHeight, tmpTitleBarHeight, pNodeTypeConfig);
		}

		// Determine if this node has a title-bar icon (FlowCard with CardMetadata)
		let tmpHasTitleIcon = false;
		let tmpTitleIconSize = 12;
		let tmpTitleIconMarginLeft = 8;
		let tmpTitleIconGap = 4;

		if (pNodeTypeConfig && pNodeTypeConfig.CardMetadata)
		{
			let tmpMeta = pNodeTypeConfig.CardMetadata;
			let tmpIconProvider = this._FlowView._IconProvider;
			if (tmpMeta.Icon || tmpIconProvider)
			{
				tmpHasTitleIcon = true;
			}
		}

		// Title text (position adjusts when a title-bar icon is present)
		let tmpTitle = this._FlowView._SVGHelperProvider.createSVGElement('text');
		tmpTitle.setAttribute('class', 'pict-flow-node-title');
		if (tmpHasTitleIcon)
		{
			tmpTitle.setAttribute('x', String(tmpTitleIconMarginLeft + tmpTitleIconSize + tmpTitleIconGap));
			tmpTitle.setAttribute('text-anchor', 'start');
		}
		else
		{
			tmpTitle.setAttribute('x', String(tmpWidth / 2));
			tmpTitle.setAttribute('text-anchor', 'middle');
		}
		tmpTitle.setAttribute('y', String(tmpTitleBarHeight / 2 + 1));
		tmpTitle.setAttribute('dominant-baseline', 'central');
		tmpTitle.textContent = pNodeData.Title || 'Untitled';
		tmpGroup.appendChild(tmpTitle);

		// Determine whether labels should be rendered
		let tmpShowTypeLabel = (!pNodeTypeConfig || pNodeTypeConfig.ShowTypeLabel !== false);
		let tmpLabelsInFront = (!pNodeTypeConfig || pNodeTypeConfig.LabelsInFront !== false);

		// Helper: render type label + code badge + tooltip (the "middle labels")
		let tmpRenderTypeLabels = () =>
		{
			// Type label (below title bar — hover-only for FlowCard nodes via CSS)
			if (tmpShowTypeLabel && pNodeTypeConfig && pNodeTypeConfig.Label && pNodeTypeConfig.Label !== pNodeData.Title)
			{
				let tmpTypeLabel = this._FlowView._SVGHelperProvider.createSVGElement('text');
				tmpTypeLabel.setAttribute('class', 'pict-flow-node-type-label');
				tmpTypeLabel.setAttribute('x', String(tmpWidth / 2));
				tmpTypeLabel.setAttribute('y', String(tmpTitleBarHeight + 16));
				tmpTypeLabel.setAttribute('text-anchor', 'middle');
				tmpTypeLabel.setAttribute('dominant-baseline', 'central');
				tmpTypeLabel.textContent = pNodeTypeConfig.Label;
				tmpGroup.appendChild(tmpTypeLabel);
			}

			// FlowCard metadata: icon in title bar, code badge in body (hover-only via CSS)
			if (pNodeTypeConfig && pNodeTypeConfig.CardMetadata)
			{
				let tmpMeta = pNodeTypeConfig.CardMetadata;
				let tmpIconProvider = this._FlowView._IconProvider;
				let tmpTitleIconRendered = false;

				// Icon position in title bar (vertically centered)
				let tmpIconX = tmpTitleIconMarginLeft;
				let tmpIconY = (tmpTitleBarHeight - tmpTitleIconSize) / 2;

				if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					// SVG icon via the icon provider — rendered into title bar
					let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
					let tmpIconGroup = tmpIconProvider.renderIconIntoSVGGroup(
						tmpResolvedKey, tmpGroup,
						tmpIconX, tmpIconY,
						tmpTitleIconSize);
					if (tmpIconGroup)
					{
						tmpIconGroup.setAttribute('class',
							(tmpIconGroup.getAttribute('class') || '') + ' pict-flow-node-title-icon');
					}
					tmpTitleIconRendered = true;
				}
				else if (tmpMeta.Icon && tmpIconProvider && tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
				{
					// Emoji icon in title bar
					let tmpIconText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpIconText.setAttribute('class', 'pict-flow-node-card-icon pict-flow-node-title-icon-emoji');
					tmpIconText.setAttribute('font-size', String(tmpTitleIconSize));
					tmpIconText.setAttribute('text-anchor', 'middle');
					tmpIconText.setAttribute('dominant-baseline', 'central');
					tmpIconText.setAttribute('pointer-events', 'none');
					tmpIconText.setAttribute('x', String(tmpIconX + tmpTitleIconSize / 2));
					tmpIconText.setAttribute('y', String(tmpTitleBarHeight / 2));
					tmpIconText.textContent = tmpMeta.Icon;
					tmpGroup.appendChild(tmpIconText);
					tmpTitleIconRendered = true;
				}
				else if (tmpMeta.Icon)
				{
					// No icon provider — text fallback in title bar
					let tmpIconText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpIconText.setAttribute('class', 'pict-flow-node-card-icon pict-flow-node-title-icon-emoji');
					tmpIconText.setAttribute('font-size', String(tmpTitleIconSize));
					tmpIconText.setAttribute('text-anchor', 'middle');
					tmpIconText.setAttribute('dominant-baseline', 'central');
					tmpIconText.setAttribute('pointer-events', 'none');
					tmpIconText.setAttribute('x', String(tmpIconX + tmpTitleIconSize / 2));
					tmpIconText.setAttribute('y', String(tmpTitleBarHeight / 2));
					tmpIconText.textContent = tmpMeta.Icon;
					tmpGroup.appendChild(tmpIconText);
					tmpTitleIconRendered = true;
				}

				// Default fallback icon in title bar
				if (!tmpTitleIconRendered && tmpIconProvider)
				{
					let tmpIconGroup = tmpIconProvider.renderIconIntoSVGGroup(
						'default', tmpGroup,
						tmpIconX, tmpIconY,
						tmpTitleIconSize);
					if (tmpIconGroup)
					{
						tmpIconGroup.setAttribute('class',
							(tmpIconGroup.getAttribute('class') || '') + ' pict-flow-node-title-icon');
					}
				}

				// Code badge in body (hover-only via CSS, skipped when ShowTypeLabel is false)
				let tmpBodyCenterY = tmpTitleBarHeight + (tmpHeight - tmpTitleBarHeight) / 2;
				if (tmpShowTypeLabel && tmpMeta.Code)
				{
					let tmpCodeText = this._FlowView._SVGHelperProvider.createSVGElement('text');
					tmpCodeText.setAttribute('class', 'pict-flow-node-card-code');
					tmpCodeText.setAttribute('font-size', '10');
					tmpCodeText.setAttribute('font-family', 'monospace');
					tmpCodeText.setAttribute('fill', '#7f8c8d');
					tmpCodeText.setAttribute('text-anchor', 'middle');
					tmpCodeText.setAttribute('dominant-baseline', 'central');
					tmpCodeText.setAttribute('pointer-events', 'none');
					tmpCodeText.setAttribute('x', String(tmpWidth / 2));
					tmpCodeText.setAttribute('y', String(tmpBodyCenterY));
					tmpCodeText.textContent = tmpMeta.Code;
					tmpGroup.appendChild(tmpCodeText);
				}

				// Tooltip via SVG <title> element
				if (tmpMeta.Tooltip || tmpMeta.Description)
				{
					let tmpSVGTitle = this._FlowView._SVGHelperProvider.createSVGElement('title');
					tmpSVGTitle.textContent = tmpMeta.Tooltip || tmpMeta.Description;
					tmpGroup.appendChild(tmpSVGTitle);
				}
			}
		};

		// Render order depends on LabelsInFront:
		//   true  (default): body content first, then labels + ports (labels on top)
		//   false:           labels + ports first, then body content (content on top)
		if (tmpLabelsInFront)
		{
			this._renderBodyContent(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
			tmpRenderTypeLabels();
			this._renderPorts(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
		}
		else
		{
			tmpRenderTypeLabels();
			this._renderPorts(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
			this._renderBodyContent(pNodeData, tmpGroup, tmpWidth, tmpHeight, pNodeTypeConfig);
		}

		// Panel indicator icon (small rect in bottom-right corner)
		if (pNodeTypeConfig && pNodeTypeConfig.PropertiesPanel)
		{
			let tmpIndicatorSize = 10;
			let tmpIndicatorMargin = 4;
			let tmpIndicatorX = tmpWidth - tmpIndicatorSize - tmpIndicatorMargin;
			let tmpIndicatorY = tmpHeight - tmpIndicatorSize - tmpIndicatorMargin;
			let tmpShapeProvider = this._FlowView._ConnectorShapesProvider;
			let tmpIndicator;

			if (tmpShapeProvider)
			{
				tmpIndicator = tmpShapeProvider.createPanelIndicatorElement(
					pNodeData.Hash, tmpIndicatorX, tmpIndicatorY,
					tmpIndicatorSize, tmpIndicatorSize);
			}
			else
			{
				tmpIndicator = this._FlowView._SVGHelperProvider.createSVGElement('rect');
				tmpIndicator.setAttribute('class', 'pict-flow-node-panel-indicator');
				tmpIndicator.setAttribute('x', String(tmpIndicatorX));
				tmpIndicator.setAttribute('y', String(tmpIndicatorY));
				tmpIndicator.setAttribute('width', String(tmpIndicatorSize));
				tmpIndicator.setAttribute('height', String(tmpIndicatorSize));
				tmpIndicator.setAttribute('rx', '2');
				tmpIndicator.setAttribute('ry', '2');
				tmpIndicator.setAttribute('data-node-hash', pNodeData.Hash);
				tmpIndicator.setAttribute('data-element-type', 'panel-indicator');
			}

			let tmpIndicatorTitle = this._FlowView._SVGHelperProvider.createSVGElement('title');
			tmpIndicatorTitle.textContent = 'Double-click to open properties';
			tmpIndicator.appendChild(tmpIndicatorTitle);

			tmpGroup.appendChild(tmpIndicator);
		}

		pNodesLayer.appendChild(tmpGroup);
	}

	/**
	 * Render ports for a node — delegates to the PortRenderer service.
	 * @param {Object} pNodeData
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {Object} [pNodeTypeConfig] - Node type configuration (for label display options)
	 */
	_renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig)
	{
		this._FlowView._PortRenderer.renderPorts(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig, this.options.NodeTitleBarHeight);
	}

	/**
	 * Render custom body content for a node (svg, html, or canvas).
	 *
	 * Checks for a BodyContent configuration on the node type and renders
	 * the appropriate content type into the node's SVG group.
	 *
	 * @param {Object} pNodeData - The node data object
	 * @param {SVGGElement} pGroup - The node's SVG group
	 * @param {number} pWidth - Node width
	 * @param {number} pHeight - Node height
	 * @param {Object} pNodeTypeConfig - The node type configuration
	 */
	_renderBodyContent(pNodeData, pGroup, pWidth, pHeight, pNodeTypeConfig)
	{
		if (!pNodeTypeConfig || !pNodeTypeConfig.BodyContent) return;

		let tmpBodyContent = pNodeTypeConfig.BodyContent;
		let tmpContentType = tmpBodyContent.ContentType;
		if (!tmpContentType) return;

		let tmpTitleBarHeight = this.options.NodeTitleBarHeight;
		let tmpPadding = (typeof tmpBodyContent.Padding === 'number') ? tmpBodyContent.Padding : 2;
		let tmpBodyBounds =
		{
			x: tmpPadding,
			y: tmpTitleBarHeight + tmpPadding,
			width: pWidth - (tmpPadding * 2),
			height: pHeight - tmpTitleBarHeight - (tmpPadding * 2)
		};

		let tmpPict = this._FlowView.pict || this.pict;

		// Register any templates defined in the BodyContent config (once)
		if (tmpBodyContent.Templates && Array.isArray(tmpBodyContent.Templates))
		{
			if (!this._registeredBodyTemplates)
			{
				this._registeredBodyTemplates = new Set();
			}
			for (let i = 0; i < tmpBodyContent.Templates.length; i++)
			{
				let tmpTpl = tmpBodyContent.Templates[i];
				if (tmpTpl.Hash && tmpTpl.Template && !this._registeredBodyTemplates.has(tmpTpl.Hash))
				{
					tmpPict.TemplateProvider.addTemplate(tmpTpl.Hash, tmpTpl.Template, 'PictViewFlowNode-BodyContent');
					this._registeredBodyTemplates.add(tmpTpl.Hash);
				}
			}
		}

		switch (tmpContentType)
		{
			case 'svg':
				this._renderBodyContentSVG(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig, tmpPict);
				break;
			case 'html':
				this._renderBodyContentHTML(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig, tmpPict);
				break;
			case 'canvas':
				this._renderBodyContentCanvas(pNodeData, pGroup, tmpBodyContent, tmpBodyBounds, pNodeTypeConfig);
				break;
			default:
				this.log.warn('PictViewFlowNode _renderBodyContent: unknown ContentType [' + tmpContentType + ']');
				break;
		}
	}

	/**
	 * Render SVG body content into a <g> group.
	 */
	_renderBodyContentSVG(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig, pPict)
	{
		let tmpContentGroup = this._FlowView._SVGHelperProvider.createSVGElement('g');
		tmpContentGroup.setAttribute('class', 'pict-flow-node-body-content');
		tmpContentGroup.setAttribute('transform', `translate(${pBounds.x}, ${pBounds.y})`);

		// Render template content
		let tmpRenderedContent = this._resolveBodyTemplate(pBodyContent, pNodeData, pPict);
		if (tmpRenderedContent)
		{
			// Parse SVG markup into the group via a temporary SVG element
			let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			tmpTempSVG.innerHTML = tmpRenderedContent;
			while (tmpTempSVG.firstChild)
			{
				tmpContentGroup.appendChild(tmpTempSVG.firstChild);
			}
		}

		// Invoke render callback if provided
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpContentGroup, pNodeData, pNodeTypeConfig, pBounds);
		}

		pGroup.appendChild(tmpContentGroup);
	}

	/**
	 * Render HTML body content into a foreignObject.
	 */
	_renderBodyContentHTML(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig, pPict)
	{
		let tmpFO = this._FlowView._SVGHelperProvider.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-node-body-content-fo');
		tmpFO.setAttribute('x', String(pBounds.x));
		tmpFO.setAttribute('y', String(pBounds.y));
		tmpFO.setAttribute('width', String(pBounds.width));
		tmpFO.setAttribute('height', String(pBounds.height));

		let tmpDiv = document.createElement('div');
		tmpDiv.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
		tmpDiv.setAttribute('class', 'pict-flow-node-body-content-html');

		// Pointer event isolation — prevent node drag/canvas pan
		tmpDiv.addEventListener('pointerdown', (pEvent) => { pEvent.stopPropagation(); });
		tmpDiv.addEventListener('wheel', (pEvent) => { pEvent.stopPropagation(); });

		// Render template content
		let tmpRenderedContent = this._resolveBodyTemplate(pBodyContent, pNodeData, pPict);
		if (tmpRenderedContent)
		{
			tmpDiv.innerHTML = tmpRenderedContent;
		}

		// Invoke render callback if provided
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpDiv, pNodeData, pNodeTypeConfig, pBounds);
		}

		tmpFO.appendChild(tmpDiv);
		pGroup.appendChild(tmpFO);
	}

	/**
	 * Render canvas body content into a foreignObject.
	 */
	_renderBodyContentCanvas(pNodeData, pGroup, pBodyContent, pBounds, pNodeTypeConfig)
	{
		let tmpFO = this._FlowView._SVGHelperProvider.createSVGElement('foreignObject');
		tmpFO.setAttribute('class', 'pict-flow-node-body-content-fo');
		tmpFO.setAttribute('x', String(pBounds.x));
		tmpFO.setAttribute('y', String(pBounds.y));
		tmpFO.setAttribute('width', String(pBounds.width));
		tmpFO.setAttribute('height', String(pBounds.height));

		let tmpCanvas = document.createElement('canvas');
		tmpCanvas.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
		tmpCanvas.setAttribute('class', 'pict-flow-node-body-content-canvas');
		tmpCanvas.width = Math.floor(pBounds.width);
		tmpCanvas.height = Math.floor(pBounds.height);
		tmpCanvas.style.width = '100%';
		tmpCanvas.style.height = '100%';

		// Pointer event isolation
		tmpCanvas.addEventListener('pointerdown', (pEvent) => { pEvent.stopPropagation(); });
		tmpCanvas.addEventListener('wheel', (pEvent) => { pEvent.stopPropagation(); });

		// Invoke render callback (the primary rendering path for canvas)
		if (typeof pBodyContent.RenderCallback === 'function')
		{
			pBodyContent.RenderCallback(tmpCanvas, pNodeData, pNodeTypeConfig, pBounds);
		}

		tmpFO.appendChild(tmpCanvas);
		pGroup.appendChild(tmpFO);
	}

	/**
	 * Resolve and render a body content template string.
	 * @param {Object} pBodyContent - The BodyContent config
	 * @param {Object} pNodeData - The node data (template record)
	 * @param {Object} pPict - The Pict instance
	 * @returns {string|null} Rendered template content, or null
	 */
	_resolveBodyTemplate(pBodyContent, pNodeData, pPict)
	{
		if (pBodyContent.TemplateHash)
		{
			return pPict.parseTemplateByHash(pBodyContent.TemplateHash, pNodeData);
		}
		if (pBodyContent.Template)
		{
			return pPict.parseTemplate(pBodyContent.Template, pNodeData, null, [pNodeData]);
		}
		return null;
	}

	// ── Node Body Renderers ──────────────────────────────────────────────

	/**
	 * Render the standard rect-based node body (default mode).
	 * @param {SVGGElement} pGroup
	 * @param {Object} pNodeData
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {number} pTitleBarHeight
	 * @param {Object} pNodeTypeConfig
	 */
	_renderRectNodeBody(pGroup, pNodeData, pWidth, pHeight, pTitleBarHeight, pNodeTypeConfig)
	{
		// Node body (main rectangle)
		let tmpBody = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpBody.setAttribute('class', 'pict-flow-node-body');
		tmpBody.setAttribute('x', '0');
		tmpBody.setAttribute('y', '0');
		tmpBody.setAttribute('width', String(pWidth));
		tmpBody.setAttribute('height', String(pHeight));
		tmpBody.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBody.setAttribute('data-element-type', 'node-body');

		// Apply custom styles from node type
		if (pNodeTypeConfig && pNodeTypeConfig.BodyStyle)
		{
			for (let tmpStyleKey in pNodeTypeConfig.BodyStyle)
			{
				tmpBody.setAttribute(tmpStyleKey, pNodeTypeConfig.BodyStyle[tmpStyleKey]);
			}
		}

		// Apply per-instance style overrides (for node-specific editing)
		// These must be applied as inline styles so they override CSS rules
		// (CSS declarations take precedence over SVG presentation attributes).
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyFill) tmpInlineStyles.push('fill:' + pNodeData.Style.BodyFill);
			if (pNodeData.Style.BodyStroke) tmpInlineStyles.push('stroke:' + pNodeData.Style.BodyStroke);
			if (pNodeData.Style.BodyStrokeWidth) tmpInlineStyles.push('stroke-width:' + pNodeData.Style.BodyStrokeWidth);
			if (tmpInlineStyles.length > 0)
			{
				tmpBody.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBody);

		// Title bar background (top portion)
		let tmpTitleBar = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleBar.setAttribute('class', 'pict-flow-node-title-bar');
		tmpTitleBar.setAttribute('x', '0');
		tmpTitleBar.setAttribute('y', '0');
		tmpTitleBar.setAttribute('width', String(pWidth));
		tmpTitleBar.setAttribute('height', String(pTitleBarHeight));
		tmpTitleBar.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleBar.setAttribute('data-element-type', 'node-body');

		// Apply custom title bar color
		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleBar.setAttribute('fill', pNodeTypeConfig.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleBar);

		// Title bar bottom fill (to square off the rounded corners at the bottom of the title bar)
		let tmpTitleBarBottom = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleBarBottom.setAttribute('class', 'pict-flow-node-title-bar-bottom');
		tmpTitleBarBottom.setAttribute('x', '0');
		tmpTitleBarBottom.setAttribute('y', String(pTitleBarHeight - 8));
		tmpTitleBarBottom.setAttribute('width', String(pWidth));
		tmpTitleBarBottom.setAttribute('height', '8');
		tmpTitleBarBottom.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleBarBottom.setAttribute('data-element-type', 'node-body');

		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleBarBottom.setAttribute('fill', pNodeTypeConfig.TitleBarColor);
		}

		// Per-instance title bar color override
		// Applied as inline style to override CSS rules.
		if (pNodeData.Style && pNodeData.Style.TitleBarColor)
		{
			tmpTitleBar.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
			tmpTitleBarBottom.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleBarBottom);
	}

	/**
	 * Render a bracket-style node body (used by sketch/blueprint themes).
	 *
	 * The bracket body consists of:
	 * 1. A fill rect for the body background (no stroke)
	 * 2. A fill rect for the title bar background (no stroke)
	 * 3. A bracket path drawn via the noise provider (outline + title divider)
	 *
	 * @param {SVGGElement} pGroup
	 * @param {Object} pNodeData
	 * @param {number} pWidth
	 * @param {number} pHeight
	 * @param {number} pTitleBarHeight
	 * @param {Object} pNodeTypeConfig
	 */
	_renderBracketNodeBody(pGroup, pNodeData, pWidth, pHeight, pTitleBarHeight, pNodeTypeConfig)
	{
		// 1. Body fill rect (background only, no stroke)
		let tmpBodyFill = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpBodyFill.setAttribute('class', 'pict-flow-node-body pict-flow-node-bracket-fill');
		tmpBodyFill.setAttribute('x', '0');
		tmpBodyFill.setAttribute('y', '0');
		tmpBodyFill.setAttribute('width', String(pWidth));
		tmpBodyFill.setAttribute('height', String(pHeight));
		tmpBodyFill.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBodyFill.setAttribute('data-element-type', 'node-body');

		// Per-instance style overrides
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyFill) tmpInlineStyles.push('fill:' + pNodeData.Style.BodyFill);
			if (tmpInlineStyles.length > 0)
			{
				tmpBodyFill.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBodyFill);

		// 2. Title bar fill rect (background only, no stroke)
		let tmpTitleFill = this._FlowView._SVGHelperProvider.createSVGElement('rect');
		tmpTitleFill.setAttribute('class', 'pict-flow-node-title-bar pict-flow-node-bracket-title-fill');
		tmpTitleFill.setAttribute('x', '0');
		tmpTitleFill.setAttribute('y', '0');
		tmpTitleFill.setAttribute('width', String(pWidth));
		tmpTitleFill.setAttribute('height', String(pTitleBarHeight));
		tmpTitleFill.setAttribute('data-node-hash', pNodeData.Hash);
		tmpTitleFill.setAttribute('data-element-type', 'node-body');

		if (pNodeTypeConfig && pNodeTypeConfig.TitleBarColor)
		{
			tmpTitleFill.setAttribute('style', 'fill:' + pNodeTypeConfig.TitleBarColor);
		}
		if (pNodeData.Style && pNodeData.Style.TitleBarColor)
		{
			tmpTitleFill.setAttribute('style', 'fill:' + pNodeData.Style.TitleBarColor);
		}

		pGroup.appendChild(tmpTitleFill);

		// 3. Bracket path (outline + title divider with optional noise)
		let tmpBracketConfig = { SerifLength: 6, TitleSeparator: true };
		if (this._FlowView._ThemeProvider)
		{
			let tmpActiveTheme = this._FlowView._ThemeProvider.getActiveTheme();
			if (tmpActiveTheme && tmpActiveTheme.BracketConfig)
			{
				tmpBracketConfig = Object.assign(tmpBracketConfig, tmpActiveTheme.BracketConfig);
			}
		}

		let tmpAmplitude = 0;
		if (this._FlowView._ThemeProvider)
		{
			tmpAmplitude = this._FlowView._ThemeProvider.getNodeNoiseAmplitude();
		}

		let tmpBracketD = '';
		if (this._FlowView._NoiseProvider)
		{
			tmpBracketD = this._FlowView._NoiseProvider.generateBracketPath(
				pWidth, pHeight,
				tmpBracketConfig.SerifLength,
				tmpBracketConfig.TitleSeparator ? pTitleBarHeight : 0,
				tmpAmplitude,
				pNodeData.Hash
			);
		}

		let tmpBracketPath = this._FlowView._SVGHelperProvider.createSVGElement('path');
		tmpBracketPath.setAttribute('class', 'pict-flow-node-bracket');
		tmpBracketPath.setAttribute('d', tmpBracketD);
		tmpBracketPath.setAttribute('data-node-hash', pNodeData.Hash);
		tmpBracketPath.setAttribute('data-element-type', 'node-body');

		// Per-instance stroke overrides
		if (pNodeData.Style)
		{
			let tmpInlineStyles = [];
			if (pNodeData.Style.BodyStroke) tmpInlineStyles.push('stroke:' + pNodeData.Style.BodyStroke);
			if (pNodeData.Style.BodyStrokeWidth) tmpInlineStyles.push('stroke-width:' + pNodeData.Style.BodyStrokeWidth);
			if (tmpInlineStyles.length > 0)
			{
				tmpBracketPath.setAttribute('style', tmpInlineStyles.join(';'));
			}
		}

		pGroup.appendChild(tmpBracketPath);
	}
}

module.exports = PictViewFlowNode;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":239}],60:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-PropertiesPanel',

	AutoRender: false,

	Templates:
	[
		{
			Hash: 'Flow-InfoPanel-Wrapper',
			Template: '<div class="pict-flow-info-panel">{~D:Record.PanelContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Header-Icon',
			Template: '<div class="pict-flow-info-panel-header with-icon">{~D:Record.Icon~} {~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Header',
			Template: '<div class="pict-flow-info-panel-header">{~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Description',
			Template: '<div class="pict-flow-info-panel-description">{~D:Record.Description~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Badges',
			Template: '<div class="pict-flow-info-panel-badges">{~D:Record.BadgesContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Badge-Category',
			Template: '<span class="pict-flow-info-panel-badge category">{~D:Record.Category~}</span>'
		},
		{
			Hash: 'Flow-InfoPanel-Badge-Code',
			Template: '<span class="pict-flow-info-panel-badge code">{~D:Record.Code~}</span>'
		},
		{
			Hash: 'Flow-InfoPanel-Section-Inputs',
			Template: '<div class="pict-flow-info-panel-section"><div class="pict-flow-info-panel-section-title">Inputs</div>{~D:Record.PortsContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Section-Outputs',
			Template: '<div class="pict-flow-info-panel-section"><div class="pict-flow-info-panel-section-title">Outputs</div>{~D:Record.PortsContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Input',
			Template: '<div class="pict-flow-info-panel-port input">{~D:Record.Label~}{~D:Record.Constraint~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Output',
			Template: '<div class="pict-flow-info-panel-port output">{~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Constraint',
			Template: ' <span class="pict-flow-info-panel-port-constraint">{~D:Record.ConstraintText~}</span>'
		},
		{
			Hash: 'Flow-InfoPanel-Section-Generic',
			Template: '<div class="pict-flow-info-panel-section"><div class="pict-flow-info-panel-section-title">{~D:Record.SectionTitle~}</div>{~D:Record.PortsContent~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Event',
			Template: '<div class="pict-flow-info-panel-port event">{~D:Record.Label~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-Value',
			Template: '<div class="pict-flow-info-panel-port value">{~D:Record.Label~}{~D:Record.DataType~}</div>'
		},
		{
			Hash: 'Flow-InfoPanel-Port-DataType',
			Template: ' <span class="pict-flow-info-panel-port-constraint">{~D:Record.DataTypeText~}</span>'
		},
		{
			Hash: 'Flow-NodeProps-Editor',
			Template: '<div class="pict-flow-node-props-fields"><div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Title</label><input type="text" class="pict-flow-node-props-input" data-prop="Title" value="{~D:Record.Title~}" /></div><div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Width</label><input type="number" class="pict-flow-node-props-input" data-prop="Width" value="{~D:Record.Width~}" min="60" step="10" /></div><div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Height</label><input type="number" class="pict-flow-node-props-input" data-prop="Height" value="{~D:Record.Height~}" min="40" step="10" /></div><div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Body Fill</label><input type="color" class="pict-flow-node-props-input pict-flow-node-props-color" data-prop="Style.BodyFill" value="{~D:Record.BodyFillValue~}" /></div><div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Body Stroke</label><input type="color" class="pict-flow-node-props-input pict-flow-node-props-color" data-prop="Style.BodyStroke" value="{~D:Record.BodyStrokeValue~}" /></div><div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Stroke Width</label><input type="number" class="pict-flow-node-props-input" data-prop="Style.BodyStrokeWidth" value="{~D:Record.BodyStrokeWidthValue~}" min="0" max="10" step="0.5" /></div><div class="pict-flow-node-props-field"><label class="pict-flow-node-props-label">Title Bar</label><input type="color" class="pict-flow-node-props-input pict-flow-node-props-color" data-prop="Style.TitleBarColor" value="{~D:Record.TitleBarColorValue~}" /></div></div>'
		}
	]
};

/**
 * PictView-Flow-PropertiesPanel
 *
 * Renders and manages all open properties panels on the flow graph.
 * Panels are SVG foreignObject elements containing HTML, placed inside
 * the viewport group so they zoom/pan with the graph.
 *
 * Responsibilities:
 *   - Reconcile DOM (add new panels, remove closed ones, update positions)
 *   - Render tether lines from each panel to its node
 *   - Manage panel instance cache (PictFlowCardPropertiesPanel subclasses)
 *   - Isolate HTML events from SVG interactions
 */
class PictViewFlowPropertiesPanel extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowPropertiesPanel';

		this._FlowView = null;

		// Cache of active panel instances: Map<panelHash, PictFlowCardPropertiesPanel>
		this._PanelInstances = {};
	}

	/**
	 * Render all open panels and their tethers.
	 *
	 * Uses DOM reconciliation for panels (to preserve live HTML state)
	 * and clear-and-rebuild for tethers (trivial SVG lines).
	 *
	 * @param {Array} pOpenPanels - Array of panel data objects from _FlowData.OpenPanels
	 * @param {SVGGElement} pPanelsLayer - The SVG <g> for panel foreignObjects
	 * @param {SVGGElement} pTethersLayer - The SVG <g> for tether lines
	 * @param {string|null} pSelectedTetherHash - Hash of the selected tether's panel, or null
	 */
	renderPanels(pOpenPanels, pPanelsLayer, pTethersLayer, pSelectedTetherHash)
	{
		if (!pPanelsLayer || !pTethersLayer) return;
		if (!this._FlowView) return;

		let tmpOpenPanels = Array.isArray(pOpenPanels) ? pOpenPanels : [];

		// --- Reconcile panels layer (add new, remove closed, update positions) ---
		let tmpExistingPanelHashes = new Set();
		let tmpExistingForeignObjects = pPanelsLayer.querySelectorAll('.pict-flow-panel-foreign-object');
		for (let i = 0; i < tmpExistingForeignObjects.length; i++)
		{
			tmpExistingPanelHashes.add(tmpExistingForeignObjects[i].getAttribute('data-panel-hash'));
		}

		let tmpDesiredPanelHashes = new Set();
		for (let i = 0; i < tmpOpenPanels.length; i++)
		{
			tmpDesiredPanelHashes.add(tmpOpenPanels[i].Hash);
		}

		// Remove panels that are no longer open
		for (let i = 0; i < tmpExistingForeignObjects.length; i++)
		{
			let tmpHash = tmpExistingForeignObjects[i].getAttribute('data-panel-hash');
			if (!tmpDesiredPanelHashes.has(tmpHash))
			{
				tmpExistingForeignObjects[i].remove();
				// Destroy cached instance
				if (this._PanelInstances[tmpHash])
				{
					this._PanelInstances[tmpHash].destroy();
					delete this._PanelInstances[tmpHash];
				}
			}
		}

		// Add or update panels
		for (let i = 0; i < tmpOpenPanels.length; i++)
		{
			let tmpPanelData = tmpOpenPanels[i];

			if (tmpExistingPanelHashes.has(tmpPanelData.Hash))
			{
				// Update position of existing panel
				let tmpFO = pPanelsLayer.querySelector(`[data-panel-hash="${tmpPanelData.Hash}"]`);
				if (tmpFO)
				{
					tmpFO.setAttribute('x', String(tmpPanelData.X));
					tmpFO.setAttribute('y', String(tmpPanelData.Y));
					tmpFO.setAttribute('width', String(tmpPanelData.Width));
					tmpFO.setAttribute('height', String(tmpPanelData.Height));
				}
			}
			else
			{
				// Create new panel
				this._createPanelForeignObject(tmpPanelData, pPanelsLayer);
			}
		}

		// --- Clear and rebuild tethers ---
		while (pTethersLayer.firstChild)
		{
			pTethersLayer.removeChild(pTethersLayer.firstChild);
		}

		for (let i = 0; i < tmpOpenPanels.length; i++)
		{
			let tmpIsSelected = (pSelectedTetherHash === tmpOpenPanels[i].Hash);
			this._renderTether(tmpOpenPanels[i], pTethersLayer, tmpIsSelected);
		}
	}

	/**
	 * Create a foreignObject containing the panel chrome and content.
	 * Delegates to the PanelChrome provider for template-based chrome creation,
	 * then renders panel content into the body container.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels
	 * @param {SVGGElement} pPanelsLayer
	 */
	_createPanelForeignObject(pPanelData, pPanelsLayer)
	{
		let tmpPanelChromeProvider = this._FlowView._PanelChromeProvider;
		if (!tmpPanelChromeProvider) return;

		let tmpBody = tmpPanelChromeProvider.createPanelForeignObject(pPanelData, pPanelsLayer);

		// Render the panel content into the Properties tab pane
		if (tmpBody)
		{
			this._renderPanelContent(pPanelData, tmpBody);
		}

		let tmpFO = pPanelsLayer.querySelector(`[data-panel-hash="${pPanelData.Hash}"]`);
		if (tmpFO)
		{
			// Render appearance and help tabs
			this._renderAppearanceTab(pPanelData, tmpFO);
			this._renderHelpTab(pPanelData, tmpFO);

			// Wire up tab switching
			this._wireTabSwitching(tmpFO);
		}
	}

	/**
	 * Instantiate (or reuse) the panel type implementation and render into the body container.
	 *
	 * @param {Object} pPanelData
	 * @param {HTMLDivElement} pBodyContainer
	 */
	_renderPanelContent(pPanelData, pBodyContainer)
	{
		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNodeData.Type);
		if (!tmpNodeTypeConfig) return;

		// If no PropertiesPanel is configured, render the auto-generated info panel
		if (!tmpNodeTypeConfig.PropertiesPanel)
		{
			this._renderInfoPanelContent(pBodyContainer, tmpNodeData, tmpNodeTypeConfig);
			return;
		}

		let tmpPanelConfig = tmpNodeTypeConfig.PropertiesPanel;
		let tmpPanelType = tmpPanelConfig.PanelType || 'Base';

		// Try to get a registered panel type service
		let tmpServiceName = `PictFlowCardPropertiesPanel-${tmpPanelType}`;
		let tmpInstance = null;

		if (this._PanelInstances[pPanelData.Hash])
		{
			// Reuse existing instance
			tmpInstance = this._PanelInstances[pPanelData.Hash];
		}
		else
		{
			// Create a new instance
			if (this.fable.servicesMap.hasOwnProperty(tmpServiceName))
			{
				tmpInstance = this.fable.instantiateServiceProviderWithoutRegistration(tmpServiceName, tmpPanelConfig);
			}
			else if (this.fable.servicesMap.hasOwnProperty('PictFlowCardPropertiesPanel'))
			{
				// Fall back to base class
				tmpInstance = this.fable.instantiateServiceProviderWithoutRegistration('PictFlowCardPropertiesPanel', tmpPanelConfig);
			}

			if (tmpInstance)
			{
				tmpInstance._FlowView = this._FlowView;
				this._PanelInstances[pPanelData.Hash] = tmpInstance;
			}
		}

		if (tmpInstance)
		{
			tmpInstance.render(pBodyContainer, tmpNodeData);
		}

		// After the form renders, append port summary sections showing
		// event inputs, event outputs, and state outputs.
		// SettingsInputs are already visible as form fields above.
		this._renderPortSummary(pBodyContainer, tmpNodeTypeConfig);
	}

	/**
	 * Render an auto-generated info panel for nodes without a configured PropertiesPanel.
	 * Shows the node type, description, and a summary of input/output ports with
	 * their connection constraints.
	 *
	 * Uses configuration-based templates from _DefaultConfiguration.Templates
	 * rendered via pict.parseTemplateByHash().
	 *
	 * @param {HTMLDivElement} pContainer
	 * @param {Object} pNodeData
	 * @param {Object} pNodeTypeConfig
	 */
	_renderInfoPanelContent(pContainer, pNodeData, pNodeTypeConfig)
	{
		let tmpMeta = pNodeTypeConfig.CardMetadata || {};
		let tmpPorts = pNodeTypeConfig.DefaultPorts || [];

		let tmpInputs = tmpPorts.filter((pPort) => pPort.Direction === 'input');
		let tmpOutputs = tmpPorts.filter((pPort) => pPort.Direction === 'output');

		let tmpLabel = pNodeTypeConfig.Label || pNodeData.Type;

		// Build content by rendering configuration-based templates
		let tmpContentParts = [];

		// Header
		let tmpIconProvider = this._FlowView._IconProvider;
		if (tmpMeta.Icon && tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
		{
			// SVG icon markup for the header
			let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
			let tmpIconMarkup = tmpIconProvider.getIconSVGMarkup(tmpResolvedKey, 18);
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header-Icon', { Icon: tmpIconMarkup, Label: tmpLabel }));
		}
		else if (tmpMeta.Icon)
		{
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header-Icon', { Icon: tmpMeta.Icon, Label: tmpLabel }));
		}
		else if (tmpIconProvider)
		{
			// No icon specified — render default fallback
			let tmpDefaultMarkup = tmpIconProvider.getIconSVGMarkup('default', 18);
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header-Icon', { Icon: tmpDefaultMarkup, Label: tmpLabel }));
		}
		else
		{
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Header', { Label: tmpLabel }));
		}

		// Description
		if (tmpMeta.Description)
		{
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Description', { Description: tmpMeta.Description }));
		}

		// Category + Code badges
		if (tmpMeta.Category || tmpMeta.Code)
		{
			let tmpBadgesContent = '';
			if (tmpMeta.Category)
			{
				tmpBadgesContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Badge-Category', { Category: tmpMeta.Category });
			}
			if (tmpMeta.Code)
			{
				tmpBadgesContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Badge-Code', { Code: tmpMeta.Code });
			}
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Badges', { BadgesContent: tmpBadgesContent }));
		}

		// Inputs
		if (tmpInputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpInputs.length; i++)
			{
				let tmpPort = tmpInputs[i];
				let tmpConstraint = this._getPortConstraintHTML(tmpPort);
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Input', { Label: tmpPort.Label || 'In', Constraint: tmpConstraint });
			}
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Inputs', { PortsContent: tmpPortsContent }));
		}

		// Outputs
		if (tmpOutputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpOutputs.length; i++)
			{
				let tmpPort = tmpOutputs[i];
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Output', { Label: tmpPort.Label || 'Out' });
			}
			tmpContentParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Outputs', { PortsContent: tmpPortsContent }));
		}

		pContainer.innerHTML = this.pict.parseTemplateByHash('Flow-InfoPanel-Wrapper', { PanelContent: tmpContentParts.join('') });
	}

	/**
	 * Render port summary sections below the form panel content.
	 * Shows event inputs, event outputs, and state outputs — the ports
	 * that the form does not cover (since the form only shows SettingsInputs).
	 *
	 * @param {HTMLDivElement} pContainer
	 * @param {Object} pNodeTypeConfig
	 */
	_renderPortSummary(pContainer, pNodeTypeConfig)
	{
		let tmpPorts = pNodeTypeConfig.DefaultPorts || [];
		if (tmpPorts.length === 0) return;

		// Categorize ports by type (settings are already shown as form fields)
		let tmpEventInputs = [];
		let tmpEventOutputs = [];
		let tmpStateOutputs = [];

		for (let i = 0; i < tmpPorts.length; i++)
		{
			let tmpPort = tmpPorts[i];
			let tmpPortType = tmpPort.PortType || '';

			if (tmpPortType === 'event-in')
			{
				tmpEventInputs.push(tmpPort);
			}
			else if (tmpPortType === 'event-out' || tmpPortType === 'error')
			{
				tmpEventOutputs.push(tmpPort);
			}
			else if (tmpPortType === 'value')
			{
				tmpStateOutputs.push(tmpPort);
			}
		}

		// Only render if there are non-settings ports to show
		if (tmpEventInputs.length === 0 && tmpEventOutputs.length === 0 && tmpStateOutputs.length === 0)
		{
			return;
		}

		let tmpSummaryParts = [];

		// Event Inputs
		if (tmpEventInputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpEventInputs.length; i++)
			{
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Event', { Label: tmpEventInputs[i].Label || tmpEventInputs[i].Name || 'Event In' });
			}
			tmpSummaryParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Generic', { SectionTitle: 'Event Inputs', PortsContent: tmpPortsContent }));
		}

		// Event Outputs
		if (tmpEventOutputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpEventOutputs.length; i++)
			{
				let tmpPort = tmpEventOutputs[i];
				let tmpLabel = tmpPort.Label || tmpPort.Name || 'Event Out';
				if (tmpPort.PortType === 'error')
				{
					tmpLabel += ' ⚠';
				}
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Event', { Label: tmpLabel });
			}
			tmpSummaryParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Generic', { SectionTitle: 'Event Outputs', PortsContent: tmpPortsContent }));
		}

		// State Outputs
		if (tmpStateOutputs.length > 0)
		{
			let tmpPortsContent = '';
			for (let i = 0; i < tmpStateOutputs.length; i++)
			{
				let tmpPort = tmpStateOutputs[i];
				let tmpLabel = tmpPort.Label || tmpPort.Name || 'Output';
				let tmpDataType = '';
				if (tmpPort.DataType)
				{
					tmpDataType = this.pict.parseTemplateByHash('Flow-InfoPanel-Port-DataType', { DataTypeText: tmpPort.DataType });
				}
				tmpPortsContent += this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Value', { Label: tmpLabel, DataType: tmpDataType });
			}
			tmpSummaryParts.push(this.pict.parseTemplateByHash('Flow-InfoPanel-Section-Generic', { SectionTitle: 'State Outputs', PortsContent: tmpPortsContent }));
		}

		if (tmpSummaryParts.length > 0)
		{
			// Create a wrapper div for the port summary and append it to the container
			let tmpSummaryDiv = document.createElement('div');
			tmpSummaryDiv.className = 'pict-flow-info-panel pict-flow-port-summary';
			tmpSummaryDiv.innerHTML = tmpSummaryParts.join('');
			pContainer.appendChild(tmpSummaryDiv);
		}
	}

	/**
	 * Build the constraint markup for a port using configuration templates.
	 *
	 * @param {Object} pPort
	 * @returns {string} Rendered constraint HTML or empty string
	 */
	_getPortConstraintHTML(pPort)
	{
		let tmpMin = (typeof pPort.MinimumInputCount === 'number') ? pPort.MinimumInputCount : 0;
		let tmpMax = (typeof pPort.MaximumInputCount === 'number') ? pPort.MaximumInputCount : -1;

		if (tmpMin > 0 || tmpMax > 0)
		{
			let tmpConstraintText = '';
			if (tmpMax < 0)
			{
				tmpConstraintText = `(min ${tmpMin})`;
			}
			else if (tmpMin === tmpMax)
			{
				tmpConstraintText = `(exactly ${tmpMin})`;
			}
			else
			{
				tmpConstraintText = `(${tmpMin}\u2013${tmpMax})`;
			}
			return this.pict.parseTemplateByHash('Flow-InfoPanel-Port-Constraint', { ConstraintText: tmpConstraintText });
		}
		return '';
	}

	/**
	 * Render the Appearance tab content with node property editor fields.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels
	 * @param {Element} pForeignObject - The panel's SVG foreignObject element
	 */
	_renderAppearanceTab(pPanelData, pForeignObject)
	{
		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpAppearancePane = pForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="appearance"]');
		if (!tmpAppearancePane) return;

		// Build the template record with safe defaults for Style values
		let tmpStyle = tmpNodeData.Style || {};

		// Resolve default colors from the node type config or CSS token defaults
		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNodeData.Type);
		let tmpDefaultTitleBarColor = '#2c3e50';
		let tmpDefaultBodyFill = '#ffffff';
		let tmpDefaultBodyStroke = '#d0d4d8';
		if (tmpNodeTypeConfig)
		{
			if (tmpNodeTypeConfig.TitleBarColor) tmpDefaultTitleBarColor = tmpNodeTypeConfig.TitleBarColor;
			if (tmpNodeTypeConfig.BodyStyle)
			{
				if (tmpNodeTypeConfig.BodyStyle.fill) tmpDefaultBodyFill = tmpNodeTypeConfig.BodyStyle.fill;
				if (tmpNodeTypeConfig.BodyStyle.stroke) tmpDefaultBodyStroke = tmpNodeTypeConfig.BodyStyle.stroke;
			}
		}

		let tmpRecord =
		{
			Title: tmpNodeData.Title || '',
			Width: tmpNodeData.Width || 180,
			Height: tmpNodeData.Height || 80,
			BodyFillValue: tmpStyle.BodyFill || tmpDefaultBodyFill,
			BodyStrokeValue: tmpStyle.BodyStroke || tmpDefaultBodyStroke,
			BodyStrokeWidthValue: tmpStyle.BodyStrokeWidth || 1,
			TitleBarColorValue: tmpStyle.TitleBarColor || tmpDefaultTitleBarColor
		};

		tmpAppearancePane.innerHTML = this.pict.parseTemplateByHash('Flow-NodeProps-Editor', tmpRecord);

		// Wire up live change handlers on all input fields
		let tmpInputs = tmpAppearancePane.querySelectorAll('.pict-flow-node-props-input');
		for (let i = 0; i < tmpInputs.length; i++)
		{
			let tmpInput = tmpInputs[i];
			let tmpProp = tmpInput.getAttribute('data-prop');

			tmpInput.addEventListener('input', (pEvent) =>
			{
				pEvent.stopPropagation();
				this._applyNodePropChange(pPanelData.NodeHash, tmpProp, tmpInput.value, tmpInput.type);
			});

			// Prevent pointer events from propagating to SVG drag handler
			tmpInput.addEventListener('pointerdown', (pEvent) => { pEvent.stopPropagation(); });
		}
	}

	/**
	 * Render the Help tab content if help text is defined on the node type.
	 * Shows the Help tab button only when help content is available.
	 *
	 * @param {Object} pPanelData - Panel data from OpenPanels
	 * @param {Element} pForeignObject - The panel's SVG foreignObject element
	 */
	_renderHelpTab(pPanelData, pForeignObject)
	{
		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpNodeTypeConfig = this._FlowView._NodeTypeProvider.getNodeType(tmpNodeData.Type);
		if (!tmpNodeTypeConfig) return;

		let tmpHelpText = (tmpNodeTypeConfig.CardMetadata && tmpNodeTypeConfig.CardMetadata.Help)
			? tmpNodeTypeConfig.CardMetadata.Help
			: null;

		if (!tmpHelpText) return;

		// Show the Help tab button
		let tmpHelpTabButton = pForeignObject.querySelector('.pict-flow-panel-tab[data-tab-target="help"]');
		if (tmpHelpTabButton)
		{
			tmpHelpTabButton.style.display = '';
		}

		// Render help content into the help pane
		let tmpHelpPane = pForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="help"]');
		if (tmpHelpPane)
		{
			tmpHelpPane.innerHTML = '<div class="pict-flow-panel-help-content">' + tmpHelpText + '</div>';
		}
	}

	/**
	 * Wire up tab switching on all tab buttons within a panel foreignObject.
	 *
	 * @param {Element} pForeignObject - The panel's SVG foreignObject element
	 */
	_wireTabSwitching(pForeignObject)
	{
		let tmpTabs = pForeignObject.querySelectorAll('.pict-flow-panel-tab');
		let tmpPanes = pForeignObject.querySelectorAll('.pict-flow-panel-tab-pane');

		for (let i = 0; i < tmpTabs.length; i++)
		{
			tmpTabs[i].addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpTarget = pEvent.currentTarget.getAttribute('data-tab-target');

				// Deactivate all tabs and panes
				for (let j = 0; j < tmpTabs.length; j++)
				{
					tmpTabs[j].classList.remove('active');
				}
				for (let j = 0; j < tmpPanes.length; j++)
				{
					tmpPanes[j].classList.remove('active');
					tmpPanes[j].style.display = 'none';
				}

				// Activate the selected tab and pane
				pEvent.currentTarget.classList.add('active');
				let tmpTargetPane = pForeignObject.querySelector('.pict-flow-panel-tab-pane[data-tab="' + tmpTarget + '"]');
				if (tmpTargetPane)
				{
					tmpTargetPane.classList.add('active');
					tmpTargetPane.style.display = 'block';
				}
			});
		}
	}

	/**
	 * Apply a node property change from the properties editor and re-render.
	 *
	 * @param {string} pNodeHash - Hash of the node to update
	 * @param {string} pPropPath - Property path (e.g. 'Title', 'Width', 'Style.BodyFill')
	 * @param {string} pValue - The new value from the input
	 * @param {string} pInputType - The input element type ('text', 'number', 'color')
	 */
	_applyNodePropChange(pNodeHash, pPropPath, pValue, pInputType)
	{
		let tmpNodeData = this._FlowView.getNode(pNodeHash);
		if (!tmpNodeData) return;

		// Parse numeric values
		let tmpValue = pValue;
		if (pInputType === 'number')
		{
			tmpValue = parseFloat(pValue);
			if (isNaN(tmpValue)) return;
		}

		// Apply the value based on the property path
		if (pPropPath === 'Title')
		{
			tmpNodeData.Title = tmpValue;
		}
		else if (pPropPath === 'Width')
		{
			tmpNodeData.Width = tmpValue;
		}
		else if (pPropPath === 'Height')
		{
			tmpNodeData.Height = tmpValue;
		}
		else if (pPropPath.startsWith('Style.'))
		{
			if (!tmpNodeData.Style) tmpNodeData.Style = {};
			let tmpStyleKey = pPropPath.substring(6); // Remove 'Style.' prefix
			tmpNodeData.Style[tmpStyleKey] = tmpValue;
		}

		// Re-render the flow to reflect changes
		this._FlowView.renderFlow();
		this._FlowView.marshalFromView();

		// Fire change event
		if (this._FlowView._EventHandlerProvider)
		{
			this._FlowView._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowView._FlowData);
		}
	}

	/**
	 * Render a tether from a panel to its node.
	 * Delegates to the TetherService for geometry, path generation, and SVG element creation.
	 *
	 * @param {Object} pPanelData
	 * @param {SVGGElement} pTethersLayer
	 * @param {boolean} pIsSelected
	 */
	_renderTether(pPanelData, pTethersLayer, pIsSelected)
	{
		let tmpTetherService = this._FlowView._TetherService;
		if (!tmpTetherService) return;

		let tmpNodeData = this._FlowView.getNode(pPanelData.NodeHash);
		if (!tmpNodeData) return;

		let tmpViewIdentifier = this._FlowView.options.ViewIdentifier;
		tmpTetherService.renderTether(pPanelData, tmpNodeData, pTethersLayer, pIsSelected, tmpViewIdentifier);
	}

	/**
	 * Marshal data from all open panels back into their node Data objects.
	 */
	marshalAllFromPanels()
	{
		for (let tmpPanelHash in this._PanelInstances)
		{
			let tmpInstance = this._PanelInstances[tmpPanelHash];
			if (tmpInstance && tmpInstance._NodeData)
			{
				tmpInstance.marshalFromPanel(tmpInstance._NodeData);
			}
		}
	}

	/**
	 * Destroy a specific panel instance and clean up.
	 *
	 * @param {string} pPanelHash
	 */
	destroyPanel(pPanelHash)
	{
		if (this._PanelInstances[pPanelHash])
		{
			this._PanelInstances[pPanelHash].destroy();
			delete this._PanelInstances[pPanelHash];
		}
	}

	/**
	 * Destroy all panel instances.
	 */
	destroyAllPanels()
	{
		for (let tmpPanelHash in this._PanelInstances)
		{
			this._PanelInstances[tmpPanelHash].destroy();
		}
		this._PanelInstances = {};
	}
}

module.exports = PictViewFlowPropertiesPanel;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":239}],61:[function(require,module,exports){
const libPictView = require('pict-view');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Flow-Toolbar',

	DefaultRenderable: 'Flow-Toolbar-Content',
	DefaultDestinationAddress: '#Flow-Toolbar-Container',

	AutoRender: false,

	FlowViewIdentifier: 'Pict-Flow',

	EnablePalette: true,
	EnableAddNode: true,
	EnableCardPalette: true,

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-Toolbar-Template',
			Template: /*html*/`
<div class="pict-flow-toolbar" id="Flow-Toolbar-Bar-{~D:Record.FlowViewIdentifier~}">
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="add-node" id="Flow-Toolbar-AddNode-{~D:Record.FlowViewIdentifier~}" title="Add Node">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-plus-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Node</span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="cards-popup" id="Flow-Toolbar-Cards-{~D:Record.FlowViewIdentifier~}" title="Card Palette">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-cards-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Cards</span>
			<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-CardsChevron-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="delete-selected" title="Delete Node">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-trash-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="layout-popup" id="Flow-Toolbar-Layout-{~D:Record.FlowViewIdentifier~}" title="Manage Layouts">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-layout-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Layout</span>
			<span class="pict-flow-toolbar-btn-chevron" id="Flow-Toolbar-LayoutChevron-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="auto-layout" title="Auto Layout">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-auto-layout-{~D:Record.FlowViewIdentifier~}"></span>
			<span class="pict-flow-toolbar-btn-text">Auto Layout</span>
		</button>
	</div>
	<div class="pict-flow-toolbar-group">
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-in" title="Zoom In">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-in-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-out" title="Zoom Out">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-out-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="zoom-fit" title="Fit to View">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-zoom-fit-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
	<div class="pict-flow-toolbar-group pict-flow-toolbar-right">
		<button class="pict-flow-toolbar-btn" data-flow-action="settings-popup" id="Flow-Toolbar-Settings-{~D:Record.FlowViewIdentifier~}" title="Theme Settings">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-settings-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="fullscreen" id="Flow-Toolbar-Fullscreen-{~D:Record.FlowViewIdentifier~}" title="Toggle Fullscreen">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Fullscreen-Icon-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="toggle-floating" title="Float">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-grip-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
		<button class="pict-flow-toolbar-btn" data-flow-action="collapse-toolbar" title="Collapse Toolbar">
			<span class="pict-flow-toolbar-btn-icon" id="Flow-Toolbar-Icon-collapse-{~D:Record.FlowViewIdentifier~}"></span>
		</button>
	</div>
</div>
<div class="pict-flow-toolbar-collapsed" id="Flow-Toolbar-Collapsed-{~D:Record.FlowViewIdentifier~}">
	<button class="pict-flow-toolbar-expand-btn" data-flow-action="expand-toolbar" title="Expand Toolbar" id="Flow-Toolbar-ExpandBtn-{~D:Record.FlowViewIdentifier~}">
		<span id="Flow-Toolbar-Icon-expand-{~D:Record.FlowViewIdentifier~}"></span>
	</button>
</div>
<div class="pict-flow-toolbar-popup-anchor" id="Flow-Toolbar-PopupAnchor-{~D:Record.FlowViewIdentifier~}">
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-Toolbar-Content',
			TemplateHash: 'Flow-Toolbar-Template',
			DestinationAddress: '#Flow-Toolbar-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlowToolbar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictViewFlowToolbar';

		this._FlowView = null;

		// Toolbar mode state
		this._ToolbarMode = 'docked'; // 'docked' | 'floating' | 'collapsed'
		this._ActivePopup = null;     // 'add-node' | 'cards' | 'layout' | null
		this._FloatingPosition = { X: 80, Y: 80 };
		this._DocumentClickHandler = null;
		this._FloatingToolbarView = null;
	}

	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		// Pass this.options as the template record so {~D:Record.FlowViewIdentifier~}
		// resolves correctly in the toolbar template.
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Bind toolbar button events via event delegation
		let tmpToolbarBar = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Bar-${tmpFlowViewIdentifier}`);
		if (tmpToolbarBar.length > 0)
		{
			tmpToolbarBar[0].addEventListener('click', (pEvent) =>
			{
				let tmpTarget = pEvent.target;
				if (!tmpTarget) return;

				// Walk up to find the button with the action
				let tmpButton = tmpTarget.closest('[data-flow-action]');
				if (!tmpButton) return;

				let tmpAction = tmpButton.getAttribute('data-flow-action');
				this._handleToolbarAction(tmpAction);
			});
		}

		// Bind expand button click (it's outside the main toolbar bar)
		let tmpExpandBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-ExpandBtn-${tmpFlowViewIdentifier}`);
		if (tmpExpandBtn.length > 0)
		{
			tmpExpandBtn[0].addEventListener('click', () =>
			{
				this._setToolbarMode('docked');
			});
		}

		// Populate SVG icons for toolbar buttons
		this._populateToolbarIcons();

		// Remove buttons from DOM based on options
		if (this.options.EnableAddNode === false)
		{
			let tmpAddNodeBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-AddNode-${tmpFlowViewIdentifier}`);
			if (tmpAddNodeBtn.length > 0)
			{
				tmpAddNodeBtn[0].remove();
			}
		}
		if (this.options.EnableCardPalette === false)
		{
			let tmpCardsBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Cards-${tmpFlowViewIdentifier}`);
			if (tmpCardsBtn.length > 0)
			{
				tmpCardsBtn[0].remove();
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	// ── Icon Population ───────────────────────────────────────────────────

	/**
	 * Populate SVG icons for all toolbar buttons.
	 */
	_populateToolbarIcons()
	{
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (!tmpIconProvider) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Map of element ID suffix → icon key
		let tmpIconMap =
		{
			'plus': 'plus',
			'trash': 'trash',
			'zoom-in': 'zoom-in',
			'zoom-out': 'zoom-out',
			'zoom-fit': 'zoom-fit',
			'auto-layout': 'auto-layout',
			'cards': 'cards',
			'layout': 'layout',
			'settings': 'settings',
			'grip': 'grip',
			'collapse': 'collapse',
			'expand': 'expand'
		};

		let tmpKeys = Object.keys(tmpIconMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpElementId = `Flow-Toolbar-Icon-${tmpKeys[i]}-${tmpFlowViewIdentifier}`;
			let tmpElements = this.pict.ContentAssignment.getElement(`#${tmpElementId}`);
			if (tmpElements.length > 0)
			{
				tmpElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(tmpIconMap[tmpKeys[i]], 14);
			}
		}

		// Fullscreen icon
		let tmpFullscreenIcon = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-Icon-${tmpFlowViewIdentifier}`);
		if (tmpFullscreenIcon.length > 0)
		{
			tmpFullscreenIcon[0].innerHTML = tmpIconProvider.getIconSVGMarkup('fullscreen', 14);
		}

		// Chevrons (smaller)
		let tmpCardsChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-CardsChevron-${tmpFlowViewIdentifier}`);
		if (tmpCardsChevron.length > 0)
		{
			tmpCardsChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}

		let tmpLayoutChevron = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-LayoutChevron-${tmpFlowViewIdentifier}`);
		if (tmpLayoutChevron.length > 0)
		{
			tmpLayoutChevron[0].innerHTML = tmpIconProvider.getIconSVGMarkup('chevron-down', 8);
		}
	}

	// ── Popup Management ──────────────────────────────────────────────────

	/**
	 * Open a popup below a trigger button.
	 * @param {string} pType - 'add-node' | 'cards' | 'layout'
	 */
	_openPopup(pType)
	{
		// Toggle off if already open
		if (this._ActivePopup === pType)
		{
			this._closePopup();
			return;
		}

		// Close any existing popup first
		this._closePopup();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpAnchor = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-PopupAnchor-${tmpFlowViewIdentifier}`);
		if (tmpAnchor.length < 1) return;

		// Create popup div
		let tmpPopup = document.createElement('div');
		tmpPopup.className = 'pict-flow-toolbar-popup';
		tmpPopup.setAttribute('id', `Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);

		// Build popup content
		switch (pType)
		{
			case 'add-node':
				this._buildAddNodePopup(tmpPopup);
				break;
			case 'cards':
				this._buildCardsPopup(tmpPopup);
				break;
			case 'layout':
				this._buildLayoutPopup(tmpPopup);
				break;
			case 'settings':
				this._buildSettingsPopup(tmpPopup);
				break;
		}

		tmpAnchor[0].appendChild(tmpPopup);
		this._ActivePopup = pType;

		// Position the popup below the trigger button
		this._positionPopup(tmpPopup, pType);

		// Click-outside-to-close handler (delayed to avoid catching the opening click)
		setTimeout(() =>
		{
			this._DocumentClickHandler = (pEvent) =>
			{
				if (!tmpPopup.contains(pEvent.target))
				{
					// Check if click was on the trigger button itself (toggle behavior)
					let tmpButton = pEvent.target.closest('[data-flow-action]');
					if (tmpButton)
					{
						let tmpAction = tmpButton.getAttribute('data-flow-action');
						if (tmpAction === pType || tmpAction === pType.replace('-popup', '') + '-popup')
						{
							return; // Let the toggle handle it
						}
					}
					this._closePopup();
				}
			};
			document.addEventListener('click', this._DocumentClickHandler, true);
		}, 0);

		// Focus search input if Add Node popup
		if (pType === 'add-node')
		{
			let tmpSearch = tmpPopup.querySelector('.pict-flow-popup-search');
			if (tmpSearch)
			{
				setTimeout(() => { tmpSearch.focus(); }, 50);
			}
		}
	}

	/**
	 * Close the active popup and clean up.
	 */
	_closePopup()
	{
		if (this._DocumentClickHandler)
		{
			document.removeEventListener('click', this._DocumentClickHandler, true);
			this._DocumentClickHandler = null;
		}

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpPopup = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Popup-${tmpFlowViewIdentifier}`);
		if (tmpPopup.length > 0)
		{
			tmpPopup[0].parentNode.removeChild(tmpPopup[0]);
		}

		this._ActivePopup = null;
	}

	/**
	 * Position a popup below its trigger button.
	 * @param {HTMLElement} pPopupDiv
	 * @param {string} pType
	 */
	_positionPopup(pPopupDiv, pType)
	{
		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		// Determine which button triggered the popup
		let tmpTriggerSelector;
		switch (pType)
		{
			case 'add-node':
				tmpTriggerSelector = `#Flow-Toolbar-AddNode-${tmpFlowViewIdentifier}`;
				break;
			case 'cards':
				tmpTriggerSelector = `#Flow-Toolbar-Cards-${tmpFlowViewIdentifier}`;
				break;
			case 'layout':
				tmpTriggerSelector = `#Flow-Toolbar-Layout-${tmpFlowViewIdentifier}`;
				break;
			case 'settings':
				tmpTriggerSelector = `#Flow-Toolbar-Settings-${tmpFlowViewIdentifier}`;
				break;
			default:
				return;
		}

		let tmpTriggerElements = this.pict.ContentAssignment.getElement(tmpTriggerSelector);
		if (tmpTriggerElements.length < 1) return;

		let tmpAnchor = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-PopupAnchor-${tmpFlowViewIdentifier}`);
		if (tmpAnchor.length < 1) return;

		let tmpTriggerRect = tmpTriggerElements[0].getBoundingClientRect();
		let tmpAnchorRect = tmpAnchor[0].getBoundingClientRect();

		let tmpLeft = tmpTriggerRect.left - tmpAnchorRect.left;
		pPopupDiv.style.left = tmpLeft + 'px';
		pPopupDiv.style.top = '0px';
	}

	// ── Add Node Popup ────────────────────────────────────────────────────

	/**
	 * Build the searchable Add Node popup content.
	 * @param {HTMLElement} pContainer
	 */
	_buildAddNodePopup(pContainer)
	{
		// Search wrapper
		let tmpSearchWrapper = document.createElement('div');
		tmpSearchWrapper.className = 'pict-flow-popup-search-wrapper';

		let tmpSearchIcon = document.createElement('span');
		tmpSearchIcon.className = 'pict-flow-popup-search-icon';
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (tmpIconProvider)
		{
			tmpSearchIcon.innerHTML = tmpIconProvider.getIconSVGMarkup('search', 12);
		}
		tmpSearchWrapper.appendChild(tmpSearchIcon);

		let tmpSearchInput = document.createElement('input');
		tmpSearchInput.className = 'pict-flow-popup-search';
		tmpSearchInput.setAttribute('type', 'text');
		tmpSearchInput.setAttribute('placeholder', 'Search node types...');
		tmpSearchWrapper.appendChild(tmpSearchInput);
		pContainer.appendChild(tmpSearchWrapper);

		// Node list
		let tmpListDiv = document.createElement('div');
		tmpListDiv.className = 'pict-flow-popup-node-list';
		pContainer.appendChild(tmpListDiv);

		// Initial population
		this._populateNodeList(tmpListDiv, '');

		// Filter on input
		tmpSearchInput.addEventListener('input', () =>
		{
			this._populateNodeList(tmpListDiv, tmpSearchInput.value);
		});
	}

	/**
	 * Populate the node list in the Add Node popup, filtered by search text.
	 * @param {HTMLElement} pListDiv
	 * @param {string} pFilter
	 */
	_populateNodeList(pListDiv, pFilter)
	{
		if (!this._FlowView || !this._FlowView._NodeTypeProvider) return;

		// Clear
		while (pListDiv.firstChild)
		{
			pListDiv.removeChild(pListDiv.firstChild);
		}

		let tmpTypes = this._FlowView._NodeTypeProvider.getNodeTypes();
		let tmpTypeKeys = Object.keys(tmpTypes);
		let tmpFilter = (pFilter || '').toLowerCase().trim();
		let tmpIconProvider = this._FlowView._IconProvider;
		let tmpMatchCount = 0;

		for (let i = 0; i < tmpTypeKeys.length; i++)
		{
			let tmpTypeConfig = tmpTypes[tmpTypeKeys[i]];
			let tmpMeta = tmpTypeConfig.CardMetadata || {};

			// Skip disabled cards
			if (tmpMeta.Enabled === false) continue;

			// Filter match: label, code, or category
			if (tmpFilter)
			{
				let tmpLabel = (tmpTypeConfig.Label || '').toLowerCase();
				let tmpCode = (tmpMeta.Code || '').toLowerCase();
				let tmpCategory = (tmpMeta.Category || '').toLowerCase();
				if (tmpLabel.indexOf(tmpFilter) < 0 &&
					tmpCode.indexOf(tmpFilter) < 0 &&
					tmpCategory.indexOf(tmpFilter) < 0)
				{
					continue;
				}
			}

			tmpMatchCount++;

			let tmpRow = document.createElement('div');
			tmpRow.className = 'pict-flow-popup-list-item';
			tmpRow.setAttribute('data-node-type', tmpTypeKeys[i]);

			// Icon
			let tmpIconSpan = document.createElement('span');
			tmpIconSpan.className = 'pict-flow-popup-list-item-icon';
			if (tmpIconProvider)
			{
				let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
				tmpIconSpan.innerHTML = tmpIconProvider.getIconSVGMarkup(tmpResolvedKey, 16);
			}
			tmpRow.appendChild(tmpIconSpan);

			// Label
			let tmpLabelSpan = document.createElement('span');
			tmpLabelSpan.className = 'pict-flow-popup-list-item-label';
			tmpLabelSpan.textContent = tmpTypeConfig.Label;
			tmpRow.appendChild(tmpLabelSpan);

			// Code badge
			if (tmpMeta.Code)
			{
				let tmpCodeSpan = document.createElement('span');
				tmpCodeSpan.className = 'pict-flow-popup-list-item-code';
				tmpCodeSpan.textContent = tmpMeta.Code;
				tmpRow.appendChild(tmpCodeSpan);
			}

			// Click handler
			tmpRow.addEventListener('click', () =>
			{
				this._addNodeAtCenter(tmpTypeKeys[i]);
				this._closePopup();
			});

			pListDiv.appendChild(tmpRow);
		}

		if (tmpMatchCount === 0)
		{
			let tmpEmpty = document.createElement('div');
			tmpEmpty.className = 'pict-flow-popup-list-empty';
			tmpEmpty.textContent = 'No matching node types';
			pListDiv.appendChild(tmpEmpty);
		}
	}

	// ── Cards Popup ───────────────────────────────────────────────────────

	/**
	 * Build the Cards popup content with search and categorized palette.
	 * @param {HTMLElement} pContainer
	 */
	_buildCardsPopup(pContainer)
	{
		// Search wrapper
		let tmpSearchWrapper = document.createElement('div');
		tmpSearchWrapper.className = 'pict-flow-popup-search-wrapper';

		let tmpSearchIcon = document.createElement('span');
		tmpSearchIcon.className = 'pict-flow-popup-search-icon';
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;
		if (tmpIconProvider)
		{
			tmpSearchIcon.innerHTML = tmpIconProvider.getIconSVGMarkup('search', 12);
		}
		tmpSearchWrapper.appendChild(tmpSearchIcon);

		let tmpSearchInput = document.createElement('input');
		tmpSearchInput.className = 'pict-flow-popup-search';
		tmpSearchInput.setAttribute('type', 'text');
		tmpSearchInput.setAttribute('placeholder', 'Search cards...');
		tmpSearchWrapper.appendChild(tmpSearchInput);
		pContainer.appendChild(tmpSearchWrapper);

		// Palette list container
		let tmpListDiv = document.createElement('div');
		tmpListDiv.className = 'pict-flow-popup-node-list';
		pContainer.appendChild(tmpListDiv);

		// Initial population
		this._renderPalette(tmpListDiv, '');

		// Filter on input
		tmpSearchInput.addEventListener('input', () =>
		{
			this._renderPalette(tmpListDiv, tmpSearchInput.value);
		});

		// Focus search input
		setTimeout(() => { tmpSearchInput.focus(); }, 50);
	}

	/**
	 * Render the card palette with categories and card chips into a container.
	 * @param {HTMLElement} pContainer - The target container element
	 * @param {string} [pFilter] - Optional search filter text
	 */
	_renderPalette(pContainer, pFilter)
	{
		if (!this._FlowView || !this._FlowView._NodeTypeProvider) return;

		// Clear existing content
		while (pContainer.firstChild)
		{
			pContainer.removeChild(pContainer.firstChild);
		}

		let tmpCategories = this._FlowView._NodeTypeProvider.getCardsByCategory();
		let tmpCategoryKeys = Object.keys(tmpCategories);
		let tmpFilter = (pFilter || '').toLowerCase().trim();
		let tmpTotalMatchCount = 0;

		for (let i = 0; i < tmpCategoryKeys.length; i++)
		{
			let tmpCategoryName = tmpCategoryKeys[i];
			let tmpCards = tmpCategories[tmpCategoryName];
			let tmpMatchingCards = [];

			// Filter cards within this category
			for (let j = 0; j < tmpCards.length; j++)
			{
				let tmpCardConfig = tmpCards[j];
				let tmpMeta = tmpCardConfig.CardMetadata || {};

				if (tmpFilter)
				{
					let tmpLabel = (tmpCardConfig.Label || '').toLowerCase();
					let tmpCode = (tmpMeta.Code || '').toLowerCase();
					let tmpCategory = tmpCategoryName.toLowerCase();
					if (tmpLabel.indexOf(tmpFilter) < 0 &&
						tmpCode.indexOf(tmpFilter) < 0 &&
						tmpCategory.indexOf(tmpFilter) < 0)
					{
						continue;
					}
				}

				tmpMatchingCards.push(tmpCardConfig);
			}

			if (tmpMatchingCards.length === 0) continue;

			tmpTotalMatchCount += tmpMatchingCards.length;

			let tmpCategoryDiv = document.createElement('div');
			tmpCategoryDiv.className = 'pict-flow-palette-category';
			tmpCategoryDiv.style.padding = '0.35em 0.5em';

			let tmpCategoryLabel = document.createElement('div');
			tmpCategoryLabel.className = 'pict-flow-palette-category-label';
			tmpCategoryLabel.textContent = tmpCategoryName;
			tmpCategoryDiv.appendChild(tmpCategoryLabel);

			let tmpCardsDiv = document.createElement('div');
			tmpCardsDiv.className = 'pict-flow-palette-cards';

			for (let j = 0; j < tmpMatchingCards.length; j++)
			{
				let tmpCardConfig = tmpMatchingCards[j];
				let tmpMeta = tmpCardConfig.CardMetadata || {};

				let tmpCardEl = document.createElement('div');
				tmpCardEl.className = 'pict-flow-palette-card';
				if (tmpMeta.Enabled === false)
				{
					tmpCardEl.classList.add('disabled');
				}
				tmpCardEl.setAttribute('data-card-type', tmpCardConfig.Hash);

				if (tmpMeta.Tooltip)
				{
					tmpCardEl.setAttribute('title', tmpMeta.Tooltip);
				}
				else if (tmpMeta.Description)
				{
					tmpCardEl.setAttribute('title', tmpMeta.Description);
				}

				// Icon or color swatch
				if (tmpMeta.Icon)
				{
					let tmpIconSpan = document.createElement('span');
					tmpIconSpan.className = 'pict-flow-palette-card-icon';
					let tmpIconProvider = this._FlowView._IconProvider;
					if (tmpIconProvider && !tmpIconProvider.isEmojiIcon(tmpMeta.Icon))
					{
						let tmpResolvedKey = tmpIconProvider.resolveIconKey(tmpMeta);
						tmpIconSpan.innerHTML = tmpIconProvider.getIconSVGMarkup(tmpResolvedKey, 14);
					}
					else
					{
						tmpIconSpan.textContent = tmpMeta.Icon;
					}
					tmpCardEl.appendChild(tmpIconSpan);
				}
				else if (this._FlowView._IconProvider)
				{
					let tmpIconSpan = document.createElement('span');
					tmpIconSpan.className = 'pict-flow-palette-card-icon';
					tmpIconSpan.innerHTML = this._FlowView._IconProvider.getIconSVGMarkup('default', 14);
					tmpCardEl.appendChild(tmpIconSpan);
				}
				else if (tmpCardConfig.TitleBarColor)
				{
					let tmpSwatch = document.createElement('span');
					tmpSwatch.className = 'pict-flow-palette-card-swatch';
					tmpSwatch.style.backgroundColor = tmpCardConfig.TitleBarColor;
					tmpCardEl.appendChild(tmpSwatch);
				}

				// Title
				let tmpTitleSpan = document.createElement('span');
				tmpTitleSpan.className = 'pict-flow-palette-card-title';
				tmpTitleSpan.textContent = tmpCardConfig.Label;
				tmpCardEl.appendChild(tmpTitleSpan);

				// Code badge
				if (tmpMeta.Code)
				{
					let tmpCodeSpan = document.createElement('span');
					tmpCodeSpan.className = 'pict-flow-palette-card-code';
					tmpCodeSpan.textContent = tmpMeta.Code;
					tmpCardEl.appendChild(tmpCodeSpan);
				}

				// Click handler
				tmpCardEl.addEventListener('click', () =>
				{
					this._addCardFromPalette(tmpCardConfig.Hash);
					this._closePopup();
				});

				tmpCardsDiv.appendChild(tmpCardEl);
			}

			tmpCategoryDiv.appendChild(tmpCardsDiv);
			pContainer.appendChild(tmpCategoryDiv);
		}

		if (tmpTotalMatchCount === 0)
		{
			let tmpEmpty = document.createElement('div');
			tmpEmpty.className = 'pict-flow-popup-list-empty';
			tmpEmpty.textContent = tmpFilter ? 'No matching cards' : 'No card types available';
			pContainer.appendChild(tmpEmpty);
		}
	}

	// ── Layout Popup ──────────────────────────────────────────────────────

	/**
	 * Build the Layout popup content.
	 * @param {HTMLElement} pContainer
	 */
	_buildLayoutPopup(pContainer)
	{
		let tmpIconProvider = this._FlowView ? this._FlowView._IconProvider : null;

		// Save Layout section at top
		let tmpSaveSection = document.createElement('div');
		tmpSaveSection.className = 'pict-flow-popup-layout-save-section';

		// Save input row (hidden initially)
		let tmpSaveInputRow = document.createElement('div');
		tmpSaveInputRow.className = 'pict-flow-popup-layout-save-input-row';
		tmpSaveInputRow.style.display = 'none';

		let tmpSaveInput = document.createElement('input');
		tmpSaveInput.className = 'pict-flow-popup-layout-save-input';
		tmpSaveInput.setAttribute('type', 'text');
		tmpSaveInput.setAttribute('placeholder', 'Layout name...');
		tmpSaveInputRow.appendChild(tmpSaveInput);

		let tmpSaveConfirmBtn = document.createElement('button');
		tmpSaveConfirmBtn.className = 'pict-flow-popup-layout-save-confirm';
		tmpSaveConfirmBtn.title = 'Save';
		if (tmpIconProvider)
		{
			tmpSaveConfirmBtn.innerHTML = tmpIconProvider.getIconSVGMarkup('save', 14);
		}
		else
		{
			tmpSaveConfirmBtn.textContent = '✓';
		}
		tmpSaveInputRow.appendChild(tmpSaveConfirmBtn);

		// "Save Current Layout" clickable row
		let tmpSaveRow = document.createElement('div');
		tmpSaveRow.className = 'pict-flow-popup-layout-save';

		let tmpSaveIcon = document.createElement('span');
		tmpSaveIcon.className = 'pict-flow-popup-layout-save-icon';
		if (tmpIconProvider)
		{
			tmpSaveIcon.innerHTML = tmpIconProvider.getIconSVGMarkup('save', 14);
		}
		tmpSaveRow.appendChild(tmpSaveIcon);

		let tmpSaveText = document.createElement('span');
		tmpSaveText.textContent = 'Save Current Layout';
		tmpSaveRow.appendChild(tmpSaveText);

		// Click "Save Current Layout" to reveal the input row
		tmpSaveRow.addEventListener('click', () =>
		{
			tmpSaveRow.style.display = 'none';
			tmpSaveInputRow.style.display = '';
			tmpSaveInput.value = '';
			setTimeout(() => { tmpSaveInput.focus(); }, 50);
		});

		// Confirm save via button click
		let tmpDoSave = () =>
		{
			let tmpName = tmpSaveInput.value.trim();
			if (tmpName === '') return;
			this._FlowView._LayoutProvider.saveLayout(tmpName);
			// Refresh the popup content
			while (pContainer.firstChild)
			{
				pContainer.removeChild(pContainer.firstChild);
			}
			this._buildLayoutPopup(pContainer);
		};

		tmpSaveConfirmBtn.addEventListener('click', tmpDoSave);

		// Confirm save via Enter key
		tmpSaveInput.addEventListener('keydown', (pEvent) =>
		{
			if (pEvent.key === 'Enter')
			{
				pEvent.preventDefault();
				tmpDoSave();
			}
			else if (pEvent.key === 'Escape')
			{
				// Cancel — hide input, show the save row again
				tmpSaveInputRow.style.display = 'none';
				tmpSaveRow.style.display = '';
			}
		});

		// Prevent clicks inside the input from closing the popup
		tmpSaveInput.addEventListener('click', (pEvent) =>
		{
			pEvent.stopPropagation();
		});

		tmpSaveSection.appendChild(tmpSaveRow);
		tmpSaveSection.appendChild(tmpSaveInputRow);
		pContainer.appendChild(tmpSaveSection);

		// Divider
		let tmpDivider = document.createElement('div');
		tmpDivider.className = 'pict-flow-popup-divider';
		pContainer.appendChild(tmpDivider);

		// Layout rows
		if (!this._FlowView || !this._FlowView._LayoutProvider)
		{
			let tmpEmpty = document.createElement('div');
			tmpEmpty.className = 'pict-flow-popup-list-empty';
			tmpEmpty.textContent = 'No saved layouts';
			pContainer.appendChild(tmpEmpty);
			return;
		}

		let tmpLayouts = this._FlowView._LayoutProvider.getLayouts();

		if (tmpLayouts.length === 0)
		{
			let tmpEmpty = document.createElement('div');
			tmpEmpty.className = 'pict-flow-popup-list-empty';
			tmpEmpty.textContent = 'No saved layouts';
			pContainer.appendChild(tmpEmpty);
			return;
		}

		for (let i = 0; i < tmpLayouts.length; i++)
		{
			let tmpLayout = tmpLayouts[i];

			let tmpRow = document.createElement('div');
			tmpRow.className = 'pict-flow-popup-layout-row';

			let tmpNameSpan = document.createElement('span');
			tmpNameSpan.className = 'pict-flow-popup-layout-name';
			tmpNameSpan.textContent = tmpLayout.Name;
			tmpRow.appendChild(tmpNameSpan);

			// Delete button (visible on hover via CSS)
			let tmpDeleteBtn = document.createElement('button');
			tmpDeleteBtn.className = 'pict-flow-popup-layout-delete';
			tmpDeleteBtn.title = 'Delete layout';
			if (tmpIconProvider)
			{
				tmpDeleteBtn.innerHTML = tmpIconProvider.getIconSVGMarkup('trash', 12);
			}
			else
			{
				tmpDeleteBtn.textContent = '×';
			}
			tmpRow.appendChild(tmpDeleteBtn);

			// Click row → restore layout
			tmpRow.addEventListener('click', (pEvent) =>
			{
				// Don't restore if they clicked the delete button
				if (pEvent.target.closest('.pict-flow-popup-layout-delete'))
				{
					return;
				}
				this._FlowView._LayoutProvider.restoreLayout(tmpLayout.Hash);
				this._closePopup();
			});

			// Click delete → delete layout and refresh popup
			tmpDeleteBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				this._FlowView._LayoutProvider.deleteLayout(tmpLayout.Hash);
				// Refresh the popup content
				while (pContainer.firstChild)
				{
					pContainer.removeChild(pContainer.firstChild);
				}
				this._buildLayoutPopup(pContainer);
			});

			pContainer.appendChild(tmpRow);
		}
	}

	// ── Settings Popup ───────────────────────────────────────────────────

	/**
	 * Build the Settings popup content (theme dropdown + noise slider).
	 * @param {HTMLElement} pContainer
	 */
	_buildSettingsPopup(pContainer)
	{
		if (!this._FlowView || !this._FlowView._ThemeProvider) return;

		let tmpThemeProvider = this._FlowView._ThemeProvider;

		// Theme selector section
		let tmpThemeSection = document.createElement('div');
		tmpThemeSection.className = 'pict-flow-popup-settings-section';

		let tmpThemeLabel = document.createElement('label');
		tmpThemeLabel.className = 'pict-flow-popup-settings-label';
		tmpThemeLabel.textContent = 'Theme';
		tmpThemeSection.appendChild(tmpThemeLabel);

		let tmpThemeSelect = document.createElement('select');
		tmpThemeSelect.className = 'pict-flow-popup-settings-select';

		let tmpThemeKeys = tmpThemeProvider.getThemeKeys();
		let tmpActiveKey = tmpThemeProvider.getActiveThemeKey();

		for (let i = 0; i < tmpThemeKeys.length; i++)
		{
			let tmpOption = document.createElement('option');
			tmpOption.value = tmpThemeKeys[i];

			let tmpTheme = tmpThemeProvider._Themes[tmpThemeKeys[i]];
			tmpOption.textContent = tmpTheme.Label || tmpThemeKeys[i];

			if (tmpThemeKeys[i] === tmpActiveKey)
			{
				tmpOption.selected = true;
			}
			tmpThemeSelect.appendChild(tmpOption);
		}

		tmpThemeSelect.addEventListener('change', () =>
		{
			this._FlowView.setTheme(tmpThemeSelect.value);
			// Refresh the noise slider visibility
			this._refreshNoiseSlider(pContainer);
		});

		// Prevent popup close on select interaction
		tmpThemeSelect.addEventListener('click', (pEvent) => { pEvent.stopPropagation(); });

		tmpThemeSection.appendChild(tmpThemeSelect);
		pContainer.appendChild(tmpThemeSection);

		// Divider
		let tmpDivider = document.createElement('div');
		tmpDivider.className = 'pict-flow-popup-divider';
		pContainer.appendChild(tmpDivider);

		// Noise level section
		let tmpNoiseSection = document.createElement('div');
		tmpNoiseSection.className = 'pict-flow-popup-settings-section pict-flow-popup-settings-noise';
		tmpNoiseSection.setAttribute('data-settings-type', 'noise');

		let tmpNoiseLabel = document.createElement('label');
		tmpNoiseLabel.className = 'pict-flow-popup-settings-label';
		tmpNoiseLabel.textContent = 'Noise';
		tmpNoiseSection.appendChild(tmpNoiseLabel);

		let tmpNoiseRow = document.createElement('div');
		tmpNoiseRow.className = 'pict-flow-popup-settings-slider-row';

		let tmpNoiseSlider = document.createElement('input');
		tmpNoiseSlider.type = 'range';
		tmpNoiseSlider.className = 'pict-flow-popup-settings-slider';
		tmpNoiseSlider.min = '0';
		tmpNoiseSlider.max = '100';
		tmpNoiseSlider.value = String(Math.round(tmpThemeProvider.getNoiseLevel() * 100));

		let tmpNoiseValue = document.createElement('span');
		tmpNoiseValue.className = 'pict-flow-popup-settings-slider-value';
		tmpNoiseValue.textContent = tmpNoiseSlider.value + '%';

		tmpNoiseSlider.addEventListener('input', () =>
		{
			let tmpLevel = parseInt(tmpNoiseSlider.value, 10) / 100;
			tmpNoiseValue.textContent = tmpNoiseSlider.value + '%';
			this._FlowView.setNoiseLevel(tmpLevel);
		});

		// Prevent popup close on slider interaction
		tmpNoiseSlider.addEventListener('click', (pEvent) => { pEvent.stopPropagation(); });
		tmpNoiseSlider.addEventListener('pointerdown', (pEvent) => { pEvent.stopPropagation(); });

		tmpNoiseRow.appendChild(tmpNoiseSlider);
		tmpNoiseRow.appendChild(tmpNoiseValue);
		tmpNoiseSection.appendChild(tmpNoiseRow);
		pContainer.appendChild(tmpNoiseSection);

		// Show/hide noise slider based on active theme
		this._refreshNoiseSlider(pContainer);
	}

	/**
	 * Show or hide the noise slider based on whether the active theme supports noise.
	 * @param {HTMLElement} pContainer - The settings popup container
	 */
	_refreshNoiseSlider(pContainer)
	{
		let tmpNoiseSection = pContainer.querySelector('[data-settings-type="noise"]');
		if (!tmpNoiseSection) return;

		let tmpTheme = this._FlowView._ThemeProvider.getActiveTheme();
		if (tmpTheme && tmpTheme.NoiseConfig && tmpTheme.NoiseConfig.Enabled)
		{
			tmpNoiseSection.style.display = '';
			// Update slider value to reflect theme default
			let tmpSlider = tmpNoiseSection.querySelector('.pict-flow-popup-settings-slider');
			let tmpValueLabel = tmpNoiseSection.querySelector('.pict-flow-popup-settings-slider-value');
			if (tmpSlider)
			{
				let tmpLevel = Math.round(this._FlowView._ThemeProvider.getNoiseLevel() * 100);
				tmpSlider.value = String(tmpLevel);
				if (tmpValueLabel) tmpValueLabel.textContent = tmpLevel + '%';
			}
		}
		else
		{
			tmpNoiseSection.style.display = 'none';
		}
	}

	// ── Toolbar Mode Switching ────────────────────────────────────────────

	/**
	 * Switch between docked, floating, and collapsed modes.
	 * @param {string} pMode - 'docked' | 'floating' | 'collapsed'
	 */
	_setToolbarMode(pMode)
	{
		// Close any active popup first
		this._closePopup();

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
		let tmpBar = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Bar-${tmpFlowViewIdentifier}`);
		let tmpCollapsed = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Collapsed-${tmpFlowViewIdentifier}`);

		switch (pMode)
		{
			case 'docked':
				// Show toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = '';
				// Hide collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.remove('visible');
				// Hide floating toolbar
				if (this._FloatingToolbarView) this._FloatingToolbarView.hide();
				break;

			case 'floating':
				// Hide toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = 'none';
				// Hide collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.remove('visible');
				// Show floating toolbar
				this._showFloatingToolbar();
				break;

			case 'collapsed':
				// Hide toolbar bar
				if (tmpBar.length > 0) tmpBar[0].style.display = 'none';
				// Show collapsed button
				if (tmpCollapsed.length > 0) tmpCollapsed[0].classList.add('visible');
				// Hide floating toolbar
				if (this._FloatingToolbarView) this._FloatingToolbarView.hide();
				break;
		}

		this._ToolbarMode = pMode;
	}

	/**
	 * Lazily create and show the floating toolbar.
	 */
	_showFloatingToolbar()
	{
		if (!this._FlowView) return;

		if (!this._FloatingToolbarView)
		{
			let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;
			this._FloatingToolbarView = this.fable.instantiateServiceProviderWithoutRegistration(
				'PictViewFlowFloatingToolbar',
				{
					FlowViewIdentifier: tmpFlowViewIdentifier,
					DefaultDestinationAddress: `#Flow-FloatingToolbar-Container-${tmpFlowViewIdentifier}`,
					EnableAddNode: this.options.EnableAddNode,
					EnableCardPalette: this.options.EnableCardPalette
				}
			);
			this._FloatingToolbarView._ToolbarView = this;
			this._FloatingToolbarView._FlowView = this._FlowView;
			this._FloatingToolbarView.render();
		}

		this._FloatingToolbarView.show();
	}

	// ── Node Placement Helpers ────────────────────────────────────────────

	/**
	 * Add a node at the center of the visible viewport.
	 * @param {string} pNodeType - The node type hash
	 */
	_addNodeAtCenter(pNodeType)
	{
		if (!this._FlowView) return;

		let tmpVS = this._FlowView.viewState;

		// Calculate the center of the visible SVG area
		let tmpSVGContainer = this._FlowView._SVGElement;
		let tmpWidth = tmpSVGContainer ? tmpSVGContainer.clientWidth : 600;
		let tmpHeight = tmpSVGContainer ? tmpSVGContainer.clientHeight : 400;

		let tmpCenterX = (-tmpVS.PanX + tmpWidth / 2) / tmpVS.Zoom;
		let tmpCenterY = (-tmpVS.PanY + tmpHeight / 2) / tmpVS.Zoom;

		// Slight offset to avoid stacking
		let tmpNodeCount = this._FlowView.flowData.Nodes.length;
		tmpCenterX += (tmpNodeCount % 5) * 30;
		tmpCenterY += (tmpNodeCount % 5) * 30;

		this._FlowView.addNode(pNodeType, tmpCenterX, tmpCenterY);
	}

	/**
	 * Add a node from a palette card click.
	 * @param {string} pCardType - The card type hash
	 */
	_addCardFromPalette(pCardType)
	{
		if (!this._FlowView) return;

		let tmpVS = this._FlowView.viewState;
		let tmpX = (-tmpVS.PanX + 200) / tmpVS.Zoom;
		let tmpY = (-tmpVS.PanY + 200) / tmpVS.Zoom;

		// Offset to avoid overlap
		let tmpNodeCount = this._FlowView.flowData.Nodes.length;
		tmpX += (tmpNodeCount % 5) * 40;
		tmpY += (tmpNodeCount % 5) * 40;

		this._FlowView.addNode(pCardType, tmpX, tmpY);
	}

	// ── Action Handler ────────────────────────────────────────────────────

	/**
	 * Handle a toolbar action
	 * @param {string} pAction
	 */
	_handleToolbarAction(pAction)
	{
		if (!this._FlowView) return;

		let tmpFlowViewIdentifier = this.options.FlowViewIdentifier;

		switch (pAction)
		{
			case 'add-node':
				this._openPopup('add-node');
				break;

			case 'delete-selected':
				this._FlowView.deleteSelected();
				break;

			case 'zoom-in':
				this._FlowView.setZoom(this._FlowView.viewState.Zoom + this._FlowView.options.ZoomStep);
				break;

			case 'zoom-out':
				this._FlowView.setZoom(this._FlowView.viewState.Zoom - this._FlowView.options.ZoomStep);
				break;

			case 'zoom-fit':
				this._FlowView.zoomToFit();
				break;

			case 'auto-layout':
				this._FlowView.autoLayout();
				break;

			case 'cards-popup':
				this._openPopup('cards');
				break;

			case 'layout-popup':
				this._openPopup('layout');
				break;

			case 'settings-popup':
				this._openPopup('settings');
				break;

			case 'toggle-floating':
				if (this._ToolbarMode === 'floating')
				{
					this._setToolbarMode('docked');
				}
				else
				{
					this._setToolbarMode('floating');
				}
				break;

			case 'collapse-toolbar':
				this._setToolbarMode('collapsed');
				break;

			case 'expand-toolbar':
				this._setToolbarMode('docked');
				break;

			case 'fullscreen':
				{
					let tmpIsFullscreen = this._FlowView.toggleFullscreen();
					let tmpIconProvider = this._FlowView._IconProvider;
					let tmpIconElements = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-Icon-${tmpFlowViewIdentifier}`);
					if (tmpIconElements.length > 0 && tmpIconProvider)
					{
						tmpIconElements[0].innerHTML = tmpIconProvider.getIconSVGMarkup(
							tmpIsFullscreen ? 'exit-fullscreen' : 'fullscreen', 14);
					}
					let tmpFullscreenBtn = this.pict.ContentAssignment.getElement(`#Flow-Toolbar-Fullscreen-${tmpFlowViewIdentifier}`);
					if (tmpFullscreenBtn.length > 0)
					{
						tmpFullscreenBtn[0].setAttribute('title', tmpIsFullscreen ? 'Exit Fullscreen' : 'Toggle Fullscreen');
					}
				}
				break;

			default:
				this.log.warn(`PictViewFlowToolbar: unknown action '${pAction}'`);
				break;
		}
	}
}

module.exports = PictViewFlowToolbar;

module.exports.default_configuration = _DefaultConfiguration;

},{"pict-view":239}],62:[function(require,module,exports){
const libPictView = require('pict-view');

const libPictServiceFlowInteractionManager = require('../services/PictService-Flow-InteractionManager.js');
const libPictServiceFlowConnectionRenderer = require('../services/PictService-Flow-ConnectionRenderer.js');
const libPictServiceFlowTether = require('../services/PictService-Flow-Tether.js');
const libPictServiceFlowLayout = require('../services/PictService-Flow-Layout.js');
const libPictServiceFlowPathGenerator = require('../services/PictService-Flow-PathGenerator.js');
const libPictServiceFlowViewportManager = require('../services/PictService-Flow-ViewportManager.js');
const libPictServiceFlowSelectionManager = require('../services/PictService-Flow-SelectionManager.js');
const libPictServiceFlowPanelManager = require('../services/PictService-Flow-PanelManager.js');
const libPictServiceFlowDataManager = require('../services/PictService-Flow-DataManager.js');
const libPictServiceFlowConnectionHandleManager = require('../services/PictService-Flow-ConnectionHandleManager.js');
const libPictServiceFlowRenderManager = require('../services/PictService-Flow-RenderManager.js');
const libPictServiceFlowPortRenderer = require('../services/PictService-Flow-PortRenderer.js');

const libPictProviderFlowNodeTypes = require('../providers/PictProvider-Flow-NodeTypes.js');
const libPictProviderFlowEventHandler = require('../providers/PictProvider-Flow-EventHandler.js');
const libPictProviderFlowLayouts = require('../providers/PictProvider-Flow-Layouts.js');
const libPictProviderFlowSVGHelpers = require('../providers/PictProvider-Flow-SVGHelpers.js');
const libPictProviderFlowGeometry = require('../providers/PictProvider-Flow-Geometry.js');
const libPictProviderFlowPanelChrome = require('../providers/PictProvider-Flow-PanelChrome.js');
const libPictProviderFlowCSS = require('../providers/PictProvider-Flow-CSS.js');
const libPictProviderFlowIcons = require('../providers/PictProvider-Flow-Icons.js');
const libPictProviderFlowConnectorShapes = require('../providers/PictProvider-Flow-ConnectorShapes.js');
const libPictProviderFlowTheme = require('../providers/PictProvider-Flow-Theme.js');
const libPictProviderFlowNoise = require('../providers/PictProvider-Flow-Noise.js');

const libPictViewFlowNode = require('./PictView-Flow-Node.js');
const libPictViewFlowToolbar = require('./PictView-Flow-Toolbar.js');
const libPictViewFlowFloatingToolbar = require('./PictView-Flow-FloatingToolbar.js');
const libPictViewFlowPropertiesPanel = require('./PictView-Flow-PropertiesPanel.js');

const libPictFlowCardPropertiesPanel = require('../PictFlowCardPropertiesPanel.js');
const libPanelTemplate = require('../panels/FlowCardPropertiesPanel-Template.js');
const libPanelMarkdown = require('../panels/FlowCardPropertiesPanel-Markdown.js');
const libPanelForm = require('../panels/FlowCardPropertiesPanel-Form.js');
const libPanelView = require('../panels/FlowCardPropertiesPanel-View.js');

const _DefaultConfiguration =
{
	ViewIdentifier: 'Pict-Flow',

	DefaultRenderable: 'Flow-Container',
	DefaultDestinationAddress: '#Flow-Container',

	AutoRender: false,

	FlowDataAddress: false,

	TargetElementAddress: '#Flow-SVG-Container',

	EnableToolbar: true,
	EnableAddNode: true,
	EnableCardPalette: true,
	IncludeDefaultNodeTypes: true,
	EnablePanning: true,
	EnableZooming: true,
	EnableNodeDragging: true,
	EnableConnectionCreation: true,
	EnableGridSnap: false,
	GridSnapSize: 20,

	MinZoom: 0.1,
	MaxZoom: 5.0,
	ZoomStep: 0.1,

	DefaultNodeType: 'default',
	DefaultNodeWidth: 180,
	DefaultNodeHeight: 80,

	CSS: false,

	Templates:
	[
		{
			Hash: 'Flow-PanelChrome-Template',
			Template: /*html*/`<div class="pict-flow-panel" xmlns="http://www.w3.org/1999/xhtml"><div class="pict-flow-panel-titlebar" data-element-type="panel-titlebar" data-panel-hash="{~D:Record.Hash~}"><span class="pict-flow-panel-title-text">{~D:Record.Title~}</span><span class="pict-flow-panel-close-btn" data-element-type="panel-close" data-panel-hash="{~D:Record.Hash~}"><span class="pict-flow-panel-close-icon"></span></span></div><div class="pict-flow-panel-content" data-panel-hash="{~D:Record.Hash~}"><div class="pict-flow-panel-tab-pane active" data-tab="properties" data-panel-hash="{~D:Record.Hash~}"></div><div class="pict-flow-panel-tab-pane" data-tab="help" data-panel-hash="{~D:Record.Hash~}" style="display:none;"></div><div class="pict-flow-panel-tab-pane" data-tab="appearance" data-panel-hash="{~D:Record.Hash~}" style="display:none;"></div></div><div class="pict-flow-panel-resize-handle" data-element-type="panel-resize" data-panel-hash="{~D:Record.Hash~}"></div><div class="pict-flow-panel-tabbar" data-panel-hash="{~D:Record.Hash~}"><div class="pict-flow-panel-tab active" data-tab-target="properties" data-panel-hash="{~D:Record.Hash~}">Properties</div><div class="pict-flow-panel-tab" data-tab-target="help" data-panel-hash="{~D:Record.Hash~}" style="display:none;">Help</div><div class="pict-flow-panel-tab" data-tab-target="appearance" data-panel-hash="{~D:Record.Hash~}">Appearance</div></div></div>`
		},
		{
			Hash: 'Flow-Container-Template',
			Template: /*html*/`
<div class="pict-flow-container" id="Flow-Wrapper-{~D:Record.ViewIdentifier~}">
	<div id="Flow-Toolbar-{~D:Record.ViewIdentifier~}"></div>
	<div id="Flow-FloatingToolbar-Container-{~D:Record.ViewIdentifier~}" style="display:none;position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:100;"></div>
	<div class="pict-flow-svg-container" id="Flow-SVG-Container-{~D:Record.ViewIdentifier~}">
		<svg class="pict-flow-svg"
			id="Flow-SVG-{~D:Record.ViewIdentifier~}"
			xmlns="http://www.w3.org/2000/svg">
			<defs>
				<pattern id="flow-grid-{~D:Record.ViewIdentifier~}"
					width="20" height="20" patternUnits="userSpaceOnUse">
					<line x1="20" y1="0" x2="20" y2="20" class="pict-flow-grid-pattern" />
					<line x1="0" y1="20" x2="20" y2="20" class="pict-flow-grid-pattern" />
				</pattern>
			</defs>
			<rect width="10000" height="10000" x="-5000" y="-5000"
				fill="url(#flow-grid-{~D:Record.ViewIdentifier~})"
				class="pict-flow-grid-background" />
			<g class="pict-flow-viewport" id="Flow-Viewport-{~D:Record.ViewIdentifier~}">
				<g class="pict-flow-connections-layer" id="Flow-Connections-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-nodes-layer" id="Flow-Nodes-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-tethers-layer" id="Flow-Tethers-{~D:Record.ViewIdentifier~}"></g>
				<g class="pict-flow-panels-layer" id="Flow-Panels-{~D:Record.ViewIdentifier~}"></g>
			</g>
		</svg>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Flow-Container',
			TemplateHash: 'Flow-Container-Template',
			DestinationAddress: '#Flow-Container',
			RenderMethod: 'replace'
		}
	]
};

class PictViewFlow extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.serviceType = 'PictSectionFlow';

		// ---- Declarative service registry ----
		// Each entry defines a service to register, instantiate, and guard.
		// Optional flags:
		//   NoFlowView  — instantiate without { FlowView: this }
		//   PostInit    — method name to call on the instance after creation
		//   RegisterOnly — only register the type; do not bulk-instantiate
		this._ServiceRegistry =
		[
			// Providers (stateless or config-only — no FlowView needed)
			{ ServiceType: 'PictProviderFlowSVGHelpers',   Library: libPictProviderFlowSVGHelpers,   Property: '_SVGHelperProvider',    NoFlowView: true },
			{ ServiceType: 'PictProviderFlowGeometry',      Library: libPictProviderFlowGeometry,      Property: '_GeometryProvider',     NoFlowView: true },
			{ ServiceType: 'PictProviderFlowNoise',         Library: libPictProviderFlowNoise,         Property: '_NoiseProvider',        NoFlowView: true },

			// Providers (need FlowView)
			{ ServiceType: 'PictProviderFlowTheme',         Library: libPictProviderFlowTheme,         Property: '_ThemeProvider' },
			{ ServiceType: 'PictProviderFlowCSS',           Library: libPictProviderFlowCSS,           Property: '_CSSProvider',          PostInit: 'registerCSS' },
			{ ServiceType: 'PictProviderFlowIcons',         Library: libPictProviderFlowIcons,         Property: '_IconProvider',         PostInit: 'registerIconTemplates' },
			{ ServiceType: 'PictProviderFlowConnectorShapes', Library: libPictProviderFlowConnectorShapes, Property: '_ConnectorShapesProvider' },
			{ ServiceType: 'PictProviderFlowPanelChrome',   Library: libPictProviderFlowPanelChrome,   Property: '_PanelChromeProvider' },
			{ ServiceType: 'PictProviderFlowNodeTypes',     Library: libPictProviderFlowNodeTypes,     Property: '_NodeTypeProvider',   ExtraOptions: () => ({ AdditionalNodeTypes: this.options.NodeTypes, IncludeDefaultNodeTypes: this.options.IncludeDefaultNodeTypes }) },
			{ ServiceType: 'PictProviderFlowEventHandler',  Library: libPictProviderFlowEventHandler,  Property: '_EventHandlerProvider' },
			{ ServiceType: 'PictProviderFlowLayouts',       Library: libPictProviderFlowLayouts,       Property: '_LayoutProvider',       PostInit: 'loadPersistedLayouts' },

			// Services
			{ ServiceType: 'PictServiceFlowPathGenerator',           Library: libPictServiceFlowPathGenerator,           Property: '_PathGenerator' },
			{ ServiceType: 'PictServiceFlowDataManager',             Library: libPictServiceFlowDataManager,             Property: '_DataManager' },
			{ ServiceType: 'PictServiceFlowConnectionHandleManager', Library: libPictServiceFlowConnectionHandleManager, Property: '_ConnectionHandleManager' },
			{ ServiceType: 'PictServiceFlowRenderManager',           Library: libPictServiceFlowRenderManager,           Property: '_RenderManager' },
			{ ServiceType: 'PictServiceFlowPortRenderer',            Library: libPictServiceFlowPortRenderer,            Property: '_PortRenderer' },
			{ ServiceType: 'PictServiceFlowInteractionManager',      Library: libPictServiceFlowInteractionManager,      Property: '_InteractionManager' },
			{ ServiceType: 'PictServiceFlowConnectionRenderer',      Library: libPictServiceFlowConnectionRenderer,      Property: '_ConnectionRenderer' },
			{ ServiceType: 'PictServiceFlowTether',                  Library: libPictServiceFlowTether,                  Property: '_TetherService' },
			{ ServiceType: 'PictServiceFlowLayout',                  Library: libPictServiceFlowLayout,                  Property: '_LayoutService' },
			{ ServiceType: 'PictServiceFlowViewportManager',         Library: libPictServiceFlowViewportManager,         Property: '_ViewportManager' },
			{ ServiceType: 'PictServiceFlowSelectionManager',        Library: libPictServiceFlowSelectionManager,        Property: '_SelectionManager' },
			{ ServiceType: 'PictServiceFlowPanelManager',            Library: libPictServiceFlowPanelManager,            Property: '_PanelManager' },

			// View types (register only — instantiated with custom config in onAfterInitialRender)
			{ ServiceType: 'PictViewFlowNode',             Library: libPictViewFlowNode,             RegisterOnly: true },
			{ ServiceType: 'PictViewFlowToolbar',          Library: libPictViewFlowToolbar,          RegisterOnly: true },
			{ ServiceType: 'PictViewFlowFloatingToolbar',  Library: libPictViewFlowFloatingToolbar,  RegisterOnly: true },
			{ ServiceType: 'PictViewFlowPropertiesPanel',  Library: libPictViewFlowPropertiesPanel,  RegisterOnly: true },

			// Panel types (register only)
			{ ServiceType: 'PictFlowCardPropertiesPanel',           Library: libPictFlowCardPropertiesPanel,  RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Template',  Library: libPanelTemplate,               RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Markdown',  Library: libPanelMarkdown,               RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-Form',      Library: libPanelForm,                   RegisterOnly: true },
			{ ServiceType: 'PictFlowCardPropertiesPanel-View',      Library: libPanelView,                   RegisterOnly: true }
		];

		this._registerServiceTypes();

		// Internal state
		this._FlowData = {
			Nodes: [],
			Connections: [],
			OpenPanels: [],
			SavedLayouts: [],
			ViewState: {
				PanX: 0,
				PanY: 0,
				Zoom: 1,
				SelectedNodeHash: null,
				SelectedConnectionHash: null,
				SelectedTetherHash: null
			}
		};

		this._SVGElement = null;
		this._ViewportElement = null;
		this._NodesLayer = null;
		this._ConnectionsLayer = null;
		this._TethersLayer = null;
		this._PanelsLayer = null;

		this._DataManager = null;
		this._ConnectionHandleManager = null;
		this._RenderManager = null;
		this._PortRenderer = null;

		this._InteractionManager = null;
		this._ConnectionRenderer = null;
		this._TetherService = null;
		this._LayoutService = null;
		this._PathGenerator = null;
		this._ViewportManager = null;
		this._SelectionManager = null;
		this._PanelManager = null;
		this._CSSProvider = null;
		this._IconProvider = null;
		this._ConnectorShapesProvider = null;
		this._ThemeProvider = null;
		this._NoiseProvider = null;
		this._SVGHelperProvider = null;
		this._GeometryProvider = null;
		this._PanelChromeProvider = null;
		this._NodeTypeProvider = null;
		this._LayoutProvider = null;
		this._EventHandlerProvider = null;
		this._NodeView = null;
		this._ToolbarView = null;
		this._PropertiesPanelView = null;

		this.initialRenderComplete = false;
	}

	_registerServiceTypes()
	{
		for (let i = 0; i < this._ServiceRegistry.length; i++)
		{
			let tmpEntry = this._ServiceRegistry[i];
			if (!this.fable.servicesMap.hasOwnProperty(tmpEntry.ServiceType))
			{
				this.fable.addServiceType(tmpEntry.ServiceType, tmpEntry.Library);
			}
		}
	}

	_instantiateServices()
	{
		for (let i = 0; i < this._ServiceRegistry.length; i++)
		{
			let tmpEntry = this._ServiceRegistry[i];
			if (tmpEntry.RegisterOnly) continue;
			if (this[tmpEntry.Property]) continue;

			let tmpOptions = tmpEntry.NoFlowView ? {} : { FlowView: this };
			if (typeof tmpEntry.ExtraOptions === 'function')
			{
				Object.assign(tmpOptions, tmpEntry.ExtraOptions());
			}

			this[tmpEntry.Property] = this.fable.instantiateServiceProviderWithoutRegistration(tmpEntry.ServiceType, tmpOptions);

			if (tmpEntry.PostInit && typeof this[tmpEntry.Property][tmpEntry.PostInit] === 'function')
			{
				this[tmpEntry.Property][tmpEntry.PostInit]();
			}
		}
	}

	get flowData()
	{
		return this._FlowData;
	}

	get viewState()
	{
		return this._FlowData.ViewState;
	}

	// Backward-compatible getter for InteractionManager direct access
	get _IsFullscreen()
	{
		return this._ViewportManager ? this._ViewportManager._IsFullscreen : false;
	}

	/**
	 * Override render to pass view options as the template record,
	 * so template expressions like {~D:Record.ViewIdentifier~} resolve correctly.
	 */
	render(pRenderableHash, pRenderDestinationAddress)
	{
		return super.render(pRenderableHash, pRenderDestinationAddress, this.options);
	}

	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		// If no record address is explicitly provided, use this.options as the record
		if (typeof pTemplateRecordAddress === 'function' || typeof pTemplateRecordAddress === 'undefined')
		{
			return super.renderAsync(pRenderableHash, pRenderDestinationAddress, this.options, pRootRenderable, pTemplateRecordAddress || fCallback);
		}
		return super.renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Theme + Noise must be created first (CSS PostInit depends on theme state)
		this._ThemeProvider = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowTheme', { FlowView: this });
		this._NoiseProvider = this.fable.instantiateServiceProviderWithoutRegistration('PictProviderFlowNoise');

		// Apply initial theme from options
		if (this.options.Theme)
		{
			this._ThemeProvider.setTheme(this.options.Theme);
		}
		if (typeof this.options.NoiseLevel === 'number')
		{
			this._ThemeProvider.setNoiseLevel(this.options.NoiseLevel);
		}

		// Instantiate all remaining services (skips Theme + Noise since already set)
		this._instantiateServices();

		return super.onBeforeInitialize();
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	onAfterInitialRender()
	{
		let tmpViewIdentifier = this.options.ViewIdentifier;

		// Grab SVG DOM elements
		let tmpSVGElements = this.pict.ContentAssignment.getElement(`#Flow-SVG-${tmpViewIdentifier}`);
		if (tmpSVGElements.length < 1)
		{
			this.log.error(`PictSectionFlow could not find SVG element #Flow-SVG-${tmpViewIdentifier}`);
			return false;
		}
		this._SVGElement = tmpSVGElements[0];

		let tmpViewportElements = this.pict.ContentAssignment.getElement(`#Flow-Viewport-${tmpViewIdentifier}`);
		if (tmpViewportElements.length > 0)
		{
			this._ViewportElement = tmpViewportElements[0];
		}

		let tmpNodesElements = this.pict.ContentAssignment.getElement(`#Flow-Nodes-${tmpViewIdentifier}`);
		if (tmpNodesElements.length > 0)
		{
			this._NodesLayer = tmpNodesElements[0];
		}

		let tmpConnectionsElements = this.pict.ContentAssignment.getElement(`#Flow-Connections-${tmpViewIdentifier}`);
		if (tmpConnectionsElements.length > 0)
		{
			this._ConnectionsLayer = tmpConnectionsElements[0];
		}

		let tmpTethersElements = this.pict.ContentAssignment.getElement(`#Flow-Tethers-${tmpViewIdentifier}`);
		if (tmpTethersElements.length > 0)
		{
			this._TethersLayer = tmpTethersElements[0];
		}

		let tmpPanelsElements = this.pict.ContentAssignment.getElement(`#Flow-Panels-${tmpViewIdentifier}`);
		if (tmpPanelsElements.length > 0)
		{
			this._PanelsLayer = tmpPanelsElements[0];
		}

		// Ensure all services are initialized (fallback if onBeforeInitialize was skipped)
		this._instantiateServices();

		// Inject marker defs via the connector shapes provider
		// Note: insertAdjacentHTML does not work on SVG elements (wrong namespace),
		// so we parse via a temporary <svg> element to ensure SVG namespace.
		if (this._ConnectorShapesProvider && this._SVGElement)
		{
			let tmpDefs = this._SVGElement.querySelector('defs');
			if (tmpDefs)
			{
				let tmpMarkerMarkup = this._ConnectorShapesProvider.generateMarkerDefs(tmpViewIdentifier);
				let tmpTempSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				tmpTempSVG.innerHTML = tmpMarkerMarkup;
				while (tmpTempSVG.firstChild)
				{
					tmpDefs.appendChild(tmpTempSVG.firstChild);
				}
			}
		}

		// Setup the toolbar if enabled
		if (this.options.EnableToolbar)
		{
			this._ToolbarView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowToolbar',
				Object.assign({},
					libPictViewFlowToolbar.default_configuration,
					{
						ViewIdentifier: `Flow-Toolbar-${tmpViewIdentifier}`,
						DefaultDestinationAddress: `#Flow-Toolbar-${tmpViewIdentifier}`,
						FlowViewIdentifier: tmpViewIdentifier,
						EnableAddNode: this.options.EnableAddNode,
						EnableCardPalette: this.options.EnableCardPalette
					}
				));
			// Use the toolbar's render method after it's set up
			if (this._ToolbarView && typeof this._ToolbarView.render === 'function')
			{
				this._ToolbarView._FlowView = this;
				this._ToolbarView.render();
			}
		}

		// Setup the node renderer
		this._NodeView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowNode',
			Object.assign({},
				libPictViewFlowNode.default_configuration,
				{
					ViewIdentifier: `Flow-NodeRenderer-${tmpViewIdentifier}`,
					AutoRender: false
				}
			));
		this._NodeView._FlowView = this;

		// Setup the properties panel renderer
		this._PropertiesPanelView = this.fable.instantiateServiceProviderWithoutRegistration('PictViewFlowPropertiesPanel',
			Object.assign({},
				libPictViewFlowPropertiesPanel.default_configuration,
				{
					ViewIdentifier: `Flow-PropertiesPanel-${tmpViewIdentifier}`,
					AutoRender: false
				}
			));
		this._PropertiesPanelView._FlowView = this;

		// Bind interaction events
		this._InteractionManager.initialize(this._SVGElement, this._ViewportElement);

		// Load initial flow data if an address is configured
		if (this.options.FlowDataAddress)
		{
			this.marshalToView();
		}

		// Render the initial flow
		this.renderFlow();
	}

	// ---- Data Manager Delegations ----

	marshalToView() { return this._DataManager.marshalToView(); }
	marshalFromView() { return this._DataManager.marshalFromView(); }
	getFlowData() { return this._DataManager.getFlowData(); }
	setFlowData(pFlowData) { return this._DataManager.setFlowData(pFlowData); }
	addNode(pType, pX, pY, pTitle, pData) { return this._DataManager.addNode(pType, pX, pY, pTitle, pData); }
	removeNode(pNodeHash) { return this._DataManager.removeNode(pNodeHash); }
	addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData) { return this._DataManager.addConnection(pSourceNodeHash, pSourcePortHash, pTargetNodeHash, pTargetPortHash, pData); }
	removeConnection(pConnectionHash) { return this._DataManager.removeConnection(pConnectionHash); }

	/**
	 * Select a node
	 * @param {string|null} pNodeHash - Hash of the node to select, or null to deselect
	 */
	selectNode(pNodeHash)
	{
		return this._SelectionManager.selectNode(pNodeHash);
	}

	/**
	 * Select a connection
	 * @param {string|null} pConnectionHash - Hash of the connection to select, or null to deselect
	 */
	selectConnection(pConnectionHash)
	{
		return this._SelectionManager.selectConnection(pConnectionHash);
	}

	/**
	 * Deselect all nodes and connections
	 */
	deselectAll()
	{
		return this._SelectionManager.deselectAll();
	}

	/**
	 * Delete the currently selected node or connection
	 * @returns {boolean}
	 */
	deleteSelected()
	{
		return this._SelectionManager.deleteSelected();
	}

	/**
	 * Update the viewport transform (pan and zoom)
	 */
	updateViewportTransform()
	{
		return this._ViewportManager.updateViewportTransform();
	}

	/**
	 * Set zoom level
	 * @param {number} pZoom - The zoom level
	 * @param {number} [pFocusX] - X coordinate to zoom toward (SVG space)
	 * @param {number} [pFocusY] - Y coordinate to zoom toward (SVG space)
	 */
	setZoom(pZoom, pFocusX, pFocusY)
	{
		return this._ViewportManager.setZoom(pZoom, pFocusX, pFocusY);
	}

	/**
	 * Zoom to fit all nodes in the viewport
	 */
	zoomToFit()
	{
		return this._ViewportManager.zoomToFit();
	}

	/**
	 * Apply auto-layout to all nodes
	 */
	autoLayout()
	{
		if (this._LayoutService)
		{
			this._LayoutService.autoLayout(this._FlowData.Nodes, this._FlowData.Connections);
			this.renderFlow();
			this.marshalFromView();

			if (this._EventHandlerProvider)
			{
				this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
			}
		}
	}

	/**
	 * Toggle fullscreen mode on the flow editor container.
	 * Uses a CSS fixed-position overlay instead of the Fullscreen API.
	 * @returns {boolean} The new fullscreen state
	 */
	toggleFullscreen()
	{
		return this._ViewportManager.toggleFullscreen();
	}

	/**
	 * Exit fullscreen mode if currently active.
	 */
	exitFullscreen()
	{
		return this._ViewportManager.exitFullscreen();
	}

	// ── Theme API ────────────────────────────────────────────────────────

	/**
	 * Switch the active theme and re-render.
	 * @param {string} pThemeKey - Theme key (e.g. 'default', 'sketch', 'blueprint', 'mono', 'retro-80s', 'retro-90s')
	 */
	setTheme(pThemeKey)
	{
		if (!this._ThemeProvider)
		{
			this.log.warn('PictSectionFlow setTheme: ThemeProvider not available');
			return;
		}

		let tmpApplied = this._ThemeProvider.setTheme(pThemeKey);
		if (!tmpApplied) return;

		// Re-register CSS with the new theme overrides
		if (this._CSSProvider)
		{
			this._CSSProvider.registerCSS();
		}

		// Re-inject marker defs (arrowhead colors may have changed)
		this._reinjectMarkerDefs();

		// Full re-render
		if (this.initialRenderComplete)
		{
			this.renderFlow();
		}

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onThemeChanged', pThemeKey);
		}
	}

	/**
	 * Set the noise level (0 to 1) and re-render.
	 * @param {number} pLevel - 0 = precise, 1 = maximum wobble
	 */
	setNoiseLevel(pLevel)
	{
		if (!this._ThemeProvider)
		{
			this.log.warn('PictSectionFlow setNoiseLevel: ThemeProvider not available');
			return;
		}

		this._ThemeProvider.setNoiseLevel(pLevel);

		// Full re-render to apply new noise
		if (this.initialRenderComplete)
		{
			this.renderFlow();
		}
	}

	/**
	 * Get the current noise level (0 to 1).
	 * @returns {number}
	 */
	getNoiseLevel()
	{
		if (this._ThemeProvider)
		{
			return this._ThemeProvider.getNoiseLevel();
		}
		return 0;
	}

	/**
	 * Get the active theme key.
	 * @returns {string}
	 */
	getThemeKey()
	{
		if (this._ThemeProvider)
		{
			return this._ThemeProvider.getActiveThemeKey();
		}
		return 'default';
	}

	_reinjectMarkerDefs() { return this._RenderManager.reinjectMarkerDefs(); }

	/**
	 * Get a node by hash
	 * @param {string} pNodeHash
	 * @returns {Object|null}
	 */
	getNode(pNodeHash)
	{
		return this._FlowData.Nodes.find((pNode) => pNode.Hash === pNodeHash) || null;
	}

	/**
	 * Get a connection by hash
	 * @param {string} pConnectionHash
	 * @returns {Object|null}
	 */
	getConnection(pConnectionHash)
	{
		return this._FlowData.Connections.find((pConn) => pConn.Hash === pConnectionHash) || null;
	}

	/**
	 * Select a tether by its panel hash.
	 * @param {string|null} pPanelHash - Hash of the panel whose tether to select, or null to deselect
	 */
	selectTether(pPanelHash)
	{
		return this._SelectionManager.selectTether(pPanelHash);
	}

	// ---- Connection Handle Manager Delegations ----

	updateConnectionHandle(pConnectionHash, pHandleType, pX, pY) { return this._ConnectionHandleManager.updateConnectionHandle(pConnectionHash, pHandleType, pX, pY); }
	addConnectionHandle(pConnectionHash, pX, pY) { return this._ConnectionHandleManager.addConnectionHandle(pConnectionHash, pX, pY); }
	removeConnectionHandle(pConnectionHash, pIndex) { return this._ConnectionHandleManager.removeConnectionHandle(pConnectionHash, pIndex); }
	_resetHandlesForNode(pNodeHash) { return this._ConnectionHandleManager.resetHandlesForNode(pNodeHash); }
	_resetHandlesForPanel(pPanelHash) { return this._ConnectionHandleManager.resetHandlesForPanel(pPanelHash); }

	/**
	 * Add a bezier handle to a tether at the specified SVG position.
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	addTetherHandle(pPanelHash, pX, pY)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel || !this._TetherService) return;

		let tmpNode = this.getNode(tmpPanel.NodeHash);
		if (!tmpNode) return;

		let tmpAnchors = this._TetherService.getSmartAnchors(tmpPanel, tmpNode);

		this._TetherService.addHandle(tmpPanel, pX, pY, tmpAnchors.panelAnchor, tmpAnchors.nodeAnchor);

		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Remove a bezier handle from a tether by index.
	 * @param {string} pPanelHash
	 * @param {number} pIndex
	 */
	removeTetherHandle(pPanelHash, pIndex)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel || !this._TetherService) return;

		this._TetherService.removeHandle(tmpPanel, pIndex);

		this.renderFlow();
		this.marshalFromView();

		if (this._EventHandlerProvider)
		{
			this._EventHandlerProvider.fireEvent('onFlowChanged', this._FlowData);
		}
	}

	/**
	 * Update a tether handle position during drag (for real-time feedback).
	 * Delegates state update to the TetherService.
	 * @param {string} pPanelHash
	 * @param {string} pHandleType
	 * @param {number} pX
	 * @param {number} pY
	 */
	updateTetherHandle(pPanelHash, pHandleType, pX, pY)
	{
		let tmpPanel = this._FlowData.OpenPanels.find((pPanel) => pPanel.Hash === pPanelHash);
		if (!tmpPanel) return;

		if (this._TetherService)
		{
			this._TetherService.updateHandlePosition(tmpPanel, pHandleType, pX, pY);
		}

		this._renderSingleTether(pPanelHash);
	}

	/**
	 * Get a port's absolute position in SVG coordinates.
	 *
	 * For left and right side ports, positioning is offset below the title bar
	 * so that connection endpoints match the rendered port circles.
	 *
	 * @param {string} pNodeHash
	 * @param {string} pPortHash
	 * @returns {{x: number, y: number, side: string}|null}
	 */
	getPortPosition(pNodeHash, pPortHash)
	{
		let tmpNode = this.getNode(pNodeHash);
		if (!tmpNode) return null;

		let tmpPort = tmpNode.Ports.find((p) => p.Hash === pPortHash);
		if (!tmpPort) return null;

		// Count ports on the same side (matching both direction and side)
		let tmpSameSidePorts = tmpNode.Ports.filter((p) => p.Side === tmpPort.Side);
		let tmpPortIndex = tmpSameSidePorts.indexOf(tmpPort);
		let tmpPortCount = tmpSameSidePorts.length;

		let tmpTitleBarHeight = (this._NodeView && this._NodeView.options.NodeTitleBarHeight) || 28;

		// Use the adjusted node height that accounts for minimum port
		// spacing.  Connections render before nodes, so the node renderer
		// may not have written back its adjusted height yet.
		let tmpHeight = tmpNode.Height || 80;
		if (this._GeometryProvider && tmpNode.Ports && tmpNode.Ports.length > 0)
		{
			let tmpMinHeight = this._GeometryProvider.computeMinimumNodeHeight(tmpNode.Ports, tmpTitleBarHeight);
			if (tmpMinHeight > tmpHeight)
			{
				tmpHeight = tmpMinHeight;
			}
		}

		// Build port counts map for adaptive zone sizing
		let tmpPortCountsBySide = this._GeometryProvider.buildPortCountsBySide(tmpNode.Ports);

		let tmpLocal = this._GeometryProvider.getPortLocalPosition(tmpPort.Side, tmpPortIndex, tmpPortCount, tmpNode.Width, tmpHeight, tmpTitleBarHeight, tmpPortCountsBySide);

		return { x: tmpNode.X + tmpLocal.x, y: tmpNode.Y + tmpLocal.y, side: tmpPort.Side || 'right' };
	}

	/**
	 * Convert screen coordinates to SVG viewport coordinates
	 * @param {number} pScreenX
	 * @param {number} pScreenY
	 * @returns {{x: number, y: number}}
	 */
	screenToSVGCoords(pScreenX, pScreenY)
	{
		return this._ViewportManager.screenToSVGCoords(pScreenX, pScreenY);
	}

	// ---- Render Manager Delegations ----

	renderFlow() { return this._RenderManager.renderFlow(); }
	_renderSingleConnection(pConnectionHash) { return this._RenderManager.renderSingleConnection(pConnectionHash); }
	_renderSingleTether(pPanelHash) { return this._RenderManager.renderSingleTether(pPanelHash); }
	updateNodePosition(pNodeHash, pX, pY) { return this._RenderManager.updateNodePosition(pNodeHash, pX, pY); }
	_renderConnectionsForNode(pNodeHash) { return this._RenderManager.renderConnectionsForNode(pNodeHash); }
	_renderTethersForNode(pNodeHash) { return this._RenderManager.renderTethersForNode(pNodeHash); }

	// ---- Properties Panel Management ----

	/**
	 * Open a properties panel for a node.
	 * @param {string} pNodeHash - The hash of the node to open a panel for
	 * @returns {Object|false} The panel data, or false if the node has no PropertiesPanel config
	 */
	openPanel(pNodeHash)
	{
		return this._PanelManager.openPanel(pNodeHash);
	}

	/**
	 * Close a properties panel by panel hash.
	 * @param {string} pPanelHash
	 * @returns {boolean}
	 */
	closePanel(pPanelHash)
	{
		return this._PanelManager.closePanel(pPanelHash);
	}

	/**
	 * Close all panels for a given node.
	 * @param {string} pNodeHash
	 * @returns {boolean}
	 */
	closePanelForNode(pNodeHash)
	{
		return this._PanelManager.closePanelForNode(pNodeHash);
	}

	/**
	 * Toggle a properties panel for a node (open if closed, close if open).
	 * @param {string} pNodeHash
	 * @returns {Object|false}
	 */
	togglePanel(pNodeHash)
	{
		return this._PanelManager.togglePanel(pNodeHash);
	}

	/**
	 * Update a panel's position (for drag).
	 * @param {string} pPanelHash
	 * @param {number} pX
	 * @param {number} pY
	 */
	updatePanelPosition(pPanelHash, pX, pY)
	{
		return this._PanelManager.updatePanelPosition(pPanelHash, pX, pY);
	}
}

module.exports = PictViewFlow;

module.exports.default_configuration = _DefaultConfiguration;

},{"../PictFlowCardPropertiesPanel.js":30,"../panels/FlowCardPropertiesPanel-Form.js":31,"../panels/FlowCardPropertiesPanel-Markdown.js":32,"../panels/FlowCardPropertiesPanel-Template.js":33,"../panels/FlowCardPropertiesPanel-View.js":34,"../providers/PictProvider-Flow-CSS.js":35,"../providers/PictProvider-Flow-ConnectorShapes.js":36,"../providers/PictProvider-Flow-EventHandler.js":37,"../providers/PictProvider-Flow-Geometry.js":38,"../providers/PictProvider-Flow-Icons.js":39,"../providers/PictProvider-Flow-Layouts.js":40,"../providers/PictProvider-Flow-NodeTypes.js":41,"../providers/PictProvider-Flow-Noise.js":42,"../providers/PictProvider-Flow-PanelChrome.js":43,"../providers/PictProvider-Flow-SVGHelpers.js":44,"../providers/PictProvider-Flow-Theme.js":45,"../services/PictService-Flow-ConnectionHandleManager.js":46,"../services/PictService-Flow-ConnectionRenderer.js":47,"../services/PictService-Flow-DataManager.js":48,"../services/PictService-Flow-InteractionManager.js":49,"../services/PictService-Flow-Layout.js":50,"../services/PictService-Flow-PanelManager.js":51,"../services/PictService-Flow-PathGenerator.js":52,"../services/PictService-Flow-PortRenderer.js":53,"../services/PictService-Flow-RenderManager.js":54,"../services/PictService-Flow-SelectionManager.js":55,"../services/PictService-Flow-Tether.js":56,"../services/PictService-Flow-ViewportManager.js":57,"./PictView-Flow-FloatingToolbar.js":58,"./PictView-Flow-Node.js":59,"./PictView-Flow-PropertiesPanel.js":60,"./PictView-Flow-Toolbar.js":61,"pict-view":239}],63:[function(require,module,exports){
module.exports={
    "name": "pict-section-form",
    "version": "1.0.199",
    "description": "Pict dynamic form sections",
    "main": "source/Pict-Section-Form.js",
    "directories": {
        "test": "test"
    },
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-section-form.git"
    },
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-section-form/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-section-form#readme",
    "scripts": {
        "start": "node source/Pict-Section-Form.js",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "test": "npx quack test",
        "lint": "eslint source/**",
        "types": "tsc -p .",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-section-form-image:local",
        "docker-dev-run": "docker run -it -d --name pict-section-form-dev -p 48888:8080 -p 49999:9999 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-section-form\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-section-form-image:local",
        "docker-dev-shell": "docker exec -it pict-section-form-dev /bin/bash"
    },
    "types": "types/source/Pict-Section-Form.d.ts",
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "devDependencies": {
        "@eslint/js": "^9.39.2",
        "browser-env": "^3.3.0",
        "eslint": "^9.39.2",
        "jquery": "^4.0.0",
        "pict": "^1.0.372",
        "pict-application": "^1.0.34",
        "pict-docuserve": "^1.4.1",
        "pict-service-commandlineutility": "^1.0.19",
        "quackage": "^1.2.4",
        "tui-grid": "^4.21.22",
        "typescript": "^5.9.3"
    },
    "dependencies": {
        "chart.js": "^4.5.1",
        "fable-serviceproviderbase": "^3.0.19",
        "marked": "^4.3.0",
        "pict-provider": "^1.0.13",
        "pict-section-tuigrid": "^1.0.31",
        "pict-template": "^1.0.15",
        "pict-view": "^1.0.68"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    }
}

},{}],64:[function(require,module,exports){
// The container for all the Pict-Section-Form related code.

// The main dynamic view class
module.exports = require('./views/Pict-View-DynamicForm.js');
//module.exports.default_configuration = require('./views/Pict-View-DynamicForm-DefaultConfiguration.json');

// The dynamic application dependencies
module.exports.PictDynamicFormDependencyManager = require('./services/Pict-Service-DynamicFormDependencyManager.js');

// The base provider class for form section templates; meant to be subclassed
module.exports.PictFormTemplateProvider = require('./providers/Pict-Provider-DynamicTemplates.js');

// The base provider class for Input Extensions
module.exports.PictInputExtensionProvider = require('./providers/Pict-Provider-InputExtension.js');

// The metacontroller view
module.exports.PictFormMetacontroller = require('./views/Pict-View-Form-Metacontroller.js');

// The application container
module.exports.PictFormApplication = require('./application/Pict-Application-Form.js');

// The dynamic layout provider
module.exports.PictDynamicLayoutProvider = require('./providers/Pict-Provider-DynamicLayout.js');

// The ManifestFactory, for when we want to convert tabular data to configuration
module.exports.ManifestFactory = require('./services/ManifestFactory.js');
module.exports.ManifestConversionToCSV = require('./services/ManifestConversionToCSV.js');

// Reveal the support base class
module.exports.PictFormSupportBase = require('./views/support/Pict-View-PSF-SupportBase.js');

// The optional form persistence provider for offline data storage
module.exports.PictFormPersistenceProvider = require('./providers/Pict-Provider-FormPersistence.js');


// The extension views
module.exports.ExtensionViews = (
	{
		LifecycleVisualization: require('./views/support/Pict-View-PSF-LifeCycle-Visualization.js'),
		DebugViewer: require('./views/support/Pict-View-PSF-DebugViewer.js')
	});
},{"./application/Pict-Application-Form.js":65,"./providers/Pict-Provider-DynamicLayout.js":69,"./providers/Pict-Provider-DynamicTemplates.js":73,"./providers/Pict-Provider-FormPersistence.js":74,"./providers/Pict-Provider-InputExtension.js":76,"./services/ManifestConversionToCSV.js":105,"./services/ManifestFactory.js":106,"./services/Pict-Service-DynamicFormDependencyManager.js":107,"./views/Pict-View-DynamicForm.js":122,"./views/Pict-View-Form-Metacontroller.js":123,"./views/support/Pict-View-PSF-DebugViewer.js":126,"./views/support/Pict-View-PSF-LifeCycle-Visualization.js":127,"./views/support/Pict-View-PSF-SupportBase.js":130}],65:[function(require,module,exports){
const libPictApplication = require('pict-application');

const libPictSectionForm = require('../Pict-Section-Form.js');

/**
 * Represents a PictSectionFormApplication.
 *
 * This is the automagic controller for a dyncamic form application.
 *
 * @class
 * @extends libPictApplication
 */
class PictSectionFormApplication extends libPictApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & import('fable')} */
		this.pict;
		// Add the pict form service
		this.pict.addServiceType('PictSectionForm', libPictSectionForm);

		// Add the pict form metacontroller service, which provides programmaatic view construction from manifests and render/marshal methods.
		this.pict.addView('PictFormMetacontroller', {}, libPictSectionForm.PictFormMetacontroller);
	}

	/**
	 * Marshals data from any rendered dynamic views to application data.
	 */
	marshalDataFromDynamicViewsToAppData()
	{
		this.pict.views.PictFormMetacontroller.marshalFromView();
	}

	/**
	 * Marshals data from the application data to any rendered dynamic views.
	 */
	marshalDataFromAppDataToDynamicViews()
	{
		this.pict.views.PictFormMetacontroller.marshalToView();
	}
};

module.exports = PictSectionFormApplication

/** @type {Record<string, any>} */
module.exports.default_configuration = (
{
	"Name": "A Simple Pict Forms Application",
	"Hash": "PictFormsApp",

	"MainViewportViewIdentifier": "PictFormMetacontroller",
	"AutoSolveAfterInitialize": false,

	"pict_configuration":
		{
			"Product": "PictDefaultFormsApp"
		}
});

},{"../Pict-Section-Form.js":64,"pict-application":7}],66:[function(require,module,exports){
const libPictProvider = require('pict-provider');

// TODO: Pull this back to pict as a core service once we are happy with the shape.
/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-SolverBehaviors",

	"AutoInitialize": false,
	"AutoInitializeOrdinal": 0,
	"AutoSolveWithApp": false
});

/**
 * Provides functions available in the solver for manipulating the form.
 * Such as showing/hiding sections, inputs, groups.  Coloring inputs,
 * sections, groups.  Applying styles to inputs, sections, groups.
 * Extends the `libPictProvider` class.
 */
class PictDynamicFormsSolverBehaviors extends libPictProvider
{
	/**
	 * Creates an instance of the `PictDynamicFormsInformary` class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { newManyfest: (options: any) => import('manyfest') }} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {string} */
		this.cssHideSectionClass = 'pict-section-form-hidden-section';
		this.cssHideGroupClass = 'pict-section-form-hidden-group';
		/** @type {string} */
		this.cssTabularRowHighlightClass = 'pict-tabular-row-highlight';
		/** @type {string} */
		this.cssTabularColumnHighlightClass = 'pict-tabular-column-highlight';
		this.cssSnippet = '.pict-section-form-hidden-section { display: none; } .pict-section-form-hidden-group { display: none; }'
			// Row/column highlight classes used by the highlighttabularrow / highlighttabularcolumn solvers.
			// !important so the highlight beats host table-striping CSS; the color solvers set
			// inline-important styles which in turn beat these (inline-important > stylesheet-important).
			+ ' .pict-tabular-row-highlight > td, .pict-tabular-row-highlight > th { background-color: var(--pict-tabular-highlight-color, #FFF3CD) !important; }'
			+ ' td.pict-tabular-column-highlight, th.pict-tabular-column-highlight { background-color: var(--pict-tabular-highlight-color, #FFF3CD) !important; }';

		this.solverOrdinalMap = {};

		this.setCSSSnippets();
	}

	setCSSSnippets(pCSSHideClass, pCSSSnippet)
	{
		this.cssHideClass = pCSSHideClass || this.cssHideClass;
		this.cssSnippet = pCSSSnippet || this.cssSnippet;
		this.pict.CSSMap.addCSS('Pict-Section-Form-SolverBehaviors', this.cssSnippet, 1001, 'Pict-DynamicForm-SolverBehaviors');
		this.pict.CSSMap.injectCSS();
	}

	addSolverFunction(pExpressionParser, pFunctionName, pFunctionAddress, pFunctionComment, pAddressParameterIndices)
	{
		let tmpFunctionName = (pFunctionName || '').trim().toLowerCase();
		if (pExpressionParser.functionMap.hasOwnProperty(tmpFunctionName))
		{
			this.log.warn(`PictDynamicFormsInformary: Function ${tmpFunctionName} already exists in the solver, overwriting with address [${pFunctionAddress}].`);
			//return false;
		}
		let tmpFunctionEntry = (
		{
			Name: pFunctionComment || `Autogenerated function ${tmpFunctionName}`,
			Address: pFunctionAddress,
		});
		if (Array.isArray(pAddressParameterIndices) && pAddressParameterIndices.length > 0)
		{
			tmpFunctionEntry.AddressParameterIndices = pAddressParameterIndices;
		}
		pExpressionParser.functionMap[tmpFunctionName] = tmpFunctionEntry;
	}

	runSolvers()
	{
		const tmpViewHashes = this.pict.providers.DynamicSolver.solveViews(undefined, true);
		/* TODO: since this is always run from a solve, I don't think we need to do an extra marshal here
		if (this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			for (let i = 0; i < tmpViewHashes.length; i++)
			{
				const tmpViewHash = tmpViewHashes[i];
				this.pict.views[tmpViewHash]?.marshalToView?.();
			}
		}
		*/
	}

	injectBehaviors(pExpressionParser)
	{
		// Wire up the solver functions.
		this.addSolverFunction(pExpressionParser, 'logvalues', 'fable.providers.DynamicFormSolverBehaviors.logValues', 'Logs a set of values to the console and returns the last one.');

		this.addSolverFunction(pExpressionParser, 'unionarrays', 'fable.providers.DynamicFormSolverBehaviors.unionArrays', 'Return the union of two arrays.');
		this.addSolverFunction(pExpressionParser, 'differencearrays', 'fable.providers.DynamicFormSolverBehaviors.differenceArrays', 'Return the difference of two arrays.');
		this.addSolverFunction(pExpressionParser, 'uniquearray', 'fable.providers.DynamicFormSolverBehaviors.uniqueArray', 'Return a new array with only unique values from the input array.');
		this.addSolverFunction(pExpressionParser, 'sortarray', 'fable.providers.DynamicFormSolverBehaviors.sortArray', 'Returns a sorted array from the input array.');

		this.addSolverFunction(pExpressionParser, 'showsections', 'fable.providers.DynamicFormSolverBehaviors.showSections', 'Shows sections based on hashes in an array.', [0]);
		this.addSolverFunction(pExpressionParser, 'hidesections', 'fable.providers.DynamicFormSolverBehaviors.hideSections', 'Hides sections based on hashes in an array.', [0]);

		this.addSolverFunction(pExpressionParser, 'setsectionvisibility', 'fable.providers.DynamicFormSolverBehaviors.setSectionVisibility', 'Sets a sections visiblity to true or fales based on the second parameter.', [0]);
		this.addSolverFunction(pExpressionParser, 'setgroupvisibility', 'fable.providers.DynamicFormSolverBehaviors.setGroupVisibility', 'Sets a group visiblity to true or fales based on the third parameter.', [0, 1]);

		this.addSolverFunction(pExpressionParser, 'generatehtmlhexcolor', 'fable.providers.DynamicFormSolverBehaviors.generateHTMLHexColor', 'Generates a HTML hex color from three integer parameters (red, green, blue).');

		this.addSolverFunction(pExpressionParser, 'colorsectionbackground', 'fable.providers.DynamicFormSolverBehaviors.colorSectionBackground', 'Colors a section background with a HTML hex color (e.g. #FF0000 for red).', [0]);
		this.addSolverFunction(pExpressionParser, 'colorgroupbackground', 'fable.providers.DynamicFormSolverBehaviors.colorGroupBackground', 'Colors a group background with a HTML hex color (e.g. #FF0000 for red).', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colorinputbackground', 'fable.providers.DynamicFormSolverBehaviors.colorInputBackground', 'Colors an input background with a HTML hex color (e.g. #FF0000 for red).', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colorinputbackgroundtabular', 'fable.providers.DynamicFormSolverBehaviors.colorInputBackgroundTabular', 'Colors a tabular input background with a HTML hex color (e.g. #FF0000 for red).', [0, 1, 2]);

		// Whole-row and whole-column highlight/color for tabular groups. The highlight pair toggles a
		// CSS class across every cell of a row/column based on a 1/0 flag; the color pair sets (1) or
		// clears (0) an inline background color. None of these touch form data -- purely presentational.
		this.addSolverFunction(pExpressionParser, 'highlighttabularrow', 'fable.providers.DynamicFormSolverBehaviors.highlightTabularRow', 'Adds (1) or removes (0) a highlight class on every cell of a tabular row.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'highlighttabularcolumn', 'fable.providers.DynamicFormSolverBehaviors.highlightTabularColumn', 'Adds (1) or removes (0) a highlight class on every cell of a tabular column.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colortabularrow', 'fable.providers.DynamicFormSolverBehaviors.colorTabularRow', 'Sets (1) or clears (0) the background color on every cell of a tabular row.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'colortabularcolumn', 'fable.providers.DynamicFormSolverBehaviors.colorTabularColumn', 'Sets (1) or clears (0) the background color on every cell of a tabular column.', [0, 1]);

		this.addSolverFunction(pExpressionParser, 'setsolverordinalenabled', 'fable.providers.DynamicFormSolverBehaviors.setSolverOrdinalEnabled', 'Enables or disabled a solver ordinal to determine if it should run.');
		this.addSolverFunction(pExpressionParser, 'enablesolverordinal', 'fable.providers.DynamicFormSolverBehaviors.enableSolverOrdinal', 'Enables a solver ordinal so that it can run.');
		this.addSolverFunction(pExpressionParser, 'disablesolverordinall', 'fable.providers.DynamicFormSolverBehaviors.disableSolverOrdinal', 'Disables a solver ordinal so that it will not run.');

		this.addSolverFunction(pExpressionParser, 'settabularrowlength', 'fable.providers.DynamicFormSolverBehaviors.setTabularRowLength', 'Sets the length of a tabular data set.', [0, 1]);
		this.addSolverFunction(pExpressionParser, 'runsolvers', 'fable.providers.DynamicFormSolverBehaviors.runSolvers', 'Solves all views.');
		this.addSolverFunction(pExpressionParser, 'refreshtabularsection', 'fable.providers.DynamicFormSolverBehaviors.refreshTabularSection', 'Causes a tabular section to refresh its display.', [0, 1]);

		// Scope data access functions for cross-section and global data resolution
		this.addSolverFunction(pExpressionParser, 'getglobalformdata', 'fable.providers.DynamicFormSolverBehaviors.getGlobalFormData', 'Gets a value from the global form data by hash.');
		this.addSolverFunction(pExpressionParser, 'resolveglobalformdata', 'fable.providers.DynamicFormSolverBehaviors.resolveGlobalFormData', 'Resolves a value from the global form data by manyfest address.');
		this.addSolverFunction(pExpressionParser, 'getsectionformdata', 'fable.providers.DynamicFormSolverBehaviors.getSectionFormData', 'Gets a value from a specific section by hash or address.', [0]);
		this.addSolverFunction(pExpressionParser, 'getsectiontabularformdata', 'fable.providers.DynamicFormSolverBehaviors.getSectionTabularFormData', 'Gets a value from a specific tabular section row by hash or address.', [0, 1]);

		// Comprehension generation -- writes a single Property/Value into the configured comprehension destination
		// nested as Context -> Entity -> GUID -> Property.  Context is treated as a manyfest address so dotted
		// contexts like "OnApprovalAction.Approve" produce nested context branches.  See docs/Comprehensions.md.
		this.addSolverFunction(pExpressionParser, 'addcomprehensionentity', 'fable.providers.DynamicFormSolverBehaviors.addComprehensionEntity', 'Writes a property/value into the configured comprehension destination, nested as Context -> Entity -> GUID -> Property.');

		return false;
	}

	// TODO: These array functions probably belong in fable as core utilities; move them back later
	/**
	 * Returns a new array containing the union of two input arrays, removing duplicate values.
	 *
	 * @param {Array} pArrayA - The first array to union.
	 * @param {Array} pArrayB - The second array to union.
	 * @returns {Array} A new array containing unique elements from both input arrays.
	 */
	unionArrays(pArrayA, pArrayB)
	{
		let tmpSet = new Set();

		if (Array.isArray(pArrayA))
		{
			for (let i = 0; i < pArrayA.length; i++)
			{
				tmpSet.add(pArrayA[i]);
			}
		}

		if (Array.isArray(pArrayB))
		{
			for (let i = 0; i < pArrayB.length; i++)
			{
				tmpSet.add(pArrayB[i]);
			}
		}

		return Array.from(tmpSet);
	}

	/**
	 * Returns an array containing the elements that are present in the first array but not in the second array.
	 *
	 * @param {Array} pArrayA - The array from which to subtract elements.
	 * @param {Array} pArrayB - The array containing elements to exclude from the first array.
	 * @returns {Array} An array of elements found in pArrayA but not in pArrayB.
	 */
	differenceArrays(pArrayA, pArrayB)
	{
		let tmpSetA = new Set();
		let tmpSetB = new Set();

		if (Array.isArray(pArrayA))
		{
			for (let i = 0; i < pArrayA.length; i++)
			{
				tmpSetA.add(pArrayA[i]);
			}
		}

		if (Array.isArray(pArrayB))
		{
			for (let i = 0; i < pArrayB.length; i++)
			{
				tmpSetB.add(pArrayB[i]);
			}
		}

		let tmpResultSet = new Set();

		tmpSetA.forEach(
			(pValue) =>
			{
				if (!tmpSetB.has(pValue))
				{
					tmpResultSet.add(pValue);
				}
			}
		);

		return Array.from(tmpResultSet);
	}

	/**
	 * Returns a new array containing only the unique elements from the input array.
	 *
	 * @param {Array} pArray - The array from which to extract unique elements.
	 * @returns {Array} A new array with duplicate values removed.
	 */
	uniqueArray(pArray)
	{
		let tmpSet = new Set();

		if (Array.isArray(pArray))
		{
			for (let i = 0; i < pArray.length; i++)
			{
				tmpSet.add(pArray[i]);
			}
		}

		return Array.from(tmpSet);
	}

	/**
	 * Sorts the given array in place using the default sort order.
	 * If the input is not an array, returns an empty array.
	 *
	 * @param {Array} pArray - The array to be sorted.
	 * @returns {Array} The sorted array, or an empty array if input is not an array.
	 */
	sortArray(pArray)
	{
		if (!Array.isArray(pArray))
		{
			return [];
		}

		return pArray.sort();
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 * @param {boolean|string|number} pEnabled
	 */
	setSolverOrdinalEnabled(pSolverOrdinal, pEnabled)
	{
		this.solverOrdinalMap[`ORD-${pSolverOrdinal}`] = pEnabled == true || pEnabled == '1';
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 */
	enableSolverOrdinal(pSolverOrdinal)
	{
		this.solverOrdinalMap[`ORD-${pSolverOrdinal}`] = true;
	}

	/**
	 * @param {number|string} pSolverOrdinal
	 */
	disableSolverOrdinal(pSolverOrdinal)
	{
		this.solverOrdinalMap[`ORD-${pSolverOrdinal}`] = false;
	}

	/**
	 * @param {number|string} pSolveOrdinal
	 *
	 * @return {boolean}
	 */
	checkSolverOrdinalEnabled(pSolveOrdinal)
	{
		let tmpOrdinalKey = `ORD-${pSolveOrdinal}`;
		return (!(tmpOrdinalKey in this.solverOrdinalMap)) || (this.solverOrdinalMap[tmpOrdinalKey] === true);
	}

	getSectionSelector(pSectionFormID)
	{
		return `#SECTION-${pSectionFormID}`;
	}

	setSectionVisibility(pSectionHash, pVisible)
	{
		if (pVisible != "0")
		{
			return this.showSection(pSectionHash);
		}
		else
		{
			return this.hideSection(pSectionHash);
		}
	}

	/**
	 * Shows multiple sections by their hash identifiers.
	 *
	 * Iterates over the provided array of section hash values and calls `showSection`
	 * for each one to display the corresponding section.
	 *
	 * @param {string | Array<string>} pSectionHashArray - An array of section hash strings to be shown.
	 */
	showSections(pSectionHashArray)
	{
		const tmpSectionHashArray = Array.isArray(pSectionHashArray) ? pSectionHashArray : [pSectionHashArray];
		for (let i = 0; i < tmpSectionHashArray.length; i++)
		{
			this.showSection(tmpSectionHashArray[i]);
		}
	}

	/**
	 * Hides multiple sections specified by their hash values.
	 *
	 * Iterates over the provided array of section hashes and hides each section
	 * by calling the `hideSection` method for each hash.
	 *
	 * @param {string | Array<string>} pSectionHashArray - An array of section hash strings to be hidden.
	 */
	hideSections(pSectionHashArray)
	{
		const tmpSectionHashArray = Array.isArray(pSectionHashArray) ? pSectionHashArray : [pSectionHashArray];
		for (let i = 0; i < tmpSectionHashArray.length; i++)
		{
			this.hideSection(tmpSectionHashArray[i]);
		}
	}

	/* THESE DO NOT BELONG HERE BUT THIS WORKS FOR NOW */
	hideSection(pSectionHash)
	{
		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsInformary: hideSection could not find section with hash [${pSectionHash}].`);
			return false;
		}

		if (this.pict.ContentAssignment.hasClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass))
		{
			// Already hidden.
			return true;
		}

		this.pict.ContentAssignment.addClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass);
		return true;
	}

	showSection(pSectionHash)
	{
		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsInformary: showSection could not find section with hash [${pSectionHash}].`);
			return false;
		}

		if (!this.pict.ContentAssignment.hasClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass))
		{
			// Already visible.
			return true;
		}

		this.pict.ContentAssignment.removeClass(this.getSectionSelector(tmpSectionView.formID), this.cssHideSectionClass);
		return true;
	}

	getGroupSelector(pSectionFormID, pGroupHash)
	{
		return `#GROUP-${pSectionFormID}-${pGroupHash}`;
	}

	setGroupVisibility(pSectionHash, pGroupHash, pVisible)
	{
		if (pVisible != "0")
		{
			return this.showGroup(pSectionHash, pGroupHash);
		}
		else
		{
			return this.hideGroup(pSectionHash, pGroupHash);
		}
	}

	hideGroup(pSectionHash, pGroupHash)
	{
		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: hideGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		if (this.pict.ContentAssignment.hasClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass))
		{
			// Already hidden.
			return true;
		}

		this.pict.ContentAssignment.addClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass);
		return true;
	}

	showGroup(pSectionHash, pGroupHash)
	{
		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: showGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		if (!this.pict.ContentAssignment.hasClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass))
		{
			// Already visible.
			return true;
		}

		this.pict.ContentAssignment.removeClass(this.getGroupSelector(tmpGroupView.formID, pGroupHash), this.cssHideGroupClass);
		return true;
	}

	/**
	 * Causes a tabular section to refresh its display
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group
	 * @param {string} pGroupHash - The hash of the tabular group
	 *
	 * @return {void}
	 */
	refreshTabularSection(pSectionHash, pGroupHash)
	{
		const tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: showGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return;
		}
		const tmpGroupIndex = tmpGroupView.getGroupIndexFromHash(pGroupHash);
		if (tmpGroupIndex < 0)
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return;
		}
		const tmpGroup = tmpGroupView.getGroup(tmpGroupIndex);

		if (tmpGroup)
		{
			// Also render any other views that have this as the RecordSetAddress
			// Filter the views by each Group.RecordSetAddress and find the ones with this RecordSetAddress
			const tmpViewsToRender = this.pict.views.PictFormMetacontroller.filterViews(
				/** @param {import('../views/Pict-View-DynamicForm.js')} pViewToTestForGroup */
				(pViewToTestForGroup) =>
				{
					if (!pViewToTestForGroup.isPictSectionForm)
					{
						return false;
					}
					const tmpGroupsToTest = pViewToTestForGroup.getGroups();
					for (let i = 0; i < tmpGroupsToTest.length; i++)
					{
						if (tmpGroupsToTest[i].RecordSetAddress == tmpGroup.RecordSetAddress)
						{
							return true;
						}
					}
					return false;
				}
			)
			// We expect this view to be in the set.
			for (let i = 0; i < tmpViewsToRender.length; i++)
			{
				tmpViewsToRender[i].render();
			}

			//NOTE: not running a solve, since this is run from the solver; if you need a solve, call runSolvers()

			// We've re-rendered but we don't know what needs to be marshaled
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
	}

	/**
	 * Set the length of a tabular set
	 * @param {string} pSectionHash - The hash of the section containing the tabular group
	 * @param {string} pGroupHash - The hash of the tabular group
	 * @param {number|string} pLength - The desired length of the tabular set
	 * @param {boolean|string} pDeleteExtraRows - If true, will delete extra rows from the end if the length is less than current 
	 * @returns 
	 */
	setTabularRowLength(pSectionHash, pGroupHash, pLength, pDeleteExtraRows = false)
	{
		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: showGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}
		let tmpGroupIndex = tmpGroupView.getGroupIndexFromHash(pGroupHash);
		if (tmpGroupIndex < 0)
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}
		let tmpTabularRecordSet = tmpGroupView.getTabularRecordSet(tmpGroupIndex);
		if (!tmpTabularRecordSet || !Array.isArray(tmpTabularRecordSet))
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength could not find a valid tabular record set with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		let tmpLength = parseInt(pLength.toString());
		if (isNaN(tmpLength) || tmpLength < 0)
		{
			this.log.warn(`PictDynamicFormsInformary: setTabularRowLength was given an invalid length [${pLength}] with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		// See if the length is less than what we have
		let tmpCurrentLength = tmpTabularRecordSet.length;

		let tmpDeleteExtraRows = (pDeleteExtraRows == true || pDeleteExtraRows == '1');

		if (tmpLength > tmpCurrentLength)
		{
			// Add rows until we are at the expected length
			for (let i = tmpCurrentLength; i < tmpLength; i++)
			{
				tmpGroupView.createDynamicTableRow(tmpGroupIndex);
			}
		}
		else if (tmpLength < tmpCurrentLength && tmpDeleteExtraRows)
		{
			// Remove rows from the end until we are at the expected length
			for (let i = tmpCurrentLength - 1; i >= tmpLength; i--)
			{
				tmpGroupView.deleteDynamicTableRow(tmpGroupIndex, i);
			}
		}
	}


	generateHTMLHexColor(pRed, pGreen, pBlue)
	{
		let tmpRed = (parseInt(pRed) || 0);
		let tmpGreen = (parseInt(pGreen) || 0);
		let tmpBlue = (parseInt(pBlue) || 0);

		if (tmpRed < 0) { tmpRed = 0; }
		if (tmpRed > 255) { tmpRed = 255; }
		if (tmpGreen < 0) { tmpGreen = 0; }
		if (tmpGreen > 255) { tmpGreen = 255; }
		if (tmpBlue < 0) { tmpBlue = 0; }
		if (tmpBlue > 255) { tmpBlue = 255; }

		let tmpRedHex = tmpRed.toString(16).toUpperCase();
		if (tmpRedHex.length < 2) { tmpRedHex = `0${tmpRedHex}`; }
		let tmpGreenHex = tmpGreen.toString(16).toUpperCase();
		if (tmpGreenHex.length < 2) { tmpGreenHex = `0${tmpGreenHex}`; }
		let tmpBlueHex = tmpBlue.toString(16).toUpperCase();
		if (tmpBlueHex.length < 2) { tmpBlueHex = `0${tmpBlueHex}`; }

		return `#${tmpRedHex}${tmpGreenHex}${tmpBlueHex}`;
	}

	colorSectionBackground(pSectionHash, pColor, pApplyChange)
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorSection could not find section with hash [${pSectionHash}].`);
			return false;
		}

		let tmpElementSet = this.pict.ContentAssignment.getElement(this.getSectionSelector(tmpSectionView.formID));

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorSection could not find section element with hash [${pSectionHash}] selector [${this.getSectionSelector(tmpSectionView.formID)}].`);
			return false;
		}

		let tmpElement = tmpElementSet[0];

		tmpElement.style.backgroundColor = pColor;

		return true;
	}

	colorGroupBackground(pSectionHash, pGroupHash, pColor, pApplyChange)
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		let tmpGroupView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash)
		if (!tmpGroupView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorGroup could not find group with section hash [${pSectionHash}] group [${pGroupHash}].`);
			return false;
		}

		let tmpElementSet = this.pict.ContentAssignment.getElement(this.getGroupSelector(tmpGroupView.formID, pGroupHash));

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorGroup could not find group element with section hash [${pSectionHash}] group [${pGroupHash}] selector [${this.getGroupSelector(tmpGroupView.formID, pGroupHash)}].`);
			return false;
		}

		let tmpElement = tmpElementSet[0];
		tmpElement.style.backgroundColor = pColor;

		return true;
	}

	/**
	 * Colors an input background or its container with a HTML hex color (e.g. #FF0000 for red).
	 * @param {string} pSectionHash - The hash of the section containing the input.
	 * @param {string} pInputHash - The hash of the input to color.
	 * @param {string} pColor - The HTML hex color to apply (e.g. #FF0000 for red).
	 * @param {string} pApplyChange - If "0", the change will not be applied.
	 * @param {string} [pCSSSelector] - Optional. If provided, the color will be applied to the closest element matching this selector instead of the input itself.
	 * @returns {boolean} - Returns true if the color was applied successfully or if the change was skipped for pApplyChange equal to "0", false otherwise.
	 */
	colorInputBackground(pSectionHash, pInputHash, pColor, pApplyChange, pCSSSelector)
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		let tmpInputView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);

		if (!tmpInputView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInput could not find input with section hash [${pSectionHash}] input [${pInputHash}].`);
			return false;
		}

		let tmpInput = tmpInputView.getInputFromHash(pInputHash);

		if (!tmpInput)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInput could not find input with section hash [${pSectionHash}] input [${pInputHash}].`);
			return false;
		}

		let tmpElementSet = this.pict.ContentAssignment.getElement(tmpInput.Macro.HTMLSelectorControl);

		if (tmpElementSet.length < 1)
		{
			tmpElementSet = this.pict.ContentAssignment.getElement(`#${tmpInput.Macro.RawHTMLID}`);
		}

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInput could not find input element with section hash [${pSectionHash}] input [${pInputHash}] selector [#${tmpInput.Macro.RawHTMLID}].`);
			return false;
		}

		return this.colorElementBackground(tmpElementSet, pColor, pCSSSelector);
	}

	/**
	 * Colors an input background or its container with a HTML hex color (e.g. #FF0000 for red).
	 * @param {string} pSectionHash - The hash of the section containing the input.
	 * @param {string} pGroupHash - The hash of the group containing the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pInputHash - The hash of the input to color.
	 * @param {string} pColor - The HTML hex color to apply (e.g. #FF0000 for red).
	 * @param {string} pApplyChange - If "0", the change will not be applied.
	 * @param {string} [pCSSSelector] - Optional. If provided, the color will be applied to the closest element matching this selector instead of the input itself.
	 * @param {string} [pElementIDPrefix] - Optional. The prefix for the tabular element ID. Default is 'TABULAR-DATA-'.
	 * @returns {boolean} - Returns true if the color was applied successfully or if the change was skipped for pApplyChange equal to "0", false otherwise.
	 */
	colorInputBackgroundTabular(pSectionHash, pGroupHash, pInputHash, pRowIndex, pColor, pApplyChange, pCSSSelector, pElementIDPrefix = 'TABULAR-DATA-')
	{
		if (pApplyChange == "0")
		{
			return true;
		}

		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		let tmpInputView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);

		if (!tmpInputView)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular could not find input with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}].`);
			return false;
		}

		let tmpInput = tmpInputView.getTabularRecordInputByHash(pGroupHash, pInputHash);

		if (!tmpInput)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular could not find input with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}].`);
			return false;
		}

		if (!tmpInput.Macro)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular input with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}] is missing Macro data.`);
			return false;
		}

		//FIXME: how do we get the input decorated with the index?
		const tmpControlHTMLSelector = tmpInput.Macro.HTMLSelectorControlTabular + `[data-i-index="${pRowIndex}"]`;
		let tmpElementSet = this.pict.ContentAssignment.getElement(tmpControlHTMLSelector);

		if (tmpElementSet.length < 1)
		{
			//FIXME: is this reliable for all input types? (no)
			tmpElementSet = this.pict.ContentAssignment.getElement(`#${pElementIDPrefix}${tmpInput.Macro.RawHTMLID}-${pRowIndex}`);
		}

		if (tmpElementSet.length < 1)
		{
			this.log.warn(`PictDynamicFormsInformary: colorInputBackgroundTabular could not find input element with section hash [${pSectionHash}] group hash [${pGroupHash}] input hash [${pInputHash}] row index [${pRowIndex}] selector [#${tmpInput.Macro.RawHTMLID}-${pRowIndex}].`);
			return false;
		}

		return this.colorElementBackground(tmpElementSet, pColor, pCSSSelector);
	}

	/**
	 * @param {Array<HTMLElement>} pElementSet - The element to color.
	 * @param {string} pColor - The HTML hex color to apply (e.g. #FF0000 for red).
	 * @param {string} [pCSSSelector] - Optional. If provided, the color will be applied to the closest element matching this selector instead of the input itself.
	 *
	 * @returns {boolean}
	 */
	colorElementBackground(pElementSet, pColor, pCSSSelector)
	{
		/** @type {HTMLElement} */
		let tmpElement = pElementSet[0];

		// if we passed a class target, find the closest element with that class and apply the color to it
		// otherwise, just apply it to the input element itself
		if (pCSSSelector)
		{
			// find closest target by class name and if we find it, immediately break out of the loop
			for (let i = 0; i < pElementSet.length; i++)
			{
				const element = pElementSet[i];
				const closest = element.closest(`${pCSSSelector}`);
				if (closest && closest instanceof HTMLElement)
				{
					tmpElement = closest;
					break;
				}
			}
		}

		tmpElement.style.backgroundColor = pColor;

		return true;
	}

	/**
	 * Interprets a solver-supplied 1/0 (or true/false) flag.
	 *
	 * Solver numbers arrive as arbitrary-precision strings, so a plain truthiness
	 * check would treat the string "0" as true. This normalizes the common
	 * "off" representations to false and everything else to true.
	 *
	 * @param {any} pFlag
	 * @returns {boolean}
	 */
	isSolverFlagEnabled(pFlag)
	{
		return (pFlag != null)
			&& (pFlag !== false)
			&& (pFlag !== 0)
			&& (pFlag !== '0')
			&& (pFlag !== '')
			&& (pFlag !== 'false');
	}

	/**
	 * Resolves the DOM selector for a tabular group's container div.
	 *
	 * The tabular group div carries `id="GROUP-<formID>-<groupHash>"` (the same
	 * convention the non-tabular group layout uses), so highlight/color solvers
	 * can scope their cell queries to a single group.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @returns {string|null} A CSS selector for the group container, or null if unresolved.
	 */
	getTabularGroupSelector(pSectionHash, pGroupHash)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('PictDynamicFormsSolverBehaviors: getTabularGroupSelector has no PictFormMetacontroller.');
			return null;
		}
		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);
		if (!tmpSectionView)
		{
			this.log.warn(`PictDynamicFormsSolverBehaviors: getTabularGroupSelector could not find section view with hash [${pSectionHash}].`);
			return null;
		}
		return `#GROUP-${tmpSectionView.formID}-${pGroupHash}`;
	}

	/**
	 * Adds (pApplyFlag truthy) or removes (pApplyFlag falsy) a highlight class on
	 * every cell of a tabular row -- the row labels, editing controls and data
	 * cells all get the class because it lands on the row's `<tr>`.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pRowIndex - The zero-based row index.
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- add or remove the class.
	 * @param {string} [pHighlightClass] - Optional override for the class name.
	 * @returns {boolean}
	 */
	highlightTabularRow(pSectionHash, pGroupHash, pRowIndex, pApplyFlag, pHighlightClass)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpClass = (typeof pHighlightClass === 'string' && pHighlightClass.length > 0) ? pHighlightClass : this.cssTabularRowHighlightClass;
		let tmpRowSelector = `${tmpGroupSelector} tr[data-tabular-row-index="${pRowIndex}"]`;
		if (this.isSolverFlagEnabled(pApplyFlag))
		{
			this.pict.ContentAssignment.addClass(tmpRowSelector, tmpClass);
		}
		else
		{
			this.pict.ContentAssignment.removeClass(tmpRowSelector, tmpClass);
		}
		return true;
	}

	/**
	 * Adds (pApplyFlag truthy) or removes (pApplyFlag falsy) a highlight class on
	 * every cell of a tabular column -- both the `<th>` header cell and every
	 * `<td>` data cell that carries the matching `data-tabular-column-index`.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pColumnIndex - The column's input index (descriptor InputIndex).
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- add or remove the class.
	 * @param {string} [pHighlightClass] - Optional override for the class name.
	 * @returns {boolean}
	 */
	highlightTabularColumn(pSectionHash, pGroupHash, pColumnIndex, pApplyFlag, pHighlightClass)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpClass = (typeof pHighlightClass === 'string' && pHighlightClass.length > 0) ? pHighlightClass : this.cssTabularColumnHighlightClass;
		let tmpColumnSelector = `${tmpGroupSelector} [data-tabular-column-index="${pColumnIndex}"]`;
		if (this.isSolverFlagEnabled(pApplyFlag))
		{
			this.pict.ContentAssignment.addClass(tmpColumnSelector, tmpClass);
		}
		else
		{
			this.pict.ContentAssignment.removeClass(tmpColumnSelector, tmpClass);
		}
		return true;
	}

	/**
	 * Sets (pApplyFlag truthy) or clears (pApplyFlag falsy) an inline background
	 * color on every data cell of a tabular row.
	 *
	 * The color is applied with `important` priority so it beats both host
	 * table-striping CSS and the highlight classes.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pRowIndex - The zero-based row index.
	 * @param {string} pColor - The HTML color to apply (e.g. #FF0000).
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- apply or clear the color.
	 * @returns {boolean}
	 */
	colorTabularRow(pSectionHash, pGroupHash, pRowIndex, pColor, pApplyFlag)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpApply = this.isSolverFlagEnabled(pApplyFlag) && (typeof pColor === 'string') && (pColor.length > 0);
		let tmpElementSet = this.pict.ContentAssignment.getElement(`${tmpGroupSelector} tr[data-tabular-row-index="${pRowIndex}"] td`);
		for (let i = 0; i < tmpElementSet.length; i++)
		{
			if (tmpApply)
			{
				tmpElementSet[i].style.setProperty('background-color', pColor, 'important');
			}
			else
			{
				tmpElementSet[i].style.removeProperty('background-color');
			}
		}
		return true;
	}

	/**
	 * Sets (pApplyFlag truthy) or clears (pApplyFlag falsy) an inline background
	 * color on every cell of a tabular column -- header `<th>` plus all data `<td>`.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pColumnIndex - The column's input index (descriptor InputIndex).
	 * @param {string} pColor - The HTML color to apply (e.g. #FF0000).
	 * @param {number|string|boolean} pApplyFlag - 1/0 (or true/false) -- apply or clear the color.
	 * @returns {boolean}
	 */
	colorTabularColumn(pSectionHash, pGroupHash, pColumnIndex, pColor, pApplyFlag)
	{
		let tmpGroupSelector = this.getTabularGroupSelector(pSectionHash, pGroupHash);
		if (!tmpGroupSelector)
		{
			return false;
		}
		let tmpApply = this.isSolverFlagEnabled(pApplyFlag) && (typeof pColor === 'string') && (pColor.length > 0);
		let tmpElementSet = this.pict.ContentAssignment.getElement(`${tmpGroupSelector} [data-tabular-column-index="${pColumnIndex}"]`);
		for (let i = 0; i < tmpElementSet.length; i++)
		{
			if (tmpApply)
			{
				tmpElementSet[i].style.setProperty('background-color', pColor, 'important');
			}
			else
			{
				tmpElementSet[i].style.removeProperty('background-color');
			}
		}
		return true;
	}

	/**
	 * Gets a value from the global form data by hash, falling back to address resolution
	 * using the global manyfest from the metacontroller.
	 *
	 * @param {string} pHash - The hash to resolve from the global form data.
	 * @returns {any} The value at the hash, or undefined if not found.
	 */
	getGlobalFormData(pHash)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('getGlobalFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpMarshalDestination = this.pict.views.PictFormMetacontroller.viewMarshalDestination;
		let tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestination);

		if ((typeof(tmpMarshalDestinationObject) !== 'object') || (tmpMarshalDestinationObject === null))
		{
			tmpMarshalDestinationObject = this.pict.AppData;
		}

		// Use the global pict manifest which has all descriptors added during bootstrapPictFormViewsFromManifest
		return this.pict.manifest.getValueByHash(tmpMarshalDestinationObject, pHash);
	}

	/**
	 * Resolves a value from the global form data by manyfest address,
	 * using the global manyfest from the metacontroller and the viewMarshalDestination.
	 *
	 * @param {string} pAddress - The manyfest address to resolve from the global form data.
	 * @returns {any} The value at the address, or undefined if not found.
	 */
	resolveGlobalFormData(pAddress)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('resolveGlobalFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpMarshalDestination = this.pict.views.PictFormMetacontroller.viewMarshalDestination;
		let tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestination);

		if ((typeof(tmpMarshalDestinationObject) !== 'object') || (tmpMarshalDestinationObject === null))
		{
			tmpMarshalDestinationObject = this.pict.AppData;
		}

		// Use the global pict manifest to resolve the address
		return this.pict.manifest.getValueAtAddress(tmpMarshalDestinationObject, pAddress);
	}

	/**
	 * Gets a value from a specific section's form data by hash or address.
	 *
	 * Uses the section view's sectionManifest and getMarshalDestinationObject
	 * to properly resolve the value within the section's scope.
	 *
	 * @param {string} pSectionHash - The hash of the section to get data from.
	 * @param {string} pHashOrAddress - The hash or address to resolve within the section.
	 * @returns {any} The value at the hash/address, or undefined if not found.
	 */
	getSectionFormData(pSectionHash, pHashOrAddress)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('getSectionFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);
		if (!tmpSectionView)
		{
			this.log.warn(`getSectionFormData: Could not find section view with hash [${pSectionHash}].`);
			return undefined;
		}

		return tmpSectionView.getValueByHash(pHashOrAddress);
	}

	/**
	 * Gets a value from a specific tabular section's row data by hash or address.
	 *
	 * Resolves the tabular record set from the section view, then gets the specific
	 * row's value using the group's supportingManifest.
	 *
	 * @param {string} pSectionHash - The hash of the section containing the tabular group.
	 * @param {string} pGroupHash - The hash of the tabular group.
	 * @param {number|string} pRowIndex - The index of the row (may be string due to arbitrary precision).
	 * @param {string} pHashOrAddress - The hash or address to resolve within the row.
	 * @returns {any} The value at the hash/address in the row, or undefined if not found.
	 */
	getSectionTabularFormData(pSectionHash, pGroupHash, pRowIndex, pHashOrAddress)
	{
		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.warn('getSectionTabularFormData: No PictFormMetacontroller available.');
			return undefined;
		}

		let tmpSectionView = this.pict.views.PictFormMetacontroller.getSectionViewFromHash(pSectionHash);
		if (!tmpSectionView)
		{
			this.log.warn(`getSectionTabularFormData: Could not find section view with hash [${pSectionHash}].`);
			return undefined;
		}

		let tmpGroupIndex = tmpSectionView.getGroupIndexFromHash(pGroupHash);
		if (tmpGroupIndex < 0)
		{
			this.log.warn(`getSectionTabularFormData: Could not find group with hash [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		let tmpGroup = tmpSectionView.getGroup(tmpGroupIndex);
		if (!tmpGroup)
		{
			this.log.warn(`getSectionTabularFormData: Could not get group at index ${tmpGroupIndex} in section [${pSectionHash}].`);
			return undefined;
		}

		let tmpTabularRecordSet = tmpSectionView.getTabularRecordSet(tmpGroupIndex);
		if (!tmpTabularRecordSet)
		{
			this.log.warn(`getSectionTabularFormData: Could not find tabular record set for group [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		// RowIndex may be passed as a string due to arbitrary precision numbers in the solver
		let tmpRowIndex = parseInt(pRowIndex.toString());
		if (isNaN(tmpRowIndex) || tmpRowIndex < 0)
		{
			this.log.warn(`getSectionTabularFormData: Invalid row index [${pRowIndex}] for group [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		if (tmpRowIndex >= tmpTabularRecordSet.length)
		{
			this.log.warn(`getSectionTabularFormData: Row index [${tmpRowIndex}] out of bounds for group [${pGroupHash}] in section [${pSectionHash}] (length ${tmpTabularRecordSet.length}).`);
			return undefined;
		}
		let tmpRecord = tmpTabularRecordSet[tmpRowIndex];

		if (!tmpRecord || typeof(tmpRecord) !== 'object')
		{
			this.log.warn(`getSectionTabularFormData: No valid record at row index [${tmpRowIndex}] for group [${pGroupHash}] in section [${pSectionHash}].`);
			return undefined;
		}

		// Use the group's supporting manifest to resolve the value
		if (tmpGroup.supportingManifest)
		{
			return tmpGroup.supportingManifest.getValueByHash(tmpRecord, pHashOrAddress);
		}

		// Fallback to direct property access if no supporting manifest
		if (pHashOrAddress in tmpRecord)
		{
			return tmpRecord[pHashOrAddress];
		}

		return undefined;
	}

	logValues()
	{
		let tmpLastValue = null;
		let tmpLogLine = 'Solver logvalues call: ';
		for (let i = 0; i < arguments.length; i++)
		{
			tmpLastValue = arguments[i];
			tmpLogLine += `  [${i}]=[${tmpLastValue}]`;
		}
		this.log.info(tmpLogLine);
		return tmpLastValue;
	}

	/**
	 * Resolves the comprehension destination object, creating intermediate objects along the configured
	 * address if they don't exist.  The address is read from
	 * `PictFormMetacontroller.comprehensionDestinationAddress` (default `AppData.FormEntityComprehensions`)
	 * and resolved against the pict instance, so callers can target any subtree (`AppData.*`, `Bundle.*`, ...).
	 *
	 * @returns {Record<string, any>|null} The destination object (mutable), or null if the address resolves
	 * to a non-object value the function can't safely write into (e.g. a number).
	 */
	resolveComprehensionDestination()
	{
		let tmpAddress = 'AppData.FormEntityComprehensions';
		if (this.pict.views.PictFormMetacontroller && typeof this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress === 'string'
			&& this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress.length > 0)
		{
			tmpAddress = this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress;
		}

		let tmpExisting = this.pict.resolveStateFromAddress(tmpAddress);
		if (tmpExisting && typeof tmpExisting === 'object')
		{
			return tmpExisting;
		}
		if (tmpExisting != null && typeof tmpExisting !== 'object')
		{
			this.log.warn(`addComprehensionEntity: comprehension destination [${tmpAddress}] resolves to a non-object value; refusing to overwrite.`);
			return null;
		}

		// The address is empty -- materialize an object there.  setStateValueAtAddress walks the
		// address creating intermediate objects on the way.
		this.pict.setStateValueAtAddress(tmpAddress, null, {});
		return this.pict.resolveStateFromAddress(tmpAddress);
	}

	/**
	 * Writes a single property/value into the configured comprehension destination, nested as
	 * `Context -> Entity -> GUID -> Property = Value`.
	 *
	 * `Context` is a manyfest address (dot-separated) so dotted contexts like
	 * `OnApprovalAction.Approve` produce nested context branches.  `Entity`, `GUID`, and `Property`
	 * are treated as opaque property names -- dots in them are NOT interpreted as nesting (so an
	 * entity GUID like `0x73278432987` lands as a single key).
	 *
	 * Successive calls to the same `(Context, Entity, GUID)` accumulate properties on the same
	 * record.  Successive calls to the same `(Context, Entity, GUID, Property)` overwrite.
	 *
	 * The destination address is configured on the metacontroller via
	 * `comprehensionDestinationAddress` (default `AppData.FormEntityComprehensions`) -- see
	 * `docs/Comprehensions.md`.
	 *
	 * @param {string} pContext - The comprehension context address (e.g. `"OnSave"`, `"OnApprovalAction.Approve"`).
	 * @param {string} pEntity - The entity name (e.g. `"Book"`).
	 * @param {string} pGUID - The external GUID for the record (e.g. `"0x73278432987"`).
	 * @param {string} pProperty - The property to set on the record (e.g. `"Title"`).
	 * @param {any} pValue - The value to write.
	 *
	 * @returns {any} `pValue` on success, `undefined` if the call was a no-op (invalid args / unwritable destination).
	 */
	addComprehensionEntity(pContext, pEntity, pGUID, pProperty, pValue)
	{
		// Every part of the path must be a non-empty stringifiable identifier -- silently swallowing
		// missing parts would write the comprehension into the wrong place under a literal "undefined"
		// key.  Warn and bail instead.
		if (pContext == null || pEntity == null || pGUID == null || pProperty == null)
		{
			this.log.warn(`addComprehensionEntity: ignoring call with null/undefined parts (Context=[${pContext}], Entity=[${pEntity}], GUID=[${pGUID}], Property=[${pProperty}]).`);
			return undefined;
		}

		let tmpContext = String(pContext);
		let tmpEntity = String(pEntity);
		let tmpGUID = String(pGUID);
		let tmpProperty = String(pProperty);

		if (tmpContext.length < 1 || tmpEntity.length < 1 || tmpGUID.length < 1 || tmpProperty.length < 1)
		{
			this.log.warn(`addComprehensionEntity: ignoring call with empty parts (Context=[${tmpContext}], Entity=[${tmpEntity}], GUID=[${tmpGUID}], Property=[${tmpProperty}]).`);
			return undefined;
		}

		let tmpDestination = this.resolveComprehensionDestination();
		if (!tmpDestination)
		{
			return undefined;
		}

		// Walk the context path manually so we don't have to worry about manyfest's address parsing
		// for the entity/GUID/property keys (which may contain characters like '0x...' that are fine
		// as keys but unusual as addresses).
		let tmpContextParts = tmpContext.split('.');
		let tmpCursor = tmpDestination;
		for (let i = 0; i < tmpContextParts.length; i++)
		{
			let tmpKey = tmpContextParts[i];
			if (tmpKey.length < 1)
			{
				continue;
			}
			if (!tmpCursor[tmpKey] || typeof tmpCursor[tmpKey] !== 'object')
			{
				tmpCursor[tmpKey] = {};
			}
			tmpCursor = tmpCursor[tmpKey];
		}

		if (!tmpCursor[tmpEntity] || typeof tmpCursor[tmpEntity] !== 'object')
		{
			tmpCursor[tmpEntity] = {};
		}
		let tmpEntityBucket = tmpCursor[tmpEntity];

		if (!tmpEntityBucket[tmpGUID] || typeof tmpEntityBucket[tmpGUID] !== 'object')
		{
			tmpEntityBucket[tmpGUID] = {};
		}
		tmpEntityBucket[tmpGUID][tmpProperty] = pValue;

		return pValue;
	}
}

module.exports = PictDynamicFormsSolverBehaviors;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],67:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Input",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicInput class is a provider that manages data brokering and provider mappings for dynamic inputs.
 */
class PictDynamicInput extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicInput class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		// A map of strings for each input template, mapping it to arrays of default providers.
		this.templateProviderMap = {};
		/** @type {Record<string, boolean>} */
		this.ignoredEventHashes = {};
	}

	/**
	 * @param {string} pEventHash
	 */
	registerIgnoredEventHash(pEventHash)
	{
		this.ignoredEventHashes[pEventHash] = true;
	}

	/**
	 * Retrieves the template hash for the input based on the provided view and input.
	 *
	 * @param {import('../views/Pict-View-DynamicForm')} pView - The view object.
	 * @param {any} pInput - The input object.
	 * @returns {string|boolean} - The template hash if found, otherwise false.
	 */
	getInputTemplateHash(pView, pInput)
	{
		if (pInput.IsTabular)
		{
			let tmpTemplateBeginInputTypePostfix = `-TabularTemplate-Begin-Input-InputType-${pInput.PictForm.InputType}`;
			let tmpTemplateEndInputTypePostfix = `-TabularTemplate-End-Input-InputType-${pInput.PictForm.InputType}`;

			let tmpTemplateBeginDataTypePostfix = `-TabularTemplate-Begin-Input-DataType-${pInput.DataType}`;
			let tmpTemplateEndDataTypePostfix = `-TabularTemplate-End-Input-DataType-${pInput.DataType}`;
			if (pView.checkViewSpecificTemplate(tmpTemplateBeginInputTypePostfix) && pView.checkViewSpecificTemplate(tmpTemplateEndInputTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateBeginInputTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateBeginInputTypePostfix) && pView.checkThemeSpecificTemplate(tmpTemplateEndInputTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateBeginInputTypePostfix);
			}
			else if (pView.checkViewSpecificTemplate(tmpTemplateBeginDataTypePostfix) && pView.checkViewSpecificTemplate(tmpTemplateEndDataTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateBeginDataTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateBeginDataTypePostfix) && pView.checkThemeSpecificTemplate(tmpTemplateEndDataTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateBeginDataTypePostfix);
			}
		}
		else
		{
			let tmpTemplateInputTypePostfix = `-Template-Input-InputType-${pInput.PictForm.InputType}`;
			let tmpTemplateDataTypePostfix = `-Template-Input-DataType-${pInput.DataType}`;
			if (pView.checkViewSpecificTemplate(tmpTemplateInputTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateInputTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateInputTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateInputTypePostfix);
			}
			else if (pView.checkViewSpecificTemplate(tmpTemplateDataTypePostfix))
			{
				return pView.getViewSpecificTemplateHash(tmpTemplateDataTypePostfix);
			}
			else if (pView.checkThemeSpecificTemplate(tmpTemplateDataTypePostfix))
			{
				return pView.getThemeSpecificTemplateHash(tmpTemplateDataTypePostfix);
			}
		}
		return false;
	}

	/**
	 * Adds a default input provider for a given template full hash.
	 *
	 * @param {string} pTemplateFullHash - The full hash of the template.
	 * @param {any} pProvider - The provider to be added.
	 */
	addDefaultInputProvider(pTemplateFullHash, pProvider)
	{
		if (!(pTemplateFullHash in this.templateProviderMap))
		{
			this.templateProviderMap[pTemplateFullHash] = [];
		}
		if (this.templateProviderMap[pTemplateFullHash].indexOf(pProvider) < 0)
		{
			this.templateProviderMap[pTemplateFullHash].push(pProvider);
		}
	}

	/**
	 * Retrieves the default input providers based on the given view and input.
	 *
	 * @param {import('../views/Pict-View-DynamicForm')} pView - The view object.
	 * @param {string} pInput - The input to retrieve input providers for.
	 * @returns {Array} An array of default input providers.
	 */
	getDefaultInputProviders(pView, pInput)
	{
		let tmpTemplateHash = this.getInputTemplateHash(pView, pInput);
		if (tmpTemplateHash && this.templateProviderMap[tmpTemplateHash])
		{
			return this.templateProviderMap[tmpTemplateHash];
		}
		return [];
	}
}

module.exports = PictDynamicInput;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],68:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-InputEvents",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicInputEvents class is a provider that manages data brokering and provider mappings for dynamic inputs.
 */
class PictDynamicInputEvents extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicInputEvents class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/**
	 * Requests input data from the view based on the provided input hash.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pInputHash - The input hash.
	 * @param {any} [pEvent] - The input event.
	 */
	inputDataRequest(pView, pInputHash, pEvent)
	{
		if (pInputHash)
		{
			let tmpInput = pView.getInputFromHash(pInputHash);
			if (pEvent)
			{
				let tmpFormattedEvent;
				if (typeof pEvent === 'string')
				{
					tmpFormattedEvent = pEvent;
				}
				else
				{
					if (pEvent.namespace)
					{
						tmpFormattedEvent = `${pEvent.type}.${pEvent.namespace}`;
					}
					else
					{
						tmpFormattedEvent = pEvent.type;
					}
				}
				if (this.pict.providers.DynamicInput.ignoredEventHashes[tmpFormattedEvent])
				{
					return;
				}
			}
			let tmpHashAddress = pView.sectionManifest.resolveHashAddress(pInputHash);
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpHashAddress);
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						pView.pict.providers[tmpInputProviderList[i]].onDataRequest(pView, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector);
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] inputDataRequest cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}].`);
					}
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error running inputDataRequest specific (${pInputHash}) data from view in dataChanged event: ${pError}`);
			}
		}
		else
		{
			pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find input hash [${pInputHash}] for inputDataRequest event.`);
		}
	}

	/**
	 * Handles the input event for a dynamic form.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pInputHash - The input hash.
	 * @param {string} pEvent - The input event.
	 * @param {string} [pTransactionGUID] - (optional) The active transaction GUID.
	 */
	inputEvent(pView, pInputHash, pEvent, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof pTransactionGUID === 'string') ? pTransactionGUID : this.pict.getUUID();
		let tmpInput = pView.getInputFromHash(pInputHash);
		if (pInputHash)
		{
			let tmpHashAddress = pView.sectionManifest.resolveHashAddress(pInputHash);
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpHashAddress);
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						// we may find uninitialized inputs here, so we do not send events to those
						if (tmpInput.Macro)
						{
							pView.pict.providers[tmpInputProviderList[i]].onEvent(pView, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, pEvent, tmpTransactionGUID);
							pView.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
							{
								pView.pict.providers[tmpInputProviderList[i]].onAfterEventCompletion(pView, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, pEvent, tmpTransactionGUID);
							});
						}
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] inputEvent ${pEvent} cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}].`);
					}
				}
				if (pTransactionGUID !== tmpTransactionGUID)
				{
					// since we synthesized this transaction, finalize it
					pView.finalizeTransaction(tmpTransactionGUID);
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error running inputEvent ${pEvent} specific (${pInputHash}) data from view in dataChanged event: ${pError}`);
			}
		}
		else
		{
			pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find input hash [${pInputHash}] for inputEvent ${pEvent} event.`);
		}
	}

	/**
	 * Requests input data for a tabular record.
	 *
	 * @param {import('../views/Pict-View-DynamicForm')} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {any} [pEvent] - The input event.
	 */
	inputDataRequestTabular(pView, pGroupIndex, pInputIndex, pRowIndex, pEvent)
	{
		let tmpInput = pView.getTabularRecordInput(pGroupIndex, pInputIndex);
		if (pGroupIndex && pInputIndex && pRowIndex && tmpInput)
		{
			if (pEvent)
			{
				let tmpFormattedEvent;
				if (typeof pEvent === 'string')
				{
					tmpFormattedEvent = pEvent;
				}
				else
				{
					if (pEvent.namespace)
					{
						tmpFormattedEvent = `${pEvent.type}.${pEvent.namespace}`;
					}
					else
					{
						tmpFormattedEvent = pEvent.type;
					}
				}
				if (this.pict.providers.DynamicInput.ignoredEventHashes[tmpFormattedEvent])
				{
					return;
				}
			}
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				// TODO: Can we simplify pView?
				let tmpValueAddress = pView.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpValueAddress);

				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular+`[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						pView.pict.providers[tmpInputProviderList[i]].onDataRequestTabular(pView, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex);
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex}.`);
					}
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error marshaling specific (${pGroupIndex} | ${pInputIndex} | ${pRowIndex}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in dataChanged event: ${pError}`);
			}
		}
		else
		{
			// pView is what is called whenever a hash is changed.  We could marshal from view, solve and remarshal to view.
			pView.marshalFromView();
		}
	}

	/**
	 * Handles the tabular input event.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pEvent - The input event.
	 * @param {string} [pTransactionGUID] - (optional) The active transaction GUID.
	 */
	inputEventTabular(pView, pGroupIndex, pInputIndex, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof pTransactionGUID === 'string') ? pTransactionGUID : this.pict.getUUID();
		let tmpInput = pView.getTabularRecordInput(pGroupIndex, pInputIndex);
		if (pGroupIndex != null && pInputIndex != null && pRowIndex != null && tmpInput)
		{
			try
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();

				// TODO: Can we simplify pView?
				let tmpValueAddress = pView.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				let tmpValue = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpValueAddress);

				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular+`[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = pView.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (pView.pict.providers[tmpInputProviderList[i]])
					{
						pView.pict.providers[tmpInputProviderList[i]].onEventTabular(pView, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, pEvent, tmpTransactionGUID);
						pView.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
						{
							pView.pict.providers[tmpInputProviderList[i]].onAfterEventTabularCompletion(pView, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, pEvent, tmpTransactionGUID);
						});
					}
					else
					{
						pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] cannot find embedded provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex} calling inputEvent ${pEvent}.`);
					}
				}
				if (pTransactionGUID !== tmpTransactionGUID)
				{
					// since we synthesized this transaction, finalize it
					pView.finalizeTransaction(tmpTransactionGUID);
				}
			}
			catch (pError)
			{
				pView.log.error(`Dynamic form [${pView.Hash}]::[${pView.UUID}] gross error marshaling specific (${pGroupIndex} | ${pInputIndex} | ${pRowIndex}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in calling inputEvent ${pEvent}: ${pError}`);
			}
		}
	}
}

module.exports = PictDynamicInputEvents;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],69:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Layout",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicLayout class is a provider that generates dynamic layouts based on configuration.
 */
class PictDynamicLayout extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicLayout class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	/**
	 * Generate a group layout template for the Dynamically Generated views.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		return '';
	}

	/**
	 * After a group template has been rendered, this lets a layout initialize any controls that
	 * are necessary (e.g. a custom input type or such).
	 *
	 * @param {object} pView  - The view to initialize the newly rendered control for
	 * @param {object} pGroup - The group to initialize the newly rendered control for
	 * @returns
	 */
	onGroupLayoutInitialize(pView, pGroup)
	{
		return true;
	}

	/**
	 * This fires after data has been marshaled to the form from the model.
	 *
	 * @param {object} pView  - The view to initialize the newly rendered control for
	 * @param {object} pGroup - The group to initialize the newly rendered control for
	 * @returns {boolean}
	 */
	onDataMarshalToForm(pView, pGroup)
	{
		return true;
	}
}

module.exports = PictDynamicLayout;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],70:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-RecordSet",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictRecordSet class is a provider to read and write record sets.
 *
 * Record sets are bodies of records that are larger than what we would want to
 * be projected into a view.
 */
class PictRecordSet extends libPictProvider
{
	/**
	 * Creates an instance of the PictRecordSet class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.recordProviders = {};
	}

	/**
	 * Returns the count for a specific dynamic record set.
	 *
	 * @param {Object} pFilter - The filter object.
	 * @param {Function} fCallback - The callback function to be called after the count is returned.
	 * @returns {any} - The result of the callback function.
	 */
	count(pFilter, fCallback)
	{
		return fCallback();
	}

	/**
	 * Reads a record list.
	 *
	 * @param {Object} pFilter - The filter object.
	 * @param {Function} fCallback - The callback function to be called after the record list is read.
	 * @returns {any} - The result of the callback function.
	 */
	readRecordList(pFilter, fCallback)
	{
		return fCallback();
	}

	/**
	 * Reads a record.
	 *
	 * @param {Object} pFilter - The filter object.
	 * @param {Function} fCallback - The callback function to be called after the record is read.
	 * @returns {any} - The result of the callback function.
	 */
	readRecord(pFilter, fCallback)
	{
		return fCallback();
	}

	/**
	 * Writes a record.
	 *
	 * @param {Object} pRecord - The record to be written.
	 * @param {Function} fCallback - The callback function to be called after the record is written.
	 * @returns {any} - The result of the callback function.
	 */
	writeRecord(pRecord, fCallback)
	{
		return fCallback();
	}

	/**
	 * Deletes a record.
	 *
	 * @param {Object} pRecord - The record to be deleted.
	 * @param {Function} fCallback - The callback function to be called after the record is deleted.
	 * @returns {any} - The result of the callback function.
	 */
	deleteRecord(pRecord, fCallback)
	{
		return fCallback();
	}
}

module.exports = PictRecordSet;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],71:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libDynamicFormSolverBehaviors = require('./Pict-Provider-DynamicFormSolverBehaviors.js');

const libListDistilling = require('./Pict-Provider-ListDistilling.js');
const libDynamicMetaLists = require('./Pict-Provider-MetaLists.js');

const libInputSelect = require('./inputs/Pict-Provider-Input-Select.js');
const libInputDateTime = require('./inputs/Pict-Provider-Input-DateTime.js');
const libInputTabGroupSelector = require('./inputs/Pict-Provider-Input-TabGroupSelector.js');
const libInputTabSectionSelector = require('./inputs/Pict-Provider-Input-TabSectionSelector.js');
const libInputEntityBundleRequest = require('./inputs/Pict-Provider-Input-EntityBundleRequest.js');
const libInputAutofillTriggerGroup = require('./inputs/Pict-Provider-Input-AutofillTriggerGroup.js');
const libInputMarkdown = require('./inputs/Pict-Provider-Input-Markdown.js');
const libInputHTML = require('./inputs/Pict-Provider-Input-HTML.js');
const libInputTemplated = require('./inputs/Pict-Provider-Input-Templated.js');
const libInputPreciseNumber = require('./inputs/Pict-Provider-Input-PreciseNumber.js');
const libInputLink = require('./inputs/Pict-Provider-Input-Link.js');
const libInputTemplatedEntityLookup = require('./inputs/Pict-Provider-Input-TemplatedEntityLookup.js');
const libInputChart = require('./inputs/Pict-Provider-Input-Chart.js');
const libInputTabularTriggerGroup = require('./inputs/Pict-Provider-Input-TabularTriggerGroup.js');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Solver",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictDynamicSolver class is a provider that solves configuration-generated dynamic views.
 */
class PictDynamicSolver extends libPictProvider
{
	/**
	 * Creates an instance of the PictDynamicSolver class.
	 *
	 * @param {import('pict')} pFable - The Pict instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict') & { ExpressionParser: any }} */
		this.pict;
		/** @type {import('pict') & { instantiateServiceProviderIfNotExists: (hash: string) => any, ExpressionParser: any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this._RunSolversRegex = /\brunsolvers\b/gi;

		// Initialize the solver service if it isn't up
		this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');

		this.pict.addProviderSingleton('DynamicFormSolverBehaviors', libDynamicFormSolverBehaviors.default_configuration, libDynamicFormSolverBehaviors);
		this.pict.providers.DynamicFormSolverBehaviors.injectBehaviors(this.fable.ExpressionParser);
		this.pict.addProviderSingleton('DynamicMetaLists', libDynamicMetaLists.default_configuration, libDynamicMetaLists);
		this.pict.addProviderSingleton('ListDistilling', libListDistilling.default_configuration, libListDistilling);
		this.pict.addProviderSingleton('Pict-Input-Select', libInputSelect.default_configuration, libInputSelect);
		this.pict.addProviderSingleton('Pict-Input-DateTime', libInputDateTime.default_configuration, libInputDateTime);
		this.pict.addProviderSingleton('Pict-Input-TabGroupSelector', libInputTabGroupSelector.default_configuration, libInputTabGroupSelector);
		this.pict.addProviderSingleton('Pict-Input-TabSectionSelector', libInputTabSectionSelector.default_configuration, libInputTabSectionSelector);
		this.pict.addProviderSingleton('Pict-Input-EntityBundleRequest', libInputEntityBundleRequest.default_configuration, libInputEntityBundleRequest);
		this.pict.addProviderSingleton('Pict-Input-AutofillTriggerGroup', libInputAutofillTriggerGroup.default_configuration, libInputAutofillTriggerGroup);
		this.pict.addProviderSingleton('Pict-Input-Markdown', libInputMarkdown.default_configuration, libInputMarkdown);
		this.pict.addProviderSingleton('Pict-Input-HTML', libInputHTML.default_configuration, libInputHTML);
		this.pict.addProviderSingleton('Pict-Input-Templated', libInputTemplated.default_configuration, libInputTemplated);
		this.pict.addProviderSingleton('Pict-Input-PreciseNumber', libInputPreciseNumber.default_configuration, libInputPreciseNumber);
		this.pict.addProviderSingleton('Pict-Input-TemplatedEntityLookup', libInputTemplatedEntityLookup.default_configuration, libInputTemplatedEntityLookup);
		this.pict.addProviderSingleton('Pict-Input-Link', libInputLink.default_configuration, libInputLink);
		this.pict.addProviderSingleton('Pict-Input-Chart', libInputChart.default_configuration, libInputChart);
		this.pict.addProviderSingleton('Pict-Input-TabularTriggerGroup', libInputTabularTriggerGroup.default_configuration, libInputTabularTriggerGroup);
	}

	logSolveOutcome(pSolveOutcome)
	{
		let tmpSolveOutcome = pSolveOutcome;
		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			tmpSolveOutcome = this.lastSolveOutcome;
		}
		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			this.log.error(`DynamicSolver [${this.UUID}]::[${this.Hash}] No solve outcome available to log.`);
			return;
		}

		let tmpSolversRun = tmpSolveOutcome.SolverResultsMap.ExecutedSolvers.length;

		this.log.info(`DynamicSolver completed solving ${tmpSolversRun} solvers in ${tmpSolveOutcome.EndTimeStamp - tmpSolveOutcome.StartTimeStamp} ms.`);

		for (let i = 0; i < tmpSolveOutcome.SolverResultsMap.ExecutedSolvers.length; i++)
		{
			let tmpSolver = tmpSolveOutcome.SolverResultsMap.ExecutedSolvers[i];
			this.log.info(`  Solver [${tmpSolver.Hash}] Ordinal ${tmpSolver.Ordinal} executed in ${tmpSolver.EndTimeStamp - tmpSolver.StartTimeStamp}ms solving for [${tmpSolver?.ResultsObject?.PostfixedAssignmentAddress}] expression [${tmpSolver.Expression}]`);
		}
	}

	/**
	 * Prepares the solver results map by ensuring it has the necessary structure.
	 *
	 * @param {Object} pSolverResultsMap - The solver results map to prepare.
	 * @returns {Object} - The prepared solver results map.
	*/
	prepareSolverResultsMap(pSolverResultsMap)
	{
		let tmpSolverResultsMap = pSolverResultsMap;
		if (typeof(tmpSolverResultsMap) !== 'object' || tmpSolverResultsMap === null)
		{
			tmpSolverResultsMap = {};
		}
		if (!('ExecutedSolvers' in tmpSolverResultsMap))
		{
			tmpSolverResultsMap.ExecutedSolvers = [];
		}
		if (!('SolverResolutionMap' in tmpSolverResultsMap))
		{
			tmpSolverResultsMap.SolverResolutionMap = {};
		}
		return tmpSolverResultsMap;
	}

	/**
	 * Backfills solver dependencies into the solve outcome.
	 *
	 * @param {Object} pSolveOutcome - The solve outcome object.
	 * @returns {Object} - The updated solve outcome with backfilled dependencies.
	 */
	backfillSolverDependencies(pSolveOutcome)
	{
		let tmpSolveOutcome = pSolveOutcome;

		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			tmpSolveOutcome = this.lastSolveOutcome;
		}

		if (typeof(tmpSolveOutcome) !== 'object' || tmpSolveOutcome === null)
		{
			this.log.error(`DynamicSolver [${this.UUID}]::[${this.Hash}] No solve outcome available to backfill solver dependencies.`);
			return;
		}

		for (let i = 0; i < tmpSolveOutcome.SolverResultsMap.ExecutedSolvers.length; i++)
		{
			let tmpSolver = tmpSolveOutcome.SolverResultsMap.ExecutedSolvers[i];
			if (('ResultsObject' in tmpSolver) && (typeof(tmpSolver.ResultsObject) === 'object') && (tmpSolver.ResultsObject !== null))
			{
				// Now fill any dependencies from the results object
				// If the Postfixed Assignment Address is "Result" it hasn't been set and we will ignore it.
				if (tmpSolver.ResultsObject.PostfixedAssignmentAddress && (tmpSolver.ResultsObject.PostfixedAssignmentAddress != 'Result'))
				{
					if (typeof(tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress]) !== 'object')
					{
						tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress] = {};
					}
					// Go through the postfixed list and pull out any symbols being assigned
					for (let j = 0; j < tmpSolver.ResultsObject.PostfixTokenObjects.length; j++)
					{
						let tmpTokenObject = tmpSolver.ResultsObject.PostfixTokenObjects[j];
						if (tmpTokenObject.Type == 'Token.Symbol')
						{
							if (!(tmpTokenObject.Token in tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress]))
							{
								tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress][tmpTokenObject.Token] = 0;
							}
							tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress][tmpTokenObject.Token] = tmpSolveOutcome.SolverResultsMap.SolverResolutionMap[tmpSolver.ResultsObject.PostfixedAssignmentAddress][tmpTokenObject.Token] + 1;
						}
					}
				}
			}
		}

		return tmpSolveOutcome;
	}

	/**
	 * Runs a manual solver expression against the dynamic view marshal destination or the application data.
	 *
	 * @param {string} pSolverExpression - The solver expression to run.
	 * @param {boolean} [pSilent=false] - Whether to suppress debug logging output.
	 * @returns {any} - The result of the solver expression.
	 */
	runSolver(pSolverExpression, pSilent = false)
	{
		let tmpViewMarshalDestinationObject = this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);

		if ((typeof(tmpViewMarshalDestinationObject) !== 'object') || (tmpViewMarshalDestinationObject === null))
		{
			tmpViewMarshalDestinationObject = this.pict.AppData;
		}

		let tmpResultsObject = {};
		let tmpSolutionValue = this.fable.ExpressionParser.solve(pSolverExpression, tmpViewMarshalDestinationObject, tmpResultsObject, this.pict.manifest);

		if (tmpResultsObject.fable)
		{
			delete tmpResultsObject.fable;
		}

		if (!pSilent)
		{
			this.pict.log.trace(`Manual solve executed for expression: ${pSolverExpression}`, tmpResultsObject);
		}

		return tmpSolutionValue;
	}

	/**
	 * Checks the solver and returns the solver object if it passes the checks.
	 *
	 * Automatically converts string solvers to have an Ordinal of 1.
	 *
	 * @param {string|object} pSolver - The solver to be checked. It can be either a string or an object.
	 * @param {boolean} [pFiltered=false] - Indicates whether the solvers should be filtered.
	 * @param {number} [pOrdinal] - The ordinal value to compare with the solver's ordinal value when filtered.
	 * @returns {object|undefined} - The solver object if it passes the checks, otherwise undefined.
	 */
	checkSolver(pSolver, pFiltered, pOrdinal)
	{
		let tmpSolver = pSolver;
		if (tmpSolver === undefined)
		{
			return;
		}
		if (typeof(tmpSolver) === 'string')
		{
			tmpSolver = {Expression:tmpSolver, Ordinal:1};
		}
		if (!('Expression' in tmpSolver))
		{
			this.log.error(`Dynamic View solver ${pOrdinal} is missing the Expression property.`, { Solver: pSolver });
			return;
		}
		if (!(`Ordinal` in tmpSolver))
		{
			tmpSolver.Ordinal = 1;
		}

		// This filters the solvers
		if (pFiltered && (tmpSolver.Ordinal != pOrdinal))
		{
			return;
		}

		return tmpSolver;
	}

	/** @typedef {{ Ordinal: number, Expression: string } | string} Solver */

	/**
	 * Execute a set of adhoc solvers.
	 *
	 * @param {import('../views/Pict-View-DynamicForm.js')} pView - The dynamic view to execute the solvers against.
	 * @param {Array<Solver>} pSolvers - An array of solvers to execute.
	 * @param {string} pReason - The reason for executing the solvers.
	 */
	executeSolvers(pView, pSolvers, pReason)
	{
		const tmpSolvers = Array.isArray(pSolvers) ? pSolvers : [];
		let tmpSolveOutcome = {};
		tmpSolveOutcome.SolverResultsMap = {};
		tmpSolveOutcome.StartTimeStamp = +new Date();

		let tmpOrdinalsToSolve = {};
		tmpSolveOutcome.SolveOrdinals = tmpOrdinalsToSolve;
		for (let i = 0; i < tmpSolvers.length; i++)
		{
			const tmpSolver = this.checkSolver(tmpSolvers[i]);
			if (tmpSolver)
			{
				let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
				tmpOrdinalContainer.AdhocSolvers.push(tmpSolver);
			}
		}

		// Now sort the ordinal container keys
		let tmpOrdinalKeys = Object.keys(tmpOrdinalsToSolve);
		tmpOrdinalKeys.sort((a, b) =>
		{
			if (isNaN(Number(a)) || isNaN(Number(b)))
			{
				return a.localeCompare(b);
			}
			return Number(a) - Number(b);
		});

		// Now enumerate the keys and solve each layer of the solution set
		for (let i = 0; i < tmpOrdinalKeys.length; i++)
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`DynamicSolver [${this.UUID}]::[${this.Hash}] [${pReason}] Solving ordinal ${tmpOrdinalKeys[i]}`);
			}
			let tmpOrdinalContainer = tmpOrdinalsToSolve[tmpOrdinalKeys[i]];
			let tmpExecuteOrdinal = this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpOrdinalKeys[i]);
			if (tmpExecuteOrdinal)
			{
				this.executeAdhocSolvers(pView, tmpOrdinalContainer.AdhocSolvers, pReason, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap);
			}
		}

		tmpSolveOutcome.EndTimeStamp = +new Date();

		// It's up to the developer to decide if they want to use this information somewhere.
		this.lastAdhocSolveOutcome = tmpSolveOutcome;
	}

	/**
	 * Runs each Adhoc solver formulae for a dynamic view group at a given ordinal.
	 *
	 * Or for all ordinals if no ordinal is passed.
	 *
	 * @param {import('../views/Pict-View-DynamicForm.js')} pView - The dynamic view to execute the solvers against.
	 * @param {Array<string>} pAdhocSolverArray - An array of Solvers from the groups to solve.
	 * @param {string} pReason - The reason for executing the solvers.
	 * @param {number} pOrdinal - The ordinal value to filter to.  Optional.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles.
	 */
	executeAdhocSolvers(pView, pAdhocSolverArray, pReason, pOrdinal, pSolverResultsMap, pPreventSolverCycles = false)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		for (let i = 0; i < pAdhocSolverArray.length; i++)
		{
			let tmpSolver = this.checkSolver(pAdhocSolverArray[i], tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					pView.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] [${pReason}] skipping RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			tmpSolver.StartTimeStamp = +new Date();
			tmpSolver.Hash = `AdhocSolver-${i}`;

			// TODO: Precompile the solvers (it's super easy)
			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.trace(`Dynamic View [${pView.UUID}]::[${pView.Hash}] [${pReason}] solving equation ${i} ordinal ${tmpSolver.Ordinal} [${pView.options.Solvers[i]}]`);
			}
			tmpSolver.ResultsObject = {};
			let tmpSolutionValue = this.fable.ExpressionParser.solve(tmpSolver.Expression, pView.getMarshalDestinationObject(), tmpSolver.ResultsObject, this.pict.manifest, pView.getMarshalDestinationObject());
			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.trace(`[${tmpSolver.Expression}] [${pReason}] result was ${tmpSolutionValue}`);
			}
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = +new Date();
		}
	}

	/**
	 * Runs each RecordSet solver formulae for a dynamic view group at a given ordinal.
	 *
	 * Or for all ordinals if no ordinal is passed.
	 *
	 * @param {array} pGroupSolverArray - An array of Solvers from the groups to solve.
	 * @param {number} pOrdinal - The ordinal value to filter to.  Optional.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles.
	 */
	executeGroupSolvers(pGroupSolverArray, pOrdinal, pSolverResultsMap, pPreventSolverCycles = false)
	{
		// This is purely for readability of the code below ... uglify optimizes it out.
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		// Solve the group RecordSet solvers first
		for (let j = 0; j < pGroupSolverArray.length; j++)
		{
			let tmpView = this.pict.views[pGroupSolverArray[j].ViewHash];
			let tmpGroup = tmpView.getGroup(pGroupSolverArray[j].GroupIndex);
			let tmpSolver = this.checkSolver(pGroupSolverArray[j].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					tmpView.log.warn(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] skipping RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			tmpSolver.StartTimeStamp = Date.now();
			tmpSolver.Hash = `${pGroupSolverArray[j].ViewHash}-GroupSolver-${j}`;

			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] solving RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}]`);
			}

			let tmpRecordSet = tmpView.getTabularRecordSet(tmpGroup.GroupIndex);

			if (Array.isArray(tmpRecordSet))
			{
				for (let l = 0; l < tmpRecordSet.length; l++)
				{
					let tmpRecord = tmpRecordSet[l];
					tmpSolver.ResultsObject = {};
					let tmpSolutionValue = tmpView.fable.ExpressionParser.solve(tmpSolver.Expression, tmpRecord, tmpSolver.ResultsObject, tmpGroup.supportingManifest, tmpRecord);
					if (this.pict.LogNoisiness > 1)
					{
						tmpView.log.trace(`Group ${tmpGroup.Hash} [${tmpSolver.Expression}] record ${l} result was ${tmpSolutionValue}`);
					}
				}
			}
			else if (typeof(tmpRecordSet) == 'object')
			{
				let tmpRecordSetKeys = Object.keys(tmpRecordSet);
				for (let l = 0; l < tmpRecordSetKeys.length; l++)
				{
					let tmpRecord = tmpRecordSet[tmpRecordSetKeys[l]];
					tmpSolver.ResultsObject = {};
					let tmpSolutionValue = tmpView.fable.ExpressionParser.solve(tmpSolver.Expression, tmpRecord, tmpSolver.ResultsObject, tmpGroup.supportingManifest, tmpRecord);
					if (this.pict.LogNoisiness > 1)
					{
						tmpView.log.trace(`Group ${tmpGroup.Hash} [${tmpSolver.Expression}] record ${l} result was ${tmpSolutionValue}`);
					}
				}
			}
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = Date.now();
		}
	}

	/**
	 * Executes the section solvers at a given ordinal (or all if no ordinal is passed).
	 *
	 * @param {Array} pViewSectionSolverArray - The array of view section solvers.
	 * @param {number} pOrdinal - The ordinal value.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles.
	 */
	executeSectionSolvers(pViewSectionSolverArray, pOrdinal, pSolverResultsMap, pPreventSolverCycles = false)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		for (let i = 0; i < pViewSectionSolverArray.length; i++)
		{
			let tmpView = this.pict.views[pViewSectionSolverArray[i].ViewHash];
			let tmpSolver = this.checkSolver(pViewSectionSolverArray[i].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					tmpView.log.warn(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] skipping RecordSet ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			tmpSolver.StartTimeStamp = +new Date();
			tmpSolver.Hash = `${pViewSectionSolverArray[i].ViewHash}-SectionSolver-${i}`;

			// TODO: Precompile the solvers (it's super easy)
			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] solving equation ${i} ordinal ${tmpSolver.Ordinal} [${tmpView.options.Solvers[i]}]`);
			}
			tmpSolver.ResultsObject = {};
			let tmpSolutionValue = tmpView.fable.ExpressionParser.solve(tmpSolver.Expression, tmpView.getMarshalDestinationObject(), tmpSolver.ResultsObject, this.pict.manifest, tmpView.getMarshalDestinationObject());
			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`[${tmpSolver.Expression}] result was ${tmpSolutionValue}`);
			}
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = +new Date();
		}
	}

	/**
	 * Executes the view solvers for the given array of view hashes.
	 *
	 * @param {Array} pViewSolverArray - The array of view solvers to execute.
	 * @param {number} pOrdinal - The ordinal value.
	 * @param {Object} pSolverResultsMap - The solver results map.
	 */
	executeViewSolvers(pViewSolverArray, pOrdinal, pSolverResultsMap)
	{
		let tmpFiltered = (typeof(pOrdinal) === 'undefined') ? false : true;
		let tmpSolverReultsMap = this.prepareSolverResultsMap(pSolverResultsMap);

		for (let i = 0; i < pViewSolverArray.length; i++)
		{
			let tmpSolver = this.checkSolver(pViewSolverArray[i].Solver, tmpFiltered, pOrdinal);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}
			tmpSolver.Hash = `${pViewSolverArray[i].ViewHash}-ViewSolve-${i}`;
			tmpSolver.StartTimeStamp = +new Date();
			let tmpView = this.pict.views[pViewSolverArray[i].ViewHash];
			if (this.pict.LogNoisiness > 1)
			{
				tmpView.log.trace(`Dynamic View [${tmpView.UUID}]::[${tmpView.Hash}] running solve() on view [${pViewSolverArray[i].ViewHash}`);
			}
			// Solve with the normal view solve() pipeline
			tmpView.solve();
			tmpSolverReultsMap.ExecutedSolvers.push(tmpSolver);
			tmpSolver.EndTimeStamp = +new Date();
		}
	}

	/**
	 * Executes any validation solvers defined in the form manifest.
	 *
	 * @param {Object} pSolverResultsMap - The solver results map to use for executing validation solvers.
	 * @param {boolean} [pPreventSolverCycles=false] - Whether to prevent solver cycles when executing validation solvers.
	 */
	executeValidationSolvers(pSolverResultsMap, pPreventSolverCycles = false)
	{
		const tmpValidationSolvers = this.pict.views.PictFormMetacontroller?.manifestDescription?.ValidationSolvers;
		if (!Array.isArray(tmpValidationSolvers))
		{
			return;
		}
		const tmpMarshalDestination = this.pict.views.PictFormMetacontroller && this.pict.resolveStateFromAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination) || this.pict.AppData;
		for (let i = 0; i < tmpValidationSolvers.length; i++)
		{
			const tmpSolver = this.checkSolver(tmpValidationSolvers[i]);
			if (typeof(tmpSolver) === 'undefined')
			{
				continue;
			}

			if (pPreventSolverCycles && tmpSolver.Expression.match(this._RunSolversRegex))
			{
				if (this.pict.LogNoisiness > 0)
				{
					this.pict.log.warn(`Skipping Validation Solver ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}] due to solver cycle prevention.`);
				}
				continue;
			}

			if (this.pict.LogNoisiness > 1)
			{
				this.pict.log.trace(`Running validation solver ordinal ${tmpSolver.Ordinal} [${tmpSolver.Expression}]`);
			}
			this.pict.ExpressionParser.solve(tmpSolver.Expression, tmpMarshalDestination, pSolverResultsMap, this.pict.manifest, this.pict.AppData);
		}
	}

	/**
	 * Checks if the given ordinal exists in the provided ordinal set.
	 *
	 * If not, it adds the ordinal to the set.
	 *
	 * @param {number} pOrdinal - The ordinal to check.
	 * @param {Object} pOrdinalSet - The ordinal set to check against.
	 * @returns {Object} - The ordinal object from the ordinal set.
	 */
	checkAutoSolveOrdinal (pOrdinal, pOrdinalSet)
	{
		if (!(pOrdinal.toString() in pOrdinalSet))
		{
			pOrdinalSet[pOrdinal.toString()] = { ViewSolvers:[], SectionSolvers:[], GroupSolvers:[], AdhocSolvers:[] };
		}
		return pOrdinalSet[pOrdinal];
	}

	/**
	 * Solves the views based on the provided view hashes or all views in pict.
	 *
	 * If non-dynamic views are also passed in, they are solved as well.
	 *
	 * This algorithm is particularly complex because it solves views in
	 * order across two dimensions:
	 *
	 * 1. The order of the views in the view hash array.
	 * 2. Precedence order (based on Ordinal)
	 *
	 * The way it manages the precedence order solving is by enumerating the
	 * view hash array multiple times until it exhausts the solution set.
	 *
	 * In dynamic views, when there are collisions in precedence order between
	 * Section Solvers and Group RecordSet Solvers, it prefers the RecordSet
	 * solvers first.  The thinking behind this is that a RecordSet solver is
	 * a "tier down" from the core Section it resides within.  These are
	 * leaves on the tree.

	 * @param {Array|string[]} [pViewHashes] - An optional array of view hashes to solve. If not provided, all views in the fable will be solved.
	 * @param {boolean} [pPreventSolverCycles] - An optional context string for the solve operation.
	 * TODO: make sure you can't cycle with the same solve context - new solver method to invoke this
	 *
	 * @return {Array<string>} - An array of view hashes that were solved.
	 */
	solveViews(pViewHashes, pPreventSolverCycles)
	{
		//this.log.trace(`Dynamic View Provider [${this.UUID}]::[${this.Hash}] solving views.`);
		let tmpViewHashes = Array.isArray(pViewHashes) ? pViewHashes : Object.keys(this.fable.views);
		const tmpPreventSolverCycles = pPreventSolverCycles === true;

		let tmpSolveOutcome = {};
		tmpSolveOutcome.SolverResultsMap = {};
		tmpSolveOutcome.StartTimeStamp = +new Date();
		tmpSolveOutcome.ViewHashes = tmpViewHashes;

		let tmpOrdinalsToSolve = {};
		tmpSolveOutcome.SolveOrdinals = tmpOrdinalsToSolve;
		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			let tmpView = this.fable.views[tmpViewHashes[i]];
			if (tmpView.isPictView && !tmpView.isPictSectionForm && !tmpView.isPictMetacontroller)
			{
				// This is just a normal view.  We will solve it at the appropriate ordinal.
				let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpView.options.AutoSolveOrdinal, tmpOrdinalsToSolve);
				tmpOrdinalContainer.ViewSolvers.push({ViewHash:tmpViewHashes[i]});
			}
			else if (tmpView.isPictSectionForm)
			{
				// These guards are here because the metacontroller view masquerades as a section form view but isn't one.
				for (let j = 0; j < tmpView.sectionDefinition.Groups.length; j++)
				{
					let tmpGroup = tmpView.getGroup(j);
					if (`RecordSetSolvers` in tmpGroup)
					{
						for (let k = 0; k < tmpGroup.RecordSetSolvers.length; k++)
						{
							let tmpSolver = this.checkSolver(tmpGroup.RecordSetSolvers[k]);
							if (tmpSolver)
							{
								let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
								tmpOrdinalContainer.GroupSolvers.push({ViewHash:tmpViewHashes[i], GroupIndex:j, Solver:tmpSolver});
							}
						}
					}
				}
				if (Array.isArray(tmpView.options.Solvers))
				{
					// Add thje section solver(s)
					for (let j = 0; j < tmpView.options.Solvers.length; j++)
					{
						let tmpSolver = this.checkSolver(tmpView.options.Solvers[j]);
						if (tmpSolver)
						{
							let tmpOrdinalContainer = this.checkAutoSolveOrdinal(tmpSolver.Ordinal, tmpOrdinalsToSolve);
							tmpOrdinalContainer.SectionSolvers.push({ViewHash:tmpViewHashes[i], Solver:tmpSolver});
						}
					}
				}
			}
		}

		// Now sort the ordinal container keys
		let tmpOrdinalKeys = Object.keys(tmpOrdinalsToSolve);
		tmpOrdinalKeys.sort((a, b) =>
		{
			if (isNaN(Number(a)) || isNaN(Number(b)))
			{
				return a.localeCompare(b);
			}
			return Number(a) - Number(b);
		});

		// Now enumerate the keys and solve each layer of the solution set
		for (let i = 0; i < tmpOrdinalKeys.length; i++)
		{
			if (this.pict.LogNoisiness > 1)
			{
				this.log.trace(`DynamicSolver [${this.UUID}]::[${this.Hash}] Solving ordinal ${tmpOrdinalKeys[i]}`);
			}
			let tmpOrdinalContainer = tmpOrdinalsToSolve[tmpOrdinalKeys[i]];
			let tmpExecuteOrdinal = this.pict.providers.DynamicFormSolverBehaviors.checkSolverOrdinalEnabled(tmpOrdinalKeys[i]);
			if (tmpExecuteOrdinal)
			{
				this.executeGroupSolvers(tmpOrdinalContainer.GroupSolvers, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap, tmpPreventSolverCycles);
				this.executeSectionSolvers(tmpOrdinalContainer.SectionSolvers, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap, tmpPreventSolverCycles);
				this.executeViewSolvers(tmpOrdinalContainer.ViewSolvers, Number(tmpOrdinalKeys[i]), tmpSolveOutcome.SolverResultsMap);
			}
		}

		this.executeValidationSolvers(tmpSolveOutcome.SolverResultsMap, tmpPreventSolverCycles);

		// Now regenerate the metalists .. after the solve has happened.
		this.pict.providers.DynamicMetaLists.buildViewSpecificLists(tmpViewHashes);

		tmpSolveOutcome.EndTimeStamp = +new Date();

		// It's up to the developer to decide if they want to use this information somewhere.
		this.lastSolveOutcome = tmpSolveOutcome;
		return tmpViewHashes;
	}
}

module.exports = PictDynamicSolver;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./Pict-Provider-DynamicFormSolverBehaviors.js":66,"./Pict-Provider-ListDistilling.js":77,"./Pict-Provider-MetaLists.js":78,"./inputs/Pict-Provider-Input-AutofillTriggerGroup.js":83,"./inputs/Pict-Provider-Input-Chart.js":84,"./inputs/Pict-Provider-Input-DateTime.js":85,"./inputs/Pict-Provider-Input-EntityBundleRequest.js":86,"./inputs/Pict-Provider-Input-HTML.js":87,"./inputs/Pict-Provider-Input-Link.js":88,"./inputs/Pict-Provider-Input-Markdown.js":89,"./inputs/Pict-Provider-Input-PreciseNumber.js":90,"./inputs/Pict-Provider-Input-Select.js":91,"./inputs/Pict-Provider-Input-TabGroupSelector.js":92,"./inputs/Pict-Provider-Input-TabSectionSelector.js":93,"./inputs/Pict-Provider-Input-TabularTriggerGroup.js":94,"./inputs/Pict-Provider-Input-Templated.js":95,"./inputs/Pict-Provider-Input-TemplatedEntityLookup.js":96,"pict-provider":19}],72:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-DynamicTabularData",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * @typedef {Object} ElementDescriptor
 * @property {string} Hash - The hash of the element.
 */

/**
 * The DynamicTabularData class is a provider that translates simple list entries into arrays of entries ready to use in drop-down lists and such
 */
class DynamicTabularData extends libPictProvider
{
	/**
	 * Creates an instance of the DynamicTabularData class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	/**
	 * Retrieves the tabular record set from the specified view and group index.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @returns {Array|Object|boolean} - The tabular record set if it exists, otherwise false.
	 */
	getTabularRecordSet(pView, pGroupIndex)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroup(pGroupIndex);
		if (!tmpGroup || !tmpGroup?.RecordSetAddress)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordSet ${pGroupIndex} was not a valid group or did not have a valid RecordSetAddress.`);
			return false;
		}

		let tmpRowSource = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

		return tmpRowSource;
	}

	/**
	 * Retrieves the tabular record input from the specified view, group, and input indexes.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @returns {ElementDescriptor|boolean} The tabular record input or false if the group is invalid.
	 */
	getTabularRecordInput(pView, pGroupIndex, pInputIndex)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordInput ${pGroupIndex} was not a valid group.`);
			return false;
		}

		// Now get the supporting manifest and the input element
		// This needs more guards
		let tmpSupportingManifestHash = tmpGroup.supportingManifest.elementAddresses[pInputIndex];
		return tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
	}

	/**
	 * Retrieves the tabular record input from the specified view, group, and input indexes.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupHash - The index of the group.
	 * @param {number} pInputHash - The index of the input.
	 * @returns {ElementDescriptor|boolean} The tabular record input or false if the group is invalid.
	 */
	getTabularRecordInputByHash(pView, pGroupHash, pInputHash)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroups().find((pGroup) => pGroup.Hash === pGroupHash);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordInputByHash ${pGroupHash} was not a valid group.`);
			return false;
		}

		if (!tmpGroup.supportingManifest)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordInputByHash ${pGroupHash} s not a tabular group.`);
			return false;
		}

		// Now get the supporting manifest and the input element
		// This needs more guards
		for (const tmpDescriptor of Object.values(tmpGroup.supportingManifest.elementDescriptors))
		{
			if (tmpDescriptor.Hash === pInputHash)
			{
				return tmpDescriptor;
			}
		}

		this.log.warn(`PICT View Metatemplate Helper getTabularRecordInputByHash ${pGroupHash} could not find input ${pInputHash}.`);
		return false;
	}

	/**
	 * Retrieves tabular record data based on the provided parameters.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pRowIdentifier - The identifier of the row.
	 * @returns {boolean|Object} - The tabular record data or false if not found.
	 */
	getTabularRecordData(pView, pGroupIndex, pRowIdentifier)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} was not a valid group.`);
			return false;
		}

		// Now identify the group
		let tmpRowSourceRecord =  pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

		if (!tmpRowSourceRecord)
		{
			// Try the address
			tmpRowSourceRecord = pView.sectionManifest.getValueAtAddress(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		}

		if (!tmpRowSourceRecord)
		{
			this.log.warn(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} could not find the record set for ${tmpGroup.RecordSetAddress}.`);
			return false;
		}

		// Now we have the source record let's see what it is
		try
		{
			if (Array.isArray(tmpRowSourceRecord))
			{
				return tmpRowSourceRecord[pRowIdentifier];
			}
			else if (typeof(tmpRowSourceRecord) === 'object')
			{
				return tmpRowSourceRecord[pRowIdentifier];
			}
			else
			{
				this.log.warn(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} could not determine the type of the record set for ${tmpGroup.RecordSetAddress}.`);
				return false;
			}
		}
		catch (pError)
		{
			this.log.error(`PICT View Metatemplate Helper getTabularRecordData ${pGroupIndex} encountered an error: ${pError}`);
			return false;
		}
	}

	/**
	 * Creates a dynamic table row for the given view and group index.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 */
	createDynamicTableRow(pView, pGroupIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				if (tmpGroup.MaximumRowCount && (tmpDestinationObject.length >= tmpGroup.MaximumRowCount))
				{
					this.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to add a row but the maximum rows ${tmpGroup.MaximumRowCount} has been reached.`);
					return;
				}
				let tmpRowPrototype = {};
				if (tmpGroup.DefaultRows && tmpDestinationObject.length < tmpGroup.DefaultRows.length)
				{
					tmpRowPrototype = JSON.parse(JSON.stringify(tmpGroup.DefaultRows[tmpDestinationObject.length]));
				}
				tmpDestinationObject.push(tmpGroup.supportingManifest.populateDefaults(tmpRowPrototype));

				// Also render any other views that have this as the RecordSetAddress
				// Filter the views by each Group.RecordSetAddress and find the ones with this RecordSetAddress
				let tmpViewsToRender = this.pict.views.PictFormMetacontroller.filterViews(
					/** @param {import('../views/Pict-View-DynamicForm.js')} pViewToTestForGroup */
					(pViewToTestForGroup) =>
					{
						if (!pViewToTestForGroup.isPictSectionForm)
						{
							return false;
						}
						let tmpGroupsToTest = pViewToTestForGroup.getGroups();
						for (let i = 0; i < tmpGroupsToTest.length; i++)
						{
							if (tmpGroupsToTest[i].RecordSetAddress == tmpGroup.RecordSetAddress)
							{
								return true;
							}
						}
						return false;
					}
				)
				// We expect this view to be in the set.
				for (let i = 0; i < tmpViewsToRender.length; i++)
				{
					tmpViewsToRender[i].render();
				}

				// Run the solver
				this.pict.providers.DynamicSolver.solveViews();

				//pView.render();
				//pView.marshalToView();
				// We've re-rendered but we don't know what needs to be marshaled based on the solve that ran above so marshal everything
				this.pict.views.PictFormMetacontroller.marshalFormSections();
			}
		}
	}


	/**
	 * Creates a dynamic table row for the given view and group index without firing render or marshal events.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 */
	createDynamicTableRowWithoutEvents(pView, pGroupIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				if (tmpGroup.MaximumRowCount && (tmpDestinationObject.length >= tmpGroup.MaximumRowCount))
				{
					this.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to add a row but the maximum rows ${tmpGroup.MaximumRowCount} has been reached.`);
					return;
				}
				let tmpRowPrototype = {};
				if (tmpGroup.DefaultRows && tmpDestinationObject.length < tmpGroup.DefaultRows.length)
				{
					tmpRowPrototype = JSON.parse(JSON.stringify(tmpGroup.DefaultRows[tmpDestinationObject.length]));
				}
				tmpDestinationObject.push(tmpGroup.supportingManifest.populateDefaults(tmpRowPrototype))
			}
		}
	}

	/**
	 * Sets the index of a dynamic table row in a view.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number|string} pRowIndex - The current index of the row.
	 * @param {number} pNewRowIndex - The new index to move the row to.
	 * @returns {boolean} - Returns false if the index is out of bounds, otherwise returns undefined.
	 */
	setDynamicTableRowIndex(pView, pGroupIndex, pRowIndex, pNewRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				let tmpNewRowIndex = parseInt(String(pNewRowIndex), 10);
				if ((tmpDestinationObject.length <= tmpRowIndex) || (tmpRowIndex < 0))
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] to [${pNewRowIndex}] but the index is out of bounds.`);
					return false;
				}
				let tmpElementToBeMoved = tmpDestinationObject.splice(tmpRowIndex, 1);
				tmpDestinationObject.splice(tmpNewRowIndex, 0, tmpElementToBeMoved[0]);
				this.pict.providers.DynamicSolver.solveViews();
				pView.render();
				//pView.marshalToView();
				// We've re-rendered but we don't know what needs to be marshaled based on the solve that ran above so marshal everything
				this.pict.views.PictFormMetacontroller.marshalFormSections();
			}
		}
	}

	/**
	 * Moves a dynamic table row down within a view.
	 *
	 * @param {Object} pView - The view containing the dynamic table.
	 * @param {number} pGroupIndex - The index of the group containing the row.
	 * @param {number|string} pRowIndex - The index of the row to be moved.
	 * @returns {boolean} - Returns true if the row was successfully moved, false otherwise.
	 */
	moveDynamicTableRowDown(pView, pGroupIndex, pRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpDestinationObject.length <= tmpRowIndex)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] down but it's already at the bottom.`);
					return false;
				}
				let tmpElementToBeMoved = tmpDestinationObject.splice(tmpRowIndex, 1);
				tmpDestinationObject.splice(tmpRowIndex + 1, 0, tmpElementToBeMoved[0]);
				this.pict.providers.DynamicSolver.solveViews();
				pView.render();
				//pView.marshalToView();
				// We've re-rendered but we don't know what needs to be marshaled based on the solve that ran above so marshal everything
				this.pict.views.PictFormMetacontroller.marshalFormSections();
			}
		}
	}

	/**
	 * Moves a dynamic table row up.
	 *
	 * @param {Object} pView - The view object.
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number|string} pRowIndex - The index of the row to be moved.
	 * @returns {boolean} Returns true if the row was moved successfully, false otherwise.
	 */
	moveDynamicTableRowUp(pView, pGroupIndex, pRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpRowIndex == 0)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] up but it's already at the top.`);
					return false;
				}
				if (tmpDestinationObject.length <= tmpRowIndex)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to move row [${pRowIndex}] but the index is out of bounds.`);
					return false;
				}
				let tmpElementToBeMoved = tmpDestinationObject.splice(tmpRowIndex, 1);
				tmpDestinationObject.splice(tmpRowIndex - 1, 0, tmpElementToBeMoved[0]);
				this.pict.providers.DynamicSolver.solveViews();
				pView.render();
				//pView.marshalToView();
				// We've re-rendered but we don't know what needs to be marshaled based on the solve that ran above so marshal everything
				this.pict.views.PictFormMetacontroller.marshalFormSections();
			}
		}
	}


	/**
	 * Deletes a dynamic table row from the specified view.
	 *
	 * @param {Object} pView - The view from which to delete the row.
	 * @param {number} pGroupIndex - The index of the group containing the row.
	 * @param {number|string} pRowIndex - The index or key of the row to delete.
	 * @returns {boolean} - Returns true if the row was successfully deleted, false otherwise.
	 */
	deleteDynamicTableRow(pView, pGroupIndex, pRowIndex)
	{
		let tmpGroup = pView.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			let tmpDestinationObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);

			if (Array.isArray(tmpDestinationObject))
			{
				if (tmpGroup.MinimumRowCount && (tmpDestinationObject.length <= tmpGroup.MinimumRowCount))
				{
					this.log.warn(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to delete a row but the minimum rows ${tmpGroup.MinimumRowCount} has been reached.`);
					return false;
				}

				let tmpRowIndex = parseInt(String(pRowIndex), 10);
				if (tmpDestinationObject.length <= tmpRowIndex)
				{
					this.log.error(`Dynamic View [${pView.UUID}]::[${pView.Hash}] Group ${tmpGroup.Hash} attempting to delete row [${pRowIndex}] but the index is out of bounds.`);
					return false;
				}
				tmpDestinationObject.splice(tmpRowIndex, 1);

				// Also render any other views that have this as the RecordSetAddress
				// Filter the views by each Group.RecordSetAddress and find the ones with this RecordSetAddress
				let tmpViewsToRender = this.pict.views.PictFormMetacontroller.filterViews(
					(pViewToTestForGroup) =>
					{
						if (!pViewToTestForGroup.isPictSectionForm)
						{
							return false;
						}
						let tmpGroupsToTest = pViewToTestForGroup.getGroups();
						for (let i = 0; i < tmpGroupsToTest.length; i++)
						{
							if (tmpGroupsToTest[i].RecordSetAddress == tmpGroup.RecordSetAddress)
							{
								return true;
							}
						}
						return false;
					}
				)
				// We expect this view to be in the set.
				for (let i = 0; i < tmpViewsToRender.length; i++)
				{
					tmpViewsToRender[i].render();
				}

				// Run the solver
				this.pict.providers.DynamicSolver.solveViews();

				// We've re-rendered but we don't know what needs to be marshaled based on the solve that ran above so marshal everything
				this.pict.views.PictFormMetacontroller.marshalFormSections();
			}
		}
	}
}

module.exports = DynamicTabularData;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],73:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libDynamicInput = require('../providers/Pict-Provider-DynamicInput.js');

const templateSetDefaultFormTemplates = require('./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js');
const templateSetReadOnlyTemplates = require('./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates-ReadOnly.js');

const libTemplateValueSetWithGroup = require('../templates/Pict-Template-Metacontroller-ValueSetWithGroup.js');
const libTemplateDynamicInput = require('../templates/Pict-Template-Metatemplate-Input.js');
const libTemplateDynamicInputWithHashAddress = require('../templates/Pict-Template-Metatemplate-InputWithHashAddress.js');
const libTemplateDynamicInputWithView = require('../templates/Pict-Template-Metatemplate-InputWithView.js');
const libTemplateDynamicInputWithViewAndHashAddress = require('../templates/Pict-Template-Metatemplate-InputWithViewAndHashAddress.js');
const libTemplateDynamicInputWithViewAndDescriptorAddress = require('../templates/Pict-Template-Metatemplate-InputWithViewAndDescriptorAddress.js');
const libTemplateControlFromDynamicManifest = require('../templates/Pict-Template-ControlFromDynamicManifest.js');
const libTemplateControlFromDynamicManifestForHash = require('../templates/Pict-Template-ControlFromDynamicManifestForHash.js');
const libTemplateGetViewSchemaValue = require('../templates/Pict-Template-DyanmicView-Value.js');
const libTemplateGetViewSchemaValueByHash = require('../templates/Pict-Template-DyanmicView-ValueByHash.js');
const libTemplateTabularRowLabels = require('../templates/Pict-Template-TabularRowLabels.js');
const libTemplateTabularEditingControls = require('../templates/Pict-Template-TabularEditingControls.js');


// TODO: This is temporary until we publish new pict
const libTemplatePluckJoinUnique = require('../templates/Pict-Template-Proxy-PluckJoinUnique.js');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-MetaTemplates-Basic",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * Represents a class that provides dynamic templates for the Pict form section provider.
 * @extends libPictProvider
 */
class PictDynamicFormsTemplates extends libPictProvider
{
	/**
	 * Constructs a new instance of the PictProviderDynamicTemplates class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		this.pict.addProviderSingleton('DynamicInput', libDynamicInput.default_configuration, libDynamicInput);

		this.pict.addTemplate(libTemplateValueSetWithGroup);
		this.pict.addTemplate(libTemplateDynamicInput);
		this.pict.addTemplate(libTemplateDynamicInputWithHashAddress);
		this.pict.addTemplate(libTemplateDynamicInputWithView);
		this.pict.addTemplate(libTemplateDynamicInputWithViewAndHashAddress);
		this.pict.addTemplate(libTemplateDynamicInputWithViewAndDescriptorAddress);
		this.pict.addTemplate(libTemplatePluckJoinUnique);
		this.pict.addTemplate(libTemplateControlFromDynamicManifest);
		this.pict.addTemplate(libTemplateControlFromDynamicManifestForHash);
		this.pict.addTemplate(libTemplateGetViewSchemaValue);
		this.pict.addTemplate(libTemplateGetViewSchemaValueByHash);
		this.pict.addTemplate(libTemplateTabularRowLabels);
		this.pict.addTemplate(libTemplateTabularEditingControls);

		if (this.options?.MetaTemplateSet && typeof(this.options.MetaTemplateSet) === 'object')
		{
			this.injectTemplateSet(this.options.MetaTemplateSet);
		}
		else
		{
			this.injectTemplateSet(templateSetDefaultFormTemplates);
		}
		this.injectTemplateSet(templateSetReadOnlyTemplates);
	}

	/**
	 * Injects a template set into Pict for the Dynamic Form Section Provider.
	 *
	 * The TemplateSet object expects to have a `TemplatePrefix` and `Templates` property.
	 *
	 * The `TemplatePrefix` is used to prefix the hash of the template.
	 *
	 * The `Templates` property is an array of objects with the following properties:
	 * - `HashPostfix` - The postfix to be added to the template hash.  This defines which dynamic template in the Layout it represents.
	 * - `Template` - The template string to be injected.
	 * - `DefaultInputExtensions` - An optional array of default input extensions to be added to the Dynamic Input provider.
	 *
	 * The context of the template *is not the data*.  The template context is one of these five things depending on the layout layer:
	 * - `Form` - The form object.
	 * - `Section` - The section object.
	 * - `Group` - The group object.
	 * - `Row` - The row object.
	 * - `Input` - The input object.
	 *
	 * @param {Object} pTemplateSet - The template set to be injected.
	 */
	injectTemplateSet(pTemplateSet)
	{
		let tmpTemplatePrefix = 'PictFormsUnknown';
		let tmpTemplates = [];
		let tmpTemplateSet = {};

		tmpTemplatePrefix = this.options?.MetaTemplateSet ?? tmpTemplatePrefix;
		tmpTemplates = this.options?.MetaTemplateSet?.Templates ?? tmpTemplates;

		tmpTemplatePrefix = pTemplateSet?.TemplatePrefix ?? tmpTemplatePrefix;
		tmpTemplates = pTemplateSet?.Templates ?? tmpTemplates;

		for (let i = 0; i < tmpTemplates.length; i++)
		{
			let tmpMetaTemplate = tmpTemplates[i];
			let tmpMetaTemplateHash = `${tmpTemplatePrefix}${tmpMetaTemplate.HashPostfix}`;
			tmpTemplateSet[tmpMetaTemplateHash] = (
				{
					Hash: tmpMetaTemplateHash,
					Template: tmpMetaTemplate.Template
				});
			if (tmpMetaTemplate.hasOwnProperty('DefaultInputExtensions'))
			{
				tmpTemplateSet[tmpMetaTemplateHash].DefaultInputExtensions = JSON.parse(JSON.stringify(tmpMetaTemplate.DefaultInputExtensions));
			}
		}

		for (let i = 0; i < templateSetDefaultFormTemplates.Templates.length; i++)
		{
			let tmpTemplate = templateSetDefaultFormTemplates.Templates[i];
			let tmpTemplateHash = `${tmpTemplatePrefix}${tmpTemplate.HashPostfix}`;
			// Only load default templates if they are not already defined in the options
			if (!(tmpTemplateHash in tmpTemplateSet))
			{
				tmpTemplateSet[tmpTemplateHash] = (
					{
						Hash: tmpTemplateHash,
						Template: tmpTemplate.Template
					});
				if (tmpTemplate.hasOwnProperty('DefaultInputExtensions'))
				{
					tmpTemplateSet[tmpTemplateHash].DefaultInputExtensions = JSON.parse(JSON.stringify(tmpTemplate.DefaultInputExtensions));
				}
			}
		}

		let tmpTemplateList = Object.keys(tmpTemplateSet);
		this.log.info(`Pict Form Section Provider for [${tmpTemplatePrefix}] Loaded ${tmpTemplateList.length} templates.`);
		for (let i = 0; i < tmpTemplateList.length; i++)
		{
			let tmpMetaTemplate = tmpTemplateSet[tmpTemplateList[i]];
			this.pict.TemplateProvider.addTemplate(tmpMetaTemplate.Hash, tmpMetaTemplate.Template);
			if (tmpMetaTemplate.hasOwnProperty('DefaultInputExtensions'))
			{
				for (let i = 0; i < tmpMetaTemplate.DefaultInputExtensions.length; i++)
				{
					this.pict.providers.DynamicInput.addDefaultInputProvider(tmpMetaTemplate.Hash, tmpMetaTemplate.DefaultInputExtensions[i]);
				}
			}
		}
	}
}

module.exports = PictDynamicFormsTemplates;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../providers/Pict-Provider-DynamicInput.js":67,"../templates/Pict-Template-ControlFromDynamicManifest.js":108,"../templates/Pict-Template-ControlFromDynamicManifestForHash.js":109,"../templates/Pict-Template-DyanmicView-Value.js":110,"../templates/Pict-Template-DyanmicView-ValueByHash.js":111,"../templates/Pict-Template-Metacontroller-ValueSetWithGroup.js":112,"../templates/Pict-Template-Metatemplate-Input.js":113,"../templates/Pict-Template-Metatemplate-InputWithHashAddress.js":114,"../templates/Pict-Template-Metatemplate-InputWithView.js":115,"../templates/Pict-Template-Metatemplate-InputWithViewAndDescriptorAddress.js":116,"../templates/Pict-Template-Metatemplate-InputWithViewAndHashAddress.js":117,"../templates/Pict-Template-Proxy-PluckJoinUnique.js":118,"../templates/Pict-Template-TabularEditingControls.js":119,"../templates/Pict-Template-TabularRowLabels.js":120,"./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates-ReadOnly.js":81,"./dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js":82,"pict-provider":19}],74:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Provider-FormPersistence",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false,

	// Scoping configuration
	// Override the app identifier; defaults to pict.settings.Product
	"AppIdentifier": false,
	// Override the form type identifier; defaults to "DefaultForm"
	"FormTypeIdentifier": false,

	// Auto-persistence settings
	// When true, the provider will automatically persist the active form on data changes
	// triggered from DynamicForm views (dataChanged / dataChangedTabular).
	"AutoPersistOnDataChange": false,
	"AutoPersistDebounceMs": 2000,
	// When true, bundle data is also saved alongside form data during autosave
	// if the active form record has a BundleContextIdentifier.
	"AutoPersistBundleWithForm": true,

	// Storage key prefix
	"StorageKeyPrefix": "PSF",

	// The address to resolve bundle data from (e.g. "Bundle")
	"BundleSourceAddress": "Bundle",
	// The address to resolve form data from; false means use DataBroker.marshalDestination
	"FormDataSourceAddress": false
});

/**
 * Provider for offline form data persistence.
 *
 * Stores form data and bundle data in scoped records (localStorage by default).
 * The wrapping application can override the storage backend by calling setStorageAdapter().
 *
 * This provider is opt-in; the wrapping application registers it when needed.
 *
 * @extends libPictProvider
 */
class PictFormPersistence extends libPictProvider
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {string|null} */
		this._activeFormGUID = null;

		/** @type {any} */
		this._persistTimerHandle = null;

		// Initialize the default localStorage adapter
		this.storageAdapter = this.createLocalStorageAdapter();
	}

	// ========================================================================
	// Storage Adapter
	// ========================================================================

	/**
	 * Creates the default localStorage adapter.
	 *
	 * @returns {object} An adapter object with setItem, getItem, removeItem, getKeysWithPrefix methods.
	 */
	createLocalStorageAdapter()
	{
		let tmpSelf = this;

		return (
		{
			setItem: function (pKey, pValue)
			{
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						window.localStorage.setItem(pKey, pValue);
						return true;
					}
					tmpSelf.log.warn('FormPersistence: localStorage is not available.');
					return false;
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage setItem error: ${pError.message}`);
					return false;
				}
			},

			getItem: function (pKey)
			{
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						return window.localStorage.getItem(pKey);
					}
					tmpSelf.log.warn('FormPersistence: localStorage is not available.');
					return null;
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage getItem error: ${pError.message}`);
					return null;
				}
			},

			removeItem: function (pKey)
			{
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						window.localStorage.removeItem(pKey);
						return true;
					}
					tmpSelf.log.warn('FormPersistence: localStorage is not available.');
					return false;
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage removeItem error: ${pError.message}`);
					return false;
				}
			},

			getKeysWithPrefix: function (pPrefix)
			{
				let tmpKeys = [];
				try
				{
					if (typeof (window) !== 'undefined' && window.localStorage)
					{
						for (let i = 0; i < window.localStorage.length; i++)
						{
							let tmpKey = window.localStorage.key(i);
							if (tmpKey && tmpKey.startsWith(pPrefix))
							{
								tmpKeys.push(tmpKey);
							}
						}
					}
				}
				catch (pError)
				{
					tmpSelf.log.error(`FormPersistence: localStorage getKeysWithPrefix error: ${pError.message}`);
				}
				return tmpKeys;
			}
		});
	}

	/**
	 * Replace the storage adapter with a custom implementation.
	 *
	 * The adapter must implement: setItem(key, value), getItem(key), removeItem(key), getKeysWithPrefix(prefix).
	 *
	 * @param {object} pAdapter - The storage adapter to use.
	 * @returns {boolean} True if the adapter was accepted.
	 */
	setStorageAdapter(pAdapter)
	{
		if (typeof (pAdapter) !== 'object' || pAdapter === null)
		{
			this.log.error('FormPersistence setStorageAdapter called with an invalid adapter.');
			return false;
		}

		let tmpRequiredMethods = ['setItem', 'getItem', 'removeItem', 'getKeysWithPrefix'];

		for (let i = 0; i < tmpRequiredMethods.length; i++)
		{
			if (typeof (pAdapter[tmpRequiredMethods[i]]) !== 'function')
			{
				this.log.error(`FormPersistence setStorageAdapter: adapter is missing required method [${tmpRequiredMethods[i]}].`);
				return false;
			}
		}

		this.storageAdapter = pAdapter;
		return true;
	}

	// ========================================================================
	// Key Generation
	// ========================================================================

	/**
	 * Returns the application identifier for storage key scoping.
	 *
	 * @returns {string}
	 */
	getAppIdentifier()
	{
		if (this.options.AppIdentifier)
		{
			return this.options.AppIdentifier;
		}
		if (this.pict && this.pict.settings && this.pict.settings.Product)
		{
			return this.pict.settings.Product;
		}
		return 'DefaultApp';
	}

	/**
	 * Returns the form type identifier for storage key scoping.
	 *
	 * @returns {string}
	 */
	getFormTypeIdentifier()
	{
		if (this.options.FormTypeIdentifier)
		{
			return this.options.FormTypeIdentifier;
		}
		return 'DefaultForm';
	}

	/**
	 * Builds a storage key for a specific record type and identifier.
	 *
	 * @param {string} pRecordType - The record type (e.g. "Form", "Bundle", "Index").
	 * @param {string} [pIdentifier] - The specific record identifier (e.g. GUID or context ID).
	 * @returns {string} The fully qualified storage key.
	 */
	getStorageKey(pRecordType, pIdentifier)
	{
		let tmpPrefix = `${this.options.StorageKeyPrefix}:${this.getAppIdentifier()}:${this.getFormTypeIdentifier()}`;

		if (pIdentifier)
		{
			return `${tmpPrefix}:${pRecordType}:${pIdentifier}`;
		}
		return `${tmpPrefix}:${pRecordType}`;
	}

	/**
	 * Returns the storage key for the form index.
	 *
	 * @returns {string}
	 */
	getIndexKey()
	{
		return this.getStorageKey('Index');
	}

	// ========================================================================
	// Index Management
	// ========================================================================

	/**
	 * Retrieves the form index from storage.
	 *
	 * The index contains metadata for all persisted form records.
	 *
	 * @returns {object} The index object with a Records property.
	 */
	getFormIndex()
	{
		let tmpIndexKey = this.getIndexKey();
		let tmpRawIndex = this.storageAdapter.getItem(tmpIndexKey);

		if (tmpRawIndex)
		{
			try
			{
				let tmpIndex = JSON.parse(tmpRawIndex);
				if (typeof (tmpIndex) === 'object' && tmpIndex !== null && ('Records' in tmpIndex))
				{
					return tmpIndex;
				}
			}
			catch (pError)
			{
				this.log.error(`FormPersistence getFormIndex: failed to parse index: ${pError.message}`);
			}
		}

		// Return a fresh empty index
		return { Records: {} };
	}

	/**
	 * Saves the form index to storage.
	 *
	 * @param {object} pIndex - The index object to persist.
	 * @returns {boolean} True if saved successfully.
	 */
	_saveFormIndex(pIndex)
	{
		let tmpIndexKey = this.getIndexKey();
		return this.storageAdapter.setItem(tmpIndexKey, JSON.stringify(pIndex));
	}

	// ========================================================================
	// Form Data CRUD
	// ========================================================================

	/**
	 * Creates a new form record in the index and returns its GUID.
	 *
	 * This does not save any form data yet; it only creates the index entry.
	 * Call saveFormData() to persist the actual form content.
	 *
	 * @param {string} [pBundleContextIdentifier] - An optional context identifier linking this form to a bundle (e.g. a project ID).
	 * @param {string} [pLabel] - An optional human-readable label for this form instance.
	 * @returns {string} The GUID assigned to the new form record.
	 */
	newFormRecord(pBundleContextIdentifier, pLabel)
	{
		let tmpGUID = this.fable.getUUID();
		let tmpNow = new Date().toISOString();

		let tmpFormIndex = this.getFormIndex();

		tmpFormIndex.Records[tmpGUID] = (
		{
			GUID: tmpGUID,
			Created: tmpNow,
			Modified: tmpNow,
			BundleContextIdentifier: pBundleContextIdentifier || null,
			Synced: false,
			SyncedTimestamp: null,
			Label: pLabel || null
		});

		this._saveFormIndex(tmpFormIndex);

		this.log.info(`FormPersistence: created new form record [${tmpGUID}]${pLabel ? ` labeled "${pLabel}"` : ''}.`);

		return tmpGUID;
	}

	/**
	 * Saves the current in-memory form data to storage for a specific instance GUID.
	 *
	 * Reads from the DataBroker marshal destination (or the configured FormDataSourceAddress).
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record to save.
	 * @returns {boolean} True if saved successfully.
	 */
	saveFormData(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence saveFormData called without an instance GUID.');
			return false;
		}

		let tmpFormIndex = this.getFormIndex();
		if (!(pInstanceGUID in tmpFormIndex.Records))
		{
			this.log.error(`FormPersistence saveFormData called for unknown GUID [${pInstanceGUID}].`);
			return false;
		}

		let tmpFormDataSource;
		try
		{
			if (this.options.FormDataSourceAddress)
			{
				tmpFormDataSource = this.pict.resolveStateFromAddress(this.options.FormDataSourceAddress);
			}
			else
			{
				tmpFormDataSource = this.pict.providers.DataBroker.marshalDestinationObject;
			}
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveFormData: failed to resolve form data source: ${pError.message}`);
			return false;
		}

		let tmpSerializedData;
		try
		{
			tmpSerializedData = JSON.stringify(tmpFormDataSource);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveFormData: failed to serialize form data: ${pError.message}`);
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		let tmpResult = this.storageAdapter.setItem(tmpStorageKey, tmpSerializedData);

		if (tmpResult)
		{
			// Update index metadata
			tmpFormIndex.Records[pInstanceGUID].Modified = new Date().toISOString();
			tmpFormIndex.Records[pInstanceGUID].Synced = false;
			this._saveFormIndex(tmpFormIndex);
		}

		return tmpResult;
	}

	/**
	 * Returns the raw serialized form data string for a given GUID without loading it into memory.
	 *
	 * Useful for synchronization -- the wrapping app can send this directly to the server.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record.
	 * @returns {string|null} The raw JSON string, or null if not found.
	 */
	getFormDataRaw(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence getFormDataRaw called without an instance GUID.');
			return null;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		return this.storageAdapter.getItem(tmpStorageKey);
	}

	/**
	 * Loads form data from storage and applies it to the in-memory marshal destination.
	 *
	 * After loading, calls marshalToView() on the metacontroller if available.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record to load.
	 * @returns {boolean} True if loaded successfully.
	 */
	loadFormData(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence loadFormData called without an instance GUID.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		let tmpSerializedData = this.storageAdapter.getItem(tmpStorageKey);

		if (tmpSerializedData === null)
		{
			this.log.warn(`FormPersistence loadFormData: no data found for GUID [${pInstanceGUID}].`);
			return false;
		}

		let tmpFormData;
		try
		{
			tmpFormData = JSON.parse(tmpSerializedData);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadFormData: failed to parse stored data for GUID [${pInstanceGUID}]: ${pError.message}`);
			return false;
		}

		// Resolve the destination object
		let tmpDestinationObject;
		try
		{
			if (this.options.FormDataSourceAddress)
			{
				tmpDestinationObject = this.pict.resolveStateFromAddress(this.options.FormDataSourceAddress);
			}
			else
			{
				tmpDestinationObject = this.pict.providers.DataBroker.marshalDestinationObject;
			}
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadFormData: failed to resolve destination object: ${pError.message}`);
			return false;
		}

		// Clear existing data and apply loaded data
		let tmpExistingKeys = Object.keys(tmpDestinationObject);
		for (let i = 0; i < tmpExistingKeys.length; i++)
		{
			delete tmpDestinationObject[tmpExistingKeys[i]];
		}
		Object.assign(tmpDestinationObject, tmpFormData);

		// Marshal to view if the metacontroller is available
		if (this.pict.views && this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalToView();
		}

		this.log.info(`FormPersistence: loaded form data for GUID [${pInstanceGUID}].`);
		return true;
	}

	/**
	 * Deletes a form record from storage and removes it from the index.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record to delete.
	 * @returns {boolean} True if deleted successfully.
	 */
	deleteFormRecord(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence deleteFormRecord called without an instance GUID.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Form', pInstanceGUID);
		this.storageAdapter.removeItem(tmpStorageKey);

		let tmpFormIndex = this.getFormIndex();
		if (pInstanceGUID in tmpFormIndex.Records)
		{
			delete tmpFormIndex.Records[pInstanceGUID];
			this._saveFormIndex(tmpFormIndex);
		}

		this.log.info(`FormPersistence: deleted form record [${pInstanceGUID}].`);
		return true;
	}

	// ========================================================================
	// Bundle Data
	// ========================================================================

	/**
	 * Saves bundle data for a given context identifier.
	 *
	 * Reads from the configured BundleSourceAddress (default: "Bundle").
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier (e.g. a project ID).
	 * @returns {boolean} True if saved successfully.
	 */
	saveBundleData(pContextIdentifier)
	{
		if (!pContextIdentifier)
		{
			this.log.error('FormPersistence saveBundleData called without a context identifier.');
			return false;
		}

		let tmpBundleData;
		try
		{
			tmpBundleData = this.pict.resolveStateFromAddress(this.options.BundleSourceAddress);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveBundleData: failed to resolve bundle data source: ${pError.message}`);
			return false;
		}

		let tmpSerializedData;
		try
		{
			tmpSerializedData = JSON.stringify(tmpBundleData);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence saveBundleData: failed to serialize bundle data: ${pError.message}`);
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Bundle', pContextIdentifier);
		return this.storageAdapter.setItem(tmpStorageKey, tmpSerializedData);
	}

	/**
	 * Loads bundle data for a given context identifier into the bundle source address.
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier (e.g. a project ID).
	 * @returns {boolean} True if loaded successfully.
	 */
	loadBundleData(pContextIdentifier)
	{
		if (!pContextIdentifier)
		{
			this.log.error('FormPersistence loadBundleData called without a context identifier.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Bundle', pContextIdentifier);
		let tmpSerializedData = this.storageAdapter.getItem(tmpStorageKey);

		if (tmpSerializedData === null)
		{
			this.log.warn(`FormPersistence loadBundleData: no data found for context [${pContextIdentifier}].`);
			return false;
		}

		let tmpBundleData;
		try
		{
			tmpBundleData = JSON.parse(tmpSerializedData);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadBundleData: failed to parse stored data for context [${pContextIdentifier}]: ${pError.message}`);
			return false;
		}

		// Resolve the bundle destination
		let tmpBundleDestination;
		try
		{
			tmpBundleDestination = this.pict.resolveStateFromAddress(this.options.BundleSourceAddress);
		}
		catch (pError)
		{
			this.log.error(`FormPersistence loadBundleData: failed to resolve bundle destination: ${pError.message}`);
			return false;
		}

		// Clear existing bundle data and apply loaded data
		let tmpExistingKeys = Object.keys(tmpBundleDestination);
		for (let i = 0; i < tmpExistingKeys.length; i++)
		{
			delete tmpBundleDestination[tmpExistingKeys[i]];
		}
		Object.assign(tmpBundleDestination, tmpBundleData);

		this.log.info(`FormPersistence: loaded bundle data for context [${pContextIdentifier}].`);
		return true;
	}

	/**
	 * Deletes bundle data for a given context identifier.
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier.
	 * @returns {boolean} True if deleted successfully.
	 */
	deleteBundleData(pContextIdentifier)
	{
		if (!pContextIdentifier)
		{
			this.log.error('FormPersistence deleteBundleData called without a context identifier.');
			return false;
		}

		let tmpStorageKey = this.getStorageKey('Bundle', pContextIdentifier);
		this.storageAdapter.removeItem(tmpStorageKey);

		this.log.info(`FormPersistence: deleted bundle data for context [${pContextIdentifier}].`);
		return true;
	}

	// ========================================================================
	// Listing
	// ========================================================================

	/**
	 * Returns an array of all form record metadata objects from the index.
	 *
	 * @returns {Array<object>} An array of form record metadata.
	 */
	listFormRecords()
	{
		let tmpFormIndex = this.getFormIndex();
		return Object.values(tmpFormIndex.Records);
	}

	/**
	 * Returns an array of form records that have not been marked as synced.
	 *
	 * @returns {Array<object>} An array of unsynced form record metadata.
	 */
	listUnsyncedFormRecords()
	{
		let tmpRecords = this.listFormRecords();
		let tmpUnsynced = [];

		for (let i = 0; i < tmpRecords.length; i++)
		{
			if (!tmpRecords[i].Synced)
			{
				tmpUnsynced.push(tmpRecords[i]);
			}
		}

		return tmpUnsynced;
	}

	/**
	 * Returns an array of form records associated with a specific bundle context.
	 *
	 * @param {string} pContextIdentifier - The bundle context identifier.
	 * @returns {Array<object>} An array of matching form record metadata.
	 */
	listFormRecordsForContext(pContextIdentifier)
	{
		let tmpRecords = this.listFormRecords();
		let tmpMatching = [];

		for (let i = 0; i < tmpRecords.length; i++)
		{
			if (tmpRecords[i].BundleContextIdentifier === pContextIdentifier)
			{
				tmpMatching.push(tmpRecords[i]);
			}
		}

		return tmpMatching;
	}

	// ========================================================================
	// Sync Support
	// ========================================================================

	/**
	 * Marks a form record as synced.
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record.
	 * @returns {boolean} True if the record was found and updated.
	 */
	markFormSynced(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence markFormSynced called without an instance GUID.');
			return false;
		}

		let tmpFormIndex = this.getFormIndex();

		if (!(pInstanceGUID in tmpFormIndex.Records))
		{
			this.log.warn(`FormPersistence markFormSynced: GUID [${pInstanceGUID}] not found in index.`);
			return false;
		}

		tmpFormIndex.Records[pInstanceGUID].Synced = true;
		tmpFormIndex.Records[pInstanceGUID].SyncedTimestamp = new Date().toISOString();
		this._saveFormIndex(tmpFormIndex);

		return true;
	}

	/**
	 * Marks a form record as dirty (unsynced).
	 *
	 * @param {string} pInstanceGUID - The GUID of the form record.
	 * @returns {boolean} True if the record was found and updated.
	 */
	markFormDirty(pInstanceGUID)
	{
		if (!pInstanceGUID)
		{
			this.log.error('FormPersistence markFormDirty called without an instance GUID.');
			return false;
		}

		let tmpFormIndex = this.getFormIndex();

		if (!(pInstanceGUID in tmpFormIndex.Records))
		{
			this.log.warn(`FormPersistence markFormDirty: GUID [${pInstanceGUID}] not found in index.`);
			return false;
		}

		tmpFormIndex.Records[pInstanceGUID].Synced = false;
		this._saveFormIndex(tmpFormIndex);

		return true;
	}

	// ========================================================================
	// Active Form Management
	// ========================================================================

	/**
	 * Gets the currently active form instance GUID.
	 *
	 * @returns {string|null} The active form GUID, or null if none is set.
	 */
	getActiveFormGUID()
	{
		return this._activeFormGUID;
	}

	/**
	 * Sets the active form instance GUID.
	 *
	 * This is used by persistActiveForm() and triggerDebouncedPersist().
	 *
	 * @param {string} pInstanceGUID - The GUID to set as active.
	 */
	setActiveFormGUID(pInstanceGUID)
	{
		this._activeFormGUID = pInstanceGUID || null;
	}

	/**
	 * Saves the currently active form's data to storage.
	 *
	 * When AutoPersistBundleWithForm is true and the active form record has
	 * a BundleContextIdentifier, the bundle data is also persisted.
	 *
	 * @returns {boolean} True if persisted successfully, false if no active form or save failed.
	 */
	persistActiveForm()
	{
		if (!this._activeFormGUID)
		{
			this.log.warn('FormPersistence persistActiveForm: no active form GUID set.');
			return false;
		}

		let tmpResult = this.saveFormData(this._activeFormGUID);

		// Also persist the associated bundle context if configured
		if (tmpResult && this.options.AutoPersistBundleWithForm)
		{
			let tmpFormIndex = this.getFormIndex();
			let tmpRecord = tmpFormIndex.Records[this._activeFormGUID];
			if (tmpRecord && tmpRecord.BundleContextIdentifier)
			{
				this.saveBundleData(tmpRecord.BundleContextIdentifier);
			}
		}

		return tmpResult;
	}

	/**
	 * Triggers a debounced persist of the active form.
	 *
	 * Call this from a dataChanged handler to avoid persisting on every keystroke.
	 * The persist fires after AutoPersistDebounceMs of inactivity.
	 */
	triggerDebouncedPersist()
	{
		if (!this._activeFormGUID)
		{
			return;
		}

		if (this._persistTimerHandle)
		{
			clearTimeout(this._persistTimerHandle);
		}

		let tmpSelf = this;
		this._persistTimerHandle = setTimeout(
			function ()
			{
				tmpSelf.persistActiveForm();
				tmpSelf._persistTimerHandle = null;
			},
			this.options.AutoPersistDebounceMs);
	}

	/**
	 * Called by DynamicForm views when data changes (dataChanged or dataChangedTabular).
	 *
	 * When AutoPersistOnDataChange is enabled, triggers a debounced persist.
	 * This method exists as the integration hook between the form lifecycle and
	 * the persistence provider -- the DynamicForm view calls this if the provider exists.
	 */
	onFormDataChanged()
	{
		if (this.options.AutoPersistOnDataChange)
		{
			this.triggerDebouncedPersist();
		}
	}
}

module.exports = PictFormPersistence;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],75:[function(require,module,exports){
const libPictProvider = require('pict-provider');

// TODO: Pull this back to pict as a core service once we are happy with the shape.
/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Informary",

	"AutoInitialize": false,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * Represents a provider for dynamic forms in the PICT system.
 * Extends the `libPictProvider` class.
 */
class PictDynamicFormsInformary extends libPictProvider
{
	/**
	 * Creates an instance of the `PictDynamicFormsInformary` class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { newManyfest: (options: any) => import('manyfest') }} */
		this.pict;
		/** @type {any} */
		this.log;

		this.genericManifest = this.pict.newManyfest({Scope:'GenericInformary'});
	}

	/**
	 * Retrieves all form elements for a given form hash.
	 *
	 * @param {string} pFormHash - The hash of the form.
	 * @returns {HTMLElement[]} - An array of HTML elements representing the form elements.
	 */
	getFormElements(pFormHash)
	{
		let tmpSelector = `[data-i-form="${pFormHash}"]`;
		//this.log.trace(`Getting form elements for form hash selector: ${tmpSelector}`);
		return this.pict.ContentAssignment.getElement(tmpSelector);
	}

	/**
	 * Get a full content browser address based on the form, datum and optionally the container and index.
	 *
	 * This can be used in getDomElementByAddress or jquery selectors to return the element.
	 *
	 * @param {string} pFormHash - The form hash.
	 * @param {string} pDatumHash - The datum hash.
	 * @param {string|null} pContainer - The container (optional).
	 * @param {string|number} pIndex - The index.
	 * @returns {string} The content browser address.
	 */
	getContentBrowserAddress(pFormHash, pDatumHash, pContainer, pIndex)
	{
		// TODO: Need some guards, yo
		if (pContainer)
		{
			return `[data-i-form="${pFormHash}"][data-i-datum="${pDatumHash}"][data-i-container="${pContainer}"][data-i-index="${pIndex}"]`;
		}
		else
		{
			return `[data-i-form="${pFormHash}"][data-i-datum="${pDatumHash}"]`;
		}
	}

	/**
	 * Returns the composed container address string for a given container, index, and datum hash.
	 *
	 * @param {string} pContainer - The container name.
	 * @param {string|number} pIndex - The index of the container.
	 * @param {string} pDatumHash - The datum hash.
	 * @returns {string} The composed container address.
	 */
	getComposedContainerAddress(pContainer, pIndex, pDatumHash)
	{
		return `${pContainer}[${pIndex}].${pDatumHash}`;
	}

	/**
	 * Marshals form data to the provided application state data object using the given form hash and manifest.
	 *
	 * @param {object} pAppStateData - The application state data object to marshal the form data to.
	 * @param {string} pFormHash - The form hash representing the form elements.
	 * @param {object} pManifest - The manifest object used to map form data to the application state data.
	 * @param {string} [pDatum] - The datum hash to pull in.  If not provided, all data is marshalled.
	 * @param {number|string} [pRecordIndex] - The record index to pull in.  If not provided, all data is marshalled.
	 */
	marshalFormToData(pAppStateData, pFormHash, pManifest, pDatum, pRecordIndex)
	{
		const tmpManifest = typeof(pManifest) === 'object' ? pManifest : this.genericManifest;
		const tmpFormElements = this.getFormElements(pFormHash);

		// Optional Filters (so we don't just blindly do the whole form)
		const tmpDatum = (pDatum != null) ? false : pDatum;
		const tmpRecordIndex = (typeof(pRecordIndex) === 'number') ? String(pRecordIndex) : pRecordIndex;

		// Enumerate the form elements, and put data in them for each address
		for (const tmpFormElement of tmpFormElements)
		{
			this.marshalSpecicificFormElementToData(pFormHash, tmpFormElement, tmpManifest, pAppStateData, tmpDatum, tmpRecordIndex);
		}
	}

	/**
	 * Marshals a specific form element's data to the application state data.
	 *
	 * @param {string} pFormHash - The hash of the form.
	 * @param {HTMLElement} tmpFormElement - The form element to marshal.
	 * @param {Object} tmpManifest - The manifest object to set values.
	 * @param {Object} pAppStateData - The application state data object.
	 * @param {any} [pDatumFilter] - Optional filter for datum address.
	 * @param {any} [pRecordIndexFilter] - Optional filter for record index.
	 * @returns {boolean} - Returns false if the element falls outside the filters or if the browser value is null.
	 */
	marshalSpecicificFormElementToData(pFormHash, tmpFormElement, tmpManifest, pAppStateData, pDatumFilter, pRecordIndexFilter)
	{
		const tmpDatumAddress = tmpFormElement.getAttribute('data-i-datum');

		const tmpContainerAddress = tmpFormElement.getAttribute('data-i-container');
		const tmpIndex = tmpFormElement.getAttribute('data-i-index');

		// Process the filters
		// TODO: Now that this is a function, having these filters here is not good.  We need to move this to the caller.  But the above getAttribute is required... rethink filtering?
		if (pDatumFilter && (pDatumFilter !== tmpDatumAddress))
		{
			// Falls outside the filter, continue on
			return false;
		}
		if (pRecordIndexFilter && tmpIndex && pRecordIndexFilter !== tmpIndex)
		{
			// Falls outside the filter, continue on
			return false;
		}

		let tmpBrowserValue = this.pict.ContentAssignment.readContent(this.getContentBrowserAddress(pFormHash, tmpDatumAddress, tmpContainerAddress, tmpIndex));
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`Informary marshalling BrowserForm Data ${tmpBrowserValue} from form element [${tmpDatumAddress}] in container [${tmpContainerAddress}] at index [${tmpIndex}] to the datum address [${tmpDatumAddress}].`);
		}

		if (tmpBrowserValue == null)
		{
			return false;
		}

		if (!tmpContainerAddress)
		{
			tmpManifest.setValueAtAddress(pAppStateData, tmpDatumAddress, tmpBrowserValue);
		}
		else
		{
			// Compose the address .. right now only arrays
			tmpManifest.setValueAtAddress(pAppStateData, this.getComposedContainerAddress(tmpContainerAddress, tmpIndex, tmpDatumAddress), tmpBrowserValue);
		}		
	}

	/**
	 * Marshals data from some application state object to a specific subset of browser form elements.
	 *
	 * @param {object} pAppStateData - The application state data to marshal into the form.  Usually AppData but can be other objects.
	 * @param {string} pFormHash - The hash of the form to marshal data into.  This is the data-i-form attribute.
	 * @param {object} pManifest - The manifest object.  If not provided, the generic manifest is used.
	 */
	marshalDataToForm(pAppStateData, pFormHash, pManifest)
	{
		// TODO: Take a list of hashes and/or index addresses to marshal in, preventing OVERMARSHAL from taking control
		let tmpManifest = typeof(pManifest) === 'object' ? pManifest : this.genericManifest;
		let tmpFormElements = this.getFormElements(pFormHash);

		// Enumerate the form elements, and put data in them for each address
		for (let i = 0; i < tmpFormElements.length; i++)
		{
			this.marshalSpecificElementDataToForm(pFormHash, tmpFormElements[i], tmpManifest, pAppStateData);
		}
	}

	/**
	 * Marshals specific element data to a form.
	 *
	 * @param {string} pFormHash - The hash of the form.
	 * @param {HTMLElement} pFormElement - The form element to marshal data to.
	 * @param {Object} tmpManifest - The manifest object containing data retrieval methods.
	 * @param {Object} pAppStateData - The application state data.
	 * @returns {boolean} Returns false if the form element does not have a datum address.
	 */
	marshalSpecificElementDataToForm(pFormHash, pFormElement, tmpManifest, pAppStateData)
	{
		let tmpDatumAddress = pFormElement.getAttribute('data-i-datum');

		let tmpContainerAddress = pFormElement.getAttribute('data-i-container');
		let tmpIndex = Number(pFormElement.getAttribute('data-i-index'));

		if (!tmpDatumAddress)
		{
			this.log.warn(`Informary found a form element without a datum address.  Skipping.`);
			return false;
		}

		if (!tmpContainerAddress)
		{
			let tmpAppStateValue = tmpManifest.getValueAtAddress(pAppStateData, tmpDatumAddress);

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`Informary marshalling App State data ${tmpAppStateValue} to Browser Form element [${tmpDatumAddress}].`);
			}

			if (tmpAppStateValue != null)
			{
				this.pict.ContentAssignment.assignContent(this.getContentBrowserAddress(pFormHash, tmpDatumAddress, tmpContainerAddress, tmpIndex), tmpAppStateValue);
			}
		}
		else
		{
			let tmpAppStateValue = tmpManifest.getValueAtAddress(pAppStateData, this.getComposedContainerAddress(tmpContainerAddress, tmpIndex, tmpDatumAddress));

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`Informary marshalling App State data ${tmpAppStateValue} to Browser Form element [${tmpDatumAddress}] in container [${tmpContainerAddress}] at index [${tmpIndex}].`);
			}

			if (tmpAppStateValue != null)
			{
				this.pict.ContentAssignment.assignContent(this.getContentBrowserAddress(pFormHash, tmpDatumAddress, tmpContainerAddress, tmpIndex), tmpAppStateValue);
			}
		}
	}

	/**
	 * Manually marshals data to a form by assigning content based on context in the descriptor.
	 * @param {object} pInput - The input manifest descriptor to marshal data to form from.
	 * @returns boolean if assignment was successful
	 */
	manualMarshalDataToFormByInput(pInput)
	{
		if (typeof(pInput) !== 'object')
		{
			this.log.error(`Informary failed to marshal data to form because the input is not an object.`);
			return false;
		}
		if (!('Hash' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a hash.`);
			return false;
		}
		if (!('PictForm' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a PictForm object.`);
			return false;
		}
		let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
		if (!tmpInputView)
		{
			this.log.error(`Informary failed to marshal data to form because the input view is missing.`);
			return false;
		}
		return this.pict.ContentAssignment.assignContent(pInput.Macro.HTMLSelector, tmpInputView.getValueByHash(pInput.Hash));
	}

	/**
	 * Manually marshals tabular data to a form by assigning content based on context in the descriptor.
	 * @param {object} pInput - The input manifest descriptor to marshal data to form from.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 * @returns boolean if assignment was successful
	 */
	manualMarshalTabularDataToFormByInput(pInput, pRowIndex)
	{
		if (typeof(pInput) !== 'object')
		{
			this.log.error(`Informary failed to marshal data to form because the input is not an object.`);
			return false;
		}
		if (!('Hash' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a hash.`);
			return false;
		}
		if (!('PictForm' in pInput))
		{
			this.log.error(`Informary failed to marshal data to form because the input is missing a PictForm object.`);
			return false;
		}
		let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
		if (!tmpInputView)
		{
			this.log.error(`Informary failed to marshal data to form because the input view is missing.`);
			return false;
		}
		return this.pict.ContentAssignment.assignContent(`${pInput.Macro.HTMLSelectorTabular}[data-i-index="${pRowIndex}"]`,
			tmpInputView.getTabularValueByHash(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex));
	}

	/**
	 * Manually marshals data to a form by assigning content to a specified HTML address.
	 *
	 * @param {string} pHTMLAddress - The HTML address where the content should be assigned.
	 * @param {string} pValue - The value to be assigned to the specified HTML address.
	 */
	manualMarshalDataToForm(pHTMLAddress, pValue)
	{
		return this.pict.ContentAssignment.assignContent(pHTMLAddress, pValue);
	}

	/**
	 * Manually marshals tabular data to a form.
	 *
	 * @param {string} pHTMLAddress - The HTML address where the data should be assigned.
	 * @param {string} pValue - The value to be assigned to the form element.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 */
	manualMarshalTabularDataToForm(pHTMLAddress, pValue, pRowIndex)
	{
		return this.pict.ContentAssignment.assignContent(`${pHTMLAddress}[data-i-index="${pRowIndex}"]`, pValue);
	}
}

module.exports = PictDynamicFormsInformary;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],76:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-InputExtension",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictInputExtensionProvider class is a provider that allows extensions to the input fields of a form.
 *
 * Can be mapped in via the PictForm property of a descriptor.
 */
class PictInputExtensionProvider extends libPictProvider
{
	/**
	 * Creates an instance of the PictInputExtensionProvider class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}


	/**
	 * Generates the HTML ID for a custom input element based on the given input HTML ID.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @returns {string} The generated input HTML ID.
	 */
	getInputHTMLID(pInputHTMLID)
	{
		return `#INPUT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates the HTML ID for a hidden input element in a tabular data provider.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 * @returns {string} - The generated HTML ID for the hidden input element.
	 */
	getTabularInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * An input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * A tabular input has been initialized (rendered into the DOM)
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object (it will return an array).
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @param {number} pRowIndex - The row index of the tabular data
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Called when the data change function is called
	 *
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Called when an input has this Provider hash in its 'Providers' array.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input object
	 * @param {string} pHTMLSelector - The HTML selector for the input object
	 * @param {number} pRowIndex - The row index of the tabular data
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {number} pRow - The Row index.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Fires when data is marshaled to the form for this input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group definition object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to marshal.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the input in the row columns.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the data was successfully marshaled to the form.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @returns {boolean} - Returns true.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		return true;
	}

	/**
	 * Handles data requests for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @returns {boolean} - Returns true.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		return true;
	}


	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEvent(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onEventTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		return true;
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		return true;
	}
}

module.exports = PictInputExtensionProvider;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],77:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-ListDistilling",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictListDistilling class is a provider that filters lists based on input rules.
 */
class PictListDistilling extends libPictProvider
{
	/**
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/*
	  * This is a sidecar just for making filtration simpler.
	  *
	  * Types of Filtration:
	  * 1. Filter by an explicit value list (union of a set of values)
	  *   Example (explicit:
	  *		{ FilterType: "Explicit", FilterList: ["B", "C"] }
	  *   Example (implicit):
	  * 	{ FilterType: "Explicit", FilterListAddress: 'AppData.Bundle.Colors' }
	  * 2. Filter by a cross-map to a "join" list
	  *   Example (explicit):
	  * 	{ FilterType: "CrossMap", FilterValue:10, FilterValueAddress:'IDColor', FilterValueLookupAddress:'AppData.CurrentSelections.IDColor', FilterMap: [{IDColor:10, IDFruit:20}, {IDColor:10, IDFruit:30, {IDColor:20, IDFruit:30}] }
	  *   Example (implicit):
	  * 	{ FilterType: "CrossMap", FilterValue:10, FilterValueAddress:'IDColor', FilterValueLookupAddress:'AppData.CurrentSelections.IDColor', FilterMapAddress: 'AppData.Bundle.ColorFruitJoin' }
	  * 3. Filter by a string match (from an address?!  Would be cool)
	  *   Example:
	  * 	{ FilterType: "StringMatch", StringMatch: '*Apple* }
	  */
	/**
	  * Filter a list of options based on the filtering rules in a dynamic form input.
	  *
	  * Example Configuration:
	  * ...
			"ListFilterRules": [
					{
						"Filter": "Colour Entry Filter",
						"FilterType": "Explicit",
						"FilterValueComparison": "==",
						"FilterValueAddress": "Listopia.Filters.Colour",
						"IgnoreEmptyValue": true
					},
					{
						"Filter": "Colour List Distilling Filter",
						"FilterType": "CrossMap",
						"JoinListAddress": "View.sectionDefinition.Intersections.Colors.FruitSelectionColorsJoin",
						"JoinListAddressGlobal": true,
						"JoinListValueAddress": "GUIDColors",
						"ExternalValueAddress": "GUIDFruitSelection",
						"FilterToValueAddress": "Listopia.Fruit",
						"IgnoreEmpty": true
					}
				],
	  * ...
	  *
	  * @param {Object} pView - The pict view the list is within
	  * @param {*} pInput - The input within the dynamic forms view
	  * @param {*} pList - The raw list of options to filter
	  * @returns
	  */
	filterList(pView, pInput, pList)
	{
		// The list is expected to be an array of objects with "id" and "text" properties.  This is because of Select2.
		if (typeof(pInput) != 'object')
		{
			this.log.warn(`FilterList failed because the input is not an object.`);
			return pList;
		}
		if (!('PictForm' in pInput))
		{
			this.log.warn(`FilterList failed because the input does not have a PictForm stanza object.`);
			return pList;
		}
		if (!Array.isArray(pList))
		{
			this.log.warn(`FilterList for input [${pInput.Hash}] failed because the list is not an array.`);
			return [];
		}
		let tmpFilterRules = pInput.PictForm.ListFilterRules;
		if ((!tmpFilterRules) || (tmpFilterRules.length == 0) || (!Array.isArray(tmpFilterRules)))
		{
			return pList;
		}

		// Make a copy of the incoming list of options
		let tmpFilteredList = pList.slice(0);
		// We walk backwards so we can remove items from the end without breaking this loop.
		for (let h = pList.length - 1; h >= 0; h--)
		{
			let tmpListEntry = pList[h];
			let tmpEntryAllowed = true;
			for (let i = 0; i < tmpFilterRules.length; i++)
			{
				let tmpFilterRule = tmpFilterRules[i];

				// Remember that options are objects with "id" and "text" properties.  Because of Select2.
				// Genericising this with templating.  Most users will not leverage this technology.
				let tmpRecordComparisonValueAddress = ('FilteredRecordComparisonValue' in tmpFilterRule) ? tmpFilterRule.FilteredRecordComparisonValueAddress : false;
				let tmpComparisonValue;
				if (!tmpRecordComparisonValueAddress)
				{
					// Presume it's filtering on 'id'
					tmpComparisonValue = tmpListEntry.id;
				}
				else
				{
					tmpComparisonValue = pView.getValueByHash(tmpRecordComparisonValueAddress);
				}

				switch(tmpFilterRule.FilterType)
				{
					case 'Explicit':
						let tmpExplicitFilterValueAddress = tmpFilterRule.FilterValueAddress;
						let tmpExplicitFilterValueComparison = ('FilterValueComparison' in tmpFilterRule) ? tmpFilterRule.FilterValueComparison : '==';
						let tmpExplicitFilterIgnoreEmpty = ('IgnoreEmptyValue' in tmpFilterRule) ? tmpFilterRule.IgnoreEmptyValue : false;

						// TODO: This can be massively optimized by only solving this when something changes in the data location.
						//       Cache invalidation will be a PITA on this one.
						let tmpExplicitFilterValue = pView.getValueByHash(tmpExplicitFilterValueAddress);

						if (tmpExplicitFilterIgnoreEmpty && ((!tmpExplicitFilterValue) || (tmpExplicitFilterValue == '')))
						{
							// The comparison value is empty, so ignore it.
							break;
						}

						// Now check each value in the list to see if it matches the filter.
						switch(tmpExplicitFilterValueComparison.toLowerCase())
						{
							// Equal To
							case '=':
							case '==':
							case 'eq':
								if (tmpComparisonValue != tmpExplicitFilterValue)
								{
									this.fable.log.debug(`FilterList: ${tmpComparisonValue} != ${tmpExplicitFilterValue}; distilling is removing from the outcome array.`);
									tmpEntryAllowed = false;
								}
								break;

							// Not Equal
							case '!=':
							case 'ne':
								if (tmpComparisonValue == tmpExplicitFilterValue)
								{
									this.fable.log.debug(`FilterList: ${tmpComparisonValue} == ${tmpExplicitFilterValue}; distilling is removing from the outcome array.`);
									tmpEntryAllowed = false;
								}
								break;

							// Approximately Equal
							case '~=':
							case 'ae':
								if (tmpComparisonValue == tmpExplicitFilterValue)
								{
									this.fable.log.debug(`FilterList: ${tmpComparisonValue} == ${tmpExplicitFilterValue}; distilling is removing from the outcome array.`);
									tmpEntryAllowed = false;
								}
								break;
						}
						break;

					case 'CrossMap':
						// Filter based on a list of "join" records, with:
						// A "JoinListAddress" address - where to find the list of joins in the application state
						// A "JoinListAddressGlobal" boolean - if the list is global or not (global means scoped to pict vs appdata/state location)
						// A "JoinListValueAddress" address - the address within the record that maps to the ID of the list value
						// A "ExternalValueAddress" address - the address of the external value we are comparing to
						// A "FilterToValueAddress" address - the external address to use to see if the ExternalValue matches
						// A "IgnoreEmpty" boolean - makes the tech ignore empty ExternalValue (including undefined etc.)
						//
						// So for example, if you had a list of Colors with id: "Red", "Green", "Blue"
						/*
							...And you had a list of joins they would be something like:
							AppData.BrandList [
								{ Brand: "Santa", DominantColor: "Red"},
								{ Brand: "Subaru", DominantColor: "Off White"},
								{ Brand: "Subaru", DominantColor: "Green"},
								{ Brand: "IBM", DominantColor: "Blue"},
								{ .... }
							]

							...And somewhere else we had the following state:

							AppData.SelectedBrand: "Subaru"
						*/
						/*
							The values would be:
								-> JoinListAddress: "AppData.BrandList"
								-> JoinListAddressGlobal: false
								-> JoinListValueAddress: "Record.Color"          <-- (this maps to the id in the select list)
								-> ExternalValueAddress: "Record.Brand"          <-- (this maps to the id for the external lookup)
								-> FilterToValueAddress: "AppData.SelectedBrand"
								-> IgnoreEmpty: true                             <-- Don't filter if the AppData.SelectedBrand is an empty string or such
						*/
						let tmpJoinListAddress = tmpFilterRule.JoinListAddress;
						let tmpJoinListAddressGlobal = ('JoinListAddressGlobal' in tmpFilterRule) ? tmpFilterRule.JoinListAddressGlobal : false;
						let tmpJoinListValueAddress = tmpFilterRule.JoinListValueAddress;
						let tmpExternalValueAddress = tmpFilterRule.ExternalValueAddress;
						let tmpFilterToValueAddress = tmpFilterRule.FilterToValueAddress;
						let tmpIgnoreEmpty = ('IgnoreEmpty' in tmpFilterRule) ? tmpFilterRule.IgnoreEmpty : false;

						let tmpJoinList;

						if (tmpJoinListAddressGlobal)
						{
							const tmpAddressSpace =
							{
								Fable: this.pict,
								Pict: this.pict,
								AppData: this.pict.AppData,
								Bundle: this.pict.Bundle,
								View: pView,
							};

							tmpJoinList = this.pict.manifest.getValueAtAddress(tmpAddressSpace, tmpJoinListAddress);
						}
						else
						{
							tmpJoinList = pView.getValueByHash(tmpJoinListAddress);
						}
						let tmpFilterToValueAddressValue = pView.getValueByHash(tmpFilterToValueAddress);

						if (tmpIgnoreEmpty && ((!tmpFilterToValueAddressValue) || (tmpFilterToValueAddressValue == '')))
						{
							// The comparison value is empty, so ignore it.
							break;
						}
						if ((!Array.isArray(tmpJoinList)) && (tmpJoinList != null) && (typeof(tmpJoinList) == 'object'))
						{
							let tmpJoinListKeys = Object.keys(tmpJoinList);
							let tmpNewJoinList = [];
							for (let i = 0; i < tmpJoinListKeys.length; i++)
							{
								tmpNewJoinList.push(tmpJoinList[tmpJoinListKeys[i]]);
							}
							tmpJoinList = tmpNewJoinList;
						}

						if ((!Array.isArray(tmpJoinList)) || (tmpJoinList.length == 0))
						{
							// The join list is not an array.  We can't filter it.
							break;
						}

						//this.pict.log.trace(`FilterList: CrossMap: JoinListAddress[${tmpJoinListAddress}](${tmpJoinList.length})->${tmpJoinListValueAddress} ExternalValueAddress[${tmpExternalValueAddress}] FilterToValueAddress[${tmpFilterToValueAddress}]`);

						// TODO: This is not industrial grade, yo.  Small lists only please.  O(n^2) is not cool.
						let tmpPossiblyAllowed = false;
						for (let i = 0; i < tmpJoinList.length; i++)
						{
							let tmpJoinListValue = this.pict.manifest.getValueAtAddress(tmpJoinList[i], tmpJoinListValueAddress);
							let tmpExternalValue = this.pict.manifest.getValueAtAddress(tmpJoinList[i], tmpExternalValueAddress);

							if (tmpIgnoreEmpty && ((!tmpJoinListValue) || (tmpJoinListValue == '')))
							{
								// The comparison value is empty, so ignore it.
								continue;
							}

							//this.pict.log.trace(`          CrossMap Test: JoinListValue[${tmpJoinListValue}]<==>ComparisonValue[${tmpComparisonValue}] ExternalValue[${tmpExternalValue}]<==>FilterToValue[${tmpFilterToValueAddressValue}]`);
							if ((tmpFilterToValueAddressValue == tmpExternalValue) && (tmpJoinListValue == tmpComparisonValue))
							{
								//this.pict.log.trace(`   !!! CrossMap: Matched: ${tmpJoinListValue} == ${tmpComparisonValue} && ${tmpExternalValue} == ${tmpFilterToValueAddressValue}`);
								tmpPossiblyAllowed = true;
								break;
							}
						}
						tmpEntryAllowed = tmpPossiblyAllowed && tmpEntryAllowed;

						break;

					default:
						// See if there is a provider for it
						let tmpProvider = this.pict.providers[tmpFilterRule.FilterType];
						if (tmpProvider)
						{
							// Your provider could do anything here.
							// We may want a second place to bolt one of these on
							tmpEntryAllowed = tmpProvider.filterList(pView, pInput, pList, tmpListEntry);
						}
						break;
				}
			}

			if (!tmpEntryAllowed)
			{
				tmpFilteredList.splice(h,1);
			}
		}

		//this.log.trace(`FilterList: Input [${pInput.Hash}] has [${pList.length}] options to filter with [${tmpFilterRules.length}] rules.`);

		return tmpFilteredList;
	}
}

module.exports = PictListDistilling;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],78:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-MetaList",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * The PictMetalist class is a provider that translates simple list entries into arrays of entries ready to use in drop-down lists and such
 */
class PictMetalist extends libPictProvider
{
	/**
	 * Creates an instance of the PictMetalist class.
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.computedLists = {};
		this.listDefinitions = {};
	}
	/** @typedef {{ id: string, text: string }} PickListItem */

	/**
	 * Retrieves a list based on the provided view hash and list hash.
	 *
	 * @param {string} pListHash - The list hash.
	 * @param {Object} [pOptions={}] - (optional) Additional options for retrieving the list. (ex. search term)
	 *
	 * @returns {Array<PickListItem>} - The retrieved list.
	 */
	getList(pListHash, pOptions = {})
	{
		if (this.listDefinitions[pListHash].Dynamic)
		{
			const tmpList = [];
			const tmpTransactionGUID = this.pict.getUUID();
			const tmpHash = tmpTransactionGUID.substring(0, 8);
			const tmpAddress = `AppData._MetaLists.${tmpHash}`;
			this.pict.manifest.setValueByHash(this.pict, tmpAddress, tmpList);
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`GetPickList:${pListHash}:${tmpAddress}:${JSON.stringify(pOptions)}`, tmpTransactionGUID);
			this.pict.views.PictFormMetacontroller.finalizeTransaction(tmpTransactionGUID);
			delete this.pict.AppData._MetaLists[tmpHash];
			return tmpList;
		}
		if (pListHash in this.computedLists)
		{
			return this.computedLists[pListHash];
		}
		return [];
	}

	/**
	 * Checks if a list exists in the Pict Provider MetaLists.
	 *
	 * @param {string} pListHash - The hash of the list.
	 * @returns {boolean} - Returns true if the list exists, otherwise false.
	 */
	hasList(pListHash)
	{
		return (pListHash in this.computedLists);
	}

	/**
	 * Rebuilds any lists defined in specific views
	 * @param {Array} pViewHashes - An array of strings representing the view hashes to rebuild lists for.
	 */
	buildViewSpecificLists(pViewHashes)
	{
		// this.log.trace(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] pulling Metalists.`);
		let tmpViewHashes = Array.isArray(pViewHashes) ? pViewHashes : Object.keys(this.fable.views);

		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			let tmpViewHash = tmpViewHashes[i];
			let tmpView = this.fable.views[tmpViewHash];
			if (tmpView.isPictSectionForm)
			{
				let tmpSection = tmpView.sectionDefinition;
				if (('PickLists' in tmpSection) && Array.isArray(tmpSection.PickLists))
				{
					for (let j = 0; j < tmpSection.PickLists.length; j++)
					{
						let tmpPickList = tmpSection.PickLists[j];
						this.buildList(tmpPickList);
					}
				}
			}
		}
	}

	/**
	 * Rebuilds a list based on the provided hash.
	 *
	 * @param {string} pListHash - The hash of the list to be rebuilt.
	 */
	rebuildListByHash(pListHash)
	{
		if (pListHash in this.listDefinitions)
		{
			this.buildList(this.listDefinitions[pListHash]);
		}
	}

	/**
	 * Builds a list based on the provided list object.  Stores it internally for use in dropdowns and list boxes.
	 * @param {Object} pListObject - The List definition object
	 * @returns boolean
	 */
	buildList(pListObject)
	{
		// Basic list validation
		if (typeof(pListObject) !== 'object')
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList that is not an object. Skipping.`);
			return false;
		}
		if (!('Hash' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a Hash. Skipping.`);
			return false;
		}

		// Lazily add it if it doesn't exist
		if (!(pListObject.Hash in this.listDefinitions))
		{
			this.listDefinitions[pListObject.Hash] = pListObject;
			this.computedLists[pListObject.Hash] = [];
		}

		// Now try to build the list!
		let tmpResultingList = [];

		// Advanced list validation
		if (!('ListAddress' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a ListAddress. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}
		if (!('ListSourceAddress' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a ListSourceAddress. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}
		// TODO: Research easy ways to infer this...
		if (!('TextTemplate' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a TextTemplate. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}
		if (!('IDTemplate' in pListObject))
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] found a PickList without a IDTemplate. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}

		if (!this.pict.views.PictFormMetacontroller)
		{
			this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] requires PictFormMetacontroller but not found. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}

		// Now try to fetch the list data
		let tmpListData = this.pict.providers.DataBroker.getValueByHash(pListObject.ListSourceAddress);
		if (!tmpListData)
		{
			//this.log.warn(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] failed to fetch the list data for PickList [${pListObject.Hash}]. Skipping.`);
			this.computedLists[pListObject.Hash] = [];
			return false;
		}

		// Use this for the unique feature
		let tmpListHashes = {};

		if (Array.isArray(tmpListData))
		{
			for (let i = 0; i < tmpListData.length; i++)
			{
				let tmpListEntry = tmpListData[i];
				if (tmpListEntry && (typeof tmpListEntry === 'object'))
				{
					let tmpTextString = this.pict.parseTemplate(pListObject.TextTemplate, tmpListEntry);
					let tmpIDString = this.pict.parseTemplate(pListObject.IDTemplate, tmpListEntry);

					if (!tmpTextString || !tmpIDString)
					{
						this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] failed to generate the Text or ID for PickList [${pListObject.Hash}]. Skipping.`);
//						this.log.error(`Dynamic MetaList Provider [${this.UUID}]::[${this.Hash}] failed to generate the Text or ID for PickList [${pListObject.Hash}]. Skipping.`, {"Text": tmpTextString, "ID": tmpIDString, "Entry": tmpListEntry});
						continue;
					}

					if (pListObject.Unique && (tmpIDString in tmpListHashes))
					{
						continue;
					}
					tmpListHashes[tmpIDString] = true;
					tmpResultingList.push({"id": tmpIDString, "text": tmpTextString});
				}
			}
		}

		if (pListObject.Sorted)
		{
			tmpResultingList.sort((pLeft, pRight) => pLeft.text.localeCompare(pRight.text));
		}

		// Now store the list
		this.computedLists[pListObject.Hash] = tmpResultingList;
	}
}

module.exports = PictMetalist;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],79:[function(require,module,exports){
const libPictProvider = require('pict-provider');

const libPictViewDynamicForm = require('../views/Pict-View-DynamicForm.js');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-Provider-MetatemplateGenerator",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

const _DynamicInputViewSection = (
		{
			"Hash": "DynamicInputs",
			"Name": "Dynamic Inputs",
			"ViewHash": "PictFormMetacontroller-DynamicInputs",

			"IncludeInMetatemplateSectionGeneration": false,

			"Manifests": {
				"Section": {
					"Scope": "MetaTemplate",
					"Sections": [
						{
							"Hash": "DynamicInputs",
							"Name": "Dynamic Inputs"
						}
					],
					"Descriptors": {
						"MetaTemplate.DynamicInputPlaceholder": {
							"Name": "DynamicInputPlaceholder",
							"Hash": "DynamicInputPlaceholder",
							"DataType": "String",
							"Macro": {
								"HTMLSelector": ""
							},
							"PictForm": {
								"Section": "DynamicInputs"
							}
						}
					}
				}
			}
		});

/**
 * Class representing a Pict Metatemplate Generator.
 * @extends libPictProvider
 */
class PictMetatemplateGenerator extends libPictProvider
{
	/**
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		/** @type {libPictViewDynamicForm} */
		this.dynamicInputView;

		this.baseTemplatePrefix = "Pict-MT-Base";
	}

	onInitializeAsync(fCallback)
	{
		this.createOnDemandMetatemplateView();
		return super.onInitializeAsync(fCallback);
	}

	createOnDemandMetatemplateView()
	{
		const tmpViewConfiguration = JSON.parse(JSON.stringify(_DynamicInputViewSection));

		if (tmpViewConfiguration.ViewHash in this.pict.views)
		{
			this.dynamicInputView = this.pict.views[tmpViewConfiguration.ViewHash];
		}
		else
		{
			this.dynamicInputView = this.pict.addView(tmpViewConfiguration.ViewHash, tmpViewConfiguration, libPictViewDynamicForm);
		}
	}

	/**
	 * Retrieves the metatemplate template reference in raw format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pTemplatePostfix - The template postfix.
	 * @param {string} pRawTemplateDataAddress - The raw template data address.
	 * @returns {string} The metatemplate template reference in raw format, or false if it doesn't exist.
	 */
	getMetatemplateTemplateReferenceRaw(pView, pTemplatePostfix, pRawTemplateDataAddress)
	{
		// 1. Check if there is a section-specific template loaded
		if (pView.checkViewSpecificTemplate(pTemplatePostfix))
		{
			return `\n{~T:${pView.formsTemplateSetPrefix}${pTemplatePostfix}:${pRawTemplateDataAddress}~}`;
		}
		// 2. Check if there is a theme-specific template loaded for this postfix
		else if (pView.checkThemeSpecificTemplate(pTemplatePostfix))
		{
			return `\n{~T:${pView.defaultTemplatePrefix}${pTemplatePostfix}:${pRawTemplateDataAddress}~}`;
		}
		// 3. This shouldn't happen if the template is based on the base class.
		else
		{
			return '';
		}
	}

	/**
	 * Retrieves the metatemplate template reference.
	 *
	 * @param {Object} pView - The view object.
	 * @param {string} pTemplatePostfix - The template postfix.
	 * @param {string} pViewDataAddress - The view data address.
	 * @returns {string} The metatemplate template reference.
	 */
	getMetatemplateTemplateReference(pView, pTemplatePostfix, pViewDataAddress)
	{
		return this.getMetatemplateTemplateReferenceRaw(pView, pTemplatePostfix, `Pict.views["${pView.Hash}"].${pViewDataAddress}`);
	}

	/**
	 * Retrieves the metatemplate template reference for the given input view, data type, input type, and view data address.
	 *
	 * @param {Object} pView - The input view.
	 * @param {string} pDataType - The data type.
	 * @param {string} pInputType - The input type.
	 * @param {string} pViewDataAddress - The view data address.
	 * @returns {string} The metatemplate template reference.
	 */
	getInputMetatemplateTemplateReference(pView, pDataType, pInputType, pViewDataAddress)
	{
		// Input types are customizable -- there could be 30 different input types for the string data type with special handling and templates
		let tmpTemplateInputTypePostfix = `-Template-Input-InputType-${pInputType}`;
		// Data types are not customizable; they are a fixed list based on what is available in Manyfest
		let tmpTemplateDataTypePostfix = `-Template-Input-DataType-${pDataType}`;

		// First check if there is an "input type" template available in either the section-specific configuration or in the general
		if (pInputType)
		{
			let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateInputTypePostfix, pViewDataAddress);
			if (tmpTemplate)
			{
				return tmpTemplate;
			}
		}

		// If we didn't find the template for the "input type", check for the "data type"
		let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateDataTypePostfix, pViewDataAddress);
		if (tmpTemplate)
		{
			return tmpTemplate;
		}

		// There wasn't an input type specific or data type specific template, so fall back to the generic input template.
		return this.getMetatemplateTemplateReference(pView, '-Template-Input', pViewDataAddress);
	}

	/**
	 * Generates a tabular input metatemplate template reference.
	 *
	 * @param {Object} pView - The view.
	 * @param {string} pDataType - The data type.
	 * @param {string} pInputType - The input type.
	 * @param {string} pViewDataAddress - The view data address.
	 * @param {number} pGroupIndex - The group index.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} The tabular input metatemplate template reference.
	 */
	getTabularInputMetatemplateTemplateReference(pView, pDataType, pInputType, pViewDataAddress, pGroupIndex, pRowIndex)
	{
		// Input types are customizable -- there could be 30 different input types for the string data type with special handling and templates
		let tmpTemplateBeginInputTypePostfix = `-TabularTemplate-Begin-Input-InputType-${pInputType}`;
		let tmpTemplateMidInputTypePostfix = `-TabularTemplate-Mid-Input-InputType-${pInputType}`;
		let tmpTemplateEndInputTypePostfix = `-TabularTemplate-End-Input-InputType-${pInputType}`;
		// Data types are not customizable; they are a fixed list based on what is available in Manyfest
		let tmpTemplateBeginDataTypePostfix = `-TabularTemplate-Begin-Input-DataType-${pDataType}`;
		let tmpTemplateMidDataTypePostfix = `-TabularTemplate-Mid-Input-DataType-${pDataType}`;
		let tmpTemplateEndDataTypePostfix = `-TabularTemplate-End-Input-DataType-${pDataType}`;

		// Tabular inputs are done in three parts -- the "begin", the "address" of the data and the "end".

		// This means it is easily extensible to work on JSON objects as well as arrays.
		let tmpMidTemplate = this.getMetatemplateTemplateReference(pView, '-TabularTemplate-Mid-Input', pViewDataAddress);
		let tmpInformaryDataAddressTemplate = this.getMetatemplateTemplateReference(pView, '-TabularTemplate-InformaryAddress-Input', pViewDataAddress);

		// First check if there is an "input type" template available in either the section-specific configuration or in the general
		if (pInputType)
		{
			let tmpBeginTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateBeginInputTypePostfix, pViewDataAddress);
			let tmpEndTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateEndInputTypePostfix, pViewDataAddress);
			let tmpCustomMidTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateMidInputTypePostfix, pViewDataAddress);
			tmpMidTemplate = (tmpCustomMidTemplate) ? tmpCustomMidTemplate : tmpMidTemplate;
			if (tmpBeginTemplate && tmpEndTemplate)
			{
				return tmpBeginTemplate + tmpMidTemplate + tmpInformaryDataAddressTemplate + tmpEndTemplate;
			}
		}

		// If we didn't find the template for the "input type", check for the "data type"
		let tmpBeginTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateBeginDataTypePostfix, pViewDataAddress);
		let tmpEndTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateEndDataTypePostfix, pViewDataAddress);
		if (tmpBeginTemplate && tmpEndTemplate)
		{
			let tmpCustomMidTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateMidDataTypePostfix, pViewDataAddress);
			tmpMidTemplate = (tmpCustomMidTemplate) ? tmpCustomMidTemplate : tmpMidTemplate;
			return tmpBeginTemplate + tmpMidTemplate + tmpInformaryDataAddressTemplate + tmpEndTemplate;
		}

		// If we didn't find the template for the "input type", or the "data type", fall back to the default
		tmpBeginTemplate = this.getMetatemplateTemplateReference(pView, 'TabularTemplate-Begin-Input', pViewDataAddress);
		tmpEndTemplate = this.getMetatemplateTemplateReference(pView, 'TabularTemplate-End-Input', pViewDataAddress);
		if (tmpBeginTemplate && tmpEndTemplate)
		{
			return tmpBeginTemplate + tmpMidTemplate + tmpInformaryDataAddressTemplate + tmpEndTemplate;
		}

		// There was some kind of catastrophic failure -- the above templates should always be loaded.
		this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] catastrophic error generating tabular metatemplate: missing input template for Data Type ${pDataType} and Input Type ${pInputType}, Data Address ${pViewDataAddress}, Group Index ${pGroupIndex} and Record Subaddress ${pRowIndex}.`)
		return '';
	}

	/**
	 * Retrieves the metatemplate template reference for the given vertical input view, data type, input type, and view data address.
	 *
	 * @param {Object} pView - The input view.
	 * @param {string} pDataType - The data type.
	 * @param {string} pInputType - The input type.
	 * @param {string} pViewDataAddress - The view data address.
	 * @returns {string} The metatemplate template reference.
	 */
	getVerticalInputMetatemplateTemplateReference(pView, pDataType, pInputType, pViewDataAddress)
	{
		// Input types are customizable -- there could be 30 different input types for the string data type with special handling and templates
		let tmpTemplateInputTypePostfix = `-VerticalTemplate-Input-InputType-${pInputType}`;
		// Data types are not customizable; they are a fixed list based on what is available in Manyfest
		let tmpTemplateDataTypePostfix = `-VerticalTemplate-Input-DataType-${pDataType}`;

		// First check if there is an "input type" template available in either the section-specific configuration or in the general
		if (pInputType)
		{
			let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateInputTypePostfix, pViewDataAddress);
			if (tmpTemplate)
			{
				return tmpTemplate;
			}
		}

		// If we didn't find the template for the "input type", check for the "data type"
		let tmpTemplate = this.getMetatemplateTemplateReference(pView, tmpTemplateDataTypePostfix, pViewDataAddress);
		if (tmpTemplate)
		{
			return tmpTemplate;
		}

		// There wasn't an input type specific or data type specific template, so fall back to the generic input template.
		return this.getMetatemplateTemplateReference(pView, '-Template-Input', pViewDataAddress);
	}

	/**
	 * Retrieves the group layout provider based on the given view and group.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @returns {Object} The group layout provider.
	 */
	getGroupLayoutProvider(pView, pGroup)
	{
		let tmpGroupLayout = (typeof(pGroup.Layout) === 'string') ? pGroup.Layout :
								(typeof(pView.sectionDefinition.DefaultGroupLayout) === 'string') ? pView.sectionDefinition.DefaultGroupLayout :
								'Record';
		// This switch is unnecessary but meant to be illustrative of what this function does.
		// It could technically be as simple as the default stanza.
		switch(tmpGroupLayout)
		{
			case 'Tabular':
				return this.pict.providers['Pict-Layout-Tabular'];
			case 'Record':
				return this.pict.providers['Pict-Layout-Record'];
			case 'Vertical':
				return this.pict.providers['Pict-Layout-VerticalRecord'];
			case 'Default':
			default:
				// Try to load a custom layout, then fall back to the Record layout if it doesn't exist
				if (`Pict-Layout-${tmpGroupLayout}` in this.pict.providers)
				{
					return this.pict.providers[`Pict-Layout-${tmpGroupLayout}`];
				}
				else
				{
					return this.pict.providers['Pict-Layout-Record'];
				}
		}
	}

	/**
	 * Rebuilds the custom template for the given view.
	 *
	 * This uses the layout providers for each group.
	 *
	 * @param {Object} pView - The view object.
	 */
	rebuildCustomTemplate(pView)
	{
		let tmpTemplate = ``;

		if (this.pict.views.PictFormMetacontroller && ('formTemplatePrefix' in this.pict.views.PictFormMetacontroller) && (!('defaultTemplatePrefix' in pView)))
		{
				pView.defaultTemplatePrefix = this.pict.views.PictFormMetacontroller.formTemplatePrefix;
		}

		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Wrap-Prefix`, `sectionDefinition`);
		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Section-Prefix`, `sectionDefinition`);

		for (let i = 0; i < pView.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = pView.sectionDefinition.Groups[i];

			tmpGroup.GroupIndex = i;

			tmpGroup.SectionTabularRowVirtualTemplateHash = `Pict-Form-Template-TabularRow-Virtual-${pView.options.Hash}-G${tmpGroup.GroupIndex}`;
			tmpGroup.SectionTabularRowTemplateHash = `Pict-Form-Template-TabularRow-${pView.options.Hash}-G${tmpGroup.GroupIndex}`;

			tmpTemplate += this.getGroupLayoutProvider(pView, tmpGroup).generateGroupLayoutTemplate(pView, tmpGroup);
		}

		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Section-Postfix`, `sectionDefinition`);
		tmpTemplate += this.getMetatemplateTemplateReference(pView, `-Template-Wrap-Postfix`, `sectionDefinition`);

		this.pict.providers.MetatemplateMacros.rebuildMacros(pView);

		this.pict.TemplateProvider.addTemplate(pView.options.SectionTemplateHash, tmpTemplate);
	}
}

module.exports = PictMetatemplateGenerator;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"../views/Pict-View-DynamicForm.js":122,"pict-provider":19}],80:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-DynamicForms-MetatemplateMacros",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
})

/**
 * Class representing PictMetatemplateMacros.
 * @extends libPictProvider
 */
class PictMetatemplateMacros extends libPictProvider
{
	/**
	 *
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict') & { settings: any }} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.additionalInputMacros = {};
		if ('AdditionalInputMacros' in this.options)
		{
			this.additionalInputMacros = Object.assign(this.additionalInputMacros, this.options.AdditionalInputMacros);
		}
		if ('CustomInputMacros' in this.pict.settings)
		{
			this.AdditionalInputMacros = Object.assign(this.additionalInputMacros, this.pict.settings.CustomInputMacros);
		}

		this.additionalGroupMacros = {};
		if ('AdditionalGroupMacros' in this.options)
		{
			this.additionalGroupMacros = Object.assign(this.additionalGroupMacros, this.options.AdditionalGroupMacros);
		}
		if ('CustomGroupMacros' in this.pict.settings)
		{
			this.additionalGroupMacros = Object.assign(this.additionalGroupMacros, this.pict.settings.CustomGroupMacros);
		}

		this.additionalSectionMacros = {};
		if ('AdditionalSectionMacros' in this.options)
		{
			this.additionalSectionMacros = Object.assign(this.additionalSectionMacros, this.options.AdditionalSectionMacros);
		}
		if ('CustomSectionMacros' in this.pict.settings)
		{
			this.additionalSectionMacros = Object.assign(this.additionalSectionMacros, this.pict.settings.CustomSectionMacros);
		}
	}

	/**
	 * Builds macros for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 */
	buildInputMacros(pView, pInput)
	{
		let tmpInputMacroKeys = Object.keys(pView.options.MacroTemplates.Input);
		let tmpAdditionalInputMacroKeys = Object.keys(this.additionalInputMacros);
		if (!('Macro' in pInput))
		{
			pInput.Macro = {};
		}
		for (let n = 0; n < tmpInputMacroKeys.length; n++)
		{
			pInput.Macro[tmpInputMacroKeys[n]] = pView.pict.parseTemplate(pView.options.MacroTemplates.Input[tmpInputMacroKeys[n]], pInput, null, [pView]);
		}
		for (let n = 0; n < tmpAdditionalInputMacroKeys.length; n++)
		{
			pInput.Macro[tmpAdditionalInputMacroKeys[n]] = pView.pict.parseTemplate(this.additionalInputMacros[tmpAdditionalInputMacroKeys[n]], pInput, null, [pView]);
		}
	}

	/**
	 * Rebuilds macros for the given view.
	 *
	 * @param {Object} pView - The view object.
	 * @returns {boolean} - Returns false if MacroTemplates is not present in pView.options.
	 */
	rebuildMacros(pView)
	{
		if (!('MacroTemplates' in pView.options))
		{
			return false;
		}

		// Section macros
		let tmpSectionMacroKeys = Object.keys(pView.options.MacroTemplates.Section);
		let tmpAdditionalSectionMacroKeys = Object.keys(this.additionalSectionMacros);
		if (typeof(pView.sectionDefinition.Macro) !== 'object')
		{
			pView.sectionDefinition.Macro = {};
		}
		for (let n = 0; n < tmpSectionMacroKeys.length; n++)
		{
			pView.sectionDefinition.Macro[tmpSectionMacroKeys[n]] = pView.pict.parseTemplate (pView.options.MacroTemplates.Section[tmpSectionMacroKeys[n]], pView.sectionDefinition, null, [pView]);
		}
		for (let n = 0; n < tmpAdditionalSectionMacroKeys.length; n++)
		{
			pView.sectionDefinition.Macro[tmpAdditionalSectionMacroKeys[n]] = pView.pict.parseTemplate (this.additionalSectionMacros[tmpAdditionalSectionMacroKeys[n]], pView.sectionDefinition, null, [pView]);
		}
		for (let i = 0; i < pView.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = pView.sectionDefinition.Groups[i];

			// Group Macros
			let tmpGroupMacroKeys = Object.keys(pView.options.MacroTemplates.Group);
			let tmpAdditionalGroupMacroKeys = Object.keys(this.additionalGroupMacros);
			if (!('Macro'  in tmpGroup))
			{
				tmpGroup.Macro = {};
			}
			for (let n = 0; n < tmpGroupMacroKeys.length; n++)
			{
				tmpGroup.Macro[tmpGroupMacroKeys[n]] = pView.pict.parseTemplate(pView.options.MacroTemplates.Group[tmpGroupMacroKeys[n]], tmpGroup, null, [pView]);
			}
			for (let n = 0; n < tmpAdditionalGroupMacroKeys.length; n++)
			{
				tmpGroup.Macro[tmpAdditionalGroupMacroKeys[n]] = pView.pict.parseTemplate(this.additionalGroupMacros[tmpAdditionalGroupMacroKeys[n]], tmpGroup, null, [pView]);
			}

			if (!Array.isArray(tmpGroup.Rows))
			{
				tmpGroup.Rows = [];
			}
			for (let j = 0; j < tmpGroup.Rows.length; j++)
			{
				// TODO: Do we want row macros?  Let's be still and find out.
				let tmpRow = tmpGroup.Rows[j];
				for (let k = 0; k < tmpRow.Inputs.length; k++)
				{
					this.buildInputMacros(pView, tmpRow.Inputs[k]);
				}
			}

			if (tmpGroup.supportingManifest)
			{
				let tmpSupportingManifestDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
				for (let k = 0; k < tmpSupportingManifestDescriptorKeys.length; k++)
				{
					this.buildInputMacros(pView, tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestDescriptorKeys[k]]);
				}
			}
		}
	}
}

module.exports = PictMetatemplateMacros;
module.exports.default_configuration = _DefaultProviderConfiguration;



},{"pict-provider":19}],81:[function(require,module,exports){
module.exports = (
{
	"TemplatePrefix": "Pict-Forms-ReadOnly",

	"Templates":
	[
		/*
		 *
		 * [ Metacontroller Templates ]
		 *
		 */
		// the form "Header", rendered once before the dynamic views, after which come the section(s), then their group(s)
		{
			"HashPostfix": "-Template-Form-Container-Header",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container Header

  ;,//;,    ,;/
 o:::::::;;///
>::::::::;;\\\
  ''\\\\'" ';\

Glug glug glug Oo... -->
<div id="Pict-{~D:Context[0].UUID~}-FormContainer" class="pict-form">`
		},
		//
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Prefix",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
<div id="Pict-{~D:Context[0].UUID~}-{~D:Record.options.Hash~}-Wrap" class="pict-form">`
		},
		// the container div into which the actual view renders.
		// if you overwrite this template, make sure this ID is available on a container somewhere or auto rendering won't work
		{
			"HashPostfix": "-Template-Form-Container",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="Pict-Form-Container-{~D:Record.options.Hash~}" class="pict-form-view"></div>`
		},
		{
			"HashPostfix": "-Template-Form-Container-Custom",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="{~D:Record.options.CustomTargetID~}" class="pict-form-view"></div>`
		},

		// -Form-Container-Wrap-Postfix
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Postfix",
			"Template": /*HTML*/`
</div>
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
`
		},


		/*
		 *
		 * [ Basic Form Templates START ]
		 *
		 */
		// the wrapping container for a view which is a collection of form section(s)...
		{
			"HashPostfix": "-Template-Wrap-Prefix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		{
			"HashPostfix": "-Template-Wrap-Postfix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		// the wrapping container for each specific section in a form... for legends and the like
		{
			"HashPostfix": "-Template-Section-Prefix",
			"Template": /*HTML*/`
		<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
		<div class="pict-form-section">
		<h2>{~D:Record.Name~}</h2>
`
		},
		// -Form-Template-Section-Postfix
		{
			"HashPostfix": "-Template-Section-Postfix",
			"Template": /*HTML*/`
		</div>
		<!-- Form Section Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Group and Row Templates (default)
		 */
		// a "group" is a cluster of inputs that are further categorized into row(s)
		{
			"HashPostfix": "-Template-Group-Prefix",
			"Template": /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" {~D:Record.Macro.PictFormLayout~}>
			<h3>Group: {~D:Record.Name~}</h3>
`
		},
		// row(s) are useful when our form has multiple inputs on some lines and a single on another...
		// like city, state and zip all in the same "row" of an address form
		{
			"HashPostfix": "-Template-Row-Prefix",
			"Template": /*HTML*/`
				<!-- Form Template Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				<div>
`
		},
		{
			"HashPostfix": "-Template-Row-Postfix",
			"Template": /*HTML*/`
				</div>
				<!-- Form Template Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-Template-Group-Postfix",
			"Template": /*HTML*/`
			</div>
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		/*
		 * END Group and Row Templates (default)
		 */

		/*
		 * BEGIN Input Templates (default)
		 */
		{
			"HashPostfix": "-Template-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input disabled type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <textarea disabled {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}></textarea>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span> <select disabled {~D:Record.Macro.ControlAttr~} id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}"></select>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<span>{~D:Record.Name~}:</span> <input disabled {~D:Record.Macro.ControlAttr~} id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}" type="datetime-local" value="" />
`
		},
		/*
		 * END Input Templates (default)
		 */
		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		/*
		 * Tab Groups are sets of Groups within a single Section that are shown/hidden when a tab control is clicked.
		 * 
		 * For example from the complex tabular application manifest descriptors:
		 *
		...
			"UI.StatisticsTabState": {
				Name: "Statistics Tab State",
				Hash: "StatisticsTabState",
				DataType: "String",
				PictForm: { Section: "Recipe", Group: "StatisticsTabs", 
					InputType: "TabGroupSelector",
					// The default when there is no state is the first entry here.
					// If you want to set a default, you can just do it in the state address though.
					TabGroupSet: ["Statistics", "FruitStatistics"] }
			},
		...
		 *
		 */
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector",
			"DefaultInputExtensions": ["Pict-Input-TabGroupSelector"],
			"Template": /*HTML*/`
					<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
					<!-- the TabSelector Input provider deals with populating this from the manifest. -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<!-- <span>{~D:Record.Name~}:</span> -->
					<div {~D:Record.Macro.ControlAttr~} id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-TabElement",
			"Template": /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<a href="#" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}" onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}')">{~D:Context[1].TabGroupHash~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-EmptyGroupContent",
			"Template": /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<p>Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</p>
`
		},		/*
		 * END View Management Templates (default)
		 */
		/*
		 *
		 * [ Basic Form Templates END ]
		 *
		 */

		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TuiGrid-Container",
			"Template": /*HTML*/`
			<div {~D:Record.Macro.ControlAttr~} id="{~D:Record.TuiGridHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-TuiGrid-Controls",
			"Template": /*HTML*/`
			<div>[ <a href="#" onclick="{~P~}.providers['Pict-Layout-TuiGrid'].addRow('{~D:Context[0].Hash~}', {~D:Record.GroupIndex~})">create</a> ]</div>
`
		},
		/*
		 *
		 * [ External Control Templates END ]
		 *
		 */


		/*
		 *
		 * [ Tabular Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TabularTemplate-Group-Prefix",
			"Template": /*HTML*/`
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" {~D:Record.Macro.PictFormLayout~}>
			<table>
					<tbody>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Group-Postfix",
			"Template": /*HTML*/`
				</tbody>
			</table>
			<div><a href="#" onclick="{~D:Record.Macro.TabularCreateRowFunctionCall~}">create</a></div>
			</div>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Tabular Template "Extra" Columns
		 * these are meant to be easy ways to add controls to the left or right side of a record column
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPrefix -->`
		},
		// because the row extension template below adds an extra column, we need to make our header have parity
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPostfix -->
						<th style="min-width:100px;"></th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPrefix -->`
		},
		// by default PICT puts a "delete row" button on the right side of a tabular templateset
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPostfix-->
					<td><a href="#" onClick="{~P~}.views['{~D:Context[0].Hash~}'].deleteDynamicTableRow({~D:Record.Group~},'{~D:Record.Key~}')">del</a>
					<a href="#" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowUp({~D:Record.Group~},'{~D:Record.Key~}')">up</a>
					<a href="#" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowDown({~D:Record.Group~},'{~D:Record.Key~}')">down</a></td>
`
		},
		/*
		 * END Tabular Template "Extra" Columns
		 */

		/*
		 * BEGIN Tabular Template Header Columns
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Prefix",
			"Template": /*HTML*/`
				<thead>
					<tr>
`
		},
		{
			"HashPostfix": "-TabularTemplate-HeaderCell",
			"Template": /*HTML*/`
						<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
						<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}">{~D:Record.Name~}</th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Postfix",
			"Template": /*HTML*/`
					</tr>
				</thead>
				<tbody>
`
		},
		/*
		 * END Tabular Template Header Columns
		 */

		/*
		 * BEGIN Tabular TemplateSet Templates (row and cell prefix/postfix ... tr/td)
		 * (these are repeated for each "row" which is a record, and then wrap each "cell" which is a columnar input)
		 */
		{
			"HashPostfix": "-TabularTemplate-Row-Prefix",
			"Template": /*HTML*/`
					<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">{~T:TabularTemplateRow-ExtraPrefix~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Prefix",
			"Template": /*HTML*/`
						<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}"><!-- {~D:Record.Name~}  -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Postfix",
			"Template": /*HTML*/`
						</td>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-Postfix",
			"Template": /*HTML*/`
					{~T:TabularTemplateRow-ExtraPostfix~}</tr>`
		},
		/*
		 * END Tabular TemplateSet Templates
		 */


		/*
		 * BEGIN Tabular Input Templates
		 */
		{
			"HashPostfix": "-TabularTemplate-Begin-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Mid-Input",
			"Template": /*HTML*/`  `
		},
		{
			"HashPostfix": "-TabularTemplate-InformaryAddress-Input",
			"Template": /*HTML*/` data-i-index="{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].dataChangedTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"  `
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-String",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-Number",
			"Template": /*HTML*/` value="">
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<textarea disabled {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-TextArea",
			"Template": /*HTML*/` ></textarea>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" id="SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Option",
			"Template": /*HTML*/` value="">
					<select disabled {~D:Record.Macro.ControlAttr~} id="SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"></select>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Boolean",
			"Template": /*HTML*/` value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-DateTime",
			"Template": /*HTML*/` value="">
					<input disabled {~D:Record.Macro.ControlAttr~} id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')" type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Hidden",
			"Template": /*HTML*/`
					<!-- InputType Hidden {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input disabled type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} {~D:Record.Macro.InformaryTabular~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Hidden",
			"Template": /*HTML*/` value="">
`
		},

		/*
		 * END Tabular Input Templates
		 */
		/*
		 *
		 * [ Tabular Templates END ]
		 *
		 */
	]
});

},{}],82:[function(require,module,exports){
module.exports = (
{
	"TemplatePrefix": "Pict-MT-Base",
	"Templates":
	[
		/*
		 *
		 * [ Metacontroller Templates ]
		 *
		 */
		// the form "Header", rendered once before the dynamic views, after which come the section(s), then their group(s)
		{
			"HashPostfix": "-Template-Form-Container-Header",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container Header

  ;,//;,    ,;/
 o:::::::;;///
>::::::::;;\\\
  ''\\\\'" ';\

Glug glug glug Oo... -->
<div id="Pict-{~D:Context[0].UUID~}-FormContainer" class="pict-form">`
		},
		//
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Prefix",
			"Template": /*HTML*/`
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
<div id="Pict-{~D:Context[0].UUID~}-{~D:Record.options.Hash~}-Wrap" class="pict-form">`
		},
		// the container div into which the actual view renders.
		// if you overwrite this template, make sure this ID is available on a container somewhere or auto rendering won't work
		{
			"HashPostfix": "-Template-Form-Container",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="Pict-Form-Container-{~D:Record.options.Hash~}" class="pict-form-view"></div>`
		},
		{
			"HashPostfix": "-Template-Form-Container-Custom",
			"Template": /*HTML*/`

	<!-- Pict Form View Container [{~D:Record.UUID~}]::[{~D:Record.Hash~}] -->
	<div id="{~D:Record.options.CustomTargetID~}" class="pict-form-view"></div>`
		},

		// -Form-Container-Wrap-Postfix
		{
			"HashPostfix": "-Template-Form-Container-Wrap-Postfix",
			"Template": /*HTML*/`
</div>
<!-- Pict Form Metacontroller container [{~D:Context[0].UUID~}] -->
`
		},


		/*
		 *
		 * [ Basic Form Templates START ]
		 *
		 */
		// the wrapping container for a view which is a collection of form section(s)...
		{
			"HashPostfix": "-Template-Wrap-Prefix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		{
			"HashPostfix": "-Template-Wrap-Postfix",
			"Template": /*HTML*/`
	<!-- Pict Form Wrap Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] -->
`
		},
		// the wrapping container for each specific section in a form... for legends and the like
		{
			"HashPostfix": "-Template-Section-Prefix",
			"Template": /*HTML*/`
		<!-- Form Section Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
		<div id="SECTION-{~D:Context[0].formID~}" class="pict-form-section {~D:Record.CSSClass~}">
		<h2>{~D:Record.Name~}</h2>
`
		},
		// -Form-Template-Section-Postfix
		{
			"HashPostfix": "-Template-Section-Postfix",
			"Template": /*HTML*/`
		</div>
		<!-- Form Section Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Group and Row Templates (default)
		 */
		// a "group" is a cluster of inputs that are further categorized into row(s)
		{
			"HashPostfix": "-Template-Group-Prefix",
			"Template": /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
			<h3>Group: {~D:Record.Name~}</h3>
`
		},
		// row(s) are useful when our form has multiple inputs on some lines and a single on another...
		// like city, state and zip all in the same "row" of an address form
		{
			"HashPostfix": "-Template-Row-Prefix",
			"Template": /*HTML*/`
				<!-- Form Template Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				<div>
`
		},
		{
			"HashPostfix": "-Template-Row-Postfix",
			"Template": /*HTML*/`
				</div>
				<!-- Form Template Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-Template-VerticalRow-Prefix",
			"Template": /*HTML*/`
				<!-- Form Template Vertical Row Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
				<div class="pict-form-vertical-group">
`
		},
		{
			"HashPostfix": "-Template-VerticalRow-Postfix",
			"Template": /*HTML*/`
				</div>
				<!-- Form Template Vertical Row Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-Template-Group-Postfix",
			"Template": /*HTML*/`
			</div>
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		/*
		 * END Group and Row Templates (default)
		 */

		/*
		 * BEGIN Input Templates (default)
		 */
		{
			"HashPostfix": "-Template-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-PreciseNumber",
			"Template": /*HTML*/`
					<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-PreciseNumberReadOnly",
			"DefaultInputExtensions": ["Pict-Input-PreciseNumber"],
			"Template": /*HTML*/`
					<!-- InputType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span>
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<input type="text" {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" value="" readonly="readonly">
`
		},

		{
			"HashPostfix": "-Template-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <textarea {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}></textarea>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span> <select {~D:Record.Macro.ControlAttr~} id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}"></select>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
`
		},
		{
			"HashPostfix": "-Template-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<span>{~D:Record.Name~}:</span> <input {~D:Record.Macro.ControlAttr~} id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}" type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Hidden",
			"Template": /*HTML*/`
					<!-- InputType Hidden {~D:Record.Hash~} {~D:Record.DataType~} -->
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Color",
			"Template": /*HTML*/`
					<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="color" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} />
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-DisplayOnly",
			"Template": /*HTML*/`
					<!-- InputType DisplayOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <span {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></span>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-ReadOnly",
			"Template": /*HTML*/`
					<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="text" readonly {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></input>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Link",
			"DefaultInputExtensions": ["Pict-Input-Link"],
			"Template": /*HTML*/`
					<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<a {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}">{~D:Record.Name~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Chart",
			"DefaultInputExtensions": ["Pict-Input-Chart"],
			"Template": /*HTML*/`
					<!-- InputType Chart {~D:Record.Hash~} {~D:Record.DataType~} -->
					<div style="width:{~DWAF:Record.PictForm.QuantizedWidth:100~}%; display:inline-block;">
						<input type="hidden" id="CONFIG-FOR-{~D:Record.Macro.RawHTMLID~}" value="">
						<h3><span>{~D:Record.Name~}:</span></h3>
						<div style="width:100%;"><canvas id="CANVAS-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></canvas></div>
					</div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Markdown",
			"DefaultInputExtensions": ["Pict-Input-Markdown"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-HTML",
			"DefaultInputExtensions": ["Pict-Input-HTML"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-Templated",
			"DefaultInputExtensions": ["Pict-Input-Templated"],
			"Template": /*HTML*/`
					<!-- InputType Templated {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-templated"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TemplatedEntityLookup",
			"DefaultInputExtensions": ["Pict-Input-TemplatedEntityLookup"],
			"Template": /*HTML*/`
					<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		/*
		 * END Input Templates (default)
		 */
		/*
		 * BEGIN Vertical Input Templates
		 */
		{
			"HashPostfix": "-VerticalTemplate-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-PreciseNumber",
			"Template": /*HTML*/`
					<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-PreciseNumberReadOnly",
			"DefaultInputExtensions": ["Pict-Input-PreciseNumber"],
			"Template": /*HTML*/`
					<!-- InputType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<div class="pict-form-vertical-input">
						<span>{~D:Record.Name~}:</span>
						<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
						<input type="text" {~D:Record.Macro.ControlAttr~} id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" value="" readonly="readonly">
					</div>

`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<textarea {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~}></textarea>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<select {~D:Record.Macro.ControlAttr~} id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}"></select>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input {~D:Record.Macro.ControlAttr~} id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" onchange="{~D:Record.Macro.DataRequestFunction~}" type="datetime-local" value="" />
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Color",
			"Template": /*HTML*/`
					<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="color" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} />
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-DisplayOnly",
			"Template": /*HTML*/`
					<!-- InputType DisplayOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<span {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></span>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-ReadOnly",
			"Template": /*HTML*/`
					<!-- InputType ReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<input type="text" readonly {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></input>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Link",
			"DefaultInputExtensions": ["Pict-Input-Link"],
			"Template": /*HTML*/`
					<!-- InputType Link {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} value="">
					<a {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}>{~D:Record.Name~}</a>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Markdown",
			"DefaultInputExtensions": ["Pict-Input-Markdown"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-markdown"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-HTML",
			"DefaultInputExtensions": ["Pict-Input-HTML"],
			"Template": /*HTML*/`
					<!-- InputType Markdown {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-html"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-Templated",
			"DefaultInputExtensions": ["Pict-Input-Templated"],
			"Template": /*HTML*/`
				<!-- InputType Templated {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="pict-section-form-templated"></div>
				</div>
`
		},
		{
			"HashPostfix": "-VerticalTemplate-Input-InputType-TemplatedEntityLookup",
			"DefaultInputExtensions": ["Pict-Input-TemplatedEntityLookup"],
			"Template": /*HTML*/`
					<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input">
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<span>{~D:Record.Name~}:</span>
					<span>{~D:Record.PictForm.ExtraDescription~}</span>
					<div {~D:Record.Macro.ControlAttr~} id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
				</div>
`
		},
		/*
		 * END Vertical Input Templates (default)
		 */
		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		/*
		 * Tab Groups are sets of Groups within a single Section that are shown/hidden when a tab control is clicked.
		 * 
		 * For example from the complex tabular application manifest descriptors:
		 *
		...
			"UI.StatisticsTabState": {
				Name: "Statistics Tab State",
				Hash: "StatisticsTabState",
				DataType: "String",
				PictForm: { Section: "Recipe", Group: "StatisticsTabs", 
					InputType: "TabGroupSelector",
					// The default when there is no state is the first entry here.
					// If you want to set a default, you can just do it in the state address though.
					TabGroupSet: ["Statistics", "FruitStatistics"] }
			},
		...
		 *
		 */
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector",
			"DefaultInputExtensions": ["Pict-Input-TabGroupSelector"],
			"Template": /*HTML*/`
					<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
					<!-- the TabSelector Input provider deals with populating this from the manifest. -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<!-- <span>{~D:Record.Name~}:</span> -->
					<div {~D:Record.Macro.ControlAttr~} id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-TabElement",
			"Template": /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<a href="#/" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}" onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}')">{~D:Context[1].TabGroupName~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabGroupSelector-EmptyGroupContent",
			"Template": /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<p>Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</p>
`
		},
		/*
		 * Tab Sections are sets of Sections within a single Section that are shown/hidden when a tab control is clicked.
		 * 
		 * For example from the complex tabular application manifest descriptors:
		 *
		...

		...
		 *
		 */
		{
			"HashPostfix": "-Template-Input-InputType-TabSectionSelector",
			"DefaultInputExtensions": ["Pict-Input-TabSectionSelector"],
			"Template": /*HTML*/`
					<!-- InputType TabSectionSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
					<!-- the TabSelector Input provider deals with populating this from the manifest. -->
					<input type="hidden" {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} value="">
					<!-- <span>{~D:Record.Name~}:</span> -->
					<div {~D:Record.Macro.ControlAttr~} id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabSectionSelector-TabElement",
			"Template": /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabSection value. -->
			<a href="#/" id="TAB-{~D:Context[1].TabSectionHash~}-{~D:Record.Macro.RawHTMLID~}" onclick="{~P~}.providers['Pict-Input-TabSectionSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabSectionHash~}')">{~D:Context[1].TabSectionName~}</a>
`
		},
		{
			"HashPostfix": "-Template-Input-InputType-TabSectionSelector-EmptyGroupContent",
			"Template": /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabSectionSet array is empty. -->
			<p>Warning! No tabs to select from for {~D:Record.TabSectionSetRawHTMLID~}</p>
`
		},
		/*
		 * END View Management Templates (default)
		 */
		/*
		 *
		 * [ Basic Form Templates END ]
		 *
		 */

		/*
		 *
		 * [ External Control Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TuiGrid-Container",
			"Template": /*HTML*/`
			<div {~D:Record.Macro.ControlAttr~} id="{~D:Record.TuiGridHTMLID~}"></div>
`
		},
		{
			"HashPostfix": "-TuiGrid-Controls",
			"Template": /*HTML*/`
			<div>[ <a href="#/" onclick="{~P~}.providers['Pict-Layout-TuiGrid'].addRow('{~D:Context[0].Hash~}', {~D:Record.GroupIndex~})">create</a> ]</div>
`
		},
		/*
		 *
		 * [ External Control Templates END ]
		 *
		 */


		/*
		 *
		 * [ RecordSet Templates START ]
		 *
		 */
		{
			"HashPostfix": "-RecordSetTemplate-Group-Prefix",
			"Template": /*HTML*/`
			<div {~D:Record.Macro.PictFormLayout~}>
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Group-Postfix",
			"Template": /*HTML*/`
			<div><a href="#/" onclick="{~D:Record.Macro.TabularCreateRowFunctionCall~}">create</a></div>
			</div>
			<!-- Form RecordSet Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},


		/*
		 * BEGIN RecordSet Template "Extra" Columns
		 * these are meant to be easy ways to add controls to the left or right side of a record column
		 */

		{
			"HashPostfix": "-RecordSetTemplate-Row-ExtraPrefix",
			"Template": /*HTML*/`<!-- RecordSetTemplateRow-ExtraPrefix -->`
		},
		// by default PICT puts a "delete row" button on the right side of a RecordSet Templateset
		{
			"HashPostfix": "-RecordSetTemplate-Row-ExtraPostfix",
			"Template": /*HTML*/`<!-- RecordSetTemplateRow-ExtraPostfix-->
					<div class="PictSectionForm-RecordSet-Controls">
						<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].deleteDynamicTableRow({~D:Record.Group~},'{~D:Record.Key~}')">del</a>
						<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowUp({~D:Record.Group~},'{~D:Record.Key~}')">up</a>
						<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowDown({~D:Record.Group~},'{~D:Record.Key~}')">down</a>
					</div>
`
		},
		/*
		 * END RecordSet Template "Extra" Columns
		 */

		/*
		 * BEGIN RecordSet TemplateSet Templates ("row" and "cell" prefix/postfix ... tr/td)
		 * (these are repeated for each "row" which is a record, and then wrap each "cell" which is a columnar input)
		 */
		{
			"HashPostfix": "-RecordSetTemplate-Row-Prefix",
			"Template": /*HTML*/`
					<div class="RecordSetEntry">
					<!-- RecordSetTemplateRow-Prefix -->
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Cell-Prefix",
			"Template": /*HTML*/`
						<div style="display:inline;">
							<!-- RecordSetTemplateCell-Prefix -->
							<span class="RecordSetInputLabel">{~D:Record.Name~}</span>
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Cell-Postfix",
			"Template": /*HTML*/`
							<!-- RecordSetTemplateCell-Postfix -->
						</div>
`
		},
		{
			"HashPostfix": "-RecordSetTemplate-Row-Postfix",
			"Template": /*HTML*/`
					<!-- RecordSetTemplateRow-Postfix -->
					</div>`
		},
		/*
		 * END RecordSet TemplateSet Templates
		 */



		/*
		 *
		 * [ Tabular Templates START ]
		 *
		 */
		{
			"HashPostfix": "-TabularTemplate-Group-Prefix",
			"Template": /*HTML*/`
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" {~D:Record.Macro.PictFormLayout~}>
			<table>
					<tbody>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Group-Postfix",
			"Template": /*HTML*/`
				</tbody>
			</table>
			<div><a href="#/" onclick="{~D:Record.Macro.TabularCreateRowFunctionCall~}">create</a></div>
			</div>
			<!-- Form Tabular Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
`
		},

		/*
		 * BEGIN Tabular Template "Extra" Columns
		 * these are meant to be easy ways to add controls to the left or right side of a record column
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPrefix -->`
		},
		// because the row extension template below adds an extra column, we need to make our header have parity
		{
			"HashPostfix": "-TabularTemplate-RowHeader-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRowHeader-ExtraPostfix -->
						<th style="min-width:100px;"></th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPrefix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPrefix -->`
		},
		// by default PICT puts a "delete row" button on the right side of a tabular templateset
		{
			"HashPostfix": "-TabularTemplate-Row-ExtraPostfix",
			"Template": /*HTML*/`<!-- TabularTemplateRow-ExtraPostfix-->
					<td><a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].deleteDynamicTableRow({~D:Record.Group~},'{~D:Record.Key~}')">del</a>
					<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowUp({~D:Record.Group~},'{~D:Record.Key~}')">up</a>
					<a href="#/" onClick="{~P~}.views['{~D:Context[0].Hash~}'].moveDynamicTableRowDown({~D:Record.Group~},'{~D:Record.Key~}')">down</a></td>
`
		},
		/*
		 * END Tabular Template "Extra" Columns
		 */

		/*
		 * BEGIN Tabular Template Header Columns
		 */
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Prefix",
			"Template": /*HTML*/`
				<thead>
					<tr>
`
		},
		{
			"HashPostfix": "-TabularTemplate-HeaderCell",
			"Template": /*HTML*/`
						<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
						<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}">{~D:Record.Name~}</th>
`
		},
		{
			"HashPostfix": "-TabularTemplate-RowHeader-Postfix",
			"Template": /*HTML*/`
					</tr>
				</thead>
				<tbody>
`
		},
		/*
		 * END Tabular Template Header Columns
		 */

		/*
		 * BEGIN Tabular Template Extra Header Rows
		 * Used for stacked/clustered headers (the Group's `Headers` config).
		 * Each entry in Headers is one ADDITIONAL header row stacked above the
		 * default column-name row. Cells carry { Label, ColumnSpan, CSSClass }.
		 */
		{
			"HashPostfix": "-TabularTemplate-ExtraHeaderRow-Prefix",
			"Template": /*HTML*/`
					<tr class="pict-tabular-extra-header-row">
`
		},
		{
			"HashPostfix": "-TabularTemplate-ExtraHeaderRow-Postfix",
			"Template": /*HTML*/`
					</tr>
`
		},
		{
			"HashPostfix": "-TabularTemplate-ExtraHeaderCell",
			"Template": /*HTML*/`<th colspan="{~D:Record.ColumnSpan~}" class="pict-tabular-extra-header-cell {~D:Record.CSSClass~}">{~D:Record.Label~}</th>`
		},
		/*
		 * END Tabular Template Extra Header Rows
		 */

		/*
		 * BEGIN Tabular Template Row Label Columns
		 * Used for left-side label columns (the Group's `RowLabels` config).
		 * Header cell renders one <th> per RowLabels entry. Per-row cell renders
		 * one <td> per RowLabels entry; rowspans collapse consecutive equal
		 * values when `Cluster: true`. Skipped cells emit nothing (a real <td>
		 * upstream has already covered them via rowspan).
		 */
		{
			"HashPostfix": "-TabularTemplate-RowLabel-HeaderCell",
			"Template": /*HTML*/`<th class="pict-row-label-header">{~D:Record.Name~}</th>`
		},
		{
			"HashPostfix": "-TabularTemplate-RowLabel-Cell",
			"Template": /*HTML*/`<td rowspan="{~D:Record.RowSpan~}" class="pict-row-label">{~D:Record.RenderedLabel~}</td>`
		},
		{
			"HashPostfix": "-TabularTemplate-RowLabel-Cell-Skipped",
			"Template": ``
		},
		/*
		 * END Tabular Template Row Label Columns
		 */

		/*
		 * BEGIN Tabular TemplateSet Templates (row and cell prefix/postfix ... tr/td)
		 * (these are repeated for each "row" which is a record, and then wrap each "cell" which is a columnar input)
		 */
		{
			"HashPostfix": "-TabularTemplate-Row-Prefix",
			"Template": /*HTML*/`
					<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">{~T:TabularTemplateRow-ExtraPrefix~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Prefix",
			"Template": /*HTML*/`
						<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}"><!-- {~D:Record.Name~}  -->
`
		},
		{
			"HashPostfix": "-TabularTemplate-Cell-Postfix",
			"Template": /*HTML*/`
						</td>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Row-Postfix",
			"Template": /*HTML*/`
					{~T:TabularTemplateRow-ExtraPostfix~}</tr>`
		},
		/*
		 * END Tabular TemplateSet Templates
		 */


		/*
		 * BEGIN Tabular Input Templates
		 */
		{
			"HashPostfix": "-TabularTemplate-Begin-Input",
			"Template": /*HTML*/`
					<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Mid-Input",
			"Template": /*HTML*/`  `
		},
		{
			"HashPostfix": "-TabularTemplate-InformaryAddress-Input",
			"Template": /*HTML*/` data-i-index="{~D:Context[2].Key~}" onchange="{~P~}.views['{~D:Context[0].Hash~}'].dataChangedTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"  `
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-String",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-String",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-Number",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-Number",
			"Template": /*HTML*/` value="">
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-PreciseNumber",
			"Template": /*HTML*/`
					<!-- DataType PreciseNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="Number" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-PreciseNumber",
			"Template": /*HTML*/` value="">
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly",
			"DefaultInputExtensions": ["Pict-Input-PreciseNumber"],
			"Template": /*HTML*/`
					<!-- InputType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.InformaryTabular~}
`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly",
			"Template": /*HTML*/`
						value="">
					<input type="text" {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} value="" readonly="readonly">
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-TextArea",
			"Template": /*HTML*/`
					<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
					<textarea {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-TextArea",
			"Template": /*HTML*/` ></textarea>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Option",
			"DefaultInputExtensions": ["Pict-Input-Select"],
			"Template": /*HTML*/`
					<!-- InputType Option {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" id="SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Option",
			"Template": /*HTML*/` value="">
					<select {~D:Record.Macro.ControlAttr~} id="SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~} onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"></select>
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Boolean",
			"Template": /*HTML*/`
					<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="checkbox" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Boolean",
			"Template": /*HTML*/` value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-DataType-DateTime",
			"DefaultInputExtensions": ["Pict-Input-DateTime"],
			"Template": /*HTML*/`
					<!-- DataType DateTime {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" id="DATETIME-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-DataType-DateTime",
			"Template": /*HTML*/` value="">
					<input {~D:Record.Macro.ControlAttr~} id="DATETIME-TABULAR-INPUT-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~}
						onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
						type="datetime-local" value="" />
`
		},
		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Hidden",
			"Template": /*HTML*/`
					<!-- InputType Hidden {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span
`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Hidden",
			"Template": /*HTML*/`></span>`,
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Color",
			"Template": /*HTML*/`
					<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <input type="color" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InputChangeHandler~} {~D:Record.Macro.InformaryTabular~}`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Color",
			"Template": /*HTML*/` />
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-DisplayOnly",
			"Template": /*HTML*/`
					<!-- InputType DisplayOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
					<span>{~D:Record.Name~}:</span> <span {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} {~D:Record.Macro.InformaryTabular~}`
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-DisplayOnly",
			"Template": /*HTML*/` ></span>
`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-ReadOnly",
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input readonly type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-ReadOnly",
			"Template": /*HTML*/` value="">`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-Link",
			"DefaultInputExtensions": ["Pict-Input-Link"],
			"Template": /*HTML*/`
					<!-- DataType Number {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="hidden" {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-Link",
			"Template": /*HTML*/` value="">
					<a {~D:Record.Macro.ControlAttr~} id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" {~D:Record.Macro.HTMLName~}>{~D:Record.Name~}</a>`
		},

		{
			"HashPostfix": "-TabularTemplate-Begin-Input-InputType-TemplatedEntityLookup",
			"Template": /*HTML*/`
					<!-- InputType TemplatedEntityLookup {~D:Record.Hash~} {~D:Record.DataType~} -->
					<input type="text" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.HTMLName~} {~D:Record.Macro.InformaryTabular~} `
		},
		{
			"HashPostfix": "-TabularTemplate-End-Input-InputType-TemplatedEntityLookup",
			"Template": /*HTML*/` value="">`
		},

		/*
		 * END Tabular Input Templates
		 */
		/*
		 *
		 * [ Tabular Templates END ]
		 *
		 */
	]
});

},{}],83:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class for the Autofill Trigger Group
 *
 * Autofill Trigger Groups have three parameters:
 *  - the group hash
 *  - a boolean defining whether the input triggers all inputs on the group
 *    to autofill themselves
 *  - an address (either in Pict or AppData) to pull data from
 *  - whether or not to marshal values if the result is empty/null/undefined
 *
 * In practice this looks like this:
 *
	Providers: ["Pict-Input-AutofillTriggerGroup"],
	AutofillTriggerGroup:
		{
			TriggerGroupHash: "Author",
			TriggerAddress: "AppData.CurrentAuthor.Name",
			MarshalEmptyValues: true
		}
 *
 *
 * The group is cavalier about clearing data when
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	getTriggerGroupConfigurationArray(pInput)
	{
		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!tmpAutoFillTriggerGroups)
		{
			return [];
		}
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		return tmpAutoFillTriggerGroups;
	}

	autoFillFromAddressList(pView, pInput, pTriggerGroupInfo, pHTMLSelector)
	{
		// First sanity check the triggergroupinfo
		if (!('TriggerGroupHash' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerGroupHash) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerGroupHash string is not present.`);
			return false;
		}
		if (!('TriggerAddress' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerAddress) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerAddress string is not present.`);
			return false;
		}

		let tmpValue = this.pict.manifest.getValueByHash(this.pict, pTriggerGroupInfo.TriggerAddress);

		if ((!tmpValue) && !pTriggerGroupInfo.MarshalEmptyValues)
		{
			return false;
		}
		// Maybe this just works!
		pView.setDataByInput(pInput, tmpValue);
		pView.manualMarshalDataToViewByInput(pInput);
		return true;
	}

	autoFillFromAddressListTabular(pView, pInput, pTriggerGroupInfo, pHTMLSelector, pRowIndex)
	{
		// First sanity check the triggergroupinfo
		if (!('TriggerGroupHash' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerGroupHash) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerGroupHash string is not present.`);
			return false;
		}
		if (!('TriggerAddress' in pTriggerGroupInfo) || (typeof(pTriggerGroupInfo.TriggerAddress) != 'string'))
		{
			this.log.warn(`AutofillTriggerGroup failed to autofill because a TriggerAddress string is not present.`);
			return false;
		}

		let tmpValue = this.pict.manifest.getValueByHash(this.pict, pTriggerGroupInfo.TriggerAddress);

		if ((!tmpValue) && !pTriggerGroupInfo.MarshalEmptyValues)
		{
			return false;
		}
		// Setting data is in the view intentionally, to allow triggered events.  Probabbly needs to be a separate provider.
		pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpValue);
		pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
		return true;
	}

	// Trigger the group if it's flagged as a triggering input
	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpTriggerGroupConfigurations = this.getTriggerGroupConfigurationArray(pInput);
		if (Array.isArray(tmpTriggerGroupConfigurations) && this.pict.views.PictFormMetacontroller)
		{
			for (let i = 0; i < tmpTriggerGroupConfigurations.length; i++)
			{
				const tmpGroupConfig = tmpTriggerGroupConfigurations[i];
				if (tmpGroupConfig.TriggerAllInputs)
				{
					if (Array.isArray(tmpGroupConfig.PreSolvers))
					{
						this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PreSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} pre-trigger`);
					}
					pView.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
					{
						if (Array.isArray(tmpGroupConfig.PostSolvers))
						{
							this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PostSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} post-trigger`);
						}
					});
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(
						`TriggerGroup:${tmpGroupConfig.TriggerGroupHash}:DataChange:${pInput.Hash || pInput.DataAddress}:${this.pict.getUUID()}`,
						pTransactionGUID);
				}
			}
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpTriggerGroupConfigurations = this.getTriggerGroupConfigurationArray(pInput);
		if (Array.isArray(tmpTriggerGroupConfigurations) && this.pict.views.PictFormMetacontroller)
		{
			for (let i = 0; i < tmpTriggerGroupConfigurations.length; i++)
			{
				const tmpGroupConfig = tmpTriggerGroupConfigurations[i];
				if (tmpGroupConfig.TriggerAllInputs)
				{
					if (Array.isArray(tmpGroupConfig.PreSolvers))
					{
						this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PreSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} tabular pre-trigger`);
					}
					pView.registerOnTransactionCompleteCallback(pTransactionGUID, () =>
					{
						if (Array.isArray(tmpGroupConfig.PostSolvers))
						{
							this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PostSolvers, `AutofillTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} tabular post-trigger`);
						}
					});
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(
						`TriggerGroup:${tmpGroupConfig.TriggerGroupHash}:DataChange:${pInput.Hash || pInput.DataAddress}:${this.pict.getUUID()}`,
						pTransactionGUID);
				}
			}
		}
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!tmpAutoFillTriggerGroups || tmpType !== 'TriggerGroup' || (pInput.Hash || pInput.DataAddress) == tmpInputHash)
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		for (let i = 0; i < tmpAutoFillTriggerGroups.length; i++)
		{
			let tmpAutoFillTriggerGroup = tmpAutoFillTriggerGroups[i];
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			if (Array.isArray(tmpAutoFillTriggerGroup.PreSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PreSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} pre-autofill`);
			}

			//FIXME: why is this check here? revisit
			if ('TriggerAddress' in tmpAutoFillTriggerGroup)
			{
				// Autofill based on the address list as it isn't a select option
				this.autoFillFromAddressList(pView, pInput, tmpAutoFillTriggerGroup, pHTMLSelector);
			}
			
			if (tmpAutoFillTriggerGroup.SelectOptionsRefresh)
			{
				// Regenerate the picklist
				// Because the pick lists are view specific, we need to lookup the view the input is in
				let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pInput.PictForm.SelectOptionsPickList);
				this.pict.providers['Pict-Input-Select'].refreshSelectList(tmpInputView, tmpInputView.getGroup(pInput.PictForm.GroupIndex), tmpInputView.getRow(pInput.PictForm.GroupIndex, pInput.PictForm.Row), pInput, pValue, pHTMLSelector);
				tmpInputView.manualMarshalDataToViewByInput(pInput, tmpEventGUID);
			}

			if (Array.isArray(tmpAutoFillTriggerGroup.PostSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PostSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} post-autofill`);
			}
		}

		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		if (!pInput.PictForm.AutofillTriggerGroup || tmpType !== 'TriggerGroup' || (pInput.Hash || pInput.DataAddress) == tmpInputHash)
		{
			// Do nothing for now -- this is the triggering element
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		for (const tmpAutoFillTriggerGroup of tmpAutoFillTriggerGroups)
		{
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}
			/*
			 * FIXME: for large tables, do we want to run this for every row?
			if (Array.isArray(tmpAutoFillTriggerGroup.PreSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PreSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} pre-autofill`);
			}
			*/

			//FIXME: why is this flow different from non-tabular? revisit
			if (!tmpAutoFillTriggerGroup.SelectOptionsRefresh)
			{
				// Autofill based on the address list as it isn't a select option
				this.autoFillFromAddressListTabular(pView, pInput, tmpAutoFillTriggerGroup, pHTMLSelector, pRowIndex);
			}
			else if (!pInput.PictForm.SelectOptionsPickList)
			{
				// There is no select options picklist so we can't auto refresh it.
			}
			else
			{
				// Regenerate the picklist
				// TODO: This is inefficient -- it regenerates the list for every single row.  Easy optimization.
				// Use the transaction stuff at some point, now that we have it in the event.
				let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pInput.PictForm.SelectOptionsPickList);
				this.pict.providers['Pict-Input-Select'].refreshSelectListTabular(tmpInputView, tmpInputView.getGroup(pInput.PictForm.GroupIndex), tmpInputView.getRow(pInput.PictForm.GroupIndex, pInput.PictForm.Row), pInput, pValue, pHTMLSelector, pRowIndex);
				tmpInputView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex, tmpEventGUID);
			}
			/*
			 * TODO: for large tables, do we want to run this for every row?
			if (Array.isArray(tmpAutoFillTriggerGroup.PostSolvers))
			{
				this.pict.providers.DynamicSolver.executeSolvers(pView, tmpAutoFillTriggerGroup.PostSolvers, `AutofillTriggerGroup hash ${tmpAutoFillTriggerGroup.TriggerGroupHash} post-autofill`);
			}
			*/
		}

		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],84:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		// Manage the the configuration parsing configurations -- these can be overridden in the object or even per-input
		if (!this.options.DefaultCoreParsingConfiguration || !Array.isArray(this.options.DefaultCoreParsingConfiguration))
		{
			this.options.DefaultCoreParsingConfiguration = (
				{
					AddressInObject: '',
					ObjectType: 'object',
					MergeMethod: 'Object',
					Steps: [
						{
							InputProperty: false,
							Method: `Initialize`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartConfigCorePrototypeRaw',
							Method: `Raw`,
							Merge: true
						},
						{
							InputProperty: 'PictForm.ChartConfigCorePrototypeAddress',
							Method: `Address`,
							Merge: true
						},
						{
							InputProperty: `PictForm.ChartConfigCorePrototype`,
							Method: 'SingleSolver',
							Merge: true
						}
					]
				});
		}
		this.defaultCoreParsingConfiguration = JSON.parse(JSON.stringify(this.options.DefaultCoreParsingConfiguration));

		if (typeof (this.options.DefaultLabelParsingConfiguration) !== 'object' || !Array.isArray(this.options.DefaultLabelParsingConfiguration.Steps))
		{
			this.options.DefaultLabelParsingConfiguration = (
				{
					AddressInObject: 'data.labels',
					ObjectType: 'array',
					MergeMethod: 'Array',
					Steps: [
						{
							InputProperty: false,
							Method: `Initialize`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartLabelsRaw',
							Method: `Raw`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartLabelsAddress',
							Method: `Address`,
							Merge: false
						},
						{
							InputProperty: `PictForm.ChartLabelsSolver`,
							Method: 'SingleSolver',
							Merge: false
						}
					]
				});
		}
		this.defaultLabelParsingConfiguration = JSON.parse(JSON.stringify(this.options.DefaultLabelParsingConfiguration));

		if (typeof (this.options.DefaultDataParsingConfiguration) !== 'object' || !Array.isArray(this.options.DefaultDataParsingConfiguration.Steps))
		{
			this.options.DefaultDataParsingConfiguration = (
				{
					AddressInObject: 'data.datasets',
					ObjectType: 'array',
					MergeMethod: 'Array',
					Steps: [
						{
							InputProperty: false,
							Method: `Initialize`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartDatasetsRaw',
							Method: `Raw`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartDatasetsAddress',
							Method: `Address`,
							Merge: false
						},
						{
							InputProperty: 'PictForm.ChartDatasetsSolvers',
							Method: `ArrayOfSolvers`,
							Merge: true
						}
					]
				});
		}
		this.defaultDataParsingConfiguration = JSON.parse(JSON.stringify(this.options.DefaultDataParsingConfiguration));

		this.currentChartObjects = {};
		this.currentChartDataObjects = {};
	}

	/**
	 * 
	 * @param {Object} pInput - The PictForm input object
	 * @param {*} pChartConfiguration - The current configuration object for the form
	 * @param {*} pParsingConfiguration - The parsing configuration to apply
	 * @param {*} pInputParsingConfigurationScope - The input-specific parsing configuration string address for additional configuration
	 * @returns 
	 */
	applyInputParsingConfiguration(pInput, pChartConfiguration, pParsingConfiguration, pInputParsingConfigurationScope)
	{
		// TODO: There is a ton of DRY to be had in this function when we break it out to the base class
		let tmpInput = pInput;
		let tmpInputParsingConfigurationScope = pInputParsingConfigurationScope;

		let tmpChartConfiguration = pChartConfiguration;
		let tmpParsingConfiguration = pParsingConfiguration;

		if (typeof (pInput) !== 'object')
		{
			return false;
		}
		if (typeof (pInputParsingConfigurationScope) !== 'string' || (pInputParsingConfigurationScope.length < 1))
		{
			return false;
		}
		if (typeof (tmpParsingConfiguration) !== 'object')
		{
			return false;
		}

		if (typeof (tmpChartConfiguration) !== 'object')
		{
			tmpChartConfiguration = {};
		}

		// 1. Check if there is any custom configurtion for how to parse the config for this input (dynamic dynamic)
		let tmpInputCustomConfiguration = this.pict.manifest.getValueByHash(tmpInput, tmpInputParsingConfigurationScope);
		if (typeof (tmpInputCustomConfiguration) === 'object')
		{
			// Merge the custom configuration into the base configuration
			tmpParsingConfiguration = Object.assign(tmpParsingConfiguration, tmpInputCustomConfiguration);
		}

		// Get existing data
		let tmpExistingData;
		if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
		{
			tmpExistingData = tmpChartConfiguration;
		}
		else
		{
			tmpExistingData = this.pict.manifest.getValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject);
		}

		// 2. Enumerate through each step and apply them consistently
		for (let i = 0; i < tmpParsingConfiguration.Steps.length; i++)
		{
			let tmpCurrentStep = tmpParsingConfiguration.Steps[i];

			switch (tmpCurrentStep.Method)
			{
				case 'Initialize':
					// Do nothing, already initialized
					if (tmpParsingConfiguration.AddressInObject && (typeof (tmpParsingConfiguration.AddressInObject) === 'string') && (tmpParsingConfiguration.AddressInObject.length > 0))
					{
						let tmpCurrentStepData = this.pict.manifest.getValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject);
						// see if the address exists and if it's the type we expect
						if (tmpParsingConfiguration.ObjectType === 'array')
						{
							if (!tmpCurrentStepData || !Array.isArray(tmpCurrentStepData))
							{
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, []);
							}
						}
						else if (tmpParsingConfiguration.ObjectType === 'object')
						{
							if (!tmpCurrentStepData || (typeof (tmpCurrentStepData) !== 'object'))
							{
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, {});
							}
						}
						else
						{
							this.pict.log.warn(`Unsupported ObjectType ${tmpParsingConfiguration.ObjectType} parsing chart Initialize configuration for input ${tmpInput.Macro.RawHTMLID}`);
						}
					}
					break;
				case 'Raw':
					// Check if the Raw is in there
					let tmpRawDataExists = this.pict.manifest.checkAddressExists(tmpInput, tmpCurrentStep.InputProperty);
					if (!tmpRawDataExists)
					{
						break;
					}

					// Get the raw data from the input
					let tmpRawData = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);
					let tmpRawDataType = typeof(tmpRawData);

					// We only support objects as configuration
					if (tmpRawDataType !== 'object')
					{
						break;
					}

					if (tmpParsingConfiguration.ObjectType === 'array')
					{
						if (Array.isArray(tmpRawData))
						{
							if (tmpCurrentStep.Merge)
							{
								// Get existing data
								if (!Array.isArray(tmpExistingData))
								{
									tmpExistingData = [];
								}
								// Merge in the arrays
								let tmpMergedData = tmpExistingData.concat(tmpRawData);
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
							}
							else
							{
								// Just set the value
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
							}
						}
					}
					else if (tmpParsingConfiguration.ObjectType === 'object')
					{
						if (tmpCurrentStep.Merge)
						{
							if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
							{
								// This is the "root" object, so we need to merge or set directly
								if (tmpCurrentStep.Merge)
								{
									tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpRawData);
								}
								else
								{
									tmpChartConfiguration = tmpRawData;
								}
							}
							else
							{
								if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
								{
									tmpExistingData = {};
								}
								if (tmpCurrentStep.Merge)
								{
									// Merge the objects
									let tmpMergedData = Object.assign(tmpExistingData, tmpRawData);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
								}
								else
								{
									// Just set the value
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
								}
							}
						}
						else
						{
							// Just set the value?
							this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
						}
					}
					break;
				case 'Address':
					let tmpAddress = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);
					// Input is the Record in the resolution chain
					if (!tmpAddress)
					{
						break;
					}

					let tmpPotentialConfigurationObject = this.pict.resolveStateFromAddress(tmpAddress, pInput);

					if (typeof (tmpPotentialConfigurationObject) !== 'object')
					{
						break;
					}

					if (tmpParsingConfiguration.ObjectType === 'array')
					{
						if (Array.isArray(tmpRawData))
						{
							if (tmpCurrentStep.Merge)
							{
								// Get existing data
								if (!Array.isArray(tmpExistingData))
								{
									tmpExistingData = [];
								}
								// Merge in the arrays
								let tmpMergedData = tmpExistingData.concat(tmpRawData);
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
							}
							else
							{
								// Just set the value
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
							}
						}
					}
					else if (tmpParsingConfiguration.ObjectType === 'object')
					{
						if (tmpCurrentStep.Merge)
						{
							if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
							{
								// This is the "root" object, so we need to merge or set directly
								if (tmpCurrentStep.Merge)
								{
									tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpRawData);
								}
								else
								{
									tmpChartConfiguration = tmpRawData;
								}
							}
							else
							{
								if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
								{
									tmpExistingData = {};
								}
								if (tmpCurrentStep.Merge)
								{
									// Merge the objects
									let tmpMergedData = Object.assign(tmpExistingData, tmpRawData);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
								}
								else
								{
									// Just set the value
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
								}
							}
						}
						else
						{
							// Just set the value?
							this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
						}
					}
					break;
				case 'SingleSolver':
					let tmpSolverExpression = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);
					// Check that the expression is a string
					if (typeof (tmpSolverExpression) !== 'string')
					{
						break;
					}

					let tmpSolvedConfiguration = this.pict.providers.DynamicSolver.runSolver(tmpSolverExpression, true);

					if (tmpParsingConfiguration.ObjectType === 'array')
					{
						if (Array.isArray(tmpSolvedConfiguration))
						{
							if (tmpCurrentStep.Merge)
							{
								// Get existing data
								if (!Array.isArray(tmpExistingData))
								{
									tmpExistingData = [];
								}
								// Merge in the arrays
								let tmpMergedData = tmpExistingData.concat(tmpSolvedConfiguration);
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
							}
							else
							{
								// Just set the value
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpSolvedConfiguration);
							}
						}
					}
					else if (tmpParsingConfiguration.ObjectType === 'object')
					{
						if (tmpCurrentStep.Merge)
						{
							if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
							{
								// This is the "root" object, so we need to merge or set directly
								if (tmpCurrentStep.Merge)
								{
									tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpSolvedConfiguration);
								}
								else
								{
									tmpChartConfiguration = tmpSolvedConfiguration;
								}
							}
							else
							{
								if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
								{
									tmpExistingData = {};
								}
								if (tmpCurrentStep.Merge)
								{
									// Merge the objects
									let tmpMergedData = Object.assign(tmpExistingData, tmpSolvedConfiguration);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
								}
								else
								{
									// Just set the value
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
								}
							}
						}
						else
						{
							// Just set the value?
							this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
						}
					}
					break;

				case 'ArrayOfSolvers':
					let tmpSolverExpressionList = this.pict.manifest.getValueByHash(tmpInput, tmpCurrentStep.InputProperty);

					// Check that the expression is a string
					if (!Array.isArray(tmpSolverExpressionList))
					{
						break;
					}

					for (let i = 0; i < tmpSolverExpressionList.length; i++)
					{
						let tmpCurrentSolverExpression = tmpSolverExpressionList[i];
						if (typeof(tmpCurrentSolverExpression) !== 'object')
						{
							continue;
						}

						let tmpSolverLabel = tmpCurrentSolverExpression.Label;
						let tmpSolverExpression = tmpCurrentSolverExpression.DataSolver;
						let tmpSolvedDataSet = this.pict.providers.DynamicSolver.runSolver(tmpSolverExpression, true);

						let tmpDataObject = (
							{
								label: tmpSolverLabel,
								data: (Array.isArray(tmpSolvedDataSet)) ? tmpSolvedDataSet : []
							});

						if (tmpCurrentSolverExpression.ChartType)
						{
							tmpDataObject.type = tmpCurrentSolverExpression.ChartType;
						}

						// Add in any custom Y axis ID
						if (tmpCurrentSolverExpression.CustomYAxisID)
						{
							tmpDataObject.yAxisID = tmpCurrentSolverExpression.CustomYAxisID;
						}

						// Add in any custom X axis ID
						if (tmpCurrentSolverExpression.CustomXAxisID)
						{
							tmpDataObject.xAxisID = tmpCurrentSolverExpression.CustomXAxisID;
						}

						// Add in a custom Tension
						if (tmpCurrentSolverExpression.Tension)
						{
							tmpDataObject.tension = tmpCurrentSolverExpression.Tension;
						}
						
						// Add in a custom pointRadius
						if (tmpCurrentSolverExpression.PointRadius)
						{
							tmpDataObject.pointRadius = tmpCurrentSolverExpression.PointRadius;
						}

						// Check if this has a stack defined (for stacked bar charts and such)
						if (tmpCurrentSolverExpression.StackGroup)
						{
							tmpDataObject.stack = tmpCurrentSolverExpression.StackGroup;
						}

						if (tmpParsingConfiguration.ObjectType === 'array')
						{
							if (Array.isArray(tmpSolvedDataSet))
							{
								if (tmpCurrentStep.Merge)
								{
									// Get existing data
									if (!Array.isArray(tmpExistingData))
									{
										tmpExistingData = [];
									}
									tmpExistingData.push(tmpDataObject);
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpExistingData);
								}
								else
								{
									this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, [tmpDataObject]);
								}
							}
						}
						else if (tmpParsingConfiguration.ObjectType === 'object')
						{
							if (tmpCurrentStep.Merge)
							{
								if (!tmpParsingConfiguration.AddressInObject || (tmpParsingConfiguration.AddressInObject == ''))
								{
									// This is the "root" object, so we need to merge or set directly
									if (tmpCurrentStep.Merge)
									{
										tmpChartConfiguration = Object.assign(tmpChartConfiguration, tmpSolvedDataSet);
									}
									else
									{
										tmpChartConfiguration = tmpSolvedDataSet;
									}
								}
								else
								{
									if ((typeof(tmpExistingData) != 'object') || (tmpExistingData == null))
									{
										tmpExistingData = {};
									}
									if (tmpCurrentStep.Merge)
									{
										// Merge the objects
										let tmpMergedData = Object.assign(tmpExistingData, tmpSolvedDataSet);
										this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpMergedData);
									}
									else
									{
										// Just set the value
										this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
									}
								}
							}
							else
							{
								// Just set the value?
								this.pict.manifest.setValueByHash(tmpChartConfiguration, tmpParsingConfiguration.AddressInObject, tmpRawData);
							}
						}
					}
					break;
			}
		}
	}

	getInputChartConfiguration(pView, pInput, pValue)
	{
		let tmpView = pView;
		let tmpInput = pInput;
		let tmpValue = pValue;

		if (!('PictForm' in tmpInput))
		{
			return false;
		}

		let tmpPictform = pInput.PictForm;

		let tmpChartConfiguration = (typeof (tmpPictform.ChartJSOptionsCorePrototype) === 'object') ? tmpPictform.ChartJSOptionsCorePrototype : {};

		this.applyInputParsingConfiguration(pInput, tmpChartConfiguration, this.defaultCoreParsingConfiguration, 'PictForm.ChartConfigCoreParsingConfigurationOverride');
		if (!('type' in tmpChartConfiguration))
		{
			tmpChartConfiguration.type = (typeof (tmpPictform.ChartType) === 'string') ? tmpPictform.ChartType : 'bar';
		}
		this.applyInputParsingConfiguration(pInput, tmpChartConfiguration, this.defaultLabelParsingConfiguration, 'PictForm.ChartLabelsParsingConfigurationOverride');
		this.applyInputParsingConfiguration(pInput, tmpChartConfiguration, this.defaultDataParsingConfiguration, 'PictForm.ChartDataParsingConfigurationOverride');

		return tmpChartConfiguration;
	}

	initializeChartVisualization(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Stuff the config into a hidden element for reference
		let tmpConfigStorageLocation = `#CONFIG-FOR-${pInput.Macro.RawHTMLID}`;
		let tmpChartConfiguration = this.getInputChartConfiguration(pView, pInput, pValue);
		this.pict.ContentAssignment.assignContent(tmpConfigStorageLocation, JSON.stringify(tmpChartConfiguration));

		let tmpChartCanvasElementSelector = `#CANVAS-FOR-${pInput.Macro.RawHTMLID}`;
		let tmpChartCanvasElement = this.pict.ContentAssignment.getElement(tmpChartCanvasElementSelector);
		if ((!Array.isArray(tmpChartCanvasElement)) || (tmpChartCanvasElement.length < 1))
		{
			this.log.warn(`Chart canvas element not found for input ${tmpChartCanvasElementSelector}`);
			return false;
		}
		tmpChartCanvasElement = tmpChartCanvasElement[0]

		// Check if there is a window.Chart which is the Chart.js library
		if (typeof (window.Chart) !== 'function')
		{
			this.log.warn(`Chart.js library not loaded for input ${tmpChartCanvasElementSelector}`);
		}
		else
		{
			this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`] = new window.Chart(tmpChartCanvasElement, tmpChartConfiguration);
			// TODO: Make this invalidation better.
			this.currentChartDataObjects[`Data-For-${pInput.Macro.RawHTMLID}`] = JSON.stringify(tmpChartConfiguration.data);
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.initializeChartVisualization(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (!this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`])
		{
			this.initializeChartVisualization(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		}
		else
		{
			let tmpChartConfiguration = this.getInputChartConfiguration(pView, pInput, pValue);
			let tmpNewChartDataString = JSON.stringify(tmpChartConfiguration.data);
			if (this.currentChartDataObjects[`Data-For-${pInput.Macro.RawHTMLID}`] !== tmpNewChartDataString)
			{
				this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`].data = tmpChartConfiguration.data;
				this.currentChartObjects[`Object-For-${pInput.Macro.RawHTMLID}`].update();
				this.currentChartDataObjects[`Data-For-${pInput.Macro.RawHTMLID}`] = tmpNewChartDataString;
			}
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @returns {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @returns {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],85:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 * Represents a custom input handler for a Pict section form.
 * @extends libPictSectionInputExtension
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a DateTime input element based on the given input HTML ID.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @returns {string} The generated DateTime input HTML ID.
	 */
	getDateTimeInputHTMLID(pInputHTMLID)
	{
		return `#DATETIME-INPUT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates the HTML ID for a hidden input element in a tabular datetime data provider.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @param {number} pRowIndex - The index of the row in the tabular data.
	 * @returns {string} - The generated HTML ID for the hidden input element.
	 */
	getTabularDateTimeHiddenInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular date-time input HTML ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} The tabular date-time input HTML ID.
	 */
	getTabularDateTimeInputHTMLID(pInputHTMLID, pRowIndex)
	{
		return `#DATETIME-TABULAR-INPUT-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Fires after data has been marshaled to the form.
	 *
	 * This is important because the DateTime has a "shadow" hidden input that stores the value for the date control.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super method call.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getDateTimeInputHTMLID(pInput.Macro.RawHTMLID), pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form in a tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for the specified input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @returns {boolean} - Returns true if the data request is successful, otherwise false.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		// TODO: Should this be opinionated about time zone?  If so, this is the start of it.
		// let tmpDateTimeElement = this.pict.ContentAssignment.getElement(this.getDateTimeInputHTMLID(pInput.Macro.RawHTMLID));
		// if (tmpDateTimeElement && tmpDateTimeElement.length > 0)
		// {
		// 	tmpDateTimeElement = tmpDateTimeElement[0];
		// }
		// else
		// {
		// 	return false;
		// }
		//let tmpDateValue = this.fable.Dates.dayJS(tmpDateTimeElement.value);

		let tmpInputSelectValue;
		try
		{
			tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getDateTimeInputHTMLID(pInput.Macro.RawHTMLID));
			this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
			pView.dataChanged(pInput.Hash);
		}
		catch
		{
			this.log.error(`The value [${tmpInputSelectValue}] is not a valid date; skipping parsing for [#${pInput.Macro.RawHTMLID}].`);
		}

		return super.onDataRequest(pView, pInput, pValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for the specified input when in a tabular section.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be assigned.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {boolean} - Returns true if the data request is successful, otherwise false.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// TODO: If we decide to be opinionated about time zone, use the above here as well
		let tmpInputSelectValue;
		try
		{
			tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularDateTimeInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex));
			this.pict.ContentAssignment.assignContent(this.getTabularDateTimeHiddenInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
			pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		}
		catch
		{
			this.log.error(`The value [${tmpInputSelectValue}] is not a valid date; skipping parsing for [#${pInput.Macro.RawHTMLID}].`);
		}

		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],86:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class for Entity Bundle Requests.
 *
 * When an input is flagged as an EntityBundleRequest entity, it will go pull a
 * sequential list of records on data selection.
 *
 * Paired with the AutofillTriggerGroup, this allows other values to be filled
 * when a record is selected and fetched.

Providers: ["Pict-Input-EntityBundleRequest", "Pict-Input-TriggerGroup"],
		EntitiesBundle: [
		{
			"Entity": "Author",
			"Filter": "FBV~IDAuthor~EQ~{~D:Record.Value~}",
			"Destination": "AppData.CurrentAuthor",
			// This marshals a single record
			"SingleRecord": true
		},
		{
			"Entity": "BookAuthorJoin",
			"Filter": "FBV~IDAuthor~EQ~{~D:Appdata.CurrentAuthor.IDAuthor~}",
			"Destination": "AppData.BookAuthorJoins"
		},
		{
			"Entity": "Book",
			"Filter": "FBL~IDBook~LK~{PJU~:,^IDBook^Appdata.BookAuthorJoins~}",
			"Destination": "AppData.BookAuthorJoins"
		}
	],
	EntityBundleTriggerGroup: "BookTriggerGroup"

 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	gatherEntitySet(fCallback, pEntityInformation, pView, pInput, pValue)
	{
		// First sanity check the pEntityInformation
		if (!('Entity' in pEntityInformation) || (typeof(pEntityInformation.Entity) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain an Entity string.`);
			return fCallback();
		}
		if (!('Filter' in pEntityInformation) || (typeof(pEntityInformation.Filter) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain a Filter string.`);
			return fCallback();
		}
		if (!('Destination' in pEntityInformation) || (typeof(pEntityInformation.Destination) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain a Destination string.`);
			return fCallback();
		}

		const tmpFilterTemplateRecord = { Value:pValue, Input:pInput, View:pView };
		let tmpRecordStartCursor = null;
		let tmpRecordCount = null;
		if (pEntityInformation.RecordCount)
		{
			tmpRecordStartCursor = pEntityInformation.RecordStartCursor != null ? pEntityInformation.RecordStartCursor : 0;
			tmpRecordCount = pEntityInformation.RecordCount != null ? pEntityInformation.RecordCount : null;
		}
		// Parse the filter template
		const tmpFilterString = this.pict.parseTemplate(pEntityInformation.Filter, tmpFilterTemplateRecord);
		if (tmpFilterString == '')
		{
			// We may want to continue, but for now let's say nah and nope out.
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity Filter did not return a string for FilterBy`)
		}

		// Now get the records
		const callback = (pError, pRecordSet) =>
		{
			if (pError)
			{
				this.log.error(`EntityBundleRequest request Error getting entity set for [${pEntityInformation.Entity}] with filter [${tmpFilterString}]: ${pError}`, pError);
				return fCallback(pError, '');
			}

			this.log.trace(`EntityBundleRequest found ${pRecordSet.length} records for ${pEntityInformation.Entity} filtered to [${tmpFilterString}]`);

			// Now assign it back to the destination; because this is not view specific it doesn't use the manifests from them (to deal with scope overlap with subgrids).
			if (pEntityInformation.SingleRecord)
			{
				if (pRecordSet.length > 1)
				{
					this.log.warn(`EntityBundleRequest found more than one record for ${pEntityInformation.Entity} filtered to [${tmpFilterString}] but SingleRecord is true; setting the first record.`);
				}
				if (pRecordSet.length < 1)
				{
					this.pict.manifest.setValueByHash(this.pict, pEntityInformation.Destination, false);
				}
				this.pict.manifest.setValueByHash(this.pict, pEntityInformation.Destination, pRecordSet[0]);
			}
			else
			{
				this.pict.manifest.setValueByHash(this.pict, pEntityInformation.Destination, pRecordSet);
			}

			return fCallback();
		};
		if (tmpRecordCount)
		{
			this.pict.EntityProvider.getEntitySetPage(pEntityInformation.Entity, tmpFilterString, tmpRecordStartCursor, tmpRecordCount, callback);
		}
		else
		{
			this.pict.EntityProvider.getEntitySet(pEntityInformation.Entity, tmpFilterString, callback);
		}
	}

	gatherCustomDataSet(fCallback, pCustomRequestInformation, pView, pInput, pValue)
	{
		// First sanity check the pCustomRequestInformation
		if (!('URL' in pCustomRequestInformation) || (typeof(pCustomRequestInformation.URL) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the stanza did not contain a URL string.`);
			return fCallback();
		}

		const tmpURLTemplateRecord = { Value:pValue, Input:pInput, View:pView };
		// Parse the filter template
		const tmpURLTemplateString = this.pict.parseTemplate(pCustomRequestInformation.URL, tmpURLTemplateRecord);
		if (tmpURLTemplateString == '')
		{
			// We may want to continue, but for now let's say nah and nope out.
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the entity Filter did not return a string for FilterBy`)
		}

		let tmpURLPrefix = '';
		// This will only be true if the "Host" is set.
		const tmpCustomURIHost = pCustomRequestInformation.Host ? pCustomRequestInformation.Host : false;
		// If "Host" is set, protocol and port are optional.
		const tmpCustomURIProtocol = pCustomRequestInformation.Protocol ? pCustomRequestInformation.Protocol : 'https';
		const tmpCustomURIPort = pCustomRequestInformation.Port ? pCustomRequestInformation.Port : false;

		if (tmpCustomURIHost)
		{
			tmpURLPrefix = `${tmpCustomURIProtocol}://${tmpCustomURIHost}`;
			if (tmpCustomURIPort)
			{
				tmpURLPrefix += `:${tmpCustomURIPort}`;
			}
		}
		else
		{
			tmpURLPrefix = this.pict.EntityProvider.options.urlPrefix;
		}

		// Now get the records
		const callback = (pError, pResponse, pData) =>
		{
			if (pError)
			{
				this.log.error(`EntityBundleRequest request Error getting data set for [${pCustomRequestInformation.Entity}] with filter [${tmpURLTemplateString}]: ${pError}`, pError);
				return fCallback(pError, '');
			}

			this.log.trace(`EntityBundleRequest completed request for ${pCustomRequestInformation.Entity} filtered to [${tmpURLTemplateString}]`);

			// Since this is a templated endpoint it can be used for logging etc.
			if (pCustomRequestInformation.Destination)
			{
				this.pict.manifest.setValueByHash(this.pict, pCustomRequestInformation.Destination, pData);
			}

			return fCallback();
		};

		let tmpOptions = (
			{
				url: `${tmpURLPrefix}${tmpURLTemplateString}`
			});
		tmpOptions = this.pict.EntityProvider.prepareRequestOptions(tmpOptions);
		return this.pict.EntityProvider.restClient.getJSON(tmpOptions, callback);
	}

	/**
	 * TODO: I added a proise return here to know when this data load is done for the dashboard usecase. Could use a revisit.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value of the input.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} [pTransactionGUID] - (optional) The transaction GUID for the event dispatch.
	 *
	 * @return {Promise<Error?>} - Returns a promise that resolves when the data has been gathered.
	 */
	async gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Gather data from the server
		// These have to date not been asyncronous.  Now they will be...
		if ((typeof(pInput) !== 'object') || !('PictForm' in pInput) || !('EntitiesBundle' in pInput.PictForm) || !Array.isArray(pInput.PictForm.EntitiesBundle))
		{
			this.log.warn(`Input at ${pHTMLSelector} is set as an EntityBundleRequest input but no array of entity requests was found`);
			return null;
		}

		const tmpLoadGUID = `BundleLoad-${this.pict.getUUID()}`;
		if (pTransactionGUID)
		{
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpLoadGUID);
		}
		let tmpInput = pInput;
		let tmpValue = pValue;
		let tmpAnticipate = this.fable.newAnticipate();

		if (tmpInput.PictForm.EntitiesBundle.length > 0 && tmpInput.PictForm.EntitiesBundle[0].PictMode)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.pict.EntityProvider.gatherDataFromServer(tmpInput.PictForm.EntitiesBundle, (pError) =>
				{
					// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
					setTimeout(() => fNext(pError), 0);
				});
			});
		}
		else
		{
			const tmpStateStack = [];
			/** @type {Record<string, any>} */
			let tmpState = { Value: tmpValue, Input: tmpInput, View: pView };
			for (let i = 0; i < tmpInput.PictForm.EntitiesBundle.length; i++)
			{
				let tmpEntityBundleEntry = tmpInput.PictForm.EntitiesBundle[i];
				tmpAnticipate.anticipate(
					(fNext) =>
					{
						try
						{
							switch (tmpEntityBundleEntry.Type)
							{
								case 'Custom':
									return this.gatherCustomDataSet(fNext, tmpEntityBundleEntry, pView, tmpInput, tmpValue);
								case 'SetStateAddress':
									tmpStateStack.push(tmpState);
									tmpState = this.fable.manifest.getValueByHash(this.fable, tmpEntityBundleEntry.StateAddress);
									if (typeof tmpState === 'undefined')
									{
										tmpState = {};
										this.fable.manifest.setValueByHash(this.fable, tmpEntityBundleEntry.StateAddress, tmpState);
									}
									break;
								case 'PopState':
									if (tmpStateStack.length > 0)
									{
										tmpState = tmpStateStack.pop();
									}
									else
									{
										this.log.warn(`EntityBundleRequest encountered a PopState without a matching SetStateAddress.`);
									}
									break;
								case 'MapJoin':
									this.pict.EntityProvider.mapJoin(tmpEntityBundleEntry, this.pict.EntityProvider.prepareState(tmpState, tmpEntityBundleEntry));
									break;
								case 'ProjectDataset':
									this.pict.EntityProvider.projectDataset(tmpEntityBundleEntry, this.pict.EntityProvider.prepareState(tmpState, tmpEntityBundleEntry));
									break;
								// This is the default case, for a meadow entity set or single entity
								case 'MeadowEntity':
								default:
									return this.gatherEntitySet(fNext, tmpEntityBundleEntry, pView, tmpInput, tmpValue);
							}
						}
						catch (pError)
						{
							this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, pError);
						}
						return fNext();
					});
			}
			// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
			tmpAnticipate.anticipate((fNext) => setTimeout(fNext, 0));
		}

		tmpAnticipate.anticipate(
			(fNext) =>
			{
				if (tmpInput.PictForm.EntityBundleTriggerGroup && this.pict.views.PictFormMetacontroller)
				{
					const tmpGroupConfig = this.getTriggerGroupConfigurationArray(tmpInput, tmpInput.PictForm.EntityBundleTriggerGroup)[0];
					if (tmpGroupConfig && Array.isArray(tmpGroupConfig.PreSolvers))
					{
						this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PreSolvers, `EntityBundleTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} pre-trigger`);
					}
					let tmpTransactionGUID;
					if (tmpGroupConfig && Array.isArray(tmpGroupConfig.PostSolvers))
					{
						tmpTransactionGUID = pTransactionGUID || this.pict.getUUID();
						if (tmpTransactionGUID !== pTransactionGUID)
						{
							this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
						}
						pView.registerOnTransactionCompleteCallback(tmpTransactionGUID, () =>
						{
							if (Array.isArray(tmpGroupConfig.PostSolvers))
							{
								this.pict.providers.DynamicSolver.executeSolvers(pView, tmpGroupConfig.PostSolvers, `EntityBundleTriggerGroup hash ${tmpGroupConfig.TriggerGroupHash} tabular post-trigger`);
							}
						});
					}
					// Trigger the autofill global event
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(`TriggerGroup:${tmpInput.PictForm.EntityBundleTriggerGroup}:BundleLoad:${pInput.Hash || pInput.DataAddress}:${this.pict.getUUID()}`, pTransactionGUID);
					if (tmpTransactionGUID && tmpTransactionGUID !== pTransactionGUID)
					{
						pView.finalizeTransaction(tmpTransactionGUID);
					}
				}
				if (tmpInput.PictForm.EntityBundleTriggerMetacontrollerSolve && this.pict.views.PictFormMetacontroller)
				{
					// Trigger the solve global event
					this.pict.views.PictFormMetacontroller.solve();
				}
				if (tmpInput.PictForm.EntityBundleTriggerMetacontrollerRender && this.pict.views.PictFormMetacontroller)
				{
					// Trigger the render
					this.pict.views.PictFormMetacontroller.render();
				}
				fNext();
			});

		return new Promise((pResolve, pReject) =>
		{
			// Now fire the "autofilldata" event for the groups.
			tmpAnticipate.wait(
				(pError) =>
				{
					//FIXME: should we be ignoring this error? rejecting here is unsafe since the result isn't guaranteed to be handled, so will crash stuff currently
					if (pError)
					{
						this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, pError);
					}
					//TODO: close the async operation if we have a transaction GUID
					if (pTransactionGUID)
					{
						pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpLoadGUID);
					}

					return pResolve(pError);
				});
		});
	}

	/**
	 * @param {Object} pInput - The input object.
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 * @return {Array<Record<string, any>>} - An array of trigger group configurations.
	 */
	getTriggerGroupConfigurationArray(pInput, pTriggerGroupHash)
	{
		let tmpAutoFillTriggerGroups = pInput.PictForm.AutofillTriggerGroup;
		if (!tmpAutoFillTriggerGroups)
		{
			return [];
		}
		if (!Array.isArray(tmpAutoFillTriggerGroups))
		{
			tmpAutoFillTriggerGroups = [tmpAutoFillTriggerGroups];
		}
		if (pTriggerGroupHash == null)
		{
			return tmpAutoFillTriggerGroups;
		}
		return tmpAutoFillTriggerGroups.filter((pGroup) => pGroup.TriggerGroupHash === pTriggerGroupHash);
	}


	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		// Try to get the input element
		if (pInput.PictForm && (pValue || pInput.PictForm.EntityBundleTriggerWithoutValue) && pInput.PictForm.EntityBundleTriggerOnInitialize)
		{
			// This is a request on initial load
			this.gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		// This is in case we need to do a request on initial load!
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.log.error(`EntityBundleRequest for input [${pInput.Hash}] Tabular support is intentionally not supported.`);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		if (pInput.PictForm && (pValue || pInput.PictForm.EntityBundleTriggerWithoutValue) && pInput.PictForm.EntityBundleTriggerOnDataChange !== false)
		{
			this.gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
		}
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		const [ tmpType, tmpGroupHash ] = tmpPayload.split(':');

		if (tmpType !== 'TriggerGroup' || !tmpGroupHash || pInput.PictForm.TriggerGroupHash !== tmpGroupHash)
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		this.gatherDataFromServer(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);

		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],87:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		return tmpContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],88:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class LinkInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { Math: any } & { DataFormat: any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.setAttribute(this.getInputHTMLID(pInput.Macro.RawHTMLID), 'href', pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.setAttribute(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), 'href', pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = LinkInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],89:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

const libMarked = require('marked');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	getInputContent(pInput, pValue)
	{
		let tmpContent = null;
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		if (pInput.Content && (typeof(pInput.Content) === 'string'))
		{
			tmpContent = pInput.Content;
		}
		if (pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		if (tmpContent)
		{
			tmpContent = libMarked.parse(tmpContent);
		}
		return tmpContent;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onInputInitialize(pView, pGroup, pRow, pInput, tmpContent, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), tmpContent);
		}
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpContent = this.getInputContent(pInput, pValue);
		if (tmpContent)
		{
			this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpContent);
		}
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76,"marked":4}],90:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { Math: any } & { DataFormat: any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	roundValue(pInput, pValue)
	{
		let tmpValue = pValue;

		if ('DecimalPrecision' in pInput.PictForm)
		{
			let tmpRoundingMethod = this.fable.Math.roundHalfUp;
			if ('RoundingMethod' in pInput.PictForm)
			{
				try
				{
					tmpRoundingMethod = parseInt(pInput.PictForm.RoundingMethod);
				}
				catch(pError)
				{
					this.log.error(`Error parsing rounding method onDataMarshalToForm for input ${pInput.Hash}`, pError);
				}
			}
			tmpValue = this.fable.Math.toFixedPrecise(tmpValue, pInput.PictForm.DecimalPrecision, tmpRoundingMethod);
		}

		if (('AddCommas' in pInput.PictForm) && pInput.PictForm.AddCommas)
		{
			tmpValue = this.fable.DataFormat.formatterAddCommasToNumber(tmpValue);
		}

		if ('DigitsPrefix' in pInput.PictForm)
		{
			tmpValue = pInput.PictForm.DigitsPrefix + tmpValue;
		}
		if ('DigitsPostfix' in pInput.PictForm)
		{
			tmpValue = tmpValue + pInput.PictForm.DigitsPostfix;
		}

		return tmpValue;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getInputHTMLID(pInput.Macro.RawHTMLID), this.roundValue(pInput, pValue));
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent('#PRECISE-' + this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex).substring(1), pValue);
		this.pict.ContentAssignment.assignContent(this.getTabularInputHTMLID(pInput.Macro.RawHTMLID, pRowIndex), this.roundValue(pInput, pValue));
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],91:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the select input element.
	 */
	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular select input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular select input ID.
	 */
	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Generates a tabular select dropdown ID based on the input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {string} - The generated tabular select dropdown ID.
	 */
	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#SELECT-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Refreshes the select list for a dynamic input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 */
	refreshSelectList(pView, pGroup, pRow, pInput, pValue, pHTMLSelector)
	{
		// Try to get the input element
		/** @type {Array<HTMLElement>|HTMLElement} */
		let tmpInputSelectElement = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		let tmpListData = pInput.PictForm?.SelectOptions;

		if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
		{
			tmpListData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
		}

		// TODO: Determine later if this should ever be an array.
		if (!tmpInputSelectElement || tmpInputSelectElement.length < 1)
		{
			return false;
		}

		tmpListData = this.pict.providers.ListDistilling.filterList(pView, pInput, tmpListData);

		tmpInputSelectElement = tmpInputSelectElement[0];
		// HAX
		tmpInputSelectElement.innerHTML = '';

		if (tmpInputSelectElement && tmpListData && Array.isArray(tmpListData))
		{
			for (let i = 0; i < tmpListData.length; i++)
			{
				let tmpOption = document.createElement('option');
				tmpOption.value = tmpListData[i].id;
				tmpOption.text = tmpListData[i].text;
				tmpInputSelectElement.appendChild(tmpOption);
			}
		}
	}

	/**
	 * Refreshes the select list for a tabular input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex 
	 */
	refreshSelectListTabular(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Try to get the input element
		/** @type {Array<HTMLElement>|HTMLElement} */
		let tmpInputSelectElement = this.pict.ContentAssignment.getElement(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		let tmpListData = pInput.PictForm?.SelectOptions;

		if (pInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.hasList(pInput.PictForm.SelectOptionsPickList))
		{
			tmpListData = this.pict.providers.DynamicMetaLists.getList(pInput.PictForm.SelectOptionsPickList);
		}

		tmpListData = this.pict.providers.ListDistilling.filterList(pView, pInput, tmpListData);

		// TODO: Determine later if this should ever be an array.
		if (!Array.isArray(tmpInputSelectElement) || tmpInputSelectElement.length < 1)
		{
			return;
		}

		tmpInputSelectElement = tmpInputSelectElement[0];

		// HAX
		tmpInputSelectElement.innerHTML = '';

		if (tmpInputSelectElement && tmpListData && Array.isArray(tmpListData))
		{
			for (let i = 0; i < tmpListData.length; i++)
			{
				let tmpOption = document.createElement('option');
				tmpOption.value = tmpListData[i].id;
				tmpOption.text = tmpListData[i].text;
				tmpInputSelectElement.appendChild(tmpOption);
			}
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.refreshSelectList(pView, pGroup, pRow, pInput, pValue, pHTMLSelector);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.refreshSelectListTabular(pView, pGroup, pView.getRow(pInput.PictForm.GroupIndex, pRowIndex), pInput, pValue, pHTMLSelector, pRowIndex);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the change event for the data in the select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value of the input.
	 * @param {string} pHTMLSelector - The HTML selector of the input.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super.onDataChange method.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Handles the change event for tabular data.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the super method.
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		/** @type {Array<HTMLElement>|HTMLElement} */
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		const tmpInputSelectElement = tmpInputSelectElements[0];
		if (!(tmpInputSelectElement instanceof HTMLSelectElement))
		{
			return false;
		}

		let tmpValueSelected = false;

		for (let i = 0; i < tmpInputSelectElement.options.length; i++)
		{
			if (tmpInputSelectElement.options[i].value === pValue)
			{
				tmpInputSelectElement.selectedIndex = i;
				tmpValueSelected = true;
				break;
			}
		}

		if (!tmpValueSelected)
		{
			tmpInputSelectElement.selectedIndex = -1;
			//this.log.error(`The value [${pValue}] was not found in the select options for input [${pInput.Macro.RawHTMLID}] but was set in the hidden HTML input.`);
		}

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		/** @type {Array<HTMLElement>|HTMLElement} */
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}
		const tmpInputSelectElement = tmpInputSelectElements[0];
		if (!(tmpInputSelectElement instanceof HTMLSelectElement))
		{
			return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		}

		let tmpValueSelected = false;

		for (let i = 0; i < tmpInputSelectElement.options.length; i++)
		{
			if (tmpInputSelectElement.options[i].value === pValue)
			{
				tmpInputSelectElement.selectedIndex = i;
				tmpValueSelected = true;
				break;
			}
		}

		if (!tmpValueSelected)
		{
			tmpInputSelectElement.selectedIndex = -1;
			//this.log.error(`The value [${pValue}] was not found in the select options for input [${pInput.Macro.RawHTMLID}] but was set in the hidden HTML input.`);
		}

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handles the data request event for a select input in the PictProviderInputSelect class.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector object.
	 * @returns {any} - The result of the onDataRequest method.
	 */
	onDataRequest(pView, pInput, pValue, pHTMLSelector)
	{
		let tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getSelectInputHTMLID(pInput.Macro.RawHTMLID));
		this.pict.ContentAssignment.assignContent(pHTMLSelector, tmpInputSelectValue);
		pView.dataChanged(pInput.Hash);
		return super.onDataRequest(pView, pInput, tmpInputSelectValue, pHTMLSelector);
	}

	/**
	 * Handles the data request event for a tabular input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value object.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @returns {any} - The result of the data request.
	 */
	onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		let tmpInputSelectValue = this.pict.ContentAssignment.readContent(this.getTabularSelectDropdownID(pInput.Macro.RawHTMLID, pRowIndex));
		this.pict.ContentAssignment.assignContent(this.getTabularSelectInputID(pInput.Macro.RawHTMLID, pRowIndex), tmpInputSelectValue);
		pView.dataChangedTabular(pInput.PictForm.GroupIndex, pInput.PictForm.InputIndex, pRowIndex);
		return super.onDataRequestTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],92:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		/** @type {string} */
		this.cssHideClass = 'pict-tab-group-hidden';
		this.cssSelectedTabClass = 'pict-tab-group-selectedtab';
		this.cssSnippet = '.pict-tab-group-hidden { display: none; } .pict-tab-group-selectedtab { font-weight: bold; }';

		this.setCSSSnippets();
	}

	/**
	 * @param {string} [pCSSHideClass]
	 * @param {string} [pCSSSnippet]
	 */
	setCSSSnippets(pCSSHideClass, pCSSSnippet)
	{
		this.cssHideClass = pCSSHideClass || this.cssHideClass;
		this.cssSnippet = pCSSSnippet || this.cssSnippet;

		this.pict.CSSMap.addCSS('Pict-Section-Form-Input-Group-TabSelector', this.cssSnippet, 1001, 'Pict-Input-TabSelector');
		this.pict.CSSMap.injectCSS();
	}

	/**
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pGroupHash - The group hash.
	 *
	 * @return {string}
	 */
	getTabSelector(pView, pInput, pGroupHash)
	{
		return `#TAB-${pGroupHash}-${pInput.Macro.RawHTMLID}`;
	}


	/**
	 * @param {Object} pView - The view object.
	 * @param {string} pGroupHash - The group hash.
	 *
	 * @return {string}
	 */
	getGroupSelector(pView, pGroupHash)
	{
		return `#GROUP-${pView.formID}-${pGroupHash}`;
	}

	/**
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabHash
	 *
	 * @return {boolean}
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabHash)
	{
		// First get the view
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabHash}] but the view did not exist!`)
			return false;
		}
		// Then the input
		let tmpInput = tmpView.getInputFromHash(pInputHash)
		if (!tmpInput)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabHash}] but the input did not exist!`)
			return false;
		}
		// Now enumerate the tabs and hide the others, then show this one.
		// TODO: This could be made more elegant by testing which ones are shown and swapping them faster.
		if (!(tmpInput?.PictForm?.TabGroupSet) || !Array.isArray(tmpInput.PictForm.TabGroupSet))
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabHash}] but the input did not have a valid TabGroupSet array in the PictForm object!`)
			return false;
		}

		for (let i = 0; i < tmpInput.PictForm.TabGroupSet.length; i++)
		{
			let tmpTabGroupHash = tmpInput.PictForm.TabGroupSet[i];
			if (tmpTabGroupHash != pTabHash)
			{
				// Hide this tab group if it isn't the "expected to be visible" group
				this.pict.ContentAssignment.addClass(this.getGroupSelector(tmpView, tmpTabGroupHash), this.cssHideClass);
				this.pict.ContentAssignment.removeClass(this.getTabSelector(tmpView, tmpInput, tmpTabGroupHash), this.cssSelectedTabClass);
			}
			else
			{
				// Show this tab group if it is the "expected to be visible" group
				this.pict.ContentAssignment.removeClass(this.getGroupSelector(tmpView, tmpTabGroupHash), this.cssHideClass);
				this.pict.ContentAssignment.addClass(this.getTabSelector(tmpView, tmpInput, tmpTabGroupHash), this.cssSelectedTabClass);
			}
		}
		tmpView.setDataByInput(tmpInput, pTabHash);
		return true;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the select input element.
	 */
	getTabSelectorInputHTMLID(pInputHTMLID)
	{
		return `#TAB-SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		let tmpTabSet = pInput.PictForm?.TabGroupSet;

		if (!tmpTabSet || !Array.isArray(tmpTabSet) || tmpTabSet.length < 1)
		{
			this.pict.log.error(`TabSelector input provider tried to initialize Tab Group Set for HTML ID [${pInput.Macro.RawHTMLID}] but there were no valid entries in the tmpInput.PictForm.TabGroupSet array!`)
			return false;
		}

		let tmpEntryMetatemplateHash = this.pict.providers.DynamicInput.getInputTemplateHash(pView, { PictForm: { InputType: 'TabGroupSelector-TabElement', DataType: 'String' } });

		let tmpTabGroupSetEntries = '';
		// If there are tab group names, use them, otherwise use the hash
		let tempTabSetNames = pInput.PictForm?.TabGroupNames || [];

		for (let i = 0; i < tmpTabSet.length; i++)
		{
			tmpTabGroupSetEntries += this.pict.parseTemplateByHash(tmpEntryMetatemplateHash, pInput, null, [pView, {TabGroupHash: tmpTabSet[i], TabGroupName: (tempTabSetNames[i] || tmpTabSet[i])}]);
		}

		// TODO: Fix typescript types so this function has an optional rather than required fourth parameter.
		this.pict.ContentAssignment.projectContent('replace', this.getTabSelectorInputHTMLID(pInput.Macro.RawHTMLID), tmpTabGroupSetEntries, 'FixTheTypescriptTypes');

		// Now set the default tab (or first one)
		const tmpDefaultTabGroupHash = (pInput.PictForm?.DefaultFromData !== false && pValue) || pInput.PictForm?.DefaultTabGroupHash || tmpTabSet[0];

		this.selectTabByViewHash(pView.Hash, pInput.Hash, tmpDefaultTabGroupHash);

		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],93:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		/** @type {string} */
		this.cssHideClass = 'pict-tab-section-hidden';
		this.cssSelectedTabClass = 'pict-tab-section-selectedtab';
		this.cssSnippet = '.pict-tab-section-hidden { display: none; } .pict-tab-section-selectedtab { font-weight: bold; }';

		this.setCSSSnippets();
	}

	/**
	 * @param {string} [pCSSHideClass]
	 * @param {string} [pCSSSnippet]
	 */
	setCSSSnippets(pCSSHideClass, pCSSSnippet)
	{
		this.cssHideClass = pCSSHideClass || this.cssHideClass;
		this.cssSnippet = pCSSSnippet || this.cssSnippet;
		this.pict.CSSMap.addCSS('Pict-Section-Form-Input-Section-TabSelector', this.cssSnippet, 1001, 'Pict-Input-TabSelector');
	}

	/**
	 * @param {string} pManifestSectionHash
	 *
	 * @return {string}
	 */
	getViewHash(pManifestSectionHash)
	{
		return `PictSectionForm-${pManifestSectionHash}`;
	}

	/**
	 * @param {string} pTabSectionHash
	 * @param {Object} pInput
	 *
	 * @return {string}
	 */
	getTabSelector(pTabSectionHash, pInput)
	{
		return `#TAB-${pTabSectionHash}-${pInput.Macro.RawHTMLID}`;
	}

	/**
	 * @param {string} pTabViewSectionHash
	 *
	 * @return {string}
	 */
	getSectionSelector(pTabViewSectionHash)
	{
		const metaController = this.pict.views.PictFormMetacontroller;
		return `#Pict-${metaController ? metaController.UUID : this.UUID}-${pTabViewSectionHash}-Wrap`;
	}

	/**
	 * @param {string} pViewHash
	 * @param {string} pInputHash
	 * @param {string} pTabViewHash
	 *
	 * @return {boolean}
	 */
	selectTabByViewHash(pViewHash, pInputHash, pTabViewHash)
	{
		// First get the view
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the view did not exist!`)
			return false;
		}
		// Then the input
		let tmpInput = tmpView.getInputFromHash(pInputHash)
		if (!tmpInput)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the input did not exist!`)
			return false;
		}
		// Now enumerate the tabs and hide the others, then show this one.
		// TODO: This could be made more elegant by testing which ones are shown and swapping them faster.
		if (!(tmpInput?.PictForm?.TabSectionSet) || !Array.isArray(tmpInput.PictForm.TabSectionSet))
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the input did not have a valid TabSectionSet array in the PictForm object!`)
			return false;
		}
		let tmpTabView = this.pict.views[this.getViewHash(pTabViewHash)];
		if (!tmpTabView)
		{
			this.pict.log.error(`TabSelector input provider tried to switch to view [${pViewHash}] input [${pInputHash}] tab [${pTabViewHash}] but the tab view did not exist!`)
			return false;
		}

		for (let i = 0; i < tmpInput.PictForm.TabSectionSet.length; i++)
		{
			let tmpTabSectionHash = tmpInput.PictForm.TabSectionSet[i];
			if (tmpTabSectionHash != pTabViewHash)
			{
				// Hide this tab group if it isn't the "expected to be visible" group
				this.pict.ContentAssignment.addClass(this.getSectionSelector(tmpTabSectionHash), this.cssHideClass);
				this.pict.ContentAssignment.removeClass(this.getTabSelector(tmpTabSectionHash, tmpInput), this.cssSelectedTabClass);
			}
			else
			{
				// Show this tab group if it is the "expected to be visible" group
				this.pict.ContentAssignment.removeClass(this.getSectionSelector(tmpTabSectionHash), this.cssHideClass);
				this.pict.ContentAssignment.addClass(this.getTabSelector(tmpTabSectionHash, tmpInput), this.cssSelectedTabClass);
			}
		}
		tmpView.setDataByInput(tmpInput, pTabViewHash);
		return true;
	}

	/**
	 * Generates the HTML ID for a select input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 *
	 * @return {string} - The generated HTML ID for the select input element.
	 */
	getTabSelectorInputHTMLID(pInputHTMLID)
	{
		return `#TAB-SELECT-FOR-${pInputHTMLID}`;
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLTabSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID)
	{
		let tmpTabSet = pInput.PictForm?.TabSectionSet;

		if (!tmpTabSet || !Array.isArray(tmpTabSet) || tmpTabSet.length < 1)
		{
			this.pict.log.error(`TabSelector input provider tried to initialize Tab Group Set for HTML ID [${pInput.Macro.RawHTMLID}] but there were no valid entries in the tmpInput.PictForm.TabSectionSet array!`)
			return false;
		}

		let tmpEntryMetatemplateHash = this.pict.providers.DynamicInput.getInputTemplateHash(pView, { PictForm: { InputType: 'TabSectionSelector-TabElement', DataType: 'String' } });

		let tmpTabSectionSetEntries = '';
		// If there are tab group names, use them, otherwise use the hash
		let tempTabSetNames = pInput.PictForm?.TabSectionNames || [];

		for (let i = 0; i < tmpTabSet.length; i++)
		{
			tmpTabSectionSetEntries += this.pict.parseTemplateByHash(tmpEntryMetatemplateHash, pInput, null, [pView, {TabSectionHash: tmpTabSet[i], TabSectionName: (tempTabSetNames[i] || tmpTabSet[i])}]);
		}

		// TODO: Fix typescript types so this function has an optional rather than required fourth parameter.
		this.pict.ContentAssignment.projectContent('replace', this.getTabSelectorInputHTMLID(pInput.Macro.RawHTMLID), tmpTabSectionSetEntries, 'FixTheTypescriptTypes');

		// Now set the default tab (or first one)
		const tmpDefaultTabSectionHash = (pInput.PictForm?.DefaultFromData !== false && pValue) || pInput.PictForm?.DefaultTabSectionHash || tmpTabSet[0];
		this.selectTabByViewHash(pView.Hash, pInput.Hash, tmpDefaultTabSectionHash);

		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLTabSelector, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76}],94:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * TabularTriggerGroup input provider.
 *
 * This provider enables per-row trigger group behavior in tabular layouts.
 * Unlike the global AutofillTriggerGroup (which fills ALL rows with the same
 * data), this provider fetches entity data scoped to a specific row and only
 * updates inputs within that same row.
 *
 * It combines the entity-fetching capability of EntityBundleRequest with
 * the autofill behavior of AutofillTriggerGroup, but scoped to individual
 * tabular rows.
 *
 * Triggering input configuration:
 *
 *   Providers: ["Pict-Input-TabularTriggerGroup"],
 *   TabularTriggerGroup:
 *     {
 *       TriggerGroupHash: "AuthorRowTrigger",
 *       TriggerAllInputs: true,
 *       EntitiesBundle: [
 *         {
 *           "Entity": "Author",
 *           "Filter": "FBV~IDAuthor~EQ~{~D:Record.Value~}",
 *           "Destination": "CurrentAuthor",
 *           "SingleRecord": true
 *         }
 *       ]
 *     }
 *
 * Receiving input configuration:
 *
 *   Providers: ["Pict-Input-TabularTriggerGroup"],
 *   TabularTriggerGroup:
 *     {
 *       TriggerGroupHash: "AuthorRowTrigger",
 *       TriggerAddress: "CurrentAuthor.Name",
 *       MarshalEmptyValues: true
 *     }
 *
 * The provider stores fetched entity data in a per-row cache at:
 *   AppData._TabularTriggerCache.{TriggerGroupHash}[{RowIndex}]
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class TabularTriggerGroupInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;
	}

	/**
	 * Get the trigger group configuration, normalizing to an array.
	 *
	 * @param {Object} pInput - The input descriptor.
	 * @returns {Array<Record<string, any>>}
	 */
	getTriggerGroupConfigurationArray(pInput)
	{
		let tmpConfigs = pInput.PictForm.TabularTriggerGroup;
		if (!tmpConfigs)
		{
			return [];
		}
		if (!Array.isArray(tmpConfigs))
		{
			tmpConfigs = [tmpConfigs];
		}
		return tmpConfigs;
	}

	/**
	 * Ensure the per-row cache structure exists.
	 *
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 * @param {number} pRowIndex - The row index.
	 * @returns {Object} The cache object for this row.
	 */
	ensureRowCache(pTriggerGroupHash, pRowIndex)
	{
		if (!this.pict.AppData._TabularTriggerCache)
		{
			this.pict.AppData._TabularTriggerCache = {};
		}
		if (!this.pict.AppData._TabularTriggerCache[pTriggerGroupHash])
		{
			this.pict.AppData._TabularTriggerCache[pTriggerGroupHash] = {};
		}
		if (!this.pict.AppData._TabularTriggerCache[pTriggerGroupHash][pRowIndex])
		{
			this.pict.AppData._TabularTriggerCache[pTriggerGroupHash][pRowIndex] = {};
		}
		return this.pict.AppData._TabularTriggerCache[pTriggerGroupHash][pRowIndex];
	}

	/**
	 * Gather a single entity set from the server.
	 *
	 * @param {Function} fCallback - Callback when done.
	 * @param {Object} pEntityInfo - The entity bundle entry.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value of the triggering input.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 */
	gatherEntitySet(fCallback, pEntityInfo, pView, pInput, pValue, pRowIndex, pTriggerGroupHash)
	{
		if (!pEntityInfo.Entity || typeof(pEntityInfo.Entity) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse entity request: missing Entity string.`);
			return fCallback();
		}
		if (!pEntityInfo.Filter || typeof(pEntityInfo.Filter) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse entity request: missing Filter string.`);
			return fCallback();
		}
		if (!pEntityInfo.Destination || typeof(pEntityInfo.Destination) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse entity request: missing Destination string.`);
			return fCallback();
		}

		let tmpFilterTemplateRecord = { Value: pValue, Input: pInput, View: pView };
		let tmpFilterString = this.pict.parseTemplate(pEntityInfo.Filter, tmpFilterTemplateRecord);

		if (tmpFilterString === '')
		{
			this.log.warn(`TabularTriggerGroup: entity Filter did not return a string for FilterBy`);
		}

		let tmpRecordStartCursor = null;
		let tmpRecordCount = null;
		if (pEntityInfo.RecordCount)
		{
			tmpRecordStartCursor = pEntityInfo.RecordStartCursor != null ? pEntityInfo.RecordStartCursor : 0;
			tmpRecordCount = pEntityInfo.RecordCount != null ? pEntityInfo.RecordCount : null;
		}

		let tmpCallback = (pError, pRecordSet) =>
		{
			if (pError)
			{
				this.log.error(`TabularTriggerGroup error getting entity set for [${pEntityInfo.Entity}] row ${pRowIndex}: ${pError}`, pError);
				return fCallback(pError);
			}

			this.log.trace(`TabularTriggerGroup found ${pRecordSet.length} records for ${pEntityInfo.Entity} row ${pRowIndex}`);

			let tmpRowCache = this.ensureRowCache(pTriggerGroupHash, pRowIndex);

			if (pEntityInfo.SingleRecord)
			{
				if (pRecordSet.length < 1)
				{
					this.pict.manifest.setValueByHash(tmpRowCache, pEntityInfo.Destination, false);
				}
				else
				{
					this.pict.manifest.setValueByHash(tmpRowCache, pEntityInfo.Destination, pRecordSet[0]);
				}
			}
			else
			{
				this.pict.manifest.setValueByHash(tmpRowCache, pEntityInfo.Destination, pRecordSet);
			}

			return fCallback();
		};

		if (tmpRecordCount)
		{
			this.pict.EntityProvider.getEntitySetPage(pEntityInfo.Entity, tmpFilterString, tmpRecordStartCursor, tmpRecordCount, tmpCallback);
		}
		else
		{
			this.pict.EntityProvider.getEntitySet(pEntityInfo.Entity, tmpFilterString, tmpCallback);
		}
	}

	/**
	 * Gather a custom data set from the server.
	 *
	 * @param {Function} fCallback - Callback when done.
	 * @param {Object} pRequestInfo - The custom request info.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTriggerGroupHash - The trigger group hash.
	 */
	gatherCustomDataSet(fCallback, pRequestInfo, pView, pInput, pValue, pRowIndex, pTriggerGroupHash)
	{
		if (!pRequestInfo.URL || typeof(pRequestInfo.URL) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to parse custom request: missing URL string.`);
			return fCallback();
		}

		let tmpURLTemplateRecord = { Value: pValue, Input: pInput, View: pView };
		let tmpURLTemplateString = this.pict.parseTemplate(pRequestInfo.URL, tmpURLTemplateRecord);

		let tmpURLPrefix = '';
		let tmpCustomURIHost = pRequestInfo.Host ? pRequestInfo.Host : false;
		let tmpCustomURIProtocol = pRequestInfo.Protocol ? pRequestInfo.Protocol : 'https';
		let tmpCustomURIPort = pRequestInfo.Port ? pRequestInfo.Port : false;

		if (tmpCustomURIHost)
		{
			tmpURLPrefix = `${tmpCustomURIProtocol}://${tmpCustomURIHost}`;
			if (tmpCustomURIPort)
			{
				tmpURLPrefix += `:${tmpCustomURIPort}`;
			}
		}
		else
		{
			tmpURLPrefix = this.pict.EntityProvider.options.urlPrefix;
		}

		let tmpCallback = (pError, pResponse, pData) =>
		{
			if (pError)
			{
				this.log.error(`TabularTriggerGroup error getting custom data for row ${pRowIndex}: ${pError}`, pError);
				return fCallback(pError);
			}

			if (pRequestInfo.Destination)
			{
				let tmpRowCache = this.ensureRowCache(pTriggerGroupHash, pRowIndex);
				this.pict.manifest.setValueByHash(tmpRowCache, pRequestInfo.Destination, pData);
			}

			return fCallback();
		};

		let tmpOptions = { url: `${tmpURLPrefix}${tmpURLTemplateString}` };
		tmpOptions = this.pict.EntityProvider.prepareRequestOptions(tmpOptions);
		return this.pict.EntityProvider.restClient.getJSON(tmpOptions, tmpCallback);
	}

	/**
	 * Fetch entity data for a specific tabular row.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The current value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {Object} pGroupConfig - The trigger group configuration.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @returns {Promise}
	 */
	async gatherDataForRow(pView, pInput, pValue, pHTMLSelector, pRowIndex, pGroupConfig, pTransactionGUID)
	{
		if (!Array.isArray(pGroupConfig.EntitiesBundle) || pGroupConfig.EntitiesBundle.length < 1)
		{
			this.log.warn(`TabularTriggerGroup: no EntitiesBundle array found for triggering input [${pInput.Hash}] row ${pRowIndex}`);
			return null;
		}

		let tmpTriggerGroupHash = pGroupConfig.TriggerGroupHash;
		let tmpLoadGUID = `TabularBundleLoad-${this.pict.getUUID()}`;

		if (pTransactionGUID)
		{
			pView.registerEventTransactionAsyncOperation(pTransactionGUID, tmpLoadGUID);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		for (let i = 0; i < pGroupConfig.EntitiesBundle.length; i++)
		{
			let tmpEntityBundleEntry = pGroupConfig.EntitiesBundle[i];
			tmpAnticipate.anticipate(
				(fNext) =>
				{
					try
					{
						switch (tmpEntityBundleEntry.Type)
						{
							case 'Custom':
								return this.gatherCustomDataSet(fNext, tmpEntityBundleEntry, pView, pInput, pValue, pRowIndex, tmpTriggerGroupHash);
							case 'MeadowEntity':
							default:
								return this.gatherEntitySet(fNext, tmpEntityBundleEntry, pView, pInput, pValue, pRowIndex, tmpTriggerGroupHash);
						}
					}
					catch (pError)
					{
						this.log.error(`TabularTriggerGroup error gathering entity set for row ${pRowIndex}: ${pError}`, pError);
					}
					return fNext();
				});
		}

		// Ensure we wait at least one tick for event ordering
		tmpAnticipate.anticipate((fNext) => setTimeout(fNext, 0));

		// After all data is gathered, fire the row-scoped trigger event
		tmpAnticipate.anticipate(
			(fNext) =>
			{
				if (this.pict.views.PictFormMetacontroller)
				{
					// Fire row-scoped event: TabularTriggerGroup:{GroupHash}:DataChange:{InputHash}:{RowIndex}:{UUID}
					this.pict.views.PictFormMetacontroller.triggerGlobalInputEvent(
						`TabularTriggerGroup:${tmpTriggerGroupHash}:DataChange:${pInput.Hash || pInput.DataAddress}:${pRowIndex}:${this.pict.getUUID()}`,
						pTransactionGUID);
				}

				if (pGroupConfig.PostSolvers && Array.isArray(pGroupConfig.PostSolvers))
				{
					this.pict.providers.DynamicSolver.executeSolvers(pView, pGroupConfig.PostSolvers, `TabularTriggerGroup hash ${tmpTriggerGroupHash} row ${pRowIndex} post-trigger`);
				}

				fNext();
			});

		return new Promise((pResolve, pReject) =>
		{
			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`TabularTriggerGroup error gathering data for row ${pRowIndex}: ${pError}`, pError);
					}
					if (pTransactionGUID)
					{
						pView.eventTransactionAsyncOperationComplete(pTransactionGUID, tmpLoadGUID);
					}
					return pResolve(pError);
				});
		});
	}

	/**
	 * Autofill a tabular input from the row cache.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {Object} pTriggerGroupInfo - The trigger group configuration.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @returns {boolean}
	 */
	autoFillFromRowCache(pView, pInput, pTriggerGroupInfo, pHTMLSelector, pRowIndex)
	{
		if (!pTriggerGroupInfo.TriggerGroupHash || typeof(pTriggerGroupInfo.TriggerGroupHash) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to autofill: missing TriggerGroupHash string.`);
			return false;
		}
		if (!pTriggerGroupInfo.TriggerAddress || typeof(pTriggerGroupInfo.TriggerAddress) !== 'string')
		{
			this.log.warn(`TabularTriggerGroup failed to autofill: missing TriggerAddress string.`);
			return false;
		}

		let tmpRowCache = this.ensureRowCache(pTriggerGroupInfo.TriggerGroupHash, pRowIndex);
		let tmpValue = this.pict.manifest.getValueByHash(tmpRowCache, pTriggerGroupInfo.TriggerAddress);

		if ((!tmpValue) && !pTriggerGroupInfo.MarshalEmptyValues)
		{
			return false;
		}

		pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpValue);
		pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
		return true;
	}

	/**
	 * Handle data changes in tabular inputs.
	 * If this is a triggering input, fetch data and fire row-scoped event.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The new value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @returns {any}
	 */
	onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		let tmpConfigs = this.getTriggerGroupConfigurationArray(pInput);

		for (let i = 0; i < tmpConfigs.length; i++)
		{
			let tmpConfig = tmpConfigs[i];
			if (tmpConfig.TriggerAllInputs)
			{
				if (tmpConfig.PreSolvers && Array.isArray(tmpConfig.PreSolvers))
				{
					this.pict.providers.DynamicSolver.executeSolvers(pView, tmpConfig.PreSolvers, `TabularTriggerGroup hash ${tmpConfig.TriggerGroupHash} row ${pRowIndex} pre-trigger`);
				}

				this.gatherDataForRow(pView, pInput, pValue, pHTMLSelector, pRowIndex, tmpConfig, pTransactionGUID);
			}
		}

		return super.onDataChangeTabular(pView, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Handle events after completion for tabular inputs.
	 * If this is a receiving input, autofill from the row cache only if the
	 * event's row index matches.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input descriptor.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of this input.
	 * @param {string} pEvent - The event string.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @returns {boolean}
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		let tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let tmpParts = tmpPayload.split(':');
		// Expected format: TabularTriggerGroup:{GroupHash}:DataChange:{InputHash}:{RowIndex}:{UUID}
		let tmpType = tmpParts[0];
		let tmpGroupHash = tmpParts[1];
		let tmpEventType = tmpParts[2];
		let tmpInputHash = tmpParts[3];
		let tmpEventRowIndex = parseInt(tmpParts[4], 10);

		if (tmpType !== 'TabularTriggerGroup')
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		// Skip if this is the triggering input itself
		if ((pInput.Hash || pInput.DataAddress) === tmpInputHash)
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		// Only process if the row index matches
		if (pRowIndex !== tmpEventRowIndex)
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		let tmpConfigs = this.getTriggerGroupConfigurationArray(pInput);

		for (let i = 0; i < tmpConfigs.length; i++)
		{
			let tmpConfig = tmpConfigs[i];
			if (tmpConfig.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			if (tmpConfig.TriggerAddress)
			{
				this.autoFillFromRowCache(pView, pInput, tmpConfig, pHTMLSelector, pRowIndex);
			}

			if (tmpConfig.SelectOptionsRefresh)
			{
				let tmpInputView = this.pict.views[pInput.PictForm.ViewHash];
				if (tmpInputView && pInput.PictForm.SelectOptionsPickList)
				{
					this.pict.providers.DynamicMetaLists.rebuildListByHash(pInput.PictForm.SelectOptionsPickList);
					this.pict.providers['Pict-Input-Select'].refreshSelectListTabular(tmpInputView, tmpInputView.getGroup(pInput.PictForm.GroupIndex), tmpInputView.getRow(pInput.PictForm.GroupIndex, pInput.PictForm.Row), pInput, pValue, pHTMLSelector, pRowIndex);
					tmpInputView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex);
				}
			}
		}

		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * Non-tabular data change handler.
	 * TabularTriggerGroup is designed for tabular use, but we support non-tabular
	 * as a pass-through for flexibility.
	 */
	onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		return super.onDataChange(pView, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Non-tabular event handler.
	 * TabularTriggerGroup events are scoped to tabular, so non-tabular events
	 * are ignored.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}
}

module.exports = TabularTriggerGroupInputHandler;

module.exports.default_configuration = (
{
	"ProviderIdentifier": "Pict-Input-TabularTriggerGroup",
	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,
	"AutoSolveWithApp": false
});

},{"../Pict-Provider-InputExtension.js":76}],95:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

/**
 * Input provider for simple templated content display.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class TemplatedInputProvider extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#DISPLAY-FOR-TABULAR-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {number} [pRowIndex] - (optional) The row index for tabular data.
	 *
	 * @return {void}
	 */
	handleContentUpdate(pView, pInput, pValue, pRowIndex)
	{
		let tmpContent = '';
		if (pValue && (typeof(pValue) === 'string'))
		{
			tmpContent = pValue;
		}
		let tmpIsLocked = false;
		//TODO: support more templates
		//TODO: support "locked" content?
		if (!tmpIsLocked && pInput.PictForm && pInput.PictForm.Template && (typeof(pInput.PictForm.Template) === 'string'))
		{
			tmpContent = this.pict.parseTemplate(pInput.PictForm.Template, Object.assign({}, this.pict, { Data: pView.getMarshalDestinationObject() }), null, [this], this);
		}
		if (!tmpContent && !tmpIsLocked && pInput.Default && (typeof(pInput.Default) === 'string'))
		{
			tmpContent = pInput.Default;
		}

		if (pRowIndex != null)
		{
			pView.setDataTabularByHash(pInput.PictForm.GroupIndex, pInput.Hash, pRowIndex, tmpContent);
		}
		else
		{
			pView.setDataByInput(pInput, tmpContent);
		}
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this._handleInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, null, pTransactionGUID);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this._handleInitialize(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object|null} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number|null} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	_handleInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		if (pInput.PictForm && pInput.PictForm.Templates && typeof pInput.PictForm.Templates === 'object' && !Array.isArray(pInput.PictForm.Templates))
		{
			for (const [ tmpTemplateHash, tmpTemplate ] of Object.entries(pInput.PictForm.Templates))
			{
				if (this.pict.TemplateProvider.templates[tmpTemplateHash])
				{
					this.pict.log.error(`[Pict-Input-Templated] Attempt to override template with hash: ${tmpTemplateHash}; skipping.`);
					continue;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplateHash, tmpTemplate, `Templated Input hash: ${pInput.Hash}`);
			}
		}
		this.handleContentUpdate(pView, pInput, pValue);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), pValue);
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.pict.ContentAssignment.assignContent(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), pValue);
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash ] = tmpPayload.split(':');

		if (tmpType !== 'TriggerGroup')
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}

		const tmpTriggerGroupHashes = Array.isArray(pInput.PictForm?.TriggerGroupHash) ? pInput.PictForm.TriggerGroupHash : [pInput.PictForm?.TriggerGroupHash];
		if (!pInput.PictForm || !pInput.PictForm.TriggerGroupHash || !tmpTriggerGroupHashes.includes(tmpGroupHash))
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		this.handleContentUpdate(pView, pInput, pValue);
		pView.manualMarshalDataToViewByInput(pInput, pTransactionGUID);
		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {import('../../views/Pict-View-DynamicForm.js')} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash ] = tmpPayload.split(':');

		if (tmpType !== 'TriggerGroup')
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}

		const tmpTriggerGroupHashes = Array.isArray(pInput.PictForm?.TriggerGroupHash) ? pInput.PictForm.TriggerGroupHash : [pInput.PictForm?.TriggerGroupHash];
		if (!pInput.PictForm || !pInput.PictForm.TriggerGroupHash || !tmpTriggerGroupHashes.includes(tmpGroupHash))
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		this.handleContentUpdate(pView, pInput, pValue, pRowIndex);
		pView.manualMarshalTabularDataToViewByInput(pInput, pRowIndex, pTransactionGUID);
		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = TemplatedInputProvider;

},{"../Pict-Provider-InputExtension.js":76}],96:[function(require,module,exports){
const libPictSectionInputExtension = require('../Pict-Provider-InputExtension.js');

const libMarked = require('marked');

/**
 * CustomInputHandler class.
 *
 * @class
 * @extends libPictSectionInputExtension
 * @memberof providers.inputs
 */
class CustomInputHandler extends libPictSectionInputExtension
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generates the HTML ID for a content display input element.
	 *
	 * @param {string} pInputHTMLID - The HTML ID of the input element.
	 * @returns {string} - The generated HTML ID for the content display input element.
	 */
	getContentDisplayHTMLID(pInputHTMLID)
	{
		return `#DISPLAY-FOR-${pInputHTMLID}`;
	}

	/**
	 * Generates a tabular content display input ID based on the provided input HTML ID and row index.
	 *
	 * @param {string} pInputHTMLID - The input HTML ID.
	 * @param {number} pRowIndex - The row index.
	 * @returns {string} - The generated tabular content display input ID.
	 */
	getTabularContentDisplayInputID(pInputHTMLID, pRowIndex)
	{
		return `#${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * 
	 * @param {String} pDisplayID 
	 * @param {Object} pInput - The PictForm Input Object
	 * @param {any} pValue 
	 */
	assignDisplayEntityData(pDisplayID, pInput, pValue)
	{
		// 0. Manage state
		let tmpDisplayTemplate = (typeof(pInput.PictForm.TemplatedEntityLookup.Template) === "string") ? pInput.PictForm.TemplatedEntityLookup.Template : "";
		let tmpDisplayContent = '';

		if (typeof(pInput) != "object")
		{
			this.log.error("Error in assignDisplayEntityData: pInput is not an object");
			return;
		}
		if (!(`PictForm` in pInput))
		{
			this.log.error("Error in assignDisplayEntityData: pInput.PictForm is not an object");
			return;
		}
		if (!(`TemplatedEntityLookup` in pInput.PictForm))
		{
			this.log.error("Error in assignDisplayEntityData: pInput.PictForm.TemplatedEntityLookup is not in the PictForm object");
			return;
		}
		if (!Array.isArray(pInput.PictForm.TemplatedEntityLookup.EntitiesBundle))
		{
			this.log.error("Error in assignDisplayEntityData: pInput.PictForm.TemplatedEntityLookup.EntitiesBundle is not an array");
			return;
		}

		const tmpAnticipate = this.fable.newAnticipate();

		// 1. Get the entities
		tmpAnticipate.anticipate(
			function (fNext)
			{
				this.pict.EntityProvider.gatherDataFromServer(pInput.PictForm.TemplatedEntityLookup.EntitiesBundle, (pError) =>
				{
					// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
					setTimeout(() => fNext(pError), 0);
				});
			}.bind(this));

		// 2. Check the Empty Value Test List

		// 3. Render the Template
		tmpAnticipate.anticipate(
			function (fNext)
			{
				this.pict.parseTemplate(tmpDisplayTemplate, {Value: pValue},
					function (pError, pResult)
					{
						if (pError)
						{
							this.log.error("Error rendering template in assignDisplayEntityData", pError);
							return;
						}
						tmpDisplayContent = pResult;
						return fNext();
					}.bind(this));
			}.bind(this));

		// 4. Assign the Content to the display element
		tmpAnticipate.wait(
			function (pError)
			{
				if (pError)
				{
					this.log.error("Error in assignDisplayEntityData", pError);
					return;
				}
				this.pict.ContentAssignment.assignContent(pDisplayID, tmpDisplayContent);
			}.bind(this));
	}

	/**
	 * Initializes the input element for the Pict provider select input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {boolean} - Returns true if the input element is successfully initialized, false otherwise.
	 */
	onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		this.assignDisplayEntityData(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), pInput, pValue);
		return super.onInputInitialize(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Initializes a tabular input element.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The input value.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pTransactionGUID - The transaction GUID for the event dispatch.
	 * @returns {any} - The result of the initialization.
	 */
	onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		this.assignDisplayEntityData(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput, pValue);
		return super.onInputInitializeTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * This input extension only responds to events
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		if (!pInput.PictForm.TemplatedEntityLookup || !('TriggerGroupHash' in pInput.PictForm.TemplatedEntityLookup))
		{
			return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
		}
		let tmpAutoFillTriggerGroups = [pInput.PictForm.TemplatedEntityLookup];

		for (let i = 0; i < tmpAutoFillTriggerGroups.length; i++)
		{
			let tmpAutoFillTriggerGroup = tmpAutoFillTriggerGroups[i];
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			this.assignDisplayEntityData(this.getContentDisplayHTMLID(pInput.Macro.RawHTMLID), pInput, pValue);
		}

		return super.onAfterEventCompletion(pView, pInput, pValue, pHTMLSelector, pEvent, pTransactionGUID);
	}

	/**
	 * Handles events for the Pict-Provider-InputExtension.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value from AppData.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index of the tabular data.
	 * @param {string} pEvent - The event hash that is expected to be triggered.
	 * @param {string} pTransactionGUID - The transaction GUID, if any.
	 * @returns {boolean} - Returns true.
	 */
	onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID)
	{
		const tmpPayload = typeof pEvent === 'string' ? pEvent : '';
		let [ tmpType, tmpGroupHash, tmpEvent, tmpInputHash, tmpEventGUID ] = tmpPayload.split(':');
		if (!tmpEventGUID)
		{
			tmpEventGUID = this.pict.getUUID();
		}

		if (!pInput.PictForm.TemplatedEntityLookup || !('TriggerGroupHash' in pInput.PictForm.TemplatedEntityLookup))
		{
			return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
		}
		let tmpAutoFillTriggerGroups = [pInput.PictForm.TemplatedEntityLookup];
		for (const tmpAutoFillTriggerGroup of tmpAutoFillTriggerGroups)
		{
			if (tmpAutoFillTriggerGroup.TriggerGroupHash !== tmpGroupHash)
			{
				continue;
			}

			this.assignDisplayEntityData(this.getTabularContentDisplayInputID(pInput.Macro.RawHTMLID, pRowIndex), pInput, pValue);
		}

		return super.onAfterEventTabularCompletion(pView, pInput, pValue, pHTMLSelector, pRowIndex, pEvent, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;

},{"../Pict-Provider-InputExtension.js":76,"marked":4}],97:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class ChartLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a Configuration-based Chart.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		// Chart Parameters!!!
		tmpTemplate += 'No really... this is a chart.';
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}
}

module.exports = ChartLayout;

},{"../Pict-Provider-DynamicLayout.js":69}],98:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class RecordLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// loop over descriptors that have my group set?
		// set their GroupIndex from pGroup
		for (let j = 0; j < pGroup.Rows.length; j++)
		{
			let tmpRow = pGroup.Rows[j];

			// There are three row layouts: Record, Tabular and Columnar
			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{
				let tmpInput = tmpRow.Inputs[k];
				// Update the InputIndex to match the current render config
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = j;
			}
		}
		const hash = pGroup.CustomLayoutTemplateHash;
		if (hash)
		{
			const template = this.pict.TemplateProvider.getTemplate(hash);
			if (template)
			{
				return template;
			}
			this.log.warn(`Custom layout template not found for hash: ${hash}`);
		}
		return pGroup.CustomLayoutTemplate || '';
	}
}

module.exports = RecordLayout;

},{"../Pict-Provider-DynamicLayout.js":69}],99:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class RecordLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		if (!('Rows' in pGroup))
		{
			pGroup.Rows = [];
		}

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		for (let j = 0; j < pGroup.Rows.length; j++)
		{
			// TODO: Validate that the row exists?  Bootstrap seems to have it here.
			let tmpRow = pGroup.Rows[j]
			tmpRow.WidthTotalRaw = 0;

			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{
				let tmpInput = tmpRow.Inputs[k];
				// Update the InputIndex to match the current render config
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = j;
				let tmpInputWidth = 1;
				try
				{
					tmpInputWidth = Math.abs(parseFloat(tmpInput.PictForm.Width));
				}
				catch (pParseError)
				{
					tmpInputWidth = 1;
				}
				if (!tmpInputWidth || isNaN(tmpInputWidth) || tmpInputWidth <= 0)
				{
					tmpInputWidth = 1;
				}
				tmpInput.PictForm.RawWidth = tmpInputWidth;
				tmpRow.WidthTotalRaw += tmpInputWidth;

				//tmpTemplate += tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("${pGroup.GroupIndex}","${j}","${k}")`);
			}
			// Now that we've gotten all the raw widths for the row, quantize them properly.
			// Default by quantizing to 99 percentage units wide
			let tmpGroupQuantizedWidth = 95;
			if ('WidthQuantization' in pGroup)
			{
				try
				{
					tmpGroupQuantizedWidth = Math.abs(parseInt(pGroup.WidthQuantization));
					if (!tmpGroupQuantizedWidth || isNaN(tmpGroupQuantizedWidth) || tmpGroupQuantizedWidth <= 0)
					{
						tmpGroupQuantizedWidth = 95;
					}
				}
				catch(pParseError)
				{
					// TODO: UGH THIS IS NaN at the moment.......
					tmpGroupQuantizedWidth = 95;
				}
			}
			else if ('WidthQuantization' in this.pict.PictApplication.options)
			{
				tmpGroupQuantizedWidth = this.pict.PictApplication.options.WidthQuantization;
			}
			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{
				let tmpInput = tmpRow.Inputs[k];
				tmpInput.PictForm.QuantizedWidth = Math.round((tmpInput.PictForm.RawWidth / tmpRow.WidthTotalRaw) * tmpGroupQuantizedWidth);
				//this.fable.log.trace(`Quantized input width for Group ${pGroup.GroupIndex} Row ${j} Input ${k} (${tmpInput.Name}) to ${tmpInput.PictForm.QuantizedWidth} (Raw: ${tmpInput.PictForm.RawWidth} / Total Raw: ${tmpRow.WidthTotalRaw} / Group Quantization: ${tmpGroupQuantizedWidth})`);

				tmpTemplate += tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("${pGroup.GroupIndex}","${j}","${k}")`);
			}

			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		}
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}
}

module.exports = RecordLayout;

},{"../Pict-Provider-DynamicLayout.js":69}],100:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class RecordSetLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a complex multi-record repeated form view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such, only, it will render itself once for each element in a set.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// TODO: We cheated and this is still tabular.  Gotta change it up!
		// Tabular are odd in that they have a header row and then a meta TemplateSet for the rows()
		// In this case we are going to load the descriptors from the supportingManifests
		if (!pGroup.supportingManifest)
		{
			this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] error generating tabular metatemplate: missing group manifest ${pGroup.RecordManifest} from supportingManifests.`);
			return '';
		}

		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';
		let tmpTemplateSetRecordRowTemplate = '';
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		let tmpMaxRowIndex = 0;
		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
			// Update the InputIndex to match the current render config
			if (!('PictForm' in tmpInput))
			{
				tmpInput.PictForm = {};
			}
			if (tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			tmpInput.PictForm.InputIndex = k;
			tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
			if (tmpInput.PictForm.Row)
			{
				tmpInput.PictForm.RowIndex = tmpInput.PictForm.Row;
				if (tmpInput.PictForm.RowIndex > tmpMaxRowIndex)
				{
					tmpMaxRowIndex = tmpInput.PictForm.RowIndex;
				}
			}
		}

		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
			// Update the InputIndex to match the current render config
			if (!('PictForm' in tmpInput))
			{
				tmpInput.PictForm = {};
			}
			if (tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			if (!tmpInput.PictForm.RowIndex)
			{
				tmpInput.PictForm.RowIndex = tmpMaxRowIndex + 1;
			}
		}

		for (let d = 0; d < tmpMaxRowIndex + 1; d++)
		{
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
				let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
				// Update the InputIndex to match the current render config
				if (tmpInput.PictForm.TabularHidden)
				{
					continue;
				}

				// tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-HeaderCell`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
				if (tmpInput.PictForm.RowIndex == d)
				{
					tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Cell-Prefix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
					let tmpInputType = (('PictForm' in tmpInput) && tmpInput.PictForm.InputType) ? tmpInput.PictForm.InputType : 'Default';
					tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getTabularInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInputType, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`, pGroup.GroupIndex, k);
					tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Cell-Postfix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
				}
			}
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		}

		// This is the template by which the tabular template includes the rows.
		// The template recursion here is difficult to envision without drawing it.
		// TODO: Consider making this function available in manyfest in some fashion it seems dope.
		let tmpTemplateSetVirtualRowTemplate = '';
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Row-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-RecordSetTemplate-Row-ExtraPrefix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += `\n\n{~T:${pGroup.SectionTabularRowTemplateHash}:Record~}\n`;
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-RecordSetTemplate-Row-ExtraPostfix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		// This is a custom template expression
		tmpTemplate += `\n\n{~MTVS:${pGroup.SectionTabularRowVirtualTemplateHash}:${pGroup.GroupIndex}:${pView.getMarshalDestinationAddress()}.${pGroup.RecordSetAddress}~}\n`;

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-RecordSetTemplate-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		// Add the TemplateSetTemplate
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowVirtualTemplateHash, tmpTemplateSetVirtualRowTemplate);
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowTemplateHash, tmpTemplateSetRecordRowTemplate);

		return tmpTemplate;
	}
}

module.exports = RecordSetLayout;

},{"../Pict-Provider-DynamicLayout.js":69}],101:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class TabularLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		// Register the sort glyphs used by the optional ColumnSorting feature, through
		// pict's built-in icon registry (so they theme + scale like every other glyph).
		if (this.pict && this.pict.providers && this.pict.providers.Icon
			&& typeof this.pict.providers.Icon.registerSet === 'function')
		{
			this.pict.providers.Icon.registerSet(
				{
					Outline:
					{
						Sort: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 20V5"/><path d="M5.5 8.5L9 5L12.5 8.5"/><path d="M15 4V19"/><path d="M11.5 15.5L15 19L18.5 15.5"/></svg>',
						SortAscending: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20V5"/><path d="M6 11L12 5L18 11"/></svg>',
						SortDescending: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4V19"/><path d="M6 13L12 19L18 13"/></svg>'
					}
				});
		}

		// CSS for the clickable sort control. Inactive glyphs are faded; the
		// actively-sorted column's glyph is full opacity.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Layout-Tabular-Sort-CSS',
				'.pict-tabular-sort-control { cursor: pointer; display: inline-flex; vertical-align: middle; margin-left: 0.3em; opacity: 0.4; }'
				+ ' .pict-tabular-sort-control:hover { opacity: 0.75; }'
				+ ' .pict-tabular-sort-control.pict-tabular-sort-asc, .pict-tabular-sort-control.pict-tabular-sort-desc { opacity: 1; }',
				500);
		}
	}

	/**
	 * Builds one prime-header `<th>` with an injected, clickable sort control
	 * `<span>` carrying the sort SVG glyph. Used when the group has
	 * `ColumnSorting: true`. The glyph reflects the current sort state of the
	 * column (neutral / ascending / descending).
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @param {Object} pDescriptor - The column's descriptor.
	 * @param {number} pColumnIndex - The descriptor's InputIndex.
	 * @returns {string}
	 */
	_buildSortableHeaderCell(pView, pGroup, pDescriptor, pColumnIndex)
	{
		let tmpSortState = pGroup._SortState || { ColumnIndex: -1, Direction: 'none' };
		let tmpIsActive = (tmpSortState.ColumnIndex === pColumnIndex) && (tmpSortState.Direction !== 'none');
		let tmpIconName = 'Sort';
		let tmpStateClass = 'pict-tabular-sort-none';
		if (tmpIsActive && tmpSortState.Direction === 'asc')
		{
			tmpIconName = 'SortAscending';
			tmpStateClass = 'pict-tabular-sort-asc';
		}
		else if (tmpIsActive && tmpSortState.Direction === 'desc')
		{
			tmpIconName = 'SortDescending';
			tmpStateClass = 'pict-tabular-sort-desc';
		}
		let tmpGlyph = (typeof this.pict.icon === 'function') ? this.pict.icon(tmpIconName) : '';
		let tmpName = this._escapeHTML((pDescriptor && pDescriptor.Name != null) ? String(pDescriptor.Name) : '');
		return `\n\t\t\t\t\t\t<th data-tabular-column-index="${pColumnIndex}">${tmpName} `
			+ `<span class="pict-tabular-sort-control ${tmpStateClass}" `
			+ `onclick="_Pict.providers['Pict-Layout-Tabular'].sortTabularColumn('${pView.Hash}', ${pGroup.GroupIndex}, ${pColumnIndex})">`
			+ `${tmpGlyph}</span></th>\n`;
	}

	/**
	 * Resolves one row's value for a column descriptor. Dynamic columns store
	 * their value at the descriptor's InformaryDataAddress (a nested path);
	 * static columns resolve by hash.
	 *
	 * @param {Object} pGroup
	 * @param {Object} pDescriptor
	 * @param {Object} pRecord
	 * @returns {any}
	 */
	_getTabularCellValue(pGroup, pDescriptor, pRecord)
	{
		if (!pDescriptor || !pRecord || !pGroup.supportingManifest)
		{
			return undefined;
		}
		let tmpKey = (pDescriptor.PictForm && typeof pDescriptor.PictForm.InformaryDataAddress === 'string'
			&& pDescriptor.PictForm.InformaryDataAddress.length > 0)
			? pDescriptor.PictForm.InformaryDataAddress
			: pDescriptor.Hash;
		try
		{
			return pGroup.supportingManifest.getValueByHash(pRecord, tmpKey);
		}
		catch (pError)
		{
			return undefined;
		}
	}

	/**
	 * Comparator for tabular sort. Numeric when both values parse as numbers,
	 * otherwise a locale string comparison. Null/undefined sort as empty.
	 *
	 * @param {any} pValueA
	 * @param {any} pValueB
	 * @returns {number}
	 */
	_compareTabularValues(pValueA, pValueB)
	{
		let tmpA = (pValueA == null) ? '' : pValueA;
		let tmpB = (pValueB == null) ? '' : pValueB;
		let tmpNumberA = Number(tmpA);
		let tmpNumberB = Number(tmpB);
		if ((tmpA !== '') && (tmpB !== '') && !isNaN(tmpNumberA) && !isNaN(tmpNumberB))
		{
			if (tmpNumberA < tmpNumberB) { return -1; }
			if (tmpNumberA > tmpNumberB) { return 1; }
			return 0;
		}
		return String(tmpA).localeCompare(String(tmpB));
	}

	/**
	 * Inline-handler entry point: sorts a tabular group's record set by a column.
	 * A fresh column starts ascending; clicking the active column toggles
	 * ascending -> descending. Rebuilds so the header glyph re-bakes, then
	 * re-renders and re-marshals.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pColumnIndex
	 * @returns {boolean}
	 */
	sortTabularColumn(pViewHash, pGroupIndex, pColumnIndex)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || tmpGroup.ColumnSorting !== true)
		{
			return false;
		}
		let tmpColumnIndex = Number(pColumnIndex);
		if (isNaN(tmpColumnIndex) || tmpColumnIndex < 0)
		{
			return false;
		}

		// Cycle the direction: a new column starts ascending, the active column toggles.
		if (!tmpGroup._SortState)
		{
			tmpGroup._SortState = { ColumnIndex: -1, Direction: 'none' };
		}
		if (tmpGroup._SortState.ColumnIndex === tmpColumnIndex && tmpGroup._SortState.Direction === 'asc')
		{
			tmpGroup._SortState.Direction = 'desc';
		}
		else
		{
			tmpGroup._SortState.ColumnIndex = tmpColumnIndex;
			tmpGroup._SortState.Direction = 'asc';
		}

		// Resolve the descriptor + record set and sort the record set in place.
		let tmpDescriptor = null;
		if (tmpGroup.supportingManifest && Array.isArray(tmpGroup.supportingManifest.elementAddresses))
		{
			let tmpHash = tmpGroup.supportingManifest.elementAddresses[tmpColumnIndex];
			tmpDescriptor = tmpGroup.supportingManifest.elementDescriptors[tmpHash];
		}
		let tmpRecordSet = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		if (tmpDescriptor && Array.isArray(tmpRecordSet))
		{
			let tmpDirection = (tmpGroup._SortState.Direction === 'desc') ? -1 : 1;
			tmpRecordSet.sort((pRecordA, pRecordB) =>
			{
				return this._compareTabularValues(
					this._getTabularCellValue(tmpGroup, tmpDescriptor, pRecordA),
					this._getTabularCellValue(tmpGroup, tmpDescriptor, pRecordB)) * tmpDirection;
			});
		}

		// Rebuild so the header re-bakes with the updated glyph, then re-render + marshal.
		tmpView.rebuildCustomTemplate();
		tmpView.render();
		if (this.pict.views.PictFormMetacontroller)
		{
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			tmpView.marshalToView();
		}
		return true;
	}

	/**
	 * Resolve a template string against a record. Returns '' on failure.
	 *
	 * @param {string} pTemplate
	 * @param {Object} pRecord
	 * @returns {string}
	 */
	_parseTabularTemplate(pTemplate, pRecord)
	{
		if (typeof pTemplate !== 'string')
		{
			return '';
		}
		if (pTemplate.indexOf('{') === -1)
		{
			return pTemplate;
		}
		try
		{
			let tmpResult = this.pict.parseTemplate(pTemplate, pRecord, null);
			return (typeof tmpResult === 'string') ? tmpResult : '';
		}
		catch (pError)
		{
			this.log.warn(`PICT Form Tabular template parse failed: ${pError && pError.message}`);
			return '';
		}
	}

	/**
	 * Build the expanded Headers config for a group.
	 *
	 * Returns the user-provided pGroup.Headers (each row = array of cells) plus
	 * a synthesized "header group" row prepended at the front when any DynamicColumns
	 * generator declares a HeaderGroupTemplate. The synthesized row clusters
	 * consecutive descriptors with the same _DynamicColumnHeaderGroup value into
	 * a single cell with ColumnSpan.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {Array<Array<{Label: string, ColumnSpan: number, CSSClass: string}>>}
	 */
	_buildExpandedHeadersConfig(pView, pGroup)
	{
		let tmpExpanded = [];

		// Render user-provided Headers config first (at the top of the table).
		if (Array.isArray(pGroup.Headers))
		{
			for (let r = 0; r < pGroup.Headers.length; r++)
			{
				let tmpRowConfig = pGroup.Headers[r];
				if (!Array.isArray(tmpRowConfig))
				{
					continue;
				}
				let tmpNormalizedRow = [];
				for (let c = 0; c < tmpRowConfig.length; c++)
				{
					let tmpCell = tmpRowConfig[c];
					if (!tmpCell || typeof tmpCell !== 'object')
					{
						continue;
					}
					tmpNormalizedRow.push({
						Label: (typeof tmpCell.Label === 'string') ? tmpCell.Label : '',
						ColumnSpan: (Number(tmpCell.ColumnSpan) > 0) ? Number(tmpCell.ColumnSpan) : 1,
						CSSClass: (typeof tmpCell.CSSClass === 'string') ? tmpCell.CSSClass : ''
					});
				}
				tmpExpanded.push(tmpNormalizedRow);
			}
		}

		// Then synthesize a clustered super-header row from any DynamicColumns generator
		// that declared a HeaderGroupTemplate. This row sits JUST ABOVE the default
		// column-name row so the visual cluster lines up with the columns it groups.
		// Walk the supportingManifest in order and group adjacent descriptors that
		// share both _DynamicColumnGeneratorIndex and _DynamicColumnHeaderGroup; static
		// descriptors get blank "spacer" cells.
		let tmpHasHeaderGroups = false;
		if (Array.isArray(pGroup.DynamicColumns))
		{
			for (let g = 0; g < pGroup.DynamicColumns.length; g++)
			{
				if (pGroup.DynamicColumns[g] && pGroup.DynamicColumns[g].HeaderGroupTemplate)
				{
					tmpHasHeaderGroups = true;
					break;
				}
			}
		}
		if (tmpHasHeaderGroups && pGroup.supportingManifest)
		{
			let tmpSynthRow = [];
			let tmpCurrentRun = null;
			let tmpAddresses = pGroup.supportingManifest.elementAddresses;
			for (let k = 0; k < tmpAddresses.length; k++)
			{
				let tmpDescriptor = pGroup.supportingManifest.elementDescriptors[tmpAddresses[k]];
				if (!tmpDescriptor)
				{
					continue;
				}
				if (tmpDescriptor.PictForm && tmpDescriptor.PictForm.TabularHidden)
				{
					continue;
				}
				let tmpIsDynamic = (typeof tmpDescriptor._DynamicColumnGeneratorIndex === 'number');
				let tmpGroupLabel = (tmpIsDynamic && typeof tmpDescriptor._DynamicColumnHeaderGroup === 'string')
					? tmpDescriptor._DynamicColumnHeaderGroup
					: '';
				let tmpRunKey = tmpIsDynamic ? `D${tmpDescriptor._DynamicColumnGeneratorIndex}|${tmpGroupLabel}` : `S|${k}`;
				if (tmpCurrentRun && tmpCurrentRun.RunKey === tmpRunKey)
				{
					tmpCurrentRun.Cell.ColumnSpan += 1;
				}
				else
				{
					tmpCurrentRun = {
						RunKey: tmpRunKey,
						Cell: {
							Label: tmpIsDynamic ? tmpGroupLabel : '',
							ColumnSpan: 1,
							CSSClass: tmpIsDynamic ? 'pict-tabular-dynamic-header-group' : 'pict-tabular-static-header-spacer'
						}
					};
					tmpSynthRow.push(tmpCurrentRun.Cell);
				}
			}
			tmpExpanded.push(tmpSynthRow);
		}

		return tmpExpanded;
	}

	/**
	 * Compute per-row label metadata for a tabular group with RowLabels config.
	 *
	 * Walks the current RecordSetAddress array. For each row, resolves the
	 * label value for each RowLabels entry (Template / RowNumber / SourceAddress).
	 * For Cluster:true columns, consecutive equal values collapse into a single
	 * cell on the first row of the run, with continuation rows marked Skip:true.
	 *
	 * Writes the result to pGroup.RowLabelMetadata as an array index-aligned
	 * with the record set. Idempotent — safe to call on every marshal.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 */
	_computeRowLabelMetadata(pView, pGroup)
	{
		if (!Array.isArray(pGroup.RowLabels) || pGroup.RowLabels.length === 0)
		{
			pGroup.RowLabelMetadata = [];
			return;
		}
		let tmpRecordSet = [];
		if (typeof pGroup.RecordSetAddress === 'string' && pGroup.RecordSetAddress.length > 0)
		{
			let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
			let tmpFetched = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, pGroup.RecordSetAddress);
			if (Array.isArray(tmpFetched))
			{
				tmpRecordSet = tmpFetched;
			}
		}

		let tmpMetadata = [];
		for (let i = 0; i < tmpRecordSet.length; i++)
		{
			let tmpRow = tmpRecordSet[i];
			let tmpCells = [];
			for (let l = 0; l < pGroup.RowLabels.length; l++)
			{
				let tmpLabelConfig = pGroup.RowLabels[l];
				let tmpRenderedLabel = '';
				if (tmpLabelConfig.RowNumber === true)
				{
					tmpRenderedLabel = String(i + 1);
				}
				else if (typeof tmpLabelConfig.SourceAddress === 'string' && tmpLabelConfig.SourceAddress.length > 0)
				{
					let tmpLabelSource = this.pict.resolveStateFromAddress(tmpLabelConfig.SourceAddress, null);
					if (Array.isArray(tmpLabelSource) && i < tmpLabelSource.length)
					{
						let tmpItem = tmpLabelSource[i];
						tmpRenderedLabel = (typeof tmpItem === 'string') ? tmpItem : (tmpItem == null ? '' : String(tmpItem));
					}
				}
				else if (typeof tmpLabelConfig.Template === 'string')
				{
					// Templates can reference Record.Value.X (the row record) or AppData.X.
					tmpRenderedLabel = this._parseTabularTemplate(tmpLabelConfig.Template, { Value: tmpRow, Key: i });
				}
				tmpCells.push({
					Label: tmpLabelConfig.Name || '',
					RenderedLabel: tmpRenderedLabel,
					RowSpan: 1,
					Skip: false,
					Cluster: tmpLabelConfig.Cluster === true,
					CSSClass: (typeof tmpLabelConfig.CSSClass === 'string') ? tmpLabelConfig.CSSClass : ''
				});
			}
			tmpMetadata.push({ Cells: tmpCells });
		}

		// Pass 2: apply clustering (rowspan collapse for consecutive equal values).
		for (let l = 0; l < pGroup.RowLabels.length; l++)
		{
			if (!pGroup.RowLabels[l].Cluster)
			{
				continue;
			}
			let tmpRunStart = 0;
			for (let i = 1; i <= tmpMetadata.length; i++)
			{
				let tmpAtEnd = (i === tmpMetadata.length);
				let tmpMatches = !tmpAtEnd
					&& tmpMetadata[i].Cells[l].RenderedLabel === tmpMetadata[tmpRunStart].Cells[l].RenderedLabel;
				if (tmpMatches)
				{
					tmpMetadata[i].Cells[l].Skip = true;
				}
				else
				{
					let tmpRunLength = i - tmpRunStart;
					tmpMetadata[tmpRunStart].Cells[l].RowSpan = tmpRunLength;
					tmpRunStart = i;
				}
			}
		}

		pGroup.RowLabelMetadata = tmpMetadata;
	}

	/**
	 * Called from the row template via the {~TRL:...~} tag. Returns the HTML for
	 * the leading cells of one tabular row: an optional row-selection checkbox
	 * cell followed by the configured row-label cells.
	 *
	 * @param {Object} pView
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pRowKey
	 * @returns {string}
	 */
	_renderTabularRowLabelsHTML(pView, pGroupIndex, pRowKey)
	{
		if (!pView || !pView.sectionDefinition || !Array.isArray(pView.sectionDefinition.Groups))
		{
			return '';
		}
		let tmpGroupIdx = Number(pGroupIndex);
		if (isNaN(tmpGroupIdx) || tmpGroupIdx < 0 || tmpGroupIdx >= pView.sectionDefinition.Groups.length)
		{
			return '';
		}
		let tmpGroup = pView.sectionDefinition.Groups[tmpGroupIdx];
		let tmpRowKeyNum = Number(pRowKey);

		// The {~TRL:~} tag runs once per row, in row order, during a render pass.
		// Recompute the label metadata when the first row renders so a render()
		// that was not preceded by a fresh marshal (e.g. a row move / add / delete)
		// still shows correct, current row labels rather than the previous order.
		if (tmpRowKeyNum === 0)
		{
			this._computeRowLabelMetadata(pView, tmpGroup);
		}

		let tmpHTML = '';

		// Leading row-selection checkbox cell.
		if (tmpGroup._RowSelectionConfig && !isNaN(tmpRowKeyNum) && tmpRowKeyNum >= 0)
		{
			let tmpSelected = this._getTabularSelectionArray(pView, tmpGroup._RowSelectionConfig);
			let tmpCheckedAttr = tmpSelected[tmpRowKeyNum] ? ' checked="checked"' : '';
			tmpHTML += `<td class="pict-tabular-row-select">`
				+ `<input type="checkbox"${tmpCheckedAttr} onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularRowSelection('${pView.Hash}', ${tmpGroupIdx}, '${tmpRowKeyNum}', this.checked)">`
				+ `</td>`;
		}

		// Row-label cells.
		if (Array.isArray(tmpGroup.RowLabelMetadata)
			&& !isNaN(tmpRowKeyNum) && tmpRowKeyNum >= 0 && tmpRowKeyNum < tmpGroup.RowLabelMetadata.length)
		{
			let tmpCells = tmpGroup.RowLabelMetadata[tmpRowKeyNum].Cells;
			for (let c = 0; c < tmpCells.length; c++)
			{
				let tmpCell = tmpCells[c];
				if (tmpCell.Skip)
				{
					continue;
				}
				let tmpRowSpanAttr = (tmpCell.RowSpan > 1) ? ` rowspan="${tmpCell.RowSpan}"` : '';
				let tmpClassAttr = `pict-row-label${tmpCell.Cluster ? ' pict-row-label-clustered' : ''}${tmpCell.CSSClass ? ' ' + tmpCell.CSSClass : ''}`;
				tmpHTML += `<td${tmpRowSpanAttr} class="${tmpClassAttr}">${this._escapeHTML(tmpCell.RenderedLabel)}</td>`;
			}
		}
		return tmpHTML;
	}

	/**
	 * Called from the row template via {~F:...~} to emit the editing controls
	 * (del/up/down) for a row. Used when EditingControlsPosition === 'left'.
	 * For EditingControlsPosition === 'right' the existing default
	 * -TabularTemplate-Row-ExtraPostfix template handles this.
	 *
	 * @param {Object} pView
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pRowKey
	 * @returns {string}
	 */
	_renderTabularEditingControlsHTML(pView, pGroupIndex, pRowKey)
	{
		if (!pView)
		{
			return '';
		}
		let tmpViewHash = pView.Hash;
		return `<td class="pict-tabular-editing-controls"><a href="#/" onClick="_Pict.views['${tmpViewHash}'].deleteDynamicTableRow(${pGroupIndex},'${pRowKey}')">del</a> <a href="#/" onClick="_Pict.views['${tmpViewHash}'].moveDynamicTableRowUp(${pGroupIndex},'${pRowKey}')">up</a> <a href="#/" onClick="_Pict.views['${tmpViewHash}'].moveDynamicTableRowDown(${pGroupIndex},'${pRowKey}')">down</a></td>`;
	}

	_escapeHTML(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	/**
	 * Normalize a Group.RowSelection / Group.ColumnSelection config value.
	 *
	 * Accepts `true` (use all defaults) or an object
	 * `{ Enabled, DataAddress, HighlightClass, HeaderLabel }`. Returns null when
	 * selection is not enabled.
	 *
	 * - `DataAddress` — address (relative to the form's marshal destination) where
	 *   the boolean selection array is stored, so it persists with the form data.
	 * - `HighlightClass` — class auto-applied to selected rows/columns. Set to an
	 *   empty string to make selection purely data-driven (solver-applied only).
	 * - `HeaderLabel` — text for the selection column's header cell.
	 *
	 * @param {boolean|Object} pConfigValue
	 * @param {string} pDefaultDataAddress
	 * @param {string} pDefaultHighlightClass
	 * @returns {{DataAddress: string, HighlightClass: string, HeaderLabel: string}|null}
	 */
	_normalizeSelectionConfig(pConfigValue, pDefaultDataAddress, pDefaultHighlightClass)
	{
		if (pConfigValue !== true && (typeof pConfigValue !== 'object' || pConfigValue === null))
		{
			return null;
		}
		let tmpConfig = (typeof pConfigValue === 'object') ? pConfigValue : {};
		if (tmpConfig.Enabled === false)
		{
			return null;
		}
		return {
			DataAddress: (typeof tmpConfig.DataAddress === 'string' && tmpConfig.DataAddress.length > 0)
				? tmpConfig.DataAddress
				: pDefaultDataAddress,
			HighlightClass: ('HighlightClass' in tmpConfig)
				? (tmpConfig.HighlightClass || '')
				: pDefaultHighlightClass,
			HeaderLabel: (typeof tmpConfig.HeaderLabel === 'string') ? tmpConfig.HeaderLabel : ''
		};
	}

	/**
	 * The absolute address (within the form's marshal destination) of a selection
	 * config's boolean array.
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pSelectionConfig
	 * @returns {string}
	 */
	_getTabularSelectionAddress(pView, pSelectionConfig)
	{
		return `${pView.getMarshalDestinationAddress()}.${pSelectionConfig.DataAddress}`;
	}

	/**
	 * Reads the boolean selection array for a row/column selection config.
	 * Always returns an array (empty when nothing has been selected yet).
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pSelectionConfig
	 * @returns {Array<boolean>}
	 */
	_getTabularSelectionArray(pView, pSelectionConfig)
	{
		let tmpValue = this.pict.resolveStateFromAddress(this._getTabularSelectionAddress(pView, pSelectionConfig));
		return Array.isArray(tmpValue) ? tmpValue : [];
	}

	/**
	 * Sets one flag in a selection array and writes it back into the form data.
	 *
	 * @param {Object} pView
	 * @param {{DataAddress: string}} pSelectionConfig
	 * @param {number|string} pIndex
	 * @param {boolean} pSelected
	 * @returns {Array<boolean>}
	 */
	_setTabularSelectionFlag(pView, pSelectionConfig, pIndex, pSelected)
	{
		let tmpArray = this._getTabularSelectionArray(pView, pSelectionConfig);
		let tmpIndex = Number(pIndex);
		if (!isNaN(tmpIndex) && tmpIndex >= 0)
		{
			tmpArray[tmpIndex] = !!pSelected;
		}
		this.pict.setStateValueAtAddress(this._getTabularSelectionAddress(pView, pSelectionConfig), null, tmpArray);
		return tmpArray;
	}

	/**
	 * Inline-handler entry point: toggles a row's selection state. Called by the
	 * checkbox rendered in the row-selection column. Writes the new state into the
	 * form data, optionally applies the highlight class, then re-solves so any
	 * user solvers that read the selection state can react.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pRowKey
	 * @param {boolean} pChecked
	 * @returns {boolean}
	 */
	toggleTabularRowSelection(pViewHash, pGroupIndex, pRowKey, pChecked)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !tmpGroup._RowSelectionConfig)
		{
			return false;
		}
		this._setTabularSelectionFlag(tmpView, tmpGroup._RowSelectionConfig, pRowKey, pChecked);
		if (tmpGroup._RowSelectionConfig.HighlightClass && this.pict.providers.DynamicFormSolverBehaviors)
		{
			this.pict.providers.DynamicFormSolverBehaviors.highlightTabularRow(
				tmpView.sectionDefinition.Hash, tmpGroup.Hash, pRowKey, pChecked ? 1 : 0, tmpGroup._RowSelectionConfig.HighlightClass);
		}
		this.pict.PictApplication.solve();
		return true;
	}

	/**
	 * Inline-handler entry point: toggles a column's selection state. Called by the
	 * checkbox rendered in the column-selection header row.
	 *
	 * @param {string} pViewHash
	 * @param {number|string} pGroupIndex
	 * @param {number|string} pColumnIndex
	 * @param {boolean} pChecked
	 * @returns {boolean}
	 */
	toggleTabularColumnSelection(pViewHash, pGroupIndex, pColumnIndex, pChecked)
	{
		let tmpView = this.pict.views[pViewHash];
		if (!tmpView || !tmpView.sectionDefinition || !Array.isArray(tmpView.sectionDefinition.Groups))
		{
			return false;
		}
		let tmpGroup = tmpView.sectionDefinition.Groups[Number(pGroupIndex)];
		if (!tmpGroup || !tmpGroup._ColumnSelectionConfig)
		{
			return false;
		}
		this._setTabularSelectionFlag(tmpView, tmpGroup._ColumnSelectionConfig, pColumnIndex, pChecked);
		if (tmpGroup._ColumnSelectionConfig.HighlightClass && this.pict.providers.DynamicFormSolverBehaviors)
		{
			this.pict.providers.DynamicFormSolverBehaviors.highlightTabularColumn(
				tmpView.sectionDefinition.Hash, tmpGroup.Hash, pColumnIndex, pChecked ? 1 : 0, tmpGroup._ColumnSelectionConfig.HighlightClass);
		}
		this.pict.PictApplication.solve();
		return true;
	}

	/**
	 * Re-applies selection highlight classes from the stored selection arrays.
	 * Run after a (re)render rebuilds the table DOM and the classes would
	 * otherwise be lost. No-op when no highlight class is configured.
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 */
	_reapplyTabularSelectionHighlights(pView, pGroup)
	{
		let tmpBehaviors = this.pict.providers.DynamicFormSolverBehaviors;
		if (!tmpBehaviors || !pView.sectionDefinition)
		{
			return;
		}
		let tmpSectionHash = pView.sectionDefinition.Hash;
		if (pGroup._RowSelectionConfig && pGroup._RowSelectionConfig.HighlightClass)
		{
			let tmpRows = this._getTabularSelectionArray(pView, pGroup._RowSelectionConfig);
			for (let i = 0; i < tmpRows.length; i++)
			{
				tmpBehaviors.highlightTabularRow(tmpSectionHash, pGroup.Hash, i, tmpRows[i] ? 1 : 0, pGroup._RowSelectionConfig.HighlightClass);
			}
		}
		if (pGroup._ColumnSelectionConfig && pGroup._ColumnSelectionConfig.HighlightClass)
		{
			let tmpColumns = this._getTabularSelectionArray(pView, pGroup._ColumnSelectionConfig);
			for (let i = 0; i < tmpColumns.length; i++)
			{
				tmpBehaviors.highlightTabularColumn(tmpSectionHash, pGroup.Hash, i, tmpColumns[i] ? 1 : 0, pGroup._ColumnSelectionConfig.HighlightClass);
			}
		}
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// Tabular are odd in that they have a header row and then a meta TemplateSet for the rows()
		// In this case we are going to load the descriptors from the supportingManifests
		if (!pGroup.supportingManifest)
		{
			this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] error generating tabular metatemplate: missing group manifest ${pGroup.RecordManifest} from supportingManifests.`);
			return '';
		}

		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';
		let tmpTemplateSetRecordRowTemplate = '';

		// Read new optional configuration.
		let tmpEditingControlsPosition = (typeof pGroup.EditingControlsPosition === 'string') ? pGroup.EditingControlsPosition : 'right';
		let tmpRowLabels = Array.isArray(pGroup.RowLabels) ? pGroup.RowLabels : [];
		let tmpSuppressDefaultColumnHeaderRow = (pGroup.SuppressDefaultColumnHeaderRow === true);
		// ColumnSorting (off by default): injects a clickable sort-glyph span into every prime header cell.
		let tmpColumnSortingEnabled = (pGroup.ColumnSorting === true);
		if (tmpColumnSortingEnabled && !pGroup._SortState)
		{
			pGroup._SortState = { ColumnIndex: -1, Direction: 'none' };
		}
		let tmpExpandedHeaders = this._buildExpandedHeadersConfig(pView, pGroup);

		// Stash the structures referenced by the templates below.
		pGroup.ExpandedHeaders = tmpExpandedHeaders;
		pGroup.RowLabelHeaderCells = tmpRowLabels.map((pLabel) =>
			({
				Name: pLabel.Name || '',
				CSSClass: (typeof pLabel.CSSClass === 'string') ? pLabel.CSSClass : ''
			}));

		// Selectable rows / columns. When enabled, a checkbox column / header row is
		// rendered and the boolean selection state is stored in the form data so it
		// persists with a save. Solvers can read that state; selection optionally
		// auto-applies a highlight class.
		pGroup._RowSelectionConfig = this._normalizeSelectionConfig(pGroup.RowSelection, `${pGroup.Hash}_RowSelection`, 'pict-tabular-row-highlight');
		pGroup._ColumnSelectionConfig = this._normalizeSelectionConfig(pGroup.ColumnSelection, `${pGroup.Hash}_ColumnSelection`, 'pict-tabular-column-highlight');
		let tmpRowSelectionEnabled = (pGroup._RowSelectionConfig != null);
		let tmpColumnSelectionEnabled = (pGroup._ColumnSelectionConfig != null);
		let tmpEditingLeft = (tmpEditingControlsPosition === 'left');
		let tmpEditingRight = (tmpEditingControlsPosition === 'right');
		// Leading (non-data) columns that precede the data cells: row-select, row labels, left controls.
		let tmpLeadingColumnCount = (tmpRowSelectionEnabled ? 1 : 0) + tmpRowLabels.length + (tmpEditingLeft ? 1 : 0);

		// When EditingControlsPosition isn't 'right' (the default), suppress the default
		// extra-postfix slots by registering empty view-specific overrides. This keeps the
		// existing template machinery intact for backwards compatibility -- consumers that
		// don't opt in to the new behavior see identical output.
		if (tmpEditingControlsPosition === 'left' || tmpEditingControlsPosition === 'hidden')
		{
			this.pict.TemplateProvider.addTemplate(pView.getViewSpecificTemplateHash('-TabularTemplate-Row-ExtraPostfix'), '');
			this.pict.TemplateProvider.addTemplate(pView.getViewSpecificTemplateHash('-TabularTemplate-RowHeader-ExtraPostfix'), '');
		}

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		// Header section
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		// Emit additional header rows (above the default column-name row).
		// Each row gets its own <tr>; leading non-data columns get blank <th>s
		// prepended (and a trailing one for right-side editing controls) for alignment.
		for (let r = 0; r < tmpExpandedHeaders.length; r++)
		{
			let tmpHeaderRow = tmpExpandedHeaders[r];
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-ExtraHeaderRow-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
			for (let l = 0; l < tmpLeadingColumnCount; l++)
			{
				tmpTemplate += `<th class="pict-row-label-spacer"></th>`;
			}
			for (let c = 0; c < tmpHeaderRow.length; c++)
			{
				let tmpCellAddress = `getGroup("${pGroup.GroupIndex}").ExpandedHeaders.${r}.${c}`;
				tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-ExtraHeaderCell`, tmpCellAddress);
			}
			if (tmpEditingRight)
			{
				tmpTemplate += `<th class="pict-row-label-spacer"></th>`;
			}
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-ExtraHeaderRow-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		}

		// Column-selection header row -- a <tr> of checkboxes, one per visible data
		// column, plus leading/trailing spacers to line up with the data columns.
		if (tmpColumnSelectionEnabled)
		{
			let tmpColumnSelectionState = this._getTabularSelectionArray(pView, pGroup._ColumnSelectionConfig);
			let tmpColumnSelectRow = `<tr class="pict-tabular-column-select-row">`;
			for (let l = 0; l < tmpLeadingColumnCount; l++)
			{
				tmpColumnSelectRow += `<th class="pict-row-label-spacer"></th>`;
			}
			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpColumnDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
				if (!tmpColumnDescriptor || (tmpColumnDescriptor.PictForm && tmpColumnDescriptor.PictForm.TabularHidden))
				{
					continue;
				}
				let tmpColumnCheckedAttr = tmpColumnSelectionState[k] ? ' checked="checked"' : '';
				tmpColumnSelectRow += `<th class="pict-tabular-column-select">`
					+ `<input type="checkbox"${tmpColumnCheckedAttr} onchange="_Pict.providers['Pict-Layout-Tabular'].toggleTabularColumnSelection('${pView.Hash}', ${pGroup.GroupIndex}, ${k}, this.checked)">`
					+ `</th>`;
			}
			if (tmpEditingRight)
			{
				tmpColumnSelectRow += `<th class="pict-row-label-spacer"></th>`;
			}
			tmpColumnSelectRow += `</tr>`;
			tmpTemplate += tmpColumnSelectRow;
		}

		// Existing ExtraPrefix slot (preserved for host overrides)
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-ExtraPrefix`, `getGroup("${pGroup.GroupIndex}")`);

		// Row-selection header cell.
		if (tmpRowSelectionEnabled)
		{
			tmpTemplate += `<th class="pict-row-label-header pict-tabular-row-select-header">${this._escapeHTML(pGroup._RowSelectionConfig.HeaderLabel)}</th>`;
		}

		// Row label header cells in the default header row.
		for (let l = 0; l < tmpRowLabels.length; l++)
		{
			let tmpLabelHeaderAddress = `getGroup("${pGroup.GroupIndex}").RowLabelHeaderCells.${l}`;
			tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowLabel-HeaderCell`, tmpLabelHeaderAddress);
		}

		// Header cell matching the left-side editing controls column, if configured.
		if (tmpEditingLeft)
		{
			tmpTemplate += `<th class="pict-row-label-header pict-tabular-editing-controls-header"></th>`;
		}

		// Per-descriptor header cells + the per-descriptor row body template.
		let tmpDataColumnCount = 0;
		for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
		{
			let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
			let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
			// Update the InputIndex to match the current render config
			if (!('PictForm' in tmpInput))
			{
				tmpInput.PictForm = {};
			}
			if (tmpInput.PictForm.TabularHidden)
			{
				continue;
			}
			tmpInput.PictForm.InputIndex = k;
			tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
			tmpInput.PictForm.RowIndex = 0;

			if (!tmpSuppressDefaultColumnHeaderRow)
			{
				if (tmpColumnSortingEnabled)
				{
					tmpTemplate += this._buildSortableHeaderCell(pView, pGroup, tmpInput, k);
				}
				else
				{
					tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-HeaderCell`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
				}
			}

			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Cell-Prefix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
			let tmpInputType = (('PictForm' in tmpInput) && tmpInput.PictForm.InputType) ? tmpInput.PictForm.InputType : 'Default';
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getTabularInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInputType, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`, pGroup.GroupIndex, k);
			tmpTemplateSetRecordRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Cell-Postfix`, `getTabularRecordInput("${pGroup.GroupIndex}","${k}")`);
			tmpDataColumnCount++;
		}

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-ExtraPostfix`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-RowHeader-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		// Warn on header alignment mismatches (data-column count must equal each extra-header
		// row's total ColumnSpan).
		for (let r = 0; r < tmpExpandedHeaders.length; r++)
		{
			let tmpSpanTotal = 0;
			for (let c = 0; c < tmpExpandedHeaders[r].length; c++)
			{
				tmpSpanTotal += tmpExpandedHeaders[r][c].ColumnSpan || 1;
			}
			if (tmpSpanTotal !== tmpDataColumnCount)
			{
				this.log.warn(`PICT Form [${pView.UUID}]::[${pView.Hash}] tabular group [${pGroup.Hash}] header row ${r} total ColumnSpan (${tmpSpanTotal}) does not match data column count (${tmpDataColumnCount}). Header will visually misalign.`);
			}
		}

		// Compute initial row label metadata; recomputed on every marshal in onDataMarshalToForm.
		this._computeRowLabelMetadata(pView, pGroup);

		// This is the template by which the tabular template includes the rows.
		// The template recursion here is difficult to envision without drawing it.
		// TODO: Consider making this function available in manyfest in some fashion it seems dope.
		let tmpTemplateSetVirtualRowTemplate = '';
		// Row-Prefix references the per-row MTVS record (not the group) so the <tr>
		// can carry data-tabular-row-index for the highlight/color/selection features.
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-TabularTemplate-Row-Prefix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-TabularTemplate-Row-ExtraPrefix`, `Record`);

		// Leading cells: the row-selection checkbox and the row-label columns
		// (both emitted by the {~TRL:~} tag), followed by left-side editing controls.
		if (tmpRowLabels.length > 0 || tmpRowSelectionEnabled)
		{
			tmpTemplateSetVirtualRowTemplate += `{~TRL:${pView.Hash}~}`;
		}
		if (tmpEditingLeft)
		{
			tmpTemplateSetVirtualRowTemplate += `{~TEC:${pView.Hash}~}`;
		}

		tmpTemplateSetVirtualRowTemplate += `\n\n{~T:${pGroup.SectionTabularRowTemplateHash}:Record~}\n`;
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReferenceRaw(pView, `-TabularTemplate-Row-ExtraPostfix`, `Record`);
		tmpTemplateSetVirtualRowTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Row-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		// This is a custom template expression
		tmpTemplate += `\n\n{~MTVS:${pGroup.SectionTabularRowVirtualTemplateHash}:${pGroup.GroupIndex}:${pView.getMarshalDestinationAddress()}.${pGroup.RecordSetAddress}~}\n`;

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TabularTemplate-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		// Add the TemplateSetTemplate
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowVirtualTemplateHash, tmpTemplateSetVirtualRowTemplate);
		this.pict.TemplateProvider.addTemplate(pGroup.SectionTabularRowTemplateHash, tmpTemplateSetRecordRowTemplate);

		return tmpTemplate;
	}

	/**
	 * Called after data is marshaled to the form. Re-runs DynamicColumns
	 * resolution and row-label clustering so additions/removals of source
	 * data flow into the rendered table without manual refresh calls.
	 *
	 * Loop guard: only triggers a template rebuild + re-render when the
	 * desired set of dynamic descriptor hashes ACTUALLY changes from the
	 * cached state, so steady state is a no-op (just a row-label recompute).
	 *
	 * @param {Object} pView
	 * @param {Object} pGroup
	 * @returns {boolean}
	 */
	onDataMarshalToForm(pView, pGroup)
	{
		if (!pGroup)
		{
			return true;
		}
		// Avoid recursion when this hook itself triggers a render -> marshal cycle.
		if (pGroup._RebuildInProgress)
		{
			return true;
		}

		let tmpHasDynamicColumns = Array.isArray(pGroup.DynamicColumns) && pGroup.DynamicColumns.length > 0;
		if (tmpHasDynamicColumns && this.fable.ManifestFactory && typeof this.fable.ManifestFactory._resolveDynamicColumns === 'function')
		{
			let tmpResult = this.fable.ManifestFactory._resolveDynamicColumns(pView, pGroup);
			if (tmpResult && tmpResult.changed)
			{
				pGroup._RebuildInProgress = true;
				try
				{
					pView.rebuildCustomTemplate();
					pView.render();
				}
				finally
				{
					pGroup._RebuildInProgress = false;
				}
				// The re-render rebuilt the table DOM -- restore selection highlights.
				this._reapplyTabularSelectionHighlights(pView, pGroup);
				return true;
			}
		}

		this._computeRowLabelMetadata(pView, pGroup);
		// Keep selection highlights in sync with the (possibly reloaded) selection data.
		this._reapplyTabularSelectionHighlights(pView, pGroup);
		return true;
	}
}

module.exports = TabularLayout;

},{"../Pict-Provider-DynamicLayout.js":69}],102:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

const libPictSectionTuiGridLayout = require('./Pict-Layout-TuiGrid/Pict-Section-TuiGrid.js');

class TuiGridLayout extends libPictSectionGroupLayout
{
	/**
	 * @param {import('pict')} pFable - The Fable instance.
	 * @param {any} [pOptions={}] - The options for the TuiGrid layout.
	 * @param {string} [pServiceHash] - The service hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('pict')} */
		this.pict;
		/** @type {any} */
		this.log;

		this.viewGridConfigurations = {};

		this.viewTuiGrids = {};
		this.viewGridState = {};
	}

	/**
	 * Generates the HTML ID for a TuiGrid group within a specific view.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @returns {string} - The generated HTML ID.
	 */
	getGridHtmlID(pView, pGroup)
	{
		return `View-${pView.UUID}-GroupTuiGrid-${pGroup.GroupIndex}`;
	}

	/**
	 * Returns the HTML ID of the Tui view in the specified group.
	 *
	 * @param {string} pView - The Tui view.
	 * @param {string} pGroup - The group.
	 * @returns {string} - The HTML ID of the Tui view.
	 */
	getViewTuiHtmlID(pView, pGroup)
	{
		return `#${this.getGridHtmlID(pView, pGroup)}`;
	}

	/**
	 * Retrieves the TuiGrid view for a given view and group.
	 *
	 * @param {string} pView - The view name.
	 * @param {string} pGroup - The group name.
	 * @returns {libPictSectionTuiGridLayout} - The TuiGrid view if it exists, otherwise false.
	 */
	getViewGrid(pView, pGroup)
	{
		let tmpGridUUID = this.getGridHtmlID(pView, pGroup);
		if (!this.viewTuiGrids.hasOwnProperty(tmpGridUUID))
		{
			return null;
		}
		return this.viewTuiGrids[tmpGridUUID];
	}

	/**
	 * Creates a TuiGrid view for the specified view and group.
	 *
	 * @param {any} pView - The view object.
	 * @param {any} pGroup - The group object.
	 * @return {libPictSectionTuiGridLayout} - The created TuiGrid view.
	 */
	createViewTuiGrid(pView, pGroup)
	{
		let tmpGridUUID = this.getGridHtmlID(pView, pGroup);
		if (this.viewTuiGrids.hasOwnProperty(tmpGridUUID))
		{
			// Purely for information for now.
			this.log.info(`Dynamic TuiGrid view [${pView.UUID}]::[${pView.Hash}] is reinitializing a TuiGrid in group ${pGroup.GroupIndex} TuiGrid UUID [${tmpGridUUID}].`);
			// ...we need to clear out the littered tuiGrid views probably.
		}
		// Generate the pict view
		let tmpGridConfiguration = this.getViewTuiConfiguration(pView, pGroup);
		/** @type {libPictSectionTuiGridLayout} */
		let tmpGridView = this.pict.addView(tmpGridUUID, tmpGridConfiguration, libPictSectionTuiGridLayout);
		// Manually initialize the view
		tmpGridView.cachedGridData = this.generateDataRepresentation(pView, pGroup);

		tmpGridView.initialize();

		this.viewTuiGrids[tmpGridUUID] = tmpGridView;
		return tmpGridView;
	}

	/**
	 * Retrieves the TuiGrid configuration for a specific view and group.
	 *
	 * @param {any} pView - The view identifier.
	 * @param {any} pGroup - The group identifier.
	 * @returns {object} - The TuiGrid configuration for the specified view and group.
	 */
	getViewTuiConfiguration(pView, pGroup)
	{
		let tmpGridUUID = this.getGridHtmlID(pView, pGroup);
		// If there isn't yet a tui configuration, make a new one.
		if (!this.viewGridConfigurations.hasOwnProperty(tmpGridUUID))
		{
			// Generate a unique destination for the TuiGrid
			let tmpGroupTuiGridConfiguration = JSON.parse(JSON.stringify(libPictSectionTuiGridLayout.default_configuration));
			this.viewGridConfigurations[tmpGridUUID] = tmpGroupTuiGridConfiguration;

			tmpGroupTuiGridConfiguration.DefaultDestinationAddress = this.getViewTuiHtmlID(pView, pGroup);
			tmpGroupTuiGridConfiguration.TargetElementAddress = this.getViewTuiHtmlID(pView, pGroup);
			tmpGroupTuiGridConfiguration.TuiColumnSchema = [];
			/*
				{
					"header": "IDRecord",
					"name": "idrecord",
					"PictTriggerSolveOnChange": true
				},
				{
					"header": "Description",
					"name": "description",
					"editor": "text"
				}
			*/

			for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
			{
				let tmpSupportingManifestHash = pGroup.supportingManifest.elementAddresses[k];
				let tmpInput = pGroup.supportingManifest.elementDescriptors[tmpSupportingManifestHash];
				// Update the InputIndex to match the current render config
				if (!('PictForm' in tmpInput))
				{
					tmpInput.PictForm = {};
				}
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = 0;

				let tmpTuiGridInput = {
					"header": tmpInput.Name,
					"name": tmpInput.Hash,
					// TODO: Should these all trigger solves?  Seems pretty expensive?
					"PictTriggerSolveOnChange": true,
					"PictSectionFormInput": tmpInput
				};
				switch (tmpInput.DataType)
				{
					case 'Number':
					case 'PreciseNumber':
						tmpTuiGridInput.editor = (
							{
								"type": "EditorNumber",
								"options": {}
							});
						tmpTuiGridInput.editor.options.decimalPrecision = tmpInput?.PictForm?.DecimalPrecision ?? 10;
						break;
					case 'String':
						tmpTuiGridInput.editor = 'text';
						break;
					case 'DateTime':
						tmpTuiGridInput.editor = {
							type: 'datePicker',
							options: {
								format: 'yyyy-MM-dd'
							}
						};
						break;
				}
				switch (tmpInput.PictForm.InputType)
				{
					case 'Option':
					{
						tmpTuiGridInput.editor = (
							{
								"type": "select",
								"options": {
									"listItems": []
								}
							});
						let tmpDefaultData = tmpInput.PictForm.SelectOptions;
						if (tmpInput.PictForm.SelectOptionsPickList && this.pict.providers.DynamicMetaLists.hasList(pView.Hash, tmpInput.PictForm.SelectOptionsPickList))
						{
							tmpDefaultData = this.pict.providers.DynamicMetaLists.getList(pView.Hash, tmpInput.PictForm.SelectOptionsPickList);
						}
						if (tmpDefaultData && Array.isArray(tmpDefaultData))
						{
							for (let i = 0; i < tmpDefaultData.length; i++)
							{
								let tmpOption = (
									{
										"value": tmpDefaultData[i].id,
										"text": tmpDefaultData[i].text
									});
								tmpTuiGridInput.editor.options.listItems.push(tmpOption);
							}
						}
						break;
					}
				}
				tmpGroupTuiGridConfiguration.TuiColumnSchema.push(tmpTuiGridInput);
			}
		}

		return this.viewGridConfigurations[tmpGridUUID];
	}

	/**
	 * Generate a group layout template for a TuiGrid dynamically generated group view.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		// Tabular are odd in that they have a header row and then a meta TemplateSet for the rows()
		// In this case we are going to load the descriptors from the supportingManifests
		if (!pGroup.supportingManifest)
		{
			this.log.error(`PICT Form [${pView.UUID}]::[${pView.Hash}] error generating tabular metatemplate: missing group manifest ${pGroup.RecordManifest} from supportingManifests.`);
			return '';
		}

		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		pGroup.TuiGridHTMLID = this.getGridHtmlID(pView, pGroup);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TuiGrid-Container`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-TuiGrid-Controls`, `getGroup("${pGroup.GroupIndex}")`);
		//tmpTemplate += `<div id="${this.getGridHtmlID(pView, pGroup)}"></div>`;
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}

	/**
	 * Generates a data representation for the given view and group.
	 *
	 * @param {any} pView - The view object.
	 * @param {any} pGroup - The group object.
	 * @returns {Array<any>} - The generated data representation.
	 */
	generateDataRepresentation(pView, pGroup)
	{
		let tmpData = [];
		this.viewGridState[this.getGridHtmlID(pView, pGroup)] = tmpData;

		let tmpTabularRecordSet = pView.getTabularRecordSet(pGroup.GroupIndex);

		if (Array.isArray(tmpTabularRecordSet))
		{
			for (let j = 0; j < tmpTabularRecordSet.length; j++)
			{
				let tmpTuiRowData = { RecordIndex: j };
				let tmpTabularRecord = tmpTabularRecordSet[j];
				for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
				{
					let tmpElementDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
					if (tmpElementDescriptor)
					{
						pGroup.supportingManifest.setValueAtAddress(tmpTuiRowData, tmpElementDescriptor.Hash, pGroup.supportingManifest.getValueByHash(tmpTabularRecord, tmpElementDescriptor.Hash));
					}
				}
				tmpData.push(tmpTuiRowData);
			}
		}
		return tmpData;
	}

	/**
	 * Initialize the TuiGrid!
	 *
	 * @param {any} pView  - The view to initialize the newly rendered control for
	 * @param {any} pGroup - The group to initialize the newly rendered control for
	 * @returns {boolean} - Returns true if the initialization is successful, false otherwise.
	 */
	onGroupLayoutInitialize(pView, pGroup)
	{
		// We do this at the last minute to avoid extraneous creation of these.
		let tmpTuiGridView = this.createViewTuiGrid(pView, pGroup);

		// TODO: Guard?
		tmpTuiGridView.render();

		if (tmpTuiGridView.tuiGrid)
		{
			//FIXME: masking the type from the underlying tui-grid so we can decorate it here
			//       would be better to decorate the type from the upstream package.
			/** @type {any} */
			const tmpControl = tmpTuiGridView.tuiGrid;
			tmpControl.View = pView;
			tmpControl.Group = pGroup;
		}

		return true;
	}

	/**
	 * Marshals data from a view to a form in the TuiGrid layout.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @returns {boolean} - Returns true if the data marshaling is successful, false otherwise.
	 */
	onDataMarshalToForm(pView, pGroup)
	{
		let tmpTuiGridView = this.getViewGrid(pView, pGroup);

		if (!tmpTuiGridView)
		{
			this.log.error(`PICT Form TuiGrid [${pView.UUID}]::[${pView.Hash}] error marshalling data to form: missing TuiGrid for group ${pGroup.GroupIndex}; skipping marshal.`);
			return false;
		}

		// painstakingly compare each value for now.
		let tmpTabularRecordSet = pView.getTabularRecordSet(pGroup.GroupIndex);
		let tmpBrowserRecordSet = tmpTuiGridView.tuiGrid.getData();

		if (Array.isArray(tmpTabularRecordSet))
		{
			for (let j = 0; j < tmpTabularRecordSet.length; j++)
			{
				try
				{
					let tmpStoredRowData = tmpTabularRecordSet[j];
					// Get the tuigrid row that represents AppData
					let tmpBrowserRowData = tmpBrowserRecordSet[j];
					// Enumerate each entry in the manifest and see if changes happened
					for (let k = 0; k < pGroup.supportingManifest.elementAddresses.length; k++)
					{
						let tmpElementDescriptor = pGroup.supportingManifest.elementDescriptors[pGroup.supportingManifest.elementAddresses[k]];
						if (tmpElementDescriptor)
						{
							let tmpBrowserValue = pGroup.supportingManifest.getValueAtAddress(tmpBrowserRowData, tmpElementDescriptor.Hash);
							let tmpAppStateValue = pGroup.supportingManifest.getValueByHash(tmpStoredRowData, tmpElementDescriptor.Hash);
							if (tmpBrowserValue !== tmpAppStateValue)
							{
								this.log.trace(`PICT Form TuiGrid Dynamic View [${pView.UUID}]::[${pView.Hash}] updating tabular record ${j} element ${tmpElementDescriptor.Hash} from [${tmpBrowserValue}] to [${tmpAppStateValue}].`);
								tmpTuiGridView.tuiGrid.setValue(j, tmpElementDescriptor.Hash, tmpAppStateValue);
							}
						}
					}
				}
				catch (pError)
				{
					this.log.error(`PICT Form TuiGrid [${pView.UUID}]::[${pView.Hash}] gross error marshalling data to form: ${pError}`);
				}
			}
		}

		return true;
	}

	/**
	 * Adds a new row to the Pict-Layout-TuiGrid.
	 *
	 * @param {string} pViewHash - The hash of the PICT form view.
	 * @param {number} pGroupIndex - The index of the group in the view.
	 * @returns {boolean} Returns false if there is an error adding the row, otherwise returns true.
	 */
	addRow(pViewHash, pGroupIndex)
	{
		if (!(pViewHash in this.pict.views))
		{
			this.log.error(`PICT Form View [${pViewHash}] error adding row: no matching view found in pict.`);
			return false;
		}
		let tmpView = this.pict.views[pViewHash];
		let tmpGroup = tmpView.getGroup(pGroupIndex);
		if (!tmpGroup)
		{
			this.log.error(`PICT Form View [${pViewHash}] error adding row: no matching group index ${pGroupIndex} found in view.`);
			return false;
		}

		let tmpDestinationObject = tmpView.sectionManifest.getValueByHash(tmpView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
		let tmpNewObject = tmpGroup.supportingManifest.populateDefaults({});

		if (Array.isArray(tmpDestinationObject))
		{
			tmpDestinationObject.push(tmpNewObject);
		}
		else if (typeof(tmpDestinationObject) === 'object')
		{
			let tmpRowIndex = tmpView.fable.getUUID();
			tmpDestinationObject[tmpRowIndex] = tmpNewObject;
		}

		// Add it to the TUIGrid
		let tmpTuiGridView = this.getViewGrid(tmpView, tmpGroup);
		if (tmpTuiGridView)
		{
			tmpTuiGridView.tuiGrid.appendRow(JSON.parse(JSON.stringify(tmpNewObject)));
		}
	}
}

module.exports = TuiGridLayout;

},{"../Pict-Provider-DynamicLayout.js":69,"./Pict-Layout-TuiGrid/Pict-Section-TuiGrid.js":103}],103:[function(require,module,exports){
const libPictSectionTuiGrid = require('pict-section-tuigrid');

/**
 * TuiGridLayout class represents a layout for TuiGrid in the Pict-Layout-TuiGrid module.
 * @extends libPictSectionTuiGrid
 */
class TuiGridLayout extends libPictSectionTuiGrid
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.viewGridConfigurations = {};

		this.cachedGridData = [];
	}

	/**
	 * Custom configuration for the grid settings -- fires when
	 *
	 * Sets the grid data to the cached grid data for the tuigrid.
	 *
	 * @returns {any} The result of the super.customConfigureGridSettings() method.
	 */
	customConfigureGridSettings()
	{
		// Set the grid data to the cached grid data
		this.gridSettings.data = this.cachedGridData;
		return super.customConfigureGridSettings();
	}

	/**
	 * Handles the change event in the Pict-Section-TuiGrid component.
	 *
	 * Updates the state in the model based on the grid changes.  This is
	 *
	 * @param {Object} pChangeData - The change data object.
	 * @returns {any} - The result of the super changeHandler method.
	 */
	changeHandler(pChangeData)
	{
		// Update the state in our model based on the grid

		for (let i = 0; i < pChangeData.changes.length; i++)
		{
			let tmpChange = pChangeData.changes[i];
			let tmpRowIndex = pChangeData.instance.getValue(tmpChange.rowKey, 'RecordIndex');
			// TODO: Right now each of these calls runs a solve() on the entire form.  This is not ideal.
			pChangeData.instance.View.setDataTabularByHash(pChangeData.instance.Group.GroupIndex, tmpChange.columnName, tmpRowIndex, tmpChange.value);
		}

		return super.changeHandler(pChangeData);
	}
}

module.exports = TuiGridLayout;

},{"pict-section-tuigrid":223}],104:[function(require,module,exports){
const libPictSectionGroupLayout = require('../Pict-Provider-DynamicLayout.js');

class VerticalRecordLayout extends libPictSectionGroupLayout
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Generate a group layout template for a single-record dynamically generated group view.
	 *
	 * This is the standard name / field entry form that you're used to filling out for addresses
	 * and such.
	 *
	 * @param {object} pView - The view to generate the dynamic group layout for
	 * @param {object} pGroup - The group to generate and inject dynamic layout templates
	 * @returns {string} - The template for the group
	 */
	generateGroupLayoutTemplate(pView, pGroup)
	{
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		let tmpTemplate = '';

		if (!('Rows' in pGroup))
		{
			pGroup.Rows = [];
		}

		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Prefix`, `getGroup("${pGroup.GroupIndex}")`);
		// Every input has its own "row" in the vertical layout
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-VerticalRow-Prefix`, `getGroup("${pGroup.GroupIndex}")`);

		for (let j = 0; j < pGroup.Rows.length; j++)
		{
			let tmpRow = pGroup.Rows[j];
			// There are three row layouts: Record, Tabular and Columnar
			for (let k = 0; k < tmpRow.Inputs.length; k++)
			{	
				let tmpInput = tmpRow.Inputs[k];
				// Update the InputIndex to match the current render config
				tmpInput.PictForm.InputIndex = k;
				tmpInput.PictForm.GroupIndex = pGroup.GroupIndex;
				tmpInput.PictForm.RowIndex = j;

				tmpTemplate += tmpMetatemplateGenerator.getVerticalInputMetatemplateTemplateReference(pView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("${pGroup.GroupIndex}","${j}","${k}")`);
			}
		}

		// Close every input that has its own "row" in the vertical layout
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-VerticalRow-Postfix`, `getGroup("${pGroup.GroupIndex}")`);
		tmpTemplate += tmpMetatemplateGenerator.getMetatemplateTemplateReference(pView, `-Template-Group-Postfix`, `getGroup("${pGroup.GroupIndex}")`);

		return tmpTemplate;
	}
}

module.exports = VerticalRecordLayout;

},{"../Pict-Provider-DynamicLayout.js":69}],105:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class ManifestConversionToCSV extends libFableServiceProviderBase
{
    constructor(pFable, pOptions, pServiceHash)
    {
        super(pFable, pOptions, pServiceHash);

        /** @type {import('pict') & { instantiateServiceProviderWithoutRegistration: (hash: string, options?: any, uuid?: string) => any }} */
        this.fable;
        /** @type {any} */
        this.log;
        /** @type {string} */
        this.UUID;

        this.CSV_HEADER = [
            "Form",
            "Form Name",
            "SubManifest",
			"HideTabularEditingControls",
			"GroupRecordSetAddress",
            "DataOnly",
            "Section Name",
            "Section Hash",
            "Group Name",
            "Group Hash",
            "Group Layout",
            "Group CSS",
            "Group Show Title",
            "Row",
            "Width",
            "Minimum Row Count",
            "Maximum Row Count",
            "Input Address",
            "Input Name",
            "Input Hash",
            "Input Extra",
            "Units",
            "DataType",
            "Decimal Precision",
            "InputType",
            "Equation",
            "Equation Ordinal",
            "Default",
            "Description",
            "Tooltip",
            "Input Notes",
            "Entity",
            "EntityColumnFilter",
            "EntityDestination",
            "EntitySingleRecord",
            "TriggerGroup",
            "TriggerAddress",
            "TriggerAllInputs",
            "MarshalEmptyValues",
            "ChartType",
            "ChartLabelsAddress",
            "ChartLabelsSolver",
            "ChartDatasetsAddress",
            "ChartDatasetsLabel",
            "ChartDatasetsSolvers"
        ];

        // Generate the header to column mapping
        this.CSV_COLUMN_MAP = {};
        for (let i = 0; i < this.CSV_HEADER.length; i++)
        {
            let tmpColumnName = this.CSV_HEADER[i];
            this.CSV_COLUMN_MAP[tmpColumnName] = i;
        }
    }

    getRowFromDescriptor(pForm, pDescriptorKey, pDescriptor)
    {
        let tmpRow = new Array(this.CSV_HEADER.length).fill('');

        if ((!pDescriptor) || (typeof(pDescriptor) !== 'object') || !pDescriptorKey || (typeof(pDescriptorKey) !== 'string'))
        {
            return false;
        }

        let tmpPictForm = pDescriptor.PictForm;

        tmpRow[this.CSV_COLUMN_MAP["Form"]] = pForm;
        tmpRow[this.CSV_COLUMN_MAP["Form Name"]] = pDescriptor.FormName || '';
        tmpRow[this.CSV_COLUMN_MAP["SubManifest"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["DataOnly"]] = (typeof(tmpPictForm) === 'undefined') ? '1' : '';
        tmpRow[this.CSV_COLUMN_MAP["Section Name"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Section Hash"]] = (tmpPictForm && tmpPictForm.Section) ? tmpPictForm.Section
														: (pDescriptor.FormSection) ? pDescriptor.FormSection
														: '';
        tmpRow[this.CSV_COLUMN_MAP["Group Name"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Group Hash"]] = (tmpPictForm && tmpPictForm.Group) ? tmpPictForm.Group
														: (pDescriptor.FormGroup) ? pDescriptor.FormGroup
														: '';
        tmpRow[this.CSV_COLUMN_MAP["Group Layout"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Group CSS"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Group Show Title"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Row"]] = (tmpPictForm && tmpPictForm.Row) ? tmpPictForm.Row : '';
        tmpRow[this.CSV_COLUMN_MAP["Width"]] = (tmpPictForm && tmpPictForm.Width) ? tmpPictForm.Width : '';
        tmpRow[this.CSV_COLUMN_MAP["Minimum Row Count"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Maximum Row Count"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Input Address"]] = (pDescriptor.DataAddress) ? pDescriptor.DataAddress : pDescriptorKey;
        tmpRow[this.CSV_COLUMN_MAP["Input Name"]] = pDescriptor.Name || pDescriptor.DataAddress || pDescriptorKey;
        tmpRow[this.CSV_COLUMN_MAP["Input Hash"]] = pDescriptor.Hash || pDescriptorKey;
        tmpRow[this.CSV_COLUMN_MAP["Input Extra"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Units"]] = (tmpPictForm && tmpPictForm.Units) ? tmpPictForm.Units : '';
        tmpRow[this.CSV_COLUMN_MAP["DataType"]] = pDescriptor.DataType || 'String';
        tmpRow[this.CSV_COLUMN_MAP["Decimal Precision"]] = (tmpPictForm && tmpPictForm.DecimalPrecision) ? tmpPictForm.DecimalPrecision : '';
        tmpRow[this.CSV_COLUMN_MAP["InputType"]] = (tmpPictForm && tmpPictForm.InputType) ? tmpPictForm.InputType : '';
        tmpRow[this.CSV_COLUMN_MAP["Equation"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["Default"]] = (pDescriptor.Default !== undefined) ? pDescriptor.Default : '';
        tmpRow[this.CSV_COLUMN_MAP["Description"]] = (pDescriptor.Description) ? pDescriptor.Description : '';
        tmpRow[this.CSV_COLUMN_MAP["Tooltip"]] = (tmpPictForm && tmpPictForm.Tooltip) ? tmpPictForm.Tooltip : '';
        tmpRow[this.CSV_COLUMN_MAP["Input Notes"]] = (tmpPictForm && tmpPictForm.SpreadsheetNotes) ? tmpPictForm.SpreadsheetNotes : '';

        tmpRow[this.CSV_COLUMN_MAP["Entity"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["EntityColumnFilter"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["EntityDestination"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["EntitySingleRecord"]] = '';
		/**
		tmpDescriptor.PictForm.EntitiesBundle = [
				{
					"Entity": tmpRecord.Entity,
					"Filter": `FBV~${tmpRecord.EntityColumnFilter}~EQ~{~D:Record.Value~}`,
					"Destination": tmpRecord.EntityDestination,
					// This marshals a single record
					"SingleRecord": tmpRecord.EntitySingleRecord ? true : false
				}
			]
		 */
		if (tmpPictForm && tmpPictForm.EntitiesBundle && Array.isArray(tmpPictForm.EntitiesBundle) && tmpPictForm.EntitiesBundle.length > 0)
		{
			let tmpEntityBundle = tmpPictForm.EntitiesBundle[0];
			if (tmpEntityBundle.Entity)
			{
				tmpRow[this.CSV_COLUMN_MAP["Entity"]] = tmpEntityBundle.Entity;
			}
			// Pull the filter column out if we can; we only want what's between "FBV~" and "~EQ~"
			if (tmpEntityBundle.Filter)
			{
				let tmpFilter = tmpEntityBundle.Filter;
				let tmpFilterStart = tmpFilter.indexOf('FBV~');
				let tmpFilterEnd = tmpFilter.indexOf('~EQ~');
				if ((tmpFilterStart >= 0) && (tmpFilterEnd > tmpFilterStart))
				{
					let tmpColumnFilter = tmpFilter.substring(tmpFilterStart + 4, tmpFilterEnd);
					tmpRow[this.CSV_COLUMN_MAP["EntityColumnFilter"]] = tmpColumnFilter;
				}
			}
			if (tmpEntityBundle.Destination)
			{
				tmpRow[this.CSV_COLUMN_MAP["EntityDestination"]] = tmpEntityBundle.Destination;
			}
			if (tmpEntityBundle.SingleRecord)
			{
				tmpRow[this.CSV_COLUMN_MAP["EntitySingleRecord"]] = 'true';
			}
		}

        tmpRow[this.CSV_COLUMN_MAP["TriggerGroup"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["TriggerAddress"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["TriggerAllInputs"]] = '';
        tmpRow[this.CSV_COLUMN_MAP["MarshalEmptyValues"]] = '';
		if (tmpPictForm && tmpPictForm.AutofillTriggerGroup)
		{
			// Grab the first trigger group and put it in here.
			let tmpTriggerGroup;
			if (Array.isArray(tmpPictForm.AutofillTriggerGroup) && tmpPictForm.AutofillTriggerGroup.length > 0)
			{
				tmpTriggerGroup = tmpPictForm.AutofillTriggerGroup[0];
			}
			else if (typeof(tmpPictForm.AutofillTriggerGroup) === 'object')
			{
				tmpTriggerGroup = tmpPictForm.AutofillTriggerGroup;
			}
			if (tmpTriggerGroup)
			{
				if (tmpTriggerGroup.TriggerGroupHash)
				{
					tmpRow[this.CSV_COLUMN_MAP["TriggerGroup"]] = tmpTriggerGroup.TriggerGroupHash;
				}
				if (tmpTriggerGroup.TriggerAllInputs)
				{
					tmpRow[this.CSV_COLUMN_MAP["TriggerAllInputs"]] = 'true';
				}
				if (tmpTriggerGroup.TriggerAddress)
				{
					tmpRow[this.CSV_COLUMN_MAP["TriggerAddress"]] = tmpTriggerGroup.TriggerAddress;
				}
				if (tmpTriggerGroup.MarshalEmptyValues)
				{
					tmpRow[this.CSV_COLUMN_MAP["MarshalEmptyValues"]] = 'true';
				}
			}
		}
        tmpRow[this.CSV_COLUMN_MAP["ChartType"]] = (tmpPictForm && tmpPictForm.ChartType) ? tmpPictForm.ChartType : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartLabelsAddress"]] = (tmpPictForm && tmpPictForm.ChartLabelsAddress) ? tmpPictForm.ChartLabelsAddress : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartLabelsSolver"]] = (tmpPictForm && tmpPictForm.ChartLabelsSolver) ? tmpPictForm.ChartLabelsSolver : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartDatasetsAddress"]] = (tmpPictForm && tmpPictForm.ChartDatasetsAddress) ? tmpPictForm.ChartDatasetsAddress : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartDatasetsLabel"]] = (tmpPictForm && tmpPictForm.ChartDatasetsSolvers && Array.isArray(tmpPictForm.ChartDatasetsSolvers) && tmpPictForm.ChartDatasetsSolvers.length > 0) ? tmpPictForm.ChartDatasetsSolvers[0].Label : '';
        tmpRow[this.CSV_COLUMN_MAP["ChartDatasetsSolvers"]] = (tmpPictForm && tmpPictForm.ChartDatasetsSolvers && Array.isArray(tmpPictForm.ChartDatasetsSolvers) && tmpPictForm.ChartDatasetsSolvers.length > 0) ? tmpPictForm.ChartDatasetsSolvers[0].DataSolver : '';

		if (tmpPictForm && (tmpPictForm.InputType == 'Option') && tmpPictForm.SelectOptions && Array.isArray(tmpPictForm.SelectOptions))
		{
			// Pull the select options into the Input Extra field as a comma-delimited list
			let tmpInputExtraOptions = '';

			for (let i = 0; i < tmpPictForm.SelectOptions.length; i++)
			{
				let tmpOption = tmpPictForm.SelectOptions[i];

				if (tmpOption.id && tmpOption.text)
				{
					if (tmpInputExtraOptions.length > 0)
					{
						tmpInputExtraOptions += ',';
					}
					tmpInputExtraOptions += `${tmpOption.id}^${tmpOption.text}`;
				}
			}

            tmpRow[this.CSV_COLUMN_MAP["Input Extra"]] = tmpInputExtraOptions;
		}

        return tmpRow;
    }

    createTabularArrayFromManifests(pManifest)
    {
        // CSV_COLUMN_MAP is already initialized in constructor

        // Convert the manifest to an array of CSV rows
        let tmpCSVRows = [];

        // Figure out the form
        let tmpForm = 'Default';
        if ((pManifest) && (pManifest.Scope) && (typeof(pManifest.Scope) === 'string'))
        {
            tmpForm = pManifest.Scope;
        }
        if ((pManifest) && (pManifest.Form) && (typeof(pManifest.Form) === 'string'))
        {
            tmpForm = pManifest.Form;
        }

        // Add the header row
        tmpCSVRows.push(this.CSV_HEADER);

        if (typeof(pManifest) !== 'object')
        {
            this.log.error('ManifestConversionToCSV: Provided manifest is not an object; cannot convert to CSV.');
            return tmpCSVRows;
        }

        if (!pManifest.Descriptors || (typeof(pManifest.Descriptors) !== 'object'))
        {
            this.log.error('ManifestConversionToCSV: Provided manifest does not have a valid Descriptors property; cannot convert to CSV.');
            return tmpCSVRows;
        }

        let tmpDescriptorKeys = Object.keys(pManifest.Descriptors);
        for (let i = 0; i < tmpDescriptorKeys.length; i++)
        {
            let tmpDescriptorKey = tmpDescriptorKeys[i];
            let tmpDescriptor = pManifest.Descriptors[tmpDescriptorKey];

            if ((!tmpDescriptor) || (typeof(tmpDescriptor) !== 'object'))
            {
                continue;
            }

            let tmpCSVRow = this.getRowFromDescriptor(tmpForm, tmpDescriptorKey, tmpDescriptor);
            if (tmpCSVRow)
            {
                tmpCSVRows.push(tmpCSVRow);
            }
        }

        for (let i = 0; i < pManifest.Sections.length; i++)
        {
            let tmpSection = pManifest.Sections[i];
            let tmpSectionHash = tmpSection.Hash || 'DEFAULT_SECTION_HASH';

            if ((!tmpSection) || (typeof(tmpSection) !== 'object'))
            {
                continue;
            }

            // See if the group has a name and decorate the manifest entry with the group name
            if (tmpSection.Groups && Array.isArray(tmpSection.Groups))
            {
                for (let j = 0; j < tmpSection.Groups.length; j++)
                {
                    let tmpGroup = tmpSection.Groups[j];
                    let tmpGroupHash = tmpGroup.Hash;

					if ((tmpGroup.Layout == 'Tabular') || (tmpGroup.Layout == 'RecordSet'))
					{
						// Pull in the reference manifest for this tabular set
						/*
							{
								"Name": "Boxes",
								"Hash": "BoxCollGrp",
								"Rows": [],
								"RecordSetSolvers": [
									"BoxFloorspace = BoxWidth * BoxDepth",
									"BoxVolume = BoxFloorspace * BoxHeight"
								],
								"MinimumRowCount": 3,
								"MaximumRowCount": 10,
								"ShowTitle": true,
								"Layout": "Tabular",
								"RecordSetAddress": "Boxes",
								"RecordManifest": "BoxCollectionData"
							}
						*/
			   			// Validate there is a RecordSetAddress and RecordManifest
						if (tmpGroup.RecordSetAddress && tmpGroup.RecordManifest)
						{
							// Find the Array placeholder in the CSV
							let tmpGroupArrayPlaceholderIndex = -1;
							for (let k = 0; k < tmpCSVRows.length; k++)
							{
								let tmpRow = tmpCSVRows[k];
								if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
								{
									let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
									let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
									if ((tmpRowSectionHash === tmpSectionHash) && (tmpRowGroupHash === tmpGroupHash))
									{
										// This is the row for this group
										tmpGroupArrayPlaceholderIndex = k;
										break;
									}

									// Try to match on the Input Address as a fallback
									let tmpRowInputAddress = tmpRow[this.CSV_COLUMN_MAP["Input Address"]];
									if (tmpRowInputAddress === tmpGroup.RecordSetAddress)
									{
										// Set the section and group hash here, this is an old manifest
										tmpRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
										tmpRow[this.CSV_COLUMN_MAP["Group Hash"]] = tmpGroupHash;
										tmpGroupArrayPlaceholderIndex = k;
										break;
									}
								}
							}
							if (tmpGroupArrayPlaceholderIndex >= 0)
							{
								let tmpRow = tmpCSVRows[tmpGroupArrayPlaceholderIndex];

								// Set the SubManifest on the placeholder row
								tmpRow[this.CSV_COLUMN_MAP["SubManifest"]] = tmpGroup.RecordManifest;
								tmpRow[this.CSV_COLUMN_MAP["GroupRecordSetAddress"]] = tmpGroup.RecordSetAddress;
								tmpRow[this.CSV_COLUMN_MAP["HideTabularEditingControls"]] = tmpGroup.HideTabularEditingControls;

								// Now set the Minimum and Maximum Row Counts
								if (tmpGroup.MinimumRowCount)
								{
									tmpRow[this.CSV_COLUMN_MAP["Minimum Row Count"]] = tmpGroup.MinimumRowCount;
								}
								if (tmpGroup.MaximumRowCount)
								{
									tmpRow[this.CSV_COLUMN_MAP["Maximum Row Count"]] = tmpGroup.MaximumRowCount;
								}

								// Find the reference manifest, pull in the descriptors, and create rows for each
								let tmpReferenceManifest = pManifest.ReferenceManifests[tmpGroup.RecordManifest];
								let tmpReferenceManifestDescriptorKeys = Object.keys(tmpReferenceManifest.Descriptors);
								for (let m = 0; m < tmpReferenceManifestDescriptorKeys.length; m++)
								{
									let tmpReferenceDescriptorKey = tmpReferenceManifestDescriptorKeys[m];
									let tmpReferenceDescriptor = tmpReferenceManifest.Descriptors[tmpReferenceDescriptorKey];

									if ((!tmpReferenceDescriptor) || (typeof(tmpReferenceDescriptor) !== 'object'))
									{
										continue;
									}

									let tmpReferenceCSVRow = this.getRowFromDescriptor(tmpForm, tmpReferenceDescriptorKey, tmpReferenceDescriptor);
									if (tmpReferenceCSVRow)
									{
										// Set the Section and Group Hashes on this row
										tmpReferenceCSVRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
										tmpReferenceCSVRow[this.CSV_COLUMN_MAP["Group Hash"]] = tmpGroupHash;

										// Set the SubManifest on this row
										tmpReferenceCSVRow[this.CSV_COLUMN_MAP["SubManifest"]] = tmpGroup.RecordManifest;

										// Insert this row after the placeholder
										tmpCSVRows.splice(tmpGroupArrayPlaceholderIndex + 1, 0, tmpReferenceCSVRow);
									}
								}
							}
						}
					}

                    if (tmpGroupHash)
                    {
                        for (let k = 0; k < tmpCSVRows.length; k++)
                        {
                            let tmpRow = tmpCSVRows[k];
                            if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
                            {
                                let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
                                if (tmpRowGroupHash === tmpGroupHash)
                                {
                                    // This is the row for this group
                                    tmpRow[this.CSV_COLUMN_MAP["Group Name"]] = tmpGroup.Name || tmpGroupHash;
									if (tmpGroup.Layout)
									{
										tmpRow[this.CSV_COLUMN_MAP["Group Layout"]] = tmpGroup.Layout;
									}
									if (tmpGroup.hasOwnProperty('ShowTitle'))
									{
										tmpRow[this.CSV_COLUMN_MAP["Group Show Title"]] = tmpGroup.ShowTitle;
									}
									if (tmpGroup.hasOwnProperty('CSSClass'))
									{
										tmpRow[this.CSV_COLUMN_MAP["Group CSS"]] = tmpGroup.CSSClass;
									}
                                }
                            }
                        }
                    }
                }
            }

			// See if there is a section name and decorate the manifest entries with the name
            for (let j = 0; j < tmpCSVRows.length; j++)
            {
                let tmpRow = tmpCSVRows[j];
                if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
                {
                    let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
                    if (tmpRowSectionHash === tmpSectionHash)
                    {
                        // This is the row for this section
                        tmpRow[this.CSV_COLUMN_MAP["Section Name"]] = tmpSection.Name || tmpSectionHash;
                    }
                }
            }

			// Now go through the section and group solvers, and decorate the appropriate rows
			if (tmpSection.Solvers && Array.isArray(tmpSection.Solvers))
			{
				for (let j = 0; j < tmpSection.Solvers.length; j++)
				{
					let tmpSolver = tmpSection.Solvers[j];
					let tmpSolverAssigned = false;

					// find an unused row in this section to decorate
					for (let k = 0; k < tmpCSVRows.length; k++)
					{
						let tmpRow = tmpCSVRows[k];
						if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
						{
							let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
							let tmpRowEquation = tmpRow[this.CSV_COLUMN_MAP["Equation"]];
							let tmpRowSubManifest = tmpRow[this.CSV_COLUMN_MAP["SubManifest"]];
							// If it's in the section
							if ((tmpRowSectionHash === tmpSectionHash)
									// And it isn't a tabular row
									&& (!tmpRowSubManifest || (tmpRowSubManifest == ''))
									// And an equation hasn't been set already
									&& (!tmpRowEquation || (tmpRowEquation.length == 0)))
							{
								// This is an unused row for this section
								if (typeof(tmpSolver) === 'string')
								{
									tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
									tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
								}
								else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
								{
									tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
									tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
								}
								tmpSolverAssigned = true;
								break;
							}
						}
					}
					// If the solver wasn't assigned, we have to create a hidden data only row for it and splice it in
					if (!tmpSolverAssigned)
					{
						let tmpHiddenSolverRow = new Array(this.CSV_HEADER.length).fill('');
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Form"]] = tmpForm;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
						// Set DataOnly
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataOnly"]] = '1';
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataType"]] = 'String';
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["InputType"]] = 'Hidden';
						// Generate an input hash and name that show its for a solver
						let tmpSolverInputHash = `Solver_for_${tmpSectionHash}_${j + 1}`;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Hash"]] = tmpSolverInputHash;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Name"]] = `Auto gen hidden solver entry for ${tmpSection.Name || tmpSectionHash} #${j + 1}`;
						tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Address"]] = tmpSolverInputHash;
						if (typeof(tmpSolver) === 'string')
						{
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
						}
						else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
						{
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
							tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
						}
						// Splice this row after the last row for this section
						let tmpLastSectionRowIndex = -1;
						for (let k = 0; k < tmpCSVRows.length; k++)
						{
							let tmpRow = tmpCSVRows[k];
							if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
							{
								let tmpRowSectionHash = tmpRow[this.CSV_COLUMN_MAP["Section Hash"]];
								if (tmpRowSectionHash === tmpSectionHash)
								{
									tmpLastSectionRowIndex = k;
								}
							}
						}
						if (tmpLastSectionRowIndex >= 0)
						{
							tmpCSVRows.splice(tmpLastSectionRowIndex + 1, 0, tmpHiddenSolverRow);
						}
						else
						{
							// Just push it on the end
							tmpCSVRows.push(tmpHiddenSolverRow);
						}
					}
				}
			}

			// Lastly enumerate the group solvers
			if (tmpSection.Groups && Array.isArray(tmpSection.Groups))
			{
				for (let j = 0; j < tmpSection.Groups.length; j++)
				{
					let tmpGroup = tmpSection.Groups[j];
					let tmpGroupHash = tmpGroup.Hash;

					if (tmpGroup.RecordSetSolvers && Array.isArray(tmpGroup.RecordSetSolvers))
					{
						for (let m = 0; m < tmpGroup.RecordSetSolvers.length; m++)
						{
							let tmpSolver = tmpGroup.RecordSetSolvers[m];
							let tmpSolverAssigned = false;

							// find an unused row in this group to decorate
							for (let k = 0; k < tmpCSVRows.length; k++)
							{
								let tmpRow = tmpCSVRows[k];
								if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
								{
									let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
									let tmpRowEquation = tmpRow[this.CSV_COLUMN_MAP["Equation"]];
									let tmpRowSubManifest = tmpRow[this.CSV_COLUMN_MAP["SubManifest"]];
									// If it's in the group
									if ((tmpRowGroupHash === tmpGroupHash)
											// And it is a tabular row
											&& (tmpRowSubManifest == tmpGroup.RecordManifest)
											// And an equation hasn't been set already
											&& (!tmpRowEquation || (tmpRowEquation.length == 0)))
									{
										// This is an unused row for this group
										if (typeof(tmpSolver) === 'string')
										{
											tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
											tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
										}
										else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
										{
											tmpRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
											tmpRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
										}
										tmpSolverAssigned = true;
										break;
									}
								}
							}
							// If the solver wasn't assigned, we have to create a hidden data only row for it and splice it in
							if (!tmpSolverAssigned)
							{
								let tmpHiddenSolverRow = new Array(this.CSV_HEADER.length).fill('');
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Form"]] = tmpForm;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Section Hash"]] = tmpSectionHash;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Group Hash"]] = tmpGroupHash;
								// Set the submanifest on the row
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["SubManifest"]] = tmpGroup.RecordManifest;
								// Set DataOnly
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataOnly"]] = '1';
								// Generate an input hash and name that show its for a solver
								let tmpSolverInputHash = `Solver_for_${tmpGroupHash}_${m + 1}`;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Hash"]] = tmpSolverInputHash;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Name"]] = `Auto gen hidden solver entry for ${tmpGroup.Name || tmpGroupHash} #${m + 1}`;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Input Address"]] = tmpSolverInputHash;
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["DataType"]] = 'String';
								tmpHiddenSolverRow[this.CSV_COLUMN_MAP["InputType"]] = 'Hidden';
								if (typeof(tmpSolver) === 'string')
								{
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver;
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = 1;
								}
								else if (typeof(tmpSolver) === 'object' && tmpSolver.Expression)
								{
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation"]] = tmpSolver.Expression;
									tmpHiddenSolverRow[this.CSV_COLUMN_MAP["Equation Ordinal"]] = tmpSolver.Ordinal || 1;
								}
								// Splice this row after the last row for this group
								let tmpLastGroupRowIndex = -1;
								for (let k = 0; k < tmpCSVRows.length; k++)
								{
									let tmpRow = tmpCSVRows[k];
									if ((tmpRow) && (Array.isArray(tmpRow)) && (tmpRow.length >= this.CSV_HEADER.length))
									{
										let tmpRowGroupHash = tmpRow[this.CSV_COLUMN_MAP["Group Hash"]];
										if (tmpRowGroupHash === tmpGroupHash)
										{
											tmpLastGroupRowIndex = k;
										}
									}
								}
								if (tmpLastGroupRowIndex >= 0)
								{
									tmpCSVRows.splice(tmpLastGroupRowIndex + 1, 0, tmpHiddenSolverRow);
								}
								else
								{
									// Just push it on the end
									tmpCSVRows.push(tmpHiddenSolverRow);
								}
							}
						}
					}
				}
			}
        }

		if (tmpCSVRows.length > 1)
		{
			// Add the FormName from the root of the manifest to the first row Form Name column
			let tmpFirstDataRow = tmpCSVRows[1];
			if (tmpFirstDataRow && pManifest.FormName)
			{
				tmpFirstDataRow[this.CSV_COLUMN_MAP["Form Name"]] = pManifest.FormName || tmpFirstDataRow[this.CSV_COLUMN_MAP["Form Name"]];
			}
		}

        return tmpCSVRows;
    }
}

module.exports = ManifestConversionToCSV;

},{"fable-serviceproviderbase":2}],106:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const _DefaultManifestSettings = (
	{
		Manifest: { Scope: 'Default' }
	});

class ManifestFactory extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultManifestSettings)), pOptions);
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { instantiateServiceProviderWithoutRegistration: (hash: string, options?: any, uuid?: string) => any, newManyfest: () => import('manyfest') }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;

		this.manifest = tmpOptions.Manifest;

		if (!('Descriptors' in this.manifest))
		{
			this.manifest.Descriptors = {};
		}
		if (!('Sections' in this.manifest))
		{
			this.manifest.Sections = [];
		}
		if (!('ReferenceManifests' in this.manifest))
		{
			this.manifest.ReferenceManifests = {};
		}
		this.referenceManifestFactories = {};

		this.sectionHashLookup = {};
		this.groupHashLookup = {};

		let tmpReferenceManifestKeys = Object.keys(this.manifest.ReferenceManifests);
		for (let i = 0; i < tmpReferenceManifestKeys.length; i++)
		{
			this.referenceManifestFactories[tmpReferenceManifestKeys[i]] = this.fable.instantiateServiceProviderWithoutRegistration('ManifestFactory', this.manifest.ReferenceManifests[tmpReferenceManifestKeys[i]], `${this.UUID}-${tmpReferenceManifestKeys[i]}`);
		}

		// Keep track of a numeric index that's unique to this form, for autogenerating identifiers.
		this.defaultHashCounter = 0;

		this._SanitizeObjectKeyRegex = /[^a-zA-Z0-9_]/gi;
		this._SanitizeObjectKeyReplacement = '_';
		this._SanitizeObjectKeyInvalid = 'INVALID';
	}

	/**
	 * Clean a string of any characters to create a consistent object key.
	 *
	 * @param {string} pString = The string to clean.
	 * @return {string} the cleaned string, or a placeholder if the input is invalid
	 */
	sanitizeObjectKey(pString)
	{
		if (typeof pString !== 'string' || pString.length < 1)
		{
			return this._SanitizeObjectKeyInvalid;
		}
		return pString.replace(this._SanitizeObjectKeyRegex, this._SanitizeObjectKeyReplacement);
	}

	/**
	 * Initialize the form groups.
	 *
	 * This function will initialize the form groups of a view based on the manifest.
	 *
	 * TODO: Figure out if this is the best place for this.  It *is* pretty useful for
	 * inferring manifests, so has uses outside of the view lifecycle.
	 *
	 * @param {Object} pView - The view to initialize form groups for
	 */
	initializeFormGroups(pView)
	{
		// Enumerate the manifest and make sure a group exists for each group in the section definition
		let tmpDescriptorKeys = Object.keys(pView.options.Manifests.Section.Descriptors);
		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			// TODO: Change this to use the parsed sectionManifest rather than parsing the manifest itself
			let tmpDescriptor = pView.options.Manifests.Section.Descriptors[tmpDescriptorKeys[i]];

			if (
				// If there is an obect in the descriptor
				typeof (tmpDescriptor) == 'object' &&
				// AND it has a PictForm property
				('PictForm' in tmpDescriptor) &&
				// AND the PictForm property is an object
				typeof (tmpDescriptor.PictForm) == 'object' &&
				// AND the PictForm object has a Section property
				('Section' in tmpDescriptor.PictForm) &&
				// AND the Section property matches our section hash
				tmpDescriptor.PictForm.Section == pView.sectionDefinition.Hash
			)
			{
				tmpDescriptor.PictForm.InformaryDataAddress = tmpDescriptorKeys[i];

				// Decorate the view hash for reverse lookup
				tmpDescriptor.PictForm.ViewHash = pView.Hash;

				let tmpGroupHash = (typeof (tmpDescriptor.PictForm.Group) == 'string') ? tmpDescriptor.PictForm.Group : 'Default';

				if (!('Groups' in pView.sectionDefinition))
				{
					pView.sectionDefinition.Groups = [];
				}
				let tmpGroup = pView.sectionDefinition.Groups.find((pGroup) => { return pGroup.Hash == tmpGroupHash; });
				if (!tmpGroup)
				{
					tmpGroup = { Hash: tmpGroupHash, Name: tmpGroupHash, Description: false, Rows: [] };
					pView.sectionDefinition.Groups.push(tmpGroup);
				}
				else if (!Array.isArray(tmpGroup.Rows))
				{
					tmpGroup.Rows = [];
				}

				let tmpRowHash = (typeof (tmpDescriptor.PictForm.Row) == 'string') ? tmpDescriptor.PictForm.Row :
					(typeof (tmpDescriptor.PictForm.Row) == 'number') ? `Row_${tmpDescriptor.PictForm.Row.toString()}` :
						'Row_Default';

				tmpDescriptor.PictForm.RowHash = tmpRowHash;

				let tmpRow = tmpGroup.Rows.find((pRow) => { return pRow.Hash == tmpRowHash; });

				if (!tmpRow)
				{
					tmpRow = { Hash: tmpRowHash, Name: tmpRowHash, Inputs: [] };
					tmpGroup.Rows.push(tmpRow);
					tmpRow.Inputs.push(tmpDescriptor);
				}
				else
				{
					tmpRow.Inputs.push(tmpDescriptor);
				}
			}
		}

		// Now check to see if we need to build group
		for (let i = 0; i < pView.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = pView.sectionDefinition.Groups[i];
			tmpGroup.GroupIndex = i;
			if ('HideTitle' in tmpGroup)
			{
				tmpGroup.HideTitle = false;
			}
			if (!tmpGroup.hasOwnProperty('Layout'))
			{
				tmpGroup.Layout = 'Record';
			}
			// Check if the group has a Rows array.
			// TODO: Is no rows valid?  Maaaaaybe?  Layouts makes this compelling.
			if (!tmpGroup.hasOwnProperty('Rows') || !Array.isArray(tmpGroup.Rows))
			{
				tmpGroup.Rows = [];
			}

			// Check if the group has a supporting manifest and load it.
			if ('RecordManifest' in tmpGroup)
			{
				tmpGroup.supportingManifest = pView.fable.instantiateServiceProviderWithoutRegistration('Manifest', pView.options.Manifests.Section.ReferenceManifests[tmpGroup.RecordManifest]);
			}
			if (tmpGroup.supportingManifest)
			{
				let tmpSupportingManifestDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
				for (let k = 0; k < tmpSupportingManifestDescriptorKeys.length; k++)
				{
					let tmpInput = tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestDescriptorKeys[k]];
					tmpInput.IsTabular = true;

					if (!('PictForm' in tmpInput))
					{
						tmpInput.PictForm = {};
					}
					tmpInput.PictForm.ViewHash = pView.Hash;

					tmpInput.PictForm.InformaryDataAddress = tmpSupportingManifestDescriptorKeys[k];
					if (typeof (tmpGroup.RecordSetAddress) == 'string')
					{
						tmpInput.PictForm.InformaryContainerAddress = tmpGroup.RecordSetAddress;
					}
					tmpInput.RowIdentifierTemplateHash = '{~D:Record.RowID~}';
				}

				// Resolve DynamicColumns generators once at init so the supporting manifest
				// is fully populated before the layout template is generated.
				if (Array.isArray(tmpGroup.DynamicColumns) && tmpGroup.DynamicColumns.length > 0)
				{
					this._resolveDynamicColumns(pView, tmpGroup);
				}
			}

			// Check if there is a record set address; initialize it if it doesn't exist
			if (tmpGroup.RecordSetAddress)
			{
				let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
				let tmpRecordSetDataObjectExists = pView.sectionManifest.checkAddressExistsByHash(tmpMarshalDestinationObject, tmpGroup.RecordSetAddress);
				let tmpRecordSetDataObject = pView.sectionManifest.getValueAtAddress(tmpMarshalDestinationObject, tmpGroup.RecordSetAddress);
				if (!tmpRecordSetDataObjectExists)
				{
					pView.log.warn(`Automatically setting an empty array at [${tmpGroup.RecordSetAddress}].`);
					pView.sectionManifest.setValueByHash(tmpMarshalDestinationObject, tmpGroup.RecordSetAddress, []);
				}
				else if (Array.isArray(tmpRecordSetDataObject))
				{
					pView.log.trace(`RecordSetAddress is an Array for [${tmpGroup.Hash}]`);
				}
				else if (typeof (tmpRecordSetDataObject) === 'object')
				{
					pView.log.trace(`RecordSetAddress is an Object for [${tmpGroup.Hash}]`);
				}
				else
				{
					pView.log.error(`RecordSetAddress is not an Array or Object for [${tmpGroup.Hash}]; it is a [${typeof (tmpRecordSetDataObject)}] -- likely the data shape will cause erratic problems.`);
				}

				// Check if there are default rows to add
				if (tmpGroup.MinimumRowCount)
				{
					if (!tmpRecordSetDataObject)
					{
						pView.sectionManifest.setValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress, []);
						tmpRecordSetDataObject = pView.sectionManifest.getValueByHash(pView.getMarshalDestinationObject(), tmpGroup.RecordSetAddress);
					}
					for (let i = tmpRecordSetDataObject.length; i < tmpGroup.MinimumRowCount; i++)
					{
						pView.pict.providers.DynamicTabularData.createDynamicTableRowWithoutEvents(pView, tmpGroup.GroupIndex);
					}
				}
			}
		}
	}

	/**
	 * Resolve a single template string against a record context.
	 *
	 * @param {string} pTemplate - The template string to resolve.
	 * @param {Object} pRecord - The record context to resolve against.
	 * @returns {string} The resolved string, or '' on failure.
	 */
	_parseDynamicColumnTemplate(pTemplate, pRecord)
	{
		if (typeof pTemplate !== 'string')
		{
			return '';
		}
		if (pTemplate.indexOf('{') === -1)
		{
			return pTemplate;
		}
		try
		{
			let tmpResult = this.fable.parseTemplate(pTemplate, pRecord, null);
			return (typeof tmpResult === 'string') ? tmpResult : '';
		}
		catch (pError)
		{
			this.log.warn(`PICT Form Tabular DynamicColumns template parse failed: ${pError && pError.message}`);
			return '';
		}
	}

	/**
	 * Resolve a Tabular Group's DynamicColumns generators into descriptors on its supportingManifest.
	 *
	 * NON-DESTRUCTIVE: descriptor pruning is structural only -- row record data at
	 * removed InformaryDataAddresses is never touched, so hidden data persists for
	 * later restoration if the source row reappears.
	 *
	 * InformaryDataAddressTemplate is resolved ONCE at descriptor generation time
	 * (Informary itself is a pure string concat at marshal time -- see
	 * Pict-Provider-Informary.getComposedContainerAddress).
	 *
	 * @param {Object} pView - The view containing the group.
	 * @param {Object} pGroup - The group object (must already have supportingManifest).
	 * @returns {{added: Array<string>, removed: Array<string>, unchanged: Array<string>, changed: boolean}}
	 */
	_resolveDynamicColumns(pView, pGroup)
	{
		let tmpEmpty = { added: [], removed: [], unchanged: [], changed: false };
		if (!pGroup || !Array.isArray(pGroup.DynamicColumns) || pGroup.DynamicColumns.length === 0)
		{
			return tmpEmpty;
		}
		if (!pGroup.supportingManifest)
		{
			this.log.warn(`PICT Form Tabular DynamicColumns on group [${pGroup.Hash}] skipped: no supportingManifest.`);
			return tmpEmpty;
		}
		if (!Array.isArray(pGroup.DynamicColumnsState))
		{
			pGroup.DynamicColumnsState = [];
		}

		let tmpMarshalDestinationObject = pView.getMarshalDestinationObject();
		let tmpSupportingManifest = pGroup.supportingManifest;

		let tmpAggregateAdded = [];
		let tmpAggregateRemoved = [];
		let tmpAggregateUnchanged = [];
		let tmpAggregateChanged = false;

		for (let i = 0; i < pGroup.DynamicColumns.length; i++)
		{
			let tmpGenerator = pGroup.DynamicColumns[i];
			if (!pGroup.DynamicColumnsState[i])
			{
				pGroup.DynamicColumnsState[i] = { LastHashes: [], LastHeaderGroups: [] };
			}
			let tmpState = pGroup.DynamicColumnsState[i];

			if (typeof tmpGenerator.SourceAddress !== 'string' || tmpGenerator.SourceAddress.length === 0)
			{
				this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} on group [${pGroup.Hash}] is missing SourceAddress.`);
				continue;
			}
			if (typeof tmpGenerator.HashTemplate !== 'string' || tmpGenerator.HashTemplate.length === 0)
			{
				this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} on group [${pGroup.Hash}] is missing HashTemplate.`);
				continue;
			}
			if (typeof tmpGenerator.InformaryDataAddressTemplate !== 'string' || tmpGenerator.InformaryDataAddressTemplate.length === 0)
			{
				this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} on group [${pGroup.Hash}] is missing InformaryDataAddressTemplate.`);
				continue;
			}

			let tmpSourceArray = pView.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpGenerator.SourceAddress);
			if (!Array.isArray(tmpSourceArray))
			{
				tmpSourceArray = [];
			}

			// Build the desired descriptor set from the current source array.
			let tmpDesiredHashes = [];
			let tmpDesiredDescriptors = {};
			let tmpDesiredHeaderGroups = [];
			let tmpSeenHashes = {};
			for (let k = 0; k < tmpSourceArray.length; k++)
			{
				let tmpSourceRow = tmpSourceArray[k];
				let tmpHash = this._parseDynamicColumnTemplate(tmpGenerator.HashTemplate, tmpSourceRow);
				if (!tmpHash)
				{
					continue;
				}
				if (tmpSeenHashes[tmpHash])
				{
					this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} produced duplicate Hash [${tmpHash}] on group [${pGroup.Hash}]; later row wins.`);
				}
				tmpSeenHashes[tmpHash] = true;

				let tmpName = tmpGenerator.NameTemplate
					? this._parseDynamicColumnTemplate(tmpGenerator.NameTemplate, tmpSourceRow)
					: tmpHash;
				let tmpInformaryDataAddress = this._parseDynamicColumnTemplate(tmpGenerator.InformaryDataAddressTemplate, tmpSourceRow);
				if (!tmpInformaryDataAddress)
				{
					this.log.warn(`PICT Form Tabular DynamicColumns generator ${i} produced empty InformaryDataAddress for row ${k} on group [${pGroup.Hash}]; skipping.`);
					continue;
				}
				let tmpHeaderGroup = tmpGenerator.HeaderGroupTemplate
					? this._parseDynamicColumnTemplate(tmpGenerator.HeaderGroupTemplate, tmpSourceRow)
					: '';

				let tmpDescriptor = {
					Hash: tmpHash,
					Name: tmpName || tmpHash,
					DataType: tmpGenerator.DataType || 'String',
					IsTabular: true,
					_DynamicColumnGeneratorIndex: i,
					_DynamicColumnHeaderGroup: tmpHeaderGroup,
					PictForm: Object.assign({}, tmpGenerator.PictForm || {}, {
						ViewHash: pView.Hash,
						InformaryContainerAddress: pGroup.RecordSetAddress,
						InformaryDataAddress: tmpInformaryDataAddress
					})
				};

				tmpDesiredHashes.push(tmpHash);
				tmpDesiredDescriptors[tmpHash] = tmpDescriptor;
				tmpDesiredHeaderGroups.push(tmpHeaderGroup);
			}

			// Diff against the cached last state.
			let tmpLastHashes = Array.isArray(tmpState.LastHashes) ? tmpState.LastHashes : [];
			let tmpDesiredSet = {};
			for (let h = 0; h < tmpDesiredHashes.length; h++)
			{
				tmpDesiredSet[tmpDesiredHashes[h]] = true;
			}
			let tmpRemoved = tmpLastHashes.filter((pHash) => { return !tmpDesiredSet[pHash]; });
			let tmpLastSet = {};
			for (let h = 0; h < tmpLastHashes.length; h++)
			{
				tmpLastSet[tmpLastHashes[h]] = true;
			}
			let tmpAdded = tmpDesiredHashes.filter((pHash) => { return !tmpLastSet[pHash]; });
			let tmpUnchanged = tmpDesiredHashes.filter((pHash) => { return tmpLastSet[pHash]; });
			let tmpHeaderGroupsChanged = JSON.stringify(tmpDesiredHeaderGroups) !== JSON.stringify(tmpState.LastHeaderGroups || []);
			let tmpOrderChanged = JSON.stringify(tmpDesiredHashes) !== JSON.stringify(tmpLastHashes);

			// Remove dropped descriptors from the supportingManifest entirely.
			for (let r = 0; r < tmpRemoved.length; r++)
			{
				let tmpHashToRemove = tmpRemoved[r];
				let tmpAddrIdx = tmpSupportingManifest.elementAddresses.indexOf(tmpHashToRemove);
				if (tmpAddrIdx >= 0)
				{
					tmpSupportingManifest.elementAddresses.splice(tmpAddrIdx, 1);
				}
				delete tmpSupportingManifest.elementDescriptors[tmpHashToRemove];
				if (tmpSupportingManifest.elementHashes && (tmpHashToRemove in tmpSupportingManifest.elementHashes))
				{
					delete tmpSupportingManifest.elementHashes[tmpHashToRemove];
				}
			}

			// Re-place all descriptors for this generator in the desired order at the InsertAt position.
			// First, pull them out so we can splice them back in as a contiguous block.
			for (let h = 0; h < tmpDesiredHashes.length; h++)
			{
				let tmpAddr = tmpDesiredHashes[h];
				let tmpExistingIdx = tmpSupportingManifest.elementAddresses.indexOf(tmpAddr);
				if (tmpExistingIdx >= 0)
				{
					tmpSupportingManifest.elementAddresses.splice(tmpExistingIdx, 1);
				}
				// Preserve an already-registered descriptor OBJECT rather than swapping in a
				// fresh one. The live descriptor carries the generated Macro (informary HTML
				// bindings) and InputIndex stamped during the last template build. Replacing
				// it with a fresh, Macro-less object silently breaks marshaling on any later
				// render() that is NOT accompanied by a template rebuild -- e.g. moving,
				// adding or deleting a row. Refresh only the data-derived fields in place.
				let tmpExistingDescriptor = tmpSupportingManifest.elementDescriptors[tmpAddr];
				if (tmpExistingDescriptor)
				{
					let tmpFreshDescriptor = tmpDesiredDescriptors[tmpAddr];
					tmpExistingDescriptor.Name = tmpFreshDescriptor.Name;
					tmpExistingDescriptor.DataType = tmpFreshDescriptor.DataType;
					tmpExistingDescriptor.IsTabular = tmpFreshDescriptor.IsTabular;
					tmpExistingDescriptor._DynamicColumnGeneratorIndex = tmpFreshDescriptor._DynamicColumnGeneratorIndex;
					tmpExistingDescriptor._DynamicColumnHeaderGroup = tmpFreshDescriptor._DynamicColumnHeaderGroup;
					if (!tmpExistingDescriptor.PictForm)
					{
						tmpExistingDescriptor.PictForm = {};
					}
					Object.assign(tmpExistingDescriptor.PictForm, tmpFreshDescriptor.PictForm);
					tmpDesiredDescriptors[tmpAddr] = tmpExistingDescriptor;
				}
				else
				{
					tmpSupportingManifest.elementDescriptors[tmpAddr] = tmpDesiredDescriptors[tmpAddr];
				}
				if (!tmpSupportingManifest.elementHashes)
				{
					tmpSupportingManifest.elementHashes = {};
				}
				tmpSupportingManifest.elementHashes[tmpAddr] = tmpAddr;
			}

			// Compute insertion index.
			let tmpInsertAt = tmpGenerator.InsertAt || 'End';
			let tmpInsertionIndex;
			if (tmpInsertAt === 'Start')
			{
				tmpInsertionIndex = 0;
			}
			else if (typeof tmpInsertAt === 'object' && tmpInsertAt !== null && typeof tmpInsertAt.After === 'string')
			{
				let tmpAfterIdx = tmpSupportingManifest.elementAddresses.indexOf(tmpInsertAt.After);
				tmpInsertionIndex = (tmpAfterIdx < 0) ? tmpSupportingManifest.elementAddresses.length : tmpAfterIdx + 1;
			}
			else
			{
				tmpInsertionIndex = tmpSupportingManifest.elementAddresses.length;
			}
			for (let h = 0; h < tmpDesiredHashes.length; h++)
			{
				tmpSupportingManifest.elementAddresses.splice(tmpInsertionIndex + h, 0, tmpDesiredHashes[h]);
			}

			tmpState.LastHashes = tmpDesiredHashes.slice();
			tmpState.LastHeaderGroups = tmpDesiredHeaderGroups.slice();

			if (tmpAdded.length || tmpRemoved.length || tmpHeaderGroupsChanged || tmpOrderChanged)
			{
				tmpAggregateChanged = true;
			}
			tmpAggregateAdded.push.apply(tmpAggregateAdded, tmpAdded);
			tmpAggregateRemoved.push.apply(tmpAggregateRemoved, tmpRemoved);
			tmpAggregateUnchanged.push.apply(tmpAggregateUnchanged, tmpUnchanged);
		}

		return {
			added: tmpAggregateAdded,
			removed: tmpAggregateRemoved,
			unchanged: tmpAggregateUnchanged,
			changed: tmpAggregateChanged
		};
	}

	/**
	 * Adds a manifest descriptor to the manifest.
	 *
	 * @param {Object} pManifestDescriptor - The manifest descriptor to add.
	 */
	addDescriptor(pManifestDescriptor)
	{
		if (pManifestDescriptor.DataAddress in this.manifest.Descriptors)
		{
			this.log.info('[ERROR] Duplicate descriptor hash found:', pManifestDescriptor);
		}
		this.manifest.Descriptors[pManifestDescriptor.DataAddress] = pManifestDescriptor;
	}

	/**
	 * Get a section from the manifest.
	 *
	 * @param {string} pSectionHash - The section Hash
	 *
	 * @return {Object} The manifest section object
	 */
	getManifestSection(pSectionHash)
	{
		for (const tmpSection of this.manifest.Sections)
		{
			if (tmpSection.Hash === pSectionHash)
			{
				return tmpSection;
			}
		}
		// Add the section if it do no exist
		const tmpSection = { Name: pSectionHash, Hash: pSectionHash, Solvers: [], Groups: [] };
		this.manifest.Sections.push(tmpSection);
		return tmpSection;
	}

	/**
	 * Get a group from a section.
	 *
	 * @param {string|Object} pManifestSection - The manifest Section -- either a Hash string or the object itself
	 * @param {string} pGroupHash - The group Hash
	 *
	 * @return {Object} The group object
	 */
	getManifestGroup(pManifestSection, pGroupHash)
	{
		let tmpManifestSection = (typeof (pManifestSection) === 'string') ? this.getManifestSection(pManifestSection) : pManifestSection;
		for (const tmpGroup of tmpManifestSection.Groups)
		{
			if (tmpGroup.Hash === pGroupHash)
			{
				return tmpGroup;
			}
		}
		// Add the group if it do no exist
		const tmpGroup = { Name: pGroupHash, Hash: pGroupHash, Rows: [], RecordSetSolvers: [] };
		tmpManifestSection.Groups.push(tmpGroup);
		return tmpGroup;
	}

	/**
	 * Lints a manifest record row.
	 * @param {Object} pRecord - The record to be linted.
	 * @returns {boolean} - Returns true if the record is valid, false otherwise.
	 */
	tabularRowLint(pRecord)
	{
		if (!pRecord)
		{
			this.log.error('Record is missing from record:', pRecord);
			return false;
		}
		if (!pRecord.Form)
		{
			this.log.error('Form is missing from record:', pRecord);
			return false;
		}
		return true;
	}

	decorateChartDescriptorFromTabularRow(pRecord, pDescriptor, pPostfix)
	{
		let tmpRecord = pRecord;
		let tmpDescriptor = pDescriptor;
		let tmpPostfix = pPostfix || '';

		// Log out the data coming in
		//this.log.debug(`Decorating chart descriptor from tabular row for ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`,{ Record: tmpRecord, Descriptor: tmpDescriptor });

		// Charts will pull in five extra pieces of config if they exist: ChartType, ChartLabelsAddress, ChartLabelsSolver, ChartDatasetsAddress, ChartDatasetsSolver
		if (tmpRecord.ChartType)
		{
			tmpDescriptor.PictForm.ChartType = tmpRecord.ChartType;
		}
		if (tmpPostfix == '')
		{
			// Maybe later this gets more advanced.
			if (tmpRecord.ChartLabelsAddress)
			{
				tmpDescriptor.PictForm.ChartLabelsAddress = tmpRecord.ChartLabelsAddress;
			}
			if (tmpRecord.ChartLabelsSolver)
			{
				tmpDescriptor.PictForm.ChartLabelsSolver = tmpRecord.ChartLabelsSolver;
			}
			if (tmpRecord.ChartDatasetsAddress)
			{
				tmpDescriptor.PictForm.ChartDatasetsAddress = tmpRecord.ChartDatasetsAddress;
			}
		}
		
		if (tmpRecord[`ChartDatasetsSolver${tmpPostfix}`])
		{
			let tmpSolverEntry = { DataSolver: tmpRecord[`ChartDatasetsSolver${tmpPostfix}`] };
			//this.log.debug(`Adding chart dataset solver for descriptor ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`, tmpSolverEntry);
			if (!tmpRecord[`ChartDatasetsLabel${tmpPostfix}`])
			{
				tmpSolverEntry.Label = 'Data';
			}
			else
			{
				tmpSolverEntry.Label = tmpRecord[`ChartDatasetsLabel${tmpPostfix}`];
			}
			if (tmpRecord[`ChartDataSetsSolverChartType${tmpPostfix}`])
			{
				tmpSolverEntry.ChartType = tmpRecord[`ChartDataSetsSolverChartType${tmpPostfix}`];
			}
			if (!tmpDescriptor.PictForm.ChartDatasetsSolvers || !Array.isArray(tmpDescriptor.PictForm.ChartDatasetsSolvers))
			{
				tmpDescriptor.PictForm.ChartDatasetsSolvers = [];
			}
			// Log and add the solver entry
			//this.log.debug(`Adding chart dataset solver entry for ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`, tmpSolverEntry);
			tmpDescriptor.PictForm.ChartDatasetsSolvers.push(tmpSolverEntry);
		}
		// Log the descripter going out
		//this.log.debug(`Decorated chart descriptor from tabular row for ${tmpDescriptor.Hash} with postfix [${tmpPostfix}]`, tmpDescriptor);
	}

	/**
	 * Add a manifest descriptor from a tabular row.
	 *
	 * @param {Object} pManifestFactory - The manifest factory
	 * @param {Object} pRecord - The tabular row record -- expected to have at least a 'Form'
	 *
	 * @return {Object} the descriptor
	 */
	tabularRowAddDescriptor(pManifestFactory, pRecord)
	{
		if (typeof (pRecord) !== 'object')
		{
			this.log.error(`Invalid record passed to addManifestDescriptor: ${pRecord}`);
			return false;
		}

		let tmpRecord = JSON.parse(JSON.stringify(pRecord));

		// Fill out required defaults on the row
		tmpRecord['Input Hash'] = tmpRecord['Input Hash']?.trim?.() || `DefaultHash${this.defaultHashCounter++}`;
		tmpRecord['Input Address'] = tmpRecord['Input Address']?.trim?.() || `DefaultData.InputHash_${tmpRecord['Input Hash']}`;
		tmpRecord['Input Name'] = tmpRecord['Input Name']?.trim?.() || `Auto Input ${tmpRecord['Input Hash']}`;
		tmpRecord.DataType = tmpRecord.DataType?.trim?.() || 'String';

		const tmpDescriptor = (
			{
				Hash: tmpRecord['Input Hash'],
				Name: tmpRecord['Input Name'],
				DataAddress: tmpRecord['Input Address'],
				DataType: tmpRecord.DataType,
				PictForm: {},
			});

		if (tmpRecord.Default)
		{
			tmpDescriptor.Default = tmpRecord.Default;
		}

		// Set the optional settings if they are present on the record
		if (tmpRecord.InputType)
		{
			tmpDescriptor.PictForm.InputType = tmpRecord.InputType;
		}
		if (tmpRecord.Row)
		{
			tmpDescriptor.PictForm.Row = tmpRecord.Row;
		}
		if (tmpRecord.Width)
		{
			tmpDescriptor.PictForm.Width = tmpRecord.Width;
		}

		if (tmpRecord['Input Notes'])
		{
			tmpDescriptor.PictForm.SpreadsheetNotes = tmpRecord['Input Notes'];
		}

		if (tmpRecord['Description'])
		{
			tmpDescriptor.Description = tmpRecord['Description'];
		}

		if (tmpRecord['Units'])
		{
			tmpDescriptor.PictForm.Units = tmpRecord['Units'];
		}

		if (tmpRecord['Tooltip'])
		{
			tmpDescriptor.PictForm.Tooltip = tmpRecord['Tooltip'];
		}

		if ((tmpDescriptor.PictForm.InputType == 'Option') && (tmpRecord['Input Extra']))
		{
			let tmpOptionSet = [];
			let tmpOptionSetValues = tmpRecord['Input Extra'].split(',');

			for (let i = 0; i < tmpOptionSetValues.length; i++)
			{
				if (tmpOptionSetValues[i].trim() != '')
				{
					let tmpOptionSetValuePair = tmpOptionSetValues[i].split('^');
					if (tmpOptionSetValuePair.length == 2)
					{
						tmpOptionSet.push({ id: tmpOptionSetValuePair[0].trim(), text: tmpOptionSetValuePair[1].trim() });
					}
					else
					{
						tmpOptionSet.push({ id: tmpOptionSetValues[i].trim(), text: tmpOptionSetValues[i].trim() });
					}
				}
			}

			if (tmpOptionSet.length > 0)
			{
				tmpDescriptor.PictForm.SelectOptions = tmpOptionSet;
			}
		}

		if (((tmpDescriptor.PictForm.InputType == 'TabSectionSelector') || (tmpDescriptor.PictForm.InputType == 'TabGroupSelector')) && (tmpRecord['Input Extra']))
		{
			let tmpTabSet = [];
			let tmpTabSetNames = [];
			let tmpTabSetConfiguredValues = tmpRecord['Input Extra'].split(',');

			for (let i = 0; i < tmpTabSetConfiguredValues.length; i++)
			{
				if (tmpTabSetConfiguredValues[i].trim() != '')
				{
					let tmpTabSetValuePair = tmpTabSetConfiguredValues[i].split('^');
					if (tmpTabSetValuePair.length >= 2)
					{
						tmpTabSet.push(tmpTabSetValuePair[0].trim());
						tmpTabSetNames.push(tmpTabSetValuePair[1].trim());
					}
					else
					{
						tmpTabSet.push(tmpTabSetValuePair[0].trim());
						tmpTabSetNames.push(tmpTabSetValuePair[0].trim());
					}
				}
			}

			if (tmpTabSet.length > 0)
			{
				if (tmpDescriptor.PictForm.InputType == 'TabSectionSelector')
				{
					tmpDescriptor.PictForm.TabSectionSet = tmpTabSet;
					tmpDescriptor.PictForm.TabSectionNames = tmpTabSetNames;
				}
				else if (tmpDescriptor.PictForm.InputType == 'TabGroupSelector')
				{
					tmpDescriptor.PictForm.TabGroupSet = tmpTabSet;
					tmpDescriptor.PictForm.TabGroupNames = tmpTabSetNames;
				}
			}
		}

		// Verbose obtuse data validation.
		if ((`TriggerGroup` in tmpRecord) && (typeof (tmpRecord.TriggerGroup) === 'string') && (tmpRecord.TriggerGroup != ''))
		{
			if (!Array.isArray(tmpDescriptor.PictForm.Providers))
			{
				tmpDescriptor.PictForm.Providers = [];
			}

			tmpDescriptor.PictForm.Providers.push('Pict-Input-AutofillTriggerGroup');
			if (!Array.isArray(tmpDescriptor.PictForm.AutofillTriggerGroup))
			{
				const tmpPreviousTriggerGroup = tmpDescriptor.PictForm.AutofillTriggerGroup;
				tmpDescriptor.PictForm.AutofillTriggerGroup = [];
				if (tmpPreviousTriggerGroup)
				{
					tmpDescriptor.PictForm.AutofillTriggerGroup.push(tmpPreviousTriggerGroup);
				}
			}
			const tmpTriggerGroupHashes = tmpRecord.TriggerGroup.split(',');
			const tmpTriggerAddresses = (`TriggerAddress` in tmpRecord) ? tmpRecord.TriggerAddress.split(',') : [];
			const tmpTriggerAllInputs = (`TriggerAllInputs` in tmpRecord) ? tmpRecord.TriggerAllInputs.split(',') : [];

			for (let i = 0; i < tmpTriggerGroupHashes.length; i++)
			{
				const tmpTriggerGroup =
				{
					TriggerGroupHash: tmpTriggerGroupHashes[i].trim(),
					MarshalEmptyValues: tmpRecord.MarshalEmptyValues ? true : false,
				};

				const tmpTriggerAddress = tmpTriggerAddresses[i]?.trim?.();
				if (tmpTriggerAddress)
				{
					tmpTriggerGroup.TriggerAddress = tmpTriggerAddress;
				}
				const tmpTriggerAllInput = tmpTriggerAllInputs[i]?.trim?.();
				if (tmpTriggerAllInput != null && (tmpTriggerAllInput.toLowerCase() == 'true' || tmpTriggerAllInput.toLowerCase() == 'x' || tmpTriggerAllInput.toLowerCase() == '1'))
				{
					tmpTriggerGroup.TriggerAllInputs = true;
				}
				// TODO: Ugh
				if (tmpDescriptor.PictForm.InputType == 'Option')
				{
					tmpTriggerGroup.SelectOptionsRefresh = true;
				}
				tmpDescriptor.PictForm.AutofillTriggerGroup.push(tmpTriggerGroup);
			}
		}

		if (typeof tmpRecord.Entity === 'string' && tmpRecord.Entity.trim() &&
			(
				(typeof tmpRecord.EntityColumnFilter === 'string' && tmpRecord.EntityColumnFilter.trim()) ||
				(typeof tmpRecord.EntityFilterTemplate === 'string' && tmpRecord.EntityFilterTemplate.trim())
			) &&
			typeof tmpRecord.EntityDestination === 'string' && tmpRecord.EntityDestination.trim())
		{
			if (!Array.isArray(tmpDescriptor.PictForm.Providers))
			{
				tmpDescriptor.PictForm.Providers = [];
			}

			if (!tmpDescriptor.PictForm.Providers.includes('Pict-Input-EntityBundleRequest'))
			{
				tmpDescriptor.PictForm.Providers.push('Pict-Input-EntityBundleRequest')
			}
			tmpDescriptor.PictForm.EntitiesBundle = [
				{
					"Entity": tmpRecord.Entity,
					"Filter": (tmpRecord.EntityFilterTemplate && tmpRecord.EntityFilterTemplate.trim()) || `FBV~${tmpRecord.EntityColumnFilter.trim()}~EQ~{~D:Record.Value~}`,
					"Destination": tmpRecord.EntityDestination,
					// This marshals a single record
					"SingleRecord": tmpRecord.EntitySingleRecord && tmpRecord.EntitySingleRecord !== 'false',
				}
			]
		}

		// This is used for Section and Group, regardless of where the Descriptor goes.
		let tmpCoreManifestFactory = pManifestFactory;
		if ((`SubManifest` in tmpRecord) && (tmpRecord.SubManifest) && (tmpRecord.InputType != 'TabularAddress'))
		{
			tmpDescriptor.IsTabular = true;
			// Below is what amounts to complex pointer arithmatic.
			if (!(tmpRecord.SubManifest in pManifestFactory.manifest.ReferenceManifests))
			{
				// Build a reference manifest if it doesn't exist
				pManifestFactory.referenceManifestFactories[tmpRecord.SubManifest] = this.fable.instantiateServiceProviderWithoutRegistration('ManifestFactory', { Manifest: { Scope: tmpRecord.SubManifest } }, `${this.UUID}-${tmpRecord.SubManifest}`);
				pManifestFactory.manifest.ReferenceManifests[tmpRecord.SubManifest] = pManifestFactory.referenceManifestFactories[tmpRecord.SubManifest].manifest;
			}
			pManifestFactory = pManifestFactory.referenceManifestFactories[tmpRecord.SubManifest];
		}

		if ('Decimal Precision' in tmpRecord)
		{
			// See if the Decimal Precision is set
			if (tmpRecord['Decimal Precision'] && (tmpRecord['Decimal Precision'] != ''))
			{
				try
				{
					tmpDescriptor.PictForm.DecimalPrecision = parseInt(tmpRecord['Decimal Precision']);
				}
				catch (pError)
				{
					this.log.error(`Failed to parse Decimal Precision for ${tmpRecord['Input Hash']}: ${pError}`);
				}
			}
		}

		// Setup the Section and the Group
		const tmpSectionName = tmpRecord['Section Name']?.trim?.();

		let tmpSectionHash = this.sanitizeObjectKey(tmpSectionName || 'Default_Section');
		// Note: The section name part is laissez-faire about whether it needs to be there or not.  The Hash is required on each column if we want to customize.
		if (tmpRecord['Section Hash'] && tmpRecord['Section Hash'] != '')
		{
			tmpSectionHash = this.sanitizeObjectKey(tmpRecord['Section Hash']);
		}

		tmpDescriptor.PictForm.Section = tmpSectionHash;
		const tmpSection = tmpCoreManifestFactory.getManifestSection(tmpSectionHash);
		if (tmpSectionName)
		{
			tmpSection.Name = tmpSectionName;
		}

		if (tmpRecord['Section CSS'])
		{
			tmpSection.CSSClass = tmpRecord['Section CSS'];
		}

		const tmpGroupName = tmpRecord['Group Name']?.trim?.();
		let tmpGroupHash = this.sanitizeObjectKey(tmpGroupName || 'Default_Group');
		// Note: The group name part is laissez-faire about whether it needs to be there or not.  The Hash is required on each column if we want to customize.
		if (tmpRecord['Group Hash'] && tmpRecord['Group Hash'] != '')
		{
			tmpGroupHash = this.sanitizeObjectKey(tmpRecord['Group Hash']);
		}

		tmpDescriptor.PictForm.Group = tmpGroupHash;
		const tmpGroup = tmpCoreManifestFactory.getManifestGroup(tmpSection, tmpGroupHash);
		tmpGroup.Name = tmpGroupName || ''; // by default, the new group with have a name with the hash, but avoid that to support default groups without ugly forms

		if (tmpRecord['Group CSS'])
		{
			tmpGroup.CSSClass = tmpRecord['Group CSS'];
		}
		if (tmpRecord['Group Layout'])
		{
			tmpGroup.Layout = tmpRecord['Group Layout'];
		}
		if (tmpRecord['Minimum Row Count'])
		{
			try
			{
				tmpGroup.MinimumRowCount = parseInt(tmpRecord['Minimum Row Count']);
			}
			catch (pError)
			{
				this.log.error(`Failed to parse Minimum Row Count for ${tmpRecord['Input Hash']}: ${pError}`);
			}
		}
		if (tmpRecord['Maximum Row Count'])
		{
			try
			{
				tmpGroup.MaximumRowCount = parseInt(tmpRecord['Maximum Row Count']);
			}
			catch (pError)
			{
				this.log.error(`Failed to parse Maximum Row Count for ${tmpRecord['Input Hash']}: ${pError}`);
			}
		}
		if (tmpRecord['HideTabularEditingControls'] && ((tmpRecord['HideTabularEditingControls'] == '1') || (tmpRecord['HideTabularEditingControls'].toLowerCase() == 'true') || (tmpRecord['HideTabularEditingControls'].toLowerCase() == 't') || (tmpRecord['HideTabularEditingControls'].toLowerCase() == 'y')))
		{
			tmpGroup.HideTabularEditingControls = true;
		}
		if (tmpRecord['Group Show Title'] && (tmpRecord['Group Show Title'] != ''))
		{
			switch (tmpRecord['Group Show Title'].toLowerCase())
			{
				case 1:
				case '1':
				case 'true':
					tmpGroup.ShowTitle = true;
					break;
				case 0:
				case '0':
				case 'false':
					tmpGroup.ShowTitle = false;
					break;
			}
		}
		if (tmpDescriptor.Hash in pManifestFactory.manifest.Descriptors)
		{
			this.log.info(`[ERROR] Duplicate descriptor hash found ${tmpDescriptor.Hash}.  This will overwrite the original descriptor.`);
		}

		// Now checking if the group is Tabular -- if it is we need to set some extra values on the Group and have solvers occur inline
		// Layout: "Tabular",
		// RecordSetSolvers: [
		// 	{
		// 		Ordinal: 0,
		// 		Expression: "PercentTotalFat = (Fat * 9) / Calories",
		// 	},
		// ],
		// RecordSetAddress: "FruitData.FruityVice",
		// RecordManifest: "FruitEditor",
		if (tmpRecord.InputType == 'TabularAddress')
		{
			tmpGroup.Layout = 'Tabular';
			// If the csv defines the GroupRecordSetAddress, use that explicitly
			this.log.info(`Group ${tmpGroup.Hash} RSA ${tmpRecord['GroupRecordSetAddress']} -> Descriptor ${tmpDescriptor.DataAddress}`);
			if (tmpRecord['GroupRecordSetAddress'] && (typeof (tmpRecord.GroupRecordSetAddress == 'string')) && (tmpRecord.GroupRecordSetAddress.length > 0))
			{
				tmpGroup.RecordSetAddress = tmpRecord.GroupRecordSetAddress;
			}
			else
			{
				tmpGroup.RecordSetAddress = tmpDescriptor.DataAddress;
			}
			// Otherwise fall back to the DataAddress
			tmpGroup.RecordManifest = tmpRecord.SubManifest;
		}

		if (tmpRecord['Equation'] && !this._isTrue(tmpRecord['Validator']))
		{
			// Clean up the equation a bit to remove any leading/trailing spaces and replace HTML quotes
			// that may have been added by the CSV or other source.
			const tmpCleanEquation = tmpRecord['Equation'].trim();
			let tmpEquationOrdinal = 1;
			if (tmpRecord['Equation Ordinal'])
			{
				try
				{
					tmpEquationOrdinal = parseInt(tmpRecord['Equation Ordinal']);
				}
				catch (pError)
				{
					this.log.error(`Failed to parse Equation Ordinal for ${tmpRecord['Input Hash']}: ${pError}`);
				}
			}
			this.log.trace(`Adding solver to ${tmpRecord.Form} --> ${tmpGroup.Name} for ${tmpRecord['Input Hash']} Ordinal ${tmpEquationOrdinal}: ${tmpRecord['Equation']}`);
			if ((tmpGroup.Layout == 'Tabular') || (tmpGroup.Layout == 'RecordSet'))
			{
				if (tmpEquationOrdinal == 1)
				{
					tmpGroup.RecordSetSolvers.push(tmpCleanEquation);
				}
				else
				{
					tmpGroup.RecordSetSolvers.push({ Ordinal: tmpEquationOrdinal, Expression: tmpCleanEquation });
				}
			}
			else
			{
				if (tmpEquationOrdinal == 1)
				{
					tmpSection.Solvers.push(tmpCleanEquation);
				}
				else
				{
					tmpSection.Solvers.push({ Ordinal: tmpEquationOrdinal, Expression: tmpCleanEquation });
				}
			}
		}

		this.onTabularRowAddDescriptor(tmpRecord, tmpSection, tmpGroup, tmpDescriptor);

		if (tmpRecord.DataOnly && tmpDescriptor.PictForm)
		{
			if (tmpDescriptor.PictForm.Group)
			{
				tmpDescriptor.FormGroup = tmpDescriptor.PictForm.Group;
			}
			if (tmpDescriptor.PictForm.Section)
			{
				tmpDescriptor.FormSection = tmpDescriptor.PictForm.Section;
			}
			delete tmpDescriptor.PictForm;
		}

		if ((tmpRecord.InputType == 'Chart') && (tmpDescriptor.PictForm))
		{
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '1');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '2');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '3');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '4');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '5');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '6');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '7');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '8');
			this.decorateChartDescriptorFromTabularRow(tmpRecord, tmpDescriptor, '9');
		}

		// Finally add any `Descriptor_Extension_* properties
		const tmpDescriptorKeys = Object.keys(tmpRecord);
		let tmpDescriptorManifest = this.fable.newManyfest();
		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			let tmpKey = tmpDescriptorKeys[i];
			if (tmpKey.startsWith('Descriptor_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpValue = tmpRecord[tmpKey];

					// Use the manifest to put it on the descriptor
					if (tmpValue)
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}

			if (tmpKey.startsWith('Descriptor_Float_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Float_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpRawValue = tmpRecord[tmpKey];
					let tmpValue = parseFloat(tmpRawValue);

					// Use the manifest to put it on the descriptor
					if (!isNaN(tmpValue))
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
						this.log.trace(`Set Float Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}] to value [${tmpValue}]`);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Float Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}

			if (tmpKey.startsWith('Descriptor_Integer_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Integer_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpRawValue = tmpRecord[tmpKey];
					let tmpValue = parseInt(tmpRawValue);

					// Use the manifest to put it on the descriptor
					if (!isNaN(tmpValue))
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Integer Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}

			if (tmpKey.startsWith('Descriptor_Boolean_Extension_'))
			{
				const tmpExtensionKey = tmpKey.replace('Descriptor_Boolean_Extension_', '');
				try
				{
					// This is just going to stuff a string in
					let tmpAddress = tmpExtensionKey;
					let tmpRawValue = tmpRecord[tmpKey];
					let tmpValue;

					if ((tmpRawValue.toLowerCase() == 'x') || (tmpRawValue.toLowerCase() == 'y') || (tmpRawValue.toLowerCase() == 'yes') || (tmpRawValue.toLowerCase() == 't') || (tmpRawValue.toLowerCase() == 'true') || (tmpRawValue == '1'))
					{
						tmpValue = true;
					}
					if ((tmpRawValue.toLowerCase() == 'n') || (tmpRawValue.toLowerCase() == 'no') || (tmpRawValue.toLowerCase() == 'f') || (tmpRawValue.toLowerCase() == 'false') || (tmpRawValue == '0'))
					{
						tmpValue = false;
					}

					// Use the manifest to put it on the descriptor
					if ((tmpValue === true) || (tmpValue === false))
					{
						tmpDescriptorManifest.setValueAtAddress(tmpDescriptor, tmpAddress, tmpValue);
					}
					else if (tmpRawValue)
					{
						this.log.warn(`Could not parse Boolean value [${tmpRawValue}] for Descriptor Boolean Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]`);
					}
				}
				catch (pError)
				{
					this.log.error(`Failed to set Boolean Descriptor Extension [${tmpKey}] on descriptor [${tmpDescriptor.Hash}]: ${pError}`);
				}
			}
		}

		if (tmpRecord.InputType != 'TabularAddress')
		{
			pManifestFactory.addDescriptor(tmpDescriptor);
		}
		else
		{
			tmpCoreManifestFactory.addDescriptor(tmpDescriptor);
		}

		return tmpDescriptor;
	}

	/**
	 * Add a validation solver to a manifest from a tabular row.
	 *
	 * @param {Record<string, any>} pManifest - The manifest being built
	 * @param {Record<string, any>} pRecord - The tabular row record -- expected to have at least a 'Form'
	 */
	tabularRowAddValidator(pManifest, pRecord)
	{
		if (pRecord['Equation'])
		{
			// Clean up the equation a bit to remove any leading/trailing spaces and replace HTML quotes
			// that may have been added by the CSV or other source.
			const tmpCleanEquation = pRecord['Equation'].trim();
			let tmpEquationOrdinal = 1;
			if (pRecord['Equation Ordinal'])
			{
				try
				{
					tmpEquationOrdinal = parseInt(pRecord['Equation Ordinal']);
				}
				catch (pError)
				{
					this.log.error(`Failed to parse Equation Ordinal for ${pRecord['Input Hash']}: ${pError}`);
				}
			}
			this.log.trace(`Adding solver to ${pRecord.Form} Validation Solvers Ordinal ${tmpEquationOrdinal}: ${pRecord['Equation']}`);
			if (!Array.isArray(pManifest.ValidationSolvers))
			{
				pManifest.ValidationSolvers = [];
			}
			if (tmpEquationOrdinal == 1)
			{
				pManifest.ValidationSolvers.push(tmpCleanEquation);
			}
			else
			{
				pManifest.ValidationSolvers.push({ Ordinal: tmpEquationOrdinal, Expression: tmpCleanEquation });
			}
		}
	}

	/**
	 * This fires whenever a Tabular Row is adding a Descriptor to the Manifest.
	 *
	 * If you want to extend how descriptors are built, the code belongs in here.
	 *
	 * @param {Object} pIncomingDescriptor - The record for the descriptor being added (from a CSV or other source)
	 * @param {Object} pSection - The section object
	 * @param {Object} pGroup - The group object
	 * @param {Object} pNewDescriptor - The descriptor object
	 */
	onTabularRowAddDescriptor(pIncomingDescriptor, pSection, pGroup, pNewDescriptor)
	{
		// This is meant to be overloaded by the parent class
	}

	migrateAutofillTriggerGroupSolvers(pManifests)
	{
		for (const tmpManifestFactory of Object.values(pManifests))
		{
			const tmpManifest = tmpManifestFactory.manifest;

			const tmpGatheredSolverExpressions = [];

			for (const tmpSection of tmpManifest.Sections || [])
			{
				if (Array.isArray(tmpSection.Solvers))
				{
					for (let i = 0; i < tmpSection.Solvers.length; i++)
					{
						const tmpSolverEntry = tmpSection.Solvers[i];
						const tmpSolverExpression = (typeof (tmpSolverEntry) === 'string') ? tmpSolverEntry : tmpSolverEntry.Expression;
						if (typeof tmpSolverExpression === 'string' && tmpSolverExpression.startsWith('TriggerGroup:'))
						{
							tmpGatheredSolverExpressions.push(tmpSolverEntry);
							// Remove it from the section solvers
							tmpSection.Solvers.splice(i, 1);
							--i;
						}
					}
				}
				for (const tmpGroup of tmpSection.Groups || [])
				{
					if (Array.isArray(tmpGroup.RecordSetSolvers))
					{
						for (let i = 0; i < tmpGroup.RecordSetSolvers.length; i++)
						{
							const tmpSolverEntry = tmpGroup.RecordSetSolvers[i];
							const tmpSolverExpression = (typeof (tmpSolverEntry) === 'string') ? tmpSolverEntry : tmpSolverEntry.Expression;
							if (typeof tmpSolverExpression === 'string' && tmpSolverExpression.startsWith('TriggerGroup:'))
							{
								tmpGatheredSolverExpressions.push(tmpSolverEntry);
								// Remove it from the group solvers
								tmpGroup.RecordSetSolvers.splice(i, 1);
								--i;
							}
						}
					}
				}
			}
			for (const tmpTriggerGroupSolverEntry of tmpGatheredSolverExpressions)
			{
				const tmpSolverExpression = (typeof (tmpTriggerGroupSolverEntry) === 'string') ? tmpTriggerGroupSolverEntry : tmpTriggerGroupSolverEntry.Expression;
				let [ tmpType, tmpTriggerGroupHash, tmpPrePost, tmpSimpleSolverExpression ] = tmpSolverExpression.split(':');
				if (!tmpSimpleSolverExpression)
				{
					tmpSimpleSolverExpression = tmpPrePost;
					tmpPrePost = 'post';
				}

				if (!tmpSimpleSolverExpression || tmpSimpleSolverExpression.trim() === '')
				{
					this.log.error(`Skipping migration of empty TriggerGroup solver expression in manifest [${tmpManifest.Scope}] for TriggerGroup [${tmpTriggerGroupHash}]`);
					continue;
				}
				const tmpTriggerGroupDescriptor = Object.values(tmpManifest.Descriptors).find((pDescriptor) =>
				{
					if (!pDescriptor.PictForm?.AutofillTriggerGroup)
					{
						return false;
					}
					/** @type {Array<any>} */
					const tmpTriggerGroups = Array.isArray(pDescriptor.PictForm.AutofillTriggerGroup) ? pDescriptor.PictForm.AutofillTriggerGroup : [pDescriptor.PictForm.AutofillTriggerGroup];
					return tmpTriggerGroups.some((pTriggerGroup) => pTriggerGroup.TriggerGroupHash === tmpTriggerGroupHash);
				});
				if (!tmpTriggerGroupDescriptor)
				{
					this.log.error(`Could not find descriptor for TriggerGroup [${tmpTriggerGroupHash}] in manifest [${tmpManifest.Scope}] while migrating solver expression: ${tmpSolverExpression}`);
					continue;
				}
				const tmpTriggerGroups = Array.isArray(tmpTriggerGroupDescriptor.PictForm.AutofillTriggerGroup) ? tmpTriggerGroupDescriptor.PictForm.AutofillTriggerGroup : [tmpTriggerGroupDescriptor.PictForm.AutofillTriggerGroup];
				const tmpTriggerGroup = tmpTriggerGroups.find((pTriggerGroup) => pTriggerGroup.TriggerGroupHash === tmpTriggerGroupHash);
				if (!tmpTriggerGroup)
				{
					this.log.error(`Could not find TriggerGroup entry for TriggerGroup [${tmpTriggerGroupHash}] in descriptor [${tmpTriggerGroupDescriptor.Hash}] while migrating solver expression: ${tmpSolverExpression}`);
					continue;
				}
				let tmpUpdatedTriggerGroupSolverEntry = tmpTriggerGroupSolverEntry;
				if (typeof tmpTriggerGroupSolverEntry === 'string')
				{
					tmpUpdatedTriggerGroupSolverEntry = tmpSimpleSolverExpression;
				}
				else
				{
					tmpTriggerGroupSolverEntry.Expression = tmpSimpleSolverExpression;
				}
				if (tmpPrePost.toLowerCase() === 'pre')
				{
					tmpTriggerGroup.PreSolvers = tmpTriggerGroup.PreSolvers || [];
					tmpTriggerGroup.PreSolvers.push(tmpUpdatedTriggerGroupSolverEntry);
				}
				else
				{
					tmpTriggerGroup.PostSolvers = tmpTriggerGroup.PostSolvers || [];
					tmpTriggerGroup.PostSolvers.push(tmpUpdatedTriggerGroupSolverEntry);
				}
			}
		}
	}

	/**
	 * Helper function to determine if a value is "truthy" in the context of dynamic configuration.
	 *
	 * @param {any} pValue - The value to be evaluated
	 *
	 * @return {boolean} whether the value is considered true
	 */
	_isTrue(pValue)
	{
		if (typeof pValue === 'boolean')
		{
			return pValue;
		}
		if (typeof pValue === 'string')
		{
			const tmpValue = pValue.trim().toLowerCase();
			return tmpValue === 'true' || tmpValue === 't' || tmpValue === 'yes' || tmpValue === 'y' || tmpValue === '1';
		}
		return pValue == true || pValue == 1;
	}

	/**
	 * Create some manifests with a "factory" pattern.
	 *
	 * @param {any} pRecords - The records as an array of objects
	 *
	 * @return {any} the manifests
	 */
	createManifestsFromTabularArray(pRecords)
	{
		if (!pRecords || !Array.isArray(pRecords))
		{
			this.log.info('Invalid records passed to generateManifests.');
			return {};
		}

		const tmpManifestFactories = {};

		for (let i = 0; i < pRecords.length; i++)
		{
			let tmpRecord = pRecords[i];

			// Lint the row we are parsing
			if (!this.tabularRowLint(tmpRecord))
			{
				continue;
			}

			if (!tmpManifestFactories[tmpRecord.Form])
			{
				// Create the manifest if one doesn't exist
				tmpManifestFactories[tmpRecord.Form] = this.fable.instantiateServiceProviderWithoutRegistration('ManifestFactory',
					{
						Manifest:
						{
							Form: tmpRecord.Form
						}
					}, `${this.UUID}-${tmpRecord.Form}`);
			}

			const tmpManifestFactory = tmpManifestFactories[tmpRecord.Form];

			// Check if there is a Form Name to be set
			if (tmpRecord['Form Name'])
			{
				tmpManifestFactory.manifest.FormName = tmpRecord['Form Name'];
			}
			if (tmpRecord['Input Hash'])
			{
				this.tabularRowAddDescriptor(tmpManifestFactory, tmpRecord);
			}
			if (this._isTrue(tmpRecord['Validator']))
			{
				this.log.trace(`Adding validator from tabular row on form ${tmpRecord.Form}: ${tmpRecord.Equation}`);
				this.tabularRowAddValidator(tmpManifestFactory.manifest, tmpRecord);
			}
		}
		this.migrateAutofillTriggerGroupSolvers(tmpManifestFactories);

		this.log.info(`Generated ${Object.keys(tmpManifestFactories).length} manifests.`);

		let tmpManifestKeys = Object.keys(tmpManifestFactories);
		let tmpOutputManifests = {};
		for (let i = 0; i < tmpManifestKeys.length; i++)
		{
			tmpOutputManifests[tmpManifestKeys[i]] = tmpManifestFactories[tmpManifestKeys[i]].manifest;
		}
		return tmpOutputManifests;
	}
}

module.exports = ManifestFactory;
/** @type {Record<string, any>} */
ManifestFactory.default_configuration = {};

},{"fable-serviceproviderbase":2}],107:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libManifestFactory = require('../services/ManifestFactory.js');

const libDynamicSolver = require('../providers/Pict-Provider-DynamicSolver.js');
const libDynamicInput = require('../providers/Pict-Provider-DynamicInput.js');
const libDynamicInputEvents = require('../providers/Pict-Provider-DynamicInputEvents.js');
const libDynamicTabularData = require('../providers/Pict-Provider-DynamicTabularData.js');
const libDynamicRecordSet = require('../providers/Pict-Provider-DynamicRecordSet.js');

const libFormsTemplateProvider = require('../providers/Pict-Provider-DynamicTemplates.js');

const libMetatemplateGenerator = require('../providers/Pict-Provider-MetatemplateGenerator.js');
const libMetatemplateMacros = require('../providers/Pict-Provider-MetatemplateMacros.js');

const libPictLayoutRecord = require('../providers/layouts/Pict-Layout-Record.js');
const libPictLayoutVerticalRecord = require('../providers/layouts/Pict-Layout-VerticalRecord.js');
const libPictLayoutTabular = require('../providers/layouts/Pict-Layout-Tabular.js');
const libPictLayoutRecordSet = require('../providers/layouts/Pict-Layout-RecordSet.js');
const libPictLayoutChart = require('../providers/layouts/Pict-Layout-Chart.js');
const libPictLayoutTuiGrid = require('../providers/layouts/Pict-Layout-TuiGrid.js');
const libPictLayoutCustom = require('../providers/layouts/Pict-Layout-Custom.js');

const libInformary = require('../providers/Pict-Provider-Informary.js');

class PictDynamicFormDependencyManager extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		//let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultManifestSettings)), pOptions);
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict') & { addAndInstantiateSingletonService: (hash: string, options: any, prototype: any) => any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;

		this.fable.addAndInstantiateSingletonService('ManifestFactory', libManifestFactory.default_configuration, libManifestFactory);

		this.fable.addProviderSingleton('DynamicInput', libDynamicInput.default_configuration, libDynamicInput);
		this.fable.addProviderSingleton('DynamicInputEvents', libDynamicInputEvents.default_configuration, libDynamicInputEvents);
		this.fable.addProviderSingleton('DynamicSolver', libDynamicSolver.default_configuration, libDynamicSolver);
		this.fable.addProviderSingleton('DynamicTabularData', libDynamicTabularData.default_configuration, libDynamicTabularData);
		this.fable.addProviderSingleton('DynamicRecordSet', libDynamicRecordSet.default_configuration, libDynamicRecordSet);

		this.fable.addProviderSingleton('PictFormSectionDefaultTemplateProvider', libFormsTemplateProvider.default_configuration, libFormsTemplateProvider);

		this.fable.addProviderSingleton('MetatemplateGenerator', libMetatemplateGenerator.default_configuration, libMetatemplateGenerator);
		this.fable.addProviderSingleton('MetatemplateMacros', libMetatemplateMacros.default_configuration, libMetatemplateMacros);

		this.fable.addProviderSingleton('Pict-Layout-Record', libPictLayoutRecord.default_configuration, libPictLayoutRecord);
		this.fable.addProviderSingleton('Pict-Layout-VerticalRecord', libPictLayoutVerticalRecord.default_configuration, libPictLayoutVerticalRecord);
		this.fable.addProviderSingleton('Pict-Layout-Tabular', libPictLayoutTabular.default_configuration, libPictLayoutTabular);
		this.fable.addProviderSingleton('Pict-Layout-RecordSet', libPictLayoutRecordSet.default_configuration, libPictLayoutRecordSet);
		this.fable.addProviderSingleton('Pict-Layout-Chart', libPictLayoutChart.default_configuration, libPictLayoutChart);
		this.fable.addProviderSingleton('Pict-Layout-TuiGrid', libPictLayoutTuiGrid.default_configuration, libPictLayoutTuiGrid);
		this.fable.addProviderSingleton('Pict-Layout-Custom', libPictLayoutCustom.default_configuration, libPictLayoutCustom);

		this.fable.addProviderSingleton('Informary', libInformary.default_configuration, libInformary);
	}
}

module.exports = PictDynamicFormDependencyManager;

/** @type {Record<string, any>} */
PictDynamicFormDependencyManager.default_configuration = { };

},{"../providers/Pict-Provider-DynamicInput.js":67,"../providers/Pict-Provider-DynamicInputEvents.js":68,"../providers/Pict-Provider-DynamicRecordSet.js":70,"../providers/Pict-Provider-DynamicSolver.js":71,"../providers/Pict-Provider-DynamicTabularData.js":72,"../providers/Pict-Provider-DynamicTemplates.js":73,"../providers/Pict-Provider-Informary.js":75,"../providers/Pict-Provider-MetatemplateGenerator.js":79,"../providers/Pict-Provider-MetatemplateMacros.js":80,"../providers/layouts/Pict-Layout-Chart.js":97,"../providers/layouts/Pict-Layout-Custom.js":98,"../providers/layouts/Pict-Layout-Record.js":99,"../providers/layouts/Pict-Layout-RecordSet.js":100,"../providers/layouts/Pict-Layout-Tabular.js":101,"../providers/layouts/Pict-Layout-TuiGrid.js":102,"../providers/layouts/Pict-Layout-VerticalRecord.js":104,"../services/ManifestFactory.js":106,"fable-serviceproviderbase":2}],108:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * @typedef {{
       reset: () => void,
       clone: () => Manyfest,
       deserialize: (pManifestString: string) => void,
       loadManifest: (pManifest: any) => void,
       serialize: () => string,
       getManifest: () => { Scope: string, Descriptors: any, HashTranslations: any, },
       addDescriptor: (pAddress: string, pDescriptor: any) => void,
       getDescriptorByHash: (pHash: string) => any,
       getDescriptor: (pAddress: string) => any,
       eachDescriptor: (fAction: (pDescriptor: any) => void) => void,
       checkAddressExistsByHash : (pObject: any, pHash: string) => boolean,
       checkAddressExists : (pObject: any, pAddress: string) => boolean,
       resolveHashAddress: (pHash: string) => any,
       getValueByHash : (pObject: any, pHash: string) => any,
       getValueAtAddress : (pObject: any, pAddress: string) => any,
       setValueByHash: (pObject: any, pHash: string, pValue: any) => boolean,
       setValueAtAddress : (pObject: any, pAddress: string, pValue: any) => void,
       deleteValueByHash: (pObject: any, pHash: string, pValue: any) => void,
       deleteValueAtAddress : (pObject: any, pAddress: string, pValue: any) => void,
       validate: (pObject: any) => boolean,
       getDefaultValue: (pDescriptor: any) => any,
       populateDefaults: (pObject: any, pOverwriteProperties: boolean) => void,
       populateObject: (pObject: any, pOverwriteProperties: boolean, fFilter: (pDescriptor: any) => boolean) => void,
       serviceType: string,
       options: any,
       scope?: string,
       elementAddresses: Array<string>,
       elementHashes: Object,
       elementDescriptors: Object,
 * }} Manyfest
 */


/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateControlFromDynamicManifest extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~DynamicInput:', '~}');
		this.addPattern('{~DI:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		const tmpHash = pTemplateHash.trim();
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptor(tmpHash);
		if (!descriptor)
		{
			this.log.error(`PictTemplateControlFromDynamicManifest: Cannot find descriptor for address [${tmpHash}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];
		const tmpScope = tmpView || pScope;
		const tmpContextArray = tmpScope ? [ tmpScope ] : (pContextArray || [ this.pict ]);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpView, descriptor);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpView, descriptor.DataType, descriptor.PictForm.InputType,
			`getInput("${descriptor.PictForm.GroupIndex}","${descriptor.PictForm.RowIndex}","${descriptor.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, descriptor, fCallback, tmpContextArray, tmpScope, pState);
	}
}

module.exports = PictTemplateControlFromDynamicManifest;

},{"pict-template":237}],109:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateControlFromDynamicManifest extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~DynamicInputForHash:', '~}');
		this.addPattern('{~DIH:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema hash.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema hash.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;
		const tmpHash = pTemplateHash.trim();
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {import('./Pict-Template-ControlFromDynamicManifest.js').Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptorByHash(tmpHash);
		if (!descriptor)
		{
			this.log.error(`PictTemplateControlFromDynamicManifest: Cannot find descriptor for hash [${tmpHash}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];
		const tmpScope = tmpView || pScope;
		const tmpContextArray = tmpScope ? [ tmpScope ] : (pContextArray || [ this.pict ]);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpView, descriptor);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpView, descriptor.DataType, descriptor.PictForm.InputType,
			`getInput("${descriptor.PictForm.GroupIndex}","${descriptor.PictForm.RowIndex}","${descriptor.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, descriptor, fCallback, tmpContextArray, tmpScope, pState);
	}
}

module.exports = PictTemplateControlFromDynamicManifest;

},{"pict-template":237}],110:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateGetViewSchemaValue extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~SchemaValue:', '~}');
		this.addPattern('{~SV:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const [ tmpSchemaAddress, tmpTemplateHash ] = pTemplateHash.trim().split('^');
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {import('./Pict-Template-ControlFromDynamicManifest.js').Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptor(tmpSchemaAddress);
		if (!descriptor)
		{
			this.log.error(`PictTemplateGetViewSchemaValue: Cannot find descriptor for address [${tmpSchemaAddress}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];

		const value = tmpView.getValueByHash(tmpSchemaAddress);

		if (tmpTemplateHash)
		{
			const tmpRecord = { Value: value, ParentRecord: pRecord, View: tmpView, Descriptor: descriptor };
			if (typeof fCallback !== 'function')
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, pContextArray, pScope, pState);
			}
			return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return fCallback(pError, '');
					}
					return fCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}

		if (typeof(fCallback) === 'function')
		{
			fCallback(null, value ? String(value) : '');
		}
		else
		{
			return value ? String(value) : '';
		}
	}
}

module.exports = PictTemplateGetViewSchemaValue;

},{"pict-template":237}],111:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateGetViewSchemaValueByHash extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~SchemaValueForHash:', '~}');
		this.addPattern('{~SVH:', '~}');
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.renderAsync(pTemplateHash, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Renders a view managed by the metacontroller based on the manifest schema address.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string | undefined} - The rendered template or undefined if callback is provided.
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const [ tmpSchemaHash, tmpTemplateHash ] = pTemplateHash.trim().split('^');
		/** @type{import('../views/Pict-View-Form-Metacontroller.js')} */
		const metacontroller = this.pict.views.PictFormMetacontroller;
		/** @type {import('./Pict-Template-ControlFromDynamicManifest.js').Manyfest} */
		const manifest = metacontroller ? metacontroller.manifest : this.pict.manifest;
		const descriptor = manifest.getDescriptorByHash(tmpSchemaHash);
		if (!descriptor)
		{
			this.log.error(`PictTemplateGetViewSchemaValueByHash: Cannot find descriptor for address [${tmpSchemaHash}]`);
			if (typeof fCallback === 'function')
			{
				return fCallback(null, '');
			}
			return '';
		}
		/** @type {import('../views/Pict-View-DynamicForm.js')} */
		const tmpView = this.pict.views[descriptor.PictForm.ViewHash];

		const value = tmpView.getValueByHash(tmpSchemaHash);

		if (tmpTemplateHash)
		{
			const tmpRecord = { Value: value, ParentRecord: pRecord, View: tmpView, Descriptor: descriptor };
			if (typeof fCallback !== 'function')
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, pContextArray, pScope, pState);
			}
			return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return fCallback(pError, '');
					}
					return fCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}

		if (typeof(fCallback) === 'function')
		{
			fCallback(null, value ? String(value) : '');
		}
		else
		{
			return value ? String(value) : '';
		}
	}
}

module.exports = PictTemplateGetViewSchemaValueByHash;

},{"pict-template":237}],112:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will take a value set and render a template for each value in the set.
 *
 * It passes along additional context (the metacontroller group) for dynamic programming tables.
 */
class PictTemplateMetacontrollerValueSet extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~MetacontrollerTemplateValueSet:', '~}');
		this.addPattern('{~MTVS:', '~}');
	}

	/**
	 * Renders the PICT Metacontroller Template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Metacontroller Template [MetacontrollerTemplateValueSet]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetacontrollerTemplateValueSet]::[${tmpHash}]`);
		}

		let tmpGroupIndex;
		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`Metacontroller template requires 3 parameters [${tmpHash}]`);
			return '';
		}
		tmpTemplateHash = tmpHashTemplateSeparator[0];
		tmpGroupIndex = tmpHashTemplateSeparator[1];
		tmpAddressOfData = tmpHashTemplateSeparator[2];

		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i, Group: tmpGroupIndex });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpValueKeys[i], Group: tmpGroupIndex });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, tmpData, null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Asynchronously renders a template with the provided template hash, record, callback, and context array.
	 *
	 * @param {string} pTemplateHash - The template hash to render.
	 * @param {object} pRecord - The record object to use for rendering the template.
	 * @param {function} fCallback - The callback function to invoke after rendering the template.
	 * @param {array} pContextArray - The context array to use for resolving the data.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfData;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 2)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0]
		tmpAddressOfData = tmpTemplateHashPart[1];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i, });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpValueKeys[i] });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
			return;
		}
		else
		{
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
			return;
		}
	}
}

module.exports = PictTemplateMetacontrollerValueSet;

},{"pict-template":237}],113:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateMetatemplateInputTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~MetaTemplateInput:', '~}');
		this.addPattern('{~MTI:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		tmpInputAddress = tmpHashTemplateSeparator[1];
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		tmpInputAddress = tmpHashTemplateSeparator[1];
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
		return;
	}
}

module.exports = PictTemplateMetatemplateInputTemplate;

},{"pict-template":237}],114:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a Metatemplate input, for manual use of metatemplates.
 */
class PictTemplateMetatemplateInputTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~MetaTemplateInputWithHashAddress:', '~}');
		this.addPattern('{~MTIWHA:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[1], pRecord, pContextArray, null, pScope, pState);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`MetaTemplateInput template requires a valid Address for an Address in the second parameter [${tmpHash}]`);
			return '';
		}
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		const tmpInput =
		{
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm:
			{
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			},
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				const tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
	}

	/**
	 * Renders the PICT Metacontroller Template.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [MetaTemplateInput]::[${tmpHash}]`);
		}

		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the Address and the DataType)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`MetaTemplateInput template requires at least parameters (Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpInputName = tmpHashTemplateSeparator[0];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[1], pRecord, pContextArray, null, pScope, pState);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`MetaTemplateInput template requires a valid Address for an Address in the second parameter [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpDataType = tmpHashTemplateSeparator[2];
		if (tmpHashTemplateSeparator.length > 3)
		{
			tmpInputType = tmpHashTemplateSeparator[3];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpMetatemplateGenerator.dynamicInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpMetatemplateGenerator.dynamicInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpMetatemplateGenerator.dynamicInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpMetatemplateGenerator.dynamicInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpMetatemplateGenerator.dynamicInputView], tmpMetatemplateGenerator.dynamicInputView, pState);
		return;
	}
}

module.exports = PictTemplateMetatemplateInputTemplate;

},{"pict-template":237}],115:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a dynamic input using a provided dynamic view (by hash)
 */
class PictTemplateInputWithViewTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~InputWithView:', '~}');
		this.addPattern('{~IWV:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithView]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithView template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		tmpInputAddress = tmpHashTemplateSeparator[2];
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithView template requires a valid dynamic View hash [${tmpHash}]`);
			return '';
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpInputView], tmpInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpInputView], tmpInputView, pState);
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithView]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithView template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		tmpInputAddress = tmpHashTemplateSeparator[2];
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithView template requires a valid dynamic View hash [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
		return;
	}
}

module.exports = PictTemplateInputWithViewTemplate;

},{"pict-template":237}],116:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a dynamic input using a provided dynamic view (by hash)
 */
class PictTemplateInputWithViewAndDescriptorAddressTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js'), DataFormat: any }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~InputWithViewAndDescriptorAddress:', '~}');
		this.addPattern('{~IWVDA:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndDescriptorAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpDescriptorAddress;

		// This is just a simple 2 part hash (the view hash and the descriptor address)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires two parameters (ViewHash and DescriptorAddress) [${tmpHash}]`);
			return '';
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpDescriptorAddress = tmpHashTemplateSeparator[1];

		const tmpInput = this.resolveStateFromAddress(tmpDescriptorAddress, pRecord, pContextArray, null, pScope, pState);

		if (!tmpInput || typeof tmpInput !== 'object' || Array.isArray(tmpInput) || !tmpInput.Address)
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires a valid input object at address [${tmpDescriptorAddress}]`);
			return '';
		}

		this._shoreUpDescriptor(tmpInput);

		this.currentInputIndex++;

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires a valid dynamic View hash [${tmpHash}]`);
			return '';
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpInputView], tmpInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpInputView], tmpInputView, pState);
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndDescriptorAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpDescriptorAddress;

		// This is just a simple 2 part hash (the view hash and the descriptor address)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 2)
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires two parameters (ViewHash and DescriptorAddress) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpDescriptorAddress = tmpHashTemplateSeparator[1];

		const tmpInput = this.resolveStateFromAddress(tmpDescriptorAddress, pRecord, pContextArray, null, pScope, pState);

		this._shoreUpDescriptor(tmpInput);

		this.currentInputIndex++;

		const tmpInputView = this.pict.views[tmpViewHash];

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndDescriptorAddress template requires a valid dynamic View hash [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView, tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
		return;
	}

	_shoreUpDescriptor(pDescriptor)
	{
		if (!pDescriptor || typeof pDescriptor !== 'object' || Array.isArray(pDescriptor))
		{
			throw new Error('Invalid descriptor object provided to shoreUpDescriptor');
		}
		if (!pDescriptor.DataAddress)
		{
			pDescriptor.DataAddress = pDescriptor.Address;
		}
		if (!pDescriptor.Hash)
		{
			pDescriptor.Hash = this.fable.DataFormat.sanitizeObjectKey(pDescriptor.Address);
		}
		if (!pDescriptor.Name)
		{
			pDescriptor.Name = pDescriptor.Hash;
		}
		if (!pDescriptor.DataType)
		{
			pDescriptor.DataType = 'String';
		}
		if (!pDescriptor.PictForm)
		{
			pDescriptor.PictForm = { };
		}
		if (!pDescriptor.PictForm.InformaryDataAddress)
		{
			pDescriptor.PictForm.InformaryDataAddress = pDescriptor.DataAddress;
		}
		if (pDescriptor.PictForm.GroupIndex == null)
		{
			pDescriptor.PictForm.GroupIndex = 0;
		}
		if (pDescriptor.PictForm.Row == null)
		{
			pDescriptor.PictForm.Row = 0;
		}
	}
}

module.exports = PictTemplateInputWithViewAndDescriptorAddressTemplate;

},{"pict-template":237}],117:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * This is a template that will generate a dynamic input using a provided dynamic view (by hash) and a hash address.
 */
class PictTemplateInputWithViewAndHashAddressTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { ManifestFactory: import('../services/ManifestFactory.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~InputWithViewAndHashAddress:', '~}');
		this.addPattern('{~IWVHA:', '~}');

		this.currentInputIndex = 0;
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndHashAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return '';
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[2], pRecord, pContextArray, null, pScope);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid Address for an Address in the third parameter [${tmpHash}]`);
			return '';
		}
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		const tmpInput =
		{
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm:
			{
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			},
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash]; //tmpMetatemplateGenerator.dynamicInputView;

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid dynamic View hash as the first parameter [${tmpHash}]`);
			return '';
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				const tmpInput = tmpRow.Inputs[i];
				return this.pict.parseTemplate(tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`), tmpInput, null, [tmpInputView], tmpInputView, pState);
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		// Now parse it and return it.
		return this.pict.parseTemplate(tmpTemplate, tmpInput, null, [tmpInputView], tmpInputView, pState);
	}

	/**
	 * Renders an arbitrary PICT input by hash, with a custom data type, input type and label.  The Record reference is ignored in this template.
	 *
	 * @param {string} pTemplateHash - The schema hash of the control.
	 * @param {object} pRecord - The record object.
	 * @param {function | null} fCallback - The callback function.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpMetatemplateGenerator = this.pict.providers.MetatemplateGenerator;

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Metacontroller Template [InputWithViewAndHashAddress]::[${tmpHash}]`);
		}

		let tmpViewHash;
		let tmpInputName;
		let tmpInputAddress;
		let tmpDataType;
		let tmpInputType;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.split(':');
		if (tmpHashTemplateSeparator.length < 3)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires at least three parameters (ViewHash, Address and DataType) [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpViewHash = tmpHashTemplateSeparator[0];
		tmpInputName = tmpHashTemplateSeparator[1];
		// This template expects this address to be a location to get the hash from...
		//FIXME: should pScope here be the eventual view so the scope is consistent?
		tmpInputAddress = this.resolveStateFromAddress(tmpHashTemplateSeparator[2], pRecord, pContextArray, null, pScope);
		if ((typeof(tmpInputAddress) !== 'string') || tmpInputAddress.length < 1)
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid Address for an Address in the third parameter [${tmpHash}]`);
			return fCallback(null, '');
		}
		tmpDataType = tmpHashTemplateSeparator[3];
		if (tmpHashTemplateSeparator.length > 4)
		{
			tmpInputType = tmpHashTemplateSeparator[4];
		}
		// Construct a fake input object
		let tmpInput = {
			Address: tmpInputAddress,
			DataAddress: tmpInputAddress,
			Name: tmpInputName,
			Hash: this.fable.ManifestFactory.sanitizeObjectKey(tmpInputAddress),
			DataType: tmpDataType,
			PictForm: {
				InformaryDataAddress: tmpInputAddress,
				GroupIndex: 0,
				Row: 0
			}
		};

		this.currentInputIndex++;

		if (tmpInputType)
		{
			tmpInput.PictForm.InputType = tmpInputType;
		}

		const tmpInputView = this.pict.views[tmpViewHash]; //tmpMetatemplateGenerator.dynamicInputView;

		if (!tmpInputView || !tmpInputView.sectionManifest || typeof tmpInputView.getRow !== 'function')
		{
			this.log.warn(`InputWithViewAndHashAddress template requires a valid View hash as the first parameter [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Check to see if the input is already in the manifest
		let tmpRow = tmpInputView.getRow(0, 0);

		for (let i = 0; i < tmpRow.Inputs.length; i++)
		{
			if (tmpRow.Inputs[i].Hash === tmpInput.Hash)
			{
				let tmpInput = tmpRow.Inputs[i];
				let tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
					tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);
				this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
				return;
			}
		}

		// It isn't already in the manifest, so add it.
		tmpInput.PictForm.InputIndex = tmpRow.Inputs.length;
		tmpInputView.sectionManifest.addDescriptor(tmpInput.Address, tmpInput);
		tmpRow.Inputs.push(tmpInput);

		this.pict.providers.MetatemplateMacros.buildInputMacros(tmpInputView, tmpInput);

		// Now generate the metatemplate
		const tmpTemplate = tmpMetatemplateGenerator.getInputMetatemplateTemplateReference(tmpInputView,
			tmpInput.DataType, tmpInput.PictForm.InputType, `getInput("0","0","${tmpInput.PictForm.InputIndex}")`);

		this.pict.parseTemplate(tmpTemplate, tmpInput, fCallback, [tmpInputView], tmpInputView, pState);
		return;
	}
}

module.exports = PictTemplateInputWithViewAndHashAddressTemplate;

},{"pict-template":237}],118:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderPluckJoinUnique extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~PluckJoinUnique:', '~}');
		this.addPattern('{~PJU:', '~}');
	}

	/**
	 * Renders the PICT Metacontroller Template.
	 *
	 * @param {string} pTemplateHash - The template hash.
	 * @param {object} pRecord - The record object.
	 * @param {array} pContextArray - The context array.
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @returns {string} - The rendered template.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash;
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}]`);
		}

		let tmpDataAddresses = tmpHash.split('^');
		if (tmpDataAddresses.length < 3)
		{
			return '';
		}

		// Get the separator string
		let tmpSeparator = tmpDataAddresses.shift();
		let tmpAddress = tmpDataAddresses.shift();

		let tmpValueList = [];
		let tmpValueMap = {};
		for (let i = 0; i < tmpDataAddresses.length; i++)
		{
			let tmpValueSet = this.resolveStateFromAddress(tmpDataAddresses[i], tmpData, pContextArray, null, pScope);

			if (tmpValueSet && Array.isArray(tmpValueSet))
			{
				// This one only works on arrays of objects.
				for (let j = 0; j < tmpValueSet.length; j++)
				{
					if ((tmpValueSet[j] === null) || (typeof(tmpValueSet) !== 'object'))
					{
						continue;
					}
					let tmpValue = this.pict.manifest.getValueByHash(tmpValueSet[j], tmpAddress);
					if (!(tmpValue in tmpValueMap))
					{
						tmpValueMap[tmpValue] = true;
						tmpValueList.push(tmpValue);
					}
				}
			}
			else if (tmpValueSet)
			{
				if (!(tmpValueSet in tmpValueMap))
				{
					tmpValueMap[tmpValueSet] = true;
					tmpValueList.push(tmpValueSet);
				}
			}
		}

		return tmpValueList.join(tmpSeparator);
	}
}

module.exports = PictTemplateProviderPluckJoinUnique;

},{"pict-template":237}],119:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Template tag that renders the editing-controls <td> (del / up / down) for
 * one row of a tabular group when EditingControlsPosition is "left".
 *
 * Usage in a tabular row template:
 *
 *   {~TabularEditingControls:<ViewHash>~}
 *   {~TEC:<ViewHash>~}
 *
 * Reads Record.Group and Record.Key from the MTVS row wrapper, then calls
 * the layout provider's `_renderTabularEditingControlsHTML(view, gi, rk)`.
 *
 * Implemented as a dedicated tag (rather than `{~F:~}`) so it works on the
 * older pict versions some hosts ship with.
 */
class PictTemplateTabularEditingControls extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~TabularEditingControls:', '~}');
		this.addPattern('{~TEC:', '~}');
	}

	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		if (!tmpHash || !pRecord)
		{
			return '';
		}
		let tmpView = this.pict.views[tmpHash];
		if (!tmpView)
		{
			return '';
		}
		let tmpGroupIndex = pRecord.Group;
		let tmpRowKey = pRecord.Key;
		let tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || typeof tmpLayout._renderTabularEditingControlsHTML !== 'function')
		{
			return '';
		}
		return tmpLayout._renderTabularEditingControlsHTML(tmpView, tmpGroupIndex, tmpRowKey);
	}
}

module.exports = PictTemplateTabularEditingControls;

},{"pict-template":237}],120:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Template tag that renders the left-side row-label <td> cells for one row
 * of a tabular group with `RowLabels` configured.
 *
 * Usage in a tabular row template:
 *
 *   {~TabularRowLabels:<ViewHash>~}
 *   {~TRL:<ViewHash>~}
 *
 * The current Record context is expected to be the MTVS wrapper
 * (`{ Value, Key, Group }`); the tag reads `Record.Group` and `Record.Key`
 * to look up the group's precomputed `RowLabelMetadata[Record.Key].Cells`
 * and renders one `<td rowspan>` per non-skipped cell.
 *
 * This is implemented as a dedicated tag (rather than `{~F:~}`) so it works
 * on the older pict versions some hosts ship with.
 */
class PictTemplateTabularRowLabels extends libPictTemplate
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict')} */
		this.fable;
		/** @type {any} */
		this.log;

		this.addPattern('{~TabularRowLabels:', '~}');
		this.addPattern('{~TRL:', '~}');
	}

	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		if (!tmpHash || !pRecord)
		{
			return '';
		}
		let tmpView = this.pict.views[tmpHash];
		if (!tmpView)
		{
			return '';
		}
		let tmpGroupIndex = pRecord.Group;
		let tmpRowKey = pRecord.Key;
		let tmpLayout = this.pict.providers['Pict-Layout-Tabular'];
		if (!tmpLayout || typeof tmpLayout._renderTabularRowLabelsHTML !== 'function')
		{
			return '';
		}
		return tmpLayout._renderTabularRowLabelsHTML(tmpView, tmpGroupIndex, tmpRowKey);
	}
}

module.exports = PictTemplateTabularRowLabels;

},{"pict-template":237}],121:[function(require,module,exports){
module.exports={
	"AutoRender": false,
	"AutoSolveWithApp": false,

	"ExecuteSolversWithoutMetacontroller": false,
	"IncludeInMetatemplateSectionGeneration": true,
	"IncludeInDefaultDynamicRender": true,

	"DefaultRenderable": "Form-Main",
	"DefaultDestinationAddress": "#Pict-Form-Container",

	"Renderables": [],

	"Templates": [],

	"MacroTemplates": {
		"Section": {
			"HTMLID": " id=\"Section-{~D:Context[0].UUID~}\" "
		},
		"Group": {
			"HTMLID": " id=\"Group-{~D:Context[0].UUID~}\" ",

			"PictFormLayout": " data-i-pictdynamiclayout=\"true\" data-i-pictgroupindex=\"{~D:Record.GroupIndex~}\" data-i-pictlayout=\"{~D:Record.Layout~}\" ",

			"TabularCreateRowFunctionCall": "{~P~}.views['{~D:Context[0].Hash~}'].createDynamicTableRow({~D:Record.GroupIndex~})"
		},
		"Input": {
			"Informary": " data-i-form=\"{~D:Context[0].formID~}\" data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\" ",
			"InformaryTabular": " data-i-form=\"{~D:Context[0].formID~}\" data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\" data-i-container=\"{~D:Record.PictForm.InformaryContainerAddress~}\" ",

			"ControlAttr": " data-control=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\" ",

			"HTMLSelector": "[data-i-form=\"{~D:Context[0].formID~}\"][data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\"]",
			"HTMLSelectorTabular": "[data-i-form=\"{~D:Context[0].formID~}\"][data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\"][data-i-container=\"{~D:Record.PictForm.InformaryContainerAddress~}\"]",
			"HTMLSelectorControl": "[data-control=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\"]",
			"HTMLSelectorControlTabular": "[data-control=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\"]",

			"RawHTMLID": "{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}",

			"HTMLName": " name=\"{~D:Record.Name~}\" ",
			"HTMLIDAddress": "#{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}",
			"HTMLID": " id=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\" ",
			"HTMLForID": " for=\"{~D:Context[0].UUID~}-FormInput-{~D:Record.Hash~}\" ",

			"InputFullProperties": " data-i-form=\"{~D:Context[0].formID~}\" data-i-datum=\"{~D:Record.PictForm.InformaryDataAddress~}\"  name=\"{~D:Record.Name~}\" ",
			"InputChangeHandler": " onchange=\"{~P~}.views['{~D:Context[0].Hash~}'].dataChanged('{~D:Record.Hash~}')\" ",

			"DataRequestFunction": " {~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}'); "
		}
	},

	"TargetElementAddress": "#Form-Container-Div"
}

},{}],122:[function(require,module,exports){
const libPictViewClass = require('pict-view');

/** @type {Record<string, any>} */
const libPackage = require('../../package.json');

/** @type {Record<string, any>} */
const _DefaultConfiguration = require('./Pict-View-DynamicForm-DefaultConfiguration.json');

const PENDING_ASYNC_OPERATION_TYPE = 'PendingAsyncOperation';
const TRANSACTION_COMPLETE_CALLBACK_TYPE = 'onTransactionComplete';
const READY_TO_FINALIZE_TYPE = 'ReadyToFinalize';

/**
 * Represents a dynamic form view for the Pict application.
 *
 * This is the code that maintains the lifecycle with the Pict application and
 * the data handling methods for a dynamic forms view (or set of views).
 *
 * @extends libPictViewClass
 */
class PictViewDynamicForm extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultConfiguration)), pOptions);

		if (!tmpOptions.Manifests)
		{
			throw new Error('PictSectionForm instantiation attempt without a Manifests in pOptions.Manifest -- cannot instantiate.');
		}
		if (!('Section' in tmpOptions.Manifests))
		{
			throw new Error('PictSectionForm instantiation attempt without a Section manifest in pOptions.Manifests -- cannot instantiate.');
		}
		// Set the default destination address to be based on the section hash if it hasn't been overridden by the manifest section definition
		if (tmpOptions.DefaultDestinationAddress === '#Pict-Form-Container')
		{
			tmpOptions.DefaultDestinationAddress = `#Pict-Form-Container-${tmpOptions.Hash}`;
		}
		// Set the default renderable to be based on the section hash if it hasn't been overridden by the manifest section definition
		if (tmpOptions.DefaultRenderable === 'Form-Main')
		{
			tmpOptions.DefaultRenderable = `Form-${tmpOptions.Hash}`;
		}
		// Set the template hash (which is the section-specific template prefix) if it hasn't been overridden by the manifest section definition
		if (!tmpOptions.SectionTemplateHash)
		{
			tmpOptions.SectionTemplateHash = `Pict-Form-Template-${tmpOptions.Hash}`;
		}

		// Create a renderable if none exist
		if (tmpOptions.Renderables.length < 1)
		{
			tmpOptions.Renderables.push(
				{
					RenderableHash: tmpOptions.DefaultRenderable,
					TemplateHash: tmpOptions.SectionTemplateHash,
					RenderMethod: 'replace'
				});
		}

		// Now construct the view.
		super(pFable, tmpOptions, pServiceHash);

		if (!this.fable.PictDynamicFormDependencyManager)
		{
			throw new Error('PictSectionForm instantiation attempt without a PictDynamicFormDependencyManager service in fable -- cannot instantiate.');
		}

		// Use this to manage transactions
		//FIXME: should we have these sioled??
		//this.transactionTracking = this.pict.newTransactionTracker();

		/** @type {Record<string, any>} */
		this._PackagePictView = this._Package;
		this._Package = libPackage;

		// Pull in the section definition
		this.sectionDefinition = this.options;

		// Initialize the section manifest -- instantiated to live only the lifecycle of this view
		this.sectionManifest = this.fable.instantiateServiceProviderWithoutRegistration('Manifest', this.options.Manifests.Section);

		// Shift solvers to an array of tasks
		this.sectionSolvers = [];
		// Pull in solvers
		if (('Solvers' in this.options) && Array.isArray(this.options.Solvers))
		{
			for (let i = 0; i < this.options.Solvers.length; i++)
			{
				if (typeof (this.options.Solvers[i]) === 'string')
				{
					this.sectionSolvers.push(this.options.Solvers[i]);
				}
			}
		}

		// Load any view section-specific templates
		this.formsTemplateSetPrefix = `PFT-${this.Hash}-${this.UUID}`;
		if (('MetaTemplates' in this.options) && Array.isArray(this.options.MetaTemplates))
		{
			for (let i = 0; i < this.options.MetaTemplates.length; i++)
			{
				let tmpMetaTemplate = this.options.MetaTemplates[i];

				if (('HashPostfix' in tmpMetaTemplate) && ('Template' in tmpMetaTemplate))
				{
					let tmpTemplateHash = `${this.formsTemplateSetPrefix}${tmpMetaTemplate.HashPostfix}`;
					this.pict.TemplateProvider.addTemplate(tmpTemplateHash, tmpMetaTemplate.Template);
				}
				else
				{
					this.log.warn(`MetaTemplate entry ${i} in PictSectionForm [${this.UUID}]::[${this.Hash}] does not have a Hash and Template property; custom template skipped.`);
				}
			}
		}
		// The default template prefix
		this.customDefaultTemplatePrefix = null;

		this.formID = `Pict-Form-${this.Hash}-${this.UUID}`;

		this.viewMarshalDestination = null;
		this.initialBundleLoaded = false;

		this.fable.ManifestFactory.initializeFormGroups(this);

		this._LoopDetectionData = {};
	}

	/**
	 * Returns the default template prefix.
	 *
	 * @returns {string} The default template prefix.
	 */
	get defaultTemplatePrefix()
	{
		if (this.customDefaultTemplatePrefix)
		{
			return this.customDefaultTemplatePrefix;
		}
		else if (this.pict.views.PictFormMetacontroller)
		{
			return this.pict.views.PictFormMetacontroller.formTemplatePrefix;
		}
		else
		{
			return this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;
		}
	}

	/**
	 * This method is called whenever data is changed within an input.
	 *
	 * It handles the data marshaling from the view to the data model,
	 * runs any providers connected to the input, solves the Pict application,
	 * then marshals data back to the view.
	 *
	 * @param {string} pInputHash - The hash of the input that triggered the data change.
	 */
	dataChanged(pInputHash)
	{
		let tmpInput = this.getInputFromHash(pInputHash);
		// This is what is called whenever a hash is changed.  We could marshal from view, solve and remarshal to view.

		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`Dynamic form [${this.Hash}]::[${this.UUID}] dataChanged event for input [${pInputHash}].`);
		}
		if (pInputHash)
		{
			// The informary stuff doesn't know the resolution of the hash to address, so do it here.
			let tmpHashAddress = this.sectionManifest.resolveHashAddress(pInputHash);
			const tmpTransactionGUID = this.fable.getUUID();
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			try
			{
				let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
				this.pict.providers.Informary.marshalFormToData(tmpMarshalDestinationObject, this.formID, this.sectionManifest, tmpHashAddress);
				// Now run any providers connected to this input
				let tmpValue = this.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpHashAddress);

				let tmpInputProviderList = this.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (this.pict.providers[tmpInputProviderList[i]])
					{
						this.pict.providers[tmpInputProviderList[i]].onDataChange(this, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, tmpTransactionGUID);
					}
					else
					{
						this.log.error(`Dynamic form dataChanged [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}].`);
					}
				}
			}
			catch (pError)
			{
				this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${pInputHash}) data from view in dataChanged event: ${pError}`);
			}
			finally
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
		else
		{
			this.marshalFromView();
		}
		// Run any dynamic input providers for the input hash.
		this.pict.PictApplication.solve();
		if (this.pict.views.PictFormMetacontroller)
		{
			// since the solver may have changed data in other secitons, remarshal all sections
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			this.marshalToView();
		}
		// Notify the FormPersistence provider if it exists, for autosave
		if (this.pict.providers.FormPersistence)
		{
			this.pict.providers.FormPersistence.onFormDataChanged();
		}
	}


	/**
	 * Called whenever tabular data is changed.
	 *
	 * @param {number} pGroupIndex - the index of the group
	 * @param {number} pInputIndex - the index of the input
	 * @param {number} pRowIndex - the index of the row where the data was changed
	 */
	dataChangedTabular(pGroupIndex, pInputIndex, pRowIndex)
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`Dynamic form [${this.Hash}]::[${this.UUID}] dataChangedTabular event for group ${pGroupIndex} input ${pInputIndex} row ${pRowIndex}.`);
		}
		let tmpInput = this.getTabularRecordInput(pGroupIndex, pInputIndex);
		if (
			(typeof (pGroupIndex) != 'undefined')
			&& (typeof (pInputIndex) != 'undefined')
			&& (typeof (pRowIndex) != 'undefined')
			&& (typeof (tmpInput) == 'object')
		)
		{
			// The informary stuff doesn't know the resolution of the hash to address, so do it here.
			let tmpHashAddress = tmpInput.Address;
			const tmpTransactionGUID = this.fable.getUUID();
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			try
			{
				let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
				this.pict.providers.Informary.marshalFormToData(tmpMarshalDestinationObject, this.formID, this.sectionManifest, tmpHashAddress, pRowIndex);

				// TODO: Can we simplify this?
				let tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				let tmpValue = this.sectionManifest.getValueByHash(tmpMarshalDestinationObject, tmpValueAddress);
				// Each row has a distinct address!
				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular + `[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = this.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (this.pict.providers[tmpInputProviderList[i]])
					{
						this.pict.providers[tmpInputProviderList[i]].onDataChangeTabular(this, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, tmpTransactionGUID);
					}
					else
					{
						this.log.error(`Dynamic form dataChangedTabular [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex}.`);
					}
				}
			}
			catch (pError)
			{
				this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${tmpInput.Hash}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in dataChanged event: ${pError}`);
			}
			finally
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
		else
		{
			// This is what is called whenever a hash is changed.  We could marshal from view, solve and remarshal to view.
			this.marshalFromView();
		}
		// Run any dynamic input providers for the input hash.
		this.pict.PictApplication.solve();
		if (this.pict.views.PictFormMetacontroller)
		{
			// since the solver may have changed data in other secitons, remarshal all sections
			this.pict.views.PictFormMetacontroller.marshalFormSections();
		}
		else
		{
			this.marshalToView();
		}
		// Notify the FormPersistence provider if it exists, for autosave
		if (this.pict.providers.FormPersistence)
		{
			this.pict.providers.FormPersistence.onFormDataChanged();
		}
	}

	/**
	 * Sets the data in a specific form input based on the provided input object
	 *
	 * FIXME: does this need to have a transaction GUID passed in?
	 *
	 * @param {object} pInput - The input object.
	 * @param {any} pValue - The value to set.
	 * @returns {boolean} Returns true if the data was set successfully, false otherwise.
	 */
	setDataByInput(pInput, pValue)
	{
		const tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.sectionManifest.setValueByHash(this.getMarshalDestinationObject(), pInput.Hash, pValue);

			// TODO: DRY TIME, excellent.
			let tmpValue = pValue;
			// Each row has a distinct address!
			let tmpVirtualInformaryHTMLSelector = pInput.Macro.HTMLSelector;
			let tmpInputProviderList = this.getInputProviderList(pInput);
			for (let i = 0; i < tmpInputProviderList.length; i++)
			{
				if (this.pict.providers[tmpInputProviderList[i]])
				{
					this.pict.providers[tmpInputProviderList[i]].onDataChange(this, pInput, tmpValue, tmpVirtualInformaryHTMLSelector, tmpTransactionGUID);
				}
				else
				{
					this.log.error(`Dynamic form setDataByInput [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${pInput.Hash}].`);
				}
			}
		}
		catch (pError)
		{
			this.log.error(`Dynamic form setDataByInput [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${pInput.Hash}) from view in dataChanged event: ${pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}

		return false;
	}

	/**
	 * Sets the data in a specific tabular form input based on the provided hash, group and row.
	 *
	 * FIXME: does this need to have a transaction GUID passed in?
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pInputHash - The hash of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {any} pValue - The value to set.
	 * @returns {boolean} Returns true if the data was set successfully, false otherwise.
	 */
	setDataTabularByHash(pGroupIndex, pInputHash, pRowIndex, pValue)
	{
		// The neat thing about how the tabular groups work is that we can make it clever about whether it's an object or an array.
		let tmpGroup = this.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper setDataTabularByHash ${pGroupIndex} was not a valid group.`);
			return false;
		}

		let tmpInputIndex = -1;
		let tmpElementDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
		for (let i = 0; i < tmpElementDescriptorKeys.length; i++)
		{
			if (tmpGroup.supportingManifest.elementDescriptors[tmpElementDescriptorKeys[i]].Hash === pInputHash)
			{
				tmpInputIndex = i;
				break;
			}
		}
		if (tmpInputIndex < 0)
		{
			this.log.warn(`PICT View Metatemplate Helper setDataTabularByHash Group ${pGroupIndex} did not have hash [${pInputHash}].`);
			return false;
		}

		let tmpInput = this.getTabularRecordInput(pGroupIndex, tmpInputIndex);
		if (
			(typeof (pGroupIndex) != 'undefined')
			&& (typeof (pRowIndex) != 'undefined')
			&& (typeof (tmpInput) == 'object')
		)
		{
			// The informary stuff doesn't know the resolution of the hash to address, so do it here.
			const tmpTransactionGUID = this.fable.getUUID();
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
			try
			{
				let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
				let tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
				this.sectionManifest.setValueByHash(tmpMarshalDestinationObject, tmpValueAddress, pValue)

				// TODO: DRY TIME, excellent.
				let tmpValue = pValue;
				// Each row has a distinct address!
				let tmpVirtualInformaryHTMLSelector = tmpInput.Macro.HTMLSelectorTabular + `[data-i-index="${pRowIndex}"]`;
				let tmpInputProviderList = this.getInputProviderList(tmpInput);
				for (let i = 0; i < tmpInputProviderList.length; i++)
				{
					if (this.pict.providers[tmpInputProviderList[i]])
					{
						this.pict.providers[tmpInputProviderList[i]].onDataChangeTabular(this, tmpInput, tmpValue, tmpVirtualInformaryHTMLSelector, pRowIndex, tmpTransactionGUID);
					}
					else
					{
						this.log.error(`Dynamic form setDataTabularByHash [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[i]}] for input [${tmpInput.Hash}] row ${pRowIndex}.`);
					}
				}
			}
			catch (pError)
			{
				this.log.error(`Dynamic form setDataTabularByHash [${this.Hash}]::[${this.UUID}] gross error marshaling specific (${pInputHash}) tabular data for group ${pGroupIndex} row ${pRowIndex} from view in dataChanged event: ${pError}`);
			}
			finally
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}

		return false;
	}

	/**
	 * Retrieves the marshal destination address.
	 *
	 * @returns {string} The marshal destination address.
	 */
	getMarshalDestinationAddress()
	{
		return this.viewMarshalDestination || this.pict.providers.DataBroker.marshalDestination;
	}

	/**
	 * Retrieves the marshal destination object.  This is where the model data is stored.
	 *
	 * @return {Record<string, any>} The marshal destination object.
	 */
	getMarshalDestinationObject()
	{
		return this.pict.providers.DataBroker.resolveMarshalDestinationObject(this.viewMarshalDestination);
	}

	/**
	 * Gets a value by hash address.
	 *
	 * @param {string} pHashAddress
	 * @return {any} The value at the specified hash address.
	 */
	getValueByHash(pHashAddress)
	{
		return this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), pHashAddress);
	}

	/**
	 * Gets a value by hash address.
	 *
	 * @param {number} pGroupIndex
	 * @param {number} pInputIndex
	 * @param {number} pRowIndex
	 * @return {any} The value at the specified hash address.
	 */
	getTabularValueByHash(pGroupIndex, pInputIndex, pRowIndex)
	{
		const tmpInput = this.getTabularRecordInput(pGroupIndex, pInputIndex);
		const tmpAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, pRowIndex, tmpInput.PictForm.InformaryDataAddress);
		return this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), tmpAddress);
	}

	/**
	 * Marshals data to the view.
	 *
	 * @returns {any} The result of calling the superclass's onMarshalToView method.
	 */
	onMarshalToView()
	{
		// TODO: Only marshal data that has changed since the last marshal.  Thought experiment: who decides what changes happened?
		const tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
			// TODO: Add optional transaction awareness to informary
			this.pict.providers.Informary.marshalDataToForm(tmpMarshalDestinationObject, this.formID, this.sectionManifest);
			this.runLayoutProviderFunctions('onDataMarshalToForm', tmpTransactionGUID);
			this.runInputProviderFunctions('onDataMarshalToForm', null, null, tmpTransactionGUID);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling data to view: ${pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
		return super.onMarshalToView();
	}

	manualMarshalDataToViewByInput(pInput, pTransactionGUID)
	{
		const tmpTransactionGUID = (typeof(pTransactionGUID) == 'string') ? pTransactionGUID : this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.pict.providers.Informary.manualMarshalDataToFormByInput(pInput);
			this.runLayoutProviderFunctions('onDataMarshalToForm', tmpTransactionGUID);
			this.runInputProviderFunctions('onDataMarshalToForm', pInput.Hash, null, tmpTransactionGUID);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling data to view: ${pError}`);
		}
		finally
		{
			if (tmpTransactionGUID !== pTransactionGUID)
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
	}

	manualMarshalTabularDataToViewByInput(pInput, pRowIndex, pTransactionGUID)
	{
		const tmpTransactionGUID = (typeof(pTransactionGUID) == 'string') ? pTransactionGUID : this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.pict.providers.Informary.manualMarshalTabularDataToFormByInput(pInput, pRowIndex);
			this.runLayoutProviderFunctions('onDataMarshalToForm', tmpTransactionGUID);
			this.runInputProviderFunctions('onDataMarshalToForm', pInput.Hash, pRowIndex, tmpTransactionGUID);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling tabular data to view: ${pError}`);
		}
		finally
		{
			if (tmpTransactionGUID !== pTransactionGUID)
			{
				this.finalizeTransaction(tmpTransactionGUID);
			}
		}
	}

	/**
	 * Marshals data from the view to the destination object.
	 * @returns {any} The result of calling the superclass's onMarshalFromView method.
	 */
	onMarshalFromView()
	{
		try
		{
			let tmpMarshalDestinationObject = this.getMarshalDestinationObject();
			this.pict.providers.Informary.marshalFormToData(tmpMarshalDestinationObject, this.formID, this.sectionManifest);
		}
		catch (pError)
		{
			this.log.error(`Gross error marshaling data from view: ${pError}`);
		}
		return super.onMarshalFromView();
	}

	/**
	 * Executes after marshaling the data to the form.
	 * Checks if there are any hooks set from the input providers (from custom InputType handler hooks) and runs them.
	 */
	onAfterMarshalToForm()
	{
		// Check to see if there are any hooks set from the input templates
		const tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		try
		{
			this.runInputProviderFunctions('onAfterMarshalToForm', null, null, tmpTransactionGUID);

		}
		catch (pError)
		{
			this.log.error(`Gross error running after marshal to form: ${pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Executes the solve operation for the dynamic views.
	 *
	 * @returns {any} The result of the solve operation.
	 */
	onSolve()
	{
		// Usually the metacontroller runs this for the views
		if (this.options.ExecuteSolversWithoutMetacontroller)
		{
			this.pict.providers.DynamicSolver.solveViews([this.Hash]);
		}
		return super.onSolve();
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		if (!this.initialBundleLoaded)
		{
			if (Array.isArray(this.sectionDefinition.InitialBundle))
			{
				this.pict.EntityProvider.processBundle(this.sectionDefinition.InitialBundle);
			}
			this.initialBundleLoaded = true;
		}
		return super.onBeforeRender(pRenderable);
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {(error?: Error) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		super.onBeforeRenderAsync((pError) =>
		{
			if (!this.initialBundleLoaded)
			{
				if (Array.isArray(this.sectionDefinition.InitialBundle))
				{
					this.pict.EntityProvider.gatherDataFromServer(this.sectionDefinition.InitialBundle, (pInnerError) =>
					{
						if (pInnerError)
						{
							this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] failed to load initial bundle: ${pInnerError}`);
						}
						// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
						setTimeout(() => fCallback(pError), 0);
					});
					return;
				}
				this.initialBundleLoaded = true;
			}
			return fCallback(pError);
		}, pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		let tmpTransactionGUID = this.fable.getUUID();
		this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);

		try
		{
			this.runLayoutProviderFunctions('onGroupLayoutInitialize', tmpTransactionGUID);
			this.runInputProviderFunctions('onInputInitialize', null, null, tmpTransactionGUID, true);
		}
		catch (pError)
		{
			this.log.error(`Gross error running after render: ${pError.message || pError}`);
		}
		finally
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
		return super.onAfterRender(pRenderable);
	}

	/**
	 * Executes layout provider functions based on the given function name.
	 *
	 * These were TODO items that are now done but..  leaving them here to document complexity of why it works this way.
	 *
	 * --> This happens based on markers in the DOM, since we don't know which layout providers are active for which groups.
	 *
	 * --> This is easy to make happen with a macro on groups that gives us the data.
	 *
	 * --> THIS IS NOW SCOPED TO A PARTICULAR GROUP.  That is ... only one layout for a group at a time.
	 *
	 * The easiest way (and a speed up for other queries as such) is to scope it within the view container element
	 *
	 * @param {string} pFunctionName - The name of the function to execute.
	 * @param {string} [pTransactionGUID] - The transaction GUID to use for logging.
	 */
	runLayoutProviderFunctions(pFunctionName, pTransactionGUID)
	{
		const tmpTransactionGUID = (typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		const tmpTransaction = this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);

		// Check to see if there are any hooks set from the input templates
		let tmpLayoutProviders = this.pict.ContentAssignment.getElement(`${this.sectionDefinition.DefaultDestinationAddress} [data-i-pictdynamiclayout="true"]`);

		// Slightly more code for getting the active layout providers but provides TRUE DYNAMISM.
		for (let i = 0; i < tmpLayoutProviders.length; i++)
		{
			let tmpGroupIndex = tmpLayoutProviders[0].getAttribute('data-i-pictgroupindex');
			let tmpLayout = tmpLayoutProviders[0].getAttribute('data-i-pictlayout');

			if (isNaN(tmpGroupIndex) || (tmpGroupIndex < 0))
			{
				this.log.warn(`PICT View Metatemplate Helper runLayoutProviderFunctions ${tmpGroupIndex} was not a valid group index.`);
				continue;
			}
			let tmpGroup = this.getGroup(tmpGroupIndex);
			if (!tmpGroup)
			{
				this.log.warn(`PICT View Metatemplate Helper runLayoutProviderFunctions for group ${tmpGroupIndex} was not a valid group.`);
				continue;
			}
			if (!tmpLayout || typeof (tmpLayout) !== 'string')
			{
				this.log.warn(`PICT View Metatemplate Helper runLayoutProviderFunctions for group ${tmpGroup} layout [${tmpLayout}] was not a valid layout.`);
				continue;
			}

			let tmpLayoutProvider = this.pict.providers.MetatemplateGenerator.getGroupLayoutProvider(this, tmpGroup);
			if (tmpLayoutProvider && (pFunctionName in tmpLayoutProvider))
			{
				let tmpFunction = tmpLayoutProvider[pFunctionName];
				if (this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `G${tmpGroupIndex}-L${tmpLayout}`, pFunctionName))
				{
					tmpFunction.call(tmpLayoutProvider, this, tmpGroup);
				}
			}
		}
		if (tmpTransactionGUID !== pTransactionGUID)
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * @private
	 * @param {string} pFunctionName
	 * @param {string} [pInputHash]
	 * @param {number} [pRowIndex]
	 */
	_trackInfiniteLoop(pFunctionName, pInputHash, pRowIndex)
	{
		this._LoopDetectionData[pFunctionName] = this._LoopDetectionData[pFunctionName] || {};
		const tmpInputSignature = `${pInputHash ?? ''}::${pRowIndex ?? ''}`;
		const tmpNowEpochMS = Date.now();
		this._LoopDetectionData[pFunctionName][tmpInputSignature] = this._LoopDetectionData[pFunctionName][tmpInputSignature] || { Count: 0, Timestamp: tmpNowEpochMS };
		if (tmpNowEpochMS - this._LoopDetectionData[pFunctionName][tmpInputSignature].Timestamp > 1000)
		{
			// only track events within a 1 second window
			this._LoopDetectionData[pFunctionName][tmpInputSignature].Count = 0;
			this._LoopDetectionData[pFunctionName][tmpInputSignature].Timestamp = tmpNowEpochMS;
		}
		this._LoopDetectionData[pFunctionName][tmpInputSignature].Count += 1;
		return this._LoopDetectionData[pFunctionName][tmpInputSignature];
	}

	/**
	 * Runs the input provider functions.
	 *
	 * @param {string} pFunctionName - The name of the function to run for each input provider.
	 * @param {string} [pInputHash] - The hash of the input to run the function for.
	 * @param {number} [pRowIndex] - The index of the row to run the
	 * @param {string} [pTransactionGUID] - The transaction GUID to use for logging.
	 * @param {boolean} [pLoopDetection] - Whether to enable loop detection.
	 */
	runInputProviderFunctions(pFunctionName, pInputHash, pRowIndex, pTransactionGUID, pLoopDetection)
	{
		const tmpLoopData = this._trackInfiniteLoop(pFunctionName, pInputHash, pRowIndex);
		if (pLoopDetection && tmpLoopData.Count > 10) // seems like a reasonable threshold for now (10 inits in a second)
		{
			this.log.fatal(` !!!!!! Infinite loop detected in runInputProviderFunctions for function [${pFunctionName}] on input [${pInputHash}] row [${pRowIndex}] in form [${this.Hash}]::[${this.UUID}].  Aborting further processing.`, { Stack: new Error().stack });
			return;
		}
		const tmpTransactionGUID = (typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		const tmpTransaction = this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);

		// Check to see if there are any hooks set from the input templates
		for (let i = 0; i < this.sectionDefinition.Groups.length; i++)
		{
			let tmpGroup = this.sectionDefinition.Groups[i];

			if (Array.isArray(tmpGroup.Rows))
			{
				for (let j = 0; j < tmpGroup.Rows.length; j++)
				{
					// TODO: Do we want row macros?  Let's be still and find out.
					let tmpRow = tmpGroup.Rows[j];
					for (let k = 0; k < tmpRow.Inputs.length; k++)
					{
						let tmpInput = tmpRow.Inputs[k];
						// Now run any providers connected to this input
						if (tmpInput && tmpInput.PictForm
							&& (!pInputHash || (pInputHash === tmpInput.Hash)))
						{
							let tmpInputProviderList = this.getInputProviderList(tmpInput);
							for (let l = 0; l < tmpInputProviderList.length; l++)
							{
								if (this.pict.providers[tmpInputProviderList[l]])
								{
									let tmpHashAddress = this.sectionManifest.resolveHashAddress(tmpInput.Hash);
									let tmpValue = this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), tmpHashAddress);
									try
									{
										if (this.pict.LogNoisiness > 2)
										{
											this.log.trace(`Dynamic form [${this.Hash}]::[${this.UUID}] running provider [${tmpInputProviderList[l]}] function [${pFunctionName}] for input [${tmpInput.Hash}].`);
										}
										// TODO: Right now the Option input requires this bug to work
										//if (this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `I${tmpInput.Hash}-P${tmpInputProviderList[l]}`, pFunctionName))
										if ((tmpInput.PictForm.InputType == 'Option') || this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `I${tmpInput.Hash}-P${tmpInputProviderList[l]}`, pFunctionName))
										{
											this.pict.providers[tmpInputProviderList[l]][pFunctionName](this, tmpGroup, j, tmpInput, tmpValue, tmpInput.Macro.HTMLSelector, tmpTransactionGUID);
										}
									}
									catch (pError)
									{
										this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] failed to run provider [${tmpInputProviderList[l]}] function [${pFunctionName}] for input [${tmpInput.Hash}] with error: ${pError}`);
									}
								}
								else
								{
									this.log.error(`Dynamic form runInputProviderFunctions core [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[l]}] for input [${tmpInput.Hash}].`);
								}
							}
						}
					}
				}
			}

			if (tmpGroup.supportingManifest)
			{
				let tmpSupportingManifestDescriptorKeys = Object.keys(tmpGroup.supportingManifest.elementDescriptors);
				for (let k = 0; k < tmpSupportingManifestDescriptorKeys.length; k++)
				{
					let tmpTabularRecordSet = this.getTabularRecordSet(tmpGroup.GroupIndex);
					// No data in the record set, no events to push to providers.
					if (!tmpTabularRecordSet)
					{
						continue;
					}

					if (Array.isArray(tmpTabularRecordSet))
					{
						let tmpInput = tmpGroup.supportingManifest.elementDescriptors[tmpSupportingManifestDescriptorKeys[k]];
						// Now run any providers connected to this input
						if (tmpInput && tmpInput.PictForm
							&& (!pInputHash || (pInputHash === tmpInput.Hash)))
						{
							let tmpInputProviderList = this.getInputProviderList(tmpInput);
							for (let l = 0; l < tmpInputProviderList.length; l++)
							{
								let tmpRowsToExecute = [];
								if (pRowIndex != null)
								{
									if (pRowIndex < tmpTabularRecordSet.length)
									{
										tmpRowsToExecute.push(pRowIndex);
									}
									else
									{
										this.log.error(`Dynamic form runInputProviderFunctions [${this.Hash}]::[${this.UUID}] row index ${pRowIndex} is out of bounds for input [${tmpInput.Hash}] with ${tmpTabularRecordSet.length} rows.`);
									}
								}
								else
								{
									for (let r = 0; r < tmpTabularRecordSet.length; r++)
									{
										tmpRowsToExecute.push(r);
									}
								}
								for (const r of tmpRowsToExecute)
								{
									if (this.pict.providers[tmpInputProviderList[l]] &&
										(pRowIndex === undefined || pRowIndex === null || pRowIndex === r))
									{
										// There is a provider, we have an input and it is supposed to be run through for a record
										let tmpValueAddress = this.pict.providers.Informary.getComposedContainerAddress(tmpInput.PictForm.InformaryContainerAddress, r, tmpInput.PictForm.InformaryDataAddress);
										let tmpValue = this.sectionManifest.getValueByHash(this.getMarshalDestinationObject(), tmpValueAddress);
										try
										{
											if (this.pict.TransactionTracking.checkEvent(tmpTransaction.TransactionKey, `TI${tmpInput.Hash}-P${tmpInputProviderList[l]}-R${r}`, pFunctionName))
											{
												this.pict.providers[tmpInputProviderList[l]][pFunctionName + 'Tabular'](this, tmpGroup, tmpInput, tmpValue, tmpInput.Macro.HTMLSelectorTabular, r, tmpTransactionGUID);
											}
										}
										catch (pError)
										{
											this.log.error(`Dynamic form [${this.Hash}]::[${this.UUID}] failed to run provider [${tmpInputProviderList[l]}] function [${pFunctionName}] for input [${tmpInput.Hash}] with error: ${pError}`);
										}
									}
									else
									{
										this.log.error(`Dynamic form runInputProviderFunctions supporting [${this.Hash}]::[${this.UUID}] cannot find provider [${tmpInputProviderList[l]}] for input [${tmpInput.Hash}]${pRowIndex != null ? ` in row ${pRowIndex}` : ''}.`);
									}
								}
							}
						}
					}
				}
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Checks if a view-specific template exists based on the given template postfix.
	 * @param {string} pTemplatePostfix - The postfix of the template to check.
	 * @returns {boolean} - Returns true if the view-specific template exists, otherwise false.
	 */
	checkViewSpecificTemplate(pTemplatePostfix)
	{
		// This is here to cut down on complex guards, and, so we can optimize/extend it later if we need to.
		return (this.getViewSpecificTemplateHash(pTemplatePostfix) in this.pict.TemplateProvider.templates);
	}

	/**
	 * Returns the template hash for the view specific template.
	 *
	 * @param {string} pTemplatePostfix - The postfix for the template.
	 * @returns {string} The template hash for the view specific template.
	 */
	getViewSpecificTemplateHash(pTemplatePostfix)
	{
		return `${this.formsTemplateSetPrefix}${pTemplatePostfix}`;
	}

	/**
	 * Checks if a theme-specific template exists.
	 *
	 * @param {string} pTemplatePostfix - The postfix of the template.
	 * @returns {boolean} - Returns true if the theme-specific template exists, otherwise false.
	 */
	checkThemeSpecificTemplate(pTemplatePostfix)
	{
		// This is here to cut down on complex guards, and, so we can optimize/extend it later if we need to.
		return (this.getThemeSpecificTemplateHash(pTemplatePostfix) in this.pict.TemplateProvider.templates);
	}

	/**
	 * Returns the theme-specific template hash based on the given template postfix.
	 *
	 * @param {string} pTemplatePostfix - The postfix to be appended to the default template prefix.
	 * @returns {string} The theme-specific template hash.
	 */
	getThemeSpecificTemplateHash(pTemplatePostfix)
	{
		// This is here to cut down on complex guards, and, so we can optimize/extend it later if we need to.
		return `${this.defaultTemplatePrefix}${pTemplatePostfix}`;
	}

	/**
	 * Rebuilds the custom template fore the dynamic form..
	 */
	rebuildCustomTemplate()
	{
		this.pict.providers.MetatemplateGenerator.rebuildCustomTemplate(this);
	}

	/**
	 * Returns the index of a group within the sectionDefinition.Groups array that matches the provided hash.
	 *
	 * @param {string} pGroupHash - The hash value of the group to find.
	 * @returns {number} The index of the group if found; otherwise, -1.
	 */
	getGroupIndexFromHash(pGroupHash)
	{
		for (let i = 0; i < this.sectionDefinition.Groups.length; i++)
		{
			if (this.sectionDefinition.Groups[i].Hash === pGroupHash)
			{
				return i;
			}
		}
		this.log.warn(`PICT View Metatemplate Helper getGroupIndexByHash could not find group with hash [${pGroupHash}].`);
		return -1;
	}

	/**
	 * Get a group by its hash
	 * @param {string} pGroupHash - The hash of the group to retrieve.
	 * @returns {object|boolean} - The group object if found, or false if the group hash is not found.
	 */
	getGroupFromHash(pGroupHash)
	{
		for (let i = 0; i < this.sectionDefinition.Groups.length; i++)
		{
			if (this.sectionDefinition.Groups[i].Hash === pGroupHash)
			{
				return this.sectionDefinition.Groups[i];
			}
		}
		this.log.warn(`PICT View Metatemplate Helper getGroupByHash could not find group with hash [${pGroupHash}].`);
		return false;
	}

	/**
	 * Retrieves a group from the PICT View Metatemplate Helper based on the provided group index.
	 *
	 * @param {number} pGroupIndex - The index of the group to retrieve.
	 * @returns {object|boolean} - The group object if found, or false if the group index is invalid.
	 */
	getGroup(pGroupIndex)
	{
		if (isNaN(pGroupIndex))
		{
			this.log.warn(`PICT View Metatemplate Helper getGroup ${pGroupIndex} was expecting a number.`);
			return false;
		}
		if (pGroupIndex > this.sectionDefinition.Groups.length)
		{
			this.log.warn(`PICT View Metatemplate Helper getGroup ${pGroupIndex} was out of bounds.`);
			return false;
		}

		return this.sectionDefinition.Groups[pGroupIndex];
	}

	/**
	 * Returns all groups in the section.
	 * @returns {Array}
	 */
	getGroups()
	{
		if (!Array.isArray(this.sectionDefinition.Groups))
		{
			return [];
		}
		return this.sectionDefinition.Groups;
	}

	/**
	 * Get a row for an input form group.
	 *
	 * Rows are a horizontal collection of inputs.
	 *
	 * @param {number} pGroupIndex
	 * @param {number} pRowIndex
	 * @returns
	 */
	getRow(pGroupIndex, pRowIndex)
	{
		let tmpGroup = this.getGroup(pGroupIndex);

		if (tmpGroup)
		{
			if (isNaN(pRowIndex))
			{
				this.log.warn(`PICT View Metatemplate Helper getRow ${pRowIndex} was expecting a number.`);
				return false;
			}
			if (pRowIndex > tmpGroup.Rows.length)
			{
				//this.log.warn(`PICT View Metatemplate Helper getRow ${pRowIndex} was out of bounds.`);
				return [];
			}
			return tmpGroup.Rows[pRowIndex];
		}
		else
		{
			return false;
		}
	}

	/**
	 * Get a customized key value pair object for a specific row.
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {Object} a key value pair for a specific row, used in metatemplating.
	 */
	getRowKeyValuePair(pGroupIndex, pRowIndex)
	{
		return { Key: pGroupIndex, Value: this.getRow(pGroupIndex, pRowIndex), Group: this.getGroup(pGroupIndex) };
	}

	/**
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {number} pInputIndex - The index of the input.
	 * @returns {Object|boolean} The input object if found, or false if the input index is invalid.
	 */
	getInput(pGroupIndex, pRowIndex, pInputIndex)
	{
		let tmpRow = this.getRow(pGroupIndex, pRowIndex);

		if (tmpRow)
		{
			if (isNaN(pInputIndex))
			{
				this.log.warn(`PICT View Metatemplate Helper getInput ${pInputIndex} was expecting a number.`);
				return false;
			}
			if (pInputIndex > tmpRow.Inputs.length)
			{
				this.log.warn(`PICT View Metatemplate Helper getInput ${pInputIndex} was out of bounds.`);
				return false;
			}
			return tmpRow.Inputs[pInputIndex];
		}
		else
		{
			return false;
		}
	}

	/**
	 * Retrieves the input provider list for the given input object.
	 *
	 * @param {Object} pInput - The input object.
	 * @returns {Array} The input provider list.
	 */
	getInputProviderList(pInput)
	{
		if (!('PictForm' in pInput))
		{
			return [];
		}
		if (('Providers' in pInput.PictForm) && Array.isArray(pInput.PictForm.Providers))
		{
			let tmpDefaultProviders = this.pict.providers.DynamicInput.getDefaultInputProviders(this, pInput);

			if (tmpDefaultProviders.length > 0)
			{
				return tmpDefaultProviders.concat(pInput.PictForm.Providers);
			}
			return pInput.PictForm.Providers;
		}
		else
		{
			return this.pict.providers.DynamicInput.getDefaultInputProviders(this, pInput);
		}
	}

	/**
	 * Retrieves the input object for a specific hash.
	 *
	 * @param {string} pInputHash - The string hash for an input (not the address).
	 * @returns {Object} The input Object for the given hash.
	 */
	getInputFromHash(pInputHash)
	{
		return this.sectionManifest.getDescriptorByHash(pInputHash);
	}

	/**
	 * Triggers a DataRequest event for an Input Provider
	 *
	 * @param {String} pInputHash - The input hash.
	 * @param {any} [pEvent] - The input event.
	 * @returns {boolean} Whether or not the data request was successful.
	 */
	inputDataRequest(pInputHash, pEvent)
	{
		return this.pict.providers.DynamicInputEvents.inputDataRequest(this, pInputHash, pEvent);
	}

	/**
	 * Handles the generic Input Event for an Input Provider
	 *
	 * @param {String} pInputHash - The input hash object.
	 * @param {string} pEvent - The input event string.
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 * @returns {any} - The result of the input event handling.
	 */
	inputEvent(pInputHash, pEvent, pTransactionGUID)
	{
		return this.pict.providers.DynamicInputEvents.inputEvent(this, pInputHash, pEvent, pTransactionGUID);
	}

	/**
	 * @deprecated
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	globalInputEvent(pEvent, pCompletedHashes, pTransactionGUID)
	{
		this.manifestInputEvent(pEvent, pCompletedHashes, pTransactionGUID);
	}

	/**
	 *
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	manifestInputEvent(pEvent, pCompletedHashes, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		const tmpInputHashes = Object.keys(this.sectionManifest.elementHashes);

		for (let i = 0; i < tmpInputHashes.length; i++)
		{
			if (!(tmpInputHashes[i] in pCompletedHashes))
			{
				pCompletedHashes[tmpInputHashes[i]] = true;
				this.inputEvent(tmpInputHashes[i], pEvent, pTransactionGUID);
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			// We created a transaction, so finalize it.
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Triggers a DataRequest event for an Input Provider
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {any} [pEvent] - The input event.
	 * @returns {Promise<any>} A promise that resolves with the input data.
	 */
	inputDataRequestTabular(pGroupIndex, pInputIndex, pRowIndex, pEvent)
	{
		return this.pict.providers.DynamicInputEvents.inputDataRequestTabular(this, pGroupIndex, pInputIndex, pRowIndex, pEvent);
	}

	/**
	 * Handles the generic Tabular Input Event for an Input Provider
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @param {number} pRowIndex - The index of the row.
	 * @param {string} pEvent - The input event object.
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 * @returns {any} - The result of the input event handling.
	 */
	inputEventTabular(pGroupIndex, pInputIndex, pRowIndex, pEvent, pTransactionGUID)
	{
		return this.pict.providers.DynamicInputEvents.inputEventTabular(this, pGroupIndex, pInputIndex, pRowIndex, pEvent, pTransactionGUID);
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 */
	registerEventTransactionAsyncOperation(pTransactionGUID, pAsyncOperationHash)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, pAsyncOperationHash, PENDING_ASYNC_OPERATION_TYPE);
	}

	/**
	 * FIXME: consolidate with same functions(s) in the metacontroller
	 *
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 *
	 * @return {boolean} - Returns true if the async operation was found and marked as complete, otherwise false.
	 */
	eventTransactionAsyncOperationComplete(pTransactionGUID, pAsyncOperationHash)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpMarkedOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				if (tmpQueueItem.Data === pAsyncOperationHash)
				{
					tmpQueue.splice(i, 1);
					++tmpMarkedOperationCount;
					--i;
				}
				else
				{
					++tmpPendingAsyncOperationCount;
				}
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpMarkedOperationCount === 0)
		{
			this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete ${pTransactionGUID} could not find async operation with hash ${pAsyncOperationHash}.`);
			return;
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			for (let i = 0; i < tmpQueue.length; i++)
			{
				const tmpQueueItem = tmpQueue[i];
				if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
				{
					tmpQueue.splice(i, 1);
					--i;
					if (typeof tmpQueueItem.Data !== 'function')
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback was not a function.`);
						continue;
					}
					try
					{
						tmpQueueItem.Data();
					}
					catch (pError)
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback error: ${pError}`, { Stack: pError.stack });
					}
				}
			}
			delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		}
		return tmpMarkedOperationCount > 0;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 *
	 * @return {boolean} - Returns true if the transaction was found and able to be finalized, otherwise false.
	 */
	finalizeTransaction(pTransactionGUID)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, null, READY_TO_FINALIZE_TYPE);

		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
		}
		if (tmpPendingAsyncOperationCount > 0)
		{
			this.pict.log.info(`PICT View Metatemplate Helper finalizeTransaction ${pTransactionGUID} is waiting on ${tmpPendingAsyncOperationCount} pending async operations.`);
			return false;
		}
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
			{
				tmpQueue.splice(i, 1);
				--i;
				if (typeof tmpQueueItem.Data !== 'function')
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback was not a function.`);
					continue;
				}
				try
				{
					tmpQueueItem.Data();
				}
				catch (pError)
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback error: ${pError}`, { Stack: pError.stack });
				}
			}
		}
		delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		return true;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Function} fCallback - The callback to call when the transaction is complete.
	 */
	registerOnTransactionCompleteCallback(pTransactionGUID, fCallback)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			fCallback();
		}
		else
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, fCallback, TRANSACTION_COMPLETE_CALLBACK_TYPE);
		}
	}

	/**
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	groupInputEvent(pGroupIndex, pEvent, pCompletedHashes, pTransactionGUID)
	{
		const tmpGroup = this.getGroup(pGroupIndex);

		if (!tmpGroup)
		{
			this.log.warn(`PICT View Metatemplate Helper subManifestInputEvent ${pGroupIndex} is not a valid group index.`);
			return;
		}

		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}
		if (tmpGroup.Rows.length < 1)
		{
			// tabular
			const tmpRecordSetRows = this.getTabularRecordSet(pGroupIndex);
			if (!Array.isArray(tmpRecordSetRows))
			{
				return;
			}
			for (let i = 0; i < tmpRecordSetRows.length; i++)
			{
				for (const tmpInput of Object.values(tmpGroup.supportingManifest.elementDescriptors))
				{
					const tmpInputSignature = `${this.Hash}-${tmpGroup.Hash}-${tmpInput.Hash}-${i}`;
					if (!(tmpInputSignature in pCompletedHashes))
					{
						pCompletedHashes[tmpInputSignature] = true;
						this.inputEventTabular(pGroupIndex, tmpInput.PictForm.InputIndex, i, pEvent, tmpTransactionGUID);
					}
				}
			}
		}
		for (const tmpRow of tmpGroup.Rows || [])
		{
			for (const tmpInput of tmpRow.Inputs || [])
			{
				const tmpInputSignature = `${this.Hash}-${tmpGroup.Hash}-${tmpInput.Hash}-${tmpRow.Hash}`;
				if (!(tmpInputSignature in pCompletedHashes))
				{
					pCompletedHashes[tmpInputSignature] = true;
					this.inputEvent(tmpInput.Hash, pEvent, tmpTransactionGUID);
				}
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			// We created a transaction, so finalize it.
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 *
	 * @param {string} pEvent - The input event string.
	 * @param {Object} pCompletedHashes - the hashes that have already signaled the event
	 * @param {string} [pTransactionGUID] - The transaction GUID.
	 */
	sectionInputEvent(pEvent, pCompletedHashes, pTransactionGUID)
	{
		const tmpGroupCount = this.sectionDefinition.Groups.length;
		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}

		for (let i = 0; i < tmpGroupCount; i++)
		{
			this.groupInputEvent(i, pEvent, pCompletedHashes, pTransactionGUID);
		}
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * Get the input object for a specific tabular record group and index.
	 *
	 * Input objects are not distinct among rows.
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pInputIndex - The index of the input.
	 * @returns
	 */
	getTabularRecordInput(pGroupIndex, pInputIndex)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordInput(this, pGroupIndex, pInputIndex);
	}

	/**
	 * Get the input object for a specific tabular record group and index.
	 *
	 * Input objects are not distinct among rows.
	 *
	 * @param {string} pGroupHash - The hash of the group.
	 * @param {string} pInputHash - The hash of the input.
	 *
	 * @return {Object} The input object.
	 */
	getTabularRecordInputByHash(pGroupHash, pInputHash)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordInputByHash(this, pGroupHash, pInputHash);
	}

	/**
	 * Get the tabular record object for a particular row in a group.
	 *
	 * @param {number} pGroupIndex
	 * @param {number} pRowIdentifier - The row number
	 * @returns {Object} The record for the particular row
	 */
	getTabularRecordData(pGroupIndex, pRowIdentifier)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordData(this, pGroupIndex, pRowIdentifier);
	}

	/**
	 * Get the tabular record set for a particular group.
	 *
	 * @param {number} pGroupIndex
	 * @returns {Array} The record set for the group.
	 */
	getTabularRecordSet(pGroupIndex)
	{
		return this.pict.providers.DynamicTabularData.getTabularRecordSet(this, pGroupIndex);
	}

	/**
	 * Add a new data row to the end of a dynamic tabular group.
	 *
	 * This will generate any defaults in the SubManifest.
	 *
	 * @param {number} pGroupIndex
	 * @returns
	 */
	createDynamicTableRow(pGroupIndex)
	{
		return this.pict.providers.DynamicTabularData.createDynamicTableRow(this, pGroupIndex);
	}

	/**
	 * Move a dynamic table row to an arbitrary position in the array.
	 *
	 * @param {number} pGroupIndex - The group to manage the dynamic table row for
	 * @param {number} pRowIndex - The row to move
	 * @param {number} pNewRowIndex - The new position for the row
	 * @returns {boolean} True if the move was successful, or false if it wasn't.
	 */
	setDynamicTableRowIndex(pGroupIndex, pRowIndex, pNewRowIndex)
	{
		return this.pict.providers.DynamicTabularData.setDynamicTableRowIndex(this, pGroupIndex, pRowIndex, pNewRowIndex);
	}

	/**
	 * Move a dynamic table row down
	 *
	 * @param {number} pGroupIndex - The group to manage the dynamic table row for
	 * @param {number} pRowIndex - The row to move down
	 * @returns {boolean} True if the move was successful, or false if it wasn't.
	 */
	moveDynamicTableRowDown(pGroupIndex, pRowIndex)
	{
		return this.pict.providers.DynamicTabularData.moveDynamicTableRowDown(this, pGroupIndex, pRowIndex);
	}

	/**
	 * Move a dynamic table row up
	 *
	 * @param {number} pGroupIndex - The group to manage the dynamic table row for
	 * @param {number} pRowIndex - The row to move up
	 * @returns {boolean} True if the move was successful, or false if it wasn't.
	 */
	moveDynamicTableRowUp(pGroupIndex, pRowIndex)
	{
		return this.pict.providers.DynamicTabularData.moveDynamicTableRowUp(this, pGroupIndex, pRowIndex);
	}

	/**
	 * Deletes a dynamic table row.
	 *
	 * @param {number} pGroupIndex - The index of the group.
	 * @param {number} pRowIndex - The index of the row.
	 * @returns {Promise} A promise that resolves when the row is deleted.
	 */
	deleteDynamicTableRow(pGroupIndex, pRowIndex)
	{
		return this.pict.providers.DynamicTabularData.deleteDynamicTableRow(this, pGroupIndex, pRowIndex);
	}

	/**
	 * Returns whether the current form is a Pict Section form.
	 * @returns {boolean} True if the form is a Pict Section form, false otherwise.
	 */
	get isPictSectionForm()
	{
		return true;
	}
}

module.exports = PictViewDynamicForm;

module.exports.default_configuration = _DefaultConfiguration;

},{"../../package.json":63,"./Pict-View-DynamicForm-DefaultConfiguration.json":121,"pict-view":239}],123:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const libPictDynamicFormDependencyManager = require(`../services/Pict-Service-DynamicFormDependencyManager.js`);
const libPictViewDynamicForm = require('./Pict-View-DynamicForm.js');

// TODO: Potentially create an internalized list of views for this to manage, separate from the pict.views object
// TODO: Manage view lifecycle internally, including destruction of views if they are flagged to not be needed.
// Why?  This allows us to dynamically add and remove sections without having to reload the application.

const PENDING_ASYNC_OPERATION_TYPE = 'PendingAsyncOperation';
const TRANSACTION_COMPLETE_CALLBACK_TYPE = 'onTransactionComplete';
const READY_TO_FINALIZE_TYPE = 'ReadyToFinalize';

/**
 * @typedef {(a: any, b: any) => number} SortFunction
 * @typedef {import('manyfest').ManifestDescriptor} ManifestDescriptor
 */

/**
 * Class representing a PictFormMetacontroller.
 *
 * The metacontroller creates, manages and runs dynamic views and their lifecycle events.
 *
 * @extends libPictViewClass
 */
class PictFormMetacontroller extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictFormMetacontroller';

		// Load the dynamic application dependencies if they don't exist
		this.fable.addAndInstantiateSingletonService('PictDynamicFormDependencyManager', libPictDynamicFormDependencyManager.default_configuration, libPictDynamicFormDependencyManager);

		this.lastRenderedViews = [];

		this.formTemplatePrefix = this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;

		this.manifest = this.pict.manifest;

		this.AutoSolveOnFirstRender = true;
		this.FirstRenderCompleted = false;

		// Destination address for entity comprehensions generated by the addComprehensionEntity solver
		// function.  Resolves relative to the pict instance (so `AppData.X`, `Bundle.X`, etc. all work).
		// Override in code (`this.pict.views.PictFormMetacontroller.comprehensionDestinationAddress = '...'`)
		// or via the view options (`ComprehensionDestinationAddress`).
		this.comprehensionDestinationAddress = (this.options && typeof this.options.ComprehensionDestinationAddress === 'string' && this.options.ComprehensionDestinationAddress.length > 0)
			? this.options.ComprehensionDestinationAddress
			: 'AppData.FormEntityComprehensions';

		this.SupportViewPrototypes = (
		{
			LifecycleVisualization: require('./support/Pict-View-PSF-LifeCycle-Visualization.js'),
			DebugViewer: require('./support/Pict-View-PSF-DebugViewer.js'),
			AppDataViewer: require('./support/Pict-View-PSF-AppData-Visualization.js'),
			SolverVisualization: require('./support/Pict-View-PSF-Solver-Visualization.js'),
			SpecificSolveVisualization: require('./support/Pict-View-PSF-SpecificSolve-Visualization.js'),
		});
	}

	get viewMarshalDestination()
	{
		return this.pict.providers.DataBroker.marshalDestination;
	}

	set viewMarshalDestination(pValue)
	{
		this.pict.providers.DataBroker.marshalDestination = pValue;
	}

	/**
	 * Marshals data from the view to the model, usually AppData (or configured data store).
	 *
	 * @returns {any} The result of the superclass's onMarshalFromView method.
	 */
	onMarshalFromView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalFromView();
			}
		}
		return super.onMarshalFromView();
	}

	/**
	 * Marshals the data to the view from the model, usually AppData (or configured data store).
	 *
	 * @returns {any} The result of the super.onMarshalToView() method.
	 */
	onMarshalToView()
	{
		let tmpViewList = Object.keys(this.fable.views);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (this.fable.views[tmpViewList[i]].isPictSectionForm)
			{
				this.fable.views[tmpViewList[i]].marshalToView();
			}
		}
		return super.onMarshalToView();
	}

	gatherInitialBundle(fCallback)
	{
		if (this.manifestDescription && this.manifestDescription.InitialBundle)
		{
			this.log.info(`Gathering initial bundle for ${this.manifestDescription.InitialBundle.length} entities.`);
			return this.pict.EntityProvider.gatherDataFromServer(this.manifestDescription.InitialBundle, (pError) =>
			{
				// in case of an empty array, or all tasks being synchronous, wait for the next tick so we don't get event ordering problems
				setTimeout(() => fCallback(pError), 0);
			});
		}
		else
		{
			this.log.info('No initial bundle to gather.');
			return fCallback();
		}
	}

	/**
	 * Executes after the initialization of the object.
	 *
	 * @param {ErrorCallback} fCallback - The callback function to be executed after the initialization.
	 * @returns {void}
	 */
	onAfterInitializeAsync(fCallback)
	{

		return super.onAfterInitializeAsync(
			function (pError)
			{
				if (pError)
				{
					return fCallback(pError);
				}
				this.gatherInitialBundle((pError) =>
				{
					// This is safe -- if there is no settings.DefaultFormManifest configuration, it just doesn't do anything
					this.bootstrapPictFormViewsFromManifest();
					// Generate the metatemplate (the container for each section)
					this.generateMetatemplate();

					return fCallback(pError);
				});
			}.bind(this));
	}

	/**
	 * Executes after the view is rendered.
	 * It regenerates the form section templates, renders the form sections,
	 * and optionally populates the form with data.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 *
	 * @return {boolean} The result of the superclass's onAfterRender method.
	 */
	onAfterRender(pRenderable)
	{
		const res = super.onAfterRender(pRenderable);
		this.regenerateFormSectionTemplates();
		this.renderFormSections();

		if (this.AutoSolveOnFirstRender && !this.FirstRenderCompleted)
		{
			this.FirstRenderCompleted = true;
			this.pict.providers.DynamicSolver.solveViews();
		}

		if (this.options.AutoPopulateAfterRender)
		{
			this.marshalToView();
		}
		return res;
	}

	/**
	 * Executes the solve operation -- automatically solves all dynamic views that are present.
	 *
	 * @returns {any} The result of the solve operation.
	 */
	onSolve()
	{
		this.pict.providers.DynamicSolver.solveViews();
		return super.onSolve();
	}

	runSolver(pExpression, pSilent)
	{
		this.pict.providers.DynamicSolver.runSolver(pExpression, pSilent);
	}

	onBeforeFilterViews(pViewFilterState)
	{
		return pViewFilterState;
	}

	onAfterFilterViews(pViewFilterState)
	{
		return pViewFilterState;
	}

	/**
	 * @param {string} pSectionManifestHash - The hash of the section to find.
	 *
	 * @return {Record<string, any>} The section definition object, or undefined if not found.
	 */
	findDynamicSectionManifestDefinition(pSectionManifestHash)
	{
		const sectionManifest = this.manifestDescription?.ReferenceManifests?.[pSectionManifestHash];
		if (typeof(sectionManifest) !== 'object')
		{
			this.log.error(`findDynamicSectionManifestDefinition() could not find a section manifest with hash [${pSectionManifestHash}]`);
			return null;
		}
		return sectionManifest;
	}

	/**
	 * @param {Record<string, any>} pManifest - The manifest to add
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 * @param {string} [pUUID] - (optional) The UUID to use for uniqueness. If not provided, a new one will be generated.
	 *
	 * @return {Array<import('./Pict-View-DynamicForm.js')>} the views that correspond to the newly added sections
	 */
	injectManifestAndRender(pManifest, pAfterSectionHash, pUUID)
	{
		const tmpManifest = pUUID ? this.createDistinctManifest(pManifest, pUUID) : pManifest;
		const tmpViewsToRender = this.injectManifest(tmpManifest, pAfterSectionHash);
		this.updateMetatemplateInDOM();
		//FIXME: for some reason, DOM append is not synchronous, so we need to delay the render....................?
		setTimeout(() =>
		{
			for (const tmpViewToRender of tmpViewsToRender)
			{
				tmpViewToRender.render();
			}
			if (this.options.AutoPopulateAfterRender)
			{
				for (const tmpViewToRender of tmpViewsToRender)
				{
					tmpViewToRender.marshalToView();
				}
			}
		}, 0);

		return tmpViewsToRender;
	}

	/**
	 * @param {Record<string, any>} pManifest - The manifest to add
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 *
	 * @return {Array<import('./Pict-View-DynamicForm.js')>} the views that correspond to the newly added sections; note that these views are NOT rendered yet
	 */
	injectManifest(pManifest, pAfterSectionHash)
	{
		const tmpAfterSectionHash = pAfterSectionHash ? (pAfterSectionHash.startsWith('PictSectionForm-') ? pAfterSectionHash : `PictSectionForm-${pAfterSectionHash}`) : null;
		const tmpAllViewKeys = Object.keys(this.pict.views);
		const tmpReferenceManifestViewIndex = tmpAfterSectionHash ? tmpAllViewKeys.indexOf(tmpAfterSectionHash) : -1;
		const tmpViewsToShift = [];
		if (tmpReferenceManifestViewIndex >= 0)
		{
			// reorder views (hacky - add layer to do this more directly)
			for (let i = tmpReferenceManifestViewIndex + 1; i < tmpAllViewKeys.length; i++)
			{
				const tmpKey = tmpAllViewKeys[i];
				tmpViewsToShift.push({ key: tmpKey, view: this.pict.views[tmpKey] });
				delete this.pict.views[tmpKey];
			}
		}
		const tmpViewsToRender = this.bootstrapAdditiveManifest(pManifest, tmpAfterSectionHash);
		for (const tmpViewToShift of tmpViewsToShift)
		{
			this.pict.views[tmpViewToShift.key] = tmpViewToShift.view;
		}
		// this ensures if we re-render everything, we have the new sections in the template
		this.generateMetatemplate();
		for (const tmpViewToRender of tmpViewsToRender)
		{
			tmpViewToRender.rebuildCustomTemplate();
		}
		this.pict.CSSMap.injectCSS();

		return tmpViewsToRender;
	}

	/**
	 * Builds translation maps for addresses and hashes based on the manifest. This is used for rewriting solver expressions to map them to distinct manifests.
	 *
	 * @param {Record<string, any>} pManifest - The manifest to build translations from.
	 *
	 * @return {{ AddressTranslation: Record<string, string>, HashTranslation: Record<string, string> }} The translation maps for addresses and hashes.
	 */
	buildManifestTranslations(pManifest)
	{
		/** @type {Record<string, string>} */
		const tmpAddressTranslation = {};
		for (const tmpSection of pManifest.Sections || [])
		{
			if (tmpSection.OriginalHash)
			{
				tmpAddressTranslation[tmpSection.OriginalHash] = tmpSection.Hash;
			}
			for (const tmpGroup of tmpSection.Groups || [])
			{
				if (tmpGroup.OriginalHash)
				{
					tmpAddressTranslation[tmpGroup.OriginalHash] = tmpGroup.Hash;
				}
			}
		}
		/** @type {Record<string, string>} */
		const tmpHashTranslation = {};
		for (const tmpDescriptor of Object.values(pManifest?.Descriptors || {}))
		{
			if (tmpDescriptor.OriginalDataAddress)
			{
				tmpAddressTranslation[tmpDescriptor.OriginalDataAddress] = tmpDescriptor.DataAddress;
			}
			if (tmpDescriptor.OriginalHash)
			{
				tmpHashTranslation[tmpDescriptor.OriginalHash] = tmpDescriptor.Hash;
			}
		}
		return { AddressTranslation: tmpAddressTranslation, HashTranslation: tmpHashTranslation };
	}

	/**
	 * Rewrite a solver expression by tokenizing, replacing address/hash tokens, and recomposing.
	 *
	 * @param {string} pExpression - The solver expression string.
	 * @param {Record<string, string>} pHashTranslation - A mapping of original hashes to new hashes for replacement.
	 * @param {Record<string, string>} pAddressTranslation - A mapping of original addresses to new addresses for replacement.
	 *
	 * @return {string} The rewritten expression, or the original if no changes were made.
	 */
	rewriteSolverExpression(pExpression, pHashTranslation, pAddressTranslation)
	{
		const tmpHashTranslation = pHashTranslation || { };
		const tmpAddressTranslation = pAddressTranslation || { };

		// Use the expression parser tokenizer for discrete token-based solver rewriting.
		// This avoids the regex word-boundary issues when hash and address are the same string.
		const tmpExpressionParser = this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');
		const tmpMarshalDestination = this.viewMarshalDestination;

		if (typeof(pExpression) !== 'string' || pExpression.length === 0)
		{
			return pExpression;
		}

		let tmpResultObject = {};
		tmpExpressionParser.tokenize(pExpression, tmpResultObject);

		let tmpTokens = Array.from(tmpResultObject.OriginalRawTokens);
		let tmpModified = false;

		// Function context stack for tracking string parameters inside annotated functions
		let tmpFunctionStack = [];
		let tmpParenDepth = 0;

		for (let i = 0; i < tmpTokens.length; i++)
		{
			let tmpToken = tmpTokens[i];
			let tmpTokenType = tmpExpressionParser.Tokenizer.getTokenType(tmpToken);

			// Track parenthesis depth and function context
			if (tmpToken === '(')
			{
				// Check if the previous token is a known function name
				if (i > 0)
				{
					let tmpPrevToken = tmpTokens[i - 1].toLowerCase();
					if (tmpPrevToken in tmpExpressionParser.functionMap)
					{
						tmpFunctionStack.push({ name: tmpPrevToken, paramIndex: 0, depth: tmpParenDepth });
					}
				}
				tmpParenDepth++;
				continue;
			}
			if (tmpToken === ')')
			{
				tmpParenDepth--;
				if (tmpFunctionStack.length > 0 && tmpFunctionStack[tmpFunctionStack.length - 1].depth === tmpParenDepth)
				{
					tmpFunctionStack.pop();
				}
				continue;
			}
			if (tmpToken === ',')
			{
				if (tmpFunctionStack.length > 0 && tmpFunctionStack[tmpFunctionStack.length - 1].depth === tmpParenDepth - 1)
				{
					tmpFunctionStack[tmpFunctionStack.length - 1].paramIndex++;
				}
				continue;
			}

			// Token.Symbol -- check hash mappings then address mappings
			if (tmpTokenType === 'Token.Symbol')
			{
				let tmpReplacement = null;

				if (tmpToken in tmpHashTranslation)
				{
					tmpReplacement = tmpHashTranslation[tmpToken];
				}
				else if (tmpToken in tmpAddressTranslation)
				{
					tmpReplacement = tmpAddressTranslation[tmpToken];
				}
				// Check with viewMarshalDestination prefix stripped
				else if (tmpMarshalDestination && tmpToken.startsWith(tmpMarshalDestination + '.'))
				{
					let tmpStripped = tmpToken.substring(tmpMarshalDestination.length + 1);
					if (tmpStripped in tmpHashTranslation)
					{
						tmpReplacement = tmpMarshalDestination + '.' + tmpHashTranslation[tmpStripped];
					}
					else if (tmpStripped in tmpAddressTranslation)
					{
						tmpReplacement = tmpMarshalDestination + '.' + tmpAddressTranslation[tmpStripped];
					}
				}

				if (tmpReplacement !== null)
				{
					tmpTokens[i] = tmpReplacement;
					tmpModified = true;
				}
			}
			// Token.StateAddress -- extract inner address, check mappings with and without marshal prefix
			else if (tmpTokenType === 'Token.StateAddress')
			{
				let tmpInner = tmpToken.substring(1, tmpToken.length - 1);
				let tmpReplacement = null;

				if (tmpInner in tmpAddressTranslation)
				{
					tmpReplacement = '{' + tmpAddressTranslation[tmpInner] + '}';
				}
				else if (tmpInner in tmpHashTranslation)
				{
					tmpReplacement = '{' + tmpHashTranslation[tmpInner] + '}';
				}
				else if (tmpMarshalDestination && tmpInner.startsWith(tmpMarshalDestination + '.'))
				{
					let tmpStripped = tmpInner.substring(tmpMarshalDestination.length + 1);
					if (tmpStripped in tmpAddressTranslation)
					{
						tmpReplacement = '{' + tmpMarshalDestination + '.' + tmpAddressTranslation[tmpStripped] + '}';
					}
					else if (tmpStripped in tmpHashTranslation)
					{
						tmpReplacement = '{' + tmpMarshalDestination + '.' + tmpHashTranslation[tmpStripped] + '}';
					}
				}

				if (tmpReplacement !== null)
				{
					tmpTokens[i] = tmpReplacement;
					tmpModified = true;
				}
			}
			// Token.String inside an annotated function -- check if this parameter index has addresses
			else if (tmpTokenType === 'Token.String' && tmpFunctionStack.length > 0)
			{
				let tmpCurrentFunc = tmpFunctionStack[tmpFunctionStack.length - 1];
				let tmpFuncEntry = tmpExpressionParser.functionMap[tmpCurrentFunc.name];

				if (tmpFuncEntry && Array.isArray(tmpFuncEntry.AddressParameterIndices) && tmpFuncEntry.AddressParameterIndices.includes(tmpCurrentFunc.paramIndex))
				{
					let tmpStringContent = tmpToken.substring(1, tmpToken.length - 1);
					let tmpReplacement = null;

					// Check hash mappings first (hash-style rewrite for string parameters)
					if (tmpStringContent in tmpHashTranslation)
					{
						tmpReplacement = '"' + tmpHashTranslation[tmpStringContent] + '"';
					}
					else if (tmpStringContent in tmpAddressTranslation)
					{
						tmpReplacement = '"' + tmpAddressTranslation[tmpStringContent] + '"';
					}
					else if (tmpMarshalDestination && tmpStringContent.startsWith(tmpMarshalDestination + '.'))
					{
						let tmpStripped = tmpStringContent.substring(tmpMarshalDestination.length + 1);
						if (tmpStripped in tmpHashTranslation)
						{
							tmpReplacement = '"' + tmpMarshalDestination + '.' + tmpHashTranslation[tmpStripped] + '"';
						}
						else if (tmpStripped in tmpAddressTranslation)
						{
							tmpReplacement = '"' + tmpMarshalDestination + '.' + tmpAddressTranslation[tmpStripped] + '"';
						}
					}

					if (tmpReplacement !== null)
					{
						tmpTokens[i] = tmpReplacement;
						tmpModified = true;
					}
				}
			}
		}

		if (!tmpModified)
		{
			return pExpression;
		}

		return tmpExpressionParser.recompose(tmpTokens);
	}

	/**
	 * Changes:
	 *   * The hashes of each section+group to be globally unique.
	 *   * The data address of each element to map to a unique location.
	 *
	 * @param {Record<string, any>} pManifest - The manifest to create a distinct copy of.
	 * @param {string} [pUUID] - (optional) The UUID to use for uniqueness. If not provided, a new one will be generated.
	 *
	 * @return {Record<string, any>} A distinct copy of the manifest.
	 */
	createDistinctManifest(pManifest, pUUID)
	{
		const tmpUUID = pUUID != null ? pUUID : this.pict.getUUID().replace(/-/g, '');
		const tmpManifest = JSON.parse(JSON.stringify(pManifest));
		/** @type {Record<string, string>} */
		const tmpAddressTranslation = {};
		for (const tmpSection of tmpManifest.Sections || [])
		{
			if (!tmpSection.Hash)
			{
				tmpSection.Hash = `${this.fable.getUUID()}`;
			}
			tmpSection.OriginalHash = tmpSection.Hash;
			tmpSection.Hash = `${tmpSection.Hash}_${tmpUUID}`;
			tmpAddressTranslation[tmpSection.OriginalHash] = tmpSection.Hash;
			for (const tmpGroup of tmpSection.Groups || [])
			{
				if (!tmpGroup.Hash)
				{
					tmpGroup.Hash = `${this.fable.getUUID()}`;
				}
				tmpGroup.OriginalHash = tmpGroup.Hash;
				tmpGroup.Hash = `${tmpGroup.Hash}_${tmpUUID}`;
				tmpAddressTranslation[tmpGroup.OriginalHash] = tmpGroup.Hash;
			}
		}
		/** @type {Record<string, ManifestDescriptor>} */
		const tmpDescriptors = tmpManifest.Descriptors || {};
		/** @type {Record<string, ManifestDescriptor>} */
		const tmpNewDescriptors = {};
		for (const [ tmpKey, tmpDescriptor ] of Object.entries(tmpDescriptors))
		{
			if (!tmpDescriptor.DataAddress)
			{
				tmpDescriptor.DataAddress = tmpKey;
			}
			tmpDescriptor.OriginalDataAddress = tmpDescriptor.DataAddress;
			// we only make distinct top level properties to keep things as tidy as possible so do a split to isoloate that
			//TODO: if we have .. dereferences (for example) in the data address, this may not work properly

			// nest the data addresses inside a container that is unique to this injection
			tmpDescriptor.DataAddress = `${tmpUUID}.${tmpDescriptor.OriginalDataAddress}`;
			if (tmpDescriptor.Address != null)
			{
				tmpDescriptor.Address = tmpDescriptor.DataAddress;
			}
			// nesting doesn't work for hashes, so we append instead for input, section and group hashes
			if (tmpDescriptor.Hash)
			{
				tmpDescriptor.OriginalHash = tmpDescriptor.Hash;
				tmpDescriptor.Hash = `${tmpDescriptor.Hash}_${tmpUUID}`;
			}
			if (tmpDescriptor.PictForm)
			{
				if (tmpDescriptor.PictForm.Section)
				{
					tmpDescriptor.PictForm.Section = `${tmpDescriptor.PictForm.Section}_${tmpUUID}`;
				}
				if (tmpDescriptor.PictForm.Group)
				{
					tmpDescriptor.PictForm.Group = `${tmpDescriptor.PictForm.Group}_${tmpUUID}`;
				}
			}
			tmpNewDescriptors[tmpDescriptor.DataAddress] = tmpDescriptor;
		}
		tmpManifest.Descriptors = tmpNewDescriptors;
		/** @type {Record<string, string>} */
		const tmpHashTranslation = {};
		for (const tmpDescriptor of Object.values(tmpManifest?.Descriptors || {}))
		{
			if (tmpDescriptor.OriginalDataAddress)
			{
				tmpAddressTranslation[tmpDescriptor.OriginalDataAddress] = tmpDescriptor.DataAddress;
			}
			if (tmpDescriptor.OriginalHash)
			{
				tmpHashTranslation[tmpDescriptor.OriginalHash] = tmpDescriptor.Hash;
			}
		}
		const escapeRegExp =
		/**
		 * @param {string} str - the string to match
		 * @return {string} - the escaped string
		 */
		(str) =>
		{
			return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		}
		for (const [ tmpOriginalAddress, tmpUpdatedAddress ] of Object.entries(tmpAddressTranslation))
		{
			for (const tmpIterAddress of Object.keys(tmpAddressTranslation))
			{
				if (tmpIterAddress === tmpOriginalAddress)
				{
					continue;
				}
				const tmpTranslatedAddress = tmpAddressTranslation[tmpIterAddress].replace(new RegExp(`^${escapeRegExp(tmpOriginalAddress)}\\b`, 'g'), tmpUpdatedAddress);
				if (tmpTranslatedAddress !== tmpAddressTranslation[tmpIterAddress])
				{
					this.pict.log.info(`DocumentDynamicSectionManager.createDistinctManifest: Updated address translation for "${tmpIterAddress}" from "${tmpAddressTranslation[tmpIterAddress]}" to "${tmpTranslatedAddress}".`);
					tmpAddressTranslation[tmpIterAddress] = tmpTranslatedAddress;
					const [ tmpCurrentKey, tmpOriginalDescriptor ] = Object.entries(tmpManifest.Descriptors).find(([ pKey, pDescriptor ]) => pDescriptor.OriginalDataAddress === tmpIterAddress);
					tmpManifest.Descriptors[tmpCurrentKey].DataAddress = tmpTranslatedAddress;
					if (tmpManifest.Descriptors[tmpCurrentKey].Address != null)
					{
						tmpManifest.Descriptors[tmpCurrentKey].Address = tmpManifest.Descriptors[tmpCurrentKey].DataAddress;
					}
					tmpManifest.Descriptors[tmpTranslatedAddress] = tmpManifest.Descriptors[tmpCurrentKey];
					delete tmpManifest.Descriptors[tmpCurrentKey];
				}
			}
		}
		/**
		 * Rewrite a single solver entry (string or object with Expression property).
		 *
		 * @param {Array} pSolverArray - The array of solvers to rewrite in.
		 * @param {number} pIndex - The index of the solver to rewrite.
		 * @param {string} pLogPrefix - Logging prefix for identification.
		 */
		const rewriteSolverEntry = (pSolverArray, pIndex, pLogPrefix) =>
		{
			const tmpSolver = pSolverArray[pIndex];
			const tmpSolverExpression = typeof tmpSolver === 'string' ? tmpSolver : tmpSolver.Expression;
			if (!tmpSolverExpression)
			{
				return;
			}
			const tmpUpdatedSolver = this.rewriteSolverExpression(tmpSolverExpression, tmpHashTranslation, tmpAddressTranslation);
			if (tmpUpdatedSolver !== tmpSolverExpression)
			{
				this.pict.log.info(`DocumentDynamicSectionManager.createDistinctManifest: Updated ${pLogPrefix} ${pIndex} from "${tmpSolverExpression}" to "${tmpUpdatedSolver}".`);
				if (typeof tmpSolver === 'string')
				{
					pSolverArray[pIndex] = tmpUpdatedSolver;
				}
				else
				{
					pSolverArray[pIndex].Expression = tmpUpdatedSolver;
				}
			}
		};

		for (const tmpSection of tmpManifest.Sections || [])
		{
			if (Array.isArray(tmpSection.Solvers) && tmpSection.Solvers.length > 0)
			{
				for (let i = 0; i < tmpSection.Solvers.length; i++)
				{
					rewriteSolverEntry(tmpSection.Solvers, i, 'section solver reference');
				}
			}
			for (const tmpGroup of tmpSection.Groups || [])
			{
				if (tmpGroup.RecordSetAddress)
				{
					let tmpRecordSetAddress = `${tmpUUID}.${tmpGroup.RecordSetAddress}`;
					this.pict.log.info(`DocumentDynamicSectionManager.createDistinctManifest: Updated group record set address from "${tmpGroup.RecordSetAddress}" to "${tmpRecordSetAddress}".`);
					tmpGroup.RecordSetAddress = tmpRecordSetAddress;
				}
				if (Array.isArray(tmpGroup.RecordSetSolvers) && tmpGroup.RecordSetSolvers.length > 0)
				{
					for (let i = 0; i < tmpGroup.RecordSetSolvers.length; i++)
					{
						rewriteSolverEntry(tmpGroup.RecordSetSolvers, i, 'group solver reference');
					}
				}
			}
		}
		if (Array.isArray(tmpManifest.ValidationSolvers))
		{
			for (let i = 0; i < tmpManifest.ValidationSolvers.length; i++)
			{
				rewriteSolverEntry(tmpManifest.ValidationSolvers, i, 'validation solver reference');
			}
		}
		return tmpManifest;
	}

	/**
	 * @param {Array<string>} pManifestHashes - The hashes of the manifests to add.
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 * @param {string} [pUUID] - (optional) The UUID to use for uniqueness. If not provided, a new one will be generated.
	 */
	injectManifestsByHash(pManifestHashes, pAfterSectionHash, pUUID)
	{
		let tmpViewsToRender = [];
		for (const tmpManifestHash of pManifestHashes)
		{
			const tmpManifest = this.findDynamicSectionManifestDefinition(tmpManifestHash);
			if (tmpManifest)
			{
				const tmpUniqueManifest = this.createDistinctManifest(tmpManifest, pUUID);
				const tmpViews = this.injectManifest(tmpUniqueManifest, pAfterSectionHash);
				tmpViewsToRender = tmpViewsToRender.concat(tmpViews);
			}
		}
		this.updateMetatemplateInDOM();
		setTimeout(() =>
		{
			for (const tmpViewToRender of tmpViewsToRender)
			{
				tmpViewToRender.render();
			}
		}, 0);
	}

	/**
	 * @param {Record<string, any>} pSectionsManifest - The section definition object.
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 */
	bootstrapAdditiveManifest(pSectionsManifest, pAfterSectionHash)
	{
		const tmpViewsToRender = [];
		const tmpNewSectionDefinitions = this.bootstrapPictFormViewsFromManifest(pSectionsManifest, pAfterSectionHash);
		for (const tmpNewSectionDefinition of tmpNewSectionDefinitions)
		{
			const tmpView = this.pict.views[`PictSectionForm-${tmpNewSectionDefinition.Hash}`];
			if (tmpView)
			{
				tmpViewsToRender.push(tmpView);
			}
		}
		return tmpViewsToRender;
	}

	/**
	 * Filters the views based on the provided filter and sort functions.
	 *
	 * By default, filters views based on the provided filter function and sorts them based on the provided sort function.
	 *
	 * @param {Function} [fFilterFunction] - The filter function used to determine if a view should be included.
	 * @param {SortFunction} [fSortFunction] - The sort function used to sort the filtered views.
	 * @returns {Array} - The filtered and sorted views.
	 */
	filterViews(fFilterFunction, fSortFunction)
	{
		// Generate the filter state object
		let tmpViewFilterState = (
			{
				//FIXME: need to be able to control this order better - adding dynamic sections will always put them at the end, which is rarely what you want
				ViewHashList: Object.keys(this.pict.views),
				// If there is no customization to the filter or sort, just render the last set.
				RenderLastRenderedViewsWithoutCustomization: true,
				// The last rendered views that were rendered
				LastRenderedViews: this.lastRenderedViews,
				// True or false, if the view should be included in the render.
				FilterFunction: fFilterFunction,
				// The sort function to apply to the views (it is sorting OBJECTS, not strings)
				SortFunction: fSortFunction,
				// The final outcome view list
				FilteredViewList: []
			});

		// Execute the customization function
		tmpViewFilterState = this.onBeforeFilterViews(tmpViewFilterState);

		// Filter the views based on the filter function and type
		for (let i = 0; i < tmpViewFilterState.ViewHashList.length; i++)
		{
			let tmpView = this.fable.views[tmpViewFilterState.ViewHashList[i]];
			// If the filter function returns false, skip this view.
			if (tmpViewFilterState.FilterFunction && !tmpViewFilterState.FilterFunction(tmpView))
			{
				continue;
			}
			if (tmpView.isPictSectionForm)
			{
				if (
					// If you don't pass in a filter and it's a dynamic section but set to not be included in the dynamic render, skip it
					(typeof(tmpViewFilterState.FilterFunction) != 'function')
					&& (!tmpView.sectionDefinition.IncludeInDefaultDynamicRender))
				{
					continue;
				}
				tmpViewFilterState.FilteredViewList.push(tmpView);
			}
			else if (!this.options.OnlyRenderDynamicSections || tmpView.options.IncludeInMetacontrollerOperations)
			{
				// If the OnlyRenderDynamicSections option is false, we will render all views in the array..
				// This is great when the app is small and simple.  And DANGEROUS if it isn't.  Take care!
				tmpViewFilterState.FilteredViewList.push(tmpView);
			}
		}

		// Auto-position any views marked with DynamicPlacementMode or DynamicAnchor - this is to assist with mixing configuration driven forms with
		// custom views.
		const tmpViewsToAutoPosition = tmpViewFilterState.FilteredViewList.filter((v) => v.options.DynamicPlacementMode || v.options.DynamicAnchor);
		for (const tmpView of tmpViewsToAutoPosition)
		{
			const tmpMode = tmpView.options.DynamicPlacementMode || 'After';
			const tmpAnchor = tmpView.options.DynamicAnchor;
			let tmpMovingViewIndex = tmpViewFilterState.FilteredViewList.findIndex((v) => v === tmpView);
			let tmpAnchorViewIndex;

			switch (tmpMode)
			{
			case 'First':
				tmpViewFilterState.FilteredViewList.splice(tmpMovingViewIndex, 1);
				tmpViewFilterState.FilteredViewList.unshift(tmpView);
				break;
			case 'Last':
				tmpViewFilterState.FilteredViewList.splice(tmpMovingViewIndex, 1);
				tmpViewFilterState.FilteredViewList.push(tmpView);
				break;
			case 'Before':
			case 'After':
				tmpAnchorViewIndex = tmpViewFilterState.FilteredViewList.findIndex((v) => v.Hash == tmpAnchor);
				if (tmpAnchorViewIndex < 0)
				{
					// for convenience, also check for dynamic prefixed views if an exact match is not found
					const tmpDynamicAnchor = `PictSectionForm-${tmpAnchor}`;
					tmpAnchorViewIndex = tmpViewFilterState.FilteredViewList.findIndex((v) => v.Hash == tmpDynamicAnchor);
				}
				if (tmpAnchorViewIndex < 0)
				{
					this.log.error(`No anchor view [${tmpAnchor}] found to position view [${tmpView.Hash}] [${tmpMode}].`);
					break;
				}
				tmpViewFilterState.FilteredViewList.splice(tmpMovingViewIndex, 1);
				if (tmpMovingViewIndex < tmpAnchorViewIndex)
				{
					// we just removed the element before the target, so we need to adjust
					--tmpAnchorViewIndex;
				}
				if (tmpMode === 'After')
				{
					// this lets us share most of the code for Before and After
					++tmpAnchorViewIndex;
				}
				tmpViewFilterState.FilteredViewList.splice(tmpAnchorViewIndex, 0, tmpView);
				break;
			default:
				this.log.error(`Not auto-positioning view with unknown DynamicPlacementMode: ${tmpMode}`);
			}
		}

		// Sort the views based on the sort function
		// This is to allow dynamic forms sections to have their own sorting criteria before rendering.
		if (typeof(tmpViewFilterState.SortFunction) == 'function')
		{
			tmpViewFilterState.FilteredViewList.sort(tmpViewFilterState.SortFunction);
		}

		// Execute the after filter customization function
		tmpViewFilterState = this.onAfterFilterViews(tmpViewFilterState);

		return tmpViewFilterState.FilteredViewList;
	}

	/**
	 * Renders a specific dynamic form section based on the provided form section hash.
	 *
	 * For this to work, we need the container for the section to be available on the form.
	 *
	 * @param {string} pFormSectionHash - The hash of the form section to render.
	 * @returns {void}
	 */
	renderSpecificFormSection(pFormSectionHash)
	{
		let fViewFilter = (pView) => { return pView.Hash == pFormSectionHash; };
		this.lastRenderedViews = this.filterViews(fViewFilter);
		this.regenerateFormSectionTemplates();
		this.generateMetatemplate();
		this.render();
	}

	/**
	 * Renders the default dynamic form sections based on the provided form section hash.
	 *
	 * @returns {void}
	 */
	renderDefaultFormSections()
	{
		this.lastRenderedViews = this.filterViews((pView) => { return pView?.sectionDefinition?.IncludeInDefaultDynamicRender ?? false; });
		this.regenerateFormSectionTemplates();
		this.generateMetatemplate();
		this.render();
	}

	/**
	 * Renders the form sections based on the provided filter and sort functions.
	 *
	 * If no filter and sort functions are provided, render all form sections.
	 *
	 * @param {Function} [fFilterFunction] - The filter function used to filter the views.
	 * @param {SortFunction} [fSortFunction] - The sort function used to sort the views.
	 */
	renderFormSections(fFilterFunction, fSortFunction)
	{
		let tmpViewList = this.filterViews(fFilterFunction, fSortFunction);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (tmpViewList[i] === this)
			{
				continue;
			}
			tmpViewList[i].render();
		}
	}

	/**
	 * Marshals data to the form sections based on the provided filter and sort functions
	 *
	 * If no filter and sort functions are provided, render all form sections.
	 *
	 * @param {Function} [fFilterFunction] - The filter function used to filter the views.
	 * @param {SortFunction} [fSortFunction] - The sort function used to sort the views.
	 */
	marshalFormSections(fFilterFunction, fSortFunction)
	{
		let tmpViewList = this.filterViews(fFilterFunction, fSortFunction);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			if (tmpViewList[i] === this)
			{
				continue;
			}
			tmpViewList[i].marshalToView();
		}
	}

	/**
	 * Regenerates the DyunamicForm section templates based on the provided filter and sort function.
	 *
	 * @param {Function} [fFormSectionFilter] - (optional) The filter function used to determine which views to include in the regeneration.
	 * @param {SortFunction} [fSortFunction] - (optional) The sort function used to determine the order of the views in the regeneration.
	 */
	regenerateFormSectionTemplates(fFormSectionFilter, fSortFunction)
	{
		let tmpViewList = this.filterViews(fFormSectionFilter, fSortFunction);
		for (let i = 0; i < tmpViewList.length; i++)
		{
			const tmpView = tmpViewList[i];
			if (tmpView === this)
			{
				continue;
			}
			if (tmpView.isPictSectionForm)
			{
				tmpView.rebuildCustomTemplate();
			}
		}
		// Make sure any form-specific CSS is injected properly.
		this.pict.CSSMap.injectCSS();
	}

	/**
	 * Generates a meta template for the DynamicForm views managed by this Metacontroller.
	 *
	 * @param {Function} [fFormSectionFilter] - (optional) The filter function to apply on the form section.
	 * @param {SortFunction} [fSortFunction] - (optional) The sort function to apply on the form section.
	 * @returns {void}
	 */
	generateMetatemplate(fFormSectionFilter, fSortFunction)
	{
		let tmpTemplate = ``;

		if (!this.formTemplatePrefix)
		{
			this.formTemplatePrefix = this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;
		}

		// Add the Form Prefix stuff
		tmpTemplate += `{~T:${this.formTemplatePrefix}-Template-Form-Container-Header:Pict.views["${this.Hash}"]~}`;

		let tmpViewList = this.filterViews(fFormSectionFilter, fSortFunction);

		for (let i = 0; i < tmpViewList.length; i++)
		{
			let tmpFormView = tmpViewList[i];
			if (tmpFormView === this)
			{
				continue;
			}
			if (tmpFormView.options.IncludeInMetatemplateSectionGeneration)
			{
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				if (tmpFormView.isPictSectionForm)
				{
					tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				else
				{
					//NOTE: For now, requiring the destination address to be an ID for this case
					tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
					tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
			else if (!tmpFormView.isPictSectionForm)
			{
				//NOTE: For now, requiring the destination address to be an ID for this case
				tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
		}
		tmpTemplate += `{~T:${this.formTemplatePrefix}-Template-Form-Container-Footer:Pict.views["${this.Hash}"]~}`;

		this.pict.TemplateProvider.addTemplate(this.options.MetaTemplateHash, tmpTemplate);
	}

	/**
	 * Generates a meta template for the DynamicForm views managed by this Metacontroller.
	 *
	 * @param {Function} [fFormSectionFilter] - (optional) The filter function to apply on the form section.
	 * @param {SortFunction} [fSortFunction] - (optional) The sort function to apply on the form section.
	 *
	 * @return {void}
	 */
	updateMetatemplateInDOM(fFormSectionFilter, fSortFunction)
	{
		if (!this.formTemplatePrefix)
		{
			this.formTemplatePrefix = this.pict.providers.MetatemplateGenerator.baseTemplatePrefix;
		}

		let tmpViewList = this.filterViews(fFormSectionFilter, fSortFunction);
		let tmpPrevDiv = null;
		let tmpDeferredDivContent;
		let tmpDeferredDivID = null;

		for (let i = 0; i < tmpViewList.length; i++)
		{
			let tmpFormView = tmpViewList[i];
			if (tmpFormView === this)
			{
				continue;
			}
			if (!tmpFormView.isPictSectionForm)
			{
				continue;
			}
			if (!tmpFormView.options.IncludeInMetatemplateSectionGeneration)
			{
				continue;
			}
			const tmpFormDivID = tmpFormView.options.CustomTargetID || `Pict-${this.UUID}-${tmpFormView.options.Hash}-Wrap`;
			let tmpFormDivs = this.pict.ContentAssignment.getElement(`#${tmpFormDivID}`);
			if (tmpFormDivs.length > 0)
			{
				const tmpFormDiv = tmpFormDivs[0];
				if (tmpDeferredDivID)
				{
					// We have a deferred div ID, so we need to insert it before this one
					this.pict.ContentAssignment.insertContentBefore(`#${tmpFormDivID}`, tmpDeferredDivContent);
					tmpDeferredDivID = null;
					tmpDeferredDivContent = null;
				}
				tmpPrevDiv = tmpFormDiv;
				continue;
			}
			let tmpFormDivTemplate = '';
			if (tmpFormView.options.IncludeInMetatemplateSectionGeneration)
			{
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				if (tmpFormView.isPictSectionForm)
				{
					tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				else
				{
					//NOTE: For now, requiring the destination address to be an ID for this case
					tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
					tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				}
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
			else if (!tmpFormView.isPictSectionForm)
			{
				//NOTE: For now, requiring the destination address to be an ID for this case
				tmpFormView.options.CustomTargetID = tmpFormView.options.DefaultDestinationAddress.replace(/#/, '');
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Prefix:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Custom:Pict.views["${tmpFormView.Hash}"]~}`;
				tmpFormDivTemplate += `\n{~T:${this.formTemplatePrefix}-Template-Form-Container-Wrap-Postfix:Pict.views["${tmpFormView.Hash}"]~}`;
			}
			const tmpFormDivContent = this.pict.parseTemplate(tmpFormDivTemplate, tmpFormView, null, [this]);
			if (tmpPrevDiv)
			{
				this.pict.ContentAssignment.insertContentAfter(`#${tmpPrevDiv.id}`, tmpFormDivContent);
				tmpFormDivs = this.pict.ContentAssignment.getElement(`#${tmpFormDivID}`);
				tmpPrevDiv = tmpFormDivs[0];
				continue;
			}
			tmpDeferredDivID = tmpFormDivID;
			tmpDeferredDivContent = tmpFormDivContent;
		}
		if (tmpDeferredDivID)
		{
			// this means the container was empty, so just add it to the end
			this.pict.ContentAssignment.appendContent(`#Pict-${this.UUID}-FormContainer`, tmpDeferredDivContent);
			tmpDeferredDivID = null;
			tmpDeferredDivContent = null;
		}
	}

	/**
	 * Retrieves a safe clone of the section definition for a given manyfest section description object.
	 *
	 * @param {object} pSectionObject - The section object.
	 * @returns {object|boolean} - The section definition if successful, otherwise false.
	 */
	getSectionDefinition(pSectionObject)
	{
		if (typeof(pSectionObject) != 'object')
		{
			this.log.error('getSectionDefinition() called without a valid section object.');
			return false;
		}

		if (!('Hash' in pSectionObject))
		{
			this.log.error('getSectionDefinition() called without a valid section object hash.');
			return false;
		}

		try
		{
			let tmpSectionDefinition = JSON.parse(JSON.stringify(pSectionObject));

			if (!('Name' in tmpSectionDefinition))
			{
				// If there isn't a name, use the hash
				tmpSectionDefinition.Name = tmpSectionDefinition.Hash;
			}
			if (!('Description' in tmpSectionDefinition))
			{
				// If there isn't a description, use the name
				tmpSectionDefinition.Description = `PICT Section [${tmpSectionDefinition.Name}].`;
			}
			if (!('Groups' in tmpSectionDefinition))
			{
				// If there isn't a groups array, create an empty one
				tmpSectionDefinition.Groups = [];
			}

			return tmpSectionDefinition;
		}
		catch(pError)
		{
			this.log.error(`getSectionDefinition() failed to parse the section object with error: ${pError.message || pError}`);
			return false;
		}
	}

	getSectionViewFromHash(pSectionHash)
	{
		let tmpSectionHash = (typeof(pSectionHash) === 'string') ? pSectionHash : false;
		if (!tmpSectionHash)
		{
			this.log.error('getSectionViewFromHash() called without a valid section hash.');
			return false;
		}
		let tmpViewHash = `PictSectionForm-${tmpSectionHash}`;
		if (tmpViewHash in this.fable.views)
		{
			return this.fable.views[tmpViewHash];
		}
		this.log.error(`getSectionViewFromHash() could not find a view for section hash [${tmpSectionHash}].`);
		return false;
	}

	/**
	 * Clears out the manifest description set on the meta controller.
	 */
	clearManifestDescription()
	{
		this.manifestDescription = null;
	}

	/**
	 * Bootstraps Pict DynamicForm views from a Manyfest description JSON object.
	 *
	 * @param {Object} pManifestDescription - The manifest description object.
	 * @param {string} [pAfterSectionHash] - The hash of the section to add after. Omit to add to the start.
	 *
	 * @returns {Array<Record<string, any>>} - An array of section definitions added.
	 */
	bootstrapPictFormViewsFromManifest(pManifestDescription, pAfterSectionHash)
	{
		let tmpManifestDescription = (typeof(pManifestDescription) === 'object') ? pManifestDescription : false;
		let tmpSectionList = [];

		if (typeof(tmpManifestDescription) != 'object')
		{
			// Check and see if there is a DefaultFormManifest in the settings
			if (('DefaultFormManifest' in this.fable.settings)
				&& typeof(this.fable.settings.DefaultFormManifest) == 'object'
				&& ('Descriptors' in this.fable.settings.DefaultFormManifest))
			{
				tmpManifestDescription = this.fable.settings.DefaultFormManifest;
			}
			else
			{
				this.log.error('PictFormMetacontroller.bootstrapPictFormViewsFromManifest() called without a valid manifest, and no settings.DefaultFormManifest was provided.');
				return tmpSectionList;
			}
		}
		if (this.manifestDescription)
		{
			this.stashedManifestDescription = this.manifestDescription;
			this.manifestDescription = tmpManifestDescription;
			//FIXME: merge manifests more fully... should this be an external capability?
			for (const [ tmpKey, tmpDescriptor ] of Object.entries(this.manifestDescription.Descriptors || {}))
			{
				if (this.stashedManifestDescription.Descriptors[tmpKey])
				{
					this.log.error(`PictFormMetacontroller.bootstrapPictFormViewsFromManifest() found a duplicate descriptor key [${tmpKey}] when merging manifests. The new descriptor will be skipped.`);
					continue;
				}
				this.stashedManifestDescription.Descriptors[tmpKey] = JSON.parse(JSON.stringify(tmpDescriptor));
			}
			for (const tmpKey of Object.keys(this.manifestDescription.ReferenceManifests || {}))
			{
				if (this.stashedManifestDescription.ReferenceManifests[tmpKey])
				{
					this.log.warn(`PictFormMetacontroller.bootstrapPictFormViewsFromManifest() found a duplicate reference manifest key [${tmpKey}] when merging manifests. The new reference manifest will be skipped.`);
					continue;
				}
				this.stashedManifestDescription.ReferenceManifests[tmpKey] = JSON.parse(JSON.stringify(this.manifestDescription.ReferenceManifests[tmpKey]));
			}
			let tmpInsertAtIndex = this.stashedManifestDescription.Sections.findIndex((pSection) => pSection.Hash == pAfterSectionHash);
			if (tmpInsertAtIndex < 0)
			{
				tmpInsertAtIndex = 0;
			}
			else
			{
				// We want to insert AFTER the found index, so increment by 1
				++tmpInsertAtIndex;
			}
			for (const tmpSection of this.manifestDescription.Sections || [])
			{
				const tmpClonedSection = JSON.parse(JSON.stringify(tmpSection));
				this.stashedManifestDescription.Sections.splice(tmpInsertAtIndex, 0, tmpClonedSection);
				++tmpInsertAtIndex;
			}
		}
		else
		{
			this.manifestDescription = tmpManifestDescription;
		}
		let tmpManifest = this.fable.instantiateServiceProviderWithoutRegistration('Manifest', this.manifestDescription);

		if (this.options.AutoPopulateDefaultObject)
		{
			// Fill out the defaults at the marshal location if it doesn't exist
			const tmpMarshalDestinationObject = this.pict.providers.DataBroker.marshalDestinationObject;
			if (typeof(tmpMarshalDestinationObject) === 'object')
			{
				tmpManifest.populateDefaults(tmpMarshalDestinationObject);
			}
		}

		// Get the list of Explicitly Defined section hashes from the Sections property of the manifest
		if (('Sections' in this.manifestDescription) && Array.isArray(this.manifestDescription.Sections))
		{
			for (let i = 0; i < this.manifestDescription.Sections.length; i++)
			{
				let tmpSectionDefinition = this.getSectionDefinition(this.manifestDescription.Sections[i]);

				if (tmpSectionDefinition)
				{
					tmpSectionList.push(tmpSectionDefinition);
				}
			}
		}

		let tmpImplicitSectionHashes = {};

		let tmpDescriptorKeys = Object.keys(tmpManifest.elementDescriptors);

		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			let tmpDescriptor = tmpManifest.elementDescriptors[tmpDescriptorKeys[i]];

			if (tmpDescriptor)
			{
				this.pict.manifest.addDescriptor(tmpDescriptorKeys[i], tmpDescriptor);
			}

			if (
					// If there is an object in the descriptor
					typeof(tmpDescriptor) == 'object' &&
					// AND it has a PictForm property
					('PictForm' in tmpDescriptor) &&
					// AND the PictForm property is an object
					typeof(tmpDescriptor.PictForm) == 'object' &&
					// AND the PictForm object has a Section property
					('Section' in tmpDescriptor.PictForm) &&
					// AND the Section property is a string
					typeof(tmpDescriptor.PictForm.Section) == 'string'
				)
			{
				tmpImplicitSectionHashes[tmpDescriptor.PictForm.Section] = true;
			}
		}

		let tmpImplicitSectionKeys = Object.keys(tmpImplicitSectionHashes);

		for (let i = 0; i < tmpImplicitSectionKeys.length; i++)
		{
			let tmpExistingSection = tmpSectionList.find((pSection) => { return pSection.Hash == tmpImplicitSectionKeys[i]; });

			if (!tmpExistingSection)
			{
				tmpSectionList.push(this.getSectionDefinition({Hash: tmpImplicitSectionKeys[i]}));
			}
		}

		// Now load a section view for each section
		for (let i = 0; i < tmpSectionList.length; i++)
		{
			let tmpViewHash = `PictSectionForm-${tmpSectionList[i].Hash}`;

			if (tmpViewHash in this.fable.views)
			{
				this.log.info(`getSectionList() found an existing view for section [${tmpSectionList[i].Hash}] so will be skipped.`);
				continue;
			}
			let tmpViewConfiguration = JSON.parse(JSON.stringify(tmpSectionList[i]));
			if (!('Manifests' in tmpViewConfiguration))
			{
				tmpViewConfiguration.Manifests = {};
			}
			tmpViewConfiguration.Manifests.Section = this.manifestDescription;
			this.pict.addView(tmpViewHash, tmpViewConfiguration, libPictViewDynamicForm);
		}

		if ('PickLists' in this.manifestDescription)
		{
			let tmpPickListKeys = Object.keys(this.manifestDescription.PickLists);
			for (let i = 0; i < tmpPickListKeys.length; i++)
			{
				let tmpPickList = this.manifestDescription.PickLists[tmpPickListKeys[i]];
				this.pict.providers.DynamicMetaLists.buildList(tmpPickList);
			}
		}

		// Now see if there is custom CSS
		for (let i = 0; i < tmpSectionList.length; i++)
		{
			let tmpSection = tmpSectionList[i];
			if (('CustomCSS' in tmpSection) && (typeof(tmpSection.CustomCSS) == 'string'))
			{
				this.pict.CSSMap.addCSS(`PSF-SectionCSS-${tmpSection.Hash}`, tmpSection.CustomCSS);
			}
		}

		if (this.stashedManifestDescription)
		{
			this.manifestDescription = this.stashedManifestDescription;
			delete this.stashedManifestDescription;
		}
		return tmpSectionList;
	}

	/**
	 * Trigger an event on all inputs on all views.
	 * @param {string} pEvent - The event to trigger
	 * @param {string} [pTransactionGUID] - (optional) The transaction GUID to use for the event.
	 */
	triggerGlobalInputEvent(pEvent, pTransactionGUID)
	{
		const tmpTransactionGUID = (pTransactionGUID && typeof(pTransactionGUID) === 'string') ? pTransactionGUID : this.fable.getUUID();
		if (pTransactionGUID !== tmpTransactionGUID)
		{
			this.pict.TransactionTracking.registerTransaction(tmpTransactionGUID);
		}
		let tmpEvent = (typeof(pEvent) === 'string') ? pEvent : this.fable.getUUID();
		let tmpViewHashes = Object.keys(this.pict.views);
		let tmpCompletedHashes = {};
		/** @type {import('./Pict-View-DynamicForm.js')} */
		let tmpFinalizeView = null;
		// Filter the views based on the filter function and type
		for (let i = 0; i < tmpViewHashes.length; i++)
		{
			/** @type {import('./Pict-View-DynamicForm.js')} */
			let tmpView = this.pict.views[tmpViewHashes[i]];
			if (tmpView.isPictSectionForm)
			{
				tmpFinalizeView = tmpView;
				tmpView.sectionInputEvent(tmpEvent, tmpCompletedHashes, tmpTransactionGUID);
			}
		}
		if (pTransactionGUID !== tmpTransactionGUID && tmpFinalizeView)
		{
			// If we created the transaction GUID, we need to finalize it
			tmpFinalizeView.finalizeTransaction(tmpTransactionGUID);
		}
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 */
	registerEventTransactionAsyncOperation(pTransactionGUID, pAsyncOperationHash)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, pAsyncOperationHash, PENDING_ASYNC_OPERATION_TYPE);
	}

	/**
	 * FIXME: consolidate with same functions(s) in the dynamic view class
	 *
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {string} pAsyncOperationHash - The hash of the async operation.
	 *
	 * @return {boolean} - Returns true if the async operation was found and marked as complete, otherwise false.
	 */
	eventTransactionAsyncOperationComplete(pTransactionGUID, pAsyncOperationHash)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpMarkedOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				if (tmpQueueItem.Data === pAsyncOperationHash)
				{
					tmpQueue.splice(i, 1);
					++tmpMarkedOperationCount;
					--i;
				}
				else
				{
					++tmpPendingAsyncOperationCount;
				}
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpMarkedOperationCount === 0)
		{
			this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete ${pTransactionGUID} could not find async operation with hash ${pAsyncOperationHash}.`);
			return;
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			for (let i = 0; i < tmpQueue.length; i++)
			{
				const tmpQueueItem = tmpQueue[i];
				if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
				{
					tmpQueue.splice(i, 1);
					--i;
					if (typeof tmpQueueItem.Data !== 'function')
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback was not a function.`);
						continue;
					}
					try
					{
						tmpQueueItem.Data();
					}
					catch (pError)
					{
						this.log.error(`PICT View Metatemplate Helper eventTransactionAsyncOperationComplete transaction callback error: ${pError}`, { Stack: pError.stack });
					}
				}
			}
			delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		}
		return tmpMarkedOperationCount > 0;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 *
	 * @return {boolean} - Returns true if the transaction was found and able to be finalized, otherwise false.
	 */
	finalizeTransaction(pTransactionGUID)
	{
		this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, null, READY_TO_FINALIZE_TYPE);

		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
		}
		if (tmpPendingAsyncOperationCount > 0)
		{
			this.pict.log.info(`PICT View Metatemplate Helper finalizeTransaction ${pTransactionGUID} is waiting on ${tmpPendingAsyncOperationCount} pending async operations.`);
			return false;
		}
		for (let i = 0; i < tmpQueue.length; i++)
		{
			const tmpQueueItem = tmpQueue[i];
			if (tmpQueueItem.Type === TRANSACTION_COMPLETE_CALLBACK_TYPE)
			{
				tmpQueue.splice(i, 1);
				--i;
				if (typeof tmpQueueItem.Data !== 'function')
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback was not a function.`);
					continue;
				}
				try
				{
					tmpQueueItem.Data();
				}
				catch (pError)
				{
					this.log.error(`PICT View Metatemplate Helper finalizeTransaction transaction callback error: ${pError}`, { Stack: pError.stack });
				}
			}
		}
		delete this.pict.TransactionTracking.transactions[pTransactionGUID];
		return true;
	}

	/**
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @param {Function} fCallback - The callback to call when the transaction is complete.
	 */
	registerOnTransactionCompleteCallback(pTransactionGUID, fCallback)
	{
		const tmpQueue = this.pict.TransactionTracking.checkTransactionQueue(pTransactionGUID);
		let tmpPendingAsyncOperationCount = 0;
		let tmpReadyToFinalize = false;
		for (const tmpQueueItem of tmpQueue)
		{
			if (tmpQueueItem.Type === PENDING_ASYNC_OPERATION_TYPE)
			{
				++tmpPendingAsyncOperationCount;
			}
			if (tmpQueueItem.Type === READY_TO_FINALIZE_TYPE)
			{
				tmpReadyToFinalize = true;
			}
		}
		if (tmpReadyToFinalize && tmpPendingAsyncOperationCount === 0)
		{
			fCallback();
		}
		else
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pTransactionGUID, fCallback, TRANSACTION_COMPLETE_CALLBACK_TYPE);
		}
	}

	showSupportViewInlineEditor()
	{
		// 1. See if the Support views are loaded
		// 2. Load the support view if it isn't
		this.pict.addViewSingleton("Pict-Form-DebugViewer", {}, this.SupportViewPrototypes.DebugViewer);
		this.pict.addViewSingleton("Pict-Form-AppDataViewer", {}, this.SupportViewPrototypes.AppDataViewer);
//		this.pict.addViewSingleton("Pict-Form-LifecycleVisualization", {}, this.SupportViewPrototypes.LifecycleVisualization);
		this.pict.addViewSingleton("Pict-Form-SolverVisualization", {}, this.SupportViewPrototypes.SolverVisualization);
//		this.pict.addViewSingleton("Pict-Form-SpecificSolveVisualization", {}, this.SupportViewPrototypes.SpecificSolveVisualization);
	
		// 3. See if the container for the support view is loaded
		// 4. Render the container for the support view if it isn't loaded
		this.pict.views["Pict-Form-DebugViewer"].bootstrapContainer();
	
		// 5. Render the support view into the container
		this.pict.views["Pict-Form-DebugViewer"].render();
	}

	/**
	 * Returns whether the object is a Pict Metacontroller.
	 *
	 * @returns {boolean} True if the object is a Pict Metacontroller, false otherwise.
	 */
	get isPictMetacontroller()
	{
		return true;
	}
}

module.exports = PictFormMetacontroller;
/** @type {Record<string, any>} */
module.exports.default_configuration = (
{
	"AutoRender": true,

	"AutoPopulateDefaultObject": true,
	"AutoSolveBeforeRender": true,
	"AutoPopulateAfterRender": true,

	"DefaultRenderable": "Pict-Forms-Metacontainer",
	"DefaultDestinationAddress": "#Pict-Form-Container",

	"OnlyRenderDynamicSections": true,

	"MetaTemplateHash": "Pict-Forms-Metatemplate",

	"Templates": [
		{
			"Hash": "Pict-Forms-Metatemplate",
			"Template": "<!-- Pict-Forms-Metatemplate HAS NOT BEEN GENERATED; call pict.views.PictFormsMetatemplate.generateMetatemplate() to build the containers -->"
		}
	],
	"Renderables": [
		{
			"RenderableHash": "Pict-Forms-Metacontainer",
			"TemplateHash": "Pict-Forms-Metatemplate",
			"DestinationAddress": "#Pict-Form-Container"
		}
	]
});

},{"../services/Pict-Service-DynamicFormDependencyManager.js":107,"./Pict-View-DynamicForm.js":122,"./support/Pict-View-PSF-AppData-Visualization.js":125,"./support/Pict-View-PSF-DebugViewer.js":126,"./support/Pict-View-PSF-LifeCycle-Visualization.js":127,"./support/Pict-View-PSF-Solver-Visualization.js":128,"./support/Pict-View-PSF-SpecificSolve-Visualization.js":129,"pict-view":239}],124:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DefaultProviderConfiguration = (
{
	"ProviderIdentifier": "Pict-Form-SupportExtensions",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"AutoSolveWithApp": false
});

/**
 * Represents a class that provides dynamic templates for the Pict form section provider.
 * @extends libPictProvider
 */
class PictSupportExtension extends libPictProvider
{
	/**
	 * Constructs a new instance of the PictProviderDynamicTemplates class.
	 * @param {Object} pFable - The pFable object.
	 * @param {Object} pOptions - The options object.
	 * @param {Object} pServiceHash - The service hash object.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(_DefaultProviderConfiguration)), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		// These next blocks of code manually do what views often do, to support sharing of this across multiple views.

		// Only add this css if it doesn't exist already in the css map
		if (!('Pict-Support' in this.pict.CSSMap.inlineCSSMap))
		{
			this.pict.CSSMap.addCSS('Pict-Support',
				/*css*/`
					:root{
						--PSF-Global-background-color: #dcdce5;
						--PSF-Global-text-color: var(--theme-color-text-primary, #333333);

						--PSFExt-gutter-size: 5px;
						--PSFExt-indentation-size: calc(2 * var(--PSFExt-gutter-size));
						--PSFExt-Global-background-color: #dedede;
						--PSFExt-Global-text-color: var(--theme-color-text-primary, #333333);
						--PSFExt-Section-background-color: var(--theme-color-background-tertiary, #efefef);
						--PSFExt-Section-button-color: #5A52A3;
						--PSFExt-Section-button-text-color: #D8D7E5;
						--PSFExt-Section-token-color: #eAf3a2;
						--PSFExt-Section-label-color: var(--theme-color-text-muted, #999);
						--PSFExt-Section-Data-background-color: var(--theme-color-background-secondary, #fafafa);
						--PSFExt-Section-Group-Header-background-color: #ebebff;
						--PSFExt-Section-Group-Row-Header-background-color: #dcf0f0;
						--PSFExt-Solver-Entry-text-color: #bb4a9c;
						--PSFExt-Section-DynamicInput-background-color: #a3ccd8;
						--PSFExt-Section-DynamicInput-button-color: #2b89a4;
						--PSFExt-Section-DynamicInput-button-text-color: #D8D7E5;
					}

					/** Wrapping container	*/
					#Pict-Form-Extensions-Wrap {
						display:flex;
						flex-direction: column;
						height: 75vh;
						overflow: hidden;
						position: absolute;
						left: 50%;
						top: 0px;
						width: 20vw;
						min-width: 340px;
						min-height: 200px;
					}
					#Pict-Form-Extension-DragControl {
						background-color: #eae;
						cursor: move;
						padding: 4px 6px;
						border-radius: 3px;
						border: 1px solid var(--theme-color-text-primary, #111);
					}
					#Pict-Form-Extensions-Container { 
						flex-grow: 1;
						overflow: auto;
						margin-top: 2px;
						color: var(--PSF-Global-text-color);
						background-color: var(--PSF-Global-background-color);
						padding: 10px;
						border: 4px double var(--theme-color-text-primary, #111);
						border-radius: 8px;
						box-shadow: 2px 2px 10px rgba(0,0,0,0.5);
						font-size: 14px;
						font-family: Arial, sans-serif;
						font-size: 14px;
					}
					#Pict-Form-Extension-ResizeControl {
						background-color: #eae;
						cursor: move;
						padding: 4px 4px;
						border-radius: 3px;
						border: 1px solid var(--theme-color-text-primary, #111);
					}
					.PSFExt-Extension-Footer {
						text-align: right;
						font-size: 10px;
						font-weight: bold;
						margin-top: 8px;
					}

					/** Headers	*/
					.PSFExt-Extension-Header {
						font-size: 10px;
						font-weight: bold;
						margin-bottom: var(--PSFExt-gutter-size);
					}
					.PSFExt-Global-Header {
						padding: var(--PSFExt-gutter-size);
						margin: 0;
					}
					.PSFExt-Section-Header {
						padding: var(--PSFExt-gutter-size);
						margin: 0;
					}
					.PSFExt-Content-Header {
						padding: var(--PSFExt-gutter-size);
						margin: 0;
						background-color: var(--PSFExt-Section-background-color);
					}
					.PSFExt-Data-Header {
						font-weight: bold;
						border-bottom: 1px dotted var(--theme-color-border-default, #ccc);
						padding: var(--PSFExt-gutter-size);
					}
					/** Section content */
					.PSFExt-Section { 
						margin: var(--PSFExt-gutter-size);
						padding: var(--PSFExt-gutter-size);
						background-color: var(--PSFExt-Section-background-color);
						border-radius: 4px;
					}
					.PSFExt-Section-Descriptors { 
						padding: var(--PSFExt-gutter-size) 0;
					}
					.PSFExt-Section-Group { 
						padding: var(--PSFExt-gutter-size);
					}
					.PSFExt-Section-Buttons {
						list-style-type: none;
						padding: 0;
						padding-bottom: var(--PSFExt-gutter-size);
						margin: calc(var(--PSFExt-gutter-size) * 2) var(--PSFExt-gutter-size);
					}
					.PSFExt-Section-Button { 
						display: inline;
						margin-right: calc(var(--PSFExt-gutter-size) * 0.25);
						text-decoration: none;
						background-color: var(--PSFExt-Section-button-color);
						padding: var(--PSFExt-gutter-size);
						border-radius: var(--PSFExt-gutter-size);
					}
					.PSFExt-Section-Button a { 
						text-decoration: none;
						color: var(--PSFExt-Section-button-text-color);
					}
					.PSFExt-Section-Button a:hover { 
						text-decoration: underline;
					}
					.PSFExt-Section-Solver-Entry:not(:last-child) {
						border-bottom: 1px solid var(--theme-color-border-default, #ccc);
					}
					.PSFExt-Solver-Entry { 
						font-family: "Courier New", "Lucida Console", monospace;
						font-weight: bold;
						margin-top: var(--PSFExt-gutter-size);
						padding: var(--PSFExt-gutter-size);
						line-height: 1.2;
						color: var(--PSFExt-Solver-Entry-text-color);
						border-bottom: 1px dotted var(--theme-color-border-default, #ccc);
					}
					.PSFExt-Solver-Result { 
						font-family: "Courier New", "Lucida Console", monospace;
						font-weight: bold;
						margin-top: var(--PSFExt-gutter-size);
						padding: 0 var(--PSFExt-gutter-size);
						line-height: 1.2;
					}
					.PSFExt-Section-ExtraData {
						padding-top: calc(var(--PSFExt-gutter-size) / 2);
						padding-bottom: calc(var(--PSFExt-gutter-size) / 2);
						background-color: var(--PSFExt-Section-Data-background-color);
					}
					.PSFExt-Section-Group .PSFExt-Content-Header.PSFExt-Section-Group-Header {
						background-color: var(--PSFExt-Section-Group-Header-background-color);
					}
					.PSFExt-Section-Group .PSFExt-Content-Header.PSFExt-Section-Group-Row-Header {
						background-color: var(--PSFExt-Section-Group-Row-Header-background-color);
					}
					.PSFExt-DeEmphasize { 
						color: var(--PSFExt-Section-label-color);
						font-size: smaller;
					}
					.PSFExt-Data { 
						margin-left: var(--PSFExt-indentation-size);
						line-height: 0.85;
						font-size: smaller;
					}
					.PSFExt-Data-Table {
						width: 100%;
						border-collapse: collapse;
						margin-left: var(--PSFExt-indentation-size);
						margin-top: var(--PSFExt-gutter-size);
						margin-bottom: var(--PSFExt-gutter-size);
						overflow-x: auto;
					}
					.PSFExt-Label { 
						min-width: 15%;
						color: var(--PSFExt-Section-label-color);
						margin: var(--PSFExt-gutter-size) 0;
					}
					.PSFExt-Label::after {
						content: ": ";
					}
					.PSFExt-Hidden { 
						display: none;
					}
					.PSFExt-Section-Solver-DynamicInput {
						background-color: var(--theme-color-background-panel, #ffffff);
					}
					
					/** empty states */
					.PSFExt-Section-Solvers:empty::before {
						content: "No Section Solvers Defined";
						font-style: italic;
						color: var(--PSFExt-Section-label-color);
						margin-left: var(--PSFExt-indentation-size);
						text-align: center;
						padding: var(--PSFExt-gutter-size);
						display: block;
						font-size: smaller;
					}
					.PSFExt-Group-Solvers:empty::before {
						content: "No Group/RecordSet Solvers Defined";
						font-style: italic;
						color: var(--PSFExt-Section-label-color);
						margin-left: var(--PSFExt-indentation-size);
						text-align: center;
						padding: var(--PSFExt-gutter-size);
						display: block;
						font-size: smaller;
					}
					.PSFExt-ExpressionEditbox {
						width: calc(100% - 20px);
						resize: vertical;
						min-height: 80px;
						font-family: monospace;
						font-size: 0.9em;
					}
					.PSFExt-Token {
						background-color: var(--PSFExt-Section-token-color);
					}
				`, 1000, 'Pict-Form-SupportBase');
		}

		// Only add these templates if they doesn't exist
		if (this.pict.TemplateProvider.getTemplate('Pict-Form-Support-Container') == null)
		{
			this.pict.TemplateProvider.addTemplate('Pict-Form-Support-Container',
				/*html*/`
			<div id="Pict-Form-Extensions-Wrap">
				<p class="PSFExt-Extension-Header"><span id="Pict-Form-Extension-DragControl" class="PSDV-Extension-Header-Controlbar">Pict.Extensions {~TS:Pict-Form-Support-Container-Link:Pict.providers[Pict-Form-SupportExtensions].getSupportViewLinks()~} <a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.toggleClass('#Pict-Form-Extensions-Container', 'PSFExt-Hidden');{~P~}.ContentAssignment.toggleClass('#Pict-Form-Extensions-Footer', 'PSFExt-Hidden');">toggle</a></span></p>
				<div id="Pict-Form-Extensions-Container"></div>
				<p id="Pict-Form-Extensions-Footer" class="PSFExt-Extension-Footer"><span id="Pict-Form-Extension-ResizeControl">Pict.Extensions Resize</span></p>
			</div>
				`);
		}
		if (this.pict.TemplateProvider.getTemplate('Pict-Form-Support-Container-Link') == null)
		{
			this.pict.TemplateProvider.addTemplate('Pict-Form-Support-Container-Link',
				/*html*/` [ <a href="{~D:Record.Link~}" onclick="{~D:Record.OnClick~}" data-shortname="{~D:Record.ShortName~}" data-longname="{~D:Record.LongName~}">{~D:Record.ShortName~}</a> ] `);
		}


		this.SupportViews = {};
	}

	registerSupportView(pView)
	{
		this.pict.log.info(`Registering support view ${pView.Hash} with Pict Support Extension provider.`);
		this.SupportViews[pView.Hash] = pView;
	}

	getSupportViewLinks()
	{
		let tmpLinks = [];
		let tmpSupportViewHashes = Object.keys(this.SupportViews);
		for (let i = 0; i < tmpSupportViewHashes.length; i++)
		{
			let tmpViewHash = tmpSupportViewHashes[i];
			let tmpView = this.SupportViews[tmpViewHash];
			tmpLinks.push(
				{
					Hash: tmpView.Hash,
					Link: `javascript:void(0);`,
					ShortName: tmpView.DisplayShortName,
					LongName: tmpView.DisplayLongName,
					OnClick: `${this.pict.browserAddress}.views['${tmpView.Hash}'].render()`
				}
			);
		}
		return tmpLinks;
	}
}

module.exports = PictSupportExtension;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"pict-provider":19}],125:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-AppData",

	DefaultRenderable: 'Pict-Form-AppData-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-AppData-Content",
			Template: /*html*/`
<div id="Pict-Form-AppData-Content">
	<h2 class="PSFAD-Global-Header">Pict Form Data Visualization</h2>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Form Marshal Destination</span> {~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Form Data</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.{~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}')">Download JSON</a>]
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">AppData</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.AppData')">Download AppData JSON</a>]
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Fable Settings</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.settings')">Download fable settings JSON</a>]
	</p>
	<p class="PSFExt-Data">
		<span class="PSFExt-Label">Application Options</span> [<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.PictApplication.options')">Download Application options JSON</a>]
	</p>
	<div id="PSFExt-Data-Browser" class="PSFExt-Section">
		{~TVS:Pict-Form-AppData:Context[0].flattenMarshalDestination()~}
	</div>
`
		},
		{
			Hash: "Pict-Form-AppData",
			Template: /*html*/`
	<div class="PSFExt-Section">
		<h3 class="PSFExt-Section-Header"><span class="PSFExt-DeEmphasize">Address:</span> 
			{~D:Record.Key~}
		</h3>
		<div id="PSFExt-AD-{~D:Record.Key~}-Extra" class="PSFExt-Section-ExtraData">
			{~TIfAbs:Pict-Form-AppData-ObjectValueDisplay:Record:Record.Value.DataType^==^Object~}
			{~TIfAbs:Pict-Form-AppData-NotObjectValueDisplay:Record:Record.Value.DataType^!=^Object~}
		</div>
	</div>
`
		},
		{
			Hash: "Pict-Form-AppData-NotObjectValueDisplay",
			Template: /*html*/`
				<!-- Not Object Value Display -->
				{~TIfAbs:Pict-Form-AppData-ArrayValueDisplay:Record:Record.Value.DataType^==^Array~}
				{~TIfAbs:Pict-Form-AppData-PrimitiveValueDisplay:Record:Record.Value.DataType^!=^Array~}
`
		},
		{
			Hash: "Pict-Form-AppData-ObjectValueDisplay",
			Template: /*html*/`
			<!-- Object Value Display -->
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Type</span> Javascript Object {~T:Pict-Form-AppData-ObjectDownloadLink~}
			</p>
`
		},
		{
			Hash: "Pict-Form-AppData-ArrayValueDisplay",
			Template: /*html*/`
			<!-- Array Value Display -->
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Type</span> Array {~TIfAbs:Pict-Form-AppData-ArrayDownloadLink~}

			</p>
`
		},
		{
			Hash: "Pict-Form-AppData-PrimitiveValueDisplay",
			Template: /*html*/`
			<!-- Primitive Value Display -->
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Value</span> {~D:Record.Value.Default~}
			</p>
`
		},
		{
			Hash: "Pict-Form-AppData-ObjectDownloadLink",
			Template: /*html*/`[<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.{~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}')">Download JSON</a>]`
		},
		{
			Hash: "Pict-Form-AppData-ArrayDownloadLink",
			Template: /*html*/`[<a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].downloadJSONObjectAsFile('Pict.{~D:Pict.views.PictFormMetacontroller.viewMarshalDestination~}')">Download Array</a>]`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-AppData-Renderable",
			TemplateHash: "Pict-Form-AppData-Content"
		}
	]
});

class PictFormsAppData extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'FDT';
		this.DisplayLongName = 'FormData';
	}

	flattenMarshalDestination()
	{
		return this.flattenAddress(this.pict.views.PictFormMetacontroller.viewMarshalDestination);
	}

	flattenAppData()
	{
		return this.flattenAddress('AppData');
	}

	flattenAddress(pAddress)
	{
		let tmpData = this.pict.resolveStateFromAddress(pAddress);
		// Now flatten the entire data structure...
		return this.pict.manifest.objectAddressGeneration.generateAddressses(tmpData);
	}
}

module.exports = PictFormsAppData;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":130}],126:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-DebugViewer",

	DefaultRenderable: 'Pict-Form-DebugViewer-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/`
	/** Dynamic Input Section Overrides */
	#PSFExt-DynamicInputSection .PSFExt-Section { 
		margin: var(--PSFExt-gutter-size);
		padding: var(--PSFExt-gutter-size);
		background-color: var(--PSFExt-Section-DynamicInput-background-color);
	}

	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-Section-Button { 
		background-color: var(--PSFExt-Section-DynamicInput-button-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-Section-Button a { 
		color: var(--PSFExt-Section-DynamicInput-button-text-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-Label,
	#PSFExt-DynamicInputSection .PSFExt-Section .PSFExt-DeEmphasize { 
		color: var(--PSFExt-Section-DynamicInput-button-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section-Descriptors { 
		border-left: 5px solid var(--PSFExt-Section-DynamicInput-background-color);
	}
	#PSFExt-DynamicInputSection .PSFExt-Section-Group { 
		border-left: 5px solid var(--PSFExt-Section-DynamicInput-button-color);
	}
`,

	Templates: [
		{
			Hash: "Pict-Form-DebugViewer-Content",
			Template: /*html*/`
<div id="Pict-Form-DebugViewer-Content">
	<h2 class="PSFExt-Global-Header">Pict Inline Form Editing Tool</h2>
	{~T:Pict-Form-DebugViewer-MetacontrollerContainer~}
</div>`
		},
		{
			Hash: "Pict-Form-DebugViewer-MetacontrollerContainer",
			Template: /*html*/`
	<p class="PSFExt-Data"><span class="PSFExt-Label">Scope:</span> {~D:Context[0].getDynamicState().Scope~}</p>
	<ul class="PSFExt-Section-Buttons">
	</ul>
	<div id="PSFExt-SectionList">
		{~TS:Pict-Form-DebugViewer-SectionContainer:Context[0].getDynamicState().SectionViews~}
	</div>
	<hr>
	<div id="PSFExt-DynamicInputSection">
		{~T:Pict-Form-DebugViewer-SectionContainer:Context[0].getDynamicState().DynamicInputView~}
	</div>
`
		},
		{
			Hash: "Pict-Form-DebugViewer-SectionContainer",
			Template: /*html*/`
	<div id="PSFExt-Section-{~D:Record.Hash~}" class="PSFExt-Section">
		<h3 class="PSFExt-Section-Header"><span class="PSFExt-DeEmphasize">Section:</span> {~D:Record.sectionDefinition.Name~}</h3>
		<ul class="PSFExt-Section-Buttons">
			<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.views['{~D:Record.View.Hash~}'].render()">Render</a></li>
			<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.assignContent('{~D:Record.View.options.DefaultDestinationAddress~}','')">Clear</a></li>
			<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.removeClass('#PSFExt-{~D:Record.View.Hash~}-Extra', 'PSFExt-Hidden')">Extra Data</a></li>
		</ul>
		<div id="PSFExt-{~D:Record.View.Hash~}-Extra" class="PSFExt-Hidden PSFExt-Section-ExtraData">
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Description</span> {~D:Record.sectionDefinition.Description~}
			</p>
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Hash</span> {~D:Record.View.Hash~}
			</p>
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">HTML ID</span> {~D:Record.View.sectionDefinition.Macro.HTMLID~}
			</p>
			<h4 class="PSFExt-Content-Header">Section Solvers:</h4>
			<div class="PSFExt-Section-Solvers">{~TS:Pict-Form-DebugViewer-SolverEntry:Record.Solvers[]<<~?ExpressionScope,==,Section?~>>~}</div>
			<h4 class="PSFExt-Content-Header">Tabular/RecordSet Solvers:</h4>
			<div class="PSFExt-Group-Solvers">{~TS:Pict-Form-DebugViewer-SolverEntry:Record.Solvers[]<<~?ExpressionScope,==,Group?~>>~}</div>
			<h4 class="PSFExt-Content-Header">Inputs:</h4>
			<div class="PSFExt-Section-Solver-DynamicInput">
				{~TS:Pict-Form-DebugViewer-GroupContainer:Record.View.sectionDefinition.Groups~}
			</div>
			<ul class="PSFExt-Section-Buttons">
				<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.addClass('#PSFExt-{~D:Record.View.Hash~}-Extra', 'PSFExt-Hidden')">Hide Extra Data for {~D:Record.View.Hash~}</a></li>
			</ul>
		</div>
	</div>
`
		},
		{
			Hash: "Pict-Form-DebugViewer-SolverEntry",
			Template: /*html*/`
			<div class="PSFExt-Section-Solver-Entry">
				<p class="PSFExt-Solver-Entry">{~D:Record.Expression~}</p>
				<p class="PSFExt-Data"><span class="PSFExt-Label">Last Result</span> <span class="PSFExt-Solver-Result">{~D:Record.LastResult~}</span></p>
				<p class="PSFExt-Data"><span class="PSFExt-Label">Sequence</span> Ordinal [{~D:Record.Ordinal~}] Index [{~D:Record.Index~}]</p>
			</div>
			`
		},
		{
			Hash: "Pict-Form-DebugViewer-GroupContainer",
			Template: /*html*/`
			<div class="PSFExt-Section-Group">
				<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">
					<span class="PSFExt-DeEmphasize">Group:</span> {~D:Record.Name~} [idx <em>{~D:Record.GroupIndex~}</em>]
				</h5>
				<p class="PSFExt-Data"><span class="PSFExt-Label">Layout</span> {~D:Record.Layout~}</p>
				<div class="PSFExt-Section-Rows">
					{~TS:Pict-Form-DebugViewer-RowContainer:Record.Rows~}
				</div>
			</div>
			`
		},
		{
			Hash: "Pict-Form-DebugViewer-RowContainer",
			Template: /*html*/`
					<div class="PSFExt-Section-Descriptors">
						<h6 class="PSFExt-Content-Header PSFExt-Section-Group-Row-Header">
							<span class="PSFExt-DeEmphasize">Row:</span> {~D:Record.Hash~}
						</h6>
						{~TS:Pict-Form-DebugViewer-DescriptorContainer:Record.Inputs~}
					</div>
`
		},
		{
			Hash: "Pict-Form-DebugViewer-DescriptorContainer",
			Template: /*html*/`
						<div class="PSFExt-Section-Descriptor">
							<p class="PSFExt-Data-Header"><span class="PSFExt-DeEmphasize">Input:</span> {~D:Record.Name~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">Hash</span> {~D:Record.Hash~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">DataType</span> {~D:Record.DataType~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">InputType</span> {~D:Record.PictForm.InputType~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">Informary Data Address</span> {~D:Record.PictForm.InformaryDataAddress~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">Input Index</span> {~D:Record.PictForm.InputIndex~}</p>
							<p class="PSFExt-Data"><span class="PSFExt-Label">HTML ID</span> {~D:Record.PictForm.Macro.HTMLID~}</p>
						</div>
					`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-DebugViewer-Renderable",
			TemplateHash: "Pict-Form-DebugViewer-Content"
		}
	]
});

class PictFormsInlineEditor extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'ILE';
		this.DisplayLongName = 'InlineEditor';
	}
}

module.exports = PictFormsInlineEditor;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":130}],127:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-LifeCycle",

	DefaultRenderable: 'Pict-Form-LifeCycle-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-LifeCycle-Content",
			Template: /*html*/`
<div id="Pict-Form-LifeCycle-Content">
	<h2 class="PSFLC-Global-Header">Pict LifeCycle Visualization</h2>
</div>
`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-LifeCycle-Renderable",
			TemplateHash: "Pict-Form-LifeCycle-Content"
		}
	]
});

class PictFormsLifeCycle extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'LCV';
		this.DisplayLongName = 'LifecycleVisulization';
	}
}

module.exports = PictFormsLifeCycle;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":130}],128:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-Solver",

	DefaultRenderable: 'Pict-Form-Solver-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-Solver-Content",
			Template: /*html*/`
<div id="Pict-Form-Solver-Content">
	<h2 class="PSFS-Global-Header">Pict Solver Visualization</h2>
	<ul class="PSFExt-Section-Buttons">
		<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.views.PictFormMetacontroller.solve(); {~P~}.views.PictFormMetacontroller.marshalFormSections(); {~P~}.views['{~D:Context[0].Hash~}'].render();">Solve</a></li>
	</ul>
	{~TS:Pict-Form-Solver-Entries:Context[0].getDynamicState().Solvers~}
</div>
`
		},
		{
			Hash: "Pict-Form-Solver-Entries",
			Template: /*html*/`
	<div id="PSFExt-Section-{~D:Record.Hash~}" class="PSFExt-Section">
		<h3 class="PSFExt-Section-Header">
			<span class="PSFExt-DeEmphasize">{~D:Record.ExpressionScope~} {~D:Record.SectionOrdinal~}.G.{~D:Record.GroupOrdinal~}</span> Ord</span>{~D:Record.Ordinal~} <span class="PSFExt-DeEmphasize">Ind</span>{~D:Record.Index~}
			[ <a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');">Edit</a> ]
			[ <a href="javascript:void(0);" onclick="{~P~}.ContentAssignment.toggleClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer', 'PSFExt-Hidden');">More</a> ]
		</h3>
		
		<div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer" class="PSFExt-Hidden">
			<p class="PSFExt-Data">
				<textarea id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox" class="PSFExt-ExpressionEditbox">{~D:Record.Expression~}</textarea>
			</p>
			<ul class="PSFExt-Section-Buttons">
				<li class="PSFExt-Section-Button"><a href="javascript:void(0);" onclick="{~P~}.views['{~D:Context[0].Hash~}'].updateExpressionFromElement('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionEditbox', '{~D:Record.ExpressionScope~}', '{~D:Record.ViewHash~}', {~D:Record.SectionOrdinal~}, {~D:Record.Index~}, '#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display'); {~P~}.ContentAssignment.addClass('#PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExpressionContainer', 'PSFExt-Hidden');">Apply</a></li>
			</ul>
		</div>
		<div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Extra" class="PSFExt-Section-ExtraData">
			<p class="PSFExt-Solver-Entry" id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-Display">{~D:Record.Expression~}</p>
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">Value</span> {~TBT:Record.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record:Pict-Form-RecordValueDisplaySimple~}
			</p>
		</div>
		<div id="PSFExt-{~D:Record.ExpressionScope~}-{~D:Record.ViewHash~}-S{~D:Record.SectionOrdinal~}-G{~D:Record.GroupOrdinal~}-{~D:Record.Index~}-ExtraDataContainer" class="PSFExt-Section-ExtraData PSFExt-Hidden">
			<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Tokens</h5>
			{~TS:Pict-Form-Solver-PostfixToken:Record.LastResultsObject.PostfixTokenObjects~}
			<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">Virtual Symbols</h5>
			{~TVS:Pict-Form-Solver-VirtualSymbols:Record.LastResultsObject.VirtualSymbols~}
			<h5 class="PSFExt-Content-Header PSFExt-Section-Group-Header">{~D:Record.LastResultsObject.PostfixTokenObjects.length~} Postfix Solve List</h5>
			{~TVS:Pict-Form-Solver-PostFixSolveEntry:Record.LastResultsObject.PostfixSolveList~}
		</div>
	</div>
`
		},
		{
			Hash: "Pict-Form-Solver-PostfixToken",
			Template: /*html*/`
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">{~D:Record.Type~}</span> <span class="PSFExt-Token">{~D:Record.Token~}</span>
			</p>
`
		},
		{
			Hash: "Pict-Form-Solver-VirtualSymbols",
			Template: /*html*/`
			<p class="PSFExt-Data">
				<span class="PSFExt-Label">{~D:Record.Key~}</span> {~TBT:Record.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record:Pict-Form-RecordValueDisplaySimple~}
			</p>
`
		},
		{
			Hash: "Pict-Form-RecordValueDisplayComplex",
			Template: /*html*/`
			<!-- Complex Value -->
			{~TBT:Record.Value:array:Pict-Form-RecordValueDisplayArray:Record:Pict-Form-RecordValueDisplayObject~}
`
		},
		{
			Hash: "Pict-Form-RecordValueDisplayObject",
			Template: /*html*/`JSON Object
			<!-- RAW Object
{~DJ:Record.Value~}
			-->`
		},
		{
			Hash: "Pict-Form-RecordValueDisplayArray",
			Template: /*html*/`JSON Array ({~D:Record.Value.length~} items)
			<!-- RAW Array
{~DJ:Record.Value~}
			-->`
		},
		{
			Hash: "Pict-Form-RecordValueDisplaySimple",
			Template: /*html*/`{~D:Record.Value~}`
		},
		{
			Hash: "Pict-Form-Solver-PostFixSolveEntry",
			Template: /*html*/`
			<div>
				<h6 class="PSFExt-Content-Header PSFExt-Data-Header">Postfix Solve Entry #{~D:Record.Key~} Symbol <span class="PSFExt-Token">{~D:Record.Value.VirtualSymbolName~}</span></h6>
				<table class="PSFExt-Data-Table">
					<th>
						<tr><td></td><td>Left</td><td>Operation</td><td>Right</td></tr>
					</th>
					<tr>
						<td>Virtual Symbol</td>
						<td> {~D:Record.Value.LeftValue.VirtualSymbolName~} </td>
						<td> {~D:Record.Value.Operation.VirtualSymbolName~} </td>
						<td> {~D:Record.Value.RightValue.VirtualSymbolName~} </td>
					</tr>
					<tr>
						<td>Value</td>
						<td> {~TBT:Record.Value.LeftValue.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record.Value.LeftValue:Pict-Form-RecordValueDisplaySimple~} </td>
						<td></td>
						<td> {~TBT:Record.Value.RightValue.Value:object,array:Pict-Form-RecordValueDisplayComplex:Record.Value.RightValue:Pict-Form-RecordValueDisplaySimple~} </td>
					</tr>
					<tr>
						<td>Tokens</td>
						<td> {~D:Record.Value.LeftValue.Token~} </td>
						<td> {~D:Record.Value.Operation.Token~} </td>
						<td> {~D:Record.Value.RightValue.Token~} </td>
					</tr>
					<tr>
						<td>Type</td>
						<td> {~D:Record.Value.LeftValue.Type~} </td>
						<td> {~D:Record.Value.Operation.Type~} </td>
						<td> {~D:Record.Value.RightValue.Type~} </td>
					</tr>
					<tr>
						<td>Solve Layer</td>
						<td> {~D:Record.Value.LeftValue.SolveLayerStack~} </td>
						<td></td>
						<td> {~D:Record.Value.RightValue.SolveLayerStack~} </td>
					</tr>
				</table>
			</div>
`
		},
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-Solver-Renderable",
			TemplateHash: "Pict-Form-Solver-Content"
		}
	]
});

class PictFormsSolver extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'SLV';
		this.DisplayLongName = 'SolverVisualization';
	}
}

module.exports = PictFormsSolver;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":130}],129:[function(require,module,exports){
const libPictViewFormSupportBase = require(`./Pict-View-PSF-SupportBase.js`);

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-SpecificSolve",

	DefaultRenderable: 'Pict-Form-SpecificSolve-Renderable',
	DefaultDestinationAddress: "#Pict-Form-Extensions-Container",

	RenderOnLoad: false,

	CSS: /*css*/``,

	Templates: [
		{
			Hash: "Pict-Form-SpecificSolve-Content",
			Template: /*html*/`
<div id="Pict-Form-SpecificSolve-Content">
	<h2 class="PSFSS-Global-Header">Pict Specific Solve Timing Visualization</h2>
</div>
`
		}
	],
	Renderables: [
		{
			RenderableHash: "Pict-Form-SpecificSolve-Renderable",
			TemplateHash: "Pict-Form-SpecificSolve-Content"
		}
	]
});

class PictFormsSpecificSolve extends libPictViewFormSupportBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.DisplayShortName = 'STV';
		this.DisplayLongName = 'SpecificSolveTimingVisualization';
	}
}

module.exports = PictFormsSpecificSolve;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-View-PSF-SupportBase.js":130}],130:[function(require,module,exports){
const libPictView = require(`pict-view`);

const libPictSupportProvider = require('./Pict-Provider-PSF-Support.js');

const defaultViewConfiguration = (
{
	ViewIdentifier: "Pict-Form-SupportBase",

	DefaultRenderable: 'Pict-Form-SUPPORT-BASE',

	RenderOnLoad: false,

	Templates: [],
	Renderables: [
		{
			RenderableHash: "Pict-Form-SUPPORT-BASE",
			TemplateHash: "Pict-Form-SUPPORT-BASE-NOTEMPLATE"
		}
	]
});

class PictFormsSupportBase extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Add the support provider if it doesn't exist
		this.pict.addProviderSingleton("Pict-Form-SupportExtensions", {}, libPictSupportProvider);

		this.DisplayShortName = 'U';
		this.DisplayLongName = 'UNDEFINED';

		// Register this with the support provider
		this.pict.providers["Pict-Form-SupportExtensions"].registerSupportView(this);
	}

	getDynamicState()
	{
		if (!('PictFormMetacontroller' in this.pict.views))
		{
			this.pict.log.warn(`Pict Forms Inline Editor tried to initialize but no metacontroller was found.`);
			return (
				{
					"Scope": `ERR_NO_METACONTROLLER`,
					"Description": `Error initializing inline editor -- no metacontroller found.`,
					"Manifest": this.fable.newManyfest(),
					"Sections": []
				});
		}
		let tmpMetacontroller = this.pict.views.PictFormMetacontroller;
		let tmpDynamicState = (
			{
				// TODO: The way the metacontroller pulls in the manifest and bootstraps the description is putting "DEFAULT" into the actual manifest; fix this.
				"Scope": tmpMetacontroller.manifestDescription.Scope,
				"Description": ``,
				"Manifest": tmpMetacontroller.manifest,
				"ManifestDescription": tmpMetacontroller.manifestDescription,
				"AllViews": tmpMetacontroller.filterViews(),
				"SectionViews": [],
				"DynamicInputView": false,
				"Solvers": []
			});

		for (let i = 0; i < tmpDynamicState.AllViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.AllViews[i];
			if (tmpSectionView.isPictSectionForm && (tmpSectionView.Hash == 'PictFormMetacontroller-DynamicInputs'))
			{
				// This is the special Dynamic Input section -- it goes in its own place.
				tmpDynamicState.DynamicInputView = tmpSectionView;
			}
			else if (tmpSectionView.isPictSectionForm)
			{
				tmpDynamicState.SectionViews.push(
					{
						View: tmpSectionView,
						sectionDefinition: tmpSectionView.sectionDefinition,
						Solvers: []
					});
			}
		}

		// Now get the solvers for each section view
		for (let i = 0; i < tmpDynamicState.SectionViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.SectionViews[i].View;
			let tmpSectionViewSolvers = tmpDynamicState.SectionViews[i].Solvers;
			// Find the view representation in the 
			if (tmpSectionView.isPictSectionForm && Array.isArray(tmpSectionView.sectionDefinition.Solvers))
			{
				for (let j = 0; j < tmpSectionView.sectionDefinition.Solvers.length; j++)
				{
					let tmpSolver = tmpSectionView.sectionDefinition.Solvers[j];

					let tmpSolverEntry = { ViewHash: tmpSectionView.Hash, SectionOrdinal: i, GroupOrdinal: -1, Ordinal: 1, Index: j, Expression: '', ExpressionType: 'Unknown', ExpressionScope: 'Section'}
					if (typeof(tmpSolver) === 'string')
					{
						tmpSolverEntry.Expression = tmpSolver;
						tmpSolverEntry.ExpressionType = 'Simple';
					}
					else if (typeof(tmpSolver) === 'object')
					{
						// When the solvers are in this format:
						// {
						// 	Ordinal: 0,
						// 	Expression: "PercentTotalFat = (Fat * 9) / Calories",
						// }
						tmpSolverEntry.Expression = tmpSolver.Expression;
						tmpSolverEntry.Ordinal = tmpSolver.Ordinal;
						tmpSolverEntry.ExpressionType = 'Complex';
					}
					tmpDynamicState.Solvers.push(tmpSolverEntry);
					tmpSectionViewSolvers.push(tmpSolverEntry);
				}
			}

			// Now get all the Group solvers
			// These guards are here because the metacontroller view masquerades as a section form view but isn't one.
			for (let j = 0; j < tmpSectionView.sectionDefinition.Groups.length; j++)
			{
				let tmpGroup = tmpSectionView.getGroup(j);
				if (`RecordSetSolvers` in tmpGroup)
				{
					for (let k = 0; k < tmpGroup.RecordSetSolvers.length; k++)
					{
						let tmpSolver = tmpGroup.RecordSetSolvers[k];
	
						let tmpSolverEntry = { ViewHash: tmpSectionView.Hash, SectionOrdinal: i, GroupOrdinal: j, Ordinal: 1, Index: k, Expression: '', ExpressionType: 'Unknown', ExpressionScope: 'Group'}
						if (tmpSolver)
						{
							if (typeof(tmpSolver) === 'string')
							{
								tmpSolverEntry.Expression = tmpSolver;
								tmpSolverEntry.ExpressionType = 'Simple';
							}
							else if (typeof(tmpSolver) === 'object')
							{
								// When the solvers are in this format:
								// {
								// 	Ordinal: 0,
								// 	Expression: "PercentTotalFat = (Fat * 9) / Calories",
								// }
								tmpSolverEntry.Expression = tmpSolver.Expression;
								tmpSolverEntry.Ordinal = tmpSolver.Ordinal;
								tmpSolverEntry.ExpressionType = 'Complex';
							}
						}
						tmpDynamicState.Solvers.push(tmpSolverEntry);
						tmpSectionViewSolvers.push(tmpSolverEntry);
					}
				}
			}

			// Now sort the solvers by Ordinal, then Group/Section and then Index
			tmpSectionViewSolvers.sort((pLeftValue, pRightValue) => 
			{
				if (pLeftValue.Ordinal < pRightValue.Ordinal) return -1;
				if (pLeftValue.Ordinal > pRightValue.Ordinal) return 1;
				if (pLeftValue.ExpressionScope == 'Group' && pRightValue.ExpressionScope == 'Section') return -1;
				if (pLeftValue.ExpressionScope == 'Section' && pRightValue.ExpressionScope == 'Group') return 1;
				if (pLeftValue.Index < pRightValue.Index) return -1;
				if (pLeftValue.Index > pRightValue.Index) return 1;
				return 0;
			});
		}

		tmpDynamicState.Solvers.sort((pLeftValue, pRightValue) => 
			{
				if (pLeftValue.Ordinal < pRightValue.Ordinal) return -1;
				if (pLeftValue.Ordinal > pRightValue.Ordinal) return 1;
				if (pLeftValue.ExpressionScope == 'Group' && pRightValue.ExpressionScope == 'Section') return -1;
				if (pLeftValue.ExpressionScope == 'Section' && pRightValue.ExpressionScope == 'Group') return 1;
				if (pLeftValue.Index < pRightValue.Index) return -1;
				if (pLeftValue.Index > pRightValue.Index) return 1;
				return 0;
			});
		// Get the *full* last solve outcome object
		tmpDynamicState.LastSolveOutcome = this.pict.providers.DynamicSolver.lastSolveOutcome;

		// Now walk through the solvers and see if the outcome has a result for it.
		if (typeof(tmpDynamicState.LastSolveOutcome) == 'object')
		{
			for (let i = 0; i < tmpDynamicState.Solvers.length; i++)
			{
				let tmpSolverEntry = tmpDynamicState.Solvers[i];

				if (tmpSolverEntry.Ordinal in tmpDynamicState.LastSolveOutcome.SolveOrdinals)
				{
					if (tmpSolverEntry.ExpressionScope == 'Section')
					{
						let tmpSolveResultSet = tmpDynamicState.LastSolveOutcome.SolveOrdinals[tmpSolverEntry.Ordinal].SectionSolvers;
						if (Array.isArray(tmpSolveResultSet))
						{
							for (let j = 0; j < tmpSolveResultSet.length; j++)
							{
								let tmpPotentialResultEntry =	tmpSolveResultSet[j];
								if ((tmpPotentialResultEntry.ViewHash == tmpSolverEntry.ViewHash) && (tmpPotentialResultEntry.Solver.Expression == tmpSolverEntry.Expression))
								{
									// We have a match -- assign the result to the solver entry
									tmpSolverEntry.LastResult = tmpPotentialResultEntry.Solver.ResultsObject.RawResult;
									tmpSolverEntry.Value = tmpPotentialResultEntry.Solver.ResultsObject.RawResult;
									tmpSolverEntry.LastResultsObject = tmpPotentialResultEntry.Solver.ResultsObject;
								}
							}
						}
					}
					else if ((tmpSolverEntry.ExpressionScope == 'Group'))
					{
						let tmpSolveResultSet = tmpDynamicState.LastSolveOutcome.SolveOrdinals[tmpSolverEntry.Ordinal].GroupSolvers;
						if (Array.isArray(tmpSolveResultSet))
						{
							for (let j = 0; j < tmpSolveResultSet.length; j++)
							{
								let tmpPotentialResultEntry =	tmpSolveResultSet[j];
								if ((tmpPotentialResultEntry.ViewHash == tmpSolverEntry.ViewHash) && (tmpPotentialResultEntry.Solver.Expression == tmpSolverEntry.Expression))
								{
									// We have a match -- assign the result to the solver entry
									if (tmpPotentialResultEntry.Solver && ('ResultsObject' in tmpPotentialResultEntry.Solver))
									{
										tmpSolverEntry.LastResult = tmpPotentialResultEntry.Solver.ResultsObject.RawResult;
									}
									if (tmpPotentialResultEntry.Solver && ('ResultsObject' in tmpPotentialResultEntry.Solver))
									{
										tmpSolverEntry.LastResultsObject = tmpPotentialResultEntry.Solver.ResultsObject;
									}
								}
							}
						}
					}
				}
			}
		}

		return tmpDynamicState;
	}

	getSectionSolvers(pSectionViewHash)
	{
		let tmpDynamicState = this.getDynamicState();
		let tmpSectionSolvers = tmpDynamicState.Solvers.map((pSolverEntry) => { if (pSolverEntry.ViewHash === pSectionViewHash) return pSolverEntry; });
		return tmpSectionSolvers;
	}


	downloadJSONObjectAsFile(pAddress)
	{
		try
		{
			const tmpJSONData = this.pict.resolveStateFromAddress(pAddress);
			const tmpJSONFileName = `PICT_JSON_${pAddress.replace('.','_')}.json`;
			const tmpJSONString = JSON.stringify(tmpJSONData, null, 4);

			if (!URL || !Blob)
			{
				this.pict.log.error(`Browser does not support required features for downloading JSON object from address ${pAddress}.`);
				return;
			}

			// Synthesize a file, URL and link to facilitate a file download
			const tmpAbstractFileBlob = new Blob([tmpJSONString], { type: "application/json" });
			const tmpAbstractFileURL = URL.createObjectURL(tmpAbstractFileBlob);
			const tmpAbstractAnchorElement = document.createElement("a");
			tmpAbstractAnchorElement.href = tmpAbstractFileURL;
			tmpAbstractAnchorElement.download = tmpJSONFileName;
			// Trigger the download
			tmpAbstractAnchorElement.click();
			// Clean up the URL from memory
			URL.revokeObjectURL(tmpAbstractFileURL);
		}
		catch (pError)
		{
			this.pict.log.error(`Error downloading JSON object from address ${pAddress}: ${pError.message}`);
		}
	}

	updateExpressionFromElement(pExpressionElementAddress, pExpressionScope, pSectionViewHash, pSectionOrdinal, pSolverIndex, pExpressionElementRepresentationAddress)
	{
		// 1. Get the expression from the element
		let tmpExpressionElementValue = this.pict.ContentAssignment.readContent(pExpressionElementAddress);

		if (!tmpExpressionElementValue)
		{
			this.pict.log.warn(`No expression found in element at address ${pExpressionElementAddress}; cannot update ${pExpressionScope} solver Ordinal ${pSectionOrdinal} Index ${pSolverIndex}.`);
			return;
		}
		// 2. Go through the enumeration of solvers to find if this expression exists
		let tmpMetacontroller = this.pict.views.PictFormMetacontroller;
		let tmpDynamicState = (
			{
				// TODO: The way the metacontroller pulls in the manifest and bootstraps the description is putting "DEFAULT" into the actual manifest; fix this.
				"Scope": tmpMetacontroller.manifestDescription.Scope,
				"Description": ``,
				"Manifest": tmpMetacontroller.manifest,
				"ManifestDescription": tmpMetacontroller.manifestDescription,
				"AllViews": tmpMetacontroller.filterViews(),
				"SectionViews": [],
				"DynamicInputView": false,
				"Solvers": []
			});

		for (let i = 0; i < tmpDynamicState.AllViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.AllViews[i];
			if (tmpSectionView.isPictSectionForm && (tmpSectionView.Hash == 'PictFormMetacontroller-DynamicInputs'))
			{
				// This is the special Dynamic Input section -- it goes in its own place.
				tmpDynamicState.DynamicInputView = tmpSectionView;
			}
			else if (tmpSectionView.isPictSectionForm)
			{
				tmpDynamicState.SectionViews.push(
					{
						View: tmpSectionView,
						sectionDefinition: tmpSectionView.sectionDefinition,
						Solvers: []
					});
			}
		}

		// Now get the solvers for each section view
		for (let i = 0; i < tmpDynamicState.SectionViews.length; i++)
		{
			let tmpSectionView = tmpDynamicState.SectionViews[i].View;
			let tmpSectionViewSolvers = tmpDynamicState.SectionViews[i].Solvers;
			// Find the view representation in the 
			if (tmpSectionView.isPictSectionForm && Array.isArray(tmpSectionView.sectionDefinition.Solvers))
			{
				for (let j = 0; j < tmpSectionView.sectionDefinition.Solvers.length; j++)
				{
					let tmpSolver = tmpSectionView.sectionDefinition.Solvers[j];

					// 3a. Update the expression in the solver definition
					if (pExpressionScope == 'Section' && i == pSectionOrdinal && j == pSolverIndex && tmpSectionView.Hash == pSectionViewHash)
					{
						// This is the solver we are updating
						if (typeof(tmpSolver) === 'string')
						{
							// Simple solver -- just a string
							tmpSectionView.sectionDefinition.Solvers[j] = tmpExpressionElementValue;
						}
						else if (typeof(tmpSolver) === 'object')
						{
							// Complex solver -- update the expression property
							tmpSectionView.sectionDefinition.Solvers[j].Expression = tmpExpressionElementValue;
						}
					}
				}
			}

			// Now get all the Group solvers
			// These guards are here because the metacontroller view masquerades as a section form view but isn't one.
			for (let j = 0; j < tmpSectionView.sectionDefinition.Groups.length; j++)
			{
				let tmpGroup = tmpSectionView.getGroup(j);
				if (`RecordSetSolvers` in tmpGroup)
				{
					for (let k = 0; k < tmpGroup.RecordSetSolvers.length; k++)
					{
						let tmpSolver = tmpGroup.RecordSetSolvers[k];
	
						// 3b. Update the expression in the solver definition
						if (pExpressionScope == 'Group' && i == pSectionOrdinal && j == pSolverIndex && tmpSectionView.Hash == pSectionViewHash)
						{
							// This is the solver we are updating
							if (typeof(tmpSolver) === 'string')
							{
								// Simple solver -- just a string
								tmpSectionView.sectionDefinition.Solvers[j] = tmpExpressionElementValue;
							}
							else if (typeof(tmpSolver) === 'object')
							{
								// Complex solver -- update the expression property
								tmpSectionView.sectionDefinition.Solvers[j].Expression = tmpExpressionElementValue;
							}
						}
					}
				}
			}
		}

		// 4. Write the updated expression to it's representation element, if provided
		if (pExpressionElementRepresentationAddress)
		{
			this.pict.ContentAssignment.assignContent(pExpressionElementRepresentationAddress, tmpExpressionElementValue);
		}
	}

	bootstrapContainer()
	{
		// 3. See if the container for the support view is loaded
		let tmpContainerTest = this.options.DefaultDestinationAddress;

		let tmpContainerElement = this.pict.ContentAssignment.getElement(this.options.DefaultDestinationAddress);
		if (tmpContainerElement.length > 0)
		{
			return true;
		}

		// 4. Render the container for the support view if it isn't loaded
		let tmpContainerRenderableHash = 'Pict-Form-Support-Container';

		// Check if the renderable exists -- if not, create it dynamically
		// This just appends itself to the body once, and creates a simple container for extensions to load into.
		if (!(tmpContainerRenderableHash in this.renderables))
		{
			this.renderables[tmpContainerRenderableHash] = (
				{
					RenderableHash: "Pict-Form-Support-Container",
					TemplateHash: "Pict-Form-Support-Container",
					ContentDestinationAddress: 'body',
					RenderMethod: 'append_once',
					TestAddress: "#Pict-Form-Extensions-Container",
				});
		}

		this.renderables[tmpContainerRenderableHash].TestAddress = tmpContainerTest;
		this.pict.CSSMap.injectCSS();

		this.render(tmpContainerRenderableHash);

		// 5. Make the container draggable
		// Setup the draggable behavior for the window
		let tmpDraggableElement = document.getElementById('Pict-Form-Extensions-Wrap'); // What we are dragging
		let tmpDragInteractiveControl = document.getElementById('Pict-Form-Extension-DragControl'); // The control you click on to drag
		if (tmpDraggableElement && tmpDragInteractiveControl)
		{
			tmpDragInteractiveControl.addEventListener('mousedown',
				/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
				* BEGIN of browser event code block
				*
				* The below code is meant to run in response to a browser event.
				* --> Therefore the "this" context is the element that fired the event.
				* --> Happy trails.
				*/
				function (pEvent)
				{
					let tmpOffsetX = pEvent.offsetX + tmpDragInteractiveControl.clientLeft;
					let tmpOffsetY = pEvent.offsetY + tmpDragInteractiveControl.clientTop;
					function dragHandler(pEvent)
					{
						pEvent.stopPropagation();
						
						tmpDraggableElement.style.left = (pEvent.clientX - tmpOffsetX) + 'px';
						tmpDraggableElement.style.top = (pEvent.clientY - tmpOffsetY) + 'px';
					}
					function dragStop(pEvent)
					{
						window.removeEventListener('pointermove', dragHandler);
						window.removeEventListener('pointerup', dragStop);
					}
					window.addEventListener('pointermove', dragHandler);
					window.addEventListener('pointerup', dragStop);

					// Prevent janky selection behaviors in the browser
					pEvent.preventDefault();
				});
				/*
				* END of browser event code block
				* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
		}

		// 6. Make the container resizable
		// Setup the draggable behavior for the window
		let tmpResizableElement = document.getElementById('Pict-Form-Extensions-Wrap'); // What we are resizing
		let tmpResizableControl = document.getElementById('Pict-Form-Extension-ResizeControl'); // The control you click on to drag
		if (tmpResizableElement && tmpResizableControl)
		{
			tmpResizableControl.addEventListener('mousedown',
				/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
				* BEGIN of browser event code block
				*
				* The below code is meant to run in response to a browser event.
				* --> Therefore the "this" context is the element that fired the event.
				* --> Happy trails.
				*/
				function (pEvent)
				{
					function dragResizeHandler(pEvent)
					{
						pEvent.stopPropagation();
						
						let tmpNewWidth = pEvent.clientX - tmpResizableElement.getBoundingClientRect().left;
						let tmpNewHeight = pEvent.clientY - tmpResizableElement.getBoundingClientRect().top;

						// Check the CSS for minimum width and height, and set these to those if we go under
						let tmpComputedStyle = getComputedStyle(tmpResizableElement);
						let tmpMinWidth = parseInt(tmpComputedStyle.minWidth, 10);
						let tmpMinHeight = parseInt(tmpComputedStyle.minHeight, 10);

						if (tmpNewWidth < tmpMinWidth)
						{
							tmpNewWidth = tmpMinWidth;
						}
						if (tmpNewHeight < tmpMinHeight)
						{
							tmpNewHeight = tmpMinHeight;
						}
						tmpResizableElement.style.width = tmpNewWidth + 'px';
						tmpResizableElement.style.height = tmpNewHeight + 'px';
					}
					function dragResizeStop(pEvent)
					{
						window.removeEventListener('pointermove', dragResizeHandler);
						window.removeEventListener('pointerup', dragResizeStop);
					}
					window.addEventListener('pointermove', dragResizeHandler);
					window.addEventListener('pointerup', dragResizeStop);

					// Prevent janky selection behaviors in the browser
					pEvent.preventDefault();
				});
				/*
				* END of browser event code block
				* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
		}

	}
}

module.exports = PictFormsSupportBase;

module.exports.default_configuration = defaultViewConfiguration;

},{"./Pict-Provider-PSF-Support.js":124,"pict-view":239}],131:[function(require,module,exports){
module.exports = (
{
	"RenderOnLoad": true,

	"DefaultRenderable": "Login-Container",
	"DefaultDestinationAddress": "#Pict-Login-Container",

	"TargetElementAddress": "#Pict-Login-Container",

	// ----- Endpoint Configuration -----
	// Defaults match orator-authentication routes.
	// Override these to point at any custom backend.
	"LoginEndpoint": "/1.0/Authenticate",
	// "POST" sends JSON body { UserName, Password }.
	// "GET"  appends /:username/:password to LoginEndpoint.
	"LoginMethod": "POST",
	"LogoutEndpoint": "/1.0/Deauthenticate",
	"CheckSessionEndpoint": "/1.0/CheckSession",
	"OAuthProvidersEndpoint": "/1.0/OAuth/Providers",
	"OAuthBeginEndpoint": "/1.0/OAuth/Begin",

	// ----- Behavior -----
	"CheckSessionOnLoad": true,
	"ShowOAuthProviders": false,

	// ----- Data Address -----
	// Where session state is stored in the Pict address space.
	"SessionDataAddress": "AppData.Session",

	// ----- Templates -----
	"Templates":
	[
		{
			"Hash": "Pict-Login-Template-Wrapper",
			"Template": "<div class=\"pict-login-card\"><div id=\"pict-login-error\" class=\"pict-login-error\" style=\"display:none\"></div><div id=\"pict-login-form-area\"></div><div id=\"pict-login-oauth-area\"></div><div id=\"pict-login-status-area\" style=\"display:none\"></div></div>"
		},
		{
			"Hash": "Pict-Login-Template-Form",
			"Template": "<form id=\"pict-login-form\" class=\"pict-login-form\"><label class=\"pict-login-label\" for=\"pict-login-username\">Username</label><input class=\"pict-login-input\" type=\"text\" id=\"pict-login-username\" name=\"username\" autocomplete=\"username\" placeholder=\"Enter username\" /><label class=\"pict-login-label\" for=\"pict-login-password\">Password</label><input class=\"pict-login-input\" type=\"password\" id=\"pict-login-password\" name=\"password\" autocomplete=\"current-password\" placeholder=\"Enter password\" /><button class=\"pict-login-submit\" type=\"submit\">Log In</button></form>"
		},
		{
			"Hash": "Pict-Login-Template-Status",
			"Template": "<div class=\"pict-login-status\"><span class=\"pict-login-dot pict-login-dot--on\"></span><span class=\"pict-login-user-label\">Logged in as <strong id=\"pict-login-display-name\"></strong></span><span class=\"pict-login-user-id\" id=\"pict-login-display-id\"></span><button class=\"pict-login-logout-btn\" id=\"pict-login-logout\" type=\"button\">Log out</button></div>"
		},
		{
			"Hash": "Pict-Login-Template-OAuthProviders",
			"Template": "<div class=\"pict-login-oauth\"><div class=\"pict-login-oauth-divider\"><span>or sign in with</span></div><div class=\"pict-login-oauth-buttons\" id=\"pict-login-oauth-buttons\"></div></div>"
		},
		{
			"Hash": "Pict-Login-Template-Error",
			"Template": "<div class=\"pict-login-error-message\">{~D:Record.Message~}</div>"
		}
	],

	// ----- Renderables -----
	"Renderables":
	[
		{
			"RenderableHash": "Login-Container",
			"TemplateHash": "Pict-Login-Template-Wrapper",
			"DestinationAddress": "#Pict-Login-Container"
		}
	],

	// ----- CSS -----
	"CSS": `.pict-login-card
{
	max-width: 400px;
	margin: 2rem auto;
	background: var(--theme-color-background-panel, #fff);
	border: 1px solid var(--theme-color-border-default, #D4A373);
	border-top: 4px solid var(--theme-color-brand-primary, #E76F51);
	border-radius: 6px;
	padding: 1.5rem;
	box-shadow: 0 2px 8px rgba(38,70,83,0.08);
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
	color: var(--theme-color-text-primary, #264653);
}

/* ----- Form ----- */
.pict-login-form
{
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
}
.pict-login-label
{
	font-weight: 600;
	font-size: 0.85rem;
	color: var(--theme-color-text-primary, #264653);
}
.pict-login-input
{
	border: 1px solid var(--theme-color-border-light, #D4C4A8);
	background: var(--theme-color-background-secondary, #FFFCF7);
	padding: 0.55rem 0.7rem;
	border-radius: 4px;
	font-size: 0.9rem;
	color: var(--theme-color-text-primary, #264653);
	width: 100%;
	box-sizing: border-box;
}
.pict-login-input:focus
{
	outline: none;
	border-color: var(--theme-color-brand-primary, #E76F51);
	box-shadow: 0 0 0 2px rgba(231,111,81,0.15);
}
.pict-login-submit
{
	background: var(--theme-color-brand-primary, #E76F51);
	color: var(--theme-color-text-on-brand, #fff);
	border: none;
	padding: 0.6rem 1.25rem;
	border-radius: 4px;
	font-size: 0.9rem;
	font-weight: 600;
	cursor: pointer;
	margin-top: 0.25rem;
}
.pict-login-submit:hover
{
	background: var(--theme-color-brand-primary-hover, #C45A3E);
}
.pict-login-submit:disabled
{
	opacity: 0.6;
	cursor: not-allowed;
}

/* ----- Error ----- */
.pict-login-error
{
	background: var(--theme-color-background-tertiary, #FDECEA);
	border: 1px solid var(--theme-color-brand-primary, #E76F51);
	color: var(--theme-color-status-error, #8B2500);
	border-radius: 4px;
	padding: 0.6rem 0.8rem;
	font-size: 0.85rem;
	margin-bottom: 0.75rem;
}

/* ----- Logged-In Status ----- */
.pict-login-status
{
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}
.pict-login-dot
{
	width: 10px;
	height: 10px;
	border-radius: 50%;
	flex-shrink: 0;
}
.pict-login-dot--on
{
	background: var(--theme-color-status-success, #2A9D8F);
	box-shadow: 0 0 4px rgba(42,157,143,0.5);
}
.pict-login-dot--off
{
	background: var(--theme-color-text-muted, #999);
}
.pict-login-user-label
{
	font-size: 0.9rem;
}
.pict-login-user-id
{
	background: var(--theme-color-text-primary, #264653);
	color: var(--theme-color-text-on-brand, #FAEDCD);
	font-size: 0.7rem;
	font-weight: 700;
	padding: 0.15rem 0.5rem;
	border-radius: 9999px;
}
.pict-login-logout-btn
{
	margin-left: auto;
	background: var(--theme-color-text-primary, #264653);
	color: var(--theme-color-text-on-brand, #FAEDCD);
	border: none;
	padding: 0.4rem 1rem;
	border-radius: 4px;
	font-size: 0.8rem;
	font-weight: 600;
	cursor: pointer;
}
.pict-login-logout-btn:hover
{
	background: var(--theme-color-text-primary, #1A3340);
}

/* ----- OAuth ----- */
.pict-login-oauth
{
	margin-top: 1rem;
}
.pict-login-oauth-divider
{
	display: flex;
	align-items: center;
	gap: 0.75rem;
	margin-bottom: 0.75rem;
	color: var(--theme-color-text-muted, #999);
	font-size: 0.8rem;
}
.pict-login-oauth-divider::before,
.pict-login-oauth-divider::after
{
	content: '';
	flex: 1;
	height: 1px;
	background: var(--theme-color-border-light, #D4C4A8);
}
.pict-login-oauth-buttons
{
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}
.pict-login-oauth-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	padding: 0.55rem 1rem;
	border-radius: 4px;
	font-size: 0.85rem;
	font-weight: 600;
	cursor: pointer;
	text-decoration: none;
	border: 1px solid var(--theme-color-border-light, #D4C4A8);
	background: var(--theme-color-background-panel, #fff);
	color: var(--theme-color-text-primary, #264653);
}
.pict-login-oauth-btn:hover
{
	background: var(--theme-color-background-secondary, #F5F0E8);
}
.pict-login-oauth-btn--google
{
	border-color: #4285F4;
	color: #4285F4;
}
.pict-login-oauth-btn--google:hover
{
	background: #EBF2FE;
}
.pict-login-oauth-btn--microsoft
{
	border-color: #00A4EF;
	color: #00A4EF;
}
.pict-login-oauth-btn--microsoft:hover
{
	background: #E6F6FE;
}
`
});

},{}],132:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const _DefaultConfiguration = require('./Pict-Section-Login-DefaultConfiguration.js');

class PictSectionLogin extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		// --- State ---
		this.authenticated = false;
		this.sessionData = null;
		this.oauthProviders = [];

		this.initialRenderComplete = false;
	}

	// ===== Lifecycle Hooks =====

	onBeforeInitialize()
	{
		return super.onBeforeInitialize();
	}

	onAfterRender(pRenderable)
	{
		// Inject all registered CSS into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// Populate the form (or status) into the wrapper placeholders
		this._updateView();

		if (this.options.CheckSessionOnLoad)
		{
			this.checkSession();
		}

		if (this.options.ShowOAuthProviders)
		{
			this.loadOAuthProviders();
		}
	}

	// ===== Public API =====

	/**
	 * Authenticate with username and password.
	 *
	 * @param {string} pUsername - The username / login ID
	 * @param {string} pPassword - The password
	 * @param {function} [fCallback] - Optional callback(pError, pSessionData)
	 */
	login(pUsername, pPassword, fCallback)
	{
		if (typeof (fCallback) !== 'function')
		{
			fCallback = () => {};
		}

		this._clearError();

		let tmpFetchOptions = {};
		let tmpURL = this.options.LoginEndpoint;

		if (this.options.LoginMethod === 'GET')
		{
			tmpURL = tmpURL + '/' + encodeURIComponent(pUsername) + '/' + encodeURIComponent(pPassword);
			tmpFetchOptions.method = 'GET';
		}
		else
		{
			tmpFetchOptions.method = 'POST';
			tmpFetchOptions.headers = { 'Content-Type': 'application/json' };
			tmpFetchOptions.body = JSON.stringify({ UserName: pUsername, Password: pPassword });
		}

		fetch(tmpURL, tmpFetchOptions)
			.then((pResponse) =>
			{
				return pResponse.json();
			})
			.then((pData) =>
			{
				if (pData && pData.LoggedIn)
				{
					this.authenticated = true;
					this.sessionData = pData;
					this._storeSessionData(pData);
					this._updateView();
					this.onLoginSuccess(pData);
					this._solveApp();
					return fCallback(null, pData);
				}
				else
				{
					let tmpError = (pData && pData.Error) ? pData.Error : 'Authentication failed.';
					this._displayError(tmpError);
					this.onLoginFailed(tmpError);
					return fCallback(tmpError);
				}
			})
			.catch((pError) =>
			{
				let tmpMessage = 'Login request failed.';
				this.log.error('PictSectionLogin login error: ' + pError.message);
				this._displayError(tmpMessage);
				this.onLoginFailed(tmpMessage);
				return fCallback(tmpMessage);
			});
	}

	/**
	 * End the current session.
	 *
	 * @param {function} [fCallback] - Optional callback(pError)
	 */
	logout(fCallback)
	{
		if (typeof (fCallback) !== 'function')
		{
			fCallback = () => {};
		}

		fetch(this.options.LogoutEndpoint)
			.then((pResponse) =>
			{
				return pResponse.json();
			})
			.then(() =>
			{
				this.authenticated = false;
				this.sessionData = null;
				this._storeSessionData(null);
				this._updateView();
				this.onLogout();
				this._solveApp();
				return fCallback(null);
			})
			.catch((pError) =>
			{
				this.log.error('PictSectionLogin logout error: ' + pError.message);
				// Clear local state even if network failed
				this.authenticated = false;
				this.sessionData = null;
				this._storeSessionData(null);
				this._updateView();
				this.onLogout();
				this._solveApp();
				return fCallback(pError.message);
			});
	}

	/**
	 * Check whether an existing session is active (e.g. from a cookie).
	 *
	 * @param {function} [fCallback] - Optional callback(pError, pSessionData)
	 */
	checkSession(fCallback)
	{
		if (typeof (fCallback) !== 'function')
		{
			fCallback = () => {};
		}

		fetch(this.options.CheckSessionEndpoint)
			.then((pResponse) =>
			{
				return pResponse.json();
			})
			.then((pData) =>
			{
				if (pData && pData.LoggedIn)
				{
					this.authenticated = true;
					this.sessionData = pData;
					this._storeSessionData(pData);
					this._updateView();
				}
				this.onSessionChecked(pData);
				this._solveApp();
				return fCallback(null, pData);
			})
			.catch((pError) =>
			{
				this.log.error('PictSectionLogin checkSession error: ' + pError.message);
				this.onSessionChecked(null);
				return fCallback(pError.message);
			});
	}

	/**
	 * Fetch available OAuth providers and render buttons.
	 *
	 * @param {function} [fCallback] - Optional callback(pError, pProviders)
	 */
	loadOAuthProviders(fCallback)
	{
		if (typeof (fCallback) !== 'function')
		{
			fCallback = () => {};
		}

		fetch(this.options.OAuthProvidersEndpoint)
			.then((pResponse) =>
			{
				return pResponse.json();
			})
			.then((pData) =>
			{
				if (pData && Array.isArray(pData.Providers))
				{
					this.oauthProviders = pData.Providers;
					this._renderOAuthButtons();
				}
				return fCallback(null, this.oauthProviders);
			})
			.catch((pError) =>
			{
				this.log.warn('PictSectionLogin loadOAuthProviders: ' + pError.message);
				return fCallback(pError.message);
			});
	}

	// ===== Overridable Hooks =====
	// Developers override these for custom post-login/logout behavior.

	/**
	 * Called after a successful login.
	 * @param {object} pSessionData - The session data from the server
	 */
	onLoginSuccess(pSessionData)
	{
		// Override in subclass or instance
	}

	/**
	 * Called after a failed login attempt.
	 * @param {string} pError - The error message
	 */
	onLoginFailed(pError)
	{
		// Override in subclass or instance
	}

	/**
	 * Called after a successful logout.
	 */
	onLogout()
	{
		// Override in subclass or instance
	}

	/**
	 * Called after a session check completes.
	 * @param {object|null} pSessionData - The session data, or null on error
	 */
	onSessionChecked(pSessionData)
	{
		// Override in subclass or instance
	}

	// ===== Internal Helpers =====

	/**
	 * Wire up DOM event handlers on the login form and logout button.
	 */
	_wireFormEvents()
	{
		let tmpFormElements = this.services.ContentAssignment.getElement('#pict-login-form');
		if (tmpFormElements && tmpFormElements.length > 0)
		{
			let tmpForm = tmpFormElements[0];
			tmpForm.addEventListener('submit', (pEvent) =>
			{
				pEvent.preventDefault();
				let tmpUsernameInput = tmpForm.querySelector('#pict-login-username');
				let tmpPasswordInput = tmpForm.querySelector('#pict-login-password');

				let tmpUsername = tmpUsernameInput ? tmpUsernameInput.value : '';
				let tmpPassword = tmpPasswordInput ? tmpPasswordInput.value : '';

				if (!tmpUsername)
				{
					this._displayError('Please enter a username.');
					return;
				}

				this.login(tmpUsername, tmpPassword);
			});
		}

		let tmpLogoutElements = this.services.ContentAssignment.getElement('#pict-login-logout');
		if (tmpLogoutElements && tmpLogoutElements.length > 0)
		{
			tmpLogoutElements[0].addEventListener('click', () =>
			{
				this.logout();
			});
		}
	}

	/**
	 * Show an error message in the error area.
	 * @param {string} pMessage - The error text
	 */
	_displayError(pMessage)
	{
		let tmpErrorElements = this.services.ContentAssignment.getElement('#pict-login-error');
		if (tmpErrorElements && tmpErrorElements.length > 0)
		{
			let tmpErrorEl = tmpErrorElements[0];
			tmpErrorEl.textContent = pMessage;
			tmpErrorEl.style.display = 'block';
		}
	}

	/**
	 * Hide the error area.
	 */
	_clearError()
	{
		let tmpErrorElements = this.services.ContentAssignment.getElement('#pict-login-error');
		if (tmpErrorElements && tmpErrorElements.length > 0)
		{
			let tmpErrorEl = tmpErrorElements[0];
			tmpErrorEl.textContent = '';
			tmpErrorEl.style.display = 'none';
		}
	}

	/**
	 * Re-render the view to reflect current authentication state.
	 * Shows the login form when unauthenticated, or the status bar when authenticated.
	 */
	_updateView()
	{
		let tmpFormAreaElements = this.services.ContentAssignment.getElement('#pict-login-form-area');
		let tmpStatusAreaElements = this.services.ContentAssignment.getElement('#pict-login-status-area');
		let tmpOAuthAreaElements = this.services.ContentAssignment.getElement('#pict-login-oauth-area');

		if (this.authenticated && this.sessionData)
		{
			// --- Authenticated: show status, hide form ---
			if (tmpFormAreaElements && tmpFormAreaElements.length > 0)
			{
				tmpFormAreaElements[0].style.display = 'none';
			}
			if (tmpOAuthAreaElements && tmpOAuthAreaElements.length > 0)
			{
				tmpOAuthAreaElements[0].style.display = 'none';
			}
			if (tmpStatusAreaElements && tmpStatusAreaElements.length > 0)
			{
				let tmpStatusArea = tmpStatusAreaElements[0];
				tmpStatusArea.style.display = 'block';

				// Render the status template
				let tmpStatusHTML = this.pict.parseTemplateByHash('Pict-Login-Template-Status', {});
				tmpStatusArea.innerHTML = tmpStatusHTML;

				// Populate display values
				let tmpDisplayName = '';
				let tmpDisplayID = '';

				if (this.sessionData.UserRecord)
				{
					tmpDisplayName = this.sessionData.UserRecord.FullName
						|| this.sessionData.UserRecord.LoginID
						|| this.sessionData.UserRecord.Email
						|| '';
					tmpDisplayID = this.sessionData.UserRecord.IDUser || this.sessionData.UserID || '';
				}
				else if (this.sessionData.UserID)
				{
					tmpDisplayID = this.sessionData.UserID;
				}

				let tmpNameElements = tmpStatusArea.querySelectorAll('#pict-login-display-name');
				if (tmpNameElements.length > 0)
				{
					tmpNameElements[0].textContent = tmpDisplayName;
				}

				let tmpIDElements = tmpStatusArea.querySelectorAll('#pict-login-display-id');
				if (tmpIDElements.length > 0)
				{
					if (tmpDisplayID)
					{
						tmpIDElements[0].textContent = 'ID ' + tmpDisplayID;
					}
					else
					{
						tmpIDElements[0].style.display = 'none';
					}
				}

				// Wire logout button
				let tmpLogoutBtn = tmpStatusArea.querySelector('#pict-login-logout');
				if (tmpLogoutBtn)
				{
					tmpLogoutBtn.addEventListener('click', () =>
					{
						this.logout();
					});
				}
			}
			this._clearError();
		}
		else
		{
			// --- Unauthenticated: show form, hide status ---
			if (tmpStatusAreaElements && tmpStatusAreaElements.length > 0)
			{
				tmpStatusAreaElements[0].style.display = 'none';
				tmpStatusAreaElements[0].innerHTML = '';
			}
			if (tmpFormAreaElements && tmpFormAreaElements.length > 0)
			{
				let tmpFormArea = tmpFormAreaElements[0];
				tmpFormArea.style.display = 'block';

				// Re-render form if empty
				if (!tmpFormArea.querySelector('#pict-login-form'))
				{
					let tmpFormHTML = this.pict.parseTemplateByHash('Pict-Login-Template-Form', {});
					tmpFormArea.innerHTML = tmpFormHTML;
					this._wireFormEvents();
				}
			}
			if (tmpOAuthAreaElements && tmpOAuthAreaElements.length > 0)
			{
				if (this.options.ShowOAuthProviders && this.oauthProviders.length > 0)
				{
					tmpOAuthAreaElements[0].style.display = 'block';
				}
				else
				{
					tmpOAuthAreaElements[0].style.display = 'none';
				}
			}
		}
	}

	/**
	 * Render OAuth provider buttons into the OAuth area.
	 */
	_renderOAuthButtons()
	{
		let tmpOAuthAreaElements = this.services.ContentAssignment.getElement('#pict-login-oauth-area');
		if (!tmpOAuthAreaElements || tmpOAuthAreaElements.length < 1)
		{
			return;
		}

		if (!this.oauthProviders || this.oauthProviders.length < 1)
		{
			tmpOAuthAreaElements[0].style.display = 'none';
			return;
		}

		// Render the OAuth container template
		let tmpOAuthHTML = this.pict.parseTemplateByHash('Pict-Login-Template-OAuthProviders', {});
		tmpOAuthAreaElements[0].innerHTML = tmpOAuthHTML;
		tmpOAuthAreaElements[0].style.display = 'block';

		// Build individual provider buttons
		let tmpButtonContainer = tmpOAuthAreaElements[0].querySelector('#pict-login-oauth-buttons');
		if (!tmpButtonContainer)
		{
			return;
		}

		let tmpButtonsHTML = '';
		for (let i = 0; i < this.oauthProviders.length; i++)
		{
			let tmpProvider = this.oauthProviders[i];
			let tmpName = tmpProvider.Name || 'provider';
			let tmpBeginURL = tmpProvider.BeginURL || (this.options.OAuthBeginEndpoint + '/' + tmpName);
			let tmpDisplayName = tmpName.charAt(0).toUpperCase() + tmpName.slice(1);
			let tmpCSSModifier = tmpName.toLowerCase();

			tmpButtonsHTML += '<a class="pict-login-oauth-btn pict-login-oauth-btn--' + tmpCSSModifier + '" href="' + tmpBeginURL + '">Sign in with ' + tmpDisplayName + '</a>';
		}

		tmpButtonContainer.innerHTML = tmpButtonsHTML;
	}

	/**
	 * Store session data at the configured Pict address.
	 * @param {object|null} pData - Session data to store
	 */
	_storeSessionData(pData)
	{
		if (this.options.SessionDataAddress)
		{
			let tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.pict.AppData,
				Bundle: this.pict.Bundle
			};
			this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.SessionDataAddress, pData);
		}
	}

	/**
	 * Trigger a solve on the PictApplication if one exists.
	 */
	_solveApp()
	{
		if (this.pict && this.pict.PictApplication && typeof (this.pict.PictApplication.solve) === 'function')
		{
			this.pict.PictApplication.solve();
		}
	}
}

module.exports = PictSectionLogin;

module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-Section-Login-DefaultConfiguration.js":131,"pict-view":239}],133:[function(require,module,exports){
// The container for all the Pict-Section-Content related code.

// The main content view class
module.exports = require('./views/Pict-View-Content.js');

// The content provider (markdown parsing, HTML escaping)
module.exports.PictContentProvider = require('./providers/Pict-Provider-Content.js');

// A thin demo view that auto-registers the provider, reads markdown
// from an AppData address, and pushes parsed HTML through the base
// view's displayContent pipeline.  Used by the docuserve playground;
// host applications can pick it up too if they just want "render this
// markdown blob" without writing the parse-and-display glue.
module.exports.PictContentDemoView = require('./views/PictView-Content-Demo.js');

},{"./providers/Pict-Provider-Content.js":134,"./views/Pict-View-Content.js":135,"./views/PictView-Content-Demo.js":136}],134:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libCreateHighlighter = require('pict-section-code').createHighlighter;

/**
 * Content Provider for Pict Section Content
 *
 * A general-purpose markdown-to-HTML parser with support for:
 * - Headings, paragraphs, lists, blockquotes, horizontal rules
 * - Fenced code blocks with language tags (nested fence support)
 * - Syntax highlighting and line numbers for code blocks (via pict-section-code)
 * - Tables (GFM pipe syntax)
 * - Mermaid diagram blocks
 * - KaTeX math (inline and display)
 * - Bold, italic, inline code, links, images
 *
 * Link resolution is customizable via an optional callback.
 */
class PictContentProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Highlight a code string using pict-section-code's syntax highlighter.
	 * Uses a mock element to interface with the highlighter's DOM-based API.
	 *
	 * @param {string} pCode - The raw code string
	 * @param {string} pLanguage - The language identifier (e.g. "javascript", "html")
	 * @returns {string} The syntax-highlighted HTML
	 */
	highlightCode(pCode, pLanguage)
	{
		if (!pCode)
		{
			return '';
		}

		let tmpHighlighter = libCreateHighlighter(pLanguage);
		// Create a mock element to interface with the highlighter
		let tmpMockElement = { textContent: pCode, innerHTML: '' };
		tmpHighlighter(tmpMockElement);
		return tmpMockElement.innerHTML;
	}

	/**
	 * Generate line number HTML for a code block.
	 *
	 * @param {string} pCode - The raw code string
	 * @returns {string} HTML string with line number spans
	 */
	generateLineNumbers(pCode)
	{
		if (!pCode)
		{
			return '<span>1</span>';
		}

		let tmpLineCount = pCode.split('\n').length;
		let tmpHTML = '';

		for (let i = 1; i <= tmpLineCount; i++)
		{
			tmpHTML += '<span>' + i + '</span>';
		}

		return tmpHTML;
	}

	/**
	 * Parse a markdown string into HTML.
	 *
	 * @param {string} pMarkdown - The raw markdown text
	 * @param {Function} [pLinkResolver] - Optional callback for link resolution: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback for image URL resolution: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. Passed through to parseInline() for vocabulary term auto-linking.
	 * @returns {string} The parsed HTML
	 */
	parseMarkdown(pMarkdown, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pMarkdown)
		{
			return '';
		}

		let tmpLines = pMarkdown.split('\n');
		let tmpHTML = [];
		let tmpInCodeBlock = false;
		let tmpCodeFenceLength = 0;
		let tmpCodeLang = '';
		let tmpCodeLines = [];
		let tmpInList = false;
		let tmpListType = '';
		let tmpInBlockquote = false;
		let tmpBlockquoteLines = [];
		let tmpInMathBlock = false;
		let tmpMathLines = [];
		let tmpParagraphLines = [];

		// Helper to flush accumulated paragraph lines into a single <p> tag
		let fFlushParagraph = () =>
		{
			if (tmpParagraphLines.length > 0)
			{
				tmpHTML.push('<p>' + tmpParagraphLines.map((pLine) => { return this.parseInline(pLine, pLinkResolver, pImageResolver, pVocabularyResolver); }).join(' ') + '</p>');
				tmpParagraphLines = [];
			}
		};

		for (let i = 0; i < tmpLines.length; i++)
		{
			let tmpLine = tmpLines[i];

			// Display math blocks ($$...$$) — skip if inside a code block
			if (!tmpInCodeBlock && tmpLine.trim().match(/^\$\$/))
			{
				if (tmpInMathBlock)
				{
					// End math block
					tmpHTML.push('<div class="pict-content-katex-display">' + tmpMathLines.join('\n') + '</div>');
					tmpInMathBlock = false;
					tmpMathLines = [];
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					tmpInMathBlock = true;
				}
				continue;
			}

			if (tmpInMathBlock)
			{
				tmpMathLines.push(tmpLine);
				continue;
			}

			// Code blocks (fenced) — track fence length so ````x```` nests around ```y```
			let tmpFenceMatch = tmpLine.match(/^(`{3,})/);
			if (tmpFenceMatch)
			{
				let tmpFenceLen = tmpFenceMatch[1].length;

				if (tmpInCodeBlock)
				{
					// Only close if the closing fence is at least as long as the opening
					if (tmpFenceLen >= tmpCodeFenceLength && tmpLine.trim() === tmpFenceMatch[1])
					{
						// End code block
						if (tmpCodeLang === 'mermaid')
						{
							// Mermaid diagrams: output raw content for client-side rendering
							tmpHTML.push('<pre class="mermaid">' + tmpCodeLines.join('\n') + '</pre>');
						}
						else if (tmpCodeLang === 'excalidraw')
						{
							// Excalidraw scenes: emit a placeholder div with the
							// scene JSON URI-component encoded into a data
							// attribute.  Pict-View-Content's
							// renderExcalidrawDiagrams() swaps these for rendered
							// SVGs once the wrapper bundle is ready.  We don't
							// validate the JSON here — invalid fences just stay
							// as the loading placeholder until the runtime
							// reports the error.
							let tmpRawScene = tmpCodeLines.join('\n');
							let tmpEncoded;
							try { tmpEncoded = encodeURIComponent(tmpRawScene); }
							catch (pErr) { tmpEncoded = ''; }
							tmpHTML.push('<div class="pict-excalidraw-fence" data-scene="' + tmpEncoded + '">' +
								'<div class="pict-excalidraw-fence-loading">Rendering Excalidraw diagram…</div>' +
								'</div>');
						}
						else
						{
							let tmpCodeText = tmpCodeLines.join('\n');
						let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
						let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
						tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code class="language-' + this.escapeHTML(tmpCodeLang) + '">' + tmpHighlightedCode + '</code></pre></div>');
						}
						tmpInCodeBlock = false;
						tmpCodeFenceLength = 0;
						tmpCodeLang = '';
						tmpCodeLines = [];
						continue;
					}
					else
					{
						// Inner fence with fewer backticks — treat as content
						tmpCodeLines.push(tmpLine);
						continue;
					}
				}
				else
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list or blockquote
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					if (tmpInBlockquote)
					{
						tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
						tmpInBlockquote = false;
						tmpBlockquoteLines = [];
					}
					// Start code block — record fence length
					tmpCodeFenceLength = tmpFenceLen;
					tmpCodeLang = tmpLine.replace(/^`{3,}/, '').trim();
					tmpInCodeBlock = true;
					continue;
				}
			}

			if (tmpInCodeBlock)
			{
				tmpCodeLines.push(tmpLine);
				continue;
			}

			// Blockquotes
			if (tmpLine.match(/^>\s?/))
			{
				if (!tmpInBlockquote)
				{
					// Flush any pending paragraph
					fFlushParagraph();
					// Close any open list
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
						tmpInList = false;
					}
					tmpInBlockquote = true;
					tmpBlockquoteLines = [];
				}
				tmpBlockquoteLines.push(tmpLine.replace(/^>\s?/, ''));
				continue;
			}
			else if (tmpInBlockquote)
			{
				tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
				tmpInBlockquote = false;
				tmpBlockquoteLines = [];
			}

			// Horizontal rule
			if (tmpLine.match(/^(-{3,}|\*{3,}|_{3,})\s*$/))
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				tmpHTML.push('<hr>');
				continue;
			}

			// Headings
			let tmpHeadingMatch = tmpLine.match(/^(#{1,6})\s+(.+)/);
			if (tmpHeadingMatch)
			{
				fFlushParagraph();
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}
				let tmpLevel = tmpHeadingMatch[1].length;
				let tmpText = this.parseInline(tmpHeadingMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver);
				let tmpID = tmpHeadingMatch[2].toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
				tmpHTML.push('<h' + tmpLevel + ' id="' + tmpID + '">' + tmpText + '</h' + tmpLevel + '>');
				continue;
			}

			// Unordered list items
			let tmpULMatch = tmpLine.match(/^(\s*)[-*+]\s+(.*)/);
			if (tmpULMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ul')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ul>');
					tmpInList = true;
					tmpListType = 'ul';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpULMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Ordered list items
			let tmpOLMatch = tmpLine.match(/^(\s*)\d+\.\s+(.*)/);
			if (tmpOLMatch)
			{
				fFlushParagraph();
				if (!tmpInList || tmpListType !== 'ol')
				{
					if (tmpInList)
					{
						tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					}
					tmpHTML.push('<ol>');
					tmpInList = true;
					tmpListType = 'ol';
				}
				tmpHTML.push('<li>' + this.parseInline(tmpOLMatch[2], pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>');
				continue;
			}

			// Indented continuation line of a wrapped list item — fold its
			// content into the last <li> instead of closing the list. Closing
			// here would split a real <ol>/<ul>, and each fragment restarts
			// ordered numbering. A non-indented non-marker line still closes
			// the list (handled below); blank lines never reach this branch.
			if (tmpInList && tmpLine.match(/^\s+\S/) && tmpHTML.length > 0 && tmpHTML[tmpHTML.length - 1].endsWith('</li>'))
			{
				let tmpLastIndex = tmpHTML.length - 1;
				let tmpListItemBody = tmpHTML[tmpLastIndex].slice(0, -'</li>'.length);
				tmpHTML[tmpLastIndex] = tmpListItemBody + ' ' + this.parseInline(tmpLine.trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</li>';
				continue;
			}

			// Close list if we've left list items
			if (tmpInList && tmpLine.trim() !== '')
			{
				tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
				tmpInList = false;
			}

			// Empty line — flush any accumulated paragraph
			if (tmpLine.trim() === '')
			{
				fFlushParagraph();
				continue;
			}

			// Table detection
			if (tmpLine.match(/^\|/) && i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|[\s-:|]+\|/))
			{
				fFlushParagraph();
				// Close any open list
				if (tmpInList)
				{
					tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
					tmpInList = false;
				}

				let tmpTableHTML = '<table>';

				// Header row
				let tmpHeaders = tmpLine.split('|').filter((pCell) => { return pCell.trim() !== ''; });
				tmpTableHTML += '<thead><tr>';
				for (let h = 0; h < tmpHeaders.length; h++)
				{
					tmpTableHTML += '<th>' + this.parseInline(tmpHeaders[h].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</th>';
				}
				tmpTableHTML += '</tr></thead>';

				// Skip separator row
				i++;

				// Body rows
				tmpTableHTML += '<tbody>';
				while (i + 1 < tmpLines.length && tmpLines[i + 1].match(/^\|/))
				{
					i++;
					let tmpCells = tmpLines[i].split('|').filter((pCell) => { return pCell.trim() !== ''; });
					tmpTableHTML += '<tr>';
					for (let c = 0; c < tmpCells.length; c++)
					{
						tmpTableHTML += '<td>' + this.parseInline(tmpCells[c].trim(), pLinkResolver, pImageResolver, pVocabularyResolver) + '</td>';
					}
					tmpTableHTML += '</tr>';
				}
				tmpTableHTML += '</tbody></table>';
				tmpHTML.push(tmpTableHTML);
				continue;
			}

			// Accumulate paragraph lines — consecutive non-blank text lines
			// will be joined into a single <p> tag when flushed
			tmpParagraphLines.push(tmpLine);
		}

		// Flush any remaining accumulated paragraph
		fFlushParagraph();

		// Close any trailing open elements
		if (tmpInList)
		{
			tmpHTML.push(tmpListType === 'ul' ? '</ul>' : '</ol>');
		}
		if (tmpInBlockquote)
		{
			tmpHTML.push('<blockquote>' + this.parseMarkdown(tmpBlockquoteLines.join('\n'), pLinkResolver, pImageResolver, pVocabularyResolver) + '</blockquote>');
		}
		if (tmpInCodeBlock)
		{
			let tmpCodeText = tmpCodeLines.join('\n');
			let tmpHighlightedCode = this.highlightCode(tmpCodeText, tmpCodeLang);
			let tmpLineNumbersHTML = this.generateLineNumbers(tmpCodeText);
			tmpHTML.push('<div class="pict-content-code-wrap"><div class="pict-content-code-line-numbers">' + tmpLineNumbersHTML + '</div><pre><code>' + tmpHighlightedCode + '</code></pre></div>');
		}

		return tmpHTML.join('\n');
	}

	/**
	 * Parse inline markdown elements (bold, italic, code, links, images, KaTeX).
	 *
	 * @param {string} pText - The text to parse
	 * @param {Function} [pLinkResolver] - Optional callback: (pHref, pLinkText) => { href, target, rel } or null
	 * @param {Function} [pImageResolver] - Optional callback: (pSrc, pAlt) => resolvedSrc or null
	 * @param {Function} [pVocabularyResolver] - Optional callback: (pWord) => { slug, title, short } or null. When provided, known vocabulary terms in the rendered text are wrapped in <span class="pict-vocab-term"> with data attributes carrying the popover content.
	 * @returns {string} HTML with inline elements
	 */
	parseInline(pText, pLinkResolver, pImageResolver, pVocabularyResolver)
	{
		if (!pText)
		{
			return '';
		}

		let tmpResult = pText;

		// Extract inline code spans into placeholders so bold/italic regexes don't mangle their contents
		let tmpCodeSpans = [];
		tmpResult = tmpResult.replace(/`([^`]+)`/g, (pMatch, pCode) =>
		{
			let tmpIndex = tmpCodeSpans.length;
			tmpCodeSpans.push('<code>' + pCode + '</code>');
			return '\x00CODEINLINE' + tmpIndex + '\x00';
		});

		// Inline LaTeX equations ($...$) — must be processed before other inline patterns
		// Match single $ delimiters that aren't adjacent to spaces (to avoid false positives with currency)
		tmpResult = tmpResult.replace(/\$([^\$\s][^\$]*?[^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');
		// Also match single-character inline math like $x$
		tmpResult = tmpResult.replace(/\$([^\$\s])\$/g, '<span class="pict-content-katex-inline">$1</span>');

		// Images
		tmpResult = tmpResult.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (pMatch, pAlt, pSrc) =>
		{
			let tmpSrc = pSrc;
			if (typeof pImageResolver === 'function')
			{
				let tmpResolved = pImageResolver(pSrc, pAlt);
				if (tmpResolved)
				{
					tmpSrc = tmpResolved;
				}
			}
			return '<img src="' + tmpSrc + '" alt="' + pAlt + '">';
		});

		// Links
		tmpResult = tmpResult.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (pMatch, pLinkText, pHref) =>
		{
			if (typeof pLinkResolver === 'function')
			{
				let tmpResolved = pLinkResolver(pHref, pLinkText);
				if (tmpResolved)
				{
					let tmpTarget = tmpResolved.target ? ' target="' + tmpResolved.target + '"' : '';
					let tmpRel = tmpResolved.rel ? ' rel="' + tmpResolved.rel + '"' : '';
					return '<a href="' + tmpResolved.href + '"' + tmpTarget + tmpRel + '>' + pLinkText + '</a>';
				}
			}
			// Default behavior: external links open in new tab
			if (pHref.match(/^https?:\/\//))
			{
				return '<a href="' + pHref + '" target="_blank" rel="noopener">' + pLinkText + '</a>';
			}
			return '<a href="' + pHref + '">' + pLinkText + '</a>';
		});

		// Bold
		tmpResult = tmpResult.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
		// Underscore strong only at word boundaries (CommonMark intraword rule) so
		// identifiers / URLs like a__b or foo__bar aren't treated as emphasis.
		tmpResult = tmpResult.replace(/(^|[^A-Za-z0-9_])__([^_]+?)__(?![A-Za-z0-9_])/g, '$1<strong>$2</strong>');

		// Italic
		tmpResult = tmpResult.replace(/\*([^*]+)\*/g, '<em>$1</em>');
		// Underscore italic only at word boundaries — a single underscore inside a
		// word or a URL (e.g. hello_world in a link href) must NOT become <em>.
		tmpResult = tmpResult.replace(/(^|[^A-Za-z0-9_])_([^_]+?)_(?![A-Za-z0-9_])/g, '$1<em>$2</em>');

		// Restore inline code spans from placeholders
		tmpResult = tmpResult.replace(/\x00CODEINLINE(\d+)\x00/g, (pMatch, pIndex) =>
		{
			return tmpCodeSpans[parseInt(pIndex)];
		});

		// Vocabulary term auto-linking: scan the rendered text for
		// known vocabulary terms and wrap each first occurrence in a
		// span with data attributes for the popover system. Skips
		// content inside <code>, <a>, <pre>, and <strong> tags to
		// avoid mangling links, code, or already-emphasized text.
		if (typeof pVocabularyResolver === 'function')
		{
			tmpResult = this._applyVocabularyLinks(tmpResult, pVocabularyResolver);
		}

		return tmpResult;
	}

	/**
	 * Scan HTML for vocabulary terms and wrap the first occurrence
	 * of each in a <span class="pict-vocab-term"> element. The
	 * resolver callback is called for each candidate word/phrase
	 * and returns { slug, title, short } if it's a known term.
	 *
	 * Skips content inside HTML tags to avoid breaking links,
	 * code spans, and other markup.
	 *
	 * @param {string} pHTML
	 * @param {Function} pResolver - (word) => {slug, title, short} | null
	 * @returns {string}
	 */
	_applyVocabularyLinks(pHTML, pResolver)
	{
		if (!pHTML || typeof pResolver !== 'function')
		{
			return pHTML;
		}

		// Track which terms we've already linked to avoid duplicate
		// links for the same term appearing multiple times.
		let tmpLinked = {};

		// Split the HTML into segments: tags vs text nodes. We only
		// scan text nodes for vocabulary terms; tags pass through.
		// This regex captures HTML tags as separators.
		let tmpParts = pHTML.split(/(<[^>]+>)/g);

		// Track whether we're inside a tag that should be skipped
		let tmpSkipDepth = 0;
		let tmpSkipTags = ['code', 'a', 'pre', 'span'];

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPart = tmpParts[i];

			// Check if this is an HTML tag
			if (tmpPart.charAt(0) === '<')
			{
				// Opening tag?
				let tmpOpenMatch = tmpPart.match(/^<(\w+)/);
				if (tmpOpenMatch && tmpSkipTags.indexOf(tmpOpenMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth++;
				}
				// Closing tag?
				let tmpCloseMatch = tmpPart.match(/^<\/(\w+)/);
				if (tmpCloseMatch && tmpSkipTags.indexOf(tmpCloseMatch[1].toLowerCase()) !== -1)
				{
					tmpSkipDepth = Math.max(0, tmpSkipDepth - 1);
				}
				continue; // Don't modify tags
			}

			// Skip text inside protected elements
			if (tmpSkipDepth > 0) continue;

			// Scan this text node for vocabulary terms. Use word
			// boundary regex to match whole words only.
			tmpParts[i] = tmpPart.replace(/\b([A-Za-z][A-Za-z0-9_-]{1,30})\b/g, (pMatch, pWord) =>
			{
				// Skip very short words and common English words
				if (pWord.length < 3) return pMatch;

				let tmpLower = pWord.toLowerCase();
				if (tmpLinked[tmpLower]) return pMatch; // already linked

				let tmpResult = pResolver(tmpLower);
				if (!tmpResult) return pMatch;

				tmpLinked[tmpLower] = true;
				let tmpShortEsc = (tmpResult.short || '').replace(/"/g, '&quot;');
				return '<span class="pict-vocab-term" data-vocab-slug="' + tmpResult.slug +
					'" data-vocab-title="' + (tmpResult.title || '').replace(/"/g, '&quot;') +
					'" data-vocab-short="' + tmpShortEsc + '">' + pMatch + '</span>';
			});
		}

		return tmpParts.join('');
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}
}

module.exports = PictContentProvider;

module.exports.default_configuration =
{
	ProviderIdentifier: "Pict-Content",

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
};

},{"pict-provider":19,"pict-section-code":23}],135:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.pict-content {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
		}
		.pict-content-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 200px;
			color: var(--theme-color-text-muted, #8A7F72);
			font-size: 1em;
		}
		.pict-content h1 {
			font-size: 2em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding-bottom: 0.3em;
			margin-top: 0;
		}
		.pict-content h2 {
			font-size: 1.5em;
			color: var(--theme-color-text-primary, #3D3229);
			border-bottom: 1px solid var(--theme-color-border-light, #EAE3D8);
			padding-bottom: 0.25em;
			margin-top: 1.5em;
		}
		.pict-content h3 {
			font-size: 1.25em;
			color: var(--theme-color-text-primary, #3D3229);
			margin-top: 1.25em;
		}
		.pict-content h4, .pict-content h5, .pict-content h6 {
			color: var(--theme-color-text-secondary, #5E5549);
			margin-top: 1em;
		}
		.pict-content p {
			line-height: 1.7;
			color: var(--theme-color-text-primary, #423D37);
			margin: 0.75em 0;
		}
		.pict-content a {
			color: var(--theme-color-brand-primary, #2E7D74);
			text-decoration: none;
		}
		.pict-content a:hover {
			text-decoration: underline;
		}
		/* ─── Code blocks ─────────────────────────────────────
		   Background, text color, line-number gutter, and every
		   syntax token route through pict-provider-theme tokens —
		   the same set pict-section-code (the live editor) uses.
		   This way the rendered-preview code blocks look identical
		   to the live editor and re-skin together when the theme
		   switches.  Previous version used the text-primary token
		   as the code background (a TEXT token used as BACKGROUND),
		   which broke in dark mode and any palette where text and
		   background-tertiary diverge.
		*/
		.pict-content pre {
			background:    var(--theme-color-background-tertiary, #F0ECE4);
			color:         var(--theme-color-text-primary,        #3D3229);
			border:        1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 1.25em;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.9em;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
		}
		/* Inline code (single backtick) — slightly differentiated
		   from block code so it doesn't disappear into prose. */
		.pict-content code {
			background:    var(--theme-color-background-secondary, #FAF8F4);
			color:         var(--theme-color-text-primary,         #3D3229);
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
		}
		.pict-content-code-wrap {
			display: flex;
			flex-direction: row;
			font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
			font-size: 14px;
			line-height: 1.5;
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			overflow: hidden;
			margin: 1em 0;
			background: var(--theme-color-background-tertiary, #F0ECE4);
		}
		.pict-content-code-wrap .pict-content-code-line-numbers {
			width: 40px;
			min-width: 40px;
			padding: 1.25em 0;
			text-align: right;
			background:    var(--theme-color-background-secondary, #FAF8F4);
			border-right:  1px solid var(--theme-color-border-default, #DDD6CA);
			color:         var(--theme-color-text-muted,           #8A7F72);
			font-family: inherit;
			font-size: inherit;
			line-height: inherit;
			user-select: none;
			pointer-events: none;
			box-sizing: border-box;
		}
		.pict-content-code-wrap .pict-content-code-line-numbers span {
			display: block;
			padding: 0 8px 0 0;
		}
		.pict-content-code-wrap pre {
			margin: 0;
			background: var(--theme-color-background-tertiary, #F0ECE4);
			color:      var(--theme-color-text-primary,        #3D3229);
			border: none;
			padding: 1.25em 1.25em 1.25em 8px;
			border-radius: 0 6px 6px 0;
			overflow-x: auto;
			line-height: 1.5;
			font-size: inherit;
			flex: 1;
			min-width: 0;
		}
		.pict-content-code-wrap pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
			font-family: inherit;
		}
		/* Syntax token colors — every class binds to a --theme-color-syntax-*
		   variable, the same tokens pict-section-code (the live editor) uses.
		   Each var() carries an Atom One Light hex as fallback for hosts
		   without a theme provider; themes that DO ship syntax tokens
		   (pict-default, retold-content-system, etc.) drive everything
		   coherently. */
		.pict-content-code-wrap .keyword       { color: var(--theme-color-syntax-keyword,     #A626A4); }
		.pict-content-code-wrap .string        { color: var(--theme-color-syntax-string,      #50A14F); }
		.pict-content-code-wrap .number        { color: var(--theme-color-syntax-number,      #986801); }
		.pict-content-code-wrap .comment       { color: var(--theme-color-syntax-comment,     #A0A1A7); font-style: italic; }
		.pict-content-code-wrap .operator      { color: var(--theme-color-syntax-operator,    #0184BC); }
		.pict-content-code-wrap .punctuation   { color: var(--theme-color-syntax-punctuation, #383A42); }
		.pict-content-code-wrap .function-name { color: var(--theme-color-syntax-function,    #4078F2); }
		.pict-content-code-wrap .property      { color: var(--theme-color-syntax-property,    #E45649); }
		.pict-content-code-wrap .tag           { color: var(--theme-color-syntax-tag,         #E45649); }
		.pict-content-code-wrap .attr-name     { color: var(--theme-color-syntax-attrname,    #986801); }
		.pict-content-code-wrap .attr-value    { color: var(--theme-color-syntax-attrvalue,   #50A14F); }
		.pict-content-code-wrap .builtin       { color: var(--theme-color-syntax-builtin,     #986801); }
		.pict-content-code-wrap .type          { color: var(--theme-color-syntax-type,        #C18401); }
		.pict-content-code-wrap .variable      { color: var(--theme-color-syntax-variable,    #383A42); }
		.pict-content pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.pict-content blockquote {
			border-left: 4px solid var(--theme-color-brand-primary, #2E7D74);
			margin: 1em 0;
			padding: 0.5em 1em;
			background: var(--theme-color-background-secondary, #F7F5F0);
			color: var(--theme-color-text-secondary, #5E5549);
		}
		.pict-content blockquote p {
			margin: 0.25em 0;
		}
		.pict-content ul, .pict-content ol {
			padding-left: 2em;
			line-height: 1.8;
		}
		.pict-content li {
			margin: 0.25em 0;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content hr {
			border: none;
			border-top: 1px solid var(--theme-color-border-default, #DDD6CA);
			margin: 2em 0;
		}
		.pict-content table {
			width: 100%;
			border-collapse: collapse;
			margin: 1em 0;
		}
		.pict-content table th {
			background: var(--theme-color-background-secondary, #F5F0E8);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.6em 0.8em;
			text-align: left;
			font-weight: 600;
			color: var(--theme-color-text-primary, #3D3229);
		}
		.pict-content table td {
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			padding: 0.5em 0.8em;
			color: var(--theme-color-text-primary, #423D37);
		}
		.pict-content table tr:nth-child(even) {
			background: var(--theme-color-background-secondary, #F7F5F0);
		}
		.pict-content img {
			max-width: 100%;
			height: auto;
		}
		.pict-content pre.mermaid {
			background: var(--theme-color-background-panel, #fff);
			color: var(--theme-color-text-primary, #2A241E);
			text-align: center;
			padding: 1em;
		}
		.pict-content pre.mermaid text,
		.pict-content pre.mermaid .nodeLabel,
		.pict-content pre.mermaid .edgeLabel,
		.pict-content pre.mermaid .label,
		.pict-content pre.mermaid .cluster-label,
		.pict-content pre.mermaid span,
		.pict-content pre.mermaid foreignObject p,
		.pict-content pre.mermaid foreignObject div,
		.pict-content pre.mermaid foreignObject span {
			color: var(--theme-color-text-primary, #2A241E) !important;
			fill: var(--theme-color-text-primary, #2A241E) !important;
		}
		.pict-content pre.mermaid .edgePath .path {
			stroke: var(--theme-color-text-secondary, #5E5549) !important;
		}
		.pict-content pre.mermaid .arrowheadPath {
			fill: var(--theme-color-text-secondary, #5E5549) !important;
		}
		/* Dark-mode override for handcrafted mermaid diagrams that bake
		   per-node inline fill colors via 'style X fill:#...' directives
		   (common in architecture / module docs, where pastel layer
		   colors mark visual hierarchy). Mermaid renders those as inline
		   style="fill:#..." SVG attributes — highest specificity, so
		   neither themeVariables nor unflagged CSS can reach them.
		   In light mode the Material pastels read fine; in dark mode the
		   same light fills become a high-contrast island on the dark
		   page with unreadable text. Force the fills back to a theme
		   background so dark-mode reads; light mode is intentionally
		   unmodified so the per-layer hierarchy is preserved there. */
		.theme-dark .pict-content pre.mermaid .node rect,
		.theme-dark .pict-content pre.mermaid .node polygon,
		.theme-dark .pict-content pre.mermaid .node circle,
		.theme-dark .pict-content pre.mermaid .node ellipse,
		.theme-dark .pict-content pre.mermaid .node path,
		.theme-dark .pict-content pre.mermaid .cluster rect {
			fill:   var(--theme-color-background-tertiary, #2A241E) !important;
			stroke: var(--theme-color-border-default,      #5E5549) !important;
		}
		/* Mirror of the above for theme mode 'system' — when the user
		   hasn't explicitly picked light or dark, the theme provider
		   leaves <html> without .theme-light/.theme-dark and the CSS
		   variables follow prefers-color-scheme. The .theme-dark-prefixed
		   block above doesn't match in that case, so light pastels would
		   win again on dark OSes. Mirror the rule under the media query,
		   gated by :not(.theme-light) so an explicit light override on a
		   dark OS still wins. */
		@media (prefers-color-scheme: dark) {
			html:not(.theme-light) .pict-content pre.mermaid .node rect,
			html:not(.theme-light) .pict-content pre.mermaid .node polygon,
			html:not(.theme-light) .pict-content pre.mermaid .node circle,
			html:not(.theme-light) .pict-content pre.mermaid .node ellipse,
			html:not(.theme-light) .pict-content pre.mermaid .node path,
			html:not(.theme-light) .pict-content pre.mermaid .cluster rect {
				fill:   var(--theme-color-background-tertiary, #2A241E) !important;
				stroke: var(--theme-color-border-default,      #5E5549) !important;
			}
		}
		/* Excalidraw fence placeholders + rendered SVGs */
		.pict-content .pict-excalidraw-fence {
			display: block;
			background: var(--theme-color-background-panel, #fff);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 4px;
			padding: 1em;
			margin: 1em 0;
			text-align: center;
		}
		.pict-content .pict-excalidraw-fence svg {
			max-width: 100%;
			height: auto;
		}
		.pict-content .pict-excalidraw-fence-loading {
			color: var(--theme-color-text-secondary, #5E5549);
			font-style: italic;
			font-size: 0.9em;
			padding: 1em;
		}
		.pict-content .pict-excalidraw-fence-error {
			border-color: var(--theme-color-status-error, #D9534F);
			background: var(--theme-color-background-secondary, #FFF5F5);
		}
		.pict-content .pict-excalidraw-fence-error-message {
			color: var(--theme-color-status-error, #D9534F);
			font-family: var(--theme-typography-family-mono, monospace);
			font-size: 0.85em;
			text-align: left;
		}
		.pict-content .pict-content-katex-display {
			text-align: center;
			margin: 1em 0;
			padding: 0.5em;
			overflow-x: auto;
		}
		.pict-content .pict-content-katex-inline {
			display: inline;
		}

		/* Fullscreen viewer for images and mermaid diagrams (click-to-zoom) */
		.pict-content [data-fullscreen-source] {
			cursor: zoom-in;
			outline: 1px solid transparent;
			outline-offset: 3px;
			border-radius: 4px;
			transition: outline-color 0.15s ease;
		}
		.pict-content [data-fullscreen-source]:hover {
			outline-color: var(--theme-color-brand-primary, #2E7D74);
		}
		/* Code block container with hover-revealed action buttons */
		.pict-content-code-container {
			position: relative;
			display: flex;
			align-items: flex-start;
			gap: 8px;
			margin: 1em 0;
		}
		.pict-content-code-container > .pict-content-code-wrap {
			margin: 0;
			flex: 1 1 auto;
			min-width: 0;
		}
		.pict-content-code-actions {
			position: sticky;
			top: 64px;
			align-self: flex-start;
			display: flex;
			flex-direction: column;
			gap: 6px;
			flex: 0 0 auto;
			padding-top: 6px;
			opacity: 0;
			transform: translateX(-4px);
			transition: opacity 0.15s ease, transform 0.15s ease;
			pointer-events: none;
		}
		.pict-content-code-container:hover .pict-content-code-actions,
		.pict-content-code-container:focus-within .pict-content-code-actions {
			opacity: 1;
			transform: translateX(0);
			pointer-events: auto;
		}
		.pict-content-code-action-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 28px;
			height: 28px;
			padding: 0;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-muted, #5E5549);
			border: 1px solid var(--theme-color-border-default, #DDD6CA);
			border-radius: 6px;
			cursor: pointer;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
		}
		.pict-content-code-action-btn svg {
			display: block;
			width: 14px;
			height: 14px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.6;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-content-code-action-btn:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
		}
		.pict-content-code-action-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-content-code-action-btn.is-copied {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-brand-primary, #2E7D74);
		}
		.pict-content-code-action-btn.is-copy-failed {
			background: var(--theme-color-status-error, #B23A3A);
			color: var(--theme-color-text-on-brand, #FFFFFF);
			border-color: var(--theme-color-status-error, #B23A3A);
		}
		.pict-fullscreen-overlay {
			position: fixed;
			inset: 0;
			z-index: 9999;
			display: flex;
			flex-direction: column;
			background: rgba(0, 0, 0, 0.62);
			backdrop-filter: blur(6px);
			-webkit-backdrop-filter: blur(6px);
			color: var(--theme-color-text-primary, #2A241E);
		}
		.pict-fullscreen-overlay[hidden] {
			display: none;
		}
		.pict-fullscreen-titlebar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 1em;
			height: 48px;
			padding: 0 1em;
			background: var(--theme-color-background-panel, #FFFFFF);
			color: var(--theme-color-text-primary, #1A1612);
			border-bottom: 1px solid var(--theme-color-border-default, #DDD6CA);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
			flex: 0 0 auto;
		}
		.pict-fullscreen-title {
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
			font-size: 0.95em;
			font-weight: 600;
			letter-spacing: 0.01em;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-controls {
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}
		.pict-fullscreen-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 32px;
			height: 32px;
			padding: 0;
			background: transparent;
			border: 1px solid transparent;
			border-radius: 6px;
			color: var(--theme-color-text-muted, #5E5549);
			cursor: pointer;
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
		}
		.pict-fullscreen-btn svg {
			display: block;
			width: 16px;
			height: 16px;
			stroke: currentColor;
			fill: none;
			stroke-width: 1.75;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
		.pict-fullscreen-btn:hover {
			background: var(--theme-color-border-light, #EAE3D8);
			color: var(--theme-color-text-primary, #1A1612);
		}
		.pict-fullscreen-btn:focus-visible {
			outline: 2px solid var(--theme-color-brand-primary, #2E7D74);
			outline-offset: 2px;
		}
		.pict-fullscreen-close:hover {
			background: var(--theme-color-brand-primary, #2E7D74);
			color: var(--theme-color-text-on-brand, #FFFFFF);
		}
		.pict-fullscreen-stage {
			flex: 1 1 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			padding: 1.5em;
			cursor: zoom-in;
			touch-action: none;
		}
		.pict-fullscreen-stage.is-zoomed {
			cursor: grab;
		}
		.pict-fullscreen-stage.is-panning {
			cursor: grabbing;
		}
		.pict-fullscreen-content {
			display: flex;
			align-items: center;
			justify-content: center;
			max-width: 100%;
			max-height: 100%;
			transform-origin: center center;
			transition: transform 0.05s linear;
			will-change: transform;
		}
		.pict-fullscreen-content > * {
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
		.pict-fullscreen-content .pict-fullscreen-img {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			width: auto;
			height: auto;
			object-fit: contain;
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 12px;
			border-radius: 6px;
		}
		.pict-fullscreen-content .pict-fullscreen-mermaid-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--theme-color-background-panel, #FFFFFF);
			padding: 16px;
			border-radius: 6px;
		}
		/* Bespoke inline-SVG diagrams (pict-renderer-graph / excalidraw).  Backdrop
		   uses the diagram's own --diagram-paper so the zoomed copy keeps the same
		   theme as the inline one (the host defines --diagram-* on the overlay). */
		.pict-fullscreen-content .pict-fullscreen-diagram-svg {
			width: min(90vw, 1400px);
			height: auto;
			max-height: calc(100vh - 96px);
			background: var(--diagram-paper, var(--theme-color-background-panel, #FFFFFF));
			padding: 16px;
			border-radius: 6px;
		}
		/* Same dark-mode fill/stroke override as for inline diagrams, but
		   scoped to the fullscreen-overlay clone — which lives under
		   <body>, NOT inside .pict-content, so the pre.mermaid-scoped
		   rules above don't reach it. */
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node rect,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node polygon,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node circle,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node ellipse,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node path,
		.theme-dark .pict-fullscreen-content .pict-fullscreen-mermaid-svg .cluster rect {
			fill:   var(--theme-color-background-tertiary, #2A241E) !important;
			stroke: var(--theme-color-border-default,      #5E5549) !important;
		}
		@media (prefers-color-scheme: dark) {
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node rect,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node polygon,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node circle,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node ellipse,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .node path,
			html:not(.theme-light) .pict-fullscreen-content .pict-fullscreen-mermaid-svg .cluster rect {
				fill:   var(--theme-color-background-tertiary, #2A241E) !important;
				stroke: var(--theme-color-border-default,      #5E5549) !important;
			}
		}
		.pict-fullscreen-content .pict-fullscreen-codewrap {
			max-width: 90vw;
			max-height: calc(100vh - 96px);
			margin: 0;
			overflow: auto;
			box-shadow: 0 12px 48px rgba(0, 0, 0, 0.45);
		}
	`,

	Templates:
	[
		{
			Hash: "Pict-Content-Template",
			Template: /*html*/`
<div class="pict-content" id="Pict-Content-Body">
	<div class="pict-content-loading">Loading content...</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Pict-Content-Display",
			TemplateHash: "Pict-Content-Template",
			DestinationAddress: "#Pict-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class PictContentView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Display parsed HTML content in the content area.
	 *
	 * @param {string} pHTMLContent - The HTML to display
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	displayContent(pHTMLContent, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';

		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, pHTMLContent);

		// Scroll to top of content area
		let tmpContentContainer = document.getElementById(tmpContainerID);
		if (tmpContentContainer && tmpContentContainer.parentElement)
		{
			tmpContentContainer.parentElement.scrollTop = 0;
		}

		// Ensure the container carries the `.pict-content` class so the
		// 30+ theme-scoped CSS rules below (`.pict-content a`, `.pict-content
		// h1`, `.pict-content pre`, ...) actually match when a host passes
		// a custom container ID.  Idempotent — re-adding the class is a
		// no-op if it's already there from the host's markup.
		if (tmpContentContainer && !tmpContentContainer.classList.contains('pict-content'))
		{
			tmpContentContainer.classList.add('pict-content');
		}

		// Tag images and code blocks immediately so they're clickable.
		// Mermaid blocks are tagged after mermaid.run() resolves (see below).
		this.enableFullscreenViewers(tmpContainerID, { skipMermaid: true });

		// Post-render: initialize Mermaid diagrams if mermaid is available.
		// Once mermaid finishes, retag so the rendered SVGs are also clickable.
		this.renderMermaidDiagrams(tmpContainerID);

		// Post-render: render ```excalidraw fenced scenes if the
		// pict-section-excalidraw wrapper bundle is loaded.  Each fence
		// becomes a static SVG (with the scene embedded for re-edit by
		// retold-content-system).
		this.renderExcalidrawDiagrams(tmpContainerID);

		// Post-render: render KaTeX equations if katex is available
		this.renderKaTeXEquations(tmpContainerID);
	}

	/**
	 * Render any `.pict-excalidraw-fence` placeholders inside the container
	 * as static SVGs using the pict-section-excalidraw wrapper bundle's
	 * exportToSvg helper.  Each fence's scene JSON travels through a
	 * URI-component-encoded data-scene attribute (placed there by the
	 * markdown parser in Pict-Provider-Content).
	 *
	 * Gracefully degrades when the wrapper bundle isn't on the page:
	 * leaves the loading placeholder visible with a one-time console hint.
	 * Idempotent — placeholders carry `data-rendered="true"` after the
	 * first pass so re-renders don't double-emit.
	 *
	 * @param {string} [pContainerID]
	 */
	renderExcalidrawDiagrams(pContainerID)
	{
		if (typeof document === 'undefined') return;

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody) return;

		let tmpFences = tmpContentBody.querySelectorAll('.pict-excalidraw-fence:not([data-rendered])');
		if (tmpFences.length < 1) return;

		let tmpVendor = (typeof window !== 'undefined') ? window.PictSectionExcalidrawVendor : null;
		if (!tmpVendor || typeof tmpVendor.exportToSvg !== 'function')
		{
			// Bundle not loaded — leave the placeholder visible.  The host
			// can load the wrapper bundle and call renderExcalidrawDiagrams
			// again, or include the script tag in its HTML shell.
			if (this.log && this.log.warn && !this._excalidrawBundleWarnLogged)
			{
				this.log.warn('pict-excalidraw fence(s) found but pict-section-excalidraw wrapper bundle is not loaded — leaving as placeholders.');
				this._excalidrawBundleWarnLogged = true;
			}
			return;
		}

		for (let i = 0; i < tmpFences.length; i++)
		{
			let tmpFence = tmpFences[i];
			let tmpEncoded = tmpFence.getAttribute('data-scene') || '';
			let tmpJson = '';
			try { tmpJson = decodeURIComponent(tmpEncoded); }
			catch (pErr) { tmpJson = ''; }

			let tmpScene;
			try { tmpScene = JSON.parse(tmpJson); }
			catch (pErr)
			{
				this._renderExcalidrawFenceError(tmpFence, 'Invalid scene JSON: ' + pErr.message);
				continue;
			}

			let tmpExportArgs = {
				elements: tmpScene.elements || [],
				appState: Object.assign({ exportEmbedScene: true }, tmpScene.appState || {}),
				files:    tmpScene.files    || {}
			};

			tmpVendor.exportToSvg(tmpExportArgs).then((pSvgEl) =>
			{
				if (!pSvgEl) return;
				// Style the SVG to fit the fence's content width while preserving aspect.
				pSvgEl.removeAttribute('width');
				pSvgEl.removeAttribute('height');
				pSvgEl.setAttribute('style', 'max-width: 100%; height: auto;');
				tmpFence.innerHTML = '';
				tmpFence.appendChild(pSvgEl);
				tmpFence.setAttribute('data-rendered', 'true');
			}).catch((pErr) =>
			{
				this._renderExcalidrawFenceError(tmpFence,
					'Excalidraw render failed: ' + (pErr && pErr.message ? pErr.message : pErr));
			});
		}
	}

	_renderExcalidrawFenceError(pFence, pMessage)
	{
		pFence.setAttribute('data-rendered', 'true');
		pFence.classList.add('pict-excalidraw-fence-error');
		pFence.innerHTML = '<div class="pict-excalidraw-fence-error-message"></div>';
		// Use textContent on the inner div so any user-supplied error
		// substrings (e.g. parser error positions) can't introduce HTML.
		let tmpMsg = pFence.querySelector('.pict-excalidraw-fence-error-message');
		if (tmpMsg) tmpMsg.textContent = pMessage;
		if (this.log && this.log.warn) this.log.warn('pict-excalidraw fence: ' + pMessage);
	}

	/**
	 * Lazily wire mermaid into the active pict-provider-theme via the
	 * shared Theme-Diagram-Adapter. The adapter handles:
	 *   - mermaid.initialize() with the canonical pict token map
	 *   - onApply subscription (re-init + re-render on theme/mode change)
	 *   - source stashing + data-processed reset for refresh
	 *
	 * Idempotent: the first call binds the adapter, subsequent calls are
	 * no-ops.  When the provider isn't installed, mermaid still gets
	 * initialized once against whatever CSS variables happen to exist.
	 */
	_ensureMermaidAdapter()
	{
		if (this._mermaidAdapter) { return this._mermaidAdapter; }
		if (typeof mermaid === 'undefined' || typeof window === 'undefined') { return null; }
		let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
		try
		{
			if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.adaptMermaid === 'function')
			{
				this._mermaidAdapter = tmpProvider.diagram.adaptMermaid(mermaid, {});
			}
			else
			{
				// No provider: lazy-require the adapter directly so the
				// static base theme still picks up any CSS vars on :root.
				let libDiagramAdapter = require('pict-provider-theme/source/Theme-Diagram-Adapter.js');
				libDiagramAdapter.initializeMermaid(mermaid);
				this._mermaidAdapter =
				{
					refresh: function () { return libDiagramAdapter.refreshMermaidDiagrams(); },
					reinitialize: function () { libDiagramAdapter.initializeMermaid(mermaid); },
					dispose: function () {},
					subscribed: false
				};
			}
		}
		catch (pError)
		{
			if (this.log && this.log.warn) { this.log.warn('Mermaid theme adapter init failed: ' + pError.message); }
			this._mermaidAdapter = null;
		}
		return this._mermaidAdapter;
	}

	/**
	 * Render any Mermaid diagram blocks in the content area.
	 * Mermaid blocks are `<pre class="mermaid">` elements produced by parseMarkdown.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderMermaidDiagrams(pContainerID)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		let tmpMermaidElements = tmpContentBody.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// First-time setup: bind the Theme-Diagram-Adapter, which initializes
		// mermaid against the active palette and subscribes to onApply so a
		// theme/mode change triggers re-render of every pre.mermaid on the page.
		this._ensureMermaidAdapter();

		// Cache each diagram's source on the element so theme-change
		// re-renders can restore it. Mermaid replaces textContent with
		// the rendered SVG during run(), so we lose the source unless
		// we stash it here first.
		let tmpProviderForStash = this.pict && this.pict.providers && this.pict.providers.Theme;
		if (tmpProviderForStash && tmpProviderForStash.diagram && typeof tmpProviderForStash.diagram.stashMermaidSource === 'function')
		{
			tmpProviderForStash.diagram.stashMermaidSource(tmpMermaidElements);
		}
		else
		{
			for (let i = 0; i < tmpMermaidElements.length; i++)
			{
				let tmpEl = tmpMermaidElements[i];
				if (!tmpEl.hasAttribute('data-mermaid-source'))
				{
					tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
				}
			}
		}

		// mermaid.run() will process all pre.mermaid elements in the container.
		// It returns a promise; once it resolves the inner SVG exists and we
		// can tag the diagrams as fullscreen-clickable.
		try
		{
			let tmpResult = mermaid.run({ nodes: tmpMermaidElements });
			if (tmpResult && typeof tmpResult.then === 'function')
			{
				tmpResult.then(() =>
				{
					// Strip mermaid 11's inline !important fill/stroke flags
					// so the view's theme-aware .theme-dark CSS rules can win
					// against the per-node colors mermaid bakes inline.  The
					// adapter strips on every re-render; the initial render
					// runs through mermaid.run() directly so we have to call
					// the strip here too.  Without this the dark-mode rect
					// fill override silently loses to inline `!important`.
					let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
					if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.stripMermaidStyleImportance === 'function')
					{
						tmpProvider.diagram.stripMermaidStyleImportance(tmpMermaidElements);
					}
					this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
				}).catch((pError) =>
				{
					this.log.error('Mermaid rendering error: ' + (pError && pError.message ? pError.message : pError));
				});
			}
			else
			{
				// Synchronous fallback (older mermaid)
				let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Theme;
				if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.stripMermaidStyleImportance === 'function')
				{
					tmpProvider.diagram.stripMermaidStyleImportance(tmpMermaidElements);
				}
				this.enableFullscreenViewers(tmpContainerID, { onlyMermaid: true });
			}
		}
		catch (pError)
		{
			this.log.error('Mermaid rendering error: ' + pError.message);
		}
	}

	/**
	 * Render KaTeX inline and display math elements in the content area.
	 * Inline: `<span class="pict-content-katex-inline">`
	 * Display: `<div class="pict-content-katex-display">`
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	renderKaTeXEquations(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}

		// Render inline math
		let tmpInlineElements = tmpContentBody.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				this.log.warn('KaTeX inline error: ' + pError.message);
			}
		}

		// Render display math
		let tmpDisplayElements = tmpContentBody.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				this.log.warn('KaTeX display error: ' + pError.message);
			}
		}
	}

	/**
	 * Walk the freshly-rendered content and tag images, mermaid diagrams,
	 * and fenced code blocks so they're click-to-fullscreen.  Also installs
	 * a single delegated click listener on the container the first time it
	 * is called for that container.
	 *
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 * @param {Object} [pOptions] - { skipMermaid: bool, onlyMermaid: bool }
	 */
	enableFullscreenViewers(pContainerID, pOptions)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpContentBody = document.getElementById(tmpContainerID);
		if (!tmpContentBody)
		{
			return;
		}
		let tmpOptions = pOptions || {};

		if (!tmpOptions.onlyMermaid)
		{
			// Images
			let tmpImages = tmpContentBody.querySelectorAll('img:not([data-fullscreen-source])');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpImg = tmpImages[i];
				tmpImg.setAttribute('data-fullscreen-source', 'image');
				let tmpAlt = tmpImg.getAttribute('alt');
				if (!tmpAlt)
				{
					let tmpSrc = tmpImg.getAttribute('src') || '';
					tmpAlt = tmpSrc.split('/').pop().split('?')[0] || 'Image';
				}
				tmpImg.setAttribute('data-fullscreen-title', tmpAlt);
			}

			// Code wraps (fenced blocks): do NOT tag for click-to-fullscreen —
			// that would conflict with text selection for copy/paste.
			// Instead wrap each in a container with hover-revealed action
			// buttons (fullscreen + copy) floating to the right.
			let tmpCodeWraps = tmpContentBody.querySelectorAll('.pict-content-code-wrap:not([data-code-actions-wired])');
			for (let i = 0; i < tmpCodeWraps.length; i++)
			{
				this._wireCodeActions(tmpCodeWraps[i]);
			}
		}

		if (!tmpOptions.skipMermaid)
		{
			// Mermaid diagrams (after mermaid.run() has replaced the inner pre)
			let tmpMermaid = tmpContentBody.querySelectorAll('pre.mermaid:not([data-fullscreen-source])');
			for (let i = 0; i < tmpMermaid.length; i++)
			{
				let tmpPre = tmpMermaid[i];
				// Only tag once mermaid has actually rendered an svg into it
				if (tmpPre.querySelector('svg'))
				{
					tmpPre.setAttribute('data-fullscreen-source', 'mermaid');
					tmpPre.setAttribute('data-fullscreen-title', 'Mermaid Diagram');
				}
			}
		}

		// Install delegated click listener once per container.
		if (!tmpContentBody.__pictFullscreenWired)
		{
			tmpContentBody.__pictFullscreenWired = true;
			tmpContentBody.addEventListener('click', (pEvent) =>
			{
				let tmpTarget = pEvent.target;
				while (tmpTarget && tmpTarget !== tmpContentBody && !tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					tmpTarget = tmpTarget.parentElement;
				}
				if (tmpTarget && tmpTarget !== tmpContentBody && tmpTarget.hasAttribute('data-fullscreen-source'))
				{
					pEvent.preventDefault();
					this._openFullscreen(tmpTarget);
				}
			});
		}
	}

	/**
	 * Wrap a fenced code block in a container that holds the existing
	 * .pict-content-code-wrap plus a hover-revealed action column with
	 * fullscreen + copy buttons.  The action column is sticky-positioned
	 * so it follows the page scroll while the user is alongside a long
	 * code block.
	 *
	 * @param {HTMLElement} pCodeWrap - The .pict-content-code-wrap element
	 */
	_wireCodeActions(pCodeWrap)
	{
		if (!pCodeWrap || pCodeWrap.hasAttribute('data-code-actions-wired'))
		{
			return;
		}
		pCodeWrap.setAttribute('data-code-actions-wired', 'true');

		// Determine the fullscreen title from the language tag, if any.
		let tmpCodeEl = pCodeWrap.querySelector('code[class*="language-"]');
		let tmpLang = 'Code';
		if (tmpCodeEl)
		{
			let tmpMatch = (tmpCodeEl.getAttribute('class') || '').match(/language-(\S+)/);
			if (tmpMatch)
			{
				tmpLang = tmpMatch[1] + ' code';
			}
		}
		pCodeWrap.setAttribute('data-code-language', tmpLang);

		// Build the wrapping container.
		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-content-code-container';

		let tmpActions = document.createElement('div');
		tmpActions.className = 'pict-content-code-actions';
		tmpActions.setAttribute('aria-hidden', 'false');

		let tmpFullscreenBtn = document.createElement('button');
		tmpFullscreenBtn.type = 'button';
		tmpFullscreenBtn.className = 'pict-content-code-action-btn';
		tmpFullscreenBtn.setAttribute('aria-label', 'Open code in fullscreen');
		tmpFullscreenBtn.setAttribute('title', 'Open in fullscreen');
		tmpFullscreenBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><polyline points="3 6 3 3 6 3"></polyline><polyline points="13 6 13 3 10 3"></polyline><polyline points="3 10 3 13 6 13"></polyline><polyline points="13 10 13 13 10 13"></polyline></svg>';

		let tmpCopyBtn = document.createElement('button');
		tmpCopyBtn.type = 'button';
		tmpCopyBtn.className = 'pict-content-code-action-btn';
		tmpCopyBtn.setAttribute('aria-label', 'Copy code to clipboard');
		tmpCopyBtn.setAttribute('title', 'Copy code');
		tmpCopyBtn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="5" y="5" width="9" height="9" rx="1.25"></rect><path d="M11 5V3.25A1.25 1.25 0 0 0 9.75 2H3.25A1.25 1.25 0 0 0 2 3.25v6.5A1.25 1.25 0 0 0 3.25 11H5"></path></svg>';

		tmpActions.appendChild(tmpFullscreenBtn);
		tmpActions.appendChild(tmpCopyBtn);

		// Insert the container in the place of the code wrap, then move the
		// code wrap inside it followed by the actions column.
		let tmpParent = pCodeWrap.parentNode;
		tmpParent.insertBefore(tmpContainer, pCodeWrap);
		tmpContainer.appendChild(pCodeWrap);
		tmpContainer.appendChild(tmpActions);

		// Click handlers
		tmpFullscreenBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._openCodeFullscreen(pCodeWrap);
		});
		tmpCopyBtn.addEventListener('click', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			this._copyCodeToClipboard(pCodeWrap, tmpCopyBtn);
		});
	}

	/**
	 * Open the fullscreen overlay for a fenced code block.  Reuses the
	 * same overlay singleton as image / mermaid.
	 */
	_openCodeFullscreen(pCodeWrap)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		// Stamp the source attributes the overlay's open() expects.
		pCodeWrap.setAttribute('data-fullscreen-source', 'code');
		pCodeWrap.setAttribute('data-fullscreen-title', pCodeWrap.getAttribute('data-code-language') || 'Code');
		tmpOverlay.open(pCodeWrap);
	}

	/**
	 * Copy the raw text of a code block to the clipboard and briefly flash
	 * a "Copied!" state on the trigger button.
	 */
	_copyCodeToClipboard(pCodeWrap, pButton)
	{
		let tmpCodeEl = pCodeWrap.querySelector('code');
		let tmpText = tmpCodeEl ? tmpCodeEl.textContent : pCodeWrap.textContent;

		let fFlashOk = () =>
		{
			pButton.classList.add('is-copied');
			pButton.setAttribute('title', 'Copied!');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copied');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};
		let fFlashFail = () =>
		{
			pButton.classList.add('is-copy-failed');
			pButton.setAttribute('title', 'Copy failed');
			setTimeout(() =>
			{
				pButton.classList.remove('is-copy-failed');
				pButton.setAttribute('title', 'Copy code');
			}, 1400);
		};

		try
		{
			if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function')
			{
				navigator.clipboard.writeText(tmpText).then(fFlashOk).catch(fFlashFail);
				return;
			}
		}
		catch (e)
		{
			// fall through to legacy fallback
		}

		// Legacy fallback for non-secure contexts.
		try
		{
			let tmpTextarea = document.createElement('textarea');
			tmpTextarea.value = tmpText;
			tmpTextarea.style.position = 'fixed';
			tmpTextarea.style.opacity = '0';
			document.body.appendChild(tmpTextarea);
			tmpTextarea.select();
			let tmpOk = document.execCommand('copy');
			document.body.removeChild(tmpTextarea);
			if (tmpOk) { fFlashOk(); } else { fFlashFail(); }
		}
		catch (e)
		{
			fFlashFail();
		}
	}

	/**
	 * Lazily build the singleton fullscreen overlay element and attach it
	 * to <body>.  Returns the existing instance if already built.
	 */
	_buildFullscreenOverlay()
	{
		if (PictContentView._FullscreenOverlay)
		{
			return PictContentView._FullscreenOverlay;
		}

		let tmpOverlay = document.createElement('div');
		tmpOverlay.className = 'pict-fullscreen-overlay';
		tmpOverlay.setAttribute('role', 'dialog');
		tmpOverlay.setAttribute('aria-modal', 'true');
		tmpOverlay.setAttribute('aria-labelledby', 'pict-fullscreen-title');
		tmpOverlay.setAttribute('hidden', '');
		tmpOverlay.innerHTML = ''
			+ '<div class="pict-fullscreen-titlebar">'
			+   '<span class="pict-fullscreen-title" id="pict-fullscreen-title"></span>'
			+   '<div class="pict-fullscreen-controls">'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-out" aria-label="Zoom out" title="Zoom out"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-reset" aria-label="Reset zoom" title="Reset zoom"><svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="5"></circle><line x1="8" y1="5" x2="8" y2="11"></line><line x1="5" y1="8" x2="11" y2="8"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn" data-action="zoom-in" aria-label="Zoom in" title="Zoom in"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="3" y1="8" x2="13" y2="8"></line><line x1="8" y1="3" x2="8" y2="13"></line></svg></button>'
			+     '<button type="button" class="pict-fullscreen-btn pict-fullscreen-close" data-action="close" aria-label="Close" title="Close (Esc)"><svg viewBox="0 0 16 16" aria-hidden="true"><line x1="4" y1="4" x2="12" y2="12"></line><line x1="12" y1="4" x2="4" y2="12"></line></svg></button>'
			+   '</div>'
			+ '</div>'
			+ '<div class="pict-fullscreen-stage">'
			+   '<div class="pict-fullscreen-content"></div>'
			+ '</div>';
		document.body.appendChild(tmpOverlay);

		let tmpState = {
			scale: 1,
			translateX: 0,
			translateY: 0,
			isPanning: false,
			didPan: false,
			currentKind: '',
			panStartX: 0,
			panStartY: 0,
			panOrigX: 0,
			panOrigY: 0,
			pinchInitialDistance: 0,
			pinchInitialScale: 1
		};

		let tmpStage = tmpOverlay.querySelector('.pict-fullscreen-stage');
		let tmpContent = tmpOverlay.querySelector('.pict-fullscreen-content');
		let tmpTitleEl = tmpOverlay.querySelector('.pict-fullscreen-title');

		let fApplyTransform = () =>
		{
			tmpContent.style.transform = 'translate(' + tmpState.translateX + 'px, ' + tmpState.translateY + 'px) scale(' + tmpState.scale + ')';
			tmpStage.classList.toggle('is-zoomed', tmpState.scale > 1.001);
		};

		let fClampScale = (pValue) =>
		{
			if (pValue < 0.5) return 0.5;
			if (pValue > 8) return 8;
			return pValue;
		};

		let fZoomAt = (pNewScale, pAnchorClientX, pAnchorClientY) =>
		{
			let tmpClamped = fClampScale(pNewScale);
			let tmpStageRect = tmpStage.getBoundingClientRect();
			let tmpAnchorX = (pAnchorClientX !== undefined) ? pAnchorClientX : (tmpStageRect.left + tmpStageRect.width / 2);
			let tmpAnchorY = (pAnchorClientY !== undefined) ? pAnchorClientY : (tmpStageRect.top + tmpStageRect.height / 2);
			// Convert anchor into the local coordinate of the content (which is centered)
			let tmpCenterX = tmpStageRect.left + tmpStageRect.width / 2;
			let tmpCenterY = tmpStageRect.top + tmpStageRect.height / 2;
			let tmpDX = tmpAnchorX - tmpCenterX;
			let tmpDY = tmpAnchorY - tmpCenterY;
			let tmpRatio = tmpClamped / tmpState.scale;
			tmpState.translateX = tmpDX - tmpRatio * (tmpDX - tmpState.translateX);
			tmpState.translateY = tmpDY - tmpRatio * (tmpDY - tmpState.translateY);
			tmpState.scale = tmpClamped;
			fApplyTransform();
		};

		let fResetTransform = () =>
		{
			tmpState.scale = 1;
			tmpState.translateX = 0;
			tmpState.translateY = 0;
			fApplyTransform();
		};

		let fClose = () =>
		{
			tmpOverlay.setAttribute('hidden', '');
			tmpContent.innerHTML = '';
			fResetTransform();
			document.documentElement.style.removeProperty('overflow');
			document.removeEventListener('keydown', fKeydown);
		};

		let fKeydown = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pEvent.preventDefault();
				fClose();
			}
			else if (pEvent.key === '+' || pEvent.key === '=')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale + 0.25);
			}
			else if (pEvent.key === '-' || pEvent.key === '_')
			{
				pEvent.preventDefault();
				fZoomAt(tmpState.scale - 0.25);
			}
			else if (pEvent.key === '0')
			{
				pEvent.preventDefault();
				fResetTransform();
			}
		};

		// Backdrop click closes (only when clicking the backdrop itself or
		// the stage area, not the inner content).  Suppress if a
		// drag-to-pan just finished — the pointerup that ended the pan
		// also fires a click event which we must ignore.
		tmpOverlay.addEventListener('click', (pEvent) =>
		{
			if (tmpState.didPan)
			{
				tmpState.didPan = false;
				return;
			}
			if (pEvent.target === tmpOverlay || pEvent.target === tmpStage)
			{
				fClose();
			}
		});

		// Toolbar buttons
		tmpOverlay.querySelectorAll('[data-action]').forEach((pBtn) =>
		{
			pBtn.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				let tmpAction = pBtn.getAttribute('data-action');
				if (tmpAction === 'close')
				{
					fClose();
				}
				else if (tmpAction === 'zoom-in')
				{
					fZoomAt(tmpState.scale + 0.25);
				}
				else if (tmpAction === 'zoom-out')
				{
					fZoomAt(tmpState.scale - 0.25);
				}
				else if (tmpAction === 'zoom-reset')
				{
					fResetTransform();
				}
			});
		});

		// Wheel zoom — for images and mermaid diagrams.
		// For code blocks, let the browser handle native scrolling
		// so the user can scroll through long code.
		tmpStage.addEventListener('wheel', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			pEvent.preventDefault();
			let tmpDelta = -pEvent.deltaY;
			let tmpStep = (tmpDelta > 0 ? 1 : -1) * 0.15;
			fZoomAt(tmpState.scale + tmpStep, pEvent.clientX, pEvent.clientY);
		}, { passive: false });

		// Drag-to-pan when zoomed (not for code blocks — they scroll natively)
		tmpStage.addEventListener('pointerdown', (pEvent) =>
		{
			if (tmpState.currentKind === 'code')
			{
				return;
			}
			if (tmpState.scale <= 1.001)
			{
				return;
			}
			if (pEvent.target.closest('.pict-fullscreen-controls'))
			{
				return;
			}
			tmpState.isPanning = true;
			tmpState.panStartX = pEvent.clientX;
			tmpState.panStartY = pEvent.clientY;
			tmpState.panOrigX = tmpState.translateX;
			tmpState.panOrigY = tmpState.translateY;
			tmpStage.setPointerCapture(pEvent.pointerId);
			tmpStage.classList.add('is-panning');
		});
		tmpStage.addEventListener('pointermove', (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.translateX = tmpState.panOrigX + (pEvent.clientX - tmpState.panStartX);
			tmpState.translateY = tmpState.panOrigY + (pEvent.clientY - tmpState.panStartY);
			fApplyTransform();
		});
		let fEndPan = (pEvent) =>
		{
			if (!tmpState.isPanning)
			{
				return;
			}
			tmpState.isPanning = false;
			// Flag that a pan just ended so the subsequent click event
			// (which the browser fires after pointerup) does not close
			// the overlay via the backdrop-close handler.
			tmpState.didPan = true;
			tmpStage.classList.remove('is-panning');
			try { tmpStage.releasePointerCapture(pEvent.pointerId); } catch (e) {}
		};
		tmpStage.addEventListener('pointerup', fEndPan);
		tmpStage.addEventListener('pointercancel', fEndPan);

		// Touch pinch zoom
		let tmpActiveTouches = {};
		tmpStage.addEventListener('touchstart', (pEvent) =>
		{
			for (let i = 0; i < pEvent.touches.length; i++)
			{
				let tmpT = pEvent.touches[i];
				tmpActiveTouches[tmpT.identifier] = { x: tmpT.clientX, y: tmpT.clientY };
			}
			if (pEvent.touches.length === 2)
			{
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				tmpState.pinchInitialDistance = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				tmpState.pinchInitialScale = tmpState.scale;
			}
		}, { passive: true });
		tmpStage.addEventListener('touchmove', (pEvent) =>
		{
			if (pEvent.touches.length === 2 && tmpState.pinchInitialDistance > 0)
			{
				pEvent.preventDefault();
				let tmpA = pEvent.touches[0];
				let tmpB = pEvent.touches[1];
				let tmpDX = tmpB.clientX - tmpA.clientX;
				let tmpDY = tmpB.clientY - tmpA.clientY;
				let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY);
				let tmpRatio = tmpDist / tmpState.pinchInitialDistance;
				let tmpMidX = (tmpA.clientX + tmpB.clientX) / 2;
				let tmpMidY = (tmpA.clientY + tmpB.clientY) / 2;
				fZoomAt(tmpState.pinchInitialScale * tmpRatio, tmpMidX, tmpMidY);
			}
		}, { passive: false });
		tmpStage.addEventListener('touchend', () =>
		{
			tmpActiveTouches = {};
			tmpState.pinchInitialDistance = 0;
		});

		PictContentView._FullscreenOverlay = {
			element: tmpOverlay,
			content: tmpContent,
			titleEl: tmpTitleEl,
			state: tmpState,
			open: (pSourceEl) =>
			{
				let tmpTitle = pSourceEl.getAttribute('data-fullscreen-title') || '';
				tmpTitleEl.textContent = tmpTitle;
				tmpContent.innerHTML = '';

				let tmpKind = pSourceEl.getAttribute('data-fullscreen-source');
				tmpState.currentKind = tmpKind || '';
				let tmpClone;
				if (tmpKind === 'mermaid')
				{
					let tmpSvg = pSourceEl.querySelector('svg');
					if (tmpSvg)
					{
						tmpClone = tmpSvg.cloneNode(true);
						tmpClone.classList.add('pict-fullscreen-mermaid-svg');
						// Drop mermaid's inline max-width / width / height style so the
						// fullscreen CSS rule actually controls the size.
						tmpClone.removeAttribute('style');
						tmpClone.removeAttribute('width');
						tmpClone.removeAttribute('height');
					}
					else
					{
						tmpClone = pSourceEl.cloneNode(true);
					}
				}
				else if (tmpKind === 'diagram')
				{
					// Inline SVG diagram (bespoke pict-renderer-graph / excalidraw):
					// clone the <svg> and drop its intrinsic sizing so the fullscreen
					// stage controls the dimensions -- same approach as mermaid, but
					// the source element may BE the svg or a wrapper around it.
					let tmpSvg = (String(pSourceEl.tagName).toLowerCase() === 'svg') ? pSourceEl : pSourceEl.querySelector('svg');
					if (tmpSvg)
					{
						tmpClone = tmpSvg.cloneNode(true);
						tmpClone.classList.add('pict-fullscreen-diagram-svg');
						tmpClone.removeAttribute('style');
						tmpClone.removeAttribute('width');
						tmpClone.removeAttribute('height');
					}
					else
					{
						tmpClone = pSourceEl.cloneNode(true);
					}
				}
				else if (tmpKind === 'image')
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-img');
				}
				else
				{
					tmpClone = pSourceEl.cloneNode(true);
					tmpClone.classList.add('pict-fullscreen-codewrap');
				}
				tmpContent.appendChild(tmpClone);

				// Hide zoom controls for code blocks (they scroll natively)
				let tmpZoomBtns = tmpOverlay.querySelectorAll('[data-action="zoom-in"], [data-action="zoom-out"], [data-action="zoom-reset"]');
				for (let i = 0; i < tmpZoomBtns.length; i++)
				{
					tmpZoomBtns[i].style.display = (tmpKind === 'code') ? 'none' : '';
				}

				fResetTransform();
				tmpOverlay.removeAttribute('hidden');
				document.documentElement.style.overflow = 'hidden';
				document.addEventListener('keydown', fKeydown);
			},
			close: fClose
		};
		return PictContentView._FullscreenOverlay;
	}

	/**
	 * Open the fullscreen overlay for a tagged source element.
	 */
	_openFullscreen(pSourceEl)
	{
		let tmpOverlay = this._buildFullscreenOverlay();
		tmpOverlay.open(pSourceEl);
	}

	/**
	 * Show a loading indicator.
	 *
	 * @param {string} [pMessage] - Loading message (defaults to 'Loading content...')
	 * @param {string} [pContainerID] - The container element ID (defaults to 'Pict-Content-Body')
	 */
	showLoading(pMessage, pContainerID)
	{
		let tmpContainerID = pContainerID || 'Pict-Content-Body';
		let tmpMessage = pMessage || 'Loading content...';
		this.pict.ContentAssignment.assignContent('#' + tmpContainerID, '<div class="pict-content-loading">' + tmpMessage + '</div>');
	}
}

module.exports = PictContentView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-provider-theme/source/Theme-Diagram-Adapter.js":13,"pict-view":239}],136:[function(require,module,exports){
// Pict-Section-Content — Demo view
//
// A thin renderable wrapper around the canonical Pict-View-Content view.
// The base view is "lazy" — it shows a Loading placeholder until its host
// application explicitly calls `displayContent(parsedHTML)`.  That works
// fine when an application has its own page logic, but it's awkward for
// the docuserve playground (which doesn't know anything about
// markdown / parseMarkdown).
//
// This demo view bridges that gap:
//   1. Ensures the PictContentProvider is registered with `pict`.
//   2. Reads markdown text from an AppData address (configurable via
//      `MarkdownDataAddress`, e.g. "AppData.ContentDemo.Markdown").
//   3. On every render, parses the markdown via the provider and calls
//      the parent view's `displayContent` to push HTML into the DOM.
//
// Host applications that need anything more elaborate (navigation,
// multiple documents, link resolvers) should keep using the canonical
// Pict-View-Content view directly.  This demo view exists for the
// playground and other "just render this markdown blob" surfaces.

const libPictViewContent = require('./Pict-View-Content.js');
const libPictContentProvider = require('../providers/Pict-Provider-Content.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Pict-Content-Demo",

	DefaultRenderable: "Pict-Content-Display",
	DefaultDestinationAddress: "#Pict-Content-Container",

	// Where to read the markdown source from. Resolved against the
	// pict instance with simple dot-walking — "AppData.X.Y.Z".
	MarkdownDataAddress: "AppData.ContentDemo.Markdown",

	// AutoRender on, so the playground's wrapper just instantiates the
	// view and the markdown shows up on next tick.
	AutoRender: true,

	// Inherit CSS / Templates / Renderables from the base view so we
	// render into the same #Pict-Content-Container with the same shell.
	CSS: libPictViewContent.default_configuration.CSS,
	Templates: libPictViewContent.default_configuration.Templates,
	Renderables: libPictViewContent.default_configuration.Renderables
};

class PictContentDemoView extends libPictViewContent
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Ensure the content provider is registered. Use a stable hash
		// so repeat instantiation is a no-op.
		let tmpProviderHash = 'Pict-Content';
		if (!this.pict.providers[tmpProviderHash])
		{
			this.pict.addProvider(tmpProviderHash, libPictContentProvider.default_configuration, libPictContentProvider);
		}
	}

	/**
	 * Walk a dotted address ("AppData.X.Y.Z") against the pict instance
	 * and return the value, or null if any segment is missing.
	 */
	_readMarkdownFromAddress()
	{
		let tmpAddress = this.options.MarkdownDataAddress;
		if (!tmpAddress || typeof tmpAddress !== 'string')
		{
			return null;
		}
		let tmpParts = tmpAddress.split('.');
		let tmpCurrent = this.pict;
		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return null;
			}
			tmpCurrent = tmpCurrent[tmpParts[i]];
		}
		return (typeof tmpCurrent === 'string') ? tmpCurrent : null;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		// Pull markdown from AppData and push parsed HTML through the
		// parent view's pipeline (which also wires Mermaid / KaTeX /
		// fullscreen viewers).
		let tmpMarkdown = this._readMarkdownFromAddress();
		let tmpProvider = this.pict.providers['Pict-Content'];
		if (tmpProvider && typeof tmpMarkdown === 'string')
		{
			let tmpHTML = tmpProvider.parseMarkdown(tmpMarkdown);
			this.displayContent(tmpHTML);
		}

		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = PictContentDemoView;

module.exports.default_configuration = _ViewConfiguration;

},{"../providers/Pict-Provider-Content.js":134,"./Pict-View-Content.js":135}],137:[function(require,module,exports){
/**
 * Pict-MDE-CodeMirror: Helper module for PictSectionMarkdownEditor
 *
 * Handles CodeMirror editor instance creation, extension configuration,
 * keyboard shortcuts, paste handling, and the data URI collapse extension.
 */

/**
 * Attach CodeMirror editor creation methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Create a CodeMirror editor instance inside a container element.
	 *
	 * @param {HTMLElement} pContainer - The DOM element to mount the editor in
	 * @param {number} pSegmentIndex - The segment index
	 * @param {string} pContent - The initial content
	 */
	pView._createEditorInContainer = function _createEditorInContainer(pContainer, pSegmentIndex, pContent)
	{
		let tmpCM = pView._codeMirrorModules;

		// Build the extensions array
		let tmpExtensions = [];

		// Keyboard shortcuts for formatting, inter-segment navigation, and image paste handling
		// IMPORTANT: Must be added BEFORE consumer extensions (e.g. basicSetup) so that
		// our domEventHandlers fire before CM6's internal keymap handlers.
		tmpExtensions.push(
			tmpCM.EditorView.domEventHandlers(
			{
				keydown: (pEvent, pEditorView) =>
				{
					// Ctrl/Cmd + B = bold
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'b')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'bold');
						return true;
					}
					// Ctrl/Cmd + I = italic
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'i')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'italic');
						return true;
					}
					// Ctrl/Cmd + E = inline code
					if ((pEvent.ctrlKey || pEvent.metaKey) && pEvent.key === 'e')
					{
						pEvent.preventDefault();
						pView.applyFormatting(pSegmentIndex, 'code');
						return true;
					}

				},
				paste: (pEvent, pEditorView) =>
				{
					// Check clipboard for image data
					let tmpItems = pEvent.clipboardData && pEvent.clipboardData.items;
					if (!tmpItems)
					{
						return false;
					}
					for (let i = 0; i < tmpItems.length; i++)
					{
						if (tmpItems[i].type.startsWith('image/'))
						{
							pEvent.preventDefault();
							let tmpFile = tmpItems[i].getAsFile();
							if (tmpFile)
							{
								pView._processImageFile(tmpFile, pSegmentIndex);
							}
							return true;
						}
					}
					return false;
				},
				drop: (pEvent, pEditorView) =>
				{
					// Intercept image file drops at the CodeMirror level to prevent
					// the browser from inserting the image as a raw DOM element.
					// Without this, both CodeMirror's default drop behavior AND the
					// container-level handler fire, causing rendering artifacts.
					if (pView._dragSourceIndex >= 0)
					{
						return false; // segment-reorder drag, not a file drop
					}
					if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
					{
						return false;
					}
					let tmpFile = pEvent.dataTransfer.files[0];
					if (tmpFile.type && tmpFile.type.startsWith('image/'))
					{
						pEvent.preventDefault();
						pEvent.stopPropagation();
						pView._processImageFile(tmpFile, pSegmentIndex);
						// Clean up the dragover visual indicator on the container
						let tmpContainer = pEditorView.dom.closest('.pict-mde-segment-editor');
						if (tmpContainer)
						{
							tmpContainer.classList.remove('pict-mde-image-dragover');
						}
						return true;
					}
					return false;
				}
			})
		);

		// Add consumer-provided extensions (e.g. basicSetup, markdown())
		if (tmpCM.extensions && Array.isArray(tmpCM.extensions))
		{
			tmpExtensions = tmpExtensions.concat(tmpCM.extensions);
		}

		// Update listener for content changes, focus, and cursor tracking
		tmpExtensions.push(
			tmpCM.EditorView.updateListener.of((pUpdate) =>
			{
				if (pUpdate.docChanged)
				{
					pView._onSegmentContentChange(pSegmentIndex, pUpdate.state.doc.toString());
				}

				// Track focus changes to toggle the active class
				if (pUpdate.focusChanged)
				{
					if (pUpdate.view.hasFocus)
					{
						pView._setActiveSegment(pSegmentIndex);
						// Position sidebar at cursor on focus
						pView._updateSidebarPosition(pSegmentIndex);
					}
					else
					{
						// Small delay so clicking a sidebar button doesn't immediately deactivate
						setTimeout(() =>
						{
							if (pView._activeSegmentIndex === pSegmentIndex)
							{
								// Check if focus moved to another segment or truly left
								let tmpSegEl = document.getElementById(`PictMDE-Segment-${pSegmentIndex}`);
								if (tmpSegEl && !tmpSegEl.contains(document.activeElement))
								{
									pView._clearActiveSegment(pSegmentIndex);
									pView._resetSidebarPosition(pSegmentIndex);
								}
							}
						}, 100);
					}
				}

				// Track cursor/selection changes to move the sidebar
				if (pUpdate.selectionSet && pUpdate.view.hasFocus)
				{
					pView._updateSidebarPosition(pSegmentIndex);
				}
			})
		);

		// Collapse long data URIs in image markdown so the editor is readable
		let tmpCollapseExtension = pView._buildDataURICollapseExtension();
		if (tmpCollapseExtension)
		{
			tmpExtensions.push(tmpCollapseExtension);
		}

		// Make read-only if configured
		if (pView.options.ReadOnly)
		{
			tmpExtensions.push(tmpCM.EditorState.readOnly.of(true));
			tmpExtensions.push(tmpCM.EditorView.editable.of(false));
		}

		// Allow consumer to customize extensions
		tmpExtensions = pView.customConfigureExtensions(tmpExtensions, pSegmentIndex);

		let tmpState = tmpCM.EditorState.create(
		{
			doc: pContent || '',
			extensions: tmpExtensions
		});

		let tmpEditorView = new tmpCM.EditorView(
		{
			state: tmpState,
			parent: pContainer
		});

		pView._segmentEditors[pSegmentIndex] = tmpEditorView;

		// -- Inter-segment arrow-key navigation --
		// Use a capture-phase DOM listener so we intercept ArrowDown/ArrowUp
		// BEFORE CodeMirror's internal keymap handlers process them.
		tmpEditorView.contentDOM.addEventListener('keydown', function (pEvent)
		{
			if (pEvent.key !== 'ArrowDown' && pEvent.key !== 'ArrowUp')
			{
				return;
			}
			// Don't interfere if a modifier key is held (selection, etc.)
			if (pEvent.shiftKey || pEvent.ctrlKey || pEvent.metaKey || pEvent.altKey)
			{
				return;
			}

			let tmpState = tmpEditorView.state;
			let tmpCursorPos = tmpState.selection.main.head;
			let tmpLine = tmpState.doc.lineAt(tmpCursorPos);
			let tmpColumnOffset = tmpCursorPos - tmpLine.from;

			if (pEvent.key === 'ArrowDown')
			{
				// Only navigate when cursor is on the very last line
				if (tmpLine.to < tmpState.doc.length)
				{
					return; // not on last line — let CM handle it
				}

				// Find next segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex < 0 || tmpLogicalIndex >= tmpOrderedIndices.length - 1)
				{
					return; // last segment — nowhere to go
				}

				let tmpNextInternalIndex = tmpOrderedIndices[tmpLogicalIndex + 1];
				let tmpNextEditor = pView._segmentEditors[tmpNextInternalIndex];
				if (!tmpNextEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the next editor and place cursor on the first line
				let tmpFirstLine = tmpNextEditor.state.doc.line(1);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpFirstLine.to - tmpFirstLine.from);
				tmpNextEditor.focus();
				tmpNextEditor.dispatch({ selection: { anchor: tmpFirstLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpNextInternalIndex);
			}
			else if (pEvent.key === 'ArrowUp')
			{
				// Only navigate when cursor is on the very first line
				if (tmpLine.number > 1)
				{
					return; // not on first line — let CM handle it
				}

				// Find previous segment
				let tmpOrderedIndices = pView._getOrderedSegmentIndices();
				let tmpLogicalIndex = pView._getLogicalIndex(pSegmentIndex);
				if (tmpLogicalIndex <= 0)
				{
					return; // first segment — nowhere to go
				}

				let tmpPrevInternalIndex = tmpOrderedIndices[tmpLogicalIndex - 1];
				let tmpPrevEditor = pView._segmentEditors[tmpPrevInternalIndex];
				if (!tmpPrevEditor)
				{
					return;
				}

				pEvent.preventDefault();
				pEvent.stopPropagation();

				// Focus the previous editor and place cursor on the last line
				let tmpLastLine = tmpPrevEditor.state.doc.line(tmpPrevEditor.state.doc.lines);
				let tmpTargetCol = Math.min(tmpColumnOffset, tmpLastLine.to - tmpLastLine.from);
				tmpPrevEditor.focus();
				tmpPrevEditor.dispatch({ selection: { anchor: tmpLastLine.from + tmpTargetCol } });
				pView._setActiveSegment(tmpPrevInternalIndex);
			}
		}, true); // <-- capture phase

		// -- Capture-phase drop listener for image files --
		// Safari processes native contenteditable drops before CodeMirror's
		// bubble-phase domEventHandlers fire, which can insert a raw <img>
		// element into the editor DOM.  A capture-phase listener fires first
		// and lets us preventDefault() before the browser acts.
		tmpEditorView.contentDOM.addEventListener('drop', function (pEvent)
		{
			if (pView._dragSourceIndex >= 0)
			{
				return; // segment-reorder drag
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}
			let tmpFile = pEvent.dataTransfer.files[0];
			if (tmpFile.type && tmpFile.type.startsWith('image/'))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
				// Clean up the dragover visual indicator
				let tmpEditorEl = document.getElementById(`PictMDE-SegmentEditor-${pSegmentIndex}`);
				if (tmpEditorEl)
				{
					tmpEditorEl.classList.remove('pict-mde-image-dragover');
				}
			}
		}, true); // <-- capture phase
	};

	/**
	 * Build a CodeMirror extension that visually collapses long data URIs
	 * inside markdown image syntax.
	 *
	 * The extension uses Decoration.replace() to hide the long base64 portion
	 * and show a compact widget instead, e.g. "data:image/jpeg;base64...28KB".
	 * The actual document content is unchanged -- only the visual display
	 * is affected.
	 *
	 * Returns null if the required CodeMirror modules (Decoration, ViewPlugin,
	 * WidgetType) are not available.
	 *
	 * @returns {object|null} A CodeMirror ViewPlugin extension, or null
	 */
	pView._buildDataURICollapseExtension = function _buildDataURICollapseExtension()
	{
		let tmpCM = pView._codeMirrorModules;

		// All three classes are required -- degrade gracefully if not available
		if (!tmpCM || !tmpCM.Decoration || !tmpCM.ViewPlugin || !tmpCM.WidgetType)
		{
			return null;
		}

		let tmpDecoration = tmpCM.Decoration;
		let tmpViewPlugin = tmpCM.ViewPlugin;
		let tmpWidgetType = tmpCM.WidgetType;

		// Minimum data URI length before collapsing (short URIs are left alone)
		let tmpMinLength = 200;

		// Widget class: renders the collapsed placeholder inline
		class DataURIWidget extends tmpWidgetType
		{
			constructor(pLabel)
			{
				super();
				this.label = pLabel;
			}

			toDOM()
			{
				let tmpSpan = document.createElement('span');
				tmpSpan.className = 'pict-mde-data-uri-collapsed';
				tmpSpan.textContent = this.label;
				tmpSpan.title = 'Data URI (click to expand in image preview below)';
				return tmpSpan;
			}

			eq(pOther)
			{
				return this.label === pOther.label;
			}
		}

		/**
		 * Scan the visible ranges of the document for data URIs inside image
		 * markdown and build a DecorationSet that replaces the long portion.
		 *
		 * Pattern:  ![alt](data:image/TYPE;base64,LONGSTRING)
		 *
		 * We keep "![alt](data:image/TYPE;base64," visible and replace only the
		 * long base64 payload plus the closing ")" with a compact widget.
		 */
		function buildDecorations(pEditorView)
		{
			let tmpDecorations = [];
			let tmpDoc = pEditorView.state.doc;

			for (let tmpVisRange of pEditorView.visibleRanges)
			{
				let tmpFrom = tmpVisRange.from;
				let tmpTo = tmpVisRange.to;
				let tmpText = tmpDoc.sliceString(tmpFrom, tmpTo);

				// Match: ![...](data:image/...;base64,...) -- we need positions of the base64 payload
				let tmpRegex = /!\[[^\]]*\]\(data:([^;]+);base64,/g;
				let tmpMatch;

				while ((tmpMatch = tmpRegex.exec(tmpText)) !== null)
				{
					// tmpMatch[0] is "![alt](data:image/png;base64,"
					// tmpMatch[1] is the MIME subtype, e.g. "image/png"
					let tmpPayloadStart = tmpFrom + tmpMatch.index + tmpMatch[0].length;

					// Find the closing parenthesis -- scan forward from payloadStart
					let tmpPayloadEnd = -1;
					let tmpSearchFrom = tmpPayloadStart;
					let tmpDocLength = tmpDoc.length;

					// Scan character by character in the document for the closing ')'
					// We need to handle this carefully since the payload could be huge
					// and span beyond the visible range.
					// Search up to 5MB worth of characters (way more than any realistic image).
					let tmpMaxScan = Math.min(tmpDocLength, tmpSearchFrom + 5 * 1024 * 1024);
					let tmpChunkSize = 4096;

					for (let tmpPos = tmpSearchFrom; tmpPos < tmpMaxScan; tmpPos += tmpChunkSize)
					{
						let tmpEnd = Math.min(tmpPos + tmpChunkSize, tmpMaxScan);
						let tmpChunk = tmpDoc.sliceString(tmpPos, tmpEnd);
						let tmpParenIdx = tmpChunk.indexOf(')');
						if (tmpParenIdx >= 0)
						{
							tmpPayloadEnd = tmpPos + tmpParenIdx;
							break;
						}
					}

					if (tmpPayloadEnd < 0)
					{
						// No closing paren found -- skip this match
						continue;
					}

					// Calculate the payload length (base64 data between comma and closing paren)
					let tmpPayloadLength = tmpPayloadEnd - tmpPayloadStart;

					if (tmpPayloadLength < tmpMinLength)
					{
						// Too short to bother collapsing
						continue;
					}

					// Build a human-readable size label
					let tmpSizeBytes = Math.round(tmpPayloadLength * 0.75); // base64 to bytes approx
					let tmpSizeLabel;
					if (tmpSizeBytes >= 1024 * 1024)
					{
						tmpSizeLabel = (tmpSizeBytes / (1024 * 1024)).toFixed(1) + 'MB';
					}
					else if (tmpSizeBytes >= 1024)
					{
						tmpSizeLabel = Math.round(tmpSizeBytes / 1024) + 'KB';
					}
					else
					{
						tmpSizeLabel = tmpSizeBytes + 'B';
					}

					let tmpMimeType = tmpMatch[1] || 'image';
					let tmpWidgetLabel = `\u2026${tmpSizeLabel})`;

					// Replace from the start of the base64 payload to after the closing paren
					let tmpWidget = tmpDecoration.replace(
					{
						widget: new DataURIWidget(tmpWidgetLabel)
					});

					tmpDecorations.push(tmpWidget.range(tmpPayloadStart, tmpPayloadEnd + 1));
				}
			}

			return tmpDecoration.set(tmpDecorations, true);
		}

		// Create the ViewPlugin
		let tmpPlugin = tmpViewPlugin.fromClass(
			class
			{
				constructor(pEditorView)
				{
					this.decorations = buildDecorations(pEditorView);
				}

				update(pUpdate)
				{
					if (pUpdate.docChanged || pUpdate.viewportChanged)
					{
						this.decorations = buildDecorations(pUpdate.view);
					}
				}
			},
			{
				decorations: (pPlugin) => pPlugin.decorations
			}
		);

		return tmpPlugin;
	};
};

},{}],138:[function(require,module,exports){
/**
 * Pict-MDE-DragAndReorder: Helper module for PictSectionMarkdownEditor
 *
 * Handles segment drag-and-drop reordering, active segment management,
 * sidebar cursor-tracking positioning, and hidden-preview state maintenance
 * across reorder operations.
 */

/**
 * Attach drag/reorder and active-segment methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Wire drag-and-drop events on a segment element for reorder via the drag handle.
	 *
	 * @param {HTMLElement} pSegmentElement - The .pict-mde-segment element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._wireSegmentDragEvents = function _wireSegmentDragEvents(pSegmentElement, pSegmentIndex)
	{
		let tmpHandle = pSegmentElement.querySelector('.pict-mde-drag-handle');
		if (!tmpHandle)
		{
			return;
		}

		// The drag handle is the draggable element
		tmpHandle.addEventListener('dragstart', (pEvent) =>
		{
			pView._dragSourceIndex = pSegmentIndex;
			pEvent.dataTransfer.effectAllowed = 'move';
			pEvent.dataTransfer.setData('text/plain', String(pSegmentIndex));
			// Add a dragging class to the container so CSS can disable pointer-events
			// on CodeMirror editors (preventing them from intercepting the drop event)
			let tmpContainerEl = pView._getContainerElement();
			if (tmpContainerEl)
			{
				tmpContainerEl.classList.add('pict-mde-dragging');
			}
			setTimeout(() =>
			{
				pSegmentElement.style.opacity = '0.4';
			}, 0);
		});

		tmpHandle.addEventListener('dragend', () =>
		{
			pSegmentElement.style.opacity = '';
			pView._dragSourceIndex = -1;
			pView._clearAllDropIndicators();
			// Remove the dragging class from the container
			let tmpContainerEl = pView._getContainerElement();
			if (tmpContainerEl)
			{
				tmpContainerEl.classList.remove('pict-mde-dragging');
			}
		});

		// Drop target: the whole segment row. We determine above/below from mouse Y.
		pSegmentElement.addEventListener('dragover', (pEvent) =>
		{
			pEvent.preventDefault();
			pEvent.dataTransfer.dropEffect = 'move';

			// Clear all indicators first, then set the correct one
			pView._clearAllDropIndicators();

			// Determine if cursor is in the top or bottom half of this segment
			let tmpRect = pSegmentElement.getBoundingClientRect();
			let tmpMidY = tmpRect.top + (tmpRect.height / 2);
			if (pEvent.clientY < tmpMidY)
			{
				pSegmentElement.classList.add('pict-mde-drag-over-top');
			}
			else
			{
				pSegmentElement.classList.add('pict-mde-drag-over-bottom');
			}
		});

		pSegmentElement.addEventListener('dragleave', (pEvent) =>
		{
			// Only clear if we're actually leaving the element (not entering a child)
			if (!pSegmentElement.contains(pEvent.relatedTarget))
			{
				pSegmentElement.classList.remove('pict-mde-drag-over-top');
				pSegmentElement.classList.remove('pict-mde-drag-over-bottom');
			}
		});

		pSegmentElement.addEventListener('drop', (pEvent) =>
		{
			pEvent.preventDefault();

			let tmpDropBelow = pSegmentElement.classList.contains('pict-mde-drag-over-bottom');
			pView._clearAllDropIndicators();

			let tmpSourceIndex = pView._dragSourceIndex;
			if (tmpSourceIndex < 0 || tmpSourceIndex === pSegmentIndex)
			{
				return;
			}

			pView._reorderSegment(tmpSourceIndex, pSegmentIndex, tmpDropBelow);
		});
	};

	/**
	 * Clear all drop indicator classes from all segments.
	 */
	pView._clearAllDropIndicators = function _clearAllDropIndicators()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}
		let tmpAllSegments = tmpContainer.querySelectorAll('.pict-mde-segment');
		for (let i = 0; i < tmpAllSegments.length; i++)
		{
			tmpAllSegments[i].classList.remove('pict-mde-drag-over-top');
			tmpAllSegments[i].classList.remove('pict-mde-drag-over-bottom');
		}
	};

	/**
	 * Reorder a segment from one position to another via drag.
	 *
	 * @param {number} pFromInternalIndex - The internal index of the dragged segment
	 * @param {number} pToInternalIndex - The internal index of the drop target
	 * @param {boolean} pDropBelow - Whether the drop was on the bottom half of the target
	 */
	pView._reorderSegment = function _reorderSegment(pFromInternalIndex, pToInternalIndex, pDropBelow)
	{
		let tmpFromLogical = pView._getLogicalIndex(pFromInternalIndex);
		let tmpToLogical = pView._getLogicalIndex(pToInternalIndex);

		if (tmpFromLogical < 0 || tmpToLogical < 0)
		{
			pView.log.warn(`PICT-MarkdownEditor _reorderSegment: could not resolve logical indices (from=${tmpFromLogical}, to=${tmpToLogical}).`);
			return;
		}

		if (tmpFromLogical === tmpToLogical)
		{
			return;
		}

		// Marshal all editor content back to data before manipulating the array
		pView._marshalAllEditorsToData();

		let tmpSegments = pView._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length < 2)
		{
			return;
		}

		// Calculate the target insertion index
		let tmpInsertAt = pDropBelow ? tmpToLogical + 1 : tmpToLogical;

		// Adjust for the removal shifting indices down
		if (tmpFromLogical < tmpInsertAt)
		{
			tmpInsertAt--;
		}

		// If the insert position equals the source, no move needed
		if (tmpInsertAt === tmpFromLogical)
		{
			return;
		}

		// Perform the reorder: remove from old position, insert at new
		let tmpMoved = tmpSegments.splice(tmpFromLogical, 1)[0];
		tmpSegments.splice(tmpInsertAt, 0, tmpMoved);

		// Explicitly write the reordered array back to the data address
		pView._setSegmentsToData(tmpSegments);

		// Reorder per-segment hidden preview state to follow the moved segment
		pView._reorderHiddenPreviewState(tmpFromLogical, tmpInsertAt);

		// Reorder per-segment tab states to follow the moved segment
		pView._reorderSegmentTabStates(tmpFromLogical, tmpInsertAt);

		pView._buildEditorUI();
	};

	/**
	 * Reorder the hidden preview state after a splice-based move
	 * (remove from pFrom, insert at pTo).
	 *
	 * @param {number} pFrom - The logical index the segment was removed from
	 * @param {number} pTo - The logical index the segment was inserted at
	 */
	pView._reorderHiddenPreviewState = function _reorderHiddenPreviewState(pFrom, pTo)
	{
		if (pFrom === pTo)
		{
			return;
		}

		// Build an ordered array of hidden-state booleans
		let tmpKeys = Object.keys(pView._hiddenPreviewSegments).map((k) => parseInt(k, 10));
		if (tmpKeys.length === 0)
		{
			return;
		}

		let tmpMaxIndex = Math.max(...tmpKeys, pFrom, pTo);
		let tmpStates = [];
		for (let i = 0; i <= tmpMaxIndex; i++)
		{
			tmpStates.push(!!pView._hiddenPreviewSegments[i]);
		}

		// Perform the same splice on the states array
		let tmpMovedState = tmpStates.splice(pFrom, 1)[0];
		tmpStates.splice(pTo, 0, tmpMovedState);

		// Rebuild the hidden map
		pView._hiddenPreviewSegments = {};
		for (let i = 0; i < tmpStates.length; i++)
		{
			if (tmpStates[i])
			{
				pView._hiddenPreviewSegments[i] = true;
			}
		}
	};

	/**
	 * Swap the hidden preview state of two logical indices.
	 * Used when moveSegmentUp/Down swaps adjacent segments.
	 *
	 * @param {number} pIndexA - First logical index
	 * @param {number} pIndexB - Second logical index
	 */
	pView._swapHiddenPreviewState = function _swapHiddenPreviewState(pIndexA, pIndexB)
	{
		let tmpAHidden = !!pView._hiddenPreviewSegments[pIndexA];
		let tmpBHidden = !!pView._hiddenPreviewSegments[pIndexB];

		if (tmpBHidden) { pView._hiddenPreviewSegments[pIndexA] = true; }
		else { delete pView._hiddenPreviewSegments[pIndexA]; }

		if (tmpAHidden) { pView._hiddenPreviewSegments[pIndexB] = true; }
		else { delete pView._hiddenPreviewSegments[pIndexB]; }
	};

	/**
	 * Reorder the segment tab states after a splice-based move
	 * (remove from pFrom, insert at pTo).
	 *
	 * @param {number} pFrom - The logical index the segment was removed from
	 * @param {number} pTo - The logical index the segment was inserted at
	 */
	pView._reorderSegmentTabStates = function _reorderSegmentTabStates(pFrom, pTo)
	{
		if (pFrom === pTo)
		{
			return;
		}

		let tmpKeys = Object.keys(pView._segmentTabStates).map((k) => parseInt(k, 10));
		if (tmpKeys.length === 0)
		{
			return;
		}

		let tmpMaxIndex = Math.max(...tmpKeys, pFrom, pTo);
		let tmpStates = [];
		for (let i = 0; i <= tmpMaxIndex; i++)
		{
			tmpStates.push(pView._segmentTabStates[i] || 'editor');
		}

		let tmpMovedState = tmpStates.splice(pFrom, 1)[0];
		tmpStates.splice(pTo, 0, tmpMovedState);

		pView._segmentTabStates = {};
		for (let i = 0; i < tmpStates.length; i++)
		{
			if (tmpStates[i] !== 'editor')
			{
				pView._segmentTabStates[i] = tmpStates[i];
			}
		}
	};

	/**
	 * Swap the segment tab states of two logical indices.
	 * Used when moveSegmentUp/Down swaps adjacent segments.
	 *
	 * @param {number} pIndexA - First logical index
	 * @param {number} pIndexB - Second logical index
	 */
	pView._swapSegmentTabStates = function _swapSegmentTabStates(pIndexA, pIndexB)
	{
		let tmpA = pView._segmentTabStates[pIndexA] || 'editor';
		let tmpB = pView._segmentTabStates[pIndexB] || 'editor';

		if (tmpB !== 'editor') { pView._segmentTabStates[pIndexA] = tmpB; }
		else { delete pView._segmentTabStates[pIndexA]; }

		if (tmpA !== 'editor') { pView._segmentTabStates[pIndexB] = tmpA; }
		else { delete pView._segmentTabStates[pIndexB]; }
	};

	// -- Active Segment Management --

	/**
	 * Set a segment as the active (focused) segment.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._setActiveSegment = function _setActiveSegment(pSegmentIndex)
	{
		// Clear previous active
		if (pView._activeSegmentIndex >= 0 && pView._activeSegmentIndex !== pSegmentIndex)
		{
			let tmpPrevEl = document.getElementById(`PictMDE-Segment-${pView._activeSegmentIndex}`);
			if (tmpPrevEl)
			{
				tmpPrevEl.classList.remove('pict-mde-active');
			}
		}

		pView._activeSegmentIndex = pSegmentIndex;

		let tmpSegEl = document.getElementById(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegEl)
		{
			tmpSegEl.classList.add('pict-mde-active');
		}
	};

	/**
	 * Clear the active state from a segment (on blur).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._clearActiveSegment = function _clearActiveSegment(pSegmentIndex)
	{
		if (pView._activeSegmentIndex === pSegmentIndex)
		{
			pView._activeSegmentIndex = -1;
		}

		let tmpSegEl = document.getElementById(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegEl)
		{
			tmpSegEl.classList.remove('pict-mde-active');
		}

		// Reset sidebar back to sticky when segment is no longer active
		pView._resetSidebarPosition(pSegmentIndex);
	};

	// -- Sidebar Cursor Tracking --

	/**
	 * Update the sidebar formatting-buttons position so they float next to the
	 * cursor / selection in the active segment.
	 *
	 * When a segment is active and has a cursor, we switch the sidebar-actions
	 * from sticky positioning to absolute, offset to align with the cursor line.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateSidebarPosition = function _updateSidebarPosition(pSegmentIndex)
	{
		let tmpSegmentEl = document.getElementById(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		let tmpQuadrantTR = tmpSegmentEl.querySelector('.pict-mde-quadrant-tr');
		if (!tmpQuadrantTR)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			return;
		}

		// Get the cursor position in the editor
		let tmpCursorPos = tmpEditor.state.selection.main.head;
		let tmpCursorCoords = tmpEditor.coordsAtPos(tmpCursorPos);
		if (!tmpCursorCoords)
		{
			// If we can't get coords, revert to sticky
			pView._resetSidebarPosition(pSegmentIndex);
			return;
		}

		// Calculate the offset relative to the segment element
		let tmpSegmentRect = tmpSegmentEl.getBoundingClientRect();
		let tmpOffsetTop = tmpCursorCoords.top - tmpSegmentRect.top;

		// Clamp so the sidebar buttons don't go above the segment or below it
		let tmpSidebarHeight = tmpQuadrantTR.offsetHeight || 0;
		let tmpSegmentHeight = tmpSegmentEl.offsetHeight || 0;
		let tmpMaxOffset = Math.max(0, tmpSegmentHeight - tmpSidebarHeight);
		tmpOffsetTop = Math.max(0, Math.min(tmpOffsetTop, tmpMaxOffset));

		// Apply the cursor-relative positioning
		tmpQuadrantTR.classList.add('pict-mde-sidebar-at-cursor');
		tmpQuadrantTR.style.setProperty('--pict-mde-sidebar-top', `${tmpOffsetTop}px`);
	};

	/**
	 * Reset the sidebar back to default sticky positioning (no cursor tracking).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._resetSidebarPosition = function _resetSidebarPosition(pSegmentIndex)
	{
		let tmpSegmentEl = document.getElementById(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		let tmpQuadrantTR = tmpSegmentEl.querySelector('.pict-mde-quadrant-tr');
		if (!tmpQuadrantTR)
		{
			return;
		}

		tmpQuadrantTR.classList.remove('pict-mde-sidebar-at-cursor');
		tmpQuadrantTR.style.removeProperty('--pict-mde-sidebar-top');
	};
};

},{}],139:[function(require,module,exports){
/**
 * Pict-MDE-Formatting: Helper module for PictSectionMarkdownEditor
 *
 * Handles markdown formatting operations (bold, italic, code, heading, link)
 * applied to selections or at the cursor position in CodeMirror editors.
 */

// Markdown formatting definitions: wrapper characters for toggle-style formatting
const _FormattingMap =
{
	bold: { wrap: '**' },
	italic: { wrap: '*' },
	code: { wrap: '`' },
	heading: { prefix: '# ' },
	link: { before: '[', after: '](url)' }
};

/**
 * Attach formatting methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Apply markdown formatting to the selection (or insert formatting at cursor)
	 * in a specific segment.
	 *
	 * If text is selected, wraps it.  If no selection, inserts the formatting
	 * markers and places the cursor between them.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pFormatType - One of: 'bold', 'italic', 'code', 'heading', 'link'
	 */
	pView.applyFormatting = function applyFormatting(pSegmentIndex, pFormatType)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor applyFormatting: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpFormat = _FormattingMap[pFormatType];
		if (!tmpFormat)
		{
			pView.log.warn(`PICT-MarkdownEditor applyFormatting: unknown format type "${pFormatType}".`);
			return;
		}

		let tmpState = tmpEditor.state;
		let tmpSelection = tmpState.selection.main;
		let tmpFrom = tmpSelection.from;
		let tmpTo = tmpSelection.to;
		let tmpHasSelection = (tmpFrom !== tmpTo);
		let tmpSelectedText = tmpHasSelection ? tmpState.sliceDoc(tmpFrom, tmpTo) : '';

		let tmpChanges;
		let tmpCursorPos;

		if (tmpFormat.wrap)
		{
			// Toggle-style: wrap selection or insert empty wrapper
			let tmpWrap = tmpFormat.wrap;
			if (tmpHasSelection)
			{
				// Check if already wrapped — if so, unwrap
				let tmpBefore = tmpState.sliceDoc(Math.max(0, tmpFrom - tmpWrap.length), tmpFrom);
				let tmpAfter = tmpState.sliceDoc(tmpTo, Math.min(tmpState.doc.length, tmpTo + tmpWrap.length));

				if (tmpBefore === tmpWrap && tmpAfter === tmpWrap)
				{
					// Unwrap
					tmpChanges = [
						{ from: tmpFrom - tmpWrap.length, to: tmpFrom, insert: '' },
						{ from: tmpTo, to: tmpTo + tmpWrap.length, insert: '' }
					];
					tmpCursorPos = tmpFrom - tmpWrap.length;
					tmpEditor.dispatch(
					{
						changes: tmpChanges,
						selection: { anchor: tmpCursorPos, head: tmpCursorPos + tmpSelectedText.length }
					});
					return;
				}

				// Wrap the selection
				let tmpInsert = tmpWrap + tmpSelectedText + tmpWrap;
				tmpChanges = { from: tmpFrom, to: tmpTo, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpWrap.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos, head: tmpCursorPos + tmpSelectedText.length }
				});
			}
			else
			{
				// No selection: insert empty wrapper and place cursor inside
				let tmpInsert = tmpWrap + tmpWrap;
				tmpChanges = { from: tmpFrom, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpWrap.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos }
				});
			}
		}
		else if (tmpFormat.prefix)
		{
			// Line-prefix style (headings)
			let tmpLine = tmpState.doc.lineAt(tmpFrom);
			let tmpLineText = tmpLine.text;

			// Toggle: if line already starts with the prefix, remove it; otherwise add
			if (tmpLineText.startsWith(tmpFormat.prefix))
			{
				tmpChanges = { from: tmpLine.from, to: tmpLine.from + tmpFormat.prefix.length, insert: '' };
			}
			else
			{
				tmpChanges = { from: tmpLine.from, insert: tmpFormat.prefix };
			}
			tmpEditor.dispatch({ changes: tmpChanges });
		}
		else if (tmpFormat.before && tmpFormat.after)
		{
			// Surround style (links)
			if (tmpHasSelection)
			{
				let tmpInsert = tmpFormat.before + tmpSelectedText + tmpFormat.after;
				tmpChanges = { from: tmpFrom, to: tmpTo, insert: tmpInsert };
				// Place cursor on the "url" part
				tmpCursorPos = tmpFrom + tmpFormat.before.length + tmpSelectedText.length + 2;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos, head: tmpCursorPos + 3 }
				});
			}
			else
			{
				let tmpInsert = tmpFormat.before + tmpFormat.after;
				tmpChanges = { from: tmpFrom, insert: tmpInsert };
				tmpCursorPos = tmpFrom + tmpFormat.before.length;
				tmpEditor.dispatch(
				{
					changes: tmpChanges,
					selection: { anchor: tmpCursorPos }
				});
			}
		}

		// Re-focus the editor after clicking a sidebar button
		tmpEditor.focus();
	};
};

},{}],140:[function(require,module,exports){
/**
 * Pict-MDE-ImageHandling: Helper module for PictSectionMarkdownEditor
 *
 * Handles image operations: file picker, file processing (hook or base64
 * fallback), markdown insertion, preview thumbnail rendering, and
 * drag-and-drop for image files onto the editor.
 */

/**
 * Attach image handling methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Open a file picker to select an image for insertion into a segment.
	 * Called by the sidebar image button onclick handler.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView.openImagePicker = function openImagePicker(pSegmentIndex)
	{
		let tmpFileInput = document.getElementById(`PictMDE-ImageInput-${pSegmentIndex}`);
		if (!tmpFileInput)
		{
			pView.log.warn(`PICT-MarkdownEditor openImagePicker: file input not found for segment ${pSegmentIndex}.`);
			return;
		}

		// Wire the change handler fresh each time (in case it was already used)
		tmpFileInput.onchange = () =>
		{
			if (tmpFileInput.files && tmpFileInput.files.length > 0)
			{
				pView._processImageFile(tmpFileInput.files[0], pSegmentIndex);
			}
			// Reset the input so the same file can be re-selected
			tmpFileInput.value = '';
		};

		tmpFileInput.click();
	};

	/**
	 * Process an image File object from any input method (picker, drag, paste).
	 *
	 * If the consumer has overridden onImageUpload and it returns true, the
	 * consumer handles the upload and calls the callback with a URL.
	 * Otherwise, the image is converted to a base64 data URI inline.
	 *
	 * @param {File} pFile - The image File object
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._processImageFile = function _processImageFile(pFile, pSegmentIndex)
	{
		if (!pFile || !pFile.type || !pFile.type.startsWith('image/'))
		{
			pView.log.warn(`PICT-MarkdownEditor _processImageFile: not an image file (type: ${pFile ? pFile.type : 'null'}).`);
			return;
		}

		let tmpAltText = pFile.name ? pFile.name.replace(/\.[^.]+$/, '') : 'image';

		// Check if the consumer wants to handle the upload
		let tmpCallback = (pError, pURL) =>
		{
			if (pError)
			{
				pView.log.error(`PICT-MarkdownEditor image upload error: ${pError}`);
				return;
			}
			if (pURL)
			{
				pView._insertImageMarkdown(pSegmentIndex, pURL, tmpAltText);
			}
		};

		let tmpHandled = pView.onImageUpload(pFile, pSegmentIndex, tmpCallback);

		if (tmpHandled)
		{
			// Consumer is handling the upload asynchronously
			return;
		}

		// Default: convert to base64 data URI
		if (typeof (FileReader) === 'undefined')
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader not available in this environment.`);
			return;
		}

		let tmpReader = new FileReader();
		tmpReader.onload = () =>
		{
			pView._insertImageMarkdown(pSegmentIndex, tmpReader.result, tmpAltText);
		};
		tmpReader.onerror = () =>
		{
			pView.log.error(`PICT-MarkdownEditor _processImageFile: FileReader error.`);
		};
		tmpReader.readAsDataURL(pFile);
	};

	/**
	 * Insert markdown image syntax at the cursor position in a segment editor.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pURL - The image URL (data URI or remote URL)
	 * @param {string} [pAltText] - The alt text (default: 'image')
	 */
	pView._insertImageMarkdown = function _insertImageMarkdown(pSegmentIndex, pURL, pAltText)
	{
		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			pView.log.warn(`PICT-MarkdownEditor _insertImageMarkdown: no editor for segment ${pSegmentIndex}.`);
			return;
		}

		let tmpAlt = pAltText || 'image';
		let tmpInsert = `![${tmpAlt}](${pURL})`;

		let tmpState = tmpEditor.state;
		let tmpCursorPos = tmpState.selection.main.head;

		tmpEditor.dispatch(
		{
			changes: { from: tmpCursorPos, insert: tmpInsert },
			selection: { anchor: tmpCursorPos + tmpInsert.length }
		});

		tmpEditor.focus();

		// Update the image preview area for this segment
		pView._updateImagePreviews(pSegmentIndex);
	};

	/**
	 * Scan the content of a segment for markdown image references and render
	 * preview thumbnails in the preview area below the editor.
	 *
	 * Matches the pattern ![alt](url) and creates <img> elements for each.
	 * The preview area is hidden when there are no images.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateImagePreviews = function _updateImagePreviews(pSegmentIndex)
	{
		let tmpPreviewEl = document.getElementById(`PictMDE-ImagePreview-${pSegmentIndex}`);
		if (!tmpPreviewEl)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		let tmpContent = tmpEditor.state.doc.toString();

		// Match markdown image syntax: ![alt text](url)
		let tmpImageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
		let tmpMatches = [];
		let tmpMatch;
		while ((tmpMatch = tmpImageRegex.exec(tmpContent)) !== null)
		{
			tmpMatches.push(
			{
				alt: tmpMatch[1] || 'image',
				url: tmpMatch[2]
			});
		}

		if (tmpMatches.length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-images');
			return;
		}

		// Build preview HTML
		let tmpHTML = '';
		for (let i = 0; i < tmpMatches.length; i++)
		{
			let tmpAlt = tmpMatches[i].alt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
			let tmpResolvedURL = pView._resolveImageURL(tmpMatches[i].url);
			let tmpURL = tmpResolvedURL.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
			tmpHTML += `<div class="pict-mde-image-preview-item"><img src="${tmpURL}" alt="${tmpAlt}" /><span class="pict-mde-image-preview-label">${tmpAlt}</span></div>`;
		}

		tmpPreviewEl.innerHTML = tmpHTML;
		tmpPreviewEl.classList.add('pict-mde-has-images');
	};

	/**
	 * Wire drag-and-drop events for image files on a segment editor container.
	 *
	 * These events are separate from the segment-reorder drag events.
	 * File drags are distinguished from segment reorder drags by checking
	 * dataTransfer.types for 'Files' and ensuring _dragSourceIndex is -1.
	 *
	 * @param {HTMLElement} pEditorContainer - The .pict-mde-segment-editor element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._wireImageDragEvents = function _wireImageDragEvents(pEditorContainer, pSegmentIndex)
	{
		pEditorContainer.addEventListener('dragover', (pEvent) =>
		{
			// Only handle file drags, not segment-reorder drags
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.types || pEvent.dataTransfer.types.indexOf('Files') < 0)
			{
				return;
			}
			pEvent.preventDefault();
			pEvent.dataTransfer.dropEffect = 'copy';
			pEditorContainer.classList.add('pict-mde-image-dragover');
		});

		pEditorContainer.addEventListener('dragleave', (pEvent) =>
		{
			// Only clear if actually leaving the element
			if (!pEditorContainer.contains(pEvent.relatedTarget))
			{
				pEditorContainer.classList.remove('pict-mde-image-dragover');
			}
		});

		pEditorContainer.addEventListener('drop', (pEvent) =>
		{
			pEditorContainer.classList.remove('pict-mde-image-dragover');

			// Only handle file drops, not segment-reorder drops
			if (pView._dragSourceIndex >= 0)
			{
				return;
			}
			if (!pEvent.dataTransfer || !pEvent.dataTransfer.files || pEvent.dataTransfer.files.length < 1)
			{
				return;
			}

			let tmpFile = pEvent.dataTransfer.files[0];
			if (tmpFile.type && tmpFile.type.startsWith('image/'))
			{
				pEvent.preventDefault();
				pEvent.stopPropagation();
				pView._processImageFile(tmpFile, pSegmentIndex);
			}
		});
	};
};

},{}],141:[function(require,module,exports){
/**
 * Pict-MDE-RichPreview: Helper module for PictSectionMarkdownEditor
 *
 * Handles rich content preview rendering via pict-section-content:
 * markdown-to-HTML parsing, mermaid diagram rendering, KaTeX math
 * rendering, and the full rendered-view toggle.
 */

const libPictSectionContent = require('pict-section-content');
const libPictContentProvider = libPictSectionContent.PictContentProvider;

/**
 * Attach rich preview methods to the view instance.
 *
 * @param {object} pView - The PictSectionMarkdownEditor instance
 */
module.exports.attach = function attach(pView)
{
	/**
	 * Get the pict-section-content provider instance for markdown parsing.
	 * Lazily instantiated on first use.
	 *
	 * @returns {object} The PictContentProvider instance
	 */
	pView._getContentProvider = function _getContentProvider()
	{
		if (!pView._contentProvider)
		{
			pView._contentProvider = new libPictContentProvider(pView.fable, {}, 'Pict-Content-Provider-MDE');
		}
		return pView._contentProvider;
	};

	/**
	 * Render the raw markdown content of a segment into the rich preview area
	 * using pict-section-content's parseMarkdown() provider method.
	 *
	 * The rendered HTML includes syntax-highlighted code blocks, mermaid diagram
	 * placeholders, KaTeX math placeholders, headings, lists, tables, etc.
	 *
	 * After setting innerHTML, post-render hooks call mermaid.run() and
	 * katex.render() to activate diagrams and equations (if those libraries
	 * are available on window -- loaded by the consumer via CDN).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	pView._updateRichPreviews = function _updateRichPreviews(pSegmentIndex)
	{
		if (!pView.options.EnableRichPreview)
		{
			return;
		}

		let tmpPreviewEl = document.getElementById(`PictMDE-RichPreview-${pSegmentIndex}`);
		if (!tmpPreviewEl)
		{
			return;
		}

		let tmpEditor = pView._segmentEditors[pSegmentIndex];
		if (!tmpEditor)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		let tmpContent = tmpEditor.state.doc.toString();

		if (!tmpContent || tmpContent.trim().length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		// Use pict-section-content's provider to parse the raw markdown into HTML.
		// If a Vocabulary provider is registered on the pict instance,
		// pass its resolver so vocabulary terms auto-link in the preview.
		let tmpProvider = pView._getContentProvider();
		let tmpVocabResolver = null;
		if (pView.pict && pView.pict.providers && pView.pict.providers.Vocabulary
			&& typeof pView.pict.providers.Vocabulary.getResolver === 'function')
		{
			tmpVocabResolver = pView.pict.providers.Vocabulary.getResolver();
		}
		let tmpRenderedHTML = tmpProvider.parseMarkdown(tmpContent, null, null, tmpVocabResolver);

		if (!tmpRenderedHTML || tmpRenderedHTML.trim().length === 0)
		{
			tmpPreviewEl.innerHTML = '';
			tmpPreviewEl.classList.remove('pict-mde-has-rich-preview');
			return;
		}

		// Wrap the rendered HTML in a pict-content container so that
		// pict-section-content's CSS classes take effect
		let tmpPreviewID = `PictMDE-RichPreviewBody-${pSegmentIndex}`;
		tmpPreviewEl.innerHTML = `<div class="pict-content" id="${tmpPreviewID}">${tmpRenderedHTML}</div>`;
		tmpPreviewEl.classList.add('pict-mde-has-rich-preview');

		// Wire vocabulary popover hover handlers if the provider is available
		if (pView.pict && pView.pict.providers && pView.pict.providers.Vocabulary
			&& typeof pView.pict.providers.Vocabulary.wirePopovers === 'function')
		{
			pView.pict.providers.Vocabulary.wirePopovers('#' + tmpPreviewID);
		}

		// Resolve relative image URLs in the rendered HTML using ImageBaseURL
		if (pView.options.ImageBaseURL)
		{
			let tmpImages = tmpPreviewEl.querySelectorAll('img');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpSrc = tmpImages[i].getAttribute('src');
				if (tmpSrc)
				{
					let tmpResolved = pView._resolveImageURL(tmpSrc);
					if (tmpResolved !== tmpSrc)
					{
						tmpImages[i].setAttribute('src', tmpResolved);
					}
				}
			}
		}

		// Bump generation counter for stale-render protection (mermaid is async)
		let tmpGeneration = (pView._richPreviewGenerations[pSegmentIndex] || 0) + 1;
		pView._richPreviewGenerations[pSegmentIndex] = tmpGeneration;

		// Post-render: call mermaid.run() for mermaid diagram elements
		pView._postRenderMermaid(tmpPreviewID, pSegmentIndex, tmpGeneration);

		// Post-render: call katex.render() for KaTeX math elements
		pView._postRenderKaTeX(tmpPreviewID);
	};

	/**
	 * Lazily bind the shared Theme-Diagram-Adapter for mermaid.  The
	 * adapter handles mermaid.initialize() against the active pict
	 * theme, subscribes to onApply, and re-renders existing diagrams
	 * when the theme/mode changes.  Idempotent.
	 *
	 * Falls back to a direct-require path when no theme provider is
	 * installed — the static base theme still picks up any CSS
	 * variables on :root.
	 */
	pView._ensureMermaidAdapter = function _ensureMermaidAdapter()
	{
		if (pView._mermaidAdapter) { return pView._mermaidAdapter; }
		if (typeof mermaid === 'undefined' || typeof window === 'undefined') { return null; }
		let tmpProvider = pView.pict && pView.pict.providers && pView.pict.providers.Theme;
		try
		{
			if (tmpProvider && tmpProvider.diagram && typeof tmpProvider.diagram.adaptMermaid === 'function')
			{
				pView._mermaidAdapter = tmpProvider.diagram.adaptMermaid(mermaid, {});
			}
			else
			{
				let libDiagramAdapter = require('pict-provider-theme/source/Theme-Diagram-Adapter.js');
				libDiagramAdapter.initializeMermaid(mermaid);
				pView._mermaidAdapter =
				{
					refresh: function () { return libDiagramAdapter.refreshMermaidDiagrams(); },
					reinitialize: function () { libDiagramAdapter.initializeMermaid(mermaid); },
					dispose: function () {},
					subscribed: false
				};
			}
		}
		catch (pError)
		{
			pView.log.warn(`PICT-MarkdownEditor mermaid theme adapter init failed: ${pError.message || pError}`);
			pView._mermaidAdapter = null;
		}
		return pView._mermaidAdapter;
	};

	/**
	 * Post-render hook: render Mermaid diagrams in the preview container.
	 * Uses the same approach as pict-section-content's renderMermaidDiagrams().
	 *
	 * @param {string} pContainerID - The container element ID
	 * @param {number} pSegmentIndex - The segment index (for stale-render protection)
	 * @param {number} pGeneration - The generation counter value
	 */
	pView._postRenderMermaid = function _postRenderMermaid(pContainerID, pSegmentIndex, pGeneration)
	{
		if (typeof mermaid === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById(pContainerID);
		if (!tmpContainer)
		{
			return;
		}

		let tmpMermaidElements = tmpContainer.querySelectorAll('pre.mermaid');
		if (tmpMermaidElements.length < 1)
		{
			return;
		}

		// First-time setup: bind the shared Theme-Diagram-Adapter so mermaid
		// follows the active palette and re-renders when the theme/mode
		// changes (manual toggle or OS-driven via prefers-color-scheme).
		pView._ensureMermaidAdapter();

		// Cache each diagram's source on the element. mermaid.run()
		// replaces textContent with the rendered SVG; the cache lets
		// the adapter's refresh re-run without re-parsing markdown.
		let tmpProviderForStash = pView.pict && pView.pict.providers && pView.pict.providers.Theme;
		if (tmpProviderForStash && tmpProviderForStash.diagram && typeof tmpProviderForStash.diagram.stashMermaidSource === 'function')
		{
			tmpProviderForStash.diagram.stashMermaidSource(tmpMermaidElements);
		}
		else
		{
			for (let i = 0; i < tmpMermaidElements.length; i++)
			{
				let tmpEl = tmpMermaidElements[i];
				if (!tmpEl.hasAttribute('data-mermaid-source'))
				{
					tmpEl.setAttribute('data-mermaid-source', tmpEl.textContent);
				}
			}
		}

		try
		{
			let tmpPromise = mermaid.run({ nodes: tmpMermaidElements });
			if (tmpPromise && typeof tmpPromise.catch === 'function')
			{
				tmpPromise.catch((pError) =>
				{
					// Check stale-render: rendered view uses _renderedViewGeneration,
					// per-segment previews use _richPreviewGenerations
					let tmpCurrentGen = (pSegmentIndex === -1)
						? pView._renderedViewGeneration
						: pView._richPreviewGenerations[pSegmentIndex];
					if (tmpCurrentGen !== pGeneration)
					{
						return; // stale render -- a newer update has replaced us
					}
					pView.log.warn(`PICT-MarkdownEditor mermaid render error: ${pError.message || pError}`);
				});
			}
		}
		catch (pError)
		{
			pView.log.warn(`PICT-MarkdownEditor mermaid render error: ${pError.message || pError}`);
		}
	};

	/**
	 * Post-render hook: render KaTeX inline and display math in the preview container.
	 * Uses the same approach as pict-section-content's renderKaTeXEquations().
	 *
	 * @param {string} pContainerID - The container element ID
	 */
	pView._postRenderKaTeX = function _postRenderKaTeX(pContainerID)
	{
		if (typeof katex === 'undefined')
		{
			return;
		}

		let tmpContainer = document.getElementById(pContainerID);
		if (!tmpContainer)
		{
			return;
		}

		// Render inline math: <span class="pict-content-katex-inline">
		let tmpInlineElements = tmpContainer.querySelectorAll('.pict-content-katex-inline');
		for (let i = 0; i < tmpInlineElements.length; i++)
		{
			try
			{
				katex.render(tmpInlineElements[i].textContent, tmpInlineElements[i], { throwOnError: false, displayMode: false });
			}
			catch (pError)
			{
				pView.log.warn(`PICT-MarkdownEditor KaTeX inline error: ${pError.message || pError}`);
			}
		}

		// Render display math: <div class="pict-content-katex-display">
		let tmpDisplayElements = tmpContainer.querySelectorAll('.pict-content-katex-display');
		for (let i = 0; i < tmpDisplayElements.length; i++)
		{
			try
			{
				katex.render(tmpDisplayElements[i].textContent, tmpDisplayElements[i], { throwOnError: false, displayMode: true });
			}
			catch (pError)
			{
				pView.log.warn(`PICT-MarkdownEditor KaTeX display error: ${pError.message || pError}`);
			}
		}
	};

	/**
	 * Simple HTML escape for error messages in the rich preview.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string}
	 */
	pView._escapeHTMLForPreview = function _escapeHTMLForPreview(pText)
	{
		return pText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	};

	// -- Rendered View (full document preview) --

	/**
	 * Toggle between the editing view (CodeMirror segments) and a fully rendered
	 * view of the combined markdown output using pict-section-content.
	 *
	 * @param {boolean} [pRendered] - If provided, set to this value; otherwise toggle
	 */
	pView.toggleRenderedView = function toggleRenderedView(pRendered)
	{
		if (typeof (pRendered) === 'boolean')
		{
			pView._renderedViewActive = pRendered;
		}
		else
		{
			pView._renderedViewActive = !pView._renderedViewActive;
		}

		if (pView._renderedViewActive)
		{
			pView._renderRenderedView();
		}
		else
		{
			pView._restoreEditingView();
		}
	};

	/**
	 * Switch to the rendered view: marshal all editors, combine all segment
	 * content, render to HTML via pict-section-content, and replace the
	 * container contents with the rendered output.
	 */
	pView._renderRenderedView = function _renderRenderedView()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}

		// Marshal current editor content back to data before switching
		pView._marshalAllEditorsToData();

		// Combine all segments into a single markdown document
		let tmpSegments = pView._getSegmentsFromData();
		let tmpCombinedContent = '';
		if (tmpSegments && tmpSegments.length > 0)
		{
			let tmpParts = [];
			for (let i = 0; i < tmpSegments.length; i++)
			{
				tmpParts.push(tmpSegments[i].Content || '');
			}
			tmpCombinedContent = tmpParts.join('\n\n');
		}

		// Destroy existing CodeMirror editors
		for (let tmpIdx in pView._segmentEditors)
		{
			if (pView._segmentEditors[tmpIdx])
			{
				pView._segmentEditors[tmpIdx].destroy();
			}
		}
		pView._segmentEditors = {};

		// Render the combined markdown via pict-section-content
		let tmpProvider = pView._getContentProvider();
		let tmpRenderedHTML = tmpProvider.parseMarkdown(tmpCombinedContent);

		// Build the rendered view container
		let tmpRenderedViewID = 'PictMDE-RenderedView';
		tmpContainer.innerHTML = `<div class="pict-mde-rendered-view" id="${tmpRenderedViewID}"><div class="pict-content">${tmpRenderedHTML || ''}</div></div>`;
		tmpContainer.classList.add('pict-mde-rendered-mode');

		// Resolve relative image URLs in the rendered HTML using ImageBaseURL
		if (pView.options.ImageBaseURL)
		{
			let tmpImages = tmpContainer.querySelectorAll('.pict-mde-rendered-view img');
			for (let i = 0; i < tmpImages.length; i++)
			{
				let tmpSrc = tmpImages[i].getAttribute('src');
				if (tmpSrc)
				{
					let tmpResolved = pView._resolveImageURL(tmpSrc);
					if (tmpResolved !== tmpSrc)
					{
						tmpImages[i].setAttribute('src', tmpResolved);
					}
				}
			}
		}

		// Bump generation for stale-render protection
		pView._renderedViewGeneration++;
		let tmpGeneration = pView._renderedViewGeneration;

		// Post-render hooks for mermaid diagrams and KaTeX equations
		let tmpContentContainer = tmpContainer.querySelector(`#${tmpRenderedViewID} .pict-content`);
		if (tmpContentContainer)
		{
			let tmpContentID = 'PictMDE-RenderedViewContent';
			tmpContentContainer.id = tmpContentID;

			pView._postRenderMermaid(tmpContentID, -1, tmpGeneration);
			pView._postRenderKaTeX(tmpContentID);
		}
	};

	/**
	 * Switch back from rendered view to the editing view: rebuild the
	 * full editor UI from the data.
	 */
	pView._restoreEditingView = function _restoreEditingView()
	{
		let tmpContainer = pView._getContainerElement();
		if (!tmpContainer)
		{
			return;
		}

		tmpContainer.classList.remove('pict-mde-rendered-mode');
		pView._buildEditorUI();
	};
};

},{"pict-provider-theme/source/Theme-Diagram-Adapter.js":13,"pict-section-content":133}],142:[function(require,module,exports){
module.exports = (
{
	"DefaultRenderable": "MarkdownEditor-Wrap",
	"DefaultDestinationAddress": "#MarkdownEditor-Container-Div",

	"Templates":
	[
		{
			"Hash": "MarkdownEditor-Container",
			"Template": /*html*/`<div class="pict-mde" id="PictMDE-Container"></div>`
		},
		{
			"Hash": "MarkdownEditor-Segment",
			"Template": /*html*/`<div class="pict-mde-segment" id="PictMDE-Segment-{~D:Record.SegmentIndex~}" data-segment-index="{~D:Record.SegmentIndex~}">
	<div class="pict-mde-left-controls">
		<div class="pict-mde-quadrant-tl"></div>
		<div class="pict-mde-quadrant-bl"></div>
	</div>
	<div class="pict-mde-drag-handle" draggable="true" title="Drag to reorder"></div>
	<div class="pict-mde-segment-body">
		<div class="pict-mde-tab-bar" id="PictMDE-TabBar-{~D:Record.SegmentIndex~}">
			<button type="button" class="pict-mde-tab pict-mde-tab-active" data-tab="editor" onclick="{~D:Record.ViewIdentifier~}.switchSegmentTab({~D:Record.SegmentIndex~}, 'editor')">Edit</button>
			<button type="button" class="pict-mde-tab" data-tab="preview" onclick="{~D:Record.ViewIdentifier~}.switchSegmentTab({~D:Record.SegmentIndex~}, 'preview')">Preview</button>
		</div>
		<div class="pict-mde-segment-editor" id="PictMDE-SegmentEditor-{~D:Record.SegmentIndex~}"></div>
		<div class="pict-mde-preview-pane" id="PictMDE-PreviewPane-{~D:Record.SegmentIndex~}">
			<div class="pict-mde-image-preview" id="PictMDE-ImagePreview-{~D:Record.SegmentIndex~}"></div>
			<div class="pict-mde-rich-preview" id="PictMDE-RichPreview-{~D:Record.SegmentIndex~}"></div>
		</div>
	</div>
	<div class="pict-mde-sidebar" id="PictMDE-Sidebar-{~D:Record.SegmentIndex~}">
		<div class="pict-mde-quadrant-tr"></div>
		<div class="pict-mde-quadrant-br"></div>
		<input type="file" accept="image/*" class="pict-mde-image-input" id="PictMDE-ImageInput-{~D:Record.SegmentIndex~}" style="display:none" />
	</div>
</div>`
		},
		{
			"Hash": "MarkdownEditor-AddSegment",
			"Template": /*html*/`<div class="pict-mde-add-segment">
	<button type="button" class="pict-mde-btn-add" onclick="{~D:Record.ViewIdentifier~}.addSegment()">+ Add Segment</button>
</div>`
		}
	],

	"Renderables":
	[
		{
			"RenderableHash": "MarkdownEditor-Wrap",
			"TemplateHash": "MarkdownEditor-Container",
			"DestinationAddress": "#MarkdownEditor-Container-Div"
		}
	],

	"TargetElementAddress": "#MarkdownEditor-Container-Div",

	// Address in AppData to read/write the segments array
	// The data at this address should be an array of objects, each with a "Content" property
	// e.g. AppData.Document.Segments = [ { Content: "# Hello" }, { Content: "Some text" } ]
	"ContentDataAddress": false,

	// Whether the editor should be read-only
	"ReadOnly": false,

	// Whether to show rich content previews (rendered markdown with syntax-highlighted
	// code, mermaid diagrams, KaTeX equations, tables, etc. via pict-section-content).
	// Requires the consumer to load the mermaid and/or katex libraries via CDN
	// for diagram/equation rendering; code highlighting works without CDN scripts.
	"EnableRichPreview": true,

	// Default preview layout mode: "off", "bottom", "side", "tabbed"
	//   off       — no preview (default)
	//   bottom    — preview below the editor
	//   side      — editor and preview side-by-side
	//   tabbed    — per-segment tabs switching between editor and preview
	"DefaultPreviewMode": "off",

	// Base URL prepended to relative image URLs in image and rich previews.
	// Set this to the directory-level path (e.g. "/content/") so that images
	// referenced by filename in the markdown resolve correctly.
	// Absolute URLs (starting with /, http://, https://, data:) are left as-is.
	"ImageBaseURL": "",

	// ---- Quadrant button definitions ----
	// Each quadrant is an array of button objects:
	//   HTML   — innerHTML for the button
	//   Action — method name, optionally "method:arg" (receives segment index as first param)
	//   Class  — additional CSS class(es) appended to the base class
	//   Title  — tooltip text
	//
	// Consumers can override any quadrant to add, remove, or reorder buttons.
	// Left quadrant buttons (TL, BL) get the "pict-mde-left-btn" base class.
	// Right quadrant buttons (TR, BR) get the "pict-mde-sidebar-btn" base class.

	// Quadrant button HTML is parsed through Pict's template engine before
	// being assigned as innerHTML, so `{~I:Name~}` template tags resolve
	// to themable SVG icons from pict.providers.Icon.  Typographic
	// formatting buttons (Bold / Italic / Inline-code / Heading / Link)
	// stay as stylized letters — that's the markdown-editor convention.
	"ButtonsTL":
	[
		{ "HTML": "{~I:Close~}",    "Action": "removeSegment",    "Class": "pict-mde-btn-remove",    "Title": "Remove Segment" }
	],

	"ButtonsBL":
	[
		{ "HTML": "{~I:ArrowUp~}",   "Action": "moveSegmentUp",     "Class": "pict-mde-btn-move",     "Title": "Move Up" },
		{ "HTML": "{~I:ArrowDown~}", "Action": "moveSegmentDown",   "Class": "pict-mde-btn-move",     "Title": "Move Down" },
		{ "HTML": "{~I:Settings~}",  "Action": "toggleControls",    "Class": "pict-mde-btn-linenums", "Title": "Toggle Controls" },
		{ "HTML": "{~I:Eye~}",       "Action": "cyclePreviewMode",  "Class": "pict-mde-btn-preview",  "Title": "Cycle Preview Mode" }
	],

	"ButtonsTR":
	[
		{ "HTML": "<b>B</b>",            "Action": "applyFormatting:bold",     "Class": "", "Title": "Bold (Ctrl+B)" },
		{ "HTML": "<i>I</i>",            "Action": "applyFormatting:italic",   "Class": "", "Title": "Italic (Ctrl+I)" },
		{ "HTML": "<code>&lt;&gt;</code>","Action": "applyFormatting:code",    "Class": "", "Title": "Inline Code (Ctrl+E)" },
		{ "HTML": "#",                   "Action": "applyFormatting:heading",  "Class": "", "Title": "Heading" },
		{ "HTML": "[&thinsp;]",          "Action": "applyFormatting:link",     "Class": "", "Title": "Link" },
		{ "HTML": "{~I:Image~}",         "Action": "openImagePicker",          "Class": "pict-mde-sidebar-btn-image", "Title": "Insert Image" }
	],

	"ButtonsBR":
	[
	],

	// CSS for the markdown editor
	"CSS": /*css*/`
/* ---- Container ---- */
.pict-mde
{
	font-family: var(--theme-typography-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif);
	font-size: 14px;
}

/* ---- Segment row: left-controls | drag-handle | editor body | sidebar ---- */
.pict-mde-segment
{
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	margin-bottom: 6px;
	min-height: 48px;
	transition: background-color 0.15s ease;
}

/* ---- Left controls column ---- */
.pict-mde-left-controls
{
	flex: 0 0 22px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 2px 0;
}

/* ---- Left-side quadrants ---- */
.pict-mde-quadrant-tl
{
	display: flex;
	flex-direction: column;
	align-items: center;
	position: sticky;
	top: 2px;
	z-index: 2;
}
.pict-mde-quadrant-bl
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	position: sticky;
	bottom: 2px;
	z-index: 2;
}

/* ---- Left-side buttons (shared base) ---- */
.pict-mde-left-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	padding: 0;
	color: var(--theme-color-text-muted, #888);
	line-height: 1;
	font-family: inherit;
	opacity: 0;
	transition: opacity 0.15s ease;
}
.pict-mde-segment:hover .pict-mde-left-btn,
.pict-mde-segment.pict-mde-active .pict-mde-left-btn
{
	opacity: 1;
}
.pict-mde-left-btn:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-btn-remove:hover
{
	color: var(--theme-color-status-error, #CC3333);
}
.pict-mde-btn-linenums
{
	font-size: 11px;
	font-weight: 600;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
}
/* Highlight when controls are active */
.pict-mde.pict-mde-controls-on .pict-mde-btn-linenums
{
	color: var(--theme-color-brand-primary, #4A90D9);
}
.pict-mde-btn-preview
{
	font-size: 11px;
}
/* Preview button: highlight when any preview mode is active */
.pict-mde.pict-mde-preview-bottom .pict-mde-btn-preview,
.pict-mde.pict-mde-preview-side .pict-mde-btn-preview,
.pict-mde.pict-mde-preview-tabbed .pict-mde-btn-preview
{
	color: var(--theme-color-brand-primary, #4A90D9);
}
/* Dim preview button when mode is off */
.pict-mde.pict-mde-preview-off .pict-mde-btn-preview
{
	color: var(--theme-color-border-default, #CCC);
}

/* ---- Drag handle (simple grey bar) ---- */
.pict-mde-drag-handle
{
	flex: 0 0 8px;
	cursor: grab;
	background: var(--theme-color-background-tertiary, #EDEDED);
	transition: background-color 0.15s ease;
	user-select: none;
}
.pict-mde-drag-handle:active
{
	cursor: grabbing;
}
.pict-mde-drag-handle:hover
{
	background: var(--theme-color-border-default, #C8C8C8);
}

/* ---- Editor body (middle column) ---- */
.pict-mde-segment-body
{
	flex: 1 1 0%;
	min-width: 0;
	overflow: hidden;
	background: var(--theme-color-background-panel, #FFFFFF);
	transition: background-color 0.15s ease;
}
.pict-mde-segment-editor
{
	min-height: 48px;
}

/* ---- Image preview area below the editor ---- */
.pict-mde-image-preview
{
	display: none;
}
.pict-mde-image-preview.pict-mde-has-images
{
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 8px 12px;
	border-top: 1px solid var(--theme-color-border-light, #EDEDED);
}
.pict-mde-image-preview img
{
	max-width: 200px;
	max-height: 150px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #E0E0E0);
	object-fit: contain;
	background: var(--theme-color-background-secondary, #F8F8F8);
}
.pict-mde-image-preview-item
{
	position: relative;
	display: inline-block;
}
.pict-mde-image-preview-label
{
	display: block;
	font-size: 10px;
	color: var(--theme-color-text-muted, #999);
	margin-top: 2px;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* ---- Rich content preview area (rendered via pict-section-content) ---- */
.pict-mde-rich-preview
{
	display: none;
}
.pict-mde-rich-preview.pict-mde-has-rich-preview
{
	display: block;
	border-top: 1px solid var(--theme-color-border-light, #EDEDED);
	background: var(--theme-color-background-panel, #FCFCFC);
	overflow: hidden;
}
/* Constrain images in the rich preview even if pict-section-content CSS loads late */
.pict-mde-rich-preview img
{
	max-width: 100%;
	height: auto;
}
/* ---- Preview layout modes ---- */

/* Tab bar: hidden by default, shown only in tabbed mode */
.pict-mde-tab-bar
{
	display: none;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-tab-bar
{
	display: flex;
	gap: 0;
	border-bottom: 1px solid var(--theme-color-border-light, #EDEDED);
	background: var(--theme-color-background-secondary, #F8F8F8);
}
.pict-mde-tab
{
	padding: 4px 12px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	color: var(--theme-color-text-muted, #888);
	border-bottom: 2px solid transparent;
	font-family: inherit;
}
.pict-mde-tab:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-tab.pict-mde-tab-active
{
	color: var(--theme-color-brand-primary, #4A90D9);
	border-bottom-color: var(--theme-color-brand-primary, #4A90D9);
}

/* Off mode: hide all preview panes and tab bars */
.pict-mde.pict-mde-preview-off .pict-mde-preview-pane
{
	display: none;
}
.pict-mde.pict-mde-preview-off .pict-mde-tab-bar
{
	display: none;
}
/* Legacy class alias for backward compatibility */
.pict-mde.pict-mde-previews-hidden .pict-mde-preview-pane
{
	display: none;
}

/* Bottom mode: vertical stacking (default flex-column behavior) */
.pict-mde.pict-mde-preview-bottom .pict-mde-segment-body
{
	display: flex;
	flex-direction: column;
}

/* Side-by-side mode: editor and preview side by side */
.pict-mde.pict-mde-preview-side .pict-mde-segment-body
{
	display: flex;
	flex-direction: row;
}
.pict-mde.pict-mde-preview-side .pict-mde-segment-editor
{
	flex: 1 1 50%;
	min-width: 0;
	overflow: hidden;
}
.pict-mde.pict-mde-preview-side .pict-mde-preview-pane
{
	flex: 1 1 50%;
	min-width: 0;
	overflow: auto;
	border-left: 1px solid var(--theme-color-border-light, #EDEDED);
}
/* Side-by-side: remove top borders since preview is beside, not below */
.pict-mde.pict-mde-preview-side .pict-mde-rich-preview.pict-mde-has-rich-preview
{
	border-top: none;
}
.pict-mde.pict-mde-preview-side .pict-mde-image-preview.pict-mde-has-images
{
	border-top: none;
}

/* Tabbed mode: default hides preview, shows editor */
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment-body
{
	display: flex;
	flex-direction: column;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-preview-pane
{
	display: none;
}
/* Tabbed mode: when showing preview, hide editor and show preview */
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment.pict-mde-tab-showing-preview .pict-mde-segment-editor
{
	display: none;
}
.pict-mde.pict-mde-preview-tabbed .pict-mde-segment.pict-mde-tab-showing-preview .pict-mde-preview-pane
{
	display: block;
}

/* Per-segment preview hide: only applies in bottom and side modes */
.pict-mde.pict-mde-preview-bottom .pict-mde-segment.pict-mde-preview-hidden .pict-mde-preview-pane,
.pict-mde.pict-mde-preview-side .pict-mde-segment.pict-mde-preview-hidden .pict-mde-preview-pane
{
	display: none;
}
/* Constrain the pict-content inside the preview to fit the segment */
.pict-mde-rich-preview .pict-content
{
	padding: 12px;
	max-width: none;
	margin: 0;
	font-size: 13px;
}
/* Reduce heading sizes in the preview to be proportional */
.pict-mde-rich-preview .pict-content h1
{
	font-size: 1.4em;
	margin-top: 0;
}
.pict-mde-rich-preview .pict-content h2
{
	font-size: 1.2em;
	margin-top: 0.75em;
}
.pict-mde-rich-preview .pict-content h3
{
	font-size: 1.1em;
	margin-top: 0.6em;
}

/* ---- Rendered view (full document preview mode) ---- */
.pict-mde-rendered-view
{
	padding: 16px 20px;
	background: var(--theme-color-background-panel, #FFFFFF);
	min-height: 120px;
}
.pict-mde-rendered-view .pict-content
{
	max-width: none;
	margin: 0;
}
/* Hide the add-segment button in rendered mode */
.pict-mde.pict-mde-rendered-mode .pict-mde-add-segment
{
	display: none;
}

/* Focused / active editor gets subtle warm background */
.pict-mde-segment.pict-mde-active .pict-mde-segment-body
{
	background: var(--theme-color-background-secondary, #FAFAF5);
}
.pict-mde-segment.pict-mde-active .pict-mde-drag-handle
{
	background: var(--theme-color-border-strong, #9CB4C8);
}

/* ---- Right sidebar column ---- */
.pict-mde-sidebar
{
	flex: 0 0 30px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	position: relative;
}

/* ---- Right-side quadrants ---- */
.pict-mde-quadrant-tr
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	padding: 4px 0;
	width: 100%;
	opacity: 0;
	transition: opacity 0.15s ease, top 0.1s ease;
	position: sticky;
	top: 0;
}
.pict-mde-quadrant-br
{
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	padding: 4px 0;
	width: 100%;
	opacity: 0;
	transition: opacity 0.15s ease;
	position: sticky;
	bottom: 0;
}

/* Active segment always shows its right-side quadrants */
.pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
.pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
{
	opacity: 1;
}
/* When no segment is active, hovering shows both left + right controls */
.pict-mde:not(:has(.pict-mde-active)) .pict-mde-segment:hover .pict-mde-quadrant-tr,
.pict-mde:not(:has(.pict-mde-active)) .pict-mde-segment:hover .pict-mde-quadrant-br
{
	opacity: 1;
}

/* ---- Controls-hidden mode: right quadrants show faintly on hover ---- */
.pict-mde.pict-mde-controls-hidden .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-quadrant-br
{
	opacity: 0;
}
.pict-mde.pict-mde-controls-hidden .pict-mde-segment:hover .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-segment:hover .pict-mde-quadrant-br
{
	opacity: 0.3;
}
.pict-mde.pict-mde-controls-hidden .pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
.pict-mde.pict-mde-controls-hidden .pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
{
	opacity: 0.3;
}

/* When JS sets a cursor-relative offset, switch TR from sticky to absolute positioning */
.pict-mde-quadrant-tr.pict-mde-sidebar-at-cursor
{
	position: absolute;
	top: var(--pict-mde-sidebar-top, 0px);
}

/* ---- Right-side buttons (shared base) ---- */
.pict-mde-sidebar-btn
{
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 22px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 12px;
	padding: 0;
	border-radius: 3px;
	color: var(--theme-color-text-secondary, #666);
	line-height: 1;
	font-family: inherit;
}
.pict-mde-sidebar-btn:hover
{
	color: var(--theme-color-text-primary, #222);
}
.pict-mde-sidebar-btn b
{
	font-size: 13px;
	font-weight: 700;
}
.pict-mde-sidebar-btn i
{
	font-size: 13px;
	font-style: italic;
}
.pict-mde-sidebar-btn code
{
	font-size: 10px;
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
}

/* ---- Add segment button ---- */
.pict-mde-add-segment
{
	margin-top: 6px;
	padding-left: 30px;
}
.pict-mde-btn-add
{
	display: block;
	width: 100%;
	padding: 7px;
	border: 2px dashed var(--theme-color-border-default, #D0D0D0);
	border-radius: 4px;
	background: transparent;
	color: var(--theme-color-text-muted, #999);
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
}
.pict-mde-btn-add:hover
{
	border-color: var(--theme-color-brand-primary, #4A90D9);
	color: var(--theme-color-brand-primary, #4A90D9);
	background: rgba(74, 144, 217, 0.04);
}

/* ---- Image drag-over indicator ---- */
.pict-mde-segment-editor.pict-mde-image-dragover
{
	outline: 2px dashed var(--theme-color-brand-primary, #4A90D9);
	outline-offset: -2px;
}

/* ---- Drag-in-progress: prevent CodeMirror from intercepting drop events ---- */
.pict-mde.pict-mde-dragging .pict-mde-segment-editor
{
	pointer-events: none;
}

/* ---- Drop target indicators for drag reorder ---- */
.pict-mde-segment.pict-mde-drag-over-top
{
	box-shadow: 0 -2px 0 0 var(--theme-color-brand-primary, #4A90D9);
}
.pict-mde-segment.pict-mde-drag-over-bottom
{
	box-shadow: 0 2px 0 0 var(--theme-color-brand-primary, #4A90D9);
}

/* ---- CodeMirror overrides inside segments ---- */
.pict-mde-segment-editor .cm-editor
{
	border: none;
}
.pict-mde-segment-editor .cm-editor .cm-scroller
{
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace);
	font-size: 14px;
	line-height: 1.6;
}
.pict-mde-segment-editor .cm-editor.cm-focused
{
	outline: none;
}
.pict-mde-segment-editor .cm-editor .cm-content
{
	padding: 8px 12px;
	min-height: 36px;
}
.pict-mde-segment-editor .cm-editor .cm-gutters
{
	background: var(--theme-color-background-secondary, #F8F8F8);
	border-right: 1px solid var(--theme-color-border-light, #E8E8E8);
	color: var(--theme-color-text-muted, #BBB);
}

/* ---- Collapsed data URI widget ---- */
.pict-mde-data-uri-collapsed
{
	display: inline;
	background: var(--theme-color-background-tertiary, #F0F0F0);
	color: var(--theme-color-text-muted, #888);
	font-size: 11px;
	padding: 1px 4px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #E0E0E0);
	font-family: var(--theme-typography-family-mono, 'SFMono-Regular', 'SF Mono', 'Menlo', monospace);
	cursor: default;
	white-space: nowrap;
}

/* ---- Line number / controls toggle: gutters hidden by default ---- */
.pict-mde .cm-editor .cm-gutters
{
	display: none;
}
.pict-mde.pict-mde-controls-on .cm-editor .cm-gutters
{
	display: flex;
}

/* ============================================
   RESPONSIVE: Tablet / Phone (max-width: 768px)
   ============================================ */
@media (max-width: 768px)
{
	/* Prevent any horizontal overflow in the editor */
	.pict-mde
	{
		overflow-x: hidden;
		max-width: 100%;
	}

	/* Reduce the left controls column width */
	.pict-mde-left-controls
	{
		flex: 0 0 16px;
	}
	.pict-mde-left-btn
	{
		width: 16px;
		height: 18px;
		font-size: 10px;
	}

	/* Make left-side buttons always visible on touch (no hover) */
	.pict-mde-left-btn
	{
		opacity: 0.6;
	}

	/* Narrow the drag handle */
	.pict-mde-drag-handle
	{
		flex: 0 0 5px;
	}

	/* Shrink the right sidebar column */
	.pict-mde-sidebar
	{
		flex: 0 0 24px;
	}
	.pict-mde-sidebar-btn
	{
		width: 20px;
		height: 20px;
		font-size: 11px;
	}

	/* Make right sidebar buttons always visible (touch devices) */
	.pict-mde-quadrant-tr,
	.pict-mde-quadrant-br
	{
		opacity: 0.7;
	}
	.pict-mde-segment.pict-mde-active .pict-mde-quadrant-tr,
	.pict-mde-segment.pict-mde-active .pict-mde-quadrant-br
	{
		opacity: 1;
	}

	/* Reduce CodeMirror content padding */
	.pict-mde-segment-editor .cm-editor .cm-content
	{
		padding: 6px 6px;
	}

	/* Reduce font size slightly for more content on screen */
	.pict-mde-segment-editor .cm-editor .cm-scroller
	{
		font-size: 13px;
	}

	/* Add segment button: reduce left margin */
	.pict-mde-add-segment
	{
		padding-left: 21px;
	}

	/* Side-by-side: fall back to vertical stacking on narrow screens */
	.pict-mde.pict-mde-preview-side .pict-mde-segment-body
	{
		flex-direction: column;
	}
	.pict-mde.pict-mde-preview-side .pict-mde-preview-pane
	{
		border-left: none;
		border-top: 1px solid var(--theme-color-border-light, #EDEDED);
	}

	/* Tab bar: smaller on tablet */
	.pict-mde-tab
	{
		padding: 3px 8px;
		font-size: 11px;
	}

	/* Rich preview: less padding */
	.pict-mde-rich-preview .pict-content
	{
		padding: 8px;
		font-size: 12px;
	}

	/* Image previews: smaller max dimensions */
	.pict-mde-image-preview img
	{
		max-width: 120px;
		max-height: 100px;
	}

	/* Rendered view: less padding */
	.pict-mde-rendered-view
	{
		padding: 10px 8px;
	}
}

/* ============================================
   RESPONSIVE: Small phone (max-width: 480px)
   ============================================ */
@media (max-width: 480px)
{
	/* Wrap segment so left controls flow to the top as a horizontal bar */
	.pict-mde-segment
	{
		flex-wrap: wrap;
	}

	/* Left controls become a horizontal toolbar at the top of the segment */
	.pict-mde-left-controls
	{
		flex: 0 0 100%;
		flex-direction: row;
		justify-content: flex-start;
		gap: 2px;
		padding: 3px 4px;
		order: -1;
		background: var(--theme-color-background-secondary, #F5F5F5);
		border-bottom: 1px solid var(--theme-color-border-light, #EDEDED);
	}
	.pict-mde-left-btn
	{
		width: 24px;
		height: 24px;
		font-size: 12px;
		opacity: 0.7;
	}

	/* Left quadrants flow horizontally */
	.pict-mde-quadrant-tl,
	.pict-mde-quadrant-bl
	{
		flex-direction: row;
		gap: 2px;
		position: static;
	}

	/* Segment body: explicit basis so it fills the wrapped row */
	.pict-mde-segment-body
	{
		flex: 1 1 calc(100% - 20px);
	}

	/* Hide drag handle on very small screens */
	.pict-mde-drag-handle
	{
		display: none;
	}

	/* Right sidebar: further shrink */
	.pict-mde-sidebar
	{
		flex: 0 0 20px;
	}
	.pict-mde-sidebar-btn
	{
		width: 18px;
		height: 18px;
		font-size: 10px;
	}

	/* Add segment: no left offset since controls are at top */
	.pict-mde-add-segment
	{
		padding-left: 0;
	}

	/* Even tighter CodeMirror padding */
	.pict-mde-segment-editor .cm-editor .cm-content
	{
		padding: 4px 4px;
	}
}
`
});

},{}],143:[function(require,module,exports){
const libPictViewClass = require('pict-view');
const libPictSectionContent = require('pict-section-content');
const _DefaultConfiguration = require('./Pict-Section-MarkdownEditor-DefaultConfiguration.js');

// Helper modules
const libFormatting = require('./Pict-MDE-Formatting.js');
const libImageHandling = require('./Pict-MDE-ImageHandling.js');
const libDragAndReorder = require('./Pict-MDE-DragAndReorder.js');
const libRichPreview = require('./Pict-MDE-RichPreview.js');
const libCodeMirror = require('./Pict-MDE-CodeMirror.js');

class PictSectionMarkdownEditor extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// CodeMirror prototype references (injected by consumer or found on window)
		this._codeMirrorModules = null;

		// Map of segment index to CodeMirror EditorView instance
		this._segmentEditors = {};

		// Internal segment counter (monotonically increasing for unique IDs)
		this._segmentCounter = 0;

		// The view identifier used for onclick handlers in templates
		this._viewCallIdentifier = false;

		// Currently active (focused) segment index, or -1
		this._activeSegmentIndex = -1;

		// Drag state for reorder
		this._dragSourceIndex = -1;

		// Whether controls (line numbers + right sidebar) are currently visible
		this._controlsVisible = true;

		// Current preview layout mode: "off", "bottom", "side", "tabbed"
		this._previewMode = this.options.DefaultPreviewMode || 'off';

		// Last non-off preview layout, for togglePreview() backward compatibility
		this._lastPreviewLayout = 'bottom';

		// Per-segment tab state in tabbed mode (keyed by logical index; "editor" or "preview")
		this._segmentTabStates = {};

		// Set of logical segment indices where preview has been individually hidden
		this._hiddenPreviewSegments = {};

		// Debounce timers for image preview updates (keyed by segment index)
		this._imagePreviewTimers = {};

		// Debounce timers for rich content preview updates (keyed by segment index)
		this._richPreviewTimers = {};

		// Generation counters for mermaid async rendering (keyed by segment index)
		this._richPreviewGenerations = {};

		// Content provider for markdown-to-HTML rendering in rich previews
		// (pict-section-content provides parseMarkdown, code highlighting, etc.)
		this._contentProvider = null;

		// Whether the rendered (read-mode) view is currently active
		this._renderedViewActive = false;

		// Generation counter for rendered view mermaid async rendering
		this._renderedViewGeneration = 0;

		// Attach helper modules
		libFormatting.attach(this);
		libImageHandling.attach(this);
		libDragAndReorder.attach(this);
		libRichPreview.attach(this);
		libCodeMirror.attach(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		this.targetElement = false;

		return super.onBeforeInitialize();
	}

	/**
	 * Connect the CodeMirror modules.  The consumer must pass an object with:
	 *   - EditorView: the EditorView class
	 *   - EditorState: the EditorState class
	 *   - extensions: an array of extensions to use (e.g. basicSetup, markdown(), etc.)
	 *
	 * If not called explicitly, the view will attempt to find them on window.CodeMirrorModules.
	 *
	 * @param {object} [pCodeMirrorModules] - The CodeMirror modules object
	 * @returns {boolean|void}
	 */
	connectCodeMirrorModules(pCodeMirrorModules)
	{
		if (pCodeMirrorModules && typeof (pCodeMirrorModules) === 'object')
		{
			if (typeof (pCodeMirrorModules.EditorView) === 'function' && typeof (pCodeMirrorModules.EditorState) === 'function')
			{
				this._codeMirrorModules = pCodeMirrorModules;
				return;
			}
		}

		// Try to find CodeMirror modules in global scope
		if (typeof (window) !== 'undefined')
		{
			if (window.CodeMirrorModules && typeof (window.CodeMirrorModules.EditorView) === 'function')
			{
				this.log.trace(`PICT-MarkdownEditor Found CodeMirror modules on window.CodeMirrorModules.`);
				this._codeMirrorModules = window.CodeMirrorModules;
				return;
			}
		}

		this.log.error(`PICT-MarkdownEditor No CodeMirror modules found. Provide them via connectCodeMirrorModules() or set window.CodeMirrorModules.`);
		return false;
	}

	onAfterRender(pRenderable)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}

		// Inject CSS from all registered views (after onAfterInitialRender so
		// that pict-section-content's CSS is registered before injection)
		this.pict.CSSMap.injectCSS();

		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// Resolve CodeMirror modules if not already set
		if (!this._codeMirrorModules)
		{
			this.connectCodeMirrorModules();
		}

		if (!this._codeMirrorModules)
		{
			this.log.error(`PICT-MarkdownEditor Cannot initialize; no CodeMirror modules available.`);
			return false;
		}

		// Register pict-section-content's CSS for rich preview rendering.
		// This ensures the rendered markdown (headings, code blocks, tables, etc.)
		// is styled correctly inside the preview area.
		if (this.options.EnableRichPreview)
		{
			let tmpContentViewConfig = libPictSectionContent.default_configuration;
			if (tmpContentViewConfig && tmpContentViewConfig.CSS)
			{
				this.pict.CSSMap.addCSS('Pict-Content-View', tmpContentViewConfig.CSS);
			}
		}

		// Find the target element
		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (!tmpTargetElementSet || tmpTargetElementSet.length < 1)
		{
			this.log.error(`PICT-MarkdownEditor Could not find target element [${this.options.TargetElementAddress}]!`);
			this.targetElement = false;
			return false;
		}
		this.targetElement = tmpTargetElementSet[0];

		// Determine the view call identifier for onclick handlers
		this._viewCallIdentifier = this._resolveViewCallIdentifier();

		// Build the editor UI
		this._buildEditorUI();
	}

	/**
	 * Resolve how the view can be referenced from global onclick handlers.
	 * Returns a string like "_Pict.views['MyViewHash']" — bracket syntax
	 * is required so view hashes containing hyphens (e.g.
	 * "ContentEditor-MarkdownEditor") parse correctly. Dot access
	 * (`_Pict.views.X-Y`) is read as subtraction by the JS parser and
	 * the onclick silently no-ops.
	 *
	 * @returns {string}
	 */
	_resolveViewCallIdentifier()
	{
		let tmpViews = this.pict.views;
		for (let tmpViewHash in tmpViews)
		{
			if (tmpViews[tmpViewHash] === this)
			{
				return `_Pict.views['${tmpViewHash}']`;
			}
		}
		return `_Pict.servicesMap.PictView['${this.Hash}']`;
	}

	/**
	 * Get the .pict-mde container element.  Always does a fresh DOM lookup
	 * because pict's async render pipeline can replace the element between calls.
	 *
	 * @returns {HTMLElement|null}
	 */
	_getContainerElement()
	{
		if (this.targetElement)
		{
			let tmpContainer = this.targetElement.querySelector('.pict-mde');
			if (tmpContainer)
			{
				return tmpContainer;
			}
		}
		return this.targetElement || null;
	}

	/**
	 * Resolve a URL relative to the configured ImageBaseURL.
	 *
	 * Absolute URLs (starting with /, http://, https://, data:) are returned
	 * unchanged.  Relative URLs are prepended with this.options.ImageBaseURL.
	 *
	 * @param {string} pURL - The URL to resolve
	 * @returns {string} The resolved URL
	 */
	_resolveImageURL(pURL)
	{
		if (!pURL || !this.options.ImageBaseURL)
		{
			return pURL;
		}

		// Leave absolute URLs alone
		if (pURL.startsWith('/') || pURL.startsWith('http://') || pURL.startsWith('https://') || pURL.startsWith('data:'))
		{
			return pURL;
		}

		let tmpBase = this.options.ImageBaseURL;
		// Ensure base ends with /
		if (tmpBase && !tmpBase.endsWith('/'))
		{
			tmpBase += '/';
		}

		return tmpBase + pURL;
	}

	/**
	 * Build the full editor UI: render existing segments from data and the add-segment button.
	 */
	_buildEditorUI()
	{
		let tmpContainer = this._getContainerElement();

		// Ensure the container has the pict-mde class (the template's wrapper
		// may have been replaced by pict's async render pipeline)
		if (tmpContainer && !tmpContainer.classList.contains('pict-mde'))
		{
			tmpContainer.classList.add('pict-mde');
		}

		// Destroy existing editors before clearing
		for (let tmpIdx in this._segmentEditors)
		{
			if (this._segmentEditors[tmpIdx])
			{
				this._segmentEditors[tmpIdx].destroy();
			}
		}

		tmpContainer.innerHTML = '';

		// Restore toggle states on the container after clearing
		tmpContainer.classList.remove('pict-mde-preview-off', 'pict-mde-preview-bottom', 'pict-mde-preview-side', 'pict-mde-preview-tabbed', 'pict-mde-previews-hidden');
		tmpContainer.classList.add('pict-mde-preview-' + this._previewMode);
		if (this._controlsVisible)
		{
			tmpContainer.classList.add('pict-mde-controls-on');
		}
		else
		{
			tmpContainer.classList.add('pict-mde-controls-hidden');
		}

		// Load existing segments from data address, or start with one empty segment
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length === 0)
		{
			tmpSegments = [{ Content: '' }];
			this._setSegmentsToData(tmpSegments);
		}

		this._segmentCounter = 0;
		this._segmentEditors = {};

		for (let i = 0; i < tmpSegments.length; i++)
		{
			this._renderSegment(tmpContainer, i, tmpSegments[i].Content || '');
		}

		this._renderAddButton(tmpContainer);
	}

	/**
	 * Render a single segment into the container.
	 *
	 * @param {HTMLElement} pContainer - The container element
	 * @param {number} pIndex - The segment index
	 * @param {string} pContent - The initial content
	 */
	_renderSegment(pContainer, pIndex, pContent)
	{
		let tmpSegmentIndex = this._segmentCounter++;

		let tmpRecord =
		{
			SegmentIndex: tmpSegmentIndex,
			SegmentDisplayIndex: pIndex + 1,
			ViewIdentifier: this._viewCallIdentifier
		};

		let tmpHTML = this.pict.parseTemplateByHash('MarkdownEditor-Segment', tmpRecord);

		let tmpTempDiv = document.createElement('div');
		tmpTempDiv.innerHTML = tmpHTML;
		let tmpSegmentElement = tmpTempDiv.firstElementChild;
		pContainer.appendChild(tmpSegmentElement);

		// Build quadrant buttons from configuration arrays
		this._buildQuadrantButtons(tmpSegmentElement, tmpSegmentIndex);

		// Restore per-segment preview hidden state (tracked by logical index)
		if (this._hiddenPreviewSegments[pIndex])
		{
			tmpSegmentElement.classList.add('pict-mde-preview-hidden');
		}

		// Restore per-segment tab state in tabbed mode
		if (this._previewMode === 'tabbed' && this._segmentTabStates[pIndex] === 'preview')
		{
			tmpSegmentElement.classList.add('pict-mde-tab-showing-preview');
			let tmpTabBar = tmpSegmentElement.querySelector('.pict-mde-tab-bar');
			if (tmpTabBar)
			{
				let tmpEditorTab = tmpTabBar.querySelector('[data-tab="editor"]');
				let tmpPreviewTab = tmpTabBar.querySelector('[data-tab="preview"]');
				if (tmpEditorTab) { tmpEditorTab.classList.remove('pict-mde-tab-active'); }
				if (tmpPreviewTab) { tmpPreviewTab.classList.add('pict-mde-tab-active'); }
			}
		}

		// Wire up drag-and-drop on the drag handle
		this._wireSegmentDragEvents(tmpSegmentElement, tmpSegmentIndex);

		// Create the CodeMirror editor in the segment editor container
		let tmpEditorContainer = document.getElementById(`PictMDE-SegmentEditor-${tmpSegmentIndex}`);
		if (tmpEditorContainer)
		{
			this._createEditorInContainer(tmpEditorContainer, tmpSegmentIndex, pContent);

			// Wire image drag-and-drop on the editor container
			this._wireImageDragEvents(tmpEditorContainer, tmpSegmentIndex);

			// Render image previews for existing content
			if (pContent)
			{
				this._updateImagePreviews(tmpSegmentIndex);
				this._updateRichPreviews(tmpSegmentIndex);
			}
		}
	}

	/**
	 * Build buttons in all four quadrants (TL, BL, TR, BR) from the
	 * configuration arrays.  Each button config has:
	 *   HTML   — innerHTML
	 *   Action — "methodName" or "methodName:arg"
	 *   Class  — additional CSS class(es)
	 *   Title  — tooltip text
	 *
	 * Left quadrant buttons (TL, BL) get the "pict-mde-left-btn" base class.
	 * Right quadrant buttons (TR, BR) get the "pict-mde-sidebar-btn" base class.
	 *
	 * @param {HTMLElement} pSegmentElement - The .pict-mde-segment element
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	_buildQuadrantButtons(pSegmentElement, pSegmentIndex)
	{
		let tmpQuadrants =
		[
			{ key: 'ButtonsTL', selector: '.pict-mde-quadrant-tl', baseClass: 'pict-mde-left-btn' },
			{ key: 'ButtonsBL', selector: '.pict-mde-quadrant-bl', baseClass: 'pict-mde-left-btn' },
			{ key: 'ButtonsTR', selector: '.pict-mde-quadrant-tr', baseClass: 'pict-mde-sidebar-btn' },
			{ key: 'ButtonsBR', selector: '.pict-mde-quadrant-br', baseClass: 'pict-mde-sidebar-btn' }
		];

		let tmpSelf = this;

		for (let q = 0; q < tmpQuadrants.length; q++)
		{
			let tmpQuadrant = tmpQuadrants[q];
			let tmpContainer = pSegmentElement.querySelector(tmpQuadrant.selector);
			if (!tmpContainer)
			{
				continue;
			}

			let tmpButtons = this.options[tmpQuadrant.key];
			if (!Array.isArray(tmpButtons))
			{
				continue;
			}

			for (let b = 0; b < tmpButtons.length; b++)
			{
				let tmpBtnConfig = tmpButtons[b];

				let tmpButton = document.createElement('button');
				tmpButton.type = 'button';
				tmpButton.className = tmpQuadrant.baseClass;
				if (tmpBtnConfig.Class)
				{
					tmpButton.className += ' ' + tmpBtnConfig.Class;
				}
				// Run the button HTML through Pict's template engine so
				// `{~I:Name~}` tags expand into themable SVG icons from
				// pict.providers.Icon.  Plain HTML strings (e.g. the
				// stylized `<b>B</b>` formatting buttons) pass through
				// unchanged — the parser is a no-op when no template tags
				// are present.
				let tmpHTML = tmpBtnConfig.HTML || '';
				if (tmpHTML && typeof (this.pict.parseTemplate) === 'function')
				{
					tmpHTML = this.pict.parseTemplate(tmpHTML, {});
				}
				tmpButton.innerHTML = tmpHTML;
				tmpButton.title = tmpBtnConfig.Title || '';

				// Parse the action string: "methodName" or "methodName:arg"
				let tmpAction = tmpBtnConfig.Action || '';
				let tmpMethod = tmpAction;
				let tmpArg = null;
				let tmpColonIndex = tmpAction.indexOf(':');
				if (tmpColonIndex >= 0)
				{
					tmpMethod = tmpAction.substring(0, tmpColonIndex);
					tmpArg = tmpAction.substring(tmpColonIndex + 1);
				}

				// Build the click handler
				(function (pMethod, pArg, pSegIdx)
				{
					tmpButton.addEventListener('click', () =>
					{
						if (typeof (tmpSelf[pMethod]) === 'function')
						{
							if (pArg !== null)
							{
								tmpSelf[pMethod](pSegIdx, pArg);
							}
							else
							{
								tmpSelf[pMethod](pSegIdx);
							}
						}
						else
						{
							tmpSelf.log.warn(`PICT-MarkdownEditor _buildQuadrantButtons: method "${pMethod}" not found.`);
						}
					});
				})(tmpMethod, tmpArg, pSegmentIndex);

				tmpContainer.appendChild(tmpButton);
			}
		}
	}


	/**
	 * Hook for subclasses to customize the CodeMirror extensions before editor creation.
	 *
	 * @param {Array} pExtensions - The extensions array to modify
	 * @param {number} pSegmentIndex - The segment index
	 * @returns {Array} The modified extensions array
	 */
	customConfigureExtensions(pExtensions, pSegmentIndex)
	{
		return pExtensions;
	}

	/**
	 * Render the "Add Segment" button at the bottom of the container.
	 *
	 * @param {HTMLElement} pContainer - The container element
	 */
	_renderAddButton(pContainer)
	{
		let tmpRecord =
		{
			ViewIdentifier: this._viewCallIdentifier
		};

		let tmpHTML = this.pict.parseTemplateByHash('MarkdownEditor-AddSegment', tmpRecord);

		let tmpTempDiv = document.createElement('div');
		tmpTempDiv.innerHTML = tmpHTML;
		let tmpButtonElement = tmpTempDiv.firstElementChild;
		pContainer.appendChild(tmpButtonElement);
	}

	/**
	 * Hook for consumers to handle image uploads.
	 *
	 * Override this in a subclass or consumer to upload images to a server/CDN.
	 * Return true to indicate you are handling the upload asynchronously.
	 * Call fCallback(null, url) on success, or fCallback(error) on failure.
	 * Return false/undefined to fall back to base64 data URI inline.
	 *
	 * @param {File} pFile - The image File object
	 * @param {number} pSegmentIndex - The logical segment index
	 * @param {function} fCallback - Callback: fCallback(pError, pURL)
	 * @returns {boolean} true if handling the upload, false to use base64 default
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		// Override in subclass or consumer
		return false;
	}

	// -- Controls Toggle (line numbers + right sidebar) --

	/**
	 * Toggle controls (line number gutters and right sidebar formatting
	 * buttons) on or off for all segments.
	 *
	 * When controls are hidden the right-side quadrants (TR, BR) appear
	 * faintly on hover but are otherwise invisible, and CodeMirror line
	 * number gutters are hidden.
	 *
	 * This method is called by the quadrant button system with the segment
	 * index as the first argument — it ignores that argument and uses only
	 * the optional boolean.
	 *
	 * @param {number|boolean} [pSegmentIndexOrVisible] - Segment index (ignored) or boolean
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleControls(pSegmentIndexOrVisible, pVisible)
	{
		// When called from a quadrant button, first arg is segment index (number).
		// When called programmatically, first arg may be a boolean.
		let tmpVisible = pVisible;
		if (typeof (pSegmentIndexOrVisible) === 'boolean')
		{
			tmpVisible = pSegmentIndexOrVisible;
		}

		if (typeof (tmpVisible) === 'boolean')
		{
			this._controlsVisible = tmpVisible;
		}
		else
		{
			this._controlsVisible = !this._controlsVisible;
		}

		let tmpContainer = this._getContainerElement();
		if (tmpContainer)
		{
			if (this._controlsVisible)
			{
				tmpContainer.classList.add('pict-mde-controls-on');
				tmpContainer.classList.remove('pict-mde-controls-hidden');
			}
			else
			{
				tmpContainer.classList.remove('pict-mde-controls-on');
				tmpContainer.classList.add('pict-mde-controls-hidden');
			}
		}
	}

	/**
	 * Toggle line numbers on or off for all segments.
	 * Backward-compatible alias for toggleControls().
	 *
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleLineNumbers(pVisible)
	{
		this.toggleControls(pVisible);
	}

	// -- Preview Toggle --

	/**
	 * Toggle rich previews on or off for all segments globally.
	 *
	 * When hidden globally, individual segment overrides are preserved
	 * so that restoring global visibility returns to the per-segment state.
	 *
	 * Backward compatible: toggles between "off" and the last-used preview layout.
	 *
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	togglePreview(pVisible)
	{
		if (typeof (pVisible) === 'boolean')
		{
			if (pVisible)
			{
				this.setPreviewMode(this._lastPreviewLayout || 'bottom');
			}
			else
			{
				this.setPreviewMode('off');
			}
		}
		else
		{
			if (this._previewMode === 'off')
			{
				this.setPreviewMode(this._lastPreviewLayout || 'bottom');
			}
			else
			{
				this.setPreviewMode('off');
			}
		}
	}

	/**
	 * Set the preview layout mode.
	 *
	 * @param {string} pMode - One of "off", "bottom", "side", "tabbed"
	 */
	setPreviewMode(pMode)
	{
		let tmpValidModes = ['off', 'bottom', 'side', 'tabbed'];
		if (tmpValidModes.indexOf(pMode) < 0)
		{
			this.log.warn(`PICT-MarkdownEditor setPreviewMode: unknown mode "${pMode}".`);
			return;
		}

		// Remember the last non-off mode for toggle restore
		if (pMode !== 'off')
		{
			this._lastPreviewLayout = pMode;
		}

		this._previewMode = pMode;

		let tmpContainer = this._getContainerElement();
		if (tmpContainer)
		{
			tmpContainer.classList.remove('pict-mde-preview-off', 'pict-mde-preview-bottom', 'pict-mde-preview-side', 'pict-mde-preview-tabbed', 'pict-mde-previews-hidden');
			tmpContainer.classList.add('pict-mde-preview-' + pMode);
		}

		// When switching to a visible preview mode, trigger preview renders
		// for all segments to ensure they are up to date
		if (pMode !== 'off')
		{
			let tmpOrderedIndices = this._getOrderedSegmentIndices();
			for (let i = 0; i < tmpOrderedIndices.length; i++)
			{
				this._updateRichPreviews(tmpOrderedIndices[i]);
				this._updateImagePreviews(tmpOrderedIndices[i]);
			}
		}
	}

	/**
	 * Cycle through preview layout modes: off → bottom → side → tabbed → off.
	 *
	 * Accepts a segment index as first argument (ignored) for compatibility
	 * with the quadrant button system.
	 *
	 * @param {number} [pSegmentIndex] - Ignored; present for quadrant button compat
	 */
	cyclePreviewMode(pSegmentIndex)
	{
		let tmpModeOrder = ['off', 'bottom', 'side', 'tabbed'];
		let tmpCurrentIndex = tmpModeOrder.indexOf(this._previewMode);
		let tmpNextIndex = (tmpCurrentIndex + 1) % tmpModeOrder.length;
		this.setPreviewMode(tmpModeOrder[tmpNextIndex]);
	}

	/**
	 * Switch a segment between editor and preview tabs (tabbed mode).
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pTab - "editor" or "preview"
	 */
	switchSegmentTab(pSegmentIndex, pTab)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		this._segmentTabStates[tmpLogicalIndex] = pTab;

		let tmpSegmentEl = document.getElementById(`PictMDE-Segment-${pSegmentIndex}`);
		if (!tmpSegmentEl)
		{
			return;
		}

		// Toggle the preview-showing class on the segment
		if (pTab === 'preview')
		{
			tmpSegmentEl.classList.add('pict-mde-tab-showing-preview');
			// Trigger preview render when switching to preview tab
			this._updateRichPreviews(pSegmentIndex);
			this._updateImagePreviews(pSegmentIndex);
		}
		else
		{
			tmpSegmentEl.classList.remove('pict-mde-tab-showing-preview');
		}

		// Update tab bar active state
		let tmpTabBar = document.getElementById(`PictMDE-TabBar-${pSegmentIndex}`);
		if (tmpTabBar)
		{
			let tmpTabs = tmpTabBar.querySelectorAll('.pict-mde-tab');
			for (let i = 0; i < tmpTabs.length; i++)
			{
				if (tmpTabs[i].getAttribute('data-tab') === pTab)
				{
					tmpTabs[i].classList.add('pict-mde-tab-active');
				}
				else
				{
					tmpTabs[i].classList.remove('pict-mde-tab-active');
				}
			}
		}
	}

	/**
	 * Toggle the rich preview for a single segment.
	 *
	 * This adds/removes the .pict-mde-preview-hidden class on the
	 * individual segment element, independent of the global toggle.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {boolean} [pVisible] - If provided, set to this value; otherwise toggle
	 */
	toggleSegmentPreview(pSegmentIndex, pVisible)
	{
		// Convert internal index to logical index for persistent tracking
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		let tmpCurrentlyHidden = !!this._hiddenPreviewSegments[tmpLogicalIndex];

		if (typeof (pVisible) === 'boolean')
		{
			tmpCurrentlyHidden = !pVisible;
		}
		else
		{
			tmpCurrentlyHidden = !tmpCurrentlyHidden;
		}

		if (tmpCurrentlyHidden)
		{
			this._hiddenPreviewSegments[tmpLogicalIndex] = true;
		}
		else
		{
			delete this._hiddenPreviewSegments[tmpLogicalIndex];
		}

		let tmpSegmentEl = document.getElementById(`PictMDE-Segment-${pSegmentIndex}`);
		if (tmpSegmentEl)
		{
			if (tmpCurrentlyHidden)
			{
				tmpSegmentEl.classList.add('pict-mde-preview-hidden');
			}
			else
			{
				tmpSegmentEl.classList.remove('pict-mde-preview-hidden');
				// Render preview content when making it visible
				this._updateRichPreviews(pSegmentIndex);
				this._updateImagePreviews(pSegmentIndex);
			}
		}
	}

	// -- Segment Data Management --

	/**
	 * Get the segments array from the configured data address.
	 *
	 * @returns {Array|null}
	 */
	_getSegmentsFromData()
	{
		if (!this.options.ContentDataAddress)
		{
			return null;
		}

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.AppData,
			Bundle: this.Bundle,
			Options: this.options
		};

		let tmpData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.ContentDataAddress);

		if (Array.isArray(tmpData))
		{
			return tmpData;
		}

		return null;
	}

	/**
	 * Write the segments array to the configured data address.
	 *
	 * @param {Array} pSegments - The segments array
	 */
	_setSegmentsToData(pSegments)
	{
		if (!this.options.ContentDataAddress)
		{
			return;
		}

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.AppData,
			Bundle: this.Bundle,
			Options: this.options
		};

		this.fable.manifest.setValueByHash(tmpAddressSpace, this.options.ContentDataAddress, pSegments);
	}

	/**
	 * Called when a segment's content changes in the CodeMirror editor.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 * @param {string} pContent - The new content
	 */
	_onSegmentContentChange(pSegmentIndex, pContent)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			return;
		}

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		if (tmpLogicalIndex < tmpSegments.length)
		{
			tmpSegments[tmpLogicalIndex].Content = pContent;
		}

		this.onContentChange(tmpLogicalIndex, pContent);

		// Debounce image preview updates (500ms) to avoid thrashing on every keystroke
		let tmpSelf = this;
		if (this._imagePreviewTimers[pSegmentIndex])
		{
			clearTimeout(this._imagePreviewTimers[pSegmentIndex]);
		}
		this._imagePreviewTimers[pSegmentIndex] = setTimeout(() =>
		{
			tmpSelf._updateImagePreviews(pSegmentIndex);
			delete tmpSelf._imagePreviewTimers[pSegmentIndex];
		}, 500);

		// Debounce rich content preview updates (mermaid / KaTeX) at 500ms
		if (this._richPreviewTimers[pSegmentIndex])
		{
			clearTimeout(this._richPreviewTimers[pSegmentIndex]);
		}
		this._richPreviewTimers[pSegmentIndex] = setTimeout(() =>
		{
			tmpSelf._updateRichPreviews(pSegmentIndex);
			delete tmpSelf._richPreviewTimers[pSegmentIndex];
		}, 500);
	}

	/**
	 * Hook for subclasses to respond to content changes.
	 *
	 * @param {number} pSegmentIndex - The logical segment index
	 * @param {string} pContent - The new content
	 */
	onContentChange(pSegmentIndex, pContent)
	{
		// Override in subclass
	}

	/**
	 * Get the logical (ordered) index for an internal segment index.
	 *
	 * @param {number} pInternalIndex - The internal segment index
	 * @returns {number} The logical index, or -1 if not found
	 */
	_getLogicalIndex(pInternalIndex)
	{
		let tmpContainer = this._getContainerElement();
		if (!tmpContainer)
		{
			return -1;
		}

		let tmpSegmentElements = tmpContainer.querySelectorAll('.pict-mde-segment');
		for (let i = 0; i < tmpSegmentElements.length; i++)
		{
			let tmpIndex = parseInt(tmpSegmentElements[i].getAttribute('data-segment-index'), 10);
			if (tmpIndex === pInternalIndex)
			{
				return i;
			}
		}

		return -1;
	}

	/**
	 * Get the ordered list of internal segment indices from the DOM.
	 *
	 * @returns {Array<number>}
	 */
	_getOrderedSegmentIndices()
	{
		let tmpContainer = this._getContainerElement();
		if (!tmpContainer)
		{
			return [];
		}

		let tmpSegmentElements = tmpContainer.querySelectorAll('.pict-mde-segment');
		let tmpIndices = [];
		for (let i = 0; i < tmpSegmentElements.length; i++)
		{
			tmpIndices.push(parseInt(tmpSegmentElements[i].getAttribute('data-segment-index'), 10));
		}
		return tmpIndices;
	}

	// -- Public API --

	/**
	 * Add a new empty segment at the end.
	 *
	 * @param {string} [pContent] - Optional initial content for the new segment
	 */
	addSegment(pContent)
	{
		let tmpContent = (typeof (pContent) === 'string') ? pContent : '';

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			tmpSegments = [];
		}
		tmpSegments.push({ Content: tmpContent });
		this._setSegmentsToData(tmpSegments);

		this._buildEditorUI();
	}

	/**
	 * Remove a segment by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	removeSegment(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex < 0)
		{
			this.log.warn(`PICT-MarkdownEditor removeSegment: segment index ${pSegmentIndex} not found.`);
			return;
		}

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpSegments.length <= 1)
		{
			this.log.warn(`PICT-MarkdownEditor removeSegment: cannot remove the last segment.`);
			return;
		}

		if (this._segmentEditors[pSegmentIndex])
		{
			this._segmentEditors[pSegmentIndex].destroy();
			delete this._segmentEditors[pSegmentIndex];
		}

		tmpSegments.splice(tmpLogicalIndex, 1);
		this._setSegmentsToData(tmpSegments);

		// Update per-segment hidden preview state after removal
		let tmpNewHidden = {};
		for (let tmpKey in this._hiddenPreviewSegments)
		{
			let tmpIdx = parseInt(tmpKey, 10);
			if (tmpIdx < tmpLogicalIndex)
			{
				tmpNewHidden[tmpIdx] = true;
			}
			else if (tmpIdx > tmpLogicalIndex)
			{
				tmpNewHidden[tmpIdx - 1] = true;
			}
			// tmpIdx === tmpLogicalIndex is the removed segment; skip it
		}
		this._hiddenPreviewSegments = tmpNewHidden;

		// Update per-segment tab states after removal
		let tmpNewTabStates = {};
		for (let tmpKey in this._segmentTabStates)
		{
			let tmpIdx = parseInt(tmpKey, 10);
			if (tmpIdx < tmpLogicalIndex)
			{
				tmpNewTabStates[tmpIdx] = this._segmentTabStates[tmpKey];
			}
			else if (tmpIdx > tmpLogicalIndex)
			{
				tmpNewTabStates[tmpIdx - 1] = this._segmentTabStates[tmpKey];
			}
		}
		this._segmentTabStates = tmpNewTabStates;

		this._buildEditorUI();
	}

	/**
	 * Move a segment up by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	moveSegmentUp(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		if (tmpLogicalIndex <= 0)
		{
			return;
		}

		this._marshalAllEditorsToData();

		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		let tmpTemp = tmpSegments[tmpLogicalIndex];
		tmpSegments[tmpLogicalIndex] = tmpSegments[tmpLogicalIndex - 1];
		tmpSegments[tmpLogicalIndex - 1] = tmpTemp;

		// Swap per-segment hidden preview state to follow the moved segment
		this._swapHiddenPreviewState(tmpLogicalIndex, tmpLogicalIndex - 1);
		this._swapSegmentTabStates(tmpLogicalIndex, tmpLogicalIndex - 1);

		this._buildEditorUI();
	}

	/**
	 * Move a segment down by its internal index.
	 *
	 * @param {number} pSegmentIndex - The internal segment index
	 */
	moveSegmentDown(pSegmentIndex)
	{
		let tmpLogicalIndex = this._getLogicalIndex(pSegmentIndex);
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments || tmpLogicalIndex < 0 || tmpLogicalIndex >= tmpSegments.length - 1)
		{
			return;
		}

		this._marshalAllEditorsToData();

		let tmpTemp = tmpSegments[tmpLogicalIndex];
		tmpSegments[tmpLogicalIndex] = tmpSegments[tmpLogicalIndex + 1];
		tmpSegments[tmpLogicalIndex + 1] = tmpTemp;

		// Swap per-segment hidden preview state to follow the moved segment
		this._swapHiddenPreviewState(tmpLogicalIndex, tmpLogicalIndex + 1);
		this._swapSegmentTabStates(tmpLogicalIndex, tmpLogicalIndex + 1);

		this._buildEditorUI();
	}

	/**
	 * Get the content of a specific segment by logical index.
	 *
	 * @param {number} pLogicalIndex - The logical (0-based) index
	 * @returns {string} The segment content
	 */
	getSegmentContent(pLogicalIndex)
	{
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		if (pLogicalIndex < 0 || pLogicalIndex >= tmpOrderedIndices.length)
		{
			return '';
		}

		let tmpInternalIndex = tmpOrderedIndices[pLogicalIndex];
		let tmpEditor = this._segmentEditors[tmpInternalIndex];
		if (tmpEditor)
		{
			return tmpEditor.state.doc.toString();
		}

		return '';
	}

	/**
	 * Set the content of a specific segment by logical index.
	 *
	 * @param {number} pLogicalIndex - The logical (0-based) index
	 * @param {string} pContent - The content to set
	 */
	setSegmentContent(pLogicalIndex, pContent)
	{
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		if (pLogicalIndex < 0 || pLogicalIndex >= tmpOrderedIndices.length)
		{
			this.log.warn(`PICT-MarkdownEditor setSegmentContent: index ${pLogicalIndex} out of range.`);
			return;
		}

		let tmpInternalIndex = tmpOrderedIndices[pLogicalIndex];
		let tmpEditor = this._segmentEditors[tmpInternalIndex];
		if (tmpEditor)
		{
			tmpEditor.dispatch(
			{
				changes:
				{
					from: 0,
					to: tmpEditor.state.doc.length,
					insert: pContent
				}
			});
		}
	}

	/**
	 * Get the total number of segments.
	 *
	 * @returns {number}
	 */
	getSegmentCount()
	{
		return this._getOrderedSegmentIndices().length;
	}

	/**
	 * Get all content from all segments joined together.
	 *
	 * @param {string} [pSeparator] - The separator between segments (default: "\n\n")
	 * @returns {string}
	 */
	getAllContent(pSeparator)
	{
		let tmpSeparator = (typeof (pSeparator) === 'string') ? pSeparator : '\n\n';
		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		let tmpParts = [];

		for (let i = 0; i < tmpOrderedIndices.length; i++)
		{
			let tmpEditor = this._segmentEditors[tmpOrderedIndices[i]];
			if (tmpEditor)
			{
				tmpParts.push(tmpEditor.state.doc.toString());
			}
		}

		return tmpParts.join(tmpSeparator);
	}

	/**
	 * Marshal all editor contents back into the data address.
	 */
	_marshalAllEditorsToData()
	{
		let tmpSegments = this._getSegmentsFromData();
		if (!tmpSegments)
		{
			return;
		}

		let tmpOrderedIndices = this._getOrderedSegmentIndices();
		for (let i = 0; i < tmpOrderedIndices.length; i++)
		{
			let tmpEditor = this._segmentEditors[tmpOrderedIndices[i]];
			if (tmpEditor && i < tmpSegments.length)
			{
				tmpSegments[i].Content = tmpEditor.state.doc.toString();
			}
		}
	}

	/**
	 * Set the read-only state of all editors.
	 *
	 * @param {boolean} pReadOnly - Whether editors should be read-only
	 */
	setReadOnly(pReadOnly)
	{
		this.options.ReadOnly = pReadOnly;
		if (this.initialRenderComplete)
		{
			this._marshalAllEditorsToData();
			this._buildEditorUI();
		}
	}

	/**
	 * Marshal content from the data address into the view.
	 */
	marshalToView()
	{
		super.marshalToView();
		if (this.initialRenderComplete && this.options.ContentDataAddress)
		{
			this._buildEditorUI();
		}
	}

	/**
	 * Marshal the current editor content back to the data address.
	 */
	marshalFromView()
	{
		super.marshalFromView();
		this._marshalAllEditorsToData();
	}

	/**
	 * Destroy all editors and clean up.
	 */
	destroy()
	{
		for (let tmpIndex in this._segmentEditors)
		{
			if (this._segmentEditors[tmpIndex])
			{
				this._segmentEditors[tmpIndex].destroy();
			}
		}
		this._segmentEditors = {};

		// Clear rich preview debounce timers
		for (let tmpIndex in this._richPreviewTimers)
		{
			clearTimeout(this._richPreviewTimers[tmpIndex]);
		}
		this._richPreviewTimers = {};
		this._richPreviewGenerations = {};
		this._segmentTabStates = {};
	}
}

module.exports = PictSectionMarkdownEditor;

module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-MDE-CodeMirror.js":137,"./Pict-MDE-DragAndReorder.js":138,"./Pict-MDE-Formatting.js":139,"./Pict-MDE-ImageHandling.js":140,"./Pict-MDE-RichPreview.js":141,"./Pict-Section-MarkdownEditor-DefaultConfiguration.js":142,"pict-section-content":133,"pict-view":239}],144:[function(require,module,exports){
/**
 * Pict-Modal-Confirm
 *
 * Builds confirm and double-confirm dialog DOM, returns Promises.
 */
class PictModalConfirm
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a single-step confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmLabel, cancelLabel, dangerous)
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is provided, user must type it to enable the confirm button.
	 * Otherwise, first click changes button text, second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options (title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel)
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultDoubleConfirmOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDoubleConfirmDialog(tmpOptions.title, pMessage, fResolve, tmpOptions);
			this._showDialog(tmpDialog, fResolve);
		});
	}

	/**
	 * Build a standard confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpBtnStyle = pOptions.dangerous ? 'danger' : 'primary';

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				'<p>' + this._escapeHTML(pMessage) + '</p>' +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--' + tmpBtnStyle + '" data-action="confirm">' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpConfirmBtn.addEventListener('click', () => { tmpDismiss(true); });

		tmpDialog._dismiss = tmpDismiss;
		tmpDialog._focusTarget = tmpCancelBtn;

		return tmpDialog;
	}

	/**
	 * Build a double-confirm dialog element.
	 *
	 * @param {string} pTitle
	 * @param {string} pMessage
	 * @param {function} fResolve - Promise resolver
	 * @param {object} pOptions
	 * @returns {HTMLElement}
	 */
	_buildDoubleConfirmDialog(pTitle, pMessage, fResolve, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpHasPhrase = (typeof pOptions.confirmPhrase === 'string') && (pOptions.confirmPhrase.length > 0);

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = '420px';

		let tmpBodyContent = '<p>' + this._escapeHTML(pMessage) + '</p>';

		if (tmpHasPhrase)
		{
			let tmpPromptText = pOptions.phrasePrompt.replace('{phrase}', pOptions.confirmPhrase);
			tmpBodyContent +=
				'<div class="pict-modal-confirm-prompt">' + this._escapeHTML(tmpPromptText) + '</div>' +
				'<input type="text" class="pict-modal-confirm-input" autocomplete="off" spellcheck="false" />';
		}

		tmpDialog.innerHTML =
			'<div class="pict-modal-dialog-header">' +
				'<span class="pict-modal-dialog-title">' + this._escapeHTML(pTitle) + '</span>' +
				'<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>' +
			'</div>' +
			'<div class="pict-modal-dialog-body">' +
				tmpBodyContent +
			'</div>' +
			'<div class="pict-modal-dialog-footer">' +
				'<button class="pict-modal-btn" data-action="cancel">' + this._escapeHTML(pOptions.cancelLabel) + '</button>' +
				'<button class="pict-modal-btn pict-modal-btn--danger" data-action="confirm" disabled>' + this._escapeHTML(pOptions.confirmLabel) + '</button>' +
			'</div>';

		let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
		let tmpCancelBtn = tmpDialog.querySelector('[data-action="cancel"]');
		let tmpConfirmBtn = tmpDialog.querySelector('[data-action="confirm"]');

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve);
		};

		tmpCloseBtn.addEventListener('click', () => { tmpDismiss(false); });
		tmpCancelBtn.addEventListener('click', () => { tmpDismiss(false); });

		if (tmpHasPhrase)
		{
			// Phrase-based: enable confirm button when input matches
			let tmpInput = tmpDialog.querySelector('.pict-modal-confirm-input');
			tmpInput.addEventListener('input', () =>
			{
				tmpConfirmBtn.disabled = (tmpInput.value !== pOptions.confirmPhrase);
			});
			tmpConfirmBtn.addEventListener('click', () =>
			{
				if (!tmpConfirmBtn.disabled)
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpInput;
		}
		else
		{
			// Two-click: first click changes label, second click confirms
			let tmpClickCount = 0;
			let tmpOriginalLabel = pOptions.confirmLabel;
			tmpConfirmBtn.disabled = false;

			tmpConfirmBtn.addEventListener('click', () =>
			{
				tmpClickCount++;
				if (tmpClickCount === 1)
				{
					tmpConfirmBtn.textContent = 'Click again to confirm';
				}
				else
				{
					tmpDismiss(true);
				}
			});
			tmpDialog._focusTarget = tmpCancelBtn;
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show a dialog element: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {function} fResolve - Promise resolver (for overlay click dismiss)
	 */
	_showDialog(pDialog, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'confirm'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(false); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track active modal
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus
		if (pDialog._focusTarget)
		{
			pDialog._focusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape')
			{
				pDialog._dismiss(false);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);
	}

	/**
	 * Dismiss a dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult - Value to resolve the promise with
	 * @param {function} fResolve - Promise resolver
	 */
	_dismissDialog(pDialog, pResult, fResolve)
	{
		// Prevent double-dismiss
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		// Remove keyboard handler
		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		// Animate out
		pDialog.classList.remove('pict-modal-visible');

		// Remove from active modals
		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		// Update overlay click handler to point to new topmost modal
		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		// Hide overlay
		this._modal._overlay.hide();

		// Remove from DOM after transition
		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		// Resolve promise
		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalConfirm;

},{}],145:[function(require,module,exports){
/**
 * Pict-Modal-Dropdown
 *
 * Anchor-positioned menu that behaves like a dropdown / popover. Handy for:
 *   - nav menus that hang off a header link or button
 *   - "split button" style addenda (a primary action paired with a chevron
 *     that opens a list of related/alternate actions)
 *   - any "more options" affordance where a full modal would be heavy
 *
 * Differences from the modal Window helper:
 *   - No backdrop overlay — the rest of the page stays interactive.
 *   - Positioned next to the anchor element, not centered.
 *   - Auto-flips above when there isn't room below; clamps inside the viewport.
 *   - Click outside or Escape dismisses (matches native menu conventions).
 *
 * Usage:
 *     modal.dropdown(anchorEl, {
 *         items:
 *         [
 *             { Hash: 'edit',   Label: 'Edit'                    },
 *             { Hash: 'rename', Label: 'Rename...'                },
 *             { Separator: true                                   },
 *             { Hash: 'delete', Label: 'Delete', Style: 'danger'  },
 *             { Hash: 'archive',Label: 'Archive', Disabled: true,
 *               Tooltip: 'Already archived'                       }
 *         ],
 *         align: 'left'        // 'left' | 'right' (relative to anchor)
 *     }).then((pChoice) => { ... });
 *
 * Returns a Promise that resolves with `{ Hash, Item }` on selection or
 * `null` on dismiss.
 */
class PictModalDropdown
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._activeMenu = null;
	}

	/**
	 * Open a dropdown menu anchored to an element.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   a rect-like { left, top, width, height } anchor (handy for context menus).
	 * @param {object} pOptions
	 * @param {Array}    pOptions.items     - [{ Hash, Label, Style?, Disabled?, Tooltip?, Icon?, Separator? }]
	 * @param {string}   [pOptions.align]   - 'left'|'right' (default 'left')
	 * @param {string}   [pOptions.position]- 'auto'|'below'|'above' (default 'auto')
	 * @param {string}   [pOptions.minWidth]- CSS minWidth (default: anchor width if known, else '160px')
	 * @param {string}   [pOptions.maxHeight]- CSS maxHeight (default '60vh')
	 * @param {string}   [pOptions.className]- extra class(es) for the menu element
	 * @param {boolean}  [pOptions.closeOnSelect] - default true
	 * @param {function} [pOptions.onSelect]- called with (Hash, Item) on selection
	 * @param {function} [pOptions.onClose] - called after dismiss
	 * @returns {Promise<{Hash: string, Item: object}|null>}
	 */
	dropdown(pAnchor, pOptions)
	{
		let tmpOptions = Object.assign(
			{
				align:         'left',
				position:      'auto',
				maxHeight:     '60vh',
				closeOnSelect: true,
			},
			pOptions || {});

		let tmpAnchorEl = this._resolveAnchor(pAnchor);
		let tmpAnchorRect = this._anchorRect(pAnchor, tmpAnchorEl);
		if (!tmpAnchorRect) { return Promise.resolve(null); }

		// Re-opening the same menu is a no-op; closing-then-reopening is a
		// caller decision (just call dismissDropdown() first).
		if (this._activeMenu && this._activeMenu.anchor === tmpAnchorEl)
		{
			return this._activeMenu.promise;
		}

		// Only one dropdown at a time keeps focus / keyboard handling sane.
		this.dismissAll();

		let tmpItems = Array.isArray(tmpOptions.items) ? tmpOptions.items : [];

		let tmpResolveOuter;
		let tmpPromise = new Promise((fResolve) => { tmpResolveOuter = fResolve; });

		let tmpMenu = this._buildMenu(tmpItems, tmpOptions);
		document.body.appendChild(tmpMenu);
		this._positionMenu(tmpMenu, tmpAnchorRect, tmpOptions);

		// Animate in on the next frame.
		void tmpMenu.offsetHeight;
		tmpMenu.classList.add('pict-modal-visible');

		let tmpDismiss = (pResult) =>
		{
			if (tmpMenu._dismissed) { return; }
			tmpMenu._dismissed = true;
			document.removeEventListener('mousedown', tmpOutsideHandler, true);
			document.removeEventListener('keydown', tmpKeyHandler, true);
			window.removeEventListener('resize', tmpRepositionHandler);
			window.removeEventListener('scroll', tmpRepositionHandler, true);
			tmpMenu.classList.remove('pict-modal-visible');
			setTimeout(() =>
				{
					if (tmpMenu.parentNode) { tmpMenu.parentNode.removeChild(tmpMenu); }
				}, 180);
			if (this._activeMenu && this._activeMenu.element === tmpMenu) { this._activeMenu = null; }
			if (typeof tmpOptions.onClose === 'function') { tmpOptions.onClose(pResult); }
			tmpResolveOuter(pResult);
		};

		// Wire item clicks (each item element carries a data-hash; separators
		// and disabled items are skipped).
		let tmpItemEls = tmpMenu.querySelectorAll('[data-pict-modal-dropdown-item]');
		for (let i = 0; i < tmpItemEls.length; i++)
		{
			let tmpEl = tmpItemEls[i];
			tmpEl.addEventListener('click', (pEvent) =>
				{
					if (tmpEl.hasAttribute('data-disabled')) { return; }
					pEvent.stopPropagation();
					let tmpIdx = parseInt(tmpEl.getAttribute('data-index'), 10);
					let tmpItem = tmpItems[tmpIdx];
					let tmpHash = tmpEl.getAttribute('data-hash');
					if (typeof tmpOptions.onSelect === 'function')
					{
						tmpOptions.onSelect(tmpHash, tmpItem);
					}
					if (tmpOptions.closeOnSelect !== false) { tmpDismiss({ Hash: tmpHash, Item: tmpItem }); }
				});
		}

		// Click anywhere outside the menu (and outside the anchor) → dismiss.
		// Use mousedown/capture so we beat any per-element click handlers.
		let tmpOutsideHandler = (pEvent) =>
		{
			if (tmpMenu.contains(pEvent.target)) { return; }
			if (tmpAnchorEl && tmpAnchorEl.contains && tmpAnchorEl.contains(pEvent.target)) { return; }
			tmpDismiss(null);
		};
		document.addEventListener('mousedown', tmpOutsideHandler, true);

		// Esc dismisses; arrow keys navigate items (skipping disabled/separator).
		let tmpKeyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape') { pEvent.stopPropagation(); tmpDismiss(null); return; }
			if (pEvent.key === 'ArrowDown' || pEvent.key === 'ArrowUp')
			{
				pEvent.preventDefault();
				this._focusNeighbor(tmpMenu, pEvent.key === 'ArrowDown' ? 1 : -1);
			}
			else if (pEvent.key === 'Enter' || pEvent.key === ' ')
			{
				let tmpFocused = document.activeElement;
				if (tmpFocused && tmpMenu.contains(tmpFocused) && tmpFocused.hasAttribute('data-pict-modal-dropdown-item'))
				{
					pEvent.preventDefault();
					tmpFocused.click();
				}
			}
		};
		document.addEventListener('keydown', tmpKeyHandler, true);

		// Reposition on viewport resize / scroll so the menu doesn't drift
		// off the anchor.
		let tmpRepositionHandler = () =>
		{
			let tmpRect = this._anchorRect(pAnchor, tmpAnchorEl);
			if (tmpRect) { this._positionMenu(tmpMenu, tmpRect, tmpOptions); }
		};
		window.addEventListener('resize', tmpRepositionHandler);
		window.addEventListener('scroll', tmpRepositionHandler, true);

		// Move keyboard focus to the first enabled item so arrows / Enter work
		// without an extra click.
		setTimeout(() => { this._focusFirstEnabled(tmpMenu); }, 0);

		this._activeMenu = { element: tmpMenu, anchor: tmpAnchorEl, promise: tmpPromise, dismiss: tmpDismiss };

		return tmpPromise;
	}

	/**
	 * Dismiss the currently-open dropdown (if any).
	 */
	dismissAll()
	{
		if (this._activeMenu)
		{
			let tmpDismiss = this._activeMenu.dismiss;
			this._activeMenu = null;
			tmpDismiss(null);
		}
	}

	// ─────────────────────────────────────────────
	//  Internals
	// ─────────────────────────────────────────────

	_resolveAnchor(pAnchor)
	{
		if (!pAnchor) { return null; }
		if (typeof pAnchor === 'string') { return document.querySelector(pAnchor); }
		if (pAnchor.nodeType === 1) { return pAnchor; }
		// rect-like — no element to attach focus / outside-click ignore to,
		// but that's fine, the caller knows what they're doing.
		return null;
	}

	_anchorRect(pAnchor, pAnchorEl)
	{
		if (pAnchorEl && typeof pAnchorEl.getBoundingClientRect === 'function')
		{
			return pAnchorEl.getBoundingClientRect();
		}
		if (pAnchor && typeof pAnchor === 'object'
			&& typeof pAnchor.left === 'number' && typeof pAnchor.top === 'number')
		{
			return {
				left:   pAnchor.left,
				top:    pAnchor.top,
				width:  pAnchor.width  || 0,
				height: pAnchor.height || 0,
				right:  pAnchor.left + (pAnchor.width  || 0),
				bottom: pAnchor.top  + (pAnchor.height || 0),
			};
		}
		return null;
	}

	_buildMenu(pItems, pOptions)
	{
		let tmpId = this._modal._nextId();
		let tmpMenu = document.createElement('div');
		tmpMenu.className = 'pict-modal-dropdown';
		if (pOptions.className) { tmpMenu.className += ' ' + pOptions.className; }
		tmpMenu.id = 'pict-modal-dropdown-' + tmpId;
		tmpMenu.setAttribute('role', 'menu');
		tmpMenu.style.maxHeight = pOptions.maxHeight;

		let tmpHtml = '';
		for (let i = 0; i < pItems.length; i++)
		{
			let tmpItem = pItems[i];
			if (tmpItem.Separator)
			{
				tmpHtml += '<div class="pict-modal-dropdown-separator" role="separator"></div>';
				continue;
			}
			if (tmpItem.Header)
			{
				tmpHtml += '<div class="pict-modal-dropdown-header">'
					+ this._escapeHTML(tmpItem.Header) + '</div>';
				continue;
			}
			let tmpCls = 'pict-modal-dropdown-item';
			if (tmpItem.Style)    { tmpCls += ' pict-modal-dropdown-item--' + tmpItem.Style; }
			if (tmpItem.Disabled) { tmpCls += ' pict-modal-dropdown-item--disabled'; }
			let tmpAttrs = ''
				+ ' data-pict-modal-dropdown-item'
				+ ' data-index="' + i + '"'
				+ ' data-hash="'  + this._escapeHTML(tmpItem.Hash || '') + '"'
				+ ' role="menuitem"'
				+ ' tabindex="-1"';
			if (tmpItem.Disabled) { tmpAttrs += ' aria-disabled="true" data-disabled'; }
			if (tmpItem.Tooltip)  { tmpAttrs += ' title="' + this._escapeHTML(tmpItem.Tooltip) + '"'; }
			let tmpIcon = tmpItem.Icon ? '<span class="pict-modal-dropdown-item-icon">' + tmpItem.Icon + '</span>' : '';
			let tmpHint = tmpItem.Hint ? '<span class="pict-modal-dropdown-item-hint">' + this._escapeHTML(tmpItem.Hint) + '</span>' : '';
			tmpHtml += '<div class="' + tmpCls + '"' + tmpAttrs + '>'
				+ tmpIcon
				+ '<span class="pict-modal-dropdown-item-label">' + this._escapeHTML(tmpItem.Label || '') + '</span>'
				+ tmpHint
				+ '</div>';
		}

		tmpMenu.innerHTML = tmpHtml;
		return tmpMenu;
	}

	_positionMenu(pMenu, pAnchorRect, pOptions)
	{
		// Apply min-width before measuring so the menu's natural size accounts
		// for the constraint.
		let tmpMinWidth = pOptions.minWidth
			|| (pAnchorRect.width >= 80 ? Math.ceil(pAnchorRect.width) + 'px' : '160px');
		pMenu.style.minWidth = tmpMinWidth;

		// Measure after attaching.
		let tmpMenuRect = pMenu.getBoundingClientRect();
		let tmpVw = window.innerWidth || document.documentElement.clientWidth;
		let tmpVh = window.innerHeight || document.documentElement.clientHeight;
		let tmpGap = 4; // breathing room between anchor and menu

		// Vertical: prefer below; flip above when not enough room and there's
		// more above. 'below'/'above' overrides force the side.
		let tmpRoomBelow = tmpVh - pAnchorRect.bottom - tmpGap;
		let tmpRoomAbove = pAnchorRect.top - tmpGap;
		let tmpPlaceAbove;
		if      (pOptions.position === 'above') { tmpPlaceAbove = true; }
		else if (pOptions.position === 'below') { tmpPlaceAbove = false; }
		else { tmpPlaceAbove = (tmpMenuRect.height > tmpRoomBelow) && (tmpRoomAbove > tmpRoomBelow); }

		// Cap height to whichever side we landed on so the menu can scroll
		// internally instead of running off the screen.
		let tmpCap = Math.max(80, (tmpPlaceAbove ? tmpRoomAbove : tmpRoomBelow) - 8);
		pMenu.style.maxHeight = tmpCap + 'px';

		// Horizontal alignment to the anchor, then clamp inside the viewport.
		let tmpLeft;
		if (pOptions.align === 'right')
		{
			tmpLeft = pAnchorRect.right - tmpMenuRect.width;
		}
		else if (pOptions.align === 'center')
		{
			tmpLeft = pAnchorRect.left + (pAnchorRect.width - tmpMenuRect.width) / 2;
		}
		else
		{
			tmpLeft = pAnchorRect.left;
		}
		tmpLeft = Math.min(tmpLeft, tmpVw - tmpMenuRect.width - 4);
		tmpLeft = Math.max(4, tmpLeft);

		let tmpTop;
		if (tmpPlaceAbove)
		{
			tmpTop = Math.max(4, pAnchorRect.top - tmpMenuRect.height - tmpGap);
			pMenu.classList.add('pict-modal-dropdown--above');
		}
		else
		{
			tmpTop = pAnchorRect.bottom + tmpGap;
			pMenu.classList.remove('pict-modal-dropdown--above');
		}

		pMenu.style.left = Math.round(tmpLeft) + 'px';
		pMenu.style.top  = Math.round(tmpTop)  + 'px';
	}

	_focusFirstEnabled(pMenu)
	{
		let tmpItems = pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])');
		if (tmpItems.length) { tmpItems[0].focus(); }
	}

	_focusNeighbor(pMenu, pDirection)
	{
		let tmpItems = Array.prototype.slice.call(
			pMenu.querySelectorAll('[data-pict-modal-dropdown-item]:not([data-disabled])'));
		if (!tmpItems.length) { return; }
		let tmpActive = document.activeElement;
		let tmpIdx = tmpItems.indexOf(tmpActive);
		let tmpNext = (tmpIdx === -1)
			? (pDirection > 0 ? 0 : tmpItems.length - 1)
			: (tmpIdx + pDirection + tmpItems.length) % tmpItems.length;
		tmpItems[tmpNext].focus();
	}

	_escapeHTML(pText)
	{
		if (typeof pText !== 'string') { return ''; }
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalDropdown;

},{}],146:[function(require,module,exports){
/**
 * Pict-Modal-Overlay
 *
 * Manages a shared backdrop overlay element appended to document.body.
 * Reference-counted — created on first modal open, removed when last closes.
 */
class PictModalOverlay
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._element = null;
		this._refCount = 0;
	}

	/**
	 * Show the overlay (incrementing reference count).
	 * Creates the DOM element on first call.
	 *
	 * @param {function} [fOnClick] - Optional click handler (e.g. dismiss topmost modal)
	 */
	show(fOnClick)
	{
		this._refCount++;

		if (!this._element)
		{
			this._element = document.createElement('div');
			this._element.className = 'pict-modal-overlay';
			document.body.appendChild(this._element);

			// Force reflow so the transition animates
			void this._element.offsetHeight;
			this._element.classList.add('pict-modal-visible');
		}

		if (fOnClick)
		{
			// Store the latest click handler (for the topmost modal)
			this._currentClickHandler = fOnClick;
			this._element.onclick = (pEvent) =>
			{
				if (pEvent.target === this._element && this._currentClickHandler)
				{
					this._currentClickHandler();
				}
			};
		}
	}

	/**
	 * Update the overlay click handler (e.g. when topmost modal changes).
	 *
	 * @param {function} [fOnClick] - New click handler
	 */
	updateClickHandler(fOnClick)
	{
		this._currentClickHandler = fOnClick || null;
	}

	/**
	 * Hide the overlay (decrementing reference count).
	 * Removes the DOM element when reference count reaches zero.
	 */
	hide()
	{
		this._refCount--;

		if (this._refCount <= 0)
		{
			this._refCount = 0;
			if (this._element)
			{
				this._element.classList.remove('pict-modal-visible');
				let tmpElement = this._element;
				// Remove after transition
				setTimeout(() =>
				{
					if (tmpElement.parentNode)
					{
						tmpElement.parentNode.removeChild(tmpElement);
					}
				}, 220);
				this._element = null;
				this._currentClickHandler = null;
			}
		}
	}

	/**
	 * Force-remove the overlay regardless of reference count.
	 */
	destroy()
	{
		this._refCount = 0;
		if (this._element && this._element.parentNode)
		{
			this._element.parentNode.removeChild(this._element);
		}
		this._element = null;
		this._currentClickHandler = null;
	}
}

module.exports = PictModalOverlay;

},{}],147:[function(require,module,exports){
/**
 * Pict-Modal-Panel
 *
 * Adds resizable and collapsible panel behavior to any DOM element.
 * Follows the handler composition pattern used by the other modal
 * handlers (confirm, window, toast, tooltip).
 *
 * Usage:
 *   let handle = modal.panel('#my-panel', { position: 'right', width: 340 });
 *   handle.toggle();
 *   handle.destroy();
 */
class PictModalPanel
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._panels = [];
	}

	/**
	 * Attach resizable/collapsible panel behavior to an element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Panel options
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	create(pTargetSelector, pOptions)
	{
		let tmpDefaults = (this._modal && this._modal.options && this._modal.options.DefaultPanelOptions) || {};
		let tmpOptions = Object.assign({},
			{
				position: 'right',
				width: 340,
				minWidth: 200,
				maxWidth: 600,
				collapsible: true,
				collapsed: false,
				persist: false,
				persistKey: '',
				onResize: null,
				onToggle: null
			},
			tmpDefaults,
			pOptions);

		if (typeof document === 'undefined') return this._nullHandle();

		let tmpTarget = document.querySelector(pTargetSelector);
		if (!tmpTarget) return this._nullHandle();

		let tmpId = this._modal._nextId();
		let tmpIsRight = tmpOptions.position === 'right';
		let tmpIsCollapsed = false;
		let tmpCurrentWidth = tmpOptions.width;
		let tmpDestroyed = false;

		// Restore persisted state
		if (tmpOptions.persist && tmpOptions.persistKey)
		{
			try
			{
				let tmpStored = localStorage.getItem('pict-panel-' + tmpOptions.persistKey);
				if (tmpStored)
				{
					let tmpParsed = JSON.parse(tmpStored);
					if (typeof tmpParsed.width === 'number') tmpCurrentWidth = tmpParsed.width;
					if (typeof tmpParsed.collapsed === 'boolean') tmpOptions.collapsed = tmpParsed.collapsed;
				}
			}
			catch (e) { /* ignore */ }
		}

		// Apply classes and initial width
		tmpTarget.classList.add('pict-panel');
		tmpTarget.classList.add(tmpIsRight ? 'pict-panel-right' : 'pict-panel-left');
		tmpTarget.style.width = tmpCurrentWidth + 'px';

		// Remove display:none if present — panel uses width collapse instead
		if (tmpTarget.style.display === 'none')
		{
			tmpTarget.style.display = '';
		}

		// ── Create the edge container ───────────────────────
		let tmpEdge = document.createElement('div');
		tmpEdge.className = 'pict-panel-edge ' + (tmpIsRight ? 'pict-panel-edge-right' : 'pict-panel-edge-left');

		// Resize handle
		let tmpResize = document.createElement('div');
		tmpResize.className = 'pict-panel-resize';
		tmpEdge.appendChild(tmpResize);

		// Collapse tab (chevron SVG)
		let tmpTab = null;
		if (tmpOptions.collapsible)
		{
			tmpTab = document.createElement('div');
			tmpTab.className = 'pict-panel-tab';
			tmpTab.title = 'Toggle panel';
			tmpEdge.appendChild(tmpTab);
		}

		// Insert edge as a sibling so it is not clipped by the
		// panel's own overflow (e.g. overflow-y: auto for scrolling).
		// Right panels: edge goes BEFORE the panel (left side).
		// Left panels: edge goes AFTER the panel (right side).
		if (tmpTarget.parentNode)
		{
			if (tmpIsRight)
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget);
			}
			else
			{
				tmpTarget.parentNode.insertBefore(tmpEdge, tmpTarget.nextSibling);
			}
		}
		else
		{
			tmpTarget.insertBefore(tmpEdge, tmpTarget.firstChild);
		}

		// ── Chevron lookup via pict.providers.Icon ──────────
		// Both directions come from the core registry (`{~I:ChevronLeft~}`
		// / `{~I:ChevronRight~}`).  Resolved per-render so a theme that
		// re-registers the chevron variant picks up automatically.  Empty
		// fallback in the unlikely case pict is missing the Icon provider
		// (very old pict versions; current minimum is 1.0.368).
		let tmpPictHandle = (typeof (window) !== 'undefined' && window.pict) ? window.pict : null;
		let tmpIcon = (pName) => (tmpPictHandle && typeof (tmpPictHandle.icon) === 'function')
			? tmpPictHandle.icon(pName)
			: '';

		let tmpUpdateChevron = () =>
		{
			if (!tmpTab) return;
			let tmpChevronRight = tmpIcon('ChevronRight');
			let tmpChevronLeft  = tmpIcon('ChevronLeft');
			if (tmpIsRight)
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronLeft : tmpChevronRight;
			}
			else
			{
				tmpTab.innerHTML = tmpIsCollapsed ? tmpChevronRight : tmpChevronLeft;
			}
		};

		// ── Persist helper ──────────────────────────────────
		let tmpPersist = () =>
		{
			if (!tmpOptions.persist || !tmpOptions.persistKey) return;
			try
			{
				localStorage.setItem('pict-panel-' + tmpOptions.persistKey,
					JSON.stringify({ width: tmpCurrentWidth, collapsed: tmpIsCollapsed }));
			}
			catch (e) { /* ignore */ }
		};

		// ── Collapse / expand ───────────────────────────────
		let tmpCollapse = () =>
		{
			if (tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(true);
		};

		let tmpExpand = () =>
		{
			if (!tmpIsCollapsed || tmpDestroyed) return;
			tmpIsCollapsed = false;
			tmpEdge.classList.remove('pict-panel-edge-collapsed');
			tmpTarget.classList.remove('pict-panel-collapsed');
			tmpTarget.style.width = tmpCurrentWidth + 'px';
			tmpUpdateChevron();
			tmpPersist();
			if (typeof tmpOptions.onToggle === 'function') tmpOptions.onToggle(false);
		};

		let tmpToggle = () =>
		{
			if (tmpIsCollapsed) tmpExpand();
			else tmpCollapse();
		};

		let tmpSetWidth = (pWidth) =>
		{
			if (tmpDestroyed) return;
			let tmpWidth = Math.max(tmpOptions.minWidth, Math.min(tmpOptions.maxWidth, pWidth));
			tmpCurrentWidth = tmpWidth;
			if (!tmpIsCollapsed)
			{
				tmpTarget.style.width = tmpWidth + 'px';
			}
			tmpPersist();
			if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpWidth);
		};

		// ── Tab click ───────────────────────────────────────
		if (tmpTab)
		{
			tmpTab.addEventListener('click', (pEvent) =>
			{
				pEvent.stopPropagation();
				tmpToggle();
			});
		}

		// ── Resize drag ─────────────────────────────────────
		let tmpOnMouseDown = (pEvent) =>
		{
			if (tmpIsCollapsed) return;
			pEvent.preventDefault();

			let tmpStartX = pEvent.clientX;
			let tmpStartWidth = tmpTarget.offsetWidth;

			tmpResize.classList.add('dragging');
			tmpTarget.style.transition = 'none';
			document.body.style.userSelect = 'none';
			document.body.style.cursor = 'col-resize';

			let tmpOnMouseMove = (pMoveEvent) =>
			{
				let tmpDelta = tmpIsRight
					? (tmpStartX - pMoveEvent.clientX)
					: (pMoveEvent.clientX - tmpStartX);
				let tmpNewWidth = Math.max(tmpOptions.minWidth,
					Math.min(tmpOptions.maxWidth, tmpStartWidth + tmpDelta));
				tmpTarget.style.width = tmpNewWidth + 'px';
			};

			let tmpOnMouseUp = (pUpEvent) =>
			{
				document.removeEventListener('mousemove', tmpOnMouseMove);
				document.removeEventListener('mouseup', tmpOnMouseUp);

				tmpResize.classList.remove('dragging');
				tmpTarget.style.transition = '';
				document.body.style.userSelect = '';
				document.body.style.cursor = '';

				// Capture the final width
				tmpCurrentWidth = tmpTarget.offsetWidth;
				tmpPersist();
				if (typeof tmpOptions.onResize === 'function') tmpOptions.onResize(tmpCurrentWidth);
			};

			document.addEventListener('mousemove', tmpOnMouseMove);
			document.addEventListener('mouseup', tmpOnMouseUp);
		};

		tmpResize.addEventListener('mousedown', tmpOnMouseDown);

		// ── Initial state ───────────────────────────────────
		tmpUpdateChevron();

		if (tmpOptions.collapsed)
		{
			tmpIsCollapsed = true;
			tmpTarget.classList.add('pict-panel-collapsed');
			tmpEdge.classList.add('pict-panel-edge-collapsed');
			tmpUpdateChevron();
		}

		// ── Destroy ─────────────────────────────────────────
		let tmpDestroy = () =>
		{
			if (tmpDestroyed) return;
			tmpDestroyed = true;

			tmpResize.removeEventListener('mousedown', tmpOnMouseDown);
			if (tmpEdge.parentNode) tmpEdge.remove();
			tmpTarget.classList.remove('pict-panel', 'pict-panel-right', 'pict-panel-left', 'pict-panel-collapsed');
			tmpTarget.style.width = '';
			tmpTarget.style.transition = '';

			let tmpIdx = this._panels.indexOf(tmpHandle);
			if (tmpIdx >= 0) this._panels.splice(tmpIdx, 1);
		};

		// ── Return handle ───────────────────────────────────
		let tmpHandle =
		{
			id: tmpId,
			collapse: tmpCollapse,
			expand: tmpExpand,
			toggle: tmpToggle,
			setWidth: tmpSetWidth,
			destroy: tmpDestroy
		};

		this._panels.push(tmpHandle);
		return tmpHandle;
	}

	/**
	 * Return a no-op handle for server-side or missing-element cases.
	 */
	_nullHandle()
	{
		return {
			id: 0,
			collapse: () => {},
			expand: () => {},
			toggle: () => {},
			setWidth: () => {},
			destroy: () => {}
		};
	}

	/**
	 * Destroy all active panels.
	 */
	destroyAll()
	{
		let tmpPanels = this._panels.slice();
		for (let i = 0; i < tmpPanels.length; i++)
		{
			tmpPanels[i].destroy();
		}
	}
}

module.exports = PictModalPanel;

},{}],148:[function(require,module,exports){
/**
 * Pict-Modal-Shell — viewport-managing layout system for top / right /
 * bottom / left panels around a center.
 *
 * # What this is for
 *
 * Most apps grow a chrome of stacked bars: a topbar, sometimes a
 * sub-nav, sometimes a bottom status bar, often a left sidebar, maybe
 * a right inspector. Each one has its own collapse / resize / persist
 * concerns, and apps end up reinventing the layout glue + the chrome
 * controls per-app.
 *
 * The Shell solves this once. The host calls `modal.shell(viewport)`,
 * adds panels in the order they should stack from each edge, and the
 * Shell manages:
 *
 *   - DOM structure (a flex tree wrapping the viewport)
 *   - Layout placement (multiple panels per side, each in registration order)
 *   - Collapse / expand chrome (a thin tab strip when collapsed)
 *   - Resize chrome (drag handle on the inner edge)
 *   - Pinned (in-flow) vs overlay (absolutely-positioned) panels
 *   - Persistence (per-panel collapsed + size, scoped by host or custom key)
 *   - Center destination (the workspace area between all panels)
 *
 * # Usage
 *
 *   let tmpShell = modal.shell('#App-Container', { PersistenceKey: 'my-app' });
 *
 *   tmpShell.addPanel({
 *       Hash: 'topbar', Side: 'top', Mode: 'fixed', Size: 60,
 *       ContentDestinationId: 'App-TopBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'statusbar', Side: 'bottom', Mode: 'fixed', Size: 28,
 *       ContentDestinationId: 'App-StatusBar'
 *   });
 *   tmpShell.addPanel({
 *       Hash: 'sidebar', Side: 'left', Mode: 'resizable', Size: 280,
 *       MinSize: 180, MaxSize: 480, Title: 'Modules',
 *       ContentDestinationId: 'App-Sidebar'
 *   });
 *
 *   let tmpCenter = tmpShell.center({ ContentDestinationId: 'App-Workspace' });
 *
 *   // Render into the destinations the same way as any other Pict view.
 *   pict.ContentAssignment.assignContent('#App-Sidebar', tmpHTML);
 *
 * # Panel options
 *
 *   Hash:                 unique id within the shell (auto-generated if omitted).
 *                         Used as the localStorage key suffix and for getPanel().
 *   Side:                 'top' | 'right' | 'bottom' | 'left'.
 *   Mode:                 'fixed' (no chrome), 'collapsible' (collapse tab),
 *                         'resizable' (collapse tab + drag handle).
 *   Position:             'pinned' (default; takes layout space) or 'overlay'
 *                         (absolutely positioned over the center / siblings).
 *   Scope:                'shell' (default) | 'center'.
 *                         When 'shell', the panel mounts in one of the
 *                         outer rows / side stacks (Side decides which).
 *                         When 'center', the panel mounts INSIDE the
 *                         center column instead — useful for bars that
 *                         should align with the content area only, not
 *                         span across the sidebars.  Only Side='top' and
 *                         Side='bottom' are supported with Scope='center'.
 *                         The center auto-switches to a flex-column
 *                         layout so the content destination + inner
 *                         panels stack vertically.
 *   Size:                 initial px (height for top/bottom, width for left/right).
 *                         Default: 200 for sides, 60 for top/bottom.
 *   MinSize, MaxSize:     drag clamp for resizable panels.
 *   Collapsed:            initial state. Persisted state overrides this.
 *   CollapsedSize:        px the panel becomes when collapsed (default 24).
 *   Title:                shown in the collapse tab.
 *   Icon:                 optional inline SVG / HTML for the collapse tab.
 *   ContentDestinationId: id given to the inner content div so the host can
 *                         reach it via #ContentDestinationId selectors.
 *   ContentView:          ViewIdentifier (string) of a registered Pict view
 *                         that owns this panel's content. When set, the
 *                         shell auto-renders the view once at panel creation
 *                         (so the destination is filled before the user
 *                         opens the panel) AND again on every expand
 *                         transition (so freshly-streamed state shows up).
 *                         Centralises the "I created a panel — now I have
 *                         to remember to render the view into it" boilerplate.
 *   Persist:              default true; pass false to skip save/load for this
 *                         panel even when the shell has persistence enabled.
 *   Hidden:               default false. When true, the collapsed state has
 *                         NO visible chrome — no collapse tab, no edge
 *                         affordance, the panel root is display: none. The
 *                         only way to reveal it is a programmatic
 *                         expand()/toggle() from elsewhere (e.g. a topbar
 *                         gear). Mode still controls the EXPANDED chrome —
 *                         pass Mode: 'resizable' to keep the drag handle
 *                         while open, then vanish on collapse.
 *   OnExpand, OnCollapse: callbacks that fire ONLY on transitions
 *                         (collapsed→expanded or expanded→collapsed).
 *                         Cleaner than OnToggle which fires for both
 *                         directions and forces callers to inspect the
 *                         bool. OnToggle is kept for back-compat.
 *
 * # Persistence
 *
 *   Storage key:  'pict-modal-shell:' + <PersistenceKey or hostname or 'default'>
 *   Value shape:  { Version: 1, Panels: { <hash>: { Collapsed: bool, Size: number } } }
 */

const STORAGE_PREFIX = 'pict-modal-shell:';
const SCHEMA_VERSION = 1;
const DEFAULT_COLLAPSED_SIZE = 24;
const DEFAULT_SIZE_SIDE = 240;
const DEFAULT_SIZE_TOPBOTTOM = 60;

class PictModalShell
{
	constructor(pModalSection, pViewportEl, pOptions)
	{
		this._modal = pModalSection;
		this._viewport = pViewportEl;
		this._options = pOptions || {};
		this._panels = [];
		this._panelsByHash = {};
		this._centerDestinationEl = null;
		this._idCounter = 0;
		this._activeDrag = null;
		this._persistenceEnabled = (this._options.Persistence !== false);
		this._persistenceKey = this._persistenceEnabled
			? this._resolvePersistenceKey(this._options.PersistenceKey)
			: null;

		// Build the wrapper DOM inside the viewport.
		this._buildSkeleton();
	}

	// ────────────────────────────────────────────────────────────────
	//  Public API
	// ────────────────────────────────────────────────────────────────

	addPanel(pConfig)
	{
		let tmpPanel = new ShellPanel(this, pConfig || {});
		this._panels.push(tmpPanel);
		this._panelsByHash[tmpPanel.Hash] = tmpPanel;
		this._mountPanel(tmpPanel);
		// Render the bound ContentView once now so the destination has
		// content even before the user opens the panel. This is the
		// "create" half of the unified create-and-popup pattern — hosts
		// no longer need to chase down each panel and call view.render()
		// manually after addPanel().
		tmpPanel._renderContentView();
		return tmpPanel;
	}

	getPanel(pHash) { return this._panelsByHash[pHash] || null; }

	getPanels() { return this._panels.slice(); }

	/**
	 * Convenience for cross-view popup triggers. Equivalent to
	 * `shell.getPanel(hash).popup()`. Silently no-ops when the hash
	 * doesn't match a registered panel (so callers don't have to
	 * null-check during boot races).
	 */
	openPanel(pHash)
	{
		let tmpPanel = this._panelsByHash[pHash];
		if (tmpPanel) { tmpPanel.popup(); }
		return tmpPanel || null;
	}

	/**
	 * Configure the center area. Optional; if never called, the center
	 * still exists but has no host-supplied destination id (host can
	 * still reach it via .pict-modal-shell-center).
	 */
	center(pOptions)
	{
		pOptions = pOptions || {};
		if (pOptions.ContentDestinationId)
		{
			// Remove any previously-created destination so center() is
			// idempotent across reconfigurations.  We don't blow away
			// the whole center via innerHTML='' anymore: Scope:'center'
			// panels mounted by earlier addPanel() calls need to stay
			// in place.  Find the right insertion point so the
			// destination sits between any top-scoped panels and any
			// bottom-scoped panels.
			if (this._centerDestinationEl && this._centerDestinationEl.parentNode === this._centerEl)
			{
				this._centerEl.removeChild(this._centerDestinationEl);
			}
			let tmpInner = document.createElement('div');
			tmpInner.id = pOptions.ContentDestinationId;
			tmpInner.className = 'pict-modal-shell-center-content';
			let tmpFirstBottomScoped = null;
			let tmpChildren = this._centerEl.children;
			for (let i = 0; i < tmpChildren.length; i++)
			{
				let tmpCandidate = tmpChildren[i];
				if (tmpCandidate.classList && tmpCandidate.classList.contains('pict-modal-shell-panel-bottom'))
				{
					tmpFirstBottomScoped = tmpCandidate;
					break;
				}
			}
			if (tmpFirstBottomScoped)
			{
				this._centerEl.insertBefore(tmpInner, tmpFirstBottomScoped);
			}
			else
			{
				this._centerEl.appendChild(tmpInner);
			}
			this._centerDestinationEl = tmpInner;
		}
		return this._centerEl;
	}

	getCenterEl() { return this._centerEl; }

	destroy()
	{
		for (let i = 0; i < this._panels.length; i++) { this._panels[i].destroy(true); }
		this._panels = [];
		this._panelsByHash = {};
		if (this._wrapperEl && this._wrapperEl.parentNode)
		{
			this._wrapperEl.parentNode.removeChild(this._wrapperEl);
		}
		this._detachDragHandlers();
	}

	// ────────────────────────────────────────────────────────────────
	//  Persistence
	// ────────────────────────────────────────────────────────────────

	_resolvePersistenceKey(pUserKey)
	{
		if (typeof pUserKey === 'string' && pUserKey.length > 0) return STORAGE_PREFIX + pUserKey;
		try
		{
			if (typeof window !== 'undefined' && window.location && window.location.hostname)
			{
				return STORAGE_PREFIX + window.location.hostname;
			}
		}
		catch (pErr) { /* fall through */ }
		return STORAGE_PREFIX + 'default';
	}

	_loadState()
	{
		if (!this._persistenceKey) return null;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return null;
			let tmpRaw = tmpStore.getItem(this._persistenceKey);
			if (!tmpRaw) return null;
			let tmpParsed = JSON.parse(tmpRaw);
			if (!tmpParsed || tmpParsed.Version !== SCHEMA_VERSION) return null;
			return (tmpParsed.Panels && typeof tmpParsed.Panels === 'object') ? tmpParsed.Panels : {};
		}
		catch (pErr) { return null; }
	}

	_loadPanelState(pHash)
	{
		let tmpAll = this._loadState();
		if (!tmpAll) return null;
		return tmpAll[pHash] || null;
	}

	_savePanelState(pHash, pState)
	{
		if (!this._persistenceKey) return;
		try
		{
			let tmpStore = (typeof window !== 'undefined') ? window.localStorage : null;
			if (!tmpStore) return;
			let tmpAll = this._loadState() || {};
			tmpAll[pHash] = pState;
			tmpStore.setItem(this._persistenceKey, JSON.stringify(
			{
				Version: SCHEMA_VERSION,
				Panels: tmpAll,
				SavedAt: new Date().toISOString()
			}));
		}
		catch (pErr) { /* swallow */ }
	}

	// ────────────────────────────────────────────────────────────────
	//  DOM scaffolding
	// ────────────────────────────────────────────────────────────────

	_buildSkeleton()
	{
		// Wipe whatever was inside the viewport — the host opted into
		// the shell taking ownership of layout.
		this._viewport.innerHTML = '';
		this._viewport.classList.add('pict-modal-shell-host');

		this._wrapperEl = document.createElement('div');
		this._wrapperEl.className = 'pict-modal-shell';

		this._topRow = document.createElement('div');
		this._topRow.className = 'pict-modal-shell-row pict-modal-shell-row-top';
		this._wrapperEl.appendChild(this._topRow);

		this._middleRow = document.createElement('div');
		this._middleRow.className = 'pict-modal-shell-row pict-modal-shell-row-middle';
		this._wrapperEl.appendChild(this._middleRow);

		this._leftStack = document.createElement('div');
		this._leftStack.className = 'pict-modal-shell-side pict-modal-shell-side-left';
		this._middleRow.appendChild(this._leftStack);

		this._centerEl = document.createElement('div');
		this._centerEl.className = 'pict-modal-shell-center';
		this._middleRow.appendChild(this._centerEl);

		this._rightStack = document.createElement('div');
		this._rightStack.className = 'pict-modal-shell-side pict-modal-shell-side-right';
		this._middleRow.appendChild(this._rightStack);

		this._bottomRow = document.createElement('div');
		this._bottomRow.className = 'pict-modal-shell-row pict-modal-shell-row-bottom';
		this._wrapperEl.appendChild(this._bottomRow);

		// Overlay layer for overlay-position panels (absolute over middle row)
		this._overlayLayer = document.createElement('div');
		this._overlayLayer.className = 'pict-modal-shell-overlay-layer';
		this._middleRow.appendChild(this._overlayLayer);

		this._viewport.appendChild(this._wrapperEl);
	}

	_mountPanel(pPanel)
	{
		if (pPanel.Position === 'overlay')
		{
			this._overlayLayer.appendChild(pPanel.El);
			return;
		}
		if (pPanel.Scope === 'center')
		{
			// Center-scoped panels mount inside the center column.
			// The column switches to flex-column so the content
			// destination + the panel(s) stack vertically.
			this._centerEl.classList.add('pict-modal-shell-center-with-inner-panel');
			if (pPanel.Side === 'top')
			{
				// Top-scoped panels go above the content destination.
				// If center() hasn't run yet, this still works — we
				// insert before whatever's first (or just append to an
				// empty center, which leaves us above any subsequent
				// content destination).
				this._centerEl.insertBefore(pPanel.El, this._centerEl.firstChild);
			}
			else
			{
				// Side === 'bottom' (the Scope guard already filtered
				// left/right).  Append to the bottom of the center.
				this._centerEl.appendChild(pPanel.El);
			}
			return;
		}
		let tmpHost;
		if      (pPanel.Side === 'top')    tmpHost = this._topRow;
		else if (pPanel.Side === 'bottom') tmpHost = this._bottomRow;
		else if (pPanel.Side === 'left')   tmpHost = this._leftStack;
		else if (pPanel.Side === 'right')  tmpHost = this._rightStack;
		else                               tmpHost = this._wrapperEl;
		tmpHost.appendChild(pPanel.El);
	}

	// ────────────────────────────────────────────────────────────────
	//  Drag (resize) machinery — shared across all resizable panels.
	// ────────────────────────────────────────────────────────────────

	_attachDragStart(pPanel, pEvent)
	{
		pEvent.preventDefault();
		let tmpAxis = (pPanel.Side === 'top' || pPanel.Side === 'bottom') ? 'y' : 'x';
		this._activeDrag =
		{
			Panel:       pPanel,
			Axis:        tmpAxis,
			StartCoord:  (tmpAxis === 'x') ? pEvent.clientX : pEvent.clientY,
			StartSize:   pPanel.Size,
			Direction:   (pPanel.Side === 'left' || pPanel.Side === 'top') ? 1 : -1,
			PendingSize: null,
			RAFId:       0
		};
		document.body.classList.add(tmpAxis === 'x' ? 'pict-modal-shell-dragging-x' : 'pict-modal-shell-dragging-y');
		// Suppress the panel's collapse/expand width/height transition for
		// the duration of the drag — without this, every pointermove kicks
		// off a fresh 140ms transition that stacks up and renders the
		// resize as visibly laggy ("choppy"). With the transition off the
		// panel snaps to each new size in the same frame as the pointer.
		pPanel.El.classList.add('pict-modal-shell-panel-resizing');
		// Capture the pointer so dragging works even when the cursor leaves
		// the resize handle (otherwise the user has to keep the cursor
		// exactly on the 6 px strip — feels twitchy).
		try { pEvent.target.setPointerCapture && pEvent.target.setPointerCapture(pEvent.pointerId); }
		catch (pErr) { /* not supported in old browsers — fine */ }
		document.addEventListener('pointermove', this._onDragMove);
		document.addEventListener('pointerup',   this._onDragEnd);
	}

	// Pointer events fire at the device's input rate (often 240 Hz+ on
	// modern trackpads / mice) but we only paint at the display's refresh
	// rate (60–120 Hz). Coalesce multiple pointermoves per frame into a
	// single setSize() call via requestAnimationFrame — this drops the
	// per-frame work to one DOM mutation regardless of pointer rate.
	_onDragMove = (pEvent) =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		let tmpCoord = (tmpD.Axis === 'x') ? pEvent.clientX : pEvent.clientY;
		let tmpDelta = (tmpCoord - tmpD.StartCoord) * tmpD.Direction;
		tmpD.PendingSize = tmpD.StartSize + tmpDelta;
		if (!tmpD.RAFId)
		{
			let tmpSelf = this;
			tmpD.RAFId = (typeof window !== 'undefined' && window.requestAnimationFrame)
				? window.requestAnimationFrame(function () { tmpSelf._flushDrag(); })
				: setTimeout(function () { tmpSelf._flushDrag(); }, 16);
		}
	};

	_flushDrag()
	{
		let tmpD = this._activeDrag;
		if (!tmpD) return;
		tmpD.RAFId = 0;
		if (tmpD.PendingSize !== null)
		{
			tmpD.Panel.setSize(tmpD.PendingSize);
			tmpD.PendingSize = null;
		}
	}

	_onDragEnd = () =>
	{
		if (!this._activeDrag) return;
		let tmpD = this._activeDrag;
		// Flush any pending pointermove that hadn't painted yet so the
		// final size matches the actual cursor position, not the last
		// rAF-aligned value.
		if (tmpD.PendingSize !== null) { this._flushDrag(); }
		if (tmpD.RAFId && typeof window !== 'undefined' && window.cancelAnimationFrame)
		{
			window.cancelAnimationFrame(tmpD.RAFId);
		}
		document.body.classList.remove('pict-modal-shell-dragging-x');
		document.body.classList.remove('pict-modal-shell-dragging-y');
		tmpD.Panel.El.classList.remove('pict-modal-shell-panel-resizing');
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
		// Persist final size.
		tmpD.Panel._persist();
		this._activeDrag = null;
	};

	_detachDragHandlers()
	{
		document.removeEventListener('pointermove', this._onDragMove);
		document.removeEventListener('pointerup',   this._onDragEnd);
	}
}

// ════════════════════════════════════════════════════════════════════
//  ShellPanel — one panel within a Shell
// ════════════════════════════════════════════════════════════════════

class ShellPanel
{
	constructor(pShell, pConfig)
	{
		this._shell = pShell;
		this._config = pConfig;

		this.Hash = pConfig.Hash || ('panel-' + ++pShell._idCounter);
		this.Side = (pConfig.Side === 'right' || pConfig.Side === 'bottom' || pConfig.Side === 'left') ? pConfig.Side : 'top';
		this.Mode = (pConfig.Mode === 'collapsible' || pConfig.Mode === 'resizable') ? pConfig.Mode : 'fixed';
		this.Position = (pConfig.Position === 'overlay') ? 'overlay' : 'pinned';
		// Scope: 'center' opts the panel into the center column instead
		// of the shell's outer rows.  Only valid for Side='top'/'bottom'
		// (left/right inside center would need a separate axis we don't
		// support).  Invalid combinations silently fall back to 'shell'.
		this.Scope = (pConfig.Scope === 'center'
				&& (this.Side === 'top' || this.Side === 'bottom'))
			? 'center'
			: 'shell';
		this.Title = pConfig.Title || '';
		this.Icon  = pConfig.Icon  || '';
		this.MinSize = (typeof pConfig.MinSize === 'number') ? pConfig.MinSize : 40;
		this.MaxSize = (typeof pConfig.MaxSize === 'number') ? pConfig.MaxSize : 1200;
		// `Hidden: true` is a panel that has NO visible chrome in its collapsed
		// state — no collapse tab sliver, no resize handle, no edge marker, and
		// (via CSS) display: none on the panel root. The only way to reveal it
		// is a programmatic expand()/toggle() called from elsewhere in the app
		// (e.g. a gear button in the topbar). Useful when the host wants a
		// fully-shaped panel but doesn't want an always-visible affordance for
		// discovering it. The Mode is still honoured for the EXPANDED state —
		// pass Mode: 'resizable' to keep the drag handle while the panel is
		// open, while still vanishing entirely when collapsed.
		this.Hidden = !!pConfig.Hidden;
		this.CollapsedSize = (typeof pConfig.CollapsedSize === 'number')
			? pConfig.CollapsedSize
			: (this.Hidden ? 0 : DEFAULT_COLLAPSED_SIZE);
		this.PersistEnabled = pShell._persistenceEnabled && (pConfig.Persist !== false);

		let tmpDefaultSize = (this.Side === 'left' || this.Side === 'right') ? DEFAULT_SIZE_SIDE : DEFAULT_SIZE_TOPBOTTOM;
		this.Size = (typeof pConfig.Size === 'number') ? pConfig.Size : tmpDefaultSize;
		this.Collapsed = !!pConfig.Collapsed;

		// Persisted state overrides initial Size/Collapsed.
		if (this.PersistEnabled)
		{
			let tmpSaved = pShell._loadPanelState(this.Hash);
			if (tmpSaved)
			{
				if (typeof tmpSaved.Size === 'number') this.Size = tmpSaved.Size;
				if (typeof tmpSaved.Collapsed === 'boolean') this.Collapsed = tmpSaved.Collapsed;
			}
		}
		this._clampSize();

		// Build the panel DOM.
		this._buildEl(pConfig);
		this._applySize();
		this._applyCollapsedClass();

		// Responsive drawer — at narrow viewports, flip a docked side
		// panel into a "top drawer" by adding a class to the middle row
		// that toggles flex-direction from row to column. The panel
		// stretches to full width and trades its inline `width` for a
		// configurable drawer `height`. The user's collapse/expand
		// keeps working: collapsed in drawer mode just gives the panel
		// height: 0 (so only the collapse tab remains visible at the
		// top of the content), expanded restores the drawer height.
		// Pass `0` or omit to disable. Mirrors retold-remote's
		// `.content-editor-body { flex-direction: column }` pattern.
		this.ResponsiveDrawer = (typeof pConfig.ResponsiveDrawer === 'number'
			&& pConfig.ResponsiveDrawer > 0)
				? pConfig.ResponsiveDrawer : 0;
		// Drawer height — applied as `height` to the panel in drawer
		// mode. CSS units (px / vh / %) accepted. Default 33vh which
		// gives the panel roughly a third of the viewport height and
		// leaves comfortable room for the workspace below.
		this.DrawerHeight = (typeof pConfig.DrawerHeight === 'string' && pConfig.DrawerHeight)
			? pConfig.DrawerHeight : '33vh';
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
		if (this.ResponsiveDrawer > 0)
		{
			this._wireResponsiveDrawer();
		}
	}

	// ───────────── public ─────────────

	getContentEl() { return this._contentEl; }

	/**
	 * Returns the currently-bound ContentView Pict view instance, or
	 * null if no ContentView is configured / the view isn't registered
	 * yet.
	 */
	getContentView()
	{
		if (!this._config.ContentView) return null;
		let tmpPict = this._shell._modal && this._shell._modal.pict;
		if (!tmpPict || !tmpPict.views) return null;
		return tmpPict.views[this._config.ContentView] || null;
	}

	collapse() { this._setCollapsed(true);  }
	expand()   { this._setCollapsed(false); }
	toggle()   { this._setCollapsed(!this.Collapsed); }

	/**
	 * Unified "show this panel" affordance — this is the shared
	 * codepath every popup trigger should funnel through. Behavior:
	 *
	 *   - If collapsed → expand (which fires OnExpand + re-renders the
	 *     ContentView via the shared transition machinery).
	 *   - If already open → re-render the ContentView (so any newly-
	 *     streamed state is visible) AND briefly flash the panel
	 *     border so the user notices that the existing panel just
	 *     received attention. Avoids the "I clicked a button but
	 *     nothing happened" feeling when the panel was already open.
	 *
	 * Idempotent — safe to call from any number of triggers without
	 * stacking effects.
	 */
	popup()
	{
		if (this.Collapsed)
		{
			this._setCollapsed(false);
		}
		else
		{
			// Already open — refresh content + flash for attention.
			this._renderContentView();
			this._flash();
		}
	}

	setSize(pSize)
	{
		if (typeof pSize !== 'number' || !isFinite(pSize)) return;
		this.Size = pSize;
		this._clampSize();
		this._applySize();
	}

	destroy(pSkipFromShell)
	{
		this._unwireResponsiveDrawer();
		if (this.El && this.El.parentNode) this.El.parentNode.removeChild(this.El);
		if (!pSkipFromShell)
		{
			let tmpIdx = this._shell._panels.indexOf(this);
			if (tmpIdx >= 0) this._shell._panels.splice(tmpIdx, 1);
			delete this._shell._panelsByHash[this.Hash];
		}
	}

	// ───────────── internals ─────────────

	_clampSize()
	{
		if (this.Size < this.MinSize) this.Size = this.MinSize;
		if (this.Size > this.MaxSize) this.Size = this.MaxSize;
	}

	// Responsive drawer — sets up a matchMedia listener for
	// `(max-width: <ResponsiveDrawer>px)`. Each crossing flips the
	// shell's middle row between row layout (wide) and column layout
	// (narrow) by toggling the `pict-modal-shell-drawer-active` class
	// on the middle row. The matching CSS makes side panels expand to
	// full width with a fixed `DrawerHeight`, becoming top/bottom
	// drawers above/below the workspace center. Collapsed in drawer
	// mode collapses to height: 0, leaving only the collapse tab.
	//
	// This pattern is the conventional "responsive sidebar" approach
	// (used by retold-remote's content editor) — the user keeps their
	// sidebar accessible at narrow widths but it gives the workspace
	// room to breathe.
	_wireResponsiveDrawer()
	{
		if (typeof window === 'undefined' || !window.matchMedia) return;

		this._mediaQuery = window.matchMedia('(max-width: ' + this.ResponsiveDrawer + 'px)');

		// Apply the drawer height as a CSS variable on the panel
		// element so the static CSS rules can read it. Doing this once
		// here avoids per-event JS style writes.
		if (this.El) { this.El.style.setProperty('--pict-modal-drawer-height', this.DrawerHeight); }

		let tmpSelf = this;
		this._mediaQueryHandler = function (pEvent)
		{
			let tmpNarrow = (pEvent && typeof pEvent.matches === 'boolean')
				? pEvent.matches
				: tmpSelf._mediaQuery.matches;
			tmpSelf._setDrawerMode(tmpNarrow);
		};

		// Apply the current state immediately (handles the case where the
		// page loads already-narrow). Newer browsers use addEventListener;
		// older ones use addListener.
		if (this._mediaQuery.addEventListener)
		{
			this._mediaQuery.addEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.addListener)
		{
			this._mediaQuery.addListener(this._mediaQueryHandler);
		}
		this._mediaQueryHandler({ matches: this._mediaQuery.matches });

		// Belt + suspenders: also listen to window resize and re-sync.
		// `matchMedia.change` is supposed to be reliable on every
		// boundary crossing, but in real-world testing (esp. when the
		// user is dragging DevTools to resize the inner viewport, or
		// going through fast successive crossings) we've seen the
		// change event silently miss. A plain resize listener is
		// cheap and the handler is idempotent — if matches state
		// hasn't actually changed the body of `_setDrawerMode` is a
		// no-op (it short-circuits when classes are already correct).
		this._resizeHandler = function ()
		{
			tmpSelf._setDrawerMode(tmpSelf._mediaQuery.matches);
		};
		window.addEventListener('resize', this._resizeHandler);
	}

	_unwireResponsiveDrawer()
	{
		if (this._resizeHandler && typeof window !== 'undefined')
		{
			window.removeEventListener('resize', this._resizeHandler);
			this._resizeHandler = null;
		}
		if (!this._mediaQuery || !this._mediaQueryHandler) return;
		if (this._mediaQuery.removeEventListener)
		{
			this._mediaQuery.removeEventListener('change', this._mediaQueryHandler);
		}
		else if (this._mediaQuery.removeListener)
		{
			this._mediaQuery.removeListener(this._mediaQueryHandler);
		}
		this._mediaQuery = null;
		this._mediaQueryHandler = null;
	}

	// Toggle drawer mode by adding / removing a class on the shell's
	// middle row. The CSS rule for `.pict-modal-shell-drawer-active`
	// flips flex-direction column, makes side panels full-width, and
	// applies the panel's `--pict-modal-drawer-height` for sizing.
	// Also tags the panel itself so per-panel CSS can target it.
	// Re-applies the inline size at the end so the wide-mode crossing
	// gets a clean width back (drawer mode forced width: 100% via CSS
	// !important; the inline style was stale).
	_setDrawerMode(pDrawer)
	{
		if (!this._shell || !this._shell._middleRow) return;
		// Idempotent — short-circuit when the panel's drawer state
		// already matches the target. Keeps the resize-event fallback
		// (which fires constantly during drag-resize) from doing
		// pointless DOM thrash + style re-application every frame.
		let tmpCurrentlyDrawer = !!(this.El
			&& this.El.classList.contains('pict-modal-shell-panel-drawer'));
		if (tmpCurrentlyDrawer === !!pDrawer) return;
		if (pDrawer)
		{
			this._shell._middleRow.classList.add('pict-modal-shell-drawer-active');
			if (this.El) { this.El.classList.add('pict-modal-shell-panel-drawer'); }
		}
		else
		{
			// Only remove the row-level class if NO other panel still
			// wants drawer mode. Multi-panel hosts can safely each opt
			// in independently this way.
			let tmpStillNarrow = false;
			let tmpPanels = this._shell._panels || [];
			for (let i = 0; i < tmpPanels.length; i++)
			{
				let tmpP = tmpPanels[i];
				if (tmpP !== this
					&& tmpP._mediaQuery
					&& tmpP._mediaQuery.matches
					&& tmpP.ResponsiveDrawer > 0)
				{
					tmpStillNarrow = true;
					break;
				}
			}
			if (!tmpStillNarrow)
			{
				this._shell._middleRow.classList.remove('pict-modal-shell-drawer-active');
			}
			if (this.El) { this.El.classList.remove('pict-modal-shell-panel-drawer'); }
		}
		// Re-apply inline size. In drawer mode the CSS !important
		// rule overrides this anyway, but on the wide crossing we
		// need the inline width to be correct so the panel shows up
		// at its proper docked / collapsed-docked size rather than
		// inheriting any stale state.
		this._applySize();
	}

	_buildEl(pConfig)
	{
		let tmpRoot = document.createElement('div');
		tmpRoot.className = 'pict-modal-shell-panel pict-modal-shell-panel-' + this.Side
			+ ' pict-modal-shell-panel-mode-' + this.Mode
			+ (this.Position === 'overlay' ? ' pict-modal-shell-panel-overlay' : '')
			+ (this.Hidden ? ' pict-modal-shell-panel-hidden' : '');
		tmpRoot.setAttribute('data-shell-panel-hash', this.Hash);
		tmpRoot.setAttribute('data-shell-panel-side', this.Side);
		tmpRoot.setAttribute('data-shell-panel-mode', this.Mode);

		// Content area — hosts render their stuff into the inner #id div.
		let tmpContentWrap = document.createElement('div');
		tmpContentWrap.className = 'pict-modal-shell-panel-content';
		this._contentEl = document.createElement('div');
		if (pConfig.ContentDestinationId)
		{
			this._contentEl.id = pConfig.ContentDestinationId;
		}
		this._contentEl.className = 'pict-modal-shell-panel-content-inner';
		tmpContentWrap.appendChild(this._contentEl);
		tmpRoot.appendChild(tmpContentWrap);

		// Collapse tab — shown when collapsible / resizable. Lives at the
		// inner edge so it's always reachable when the panel is collapsed.
		// Hidden panels skip the tab entirely — the only path back from
		// collapsed → expanded is a programmatic expand() / toggle() call
		// from the host (e.g. a topbar gear button).
		if ((this.Mode === 'collapsible' || this.Mode === 'resizable') && !this.Hidden)
		{
			this._collapseTab = document.createElement('button');
			this._collapseTab.type = 'button';
			this._collapseTab.className = 'pict-modal-shell-panel-collapse-tab';
			this._collapseTab.setAttribute('aria-label',
				(this.Title ? 'Toggle ' + this.Title : 'Toggle panel'));
			this._collapseTab.title = this.Title || 'Toggle';
			this._collapseTab.innerHTML = ''
				+ (this.Icon ? '<span class="pict-modal-shell-panel-collapse-tab-icon">' + this.Icon + '</span>' : '')
				+ (this.Title ? '<span class="pict-modal-shell-panel-collapse-tab-title">' + this._escape(this.Title) + '</span>' : '');
			let tmpSelf = this;
			this._collapseTab.addEventListener('click', function () { tmpSelf.toggle(); });
			tmpRoot.appendChild(this._collapseTab);
		}

		// Resize handle — only when resizable. Positioned via CSS based
		// on side.
		if (this.Mode === 'resizable')
		{
			this._resizeHandle = document.createElement('div');
			this._resizeHandle.className = 'pict-modal-shell-panel-resize-handle';
			this._resizeHandle.setAttribute('aria-hidden', 'true');
			let tmpSelf = this;
			this._resizeHandle.addEventListener('pointerdown', function (pEvent)
			{
				if (tmpSelf.Collapsed) return;
				tmpSelf._shell._attachDragStart(tmpSelf, pEvent);
			});
			tmpRoot.appendChild(this._resizeHandle);
		}

		this.El = tmpRoot;
	}

	_applySize()
	{
		let tmpEffective = this.Collapsed ? this.CollapsedSize : this.Size;
		if (this.Side === 'left' || this.Side === 'right')
		{
			this.El.style.width = tmpEffective + 'px';
			this.El.style.height = '';
		}
		else
		{
			this.El.style.height = tmpEffective + 'px';
			this.El.style.width = '';
		}
	}

	_applyCollapsedClass()
	{
		if (this.Collapsed) this.El.classList.add('pict-modal-shell-panel-collapsed');
		else this.El.classList.remove('pict-modal-shell-panel-collapsed');
	}

	_setCollapsed(pBool)
	{
		if (this.Collapsed === !!pBool) return;
		let tmpWasCollapsed = this.Collapsed;
		this.Collapsed = !!pBool;
		this._applyCollapsedClass();
		this._applySize();
		this._persist();

		// Transition-specific hooks fire BEFORE OnToggle so OnExpand
		// callers can mutate state (e.g. set focus, re-fetch data) and
		// have it reflected by any OnToggle observer that runs after.
		if (tmpWasCollapsed && !this.Collapsed)
		{
			// collapsed → expanded. Render the bound ContentView so
			// freshly-streamed state shows up the moment the panel
			// becomes visible (replaces the manual view.render() dance
			// hosts used to do in their own runAction-style helpers).
			this._renderContentView();
			this._fireHook('OnExpand');
		}
		else if (!tmpWasCollapsed && this.Collapsed)
		{
			this._fireHook('OnCollapse');
		}

		// Back-compat: OnToggle still fires for both directions.
		this._fireHook('OnToggle', this.Collapsed);
	}

	_fireHook(pName, pArg)
	{
		let tmpFn = this._config[pName];
		if (typeof tmpFn !== 'function') return;
		try
		{
			if (typeof pArg !== 'undefined') { tmpFn(pArg, this); }
			else                             { tmpFn(this); }
		}
		catch (pErr) { /* host hook failure must not break the panel */ }
	}

	/**
	 * Render the bound ContentView (if any) into this panel's
	 * destination. Called by the shell on panel creation + on every
	 * collapsed→expanded transition + by popup() when re-flashing an
	 * already-open panel. Silently no-ops when no ContentView is
	 * configured or the view isn't registered yet (boot races).
	 */
	_renderContentView()
	{
		let tmpView = this.getContentView();
		if (tmpView && typeof tmpView.render === 'function')
		{
			try { tmpView.render(); }
			catch (pErr) { /* view render failure shouldn't break the panel chrome */ }
		}
	}

	/**
	 * Briefly highlight the panel — used by popup() when called on an
	 * already-open panel so the user sees that their click landed.
	 * The class is removed after the CSS animation completes; safe to
	 * re-trigger (timeouts overlap, last one wins on the trailing edge).
	 */
	_flash()
	{
		if (!this.El) return;
		this.El.classList.add('pict-modal-shell-panel-flash');
		let tmpSelf = this;
		clearTimeout(this._flashTimer);
		this._flashTimer = setTimeout(function ()
		{
			if (tmpSelf.El) tmpSelf.El.classList.remove('pict-modal-shell-panel-flash');
		}, 700);
	}

	_persist()
	{
		if (!this.PersistEnabled) return;
		this._shell._savePanelState(this.Hash,
		{
			Collapsed: this.Collapsed,
			Size: this.Size
		});
	}

	_escape(pStr)
	{
		return String(pStr || '')
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

// ════════════════════════════════════════════════════════════════════
//  Module exports — used internally by Pict-Section-Modal.shell()
// ════════════════════════════════════════════════════════════════════

class PictModalShellManager
{
	constructor(pModalSection)
	{
		this._modal = pModalSection;
		this._shellsByViewport = new WeakMap();
	}

	/**
	 * Idempotent — calling shell() twice with the same viewport returns
	 * the same instance.
	 */
	shell(pViewportSelectorOrEl, pOptions)
	{
		let tmpEl = (typeof pViewportSelectorOrEl === 'string')
			? document.querySelector(pViewportSelectorOrEl)
			: pViewportSelectorOrEl;
		if (!tmpEl)
		{
			throw new Error('Pict-Modal-Shell.shell: viewport not found for ' + pViewportSelectorOrEl);
		}
		let tmpExisting = this._shellsByViewport.get(tmpEl);
		if (tmpExisting) return tmpExisting;
		let tmpShell = new PictModalShell(this._modal, tmpEl, pOptions);
		this._shellsByViewport.set(tmpEl, tmpShell);
		return tmpShell;
	}
}

module.exports = PictModalShellManager;
module.exports.PictModalShell = PictModalShell;
module.exports.ShellPanel = ShellPanel;
module.exports.STORAGE_PREFIX = STORAGE_PREFIX;
module.exports.SCHEMA_VERSION = SCHEMA_VERSION;

},{}],149:[function(require,module,exports){
/**
 * Pict-Modal-Toast
 *
 * Manages toast notification elements with auto-dismiss and stacking.
 */
class PictModalToast
{
	constructor(pModal)
	{
		this._modal = pModal;
		this._containers = {};
	}

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message text
	 * @param {object} [pOptions] - Options (type, duration, position, dismissible)
	 * @returns {{ dismiss: function }} Handle with dismiss method
	 */
	toast(pMessage, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultToastOptions, pOptions);
		let tmpContainer = this._getContainer(tmpOptions.position);
		let tmpId = this._modal._nextId();

		let tmpToast = document.createElement('div');
		tmpToast.className = 'pict-modal-toast pict-modal-toast--' + tmpOptions.type;
		tmpToast.id = 'pict-modal-toast-' + tmpId;

		let tmpContent = '<span class="pict-modal-toast-message">' + this._escapeHTML(pMessage) + '</span>';

		if (tmpOptions.dismissible)
		{
			tmpContent += '<button class="pict-modal-toast-dismiss" aria-label="Dismiss">&times;</button>';
		}

		tmpToast.innerHTML = tmpContent;

		// Create handle
		let tmpDismissed = false;
		let tmpTimeoutHandle = null;

		let tmpDismiss = () =>
		{
			if (tmpDismissed)
			{
				return;
			}
			tmpDismissed = true;

			if (tmpTimeoutHandle)
			{
				clearTimeout(tmpTimeoutHandle);
			}

			// Exit animation
			tmpToast.classList.remove('pict-modal-visible');
			tmpToast.classList.add('pict-modal-toast-exit');

			// Remove from active list
			this._modal._activeToasts = this._modal._activeToasts.filter(
				(pEntry) => { return pEntry.element !== tmpToast; }
			);

			// Remove from DOM after transition
			setTimeout(() =>
			{
				if (tmpToast.parentNode)
				{
					tmpToast.parentNode.removeChild(tmpToast);
				}
				this._cleanupContainer(tmpOptions.position);
			}, 220);
		};

		let tmpHandle = { dismiss: tmpDismiss };

		// Wire dismiss button
		if (tmpOptions.dismissible)
		{
			let tmpDismissBtn = tmpToast.querySelector('.pict-modal-toast-dismiss');
			if (tmpDismissBtn)
			{
				tmpDismissBtn.addEventListener('click', tmpDismiss);
			}
		}

		// Append to container
		tmpContainer.appendChild(tmpToast);

		// Track
		let tmpEntry =
		{
			element: tmpToast,
			dismiss: tmpDismiss,
			handle: tmpHandle
		};
		this._modal._activeToasts.push(tmpEntry);

		// Animate in
		void tmpToast.offsetHeight;
		tmpToast.classList.add('pict-modal-visible');

		// Auto-dismiss
		if (tmpOptions.duration > 0)
		{
			tmpTimeoutHandle = setTimeout(tmpDismiss, tmpOptions.duration);
		}

		return tmpHandle;
	}

	/**
	 * Get or create a toast container for the given position.
	 *
	 * @param {string} pPosition - Position key (e.g. 'top-right')
	 * @returns {HTMLElement}
	 */
	_getContainer(pPosition)
	{
		if (this._containers[pPosition])
		{
			return this._containers[pPosition];
		}

		let tmpContainer = document.createElement('div');
		tmpContainer.className = 'pict-modal-toast-container pict-modal-toast-container--' + pPosition;
		document.body.appendChild(tmpContainer);
		this._containers[pPosition] = tmpContainer;

		return tmpContainer;
	}

	/**
	 * Remove a container if it has no more toasts.
	 *
	 * @param {string} pPosition
	 */
	_cleanupContainer(pPosition)
	{
		let tmpContainer = this._containers[pPosition];
		if (tmpContainer && tmpContainer.children.length === 0)
		{
			if (tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
			delete this._containers[pPosition];
		}
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissAll()
	{
		let tmpToasts = this._modal._activeToasts.slice();
		for (let i = 0; i < tmpToasts.length; i++)
		{
			tmpToasts[i].dismiss();
		}
	}

	/**
	 * Destroy all containers.
	 */
	destroy()
	{
		this.dismissAll();
		let tmpPositions = Object.keys(this._containers);
		for (let i = 0; i < tmpPositions.length; i++)
		{
			let tmpContainer = this._containers[tmpPositions[i]];
			if (tmpContainer && tmpContainer.parentNode)
			{
				tmpContainer.parentNode.removeChild(tmpContainer);
			}
		}
		this._containers = {};
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalToast;

},{}],150:[function(require,module,exports){
/**
 * Pict-Modal-Tooltip
 *
 * Manages simple text and rich HTML tooltips with positioning and auto-flip.
 */
class PictModalTooltip
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options (position, delay, maxWidth)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	tooltip(pElement, pText, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pText, false, tmpOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content for the tooltip
	 * @param {object} [pOptions] - Options (position, delay, maxWidth, interactive)
	 * @returns {{ destroy: function }} Handle to remove the tooltip
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultTooltipOptions, pOptions);
		return this._attachTooltip(pElement, pHTMLContent, true, tmpOptions);
	}

	/**
	 * Internal: attach tooltip event listeners to an element.
	 *
	 * @param {HTMLElement} pElement
	 * @param {string} pContent
	 * @param {boolean} pIsHTML
	 * @param {object} pOptions
	 * @returns {{ destroy: function }}
	 */
	_attachTooltip(pElement, pContent, pIsHTML, pOptions)
	{
		let tmpTooltipElement = null;
		let tmpShowTimeout = null;
		let tmpHideTimeout = null;
		let tmpDestroyed = false;
		let tmpId = this._modal._nextId();

		let tmpShow = () =>
		{
			if (tmpDestroyed || tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement = document.createElement('div');
			tmpTooltipElement.className = 'pict-modal-tooltip pict-modal-tooltip--' + pOptions.position;
			tmpTooltipElement.id = 'pict-modal-tooltip-' + tmpId;
			tmpTooltipElement.setAttribute('role', 'tooltip');
			tmpTooltipElement.style.maxWidth = pOptions.maxWidth;

			if (pOptions.interactive)
			{
				tmpTooltipElement.classList.add('pict-modal-tooltip-interactive');
			}

			// Arrow
			let tmpArrow = document.createElement('div');
			tmpArrow.className = 'pict-modal-tooltip-arrow';

			// Content
			let tmpContentDiv = document.createElement('div');
			if (pIsHTML)
			{
				tmpContentDiv.innerHTML = pContent;
			}
			else
			{
				tmpContentDiv.textContent = pContent;
			}

			tmpTooltipElement.appendChild(tmpArrow);
			tmpTooltipElement.appendChild(tmpContentDiv);
			document.body.appendChild(tmpTooltipElement);

			// Set aria-describedby on target
			pElement.setAttribute('aria-describedby', tmpTooltipElement.id);

			// Position
			this._positionTooltip(tmpTooltipElement, pElement, pOptions.position);

			// Animate in
			void tmpTooltipElement.offsetHeight;
			tmpTooltipElement.classList.add('pict-modal-visible');

			// Track
			this._modal._activeTooltips.push(
			{
				element: tmpTooltipElement,
				targetElement: pElement,
				destroy: tmpDestroy
			});

			// For interactive tooltips, allow hovering over the tooltip itself
			if (pOptions.interactive && tmpTooltipElement)
			{
				tmpTooltipElement.addEventListener('mouseenter', () =>
				{
					if (tmpHideTimeout)
					{
						clearTimeout(tmpHideTimeout);
						tmpHideTimeout = null;
					}
				});
				tmpTooltipElement.addEventListener('mouseleave', () =>
				{
					tmpHide();
				});
			}
		};

		let tmpHide = () =>
		{
			if (!tmpTooltipElement)
			{
				return;
			}

			tmpTooltipElement.classList.remove('pict-modal-visible');
			let tmpEl = tmpTooltipElement;
			tmpTooltipElement = null;

			// Remove aria
			pElement.removeAttribute('aria-describedby');

			// Remove from tracking
			this._modal._activeTooltips = this._modal._activeTooltips.filter(
				(pEntry) => { return pEntry.element !== tmpEl; }
			);

			setTimeout(() =>
			{
				if (tmpEl.parentNode)
				{
					tmpEl.parentNode.removeChild(tmpEl);
				}
			}, 220);
		};

		let tmpOnMouseEnter = () =>
		{
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
				tmpHideTimeout = null;
			}
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnMouseLeave = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			// Small delay before hiding to allow moving to interactive tooltip
			if (pOptions.interactive)
			{
				tmpHideTimeout = setTimeout(tmpHide, 100);
			}
			else
			{
				tmpHide();
			}
		};

		let tmpOnFocusIn = () =>
		{
			tmpShowTimeout = setTimeout(tmpShow, pOptions.delay);
		};

		let tmpOnFocusOut = () =>
		{
			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
				tmpShowTimeout = null;
			}
			tmpHide();
		};

		// Attach listeners
		pElement.addEventListener('mouseenter', tmpOnMouseEnter);
		pElement.addEventListener('mouseleave', tmpOnMouseLeave);
		pElement.addEventListener('focusin', tmpOnFocusIn);
		pElement.addEventListener('focusout', tmpOnFocusOut);

		let tmpDestroy = () =>
		{
			if (tmpDestroyed)
			{
				return;
			}
			tmpDestroyed = true;

			if (tmpShowTimeout)
			{
				clearTimeout(tmpShowTimeout);
			}
			if (tmpHideTimeout)
			{
				clearTimeout(tmpHideTimeout);
			}

			tmpHide();

			pElement.removeEventListener('mouseenter', tmpOnMouseEnter);
			pElement.removeEventListener('mouseleave', tmpOnMouseLeave);
			pElement.removeEventListener('focusin', tmpOnFocusIn);
			pElement.removeEventListener('focusout', tmpOnFocusOut);
		};

		return { destroy: tmpDestroy };
	}

	/**
	 * Position a tooltip element relative to the target element.
	 * Flips direction if the tooltip would overflow the viewport.
	 *
	 * @param {HTMLElement} pTooltip
	 * @param {HTMLElement} pTarget
	 * @param {string} pPosition - 'top', 'bottom', 'left', 'right'
	 */
	_positionTooltip(pTooltip, pTarget, pPosition)
	{
		let tmpTargetRect = pTarget.getBoundingClientRect();
		let tmpTooltipRect = pTooltip.getBoundingClientRect();
		let tmpGap = 8;

		let tmpPosition = pPosition;

		// Flip if needed
		if (tmpPosition === 'top' && tmpTargetRect.top < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'bottom';
		}
		else if (tmpPosition === 'bottom' && (window.innerHeight - tmpTargetRect.bottom) < tmpTooltipRect.height + tmpGap)
		{
			tmpPosition = 'top';
		}
		else if (tmpPosition === 'left' && tmpTargetRect.left < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'right';
		}
		else if (tmpPosition === 'right' && (window.innerWidth - tmpTargetRect.right) < tmpTooltipRect.width + tmpGap)
		{
			tmpPosition = 'left';
		}

		// Update class for arrow direction
		pTooltip.className = pTooltip.className.replace(/pict-modal-tooltip--\w+/, 'pict-modal-tooltip--' + tmpPosition);

		let tmpTop = 0;
		let tmpLeft = 0;

		switch (tmpPosition)
		{
			case 'top':
				tmpTop = tmpTargetRect.top - tmpTooltipRect.height - tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'bottom':
				tmpTop = tmpTargetRect.bottom + tmpGap;
				tmpLeft = tmpTargetRect.left + (tmpTargetRect.width / 2) - (tmpTooltipRect.width / 2);
				break;
			case 'left':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.left - tmpTooltipRect.width - tmpGap;
				break;
			case 'right':
				tmpTop = tmpTargetRect.top + (tmpTargetRect.height / 2) - (tmpTooltipRect.height / 2);
				tmpLeft = tmpTargetRect.right + tmpGap;
				break;
		}

		// Clamp to viewport
		tmpLeft = Math.max(4, Math.min(tmpLeft, window.innerWidth - tmpTooltipRect.width - 4));
		tmpTop = Math.max(4, Math.min(tmpTop, window.innerHeight - tmpTooltipRect.height - 4));

		pTooltip.style.top = tmpTop + 'px';
		pTooltip.style.left = tmpLeft + 'px';
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissAll()
	{
		let tmpTooltips = this._modal._activeTooltips.slice();
		for (let i = 0; i < tmpTooltips.length; i++)
		{
			tmpTooltips[i].destroy();
		}
	}
}

module.exports = PictModalTooltip;

},{}],151:[function(require,module,exports){
/**
 * Pict-Modal-Window
 *
 * Builds custom floating modal windows with arbitrary content and buttons.
 */
class PictModalWindow
{
	constructor(pModal)
	{
		this._modal = pModal;
	}

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options
	 * @param {string} [pOptions.title] - Dialog title
	 * @param {string} [pOptions.content] - HTML content for the body
	 * @param {Array} [pOptions.buttons] - Array of { Hash, Label, Style }
	 * @param {boolean} [pOptions.closeable] - Whether the close button and overlay dismiss are enabled
	 * @param {string} [pOptions.width] - CSS width value
	 * @param {boolean} [pOptions.unbounded] - If true, removes the default 90vh/90vw viewport cap. The dialog will grow with its content and may extend beyond the viewport.
	 * @param {function} [pOptions.onOpen] - Called after dialog is shown, receives dialog element
	 * @param {function} [pOptions.onClose] - Called after dialog is dismissed
	 * @returns {Promise<string|null>} Resolves with clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		let tmpOptions = Object.assign({}, this._modal.options.DefaultModalOptions, pOptions);

		return new Promise((fResolve) =>
		{
			let tmpDialog = this._buildDialog(tmpOptions, fResolve);
			this._showDialog(tmpDialog, tmpOptions, fResolve);
		});
	}

	/**
	 * Build the modal dialog element.
	 *
	 * @param {object} pOptions
	 * @param {function} fResolve
	 * @returns {HTMLElement}
	 */
	_buildDialog(pOptions, fResolve)
	{
		let tmpId = this._modal._nextId();

		let tmpDialog = document.createElement('div');
		tmpDialog.className = 'pict-modal-dialog';
		if (pOptions.unbounded)
		{
			tmpDialog.className += ' pict-modal-dialog--unbounded';
		}
		tmpDialog.id = 'pict-modal-' + tmpId;
		tmpDialog.setAttribute('role', 'dialog');
		tmpDialog.setAttribute('aria-modal', 'true');
		tmpDialog.style.width = pOptions.width;

		// Header
		let tmpHeaderHTML = '';
		if (pOptions.title || pOptions.closeable)
		{
			tmpHeaderHTML = '<div class="pict-modal-dialog-header">';
			tmpHeaderHTML += '<span class="pict-modal-dialog-title">' + this._escapeHTML(pOptions.title) + '</span>';
			if (pOptions.closeable)
			{
				tmpHeaderHTML += '<button class="pict-modal-dialog-close" aria-label="Close">&times;</button>';
			}
			tmpHeaderHTML += '</div>';
		}

		// Body
		let tmpBodyHTML = '<div class="pict-modal-dialog-body">' + (pOptions.content || '') + '</div>';

		// Footer with buttons
		let tmpFooterHTML = '';
		if (pOptions.buttons && pOptions.buttons.length > 0)
		{
			tmpFooterHTML = '<div class="pict-modal-dialog-footer">';
			for (let i = 0; i < pOptions.buttons.length; i++)
			{
				let tmpButton = pOptions.buttons[i];
				let tmpBtnClass = 'pict-modal-btn';
				if (tmpButton.Style)
				{
					tmpBtnClass += ' pict-modal-btn--' + tmpButton.Style;
				}
				tmpFooterHTML += '<button class="' + tmpBtnClass + '" data-hash="' + this._escapeHTML(tmpButton.Hash) + '">' +
					this._escapeHTML(tmpButton.Label) + '</button>';
			}
			tmpFooterHTML += '</div>';
		}

		tmpDialog.innerHTML = tmpHeaderHTML + tmpBodyHTML + tmpFooterHTML;

		let tmpDismiss = (pResult) =>
		{
			this._dismissDialog(tmpDialog, pResult, fResolve, pOptions);
		};

		// Wire close button
		if (pOptions.closeable)
		{
			let tmpCloseBtn = tmpDialog.querySelector('.pict-modal-dialog-close');
			if (tmpCloseBtn)
			{
				tmpCloseBtn.addEventListener('click', () => { tmpDismiss(null); });
			}
		}

		// Wire action buttons
		let tmpActionButtons = tmpDialog.querySelectorAll('[data-hash]');
		for (let i = 0; i < tmpActionButtons.length; i++)
		{
			let tmpBtn = tmpActionButtons[i];
			tmpBtn.addEventListener('click', () =>
			{
				tmpDismiss(tmpBtn.getAttribute('data-hash'));
			});
		}

		tmpDialog._dismiss = tmpDismiss;

		return tmpDialog;
	}

	/**
	 * Show the dialog: append to body, show overlay, animate in.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {object} pOptions
	 * @param {function} fResolve
	 */
	_showDialog(pDialog, pOptions, fResolve)
	{
		let tmpModalEntry =
		{
			element: pDialog,
			dismiss: pDialog._dismiss,
			type: 'window'
		};

		// Show overlay
		let tmpOverlayClickHandler = null;
		if (this._modal.options.OverlayClickDismisses && pOptions.closeable)
		{
			tmpOverlayClickHandler = () => { pDialog._dismiss(null); };
		}
		this._modal._overlay.show(tmpOverlayClickHandler);

		// Append to body
		document.body.appendChild(pDialog);

		// Track
		this._modal._activeModals.push(tmpModalEntry);

		// Animate in
		void pDialog.offsetHeight;
		pDialog.classList.add('pict-modal-visible');

		// Focus first button or close button
		let tmpFocusTarget = pDialog.querySelector('.pict-modal-btn') || pDialog.querySelector('.pict-modal-dialog-close');
		if (tmpFocusTarget)
		{
			tmpFocusTarget.focus();
		}

		// Keyboard handler
		pDialog._keyHandler = (pEvent) =>
		{
			if (pEvent.key === 'Escape' && pOptions.closeable)
			{
				pDialog._dismiss(null);
			}
		};
		document.addEventListener('keydown', pDialog._keyHandler);

		// onOpen callback
		if (typeof pOptions.onOpen === 'function')
		{
			pOptions.onOpen(pDialog);
		}
	}

	/**
	 * Dismiss the dialog: animate out, remove from DOM, hide overlay.
	 *
	 * @param {HTMLElement} pDialog
	 * @param {*} pResult
	 * @param {function} fResolve
	 * @param {object} pOptions
	 */
	_dismissDialog(pDialog, pResult, fResolve, pOptions)
	{
		if (pDialog._dismissed)
		{
			return;
		}
		pDialog._dismissed = true;

		if (pDialog._keyHandler)
		{
			document.removeEventListener('keydown', pDialog._keyHandler);
		}

		pDialog.classList.remove('pict-modal-visible');

		this._modal._activeModals = this._modal._activeModals.filter(
			(pEntry) => { return pEntry.element !== pDialog; }
		);

		if (this._modal._activeModals.length > 0)
		{
			let tmpTopModal = this._modal._activeModals[this._modal._activeModals.length - 1];
			this._modal._overlay.updateClickHandler(
				this._modal.options.OverlayClickDismisses ? tmpTopModal.dismiss : null
			);
		}

		this._modal._overlay.hide();

		setTimeout(() =>
		{
			if (pDialog.parentNode)
			{
				pDialog.parentNode.removeChild(pDialog);
			}
		}, 220);

		if (typeof pOptions.onClose === 'function')
		{
			pOptions.onClose(pResult);
		}

		fResolve(pResult);
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText
	 * @returns {string}
	 */
	_escapeHTML(pText)
	{
		if (typeof pText !== 'string')
		{
			return '';
		}
		return pText
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}
}

module.exports = PictModalWindow;

},{}],152:[function(require,module,exports){
module.exports = (
{
	"AutoInitialize": true,
	"AutoRender": false,
	"AutoSolveWithApp": false,

	"ViewIdentifier": "Pict-Section-Modal",

	"OverlayClickDismisses": true,

	"DefaultConfirmOptions":
	{
		"title": "Confirm",
		"confirmLabel": "OK",
		"cancelLabel": "Cancel",
		"dangerous": false,
		"unbounded": false
	},

	"DefaultDoubleConfirmOptions":
	{
		"title": "Are you sure?",
		"confirmLabel": "Confirm",
		"cancelLabel": "Cancel",
		"phrasePrompt": "Type \"{phrase}\" to confirm:",
		"confirmPhrase": "",
		"unbounded": false
	},

	"DefaultModalOptions":
	{
		"title": "",
		"content": "",
		"buttons": [],
		"closeable": true,
		"width": "480px",
		"unbounded": false
	},

	"DefaultTooltipOptions":
	{
		"position": "top",
		"delay": 200,
		"maxWidth": "300px",
		"interactive": false
	},

	"DefaultToastOptions":
	{
		"type": "info",
		"duration": 3000,
		"position": "top-right",
		"dismissible": true
	},

	"DefaultPanelOptions":
	{
		"position": "right",
		"width": 340,
		"minWidth": 200,
		"maxWidth": 600,
		"collapsible": true,
		"collapsed": false,
		"persist": false,
		"persistKey": ""
	},

	"Templates": [],
	"Renderables": [],

	"CSS": /*css*/`
/* pict-section-modal */
.pict-modal-root
{
	/* Defaults are routed through pict-provider-theme tokens so apps
	   using the theme provider get themed modals automatically.  Each
	   var() carries its original hex as the fallback so apps that don't
	   install pict-provider-theme look exactly as before.  Apps may
	   still override any --pict-modal-* var directly to layer over the
	   theme-driven defaults. */

	/* Overlay */
	--pict-modal-overlay-bg: rgba(0, 0, 0, 0.5);

	/* Dialog */
	--pict-modal-bg:                  var(--theme-color-background-panel,  #ffffff);
	--pict-modal-fg:                  var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-border:              var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-border-radius:       8px;
	--pict-modal-shadow:              0 4px 24px rgba(0, 0, 0, 0.15);
	--pict-modal-header-bg:           var(--theme-color-background-secondary, #f5f5f5);
	--pict-modal-header-fg:           var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-header-border:       var(--theme-color-border-default,    #e0e0e0);

	/* Buttons */
	--pict-modal-btn-bg:              var(--theme-color-background-secondary, #e0e0e0);
	--pict-modal-btn-fg:              var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-btn-hover-bg:        var(--theme-color-background-hover,  #d0d0d0);
	--pict-modal-btn-primary-bg:      var(--theme-color-brand-primary,     #2563eb);
	--pict-modal-btn-primary-fg:      var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-primary-hover-bg:var(--theme-color-brand-primary-hover,#1d4ed8);
	--pict-modal-btn-danger-bg:       var(--theme-color-status-error,      #dc2626);
	--pict-modal-btn-danger-fg:       var(--theme-color-text-on-brand,     #ffffff);
	--pict-modal-btn-danger-hover-bg: var(--theme-color-status-error,      #b91c1c);
	--pict-modal-btn-border-radius:   4px;

	/* Toast */
	--pict-modal-toast-bg:            var(--theme-color-background-panel,  #333333);
	--pict-modal-toast-fg:            var(--theme-color-text-primary,      #ffffff);
	--pict-modal-toast-success-bg:    var(--theme-color-status-success,    #16a34a);
	--pict-modal-toast-warning-bg:    var(--theme-color-status-warning,    #d97706);
	--pict-modal-toast-error-bg:      var(--theme-color-status-error,      #dc2626);
	--pict-modal-toast-info-bg:       var(--theme-color-status-info,       #2563eb);
	--pict-modal-toast-border-radius: 6px;
	--pict-modal-toast-shadow:        0 2px 12px rgba(0, 0, 0, 0.15);

	/* Tooltip */
	--pict-modal-tooltip-bg:          var(--theme-color-background-tertiary,#1a1a1a);
	--pict-modal-tooltip-fg:          var(--theme-color-text-primary,      #ffffff);
	--pict-modal-tooltip-border-radius:4px;
	--pict-modal-tooltip-shadow:      0 2px 8px rgba(0, 0, 0, 0.15);

	/* Dropdown */
	--pict-modal-dropdown-bg:                 var(--theme-color-background-panel,  #ffffff);
	--pict-modal-dropdown-fg:                 var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-border:             var(--theme-color-border-default,    #e0e0e0);
	--pict-modal-dropdown-border-radius:      6px;
	--pict-modal-dropdown-shadow:             0 6px 18px rgba(0, 0, 0, 0.18);
	--pict-modal-dropdown-item-hover-bg:      var(--theme-color-background-hover,  rgba(37, 99, 235, 0.10));
	--pict-modal-dropdown-item-hover-fg:      var(--theme-color-text-primary,      #1a1a1a);
	--pict-modal-dropdown-item-disabled-fg:   var(--theme-color-text-muted,        #9aa0a6);
	--pict-modal-dropdown-separator:          var(--theme-color-border-light,      #e8e8e8);
	--pict-modal-dropdown-header-fg:          var(--theme-color-text-secondary,    #6b7280);
	--pict-modal-dropdown-danger-fg:          var(--theme-color-status-error,      #dc2626);
	--pict-modal-dropdown-primary-fg:         var(--theme-color-brand-primary,     #2563eb);

	/* Typography */
	--pict-modal-font-family:         var(--theme-typography-family-sans,  system-ui, -apple-system, sans-serif);
	--pict-modal-font-size:           14px;
	--pict-modal-title-font-size:     16px;

	/* Animation */
	--pict-modal-transition-duration: 200ms;
}

/* Overlay */
.pict-modal-overlay
{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background: var(--pict-modal-overlay-bg);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
}

.pict-modal-overlay.pict-modal-visible
{
	opacity: 1;
}

/* Dialog */
.pict-modal-dialog
{
	position: fixed;
	z-index: 1010;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) translateY(-20px);
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;

	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;

	background: var(--pict-modal-bg);
	color: var(--pict-modal-fg);
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-border-radius);
	box-shadow: var(--pict-modal-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
}

.pict-modal-dialog.pict-modal-visible
{
	opacity: 1;
	transform: translate(-50%, -50%) translateY(0);
}

/* Unbounded modifier — lets callers opt out of the 90vh/90vw viewport cap.
   Use with caution: content taller than the viewport will push buttons
   below the fold. */
.pict-modal-dialog.pict-modal-dialog--unbounded
{
	max-height: none;
	max-width: none;
}

.pict-modal-dialog-header
{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	background: var(--pict-modal-header-bg);
	color: var(--pict-modal-header-fg);
	border-bottom: 1px solid var(--pict-modal-header-border);
	border-radius: var(--pict-modal-border-radius) var(--pict-modal-border-radius) 0 0;
}

.pict-modal-dialog-title
{
	font-size: var(--pict-modal-title-font-size);
	font-weight: 600;
}

.pict-modal-dialog-close
{
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: var(--pict-modal-fg);
	padding: 0 4px;
	line-height: 1;
	opacity: 0.6;
}

.pict-modal-dialog-close:hover
{
	opacity: 1;
}

.pict-modal-dialog-body
{
	padding: 16px;
	overflow-y: auto;
	flex: 1;
}

.pict-modal-dialog-footer
{
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid var(--pict-modal-border);
}

/* Buttons */
.pict-modal-btn
{
	padding: 8px 16px;
	border: none;
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	cursor: pointer;
	background: var(--pict-modal-btn-bg);
	color: var(--pict-modal-btn-fg);
	transition: background var(--pict-modal-transition-duration) ease;
}

.pict-modal-btn:hover
{
	background: var(--pict-modal-btn-hover-bg);
}

.pict-modal-btn:disabled
{
	opacity: 0.5;
	cursor: not-allowed;
}

.pict-modal-btn--primary
{
	background: var(--pict-modal-btn-primary-bg);
	color: var(--pict-modal-btn-primary-fg);
}

.pict-modal-btn--primary:hover
{
	background: var(--pict-modal-btn-primary-hover-bg);
}

.pict-modal-btn--danger
{
	background: var(--pict-modal-btn-danger-bg);
	color: var(--pict-modal-btn-danger-fg);
}

.pict-modal-btn--danger:hover
{
	background: var(--pict-modal-btn-danger-hover-bg);
}

/* Double confirm input */
.pict-modal-confirm-input
{
	width: 100%;
	padding: 8px 12px;
	margin-top: 12px;
	border: 1px solid var(--pict-modal-border);
	border-radius: var(--pict-modal-btn-border-radius);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	box-sizing: border-box;
}

.pict-modal-confirm-input:focus
{
	outline: 2px solid var(--pict-modal-btn-primary-bg);
	outline-offset: -1px;
}

.pict-modal-confirm-prompt
{
	margin-top: 12px;
	font-size: 13px;
	color: var(--pict-modal-fg);
	opacity: 0.7;
}

/* Toast container */
.pict-modal-toast-container
{
	position: fixed;
	z-index: 1030;
	display: flex;
	flex-direction: column;
	gap: 8px;
	pointer-events: none;
	max-width: 400px;
}

.pict-modal-toast-container--top-right
{
	top: 16px;
	right: 16px;
}

.pict-modal-toast-container--top-left
{
	top: 16px;
	left: 16px;
}

.pict-modal-toast-container--bottom-right
{
	bottom: 16px;
	right: 16px;
}

.pict-modal-toast-container--bottom-left
{
	bottom: 16px;
	left: 16px;
}

.pict-modal-toast-container--top-center
{
	top: 16px;
	left: 50%;
	transform: translateX(-50%);
}

.pict-modal-toast-container--bottom-center
{
	bottom: 16px;
	left: 50%;
	transform: translateX(-50%);
}

/* Toast */
.pict-modal-toast
{
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 12px 16px;
	border-radius: var(--pict-modal-toast-border-radius);
	box-shadow: var(--pict-modal-toast-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	background: var(--pict-modal-toast-bg);
	color: var(--pict-modal-toast-fg);
	pointer-events: auto;
	opacity: 0;
	transform: translateX(100%);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

.pict-modal-toast.pict-modal-visible
{
	opacity: 1;
	transform: translateX(0);
}

.pict-modal-toast.pict-modal-toast-exit
{
	opacity: 0;
	transform: translateX(100%);
}

.pict-modal-toast--info
{
	background: var(--pict-modal-toast-info-bg);
}

.pict-modal-toast--success
{
	background: var(--pict-modal-toast-success-bg);
}

.pict-modal-toast--warning
{
	background: var(--pict-modal-toast-warning-bg);
}

.pict-modal-toast--error
{
	background: var(--pict-modal-toast-error-bg);
}

.pict-modal-toast-message
{
	flex: 1;
}

.pict-modal-toast-dismiss
{
	background: none;
	border: none;
	color: inherit;
	font-size: 18px;
	cursor: pointer;
	padding: 0 2px;
	line-height: 1;
	opacity: 0.7;
}

.pict-modal-toast-dismiss:hover
{
	opacity: 1;
}

/* Tooltip */
.pict-modal-tooltip
{
	position: fixed;
	z-index: 1020;
	padding: 6px 10px;
	border-radius: var(--pict-modal-tooltip-border-radius);
	box-shadow: var(--pict-modal-tooltip-shadow);
	background: var(--pict-modal-tooltip-bg);
	color: var(--pict-modal-tooltip-fg);
	font-family: var(--pict-modal-font-family);
	font-size: 13px;
	pointer-events: none;
	opacity: 0;
	transition: opacity var(--pict-modal-transition-duration) ease;
	white-space: normal;
	word-wrap: break-word;
}

.pict-modal-tooltip.pict-modal-tooltip-interactive
{
	pointer-events: auto;
}

.pict-modal-tooltip.pict-modal-visible
{
	opacity: 1;
}

.pict-modal-tooltip-arrow
{
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--pict-modal-tooltip-bg);
	transform: rotate(45deg);
}

.pict-modal-tooltip--top .pict-modal-tooltip-arrow
{
	bottom: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--bottom .pict-modal-tooltip-arrow
{
	top: -4px;
	left: 50%;
	margin-left: -4px;
}

.pict-modal-tooltip--left .pict-modal-tooltip-arrow
{
	right: -4px;
	top: 50%;
	margin-top: -4px;
}

.pict-modal-tooltip--right .pict-modal-tooltip-arrow
{
	left: -4px;
	top: 50%;
	margin-top: -4px;
}

/* ── Dropdown ─────────────────────────────────────────────────────────
   Anchor-positioned menu (no overlay). Used for nav menus and
   "split button" addenda — see Pict-Modal-Dropdown.js.
*/
.pict-modal-dropdown
{
	position: fixed;
	z-index: 1025;
	min-width: 160px;
	max-width: 360px;
	max-height: 60vh;
	overflow-y: auto;
	background: var(--pict-modal-dropdown-bg);
	color: var(--pict-modal-dropdown-fg);
	border: 1px solid var(--pict-modal-dropdown-border);
	border-radius: var(--pict-modal-dropdown-border-radius);
	box-shadow: var(--pict-modal-dropdown-shadow);
	font-family: var(--pict-modal-font-family);
	font-size: var(--pict-modal-font-size);
	padding: 4px 0;
	opacity: 0;
	transform: translateY(-4px);
	transition: opacity var(--pict-modal-transition-duration) ease,
	            transform var(--pict-modal-transition-duration) ease;
}

.pict-modal-dropdown.pict-modal-dropdown--above { transform: translateY(4px); }

.pict-modal-dropdown.pict-modal-visible
{
	opacity: 1;
	transform: translateY(0);
}

.pict-modal-dropdown-item
{
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 14px;
	cursor: pointer;
	user-select: none;
	color: inherit;
	outline: none;
}

.pict-modal-dropdown-item:hover,
.pict-modal-dropdown-item:focus
{
	background: var(--pict-modal-dropdown-item-hover-bg);
	color: var(--pict-modal-dropdown-item-hover-fg);
}

.pict-modal-dropdown-item--disabled
{
	cursor: not-allowed;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--disabled:hover,
.pict-modal-dropdown-item--disabled:focus
{
	background: transparent;
	color: var(--pict-modal-dropdown-item-disabled-fg);
}

.pict-modal-dropdown-item--primary { color: var(--pict-modal-dropdown-primary-fg); }
.pict-modal-dropdown-item--danger  { color: var(--pict-modal-dropdown-danger-fg); }

.pict-modal-dropdown-item-icon
{
	flex: 0 0 auto;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
}

.pict-modal-dropdown-item-icon svg { width: 100%; height: 100%; display: block; }

.pict-modal-dropdown-item-label { flex: 1 1 auto; min-width: 0; }

.pict-modal-dropdown-item-hint
{
	flex: 0 0 auto;
	font-size: 11px;
	opacity: 0.6;
	margin-left: 12px;
}

.pict-modal-dropdown-separator
{
	height: 1px;
	background: var(--pict-modal-dropdown-separator);
	margin: 4px 0;
}

.pict-modal-dropdown-header
{
	padding: 6px 14px 2px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: var(--pict-modal-dropdown-header-fg);
}

/* ── Resizable / Collapsible Panels ──────────────── */
.pict-panel
{
	position: relative;
	transition: width 0.2s ease;
	flex-shrink: 0;
	overflow: visible;
}
.pict-panel-collapsed
{
	width: 0 !important;
	min-width: 0 !important;
	overflow: visible;
}
.pict-panel-collapsed > *:not(.pict-panel-edge)
{
	display: none;
}

/* Edge container — zero-width flex sibling of the panel.
   Sits next to the panel in the flex layout; children
   use absolute positioning to overlap the panel boundary. */
.pict-panel-edge
{
	position: relative;
	width: 0;
	flex-shrink: 0;
	z-index: 50;
	overflow: visible;
}

/* Resize handle — thin strip on the panel boundary */
.pict-panel-resize
{
	position: absolute;
	top: 0;
	bottom: 0;
	width: 4px;
	cursor: col-resize;
	background: transparent;
	transition: background 0.15s, width 0.15s;
}
.pict-panel-edge-right .pict-panel-resize
{
	right: 0;
	border-right: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-edge-left .pict-panel-resize
{
	left: 0;
	border-left: 1px solid var(--pict-panel-border, #DDD6CA);
}
.pict-panel-resize:hover,
.pict-panel-edge:hover .pict-panel-resize
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 0.5;
}
.pict-panel-resize.dragging
{
	width: 5px;
	background: var(--pict-panel-accent, #2E7D74);
	opacity: 1;
	transition: none;
}
.pict-panel-edge-collapsed .pict-panel-resize
{
	display: none;
}

/* Collapse tab — tucked sliver at rest, slides out on hover */
.pict-panel-tab
{
	position: absolute;
	top: 8px;
	width: 8px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: var(--pict-panel-border, #DDD6CA);
	border: 1px solid var(--pict-panel-border, #DDD6CA);
	cursor: pointer;
	color: var(--pict-panel-fg, #8A7F72);
	font-size: 10px;
	line-height: 1;
	opacity: 0.5;
	transition: opacity 0.25s, width 0.2s ease, height 0.2s ease, left 0.2s ease, right 0.2s ease, background 0.2s;
	z-index: 51;
}
.pict-panel-edge:hover .pict-panel-tab,
.pict-panel-tab:hover
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}
/* Right panel: tab to the left of the edge */
.pict-panel-edge-right .pict-panel-tab
{
	right: 0;
	border-right: none;
	border-radius: 4px 0 0 4px;
}
.pict-panel-edge-right:hover .pict-panel-tab,
.pict-panel-edge-right .pict-panel-tab:hover
{
	right: 0;
}
/* Left panel: tab to the right of the edge */
.pict-panel-edge-left .pict-panel-tab
{
	left: 0;
	border-left: none;
	border-radius: 0 4px 4px 0;
}
.pict-panel-edge-left:hover .pict-panel-tab,
.pict-panel-edge-left .pict-panel-tab:hover
{
	left: 0;
}
/* When collapsed — more visible */
.pict-panel-edge-collapsed .pict-panel-tab
{
	width: 10px;
	height: 28px;
	opacity: 0.6;
}
.pict-panel-edge-collapsed .pict-panel-tab:hover,
.pict-panel-edge-collapsed:hover .pict-panel-tab
{
	width: 20px;
	height: 32px;
	opacity: 1;
	overflow: visible;
	background: var(--pict-panel-bg, #FAF8F4);
}

/* ───────────────────────────────────────────────────────────────────
 *  Pict-Modal-Shell — viewport-managing layout for top / right /
 *  bottom / left panels around a center.
 * ───────────────────────────────────────────────────────────────── */

.pict-modal-shell-host { display: block; height: 100%; min-height: 0; }
.pict-modal-shell
{
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 0;
	position: relative;
	color: var(--pict-modal-fg, var(--theme-color-text-primary, #1a1a1a));
	background: var(--theme-color-background-primary, transparent);
}
.pict-modal-shell-row { display: flex; min-width: 0; min-height: 0; }
/* "First added = at the edge" convention is held by reversing the
   flex-direction on the bottom row + right side. That way, for ALL
   four sides, calling addPanel() N times stacks panel #1 against
   the viewport edge, panel #2 just inside it, panel #3 further in,
   and so on. Without these reverses, top + left worked that way but
   bottom + right inverted (first-added at content side, last-added
   at edge), which surprised callers. */
.pict-modal-shell-row-top    { flex: 0 0 auto; flex-direction: column; }
.pict-modal-shell-row-bottom { flex: 0 0 auto; flex-direction: column-reverse; }
.pict-modal-shell-row-middle
{
	flex: 1 1 0;
	flex-direction: row;
	min-height: 0;
	position: relative;
}
.pict-modal-shell-side
{
	display: flex;
	flex: 0 0 auto;
	min-height: 0;
}
.pict-modal-shell-side-left  { flex-direction: row; }
.pict-modal-shell-side-right { flex-direction: row-reverse; }
.pict-modal-shell-center
{
	flex: 1 1 0;
	min-width: 0;
	min-height: 0;
	overflow: auto;
	position: relative;
}
.pict-modal-shell-center-content
{
	min-height: 100%;
}
/* Center column gains this class when at least one Scope:'center'
   panel is added.  The center stops scrolling internally — that job
   moves to the content destination — and switches to a vertical flex
   so the destination and any inner panels stack cleanly. */
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel
{
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-center-content
{
	flex: 1 1 0;
	min-height: 0;
	overflow: auto;
}
.pict-modal-shell-center.pict-modal-shell-center-with-inner-panel > .pict-modal-shell-panel
{
	flex: 0 0 auto;
	width: 100%;
}

/* Panels — base */
.pict-modal-shell-panel
{
	/* How far the collapse-tab's panel-bg "merge bar" extends INTO
	   the panel past the tab's geometric edge. Painted via box-shadow
	   on the tab (no DOM impact), it masks any 1px theme border on an
	   inner element, content padding offset, or resize-handle hover
	   bleed in the strip between the tab's panel-facing edge and the
	   first real pixel of panel content. Consumers can bump this for
	   themes with thicker (2+px) inner borders. */
	--pict-modal-collapse-tab-merge: 2px;
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: inherit;
	min-width: 0;
	min-height: 0;
	transition: width 140ms ease, height 140ms ease;
}
.pict-modal-shell-panel-content
{
	flex: 1 1 auto;
	min-width: 0;
	min-height: 0;
	overflow: auto;
}
/* Fixed-mode panels are pure chrome (topbars, status rows). Their
   content should fit the configured Size exactly — never scroll. The
   1px border that .pict-modal-shell-panel-mode-fixed adds on the
   inner edge shaves 1px off the content's available height, which
   then triggers a sliver-scrollbar on any inner widget with
   min-height matching the panel Size. overflow:hidden here suppresses
   that without affecting resizable/collapsible panels (sidebars,
   drawers) where scrollable content is the whole point. */
.pict-modal-shell-panel-mode-fixed > .pict-modal-shell-panel-content
{
	overflow: hidden;
}
.pict-modal-shell-panel-content-inner
{
	min-height: 100%;
}
/* Panel boundary — fixed-mode panels get a hairline border for explicit
   demarcation. Collapsible / resizable panels DROP the boundary border
   (background contrast separates them from the center anyway) so the
   collapse tab can pull out cleanly without a hairline cutting across
   it. The host stylesheet still gets full control via the panel's own
   background. */
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-top    { border-bottom: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-bottom { border-top:    1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-left   { border-right:  1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }
.pict-modal-shell-panel-mode-fixed.pict-modal-shell-panel-right  { border-left:   1px solid var(--pict-modal-border, var(--theme-color-border-default, #e0e0e0)); }

/* Resize handle — absolute on the inner edge of each panel. */
.pict-modal-shell-panel-resize-handle
{
	position: absolute;
	background: transparent;
	z-index: 5;
	transition: background-color 120ms ease;
}
/* Resize handle hover — use the active brand's mode-aware primary
   color (set by pict-section-theme's Brand provider as
   --brand-color-primary-mode) so the resize affordance picks up the
   app's wordmark color. Falls back to the theme's brand-primary
   token if no brand is registered. */
.pict-modal-shell-panel-resize-handle:hover
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.4;
}
.pict-modal-shell-panel-left   .pict-modal-shell-panel-resize-handle { right: -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-right  .pict-modal-shell-panel-resize-handle { left:  -3px; top: 0; bottom: 0; width: 6px; cursor: col-resize; }
.pict-modal-shell-panel-top    .pict-modal-shell-panel-resize-handle { bottom:-3px; left: 0; right: 0; height: 6px; cursor: row-resize; }
.pict-modal-shell-panel-bottom .pict-modal-shell-panel-resize-handle { top:   -3px; left: 0; right: 0; height: 6px; cursor: row-resize; }

/* Collapse tab — slim sliver flush on the panel's OUTER boundary
   (where the resize handle sits), modelled on retold-content-system's
   sidebar tab. At rest it's a 6×28 px sliver; hover expands to
   18×36 px without overlapping the panel's own content. The tab is
   positioned with its center on the boundary so half pokes into the
   adjacent area — the only place we can safely take over without
   stepping on app UI inside the panel. Title text only renders in the
   collapsed state where there's room for it. */
.pict-modal-shell-panel-collapse-tab
{
	position: absolute;
	display: flex;            /* not inline-flex — avoids baseline alignment quirks */
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #d0d7de));
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #ffffff));
	color: var(--theme-color-text-muted, #6b7280);
	font: inherit;
	font-size: 10px;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	cursor: pointer;
	z-index: 50;
	opacity: 0.55;
	padding: 0;
	box-sizing: border-box;
	line-height: 0;          /* keep child boxes from inflating around the rotated chevron */
	/* Geometry (width/height/right/left) is intentionally NOT animated.
	   Sliding the tab's outer edge inward on hover-out makes it look like
	   the tab is "sliding into" the panel content — weird visual.
	   Snapping the size change instead, and animating only the appearance
	   (opacity/color/shadow), gives a clean fade-in/out with no boundary
	   weirdness. */
	transition: opacity 160ms ease,
	            background-color 160ms ease, color 160ms ease,
	            border-color 160ms ease, box-shadow 160ms ease;
}
/* Hover state pulls accent color from the active brand (mode-aware,
   so it's legible in both light + dark) with theme brand-primary as
   fallback. The whole point of brand colors is that they show up
   across the app's chrome. */
.pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab
{
	opacity: 1;
	color:        var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Drop shadow casts AWAY from the panel so the tab feels pulled out
   (extension of the panel) rather than floating across the boundary.
   The tab itself is now positioned fully OUTSIDE the panel boundary
   (see the per-side rules below), so we don't need a merge-bar shadow
   to mask any in-panel overlap — only the drop shadow remains. */
.pict-modal-shell-panel-left:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left    > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-right:hover   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right   > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: -3px 0 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-top:hover     > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top     > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-panel-bottom:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom  > .pict-modal-shell-panel-collapse-tab:hover
{
	box-shadow: 0 -3px 6px -2px rgba(0, 0, 0, 0.18);
}

/* Per-side base positioning — the tab lives entirely OUTSIDE the
   panel's outer boundary.  Its panel-facing edge touches the boundary
   (offset = -tabThickness) and the rest of the tab pokes out into the
   adjacent area (center / sibling panel).  Border on the panel-facing
   edge is dropped so the tab looks attached to the panel rather than
   floating beside it.
   Why fully-outside?  Earlier iterations had the tab straddling the
   boundary (1px inside + 4px outside) with a panel-bg-colored merge-bar
   masking the in-panel half — that worked geometrically but visually
   read as "tab pinned into the panel," and any rendering inside the
   panel (especially custom borders or hover bleeds) could clip against
   the in-panel half.  Fully-external positioning eliminates the overlap
   class of bugs and lets the tab live entirely in the adjacent area
   where there's no app content to step on. */
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab
{
	right: -6px; top: 14px; width: 6px; height: 28px;
	border-radius: 0 4px 4px 0;
	border-left: 0;
}
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab
{
	left:  -6px; top: 14px; width: 6px; height: 28px;
	border-radius: 4px 0 0 4px;
	border-right: 0;
}
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab
{
	bottom: -6px; right: 14px; width: 28px; height: 6px;
	border-radius: 0 0 4px 4px;
	border-top: 0;
}
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab
{
	top:    -6px; right: 14px; width: 28px; height: 6px;
	border-radius: 4px 4px 0 0;
	border-bottom: 0;
}

/* Hover: tab grows OUTWARD into the adjacent area.  The panel-facing
   edge stays glued to the boundary (offset = -tabThickness), so the
   tab still looks attached on hover — only its outer dimension grows.
   For side panels the height also grows (28 → 36) downward; for top
   /bottom panels the width grows (28 → 36) — see the next block for
   the perpendicular-axis offsets. */
.pict-modal-shell-panel-left:hover  > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-left  > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; right: -18px;
}
.pict-modal-shell-panel-right:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 18px; height: 36px; left: -18px;
}
.pict-modal-shell-panel-top:hover    > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-top    > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; bottom: -18px;
}
.pict-modal-shell-panel-bottom:hover > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-bottom > .pict-modal-shell-panel-collapse-tab:hover
{
	width: 36px; height: 18px; top: -18px;
}

.pict-modal-shell-panel-collapse-tab-title { display: none; white-space: nowrap; }

/* Auto-generated chevron glyph inside the tab — only visible once the
   tab is wide / tall enough to show it (i.e. hover state, or when the
   panel is collapsed). Direction follows side + state.
   Sized 5×5 (down from 6) so even with rotation the visual stays
   well clear of the tab's overflow:hidden bounds at 18×36 hover and
   the 24px collapsed tab strip width. flex-shrink:0 ensures the
   pseudo never collapses to zero in tight tab dimensions. */
.pict-modal-shell-panel-collapse-tab::before
{
	content: '';
	display: block;
	width: 5px; height: 5px;
	flex-shrink: 0;
	opacity: 0;
	border-right: 1.5px solid currentColor;
	border-bottom: 1.5px solid currentColor;
	transform: rotate(135deg);
	transform-origin: center center;
	transition: opacity 160ms ease, transform 160ms ease;
}
.pict-modal-shell-panel:hover > .pict-modal-shell-panel-collapse-tab::before,
.pict-modal-shell-panel-collapse-tab:hover::before,
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	opacity: 1;
}
.pict-modal-shell-panel-right                                       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-top                                         > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }
.pict-modal-shell-panel-bottom                                      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed       > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-45deg); }
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed      > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(135deg); }
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed        > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(45deg); }
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed     > .pict-modal-shell-panel-collapse-tab::before { transform: rotate(-135deg); }

/* Collapsed state — content disappears, only the collapse tab remains. */
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-content
{
	display: none;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed
{
	/* When collapsed, side panels rotate the title for vertical reading. */
	overflow: hidden;
}
/* When collapsed: the entire panel becomes the tab strip — full width
   for sides, full height for top/bottom — with the title visible
   vertically (sides) or horizontally (top/bottom). The little sliver
   tab on the boundary disappears (we don't need it anymore — clicking
   anywhere on the panel toggles it back open). */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-top.pict-modal-shell-panel-collapsed,
.pict-modal-shell-panel-bottom.pict-modal-shell-panel-collapsed
{
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	/* Promote the tab to FILL the collapsed panel (not just hug its
	   content) so the centered chevron + title group sits in the middle
	   of the panel. Without explicit width/height: 100%, the position:
	   absolute element shrinks to its natural content size and the
	   group ends up flush at the top of the panel — where the chevron
	   gets clipped by the topbar. */
	position: absolute !important;
	top: 0 !important; right: 0 !important; bottom: 0 !important; left: 0 !important;
	width: 100% !important;
	height: 100% !important;
	border: 0;
	border-radius: 0;
	background: transparent;
	opacity: 0.85;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px 4px;        /* keeps chevron + title clear of edges */
	box-shadow: none;
	color: var(--theme-color-text-muted, #6b7280);
	box-sizing: border-box;
	overflow: hidden;
}
.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	background: var(--theme-color-background-hover, var(--pict-modal-bg, #fff));
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: none;
}
/* Side panels (collapsed): rotate the title for vertical reading. */
.pict-modal-shell-panel-left.pict-modal-shell-panel-collapsed   > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-right.pict-modal-shell-panel-collapsed  > .pict-modal-shell-panel-collapse-tab
{
	writing-mode: vertical-rl;
	text-orientation: mixed;
}
.pict-modal-shell-panel-collapsed .pict-modal-shell-panel-collapse-tab-title
{
	display: inline;
}

/* Hidden panels — when Hidden:true is passed to addPanel, the collapsed
   state has zero footprint: no collapse tab (the tab is never built),
   the panel root is display:none, and the resize handle vanishes. The
   only path to the open state is a programmatic expand()/toggle() from
   somewhere else in the app (e.g. a topbar gear button). When expanded,
   the panel renders normally — so resize/drag handles continue to work
   while the panel is open. */
.pict-modal-shell-panel-hidden.pict-modal-shell-panel-collapsed
{
	display: none !important;
}

/* Overlay panels — float over the middle row instead of taking layout
   space. The overlay layer is positioned absolutely inside the middle
   row; individual overlay panels stack with positive z-index. */
.pict-modal-shell-overlay-layer
{
	position: absolute;
	inset: 0;
	pointer-events: none;
	z-index: 10;
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel
{
	pointer-events: auto;
	position: absolute;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-left   { left:   0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-right  { right:  0; top: 0; bottom: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-top    { top:    0; left: 0; right: 0; }
.pict-modal-shell-overlay-layer .pict-modal-shell-panel-bottom { bottom: 0; left: 0; right: 0; }

/* ─────────────────────────────────────────────────────────────────
   Responsive drawer mode — .pict-modal-shell-drawer-active toggles
   onto the middle row when any panel with ResponsiveDrawer crosses
   below its breakpoint. Flips the row's flex-direction from row to
   column, stacking side panels above the center and stretching them
   to full width. Each opted-in panel itself gets the
   .pict-modal-shell-panel-drawer class so per-panel rules below
   target only the drawer-mode panels (right + non-drawer panels in
   the same row are unaffected). The drawer height is read from a
   per-panel --pict-modal-drawer-height CSS variable (default
   33vh, set in JS from the DrawerHeight option).
   ───────────────────────────────────────────────────────────────── */
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active
{
	flex-direction: column;
	/* The drawer tab lives outside the drawer's bottom edge — ancestor
	   chain MUST allow it to escape clip. */
	overflow: visible;
}
.pict-modal-shell-row-middle.pict-modal-shell-drawer-active .pict-modal-shell-side
{
	/* Side stacks stretch full-width and lay out their panels as a
	   horizontal row of stacked drawers (so two drawers from the same
	   side don't end up overlapping). overflow: visible so the
	   per-panel tab can extend below the side stack into the workspace. */
	width: 100% !important;
	flex-direction: column;
	overflow: visible;
}
/* The drawer-tagged panel itself: kill the inline width set by
   _applySize (we override with !important since the inline style has
   higher specificity than a class selector), then size by height
   from the CSS variable. Resize handle is hidden in drawer mode
   because horizontal dragging doesn't translate to vertical sizing
   and the user already has the collapse tab to dismiss / restore.

   padding-bottom reserves an 18px strip at the bottom of the panel
   for the tab. The tab sits INSIDE the drawer's footprint — never
   below it — so the workspace header below the drawer is never in
   the same vertical band as the tab. (Previously the tab hung
   below the drawer's bottom edge into the workspace's top padding;
   that made the tab visually compete with the workspace header,
   even when the tab box-model bounds technically cleared the
   header.) box-sizing: border-box so the padding eats from the
   33vh, not adding to it. */
.pict-modal-shell-panel-drawer
{
	width: 100% !important;
	max-width: 100% !important;
	height: var(--pict-modal-drawer-height, 33vh);
	transition: height 140ms ease;
	padding-bottom: 18px;
	box-sizing: border-box;
	overflow: visible !important;
	/* Clip the panel bg to its CONTENT area only — the 18px
	   padding-bottom reserve (where the tab lives) becomes
	   transparent, so the middle row's primary background shows
	   through. Without this the reserve would render with the
	   panel's chrome bg, creating a visible "strip" between the
	   drawer content above and the workspace below — the tab would
	   look like it's sitting on its own miscoloured band rather
	   than at the seam between drawer and workspace. */
	background-clip: content-box;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed
{
	/* Collapsed = "just the tab strip is visible". 18px matches the
	   panel's tab reserve so the height is consistent across states.
	   When this is 0 the tab would have nowhere to render and the
	   user couldn't reopen the drawer. */
	height: 18px !important;
	padding-bottom: 0 !important;
	/* Drop the panel's bg in collapsed state — without this the 18px
	   strip shows the --pict-modal-bg (panel chrome) which doesn't
	   match the workspace --theme-color-background-primary below it,
	   creating a visible "drawer band" around the tab that breaks the
	   illusion of the tab belonging to the workspace area. With
	   transparent bg the middle row's primary background shows
	   through, the strip blends with the workspace, and the tab pill
	   reads as a free-floating handle. */
	background: transparent !important;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-resize-handle
{
	display: none;
}
/* The drawer's collapse tab is a horizontal pill protruding from the
   bottom of the drawer (rather than the inner edge of a side panel).
   Override the side-panel positioning rules from above so the tab
   always sits at the drawer's bottom-center seam, in both expanded
   and collapsed states. The expand-from-zero affordance: when
   collapsed (height: 0), the tab still hangs below "where the
   drawer would be" — a small handle the user can click to pull
   the drawer back down. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	position: absolute !important;
	/* Anchored to the panel's BOTTOM edge — the tab lives INSIDE the
	   drawer's footprint (in the 18px reserve at the bottom), never
	   below it into the workspace. This means the workspace below
	   the drawer is never sharing a vertical band with the tab, so
	   the workspace header doesn't optically compete with it.
	   bottom: 4px aligns the tab's top edge exactly with the panel's
	   CONTENT-AREA bottom (panel.height − padding-bottom 18px). With
	   border-top: 0 on the tab, the seam between the drawer content
	   above and the tab body is invisible — they share --pict-modal-bg
	   and merge into one shape, the tab reading as a labelled
	   extension of the drawer hanging downward. Collapsed state
	   keeps the smaller offset (overridden below) because its panel
	   has no padding-bottom, so the math doesn't apply. */
	top: auto !important;
	bottom: 4px !important;
	left: 50% !important;
	right: auto !important;
	transform: translate(-50%, 0) !important;
	width: 64px !important;
	height: 14px !important;
	/* CRITICAL: border-box + padding: 0 — the collapsed-state base
	   rule inherits "padding: 12px 4px" (so the chevron clears the
	   edges of a tab that fills a 24px-wide side strip). In drawer
	   mode the tab is a 14px tall pill, NOT a strip-fill, so that
	   12px vertical padding would balloon the tab's outer height to
	   ~38px and crash into the workspace header text. The chevron
	   is centered via flex anyway. */
	box-sizing: border-box !important;
	padding: 0 !important;
	/* Rounded BOTTOM corners + no top border — the tab looks like a
	   traditional drawer-handle/tab hanging from above. Its rounded
	   bottom curves face the workspace (the "open downward" affordance
	   for a top drawer). border-top: 0 lets the tab visually merge
	   with whatever's directly above it inside the panel (sidebar
	   content when expanded, the panel background when collapsed). */
	border-radius: 0 0 8px 8px;
	border: 1px solid var(--pict-modal-border, var(--theme-color-border-default, #cfd5dd));
	border-top: 0;
	background: var(--pict-modal-bg, var(--theme-color-background-panel, #fff));
	opacity: 0.95;
	z-index: 20;
	/* The default side-panel hover-grow values would yank the tab off
	   to the wrong spot in drawer mode — neutralise. */
	display: flex;
	align-items: center;
	justify-content: center;
}
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab:hover,
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab:hover
{
	opacity: 1;
	width: 96px !important;
	/* height stays at 14px — the tab is anchored with bottom, so any
	   height growth would push the tab's TOP edge UPWARD past the
	   space available above it. In EXPANDED state that crashes into
	   the drawer content above; in COLLAPSED state it crashes into
	   the topbar's brand stripes. Width-only growth (64 to 96, +50%)
	   still gives the "tab is reaching toward me" affordance without
	   the encroachment. */
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.18);
}
/* Collapsed-state bottom-offset override. Expanded panels have an
   18px padding-bottom reserve, and "bottom: 4px" anchors the tab's
   top edge exactly at the content-area boundary (so it merges
   visually with the drawer above). Collapsed panels have
   padding-bottom: 0 and a total height of 18px — "bottom: 4px"
   there would put the tab's top at the panel's actual top edge,
   crashing the (border-top: 0) tab into the topbar. The smaller
   "bottom: 2px" keeps the 14px tab vertically centered in the 18px
   strip with 2px margins on either side. */
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab
{
	bottom: 2px !important;
}
/* Chevron inside the tab: point UP when expanded (the drawer
   collapses UP / out of view, so the arrow indicates "click me to
   send the drawer up"), DOWN when collapsed (the drawer expands DOWN
   into view). Rotations come from the existing top-panel chevron
   table: rotate(-135deg) → UP arrow, rotate(45deg) → DOWN arrow. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(-135deg) !important;
}
.pict-modal-shell-panel-drawer.pict-modal-shell-panel-collapsed > .pict-modal-shell-panel-collapse-tab::before
{
	transform: rotate(45deg) !important;
}
/* The collapse tab's existing title-text span is hidden when reduced
   to a pill — there's no horizontal room. The chevron alone reads
   correctly. */
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-title,
.pict-modal-shell-panel-drawer > .pict-modal-shell-panel-collapse-tab .pict-modal-shell-panel-collapse-tab-icon
{
	display: none;
}

/* Drag-active state — disable text selection + change cursor globally
   so resize feels solid even when the cursor briefly leaves the handle. */
.pict-modal-shell-dragging-x, .pict-modal-shell-dragging-y { user-select: none; }
.pict-modal-shell-dragging-x * { cursor: col-resize !important; }
.pict-modal-shell-dragging-y * { cursor: row-resize !important; }

/* Per-panel resize-active state — kills the panel's collapse/expand
   width/height transition for the duration of a drag. Without this,
   every pointermove starts a fresh 140 ms transition and the resize
   visibly lags behind the cursor ("choppy"). With it disabled the
   panel snaps to the new size on the same frame as the pointer, which
   feels native. */
.pict-modal-shell-panel-resizing { transition: none !important; }
.pict-modal-shell-panel-resizing > .pict-modal-shell-panel-resize-handle
{
	background: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	opacity: 0.5;
}

/* Panel popup-attention flash — fires when popup() is called on an
   already-open panel. Brief brand-colored inset glow so the user sees
   that their click landed even though the panel didn't change shape.
   Class is added by the shell, auto-removed after ~700 ms. */
@keyframes pict-modal-shell-panel-flash
{
	0%   { box-shadow: inset 0 0 0 0 transparent; }
	30%  { box-shadow: inset 0 0 0 3px var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)); }
	100% { box-shadow: inset 0 0 0 0 transparent; }
}
.pict-modal-shell-panel-flash
{
	animation: pict-modal-shell-panel-flash 600ms ease-out;
}
`
});

},{}],153:[function(require,module,exports){
const libPictViewClass = require('pict-view');

const libPictModalOverlay = require('./Pict-Modal-Overlay.js');
const libPictModalConfirm = require('./Pict-Modal-Confirm.js');
const libPictModalWindow = require('./Pict-Modal-Window.js');
const libPictModalToast = require('./Pict-Modal-Toast.js');
const libPictModalTooltip = require('./Pict-Modal-Tooltip.js');
const libPictModalPanel = require('./Pict-Modal-Panel.js');
const libPictModalDropdown = require('./Pict-Modal-Dropdown.js');
const libPictModalShell = require('./Pict-Modal-Shell.js');

const _DefaultConfiguration = require('./Pict-Section-Modal-DefaultConfiguration.js');

class PictSectionModal extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);

		super(pFable, tmpOptions, pServiceHash);

		this._activeModals = [];
		this._activeTooltips = [];
		this._activeToasts = [];
		this._idCounter = 0;

		this._overlay = new libPictModalOverlay(this);
		this._confirm = new libPictModalConfirm(this);
		this._window = new libPictModalWindow(this);
		this._toast = new libPictModalToast(this);
		this._tooltip = new libPictModalTooltip(this);
		this._panel = new libPictModalPanel(this);
		this._dropdown = new libPictModalDropdown(this);
		this._shell = new libPictModalShell(this);
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Ensure the root class is on the body for CSS variable scoping
		if (typeof document !== 'undefined' && document.body)
		{
			if (!document.body.classList.contains('pict-modal-root'))
			{
				document.body.classList.add('pict-modal-root');
			}
		}

		return super.onBeforeInitialize();
	}

	/**
	 * Generate a unique ID for DOM elements.
	 *
	 * @returns {number}
	 */
	_nextId()
	{
		this._idCounter++;
		return this._idCounter;
	}

	// -- Confirm API --

	/**
	 * Show a confirmation dialog.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmLabel, cancelLabel, dangerous }
	 * @returns {Promise<boolean>}
	 */
	confirm(pMessage, pOptions)
	{
		return this._confirm.confirm(pMessage, pOptions);
	}

	/**
	 * Show a two-step confirmation dialog.
	 *
	 * If confirmPhrase is set, the user must type it to enable the confirm button.
	 * If no confirmPhrase, the first click changes the button text and the second click confirms.
	 *
	 * @param {string} pMessage - The confirmation message
	 * @param {object} [pOptions] - Options { title, confirmPhrase, phrasePrompt, confirmLabel, cancelLabel }
	 * @returns {Promise<boolean>}
	 */
	doubleConfirm(pMessage, pOptions)
	{
		return this._confirm.doubleConfirm(pMessage, pOptions);
	}

	// -- Modal Window API --

	/**
	 * Show a custom modal window.
	 *
	 * @param {object} [pOptions] - Options { title, content, buttons, closeable, width, onOpen, onClose }
	 * @returns {Promise<string|null>} Resolves with the clicked button Hash, or null on close
	 */
	show(pOptions)
	{
		return this._window.show(pOptions);
	}

	// -- Tooltip API --

	/**
	 * Attach a simple text tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pText - Tooltip text
	 * @param {object} [pOptions] - Options { position, delay, maxWidth }
	 * @returns {{ destroy: function }}
	 */
	tooltip(pElement, pText, pOptions)
	{
		return this._tooltip.tooltip(pElement, pText, pOptions);
	}

	/**
	 * Attach a rich HTML tooltip to an element.
	 *
	 * @param {HTMLElement} pElement - Target element
	 * @param {string} pHTMLContent - HTML content
	 * @param {object} [pOptions] - Options { position, delay, maxWidth, interactive }
	 * @returns {{ destroy: function }}
	 */
	richTooltip(pElement, pHTMLContent, pOptions)
	{
		return this._tooltip.richTooltip(pElement, pHTMLContent, pOptions);
	}

	// -- Toast API --

	/**
	 * Show a toast notification.
	 *
	 * @param {string} pMessage - Toast message
	 * @param {object} [pOptions] - Options { type, duration, position, dismissible }
	 * @returns {{ dismiss: function }}
	 */
	toast(pMessage, pOptions)
	{
		return this._toast.toast(pMessage, pOptions);
	}

	// -- Dropdown API --

	/**
	 * Open an anchor-positioned dropdown menu (no backdrop, click-outside
	 * dismisses). Useful for nav menus and split-button addenda.
	 *
	 * @param {HTMLElement|string|object} pAnchor - Element, CSS selector, or
	 *   { left, top, width, height } rect for context-menu style anchoring.
	 * @param {object} pOptions - { items, align, position, minWidth, maxHeight,
	 *   className, closeOnSelect, onSelect, onClose }
	 * @returns {Promise<{Hash, Item}|null>} Selection or null on dismiss.
	 */
	dropdown(pAnchor, pOptions)
	{
		return this._dropdown.dropdown(pAnchor, pOptions);
	}

	/**
	 * Dismiss any open dropdown.
	 */
	dismissDropdowns()
	{
		this._dropdown.dismissAll();
	}

	// -- Panel API --

	/**
	 * Attach resizable/collapsible panel behavior to a DOM element.
	 *
	 * @param {string} pTargetSelector - CSS selector for the panel element
	 * @param {object} [pOptions] - Options { position, width, minWidth, maxWidth, collapsible, collapsed, persist, persistKey, onResize, onToggle }
	 * @returns {{ collapse, expand, toggle, setWidth, destroy }} Panel handle
	 */
	panel(pTargetSelector, pOptions)
	{
		return this._panel.create(pTargetSelector, pOptions);
	}

	// -- Shell API --

	/**
	 * Get (or create) a layout shell for a viewport. Idempotent.
	 *
	 * The shell takes ownership of the viewport's contents and manages
	 * top / right / bottom / left panel placement plus a center area.
	 * See Pict-Modal-Shell.js for full panel-config semantics.
	 *
	 * @param {string|HTMLElement} pViewport - selector or element of the
	 *   container the shell should fill (commonly the app's root div).
	 * @param {object} [pOptions]
	 * @param {boolean} [pOptions.Persistence=true]   - autosave panel state to localStorage
	 * @param {string}  [pOptions.PersistenceKey=null]- override scope (default: hostname)
	 * @returns {PictModalShell}
	 */
	shell(pViewport, pOptions)
	{
		return this._shell.shell(pViewport, pOptions);
	}

	// -- Cleanup API --

	/**
	 * Dismiss all open modals.
	 */
	dismissModals()
	{
		let tmpModals = this._activeModals.slice();
		for (let i = tmpModals.length - 1; i >= 0; i--)
		{
			tmpModals[i].dismiss(null);
		}
	}

	/**
	 * Dismiss all active tooltips.
	 */
	dismissTooltips()
	{
		this._tooltip.dismissAll();
	}

	/**
	 * Dismiss all active toasts.
	 */
	dismissToasts()
	{
		this._toast.dismissAll();
	}

	/**
	 * Dismiss everything: modals, tooltips, and toasts.
	 */
	dismissAll()
	{
		this.dismissModals();
		this.dismissTooltips();
		this.dismissToasts();
		this.dismissDropdowns();
	}

	/**
	 * Clean up all DOM elements when the view is destroyed.
	 */
	/**
	 * Destroy all active panels.
	 */
	destroyPanels()
	{
		this._panel.destroyAll();
	}

	destroy()
	{
		this.dismissAll();
		this.destroyPanels();
		this._overlay.destroy();
		this._toast.destroy();
		if (typeof super.destroy === 'function') { return super.destroy(); }
	}
}

module.exports = PictSectionModal;

module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-Modal-Confirm.js":144,"./Pict-Modal-Dropdown.js":145,"./Pict-Modal-Overlay.js":146,"./Pict-Modal-Panel.js":147,"./Pict-Modal-Shell.js":148,"./Pict-Modal-Toast.js":149,"./Pict-Modal-Tooltip.js":150,"./Pict-Modal-Window.js":151,"./Pict-Section-Modal-DefaultConfiguration.js":152,"pict-view":239}],154:[function(require,module,exports){
module.exports = (
{
	ViewIdentifier: 'Pict-ObjectEditor',

	DefaultRenderable: 'ObjectEditor-Container',
	DefaultDestinationAddress: '#ObjectEditor-Container',

	AutoRender: false,

	// Address in AppData where the JSON object lives
	ObjectDataAddress: false,

	// Maximum depth to auto-expand on initial load
	InitialExpandDepth: 1,

	// Whether editing is enabled (vs read-only inspector mode)
	Editable: true,

	// Whether to show type indicator badges
	ShowTypeIndicators: true,

	// Indentation pixels per depth level
	IndentPixels: 20,

	CSS: /*css*/`
.pict-objecteditor
{
	font-family: 'SF Mono', 'Fira Code', 'Cascadia Code', 'JetBrains Mono', Consolas, monospace;
	font-size: 13px;
	line-height: 1.5;
	color: var(--theme-color-text-primary, #3D3229);
	background: var(--theme-color-background-panel, #FDFCFA);
	border: 1px solid var(--theme-color-border-default, #E8E3DA);
	border-radius: 6px;
	padding: 8px 0;
	overflow: auto;
}
.pict-oe-row
{
	display: flex;
	align-items: center;
	padding: 2px 12px 2px 0;
	min-height: 26px;
	cursor: default;
	border-radius: 3px;
}
.pict-oe-row:hover
{
	background: var(--theme-color-background-hover, #F5F0E8);
}
.pict-oe-toggle
{
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	cursor: pointer;
	color: var(--theme-color-text-muted, #8A7F72);
	font-size: 10px;
	flex-shrink: 0;
	user-select: none;
	border-radius: 3px;
	transition: color 0.1s;
}
.pict-oe-toggle:hover
{
	background: var(--theme-color-border-default, #E8E3DA);
	color: var(--theme-color-text-primary, #3D3229);
}
.pict-oe-spacer
{
	display: inline-block;
	width: 16px;
	flex-shrink: 0;
}
.pict-oe-key
{
	color: var(--theme-color-syntax-property, #9E6B47);
	flex-shrink: 0;
}
.pict-oe-separator
{
	color: var(--theme-color-text-muted, #8A7F72);
	margin: 0 8px;
	flex-shrink: 0;
}
.pict-oe-value
{
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.pict-oe-value-string
{
	color: var(--theme-color-syntax-string, #2E7D74);
}
.pict-oe-value-string::before
{
	content: '"';
	color: var(--theme-color-syntax-string, #A8CFC9);
}
.pict-oe-value-string::after
{
	content: '"';
	color: var(--theme-color-syntax-string, #A8CFC9);
}
.pict-oe-value-number
{
	color: var(--theme-color-syntax-number, #3B6DAA);
}
.pict-oe-value-boolean
{
	color: var(--theme-color-syntax-keyword, #8B5E3C);
	font-weight: 600;
}
.pict-oe-value-null
{
	color: var(--theme-color-syntax-keyword, #B0A89E);
	font-style: italic;
}
.pict-oe-summary
{
	color: var(--theme-color-text-placeholder, #B0A89E);
	margin-left: 6px;
	font-size: 12px;
}
.pict-oe-type-badge
{
	display: inline-block;
	font-size: 9px;
	padding: 0 4px;
	border-radius: 3px;
	background: var(--theme-color-background-tertiary, #F0ECE4);
	color: var(--theme-color-text-muted, #8A7F72);
	margin-left: 6px;
	line-height: 16px;
	vertical-align: middle;
}
.pict-oe-value-input
{
	background: var(--theme-color-background-panel, #FFF);
	border: 1px solid var(--theme-color-syntax-string, #2E7D74);
	border-radius: 3px;
	padding: 1px 4px;
	font-family: inherit;
	font-size: inherit;
	color: inherit;
	outline: none;
	min-width: 80px;
}
.pict-oe-value-input:focus
{
	border-color: var(--theme-color-syntax-number, #3B6DAA);
	box-shadow: 0 0 0 2px rgba(59, 109, 170, 0.15);
}
.pict-oe-array-index
{
	color: var(--theme-color-text-muted, #8A7F72);
	font-size: 11px;
}
.pict-oe-empty
{
	color: var(--theme-color-text-placeholder, #B0A89E);
	font-style: italic;
	padding: 8px 12px;
}
.pict-oe-actions
{
	margin-left: auto;
	padding-left: 12px;
	padding-right: 4px;
	opacity: 0.4;
	transition: opacity 0.15s;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 5px;
}
.pict-oe-row:hover .pict-oe-actions
{
	opacity: 1;
}
.pict-oe-action-btn
{
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 22px;
	height: 22px;
	padding: 0 5px;
	border-radius: 3px;
	border: 1px solid var(--theme-color-border-default, #DDD8CF);
	background: var(--theme-color-background-hover, #F5F0E8);
	cursor: pointer;
	font-size: 12px;
	color: var(--theme-color-text-muted, #8A7F72);
	user-select: none;
	box-sizing: border-box;
}
.pict-oe-action-btn:hover
{
	background: var(--theme-color-background-hover, #E8E3DA);
	border-color: var(--theme-color-border-default, #C5BFAE);
	color: var(--theme-color-text-primary, #3D3229);
}
.pict-oe-action-remove
{
	border-color: var(--theme-color-status-error, #E8C8C8);
	background: var(--theme-color-background-hover, #FAF0F0);
	color: var(--theme-color-status-error, #A04040);
}
.pict-oe-action-remove:hover
{
	background: var(--theme-color-background-hover, #F0D6D6);
	border-color: var(--theme-color-status-error, #D4A0A0);
	color: var(--theme-color-status-error, #A04040);
}
.pict-oe-action-move
{
	font-size: 9px;
}
.pict-oe-action-move:hover
{
	background: var(--theme-color-background-hover, #D6E4F0);
	border-color: var(--theme-color-status-info, #A8C4DA);
	color: var(--theme-color-status-info, #3B6DAA);
}
.pict-oe-action-add
{
	border-color: var(--theme-color-status-success, #C8D8C8);
	background: var(--theme-color-background-hover, #F0F5F0);
	color: var(--theme-color-status-success, #5A7A5A);
}
.pict-oe-action-add:hover
{
	background: var(--theme-color-background-hover, #D6E8D6);
	border-color: var(--theme-color-status-success, #A0C0A0);
	color: var(--theme-color-status-success, #3D5C3D);
}
.pict-oe-key-input
{
	background: var(--theme-color-background-panel, #FFF);
	border: 1px solid var(--theme-color-syntax-property, #9E6B47);
	border-radius: 3px;
	padding: 1px 4px;
	font-family: inherit;
	font-size: inherit;
	color: var(--theme-color-syntax-property, #9E6B47);
	outline: none;
	min-width: 60px;
	margin-left: 6px;
}
.pict-oe-key-input:focus
{
	border-color: var(--theme-color-syntax-number, #3B6DAA);
	box-shadow: 0 0 0 2px rgba(59, 109, 170, 0.15);
}
.pict-oe-type-select
{
	background: var(--theme-color-background-panel, #FFF);
	border: 1px solid var(--theme-color-border-default, #C5BFAE);
	border-radius: 3px;
	padding: 1px 4px;
	font-family: inherit;
	font-size: inherit;
	color: var(--theme-color-text-primary, #3D3229);
	outline: none;
	margin-left: 6px;
	cursor: pointer;
}
.pict-oe-type-select:focus
{
	border-color: var(--theme-color-syntax-number, #3B6DAA);
	box-shadow: 0 0 0 2px rgba(59, 109, 170, 0.15);
}
.pict-oe-root-add
{
	display: flex;
	align-items: center;
	padding: 4px 12px;
	min-height: 26px;
	cursor: default;
}
.pict-oe-root-add .pict-oe-action-btn
{
	width: auto;
	white-space: nowrap;
	padding: 0 8px;
}
`,

	MacroTemplates:
	{
		Node:
		{
			RowOpen: '<div class="pict-oe-row" style="padding-left:{~D:Record.PaddingLeft~}px" data-path="{~D:Record.EscapedPath~}">',
			RowClose: '</div>',
			Toggle: '<span class="pict-oe-toggle" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].toggleNode(\'{~D:Record.EscapedPath~}\')">{~D:Record.ToggleArrow~}</span>',
			Spacer: '<span class="pict-oe-spacer"></span>',
			KeyName: '<span class="pict-oe-key">{~D:Record.EscapedKey~}</span>',
			KeyIndex: '<span class="pict-oe-key"><span class="pict-oe-array-index">{~D:Record.ArrayIndex~}</span></span>',
			Separator: '<span class="pict-oe-separator">:</span>',
			TypeBadge: '<span class="pict-oe-type-badge">{~D:Record.TypeLabel~}</span>',
			Summary: '<span class="pict-oe-summary">{~D:Record.SummaryText~}</span>',
			ValueStringEditable: '<span class="pict-oe-value pict-oe-value-string" ondblclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginEdit(\'{~D:Record.EscapedPath~}\', \'string\')" title="{~D:Record.EscapedTitle~}">{~D:Record.EscapedValue~}</span>',
			ValueStringReadOnly: '<span class="pict-oe-value pict-oe-value-string" title="{~D:Record.EscapedTitle~}">{~D:Record.EscapedValue~}</span>',
			ValueNumberEditable: '<span class="pict-oe-value pict-oe-value-number" ondblclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginEdit(\'{~D:Record.EscapedPath~}\', \'number\')">{~D:Record.EscapedValue~}</span>',
			ValueNumberReadOnly: '<span class="pict-oe-value pict-oe-value-number">{~D:Record.EscapedValue~}</span>',
			ValueBooleanEditable: '<span class="pict-oe-value pict-oe-value-boolean" style="cursor:pointer" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].toggleBoolean(\'{~D:Record.EscapedPath~}\')">{~D:Record.DisplayValue~}</span>',
			ValueBooleanReadOnly: '<span class="pict-oe-value pict-oe-value-boolean">{~D:Record.DisplayValue~}</span>',
			ValueNull: '<span class="pict-oe-value pict-oe-value-null">null</span>',
			ActionsOpen: '<span class="pict-oe-actions">',
			ActionsClose: '</span>',
			ButtonRemove: '<span class="pict-oe-action-btn pict-oe-action-remove" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].removeNode(\'{~D:Record.EscapedPath~}\')" title="Remove">\u00D7</span>',
			ButtonAddObject: '<span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToObject(\'{~D:Record.EscapedPath~}\')" title="Add">+</span>',
			ButtonAddArray: '<span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToArray(\'{~D:Record.EscapedPath~}\')" title="Add">+</span>',
			ButtonMoveUp: '<span class="pict-oe-action-btn pict-oe-action-move" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].moveArrayElementUp(\'{~D:Record.EscapedArrayPath~}\', {~D:Record.ArrayIndex~})" title="Move up">\u25B2</span>',
			ButtonMoveDown: '<span class="pict-oe-action-btn pict-oe-action-move" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].moveArrayElementDown(\'{~D:Record.EscapedArrayPath~}\', {~D:Record.ArrayIndex~})" title="Move down">\u25BC</span>',
			RootAddObject: '<div class="pict-oe-root-add" data-path=""><span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToObject(\'\')" title="Add property">+ add property</span></div>',
			RootAddArray: '<div class="pict-oe-root-add" data-path=""><span class="pict-oe-action-btn pict-oe-action-add" onclick="{~P~}.views[\'{~D:Context[0].Hash~}\'].beginAddToArray(\'\')" title="Add element">+ add element</span></div>'
		}
	},

	Templates:
	[
		{
			Hash: 'ObjectEditor-Container-Template',
			Template: '<div class="pict-objecteditor" id="ObjectEditor-Tree-{~D:Context[0].Hash~}"></div>'
		},
		{
			Hash: 'ObjectEditor-Node-String',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Number',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Boolean',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Null',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Spacer~}{~D:Record.Macro.Key~}{~D:Record.Macro.Separator~}{~D:Record.Macro.Value~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Object',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Toggle~}{~D:Record.Macro.Key~}{~D:Record.Macro.TypeBadge~}{~D:Record.Macro.Summary~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		},
		{
			Hash: 'ObjectEditor-Node-Array',
			Template: '{~D:Record.Macro.RowOpen~}{~D:Record.Macro.Toggle~}{~D:Record.Macro.Key~}{~D:Record.Macro.TypeBadge~}{~D:Record.Macro.Summary~}{~D:Record.Macro.Actions~}{~D:Record.Macro.RowClose~}'
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'ObjectEditor-Container',
			TemplateHash: 'ObjectEditor-Container-Template',
			DestinationAddress: '#ObjectEditor-Container',
			RenderMethod: 'replace'
		}
	]
});

},{}],155:[function(require,module,exports){
// Pict Section: Object Editor
// A tree-based JSON object viewer and editor for Pict applications.

// The main object editor view class
module.exports = require('./views/PictView-ObjectEditor.js');

// Node type views
module.exports.PictViewObjectEditorNode = require('./views/PictView-ObjectEditor-Node.js');
module.exports.PictViewObjectEditorNodeString = require('./views/PictView-ObjectEditor-NodeString.js');
module.exports.PictViewObjectEditorNodeNumber = require('./views/PictView-ObjectEditor-NodeNumber.js');
module.exports.PictViewObjectEditorNodeBoolean = require('./views/PictView-ObjectEditor-NodeBoolean.js');
module.exports.PictViewObjectEditorNodeNull = require('./views/PictView-ObjectEditor-NodeNull.js');
module.exports.PictViewObjectEditorNodeObject = require('./views/PictView-ObjectEditor-NodeObject.js');
module.exports.PictViewObjectEditorNodeArray = require('./views/PictView-ObjectEditor-NodeArray.js');

// Default configuration
module.exports.default_configuration = require('./Pict-Section-ObjectEditor-DefaultConfiguration.js');

},{"./Pict-Section-ObjectEditor-DefaultConfiguration.js":154,"./views/PictView-ObjectEditor-Node.js":156,"./views/PictView-ObjectEditor-NodeArray.js":157,"./views/PictView-ObjectEditor-NodeBoolean.js":158,"./views/PictView-ObjectEditor-NodeNull.js":159,"./views/PictView-ObjectEditor-NodeNumber.js":160,"./views/PictView-ObjectEditor-NodeObject.js":161,"./views/PictView-ObjectEditor-NodeString.js":162,"./views/PictView-ObjectEditor.js":163}],156:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Base class for all object editor node type renderers.
 *
 * Each subclass implements renderNodeHTML() to return an HTML string
 * for a single tree row.  One instance per type, not per node.
 *
 * Rendering uses the Pict template system with MacroTemplates defined
 * in the view configuration.  Each macro is a Jellyfish template string
 * compiled against the node descriptor (Record) and the ObjectEditor
 * view (Context[0]).  Subclasses set type-specific properties on the
 * node descriptor, call compileMacros(), then resolve a per-type
 * template that references the compiled macros.
 */
class PictViewObjectEditorNode extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNode';

		// Reference to the parent ObjectEditor view; set by the orchestrator
		this._ObjectEditorView = null;
	}

	/**
	 * Render a single tree node row as an HTML string.
	 *
	 * @param {Object} pNode - Node descriptor { Path, Key, Depth, DataType, HasChildren, ChildCount, IsExpanded, IsArrayElement, ArrayIndex }
	 * @param {*} pValue - The actual value at this node's path
	 * @param {Object} pOptions - Editor options { Editable, ShowTypeIndicators, IndentPixels, ViewHash }
	 *
	 * @return {string} HTML string for this row
	 */
	renderNodeHTML(pNode, pValue, pOptions)
	{
		return '';
	}

	// --- Macro compilation ---

	/**
	 * Compile all MacroTemplates onto pNode.Macro.
	 *
	 * This sets computed display properties on the node descriptor,
	 * then resolves every MacroTemplate from the view configuration
	 * against the node (as Record) and the ObjectEditor view (as Context[0]).
	 *
	 * After this call, pNode.Macro contains the compiled HTML fragments
	 * ready to be composed by a per-type template.
	 */
	compileMacros(pNode, pValue, pOptions)
	{
		// Compute derived display properties on the node descriptor
		pNode.PaddingLeft = (pNode.Depth * pOptions.IndentPixels) + 12;
		pNode.EscapedPath = this.escapeAttribute(pNode.Path);
		pNode.EscapedKey = this.escapeHTML(String(pNode.Key));
		pNode.ToggleArrow = pNode.IsExpanded ? '\u25BC' : '\u25B6';

		// Parse out parent array path for move buttons
		let tmpBracketMatch = pNode.Path.match(/^(.*)\[(\d+)\]$/);
		if (tmpBracketMatch)
		{
			pNode.EscapedArrayPath = this.escapeAttribute(tmpBracketMatch[1]);
		}
		else
		{
			pNode.EscapedArrayPath = '';
		}

		// Compile each MacroTemplate onto pNode.Macro
		let tmpMacroTemplates = this._ObjectEditorView.options.MacroTemplates.Node;
		let tmpMacroKeys = Object.keys(tmpMacroTemplates);
		pNode.Macro = {};

		for (let i = 0; i < tmpMacroKeys.length; i++)
		{
			let tmpKey = tmpMacroKeys[i];
			pNode.Macro[tmpKey] = this.pict.parseTemplate(
				tmpMacroTemplates[tmpKey],
				pNode,
				null,
				[this._ObjectEditorView]
			);
		}

		// Set the Key macro conditionally: array index or key name
		if (pNode.IsArrayElement)
		{
			pNode.Macro.Key = pNode.Macro.KeyIndex;
		}
		else
		{
			pNode.Macro.Key = pNode.Macro.KeyName;
		}

		// Set TypeBadge to empty if ShowTypeIndicators is false
		if (!pOptions.ShowTypeIndicators)
		{
			pNode.Macro.TypeBadge = '';
		}
	}

	/**
	 * Compose action button macros for leaf nodes.
	 * Returns a compiled HTML string for the actions area.
	 */
	compileActions(pNode, pOptions)
	{
		if (!pOptions.Editable)
		{
			return '';
		}
		let tmpHTML = pNode.Macro.ActionsOpen;
		if (pNode.IsArrayElement)
		{
			tmpHTML += pNode.Macro.ButtonMoveUp + pNode.Macro.ButtonMoveDown;
		}
		tmpHTML += pNode.Macro.ButtonRemove;
		tmpHTML += pNode.Macro.ActionsClose;
		return tmpHTML;
	}

	/**
	 * Compose action button macros for container nodes (object/array).
	 * Includes an add button in addition to move and remove.
	 */
	compileContainerActions(pNode, pOptions, pContainerType)
	{
		if (!pOptions.Editable)
		{
			return '';
		}
		let tmpHTML = pNode.Macro.ActionsOpen;
		tmpHTML += (pContainerType === 'array') ? pNode.Macro.ButtonAddArray : pNode.Macro.ButtonAddObject;
		if (pNode.IsArrayElement)
		{
			tmpHTML += pNode.Macro.ButtonMoveUp + pNode.Macro.ButtonMoveDown;
		}
		tmpHTML += pNode.Macro.ButtonRemove;
		tmpHTML += pNode.Macro.ActionsClose;
		return tmpHTML;
	}

	/**
	 * Escape a string for safe use in HTML attributes.
	 */
	escapeAttribute(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	/**
	 * Escape a string for safe use in HTML content.
	 */
	escapeHTML(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}
}

module.exports = PictViewObjectEditorNode;

},{"pict-view":239}],157:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeArray extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeArray';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		let tmpLength = Array.isArray(pValue) ? pValue.length : 0;

		pNode.TypeLabel = 'Array';
		let tmpNoun = (tmpLength === 1) ? 'item' : 'items';
		pNode.SummaryText = '[' + tmpLength + ' ' + tmpNoun + ']';

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Compose container actions (includes add button)
		pNode.Macro.Actions = this.compileContainerActions(pNode, pOptions, 'array');

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Array'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeArray;

},{"./PictView-ObjectEditor-Node.js":156}],158:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeBoolean extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeBoolean';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		pNode.DisplayValue = pValue ? 'true' : 'false';

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Select editable or read-only value macro
		pNode.Macro.Value = pOptions.Editable ? pNode.Macro.ValueBooleanEditable : pNode.Macro.ValueBooleanReadOnly;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Boolean'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeBoolean;

},{"./PictView-ObjectEditor-Node.js":156}],159:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeNull extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeNull';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Null always uses the static ValueNull macro
		pNode.Macro.Value = pNode.Macro.ValueNull;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Null'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeNull;

},{"./PictView-ObjectEditor-Node.js":156}],160:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeNumber extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeNumber';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		pNode.EscapedValue = this.escapeHTML(String(pValue));

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Select editable or read-only value macro
		pNode.Macro.Value = pOptions.Editable ? pNode.Macro.ValueNumberEditable : pNode.Macro.ValueNumberReadOnly;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Number'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeNumber;

},{"./PictView-ObjectEditor-Node.js":156}],161:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeObject extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeObject';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		let tmpKeyCount = 0;
		if (pValue && typeof pValue === 'object' && !Array.isArray(pValue))
		{
			tmpKeyCount = Object.keys(pValue).length;
		}

		pNode.TypeLabel = 'Object';
		let tmpNoun = (tmpKeyCount === 1) ? 'key' : 'keys';
		pNode.SummaryText = '{' + tmpKeyCount + ' ' + tmpNoun + '}';

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Compose container actions (includes add button)
		pNode.Macro.Actions = this.compileContainerActions(pNode, pOptions, 'object');

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-Object'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeObject;

},{"./PictView-ObjectEditor-Node.js":156}],162:[function(require,module,exports){
const libPictViewObjectEditorNode = require('./PictView-ObjectEditor-Node.js');

class PictViewObjectEditorNodeString extends libPictViewObjectEditorNode
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictViewObjectEditorNodeString';
	}

	renderNodeHTML(pNode, pValue, pOptions)
	{
		// Set type-specific display properties on the node descriptor
		let tmpDisplayValue = (typeof pValue === 'string') ? pValue : '';
		// Truncate long strings for display
		let tmpTruncated = tmpDisplayValue.length > 120 ? tmpDisplayValue.substring(0, 120) + '\u2026' : tmpDisplayValue;
		pNode.EscapedValue = this.escapeHTML(tmpTruncated);
		pNode.EscapedTitle = this.escapeAttribute(tmpDisplayValue);

		// Compile all MacroTemplates onto pNode.Macro
		this.compileMacros(pNode, pValue, pOptions);

		// Select editable or read-only value macro
		pNode.Macro.Value = pOptions.Editable ? pNode.Macro.ValueStringEditable : pNode.Macro.ValueStringReadOnly;

		// Compose actions
		pNode.Macro.Actions = this.compileActions(pNode, pOptions);

		// Render via per-type template
		return this.pict.parseTemplate(
			this.pict.TemplateProvider.getTemplate('ObjectEditor-Node-String'),
			pNode,
			null,
			[this._ObjectEditorView]
		);
	}
}

module.exports = PictViewObjectEditorNodeString;

},{"./PictView-ObjectEditor-Node.js":156}],163:[function(require,module,exports){
const libPictView = require('pict-view');

const libNodeString = require('./PictView-ObjectEditor-NodeString.js');
const libNodeNumber = require('./PictView-ObjectEditor-NodeNumber.js');
const libNodeBoolean = require('./PictView-ObjectEditor-NodeBoolean.js');
const libNodeNull = require('./PictView-ObjectEditor-NodeNull.js');
const libNodeObject = require('./PictView-ObjectEditor-NodeObject.js');
const libNodeArray = require('./PictView-ObjectEditor-NodeArray.js');

const _DefaultConfiguration = require('../Pict-Section-ObjectEditor-DefaultConfiguration.js');

class PictViewObjectEditor extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		this.initialRenderComplete = false;

		// Set of expanded path strings
		this._ExpandedPaths = new Set();

		// Map of data type -> node renderer instance
		this._NodeRenderers = {};
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		// Register node type service types if they aren't already present
		let tmpNodeTypes =
		{
			'PictViewObjectEditorNodeString': libNodeString,
			'PictViewObjectEditorNodeNumber': libNodeNumber,
			'PictViewObjectEditorNodeBoolean': libNodeBoolean,
			'PictViewObjectEditorNodeNull': libNodeNull,
			'PictViewObjectEditorNodeObject': libNodeObject,
			'PictViewObjectEditorNodeArray': libNodeArray
		};

		let tmpNodeTypeKeys = Object.keys(tmpNodeTypes);
		for (let i = 0; i < tmpNodeTypeKeys.length; i++)
		{
			let tmpKey = tmpNodeTypeKeys[i];
			if (!this.fable.servicesMap.hasOwnProperty(tmpKey))
			{
				this.fable.addServiceType(tmpKey, tmpNodeTypes[tmpKey]);
			}
		}

		// Instantiate one renderer per data type
		this._NodeRenderers.string = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeString');
		this._NodeRenderers.number = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeNumber');
		this._NodeRenderers.boolean = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeBoolean');
		this._NodeRenderers.null = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeNull');
		this._NodeRenderers.object = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeObject');
		this._NodeRenderers.array = this.fable.instantiateServiceProviderWithoutRegistration('PictViewObjectEditorNodeArray');

		// Set back-references on each renderer
		let tmpRendererKeys = Object.keys(this._NodeRenderers);
		for (let i = 0; i < tmpRendererKeys.length; i++)
		{
			this._NodeRenderers[tmpRendererKeys[i]]._ObjectEditorView = this;
		}

		return super.onBeforeInitialize();
	}

	onAfterRender()
	{
		super.onAfterRender();

		// Ensure the CSS from all registered views is injected into the DOM
		this.pict.CSSMap.injectCSS();

		if (!this.initialRenderComplete)
		{
			this.initialRenderComplete = true;
			this.onAfterInitialRender();
		}

		// Always re-populate the tree after any render, since the container
		// template may have been re-rendered (e.g., by the application auto-render).
		this.renderTree();
	}

	onAfterInitialRender()
	{
		// Expand to the configured initial depth
		let tmpData = this._resolveObjectData();
		if (tmpData !== null && typeof tmpData === 'object')
		{
			this._expandToDepth(tmpData, '', 0, this.options.InitialExpandDepth);
		}
	}

	// --- Public API ---

	/**
	 * Toggle expand/collapse on a node path.
	 */
	toggleNode(pPath)
	{
		if (this._ExpandedPaths.has(pPath))
		{
			this._ExpandedPaths.delete(pPath);
		}
		else
		{
			this._ExpandedPaths.add(pPath);
		}
		this.renderTree();
	}

	/**
	 * Toggle a boolean value at a path.
	 */
	toggleBoolean(pPath)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}
		let tmpCurrentValue = this._getValueAtPath(tmpData, pPath);
		this._setValueAtPath(tmpData, pPath, !tmpCurrentValue);
		this.renderTree();
	}

	/**
	 * Begin inline editing of a leaf node.
	 */
	beginEdit(pPath, pType)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpCurrentValue = this._getValueAtPath(tmpData, pPath);
		let tmpRowElement = this._getTreeElement().querySelector(`[data-path="${pPath}"]`);
		if (!tmpRowElement)
		{
			return;
		}

		let tmpValueSpan = tmpRowElement.querySelector('.pict-oe-value');
		if (!tmpValueSpan)
		{
			return;
		}

		let tmpInputType = (pType === 'number') ? 'number' : 'text';
		let tmpInputValue = (tmpCurrentValue === null || tmpCurrentValue === undefined) ? '' : String(tmpCurrentValue);
		let tmpEscapedPath = tmpInputValue.replace(/"/g, '&quot;');

		let tmpInput = document.createElement('input');
		tmpInput.type = tmpInputType;
		tmpInput.className = 'pict-oe-value-input';
		tmpInput.value = tmpInputValue;

		let tmpSelf = this;
		let tmpCommit = function()
		{
			let tmpNewValue = tmpInput.value;
			if (pType === 'number')
			{
				tmpNewValue = Number(tmpNewValue);
				if (isNaN(tmpNewValue))
				{
					tmpNewValue = 0;
				}
			}
			tmpSelf._setValueAtPath(tmpData, pPath, tmpNewValue);
			tmpSelf.renderTree();
		};

		tmpInput.addEventListener('blur', tmpCommit);
		tmpInput.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpInput.blur();
			}
			else if (pEvent.key === 'Escape')
			{
				// Cancel edit, just re-render
				tmpInput.removeEventListener('blur', tmpCommit);
				tmpSelf.renderTree();
			}
		});

		tmpValueSpan.innerHTML = '';
		tmpValueSpan.appendChild(tmpInput);
		tmpInput.focus();
		tmpInput.select();
	}

	/**
	 * Set a value at a dot-path in the object data and re-render.
	 */
	setValueAtPath(pPath, pValue)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}
		this._setValueAtPath(tmpData, pPath, pValue);
		this.renderTree();
	}

	/**
	 * Expand all nodes to a given depth.
	 */
	expandToDepth(pDepth)
	{
		this._ExpandedPaths.clear();
		let tmpData = this._resolveObjectData();
		if (tmpData !== null && typeof tmpData === 'object')
		{
			this._expandToDepth(tmpData, '', 0, pDepth);
		}
		this.renderTree();
	}

	/**
	 * Expand all nodes in the tree.
	 */
	expandAll()
	{
		let tmpData = this._resolveObjectData();
		if (tmpData !== null && typeof tmpData === 'object')
		{
			this._expandToDepth(tmpData, '', 0, Infinity);
		}
		this.renderTree();
	}

	/**
	 * Collapse all nodes in the tree.
	 */
	collapseAll()
	{
		this._ExpandedPaths.clear();
		this.renderTree();
	}

	// --- Add/Remove API ---

	/**
	 * Add a property to an object at a given path.
	 */
	addObjectProperty(pPath, pKey, pDefaultValue)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (tmpTarget === null || tmpTarget === undefined || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpValue = (pDefaultValue !== undefined) ? pDefaultValue : '';
		tmpTarget[pKey] = tmpValue;

		// Auto-expand the parent so the new property is visible
		if (pPath)
		{
			this._ExpandedPaths.add(pPath);
		}

		this.renderTree();
	}

	/**
	 * Remove a property from an object at a given path.
	 */
	removeObjectProperty(pPath, pKey)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (tmpTarget === null || tmpTarget === undefined || typeof tmpTarget !== 'object' || Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpChildPath = pPath ? (pPath + '.' + pKey) : pKey;
		this._cleanupExpandedPaths(tmpChildPath);
		delete tmpTarget[pKey];

		this.renderTree();
	}

	/**
	 * Add an element to the end of an array at a given path.
	 */
	addArrayElement(pPath, pDefaultValue)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpValue = (pDefaultValue !== undefined) ? pDefaultValue : '';
		tmpTarget.push(tmpValue);

		// Auto-expand the parent so the new element is visible
		if (pPath)
		{
			this._ExpandedPaths.add(pPath);
		}

		this.renderTree();
	}

	/**
	 * Remove an element from an array at a given path by index.
	 */
	removeArrayElement(pPath, pIndex)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpIntIndex = parseInt(pIndex, 10);
		if (isNaN(tmpIntIndex) || tmpIntIndex < 0 || tmpIntIndex >= tmpTarget.length)
		{
			return;
		}

		// Clean up expanded paths for the removed element and shift higher indices
		let tmpRemovedPath = pPath ? (pPath + '[' + tmpIntIndex + ']') : ('[' + tmpIntIndex + ']');
		this._cleanupExpandedPaths(tmpRemovedPath);
		this._shiftArrayExpandedPaths(pPath, tmpIntIndex, tmpTarget.length);

		tmpTarget.splice(tmpIntIndex, 1);

		this.renderTree();
	}

	/**
	 * Remove a node from its parent, auto-detecting whether parent is object or array.
	 * Works by parsing the path to find the parent and key/index.
	 */
	removeNode(pPath)
	{
		if (!pPath)
		{
			return;
		}

		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		// Determine if the last segment is a bracket index or a dot key
		let tmpBracketMatch = pPath.match(/^(.*)\[(\d+)\]$/);
		if (tmpBracketMatch)
		{
			// Array element: parent path is the part before [N]
			let tmpParentPath = tmpBracketMatch[1];
			let tmpIndex = parseInt(tmpBracketMatch[2], 10);
			this.removeArrayElement(tmpParentPath, tmpIndex);
		}
		else
		{
			// Object property: parent path is everything before the last dot
			let tmpLastDot = pPath.lastIndexOf('.');
			if (tmpLastDot === -1)
			{
				// Top-level key — parent is root
				let tmpKey = pPath;
				this.removeObjectProperty('', tmpKey);
			}
			else
			{
				let tmpParentPath = pPath.substring(0, tmpLastDot);
				let tmpKey = pPath.substring(tmpLastDot + 1);
				this.removeObjectProperty(tmpParentPath, tmpKey);
			}
		}
	}

	// --- Array Reorder API ---

	/**
	 * Move an array element up by one position (swap with the element before it).
	 * If already at index 0 this is a no-op.
	 */
	moveArrayElementUp(pPath, pIndex)
	{
		let tmpIntIndex = parseInt(pIndex, 10);
		if (isNaN(tmpIntIndex) || tmpIntIndex <= 0)
		{
			return;
		}
		this.moveArrayElementToIndex(pPath, tmpIntIndex, tmpIntIndex - 1);
	}

	/**
	 * Move an array element down by one position (swap with the element after it).
	 * If already at the last index this is a no-op.
	 */
	moveArrayElementDown(pPath, pIndex)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpIntIndex = parseInt(pIndex, 10);
		if (isNaN(tmpIntIndex) || tmpIntIndex < 0 || tmpIntIndex >= tmpTarget.length - 1)
		{
			return;
		}
		this.moveArrayElementToIndex(pPath, tmpIntIndex, tmpIntIndex + 1);
	}

	/**
	 * Move an array element from one index to another.
	 * If pNewIndex is out of bounds it is clamped to [0, length-1].
	 */
	moveArrayElementToIndex(pPath, pFromIndex, pToIndex)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTarget = pPath ? this._getValueAtPath(tmpData, pPath) : tmpData;
		if (!Array.isArray(tmpTarget))
		{
			return;
		}

		let tmpFrom = parseInt(pFromIndex, 10);
		if (isNaN(tmpFrom) || tmpFrom < 0 || tmpFrom >= tmpTarget.length)
		{
			return;
		}

		let tmpTo = parseInt(pToIndex, 10);
		if (isNaN(tmpTo))
		{
			return;
		}
		// Clamp to valid range
		if (tmpTo < 0)
		{
			tmpTo = 0;
		}
		if (tmpTo >= tmpTarget.length)
		{
			tmpTo = tmpTarget.length - 1;
		}

		if (tmpFrom === tmpTo)
		{
			return;
		}

		// Update expanded paths before mutating the array
		this._moveArrayExpandedPaths(pPath, tmpFrom, tmpTo, tmpTarget.length);

		// Splice the element out and insert at the new position
		let tmpElement = tmpTarget.splice(tmpFrom, 1)[0];
		tmpTarget.splice(tmpTo, 0, tmpElement);

		this.renderTree();
	}

	/**
	 * Begin adding a new property to an object by showing an inline key input
	 * and a type selector dropdown.
	 */
	beginAddToObject(pPath)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTreeElement = this._getTreeElement();
		if (!tmpTreeElement)
		{
			return;
		}

		let tmpRowElement = tmpTreeElement.querySelector(`[data-path="${pPath}"]`);
		if (!tmpRowElement)
		{
			return;
		}

		// Create an inline input for the key name
		let tmpInput = document.createElement('input');
		tmpInput.type = 'text';
		tmpInput.className = 'pict-oe-key-input';
		tmpInput.placeholder = 'key';

		// Create a type selector dropdown
		let tmpSelect = this._createTypeSelect();

		let tmpSelf = this;
		let tmpCommitted = false;
		let tmpCommit = function()
		{
			if (tmpCommitted)
			{
				return;
			}
			tmpCommitted = true;
			let tmpKey = tmpInput.value.trim();
			if (tmpKey)
			{
				let tmpDefaultValue = tmpSelf._getDefaultValueForType(tmpSelect.value);
				tmpSelf.addObjectProperty(pPath, tmpKey, tmpDefaultValue);
			}
			else
			{
				tmpSelf.renderTree();
			}
		};

		tmpInput.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpCommit();
			}
			else if (pEvent.key === 'Escape')
			{
				tmpCommitted = true;
				tmpSelf.renderTree();
			}
		});

		tmpSelect.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpCommit();
			}
			else if (pEvent.key === 'Escape')
			{
				tmpCommitted = true;
				tmpSelf.renderTree();
			}
		});

		// Commit when focus leaves both elements
		let tmpBlurTimeout = null;
		let tmpHandleBlur = function()
		{
			clearTimeout(tmpBlurTimeout);
			tmpBlurTimeout = setTimeout(function()
			{
				// Check if focus moved to the other element in the pair
				if (document.activeElement !== tmpInput && document.activeElement !== tmpSelect)
				{
					tmpCommit();
				}
			}, 150);
		};

		tmpInput.addEventListener('blur', tmpHandleBlur);
		tmpSelect.addEventListener('blur', tmpHandleBlur);

		// Insert before the actions container
		let tmpActionsSpan = tmpRowElement.querySelector('.pict-oe-actions');
		if (tmpActionsSpan)
		{
			tmpRowElement.insertBefore(tmpInput, tmpActionsSpan);
			tmpRowElement.insertBefore(tmpSelect, tmpActionsSpan);
		}
		else
		{
			tmpRowElement.appendChild(tmpInput);
			tmpRowElement.appendChild(tmpSelect);
		}
		tmpInput.focus();
	}

	/**
	 * Begin adding a new element to an array by showing a type selector dropdown.
	 */
	beginAddToArray(pPath)
	{
		let tmpData = this._resolveObjectData();
		if (tmpData === null)
		{
			return;
		}

		let tmpTreeElement = this._getTreeElement();
		if (!tmpTreeElement)
		{
			return;
		}

		let tmpRowElement = tmpTreeElement.querySelector(`[data-path="${pPath}"]`);
		if (!tmpRowElement)
		{
			return;
		}

		// Create a type selector dropdown
		let tmpSelect = this._createTypeSelect();

		let tmpSelf = this;
		let tmpCommitted = false;
		let tmpCommit = function()
		{
			if (tmpCommitted)
			{
				return;
			}
			tmpCommitted = true;
			let tmpDefaultValue = tmpSelf._getDefaultValueForType(tmpSelect.value);
			tmpSelf.addArrayElement(pPath, tmpDefaultValue);
		};

		tmpSelect.addEventListener('keydown', function(pEvent)
		{
			if (pEvent.key === 'Enter')
			{
				tmpCommit();
			}
			else if (pEvent.key === 'Escape')
			{
				tmpCommitted = true;
				tmpSelf.renderTree();
			}
		});

		tmpSelect.addEventListener('blur', function()
		{
			setTimeout(function()
			{
				tmpCommit();
			}, 100);
		});

		// Insert before the actions container
		let tmpActionsSpan = tmpRowElement.querySelector('.pict-oe-actions');
		if (tmpActionsSpan)
		{
			tmpRowElement.insertBefore(tmpSelect, tmpActionsSpan);
		}
		else
		{
			tmpRowElement.appendChild(tmpSelect);
		}
		tmpSelect.focus();
	}

	/**
	 * Create a type selector <select> element for choosing the type of a new entry.
	 */
	_createTypeSelect()
	{
		let tmpSelect = document.createElement('select');
		tmpSelect.className = 'pict-oe-type-select';

		let tmpTypes = ['String', 'Number', 'Boolean', 'Null', 'Object', 'Array'];
		for (let i = 0; i < tmpTypes.length; i++)
		{
			let tmpOption = document.createElement('option');
			tmpOption.value = tmpTypes[i];
			tmpOption.textContent = tmpTypes[i];
			tmpSelect.appendChild(tmpOption);
		}

		return tmpSelect;
	}

	/**
	 * Return the default value for a given type name.
	 */
	_getDefaultValueForType(pTypeName)
	{
		switch (pTypeName)
		{
			case 'Number':
				return 0;
			case 'Boolean':
				return false;
			case 'Null':
				return null;
			case 'Object':
				return {};
			case 'Array':
				return [];
			case 'String':
			default:
				return '';
		}
	}

	// --- Marshal lifecycle ---

	marshalToView()
	{
		this.renderTree();
		return super.marshalToView();
	}

	// --- Tree rendering ---

	/**
	 * Render the visible tree into the container element.
	 */
	renderTree()
	{
		let tmpData = this._resolveObjectData();
		let tmpTreeElement = this._getTreeElement();
		if (!tmpTreeElement)
		{
			return;
		}

		if (tmpData === null || tmpData === undefined)
		{
			this.pict.ContentAssignment.assignContent(tmpTreeElement, '<div class="pict-oe-empty">No data</div>');
			return;
		}

		let tmpOptions =
		{
			Editable: this.options.Editable,
			ShowTypeIndicators: this.options.ShowTypeIndicators,
			IndentPixels: this.options.IndentPixels,
			ViewHash: this.Hash
		};

		let tmpHTML = '';

		if (typeof tmpData === 'object' && !Array.isArray(tmpData))
		{
			// Render top-level object keys without a root wrapper node
			tmpHTML = this._walkObject(tmpData, '', 0, tmpOptions, true);
			// Add a root-level "add property" button when editable
			if (tmpOptions.Editable)
			{
				tmpHTML += this.pict.parseTemplate(
					this.options.MacroTemplates.Node.RootAddObject,
					{},
					null,
					[this]
				);
			}
		}
		else if (Array.isArray(tmpData))
		{
			// Render top-level array elements without a root wrapper node
			tmpHTML = this._walkArray(tmpData, '', 0, tmpOptions, true);
			// Add a root-level "add element" button when editable
			if (tmpOptions.Editable)
			{
				tmpHTML += this.pict.parseTemplate(
					this.options.MacroTemplates.Node.RootAddArray,
					{},
					null,
					[this]
				);
			}
		}
		else
		{
			// Single primitive value at root
			let tmpNode =
			{
				Path: '',
				Key: '(root)',
				Depth: 0,
				DataType: this._getJsonType(tmpData),
				HasChildren: false,
				ChildCount: 0,
				IsExpanded: false,
				IsArrayElement: false,
				ArrayIndex: -1
			};
			let tmpRenderer = this._NodeRenderers[tmpNode.DataType];
			if (tmpRenderer)
			{
				tmpHTML = tmpRenderer.renderNodeHTML(tmpNode, tmpData, tmpOptions);
			}
		}

		if (!tmpHTML)
		{
			tmpHTML = '<div class="pict-oe-empty">Empty object</div>';
		}

		this.pict.ContentAssignment.assignContent(tmpTreeElement, tmpHTML);
	}

	// --- Internal tree walking ---

	_walkObject(pValue, pBasePath, pDepth, pOptions, pIsRoot)
	{
		let tmpHTML = '';
		let tmpKeys = Object.keys(pValue);

		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			let tmpChildPath = pBasePath ? (pBasePath + '.' + tmpKey) : tmpKey;
			let tmpChildValue = pValue[tmpKey];
			let tmpType = this._getJsonType(tmpChildValue);

			let tmpNode =
			{
				Path: tmpChildPath,
				Key: tmpKey,
				Depth: pDepth,
				DataType: tmpType,
				HasChildren: false,
				ChildCount: 0,
				IsExpanded: false,
				IsArrayElement: false,
				ArrayIndex: -1
			};

			if (tmpType === 'object')
			{
				let tmpChildKeys = (tmpChildValue !== null) ? Object.keys(tmpChildValue) : [];
				tmpNode.HasChildren = tmpChildKeys.length > 0;
				tmpNode.ChildCount = tmpChildKeys.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.object;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkObject(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else if (tmpType === 'array')
			{
				tmpNode.HasChildren = tmpChildValue.length > 0;
				tmpNode.ChildCount = tmpChildValue.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.array;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkArray(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else
			{
				let tmpRenderer = this._NodeRenderers[tmpType];
				if (tmpRenderer)
				{
					tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);
				}
			}
		}

		return tmpHTML;
	}

	_walkArray(pValue, pBasePath, pDepth, pOptions, pIsRoot)
	{
		let tmpHTML = '';

		for (let i = 0; i < pValue.length; i++)
		{
			let tmpChildPath = pBasePath ? (pBasePath + '[' + i + ']') : ('[' + i + ']');
			let tmpChildValue = pValue[i];
			let tmpType = this._getJsonType(tmpChildValue);

			let tmpNode =
			{
				Path: tmpChildPath,
				Key: String(i),
				Depth: pDepth,
				DataType: tmpType,
				HasChildren: false,
				ChildCount: 0,
				IsExpanded: false,
				IsArrayElement: true,
				ArrayIndex: i
			};

			if (tmpType === 'object')
			{
				let tmpChildKeys = (tmpChildValue !== null) ? Object.keys(tmpChildValue) : [];
				tmpNode.HasChildren = tmpChildKeys.length > 0;
				tmpNode.ChildCount = tmpChildKeys.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.object;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkObject(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else if (tmpType === 'array')
			{
				tmpNode.HasChildren = tmpChildValue.length > 0;
				tmpNode.ChildCount = tmpChildValue.length;
				tmpNode.IsExpanded = this._ExpandedPaths.has(tmpChildPath);

				let tmpRenderer = this._NodeRenderers.array;
				tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);

				if (tmpNode.IsExpanded)
				{
					tmpHTML += this._walkArray(tmpChildValue, tmpChildPath, pDepth + 1, pOptions, false);
				}
			}
			else
			{
				let tmpRenderer = this._NodeRenderers[tmpType];
				if (tmpRenderer)
				{
					tmpHTML += tmpRenderer.renderNodeHTML(tmpNode, tmpChildValue, pOptions);
				}
			}
		}

		return tmpHTML;
	}

	// --- Utility methods ---

	_getJsonType(pValue)
	{
		if (pValue === null || pValue === undefined)
		{
			return 'null';
		}
		if (Array.isArray(pValue))
		{
			return 'array';
		}
		let tmpType = typeof pValue;
		if (tmpType === 'object')
		{
			return 'object';
		}
		if (tmpType === 'number')
		{
			return 'number';
		}
		if (tmpType === 'boolean')
		{
			return 'boolean';
		}
		return 'string';
	}

	_resolveObjectData()
	{
		if (!this.options.ObjectDataAddress)
		{
			return null;
		}

		// Support "AppData.SomeKey" style addresses
		let tmpAddress = this.options.ObjectDataAddress;
		let tmpParts = tmpAddress.split('.');
		let tmpCurrent = this.fable;

		for (let i = 0; i < tmpParts.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return null;
			}
			tmpCurrent = tmpCurrent[tmpParts[i]];
		}

		return tmpCurrent;
	}

	_getTreeElement()
	{
		let tmpElementId = 'ObjectEditor-Tree-' + this.Hash;
		let tmpElements = this.pict.ContentAssignment.getElement('#' + tmpElementId);
		if (tmpElements && tmpElements.length > 0)
		{
			return tmpElements[0];
		}
		return null;
	}

	_getValueAtPath(pObject, pPath)
	{
		if (!pPath)
		{
			return pObject;
		}

		let tmpSegments = this._parsePath(pPath);
		let tmpCurrent = pObject;

		for (let i = 0; i < tmpSegments.length; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return undefined;
			}
			tmpCurrent = tmpCurrent[tmpSegments[i]];
		}

		return tmpCurrent;
	}

	_setValueAtPath(pObject, pPath, pValue)
	{
		if (!pPath)
		{
			return;
		}

		let tmpSegments = this._parsePath(pPath);
		let tmpCurrent = pObject;

		for (let i = 0; i < tmpSegments.length - 1; i++)
		{
			if (tmpCurrent === null || tmpCurrent === undefined)
			{
				return;
			}
			tmpCurrent = tmpCurrent[tmpSegments[i]];
		}

		if (tmpCurrent !== null && tmpCurrent !== undefined)
		{
			tmpCurrent[tmpSegments[tmpSegments.length - 1]] = pValue;
		}
	}

	/**
	 * Parse a dotted path with bracket notation into segments.
	 * e.g., "config.items[2].name" -> ["config", "items", 2, "name"]
	 */
	_parsePath(pPath)
	{
		let tmpSegments = [];
		let tmpParts = pPath.split('.');

		for (let i = 0; i < tmpParts.length; i++)
		{
			let tmpPart = tmpParts[i];
			// Check for bracket notation
			let tmpBracketMatch = tmpPart.match(/^([^\[]*)\[(\d+)\]$/);
			if (tmpBracketMatch)
			{
				if (tmpBracketMatch[1])
				{
					tmpSegments.push(tmpBracketMatch[1]);
				}
				tmpSegments.push(parseInt(tmpBracketMatch[2], 10));
			}
			else if (tmpPart)
			{
				tmpSegments.push(tmpPart);
			}
		}

		return tmpSegments;
	}

	/**
	 * Remove all expanded paths that reference a deleted subtree.
	 */
	_cleanupExpandedPaths(pRemovedPath)
	{
		let tmpToRemove = [];
		this._ExpandedPaths.forEach(function(tmpPath)
		{
			if (tmpPath === pRemovedPath || tmpPath.indexOf(pRemovedPath + '.') === 0 || tmpPath.indexOf(pRemovedPath + '[') === 0)
			{
				tmpToRemove.push(tmpPath);
			}
		});

		for (let i = 0; i < tmpToRemove.length; i++)
		{
			this._ExpandedPaths.delete(tmpToRemove[i]);
		}
	}

	/**
	 * After removing an array element, shift expanded paths for higher indices down by one.
	 * e.g., if we removed items[2], then items[3] becomes items[2], items[4] becomes items[3], etc.
	 */
	_shiftArrayExpandedPaths(pArrayPath, pRemovedIndex, pOriginalLength)
	{
		let tmpPrefix = pArrayPath ? pArrayPath : '';

		for (let i = pRemovedIndex + 1; i < pOriginalLength; i++)
		{
			let tmpOldPath = tmpPrefix + '[' + i + ']';
			let tmpNewPath = tmpPrefix + '[' + (i - 1) + ']';

			// Collect all expanded paths that start with the old path
			let tmpToRename = [];
			this._ExpandedPaths.forEach(function(tmpPath)
			{
				if (tmpPath === tmpOldPath)
				{
					tmpToRename.push({ old: tmpPath, replacement: tmpNewPath });
				}
				else if (tmpPath.indexOf(tmpOldPath + '.') === 0)
				{
					tmpToRename.push({ old: tmpPath, replacement: tmpNewPath + tmpPath.substring(tmpOldPath.length) });
				}
				else if (tmpPath.indexOf(tmpOldPath + '[') === 0)
				{
					tmpToRename.push({ old: tmpPath, replacement: tmpNewPath + tmpPath.substring(tmpOldPath.length) });
				}
			});

			for (let j = 0; j < tmpToRename.length; j++)
			{
				this._ExpandedPaths.delete(tmpToRename[j].old);
				this._ExpandedPaths.add(tmpToRename[j].replacement);
			}
		}
	}

	/**
	 * Update expanded paths when an array element moves from one index to another.
	 * Works by collecting all paths for every index in the affected range,
	 * then remapping them to their new positions.
	 */
	_moveArrayExpandedPaths(pArrayPath, pFromIndex, pToIndex, pLength)
	{
		let tmpPrefix = pArrayPath ? pArrayPath : '';

		// Determine the range of indices affected by the move
		let tmpMinIndex = Math.min(pFromIndex, pToIndex);
		let tmpMaxIndex = Math.max(pFromIndex, pToIndex);

		// Collect all expanded paths for every index in the affected range
		// Map: index -> array of { suffix } (the part after the [N])
		let tmpPathsByIndex = {};
		for (let i = tmpMinIndex; i <= tmpMaxIndex; i++)
		{
			tmpPathsByIndex[i] = [];
		}

		let tmpToRemove = [];
		let tmpSelf = this;

		this._ExpandedPaths.forEach(function(tmpPath)
		{
			for (let i = tmpMinIndex; i <= tmpMaxIndex; i++)
			{
				let tmpIndexPath = tmpPrefix + '[' + i + ']';
				if (tmpPath === tmpIndexPath)
				{
					tmpPathsByIndex[i].push('');
					tmpToRemove.push(tmpPath);
				}
				else if (tmpPath.indexOf(tmpIndexPath + '.') === 0)
				{
					tmpPathsByIndex[i].push(tmpPath.substring(tmpIndexPath.length));
					tmpToRemove.push(tmpPath);
				}
				else if (tmpPath.indexOf(tmpIndexPath + '[') === 0)
				{
					tmpPathsByIndex[i].push(tmpPath.substring(tmpIndexPath.length));
					tmpToRemove.push(tmpPath);
				}
			}
		});

		// Remove old paths
		for (let i = 0; i < tmpToRemove.length; i++)
		{
			this._ExpandedPaths.delete(tmpToRemove[i]);
		}

		// Compute new index mapping:
		// When moving from -> to, the element at pFromIndex goes to pToIndex,
		// and all elements between shift by 1 in the opposite direction.
		let tmpNewIndexMap = {};
		if (pFromIndex < pToIndex)
		{
			// Moving forward: elements between (from+1..to) shift down by 1
			tmpNewIndexMap[pFromIndex] = pToIndex;
			for (let i = pFromIndex + 1; i <= pToIndex; i++)
			{
				tmpNewIndexMap[i] = i - 1;
			}
		}
		else
		{
			// Moving backward: elements between (to..from-1) shift up by 1
			tmpNewIndexMap[pFromIndex] = pToIndex;
			for (let i = pToIndex; i < pFromIndex; i++)
			{
				tmpNewIndexMap[i] = i + 1;
			}
		}

		// Re-add paths at their new indices
		let tmpOldIndices = Object.keys(tmpPathsByIndex);
		for (let i = 0; i < tmpOldIndices.length; i++)
		{
			let tmpOldIndex = parseInt(tmpOldIndices[i], 10);
			let tmpNewIndex = tmpNewIndexMap[tmpOldIndex];
			let tmpSuffixes = tmpPathsByIndex[tmpOldIndex];
			for (let j = 0; j < tmpSuffixes.length; j++)
			{
				this._ExpandedPaths.add(tmpPrefix + '[' + tmpNewIndex + ']' + tmpSuffixes[j]);
			}
		}
	}

	/**
	 * Recursively expand paths up to a given depth.
	 */
	_expandToDepth(pValue, pBasePath, pCurrentDepth, pMaxDepth)
	{
		if (pValue === null || pValue === undefined || typeof pValue !== 'object')
		{
			return;
		}

		if (Array.isArray(pValue))
		{
			for (let i = 0; i < pValue.length; i++)
			{
				let tmpChildPath = pBasePath ? (pBasePath + '[' + i + ']') : ('[' + i + ']');
				if (typeof pValue[i] === 'object' && pValue[i] !== null)
				{
					// Mark this child as expanded (it's an object or array that can be toggled)
					this._ExpandedPaths.add(tmpChildPath);
					if (pCurrentDepth + 1 < pMaxDepth)
					{
						this._expandToDepth(pValue[i], tmpChildPath, pCurrentDepth + 1, pMaxDepth);
					}
				}
			}
		}
		else
		{
			let tmpKeys = Object.keys(pValue);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpKey = tmpKeys[i];
				let tmpChildPath = pBasePath ? (pBasePath + '.' + tmpKey) : tmpKey;
				let tmpChildValue = pValue[tmpKey];
				if (typeof tmpChildValue === 'object' && tmpChildValue !== null)
				{
					// Mark this child as expanded (it's an object or array that can be toggled)
					this._ExpandedPaths.add(tmpChildPath);
					if (pCurrentDepth + 1 < pMaxDepth)
					{
						this._expandToDepth(tmpChildValue, tmpChildPath, pCurrentDepth + 1, pMaxDepth);
					}
				}
			}
		}
	}
}

module.exports = PictViewObjectEditor;

module.exports.default_configuration = _DefaultConfiguration;

},{"../Pict-Section-ObjectEditor-DefaultConfiguration.js":154,"./PictView-ObjectEditor-NodeArray.js":157,"./PictView-ObjectEditor-NodeBoolean.js":158,"./PictView-ObjectEditor-NodeNull.js":159,"./PictView-ObjectEditor-NodeNumber.js":160,"./PictView-ObjectEditor-NodeObject.js":161,"./PictView-ObjectEditor-NodeString.js":162,"pict-view":239}],164:[function(require,module,exports){
/**
 * pict-section-theme — entry point.
 *
 * Bundles every Retold-ecosystem theme and exposes five reusable views:
 *
 *   - Theme-Picker      : a custom dropdown listing every registered theme,
 *                         grouped by category, with inline SVG mode-glyphs.
 *                         Switches the active theme on change.
 *   - Theme-ModeToggle  : a 3-button toggle for Light / Dark / System mode.
 *                         Disables itself when the active theme is single-mode.
 *   - Theme-ScaleSelect : a dropdown of viewport scale presets (75% – 200%).
 *                         Independent of theme bundles — applied via CSS
 *                         `zoom` on <html> + a `--theme-scale` custom prop.
 *   - Theme-Button      : an embeddable SVG topbar button that, when clicked,
 *                         opens a pict-section-modal containing the picker,
 *                         the mode toggle, and the scale select. Designed to
 *                         drop into any application chrome.
 *   - Theme-BrandStrip  : the per-app brand signature (icon + name + two
 *                         color stripes). Driven by libThemeBrand which the
 *                         host configures via the `Brand` option.
 *
 * # Recommended consumption (Pict provider)
 *
 * Add the section as a Pict provider — it self-bootstraps on construction:
 *
 *     const libPictSectionTheme = require('pict-section-theme');
 *
 *     pict.addProvider('Theme-Section',
 *     {
 *         ApplyDefault: 'retold-default',
 *         DefaultMode:  'system',
 *         DefaultScale: 1.0,
 *         Brand:        libRetoldManagerBrand
 *     }, libPictSectionTheme);
 *
 * That single addProvider call:
 *   - Ensures `pict.providers.Theme` (the underlying pict-provider-theme
 *     runtime) exists.
 *   - Registers every theme in the runtime registry — bundled starter set
 *     plus anything the host registered via `Catalog.register()`.
 *   - Adds Theme-Picker / Theme-ModeToggle / Theme-ScaleSelect /
 *     Theme-Button / Theme-BrandStrip to `pict.views[...]`.
 *   - Hydrates persisted choices from localStorage; otherwise applies the
 *     supplied `ApplyDefault` / `DefaultMode` / `DefaultScale`.
 *   - Wires the `onApply` save handler so subsequent user picks persist.
 *   - Applies the supplied Brand block if one was provided.
 *
 * # Runtime theme registration
 *
 * The bundled starter set lives in `themes/_catalog.js`. To add custom
 * themes (e.g. a host app's own brand palette, or a remote bundle from
 * a "theme garden") use the registry:
 *
 *     const libCatalog = require('pict-section-theme').Catalog;
 *     libCatalog.register({ Hash: 'my-theme', Bundle: require('./mine.json'), Category: 'App' });
 *     // Or, async, from a URL:
 *     await libCatalog.registerFromURL('https://garden.example.com/themes/foo.json');
 *
 * Themes registered before `addProvider()` runs are picked up
 * automatically. Themes registered after must be manually pushed via
 * `pict.providers.Theme.registerTheme(bundle)`.
 *
 * # Persistence
 *
 * Persisting active theme + mode + scale to localStorage is on by
 * default. Storage key is scoped to `window.location.hostname` so apps
 * on different hosts keep independent state. Override with
 * `PersistenceKey: 'my-app'`. Pass `Persistence: false` to disable.
 *
 * A saved entry takes precedence over `ApplyDefault` — once a user has
 * picked a theme, reloads honour that pick instead of the host's
 * default. If the saved theme hash is no longer in the registry (theme
 * removed, app downgraded), the bootstrap falls back to `ApplyDefault`
 * cleanly.
 *
 * # Legacy API
 *
 * `install(pict, options)` and `registerCatalog(pict)` are still
 * exported as thin shims that delegate to the provider — existing apps
 * keep working without changes.
 */

'use strict';

const libPictProvider = require('pict-provider');
const libPictProviderTheme = require('pict-provider-theme');

const libPickerView = require('./views/PictView-Theme-Picker.js');
const libModeToggleView = require('./views/PictView-Theme-ModeToggle.js');
const libScaleSelectView = require('./views/PictView-Theme-ScaleSelect.js');
const libButtonView = require('./views/PictView-Theme-Button.js');
const libBrandStripView = require('./views/PictView-Theme-BrandStrip.js');
const libBrandMarkView = require('./views/PictView-Theme-Brand-Mark.js');
const libTopBarView = require('./views/PictView-Theme-TopBar.js');
const libBottomBarView = require('./views/PictView-Theme-BottomBar.js');

const libThemePersistence = require('./Theme-Persistence.js');
const libThemeScale = require('./Theme-Scale.js');
const libThemeBrand = require('./Theme-Brand.js');
// Theme-Logo (the deterministic name → SVG generator) is intentionally
// NOT required here. It's a build-time tool used by
// `pict-section-theme-brand` to precompute brand blocks into a host's
// package.json — there's no reason for it to ride along in the runtime
// bundle every host ships. Hosts that want runtime generation can
// `require('pict-section-theme/source/Theme-Logo.js')` directly; that
// keeps the import explicit and the cost opt-in.

const libCatalog = require('./themes/_catalog.js');

// View registry: short-name → { lib, hash } where hash is the
// ViewIdentifier the view registers under in pict.views[...].
const _Views =
{
	Picker:      { lib: libPickerView,      hash: 'Theme-Picker' },
	ModeToggle:  { lib: libModeToggleView,  hash: 'Theme-ModeToggle' },
	ScaleSelect: { lib: libScaleSelectView, hash: 'Theme-ScaleSelect' },
	Button:      { lib: libButtonView,      hash: 'Theme-Button' },
	BrandStrip:  { lib: libBrandStripView,  hash: 'Theme-BrandStrip' },
	BrandMark:   { lib: libBrandMarkView,   hash: 'Theme-Brand-Mark' },
	TopBar:      { lib: libTopBarView,      hash: 'Theme-TopBar' },
	BottomBar:   { lib: libBottomBarView,   hash: 'Theme-BottomBar' }
};

const _ProviderConfiguration =
{
	ProviderIdentifier: 'Theme-Section',

	// Don't auto-fire the standard pict-provider initialize chain — we do
	// our setup work synchronously in the constructor so consumers can
	// use the views immediately after addProvider() returns.
	AutoInitialize: false,

	// Bootstrap config — same shape as the legacy install() options.
	ApplyDefault:    null,    // theme hash to apply at boot
	DefaultMode:     null,    // 'light' | 'dark' | 'system' | null (theme's default)
	DefaultScale:    null,    // 0.75 .. 2.0 — viewport scale
	Persistence:     true,
	PersistenceKey:  null,    // null → window.location.hostname
	RegisterCatalog: true,
	Views:           null,    // null → all views; or array of short-names
	ViewOptions:     null,    // { Picker: { ... }, ... } per-view overrides
	Brand:           null,    // { Name, Icon, Colors: { Primary, ... } }
	ProviderOptions: null     // pict-provider-theme overrides if a host wants them
};

// ── Helpers ──────────────────────────────────────────────────────────────

/**
 * Iterate the runtime registry and call provider.registerTheme() for each
 * entry. Safe to call before or after addProvider — the runtime's
 * registerTheme is idempotent on repeat hashes.
 *
 * @param {object} pPict - a Pict instance with the Theme runtime attached
 * @returns {number} count of themes registered
 */
function registerCatalog(pPict)
{
	if (!pPict || !pPict.providers || !pPict.providers.Theme)
	{
		if (pPict && pPict.log && pPict.log.warn)
		{
			pPict.log.warn('pict-section-theme.registerCatalog: pict.providers.Theme not found — register the runtime first');
		}
		return 0;
	}
	let tmpProvider = pPict.providers.Theme;
	let tmpEntries = libCatalog.list();
	let tmpCount = 0;
	for (let i = 0; i < tmpEntries.length; i++)
	{
		if (tmpProvider.registerTheme(tmpEntries[i].Bundle))
		{
			tmpCount++;
		}
	}
	return tmpCount;
}

/**
 * Return the registry as picker-friendly metadata (no Bundle payload).
 *
 * @returns {Array<{Hash, Name, Category, Strategy, DefaultMode, IsDefault}>}
 */
function listCatalog()
{
	let tmpEntries = libCatalog.list();
	let tmpList = [];
	for (let i = 0; i < tmpEntries.length; i++)
	{
		let tmpEntry = tmpEntries[i];
		let tmpBundle = tmpEntry.Bundle || {};
		let tmpModes = tmpBundle.Modes || {};
		tmpList.push(
		{
			Hash: tmpEntry.Hash,
			Name: tmpBundle.Name || tmpEntry.Hash,
			Category: tmpEntry.Category || 'Other',
			Strategy: tmpModes.Strategy || 'single',
			DefaultMode: tmpModes.Default || 'light',
			IsDefault: !!tmpEntry.IsDefault
		});
	}
	return tmpList;
}

// Resolve the canonical fallback theme hash from the catalog: the entry
// flagged IsDefault, or — if no entry is flagged — the first registered
// entry, or null if the catalog is empty. Used as the last-resort boot
// theme when nothing else resolved (no ApplyDefault, no saved state, or
// a saved hash that's been removed from the catalog).
function _resolveCatalogDefault()
{
	let tmpEntries = libCatalog.list();
	if (!tmpEntries || tmpEntries.length === 0) return null;
	for (let i = 0; i < tmpEntries.length; i++)
	{
		if (tmpEntries[i].IsDefault) return tmpEntries[i].Hash;
	}
	return tmpEntries[0].Hash;
}

// ── Bootstrap routine ────────────────────────────────────────────────────
// Shared between the provider class (new path) and the install() function
// (legacy path). Performs the actual wiring against a Pict instance.
function _bootstrap(pPict, pOptions)
{
	if (!pPict || typeof pPict.addProvider !== 'function')
	{
		throw new Error('pict-section-theme: requires a Pict instance');
	}
	let tmpOptions = pOptions || {};

	// 1. Theme runtime — only add if not already attached (hosts with
	//    a custom runtime, e.g. retold-remote's V2 bridge, pre-register).
	if (!pPict.providers || !pPict.providers.Theme)
	{
		let tmpRuntimeOpts = Object.assign({},
			libPictProviderTheme.default_configuration, tmpOptions.ProviderOptions || {});
		pPict.addProvider('Theme', tmpRuntimeOpts, libPictProviderTheme);
	}

	// 2. Catalog — every entry from the runtime registry, unless the host
	//    asked to skip (RegisterCatalog: false).
	if (tmpOptions.RegisterCatalog !== false)
	{
		registerCatalog(pPict);
	}

	// 3. Views — default all five; pass an array to subset.
	let tmpViewNames = Array.isArray(tmpOptions.Views) ? tmpOptions.Views : Object.keys(_Views);
	for (let i = 0; i < tmpViewNames.length; i++)
	{
		let tmpEntry = _Views[tmpViewNames[i]];
		if (!tmpEntry)
		{
			if (pPict.log && pPict.log.warn)
			{
				pPict.log.warn('pict-section-theme: unknown view name "' + tmpViewNames[i] + '" — skipped');
			}
			continue;
		}
		if (pPict.views && pPict.views[tmpEntry.hash])
		{
			// Already registered — skip silently.
			continue;
		}
		let tmpViewOpts = Object.assign({},
			tmpEntry.lib.default_configuration,
			(tmpOptions.ViewOptions && tmpOptions.ViewOptions[tmpViewNames[i]]) || {});
		pPict.addView(tmpEntry.hash, tmpViewOpts, tmpEntry.lib);
	}

	// 4. Persistence + initial apply.
	let tmpProvider = pPict.providers.Theme;
	let tmpPersistenceEnabled = (tmpOptions.Persistence !== false);
	let tmpPersistenceKey = null;

	let tmpBootHash  = tmpOptions.ApplyDefault || null;
	let tmpBootMode  = tmpOptions.DefaultMode  || null;
	let tmpBootScale = (typeof tmpOptions.DefaultScale === 'number') ? tmpOptions.DefaultScale : null;

	if (tmpPersistenceEnabled && tmpProvider)
	{
		tmpPersistenceKey = libThemePersistence.resolveKey(tmpOptions.PersistenceKey);

		let tmpSaved = libThemePersistence.load(tmpPersistenceKey);
		if (tmpSaved
			&& tmpSaved.ThemeHash
			&& typeof tmpProvider.getTheme === 'function'
			&& tmpProvider.getTheme(tmpSaved.ThemeHash))
		{
			tmpBootHash = tmpSaved.ThemeHash;
			if (tmpSaved.Mode)  { tmpBootMode  = tmpSaved.Mode; }
			if (tmpSaved.Scale) { tmpBootScale = tmpSaved.Scale; }
		}
		else if (tmpSaved && tmpSaved.Scale)
		{
			tmpBootScale = tmpSaved.Scale;
		}

		// Single save snapshot — both the provider listener and the scale
		// listener call this so any change persists the full set.
		let tmpSaveCurrent = function ()
		{
			let tmpActive = (typeof tmpProvider.getActiveTheme === 'function')
				? tmpProvider.getActiveTheme() : { Hash: null, Mode: null };
			libThemePersistence.save(tmpPersistenceKey,
			{
				ThemeHash: tmpActive.Hash,
				Mode:      tmpActive.Mode,
				Scale:     libThemeScale.getActive()
			});
		};

		tmpProvider.onApply(tmpSaveCurrent);
		libThemeScale.onChange(tmpSaveCurrent);
	}

	// If nothing resolved a theme hash (no ApplyDefault, no saved state, or
	// a saved hash that's no longer in the registry), fall back to the
	// catalog's canonical default (IsDefault: true) so the host always
	// boots with CSS variables populated. Without this fallback an app
	// configured without ApplyDefault — or one whose ApplyDefault hash
	// was removed — paints unstyled (token references resolve to their
	// inline fallback colors, which are intentionally bland) until the
	// user manually picks something from the picker.
	if (tmpProvider && (!tmpBootHash || (typeof tmpProvider.getTheme === 'function' && !tmpProvider.getTheme(tmpBootHash))))
	{
		let tmpFallback = _resolveCatalogDefault();
		if (tmpFallback)
		{
			tmpBootHash = tmpFallback;
			if (pPict.log && pPict.log.info)
			{
				pPict.log.info('pict-section-theme: no theme resolved at boot — falling back to catalog default "' + tmpFallback + '"');
			}
		}
	}

	if (tmpBootHash && tmpProvider)
	{
		tmpProvider.applyTheme(tmpBootHash, tmpBootMode);
	}
	if (tmpBootScale !== null)
	{
		libThemeScale.applyScale(tmpBootScale);
	}

	// 5. Brand — host-supplied app identity. Apply LAST so the BrandStrip
	//    view's first paint sees the CSS custom properties.
	if (tmpOptions.Brand)
	{
		libThemeBrand.applyBrand(tmpOptions.Brand);
	}

	// Stash the resolved key on the provider for debugging + so the host
	// can clear it via clearPersistence() for a "reset to defaults"
	// affordance.
	if (tmpProvider && tmpPersistenceKey)
	{
		tmpProvider._persistenceKey = tmpPersistenceKey;
	}

	return tmpProvider;
}

// ── PictProvider class ───────────────────────────────────────────────────
// The recommended entry point. `pict.addProvider('Theme-Section',
// options, PictSectionThemeProvider)` self-bootstraps the whole module
// (runtime + catalog + views + persistence + apply + brand) inside the
// constructor — no follow-up install() call required.
class PictSectionThemeProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'PictSectionTheme';

		// pict-provider sets `this.pict` for us via super() above. Run the
		// bootstrap synchronously so the views, theme runtime, and applied
		// theme are all in place before addProvider() returns.
		_bootstrap(this.pict, this.options);
	}

	/**
	 * Embed theme controls into a host-supplied container.
	 *
	 * The Theme-Button view ships a popover that hosts the picker + mode
	 * toggle + scale select — convenient for "drop a theme menu in the
	 * topbar" but not for apps that already have a settings surface and
	 * want the controls inline there. `mount()` writes the destination
	 * divs each theme view expects into the supplied container, then
	 * calls render() on each requested view.
	 *
	 * Important: each theme view has a SINGLE default destination id
	 * (e.g. `#Theme-Picker`). Mounting overrides where the view paints —
	 * once mount() is called, the picker / toggle / scale destinations
	 * live inside the supplied container. Combining a mount() with a
	 * Theme-Button popover that ALSO hosts these views causes duplicate
	 * destination ids and undefined behaviour; pick one host per view.
	 *
	 * @param {object} pOptions
	 * @param {string|HTMLElement} pOptions.Container - CSS selector or element
	 * @param {Array<string>} [pOptions.Views] - short names; default ['Picker','ModeToggle','ScaleSelect']
	 * @param {string} [pOptions.WrapperClass] - class added to the outer wrapper div
	 * @returns {object|null} { container, viewsRendered } on success, null if the container can't be resolved
	 */
	mount(pOptions)
	{
		let tmpOpts = pOptions || {};
		let tmpContainer = tmpOpts.Container;
		if (!tmpContainer) { return null; }
		let tmpEl = (typeof tmpContainer === 'string')
			? (this.pict && this.pict.ContentAssignment
				? this.pict.ContentAssignment.getElement(tmpContainer)
				: document.querySelector(tmpContainer))
			: tmpContainer;
		// ContentAssignment.getElement returns an array-like; normalise to one node.
		if (tmpEl && tmpEl.length && !tmpEl.tagName) { tmpEl = tmpEl[0]; }
		if (!tmpEl)
		{
			if (this.pict && this.pict.log && this.pict.log.warn)
			{
				this.pict.log.warn('pict-section-theme.mount: container not found for ' + tmpContainer);
			}
			return null;
		}

		let tmpRequested = Array.isArray(tmpOpts.Views) && tmpOpts.Views.length
			? tmpOpts.Views
			: ['Picker', 'ModeToggle', 'ScaleSelect'];

		// Build a wrapper that carries one row per requested view; each row
		// contains the destination div the view's render() will write into.
		let tmpRows = [];
		let tmpRendered = [];
		for (let i = 0; i < tmpRequested.length; i++)
		{
			let tmpEntry = _Views[tmpRequested[i]];
			if (!tmpEntry) { continue; }
			let tmpDestSel = tmpEntry.lib.default_configuration.DefaultDestinationAddress || '';
			let tmpDestId = tmpDestSel.replace(/^#/, '');
			if (!tmpDestId) { continue; }
			tmpRows.push(
				'<div class="pict-theme-mount-row pict-theme-mount-row-' + tmpEntry.hash.toLowerCase() + '">'
					+ '<div id="' + tmpDestId + '"></div>'
				+ '</div>');
			tmpRendered.push(tmpEntry.hash);
		}

		let tmpWrapperClass = 'pict-theme-mount' + (tmpOpts.WrapperClass ? ' ' + tmpOpts.WrapperClass : '');
		tmpEl.innerHTML = '<div class="' + tmpWrapperClass + '">' + tmpRows.join('') + '</div>';

		// Render each requested view. Each render() targets the destination
		// id we just stamped into the wrapper.
		for (let i = 0; i < tmpRendered.length; i++)
		{
			let tmpView = this.pict.views[tmpRendered[i]];
			if (tmpView && typeof tmpView.render === 'function')
			{
				try { tmpView.render(); }
				catch (pErr) { /* a view render failure shouldn't break the host */ }
			}
		}

		return { container: tmpEl, viewsRendered: tmpRendered };
	}
}

// ── Legacy install() ─────────────────────────────────────────────────────
// Thin shim for apps that already call install(); delegates to the same
// bootstrap routine the provider runs.
function install(pPict, pOptions)
{
	if (!pPict || typeof pPict.addProvider !== 'function')
	{
		throw new Error('pict-section-theme.install: first arg must be a Pict instance');
	}
	return _bootstrap(pPict, pOptions || {});
}

/**
 * Drop the saved theme state for this app's storage key. The next
 * install() (or page reload / addProvider) falls back to ApplyDefault.
 *
 * @param {object} pPict - the pict instance
 * @returns {boolean} true if anything was cleared
 */
function clearPersistence(pPict)
{
	let tmpKey = (pPict && pPict.providers && pPict.providers.Theme && pPict.providers.Theme._persistenceKey)
		|| libThemePersistence.resolveKey(null);
	return libThemePersistence.clear(tmpKey);
}

// ── Exports ──────────────────────────────────────────────────────────────
// Default export = the provider class so apps can do:
//   pict.addProvider('Theme-Section', { ... }, libPictSectionTheme);
//
// Named exports preserved so legacy callers keep working unchanged.
module.exports = PictSectionThemeProvider;
module.exports.default_configuration = _ProviderConfiguration;

module.exports.Provider = libPictProviderTheme;             // the runtime class
module.exports.PictSectionThemeProvider = PictSectionThemeProvider;
module.exports.PickerView = libPickerView;
module.exports.ModeToggleView = libModeToggleView;
module.exports.ButtonView = libButtonView;
module.exports.ScaleSelectView = libScaleSelectView;
module.exports.BrandStripView = libBrandStripView;
module.exports.BrandMarkView = libBrandMarkView;
module.exports.TopBarView = libTopBarView;
module.exports.BottomBarView = libBottomBarView;
module.exports.Catalog = libCatalog;                        // the registry singleton
module.exports.Brand = libThemeBrand;                       // the brand helper module
module.exports.Scale = libThemeScale;                       // the scale helper module
module.exports.Persistence = libThemePersistence;           // the persistence helper module
// Theme-Logo is exposed as a sub-module path, not a top-level field —
// see the comment near the imports above.
module.exports.registerCatalog = registerCatalog;
module.exports.listCatalog = listCatalog;
module.exports.install = install;
module.exports.clearPersistence = clearPersistence;

},{"./Theme-Brand.js":165,"./Theme-Persistence.js":167,"./Theme-Scale.js":168,"./themes/_catalog.js":172,"./views/PictView-Theme-BottomBar.js":214,"./views/PictView-Theme-Brand-Mark.js":215,"./views/PictView-Theme-BrandStrip.js":216,"./views/PictView-Theme-Button.js":217,"./views/PictView-Theme-ModeToggle.js":218,"./views/PictView-Theme-Picker.js":219,"./views/PictView-Theme-ScaleSelect.js":220,"./views/PictView-Theme-TopBar.js":221,"pict-provider":19,"pict-provider-theme":12}],165:[function(require,module,exports){
/**
 * Theme-Brand — app-level brand identity (icon + colors) that overlays
 * the active theme.
 *
 * # What this is for
 *
 * The active *theme* describes how UI surfaces look (panel colors,
 * borders, text, status). The active *brand* describes which APP the
 * user is in. retold-facto, retold-manager, and ultravisor can share
 * the same theme but each carries its own visual signature: a small
 * icon and two brand colors that show up in a stripe under the nav
 * (and optionally tinge link underlines, header accents, etc. when
 * the active theme opts to reference them).
 *
 * Brand is host-supplied (passed to pict-section-theme.install() as
 * `Brand: {...}` or applied later via this module's `applyBrand()`)
 * and NOT user-pickable — it's the app's wordmark. It's also not
 * persisted; the host config drives it on every boot.
 *
 * # Brand shape
 *
 * Two equivalent forms — pick whichever reads better in your app.
 *
 * ## Recommended: nested form
 *
 *   {
 *     Hash:    'retold-manager',
 *     Name:    'Retold Manager',
 *     Icon:    '<svg ...>...</svg>',
 *     Colors: {
 *       Primary:   { Light: '#0044cc', Dark: '#6b8eff' },   // both required
 *       Secondary: { Light: '#c75033', Dark: '#ff8a6b' }    // both required
 *     },
 *     Tagline: 'Optional short tagline'
 *   }
 *
 * This mirrors how theme JSONs already structure their Tokens.Color.*
 * trees, makes the "explicit light + dark variants" contract obvious,
 * and means your brand and your theme look consistent in source.
 *
 * ## Legacy: flat form
 *
 *   {
 *     Hash:    'retold-manager',
 *     Name:    'Retold Manager',
 *     Icon:    '<svg ...>...</svg>',
 *     Colors: {
 *       Primary:        '#0066ff',                // required
 *       Secondary:      '#ff6600',                // required
 *       PrimaryLight:   '#3388ff',                // optional, light-mode tint
 *       PrimaryDark:    '#0044cc',                // optional, dark-mode tint
 *       SecondaryLight: '#ff8833',
 *       SecondaryDark:  '#cc4400'
 *     }
 *   }
 *
 * The flat form's `Primary` / `Secondary` are mode-agnostic constants
 * (used for the `--brand-color-primary` / `-secondary` CSS variables);
 * the *Light / *Dark fields drive the mode-aware variants. When the
 * Light / Dark fields are omitted, the base Primary / Secondary
 * doubles for both modes. Both forms land on the same six output CSS
 * variables — see "CSS variables emitted" below.
 *
 * Icon shape: inline SVG markup, OR a data URL, OR a remote / app-served
 * URL. IconType is optional and auto-detected from the value.
 *
 * # CSS variables emitted
 *
 *   :root {
 *     --brand-color-primary:           <Primary>
 *     --brand-color-secondary:         <Secondary>
 *     --brand-color-primary-light:     <PrimaryLight or Primary>
 *     --brand-color-primary-dark:      <PrimaryDark or Primary>
 *     --brand-color-secondary-light:   <SecondaryLight or Secondary>
 *     --brand-color-secondary-dark:    <SecondaryDark or Secondary>
 *     --brand-color-primary-mode:      <Primary OR PrimaryLight in :root>
 *     --brand-color-secondary-mode:    <Secondary OR SecondaryLight in :root>
 *     --brand-name:                    "<Name>"
 *   }
 *   .theme-dark {
 *     --brand-color-primary-mode:      <PrimaryDark or Primary>
 *     --brand-color-secondary-mode:    <SecondaryDark or Secondary>
 *   }
 *
 * The `*-mode` variables are the ones theme/host CSS should reach for
 * when they want a brand color that automatically swaps for dark mode
 * (parallel to how --theme-color-* works). The plain Primary/Secondary
 * are constants that ignore the mode toggle — useful for the brand
 * stripe itself, where the brand should look the same in both modes.
 *
 * # Listener pattern
 *
 * Mirrors Theme-Scale: subscribe via `onBrandChange(cb)`, dispose by
 * calling the returned function. The BrandStrip view uses this to
 * re-render when the host changes brand at runtime (rare, but used by
 * test harnesses + multi-tenant hosts).
 */

const STYLE_ELEMENT_ID = 'pict-brand';
const FAVICON_LINK_ID = 'pict-brand-favicon';
const FAVICON_DARK_LINK_ID = 'pict-brand-favicon-dark';

let _activeBrand = null;
let _listeners = [];

function _isInlineSVG(pIcon)
{
	return (typeof pIcon === 'string') && /^\s*<svg[\s>]/i.test(pIcon);
}

function _isImageURL(pIcon)
{
	if (typeof pIcon !== 'string') return false;
	return /^(data:|https?:|\/|\.\.?\/)/.test(pIcon);
}

function _detectIconType(pBrand)
{
	if (pBrand && typeof pBrand.IconType === 'string') return pBrand.IconType;
	if (!pBrand || !pBrand.Icon) return null;
	if (_isInlineSVG(pBrand.Icon)) return 'svg';
	if (_isImageURL(pBrand.Icon)) return 'image';
	return null;
}

// Resolve a "color slot" to { Light, Dark, Base } regardless of input
// shape. Supported inputs:
//   - "string"                        → all three equal that string
//   - { Light, Dark }                 → Base = Light, others as given
//   - { Light, Dark, Base }           → Base explicit
//   - missing                         → null (caller decides how to fail)
function _resolveColorSlot(pSlot)
{
	if (typeof pSlot === 'string' && pSlot.length > 0)
	{
		return { Light: pSlot, Dark: pSlot, Base: pSlot };
	}
	if (pSlot && typeof pSlot === 'object')
	{
		let tmpLight = (typeof pSlot.Light === 'string' && pSlot.Light.length > 0) ? pSlot.Light : null;
		let tmpDark  = (typeof pSlot.Dark  === 'string' && pSlot.Dark.length  > 0) ? pSlot.Dark  : null;
		// Need at least one variant present.
		if (!tmpLight && !tmpDark) return null;
		// Fill missing variant from the other side. Base defaults to
		// the light variant (matches the legacy flat-form semantics).
		tmpLight = tmpLight || tmpDark;
		tmpDark  = tmpDark  || tmpLight;
		let tmpBase = (typeof pSlot.Base === 'string' && pSlot.Base.length > 0) ? pSlot.Base : tmpLight;
		return { Light: tmpLight, Dark: tmpDark, Base: tmpBase };
	}
	return null;
}

function _normalize(pBrand)
{
	if (!pBrand || typeof pBrand !== 'object') return null;
	let tmpColors = pBrand.Colors || {};

	// Brand colors accept TWO forms — flat or nested:
	//
	//   FLAT (legacy):
	//     Colors: {
	//       Primary:        '#e54b1e',     // required (the mode-agnostic value)
	//       Secondary:      '#1e9aa0',     // required
	//       PrimaryLight:   '#e54b1e',     // optional fallback to Primary
	//       PrimaryDark:    '#ff7a4a',     // optional fallback to Primary
	//       SecondaryLight: '#1e9aa0',     // optional fallback to Secondary
	//       SecondaryDark:  '#5fc5cb'      // optional fallback to Secondary
	//     }
	//
	//   NESTED (recommended):
	//     Colors: {
	//       Primary:   { Light: '#e54b1e', Dark: '#ff7a4a' },  // both required
	//       Secondary: { Light: '#1e9aa0', Dark: '#5fc5cb' }   // both required
	//     }
	//
	// The nested form mirrors how themes already structure their
	// Tokens.Color.* trees and makes the "this brand needs explicit
	// light + dark variants" contract obvious. Either form lands on
	// the same six --brand-color-* CSS variables.
	let tmpPriSlot = _resolveColorSlot(tmpColors.Primary);
	let tmpSecSlot = _resolveColorSlot(tmpColors.Secondary);
	if (!tmpPriSlot || !tmpSecSlot) return null;

	// Legacy flat-form fields override the resolved slot's Light/Dark
	// (so a host passing both forms gets the most explicit one).
	let tmpPriLight = tmpColors.PrimaryLight   || tmpPriSlot.Light;
	let tmpPriDark  = tmpColors.PrimaryDark    || tmpPriSlot.Dark;
	let tmpSecLight = tmpColors.SecondaryLight || tmpSecSlot.Light;
	let tmpSecDark  = tmpColors.SecondaryDark  || tmpSecSlot.Dark;

	return {
		Hash:    pBrand.Hash || 'brand',
		Name:    pBrand.Name || pBrand.Hash || 'Brand',
		Icon:    pBrand.Icon || null,
		IconType: _detectIconType(pBrand),
		Tagline: (typeof pBrand.Tagline === 'string') ? pBrand.Tagline : null,
		// Optional favicon assets. Each can be: inline `<svg>` markup, a
		// data URL, or a regular URL. When both Favicon and FaviconDark
		// are supplied, paired light/dark <link rel="icon"> tags are
		// emitted with prefers-color-scheme media queries; otherwise a
		// single <link> covers both modes.
		Favicon:     pBrand.Favicon     || null,
		FaviconDark: pBrand.FaviconDark || null,
		Colors:
		{
			Primary:        tmpPriSlot.Base,
			Secondary:      tmpSecSlot.Base,
			PrimaryLight:   tmpPriLight,
			PrimaryDark:    tmpPriDark,
			SecondaryLight: tmpSecLight,
			SecondaryDark:  tmpSecDark
		}
	};
}

// Encode an inline `<svg>` blob into a data URL safe for an <img src> /
// <link href> attribute. Falls through if the input already looks like
// a URL (data:, http:, /, ./, ../).
function _faviconHref(pIcon)
{
	if (!pIcon || typeof pIcon !== 'string') return null;
	if (_isInlineSVG(pIcon))
	{
		// percent-encode SVG markup. Don't encode '#' or '&' minimally;
		// the safe path is to encode aggressively then unescape spaces.
		let tmpEncoded = encodeURIComponent(pIcon).replace(/'/g, '%27').replace(/"/g, '%22');
		return 'data:image/svg+xml;charset=utf-8,' + tmpEncoded;
	}
	if (_isImageURL(pIcon)) return pIcon;
	return null;
}

function _removeFaviconLinks()
{
	if (typeof document === 'undefined') return;
	[FAVICON_LINK_ID, FAVICON_DARK_LINK_ID].forEach((pID) =>
	{
		let tmpEl = document.getElementById(pID);
		if (tmpEl && tmpEl.parentNode) tmpEl.parentNode.removeChild(tmpEl);
	});
}

function _injectFaviconLinks(pBrand)
{
	if (typeof document === 'undefined') return;
	_removeFaviconLinks();

	let tmpLight = _faviconHref(pBrand.Favicon);
	let tmpDark  = _faviconHref(pBrand.FaviconDark);
	if (!tmpLight && !tmpDark) return;

	let tmpHasPair = !!(tmpLight && tmpDark);

	if (tmpLight)
	{
		let tmpLink = document.createElement('link');
		tmpLink.id = FAVICON_LINK_ID;
		tmpLink.rel = 'icon';
		tmpLink.href = tmpLight;
		if (/^data:image\/svg\+xml/.test(tmpLight)) tmpLink.type = 'image/svg+xml';
		if (tmpHasPair) tmpLink.media = '(prefers-color-scheme: light)';
		document.head.appendChild(tmpLink);
	}

	if (tmpDark)
	{
		let tmpLink = document.createElement('link');
		tmpLink.id = FAVICON_DARK_LINK_ID;
		tmpLink.rel = 'icon';
		tmpLink.href = tmpDark;
		if (/^data:image\/svg\+xml/.test(tmpDark)) tmpLink.type = 'image/svg+xml';
		// If we have a light variant, the dark link's media query handles
		// the swap; otherwise it serves both modes.
		if (tmpHasPair) tmpLink.media = '(prefers-color-scheme: dark)';
		document.head.appendChild(tmpLink);
	}
}

function _injectStyleElement(pCSS)
{
	if (typeof document === 'undefined') return;
	let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
	if (!tmpStyleEl)
	{
		tmpStyleEl = document.createElement('style');
		tmpStyleEl.id = STYLE_ELEMENT_ID;
		document.head.appendChild(tmpStyleEl);
	}
	tmpStyleEl.textContent = pCSS;
}

// Escape so the brand name can ride along inside the CSS `content`-style
// `--brand-name` value as a quoted string.
function _cssQuote(pStr)
{
	return '"' + String(pStr || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
}

function _buildCSS(pBrand)
{
	let tmpC = pBrand.Colors;
	let tmpRoot = ':root {\n'
		+ '\t--brand-color-primary:         ' + tmpC.Primary + ';\n'
		+ '\t--brand-color-secondary:       ' + tmpC.Secondary + ';\n'
		+ '\t--brand-color-primary-light:   ' + tmpC.PrimaryLight + ';\n'
		+ '\t--brand-color-primary-dark:    ' + tmpC.PrimaryDark + ';\n'
		+ '\t--brand-color-secondary-light: ' + tmpC.SecondaryLight + ';\n'
		+ '\t--brand-color-secondary-dark:  ' + tmpC.SecondaryDark + ';\n'
		+ '\t--brand-color-primary-mode:    ' + tmpC.PrimaryLight + ';\n'
		+ '\t--brand-color-secondary-mode:  ' + tmpC.SecondaryLight + ';\n'
		+ '\t--brand-name:                  ' + _cssQuote(pBrand.Name) + ';\n'
		+ '}\n';
	// Dark-mode overrides for the *-mode variables only.
	let tmpDark = '.theme-dark {\n'
		+ '\t--brand-color-primary-mode:    ' + tmpC.PrimaryDark + ';\n'
		+ '\t--brand-color-secondary-mode:  ' + tmpC.SecondaryDark + ';\n'
		+ '}\n';
	return tmpRoot + tmpDark;
}

/**
 * Apply (or replace) the active brand. Pass `null` to clear.
 *
 * @param {object|null} pBrand
 * @returns {object|null} the normalized active brand (or null on clear)
 */
function applyBrand(pBrand)
{
	let tmpPrev = _activeBrand;

	if (pBrand === null)
	{
		_activeBrand = null;
		if (typeof document !== 'undefined')
		{
			let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
			if (tmpStyleEl && tmpStyleEl.parentNode) tmpStyleEl.parentNode.removeChild(tmpStyleEl);
		}
		_removeFaviconLinks();
		_fireChange(null, tmpPrev);
		return null;
	}

	let tmpNorm = _normalize(pBrand);
	if (!tmpNorm)
	{
		// Bad input — keep current brand, no-op.
		if (typeof console !== 'undefined' && console.warn)
		{
			console.warn('Theme-Brand.applyBrand: bad brand object — needs Colors.Primary + Colors.Secondary as strings.');
		}
		return _activeBrand;
	}

	_activeBrand = tmpNorm;
	_injectStyleElement(_buildCSS(tmpNorm));
	_injectFaviconLinks(tmpNorm);
	_fireChange(tmpNorm, tmpPrev);
	return tmpNorm;
}

function getActive()
{
	return _activeBrand;
}

function onChange(fCallback)
{
	if (typeof fCallback !== 'function') return function () {};
	_listeners.push(fCallback);
	return function () { offChange(fCallback); };
}

function offChange(fCallback)
{
	let tmpIdx = _listeners.indexOf(fCallback);
	if (tmpIdx >= 0) _listeners.splice(tmpIdx, 1);
}

function _fireChange(pNew, pOld)
{
	for (let i = 0; i < _listeners.length; i++)
	{
		try { _listeners[i](pNew, pOld); }
		catch (pErr) { /* swallow — listener failure must not break callers */ }
	}
}

/**
 * Reset to no-brand state and detach the injected style. Tests use this;
 * runtime hosts rarely need it.
 */
function reset()
{
	applyBrand(null);
	_listeners = [];
}

module.exports =
{
	applyBrand:      applyBrand,
	getActive:       getActive,
	onChange:        onChange,
	offChange:       offChange,
	reset:           reset,
	STYLE_ELEMENT_ID:      STYLE_ELEMENT_ID,
	FAVICON_LINK_ID:       FAVICON_LINK_ID,
	FAVICON_DARK_LINK_ID:  FAVICON_DARK_LINK_ID
};

},{}],166:[function(require,module,exports){
/**
 * Theme-Icons — single source of truth for the inline SVG glyphs the
 * theme section uses (sun, moon, system / monitor, plus a chevron for
 * dropdown triggers).
 *
 * Every icon:
 *   - Is a self-contained SVG string suitable for direct DOM insertion
 *     (innerHTML, template substitution, or pict-section-modal's
 *     `Icon: <html>` field on dropdown items).
 *   - Uses `currentColor` for stroke so it picks up the surrounding
 *     text colour from the active theme (light + dark both look right
 *     without per-mode swaps).
 *   - Has `aria-hidden="true"` so screen readers ignore the decorative
 *     glyph and rely on the surrounding label / aria-label instead.
 *
 * The shapes are intentionally line-art (stroke-based, fill="none") so
 * they read at very small sizes (12–16 px) without going muddy. The
 * "system" icon is a stylised display (rectangle + stand) rather than
 * the unicode 🖥 to keep visual weight consistent with sun + moon.
 *
 * Need a different size? Pass `pSizePx` to any of the iconXxx() helpers
 * and the wrapper SVG's width/height are emitted with that value. The
 * default is 14 px which matches the mode toggle's existing visual.
 */

const _DEFAULT_SIZE_PX = 14;

function _wrap(pSizePx, pInner)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : _DEFAULT_SIZE_PX;
	return '<svg class="pict-theme-icon"'
		+ ' width="' + tmpSize + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 24 24" fill="none"'
		+ ' stroke="currentColor" stroke-width="2"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		+ pInner
		+ '</svg>';
}

/**
 * Sun glyph — central disc + 8 radial rays. Communicates "light mode"
 * universally. Slightly chunkier disc than the typical Feather sun so
 * it still reads at 12 px.
 */
function iconSun(pSizePx)
{
	return _wrap(pSizePx,
		'<circle cx="12" cy="12" r="4"/>'
		+ '<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>');
}

/**
 * Moon glyph — clean crescent (one continuous filled-look path drawn
 * as a stroke). Avoids the brittle thin-crescent unicode characters
 * that fall back to weird outline glyphs in some system fonts.
 */
function iconMoon(pSizePx)
{
	return _wrap(pSizePx,
		'<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>');
}

/**
 * System / display glyph — a small monitor with a stand. Communicates
 * "follow the OS preference" without ambiguity (a monitor is universal
 * UI for system settings, more than the gear icon would be).
 */
function iconSystem(pSizePx)
{
	return _wrap(pSizePx,
		'<rect x="2" y="4" width="20" height="14" rx="2"/>'
		+ '<path d="M8 21h8M12 18v3"/>');
}

/**
 * Composite: a sun + moon side-by-side, sized so the two icons fit in
 * the same horizontal footprint as a single icon. Used in the picker
 * to indicate a paired (Light + Dark) theme without needing two
 * separate visual columns.
 */
function iconPaired(pSizePx)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : _DEFAULT_SIZE_PX;
	// Each half uses currentColor; the sun is rendered slightly smaller
	// in the left half and the moon in the right half by abusing the
	// viewBox width.
	return '<svg class="pict-theme-icon pict-theme-icon-paired"'
		+ ' width="' + (tmpSize * 1.6) + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 38 24" fill="none"'
		+ ' stroke="currentColor" stroke-width="2"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		// Sun on the left (centred at 8,12, radius 3)
		+ '<circle cx="8" cy="12" r="3"/>'
		+ '<path d="M8 4v1.5M8 18.5V20M2.5 12H4M12 12h1.5M4.1 7.1l1 1M11.1 7.1l-1 1M4.1 16.9l1-1M11.1 16.9l-1-1"/>'
		// Moon on the right (mirrored crescent, centred near x=28)
		+ '<path d="M33 13.5A6.5 6.5 0 1 1 26 6a5 5 0 0 0 7 7.5z"/>'
		+ '</svg>';
}

/**
 * Down-chevron used by dropdown triggers. Sized to sit alongside body
 * text (10 px default).
 */
function iconChevronDown(pSizePx)
{
	let tmpSize = (typeof pSizePx === 'number' && pSizePx > 0) ? pSizePx : 10;
	return '<svg class="pict-theme-icon pict-theme-icon-chevron"'
		+ ' width="' + tmpSize + '" height="' + tmpSize + '"'
		+ ' viewBox="0 0 12 12" fill="none"'
		+ ' stroke="currentColor" stroke-width="1.6"'
		+ ' stroke-linecap="round" stroke-linejoin="round"'
		+ ' aria-hidden="true">'
		+ '<path d="M3 4.5l3 3 3-3"/>'
		+ '</svg>';
}

/**
 * Pick the right capability icon for a theme based on its mode strategy.
 * Returns the composite paired glyph for paired themes, sun for light-only,
 * moon for dark-only.
 *
 * @param {string} pStrategy - 'single' or 'system'/'paired'
 * @param {string} pDefaultMode - 'light' or 'dark' (only consulted for single)
 * @param {number} [pSizePx]
 */
function iconForTheme(pStrategy, pDefaultMode, pSizePx)
{
	if (pStrategy === 'single')
	{
		return (pDefaultMode === 'dark') ? iconMoon(pSizePx) : iconSun(pSizePx);
	}
	return iconPaired(pSizePx);
}

module.exports =
{
	iconSun:         iconSun,
	iconMoon:        iconMoon,
	iconSystem:      iconSystem,
	iconPaired:      iconPaired,
	iconChevronDown: iconChevronDown,
	iconForTheme:    iconForTheme,
	DEFAULT_SIZE_PX: _DEFAULT_SIZE_PX
};

},{}],167:[function(require,module,exports){
/**
 * Theme-Persistence — reads and writes the user's selected theme + mode
 * to the browser's localStorage so a reload restores the same look.
 *
 * pict-provider-theme is intentionally stateless — host applications
 * decide what to apply at boot. This module is the small, opt-out-able
 * layer that pict-section-theme.install() uses to make "remember my
 * theme" the default behaviour without forcing every consumer to wire
 * it themselves.
 *
 * # Storage shape
 *
 * Every entry is a single JSON object under one key:
 *
 *   localStorage["pict-section-theme:<scope>"] =
 *     {
 *       Version:   1,
 *       ThemeHash: "retold-manager",
 *       Mode:      "dark",
 *       Scale:     1.25,
 *       SavedAt:   "2026-05-09T21:00:00.000Z"
 *     }
 *
 * Version-tagged so future schema changes can be migrated cleanly;
 * mismatched versions are treated as "no saved entry" and the host
 * application's defaults take over. Older entries that pre-date the
 * Scale field are still valid — Scale is optional and load() returns
 * null for it when absent (caller defaults to 1.0).
 *
 * # Scope (the <scope> portion of the key)
 *
 * Determined in this priority order:
 *   1. The string the host passed in (`PersistenceKey: 'my-app'`) —
 *      use this when one host serves multiple logical apps from the
 *      same origin and they shouldn't share theme state.
 *   2. window.location.hostname when running in a browser.
 *   3. The literal 'default' as a last-ditch fallback (Node, sandbox,
 *      mid-SSR, etc.).
 *
 * # Failure modes
 *
 * - localStorage missing (SSR, Safari private mode, blocked) →
 *   load() returns null, save() returns false, no exception.
 * - Quota exceeded → save() returns false silently; the in-memory
 *   active theme is unaffected.
 * - JSON parse error or version mismatch → load() returns null so the
 *   caller falls back to ApplyDefault.
 *
 * Nothing here throws — persistence failures must NEVER crash the host
 * application's boot path.
 */

const STORAGE_PREFIX = 'pict-section-theme:';
const SCHEMA_VERSION = 1;

function _getStorage()
{
	try
	{
		if (typeof window !== 'undefined' && window.localStorage)
		{
			return window.localStorage;
		}
	}
	catch (pErr) { /* SecurityError in some contexts */ }
	return null;
}

function _autoScope()
{
	try
	{
		if (typeof window !== 'undefined' && window.location && window.location.hostname)
		{
			return window.location.hostname;
		}
	}
	catch (pErr) { /* fall through */ }
	return 'default';
}

/**
 * Resolve the full localStorage key for this app's theme state.
 *
 * @param {string|null} pUserKey - Host-supplied scope override; falsy
 *   values trigger the auto-scope fallback (hostname → 'default').
 * @returns {string} the fully-qualified localStorage key.
 */
function resolveKey(pUserKey)
{
	let tmpScope = (typeof pUserKey === 'string' && pUserKey.length > 0)
		? pUserKey
		: _autoScope();
	return STORAGE_PREFIX + tmpScope;
}

/**
 * Read the saved theme state for a key.  Returns null if nothing is
 * stored, the storage is unavailable, or the entry's schema version
 * doesn't match.
 *
 * @param {string} pKey - the resolved storage key
 * @returns {{ThemeHash: string, Mode: string|null, Scale: number|null}|null}
 */
function load(pKey)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return null;

	let tmpRaw;
	try { tmpRaw = tmpStore.getItem(pKey); }
	catch (pErr) { return null; }
	if (!tmpRaw) return null;

	let tmpParsed;
	try { tmpParsed = JSON.parse(tmpRaw); }
	catch (pErr) { return null; }

	if (!tmpParsed || typeof tmpParsed !== 'object') return null;
	if (tmpParsed.Version !== SCHEMA_VERSION) return null;
	if (typeof tmpParsed.ThemeHash !== 'string' || tmpParsed.ThemeHash.length === 0) return null;

	let tmpScale = null;
	if (typeof tmpParsed.Scale === 'number' && isFinite(tmpParsed.Scale) && tmpParsed.Scale > 0)
	{
		tmpScale = tmpParsed.Scale;
	}

	return {
		ThemeHash: tmpParsed.ThemeHash,
		Mode:      (typeof tmpParsed.Mode === 'string' && tmpParsed.Mode.length > 0)
			? tmpParsed.Mode
			: null,
		Scale:     tmpScale
	};
}

/**
 * Persist the active theme + mode for this key.  No-ops gracefully
 * when storage is unavailable or quota is exceeded.
 *
 * @param {string} pKey
 * @param {{ThemeHash: string, Mode?: string, Scale?: number}} pState
 * @returns {boolean} true on success, false otherwise
 */
function save(pKey, pState)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return false;
	if (!pState || typeof pState.ThemeHash !== 'string' || pState.ThemeHash.length === 0) return false;

	let tmpEntry =
	{
		Version:   SCHEMA_VERSION,
		ThemeHash: pState.ThemeHash,
		Mode:      (typeof pState.Mode === 'string' && pState.Mode.length > 0) ? pState.Mode : null,
		Scale:     (typeof pState.Scale === 'number' && isFinite(pState.Scale) && pState.Scale > 0)
			? pState.Scale
			: null,
		SavedAt:   new Date().toISOString()
	};

	try { tmpStore.setItem(pKey, JSON.stringify(tmpEntry)); return true; }
	catch (pErr) { return false; }
}

/**
 * Remove the saved theme state for a key.  Useful for "reset to
 * defaults" actions.
 */
function clear(pKey)
{
	let tmpStore = _getStorage();
	if (!tmpStore) return false;
	try { tmpStore.removeItem(pKey); return true; }
	catch (pErr) { return false; }
}

module.exports =
{
	resolveKey: resolveKey,
	load:       load,
	save:       save,
	clear:      clear,
	STORAGE_PREFIX: STORAGE_PREFIX,
	SCHEMA_VERSION: SCHEMA_VERSION
};

},{}],168:[function(require,module,exports){
/**
 * Theme-Scale — viewport scale (zoom) selector independent of theme bundles.
 *
 * Scale is a *user preference*, not a property of any particular theme:
 * the user might want Cyberpunk-at-1.25x or Retold-Manager-at-0.85x.
 * Pict-provider-theme is intentionally bundle-shaped (Tokens / SVG /
 * Image), so scale lives here at the section layer alongside Mode.
 *
 * # Apply mechanism
 *
 * Two outputs feed cooperating CSS:
 *
 *   1. `html { zoom: <scale>; }` — works for legacy stylesheets that
 *      use `px` everywhere (most Retold apps including retold-manager).
 *      Browsers (Chromium-based + Firefox 126+ + Safari) all honour
 *      `zoom` on root.
 *
 *   2. `:root { --theme-scale: <scale>; }` — exposed for stylesheets
 *      that want to opt into explicit `calc(... * var(--theme-scale))`
 *      sizing. Keeps the value addressable from JS too via
 *      `getComputedStyle(document.documentElement).getPropertyValue(...)`.
 *
 * Both are written into a single `<style id="pict-theme-scale">` element
 * appended to `<head>` after the theme provider's own style element so
 * scale wins last. Re-applying just rewrites this one element's text.
 *
 * # Listener pattern
 *
 * Mirrors pict-provider-theme.onApply(): subscribers receive the new
 * scale value plus the previous value and a return-able `dispose`
 * function. The persistence wiring in pict-section-theme.install()
 * uses this to autosave whenever the scale changes.
 *
 * # Stateless across instances
 *
 * No singleton state — each browser window has one DOM, so the module
 * tracks active scale via a module-level variable, but exposes
 * `getActive()` for callers that want to query it. `applyScale()` is
 * idempotent: applying the same value re-injects the same CSS (cheap
 * no-op).
 */

const STYLE_ELEMENT_ID = 'pict-theme-scale';
const CSS_VAR_NAME = '--theme-scale';
const DEFAULT_SCALE = 1.0;
const MIN_SCALE = 0.5;
const MAX_SCALE = 3.0;

// Curated list of presets. Hosts that want a different range can pass
// a custom `Presets` array to the ScaleSelect view; this default covers
// the readability common cases without overwhelming the dropdown.
const PRESETS =
[
	{ Value: 0.75, Label: 'Tiny (75%)' },
	{ Value: 0.85, Label: 'Small (85%)' },
	{ Value: 1.00, Label: 'Default (100%)' },
	{ Value: 1.15, Label: 'Comfortable (115%)' },
	{ Value: 1.25, Label: 'Large (125%)' },
	{ Value: 1.50, Label: 'Huge (150%)' },
	{ Value: 1.75, Label: 'Extra Huge (175%)' },
	{ Value: 2.00, Label: 'Massive (200%)' }
];

let _activeScale = DEFAULT_SCALE;
let _listeners = [];

function _clamp(pValue)
{
	let tmpNum = Number(pValue);
	if (!isFinite(tmpNum) || tmpNum <= 0) return DEFAULT_SCALE;
	if (tmpNum < MIN_SCALE) return MIN_SCALE;
	if (tmpNum > MAX_SCALE) return MAX_SCALE;
	return tmpNum;
}

function _injectStyleElement(pCSS)
{
	if (typeof document === 'undefined') return;
	let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
	if (!tmpStyleEl)
	{
		tmpStyleEl = document.createElement('style');
		tmpStyleEl.id = STYLE_ELEMENT_ID;
		document.head.appendChild(tmpStyleEl);
	}
	tmpStyleEl.textContent = pCSS;
}

function _buildCSS(pScale)
{
	// `zoom` on <html> scales everything (px + rem + layout). The
	// `--theme-scale` custom property exposes the same value to any CSS
	// that wants to react explicitly via calc().
	return ':root {\n'
		+ '\t' + CSS_VAR_NAME + ': ' + pScale + ';\n'
		+ '}\n'
		+ 'html {\n'
		+ '\tzoom: ' + pScale + ';\n'
		+ '}\n';
}

/**
 * Apply a viewport scale.
 *
 * @param {number} pScale - desired multiplier (e.g. 1.0, 1.25). Values
 *   outside [MIN_SCALE, MAX_SCALE] are clamped; non-finite values
 *   reset to DEFAULT_SCALE.
 * @returns {number} the actually-applied scale (after clamping).
 */
function applyScale(pScale)
{
	let tmpPrev = _activeScale;
	let tmpNext = _clamp(pScale);
	_activeScale = tmpNext;
	_injectStyleElement(_buildCSS(tmpNext));
	if (tmpPrev !== tmpNext) { _fireChange(tmpNext, tmpPrev); }
	return tmpNext;
}

function getActive()
{
	return _activeScale;
}

function onChange(fCallback)
{
	if (typeof fCallback !== 'function') return function () {};
	_listeners.push(fCallback);
	return function () { offChange(fCallback); };
}

function offChange(fCallback)
{
	let tmpIdx = _listeners.indexOf(fCallback);
	if (tmpIdx >= 0) _listeners.splice(tmpIdx, 1);
}

function _fireChange(pNewScale, pOldScale)
{
	for (let i = 0; i < _listeners.length; i++)
	{
		try { _listeners[i](pNewScale, pOldScale); }
		catch (pErr) { /* listener failures must not break callers */ }
	}
}

/**
 * Reset to default scale and remove the injected style element. Useful
 * for tests + "reset to defaults" affordances.
 */
function reset()
{
	_activeScale = DEFAULT_SCALE;
	if (typeof document !== 'undefined')
	{
		let tmpStyleEl = document.getElementById(STYLE_ELEMENT_ID);
		if (tmpStyleEl && tmpStyleEl.parentNode) tmpStyleEl.parentNode.removeChild(tmpStyleEl);
	}
	_listeners = [];
}

module.exports =
{
	applyScale: applyScale,
	getActive:  getActive,
	onChange:   onChange,
	offChange:  offChange,
	reset:      reset,

	PRESETS:        PRESETS,
	DEFAULT_SCALE:  DEFAULT_SCALE,
	MIN_SCALE:      MIN_SCALE,
	MAX_SCALE:      MAX_SCALE,
	STYLE_ELEMENT_ID: STYLE_ELEMENT_ID,
	CSS_VAR_NAME:     CSS_VAR_NAME
};

},{}],169:[function(require,module,exports){
module.exports={
	"Hash": "1970s-console",
	"Name": "1970s Console",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Amber phosphor on brown-black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A1000",
				"Secondary": "#140C00",
				"Tertiary": "#1E1400",
				"Panel": "#1C1200",
				"Viewer": "#100A00",
				"Hover": "#2A1C00",
				"Selected": "#3A2800",
				"Thumb": "#140C00"
			},
			"Text": {
				"Primary": "#FFAA00",
				"Secondary": "#DD8800",
				"Muted": "#AA6600",
				"Dim": "#884400",
				"Placeholder": "#663300"
			},
			"Brand": {
				"Accent": "#FFCC00",
				"AccentHover": "#FFDD44"
			},
			"Border": {
				"Default": "#2A1800",
				"Light": "#3A2200"
			},
			"Status": {
				"Danger": "#FF4400",
				"DangerMuted": "#AA3300"
			},
			"Scrollbar": {
				"Track": "#2A1800",
				"Hover": "#3A2800"
			},
			"Selection": {
				"Background": "rgba(255, 204, 0, 0.2)"
			},
			"Focus": {
				"Outline": "#FFCC00"
			},
			"Syntax": {
				"Keyword":     "#FFB000",
				"String":      "#FFD080",
				"Number":      "#FFB000",
				"Comment":     "#806020",
				"Operator":    "#FFB000",
				"Punctuation": "#FFD080",
				"Function":    "#FFB000",
				"Variable":    "#FFE090",
				"Type":        "#FFB000",
				"Builtin":     "#FFB000",
				"Property":    "#FF6E40",
				"Tag":         "#FF6E40",
				"AttrName":    "#FFB000",
				"AttrValue":   "#FFD080"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', 'Lucida Console', monospace",
				"Mono": "'Courier New', 'Lucida Console', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#DD8800",
		"Accent": "#FFCC00",
		"Muted": "#884400",
		"Light": "#1E1400",
		"WarmBeige": "#201800",
		"TealTint": "#1A1000",
		"Lavender": "#1C1200",
		"AmberTint": "#221800",
		"PdfFill": "#201000",
		"PdfText": "#FF4400"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.405Z",
	"CompilerVersion": 1
}
},{}],170:[function(require,module,exports){
module.exports={
	"Hash": "1980s-console",
	"Name": "1980s Console",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Green phosphor on black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#001200",
				"Secondary": "#000E00",
				"Tertiary": "#001600",
				"Panel": "#001400",
				"Viewer": "#000A00",
				"Hover": "#002200",
				"Selected": "#003800",
				"Thumb": "#000E00"
			},
			"Text": {
				"Primary": "#00FF00",
				"Secondary": "#00CC00",
				"Muted": "#009900",
				"Dim": "#006600",
				"Placeholder": "#004400"
			},
			"Brand": {
				"Accent": "#00FF66",
				"AccentHover": "#44FF88"
			},
			"Border": {
				"Default": "#002A00",
				"Light": "#003A00"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#AA0000"
			},
			"Scrollbar": {
				"Track": "#002A00",
				"Hover": "#004400"
			},
			"Selection": {
				"Background": "rgba(0, 255, 102, 0.2)"
			},
			"Focus": {
				"Outline": "#00FF66"
			},
			"Syntax": {
				"Keyword":     "#00FF00",
				"String":      "#90FF90",
				"Number":      "#FFFF00",
				"Comment":     "#208020",
				"Operator":    "#00FF00",
				"Punctuation": "#90FF90",
				"Function":    "#00FF00",
				"Variable":    "#C0FFC0",
				"Type":        "#FFFF00",
				"Builtin":     "#FFFF00",
				"Property":    "#FF4040",
				"Tag":         "#FF4040",
				"AttrName":    "#FFFF00",
				"AttrValue":   "#90FF90"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', monospace",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#00CC00",
		"Accent": "#00FF66",
		"Muted": "#006600",
		"Light": "#001600",
		"WarmBeige": "#001A00",
		"TealTint": "#001200",
		"Lavender": "#001400",
		"AmberTint": "#001800",
		"PdfFill": "#140000",
		"PdfText": "#FF0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],171:[function(require,module,exports){
module.exports={
	"Hash": "1990s-website",
	"Name": "1990s Web Site",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Blue links on grey, beveled Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#C0C0C0",
				"Secondary": "#B0B0B0",
				"Tertiary": "#A8A8A8",
				"Panel": "#B8B8B8",
				"Viewer": "#D0D0D0",
				"Hover": "#B8B8D0",
				"Selected": "#000080",
				"Thumb": "#B0B0B0"
			},
			"Text": {
				"Primary": "#000000",
				"Secondary": "#000080",
				"Muted": "#404040",
				"Dim": "#606060",
				"Placeholder": "#808080"
			},
			"Brand": {
				"Accent": "#0000FF",
				"AccentHover": "#0000CC"
			},
			"Border": {
				"Default": "#808080",
				"Light": "#A0A0A0"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#990000"
			},
			"Scrollbar": {
				"Track": "#808080",
				"Hover": "#606060"
			},
			"Selection": {
				"Background": "rgba(0, 0, 128, 0.3)"
			},
			"Focus": {
				"Outline": "#0000FF"
			},
			"Syntax": {
				"Keyword":     "#0000FF",
				"String":      "#008000",
				"Number":      "#A52A2A",
				"Comment":     "#808080",
				"Operator":    "#000080",
				"Punctuation": "#000000",
				"Function":    "#0000A0",
				"Variable":    "#000000",
				"Type":        "#A52A2A",
				"Builtin":     "#A52A2A",
				"Property":    "#800080",
				"Tag":         "#800080",
				"AttrName":    "#A52A2A",
				"AttrValue":   "#008000"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Times New Roman', Times, serif",
				"Mono": "'Courier New', Courier, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#000080",
		"Accent": "#0000FF",
		"Muted": "#606060",
		"Light": "#A8A8A8",
		"WarmBeige": "#B0B0B0",
		"TealTint": "#A0A0A0",
		"Lavender": "#ABABD0",
		"AmberTint": "#B8B0A0",
		"PdfFill": "#C0A0A0",
		"PdfText": "#FF0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],172:[function(require,module,exports){
/**
 * Theme Registry — runtime registry of every theme available to
 * pict-section-theme.
 *
 * Bundled "starter set" themes are pre-registered at module load time
 * via static `require()` so browserify can resolve and inline each JSON
 * at bundle time. Beyond the starter set, consumers can register
 * additional theme bundles at runtime — useful for:
 *
 *   - Loading themes the host app authored (e.g. an app's own brand
 *     palette that isn't shipped with this module).
 *   - Pulling themes from a remote "theme garden" via
 *     `registerFromURL()` (CDN-hosted curated bundles).
 *   - Tooling / playgrounds that mutate the registry as the user
 *     iterates.
 *
 * Module exports a singleton instance, so all consumers operate on the
 * same set. Use `register({Hash, Bundle, Category, IsDefault})` to add
 * themes, `list()` to enumerate them, `get(hash)` for direct lookup,
 * `unregister(hash)` to remove.
 *
 * Each entry shape:
 *
 *   {
 *     Hash:       <string>      // matches bundle.Hash; used by the picker
 *     Bundle:     <object>      // theme JSON, ready for provider.registerTheme()
 *     Category:   <string>      // grouping label for the picker UI
 *     IsDefault:  <bool?>       // true for the canonical ecosystem default
 *     Source:     <string?>     // 'starter' | URL | host-supplied tag
 *   }
 *
 * Backwards-compat:
 *   - The instance is iterable (Symbol.iterator), exposes `.length`,
 *     and supports numeric indexing `[i]` so legacy code that treated
 *     the catalog as an array continues to work without changes.
 */
'use strict';

class ThemeRegistry
{
	constructor()
	{
		this._themes = new Map();      // Hash → entry, insertion-ordered
		this._loadStarterSet();
	}

	// ── Bundled starter set ──────────────────────────────────────────────
	// Each `require()` is a literal string so browserify inlines the JSON
	// at build time. Adding a new bundled theme: drop the JSON in this
	// folder and append a row here. Runtime additions go via register()
	// from anywhere else in the codebase.
	_loadStarterSet()
	{
		const STARTER =
		[
			// Framework defaults
			// retold-default is the canonical ecosystem default (IsDefault).
			// pict-default is retained for backwards compatibility with any
			// consumer that explicitly opts in by Hash; it's no longer the
			// default theme returned when the picker resolves "the default".
			{ Hash: 'retold-default',     Category: 'Default',  IsDefault: true,  Bundle: require('./retold-default.json') },
			{ Hash: 'pict-default',       Category: 'Default',  Bundle: require('./pict-default.json') },
			{ Hash: 'retold-mono',        Category: 'Default',  Bundle: require('./retold-mono.json') },

			// App-extracted themes (named after their host app)
			{ Hash: 'retold-manager',                Category: 'App',  Bundle: require('./retold-manager.json') },
			{ Hash: 'retold-content-system',         Category: 'App',  Bundle: require('./retold-content-system.json') },
			{ Hash: 'retold-labs',                   Category: 'App',  Bundle: require('./retold-labs.json') },
			{ Hash: 'retold-labs-cyberpunk',         Category: 'App',  Bundle: require('./retold-labs-cyberpunk.json') },
			{ Hash: 'retold-labs-retro',             Category: 'App',  Bundle: require('./retold-labs-retro.json') },
			{ Hash: 'ultravisor-desert-dusk',        Category: 'App',  Bundle: require('./ultravisor-desert-dusk.json') },
			{ Hash: 'ultravisor-desert-day',         Category: 'App',  Bundle: require('./ultravisor-desert-day.json') },
			{ Hash: 'ultravisor-desert-sunset',      Category: 'App',  Bundle: require('./ultravisor-desert-sunset.json') },
			{ Hash: 'ultravisor-professional-light', Category: 'App',  Bundle: require('./ultravisor-professional-light.json') },
			{ Hash: 'ultravisor-professional-dark',  Category: 'App',  Bundle: require('./ultravisor-professional-dark.json') },
			{ Hash: 'ultravisor-desert-canyon',      Category: 'App',  Bundle: require('./ultravisor-desert-canyon.json') },

			// Paired light/dark themes
			{ Hash: 'ocean',              Category: 'Paired',   Bundle: require('./ocean.json') },
			{ Hash: 'playground-corp',    Category: 'Paired',   Bundle: require('./playground-corp.json') },

			// Flow themes (originally pict-section-flow's internal presets; now first-class
			// pict-section-theme entries so other apps can adopt the same color identity)
			{ Hash: 'flow-modern',        Category: 'Flow',     Bundle: require('./flow-modern.json') },
			{ Hash: 'flow-sketch',        Category: 'Flow',     Bundle: require('./flow-sketch.json') },
			{ Hash: 'flow-blueprint',     Category: 'Flow',     Bundle: require('./flow-blueprint.json') },
			{ Hash: 'flow-mono',          Category: 'Flow',     Bundle: require('./flow-mono.json') },
			{ Hash: 'flow-retro-80s',     Category: 'Flow',     Bundle: require('./flow-retro-80s.json') },
			{ Hash: 'flow-retro-90s',     Category: 'Flow',     Bundle: require('./flow-retro-90s.json') },
			{ Hash: 'flow-whiteboard',    Category: 'Flow',     Bundle: require('./flow-whiteboard.json') },

			// Greys (low-light single-mode themes)
			{ Hash: 'twilight',           Category: 'Grey',     Bundle: require('./twilight.json') },
			{ Hash: 'night',              Category: 'Grey',     Bundle: require('./night.json') },
			{ Hash: 'evening',            Category: 'Grey',     Bundle: require('./evening.json') },
			{ Hash: 'afternoon',          Category: 'Grey',     Bundle: require('./afternoon.json') },
			{ Hash: 'daylight',           Category: 'Grey',     Bundle: require('./daylight.json') },

			// Fun / period palettes
			{ Hash: 'cyberpunk',          Category: 'Fun',      Bundle: require('./cyberpunk.json') },
			{ Hash: 'synthwave',          Category: 'Fun',      Bundle: require('./synthwave.json') },
			{ Hash: 'neo-tokyo',          Category: 'Fun',      Bundle: require('./neo-tokyo.json') },
			{ Hash: 'solarized-dark',     Category: 'Fun',      Bundle: require('./solarized-dark.json') },
			{ Hash: 'forest',             Category: 'Fun',      Bundle: require('./forest.json') },
			{ Hash: 'hotdog',             Category: 'Fun',      Bundle: require('./hotdog.json') },
			{ Hash: '1970s-console',      Category: 'Fun',      Bundle: require('./1970s-console.json') },
			{ Hash: '1980s-console',      Category: 'Fun',      Bundle: require('./1980s-console.json') },
			{ Hash: '1990s-website',      Category: 'Fun',      Bundle: require('./1990s-website.json') },
			{ Hash: 'early-2000s',        Category: 'Fun',      Bundle: require('./early-2000s.json') },

			// Retro workstation palettes — extracted from retold-databeacon's
			// original built-in theme set; period-platform-themed pairs.
			{ Hash: 'databeacon-nineteen-97', Category: 'Retro', Bundle: require('./databeacon-nineteen-97.json') },
			{ Hash: 'databeacon-mac-classic', Category: 'Retro', Bundle: require('./databeacon-mac-classic.json') },
			{ Hash: 'databeacon-next',        Category: 'Retro', Bundle: require('./databeacon-next.json') },
			{ Hash: 'databeacon-beos',        Category: 'Retro', Bundle: require('./databeacon-beos.json') },
			{ Hash: 'databeacon-sgi',         Category: 'Retro', Bundle: require('./databeacon-sgi.json') },

			// Diagnostics / utility
			{ Hash: 'mobile-debug',       Category: 'Debug',    Bundle: require('./mobile-debug.json') }
		];

		for (let i = 0; i < STARTER.length; i++)
		{
			let tmpEntry = Object.assign({}, STARTER[i], { Source: STARTER[i].Source || 'starter' });
			this._themes.set(tmpEntry.Hash, tmpEntry);
		}
	}

	// ── Public API ───────────────────────────────────────────────────────

	/**
	 * Register a theme. Re-registering an existing hash overwrites cleanly.
	 *
	 * @param {{Hash, Bundle, Category?, IsDefault?, Source?}} pEntry
	 * @returns {object} the stored entry
	 */
	register(pEntry)
	{
		if (!pEntry || typeof pEntry !== 'object')
		{
			throw new Error('ThemeRegistry.register: entry must be an object');
		}
		if (typeof pEntry.Hash !== 'string' || pEntry.Hash.length === 0)
		{
			throw new Error('ThemeRegistry.register: entry.Hash is required');
		}
		if (!pEntry.Bundle || typeof pEntry.Bundle !== 'object')
		{
			throw new Error('ThemeRegistry.register: entry.Bundle is required');
		}
		let tmpStored = Object.assign({ Source: 'host' }, pEntry);
		this._themes.set(pEntry.Hash, tmpStored);
		return tmpStored;
	}

	/**
	 * Remove a theme by hash. Returns true if anything was removed.
	 * @param {string} pHash
	 * @returns {boolean}
	 */
	unregister(pHash)
	{
		return this._themes.delete(pHash);
	}

	/**
	 * Look up a single theme entry by hash.
	 * @param {string} pHash
	 * @returns {object|undefined}
	 */
	get(pHash)
	{
		return this._themes.get(pHash);
	}

	has(pHash)
	{
		return this._themes.has(pHash);
	}

	/**
	 * Snapshot of every registered entry, in registration order.
	 * @returns {Array<object>}
	 */
	list()
	{
		return Array.from(this._themes.values());
	}

	/**
	 * Drop every registered entry. Mostly useful in tests; production
	 * consumers should prefer `unregister()` per hash.
	 */
	clear()
	{
		this._themes.clear();
	}

	/**
	 * Re-load the bundled starter set. No-op if the starter set is
	 * already registered (re-registering replaces, so this is safe to
	 * call any time).
	 */
	loadStarterSet()
	{
		this._loadStarterSet();
	}

	/**
	 * Number of registered themes.
	 * @returns {number}
	 */
	get count()
	{
		return this._themes.size;
	}

	/**
	 * Async fetch + register from a URL. Used by the future "online theme
	 * garden" — the URL must serve a JSON bundle compatible with
	 * pict-provider-theme's `registerTheme()` shape.
	 *
	 * @param {string} pURL
	 * @param {{Category?, IsDefault?, Hash?}} [pMetadata] - override metadata
	 * @returns {Promise<object>} the registered entry
	 */
	async registerFromURL(pURL, pMetadata)
	{
		if (typeof fetch !== 'function')
		{
			throw new Error('ThemeRegistry.registerFromURL: fetch is not available in this environment');
		}
		let tmpResponse = await fetch(pURL);
		if (!tmpResponse.ok)
		{
			throw new Error('ThemeRegistry.registerFromURL: HTTP ' + tmpResponse.status + ' for ' + pURL);
		}
		let tmpBundle = await tmpResponse.json();
		if (!tmpBundle || typeof tmpBundle !== 'object' || typeof tmpBundle.Hash !== 'string')
		{
			throw new Error('ThemeRegistry.registerFromURL: payload missing Hash');
		}
		let tmpMeta = pMetadata || {};
		return this.register(
		{
			Hash: tmpMeta.Hash || tmpBundle.Hash,
			Bundle: tmpBundle,
			Category: tmpMeta.Category || 'Garden',
			IsDefault: !!tmpMeta.IsDefault,
			Source: pURL
		});
	}

	// ── Array-like compatibility ─────────────────────────────────────────
	// Older code iterated the catalog as an array (`for (let i = 0; i <
	// CATALOG.length; i++) ... CATALOG[i]`). Preserve those usages without
	// requiring a refactor: the iterator + length + numeric proxy give
	// `Array.isArray(registry)` returns false, but everything that reads
	// keeps working. New code should prefer `list()` / `get()`.

	get length()
	{
		return this._themes.size;
	}

	[Symbol.iterator]()
	{
		return this._themes.values();
	}
}

// Singleton — every consumer gets the same registry.
const _Registry = new ThemeRegistry();

// Numeric-index proxy: `registry[0]` returns the first entry, matching
// the legacy "catalog as array" shape. Wraps the singleton so existing
// `tmpEntry = _CATALOG[i]` loops keep working.
const _IndexedRegistry = new Proxy(_Registry,
{
	get(pTarget, pProp, pReceiver)
	{
		if (typeof pProp === 'string' && /^\d+$/.test(pProp))
		{
			let tmpIdx = parseInt(pProp, 10);
			let tmpList = pTarget.list();
			return tmpList[tmpIdx];
		}
		return Reflect.get(pTarget, pProp, pReceiver);
	},
	has(pTarget, pProp)
	{
		if (typeof pProp === 'string' && /^\d+$/.test(pProp))
		{
			return parseInt(pProp, 10) < pTarget.length;
		}
		return Reflect.has(pTarget, pProp);
	}
});

module.exports = _IndexedRegistry;
module.exports.ThemeRegistry = ThemeRegistry;

},{"./1970s-console.json":169,"./1980s-console.json":170,"./1990s-website.json":171,"./afternoon.json":173,"./cyberpunk.json":174,"./databeacon-beos.json":175,"./databeacon-mac-classic.json":176,"./databeacon-next.json":177,"./databeacon-nineteen-97.json":178,"./databeacon-sgi.json":179,"./daylight.json":180,"./early-2000s.json":181,"./evening.json":182,"./flow-blueprint.json":183,"./flow-modern.json":184,"./flow-mono.json":185,"./flow-retro-80s.json":186,"./flow-retro-90s.json":187,"./flow-sketch.json":188,"./flow-whiteboard.json":189,"./forest.json":190,"./hotdog.json":191,"./mobile-debug.json":192,"./neo-tokyo.json":193,"./night.json":194,"./ocean.json":195,"./pict-default.json":196,"./playground-corp.json":197,"./retold-content-system.json":198,"./retold-default.json":199,"./retold-labs-cyberpunk.json":200,"./retold-labs-retro.json":201,"./retold-labs.json":202,"./retold-manager.json":203,"./retold-mono.json":204,"./solarized-dark.json":205,"./synthwave.json":206,"./twilight.json":207,"./ultravisor-desert-canyon.json":208,"./ultravisor-desert-day.json":209,"./ultravisor-desert-dusk.json":210,"./ultravisor-desert-sunset.json":211,"./ultravisor-professional-dark.json":212,"./ultravisor-professional-light.json":213}],173:[function(require,module,exports){
module.exports={
	"Hash": "afternoon",
	"Name": "Afternoon",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Warm light grey, softer contrast Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#E8E4E0",
				"Secondary": "#DAD6D2",
				"Tertiary": "#D0CCC8",
				"Panel": "#DDD9D5",
				"Viewer": "#F0ECE8",
				"Hover": "#CCC8C4",
				"Selected": "#B8B4B0",
				"Thumb": "#DAD6D2"
			},
			"Text": {
				"Primary": "#2A2A2A",
				"Secondary": "#404040",
				"Muted": "#707070",
				"Dim": "#909090",
				"Placeholder": "#B0B0B0"
			},
			"Brand": {
				"Accent": "#555555",
				"AccentHover": "#333333"
			},
			"Border": {
				"Default": "#C0BCB8",
				"Light": "#D0CCC8"
			},
			"Status": {
				"Danger": "#AA3333",
				"DangerMuted": "#886655"
			},
			"Scrollbar": {
				"Track": "#B8B4B0",
				"Hover": "#A0A09C"
			},
			"Selection": {
				"Background": "rgba(85, 85, 85, 0.2)"
			},
			"Focus": {
				"Outline": "#555555"
			},
			"Syntax": {
				"Keyword":     "#7038A0",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#666666",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Georgia, 'Times New Roman', serif",
				"Mono": "'Courier New', Courier, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#404040",
		"Accent": "#555555",
		"Muted": "#909090",
		"Light": "#D0CCC8",
		"WarmBeige": "#DAD6D2",
		"TealTint": "#CCC8C4",
		"Lavender": "#D2D0CE",
		"AmberTint": "#D8D2C8",
		"PdfFill": "#D8C8C0",
		"PdfText": "#AA3333"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],174:[function(require,module,exports){
module.exports={
	"Hash": "cyberpunk",
	"Name": "Cyberpunk",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Electric green on black Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0A0E0A",
				"Secondary": "#060806",
				"Tertiary": "#0E120E",
				"Panel": "#0C100C",
				"Viewer": "#040604",
				"Hover": "#142014",
				"Selected": "#1A3A1A",
				"Thumb": "#060806"
			},
			"Text": {
				"Primary": "#C8FFC8",
				"Secondary": "#A0D8A0",
				"Muted": "#608860",
				"Dim": "#406040",
				"Placeholder": "#305030"
			},
			"Brand": {
				"Accent": "#00FF41",
				"AccentHover": "#44FF77"
			},
			"Border": {
				"Default": "#1A2A1A",
				"Light": "#224022"
			},
			"Status": {
				"Danger": "#FF3333",
				"DangerMuted": "#AA2222"
			},
			"Scrollbar": {
				"Track": "#1A2A1A",
				"Hover": "#2A4A2A"
			},
			"Selection": {
				"Background": "rgba(0, 255, 65, 0.2)"
			},
			"Focus": {
				"Outline": "#00FF41"
			},
			"Syntax": {
				"Keyword":     "#FF00FF",
				"String":      "#00FF41",
				"Number":      "#FFFF00",
				"Comment":     "#406040",
				"Operator":    "#00FFFF",
				"Punctuation": "#A0D8A0",
				"Function":    "#FF00FF",
				"Variable":    "#C8FFC8",
				"Type":        "#FFFF00",
				"Builtin":     "#FFFF00",
				"Property":    "#FF3333",
				"Tag":         "#FF3333",
				"AttrName":    "#FFFF00",
				"AttrValue":   "#00FF41"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Lucida Console', 'Courier New', monospace",
				"Mono": "'Lucida Console', 'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#A0D8A0",
		"Accent": "#00FF41",
		"Muted": "#406040",
		"Light": "#0E120E",
		"WarmBeige": "#101610",
		"TealTint": "#0C140C",
		"Lavender": "#0E120E",
		"AmberTint": "#141810",
		"PdfFill": "#181010",
		"PdfText": "#FF3333"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.406Z",
	"CompilerVersion": 1
}
},{}],175:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-beos",
	"Name": "DataBeacon \u2014 BeOS",
	"Version": "0.0.1",
	"Description": "BeOS palette \u2014 cool teals with orange accents. Light: sky-blue desktop. Dark: deep ocean panels with cyan highlights.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#e0e8ec",
					"Dark": "#0a1a22"
				},
				"Secondary": {
					"Light": "#c8d6de",
					"Dark": "#102530"
				},
				"Tertiary": {
					"Light": "#d4dfe5",
					"Dark": "#0d1f29"
				},
				"Panel": {
					"Light": "#f0f4f6",
					"Dark": "#142430"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#1b313f"
				},
				"Hover": {
					"Light": "#d7dee2",
					"Dark": "#091820"
				},
				"Selected": {
					"Light": "#c2d4da",
					"Dark": "#19353e"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#101820",
					"Dark": "#b0d0e0"
				},
				"Secondary": {
					"Light": "#40525e",
					"Dark": "#7a98a8"
				},
				"Muted": {
					"Light": "#6e828e",
					"Dark": "#556a78"
				},
				"Placeholder": {
					"Light": "#95a5ae",
					"Dark": "#3a4e59"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0a1a22"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"PrimaryHover": {
					"Light": "#4e98aa",
					"Dark": "#80ccdc"
				},
				"Accent": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"AccentHover": {
					"Light": "#4e98aa",
					"Dark": "#80ccdc"
				}
			},
			"Border": {
				"Default": {
					"Light": "#8ba3b0",
					"Dark": "#466070"
				},
				"Light": {
					"Light": "#b5c5ce",
					"Dark": "#283d49"
				},
				"Strong": {
					"Light": "#6f828c",
					"Dark": "#384c59"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2a7a4a",
					"Dark": "#4ac06a"
				},
				"Warning": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Error": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"Info": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#c8d6de",
					"Dark": "#102530"
				},
				"Thumb": {
					"Light": "#7c929f",
					"Dark": "#4d6574"
				},
				"Hover": {
					"Light": "#6e828e",
					"Dark": "#556a78"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#aac4cc",
					"Dark": "#254a54"
				},
				"Text": {
					"Light": "#101820",
					"Dark": "#b0d0e0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"String": {
					"Light": "#2a7a4a",
					"Dark": "#4ac06a"
				},
				"Number": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Comment": {
					"Light": "#6e828e",
					"Dark": "#556a78"
				},
				"Operator": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"Punctuation": {
					"Light": "#40525e",
					"Dark": "#7a98a8"
				},
				"Function": {
					"Light": "#3a7a8a",
					"Dark": "#60b0c0"
				},
				"Variable": {
					"Light": "#101820",
					"Dark": "#b0d0e0"
				},
				"Type": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Builtin": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"Property": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"Tag": {
					"Light": "#cc5530",
					"Dark": "#ff8060"
				},
				"AttrName": {
					"Light": "#cc9930",
					"Dark": "#ffc860"
				},
				"AttrValue": {
					"Light": "#2a7a4a",
					"Dark": "#4ac06a"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "BeOS",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],176:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-mac-classic",
	"Name": "DataBeacon \u2014 Mac Classic",
	"Version": "0.0.1",
	"Description": "Mac OS 8/9 Platinum palette \u2014 soft greys with sky blue accents. Light: classic Mac platinum. Dark: charcoal panels with the same blue accent family.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#dddddd",
					"Dark": "#202020"
				},
				"Secondary": {
					"Light": "#cccccc",
					"Dark": "#2a2a2a"
				},
				"Tertiary": {
					"Light": "#d4d4d4",
					"Dark": "#252525"
				},
				"Panel": {
					"Light": "#f0f0f0",
					"Dark": "#2e2e2e"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#3a3a3a"
				},
				"Hover": {
					"Light": "#d4d4d4",
					"Dark": "#1e1e1e"
				},
				"Selected": {
					"Light": "#c0cce3",
					"Dark": "#2b3748"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#000000",
					"Dark": "#dddddd"
				},
				"Secondary": {
					"Light": "#444444",
					"Dark": "#b0b0b0"
				},
				"Muted": {
					"Light": "#777777",
					"Dark": "#777777"
				},
				"Placeholder": {
					"Light": "#9a9a9a",
					"Dark": "#585858"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0a0a0a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"PrimaryHover": {
					"Light": "#60a0ff",
					"Dark": "#80b8ff"
				},
				"Accent": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"AccentHover": {
					"Light": "#60a0ff",
					"Dark": "#80b8ff"
				}
			},
			"Border": {
				"Default": {
					"Light": "#999999",
					"Dark": "#555555"
				},
				"Light": {
					"Light": "#bbbbbb",
					"Dark": "#3a3a3a"
				},
				"Strong": {
					"Light": "#7a7a7a",
					"Dark": "#444444"
				}
			},
			"Status": {
				"Success": {
					"Light": "#339933",
					"Dark": "#60cc60"
				},
				"Warning": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Error": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"Info": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#cccccc",
					"Dark": "#2a2a2a"
				},
				"Thumb": {
					"Light": "#888888",
					"Dark": "#666666"
				},
				"Hover": {
					"Light": "#777777",
					"Dark": "#777777"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#aabfe7",
					"Dark": "#344867"
				},
				"Text": {
					"Light": "#000000",
					"Dark": "#dddddd"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"String": {
					"Light": "#339933",
					"Dark": "#60cc60"
				},
				"Number": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Comment": {
					"Light": "#777777",
					"Dark": "#777777"
				},
				"Operator": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"Punctuation": {
					"Light": "#444444",
					"Dark": "#b0b0b0"
				},
				"Function": {
					"Light": "#4080ff",
					"Dark": "#60a0ff"
				},
				"Variable": {
					"Light": "#000000",
					"Dark": "#dddddd"
				},
				"Type": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Builtin": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"Property": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"Tag": {
					"Light": "#cc0000",
					"Dark": "#ff4060"
				},
				"AttrName": {
					"Light": "#cc6600",
					"Dark": "#ff9933"
				},
				"AttrValue": {
					"Light": "#339933",
					"Dark": "#60cc60"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Mac Classic",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],177:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-next",
	"Name": "DataBeacon \u2014 NeXT",
	"Version": "0.0.1",
	"Description": "NeXTSTEP palette \u2014 stone backgrounds with rich purple accents. Light: warm stone. Dark: deep aubergine with lavender highlights.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#e8e6dd",
					"Dark": "#1a1420"
				},
				"Secondary": {
					"Light": "#d6d3c8",
					"Dark": "#221a2c"
				},
				"Tertiary": {
					"Light": "#dfdcd2",
					"Dark": "#1e1726"
				},
				"Panel": {
					"Light": "#f5f3ed",
					"Dark": "#251c2e"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#2f253a"
				},
				"Hover": {
					"Light": "#dedcd4",
					"Dark": "#18131e"
				},
				"Selected": {
					"Light": "#d1c7d2",
					"Dark": "#352a42"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1e1a26",
					"Dark": "#e8e6dd"
				},
				"Secondary": {
					"Light": "#4c465a",
					"Dark": "#b8b4c6"
				},
				"Muted": {
					"Light": "#7a7488",
					"Dark": "#7a7488"
				},
				"Placeholder": {
					"Light": "#a09ba5",
					"Dark": "#585263"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#1a1420"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"PrimaryHover": {
					"Light": "#8557c0",
					"Dark": "#c8aef0"
				},
				"Accent": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"AccentHover": {
					"Light": "#8557c0",
					"Dark": "#c8aef0"
				}
			},
			"Border": {
				"Default": {
					"Light": "#9a96a6",
					"Dark": "#5e5468"
				},
				"Light": {
					"Light": "#c1bec1",
					"Dark": "#3c3444"
				},
				"Strong": {
					"Light": "#7b7884",
					"Dark": "#4b4353"
				}
			},
			"Status": {
				"Success": {
					"Light": "#3a7a3a",
					"Dark": "#7acc7a"
				},
				"Warning": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Error": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"Info": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#d6d3c8",
					"Dark": "#221a2c"
				},
				"Thumb": {
					"Light": "#8a8597",
					"Dark": "#6c6478"
				},
				"Hover": {
					"Light": "#7a7488",
					"Dark": "#7a7488"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#bfb0c9",
					"Dark": "#4a3b5d"
				},
				"Text": {
					"Light": "#1e1a26",
					"Dark": "#e8e6dd"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"String": {
					"Light": "#3a7a3a",
					"Dark": "#7acc7a"
				},
				"Number": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Comment": {
					"Light": "#7a7488",
					"Dark": "#7a7488"
				},
				"Operator": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"Punctuation": {
					"Light": "#4c465a",
					"Dark": "#b8b4c6"
				},
				"Function": {
					"Light": "#6a3fa0",
					"Dark": "#b090e0"
				},
				"Variable": {
					"Light": "#1e1a26",
					"Dark": "#e8e6dd"
				},
				"Type": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Builtin": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"Property": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"Tag": {
					"Light": "#aa2c3a",
					"Dark": "#ff6a80"
				},
				"AttrName": {
					"Light": "#b88a00",
					"Dark": "#ffcf4a"
				},
				"AttrValue": {
					"Light": "#3a7a3a",
					"Dark": "#7acc7a"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "NeXT",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],178:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-nineteen-97",
	"Name": "DataBeacon \u2014 1997 (Win95/98)",
	"Version": "0.0.1",
	"Description": "Windows 95/98 retro palette \u2014 beige + navy + maroon. Light: classic Win95 desktop. Dark: indigo-grey background with sky/coral accents.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ece9d8",
					"Dark": "#1e1e2e"
				},
				"Secondary": {
					"Light": "#d8d3b8",
					"Dark": "#26263a"
				},
				"Tertiary": {
					"Light": "#e2dec8",
					"Dark": "#222234"
				},
				"Panel": {
					"Light": "#fffbf0",
					"Dark": "#2a2a3a"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#343450"
				},
				"Hover": {
					"Light": "#e2dfcf",
					"Dark": "#1c1c2c"
				},
				"Selected": {
					"Light": "#c1bfc8",
					"Dark": "#2f3553"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1a1a",
					"Dark": "#ece9d8"
				},
				"Secondary": {
					"Light": "#4a4a4a",
					"Dark": "#b8b6a8"
				},
				"Muted": {
					"Light": "#7a7a7a",
					"Dark": "#7e7c70"
				},
				"Placeholder": {
					"Light": "#a1a09a",
					"Dark": "#5c5b58"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#1a1a1a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				},
				"PrimaryHover": {
					"Light": "#0000cc",
					"Dark": "#a0b8ff"
				},
				"Accent": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				},
				"AccentHover": {
					"Light": "#0000cc",
					"Dark": "#a0b8ff"
				}
			},
			"Border": {
				"Default": {
					"Light": "#808080",
					"Dark": "#4e4e68"
				},
				"Light": {
					"Light": "#b6b4ac",
					"Dark": "#36364b"
				},
				"Strong": {
					"Light": "#666666",
					"Dark": "#3e3e53"
				}
			},
			"Status": {
				"Success": {
					"Light": "#008000",
					"Dark": "#80ff80"
				},
				"Warning": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Error": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"Info": {
					"Light": "#000080",
					"Dark": "#80c0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#d8d3b8",
					"Dark": "#26263a"
				},
				"Thumb": {
					"Light": "#7d7d7d",
					"Dark": "#66656c"
				},
				"Hover": {
					"Light": "#7a7a7a",
					"Dark": "#7e7c70"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#a09ebb",
					"Dark": "#3d4770"
				},
				"Text": {
					"Light": "#1a1a1a",
					"Dark": "#ece9d8"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"String": {
					"Light": "#008000",
					"Dark": "#80ff80"
				},
				"Number": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Comment": {
					"Light": "#7a7a7a",
					"Dark": "#7e7c70"
				},
				"Operator": {
					"Light": "#000080",
					"Dark": "#80a0ff"
				},
				"Punctuation": {
					"Light": "#4a4a4a",
					"Dark": "#b8b6a8"
				},
				"Function": {
					"Light": "#000080",
					"Dark": "#80c0ff"
				},
				"Variable": {
					"Light": "#1a1a1a",
					"Dark": "#ece9d8"
				},
				"Type": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Builtin": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"Property": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"Tag": {
					"Light": "#800000",
					"Dark": "#ff8080"
				},
				"AttrName": {
					"Light": "#808000",
					"Dark": "#ffcc00"
				},
				"AttrValue": {
					"Light": "#008000",
					"Dark": "#80ff80"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "1997 (Win95/98)",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],179:[function(require,module,exports){
module.exports={
	"Hash": "databeacon-sgi",
	"Name": "DataBeacon \u2014 SGI",
	"Version": "0.0.1",
	"Description": "SGI Indy / IRIX palette \u2014 magenta with cyan highlights. Light: signature SGI grey. Dark: deep workstation black with the same hot magenta.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#c8c8c8",
					"Dark": "#1a1a1a"
				},
				"Secondary": {
					"Light": "#b8b8b8",
					"Dark": "#232323"
				},
				"Tertiary": {
					"Light": "#c0c0c0",
					"Dark": "#1e1e1e"
				},
				"Panel": {
					"Light": "#dcdcdc",
					"Dark": "#252525"
				},
				"Input": {
					"Light": "#ffffff",
					"Dark": "#2e2e2e"
				},
				"Hover": {
					"Light": "#c0c0c0",
					"Dark": "#181818"
				},
				"Selected": {
					"Light": "#c8a9bb",
					"Dark": "#432635"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#202020",
					"Dark": "#e0e0e0"
				},
				"Secondary": {
					"Light": "#4a4a4a",
					"Dark": "#a8a8a8"
				},
				"Muted": {
					"Light": "#6e6e6e",
					"Dark": "#707070"
				},
				"Placeholder": {
					"Light": "#8d8d8d",
					"Dark": "#515151"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0a0a0a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				},
				"PrimaryHover": {
					"Light": "#e040a0",
					"Dark": "#ff80c8"
				},
				"Accent": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				},
				"AccentHover": {
					"Light": "#e040a0",
					"Dark": "#ff80c8"
				}
			},
			"Border": {
				"Default": {
					"Light": "#808080",
					"Dark": "#505050"
				},
				"Light": {
					"Light": "#a4a4a4",
					"Dark": "#353535"
				},
				"Strong": {
					"Light": "#666666",
					"Dark": "#404040"
				}
			},
			"Status": {
				"Success": {
					"Light": "#208040",
					"Dark": "#50d080"
				},
				"Warning": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Error": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"Info": {
					"Light": "#3080c0",
					"Dark": "#60c0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#b8b8b8",
					"Dark": "#232323"
				},
				"Thumb": {
					"Light": "#777777",
					"Dark": "#606060"
				},
				"Hover": {
					"Light": "#6e6e6e",
					"Dark": "#707070"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#c892b0",
					"Dark": "#63304a"
				},
				"Text": {
					"Light": "#202020",
					"Dark": "#e0e0e0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"String": {
					"Light": "#208040",
					"Dark": "#50d080"
				},
				"Number": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Comment": {
					"Light": "#6e6e6e",
					"Dark": "#707070"
				},
				"Operator": {
					"Light": "#c82080",
					"Dark": "#ff60b0"
				},
				"Punctuation": {
					"Light": "#4a4a4a",
					"Dark": "#a8a8a8"
				},
				"Function": {
					"Light": "#3080c0",
					"Dark": "#60c0ff"
				},
				"Variable": {
					"Light": "#202020",
					"Dark": "#e0e0e0"
				},
				"Type": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Builtin": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"Property": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"Tag": {
					"Light": "#e83018",
					"Dark": "#ff6060"
				},
				"AttrName": {
					"Light": "#e8a818",
					"Dark": "#ffd050"
				},
				"AttrValue": {
					"Light": "#208040",
					"Dark": "#50d080"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "220px",
			"TopbarHeight": "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "SGI",
		"Tagline": "Connect, introspect, and expose remote databases"
	}
}
},{}],180:[function(require,module,exports){
module.exports={
	"Hash": "daylight",
	"Name": "Daylight",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Bright white, dark text Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#FFFFFF",
				"Secondary": "#F0F0F0",
				"Tertiary": "#E8E8E8",
				"Panel": "#F5F5F5",
				"Viewer": "#FAFAFA",
				"Hover": "#E0E0E0",
				"Selected": "#C8C8C8",
				"Thumb": "#F0F0F0"
			},
			"Text": {
				"Primary": "#1A1A1A",
				"Secondary": "#333333",
				"Muted": "#666666",
				"Dim": "#888888",
				"Placeholder": "#AAAAAA"
			},
			"Brand": {
				"Accent": "#444444",
				"AccentHover": "#222222"
			},
			"Border": {
				"Default": "#D0D0D0",
				"Light": "#E0E0E0"
			},
			"Status": {
				"Danger": "#CC0000",
				"DangerMuted": "#884444"
			},
			"Scrollbar": {
				"Track": "#C0C0C0",
				"Hover": "#A0A0A0"
			},
			"Selection": {
				"Background": "rgba(68, 68, 68, 0.2)"
			},
			"Focus": {
				"Outline": "#444444"
			},
			"Syntax": {
				"Keyword":     "#7038A0",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#444444",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Segoe UI', system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#333333",
		"Accent": "#444444",
		"Muted": "#888888",
		"Light": "#E8E8E8",
		"WarmBeige": "#F0F0F0",
		"TealTint": "#E0E0E0",
		"Lavender": "#EBEBEB",
		"AmberTint": "#F0EDE8",
		"PdfFill": "#F0E0E0",
		"PdfText": "#CC0000"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],181:[function(require,module,exports){
module.exports={
	"Hash": "early-2000s",
	"Name": "Early 2000s Web",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Teal and silver, Web 2.0 Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#E8F4F8",
				"Secondary": "#D0E8EE",
				"Tertiary": "#C0DDE6",
				"Panel": "#D8EEF2",
				"Viewer": "#F0F8FA",
				"Hover": "#B0D4E0",
				"Selected": "#88C4D8",
				"Thumb": "#D0E8EE"
			},
			"Text": {
				"Primary": "#1A3A4A",
				"Secondary": "#2A4A5A",
				"Muted": "#5A7A8A",
				"Dim": "#7A9AAA",
				"Placeholder": "#9ABACA"
			},
			"Brand": {
				"Accent": "#0099CC",
				"AccentHover": "#00AADD"
			},
			"Border": {
				"Default": "#A0C8D8",
				"Light": "#B8D8E4"
			},
			"Status": {
				"Danger": "#CC3300",
				"DangerMuted": "#994422"
			},
			"Scrollbar": {
				"Track": "#A0C8D8",
				"Hover": "#88B8CC"
			},
			"Selection": {
				"Background": "rgba(0, 153, 204, 0.2)"
			},
			"Focus": {
				"Outline": "#0099CC"
			},
			"Syntax": {
				"Keyword":     "#1A4080",
				"String":      "#2E7A3A",
				"Number":      "#A86B00",
				"Comment":     "#888888",
				"Operator":    "#1F6FB5",
				"Punctuation": "#333333",
				"Function":    "#3357C7",
				"Variable":    "#222222",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#B62828",
				"Tag":         "#B62828",
				"AttrName":    "#A86B00",
				"AttrValue":   "#2E7A3A"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Verdana, Geneva, Tahoma, sans-serif",
				"Mono": "'Lucida Console', Monaco, monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#2A4A5A",
		"Accent": "#0099CC",
		"Muted": "#7A9AAA",
		"Light": "#C0DDE6",
		"WarmBeige": "#D0E8EE",
		"TealTint": "#B0D8E4",
		"Lavender": "#C8DCE6",
		"AmberTint": "#D8E0D0",
		"PdfFill": "#E0C8C0",
		"PdfText": "#CC3300"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],182:[function(require,module,exports){
module.exports={
	"Hash": "evening",
	"Name": "Evening",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Medium grey, transitional Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#484848",
				"Secondary": "#3C3C3C",
				"Tertiary": "#424242",
				"Panel": "#454545",
				"Viewer": "#363636",
				"Hover": "#525252",
				"Selected": "#606060",
				"Thumb": "#3C3C3C"
			},
			"Text": {
				"Primary": "#E0E0E0",
				"Secondary": "#D0D0D0",
				"Muted": "#A0A0A0",
				"Dim": "#888888",
				"Placeholder": "#707070"
			},
			"Brand": {
				"Accent": "#C0C0C0",
				"AccentHover": "#E0E0E0"
			},
			"Border": {
				"Default": "#585858",
				"Light": "#606060"
			},
			"Status": {
				"Danger": "#FF6666",
				"DangerMuted": "#AA6666"
			},
			"Scrollbar": {
				"Track": "#585858",
				"Hover": "#686868"
			},
			"Selection": {
				"Background": "rgba(192, 192, 192, 0.25)"
			},
			"Focus": {
				"Outline": "#C0C0C0"
			},
			"Syntax": {
				"Keyword":     "#B894FF",
				"String":      "#A8D8B0",
				"Number":      "#FFB880",
				"Comment":     "#8A8A8A",
				"Operator":    "#7EC0FF",
				"Punctuation": "#BBBBBB",
				"Function":    "#FFCC80",
				"Variable":    "#DDDDDD",
				"Type":        "#FFB880",
				"Builtin":     "#FFB880",
				"Property":    "#FF9494",
				"Tag":         "#FF9494",
				"AttrName":    "#FFB880",
				"AttrValue":   "#A8D8B0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0D0D0",
		"Accent": "#C0C0C0",
		"Muted": "#888888",
		"Light": "#424242",
		"WarmBeige": "#484848",
		"TealTint": "#3E3E3E",
		"Lavender": "#444444",
		"AmberTint": "#4A4640",
		"PdfFill": "#4A3C3C",
		"PdfText": "#FF6666"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],183:[function(require,module,exports){
module.exports={
	"Hash": "flow-blueprint",
	"Name": "Flow Blueprint",
	"Version": "0.0.1",
	"Description": "Technical-drawing aesthetic — white-on-navy with yellow selection. Single-mode (always dark blueprint).",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#1a3a6a",
				"Secondary": "#142e54",
				"Tertiary":  "rgba(255,255,255,0.1)",
				"Panel":     "#1a3a6a",
				"Hover":     "rgba(255,255,255,0.06)",
				"Selected":  "rgba(255,221,68,0.18)"
			},
			"Text": {
				"Primary":   "#ffffff",
				"Secondary": "rgba(255,255,255,0.7)",
				"Muted":     "rgba(255,255,255,0.5)",
				"OnBrand":   "#0d2244"
			},
			"Brand": {
				"Primary":      "#ffdd44",
				"PrimaryHover": "#ffe978",
				"Accent":       "#88ffbb"
			},
			"Border": {
				"Default": "rgba(255,255,255,0.6)",
				"Light":   "rgba(255,255,255,0.15)",
				"Strong":  "#ffffff"
			},
			"Status": {
				"Success": "#88ffbb",
				"Warning": "#ffdd44",
				"Error":   "#ff8888",
				"Info":    "#88bbff"
			},
			"Scrollbar": {
				"Track": "rgba(255,255,255,0.05)",
				"Thumb": "rgba(255,255,255,0.3)",
				"Hover": "rgba(255,255,255,0.5)"
			},
			"Focus": {
				"Outline": "#ffdd44"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.4)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Blueprint",
		"Tagline": "Technical drawing on navy"
	}
}

},{}],184:[function(require,module,exports){
module.exports={
	"Hash": "flow-modern",
	"Name": "Flow Modern",
	"Version": "0.0.1",
	"Description": "The default modern look for pict-section-flow — clean, theme-neutral. Paired light/dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#1a1a1a" },
				"Secondary": { "Light": "#f5f5f5", "Dark": "#242424" },
				"Tertiary":  { "Light": "#ecf0f1", "Dark": "#2e2e2e" },
				"Panel":     { "Light": "#ffffff", "Dark": "#222222" },
				"Hover":     { "Light": "#eef3f7", "Dark": "#2a2a2a" },
				"Selected":  { "Light": "#dde7f3", "Dark": "#2a3550" }
			},
			"Text": {
				"Primary":   { "Light": "#2c3e50", "Dark": "#ededed" },
				"Secondary": { "Light": "#7f8c8d", "Dark": "#bdbdbd" },
				"Muted":     { "Light": "#95a5a6", "Dark": "#888888" },
				"OnBrand":   { "Light": "#ffffff", "Dark": "#1a1a1a" }
			},
			"Brand": {
				"Primary":      { "Light": "#2255aa", "Dark": "#5b8aff" },
				"PrimaryHover": { "Light": "#1a4488", "Dark": "#7ba4ff" },
				"Accent":       { "Light": "#1abc9c", "Dark": "#4fd1b5" }
			},
			"Border": {
				"Default": { "Light": "#bdc3c7", "Dark": "#3a3a3a" },
				"Light":   { "Light": "#ecf0f1", "Dark": "#2c2c2c" },
				"Strong":  { "Light": "#95a5a6", "Dark": "#5a5a5a" }
			},
			"Status": {
				"Success": { "Light": "#27ae60", "Dark": "#5fc377" },
				"Warning": { "Light": "#f39c12", "Dark": "#f0b84a" },
				"Error":   { "Light": "#e74c3c", "Dark": "#ff7373" },
				"Info":    { "Light": "#3498db", "Dark": "#5fb4ff" }
			},
			"Scrollbar": {
				"Track": { "Light": "#ecf0f1", "Dark": "#1f1f1f" },
				"Thumb": { "Light": "#bdc3c7", "Dark": "#3f3f3f" },
				"Hover": { "Light": "#95a5a6", "Dark": "#5a5a5a" }
			},
			"Focus": {
				"Outline": { "Light": "#2255aa", "Dark": "#5b8aff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			}
		}
	},
	"Brand": {
		"Name": "Flow Modern",
		"Tagline": "Clean modern flow editor look"
	}
}

},{}],185:[function(require,module,exports){
module.exports={
	"Hash": "flow-mono",
	"Name": "Flow Mono",
	"Version": "0.0.1",
	"Description": "High-contrast monochrome flow editor look. Paired light/dark — pure black on white or white on black.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#000000" },
				"Secondary": { "Light": "#f0f0f0", "Dark": "#1a1a1a" },
				"Tertiary":  { "Light": "#e0e0e0", "Dark": "#262626" },
				"Panel":     { "Light": "#ffffff", "Dark": "#000000" },
				"Hover":     { "Light": "#eeeeee", "Dark": "#1f1f1f" },
				"Selected":  { "Light": "#dddddd", "Dark": "#333333" }
			},
			"Text": {
				"Primary":   { "Light": "#000000", "Dark": "#ffffff" },
				"Secondary": { "Light": "#444444", "Dark": "#cccccc" },
				"Muted":     { "Light": "#888888", "Dark": "#888888" },
				"OnBrand":   { "Light": "#ffffff", "Dark": "#000000" }
			},
			"Brand": {
				"Primary":      { "Light": "#444444", "Dark": "#bbbbbb" },
				"PrimaryHover": { "Light": "#222222", "Dark": "#dddddd" },
				"Accent":       { "Light": "#666666", "Dark": "#999999" }
			},
			"Border": {
				"Default": { "Light": "#000000", "Dark": "#ffffff" },
				"Light":   { "Light": "#cccccc", "Dark": "#333333" },
				"Strong":  { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#000000", "Dark": "#ffffff" },
				"Warning": { "Light": "#000000", "Dark": "#ffffff" },
				"Error":   { "Light": "#000000", "Dark": "#ffffff" },
				"Info":    { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Scrollbar": {
				"Track": { "Light": "#f0f0f0", "Dark": "#1a1a1a" },
				"Thumb": { "Light": "#888888", "Dark": "#888888" },
				"Hover": { "Light": "#444444", "Dark": "#cccccc" }
			},
			"Focus": {
				"Outline": { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.25)", "Dark": "rgba(255, 255, 255, 0.25)" }
			}
		}
	},
	"Brand": {
		"Name": "Flow Mono",
		"Tagline": "Monochrome ink-on-paper"
	}
}

},{}],186:[function(require,module,exports){
module.exports={
	"Hash": "flow-retro-80s",
	"Name": "Flow Retro 80s",
	"Version": "0.0.1",
	"Description": "Neon-on-purple synthwave aesthetic for the flow editor. Single-mode (always dark) — '80s arcade glow.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#0a0015",
				"Secondary": "#1a0a2e",
				"Tertiary":  "#2a0a4e",
				"Panel":     "#1a0a2e",
				"Hover":     "#2a0a4e",
				"Selected":  "#3a1466"
			},
			"Text": {
				"Primary":   "#00ffff",
				"Secondary": "#ff66ff",
				"Muted":     "#9966cc",
				"OnBrand":   "#0a0015"
			},
			"Brand": {
				"Primary":      "#ff00ff",
				"PrimaryHover": "#ff66ff",
				"Accent":       "#00ffff"
			},
			"Border": {
				"Default": "#ff00ff",
				"Light":   "#2a0a4e",
				"Strong":  "#ff00ff"
			},
			"Status": {
				"Success": "#00ff66",
				"Warning": "#ffdd44",
				"Error":   "#ff4477",
				"Info":    "#00ffff"
			},
			"Scrollbar": {
				"Track": "#1a0a2e",
				"Thumb": "#ff00ff",
				"Hover": "#ff66ff"
			},
			"Focus": {
				"Outline": "#00ffff"
			},
			"Shadow": {
				"Color": "rgba(255, 0, 255, 0.4)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Retro 80s",
		"Tagline": "Neon synthwave glow"
	}
}

},{}],187:[function(require,module,exports){
module.exports={
	"Hash": "flow-retro-90s",
	"Name": "Flow Retro 90s",
	"Version": "0.0.1",
	"Description": "Windows-95 aesthetic — gray panels, navy title bars, teal desktop. Single-mode (always its specific palette).",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#008080",
				"Secondary": "#c0c0c0",
				"Tertiary":  "#d0d0d0",
				"Panel":     "#c0c0c0",
				"Hover":     "#d0d0d0",
				"Selected":  "#a8c8e0"
			},
			"Text": {
				"Primary":   "#000000",
				"Secondary": "#404040",
				"Muted":     "#606060",
				"OnBrand":   "#ffffff"
			},
			"Brand": {
				"Primary":      "#000080",
				"PrimaryHover": "#0000a0",
				"Accent":       "#008000"
			},
			"Border": {
				"Default": "#808080",
				"Light":   "#a0a0a0",
				"Strong":  "#404040"
			},
			"Status": {
				"Success": "#008000",
				"Warning": "#808000",
				"Error":   "#800000",
				"Info":    "#000080"
			},
			"Scrollbar": {
				"Track": "#c0c0c0",
				"Thumb": "#808080",
				"Hover": "#404040"
			},
			"Focus": {
				"Outline": "#008080"
			},
			"Shadow": {
				"Color": "#404040"
			}
		}
	},
	"Brand": {
		"Name": "Flow Retro 90s",
		"Tagline": "Workstation chrome from the 90s"
	}
}

},{}],188:[function(require,module,exports){
module.exports={
	"Hash": "flow-sketch",
	"Name": "Flow Sketch",
	"Version": "0.0.1",
	"Description": "Warm-paper sketch aesthetic for the flow editor. Single-mode (always light) — sketches live on paper.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#fffef5",
				"Secondary": "#faf8ed",
				"Tertiary":  "#f0ece0",
				"Panel":     "#fffef5",
				"Hover":     "#f4f0e2",
				"Selected":  "#e8dfc8"
			},
			"Text": {
				"Primary":   "#333333",
				"Secondary": "#555555",
				"Muted":     "#888888",
				"OnBrand":   "#ffffff"
			},
			"Brand": {
				"Primary":      "#2255aa",
				"PrimaryHover": "#1a4488",
				"Accent":       "#c47b5a"
			},
			"Border": {
				"Default": "#444444",
				"Light":   "#ccccaa",
				"Strong":  "#222222"
			},
			"Status": {
				"Success": "#55aa77",
				"Warning": "#d4a040",
				"Error":   "#c44836",
				"Info":    "#5577bb"
			},
			"Scrollbar": {
				"Track": "#f0ece0",
				"Thumb": "#c5c0a8",
				"Hover": "#9e9a82"
			},
			"Focus": {
				"Outline": "#2255aa"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.08)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Sketch",
		"Tagline": "Hand-drawn paper aesthetic"
	}
}

},{}],189:[function(require,module,exports){
module.exports={
	"Hash": "flow-whiteboard",
	"Name": "Flow Whiteboard",
	"Version": "0.0.1",
	"Description": "Minimal whiteboard aesthetic — transparent fills with colored brackets per node type. Single-mode (light).",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#ffffff",
				"Secondary": "#fafafa",
				"Tertiary":  "#f5f5f5",
				"Panel":     "#ffffff",
				"Hover":     "#f0f0f0",
				"Selected":  "#e0eaff"
			},
			"Text": {
				"Primary":   "#333333",
				"Secondary": "#555555",
				"Muted":     "#999999",
				"OnBrand":   "#ffffff"
			},
			"Brand": {
				"Primary":      "#2255aa",
				"PrimaryHover": "#1a4488",
				"Accent":       "#1abc9c"
			},
			"Border": {
				"Default": "#888888",
				"Light":   "#cccccc",
				"Strong":  "#555555"
			},
			"Status": {
				"Success": "#27ae60",
				"Warning": "#f39c12",
				"Error":   "#e74c3c",
				"Info":    "#3498db"
			},
			"Scrollbar": {
				"Track": "#f5f5f5",
				"Thumb": "#cccccc",
				"Hover": "#888888"
			},
			"Focus": {
				"Outline": "#2255aa"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.06)"
			}
		}
	},
	"Brand": {
		"Name": "Flow Whiteboard",
		"Tagline": "Minimal whiteboard sketching"
	}
}

},{}],190:[function(require,module,exports){
module.exports={
	"Hash": "forest",
	"Name": "Forest",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Deep greens and earth browns Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A2018",
				"Secondary": "#141A12",
				"Tertiary": "#1E2620",
				"Panel": "#1C221A",
				"Viewer": "#101410",
				"Hover": "#283828",
				"Selected": "#344834",
				"Thumb": "#141A12"
			},
			"Text": {
				"Primary": "#D0DCC8",
				"Secondary": "#B0C4A8",
				"Muted": "#809878",
				"Dim": "#607858",
				"Placeholder": "#486040"
			},
			"Brand": {
				"Accent": "#6AAF5C",
				"AccentHover": "#88CC78"
			},
			"Border": {
				"Default": "#2A3A28",
				"Light": "#3A4A38"
			},
			"Status": {
				"Danger": "#CC4422",
				"DangerMuted": "#884422"
			},
			"Scrollbar": {
				"Track": "#2A3A28",
				"Hover": "#3A4A38"
			},
			"Selection": {
				"Background": "rgba(106, 175, 92, 0.25)"
			},
			"Focus": {
				"Outline": "#6AAF5C"
			},
			"Syntax": {
				"Keyword":     "#D4E157",
				"String":      "#A5D6A7",
				"Number":      "#FFB74D",
				"Comment":     "#5D6F58",
				"Operator":    "#80CBC4",
				"Punctuation": "#A8C8A0",
				"Function":    "#FFCC80",
				"Variable":    "#C8E6C9",
				"Type":        "#FFB74D",
				"Builtin":     "#FFB74D",
				"Property":    "#FF8A65",
				"Tag":         "#FF8A65",
				"AttrName":    "#FFB74D",
				"AttrValue":   "#A5D6A7"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#B0C4A8",
		"Accent": "#6AAF5C",
		"Muted": "#607858",
		"Light": "#1E2620",
		"WarmBeige": "#22281E",
		"TealTint": "#1A221A",
		"Lavender": "#1E2420",
		"AmberTint": "#262218",
		"PdfFill": "#261A18",
		"PdfText": "#CC4422"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],191:[function(require,module,exports){
module.exports={
	"Hash": "hotdog",
	"Name": "Hotdog",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Red and mustard yellow, garish Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#8B0000",
				"Secondary": "#6B0000",
				"Tertiary": "#7B0000",
				"Panel": "#750000",
				"Viewer": "#550000",
				"Hover": "#AA1111",
				"Selected": "#BB3300",
				"Thumb": "#6B0000"
			},
			"Text": {
				"Primary": "#FFD700",
				"Secondary": "#FFC000",
				"Muted": "#CC9900",
				"Dim": "#AA7700",
				"Placeholder": "#886600"
			},
			"Brand": {
				"Accent": "#FFD700",
				"AccentHover": "#FFEE44"
			},
			"Border": {
				"Default": "#AA2222",
				"Light": "#BB3333"
			},
			"Status": {
				"Danger": "#FFFF00",
				"DangerMuted": "#CCCC00"
			},
			"Scrollbar": {
				"Track": "#AA2222",
				"Hover": "#CC3333"
			},
			"Selection": {
				"Background": "rgba(255, 215, 0, 0.3)"
			},
			"Focus": {
				"Outline": "#FFD700"
			},
			"Syntax": {
				"Keyword":     "#FFD800",
				"String":      "#FFFFFF",
				"Number":      "#FFD800",
				"Comment":     "#9C2828",
				"Operator":    "#FFD800",
				"Punctuation": "#FFFFFF",
				"Function":    "#FFD800",
				"Variable":    "#FFFFFF",
				"Type":        "#FFD800",
				"Builtin":     "#FFD800",
				"Property":    "#FFD800",
				"Tag":         "#FFD800",
				"AttrName":    "#FFD800",
				"AttrValue":   "#FFFFFF"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Impact, 'Arial Black', sans-serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#FFC000",
		"Accent": "#FFD700",
		"Muted": "#AA7700",
		"Light": "#7B0000",
		"WarmBeige": "#800000",
		"TealTint": "#6B0000",
		"Lavender": "#780000",
		"AmberTint": "#7A1000",
		"PdfFill": "#6B0000",
		"PdfText": "#FFFF00"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.407Z",
	"CompilerVersion": 1
}
},{}],192:[function(require,module,exports){
module.exports={
	"Hash": "mobile-debug",
	"Name": "Mobile Container Debug",
	"Category": "Debug",
	"Version": "0.0.1",
	"Description": "Unique color per container for layout debugging Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#FF0000",
				"Secondary": "#00CCCC",
				"Tertiary": "#00AA00",
				"Panel": "#FFAA00",
				"Viewer": "#333333",
				"Hover": "rgba(255, 255, 255, 0.2)",
				"Selected": "rgba(255, 255, 255, 0.3)",
				"Thumb": "#AA00AA"
			},
			"Text": {
				"Primary": "#FFFFFF",
				"Secondary": "#EEEEEE",
				"Muted": "#CCCCCC",
				"Dim": "#AAAAAA",
				"Placeholder": "#888888"
			},
			"Brand": {
				"Accent": "#FFFF00",
				"AccentHover": "#FFFF88"
			},
			"Border": {
				"Default": "#FFFFFF",
				"Light": "#CCCCCC"
			},
			"Status": {
				"Danger": "#FF0000",
				"DangerMuted": "#CC4444"
			},
			"Scrollbar": {
				"Track": "#888888",
				"Hover": "#AAAAAA"
			},
			"Selection": {
				"Background": "rgba(255, 255, 0, 0.3)"
			},
			"Focus": {
				"Outline": "#FFFF00"
			},
			"Syntax": {
				"Keyword":     "#A626A4",
				"String":      "#50A14F",
				"Number":      "#986801",
				"Comment":     "#A0A1A7",
				"Operator":    "#0184BC",
				"Punctuation": "#383A42",
				"Function":    "#4078F2",
				"Variable":    "#383A42",
				"Type":        "#C18401",
				"Builtin":     "#986801",
				"Property":    "#E45649",
				"Tag":         "#E45649",
				"AttrName":    "#986801",
				"AttrValue":   "#50A14F"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#FFFFFF",
		"Accent": "#FFFF00",
		"Muted": "#CCCCCC",
		"Light": "#333333",
		"WarmBeige": "#FFAA00",
		"TealTint": "#00CCCC",
		"Lavender": "#AA00AA",
		"AmberTint": "#FFAA00",
		"PdfFill": "#FF4444",
		"PdfText": "#FFFFFF"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],193:[function(require,module,exports){
module.exports={
	"Hash": "neo-tokyo",
	"Name": "Neo-Tokyo",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Neon pink on dark navy Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0D0D2B",
				"Secondary": "#080820",
				"Tertiary": "#121235",
				"Panel": "#0F0F28",
				"Viewer": "#060615",
				"Hover": "#1A1A42",
				"Selected": "#2A1845",
				"Thumb": "#080820"
			},
			"Text": {
				"Primary": "#E8E0F0",
				"Secondary": "#D0C8E0",
				"Muted": "#9088A8",
				"Dim": "#6860A0",
				"Placeholder": "#504888"
			},
			"Brand": {
				"Accent": "#FF2D8A",
				"AccentHover": "#FF5AA0"
			},
			"Border": {
				"Default": "#2A2050",
				"Light": "#382868"
			},
			"Status": {
				"Danger": "#FF4466",
				"DangerMuted": "#AA3355"
			},
			"Scrollbar": {
				"Track": "#2A2050",
				"Hover": "#3A3068"
			},
			"Selection": {
				"Background": "rgba(255, 45, 138, 0.25)"
			},
			"Focus": {
				"Outline": "#FF2D8A"
			},
			"Syntax": {
				"Keyword":     "#FF4E9F",
				"String":      "#A1FFCE",
				"Number":      "#FFD93D",
				"Comment":     "#807A9E",
				"Operator":    "#7DF9FF",
				"Punctuation": "#C0BCEB",
				"Function":    "#FFCC80",
				"Variable":    "#E0D8FF",
				"Type":        "#FFD93D",
				"Builtin":     "#FFD93D",
				"Property":    "#FF6E6E",
				"Tag":         "#FF6E6E",
				"AttrName":    "#FFD93D",
				"AttrValue":   "#A1FFCE"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Courier New', monospace",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0C8E0",
		"Accent": "#FF2D8A",
		"Muted": "#6860A0",
		"Light": "#121235",
		"WarmBeige": "#141438",
		"TealTint": "#100E30",
		"Lavender": "#141232",
		"AmberTint": "#1A1228",
		"PdfFill": "#1A1028",
		"PdfText": "#FF4466"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],194:[function(require,module,exports){
module.exports={
	"Hash": "night",
	"Name": "Night",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Near-black, minimal contrast Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#0A0A0A",
				"Secondary": "#060606",
				"Tertiary": "#0E0E0E",
				"Panel": "#0C0C0C",
				"Viewer": "#040404",
				"Hover": "#161616",
				"Selected": "#252525",
				"Thumb": "#060606"
			},
			"Text": {
				"Primary": "#888888",
				"Secondary": "#707070",
				"Muted": "#555555",
				"Dim": "#444444",
				"Placeholder": "#333333"
			},
			"Brand": {
				"Accent": "#666666",
				"AccentHover": "#808080"
			},
			"Border": {
				"Default": "#1A1A1A",
				"Light": "#222222"
			},
			"Status": {
				"Danger": "#AA4444",
				"DangerMuted": "#663333"
			},
			"Scrollbar": {
				"Track": "#1A1A1A",
				"Hover": "#2A2A2A"
			},
			"Selection": {
				"Background": "rgba(102, 102, 102, 0.2)"
			},
			"Focus": {
				"Outline": "#666666"
			},
			"Syntax": {
				"Keyword":     "#C28FFF",
				"String":      "#B0E0B0",
				"Number":      "#FFA070",
				"Comment":     "#888888",
				"Operator":    "#80C8FF",
				"Punctuation": "#BBBBBB",
				"Function":    "#FFD080",
				"Variable":    "#DDDDDD",
				"Type":        "#FFB870",
				"Builtin":     "#FFB870",
				"Property":    "#FF9090",
				"Tag":         "#FF9090",
				"AttrName":    "#FFB870",
				"AttrValue":   "#B0E0B0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#707070",
		"Accent": "#666666",
		"Muted": "#444444",
		"Light": "#0E0E0E",
		"WarmBeige": "#121212",
		"TealTint": "#0C0C0C",
		"Lavender": "#101010",
		"AmberTint": "#141210",
		"PdfFill": "#141010",
		"PdfText": "#AA4444"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],195:[function(require,module,exports){
module.exports={
	"Hash": "ocean",
	"Name": "Ocean",
	"Version": "0.0.1",
	"Description": "Cool blue-greens (180-235°) with warm coral / amber punctuation (5-30°). Paired light/dark; feels like sea + sun on the horizon.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#f4f9fb", "Dark": "#0e1820" },
				"Secondary": { "Light": "#e8f1f5", "Dark": "#15212b" },
				"Tertiary":  { "Light": "#dde9ee", "Dark": "#1f2c38" },
				"Panel":     { "Light": "#ffffff", "Dark": "#1a2632" },
				"Hover":     { "Light": "#e0eef3", "Dark": "#26323f" },
				"Selected":  { "Light": "#c8e1ea", "Dark": "#1e3a48" }
			},
			"Text": {
				"Primary":     { "Light": "#0e2832", "Dark": "#e1ecf0" },
				"Secondary":   { "Light": "#3a5662", "Dark": "#a8c0c8" },
				"Muted":       { "Light": "#6c828b", "Dark": "#7a8e96" },
				"Placeholder": { "Light": "#90a4ad", "Dark": "#5a6e76" }
			},
			"Brand": {
				"Primary":      { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"PrimaryHover": { "Light": "#0a6371", "Dark": "#6dd4e2" },
				"Accent":       { "Light": "#e8a050", "Dark": "#f0b878" }
			},
			"Border": {
				"Default": { "Light": "#c0d5dc", "Dark": "#2c3d49" },
				"Light":   { "Light": "#d8e6ec", "Dark": "#1f2c38" },
				"Strong":  { "Light": "#90b0bc", "Dark": "#4a6470" }
			},
			"Status": {
				"Success": { "Light": "#1f8a52", "Dark": "#4dc97a" },
				"Warning": { "Light": "#d68910", "Dark": "#f0b020" },
				"Error":   { "Light": "#c93a3a", "Dark": "#ff6464" },
				"Info":    { "Light": "#0e7c8a", "Dark": "#4dc4d4" }
			},
			"Data": {
				"1": { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"2": { "Light": "#e8a050", "Dark": "#f0b878" },
				"3": { "Light": "#1f8a52", "Dark": "#4dc97a" },
				"4": { "Light": "#c93a3a", "Dark": "#ff6464" },
				"5": { "Light": "#b07bac", "Dark": "#cda6cf" },
				"6": { "Light": "#d68910", "Dark": "#f0b020" },
				"7": { "Light": "#5a7f9e", "Dark": "#82a0c4" },
				"8": { "Light": "#6c828b", "Dark": "#a8c0c8" }
			},
			"Scrollbar": {
				"Track": { "Light": "#dde9ee", "Dark": "#15212b" },
				"Thumb": { "Light": "#a8c2cc", "Dark": "#324658" },
				"Hover": { "Light": "#7a99a4", "Dark": "#506876" }
			},
			"Selection": {
				"Background": { "Light": "#c8e1ea", "Dark": "#1e3a48" },
				"Text":       { "Light": "#0e2832", "Dark": "#e1ecf0" }
			},
			"Focus": {
				"Outline": { "Light": "#0e7c8a", "Dark": "#4dc4d4" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(14, 40, 50, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"String":      { "Light": "#1f8a52", "Dark": "#4dc97a" },
				"Number":      { "Light": "#d68910", "Dark": "#f0b020" },
				"Comment":     { "Light": "#90a4ad", "Dark": "#5a6e76" },
				"Operator":    { "Light": "#3a5662", "Dark": "#a8c0c8" },
				"Punctuation": { "Light": "#3a5662", "Dark": "#a8c0c8" },
				"Function":    { "Light": "#0e7c8a", "Dark": "#4dc4d4" },
				"Variable":    { "Light": "#0e2832", "Dark": "#e1ecf0" },
				"Type":        { "Light": "#e8a050", "Dark": "#f0b878" },
				"Builtin":     { "Light": "#d68910", "Dark": "#f0b020" },
				"Property":    { "Light": "#c93a3a", "Dark": "#ff6464" },
				"Tag":         { "Light": "#c93a3a", "Dark": "#ff6464" },
				"AttrName":    { "Light": "#d68910", "Dark": "#f0b020" },
				"AttrValue":   { "Light": "#1f8a52", "Dark": "#4dc97a" }
			},
			"Editor": {
				"LineNumberBackground": { "Light": "#e8f1f5", "Dark": "#15212b" },
				"LineNumberText":       { "Light": "#90a4ad", "Dark": "#5a6e76" },
				"CurrentLineHighlight": { "Light": "#e0eef3", "Dark": "#26323f" },
				"SelectionBackground":  { "Light": "#c8e1ea", "Dark": "#1e3a48" },
				"GutterBorder":         { "Light": "#d8e6ec", "Dark": "#1f2c38" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Ocean",
		"Tagline": "Cool waters, warm sun"
	}
}

},{}],196:[function(require,module,exports){
module.exports={
	"Hash": "pict-default",
	"Name": "Pict Default",
	"Version": "0.0.1",
	"Description": "The reference paired light/dark theme for pict-based applications. Neutral palette suitable for any app; dark mode is mid-grey rather than pure black to reduce eye strain.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#1a1a1a" },
				"Secondary": { "Light": "#f5f5f5", "Dark": "#242424" },
				"Tertiary":  { "Light": "#ebebeb", "Dark": "#2e2e2e" },
				"Panel":     { "Light": "#ffffff", "Dark": "#222222" },
				"Hover":     { "Light": "#f0f0f0", "Dark": "#2a2a2a" },
				"Selected":  { "Light": "#e0eaff", "Dark": "#2a3550" }
			},
			"Text": {
				"Primary":     { "Light": "#1a1a1a", "Dark": "#ededed" },
				"Secondary":   { "Light": "#454545", "Dark": "#bdbdbd" },
				"Muted":       { "Light": "#6b6b6b", "Dark": "#888888" },
				"Placeholder": { "Light": "#9a9a9a", "Dark": "#6a6a6a" }
			},
			"Brand": {
				"Primary":      { "Light": "#3357c7", "Dark": "#6b8eff" },
				"PrimaryHover": { "Light": "#2848b3", "Dark": "#88a4ff" },
				"Accent":       { "Light": "#c75033", "Dark": "#ff8a6b" }
			},
			"Border": {
				"Default": { "Light": "#d6d6d6", "Dark": "#3a3a3a" },
				"Light":   { "Light": "#e9e9e9", "Dark": "#2c2c2c" },
				"Strong":  { "Light": "#a0a0a0", "Dark": "#5a5a5a" }
			},
			"Status": {
				"Success": { "Light": "#2e7a3a", "Dark": "#5fc377" },
				"Warning": { "Light": "#a86b00", "Dark": "#f0b84a" },
				"Error":   { "Light": "#b62828", "Dark": "#ff7373" },
				"Info":    { "Light": "#1f6fb5", "Dark": "#5fb4ff" }
			},
			"Data": {
				"1": { "Light": "#3357c7", "Dark": "#6b8eff" },
				"2": { "Light": "#c75033", "Dark": "#ff8a6b" },
				"3": { "Light": "#2e7a3a", "Dark": "#5fc377" },
				"4": { "Light": "#a86b00", "Dark": "#f0b84a" },
				"5": { "Light": "#6b3aac", "Dark": "#b08eff" },
				"6": { "Light": "#1f6fb5", "Dark": "#5fb4ff" },
				"7": { "Light": "#c63a8e", "Dark": "#ff7fb6" },
				"8": { "Light": "#6b6b6b", "Dark": "#bdbdbd" }
			},
			"Scrollbar": {
				"Track": { "Light": "#ebebeb", "Dark": "#1f1f1f" },
				"Thumb": { "Light": "#c2c2c2", "Dark": "#3f3f3f" },
				"Hover": { "Light": "#a0a0a0", "Dark": "#5a5a5a" }
			},
			"Selection": {
				"Background": { "Light": "#bcd2ff", "Dark": "#3a4f7a" },
				"Text":       { "Light": "#1a1a1a", "Dark": "#ededed" }
			},
			"Focus": {
				"Outline": { "Light": "#3357c7", "Dark": "#6b8eff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#a626a4", "Dark": "#c678dd" },
				"String":      { "Light": "#50a14f", "Dark": "#98c379" },
				"Number":      { "Light": "#986801", "Dark": "#d19a66" },
				"Comment":     { "Light": "#a0a1a7", "Dark": "#7f848e" },
				"Operator":    { "Light": "#0184bc", "Dark": "#56b6c2" },
				"Punctuation": { "Light": "#383a42", "Dark": "#abb2bf" },
				"Function":    { "Light": "#4078f2", "Dark": "#61afef" },
				"Variable":    { "Light": "#383a42", "Dark": "#e06c75" },
				"Type":        { "Light": "#c18401", "Dark": "#e5c07b" },
				"Builtin":     { "Light": "#986801", "Dark": "#d19a66" },
				"Property":    { "Light": "#e45649", "Dark": "#e06c75" },
				"Tag":         { "Light": "#e45649", "Dark": "#e06c75" },
				"AttrName":    { "Light": "#986801", "Dark": "#d19a66" },
				"AttrValue":   { "Light": "#50a14f", "Dark": "#98c379" }
			},
			"Editor": {
				"LineNumberBackground": { "Light": "#f5f5f5", "Dark": "#1f1f1f" },
				"LineNumberText":       { "Light": "#9a9a9a", "Dark": "#6a6a6a" },
				"CurrentLineHighlight": { "Light": "#f0f0f0", "Dark": "#2a2a2a" },
				"SelectionBackground":  { "Light": "#bcd2ff", "Dark": "#3a4f7a" },
				"GutterBorder":         { "Light": "#e9e9e9", "Dark": "#2c2c2c" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Pict",
		"Tagline": "A JavaScript MVC framework for building web applications."
	},
	"CSS": [
		{
			"Hash": "pict-default-brand-accents",
			"Priority": 600,
			"Content": "/* pict-default — subtle brand-aware accents.\n   Falls back gracefully to theme-color tokens when no brand is registered,\n   so non-branded apps still look right. */\na { text-decoration-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, currentColor)); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 2px solid var(--brand-color-primary-mode, var(--theme-color-border-default, transparent)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-light, transparent)); padding-bottom: 4px; }"
		}
	]
}

},{}],197:[function(require,module,exports){
module.exports={
	"Hash": "playground-corp",
	"Name": "Playground Corp",
	"Version": "0.0.1",
	"Description": "A different paired starter — corporate teal palette, rounder corners.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#fbfbfd", "Dark": "#0e1416" },
				"Secondary": { "Light": "#eef3f6", "Dark": "#152024" },
				"Tertiary":  { "Light": "#dde7ec", "Dark": "#1e2c30" },
				"Panel":     { "Light": "#ffffff", "Dark": "#162126" },
				"Hover":     { "Light": "#e5edf1", "Dark": "#1d292e" }
			},
			"Text": {
				"Primary":     { "Light": "#0a1d22", "Dark": "#e3edf0" },
				"Secondary":   { "Light": "#3a5b65", "Dark": "#a8c0c8" },
				"Muted":       { "Light": "#647e87", "Dark": "#7a929a" },
				"OnBrand":     { "Light": "#ffffff", "Dark": "#ffffff" }
			},
			"Brand": {
				"Primary":      { "Light": "#117a8b", "Dark": "#3ec0d4" },
				"PrimaryHover": { "Light": "#0e6271", "Dark": "#5fd0e0" },
				"Accent":       { "Light": "#d97706", "Dark": "#fb923c" }
			},
			"Border": {
				"Default": { "Light": "#cfdce1", "Dark": "#2c3a3f" },
				"Strong":  { "Light": "#86a3ac", "Dark": "#4d5e64" }
			},
			"Status": {
				"Success": { "Light": "#0f7a52", "Dark": "#34d399" },
				"Warning": { "Light": "#b45309", "Dark": "#fbbf24" },
				"Error":   { "Light": "#9f1239", "Dark": "#fb7185" },
				"Info":    { "Light": "#1e6fbe", "Dark": "#60a5fa" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#a626a4", "Dark": "#c678dd" },
				"String":      { "Light": "#50a14f", "Dark": "#98c379" },
				"Number":      { "Light": "#986801", "Dark": "#d19a66" },
				"Comment":     { "Light": "#a0a1a7", "Dark": "#7f848e" },
				"Operator":    { "Light": "#0184bc", "Dark": "#56b6c2" },
				"Punctuation": { "Light": "#383a42", "Dark": "#abb2bf" },
				"Function":    { "Light": "#4078f2", "Dark": "#61afef" },
				"Variable":    { "Light": "#383a42", "Dark": "#e06c75" },
				"Type":        { "Light": "#c18401", "Dark": "#e5c07b" },
				"Builtin":     { "Light": "#986801", "Dark": "#d19a66" },
				"Property":    { "Light": "#e45649", "Dark": "#e06c75" },
				"Tag":         { "Light": "#e45649", "Dark": "#e06c75" },
				"AttrName":    { "Light": "#986801", "Dark": "#d19a66" },
				"AttrValue":   { "Light": "#50a14f", "Dark": "#98c379" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Inter, system-ui, sans-serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.25rem"
			},
			"Weight": {
				"Regular": "400",
				"Bold": "700"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "14px",
			"LG": "20px",
			"XL": "28px"
		},
		"Radius": {
			"SM": "4px",
			"MD": "10px",
			"LG": "16px"
		}
	},
	"Brand": {
		"Name": "Corp"
	},
	"Aliases": {
		"--pict-modal-overlay-bg":          "Color.Background.Tertiary",
		"--pict-modal-bg":                  "Color.Background.Panel",
		"--pict-modal-fg":                  "Color.Text.Primary",
		"--pict-modal-border":              "Color.Border.Default",
		"--pict-modal-shadow":              "Color.Border.Strong",
		"--pict-modal-header-bg":           "Color.Background.Secondary",
		"--pict-modal-header-fg":           "Color.Text.Primary",
		"--pict-modal-header-border":       "Color.Border.Default",
		"--pict-modal-btn-bg":              "Color.Background.Secondary",
		"--pict-modal-btn-fg":              "Color.Text.Primary",
		"--pict-modal-btn-hover-bg":        "Color.Background.Hover",
		"--pict-modal-btn-primary-bg":      "Color.Brand.Primary",
		"--pict-modal-btn-primary-fg":      "Color.Text.OnBrand",
		"--pict-modal-btn-primary-hover-bg":"Color.Brand.PrimaryHover",
		"--pict-modal-btn-danger-bg":       "Color.Status.Error",
		"--pict-modal-btn-danger-fg":       "Color.Text.OnBrand",
		"--pict-modal-btn-danger-hover-bg": "Color.Status.Error",
		"--pict-modal-toast-bg":            "Color.Background.Panel",
		"--pict-modal-toast-fg":            "Color.Text.Primary",
		"--pict-modal-toast-shadow":        "Color.Border.Strong",
		"--pict-modal-toast-success-bg":    "Color.Status.Success",
		"--pict-modal-toast-error-bg":      "Color.Status.Error",
		"--pict-modal-toast-warning-bg":    "Color.Status.Warning",
		"--pict-modal-toast-info-bg":       "Color.Status.Info",
		"--pict-modal-tooltip-bg":          "Color.Background.Tertiary",
		"--pict-modal-tooltip-fg":          "Color.Text.Primary",
		"--pict-modal-font-family":         "Typography.Family.Sans",

		"--pict-um-bg":          "Color.Background.Panel",
		"--pict-um-fg":          "Color.Text.Primary",
		"--pict-um-muted":       "Color.Text.Muted",
		"--pict-um-accent":      "Color.Brand.Primary",
		"--pict-um-border":      "Color.Border.Default",
		"--pict-um-border-soft": "Color.Border.Light",
		"--pict-um-input-bg":    "Color.Background.Primary",
		"--pict-um-pill-bg":     "Color.Background.Tertiary",
		"--pict-um-font":        "Typography.Family.Sans"
	}
}

},{}],198:[function(require,module,exports){
module.exports={
	"Hash": "retold-content-system",
	"Name": "Retold Content System",
	"Version": "0.0.1",
	"Description": "Default palette for the Retold Content System editor — warm beige with teal accents. Light side preserves the original retold-content-system.css palette verbatim; dark side keeps the teal accent and warms the backgrounds into a deep walnut/charcoal range so dark mode reads as the same family of values rather than a generic dark theme.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#F5F3EE", "Dark": "#1F1B17" },
				"Secondary": { "Light": "#FAF8F4", "Dark": "#2A251F" },
				"Tertiary":  { "Light": "#F0EDE8", "Dark": "#332D26" },
				"Panel":     { "Light": "#FFFFFF", "Dark": "#26221C" },
				"Hover":     { "Light": "#EDE9E3", "Dark": "#383028" },
				"Selected":  { "Light": "#DCE9E7", "Dark": "#1E3833" }
			},
			"Text": {
				"Primary":     { "Light": "#3D3229", "Dark": "#E8DCC8" },
				"Secondary":   { "Light": "#5E5549", "Dark": "#C0B5A4" },
				"Muted":       { "Light": "#8A7F72", "Dark": "#8E8478" },
				"Placeholder": { "Light": "#A89E91", "Dark": "#6E6457" },
				"OnBrand":     { "Light": "#FFFFFF", "Dark": "#1F1B17" }
			},
			"Brand": {
				"Primary":      { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"PrimaryHover": { "Light": "#3A9E92", "Dark": "#65CBBE" },
				"Accent":       { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"AccentHover":  { "Light": "#3A9E92", "Dark": "#65CBBE" }
			},
			"Border": {
				"Default": { "Light": "#DDD6CA", "Dark": "#3F362C" },
				"Light":   { "Light": "#E8E2D7", "Dark": "#33291F" },
				"Strong":  { "Light": "#C4BDB0", "Dark": "#5A4F40" }
			},
			"Status": {
				"Success": { "Light": "#7BC47F", "Dark": "#8FD493" },
				"Warning": { "Light": "#E8A94D", "Dark": "#F0BE6E" },
				"Error":   { "Light": "#D9534F", "Dark": "#E87B78" },
				"Info":    { "Light": "#5DA6C7", "Dark": "#7FBDD8" }
			},
			"Data": {
				"1": { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"2": { "Light": "#E8A94D", "Dark": "#F0BE6E" },
				"3": { "Light": "#7BC47F", "Dark": "#8FD493" },
				"4": { "Light": "#D9534F", "Dark": "#E87B78" },
				"5": { "Light": "#A07ACC", "Dark": "#BCA0DC" },
				"6": { "Light": "#5DA6C7", "Dark": "#7FBDD8" },
				"7": { "Light": "#C46B8A", "Dark": "#D8919E" },
				"8": { "Light": "#8A7F72", "Dark": "#B8AFA4" }
			},
			"Scrollbar": {
				"Track": { "Light": "#F5F0E8", "Dark": "#26221C" },
				"Thumb": { "Light": "#C4BDB0", "Dark": "#4A4036" },
				"Hover": { "Light": "#8A7F72", "Dark": "#6A5F50" }
			},
			"Selection": {
				"Background": { "Light": "#CDE3E0", "Dark": "#2E5B55" },
				"Text":       { "Light": "#3D3229", "Dark": "#E8DCC8" }
			},
			"Focus": {
				"Outline": { "Light": "#2E7D74", "Dark": "#4FB3A6" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(61, 50, 41, 0.12)", "Dark": "rgba(0, 0, 0, 0.55)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#A0532E", "Dark": "#E89A6E" },
				"String":      { "Light": "#3F8A52", "Dark": "#8FD493" },
				"Number":      { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Comment":     { "Light": "#8A7F72", "Dark": "#8E8478" },
				"Operator":    { "Light": "#2E7D74", "Dark": "#4FB3A6" },
				"Punctuation": { "Light": "#5E5549", "Dark": "#C0B5A4" },
				"Function":    { "Light": "#2E5E96", "Dark": "#7FBDD8" },
				"Variable":    { "Light": "#3D3229", "Dark": "#E8DCC8" },
				"Type":        { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Builtin":     { "Light": "#A86B00", "Dark": "#E8A94D" },
				"Property":    { "Light": "#A0532E", "Dark": "#E89A6E" },
				"Tag":         { "Light": "#A0532E", "Dark": "#E89A6E" },
				"AttrName":    { "Light": "#A86B00", "Dark": "#E8A94D" },
				"AttrValue":   { "Light": "#3F8A52", "Dark": "#8FD493" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth":    "250px",
			"TopbarHeight":    "48px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Content",
		"Tagline": "Author content for the Retold ecosystem."
	}
}

},{}],199:[function(require,module,exports){
module.exports={
	"Hash": "retold-default",
	"Name": "Retold Default",
	"Version": "0.0.1",
	"Description": "The canonical paired light/dark theme for the Retold ecosystem. Neutral palette suitable for any retold-based app; dark mode is mid-grey rather than pure black to reduce eye strain.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ffffff",
					"Dark": "#1a1a1a"
				},
				"Secondary": {
					"Light": "#f5f5f5",
					"Dark": "#242424"
				},
				"Tertiary": {
					"Light": "#ebebeb",
					"Dark": "#2e2e2e"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#222222"
				},
				"Hover": {
					"Light": "#f0f0f0",
					"Dark": "#2a2a2a"
				},
				"Selected": {
					"Light": "#e0eaff",
					"Dark": "#2a3550"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1a1a",
					"Dark": "#ededed"
				},
				"Secondary": {
					"Light": "#454545",
					"Dark": "#bdbdbd"
				},
				"Muted": {
					"Light": "#6b6b6b",
					"Dark": "#888888"
				},
				"Placeholder": {
					"Light": "#9a9a9a",
					"Dark": "#6a6a6a"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#3357c7",
					"Dark": "#6b8eff"
				},
				"PrimaryHover": {
					"Light": "#2848b3",
					"Dark": "#88a4ff"
				},
				"Accent": {
					"Light": "#c75033",
					"Dark": "#ff8a6b"
				}
			},
			"Border": {
				"Default": {
					"Light": "#d6d6d6",
					"Dark": "#3a3a3a"
				},
				"Light": {
					"Light": "#e9e9e9",
					"Dark": "#2c2c2c"
				},
				"Strong": {
					"Light": "#a0a0a0",
					"Dark": "#5a5a5a"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2e7a3a",
					"Dark": "#5fc377"
				},
				"Warning": {
					"Light": "#a86b00",
					"Dark": "#f0b84a"
				},
				"Error": {
					"Light": "#b62828",
					"Dark": "#ff7373"
				},
				"Info": {
					"Light": "#1f6fb5",
					"Dark": "#5fb4ff"
				}
			},
			"Data": {
				"1": {
					"Light": "#3357c7",
					"Dark": "#6b8eff"
				},
				"2": {
					"Light": "#c75033",
					"Dark": "#ff8a6b"
				},
				"3": {
					"Light": "#2e7a3a",
					"Dark": "#5fc377"
				},
				"4": {
					"Light": "#a86b00",
					"Dark": "#f0b84a"
				},
				"5": {
					"Light": "#6b3aac",
					"Dark": "#b08eff"
				},
				"6": {
					"Light": "#1f6fb5",
					"Dark": "#5fb4ff"
				},
				"7": {
					"Light": "#c63a8e",
					"Dark": "#ff7fb6"
				},
				"8": {
					"Light": "#6b6b6b",
					"Dark": "#bdbdbd"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#ebebeb",
					"Dark": "#1f1f1f"
				},
				"Thumb": {
					"Light": "#c2c2c2",
					"Dark": "#3f3f3f"
				},
				"Hover": {
					"Light": "#a0a0a0",
					"Dark": "#5a5a5a"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#bcd2ff",
					"Dark": "#3a4f7a"
				},
				"Text": {
					"Light": "#1a1a1a",
					"Dark": "#ededed"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#3357c7",
					"Dark": "#6b8eff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0, 0, 0, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#a626a4",
					"Dark": "#c678dd"
				},
				"String": {
					"Light": "#50a14f",
					"Dark": "#98c379"
				},
				"Number": {
					"Light": "#986801",
					"Dark": "#d19a66"
				},
				"Comment": {
					"Light": "#a0a1a7",
					"Dark": "#7f848e"
				},
				"Operator": {
					"Light": "#0184bc",
					"Dark": "#56b6c2"
				},
				"Punctuation": {
					"Light": "#383a42",
					"Dark": "#abb2bf"
				},
				"Function": {
					"Light": "#4078f2",
					"Dark": "#61afef"
				},
				"Variable": {
					"Light": "#383a42",
					"Dark": "#e06c75"
				},
				"Type": {
					"Light": "#c18401",
					"Dark": "#e5c07b"
				},
				"Builtin": {
					"Light": "#986801",
					"Dark": "#d19a66"
				},
				"Property": {
					"Light": "#e45649",
					"Dark": "#e06c75"
				},
				"Tag": {
					"Light": "#e45649",
					"Dark": "#e06c75"
				},
				"AttrName": {
					"Light": "#986801",
					"Dark": "#d19a66"
				},
				"AttrValue": {
					"Light": "#50a14f",
					"Dark": "#98c379"
				}
			},
			"Editor": {
				"LineNumberBackground": {
					"Light": "#f5f5f5",
					"Dark": "#1f1f1f"
				},
				"LineNumberText": {
					"Light": "#9a9a9a",
					"Dark": "#6a6a6a"
				},
				"CurrentLineHighlight": {
					"Light": "#f0f0f0",
					"Dark": "#2a2a2a"
				},
				"SelectionBackground": {
					"Light": "#bcd2ff",
					"Dark": "#3a4f7a"
				},
				"GutterBorder": {
					"Light": "#e9e9e9",
					"Dark": "#2c2c2c"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Retold",
		"Tagline": "What is software if not a tool to tell stories."
	},
	"CSS": [
		{
			"Hash": "retold-default-brand-accents",
			"Priority": 600,
			"Content": "/* pict-default \u2014 subtle brand-aware accents.\n   Falls back gracefully to theme-color tokens when no brand is registered,\n   so non-branded apps still look right. */\na { text-decoration-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, currentColor)); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 2px solid var(--brand-color-primary-mode, var(--theme-color-border-default, transparent)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-light, transparent)); padding-bottom: 4px; }"
		}
	]
}
},{}],200:[function(require,module,exports){
module.exports={
	"Hash": "retold-labs-cyberpunk",
	"Name": "Retold Labs Cyberpunk",
	"Version": "0.0.1",
	"Description": "retold-labs’ neon \"cyberpunk\" identity — cyan/magenta on near-black (dark) or violet on light. Preserves the original cyberpunk-light / cyberpunk-dark palettes verbatim.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#eae8f0",
					"Dark": "#0a0a12"
				},
				"Secondary": {
					"Light": "#ddd8ea",
					"Dark": "#12101e"
				},
				"Tertiary": {
					"Light": "#ddd8ea",
					"Dark": "#12101e"
				},
				"Panel": {
					"Light": "#f4f2fa",
					"Dark": "#1a1628"
				},
				"Sidebar": {
					"Light": "#1e1430",
					"Dark": "#06060e"
				},
				"Hover": {
					"Light": "rgba(130, 0, 200, 0.06)",
					"Dark": "rgba(0, 255, 255, 0.08)"
				},
				"Selected": {
					"Light": "rgba(138, 0, 212, 0.10)",
					"Dark": "rgba(0, 229, 255, 0.12)"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1028",
					"Dark": "#e8e0f0"
				},
				"Secondary": {
					"Light": "#4a3868",
					"Dark": "#b0a8c8"
				},
				"Muted": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				},
				"Placeholder": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				},
				"OnBrand": {
					"Light": "#d0c8e0",
					"Dark": "#d0c8e0"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"PrimaryHover": {
					"Light": "#b040f0",
					"Dark": "#60f0ff"
				},
				"Accent": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"AccentHover": {
					"Light": "#b040f0",
					"Dark": "#60f0ff"
				}
			},
			"Border": {
				"Default": {
					"Light": "#c8c0d8",
					"Dark": "#2a2440"
				},
				"Light": {
					"Light": "#c8c0d8",
					"Dark": "#2a2440"
				},
				"Strong": {
					"Light": "#2a2040",
					"Dark": "#1a1430"
				}
			},
			"Status": {
				"Success": {
					"Light": "#00a050",
					"Dark": "#39ff14"
				},
				"Warning": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Error": {
					"Light": "#c82050",
					"Dark": "#ff3860"
				},
				"Info": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#ddd8ea",
					"Dark": "#12101e"
				},
				"Thumb": {
					"Light": "#c8c0d8",
					"Dark": "#2a2440"
				},
				"Hover": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				}
			},
			"Selection": {
				"Background": {
					"Light": "rgba(138, 0, 212, 0.10)",
					"Dark": "rgba(0, 229, 255, 0.12)"
				},
				"Text": {
					"Light": "#1a1028",
					"Dark": "#e8e0f0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(26, 16, 40, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"String": {
					"Light": "#00a050",
					"Dark": "#39ff14"
				},
				"Number": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Comment": {
					"Light": "#7a6a98",
					"Dark": "#6a6488"
				},
				"Operator": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"Punctuation": {
					"Light": "#4a3868",
					"Dark": "#b0a8c8"
				},
				"Function": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"Variable": {
					"Light": "#1a1028",
					"Dark": "#e8e0f0"
				},
				"Type": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Builtin": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"Property": {
					"Light": "#c82050",
					"Dark": "#ff3860"
				},
				"Tag": {
					"Light": "#8a00d4",
					"Dark": "#00e5ff"
				},
				"AttrName": {
					"Light": "#d41878",
					"Dark": "#ff2ec4"
				},
				"AttrValue": {
					"Light": "#00a050",
					"Dark": "#39ff14"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "230px",
			"TopbarHeight": "52px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Labs",
		"Tagline": "Run, compare, and distribute ML experiments across the mesh"
	}
}

},{}],201:[function(require,module,exports){
module.exports={
	"Hash": "retold-labs-retro",
	"Name": "Retold Labs Retro",
	"Version": "0.0.1",
	"Description": "retold-labs’ \"retro\" identity — amber/green phosphor on dark or sepia/olive on light. Preserves the original retro-light / retro-dark palettes verbatim.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#f5f0e0",
					"Dark": "#0c0c08"
				},
				"Secondary": {
					"Light": "#ebe4d0",
					"Dark": "#161610"
				},
				"Tertiary": {
					"Light": "#ebe4d0",
					"Dark": "#161610"
				},
				"Panel": {
					"Light": "#faf6e8",
					"Dark": "#1e1e14"
				},
				"Sidebar": {
					"Light": "#3a3020",
					"Dark": "#080804"
				},
				"Hover": {
					"Light": "rgba(140, 80, 20, 0.06)",
					"Dark": "rgba(255, 176, 0, 0.08)"
				},
				"Selected": {
					"Light": "rgba(140, 80, 20, 0.10)",
					"Dark": "rgba(255, 176, 0, 0.12)"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#2e2418",
					"Dark": "#d0c8a0"
				},
				"Secondary": {
					"Light": "#5c4a30",
					"Dark": "#a09870"
				},
				"Muted": {
					"Light": "#8a7450",
					"Dark": "#706848"
				},
				"Placeholder": {
					"Light": "#8a7450",
					"Dark": "#706848"
				},
				"OnBrand": {
					"Light": "#d8c8a0",
					"Dark": "#c8b870"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"PrimaryHover": {
					"Light": "#b06820",
					"Dark": "#ffc840"
				},
				"Accent": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"AccentHover": {
					"Light": "#b06820",
					"Dark": "#ffc840"
				}
			},
			"Border": {
				"Default": {
					"Light": "#d0c4a8",
					"Dark": "#2a2a1e"
				},
				"Light": {
					"Light": "#d0c4a8",
					"Dark": "#2a2a1e"
				},
				"Strong": {
					"Light": "#4a4030",
					"Dark": "#1a1a10"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Warning": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Error": {
					"Light": "#a03020",
					"Dark": "#e04030"
				},
				"Info": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#ebe4d0",
					"Dark": "#161610"
				},
				"Thumb": {
					"Light": "#d0c4a8",
					"Dark": "#2a2a1e"
				},
				"Hover": {
					"Light": "#8a7450",
					"Dark": "#706848"
				}
			},
			"Selection": {
				"Background": {
					"Light": "rgba(140, 80, 20, 0.10)",
					"Dark": "rgba(255, 176, 0, 0.12)"
				},
				"Text": {
					"Light": "#2e2418",
					"Dark": "#d0c8a0"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(46, 36, 24, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.55)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"String": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Number": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Comment": {
					"Light": "#8a7450",
					"Dark": "#706848"
				},
				"Operator": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"Punctuation": {
					"Light": "#5c4a30",
					"Dark": "#a09870"
				},
				"Function": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"Variable": {
					"Light": "#2e2418",
					"Dark": "#d0c8a0"
				},
				"Type": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Builtin": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"Property": {
					"Light": "#a03020",
					"Dark": "#e04030"
				},
				"Tag": {
					"Light": "#8c5014",
					"Dark": "#ffb000"
				},
				"AttrName": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				},
				"AttrValue": {
					"Light": "#2e7830",
					"Dark": "#40c850"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "230px",
			"TopbarHeight": "52px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Labs",
		"Tagline": "Run, compare, and distribute ML experiments across the mesh"
	}
}

},{}],202:[function(require,module,exports){
module.exports={
	"Hash": "retold-labs",
	"Name": "Retold Labs",
	"Version": "0.0.1",
	"Description": "retold-labs’ original \"professional\" identity — warm beige with teal accents and a deep teal sidebar. Light side preserves professional-light verbatim; dark side preserves professional-dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#faf6f0",
					"Dark": "#14201e"
				},
				"Secondary": {
					"Light": "#f0ebe2",
					"Dark": "#1a2c2a"
				},
				"Tertiary": {
					"Light": "#f0ebe2",
					"Dark": "#1a2c2a"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#1e3532"
				},
				"Sidebar": {
					"Light": "#1a3a3a",
					"Dark": "#0e1a18"
				},
				"Hover": {
					"Light": "rgba(13, 138, 138, 0.06)",
					"Dark": "rgba(45, 212, 191, 0.08)"
				},
				"Selected": {
					"Light": "rgba(13, 138, 138, 0.10)",
					"Dark": "rgba(45, 212, 191, 0.12)"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#2c2416",
					"Dark": "#e0ebe8"
				},
				"Secondary": {
					"Light": "#5c4f3d",
					"Dark": "#a8bfb8"
				},
				"Muted": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				},
				"Placeholder": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				},
				"OnBrand": {
					"Light": "#c8dcd8",
					"Dark": "#c8dcd8"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"PrimaryHover": {
					"Light": "#14b8a6",
					"Dark": "#5eead4"
				},
				"Accent": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"AccentHover": {
					"Light": "#14b8a6",
					"Dark": "#5eead4"
				}
			},
			"Border": {
				"Default": {
					"Light": "#ddd5c8",
					"Dark": "#2a4a44"
				},
				"Light": {
					"Light": "#ddd5c8",
					"Dark": "#2a4a44"
				},
				"Strong": {
					"Light": "#2a5454",
					"Dark": "#1e3a36"
				}
			},
			"Status": {
				"Success": {
					"Light": "#2e9e5a",
					"Dark": "#4ade80"
				},
				"Warning": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Error": {
					"Light": "#c9442e",
					"Dark": "#f87171"
				},
				"Info": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#f0ebe2",
					"Dark": "#1a2c2a"
				},
				"Thumb": {
					"Light": "#ddd5c8",
					"Dark": "#2a4a44"
				},
				"Hover": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				}
			},
			"Selection": {
				"Background": {
					"Light": "rgba(13, 138, 138, 0.10)",
					"Dark": "rgba(45, 212, 191, 0.12)"
				},
				"Text": {
					"Light": "#2c2416",
					"Dark": "#e0ebe8"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(44, 36, 22, 0.12)",
					"Dark": "rgba(0, 0, 0, 0.45)"
				}
			},
			"Syntax": {
				"Keyword": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"String": {
					"Light": "#2e9e5a",
					"Dark": "#4ade80"
				},
				"Number": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Comment": {
					"Light": "#8a7d6b",
					"Dark": "#6a8a82"
				},
				"Operator": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"Punctuation": {
					"Light": "#5c4f3d",
					"Dark": "#a8bfb8"
				},
				"Function": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"Variable": {
					"Light": "#2c2416",
					"Dark": "#e0ebe8"
				},
				"Type": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Builtin": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"Property": {
					"Light": "#c9442e",
					"Dark": "#f87171"
				},
				"Tag": {
					"Light": "#0d8a8a",
					"Dark": "#2dd4bf"
				},
				"AttrName": {
					"Light": "#e07830",
					"Dark": "#f59e4a"
				},
				"AttrValue": {
					"Light": "#2e9e5a",
					"Dark": "#4ade80"
				}
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono": "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.5",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Layout": {
			"SidebarWidth": "230px",
			"TopbarHeight": "52px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Retold Labs",
		"Tagline": "Run, compare, and distribute ML experiments across the mesh"
	}
}

},{}],203:[function(require,module,exports){
module.exports={
	"Hash": "retold-manager",
	"Name": "Retold Manager",
	"Description": "Default palette for the Retold Manager application — GitHub-style dark on slate with a parallel light variant. Dark side mirrors retold-manager.css's original colors verbatim; light side is a sympathetic translation tuned for daytime use. The retold-manager.css :root block proxies its --color-* names through these --theme-color-* tokens (with the original hexes as fallbacks), so this theme drives the whole app cleanly and other catalog themes still skin most of it.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#f6f8fa", "Dark": "#0e1116" },
				"Secondary": { "Light": "#eef1f4", "Dark": "#161b22" },
				"Tertiary":  { "Light": "#e4e8ec", "Dark": "#1c2128" },
				"Panel":     { "Light": "#ffffff", "Dark": "#161b22" },
				"PanelAlt":  { "Light": "#f0f3f6", "Dark": "#1c2128" },
				"Hover":     { "Light": "#eaeef2", "Dark": "#1c2128" },
				"Selected":  { "Light": "#dbe7ff", "Dark": "#243454" }
			},
			"Border": {
				"Default":   { "Light": "#d0d7de", "Dark": "#30363d" },
				"Light":     { "Light": "#e1e4e8", "Dark": "#21262d" },
				"Strong":    { "Light": "#a8b1bb", "Dark": "#484f58" }
			},
			"Brand": {
				"Primary":      { "Light": "#0969da", "Dark": "#2f81f7" },
				"PrimaryHover": { "Light": "#0550ae", "Dark": "#1f6feb" },
				"Accent":       { "Light": "#0969da", "Dark": "#2f81f7" },
				"AccentHover":  { "Light": "#0550ae", "Dark": "#1f6feb" }
			},
			"Text": {
				"Primary":     { "Light": "#1f2328", "Dark": "#e6edf3" },
				"Secondary":   { "Light": "#3b424a", "Dark": "#c9d1d9" },
				"Muted":       { "Light": "#656d76", "Dark": "#8b949e" },
				"Placeholder": { "Light": "#8c959f", "Dark": "#6e7681" },
				"OnBrand":     { "Light": "#ffffff", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#1a7f37", "Dark": "#3fb950" },
				"Danger":  { "Light": "#cf222e", "Dark": "#f85149" },
				"Warning": { "Light": "#9a6700", "Dark": "#d29922" },
				"Error":   { "Light": "#cf222e", "Dark": "#f85149" },
				"Info":    { "Light": "#0969da", "Dark": "#2f81f7" }
			},
			"Data": {
				"1": { "Light": "#0969da", "Dark": "#2f81f7" },
				"2": { "Light": "#cf222e", "Dark": "#f85149" },
				"3": { "Light": "#1a7f37", "Dark": "#3fb950" },
				"4": { "Light": "#9a6700", "Dark": "#d29922" },
				"5": { "Light": "#8250df", "Dark": "#a371f7" },
				"6": { "Light": "#bf3989", "Dark": "#db61a2" },
				"7": { "Light": "#1b7c83", "Dark": "#39c5cf" },
				"8": { "Light": "#656d76", "Dark": "#8b949e" }
			},
			"Scrollbar": {
				"Track": { "Light": "#eef1f4", "Dark": "#161b22" },
				"Thumb": { "Light": "#c1c8cf", "Dark": "#30363d" },
				"Hover": { "Light": "#a8b1bb", "Dark": "#484f58" }
			},
			"Selection": {
				"Background": { "Light": "#cfe6ff", "Dark": "#243454" },
				"Text":       { "Light": "#1f2328", "Dark": "#e6edf3" }
			},
			"Focus": {
				"Outline": { "Light": "#0969da", "Dark": "#2f81f7" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#cf222e", "Dark": "#ff7b72" },
				"String":      { "Light": "#0a3069", "Dark": "#a5d6ff" },
				"Number":      { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Comment":     { "Light": "#6e7781", "Dark": "#8b949e" },
				"Operator":    { "Light": "#cf222e", "Dark": "#ff7b72" },
				"Punctuation": { "Light": "#24292f", "Dark": "#c9d1d9" },
				"Function":    { "Light": "#8250df", "Dark": "#d2a8ff" },
				"Variable":    { "Light": "#24292f", "Dark": "#c9d1d9" },
				"Type":        { "Light": "#953800", "Dark": "#ffa657" },
				"Builtin":     { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Property":    { "Light": "#0550ae", "Dark": "#79c0ff" },
				"Tag":         { "Light": "#116329", "Dark": "#7ee787" },
				"AttrName":    { "Light": "#8250df", "Dark": "#d2a8ff" },
				"AttrValue":   { "Light": "#0a3069", "Dark": "#a5d6ff" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "-apple-system, BlinkMacSystemFont, \"SF Pro\", \"Segoe UI\", sans-serif",
				"Mono": "ui-monospace, \"SF Mono\", Menlo, Monaco, \"Courier New\", monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "280px",
			"TopbarHeight":    "44px",
			"StatusbarHeight": "28px"
		}
	}
}

},{}],204:[function(require,module,exports){
module.exports={
	"Hash": "retold-mono",
	"Name": "Retold Mono",
	"Version": "0.0.2",
	"Description": "High-contrast monochrome theme — black on white in light mode, white on black in dark mode. Useful for print, simple admin tooling, and as a paired-mode reference theme that proves the toggle works on something visually unmistakable.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "system"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#ffffff", "Dark": "#000000" },
				"Secondary": { "Light": "#f0f0f0", "Dark": "#101010" },
				"Tertiary":  { "Light": "#e2e2e2", "Dark": "#1c1c1c" },
				"Panel":     { "Light": "#ffffff", "Dark": "#000000" },
				"Hover":     { "Light": "#ebebeb", "Dark": "#1a1a1a" },
				"Selected":  { "Light": "#d6d6d6", "Dark": "#2a2a2a" }
			},
			"Text": {
				"Primary":     { "Light": "#000000", "Dark": "#ffffff" },
				"Secondary":   { "Light": "#222222", "Dark": "#dddddd" },
				"Muted":       { "Light": "#555555", "Dark": "#aaaaaa" },
				"Placeholder": { "Light": "#888888", "Dark": "#777777" }
			},
			"Brand": {
				"Primary":      { "Light": "#000000", "Dark": "#ffffff" },
				"PrimaryHover": { "Light": "#222222", "Dark": "#dddddd" },
				"Accent":       { "Light": "#444444", "Dark": "#bbbbbb" }
			},
			"Border": {
				"Default": { "Light": "#888888", "Dark": "#666666" },
				"Light":   { "Light": "#cccccc", "Dark": "#333333" },
				"Strong":  { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Status": {
				"Success": { "Light": "#000000", "Dark": "#ffffff" },
				"Warning": { "Light": "#000000", "Dark": "#ffffff" },
				"Error":   { "Light": "#000000", "Dark": "#ffffff" },
				"Info":    { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Data": {
				"1": { "Light": "#000000", "Dark": "#ffffff" },
				"2": { "Light": "#262626", "Dark": "#e0e0e0" },
				"3": { "Light": "#404040", "Dark": "#c0c0c0" },
				"4": { "Light": "#595959", "Dark": "#a0a0a0" },
				"5": { "Light": "#737373", "Dark": "#808080" },
				"6": { "Light": "#8c8c8c", "Dark": "#737373" },
				"7": { "Light": "#a6a6a6", "Dark": "#595959" },
				"8": { "Light": "#bfbfbf", "Dark": "#404040" }
			},
			"Scrollbar": {
				"Track": { "Light": "#e0e0e0", "Dark": "#101010" },
				"Thumb": { "Light": "#888888", "Dark": "#666666" },
				"Hover": { "Light": "#444444", "Dark": "#bbbbbb" }
			},
			"Selection": {
				"Background": { "Light": "#000000", "Dark": "#ffffff" },
				"Text":       { "Light": "#ffffff", "Dark": "#000000" }
			},
			"Focus": {
				"Outline": { "Light": "#000000", "Dark": "#ffffff" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(0, 0, 0, 0.18)", "Dark": "rgba(255, 255, 255, 0.18)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#000000", "Dark": "#ffffff" },
				"String":      { "Light": "#555555", "Dark": "#cccccc" },
				"Number":      { "Light": "#000000", "Dark": "#ffffff" },
				"Comment":     { "Light": "#888888", "Dark": "#888888" },
				"Operator":    { "Light": "#000000", "Dark": "#ffffff" },
				"Punctuation": { "Light": "#444444", "Dark": "#bbbbbb" },
				"Function":    { "Light": "#000000", "Dark": "#ffffff" },
				"Variable":    { "Light": "#000000", "Dark": "#ffffff" },
				"Type":        { "Light": "#222222", "Dark": "#dddddd" },
				"Builtin":     { "Light": "#222222", "Dark": "#dddddd" },
				"Property":    { "Light": "#444444", "Dark": "#bbbbbb" },
				"Tag":         { "Light": "#000000", "Dark": "#ffffff" },
				"AttrName":    { "Light": "#444444", "Dark": "#bbbbbb" },
				"AttrValue":   { "Light": "#555555", "Dark": "#cccccc" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Times New Roman, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "600",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.15",
				"Normal": "1.4",
				"Loose": "1.65"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "0",
			"MD": "0",
			"LG": "0",
			"XL": "0",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 0 var(--theme-color-shadow-color)",
			"MD": "0 2px 0 var(--theme-color-shadow-color)",
			"LG": "0 4px 0 var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "0ms",
			"Normal": "0ms",
			"Slow": "0ms"
		}
	},
	"Brand": {
		"Name": "Retold Mono",
		"Tagline": "Black on white. White on black. Nothing else."
	},
	"CSS": [
		{
			"Hash": "retold-mono-brand-accents",
			"Priority": 600,
			"Content": "/* retold-mono — keeps the all-monochrome aesthetic but lets brand colors\n   in for narrow accent moments. The thick rule under H1 is brand primary;\n   the hair rule under H2 is brand secondary. Without a brand registered\n   they fall back to mono black/grey. */\na { text-decoration-color: var(--brand-color-primary-mode, currentColor); text-decoration-thickness: 2px; text-underline-offset: 3px; }\nh1 { border-bottom: 3px solid var(--brand-color-primary-mode, var(--theme-color-text-primary, #000)); padding-bottom: 6px; }\nh2 { border-bottom: 1px solid var(--brand-color-secondary-mode, var(--theme-color-border-default, #888)); padding-bottom: 4px; }"
		}
	]
}

},{}],205:[function(require,module,exports){
module.exports={
	"Hash": "solarized-dark",
	"Name": "Solarized Dark",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Schoonover's classic palette Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#002B36",
				"Secondary": "#073642",
				"Tertiary": "#003B4A",
				"Panel": "#00303C",
				"Viewer": "#001E28",
				"Hover": "#0A4858",
				"Selected": "#155868",
				"Thumb": "#073642"
			},
			"Text": {
				"Primary": "#FDF6E3",
				"Secondary": "#EEE8D5",
				"Muted": "#93A1A1",
				"Dim": "#839496",
				"Placeholder": "#657B83"
			},
			"Brand": {
				"Accent": "#268BD2",
				"AccentHover": "#45A0E0"
			},
			"Border": {
				"Default": "#0A4050",
				"Light": "#125868"
			},
			"Status": {
				"Danger": "#DC322F",
				"DangerMuted": "#AA2A28"
			},
			"Scrollbar": {
				"Track": "#0A4050",
				"Hover": "#125868"
			},
			"Selection": {
				"Background": "rgba(38, 139, 210, 0.25)"
			},
			"Focus": {
				"Outline": "#268BD2"
			},
			"Syntax": {
				"Keyword":     "#859900",
				"String":      "#2AA198",
				"Number":      "#D33682",
				"Comment":     "#586E75",
				"Operator":    "#268BD2",
				"Punctuation": "#93A1A1",
				"Function":    "#B58900",
				"Variable":    "#FDF6E3",
				"Type":        "#B58900",
				"Builtin":     "#CB4B16",
				"Property":    "#268BD2",
				"Tag":         "#268BD2",
				"AttrName":    "#B58900",
				"AttrValue":   "#2AA198"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Source Code Pro', 'Fira Code', monospace",
				"Mono": "'Source Code Pro', 'Fira Code', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#EEE8D5",
		"Accent": "#268BD2",
		"Muted": "#839496",
		"Light": "#003B4A",
		"WarmBeige": "#073642",
		"TealTint": "#004050",
		"Lavender": "#003848",
		"AmberTint": "#0A3A30",
		"PdfFill": "#0A3028",
		"PdfText": "#DC322F"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],206:[function(require,module,exports){
module.exports={
	"Hash": "synthwave",
	"Name": "Synthwave",
	"Category": "Fun",
	"Version": "0.0.1",
	"Description": "Purple and pink neon Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1A0A2E",
				"Secondary": "#140824",
				"Tertiary": "#200E38",
				"Panel": "#1C0C32",
				"Viewer": "#100620",
				"Hover": "#2A1848",
				"Selected": "#3A2060",
				"Thumb": "#140824"
			},
			"Text": {
				"Primary": "#E8C0F8",
				"Secondary": "#D0A8E8",
				"Muted": "#9878B8",
				"Dim": "#7858A8",
				"Placeholder": "#584088"
			},
			"Brand": {
				"Accent": "#FF71CE",
				"AccentHover": "#FF99DD"
			},
			"Border": {
				"Default": "#302050",
				"Light": "#402868"
			},
			"Status": {
				"Danger": "#FF4488",
				"DangerMuted": "#AA3366"
			},
			"Scrollbar": {
				"Track": "#302050",
				"Hover": "#402868"
			},
			"Selection": {
				"Background": "rgba(255, 113, 206, 0.25)"
			},
			"Focus": {
				"Outline": "#FF71CE"
			},
			"Syntax": {
				"Keyword":     "#FF6AD5",
				"String":      "#FFE066",
				"Number":      "#FF6AD5",
				"Comment":     "#9C8AC1",
				"Operator":    "#26F0F1",
				"Punctuation": "#C8B6E2",
				"Function":    "#26F0F1",
				"Variable":    "#FFE0FF",
				"Type":        "#FFD93D",
				"Builtin":     "#FFD93D",
				"Property":    "#FF477E",
				"Tag":         "#FF477E",
				"AttrName":    "#FFD93D",
				"AttrValue":   "#FFE066"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "'Trebuchet MS', sans-serif",
				"Mono": "'Courier New', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#D0A8E8",
		"Accent": "#FF71CE",
		"Muted": "#7858A8",
		"Light": "#200E38",
		"WarmBeige": "#221040",
		"TealTint": "#1A0C30",
		"Lavender": "#1E0E36",
		"AmberTint": "#241028",
		"PdfFill": "#241020",
		"PdfText": "#FF4488"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],207:[function(require,module,exports){
module.exports={
	"Hash": "twilight",
	"Name": "Twilight",
	"Category": "Grey",
	"Version": "0.0.1",
	"Description": "Dark grey, low light. Ported from RetoldRemote-ThemeDefinitions.js to the pict-provider-theme manifest format. Single-mode (no light/dark bifurcation). Aliases preserve the legacy `--retold-*` variable names so existing CSS keeps working through the migration.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": "#1E1E1E",
				"Secondary": "#181818",
				"Tertiary": "#252525",
				"Panel": "#202020",
				"Viewer": "#141414",
				"Hover": "#2E2E2E",
				"Selected": "#404040",
				"Thumb": "#181818"
			},
			"Text": {
				"Primary": "#E0E0E0",
				"Secondary": "#C8C8C8",
				"Muted": "#909090",
				"Dim": "#707070",
				"Placeholder": "#585858"
			},
			"Brand": {
				"Accent": "#A0A0A0",
				"AccentHover": "#C0C0C0"
			},
			"Border": {
				"Default": "#333333",
				"Light": "#404040"
			},
			"Status": {
				"Danger": "#FF6666",
				"DangerMuted": "#AA6666"
			},
			"Scrollbar": {
				"Track": "#404040",
				"Hover": "#505050"
			},
			"Selection": {
				"Background": "rgba(160, 160, 160, 0.25)"
			},
			"Focus": {
				"Outline": "#A0A0A0"
			},
			"Syntax": {
				"Keyword":     "#B58FFF",
				"String":      "#9CDFB0",
				"Number":      "#FFB870",
				"Comment":     "#6E6E6E",
				"Operator":    "#7CC5FF",
				"Punctuation": "#C0C0C0",
				"Function":    "#FFD080",
				"Variable":    "#E0E0E0",
				"Type":        "#FFB870",
				"Builtin":     "#FFB870",
				"Property":    "#FF8B8B",
				"Tag":         "#FF8B8B",
				"AttrName":    "#FFB870",
				"AttrValue":   "#9CDFB0"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, sans-serif",
				"Mono": "'SF Mono', 'Fira Code', 'Consolas', monospace"
			}
		}
	},
	"Aliases": {
		"--retold-bg-primary": "Color.Background.Primary",
		"--retold-bg-secondary": "Color.Background.Secondary",
		"--retold-bg-tertiary": "Color.Background.Tertiary",
		"--retold-bg-panel": "Color.Background.Panel",
		"--retold-bg-viewer": "Color.Background.Viewer",
		"--retold-bg-hover": "Color.Background.Hover",
		"--retold-bg-selected": "Color.Background.Selected",
		"--retold-bg-thumb": "Color.Background.Thumb",
		"--retold-text-primary": "Color.Text.Primary",
		"--retold-text-secondary": "Color.Text.Secondary",
		"--retold-text-muted": "Color.Text.Muted",
		"--retold-text-dim": "Color.Text.Dim",
		"--retold-text-placeholder": "Color.Text.Placeholder",
		"--retold-accent": "Color.Brand.Accent",
		"--retold-accent-hover": "Color.Brand.AccentHover",
		"--retold-border": "Color.Border.Default",
		"--retold-border-light": "Color.Border.Light",
		"--retold-danger": "Color.Status.Danger",
		"--retold-danger-muted": "Color.Status.DangerMuted",
		"--retold-scrollbar": "Color.Scrollbar.Track",
		"--retold-scrollbar-hover": "Color.Scrollbar.Hover",
		"--retold-selection-bg": "Color.Selection.Background",
		"--retold-focus-outline": "Color.Focus.Outline",
		"--retold-font-family": "Typography.Family.Sans",
		"--retold-font-mono": "Typography.Family.Mono"
	},
	"IconColors": {
		"Primary": "#C8C8C8",
		"Accent": "#A0A0A0",
		"Muted": "#707070",
		"Light": "#252525",
		"WarmBeige": "#2A2A2A",
		"TealTint": "#222222",
		"Lavender": "#282828",
		"AmberTint": "#2E2A24",
		"PdfFill": "#2E2224",
		"PdfText": "#E06060"
	},
	"CSS": [],
	"SVG": {},
	"Image": {},
	"CompiledAt": "2026-05-03T18:12:53.408Z",
	"CompilerVersion": 1
}
},{}],208:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-canyon",
	"Name": "Ultravisor — Desert Canyon",
	"Version": "0.0.1",
	"Description": "Vibrant desert palette — orange brand and teal accents on deep canyon-brown backgrounds. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#18120e",
				"Secondary": "#221a14",
				"Tertiary":  "#2e2018",
				"Panel":     "#221a14",
				"Hover":     "#3a2a1e",
				"Selected":  "#3a2a1e"
			},
			"Text": {
				"Primary":     "#d8c8b0",
				"Secondary":   "#e8d8c0",
				"Muted":       "#a09080",
				"Placeholder": "#685040",
				"OnBrand":     "#18120e"
			},
			"Brand": {
				"Primary":      "#e8943a",
				"PrimaryHover": "#f0a44a",
				"Accent":       "#18a0a0",
				"AccentHover":  "#30b0b0"
			},
			"Border": {
				"Default": "#3a2a1e",
				"Light":   "#2e2018",
				"Strong":  "#4a3a2e"
			},
			"Status": {
				"Success": "#18a0a0",
				"Warning": "#e0c870",
				"Error":   "#e05830",
				"Info":    "#18a0a0"
			},
			"Scrollbar": {
				"Track": "#221a14",
				"Thumb": "#3a2a1e",
				"Hover": "#4a3a2e"
			},
			"Selection": {
				"Background": "#3a2a1e",
				"Text":       "#e8d8c0"
			},
			"Focus": {
				"Outline": "#e8943a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#221a14",
				"LineNumberText":       "#685040",
				"CurrentLineHighlight": "#2e2018",
				"SelectionBackground":  "#3a2a1e",
				"GutterBorder":         "#2e2018"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],209:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-day",
	"Name": "Ultravisor — Desert Day",
	"Version": "0.0.1",
	"Description": "Ultravisor's warm light palette — cream backgrounds, deep walnut text, teal accents. Single-mode light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#faf6f0",
				"Secondary": "#f0e6d6",
				"Tertiary":  "#e8ddd0",
				"Panel":     "#ffffff",
				"Hover":     "#f0e6d6",
				"Selected":  "#e8ddd0"
			},
			"Text": {
				"Primary":     "#3d2b1f",
				"Secondary":   "#2e1e14",
				"Muted":       "#8a7560",
				"Placeholder": "#a09080",
				"OnBrand":     "#ffffff"
			},
			"Brand": {
				"Primary":      "#5c3d2e",
				"PrimaryHover": "#7a5040",
				"Accent":       "#3a8a8c",
				"AccentHover":  "#2a7070"
			},
			"Border": {
				"Default": "#e0d0b8",
				"Light":   "#e8ddd0",
				"Strong":  "#c8b8a0"
			},
			"Status": {
				"Success": "#5a7a30",
				"Warning": "#b08020",
				"Error":   "#a03040",
				"Info":    "#3a8a8c"
			},
			"Scrollbar": {
				"Track": "#f0e6d6",
				"Thumb": "#d0c0a8",
				"Hover": "#c0b098"
			},
			"Selection": {
				"Background": "#e8ddd0",
				"Text":       "#2e1e14"
			},
			"Focus": {
				"Outline": "#c2703e"
			},
			"Shadow": {
				"Color": "rgba(92, 61, 46, 0.10)"
			},
			"Syntax": {
				"Keyword":     "#A0532E",
				"String":      "#3F8A52",
				"Number":      "#A86B00",
				"Comment":     "#8A7F72",
				"Operator":    "#2E7D74",
				"Punctuation": "#5E5549",
				"Function":    "#2E5E96",
				"Variable":    "#3D3229",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#A0532E",
				"Tag":         "#A0532E",
				"AttrName":    "#A86B00",
				"AttrValue":   "#3F8A52"
			},
			"Editor": {
				"LineNumberBackground": "#f0e6d6",
				"LineNumberText":       "#a09080",
				"CurrentLineHighlight": "#f5ede0",
				"SelectionBackground":  "#e8ddd0",
				"GutterBorder":         "#e0d0b8"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],210:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-dusk",
	"Name": "Ultravisor — Desert Dusk",
	"Version": "0.0.1",
	"Description": "Ultravisor's original default — warm tan brand on muted dark desert backgrounds. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#1a1714",
				"Secondary": "#252018",
				"Tertiary":  "#302818",
				"Panel":     "#252018",
				"Hover":     "#3a3028",
				"Selected":  "#3a3028"
			},
			"Text": {
				"Primary":     "#c8b8a0",
				"Secondary":   "#d8c8a8",
				"Muted":       "#907860",
				"Placeholder": "#706050",
				"OnBrand":     "#FFFFFF"
			},
			"Brand": {
				"Primary":      "#c4956a",
				"PrimaryHover": "#d4a57a",
				"Accent":       "#4a9090",
				"AccentHover":  "#5aacac"
			},
			"Border": {
				"Default": "#3a3028",
				"Light":   "#302818",
				"Strong":  "#4a4038"
			},
			"Status": {
				"Success": "#8a9a5a",
				"Warning": "#c0a050",
				"Error":   "#b04050",
				"Info":    "#4a9090"
			},
			"Scrollbar": {
				"Track": "#252018",
				"Thumb": "#3a3028",
				"Hover": "#4a4038"
			},
			"Selection": {
				"Background": "#3a3028",
				"Text":       "#d8c8a8"
			},
			"Focus": {
				"Outline": "#c4956a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#252018",
				"LineNumberText":       "#706050",
				"CurrentLineHighlight": "#302818",
				"SelectionBackground":  "#3a3028",
				"GutterBorder":         "#302818"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],211:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-desert-sunset",
	"Name": "Ultravisor — Desert Sunset",
	"Version": "0.0.1",
	"Description": "Ultravisor's golden-hour palette — orange brand on rust-warmed dark backgrounds. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#1e1610",
				"Secondary": "#2a2018",
				"Tertiary":  "#342818",
				"Panel":     "#2a2018",
				"Hover":     "#3a2e22",
				"Selected":  "#3a2e22"
			},
			"Text": {
				"Primary":     "#d4c4aa",
				"Secondary":   "#e0d0b8",
				"Muted":       "#8a7560",
				"Placeholder": "#6a5840",
				"OnBrand":     "#1e1610"
			},
			"Brand": {
				"Primary":      "#e8943a",
				"PrimaryHover": "#f0a44a",
				"Accent":       "#2a8a8a",
				"AccentHover":  "#3a9a9a"
			},
			"Border": {
				"Default": "#3a2e22",
				"Light":   "#342818",
				"Strong":  "#4a3e32"
			},
			"Status": {
				"Success": "#6a9a3a",
				"Warning": "#d4a46a",
				"Error":   "#c44e2a",
				"Info":    "#2a8a8a"
			},
			"Scrollbar": {
				"Track": "#2a2018",
				"Thumb": "#3a2e22",
				"Hover": "#4a3e32"
			},
			"Selection": {
				"Background": "#3a2e22",
				"Text":       "#e0d0b8"
			},
			"Focus": {
				"Outline": "#e8943a"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#2a2018",
				"LineNumberText":       "#6a5840",
				"CurrentLineHighlight": "#342818",
				"SelectionBackground":  "#3a2e22",
				"GutterBorder":         "#342818"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],212:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-professional-dark",
	"Name": "Ultravisor — Professional Dark",
	"Version": "0.0.1",
	"Description": "Dark modern palette — slate-blue text on inky surfaces, sky-blue brand. Single-mode dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#111318",
				"Secondary": "#1a1d24",
				"Tertiary":  "#22252e",
				"Panel":     "#1a1d24",
				"Hover":     "#282c34",
				"Selected":  "#282c34"
			},
			"Text": {
				"Primary":     "#c8cdd5",
				"Secondary":   "#e0e4ea",
				"Muted":       "#8b92a0",
				"Placeholder": "#5a6070",
				"OnBrand":     "#ffffff"
			},
			"Brand": {
				"Primary":      "#60a5fa",
				"PrimaryHover": "#93c5fd",
				"Accent":       "#60a5fa",
				"AccentHover":  "#93c5fd"
			},
			"Border": {
				"Default": "#282c34",
				"Light":   "#22252e",
				"Strong":  "#3a3f4a"
			},
			"Status": {
				"Success": "#34d399",
				"Warning": "#fbbf24",
				"Error":   "#f87171",
				"Info":    "#60a5fa"
			},
			"Scrollbar": {
				"Track": "#1a1d24",
				"Thumb": "#282c34",
				"Hover": "#3a3f4a"
			},
			"Selection": {
				"Background": "#1e2230",
				"Text":       "#e0e4ea"
			},
			"Focus": {
				"Outline": "#60a5fa"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.30)"
			},
			"Syntax": {
				"Keyword":     "#E89A6E",
				"String":      "#8FD493",
				"Number":      "#E8A94D",
				"Comment":     "#8E8478",
				"Operator":    "#4FB3A6",
				"Punctuation": "#C0B5A4",
				"Function":    "#7FBDD8",
				"Variable":    "#E8DCC8",
				"Type":        "#E8A94D",
				"Builtin":     "#E8A94D",
				"Property":    "#E89A6E",
				"Tag":         "#E89A6E",
				"AttrName":    "#E8A94D",
				"AttrValue":   "#8FD493"
			},
			"Editor": {
				"LineNumberBackground": "#1a1d24",
				"LineNumberText":       "#5a6070",
				"CurrentLineHighlight": "#22252e",
				"SelectionBackground":  "#1e2230",
				"GutterBorder":         "#22252e"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],213:[function(require,module,exports){
module.exports={
	"Hash": "ultravisor-professional-light",
	"Name": "Ultravisor — Professional Light",
	"Version": "0.0.1",
	"Description": "Bright modern palette — slate text on near-white backgrounds, royal-blue brand. Single-mode light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#f5f6f8",
				"Secondary": "#ffffff",
				"Tertiary":  "#e4e7ec",
				"Panel":     "#ffffff",
				"Hover":     "#f0f1f4",
				"Selected":  "#e4e7ec"
			},
			"Text": {
				"Primary":     "#2d3748",
				"Secondary":   "#1a202c",
				"Muted":       "#6b7280",
				"Placeholder": "#9ca3af",
				"OnBrand":     "#ffffff"
			},
			"Brand": {
				"Primary":      "#3b82f6",
				"PrimaryHover": "#2563eb",
				"Accent":       "#3b82f6",
				"AccentHover":  "#2563eb"
			},
			"Border": {
				"Default": "#e2e5ea",
				"Light":   "#eceef2",
				"Strong":  "#c8cdd5"
			},
			"Status": {
				"Success": "#10b981",
				"Warning": "#f59e0b",
				"Error":   "#ef4444",
				"Info":    "#3b82f6"
			},
			"Scrollbar": {
				"Track": "#f0f1f4",
				"Thumb": "#d1d5db",
				"Hover": "#b0b5bd"
			},
			"Selection": {
				"Background": "#dbeafe",
				"Text":       "#1a202c"
			},
			"Focus": {
				"Outline": "#3b82f6"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.06)"
			},
			"Syntax": {
				"Keyword":     "#A0532E",
				"String":      "#3F8A52",
				"Number":      "#A86B00",
				"Comment":     "#8A7F72",
				"Operator":    "#2E7D74",
				"Punctuation": "#5E5549",
				"Function":    "#2E5E96",
				"Variable":    "#3D3229",
				"Type":        "#A86B00",
				"Builtin":     "#A86B00",
				"Property":    "#A0532E",
				"Tag":         "#A0532E",
				"AttrName":    "#A86B00",
				"AttrValue":   "#3F8A52"
			},
			"Editor": {
				"LineNumberBackground": "#f5f6f8",
				"LineNumberText":       "#9ca3af",
				"CurrentLineHighlight": "#f0f1f4",
				"SelectionBackground":  "#dbeafe",
				"GutterBorder":         "#e2e5ea"
			}
		},
		"Typography": {
			"Family": {
				"Sans":  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
				"Serif": "Georgia, Cambria, 'Times New Roman', Times, serif",
				"Mono":  "'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace"
			}
		},
		"Layout": {
			"SidebarWidth":    "260px",
			"TopbarHeight":    "56px",
			"StatusbarHeight": "28px"
		}
	},
	"Brand": {
		"Name": "Ultravisor",
		"Tagline": "Process supervision and workflow automation"
	}
}

},{}],214:[function(require,module,exports){
/**
 * Theme-BottomBar — standard application footer row.
 *
 * The bottom-row counterpart to Theme-TopBar: a thin status / chrome bar
 * that sits at the absolute bottom of the application shell. Three
 * zones — status text on the left, info indicators in the middle, and
 * action buttons / toggles on the right.
 *
 *   ┌────────────────────────────────────────────────────────────────┐
 *   │ Status text          [── Info slot (flex) ──]      [actions]   │
 *   └────────────────────────────────────────────────────────────────┘
 *
 * Renders into `#Theme-BottomBar` by default.
 *
 * Three slots host views drop content into:
 *   - `#Theme-BottomBar-Status`  — short status / state line (left)
 *   - `#Theme-BottomBar-Info`    — center info: connection, version,
 *                                  ambient indicators
 *   - `#Theme-BottomBar-Actions` — log toggle, debug controls, etc.
 *
 * Top border uses `--brand-color-secondary-mode` so the bottombar gets
 * a brand-tinted edge that's visually distinct from the topbar's
 * primary-color stripe.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-BottomBar',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-BottomBar',
	DefaultRenderable: 'Theme-BottomBar-Renderable',

	// ViewIdentifier of a host view that fills #Theme-BottomBar-Status.
	StatusView: null,
	// ViewIdentifier of a host view that fills #Theme-BottomBar-Info.
	InfoView: null,
	// ViewIdentifier of a host view that fills #Theme-BottomBar-Actions.
	ActionsView: null,

	// Height of the bar in pixels. Drives the min-height on the chrome
	// row so it fills the panel cleanly even when the parent chain
	// (pict-section-modal shell uses min-height: 100% on its panel
	// content destination, which doesn't resolve through plain
	// height: 100% chains) doesn't establish a determinate height.
	// Hosts should match this to whatever Size they use on the panel
	// addPanel() call so the chrome and panel agree on the row size.
	Height: 32,

	Templates:
	[
		{
			Hash: 'Theme-BottomBar-Template',
			Template: /*html*/`
<div class="pict-theme-bottombar">
	<div class="pict-theme-bottombar-status" id="Theme-BottomBar-Status"></div>
	<div class="pict-theme-bottombar-info" id="Theme-BottomBar-Info"></div>
	<div class="pict-theme-bottombar-actions" id="Theme-BottomBar-Actions"></div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-BottomBar-Renderable',
			TemplateHash: 'Theme-BottomBar-Template',
			ContentDestinationAddress: '#Theme-BottomBar',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-bottombar {
	display: flex;
	align-items: center;
	gap: 14px;
	/* The min-height is rewritten per-instance in onAfterRender from the
	   Height option (default 32). A fixed px value avoids the
	   percent-height resolution trap the pict-section-modal shell sets
	   up — see the comment on Theme-TopBar's CSS for the full story. */
	min-height: 32px;
	padding: 0 14px;
	box-sizing: border-box;
	background: var(--theme-color-background-secondary, transparent);
	font-size: var(--theme-typography-size-xs, 12px);
	color: var(--theme-color-text-secondary, #4a5568);
	/* Single medium brand-primary stripe at the top of the bottombar.
	   The topbar carries the full two-stripe identifier; on the
	   bottombar (which is only 32px tall) a single 2px primary line is
	   enough to seat the brand colour at the bottom of the page
	   without competing for visual weight against the content row. */
	border-top: 2px solid var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
.pict-theme-bottombar-status {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 6px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 50%;
}
.pict-theme-bottombar-info {
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	min-width: 0;
	overflow: hidden;
}
.pict-theme-bottombar-actions {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 6px;
}`,
	CSSPriority: 500
};

class PictViewThemeBottomBar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Apply the configured Height to the rendered .pict-theme-bottombar
		// — see the matching block in Theme-TopBar's onAfterRender for why.
		if (typeof document !== 'undefined' && this.options.Height)
		{
			let tmpRoot = document.querySelector('.pict-theme-bottombar');
			if (tmpRoot) { tmpRoot.style.minHeight = this.options.Height + 'px'; }
		}

		let tmpRenderSlot = (pIdentifier) =>
		{
			if (!pIdentifier) return;
			let tmpView = this.pict.views[pIdentifier];
			if (tmpView) { tmpView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-BottomBar: slot view "' + pIdentifier + '" not registered');
			}
		};
		tmpRenderSlot(this.options.StatusView);
		tmpRenderSlot(this.options.InfoView);
		tmpRenderSlot(this.options.ActionsView);

		return super.onAfterRender ? super.onAfterRender(pRenderable, pAddress, pRecord, pContent) : undefined;
	}

	// ─── Per-route slot swapping ──────────────────────────────────────────
	// Mirrors Theme-TopBar's setNavView / setUserView — call from a
	// router callback to swap the bottom bar's slot content as the
	// route changes (different status formats per page, etc.).

	setStatusView(pViewIdentifier)  { this._setSlotView('StatusView',  '#Theme-BottomBar-Status',  pViewIdentifier); }
	setInfoView(pViewIdentifier)    { this._setSlotView('InfoView',    '#Theme-BottomBar-Info',    pViewIdentifier); }
	setActionsView(pViewIdentifier) { this._setSlotView('ActionsView', '#Theme-BottomBar-Actions', pViewIdentifier); }

	_setSlotView(pOptionKey, pDestSelector, pViewIdentifier)
	{
		this.options[pOptionKey] = pViewIdentifier || null;
		if (typeof document !== 'undefined')
		{
			let tmpDest = document.querySelector(pDestSelector);
			if (tmpDest) { tmpDest.innerHTML = ''; }
		}
		if (!pViewIdentifier) { return; }
		let tmpView = this.pict.views[pViewIdentifier];
		if (tmpView) { tmpView.render(); }
		else if (this.log && this.log.warn)
		{
			this.log.warn('Theme-BottomBar: view "' + pViewIdentifier + '" not registered');
		}
	}
}

module.exports = PictViewThemeBottomBar;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],215:[function(require,module,exports){
/**
 * Theme-Brand-Mark — single-row inline brand mark (icon + name).
 *
 * The drop-in counterpart to Theme-BrandStrip for apps that put the
 * brand wordmark *inside* their topbar (next to action buttons) rather
 * than as a multi-row chrome below the nav.
 *
 * Layout:
 *
 *   ┌─────────────────────────┐
 *   │ [icon]  App Name        │
 *   └─────────────────────────┘
 *
 * Colors come from the brand's primary/secondary; the icon (when SVG
 * with `stroke="currentColor"`) inherits `--brand-color-primary-mode`,
 * which auto-swaps between PrimaryLight (default mode) and PrimaryDark
 * (`.theme-dark`).
 *
 * Reads from libThemeBrand and re-renders on `onChange`. Renders an
 * empty span when no brand is registered.
 *
 * Drop-in destination: `<div id="Theme-Brand-Mark"></div>`.
 */

const libPictView = require('pict-view');
const libThemeBrand = require('../Theme-Brand.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Brand-Mark',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Brand-Mark',
	DefaultRenderable: 'Theme-Brand-Mark-Renderable',

	// Optional: when false the icon is omitted (text-only wordmark).
	ShowIcon: true,
	// Optional: when false the name is omitted (icon-only mark).
	ShowName: true,

	Templates:
	[
		{
			Hash: 'Theme-Brand-Mark-Template',
			Template: /*html*/`{~TS:Theme-Brand-Mark-Body-Template:AppData.PictSectionTheme.BrandMark.BodySlot~}`
		},
		{
			Hash: 'Theme-Brand-Mark-Body-Template',
			Template: /*html*/`
<span class="pict-theme-brand-mark" title="{~D:Record.Tooltip~}">
	{~TS:Theme-Brand-Mark-IconSVG-Template:Record.IconSVGSlot~}
	{~TS:Theme-Brand-Mark-IconImg-Template:Record.IconImgSlot~}
	{~TS:Theme-Brand-Mark-Name-Template:Record.NameSlot~}
</span>`
		},
		{
			// Inline SVG: trusted markup; let it ride. SVG icons that
			// reference `currentColor` inherit `--brand-color-primary-mode`.
			Hash: 'Theme-Brand-Mark-IconSVG-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-icon">{~D:Record.IconHTML~}</span>`
		},
		{
			Hash: 'Theme-Brand-Mark-IconImg-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-icon"><img src="{~D:Record.IconURL~}" alt=""></span>`
		},
		{
			Hash: 'Theme-Brand-Mark-Name-Template',
			Template: /*html*/`<span class="pict-theme-brand-mark-name">{~D:Record.Name~}</span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Brand-Mark-Renderable',
			TemplateHash: 'Theme-Brand-Mark-Template',
			ContentDestinationAddress: '#Theme-Brand-Mark',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-brand-mark {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	/* line-height: 1 collapses the inherited ~1.2 line-box around the
	   name glyphs. Without this the inline-flex container is taller
	   than its visible content, the line-box adds asymmetric space
	   above the caps, and the whole mark looks pushed up vs.
	   neighbouring buttons that sit on standard 12px-text baselines. */
	line-height: 1;
	color: var(--brand-color-primary-mode, var(--theme-color-text-primary, #1a1a1a));
	user-select: none;
}
.pict-theme-brand-mark-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	color: currentColor;
}
.pict-theme-brand-mark-icon img,
.pict-theme-brand-mark-icon svg {
	width: 100%;
	height: 100%;
	display: block;
}
.pict-theme-brand-mark-name {
	/* Font size dropped from 15 → 14 so the brand name reads closer
	   to the typical 12px action-button text height; bigger glyphs
	   reaching higher into the row are why the mark looked optically
	   high. The 2px brand-secondary underline keeps the mark feeling
	   distinctly branded; padding-bottom: 1px was an asymmetric nudge
	   that shifted the visual center up — removed. */
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 0.4px;
	border-bottom: 2px solid var(--brand-color-secondary-mode, transparent);
	white-space: nowrap;
}
/* Compact form — at narrow viewports the brand mark collapses to
   icon-only. The icon alone still reads as the brand (the deterministic
   logo is designed to be recognisable without the wordmark) and freeing
   up the wordmark's width keeps the nav buttons reachable on tablet /
   small-laptop widths. The threshold matches the topbar's compact
   breakpoint in Theme-TopBar. */
@media (max-width: 720px) {
	.pict-theme-brand-mark-name {
		display: none;
	}
}`,
	CSSPriority: 500
};

class PictViewThemeBrandMark extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromBrand = null;
	}

	onAfterInitialize()
	{
		this._subscribeToBrand();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_subscribeToBrand()
	{
		if (this._unsubscribeFromBrand) return;
		let tmpSelf = this;
		this._unsubscribeFromBrand = libThemeBrand.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpBrand = libThemeBrand.getActive();
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};

		if (!tmpBrand)
		{
			this.pict.AppData.PictSectionTheme.BrandMark = { BodySlot: [] };
			return;
		}

		// Single-element array slot drives the {~TS:~} render. Empty
		// slots for icon-img/icon-svg/name suppress those sub-templates.
		let tmpShowIcon = (this.options.ShowIcon !== false);
		let tmpShowName = (this.options.ShowName !== false);

		let tmpIconSVGSlot = (tmpShowIcon && tmpBrand.IconType === 'svg' && tmpBrand.Icon)
			? [{ IconHTML: tmpBrand.Icon }] : [];
		let tmpIconImgSlot = (tmpShowIcon && tmpBrand.IconType === 'image' && tmpBrand.Icon)
			? [{ IconURL: tmpBrand.Icon }] : [];
		let tmpNameSlot = (tmpShowName && tmpBrand.Name)
			? [{ Name: tmpBrand.Name }] : [];

		this.pict.AppData.PictSectionTheme.BrandMark =
		{
			BodySlot:
			[{
				Tooltip: tmpBrand.Tagline || tmpBrand.Name || '',
				IconSVGSlot: tmpIconSVGSlot,
				IconImgSlot: tmpIconImgSlot,
				NameSlot:    tmpNameSlot
			}]
		};
	}
}

module.exports = PictViewThemeBrandMark;
module.exports.default_configuration = _ViewConfiguration;

},{"../Theme-Brand.js":165,"pict-view":239}],216:[function(require,module,exports){
/**
 * Theme-BrandStrip — the subtle two-line brand signature that sits
 * under the application's navigation.
 *
 * Layout:
 *
 *   ┌─────────────────────────────────────────────────────────────┐
 *   │ [icon]  App Name                                            │
 *   │ ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ │  ← primary stripe (3× tall)
 *   │ ─────────────────────────────────────────────────────────── │  ← secondary stripe (1× tall)
 *   └─────────────────────────────────────────────────────────────┘
 *
 * The icon + name row is colored using the brand's primary color (and
 * the secondary as an underline accent on the name). Clicking the row
 * does nothing by default — hosts that want it to navigate or open a
 * dropdown can pass an `OnClickName` hook in the view options.
 *
 * Reads the active brand from libThemeBrand. Subscribes to
 * libThemeBrand.onChange so swapping the brand at runtime updates the
 * strip immediately. Renders nothing (an empty span) when no brand is
 * registered.
 *
 * Drop-in destination: `<div id="Theme-BrandStrip"></div>`.
 */

const libPictView = require('pict-view');
const libThemeBrand = require('../Theme-Brand.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-BrandStrip',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-BrandStrip',
	DefaultRenderable: 'Theme-BrandStrip-Renderable',

	// Stripe heights in pixels. Primary is conventionally 3× secondary,
	// per the design brief, but exposed here so hosts can tune.
	PrimaryStripeHeight: 3,
	SecondaryStripeHeight: 1,

	// When false, the icon + name row is omitted and only the two
	// stripes render. Useful for very tight chrome where the brand
	// name is already in the topbar.
	ShowName: true,

	Templates:
	[
		{
			Hash: 'Theme-BrandStrip-Template',
			Template: /*html*/`
{~TS:Theme-BrandStrip-Body-Template:AppData.PictSectionTheme.BrandStrip.BodySlot~}`
		},
		{
			Hash: 'Theme-BrandStrip-Body-Template',
			Template: /*html*/`
<div class="pict-theme-brandstrip" title="{~D:Record.Tooltip~}">
	{~TS:Theme-BrandStrip-NameRow-Template:Record.NameRowSlot~}
	<div class="pict-theme-brandstrip-stripes">
		<div class="pict-theme-brandstrip-stripe pict-theme-brandstrip-stripe-primary"
		     style="height: {~D:Record.PrimaryHeight~}px;"></div>
		<div class="pict-theme-brandstrip-stripe pict-theme-brandstrip-stripe-secondary"
		     style="height: {~D:Record.SecondaryHeight~}px;"></div>
	</div>
</div>`
		},
		{
			Hash: 'Theme-BrandStrip-NameRow-Template',
			Template: /*html*/`
<div class="pict-theme-brandstrip-row">
	{~TS:Theme-BrandStrip-IconSVG-Template:Record.IconSVGSlot~}
	{~TS:Theme-BrandStrip-IconImg-Template:Record.IconImgSlot~}
	<span class="pict-theme-brandstrip-name">{~D:Record.Name~}</span>
</div>`
		},
		{
			// SVG icon: leading <svg> markup is trusted (host-supplied,
			// not user-supplied) so we let it through verbatim. Theme-Icons
			// SVGs use stroke="currentColor" so they pick up the brand
			// primary color from the row's `color: var(--brand-color-primary)`.
			Hash: 'Theme-BrandStrip-IconSVG-Template',
			Template: /*html*/`<span class="pict-theme-brandstrip-icon">{~D:Record.IconHTML~}</span>`
		},
		{
			// <img> icon: src can be a data URL or a regular URL.
			Hash: 'Theme-BrandStrip-IconImg-Template',
			Template: /*html*/`<span class="pict-theme-brandstrip-icon"><img src="{~D:Record.IconURL~}" alt=""></span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-BrandStrip-Renderable',
			TemplateHash: 'Theme-BrandStrip-Template',
			ContentDestinationAddress: '#Theme-BrandStrip',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-brandstrip {
	display: flex;
	flex-direction: column;
	gap: 4px;
	user-select: none;
}
.pict-theme-brandstrip-row {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 6px 12px 4px;
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	color: var(--brand-color-primary, var(--theme-color-text-muted, #6b6b6b));
}
.pict-theme-brandstrip-name {
	border-bottom: 2px solid var(--brand-color-secondary, transparent);
	padding-bottom: 1px;
}
.pict-theme-brandstrip-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px; height: 16px;
	color: var(--brand-color-primary, currentColor);
}
.pict-theme-brandstrip-icon img,
.pict-theme-brandstrip-icon svg {
	width: 100%; height: 100%;
	display: block;
}
.pict-theme-brandstrip-stripes {
	display: flex;
	flex-direction: column;
	width: 100%;
}
.pict-theme-brandstrip-stripe {
	width: 100%;
}
.pict-theme-brandstrip-stripe-primary {
	background: var(--brand-color-primary, transparent);
}
.pict-theme-brandstrip-stripe-secondary {
	background: var(--brand-color-secondary, transparent);
}`,
	CSSPriority: 500
};

class PictViewThemeBrandStrip extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromBrand = null;
	}

	onAfterInitialize()
	{
		this._subscribeToBrand();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_subscribeToBrand()
	{
		if (this._unsubscribeFromBrand) return;
		let tmpSelf = this;
		this._unsubscribeFromBrand = libThemeBrand.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpBrand = libThemeBrand.getActive();
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};

		// No brand → empty BodySlot → renderable emits nothing.
		if (!tmpBrand)
		{
			this.pict.AppData.PictSectionTheme.BrandStrip = { BodySlot: [] };
			return;
		}

		let tmpShowName = (this.options.ShowName !== false);

		// Pick the right per-icon-type slot. Only one of these will be
		// non-empty so the template renders the right element.
		let tmpIconSVGSlot = [];
		let tmpIconImgSlot = [];
		if (tmpBrand.IconType === 'svg' && tmpBrand.Icon)
		{
			tmpIconSVGSlot = [{ IconHTML: tmpBrand.Icon }];
		}
		else if (tmpBrand.IconType === 'image' && tmpBrand.Icon)
		{
			tmpIconImgSlot = [{ IconURL: tmpBrand.Icon }];
		}

		let tmpNameRowSlot = tmpShowName
			? [{
				Name: tmpBrand.Name,
				IconSVGSlot: tmpIconSVGSlot,
				IconImgSlot: tmpIconImgSlot
			}]
			: [];

		let tmpTooltip = tmpBrand.Name + (tmpBrand.Tagline ? ' — ' + tmpBrand.Tagline : '');

		this.pict.AppData.PictSectionTheme.BrandStrip =
		{
			BodySlot:
			[{
				Tooltip: tmpTooltip,
				NameRowSlot: tmpNameRowSlot,
				PrimaryHeight: this.options.PrimaryStripeHeight || 3,
				SecondaryHeight: this.options.SecondaryStripeHeight || 1
			}]
		};
	}
}

PictViewThemeBrandStrip.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeBrandStrip;

},{"../Theme-Brand.js":165,"pict-view":239}],217:[function(require,module,exports){
/**
 * Theme-Button — an embeddable SVG button (sun/moon glyph) suitable for
 * application top bars. Clicking it opens a pict-section-modal popup
 * containing the Theme-Picker dropdown and the Theme-ModeToggle.
 *
 * Drop-in destination: `<div id="Theme-Button"></div>`. The button itself
 * is a tiny self-contained SVG that picks its color from the theme via
 * `currentColor` so it inherits the surrounding text color.
 *
 * Requires `pict-section-modal` to be registered (under the view hash
 * `Pict-Section-Modal` by default). If it isn't, clicking the button
 * falls back to a `console.warn` and a no-op.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Button',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Button',
	DefaultRenderable: 'Theme-Button-Renderable',

	ProviderHash: 'Theme',
	ModalViewHash: 'Pict-Section-Modal',

	// Identifiers of the picker / toggle / scale views that the popup
	// will mount. Each one is optional — if a view isn't registered the
	// matching row is silently skipped (no broken DOM placeholders).
	PickerViewHash: 'Theme-Picker',
	ModeToggleViewHash: 'Theme-ModeToggle',
	ScaleSelectViewHash: 'Theme-ScaleSelect',

	// Visible button label / title (tooltip).
	Title: 'Theme',
	AriaLabel: 'Open theme menu',

	// Modal title.
	ModalTitle: 'Theme',

	// Modal width (CSS).
	ModalWidth: '320px',

	Templates:
	[
		{
			Hash: 'Theme-Button-Template',
			// SVG sourced from the shared Theme-Icons module so the
			// topbar glyph matches the picker + mode toggle exactly.
			Template: /*html*/`
<button type="button"
        class="pict-theme-button"
        aria-label="{~D:AppData.PictSectionTheme.Button.AriaLabel~}"
        title="{~D:AppData.PictSectionTheme.Button.Title~}"
        onclick="_Pict.views['Theme-Button'].openMenu();">
	${libThemeIcons.iconSun(16)}
</button>`
		},
		{
			Hash: 'Theme-Button-Modal-Template',
			Template: /*html*/`
<div class="pict-theme-button-menu">
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Theme</label>
		<div id="Theme-Picker"></div>
	</div>
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Mode</label>
		<div id="Theme-ModeToggle"></div>
	</div>
	<div class="pict-theme-button-menu-row">
		<label class="pict-theme-button-menu-label">Scale</label>
		<div id="Theme-ScaleSelect"></div>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Button-Renderable',
			TemplateHash: 'Theme-Button-Template',
			ContentDestinationAddress: '#Theme-Button',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	/* Sized to match a typical 12px-font / 6px-12px-padding text button
	   (~28px tall) so this drops cleanly into a topbar row alongside
	   action buttons without standing taller and crashing the row's
	   visual rhythm. Squareish — width matches height for the icon. */
	width: 28px;
	height: 28px;
	padding: 0;
	border-radius: 6px;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}
.pict-theme-button:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--theme-color-brand-primary, #2563eb);
	border-color: var(--theme-color-brand-primary, #2563eb);
}
.pict-theme-button-icon { width: 16px; height: 16px; }
.pict-theme-button-menu { display: flex; flex-direction: column; gap: 14px; }
.pict-theme-button-menu-row { display: flex; flex-direction: column; gap: 6px; }
.pict-theme-button-menu-label {
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.4px;
	text-transform: uppercase;
	color: var(--theme-color-text-muted, #6b6b6b);
}`,
	CSSPriority: 500
};

class PictViewThemeButton extends libPictView
{
	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — open the theme menu in a modal.
	 */
	openMenu()
	{
		let tmpModal = this._modal();
		if (!tmpModal)
		{
			if (typeof console !== 'undefined')
			{
				console.warn('Theme-Button: pict-section-modal view not found at "'
					+ (this.options.ModalViewHash || 'Pict-Section-Modal')
					+ '" — cannot open theme menu.');
			}
			return null;
		}

		let tmpHTML = this.pict.parseTemplateByHash('Theme-Button-Modal-Template', {});

		let tmpSelf = this;
		return tmpModal.show(
		{
			title: this.options.ModalTitle || 'Theme',
			content: tmpHTML,
			width: this.options.ModalWidth || '320px',
			closeable: true,
			buttons: [],
			onOpen: function ()
			{
				// Mount the picker + toggle into the freshly-created
				// modal DOM. The views look up their own destinations
				// so a simple render() is enough.
				tmpSelf._mountSubViews();
			}
		});
	}

	// ================================================================
	// Internals
	// ================================================================

	_modal()
	{
		let tmpHash = this.options.ModalViewHash || 'Pict-Section-Modal';
		return this.pict && this.pict.views && this.pict.views[tmpHash];
	}

	_mountSubViews()
	{
		let tmpPicker = this.pict.views[this.options.PickerViewHash || 'Theme-Picker'];
		if (tmpPicker)
		{
			tmpPicker.render();
		}
		let tmpToggle = this.pict.views[this.options.ModeToggleViewHash || 'Theme-ModeToggle'];
		if (tmpToggle)
		{
			tmpToggle.render();
		}
		let tmpScale = this.pict.views[this.options.ScaleSelectViewHash || 'Theme-ScaleSelect'];
		if (tmpScale)
		{
			tmpScale.render();
		}
	}

	_refreshAppData()
	{
		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.Button =
		{
			Title: this.options.Title || 'Theme',
			AriaLabel: this.options.AriaLabel || 'Open theme menu'
		};
	}
}

PictViewThemeButton.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeButton;

},{"../Theme-Icons.js":166,"pict-view":239}],218:[function(require,module,exports){
/**
 * Theme-ModeToggle — three-segment toggle for Light / Dark / System mode.
 *
 * Calls `provider.setMode(...)` on click. Greys itself out (and the
 * Dark / System buttons) when the active theme is single-mode (since
 * single-mode themes ignore mode requests internally).
 *
 * Like the Picker, subscribes to `provider.onApply` so the active button
 * highlight stays in sync with theme changes from elsewhere.
 *
 * Drop-in destination: `<div id="Theme-ModeToggle"></div>`.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-ModeToggle',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-ModeToggle',
	DefaultRenderable: 'Theme-ModeToggle-Renderable',

	ProviderHash: 'Theme',

	// Allow hosts to relabel buttons (i18n). Order is fixed.
	Labels:
	{
		Light:  'Light',
		Dark:   'Dark',
		System: 'System'
	},

	// Show the inline sun / moon / monitor SVG icons next to the labels.
	ShowIcons: true,

	Templates:
	[
		{
			Hash: 'Theme-ModeToggle-Template',
			Template: /*html*/`
<div class="pict-theme-modetoggle-wrap">
	<div class="pict-theme-modetoggle{~NE:AppData.PictSectionTheme.ModeToggle.Disabled^ pict-theme-modetoggle-disabled~}"
	     role="group" aria-label="Color mode"
	     title="{~D:AppData.PictSectionTheme.ModeToggle.WrapTitle~}">
		{~TS:Theme-ModeToggle-Button-Template:AppData.PictSectionTheme.ModeToggle.Buttons~}
	</div>
	{~TS:Theme-ModeToggle-LockedNote-Template:AppData.PictSectionTheme.ModeToggle.LockedNoteSlot~}
</div>`
		},
		{
			Hash: 'Theme-ModeToggle-Button-Template',
			Template: /*html*/`
<button type="button"
        class="pict-theme-modetoggle-btn{~NE:Record.Active^ pict-theme-modetoggle-btn-active~}{~NE:Record.LockedOut^ pict-theme-modetoggle-btn-lockedout~}"
        title="{~D:Record.Title~}"
        aria-pressed="{~D:Record.Active~}"
        aria-disabled="{~D:Record.LockedOut~}"
        onclick="_Pict.views['Theme-ModeToggle'].pickMode('{~D:Record.Mode~}');">
	{~TS:Theme-ModeToggle-Icon-Light:Record.IconLight~}{~TS:Theme-ModeToggle-Icon-Dark:Record.IconDark~}{~TS:Theme-ModeToggle-Icon-System:Record.IconSystem~}<span class="pict-theme-modetoggle-label">{~D:Record.Label~}</span>
</button>`
		},
		{
			Hash: 'Theme-ModeToggle-LockedNote-Template',
			Template: /*html*/`
<div class="pict-theme-modetoggle-locked-note" role="note">
	<svg class="pict-theme-modetoggle-locked-icon" viewBox="0 0 24 24" fill="none"
	     stroke="currentColor" stroke-width="2" stroke-linecap="round"
	     stroke-linejoin="round" aria-hidden="true">
		<rect x="4" y="11" width="16" height="9" rx="2"/>
		<path d="M8 11V7a4 4 0 0 1 8 0v4"/>
	</svg>
	<span>{~D:Record.Message~}</span>
</div>`
		},
		// Icon templates pull SVG markup from the shared Theme-Icons
		// module so the picker, toggle, and topbar button stay visually
		// consistent — change the glyph in one place, every consumer
		// updates.
		{
			Hash: 'Theme-ModeToggle-Icon-Light',
			Template: libThemeIcons.iconSun()
		},
		{
			Hash: 'Theme-ModeToggle-Icon-Dark',
			Template: libThemeIcons.iconMoon()
		},
		{
			Hash: 'Theme-ModeToggle-Icon-System',
			Template: libThemeIcons.iconSystem()
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-ModeToggle-Renderable',
			TemplateHash: 'Theme-ModeToggle-Template',
			ContentDestinationAddress: '#Theme-ModeToggle',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-modetoggle-wrap { display: inline-flex; flex-direction: column; gap: 6px; }
.pict-theme-modetoggle {
	display: inline-flex;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	border-radius: 6px;
	overflow: hidden;
	background: var(--theme-color-background-secondary, #fbfbfc);
	font-size: 12px;
}
.pict-theme-modetoggle-btn {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 4px 10px;
	border: 0;
	background: transparent;
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	border-right: 1px solid var(--theme-color-border-default, #cfd5dd);
	transition: background-color 120ms ease, color 120ms ease;
}
.pict-theme-modetoggle-btn:last-child { border-right: 0; }
.pict-theme-modetoggle-btn:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--theme-color-text-primary, #1f2933);
}
.pict-theme-modetoggle-btn-active {
	background: var(--theme-color-brand-primary, #2563eb);
	color: var(--theme-color-text-on-brand, #ffffff);
}
.pict-theme-modetoggle-btn-active:hover {
	background: var(--theme-color-brand-primary-hover, #1e54cc);
	color: var(--theme-color-text-on-brand, #ffffff);
}
/* When the active theme is single-mode the entire group becomes
   non-interactive. The locked-out buttons (the ones the theme cannot
   switch to) get a strikethrough so the cause is unmistakable; the
   active button stays styled normally so users can still see which
   mode the theme IS using. */
.pict-theme-modetoggle-disabled .pict-theme-modetoggle-btn {
	pointer-events: none;
	cursor: not-allowed;
}
.pict-theme-modetoggle-disabled .pict-theme-modetoggle-btn-lockedout {
	opacity: 0.45;
	text-decoration: line-through;
	text-decoration-thickness: 1.5px;
}
/* Icons come from Theme-Icons.js with explicit width/height baked into
   the <svg>. We only need to nudge their vertical alignment with the
   button label. */
.pict-theme-modetoggle .pict-theme-icon {
	display: inline-block; vertical-align: -2px;
}
.pict-theme-modetoggle-label { line-height: 1; }
.pict-theme-modetoggle-locked-note {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 11px;
	line-height: 1.3;
	color: var(--theme-color-text-muted, #6b6b6b);
	padding: 0 2px;
}
.pict-theme-modetoggle-locked-icon {
	width: 12px; height: 12px;
	flex: 0 0 12px;
	color: var(--theme-color-text-muted, #6b6b6b);
}`,
	CSSPriority: 500
};

// The icon SVGs themselves live as templates above (Theme-ModeToggle-Icon-*).
// Per CLAUDE.md "AppData stores data, not HTML" — we drive icon selection
// with one-or-zero element arrays (`Record.IconLight = [{}]` to render the
// Light icon, `[]` to skip it). Each template is keyed off `Record.Mode`.

class PictViewThemeModeToggle extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromProvider = null;
	}

	onAfterInitialize()
	{
		this._subscribeToProvider();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — flip mode on the active theme. Single-mode themes
	 * silently ignore (the toggle is shown disabled in that case anyway).
	 */
	pickMode(pMode)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return false;
		let tmpOk = tmpProvider.setMode(pMode);

		if (tmpOk && typeof this.options.OnModeChange === 'function')
		{
			try { this.options.OnModeChange(pMode); }
			catch (pErr) { /* host hook failure */ }
		}

		// setMode fires onApply listeners which trigger our own re-render.
		// If single-mode rejected the change, force a re-render so the UI
		// state is still consistent.
		if (!tmpOk)
		{
			this.render();
		}
		return tmpOk;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToProvider()
	{
		if (this._unsubscribeFromProvider) return;
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.onApply !== 'function') return;
		let tmpSelf = this;
		this._unsubscribeFromProvider = tmpProvider.onApply(function ()
		{
			tmpSelf.render();
		});
	}

	_provider()
	{
		let tmpHash = this.options.ProviderHash || 'Theme';
		return this.pict && this.pict.providers && this.pict.providers[tmpHash];
	}

	_refreshAppData()
	{
		let tmpProvider = this._provider();
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : null;
		let tmpActiveMode = (tmpActive && tmpActive.Mode) || 'light';

		// Detect single-mode (Strategy === 'single') so we can lock the
		// toggle and surface the reason the buttons aren't responding.
		let tmpDisabled = false;
		let tmpLockedToMode = null;
		let tmpThemeName = null;
		if (tmpActive && tmpActive.Hash && tmpProvider && typeof tmpProvider.getTheme === 'function')
		{
			let tmpBundle = tmpProvider.getTheme(tmpActive.Hash);
			let tmpStrategy = (tmpBundle && tmpBundle.Modes && tmpBundle.Modes.Strategy) || 'single';
			tmpDisabled = (tmpStrategy === 'single');
			if (tmpDisabled)
			{
				tmpLockedToMode = (tmpBundle.Modes && tmpBundle.Modes.Default) || tmpActiveMode || 'light';
				tmpThemeName = tmpBundle.Name || tmpBundle.Hash || 'this theme';
			}
		}

		let tmpLabels = this.options.Labels || _ViewConfiguration.Labels;
		let tmpShowIcons = (this.options.ShowIcons !== false);

		// Use one-or-zero element arrays to drive each icon template so
		// the icon SVG never gets stuffed into AppData as a raw string.
		let tmpModeRows =
		[
			{ Mode: 'light',  Label: tmpLabels.Light  || 'Light' },
			{ Mode: 'dark',   Label: tmpLabels.Dark   || 'Dark' },
			{ Mode: 'system', Label: tmpLabels.System || 'System' }
		];
		let tmpButtons = [];
		for (let i = 0; i < tmpModeRows.length; i++)
		{
			let tmpRow = tmpModeRows[i];
			let tmpIsActive = (tmpActiveMode === tmpRow.Mode);
			// "Locked out" = single-mode theme AND this button is not the
			// mode the theme is fixed to. The active button keeps normal
			// styling so users can still see which mode is in use.
			let tmpLockedOut = tmpDisabled && (tmpRow.Mode !== tmpLockedToMode);
			let tmpTitle;
			if (tmpLockedOut)
			{
				let tmpLockedLabel = tmpLockedToMode.charAt(0).toUpperCase() + tmpLockedToMode.slice(1);
				tmpTitle = tmpThemeName + ' is fixed to ' + tmpLockedLabel + ' mode — pick a different theme to switch.';
			}
			else
			{
				tmpTitle = tmpRow.Label + ' mode';
			}
			tmpButtons.push(
			{
				Mode: tmpRow.Mode,
				Label: tmpRow.Label,
				Title: tmpTitle,
				Active: tmpIsActive,
				LockedOut: tmpLockedOut,
				IconLight:  (tmpShowIcons && tmpRow.Mode === 'light')  ? [{}] : [],
				IconDark:   (tmpShowIcons && tmpRow.Mode === 'dark')   ? [{}] : [],
				IconSystem: (tmpShowIcons && tmpRow.Mode === 'system') ? [{}] : []
			});
		}

		// One-or-zero element array drives the locked-note template
		// (per CLAUDE.md "single-element-array trick"). Empty array →
		// note skipped entirely.
		let tmpLockedNoteSlot = [];
		let tmpWrapTitle = '';
		if (tmpDisabled)
		{
			let tmpLockedLabel = tmpLockedToMode.charAt(0).toUpperCase() + tmpLockedToMode.slice(1);
			let tmpMessage = tmpThemeName + ' is fixed to ' + tmpLockedLabel + ' mode';
			tmpLockedNoteSlot = [{ Message: tmpMessage }];
			tmpWrapTitle = tmpMessage + ' — pick a different theme to switch modes.';
		}

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.ModeToggle =
		{
			ActiveMode: tmpActiveMode,
			Disabled: tmpDisabled,
			LockedToMode: tmpLockedToMode,
			ThemeName: tmpThemeName,
			Buttons: tmpButtons,
			LockedNoteSlot: tmpLockedNoteSlot,
			WrapTitle: tmpWrapTitle
		};
	}
}

PictViewThemeModeToggle.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeModeToggle;

},{"../Theme-Icons.js":166,"pict-view":239}],219:[function(require,module,exports){
/**
 * Theme-Picker — a custom dropdown that lists every theme registered
 * with the Theme provider, grouped by category.
 *
 * Renders as a trigger button showing the active theme name + a chevron.
 * Click → opens a `pict-section-modal` dropdown menu where each row is
 * the theme name plus an inline SVG glyph indicating the modes the
 * theme supports (sun for light-only, moon for dark-only, sun+moon for
 * paired). This is why we ditched the native <select>: option elements
 * can't render SVG, only plain text, and the unicode crescent
 * substitutes that earlier looked like dental glyphs.
 *
 * Subscribes to `provider.onApply` so a theme switch from elsewhere
 * (the modal-tucked picker, a hotkey, persistence restore) keeps the
 * trigger button in sync.
 *
 * Drop-in destination: `<div id="Theme-Picker"></div>`.
 *
 * # Modal section dependency
 *
 * Requires pict-section-modal to be registered (the dropdown popover
 * is a modal-section feature, not a hand-rolled DOM widget). When
 * pict-section-theme.install() is used, the host always has the modal
 * section available because Theme-Button needs it too. If you add this
 * view manually without the modal section, the trigger button will
 * still render but clicking it logs a warning and no-ops.
 */

const libPictView = require('pict-view');
const libThemeIcons = require('../Theme-Icons.js');

// AppData address used to surface picker state to templates.
const APPDATA_ADDRESS = 'PictSectionTheme.Picker';

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-Picker',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-Picker',
	DefaultRenderable: 'Theme-Picker-Renderable',

	ProviderHash: 'Theme',
	ModalViewHash: 'Pict-Section-Modal',

	// Optional categories block — array describing the optgroup order.
	// If omitted we discover categories from the provider's themes in
	// first-seen order.
	Categories: null,

	// Show the per-row mode-capability glyph (sun / moon / sun+moon) as
	// the leading icon on each dropdown item. Default on. Pass false if
	// you want a plainer menu.
	ShowModeIcons: true,

	Templates:
	[
		{
			Hash: 'Theme-Picker-Template',
			// Trigger button that mirrors a native <select>'s look but
			// can carry SVG content. Clicking opens the modal dropdown.
			Template: /*html*/`
<button type="button" class="pict-theme-picker"
        title="{~D:AppData.PictSectionTheme.Picker.TriggerTooltip~}"
        onclick="_Pict.views['Theme-Picker'].openMenu(this);">
	{~TS:Theme-Picker-Trigger-Glyph:AppData.PictSectionTheme.Picker.TriggerGlyphSlot~}
	<span class="pict-theme-picker-name">{~D:AppData.PictSectionTheme.Picker.ActiveLabel~}</span>
	<span class="pict-theme-picker-chevron">{~D:AppData.PictSectionTheme.Picker.ChevronHTML~}</span>
</button>`
		},
		{
			// Wrapped in a 1-or-0 element array so the trigger glyph is
			// optional (ShowModeIcons: false → empty slot, no leading
			// icon). Per CLAUDE.md "AppData stores data, not HTML".
			Hash: 'Theme-Picker-Trigger-Glyph',
			Template: /*html*/`<span class="pict-theme-picker-trigger-glyph">{~D:Record.IconHTML~}</span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-Picker-Renderable',
			TemplateHash: 'Theme-Picker-Template',
			ContentDestinationAddress: '#Theme-Picker',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-picker {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	min-width: 200px;
	max-width: 100%;
	padding: 6px 10px;
	border-radius: 6px;
	font: inherit;
	font-size: 13px;
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-primary, #1f2933);
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	cursor: pointer;
	text-align: left;
	transition: border-color 120ms ease, box-shadow 120ms ease;
}
.pict-theme-picker:hover { border-color: var(--theme-color-text-muted, #6b6b6b); }
.pict-theme-picker:focus, .pict-theme-picker:focus-visible {
	outline: none;
	border-color: var(--theme-color-brand-primary, #2563eb);
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.pict-theme-picker .pict-theme-picker-name {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.pict-theme-picker .pict-theme-picker-chevron {
	color: var(--theme-color-text-muted, #6b6b6b);
	display: inline-flex;
	align-items: center;
}
.pict-theme-picker-trigger-glyph {
	display: inline-flex; align-items: center;
	color: var(--theme-color-text-muted, #6b6b6b);
}

/* Skin the modal-dropdown items with cleaner spacing for our glyphs. */
.pict-theme-picker-menu .pict-modal-dropdown-item-icon {
	width: 28px;
	display: inline-flex;
	align-items: center;
	justify-content: flex-start;
	color: var(--theme-color-text-muted, #6b6b6b);
}
.pict-theme-picker-menu .pict-modal-dropdown-item--active {
	background: var(--theme-color-background-selected, #e0eaff);
	color: var(--theme-color-brand-primary, #2563eb);
}
.pict-theme-picker-menu .pict-modal-dropdown-item--active .pict-modal-dropdown-item-icon {
	color: var(--theme-color-brand-primary, #2563eb);
}`,
	CSSPriority: 500
};

class PictViewThemePicker extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromProvider = null;
	}

	onAfterInitialize()
	{
		this._subscribeToProvider();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		// Defensive resubscribe: onAfterInitialize attempts this once, but if the
		// Theme provider wasn't yet registered at that moment (a real race when
		// docuserve wires the Theme-Section after some views have already been
		// instantiated), the initial subscribe silently no-ops and the picker
		// never re-renders on applyTheme.  The internal guard makes this cheap
		// when we're already subscribed.
		this._subscribeToProvider();
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onclick handler — open the rich dropdown menu via pict-section-modal.
	 * @param {HTMLElement} pAnchor - the trigger button (click target)
	 */
	openMenu(pAnchor)
	{
		let tmpModal = this._modal();
		if (!tmpModal)
		{
			if (typeof console !== 'undefined' && console.warn)
			{
				console.warn('Theme-Picker: pict-section-modal not registered — cannot open menu.');
			}
			return null;
		}

		let tmpItems = this._buildMenuItems();
		let tmpSelf = this;
		return tmpModal.dropdown(pAnchor,
		{
			items: tmpItems,
			align: 'left',
			minWidth: '260px',
			maxHeight: '60vh',
			className: 'pict-theme-picker-menu',
			closeOnSelect: true,
			onSelect: function (pHash) { tmpSelf.pick(pHash); }
		});
	}

	/**
	 * Apply the picked theme. Public so external callers can drive the
	 * picker programmatically too (hotkeys, tests, etc.).
	 */
	pick(pHash)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return false;

		// Preserve the current user-facing mode if the new theme
		// supports modes. Single-mode themes will clamp internally.
		let tmpActive = tmpProvider.getActiveTheme();
		let tmpMode = tmpActive ? tmpActive.Mode : null;

		let tmpOk = tmpProvider.applyTheme(pHash, tmpMode);

		if (tmpOk && typeof this.options.OnPick === 'function')
		{
			try { this.options.OnPick(pHash); }
			catch (pErr) { /* host hook failure */ }
		}
		return tmpOk;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToProvider()
	{
		if (this._unsubscribeFromProvider) return;
		let tmpProvider = this._provider();
		if (!tmpProvider || typeof tmpProvider.onApply !== 'function') return;
		let tmpSelf = this;
		this._unsubscribeFromProvider = tmpProvider.onApply(function ()
		{
			tmpSelf.render();
		});
	}

	_provider()
	{
		let tmpHash = this.options.ProviderHash || 'Theme';
		return this.pict && this.pict.providers && this.pict.providers[tmpHash];
	}

	_modal()
	{
		let tmpHash = this.options.ModalViewHash || 'Pict-Section-Modal';
		return this.pict && this.pict.views && this.pict.views[tmpHash];
	}

	/**
	 * Build the modal-dropdown `items` array from the registered themes
	 * + the catalog's category metadata. One Header row per category,
	 * one item per theme with a leading SVG capability glyph.
	 */
	_buildMenuItems()
	{
		let tmpProvider = this._provider();
		let tmpThemes = tmpProvider ? tmpProvider.listThemes() : [];
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : { Hash: null };
		let tmpActiveHash = (tmpActive && tmpActive.Hash) || null;

		let tmpCatalog = this._loadCatalog();
		let tmpCategoryByHash = {};
		let tmpCategoryOrder = [];
		if (Array.isArray(this.options.Categories))
		{
			tmpCategoryOrder = this.options.Categories.slice();
		}
		for (let i = 0; i < tmpCatalog.length; i++)
		{
			let tmpEntry = tmpCatalog[i];
			let tmpCat = tmpEntry.Category || 'Other';
			tmpCategoryByHash[tmpEntry.Hash] = tmpCat;
			if (tmpCategoryOrder.indexOf(tmpCat) < 0) tmpCategoryOrder.push(tmpCat);
		}

		let tmpBuckets = {};
		for (let i = 0; i < tmpThemes.length; i++)
		{
			let tmpTheme = tmpThemes[i];
			let tmpCat = tmpCategoryByHash[tmpTheme.Hash] || 'Other';
			if (!tmpBuckets[tmpCat])
			{
				tmpBuckets[tmpCat] = [];
				if (tmpCategoryOrder.indexOf(tmpCat) < 0) tmpCategoryOrder.push(tmpCat);
			}
			tmpBuckets[tmpCat].push(tmpTheme);
		}

		let tmpShowIcons = (this.options.ShowModeIcons !== false);
		let tmpItems = [];
		for (let i = 0; i < tmpCategoryOrder.length; i++)
		{
			let tmpCat = tmpCategoryOrder[i];
			if (!tmpBuckets[tmpCat] || tmpBuckets[tmpCat].length === 0) continue;
			tmpItems.push({ Header: tmpCat });
			for (let j = 0; j < tmpBuckets[tmpCat].length; j++)
			{
				let tmpTheme = tmpBuckets[tmpCat][j];
				let tmpIcon = tmpShowIcons
					? libThemeIcons.iconForTheme(tmpTheme.Strategy, tmpTheme.DefaultMode, 14)
					: '';
				tmpItems.push(
				{
					Hash: tmpTheme.Hash,
					Label: tmpTheme.Name || tmpTheme.Hash,
					Icon: tmpIcon,
					Style: (tmpTheme.Hash === tmpActiveHash) ? 'active' : null,
					Tooltip: this._capabilityLabel(tmpTheme)
				});
			}
		}

		return tmpItems;
	}

	_capabilityLabel(pTheme)
	{
		let tmpStrategy = pTheme.Strategy || 'single';
		if (tmpStrategy === 'single')
		{
			let tmpMode = pTheme.DefaultMode || 'light';
			return (pTheme.Name || pTheme.Hash) + ' — '
				+ (tmpMode === 'dark' ? 'dark only' : 'light only');
		}
		return (pTheme.Name || pTheme.Hash) + ' — light + dark';
	}

	_refreshAppData()
	{
		let tmpProvider = this._provider();
		let tmpThemes = tmpProvider ? tmpProvider.listThemes() : [];
		let tmpActive = tmpProvider ? tmpProvider.getActiveTheme() : { Hash: null };
		let tmpActiveHash = (tmpActive && tmpActive.Hash) || null;

		// Find the active theme's metadata for the trigger glyph.
		let tmpActiveTheme = null;
		for (let i = 0; i < tmpThemes.length; i++)
		{
			if (tmpThemes[i].Hash === tmpActiveHash) { tmpActiveTheme = tmpThemes[i]; break; }
		}

		let tmpShowIcons = (this.options.ShowModeIcons !== false);
		let tmpTriggerGlyphSlot = [];
		if (tmpShowIcons && tmpActiveTheme)
		{
			tmpTriggerGlyphSlot = [{
				IconHTML: libThemeIcons.iconForTheme(tmpActiveTheme.Strategy, tmpActiveTheme.DefaultMode, 14)
			}];
		}

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.Picker =
		{
			ActiveHash: tmpActiveHash,
			ActiveLabel: tmpActiveTheme ? (tmpActiveTheme.Name || tmpActiveTheme.Hash) : 'Choose a theme',
			TriggerTooltip: tmpActiveTheme
				? this._capabilityLabel(tmpActiveTheme) + ' — click to change'
				: 'Choose a theme',
			TriggerGlyphSlot: tmpTriggerGlyphSlot,
			ChevronHTML: libThemeIcons.iconChevronDown(10)
		};
		this.pict.AppData.PictSectionTheme.AllThemes = tmpThemes;
	}

	_loadCatalog()
	{
		try { return require('../themes/_catalog.js'); }
		catch (pError) { return []; }
	}
}

PictViewThemePicker.default_configuration = _ViewConfiguration;
PictViewThemePicker.APPDATA_ADDRESS = APPDATA_ADDRESS;

module.exports = PictViewThemePicker;

},{"../Theme-Icons.js":166,"../themes/_catalog.js":172,"pict-view":239}],220:[function(require,module,exports){
/**
 * Theme-ScaleSelect — dropdown that picks a viewport scale (zoom).
 *
 * Independent of the active theme bundle: scale is a per-user
 * preference stored alongside ThemeHash + Mode in localStorage. Reads
 * presets from the Theme-Scale helper (or a host-supplied `Presets`
 * array). Subscribes to Theme-Scale.onChange so external scale changes
 * (the persisted boot apply, hotkeys, other code) keep the dropdown's
 * selected option in sync.
 *
 * Drop-in destination: `<div id="Theme-ScaleSelect"></div>`.
 */

const libPictView = require('pict-view');
const libThemeScale = require('../Theme-Scale.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-ScaleSelect',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-ScaleSelect',
	DefaultRenderable: 'Theme-ScaleSelect-Renderable',

	// Optional override of the preset list. Each entry: { Value: <number>, Label: <string> }.
	// When omitted we use libThemeScale.PRESETS.
	Presets: null,

	Templates:
	[
		{
			Hash: 'Theme-ScaleSelect-Template',
			Template: /*html*/`
<select class="pict-theme-scaleselect"
        title="{~D:AppData.PictSectionTheme.ScaleSelect.Tooltip~}"
        onchange="_Pict.views['Theme-ScaleSelect'].pickScale(parseFloat(this.value));">
	{~TS:Theme-ScaleSelect-Option-Template:AppData.PictSectionTheme.ScaleSelect.Options~}
</select>`
		},
		{
			Hash: 'Theme-ScaleSelect-Option-Template',
			Template: /*html*/`
<option value="{~D:Record.Value~}"{~NE:Record.Selected^ selected~}>{~D:Record.Label~}</option>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-ScaleSelect-Renderable',
			TemplateHash: 'Theme-ScaleSelect-Template',
			ContentDestinationAddress: '#Theme-ScaleSelect',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-scaleselect {
	min-width: 180px;
	padding: 6px 10px;
	border-radius: 6px;
	font: inherit;
	font-size: 13px;
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-primary, #1f2933);
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	cursor: pointer;
}
.pict-theme-scaleselect:focus {
	outline: none;
	border-color: var(--theme-color-brand-primary, #2563eb);
	box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}`,
	CSSPriority: 500
};

class PictViewThemeScaleSelect extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._unsubscribeFromScale = null;
	}

	onAfterInitialize()
	{
		this._subscribeToScale();
		return super.onAfterInitialize ? super.onAfterInitialize() : undefined;
	}

	onBeforeRender(pRenderable)
	{
		this._refreshAppData();
		return super.onBeforeRender ? super.onBeforeRender(pRenderable) : undefined;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	/**
	 * onchange handler — apply a new scale and let the listener re-render.
	 * @param {number} pScale
	 */
	pickScale(pScale)
	{
		let tmpApplied = libThemeScale.applyScale(pScale);
		if (typeof this.options.OnScaleChange === 'function')
		{
			try { this.options.OnScaleChange(tmpApplied); }
			catch (pErr) { /* host hook failure */ }
		}
		return tmpApplied;
	}

	// ================================================================
	// Internals
	// ================================================================

	_subscribeToScale()
	{
		if (this._unsubscribeFromScale) return;
		let tmpSelf = this;
		this._unsubscribeFromScale = libThemeScale.onChange(function ()
		{
			tmpSelf.render();
		});
	}

	_refreshAppData()
	{
		let tmpPresets = Array.isArray(this.options.Presets) ? this.options.Presets : libThemeScale.PRESETS;
		let tmpActive = libThemeScale.getActive();

		// "Closest" match — the saved scale may be a custom value (e.g.
		// 1.10 from a hotkey nudge) that doesn't exactly equal any preset.
		// We highlight the nearest option so the dropdown still reflects
		// roughly where the user is.
		let tmpClosestIdx = 0;
		let tmpClosestDelta = Infinity;
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpDelta = Math.abs(tmpPresets[i].Value - tmpActive);
			if (tmpDelta < tmpClosestDelta) { tmpClosestDelta = tmpDelta; tmpClosestIdx = i; }
		}

		let tmpOptions = [];
		for (let i = 0; i < tmpPresets.length; i++)
		{
			let tmpEntry = tmpPresets[i];
			tmpOptions.push(
			{
				Value: tmpEntry.Value,
				Label: tmpEntry.Label,
				Selected: (i === tmpClosestIdx)
			});
		}

		let tmpTooltip = 'Viewport scale — currently '
			+ Math.round(tmpActive * 100) + '%';

		this.pict.AppData.PictSectionTheme = this.pict.AppData.PictSectionTheme || {};
		this.pict.AppData.PictSectionTheme.ScaleSelect =
		{
			ActiveScale: tmpActive,
			Tooltip: tmpTooltip,
			Options: tmpOptions
		};
	}
}

PictViewThemeScaleSelect.default_configuration = _ViewConfiguration;

module.exports = PictViewThemeScaleSelect;

},{"../Theme-Scale.js":168,"pict-view":239}],221:[function(require,module,exports){
/**
 * Theme-TopBar — standard application chrome row.
 *
 * Provides the boilerplate every Pict / retold app remakes: a flex row
 * with three zones — brand mark on the left, navigation in the middle,
 * configuration / user widgets on the right (with the theme button
 * pinned at the far edge).
 *
 *   ┌────────────────────────────────────────────────────────────────┐
 *   │ [Brand-Mark]   [── Nav slot (flex-grow) ──]   [User-slot] [⚙]  │
 *   └────────────────────────────────────────────────────────────────┘
 *
 * Auto-mounts:
 *   - Theme-Brand-Mark in the brand slot (skip via MountBrandMark: false)
 *   - Theme-Button at the far right of the user area (skip via
 *     MountThemeButton: false)
 *
 * Host fills two empty slots via standard Pict view destinations:
 *   - `#Theme-TopBar-Nav`  — primary navigation / action buttons
 *   - `#Theme-TopBar-User` — app-specific user-area widgets (account,
 *                            log toggle, custom indicators)
 *
 * Renders into `#Theme-TopBar` by default. The host's layout shell
 * provides that destination — typically the top panel of a
 * pict-section-modal Shell.
 *
 * The bottom border uses `--brand-color-primary-mode` so the topbar
 * carries a thin brand stripe that auto-swaps with light/dark mode.
 *
 * Each app's nav / user-area views can stay app-specific; this view
 * eliminates the chrome boilerplate around them.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Theme-TopBar',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#Theme-TopBar',
	DefaultRenderable: 'Theme-TopBar-Renderable',

	// When false, the host is responsible for mounting Theme-Brand-Mark
	// itself (or skipping the brand entirely).
	MountBrandMark: true,
	// When false, Theme-Button is not auto-mounted into the user slot.
	// Useful when the host wants to position the button somewhere else
	// or when no theme picker is desired.
	MountThemeButton: true,
	// ViewIdentifier of a host-supplied view that fills the nav slot
	// (#Theme-TopBar-Nav). Typical convention: a small per-app view
	// rendering primary action buttons / nav links / breadcrumbs.
	NavView: null,
	// ViewIdentifier of a host-supplied view that fills the user-area
	// slot (#Theme-TopBar-User). Theme-Button still auto-mounts at the
	// far edge — this view fills the slot before it.
	UserView: null,

	// Height of the bar in pixels. Drives the min-height on the
	// chrome row so it fills the panel cleanly even when the parent
	// chain (pict-section-modal shell uses min-height: 100% on its
	// panel content destination, which doesn't resolve through plain
	// height: 100% chains) doesn't establish a determinate height.
	// Hosts should match this to whatever Size they use on the panel
	// addPanel() call so the chrome and panel agree on the row size.
	Height: 56,

	// Horizontal alignment of items inside the nav slot. The slot
	// itself stretches (flex: 1) between brand mark and user area;
	// this option controls where the nav content sits within that
	// stretched space. Default 'right' so action buttons hug the
	// user-area / theme button cluster (the convention every
	// retold-* app converged on). Override to 'left' to put the nav
	// flush against the brand, or 'center' to centre it across the
	// row. Maps to justify-content: flex-end / flex-start / center.
	NavAlign: 'right',

	// Viewport width (px) below which the topbar collapses to compact
	// mode: nav + user-area widgets hide, a burger button shows in
	// their place. Clicking the burger opens a pict-section-modal
	// popup with a clone of the nav + user DOM, so every action stays
	// reachable.
	//
	// Default 900px — the conventional "narrow desktop / small laptop"
	// cut-off where a topbar with ~4 nav buttons + a brand mark + a
	// user-area cluster genuinely starts crowding. Most users will
	// resize a window to this range (drag a split-pane, dock a window
	// next to another app, etc.); 600px would only trigger at true
	// mobile widths most desktop users never hit.
	//
	// Conventional ladder for picking a value:
	//   ~1024px  large breakpoint — nav-heavy apps with 6+ buttons
	//    ~900px  default — "narrow desktop window" (recommended)
	//    ~768px  tablet portrait — minimal-nav apps
	//    ~600px  mobile-only — single-button toolbars
	//        0   disable compact mode entirely
	CompactBreakpoint: 900,

	Templates:
	[
		{
			Hash: 'Theme-TopBar-Template',
			// The burger button is hidden by default and the regular nav /
			// user-slot are visible — flipped by the media query in CSS
			// at the CompactBreakpoint (default 600px). On click the
			// burger opens a pict-section-modal popup containing a clone
			// of the existing #Theme-TopBar-Nav + #Theme-TopBar-User DOM
			// — host apps don't need to provide a separate burger view.
			Template: /*html*/`
<div class="pict-theme-topbar">
	<div class="pict-theme-topbar-mark"><div id="Theme-Brand-Mark"></div></div>
	<div class="pict-theme-topbar-nav" id="Theme-TopBar-Nav"></div>
	<div class="pict-theme-topbar-user">
		<div class="pict-theme-topbar-user-slot" id="Theme-TopBar-User"></div>
		<div class="pict-theme-topbar-user-button"><div id="Theme-Button"></div></div>
		<button type="button" class="pict-theme-topbar-burger"
			aria-label="More navigation"
			title="Menu"
			onclick="_Pict.views['Theme-TopBar'].openBurgerMenu();">
			<svg width="20" height="20" viewBox="0 0 24 24" fill="none"
				stroke="currentColor" stroke-width="2"
				stroke-linecap="round" stroke-linejoin="round"
				aria-hidden="true">
				<path d="M3 6h18M3 12h18M3 18h18"/>
			</svg>
		</button>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Theme-TopBar-Renderable',
			TemplateHash: 'Theme-TopBar-Template',
			ContentDestinationAddress: '#Theme-TopBar',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
.pict-theme-topbar {
	display: flex;
	align-items: center;
	gap: 14px;
	/* The min-height is rewritten per-instance in onAfterRender from the
	   Height option (default 56). Avoids the percent-height resolution
	   trap: pict-section-modal's panel destination uses min-height: 100%
	   on its inner div, which means a child's height: 100% / min-height:
	   100% resolves against the parent's *property* (auto), not its
	   resolved size — and collapses the row to its content. A fixed px
	   value gives align-items: center real space to centre into. */
	min-height: 56px;
	padding: 0 14px;
	box-sizing: border-box;
	background: var(--theme-color-background-panel, transparent);
	/* Brand stripes are drawn by .pict-theme-topbar::after as an absolute
	   element overlaying the bottom 5px of the row. Using ::after rather
	   than border-bottom + box-shadow lets us put a transparent gap
	   between the two stripes (border / box-shadow can't draw gaps).
	   Position relative so the ::after positions to this row. */
	position: relative;
}
/* Two-stripe brand identifier at the bottom of the topbar:
     4px brand-primary (thicker — the dominant identifier)
     2px transparent gap (clearly readable separation)
     3px brand-secondary (thinner than primary but still substantial)
   Earlier iterations used 1–2px stripes; both read clearly at light
   mode but dark-mode secondary colors are often desaturated (lifted)
   so the eye can miss a thin band against a dark background. The
   current sizes push the secondary above the perception threshold
   regardless of palette. Stripes overlay the bottom 9px of the row;
   content (which centres in the full row via align-items: center)
   keeps its visual position. */
.pict-theme-topbar::after {
	content: '';
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 9px;
	pointer-events: none;
	background: linear-gradient(
		to bottom,
		var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)) 0,
		var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb)) 4px,
		transparent 4px,
		transparent 6px,
		var(--brand-color-secondary-mode, var(--theme-color-brand-secondary, transparent)) 6px,
		var(--brand-color-secondary-mode, var(--theme-color-brand-secondary, transparent)) 9px
	);
}
.pict-theme-topbar-mark {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
}
.pict-theme-topbar-nav {
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	/* Default to right-aligning nav items inside the stretched slot —
	   the convention retold-* apps converged on. Overridden per-instance
	   from the NavAlign option in onAfterRender. */
	justify-content: flex-end;
	gap: 8px;
	min-width: 0;
	/* Horizontally scrollable when the nav overflows (narrow viewports
	   with many buttons) — better than overflow:hidden which would
	   silently clip buttons offscreen. The vertical axis stays clipped
	   so a tall accidental child doesn't blow up the row height. A
	   proper overflow menu is a future enhancement; this gets us safe
	   degradation today. */
	overflow-x: auto;
	overflow-y: hidden;
	/* Hide the scrollbar by default; modern browsers pick up the
	   trackpad scroll without it. Apps wanting a visible scrollbar
	   can override at higher specificity. */
	scrollbar-width: none;
}
.pict-theme-topbar-nav::-webkit-scrollbar { display: none; }
/* Active-route indicator. The convention every host app should follow:
   put aria-current="page" on the button (or anchor) representing the
   current route. The W3C-standard attribute reads correctly to screen
   readers and gets a brand-tinted highlight here. Apps that already
   ship their own active styling can override these rules — they're
   keyed off attribute selectors so no class collision is possible. */
.pict-theme-topbar-nav [aria-current="page"],
.pict-theme-topbar-user [aria-current="page"] {
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	background: var(--theme-color-background-hover, rgba(37, 99, 235, 0.08));
}
.pict-theme-topbar-user {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	gap: 8px;
}
.pict-theme-topbar-user-slot {
	display: flex;
	align-items: center;
	gap: 8px;
}
.pict-theme-topbar-user-button {
	display: flex;
	align-items: center;
}
/* Burger button — hidden by default; the media query (or the inline
   per-instance JS that swaps it via CompactBreakpoint) shows it once
   the viewport drops below the host's compact threshold. Sized to
   match Theme-Button (28×28) so the row's rhythm is preserved. */
.pict-theme-topbar-burger {
	display: none;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	padding: 0;
	border-radius: 6px;
	border: 1px solid var(--theme-color-border-default, #cfd5dd);
	background: var(--theme-color-background-secondary, #fbfbfc);
	color: var(--theme-color-text-secondary, #4a5568);
	cursor: pointer;
	transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}
.pict-theme-topbar-burger:hover {
	background: var(--theme-color-background-hover, #f0f0f0);
	color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
	border-color: var(--brand-color-primary-mode, var(--theme-color-brand-primary, #2563eb));
}
/* Burger menu popup — applied to the cloned nav + user DOM inside
   pict-section-modal. The cloned children inherit their original
   styling (action buttons, badges, etc.) so the popup looks visually
   consistent with what was on the topbar. */
.pict-theme-burger-menu {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
.pict-theme-burger-menu-section {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
/* Cloned children render as a vertical stack inside the popup — flip
   the horizontal flex layouts to column so each button takes a full
   row instead of cramming side-by-side at narrow width. */
.pict-theme-burger-menu .rm-topbar-nav,
.pict-theme-burger-menu .rm-topbar-user,
.pict-theme-burger-menu [class*="-topbar-nav"],
.pict-theme-burger-menu [class*="-topbar-user"] {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 6px;
}
.pict-theme-burger-menu button { width: 100%; text-align: left; }
.pict-theme-burger-menu .rm-topbar-nav-divider,
.pict-theme-burger-menu [class*="divider"] { display: none; }
/* Compact mode — defaults to a 900px breakpoint. The onAfterRender
   handler injects a per-instance <style> rule when the host passes a
   different CompactBreakpoint, so this @media block is the fallback
   for hosts that accept the default. */
@media (max-width: 900px) {
	.pict-theme-topbar-nav            { display: none !important; }
	.pict-theme-topbar-user-slot      { display: none !important; }
	.pict-theme-topbar-burger         { display: inline-flex; }
	/* In wide mode the flex-1 nav slot pushes the user-area to the
	   right edge. With the nav hidden the user-area would collapse
	   left of the now-empty middle; the auto-margin re-creates the
	   "push right" effect so the theme button + burger stay flush
	   against the right edge of the topbar. */
	.pict-theme-topbar-user           { margin-left: auto; }
}`,
	CSSPriority: 500
};

class PictViewThemeTopBar extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Apply the configured Height to the rendered .pict-theme-topbar.
		// Using inline style so each instance can carry its own size
		// (different apps will pick different heights) without us having
		// to inject per-instance <style> blocks.
		if (typeof document !== 'undefined' && this.options.Height)
		{
			let tmpRoot = document.querySelector('.pict-theme-topbar');
			if (tmpRoot) { tmpRoot.style.minHeight = this.options.Height + 'px'; }
		}

		// Per-instance CompactBreakpoint. CSS @media rules can't reference
		// JS option values, so when the host overrides the default 600px
		// we inject a single-rule <style> with the chosen breakpoint and
		// !important to win over the static media query. Set to 0 to
		// disable compact mode entirely (the burger stays hidden).
		this._applyCompactBreakpoint();

		// Translate NavAlign ('left' | 'right' | 'center') to the matching
		// justify-content. Right is the default (and already in the static
		// CSS), but the inline style wins so an explicit option always
		// takes precedence over the cached stylesheet.
		if (typeof document !== 'undefined' && this.options.NavAlign)
		{
			let tmpJustify = ({
				left:   'flex-start',
				right:  'flex-end',
				center: 'center'
			})[this.options.NavAlign];
			if (tmpJustify)
			{
				let tmpNav = document.querySelector('.pict-theme-topbar-nav');
				if (tmpNav) { tmpNav.style.justifyContent = tmpJustify; }
			}
		}

		// Auto-mount the standard pieces. Host can opt out via the view
		// options (MountBrandMark / MountThemeButton).
		if (this.options.MountBrandMark !== false)
		{
			let tmpBrandMark = this.pict.views['Theme-Brand-Mark'];
			if (tmpBrandMark) { tmpBrandMark.render(); }
		}
		if (this.options.NavView)
		{
			let tmpNavView = this.pict.views[this.options.NavView];
			if (tmpNavView) { tmpNavView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-TopBar: NavView "' + this.options.NavView + '" not registered');
			}
		}
		if (this.options.UserView)
		{
			let tmpUserView = this.pict.views[this.options.UserView];
			if (tmpUserView) { tmpUserView.render(); }
			else if (this.log && this.log.warn)
			{
				this.log.warn('Theme-TopBar: UserView "' + this.options.UserView + '" not registered');
			}
		}
		if (this.options.MountThemeButton !== false)
		{
			let tmpThemeButton = this.pict.views['Theme-Button'];
			if (tmpThemeButton) { tmpThemeButton.render(); }
		}

		return super.onAfterRender ? super.onAfterRender(pRenderable, pAddress, pRecord, pContent) : undefined;
	}

	// ─── Per-route slot swapping ──────────────────────────────────────────
	// Apps with chrome that morphs between routes (e.g. breadcrumb-style
	// navigation that differs by section) call setNavView / setUserView
	// from their router callback. The new view is rendered into the
	// matching slot and the option is persisted so subsequent re-renders
	// of the topbar (theme switches, etc.) keep the new view mounted.

	/**
	 * Swap the NavView (slot at `#Theme-TopBar-Nav`) at runtime.
	 * @param {string|null} pViewIdentifier
	 *   View hash to mount, or null to clear the slot.
	 */
	setNavView(pViewIdentifier)
	{
		this.options.NavView = pViewIdentifier || null;
		this._mountSlot('#Theme-TopBar-Nav', this.options.NavView);
	}

	/**
	 * Swap the UserView (slot at `#Theme-TopBar-User`) at runtime.
	 * @param {string|null} pViewIdentifier
	 */
	setUserView(pViewIdentifier)
	{
		this.options.UserView = pViewIdentifier || null;
		this._mountSlot('#Theme-TopBar-User', this.options.UserView);
	}

	_mountSlot(pDestSelector, pViewIdentifier)
	{
		// Clear the slot first — handles both the clear-only case
		// (pViewIdentifier is null) and the swap case (gives the
		// new view a clean slate when its renderable doesn't use
		// `replace` mode).
		if (typeof document !== 'undefined')
		{
			let tmpDest = document.querySelector(pDestSelector);
			if (tmpDest) { tmpDest.innerHTML = ''; }
		}
		if (!pViewIdentifier) { return; }
		let tmpView = this.pict.views[pViewIdentifier];
		if (tmpView) { tmpView.render(); }
		else if (this.log && this.log.warn)
		{
			this.log.warn('Theme-TopBar: view "' + pViewIdentifier + '" not registered');
		}
	}

	// ─── Compact mode + burger menu ──────────────────────────────────────
	// At narrow widths the nav + user-area slots collapse into a single
	// burger button that opens a pict-section-modal popup with the
	// cloned nav + user DOM. The default breakpoint is 600px; hosts that
	// want a different value pass CompactBreakpoint in ViewOptions.

	_applyCompactBreakpoint()
	{
		if (typeof document === 'undefined') return;
		// Default value of 900 lives in the static CSS @media block; we
		// only need to inject when the host explicitly overrode it.
		let tmpBreakpoint = this.options.CompactBreakpoint;
		if (tmpBreakpoint === undefined || tmpBreakpoint === null) return;
		if (tmpBreakpoint === 900) return;  // matches default — no override needed

		let tmpStyleId = 'pict-theme-topbar-compact-' + this.UUID;
		let tmpStyleEl = document.getElementById(tmpStyleId);
		if (!tmpStyleEl)
		{
			tmpStyleEl = document.createElement('style');
			tmpStyleEl.id = tmpStyleId;
			document.head.appendChild(tmpStyleEl);
		}

		// 0 (or any non-positive value) disables compact mode by emitting
		// a never-matching media rule. The static CSS still has the 600px
		// rule, so we override it with a more-specific selector + the
		// chosen breakpoint. Specificity-wise the inline rule wins
		// because it's emitted after the static CSS and has !important
		// matching the static rule's importance.
		if (typeof tmpBreakpoint !== 'number' || tmpBreakpoint <= 0)
		{
			// Disable: force compact selectors to never apply by giving
			// the burger display: none unconditionally at all widths.
			tmpStyleEl.textContent =
				'.pict-theme-topbar-nav            { display: flex !important; }\n' +
				'.pict-theme-topbar-user-slot      { display: flex !important; }\n' +
				'.pict-theme-topbar-burger         { display: none !important; }\n' +
				'.pict-theme-topbar-user           { margin-left: 0 !important; }\n';
		}
		else
		{
			tmpStyleEl.textContent =
				'@media (max-width: ' + tmpBreakpoint + 'px) {\n' +
				'\t.pict-theme-topbar-nav            { display: none !important; }\n' +
				'\t.pict-theme-topbar-user-slot      { display: none !important; }\n' +
				'\t.pict-theme-topbar-burger         { display: inline-flex !important; }\n' +
				'\t.pict-theme-topbar-user           { margin-left: auto !important; }\n' +
				'}\n' +
				'@media (min-width: ' + (tmpBreakpoint + 1) + 'px) {\n' +
				'\t.pict-theme-topbar-nav            { display: flex !important; }\n' +
				'\t.pict-theme-topbar-user-slot      { display: flex !important; }\n' +
				'\t.pict-theme-topbar-burger         { display: none !important; }\n' +
				'\t.pict-theme-topbar-user           { margin-left: 0 !important; }\n' +
				'}\n';
		}
	}

	/**
	 * Open the burger / overflow menu. Clones the current contents of
	 * `#Theme-TopBar-Nav` and `#Theme-TopBar-User` into a
	 * pict-section-modal popup so every action stays reachable at narrow
	 * widths. The cloned buttons keep their inline `onclick` handlers
	 * (those reference globals like `_Pict.PictApplication.*`, which
	 * resolve at click-time regardless of where the DOM lives).
	 *
	 * Override on the instance (`view.openBurgerMenu = function() {...}`)
	 * to customise the popup contents — e.g. emit a per-app menu view
	 * instead of cloning the topbar DOM.
	 */
	openBurgerMenu()
	{
		if (typeof document === 'undefined') return null;
		let tmpModal = this.pict.views['Pict-Section-Modal'];
		if (!tmpModal || typeof tmpModal.show !== 'function')
		{
			if (typeof console !== 'undefined' && console.warn)
			{
				console.warn('Theme-TopBar: pict-section-modal not registered — burger menu unavailable.');
			}
			return null;
		}

		let tmpSections = [];
		let tmpNav = document.querySelector('#Theme-TopBar-Nav');
		let tmpUser = document.querySelector('#Theme-TopBar-User');
		if (tmpNav && tmpNav.innerHTML.trim())
		{
			tmpSections.push('<div class="pict-theme-burger-menu-section">' + tmpNav.innerHTML + '</div>');
		}
		if (tmpUser && tmpUser.innerHTML.trim())
		{
			tmpSections.push('<div class="pict-theme-burger-menu-section">' + tmpUser.innerHTML + '</div>');
		}
		if (tmpSections.length === 0)
		{
			tmpSections.push('<div class="pict-theme-burger-menu-empty">No menu items configured.</div>');
		}

		let tmpHTML = '<div class="pict-theme-burger-menu">' + tmpSections.join('') + '</div>';

		return tmpModal.show(
		{
			title:    'Menu',
			content:  tmpHTML,
			width:    '280px',
			closeable: true,
			buttons:  []
		});
	}
}

module.exports = PictViewThemeTopBar;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],222:[function(require,module,exports){
module.exports={
	"RenderOnLoad": true,

	"GridWidth": "auto",
	"GridRowHeight": 40,

	"GridBodyHeight": "auto",
	"GridBodyMinHeight": 130,

	"GridColumnMinWidth": 50,
	"GridColumnWidthResizable": true,
	"GridColumnHeightResizable": false,

	"GridColumnFrozenCount": 0,
	"GridColumnFrozenBorderWidth": 3,

	"GridScrollX": true,
	"GridScrollY": true,

	"GridShowDummyRows": false,
	"GridDraggableRows": false,

	"GridSelectionUnit": "cell",

	"DefaultRenderable": "TuiGrid-Wrap",
	"DefaultDestinationAddress": "#TuiGrid-Container-Div",

	"Templates": [
		{
			"Hash": "TuiGrid-Container",
			"Template": "<!-- TuiGrid-Container Rendering Soon -->"
		}
	],

	"Renderables": [
		{
			"RenderableHash": "TuiGrid-Wrap",
			"TemplateHash": "TuiGrid-Container",
			"DestinationAddress": "#TuiGrid-Container-Div"
		}
	],

	"TargetElementAddress": "#TuiGrid-Container-Div",

	"GridDataAddress": false,

	"GridData": [
		{
			"idrecord": 1,
			"entity": "SampleEntity",
			"name": "Record name 1",
			"description": "description 1"
		},
		{
			"idrecord": 2,
			"entity": "SampleEntity",
			"name": "Record name 2",
			"description": "description 2"
		},
		{
			"idrecord": 3,
			"entity": "SampleEntity",
			"name": "Record name 3",
			"description": "description 3"
		},
		{
			"idrecord": 4,
			"entity": "SampleEntity",
			"name": "Record name 4",
			"description": "description 4"
		},
		{
			"idrecord": 5,
			"entity": "SampleEntity",
			"name": "Record name 5",
			"description": "description 5"
		},
		{
			"idrecord": 6,
			"entity": "SampleEntity",
			"name": "Record name 6",
			"description": "description 6"
		},
		{
			"idrecord": 7,
			"entity": "SampleEntity",
			"name": "Record name 7",
			"description": "description 7"
		},
		{
			"idrecord": 8,
			"entity": "SampleEntity",
			"name": "Record name 8",
			"description": "description 8"
		},
		{
			"idrecord": 9,
			"entity": "SampleEntity",
			"name": "Record name 9",
			"description": "description 9"
		}
	],
	"ColumnsToSolveOnChange": {},
	"TuiColumnSchema": [
		{
			"header": "IDRecord",
			"name": "idrecord",
			"PictTriggerSolveOnChange": true
		},
		{
			"header": "Entity",
			"name": "entity",
			"PictTriggerSolveOnChange": true
		},
		{
			"header": "Name",
			"name": "name",
			"editor": "text"
		},
		{
			"header": "Description",
			"name": "description",
			"editor": "text"
		}
	]
}

},{}],223:[function(require,module,exports){
const libPictViewClass = require('pict-view');

/**
 * @typedef {typeof import('tui-grid').default} TuiGridClass
 * @typedef {import('tui-grid').default} TuiGrid
 */

class PictSectionTuiGrid extends libPictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, require('./Pict-Section-TuiGrid-DefaultConfiguration.json'), pOptions);

		super(pFable, tmpOptions, pServiceHash);

		/** @type {{ [key: string]: any }} */
		this.services;
		this.dateFormatter = this.fable.instantiateServiceProviderWithoutRegistration('Dates');

		this.initialRenderComplete = false;

		this.customFormatters = {};
	}

	onBeforeInitialize()
	{
		super.onBeforeInitialize();

		/** @type {TuiGridClass} */
		this._tuiGridPrototype = null;

		/** @type {TuiGrid} */
		this.tuiGrid = null;

		this.customHeaders = require('./Pict-TuiGrid-Headers.js');
		this.customEditors = require('./Pict-TuiGrid-Editors.js');
		this.initializeCustomFormatters();

		this.columnSchema = false;
		this.targetElementAddress = false;
		/** @type {Array<any>} */
		this.gridData = null;

		return super.onBeforeInitialize();
	}

	initializeCustomFormatters()
	{
		this.customFormatters.FormatterTwoDigitNumber = (pCell) =>
			{
				let tmpCellValue = Number.parseFloat(pCell.value);
				let tmpPrecision = pCell?.decimalPrecision ?? 2;
				if (isNaN(tmpCellValue))
				{
					return '';
				}
				else
				{
					return this.fable.Math.roundPrecise(pCell.value, tmpPrecision);
				}
			};
		this.customFormatters.FormatterCurrencyNumber = (pCell) =>
			{
				let tmpPrecision = pCell?.decimalPrecision ?? 2;
				let tmpCellValue = this.fable.DataFormat.formatterDollars(pCell.value, tmpPrecision);
				return tmpCellValue;
			};

		this.customFormatters.FormatterRoundedNumber = (pCell) =>
			{
				let tmpCellValue = Number.parseFloat(pCell.value);
				let tmpPrecision = pCell?.decimalPrecision ?? 2;
				if (isNaN(tmpCellValue))
				{
					return '';
				}
				else
				{
					return this.fable.Math.roundPrecise(pCell.value, tmpPrecision);
				}
			};

		this.customFormatters.FormatterDate = (pCell) =>
			{
				let tmpDate = this.fable.Dates.dayJS.utc(pCell.value);
				if (pCell.dateformat)
				{
					return tmpDate.format(pCell.dateformat);
				}
				else
				{
					return tmpDate.format();
				}
			};
	}

	/**
	 * Construct a tuiGrid instance and connect it to the browser's dom object for the grid.  If the
	 * prototype is not passed in, try to find a window.tui (where the library puts itself) in the window
	 * object.
	 *
	 * @param {TuiGridClass} [pTuiGridPrototype] - The TuiGrid prototype class expected to be loaded in the browser
	 * @returns
	 */
	connectTuiGridPrototype(pTuiGridPrototype)
	{
		if (typeof (pTuiGridPrototype) != 'undefined')
		{
			this._tuiGridPrototype = pTuiGridPrototype;
		}
		else
		{
			this.log.trace(`PICT-TuiGrid No TuiGrid Prototype defined or explicitly set; looking for it in the window object.`);
			if (typeof (window) != 'undefined')
			{
				if ((typeof (window.tui) != 'undefined') && (typeof (window.tui.Grid) != 'undefined'))
				{
					this.log.trace(`PICT-TuiGrid Found TuiGrid Prototype in window.tuiGrid.`);
					this.connectTuiGridPrototype(window.tui.Grid);
				}
				else
				{
					this.log.error(`PICT-TuiGrid No TuiGrid Prototype found in window.tuiGrid.`);
					return false;
				}
			}
			else
			{
				this.log.error(`PICT-TuiGrid No TuiGrid Prototype found in window.tuiGrid -- window object unavailable.`);
				return false;
			}
		}
	}

	/**
	 * @typedef {Object} TUIGridCellChange
	 * @property {any} rowKey - The key of the row that changed.
	 * @property {string} columnName - The name of the column that changed.
	 * @property {any} value - The "current" value of the cell. Slightly different meaning in preChangeHandler vs changeHandler (before / after the change is applied).
	 * @property {any} [nextValue] - The value that the cell will have after the change. Only populated in preChangeHandler (not changeHandler).
	 * @property {any} [prevValue] - The value that the cell had before the change. Only populated in changeHandler (not preChangeHandler).
	 */

	/**
	 * @typedef {Object} TUIGridChangeEvent
	 * @property {TuiGrid} instance - The TuiGrid instance that fired the event.
	 * @property {TUIGridCellChange[]} changes - An array of objects representing the changes to grid cell values.
	 */

	/**
	 * Interface method for handling changesets from the TuiGrid control. Invoked before the change has been applied to the affected cells.
	 *
	 * * The pre-change cell value is stored in value while the new cell value is stored in nextValue.
	 * * Any changes made to nextValue in this method will be reflected in the grid for that cell.
	 *
	 * @param {TUIGridChangeEvent} pChangeData - An event containing an array of objects representing the changes to grid cell values.
	 */
	preChangeHandler(pChangeData)
	{
	}

	/**
	 * Interface method for handling changesets from the TuiGrid control. Invoked after the change has been applied to the affected cells.
	 *
	 * * Performs solver trigger for changes to any columns configured in "ColumnsToSolveOnChange" or with "PictTriggerSolveOnChange": true on a specific row.
	 * * The previous cell value is stored in prevValue while the next cell value is stored in value.
	 *
	 * @param {TUIGridChangeEvent} pChangeData - An event object containing an array of objects representing the changes to grid cell values.
	 */
	changeHandler(pChangeData)
	{
		let tmpSolverNecessary = false;

		for (let i = 0; i < pChangeData.changes.length; i++)
		{
			let tmpEntity = pChangeData.instance.getValue(pChangeData.changes[i].rowKey, 'entity');
			let tmpIDRecord = pChangeData.instance.getValue(pChangeData.changes[i].rowKey, 'idrecord');

			this.log.trace(`Generic Change Handler for TuiGrid Fired, Entity ${tmpEntity} IDRecord ${tmpIDRecord} setting Column [${pChangeData.changes[i].value}] to new Value [${pChangeData.changes[i].value}]`);

			if (this.options.ColumnsToSolveOnChange.hasOwnProperty(pChangeData.changes[i].columnName))
			{
				tmpSolverNecessary = true;
			}
		}

		if (tmpSolverNecessary)
		{
			this.services.PictApplication.solve();
		}
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (!this.initialRenderComplete)
		{
			this.onAfterInitialRender();
			this.initialRenderComplete = true;
		}
		return super.onAfterRender(pRenderable);
	}

	onAfterInitialRender()
	{
		// This is where we wire up and initialize the tuigrid control -- the initial render has put the placeholder content in place.
		// Check for a tuigrid prototype, and find it in the window object it if it doesn't exist
		if (!this._tuiGridPrototype)
		{
			this.connectTuiGridPrototype();
		}
		// This is where we wire up and initialize the tuigrid control
		if (this.tuiGrid)
		{
			// The grid is already initialized.
			this.log.error(`TuiGrid going to ${this.options.TargetElementAddress} is already initialized!`);
			return false;
		}

		if (this.options.GridDataAddress)
		{
			const tmpAddressSpace =
			{
				Fable: this.fable,
				Pict: this.fable,
				AppData: this.AppData,
				Bundle: this.Bundle,
				Options: this.options,
			};
			let tmpAddressedData = this.fable.manifest.getValueByHash(tmpAddressSpace, this.options.GridDataAddress);
			if (typeof (tmpAddressedData) != 'object')
			{
				this.log.error(`Address for GridData [${this.options.GridDataAddress}] did not return an object; it was a ${typeof (tmpAddressedData)}.`);
				this.gridData = [];
			}
			else
			{
				this.gridData = JSON.parse(JSON.stringify(tmpAddressedData));
			}
		}
		else
		{
			this.gridData = [];
		}

		let tmpTargetElementSet = this.services.ContentAssignment.getElement(this.options.TargetElementAddress);
		if (tmpTargetElementSet.length < 1)
		{
			this.log.error(`Could not find target element [${this.options.TargetElementAddress}] for TuiGrid!  Rendering won't function properly.`);
			this.targetElement = false;
			return false;
		}

		// Just go for the first one.
		this.targetElement = tmpTargetElementSet[0];

		// Check to see if there are any custom formatters.
		this.columnSchema = this.options.TuiColumnSchema;
		// Setup the solver and custom schema handlers.
		for (let i = 0; i < this.columnSchema.length; i++)
		{
			let tmpColumn = this.columnSchema[i];
			// If this bit is set on a column, the Form solver will trigger each time a change happens to that column.
			if (tmpColumn.PictTriggerSolveOnChange)
			{
				this.options.ColumnsToSolveOnChange[tmpColumn.name] = tmpColumn;
			}
			// Look to see if there is an internal formatter that matches the type
			if ((tmpColumn.hasOwnProperty('formatter')) && (this.customFormatters.hasOwnProperty(tmpColumn.formatter)))
			{
				// Assign our special formatter to the column.
				tmpColumn.formatter = this.customFormatters[tmpColumn.formatter];
			}
			// Look to see if there is an editor stanza
			if (tmpColumn.hasOwnProperty('editor'))
			{
				// Look to see if there is an internal editor that matches the type
				if ((tmpColumn.editor.hasOwnProperty('type'))
					&& (typeof (tmpColumn.editor.type) == 'string')
					&& (this.customEditors.hasOwnProperty(tmpColumn.editor.type)))
				{
					// Assign our special editor to the column.
					tmpColumn.editor.type = this.customEditors[tmpColumn.editor.type];
				}

				// Look to see if there is an internal editor that matches the type
				if ((tmpColumn.editor.hasOwnProperty('options'))
					&& (typeof (tmpColumn.editor.options) == 'object')
					&& (tmpColumn.editor.options.hasOwnProperty('listItems'))
					&& (typeof (tmpColumn.editor.options.listItems) == 'string'))
				{
					// Look for this address!  For the Record object, we will pass in the options.
					const tmpAddressSpace =
					{
						Fable: this.fable,
						Pict: this.fable,
						AppData: this.AppData,
						Bundle: this.Bundle,
						Options: this.options,
					};
					let tmpListItems = this.fable.manifest.getValueByHash(tmpAddressSpace, tmpColumn.editor.options.listItems);
					if (typeof (tmpListItems) == 'object')
					{
						tmpColumn.editor.options.listItems = tmpListItems;
					}
					else
					{
						this.log.warn(`Pict TuiGrid for column [${tmpColumn.name}] had [${tmpColumn.editor.options.listItems}] as a listItems address, but it didn't return an object.  It was a [${typeof (tmpListItems)}].  Setting to empty list.`);
						tmpColumn.editor.options.listItems = [];
					}
				}
			}
		}

		this.gridSettings = {
				data: this.gridData,
				el: this.targetElement,
				columns: this.columnSchema,

				// This is no bueno, yo
				usageStatistics: false,

				scrollY: this.options.GridScrollY,

				columnOptions:
				{
					resizable: this.options.GridColumnWidthResizable
				}
			};

		this.customConfigureGridSettings();

		let libTuiGrid = this._tuiGridPrototype;
		this.tuiGrid = new libTuiGrid(this.gridSettings);
		this.tuiGrid.on('beforeChange', (pChangeData) =>
		{
			//TODO: the exported event type from tui-grid is incomplete so mask it here
			/** @type {any} */
			const tmpChangeData = pChangeData;
			this.preChangeHandler(tmpChangeData);
		});
		this.tuiGrid.on('afterChange', (pChangeData) =>
		{
			//TODO: the exported event type from tui-grid is incomplete so mask it here
			/** @type {any} */
			const tmpChangeData = pChangeData;
			this.changeHandler(tmpChangeData);
		});
	}

	/**
	 * This is expected to be overloaded with anything that needs to be added to the grid configuration
	 * before the Toast UI Grid component is initialized in the browser.
	 */
	customConfigureGridSettings ()
	{
		// This can be overloaded to tweak up the this.gridSettings
	}

	/**
	 * Lookup a specific record in the toast ui grid data set by value and pull the value from the map into the browser.
	 *
	 * This function exists because if we mutate data in the map of plain javascript records tuigrid
	 * manages, it doesn't automatically refresh the UI.  From reading the TUIGrid documentation, this
	 * is because they don't want to refresh until all the data has changed.
	 *
	 * The best practice has been to have a hidden column behind the tuigrid that maps the correct entity
	 * value set to the record in the map (e.g. IDRecord in one column and Entity in another).
	 *
	 * @param {string} pCellColumnToBeSet - the Column hash to set
	 * @param {string} pCellValueToSet - Value to be set
	 * @param {string} pLookupValue - the Value to look up in tuigrid
	 * @param {string} pLookupColumn - the key of the column in the tuigrid record (which are plain javascript objects defined by the tuigrid config)
	 * @return {void}
	 */
	SetGridValue(pCellColumnToBeSet, pCellValueToSet, pLookupValue, pLookupColumn)
	{
		if (typeof (pLookupValue) == 'undefined')
		{
			console.log(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by [${pLookupColumn}]::[${pLookupValue}].  No valid lookup value!`);
			return;
		}

		if (!this.tuiGrid)
		{
			this.log.warn(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by [${pLookupColumn}]::[${pLookupValue}].  No valid grid!`);
			return;
		}

		const tmpData = this.tuiGrid.getData();

		for (let i = 0; i < tmpData.length; i++)
		{
			const tmpRecord = tmpData[i];

			if (tmpRecord[pLookupColumn] == pLookupValue)
			{
				this.tuiGrid.setValue(i, pCellColumnToBeSet, pCellValueToSet);
			}
		}
	}

	/**
	 * Lookup a specific record in the toast ui grid data set by row key and pull in a column.
	 *
	 * This function exists because if we mutate data in the map of plain javascript records tuigrid
	 * manages, it doesn't automatically refresh the UI.  From reading the TUIGrid documentation, this
	 * is because they don't want to refresh until all the data has changed.
	 *
	 *
	 * @param {string} pCellColumnToBeSet - the Column hash to set
	 * @param {string} pCellValueToSet - Value to be set
	 * @param {string} pRowKey - the key of the row to be set
	 * @return {boolean}
	 */
	SetGridValueByRowKey(pCellColumnToBeSet, pCellValueToSet, pRowKey)
	{
		if (typeof (pRowKey) == 'undefined')
		{
			this.log.error(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by row key [${pRowKey}].  No valid row key!`);
			return false;
		}

		if (!this.tuiGrid)
		{
			this.log.warn(`Could not set grid value [${pCellColumnToBeSet}] = [${pCellValueToSet}] looked up by row key [${pRowKey}].  No valid grid!`);
			return false;
		}

		this.tuiGrid.setValue(pRowKey, pCellColumnToBeSet, pCellValueToSet);
		return true;
	}
}

module.exports = PictSectionTuiGrid;

/** @type {Record<string, any>} */
module.exports.default_configuration = require('./Pict-Section-TuiGrid-DefaultConfiguration.json');

},{"./Pict-Section-TuiGrid-DefaultConfiguration.json":222,"./Pict-TuiGrid-Editors.js":226,"./Pict-TuiGrid-Headers.js":227,"pict-view":239}],224:[function(require,module,exports){
// Custom number editor class with an option for precision
class tuiCustomEditorNumber
{
	constructor(pProperties)
	{
		const tmpElement = document.createElement('input');

		const decimalPrecision = (pProperties.columnInfo.editor.options.decimalPrecision) ? pProperties.columnInfo.editor.options.decimalPrecision : 3;

		tmpElement.type = 'number';
		tmpElement.value = String(pProperties.value);
		tmpElement.oninput = (pElement) =>
		{
			if (pElement.target instanceof HTMLInputElement)
			{
				const tmpCastNumber = parseFloat(pElement.target.value).toFixed(decimalPrecision).toString()
				if (tmpCastNumber.length < parseFloat(pElement.target.value).toString().length)
				{
					pElement.target.value = tmpCastNumber;
				}
			}
		};

		this.Element = tmpElement;
	}

	getElement()
	{
		return this.Element;
	}

	getValue()
	{
		return this.Element.value;
	}

	mounted()
	{
		this.Element.select();
	}
}

module.exports = tuiCustomEditorNumber;

},{}],225:[function(require,module,exports){
// Custom number editor class with an option for precision
class tuiCustomEditorText
{
	constructor(pProperties)
	{
		const tmpElement = document.createElement('input');

		tmpElement.type = 'text';
		tmpElement.value = String(pProperties.value);
		tmpElement.placeholder =  pProperties.columnInfo.editor.options.placeholder || '';
		tmpElement.pattern = pProperties.columnInfo.editor.options.pattern || '';
		tmpElement.minLength = pProperties.columnInfo.editor.options.minLength || '';
		tmpElement.maxLength = pProperties.columnInfo.editor.options.maxLength || '';
		tmpElement.required = pProperties.columnInfo.editor.options.required || '';

		this.Element = tmpElement;
	}

	getElement()
	{
		return this.Element;
	}

	getValue()
	{
		return this.Element.value;
	}

	mounted()
	{
		this.Element.select();
	}
}

module.exports = tuiCustomEditorText;

},{}],226:[function(require,module,exports){
module.exports =
{
	EditorNumber: require('./Pict-TuiGrid-Editor-Number.js'),
	EditorText: require('./Pict-TuiGrid-Editor-Text.js'),
};

},{"./Pict-TuiGrid-Editor-Number.js":224,"./Pict-TuiGrid-Editor-Text.js":225}],227:[function(require,module,exports){
// Custom column header where the header is hidden
class tuiCustomColumnHeaderNone
{
	constructor()
	{
		let tmpElement = document.createElement('input');
		tmpElement.type = 'hidden';
		tmpElement.value = '';
		this.Element = tmpElement;
	}

	getElement()
	{
		return this.Element;
	}

	render()
	{
		// Noop!
	}
}

module.exports =
{
	CustomColumnHeaderNone: tuiCustomColumnHeaderNone,
};

},{}],228:[function(require,module,exports){
module.exports = /*css*/`
/* ────────────────────────────────────────────────────────────
 * pict-section-usermanagement
 * Shared visual language across Login / CurrentUser / UserList /
 * UserEdit / PasswordChange. Lives at priority 500 (default) so
 * host apps can override individual selectors at higher priority.
 * ──────────────────────────────────────────────────────────── */

.pict-um-card {
	max-width: 420px; margin: 32px auto; padding: 24px 28px;
	background: var(--pict-um-bg, #ffffff);
	color: var(--pict-um-fg, #1f2933);
	border: 1px solid var(--pict-um-border, #e2e6ec);
	border-radius: 10px;
	box-shadow: 0 4px 12px rgba(0,0,0,0.06);
	font-family: var(--pict-um-font, system-ui, -apple-system, sans-serif);
}
.pict-um-card-wide { max-width: 720px; }

.pict-um-h1 { margin: 0 0 16px; font-size: 22px; font-weight: 600; }
.pict-um-h2 { margin: 0 0 10px; font-size: 16px; font-weight: 600; color: var(--pict-um-muted, #4a5568); }
.pict-um-sub { color: var(--pict-um-muted, #4a5568); font-size: 13px; margin-bottom: 18px; }

.pict-um-field { display: block; margin-bottom: 14px; }
.pict-um-label { display: block; font-size: 12px; font-weight: 500; margin-bottom: 4px;
	color: var(--pict-um-muted, #4a5568); text-transform: uppercase; letter-spacing: 0.4px; }
.pict-um-input {
	width: 100%; box-sizing: border-box;
	padding: 8px 10px; border-radius: 6px; font-size: 13px;
	border: 1px solid var(--pict-um-border, #cfd5dd);
	background: var(--pict-um-input-bg, #fbfbfc);
	color: var(--pict-um-fg, #1f2933);
}
.pict-um-input:focus {
	outline: none; border-color: var(--pict-um-accent, #2563eb);
	box-shadow: 0 0 0 3px rgba(37,99,235,0.15);
}

.pict-um-actions { display: flex; gap: 8px; justify-content: flex-end;
	margin-top: 18px; flex-wrap: wrap; }
.pict-um-btn {
	padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 500;
	border: 1px solid var(--pict-um-border, #cfd5dd);
	background: var(--pict-um-input-bg, #fbfbfc);
	color: var(--pict-um-fg, #1f2933);
	cursor: pointer; user-select: none;
}
.pict-um-btn:hover { border-color: var(--pict-um-accent, #2563eb); color: var(--pict-um-accent, #2563eb); }
.pict-um-btn-primary {
	background: var(--pict-um-accent, #2563eb); color: #fff; border-color: var(--pict-um-accent, #2563eb);
}
.pict-um-btn-primary:hover { background: #1e54cc; color: #fff; }
.pict-um-btn-danger {
	background: #fef2f2; color: #b91c1c; border-color: #fca5a5;
}
.pict-um-btn-danger:hover { background: #fee2e2; }
.pict-um-btn-sm { padding: 4px 10px; font-size: 11px; }

.pict-um-message {
	padding: 8px 12px; border-radius: 6px; margin-top: 10px;
	font-size: 12px; line-height: 1.4;
}
.pict-um-message-error { background: #fef2f2; color: #b91c1c; border: 1px solid #fca5a5; }
.pict-um-message-success { background: #f0fdf4; color: #166534; border: 1px solid #86efac; }

/* CurrentUser badge — compact display + logout */
.pict-um-currentuser {
	display: inline-flex; align-items: center; gap: 10px;
	padding: 4px 10px; border-radius: 999px;
	background: var(--pict-um-input-bg, #fbfbfc);
	border: 1px solid var(--pict-um-border, #e2e6ec);
	font-size: 12px;
}
.pict-um-currentuser-avatar {
	display: inline-flex; align-items: center; justify-content: center;
	width: 22px; height: 22px; border-radius: 50%;
	background: var(--pict-um-accent, #2563eb); color: #fff;
	font-size: 10px; font-weight: 700;
}
.pict-um-currentuser-name { font-weight: 500; }
.pict-um-currentuser-roles { color: var(--pict-um-muted, #4a5568); font-size: 11px; }
.pict-um-currentuser-logout {
	padding: 2px 10px; font-size: 11px; cursor: pointer;
	border: 0; background: transparent; color: var(--pict-um-muted, #4a5568);
}
.pict-um-currentuser-logout:hover { color: var(--pict-um-accent, #2563eb); }

/* UserList table */
.pict-um-toolbar {
	display: flex; align-items: center; gap: 10px;
	margin-bottom: 12px;
}
.pict-um-search { flex: 1; }
.pict-um-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.pict-um-table thead th {
	font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px;
	color: var(--pict-um-muted, #4a5568); font-weight: 600;
	padding: 8px 10px; border-bottom: 1px solid var(--pict-um-border, #e2e6ec); text-align: left;
}
.pict-um-table tbody td {
	padding: 8px 10px; border-bottom: 1px solid var(--pict-um-border-soft, #f0f3f7);
	vertical-align: middle;
}
.pict-um-table tbody tr:hover { background: var(--pict-um-input-bg, #fbfbfc); }
.pict-um-pill {
	display: inline-block; padding: 2px 8px; border-radius: 999px;
	font-size: 11px; background: var(--pict-um-pill-bg, #eef2f7); margin-right: 4px;
}
.pict-um-pill-admin { background: #fef3c7; color: #92400e; }

.pict-um-empty { color: var(--pict-um-muted, #4a5568); font-style: italic; padding: 24px 8px; }
`;

},{}],229:[function(require,module,exports){
/**
 * Pict-Provider-UserManagement
 *
 * Browser-side REST client for the orator-authentication session
 * surface plus the auth-beacon-backed /Users CRUD endpoints. The
 * provider does the network I/O and writes results into pict.AppData
 * keys that views subscribe to for re-render. Views NEVER fetch on
 * their own — every API call goes through here.
 *
 * AppData layout (host applications can read these too):
 *   pict.AppData.UserManagement = {
 *       CurrentUser: { LoggedIn, UserID, Username, Roles, ... } | { LoggedIn:false },
 *       AllUsers: [ {UserID, Username, Roles, Email, ...}, ... ],
 *       SelectedUser: {...} | null,           // for the edit view
 *       LastError: { Action, Message, Status } | null,
 *       Loading: { CurrentUser:false, AllUsers:false, ... }
 *   };
 *
 * Config (constructor options or fable settings):
 *   BaseURL: '/1.0/'                        — REST root for the API
 *   Fetcher: function(pPath, pOpts) → Promise<Response>
 *                                          — optional custom transport
 *   AdminRole: 'admin'                      — role name considered admin
 *
 * Why a custom Fetcher slot?
 * ==========================
 * The Pict module runs in browsers AND in test harnesses where
 * `fetch` may not be present (or where you want to inject a mock).
 * Default uses `globalThis.fetch`. Any callable that returns a
 * Promise<{ok, status, json()}>-shaped response works.
 */

const libPictProvider = require('pict-provider');

const _DefaultConfiguration =
{
	ProviderIdentifier: 'Pict-UserManagement-Provider',
	AutoInitialize: true,
	AutoSolveWithApp: false,

	BaseURL: '/1.0/',
	AdminRole: 'admin'
};

class PictUserManagementProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);

		this._BaseURL = tmpOptions.BaseURL;
		this._Fetcher = (typeof tmpOptions.Fetcher === 'function')
			? tmpOptions.Fetcher
			: ((typeof globalThis !== 'undefined' && typeof globalThis.fetch === 'function')
				? globalThis.fetch.bind(globalThis)
				: null);
		this._AdminRole = tmpOptions.AdminRole;

		// Seed the AppData container synchronously so views that mount
		// before the first /CheckSession can render an empty-but-valid
		// state without null-checking everything.
		if (this.pict && this.pict.AppData)
		{
			if (!this.pict.AppData.UserManagement)
			{
				this.pict.AppData.UserManagement = {};
			}
			let tmpAD = this.pict.AppData.UserManagement;
			if (!tmpAD.CurrentUser) tmpAD.CurrentUser = { LoggedIn: false };
			if (!tmpAD.AllUsers) tmpAD.AllUsers = [];
			if (!tmpAD.SelectedUser) tmpAD.SelectedUser = null;
			if (!tmpAD.LastError) tmpAD.LastError = null;
			if (!tmpAD.Loading)
			{
				tmpAD.Loading =
				{
					CurrentUser: false,
					AllUsers: false,
					Mutating: false
				};
			}
		}

		// CSS — providers don't get auto-registration, do it explicitly.
		if (this.pict && this.pict.CSSMap && typeof this.pict.CSSMap.addCSS === 'function')
		{
			let libCSS = require('./Pict-Provider-UserManagement-CSS.js');
			this.pict.CSSMap.addCSS('Pict-UserManagement-CSS', libCSS, 500);
		}
	}

	// =========================================================
	// Public API — async via callback (fable convention) AND
	// returns a Promise so callers can await as well. Every call
	// updates AppData and notifies the store; callbacks are
	// optional for sites that prefer to react to AppData changes.
	// =========================================================

	/**
	 * Resolve the current session by calling /CheckSession. Always
	 * updates AppData.UserManagement.CurrentUser, even on failure
	 * (sets LoggedIn:false). Useful at app boot to decide whether
	 * to show the login view or the main UI.
	 */
	checkSession(fCallback)
	{
		this._setLoading('CurrentUser', true);
		return this._call('GET', 'CheckSession', null)
			.then((pResp) =>
			{
				let tmpUser = (pResp && pResp.body) || {};
				this._setCurrentUser(tmpUser);
				this._setLoading('CurrentUser', false);
				if (fCallback) fCallback(null, tmpUser);
				return tmpUser;
			})
			.catch((pErr) =>
			{
				this._setCurrentUser({ LoggedIn: false });
				this._setLoading('CurrentUser', false);
				this._setError('checkSession', pErr);
				if (fCallback) fCallback(pErr);
				throw pErr;
			});
	}

	login(pUsername, pPassword, fCallback)
	{
		this._setLoading('CurrentUser', true);
		return this._call('POST', 'Authenticate',
			{ UserName: pUsername, Password: pPassword })
			.then((pResp) =>
			{
				let tmpBody = (pResp && pResp.body) || {};
				if (!tmpBody.LoggedIn)
				{
					this._setLoading('CurrentUser', false);
					let tmpErr = new Error(tmpBody.Error || 'Login failed');
					tmpErr._reason = tmpBody.Error;
					this._setError('login', tmpErr);
					if (fCallback) fCallback(tmpErr);
					return tmpBody;
				}
				this._setCurrentUser(tmpBody);
				this._setLoading('CurrentUser', false);
				this._setError('login', null);
				if (fCallback) fCallback(null, tmpBody);
				return tmpBody;
			})
			.catch((pErr) =>
			{
				this._setLoading('CurrentUser', false);
				this._setError('login', pErr);
				if (fCallback) fCallback(pErr);
				throw pErr;
			});
	}

	logout(fCallback)
	{
		return this._call('POST', 'Deauthenticate', null)
			.then((pResp) =>
			{
				this._setCurrentUser({ LoggedIn: false });
				if (fCallback) fCallback(null, pResp && pResp.body);
				return pResp && pResp.body;
			})
			.catch((pErr) =>
			{
				// Even if the call fails, clear local state — the user
				// asked to log out, they shouldn't see a stale session.
				this._setCurrentUser({ LoggedIn: false });
				this._setError('logout', pErr);
				if (fCallback) fCallback(pErr);
				throw pErr;
			});
	}

	loadUsers(pSearch, fCallback)
	{
		// Allow loadUsers(fCallback) for the common no-search case.
		if (typeof pSearch === 'function')
		{
			fCallback = pSearch;
			pSearch = null;
		}
		this._setLoading('AllUsers', true);
		let tmpQS = pSearch ? '?search=' + encodeURIComponent(pSearch) : '';
		return this._call('GET', 'Users' + tmpQS, null)
			.then((pResp) =>
			{
				let tmpUsers = (pResp && pResp.body && pResp.body.Users) || [];
				this._setUsers(tmpUsers);
				this._setLoading('AllUsers', false);
				this._setError('loadUsers', null);
				if (fCallback) fCallback(null, tmpUsers);
				return tmpUsers;
			})
			.catch((pErr) =>
			{
				this._setLoading('AllUsers', false);
				this._setError('loadUsers', pErr);
				if (fCallback) fCallback(pErr);
				throw pErr;
			});
	}

	createUser(pSpec, fCallback)
	{
		return this._mutate('POST', 'Users', pSpec, 'createUser', fCallback);
	}

	getUser(pUserID, fCallback)
	{
		return this._call('GET', 'User/' + encodeURIComponent(pUserID), null)
			.then((pResp) =>
			{
				let tmpUser = (pResp && pResp.body && pResp.body.User) || null;
				if (tmpUser)
				{
					this._setSelectedUser(tmpUser);
				}
				if (fCallback) fCallback(null, tmpUser);
				return tmpUser;
			})
			.catch((pErr) =>
			{
				this._setError('getUser', pErr);
				if (fCallback) fCallback(pErr);
				throw pErr;
			});
	}

	updateUser(pUserID, pUpdates, fCallback)
	{
		return this._mutate('PUT', 'User/' + encodeURIComponent(pUserID),
			pUpdates, 'updateUser', fCallback);
	}

	deleteUser(pUserID, fCallback)
	{
		return this._mutate('DELETE', 'User/' + encodeURIComponent(pUserID),
			null, 'deleteUser', fCallback);
	}

	setUserPassword(pUserID, pNewPassword, fCallback)
	{
		return this._mutate('POST',
			'User/' + encodeURIComponent(pUserID) + '/SetPassword',
			{ NewPassword: pNewPassword }, 'setUserPassword', fCallback);
	}

	changePassword(pCurrentPassword, pNewPassword, fCallback)
	{
		return this._mutate('POST', 'Me/ChangePassword',
			{ CurrentPassword: pCurrentPassword, NewPassword: pNewPassword },
			'changePassword', fCallback);
	}

	// =========================================================
	// Convenience read accessors (mirror common UI guards)
	// =========================================================

	currentUser()
	{
		let tmpAD = this.pict && this.pict.AppData
			&& this.pict.AppData.UserManagement;
		return (tmpAD && tmpAD.CurrentUser) || { LoggedIn: false };
	}

	isLoggedIn()
	{
		return !!this.currentUser().LoggedIn;
	}

	isAdmin()
	{
		let tmpUser = this.currentUser();
		if (!tmpUser.LoggedIn) return false;
		let tmpRecord = tmpUser.UserRecord || tmpUser;
		let tmpRoles = tmpRecord.Roles;
		return Array.isArray(tmpRoles) && tmpRoles.indexOf(this._AdminRole) >= 0;
	}

	// =========================================================
	// Internals
	// =========================================================

	_call(pMethod, pPath, pBody)
	{
		if (!this._Fetcher)
		{
			return Promise.reject(new Error(
				'Pict-UserManagement-Provider: no Fetcher available; pass options.Fetcher or run in a fetch-capable environment'));
		}
		let tmpURL = this._BaseURL + pPath;
		let tmpOpts =
		{
			method: pMethod,
			credentials: 'same-origin',  // ensure session cookie rides along
			headers: { 'Accept': 'application/json' }
		};
		if (pBody !== undefined && pBody !== null)
		{
			tmpOpts.headers['Content-Type'] = 'application/json';
			tmpOpts.body = JSON.stringify(pBody);
		}
		return this._Fetcher(tmpURL, tmpOpts)
			.then((pResp) =>
			{
				// Accept both Response objects (fetch native) and a
				// duck-typed mock for tests (just needs ok/status/json()).
				let tmpStatus = (pResp && pResp.status) || 0;
				let tmpOk = (pResp && pResp.ok) !== false && tmpStatus < 400;
				return Promise.resolve(pResp.json ? pResp.json() : (pResp.body || {}))
					.then((pBody) =>
					{
						if (!tmpOk)
						{
							let tmpErr = new Error((pBody && (pBody.Reason || pBody.Error))
								|| ('HTTP ' + tmpStatus));
							tmpErr.status = tmpStatus;
							tmpErr.body = pBody;
							throw tmpErr;
						}
						return { status: tmpStatus, body: pBody };
					});
			});
	}

	_mutate(pMethod, pPath, pBody, pAction, fCallback)
	{
		this._setLoading('Mutating', true);
		return this._call(pMethod, pPath, pBody)
			.then((pResp) =>
			{
				this._setLoading('Mutating', false);
				this._setError(pAction, null);
				if (fCallback) fCallback(null, pResp && pResp.body);
				return pResp && pResp.body;
			})
			.catch((pErr) =>
			{
				this._setLoading('Mutating', false);
				this._setError(pAction, pErr);
				if (fCallback) fCallback(pErr);
				throw pErr;
			});
	}

	_setCurrentUser(pUser)
	{
		let tmpAD = this._appData();
		if (!tmpAD) return;
		tmpAD.CurrentUser = pUser || { LoggedIn: false };
		this._notify('CurrentUser', tmpAD.CurrentUser);
	}

	_setUsers(pUsers)
	{
		let tmpAD = this._appData();
		if (!tmpAD) return;
		tmpAD.AllUsers = Array.isArray(pUsers) ? pUsers : [];
		this._notify('AllUsers', tmpAD.AllUsers);
	}

	_setSelectedUser(pUser)
	{
		let tmpAD = this._appData();
		if (!tmpAD) return;
		tmpAD.SelectedUser = pUser || null;
		this._notify('SelectedUser', tmpAD.SelectedUser);
	}

	_setError(pAction, pErr)
	{
		let tmpAD = this._appData();
		if (!tmpAD) return;
		if (!pErr)
		{
			tmpAD.LastError = null;
		}
		else
		{
			tmpAD.LastError =
			{
				Action: pAction,
				Message: (pErr && pErr.message) || String(pErr),
				Status: (pErr && pErr.status) || 0,
				Reason: (pErr && pErr._reason) || (pErr && pErr.body && pErr.body.Reason) || ''
			};
		}
		this._notify('LastError', tmpAD.LastError);
	}

	_setLoading(pKey, pIsLoading)
	{
		let tmpAD = this._appData();
		if (!tmpAD) return;
		if (!tmpAD.Loading) tmpAD.Loading = {};
		tmpAD.Loading[pKey] = !!pIsLoading;
		this._notify('Loading', tmpAD.Loading);
	}

	_appData()
	{
		return (this.pict && this.pict.AppData && this.pict.AppData.UserManagement)
			|| null;
	}

	_notify(pKey, pValue)
	{
		// Best-effort store notification so views subscribed to the
		// store auto-rerender. Works with or without pict.store
		// (some hosts don't wire it).
		if (this.pict && this.pict.store && typeof this.pict.store.set === 'function')
		{
			try { this.pict.store.set('UserManagement.' + pKey, pValue); }
			catch (pErr) { /* ignore */ }
		}
	}
}

module.exports = PictUserManagementProvider;
module.exports.default_configuration = _DefaultConfiguration;

},{"./Pict-Provider-UserManagement-CSS.js":228,"pict-provider":19}],230:[function(require,module,exports){
/**
 * pict-section-usermanagement — entry point.
 *
 * Provides login, current-user badge, and admin user-management views
 * backed by orator-authentication's session routes plus the auth-beacon
 * /Users CRUD endpoints.
 *
 * Two ways to consume this module:
 *
 *   1. Manual registration — host imports the named exports and
 *      registers each provider/view itself. Most flexible, recommended
 *      for apps that already have their own boot flow:
 *
 *        const um = require('pict-section-usermanagement');
 *
 *        pict.addProvider('Pict-UserManagement-Provider',
 *            um.Provider.default_configuration, um.Provider);
 *        pict.addView('PictUM-Login',
 *            um.LoginView.default_configuration, um.LoginView);
 *        pict.addView('PictUM-CurrentUser',
 *            um.CurrentUserView.default_configuration, um.CurrentUserView);
 *        pict.addView('PictUM-UserList',
 *            um.UserListView.default_configuration, um.UserListView);
 *        pict.addView('PictUM-UserEdit',
 *            um.UserEditView.default_configuration, um.UserEditView);
 *        pict.addView('PictUM-PasswordChange',
 *            um.PasswordChangeView.default_configuration, um.PasswordChangeView);
 *
 *   2. One-shot install — convenience for hosts that just want
 *      everything wired up with default options:
 *
 *        require('pict-section-usermanagement').install(pict);
 *        require('pict-section-usermanagement').install(pict, {
 *            ProviderOptions: { BaseURL: '/myapi/' },
 *            Views: ['Login', 'CurrentUser']     // subset
 *        });
 *
 * The install helper avoids any magic — it just calls addProvider /
 * addView for each requested piece. Reading the source is the fastest
 * way to understand the wiring.
 */

const libProvider = require('./Pict-Provider-UserManagement.js');
const libLoginView = require('./views/PictView-UserManagement-Login.js');
const libCurrentUserView = require('./views/PictView-UserManagement-CurrentUser.js');
const libUserListView = require('./views/PictView-UserManagement-UserList.js');
const libUserEditView = require('./views/PictView-UserManagement-UserEdit.js');
const libPasswordChangeView = require('./views/PictView-UserManagement-PasswordChange.js');

// Map of view-shortname → { module, viewHash } so the install helper
// can spell out the friendly names without leaking any internal hash
// quirks. Hosts that want a different ViewIdentifier merge their own
// over the default_configuration before passing to addView.
const _Views =
{
	Login: { lib: libLoginView, hash: 'PictUM-Login' },
	CurrentUser: { lib: libCurrentUserView, hash: 'PictUM-CurrentUser' },
	UserList: { lib: libUserListView, hash: 'PictUM-UserList' },
	UserEdit: { lib: libUserEditView, hash: 'PictUM-UserEdit' },
	PasswordChange: { lib: libPasswordChangeView, hash: 'PictUM-PasswordChange' }
};

function install(pPict, pOptions)
{
	if (!pPict || typeof pPict.addProvider !== 'function')
	{
		throw new Error('pict-section-usermanagement.install: first arg must be a Pict instance');
	}
	pOptions = pOptions || {};
	let tmpProviderOpts = Object.assign({},
		libProvider.default_configuration, pOptions.ProviderOptions || {});
	pPict.addProvider('Pict-UserManagement-Provider', tmpProviderOpts, libProvider);

	let tmpViewNames = Array.isArray(pOptions.Views) ? pOptions.Views : Object.keys(_Views);
	for (let i = 0; i < tmpViewNames.length; i++)
	{
		let tmpEntry = _Views[tmpViewNames[i]];
		if (!tmpEntry)
		{
			(pPict.log && pPict.log.warn)
				? pPict.log.warn('pict-section-usermanagement: unknown view name "' + tmpViewNames[i] + '" — skipped')
				: null;
			continue;
		}
		let tmpViewOpts = Object.assign({},
			tmpEntry.lib.default_configuration,
			(pOptions.ViewOptions && pOptions.ViewOptions[tmpViewNames[i]]) || {});
		pPict.addView(tmpEntry.hash, tmpViewOpts, tmpEntry.lib);
	}
}

module.exports = libProvider;
module.exports.Provider = libProvider;
module.exports.LoginView = libLoginView;
module.exports.CurrentUserView = libCurrentUserView;
module.exports.UserListView = libUserListView;
module.exports.UserEditView = libUserEditView;
module.exports.PasswordChangeView = libPasswordChangeView;
module.exports.install = install;

},{"./Pict-Provider-UserManagement.js":229,"./views/PictView-UserManagement-CurrentUser.js":231,"./views/PictView-UserManagement-Login.js":232,"./views/PictView-UserManagement-PasswordChange.js":233,"./views/PictView-UserManagement-UserEdit.js":234,"./views/PictView-UserManagement-UserList.js":235}],231:[function(require,module,exports){
/**
 * CurrentUser view — compact session badge + logout button.
 *
 * Designed to slot into a top bar / header. Reads
 * AppData.UserManagement.CurrentUser. Renders empty when
 * LoggedIn is false (so hosts can render unconditionally
 * without conditional layout shifts).
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'PictUM-CurrentUser',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#PictUM-CurrentUser',
	DefaultRenderable: 'PictUM-CurrentUser-Renderable',

	ProviderHash: 'Pict-UserManagement-Provider',

	Templates:
	[
		{
			Hash: 'PictUM-CurrentUser-Template',
			Template: /*html*/`
<div id="PictUM-CurrentUser-Inner"></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PictUM-CurrentUser-Renderable',
			TemplateHash: 'PictUM-CurrentUser-Template',
			ContentDestinationAddress: '#PictUM-CurrentUser',
			RenderMethod: 'replace'
		}
	],

	CSSPriority: 500
};

class PictUserManagementCurrentUserView extends libPictView
{
	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this._renderInner();
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_renderInner()
	{
		let tmpInner = (typeof document !== 'undefined')
			? document.getElementById('PictUM-CurrentUser-Inner') : null;
		if (!tmpInner) return;

		let tmpProvider = this._provider();
		let tmpCurrent = tmpProvider ? tmpProvider.currentUser() : { LoggedIn: false };
		if (!tmpCurrent || !tmpCurrent.LoggedIn)
		{
			// Render nothing visible — the host's auth gate decides
			// whether to show the login form somewhere else.
			tmpInner.innerHTML = '';
			return;
		}

		let tmpRecord = tmpCurrent.UserRecord || tmpCurrent;
		let tmpName = tmpRecord.FullName || tmpRecord.LoginID || tmpRecord.Username
			|| tmpCurrent.UserID || '?';
		let tmpInitials = String(tmpName).split(/\s+/)
			.map((s) => s.charAt(0).toUpperCase()).join('').slice(0, 2) || '?';
		let tmpRoles = Array.isArray(tmpRecord.Roles) ? tmpRecord.Roles : [];

		// Build via DOM so user-supplied fields can't sneak HTML through.
		tmpInner.innerHTML = '';
		let tmpWrap = document.createElement('span');
		tmpWrap.className = 'pict-um-currentuser';

		let tmpAvatar = document.createElement('span');
		tmpAvatar.className = 'pict-um-currentuser-avatar';
		tmpAvatar.textContent = tmpInitials;
		tmpWrap.appendChild(tmpAvatar);

		let tmpNameSpan = document.createElement('span');
		tmpNameSpan.className = 'pict-um-currentuser-name';
		tmpNameSpan.textContent = tmpName;
		tmpWrap.appendChild(tmpNameSpan);

		if (tmpRoles.length > 0)
		{
			let tmpRolesSpan = document.createElement('span');
			tmpRolesSpan.className = 'pict-um-currentuser-roles';
			tmpRolesSpan.textContent = '· ' + tmpRoles.join(', ');
			tmpWrap.appendChild(tmpRolesSpan);
		}

		let tmpLogoutBtn = document.createElement('button');
		tmpLogoutBtn.type = 'button';
		tmpLogoutBtn.className = 'pict-um-currentuser-logout';
		tmpLogoutBtn.textContent = 'Sign out';
		tmpLogoutBtn.addEventListener('click', () => this._logout());
		tmpWrap.appendChild(tmpLogoutBtn);

		tmpInner.appendChild(tmpWrap);
	}

	_logout()
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return;
		tmpProvider.logout(() =>
		{
			// Re-render to drop the badge. Hosts that want to react
			// further (e.g. re-paint a login form somewhere else,
			// redirect to a public route) pass `OnLogout` in the
			// view options — it fires AFTER the badge re-renders so
			// the host can stack visual changes on top.
			this.render();
			if (typeof this.options.OnLogout === 'function')
			{
				try { this.options.OnLogout(); }
				catch (pErr) { /* swallow — view shouldn't fail because of host hook */ }
			}
		});
	}

	_provider()
	{
		let tmpProvHash = this.options.ProviderHash || 'Pict-UserManagement-Provider';
		return this.pict && this.pict.providers && this.pict.providers[tmpProvHash];
	}
}

module.exports = PictUserManagementCurrentUserView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],232:[function(require,module,exports){
/**
 * Login view — username + password form.
 *
 * Renders into `options.DestinationAddress` (host configures it,
 * default '#PictUM-Login'). On submit, calls
 * `provider.login(u, p)`. On success, AppData.UserManagement.CurrentUser
 * flips to LoggedIn:true; the host's app-level switch (or a parent
 * view subscribed to that key) is responsible for replacing this view
 * with the main UI.
 *
 * The view does NOT itself navigate — staying decoupled from any
 * particular routing scheme. Hosts that want auto-redirect-on-login
 * subscribe to UserManagement.CurrentUser in the store.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'PictUM-Login',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#PictUM-Login',
	DefaultRenderable: 'PictUM-Login-Renderable',

	ProviderHash: 'Pict-UserManagement-Provider',

	Templates:
	[
		{
			Hash: 'PictUM-Login-Template',
			Template: /*html*/`
<div class="pict-um-card">
	<h1 class="pict-um-h1">Sign in</h1>
	<div class="pict-um-sub">Enter your credentials to continue.</div>
	<form id="PictUM-Login-Form" autocomplete="on">
		<div class="pict-um-field">
			<label class="pict-um-label" for="PictUM-Login-Username">Username</label>
			<input id="PictUM-Login-Username" class="pict-um-input"
				type="text" name="username" autocomplete="username"
				required autofocus />
		</div>
		<div class="pict-um-field">
			<label class="pict-um-label" for="PictUM-Login-Password">Password</label>
			<input id="PictUM-Login-Password" class="pict-um-input"
				type="password" name="password" autocomplete="current-password"
				required />
		</div>
		<div id="PictUM-Login-Message"></div>
		<div class="pict-um-actions">
			<button type="submit" class="pict-um-btn pict-um-btn-primary"
				id="PictUM-Login-Submit">Sign in</button>
		</div>
	</form>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PictUM-Login-Renderable',
			TemplateHash: 'PictUM-Login-Template',
			ContentDestinationAddress: '#PictUM-Login',
			RenderMethod: 'replace'
		}
	],

	CSSPriority: 500
};

class PictUserManagementLoginView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._submitting = false;
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		// Wire the form on every render — re-rendering replaces the
		// DOM, so the previous listener is gone with the old form.
		let tmpForm = this._byId('PictUM-Login-Form');
		if (tmpForm && !tmpForm._pictUMWired)
		{
			tmpForm._pictUMWired = true;
			tmpForm.addEventListener('submit', (pEvent) =>
			{
				pEvent.preventDefault();
				this._submit();
			});
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_submit()
	{
		if (this._submitting) return;
		let tmpProvider = this._provider();
		if (!tmpProvider)
		{
			this._showMessage('No user-management provider available.', 'error');
			return;
		}
		let tmpUserEl = this._byId('PictUM-Login-Username');
		let tmpPassEl = this._byId('PictUM-Login-Password');
		let tmpUser = tmpUserEl ? tmpUserEl.value.trim() : '';
		let tmpPass = tmpPassEl ? tmpPassEl.value : '';
		if (!tmpUser || !tmpPass)
		{
			this._showMessage('Username and password are required.', 'error');
			return;
		}
		this._setSubmitting(true);
		this._showMessage('', null);

		tmpProvider.login(tmpUser, tmpPass, (pErr, pResult) =>
		{
			this._setSubmitting(false);
			if (pErr)
			{
				this._showMessage(pErr.message || 'Login failed', 'error');
				return;
			}
			if (pResult && pResult.LoggedIn)
			{
				this._showMessage('Welcome, ' + (pResult.UserID || tmpUser) + '!', 'success');
				// Wipe the password field — basic hygiene.
				if (tmpPassEl) tmpPassEl.value = '';
				// OnLogin hook lets the host re-paint the surrounding
				// UI without subscribing to AppData. Same pattern as
				// CurrentUser's OnLogout.
				if (typeof this.options.OnLogin === 'function')
				{
					try { this.options.OnLogin(pResult); } catch (pErr2) { /* swallow */ }
				}
			}
			else
			{
				this._showMessage((pResult && pResult.Error) || 'Login failed', 'error');
			}
		});
	}

	_setSubmitting(pSubmitting)
	{
		this._submitting = !!pSubmitting;
		let tmpBtn = this._byId('PictUM-Login-Submit');
		if (tmpBtn)
		{
			tmpBtn.disabled = !!pSubmitting;
			tmpBtn.textContent = pSubmitting ? 'Signing in…' : 'Sign in';
		}
	}

	_showMessage(pText, pKind)
	{
		let tmpEl = this._byId('PictUM-Login-Message');
		if (!tmpEl) return;
		if (!pText)
		{
			tmpEl.innerHTML = '';
			return;
		}
		let tmpClass = (pKind === 'success')
			? 'pict-um-message pict-um-message-success'
			: 'pict-um-message pict-um-message-error';
		// pText is an arbitrary string from the server / from us; it
		// goes into a textContent path via DOM creation rather than
		// innerHTML interpolation so server-supplied error reasons
		// can't inject HTML.
		let tmpDiv = document.createElement('div');
		tmpDiv.className = tmpClass;
		tmpDiv.textContent = pText;
		tmpEl.innerHTML = '';
		tmpEl.appendChild(tmpDiv);
	}

	_byId(pID)
	{
		if (typeof document === 'undefined') return null;
		return document.getElementById(pID);
	}

	_provider()
	{
		let tmpProvHash = this.options.ProviderHash || 'Pict-UserManagement-Provider';
		return this.pict && this.pict.providers && this.pict.providers[tmpProvHash];
	}
}

module.exports = PictUserManagementLoginView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],233:[function(require,module,exports){
/**
 * PasswordChange view — self-change for the current session.
 *
 * Three fields: current password, new password, confirm new password.
 * Submit calls `provider.changePassword(current, new)`. The route
 * resolves the target user from the session cookie server-side, so
 * the view doesn't need to know anything about UserID.
 *
 * Renders nothing if no session is active — guard at the host level
 * if you want a hard "must be logged in to see this" experience.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'PictUM-PasswordChange',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#PictUM-PasswordChange',
	DefaultRenderable: 'PictUM-PasswordChange-Renderable',

	ProviderHash: 'Pict-UserManagement-Provider',

	Templates:
	[
		{
			Hash: 'PictUM-PasswordChange-Template',
			Template: /*html*/`
<div class="pict-um-card">
	<h1 class="pict-um-h1">Change password</h1>
	<form id="PictUM-PasswordChange-Form" autocomplete="off">
		<div class="pict-um-field">
			<label class="pict-um-label" for="PictUM-PasswordChange-Current">Current password</label>
			<input id="PictUM-PasswordChange-Current" class="pict-um-input"
				type="password" autocomplete="current-password" required />
		</div>
		<div class="pict-um-field">
			<label class="pict-um-label" for="PictUM-PasswordChange-New">New password</label>
			<input id="PictUM-PasswordChange-New" class="pict-um-input"
				type="password" autocomplete="new-password" required />
		</div>
		<div class="pict-um-field">
			<label class="pict-um-label" for="PictUM-PasswordChange-Confirm">Confirm new password</label>
			<input id="PictUM-PasswordChange-Confirm" class="pict-um-input"
				type="password" autocomplete="new-password" required />
		</div>
		<div id="PictUM-PasswordChange-Message"></div>
		<div class="pict-um-actions">
			<button type="submit" class="pict-um-btn pict-um-btn-primary"
				id="PictUM-PasswordChange-Submit">Change password</button>
		</div>
	</form>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PictUM-PasswordChange-Renderable',
			TemplateHash: 'PictUM-PasswordChange-Template',
			ContentDestinationAddress: '#PictUM-PasswordChange',
			RenderMethod: 'replace'
		}
	],

	CSSPriority: 500
};

class PictUserManagementPasswordChangeView extends libPictView
{
	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		let tmpForm = this._byId('PictUM-PasswordChange-Form');
		if (tmpForm && !tmpForm._pictUMWired)
		{
			tmpForm._pictUMWired = true;
			tmpForm.addEventListener('submit', (pE) =>
			{
				pE.preventDefault();
				this._submit();
			});
		}
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_submit()
	{
		let tmpProvider = this._provider();
		if (!tmpProvider)
		{
			this._showMessage('No user-management provider available.', 'error');
			return;
		}
		let tmpCurrent = (this._byId('PictUM-PasswordChange-Current') || {}).value || '';
		let tmpNew = (this._byId('PictUM-PasswordChange-New') || {}).value || '';
		let tmpConfirm = (this._byId('PictUM-PasswordChange-Confirm') || {}).value || '';
		if (!tmpCurrent || !tmpNew || !tmpConfirm)
		{
			this._showMessage('All fields are required.', 'error');
			return;
		}
		if (tmpNew !== tmpConfirm)
		{
			this._showMessage('New password and confirmation do not match.', 'error');
			return;
		}
		if (tmpNew === tmpCurrent)
		{
			this._showMessage('New password must differ from current.', 'error');
			return;
		}
		this._setSubmitting(true);
		tmpProvider.changePassword(tmpCurrent, tmpNew, (pErr, pBody) =>
		{
			this._setSubmitting(false);
			if (pErr)
			{
				this._showMessage((pErr.body && pErr.body.Reason) || pErr.message || 'Change failed', 'error');
				return;
			}
			if (pBody && pBody.Success === false)
			{
				this._showMessage(pBody.Reason || 'Change failed', 'error');
				return;
			}
			this._showMessage('Password updated. Other sessions have been signed out.', 'success');
			// Clear inputs so the user doesn't accidentally resubmit.
			let tmpCurEl = this._byId('PictUM-PasswordChange-Current');
			let tmpNewEl = this._byId('PictUM-PasswordChange-New');
			let tmpConfEl = this._byId('PictUM-PasswordChange-Confirm');
			if (tmpCurEl) tmpCurEl.value = '';
			if (tmpNewEl) tmpNewEl.value = '';
			if (tmpConfEl) tmpConfEl.value = '';
		});
	}

	_setSubmitting(pSubmitting)
	{
		let tmpBtn = this._byId('PictUM-PasswordChange-Submit');
		if (!tmpBtn) return;
		tmpBtn.disabled = !!pSubmitting;
		tmpBtn.textContent = pSubmitting ? 'Saving…' : 'Change password';
	}

	_showMessage(pText, pKind)
	{
		let tmpEl = this._byId('PictUM-PasswordChange-Message');
		if (!tmpEl) return;
		if (!pText) { tmpEl.innerHTML = ''; return; }
		let tmpDiv = document.createElement('div');
		tmpDiv.className = (pKind === 'success')
			? 'pict-um-message pict-um-message-success'
			: 'pict-um-message pict-um-message-error';
		tmpDiv.textContent = pText;
		tmpEl.innerHTML = '';
		tmpEl.appendChild(tmpDiv);
	}

	_byId(pID)
	{
		if (typeof document === 'undefined') return null;
		return document.getElementById(pID);
	}

	_provider()
	{
		let tmpProvHash = this.options.ProviderHash || 'Pict-UserManagement-Provider';
		return this.pict && this.pict.providers && this.pict.providers[tmpProvHash];
	}
}

module.exports = PictUserManagementPasswordChangeView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],234:[function(require,module,exports){
/**
 * UserEdit view — create-or-update form.
 *
 * Three modes, distinguished by what's present at render time:
 *   1. AppData.UserManagement.CreateMode === true  → empty form,
 *      submit creates a new user.
 *   2. AppData.UserManagement.SelectedUser is set → form
 *      prefilled, submit updates that user.
 *   3. Neither → renders empty.
 *
 * Submit calls `provider.createUser(spec)` or `provider.updateUser(id, updates)`.
 * On success, calls `provider.loadUsers()` so the list reflects the
 * change, and clears CreateMode / SelectedUser so the form goes back
 * to the empty state.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'PictUM-UserEdit',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#PictUM-UserEdit',
	DefaultRenderable: 'PictUM-UserEdit-Renderable',

	ProviderHash: 'Pict-UserManagement-Provider',

	Templates:
	[
		{
			Hash: 'PictUM-UserEdit-Template',
			Template: /*html*/`
<div id="PictUM-UserEdit-Inner"></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PictUM-UserEdit-Renderable',
			TemplateHash: 'PictUM-UserEdit-Template',
			ContentDestinationAddress: '#PictUM-UserEdit',
			RenderMethod: 'replace'
		}
	],

	CSSPriority: 500
};

class PictUserManagementUserEditView extends libPictView
{
	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this._renderInner();
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_renderInner()
	{
		let tmpInner = this._byId('PictUM-UserEdit-Inner');
		if (!tmpInner) return;

		let tmpAD = this._appData();
		let tmpCreate = !!(tmpAD && tmpAD.CreateMode);
		let tmpExisting = (tmpAD && tmpAD.SelectedUser) || null;

		if (!tmpCreate && !tmpExisting)
		{
			tmpInner.innerHTML = '';
			return;
		}

		let tmpUser = tmpExisting || {};
		let tmpHTML = ''
			+ '<div class="pict-um-card">'
			+   '<h1 class="pict-um-h1">' + (tmpCreate ? 'Create user' : 'Edit user') + '</h1>'
			+   '<form id="PictUM-UserEdit-Form">'
			+     this._field('Username', 'PictUM-UserEdit-Username', 'text',
				tmpUser.Username || '', tmpCreate ? null : 'Username changes re-key the user.')
			+     this._field('Full name', 'PictUM-UserEdit-FullName', 'text', tmpUser.FullName || '', null)
			+     this._field('Email',     'PictUM-UserEdit-Email',    'email', tmpUser.Email || '', null)
			+     this._field('Roles (comma-separated)', 'PictUM-UserEdit-Roles', 'text',
				(tmpUser.Roles || []).join(', '), null)
			+     (tmpCreate ? this._field('Password', 'PictUM-UserEdit-Password', 'password', '', null) : '')
			+     '<div id="PictUM-UserEdit-Message"></div>'
			+     '<div class="pict-um-actions">'
			+       '<button type="button" id="PictUM-UserEdit-Cancel" class="pict-um-btn">Cancel</button>'
			+       '<button type="submit" id="PictUM-UserEdit-Submit" class="pict-um-btn pict-um-btn-primary">'
			+         (tmpCreate ? 'Create' : 'Save changes')
			+       '</button>'
			+     '</div>'
			+   '</form>'
			+ '</div>';
		tmpInner.innerHTML = tmpHTML;

		let tmpForm = this._byId('PictUM-UserEdit-Form');
		if (tmpForm)
		{
			tmpForm.addEventListener('submit', (pE) =>
			{
				pE.preventDefault();
				if (tmpCreate) this._submitCreate();
				else this._submitUpdate(tmpUser);
			});
		}
		let tmpCancel = this._byId('PictUM-UserEdit-Cancel');
		if (tmpCancel) tmpCancel.addEventListener('click', () => this._cancel());
	}

	_field(pLabel, pID, pType, pValue, pHint)
	{
		// Always escape values in attribute context.
		let tmpVal = String(pValue == null ? '' : pValue)
			.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
		let tmpHint = pHint
			? '<div class="pict-um-sub" style="margin: 4px 0 0; font-size: 11px;">' + pHint + '</div>'
			: '';
		return ''
			+ '<div class="pict-um-field">'
			+   '<label class="pict-um-label" for="' + pID + '">' + pLabel + '</label>'
			+   '<input type="' + pType + '" id="' + pID + '" class="pict-um-input" value="' + tmpVal + '" />'
			+   tmpHint
			+ '</div>';
	}

	_collectInputs()
	{
		let tmpUsername = (this._byId('PictUM-UserEdit-Username') || {}).value || '';
		let tmpFullName = (this._byId('PictUM-UserEdit-FullName') || {}).value || '';
		let tmpEmail = (this._byId('PictUM-UserEdit-Email') || {}).value || '';
		let tmpRolesRaw = (this._byId('PictUM-UserEdit-Roles') || {}).value || '';
		let tmpRoles = tmpRolesRaw.split(',').map((s) => s.trim()).filter(Boolean);
		let tmpPassword = (this._byId('PictUM-UserEdit-Password') || {}).value || '';
		// `return\n{` triggers automatic-semicolon-insertion in JS —
		// the function would silently return undefined. Brace on the
		// same line as `return`.
		return {
			Username: tmpUsername.trim(),
			FullName: tmpFullName.trim(),
			Email: tmpEmail.trim(),
			Roles: tmpRoles,
			Password: tmpPassword
		};
	}

	_submitCreate()
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return;
		let tmpVals = this._collectInputs();
		if (!tmpVals.Username || !tmpVals.Password)
		{
			this._showMessage('Username and password are required.', 'error');
			return;
		}
		let tmpSpec =
		{
			Username: tmpVals.Username,
			Password: tmpVals.Password,
			FullName: tmpVals.FullName,
			Email: tmpVals.Email,
			Roles: tmpVals.Roles
		};
		this._setSubmitting(true);
		tmpProvider.createUser(tmpSpec, (pErr, pBody) =>
		{
			this._setSubmitting(false);
			if (pErr)
			{
				this._showMessage((pErr.body && pErr.body.Reason) || pErr.message || 'Create failed', 'error');
				return;
			}
			if (pBody && pBody.Success === false)
			{
				this._showMessage(pBody.Reason || 'Create failed', 'error');
				return;
			}
			this._afterMutation('Created.');
		});
	}

	_submitUpdate(pUser)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return;
		let tmpVals = this._collectInputs();
		// Build a minimal update payload — only fields the user actually
		// changed go through. Server's allow-list still gates this, but
		// sending fewer fields keeps the audit log readable.
		let tmpUpdates = {};
		if (tmpVals.Username !== (pUser.Username || '')) tmpUpdates.Username = tmpVals.Username;
		if (tmpVals.FullName !== (pUser.FullName || '')) tmpUpdates.FullName = tmpVals.FullName;
		if (tmpVals.Email !== (pUser.Email || '')) tmpUpdates.Email = tmpVals.Email;
		let tmpExistingRoles = (pUser.Roles || []).slice().sort().join(',');
		let tmpNewRoles = tmpVals.Roles.slice().sort().join(',');
		if (tmpExistingRoles !== tmpNewRoles) tmpUpdates.Roles = tmpVals.Roles;

		if (Object.keys(tmpUpdates).length === 0)
		{
			this._showMessage('No changes to save.', 'error');
			return;
		}
		this._setSubmitting(true);
		tmpProvider.updateUser(pUser.UserID, tmpUpdates, (pErr, pBody) =>
		{
			this._setSubmitting(false);
			if (pErr)
			{
				this._showMessage((pErr.body && pErr.body.Reason) || pErr.message || 'Save failed', 'error');
				return;
			}
			if (pBody && pBody.Success === false)
			{
				this._showMessage(pBody.Reason || 'Save failed', 'error');
				return;
			}
			this._afterMutation('Saved.');
		});
	}

	_afterMutation(pMessage)
	{
		// Refresh list, clear edit state, render the now-empty form.
		let tmpProvider = this._provider();
		let tmpAD = this._appData();
		if (tmpAD)
		{
			tmpAD.CreateMode = false;
			tmpAD.SelectedUser = null;
		}
		if (tmpProvider) tmpProvider.loadUsers();
		this._toast(pMessage, 'success');
		this.render();
	}

	_cancel()
	{
		let tmpAD = this._appData();
		if (tmpAD)
		{
			tmpAD.CreateMode = false;
			tmpAD.SelectedUser = null;
		}
		this.render();
	}

	_setSubmitting(pSubmitting)
	{
		let tmpBtn = this._byId('PictUM-UserEdit-Submit');
		if (!tmpBtn) return;
		tmpBtn.disabled = !!pSubmitting;
	}

	_showMessage(pText, pKind)
	{
		let tmpEl = this._byId('PictUM-UserEdit-Message');
		if (!tmpEl) return;
		if (!pText) { tmpEl.innerHTML = ''; return; }
		let tmpDiv = document.createElement('div');
		tmpDiv.className = (pKind === 'success')
			? 'pict-um-message pict-um-message-success'
			: 'pict-um-message pict-um-message-error';
		tmpDiv.textContent = pText;
		tmpEl.innerHTML = '';
		tmpEl.appendChild(tmpDiv);
	}

	_toast(pMsg, pKind)
	{
		let tmpModal = this.pict && this.pict.views && this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMsg, { type: pKind || 'success' });
		}
	}

	_byId(pID)
	{
		if (typeof document === 'undefined') return null;
		return document.getElementById(pID);
	}

	_appData()
	{
		return (this.pict && this.pict.AppData
			&& this.pict.AppData.UserManagement) || null;
	}

	_provider()
	{
		let tmpProvHash = this.options.ProviderHash || 'Pict-UserManagement-Provider';
		return this.pict && this.pict.providers && this.pict.providers[tmpProvHash];
	}
}

module.exports = PictUserManagementUserEditView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],235:[function(require,module,exports){
/**
 * UserList view — admin-only table of users with search + per-row
 * Edit / Delete / Reset-password actions.
 *
 * Reads AppData.UserManagement.AllUsers. The host is expected to
 * call `provider.loadUsers()` whenever the list mounts; the view
 * itself just renders whatever's currently in AppData.
 *
 * Click handlers route through the view (so re-rendering doesn't
 * leave stale closures behind) and emit semantic actions:
 *   - 'edit' → invokes `options.OnEditUser(user)` if provided,
 *               otherwise sets AppData.UserManagement.SelectedUser
 *               for the host's edit panel to subscribe to.
 *   - 'reset' → opens an inline prompt for a new password.
 *   - 'delete' → confirms via pict-section-modal then calls deleteUser.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'PictUM-UserList',
	AutoInitialize: true,
	AutoRender: false,

	DefaultDestinationAddress: '#PictUM-UserList',
	DefaultRenderable: 'PictUM-UserList-Renderable',

	ProviderHash: 'Pict-UserManagement-Provider',

	Templates:
	[
		{
			Hash: 'PictUM-UserList-Template',
			Template: /*html*/`
<div class="pict-um-card pict-um-card-wide">
	<h1 class="pict-um-h1">Users</h1>
	<div class="pict-um-toolbar">
		<input id="PictUM-UserList-Search" type="search" placeholder="Search by username…"
			class="pict-um-input pict-um-search" />
		<button type="button" id="PictUM-UserList-Refresh" class="pict-um-btn">Refresh</button>
		<button type="button" id="PictUM-UserList-New" class="pict-um-btn pict-um-btn-primary">New user</button>
	</div>
	<div id="PictUM-UserList-Body"></div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'PictUM-UserList-Renderable',
			TemplateHash: 'PictUM-UserList-Template',
			ContentDestinationAddress: '#PictUM-UserList',
			RenderMethod: 'replace'
		}
	],

	CSSPriority: 500
};

class PictUserManagementUserListView extends libPictView
{
	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this._wireToolbar();
		this._renderBody();
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_wireToolbar()
	{
		let tmpRefresh = this._byId('PictUM-UserList-Refresh');
		if (tmpRefresh && !tmpRefresh._pictUMWired)
		{
			tmpRefresh._pictUMWired = true;
			tmpRefresh.addEventListener('click', () => this._refresh());
		}
		let tmpNew = this._byId('PictUM-UserList-New');
		if (tmpNew && !tmpNew._pictUMWired)
		{
			tmpNew._pictUMWired = true;
			tmpNew.addEventListener('click', () => this._onNew());
		}
		let tmpSearch = this._byId('PictUM-UserList-Search');
		if (tmpSearch && !tmpSearch._pictUMWired)
		{
			tmpSearch._pictUMWired = true;
			let tmpDebounce = null;
			tmpSearch.addEventListener('input', () =>
			{
				if (tmpDebounce) clearTimeout(tmpDebounce);
				tmpDebounce = setTimeout(() => this._refresh(tmpSearch.value), 250);
			});
		}
	}

	_renderBody()
	{
		let tmpBody = this._byId('PictUM-UserList-Body');
		if (!tmpBody) return;
		let tmpUsers = this._users();
		if (!tmpUsers || tmpUsers.length === 0)
		{
			tmpBody.innerHTML = '';
			let tmpEmpty = document.createElement('div');
			tmpEmpty.className = 'pict-um-empty';
			tmpEmpty.textContent = 'No users to show.';
			tmpBody.appendChild(tmpEmpty);
			return;
		}
		// Build the table via DOM (not innerHTML interpolation) so user
		// fields can't break out of attributes.
		tmpBody.innerHTML = '';
		let tmpTable = document.createElement('table');
		tmpTable.className = 'pict-um-table';
		let tmpThead = document.createElement('thead');
		tmpThead.innerHTML = '<tr><th>Username</th><th>Roles</th><th>Email</th><th></th></tr>';
		tmpTable.appendChild(tmpThead);
		let tmpTbody = document.createElement('tbody');
		for (let i = 0; i < tmpUsers.length; i++)
		{
			tmpTbody.appendChild(this._buildRow(tmpUsers[i]));
		}
		tmpTable.appendChild(tmpTbody);
		tmpBody.appendChild(tmpTable);
	}

	_buildRow(pUser)
	{
		let tmpTr = document.createElement('tr');

		let tmpUsernameTd = document.createElement('td');
		tmpUsernameTd.textContent = pUser.Username || pUser.UserID || '';
		tmpTr.appendChild(tmpUsernameTd);

		let tmpRolesTd = document.createElement('td');
		let tmpRoles = Array.isArray(pUser.Roles) ? pUser.Roles : [];
		for (let i = 0; i < tmpRoles.length; i++)
		{
			let tmpPill = document.createElement('span');
			tmpPill.className = 'pict-um-pill' + (tmpRoles[i] === 'admin' ? ' pict-um-pill-admin' : '');
			tmpPill.textContent = tmpRoles[i];
			tmpRolesTd.appendChild(tmpPill);
		}
		tmpTr.appendChild(tmpRolesTd);

		let tmpEmailTd = document.createElement('td');
		tmpEmailTd.textContent = pUser.Email || '';
		tmpTr.appendChild(tmpEmailTd);

		let tmpActionsTd = document.createElement('td');
		tmpActionsTd.style.whiteSpace = 'nowrap';
		tmpActionsTd.style.textAlign = 'right';
		tmpActionsTd.appendChild(this._actionBtn('Edit', 'pict-um-btn-sm', () => this._onEdit(pUser)));
		tmpActionsTd.appendChild(document.createTextNode(' '));
		tmpActionsTd.appendChild(this._actionBtn('Reset password', 'pict-um-btn-sm', () => this._onResetPassword(pUser)));
		tmpActionsTd.appendChild(document.createTextNode(' '));
		tmpActionsTd.appendChild(this._actionBtn('Delete', 'pict-um-btn-sm pict-um-btn-danger', () => this._onDelete(pUser)));
		tmpTr.appendChild(tmpActionsTd);

		return tmpTr;
	}

	_actionBtn(pLabel, pClass, fHandler)
	{
		let tmpBtn = document.createElement('button');
		tmpBtn.type = 'button';
		tmpBtn.className = 'pict-um-btn ' + (pClass || '');
		tmpBtn.textContent = pLabel;
		tmpBtn.addEventListener('click', fHandler);
		return tmpBtn;
	}

	_refresh(pSearch)
	{
		let tmpProvider = this._provider();
		if (!tmpProvider) return;
		tmpProvider.loadUsers(pSearch || null, () => this._renderBody());
	}

	_onEdit(pUser)
	{
		// Two-stage emit: prefer the host-supplied callback, fall back
		// to AppData so a panel in the same DOM can pick it up.
		if (typeof this.options.OnEditUser === 'function')
		{
			this.options.OnEditUser(pUser);
		}
		else if (this.pict && this.pict.AppData && this.pict.AppData.UserManagement)
		{
			this.pict.AppData.UserManagement.SelectedUser = Object.assign({}, pUser);
			if (this.pict.store && typeof this.pict.store.set === 'function')
			{
				try { this.pict.store.set('UserManagement.SelectedUser', this.pict.AppData.UserManagement.SelectedUser); }
				catch (pErr) { /* ignore */ }
			}
		}
	}

	_onNew()
	{
		if (typeof this.options.OnNewUser === 'function')
		{
			this.options.OnNewUser();
		}
		else if (this.pict && this.pict.AppData && this.pict.AppData.UserManagement)
		{
			// SelectedUser=null + a flag = "open create form".
			this.pict.AppData.UserManagement.SelectedUser = null;
			this.pict.AppData.UserManagement.CreateMode = true;
			if (this.pict.store && typeof this.pict.store.set === 'function')
			{
				try { this.pict.store.set('UserManagement.CreateMode', true); }
				catch (pErr) { /* ignore */ }
			}
		}
	}

	_onResetPassword(pUser)
	{
		let tmpModal = this.pict && this.pict.views && this.pict.views['Pict-Section-Modal'];
		let tmpProvider = this._provider();
		if (!tmpProvider) return;

		// Use modal.show with an embedded input so we get a styled
		// prompt instead of native window.prompt (which is blocked
		// by Pict conventions).
		let tmpContent = '<p>Reset password for <strong>'
			+ this._escape(pUser.Username || pUser.UserID || '?')
			+ '</strong>:</p>'
			+ '<input type="password" id="PictUM-Reset-Input" class="pict-um-input" autofocus />';
		if (tmpModal && typeof tmpModal.show === 'function')
		{
			tmpModal.show(
			{
				title: 'Reset password',
				content: tmpContent,
				closeable: true,
				buttons:
				[
					{ Hash: 'cancel', Label: 'Cancel' },
					{ Hash: 'ok', Label: 'Reset', Style: 'primary' }
				]
			}).then((pChoice) =>
			{
				if (pChoice !== 'ok') return;
				let tmpInput = document.getElementById('PictUM-Reset-Input');
				let tmpNew = (tmpInput && tmpInput.value) || '';
				if (!tmpNew) return;
				tmpProvider.setUserPassword(pUser.UserID, tmpNew, (pErr) =>
				{
					if (pErr)
					{
						this._toast('Reset failed: ' + pErr.message, 'error');
						return;
					}
					this._toast('Password reset.', 'success');
				});
			});
		}
		else
		{
			// Fallback: emit via AppData so a host-defined modal can pick it up
			if (this.pict && this.pict.AppData && this.pict.AppData.UserManagement)
			{
				this.pict.AppData.UserManagement.PendingReset = { UserID: pUser.UserID };
			}
		}
	}

	_onDelete(pUser)
	{
		let tmpModal = this.pict && this.pict.views && this.pict.views['Pict-Section-Modal'];
		let tmpProvider = this._provider();
		if (!tmpProvider) return;
		let tmpName = pUser.Username || pUser.UserID || '?';
		let fGo = () =>
		{
			tmpProvider.deleteUser(pUser.UserID, (pErr) =>
			{
				if (pErr)
				{
					this._toast('Delete failed: ' + pErr.message, 'error');
					return;
				}
				this._refresh();
				this._toast('Deleted ' + tmpName, 'success');
			});
		};
		if (tmpModal && typeof tmpModal.confirm === 'function')
		{
			tmpModal.confirm('Delete user "' + tmpName + '"? This cannot be undone.',
			{
				title: 'Delete user',
				confirmLabel: 'Delete',
				cancelLabel: 'Cancel',
				dangerous: true
			}).then((pOk) => { if (pOk) fGo(); });
		}
		else
		{
			// No modal section installed — best we can do is skip
			// confirmation. Hosts should always include pict-section-modal.
			fGo();
		}
	}

	_toast(pMsg, pKind)
	{
		let tmpModal = this.pict && this.pict.views && this.pict.views['Pict-Section-Modal'];
		if (tmpModal && typeof tmpModal.toast === 'function')
		{
			tmpModal.toast(pMsg, { type: pKind || 'success' });
		}
	}

	_escape(pStr)
	{
		return String(pStr == null ? '' : pStr)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}

	_byId(pID)
	{
		if (typeof document === 'undefined') return null;
		return document.getElementById(pID);
	}

	_users()
	{
		return (this.pict.AppData && this.pict.AppData.UserManagement
			&& this.pict.AppData.UserManagement.AllUsers) || [];
	}

	_provider()
	{
		let tmpProvHash = this.options.ProviderHash || 'Pict-UserManagement-Provider';
		return this.pict && this.pict.providers && this.pict.providers[tmpProvHash];
	}
}

module.exports = PictUserManagementUserListView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],236:[function(require,module,exports){
module.exports={
    "name": "pict-template",
    "version": "1.0.15",
    "description": "Pict Template Base Class",
    "main": "source/Pict-Template.js",
    "scripts": {
        "start": "node source/Pict-Template.js",
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "types": "tsc -p ."
    },
    "types": "types/source/Pict-Template.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "pict": "^1.0.348",
        "quackage": "^1.0.58",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],237:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

/** @typedef {import('pict') & {
 *     [key: string]: any, // represent services for now as a workaround
 * }} Pict */
/**
 * @class PictTemplateExpression
 * @classdesc The PictTemplateExpression class is a service provider for the pict anti-framework that provides template rendering services.
 */
class PictTemplateExpression extends libFableServiceBase
{
	/**
	 * @param {Pict} pFable - The Fable Framework instance
	 * @param {Record<string, any>} [pOptions] - The options for the service
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.fable;

		/** @type {Pict} */
		this.pict = this.fable;

		this.serviceType = 'PictTemplate';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return '';
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		return fCallback(null, this.render(pTemplateHash, pRecord, pContextArray, pScope, pState));
	}

	/**
	 * Provide a match criteria for a template expression.  Anything between these two values is returned as the template hash.
	 *
	 * @param {string} pMatchStart - The string pattern to start a match in the template trie
	 * @param {string} pMatchEnd  - The string pattern to stop a match in the trie acyclic graph
	 *
	 * @return {void}
	 */
	addPattern(pMatchStart, pMatchEnd)
	{
		return this.pict.MetaTemplate.addPatternBoth(pMatchStart, pMatchEnd, this.render, this.renderAsync, this);
	}

	/**
	 * Read a value from a nested object using a dot notation string.
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {Record<string, any>} pRecord - The record to resolve
	 * @param {Array<any>} [pContextArray] - The context array to resolve (optional)
	 * @param {Record<string, any>} [pRootDataObject] - The root data object to resolve (optional)
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState)
	{
		return this.pict.resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState);
	}
}

module.exports = PictTemplateExpression;
module.exports.template_hash = 'Default';

},{"../package.json":236,"fable-serviceproviderbase":2}],238:[function(require,module,exports){
module.exports={
    "name": "pict-view",
    "version": "1.0.68",
    "description": "Pict View Base Class",
    "main": "source/Pict-View.js",
    "scripts": {
        "test": "npx quack test",
        "tests": "npx quack test -g",
        "start": "node source/Pict-View.js",
        "coverage": "npx quack coverage",
        "build": "npx quack build",
        "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-view-image:local",
        "docker-dev-run": "docker run -it -d --name pict-view-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-view\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-view-image:local",
        "docker-dev-shell": "docker exec -it pict-view-dev /bin/bash",
        "types": "tsc -p .",
        "lint": "eslint source/**"
    },
    "types": "types/source/Pict-View.d.ts",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/stevenvelozo/pict-view.git"
    },
    "author": "steven velozo <steven@velozo.com>",
    "license": "MIT",
    "bugs": {
        "url": "https://github.com/stevenvelozo/pict-view/issues"
    },
    "homepage": "https://github.com/stevenvelozo/pict-view#readme",
    "devDependencies": {
        "@eslint/js": "^9.39.1",
        "browser-env": "^3.3.0",
        "eslint": "^9.39.1",
        "pict": "^1.0.363",
        "quackage": "^1.0.65",
        "typescript": "^5.9.3"
    },
    "mocha": {
        "diff": true,
        "extension": [
            "js"
        ],
        "package": "./package.json",
        "reporter": "spec",
        "slow": "75",
        "timeout": "5000",
        "ui": "tdd",
        "watch-files": [
            "source/**/*.js",
            "test/**/*.js"
        ],
        "watch-ignore": [
            "lib/vendor"
        ]
    },
    "dependencies": {
        "fable": "^3.1.67",
        "fable-serviceproviderbase": "^3.0.19"
    }
}

},{}],239:[function(require,module,exports){

const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictViewSettings = (
	{
		DefaultRenderable: false,
		DefaultDestinationAddress: false,
		DefaultTemplateRecordAddress: false,

		ViewIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called as soon as it's added.
		AutoRender: true,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		CSSHash: false,
		CSS: false,
		CSSProvider: false,
		CSSPriority: 500,

		Templates: [],

		DefaultTemplates: [],

		Renderables: [],

		Manifests: {}
	});

/** @typedef {(error?: Error) => void} ErrorCallback */
/** @typedef {number | boolean} PictTimestamp */

/**
 * @typedef {'replace' | 'append' | 'prepend' | 'append_once' | 'virtual-assignment'} RenderMethod
 */
/**
 * @typedef {Object} Renderable
 *
 * @property {string} RenderableHash - A unique hash for the renderable.
 * @property {string} TemplateHash - The hash of the template to use for rendering this renderable.
 * @property {string} [DefaultTemplateRecordAddress] - The default address for resolving the data record for this renderable.
 * @property {string} [ContentDestinationAddress] - The default address (DOM CSS selector) for rendering the content of this renderable.
 * @property {RenderMethod} [RenderMethod=replace] - The method to use when projecting the renderable to the DOM ('replace', 'append', 'prepend', 'append_once', 'virtual-assignment').
 * @property {string} [TestAddress] - The address to use for testing the renderable.
 * @property {string} [TransactionHash] - The transaction hash for the root renderable.
 * @property {string} [RootRenderableViewHash] - The hash of the root renderable.
 * @property {string} [Content] - The rendered content for this renderable, if applicable.
 */

/**
 * Represents a view in the Pict ecosystem.
 */
class PictView extends libFableServiceBase
{
	/**
	 * @param {any} pFable - The Fable object that this service is attached to.
	 * @param {any} [pOptions] - (optional) The options for this service.
	 * @param {string} [pServiceHash] - (optional) The hash of the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictViewSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		//FIXME: add types to fable and ancillaries
		/** @type {any} */
		this.fable;
		/** @type {any} */
		this.options;
		/** @type {String} */
		this.UUID;
		/** @type {String} */
		this.Hash;
		/** @type {any} */
		this.log;

		const tmpHashIsUUID = this.Hash === this.UUID;
		//NOTE: since many places are using the view UUID as the HTML element ID, we prefix it to avoid starting with a number
		this.UUID = `V-${this.UUID}`;
		if (tmpHashIsUUID)
		{
			this.Hash = this.UUID;
		}

		if (!this.options.ViewIdentifier)
		{
			this.options.ViewIdentifier = `AutoViewID-${this.fable.getUUID()}`;
		}
		this.serviceType = 'PictView';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
		// Convenience and consistency naming
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict = this.fable;
		// Wire in the essential Pict application state
		this.AppData = this.pict.AppData;
		this.Bundle = this.pict.Bundle;

		/** @type {PictTimestamp} */
		this.initializeTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastSolvedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastRenderedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalFromViewTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalToViewTimestamp = false;

		this.pict.instantiateServiceProviderIfNotExists('TransactionTracking');

		// Load all templates from the array in the options
		// Templates are in the form of {Hash:'Some-Template-Hash',Template:'Template content',Source:'TemplateSource'}
		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpTemplate = this.options.Templates[i];

			if (!('Hash' in tmpTemplate) || !('Template' in tmpTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Template ${i} in the options array.`, tmpTemplate);
			}
			else
			{
				if (!tmpTemplate.Source)
				{
					tmpTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template, tmpTemplate.Source);
			}
		}

		// Load all default templates from the array in the options
		// Templates are in the form of {Prefix:'',Postfix:'-List-Row',Template:'Template content',Source:'TemplateSourceString'}
		for (let i = 0; i < this.options.DefaultTemplates.length; i++)
		{
			let tmpDefaultTemplate = this.options.DefaultTemplates[i];

			if (!('Postfix' in tmpDefaultTemplate) || !('Template' in tmpDefaultTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}

		// Load the CSS if it's available
		if (this.options.CSS)
		{
			let tmpCSSHash = this.options.CSSHash ? this.options.CSSHash : `View-${this.options.ViewIdentifier}`;
			let tmpCSSProvider = this.options.CSSProvider ? this.options.CSSProvider : tmpCSSHash;
			this.pict.CSSMap.addCSS(tmpCSSHash, this.options.CSS, tmpCSSProvider, this.options.CSSPriority);
		}

		// Load all renderables
		// Renderables are launchable renderable instructions with templates
		// They look as such: {Identifier:'ContentEntry', TemplateHash:'Content-Entry-Section-Main', ContentDestinationAddress:'#ContentSection', RecordAddress:'AppData.Content.DefaultText', ManifestTransformation:'ManyfestHash', ManifestDestinationAddress:'AppData.Content.DataToTransformContent'}
		// The only parts that are necessary are Identifier and Template
		// A developer can then do render('ContentEntry') and it just kinda works.  Or they can override the ContentDestinationAddress
		/** @type {Record<String, Renderable>} */
		this.renderables = {};
		for (let i = 0; i < this.options.Renderables.length; i++)
		{
			/** @type {Renderable} */
			let tmpRenderable = this.options.Renderables[i];
			this.addRenderable(tmpRenderable);
		}
	}

	/**
	 * Adds a renderable to the view.
	 *
	 * @param {string | Renderable} pRenderableHash - The hash of the renderable, or a renderable object.
	 * @param {string} [pTemplateHash] - (optional) The hash of the template for the renderable.
	 * @param {string} [pDefaultTemplateRecordAddress] - (optional) The default data address for the template.
	 * @param {string} [pDefaultDestinationAddress] - (optional) The default destination address for the renderable.
	 * @param {RenderMethod} [pRenderMethod=replace] - (optional) The method to use when rendering the renderable (ex. 'replace').
	 */
	addRenderable(pRenderableHash, pTemplateHash, pDefaultTemplateRecordAddress, pDefaultDestinationAddress, pRenderMethod)
	{
		/** @type {Renderable} */
		let tmpRenderable;

		if (typeof(pRenderableHash) == 'object')
		{
			// The developer passed in the renderable as an object.
			// Use theirs instead!
			tmpRenderable = pRenderableHash;
		}
		else
		{
			/** @type {RenderMethod} */
			let tmpRenderMethod = (typeof(pRenderMethod) !== 'string') ? pRenderMethod : 'replace';
			tmpRenderable = (
				{
					RenderableHash: pRenderableHash,
					TemplateHash: pTemplateHash,
					DefaultTemplateRecordAddress: pDefaultTemplateRecordAddress,
					ContentDestinationAddress: pDefaultDestinationAddress,
					RenderMethod: tmpRenderMethod
				});
		}

		if ((typeof(tmpRenderable.RenderableHash) != 'string') || (typeof(tmpRenderable.TemplateHash) != 'string'))
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Renderable; RenderableHash or TemplateHash are invalid.`, tmpRenderable);
		}
		else
		{
			if (this.pict.LogNoisiness > 0)
			{
				this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} adding renderable [${tmpRenderable.RenderableHash}] pointed to template ${tmpRenderable.TemplateHash}.`);
			}

			this.renderables[tmpRenderable.RenderableHash] = tmpRenderable;
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is initialized.
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized.
	 */
	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * Performs view initialization.
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * Performs view initialization (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				/** @param {Error} pError */
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization failed: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization complete.`);
					}
					return fCallback();
				});
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Render                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeRender:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		this.onBeforeRender(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProject(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProjectAsync(fCallback, pRenderable)
	{
		this.onBeforeProject(pRenderable);
		return fCallback();
	}

	/**
	 * Builds the render options for a renderable.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = {Valid: true};
		tmpRenderOptions.RenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
								(typeof (this.options.DefaultRenderable) == 'string') ?
								this.options.DefaultRenderable : false;
		if (!tmpRenderOptions.RenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not find a suitable RenderableHash ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.Renderable = this.renderables[tmpRenderOptions.RenderableHash];
		if (!tmpRenderOptions.Renderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.DestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
			(typeof (tmpRenderOptions.Renderable.ContentDestinationAddress) === 'string') ? tmpRenderOptions.Renderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : false;
		if (!tmpRenderOptions.DestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address (param ${pRenderDestinationAddress}).`);
			tmpRenderOptions.Valid = false;
		}

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRenderOptions.RecordAddress = 'Passed in as object';
			tmpRenderOptions.Record = pTemplateRecordAddress;
		}
		else
		{
			tmpRenderOptions.RecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderOptions.Renderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderOptions.Renderable.DefaultTemplateRecordAddress :
				(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;
			tmpRenderOptions.Record = (typeof (tmpRenderOptions.RecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRenderOptions.RecordAddress) : undefined;
		}

		return tmpRenderOptions;
	}

	/**
	 * Assigns the content to the destination address.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {Renderable} pRenderable - The renderable to render.
	 * @param {string} pRenderDestinationAddress - The address where the renderable will be rendered.
	 * @param {string} pContent - The content to render.
	 * @returns {boolean} - Returns true if the content was assigned successfully.
	 * @memberof PictView
	 */
	assignRenderContent(pRenderable, pRenderDestinationAddress, pContent)
	{
		return this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderDestinationAddress, pContent, pRenderable.TestAddress);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		return this.renderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable);
	}

	/**
	 * Render a renderable from this view, providing a specifici scope for the template.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	renderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;
		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it is not a valid renderable.`);
			return false;
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
					(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
					(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return false;
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return false;
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		// Execute the developer-overridable pre-render behavior
		this.onBeforeRender(tmpRenderable);

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] render:`);
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Render of Renderable[${tmpRenderableHash}] to Destination [${tmpRenderable.ContentDestinationAddress}]...`);
		}
		// Generate the content output from the template and data
		tmpRenderable.Content = this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord, null, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${tmpRenderableHash}] content length ${tmpRenderable.Content.length} to Destination [${tmpRenderable.ContentDestinationAddress}] using render method [${tmpRenderable.RenderMethod}].`);
		}

		this.onBeforeProject(tmpRenderable);
		this.onProject(tmpRenderable);

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			this.onAfterProject(tmpRenderable);

			// Execute the developer-overridable post-render behavior
			this.onAfterRender(tmpRenderable);
		}

		return true;
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		return this.renderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;

		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pRootRenderable) === 'function') ? pRootRenderable :
							null;

		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`));
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress : (typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`));
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return tmpCallback(new Error(`Could not render ${tmpRenderableHash}`));
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] renderAsync:`);
		}
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Asynchronous Render (callback-style)...`);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		tmpAnticipate.anticipate(
			(fOnBeforeRenderCallback) =>
			{
				this.onBeforeRenderAsync(fOnBeforeRenderCallback, tmpRenderable);
			});

		tmpAnticipate.anticipate(
			(fAsyncTemplateCallback) =>
			{
				// Render the template (asynchronously)
				this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord,
					(pError, pContent) =>
					{
						if (pError)
						{
							this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderableHash} (param ${pRenderableHash}) because it did not parse the template.`, pError);
							return fAsyncTemplateCallback(pError);
						}
						tmpRenderable.Content = pContent;

						return fAsyncTemplateCallback();
					}, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });
			});

		tmpAnticipate.anticipate((fNext) =>
		{
			this.onBeforeProjectAsync(fNext, tmpRenderable);
		});
		tmpAnticipate.anticipate((fNext) =>
		{
			this.onProjectAsync(fNext, tmpRenderable);
		});

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterProjectAsync(fNext, tmpRenderable);
			});

			// Execute the developer-overridable post-render behavior
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterRenderAsync(fNext, tmpRenderable);
			});
		}

		tmpAnticipate.wait(tmpCallback);
	}

	/**
	 * Renders the default renderable.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	renderDefaultAsync(fCallback)
	{
		// Render the default renderable
		this.renderAsync(fCallback);
	}

	/**
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRender(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		return this.basicRenderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRenderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record, null, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable }));
			return true;
		}
		else
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`);
			return false;
		}
	}

	/**
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		return this.basicRenderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		const tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record,
				/**
				 * @param {Error} [pError] - The error that occurred during template parsing.
				 * @param {string} [pContent] - The content that was rendered from the template.
				 */
				(pError, pContent) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderOptions.RenderableHash} because it did not parse the template.`, pError);
						return tmpCallback(pError);
					}

					this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, pContent);
					return tmpCallback();
				}, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable });
		}
		else
		{
			let tmpErrorMessage = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`;
			this.log.error(tmpErrorMessage);
			return tmpCallback(new Error(tmpErrorMessage));
		}
	}

	/**
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onProject:`);
		}
		if (pRenderable.RenderMethod === 'virtual-assignment')
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pRenderable.TransactionHash, { ViewHash: this.Hash, Renderable: pRenderable }, 'Deferred-Post-Content-Assignment');
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${pRenderable.RenderableHash}] content length ${pRenderable.Content.length} to Destination [${pRenderable.ContentDestinationAddress}] using Async render method ${pRenderable.RenderMethod}.`);
		}

		// Assign the content to the destination address
		this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderable.ContentDestinationAddress, pRenderable.Content, pRenderable.TestAddress);

		this.lastRenderedTimestamp = this.pict.log.getTimeStamp();
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {(error?: Error, content?: string) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that is being projected.
	 */
	onProjectAsync(fCallback, pRenderable)
	{
		this.onProject(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender:`);
		}
		if (pRenderable && pRenderable.RootRenderableViewHash === this.Hash)
		{
			const tmpTransactionQueue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const tmpEvent of tmpTransactionQueue)
			{
				const tmpView = this.pict.views[tmpEvent.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${tmpEvent.Data.ViewHash}.`);
					continue;
				}
				tmpView.onAfterProject();

				// Execute the developer-overridable post-render behavior
				tmpView.onAfterRender(tmpEvent.Data.Renderable);
			}
			// Queue is drained and nested child renders have each cleaned up
			// their own transactions; remove this root render's entry from
			// the tracking map so it does not leak.
			this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		// NOTE: this.onAfterRender(pRenderable) will itself clear the
		// transaction queue and unregister the transaction if this view is
		// the root renderable - see onAfterRender above. So by the time the
		// loop below runs, the queue is already empty and there is nothing
		// to drain. Keeping the async queue walk here defensively in case
		// future subclasses override onAfterRender in ways that skip the
		// drain, but the common path is now "sync drain, async no-op".
		this.onAfterRender(pRenderable);
		const tmpAnticipate = this.fable.newAnticipate();
		const tmpIsRootRenderable = pRenderable && pRenderable.RootRenderableViewHash === this.Hash;
		if (tmpIsRootRenderable)
		{
			const queue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const event of queue)
			{
				/** @type {PictView} */
				const tmpView = this.pict.views[event.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRenderAsync: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${event.Data.ViewHash}.`);
					continue;
				}
				tmpAnticipate.anticipate(tmpView.onAfterProjectAsync.bind(tmpView));
				tmpAnticipate.anticipate((fNext) =>
				{
					tmpView.onAfterRenderAsync(fNext, event.Data.Renderable);
				});

				// Execute the developer-overridable post-render behavior
			}
		}
		return tmpAnticipate.wait((pError) =>
		{
			// Nested virtual-assignment children have now settled their own
			// onAfterRenderAsync chains (and unregistered their own
			// transactions along the way). Ensure this root render's entry
			// is also gone - unregisterTransaction is a no-op if the sync
			// onAfterRender above already removed it, so this is safe to
			// call unconditionally on the root path.
			if (tmpIsRootRenderable && pRenderable && pRenderable.TransactionHash)
			{
				this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
			}
			return fCallback(pError);
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProjectAsync(fCallback, pRenderable)
	{
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Solver                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is solved.
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is solved.
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * Performs view solving and triggers lifecycle hooks.
	 *
	 * @return {boolean} - True if the view was solved successfully, false otherwise.
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeSolve();
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Performs view solving and triggers lifecycle hooks (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after the view is solved.
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal From View                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	onBeforeMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalFromViewAsync(fCallback)
	{
		this.onBeforeMarshalFromView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view.
	 */
	onMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalFromViewAsync(fCallback)
	{

		this.onMarshalFromView();
		return fCallback();
	}

	/**
	 * Marshals data from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalFromView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalFromView();
		this.onMarshalFromView();
		this.onAfterMarshalFromView();
		this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalFromViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalFromViewAsync() complete.`);
				}
				this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view.
	 */
	onAfterMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalFromViewAsync(fCallback)
	{
		this.onAfterMarshalFromView();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal To View                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled into the view.
	 */
	onBeforeMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalToViewAsync(fCallback)
	{
		this.onBeforeMarshalToView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view.
	 */
	onMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalToViewAsync(fCallback)
	{
		this.onMarshalToView();
		return fCallback();
	}

	/**
	 * Marshals data into the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalToView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalToView();
		this.onMarshalToView();
		this.onAfterMarshalToView();
		this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalToViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');


		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}
		tmpAnticipate.anticipate(this.onBeforeMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalToViewAsync() complete.`);
				}
				this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view.
	 */
	onAfterMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalToViewAsync(fCallback)
	{
		this.onAfterMarshalToView();
		return fCallback();
	}

	/** @return {boolean} - True if the object is a PictView. */
	get isPictView()
	{
		return true;
	}
}

module.exports = PictView;

},{"../package.json":238,"fable-serviceproviderbase":2}],240:[function(require,module,exports){
module.exports={
	"name": "ultravisor-webinterface",
	"version": "0.0.1",
	"description": "Ultravisor Task Server Web Interface",
	"main": "source/Pict-Application-Ultravisor.js",
	"scripts": {
		"start": "node source/Pict-Application-Ultravisor.js",
		"brand": "node node_modules/pict-section-theme/bin/pict-section-theme-brand.js --manifest ../../../../Retold-Modules-Manifest.json --module ultravisor --package ./package.json --favicons html/favicons",
		"prebuild": "(npm run brand || echo 'brand skipped (manifest unavailable — using committed retold.brand block)') && node ./node_modules/pict-section-flow/scripts/generate-card-help.js ./docs/card-help ./source/card-help-content.js",
		"build": "npx quack build && node build/build-codemirror-bundle.js && npx quack copy"
	},
	"author": "steven velozo <steven@velozo.com>",
	"license": "MIT",
	"dependencies": {
		"pict": "^1.0.363",
		"pict-application": "^1.0.33",
		"pict-docuserve": "^0.0.32",
		"pict-provider": "^1.0.12",
		"pict-router": "^1.0.9",
		"pict-section-code": "^1.0.7",
		"pict-section-content": "^0.0.11",
		"pict-section-flow": "^0.0.17",
		"pict-section-form": "^1.0.195",
		"pict-section-login": "^1.0.0",
		"pict-section-markdowneditor": "^1.0.7",
		"pict-section-modal": "^1.0.0",
		"pict-section-objecteditor": "^1.0.1",
		"pict-section-theme": "^1.0.0",
		"pict-section-usermanagement": "^0.0.1",
		"pict-view": "^1.0.67"
	},
	"devDependencies": {
		"@codemirror/lang-markdown": "^6.5.0",
		"@codemirror/state": "^6.6.0",
		"@codemirror/view": "^6.40.0",
		"codemirror": "^6.0.2",
		"esbuild": "^0.27.4",
		"quackage": "^1.0.65",
		"retold-sharp": "^1.0.0"
	},
	"copyFilesSettings": {
		"whenFileExists": "overwrite"
	},
	"copyFiles": [
		{
			"from": "./html/*",
			"to": "./dist/"
		},
		{
			"from": "./html/favicons/*",
			"to": "./dist/favicons/"
		},
		{
			"from": "./css/**",
			"to": "./dist/css/"
		},
		{
			"from": "./node_modules/pict/dist/*",
			"to": "./dist/js/"
		},
		{
			"from": "../docs/**",
			"to": "./dist/docs/"
		}
	],
	"retold": {
		"brand": {
			"Hash": "ultravisor",
			"Name": "Ultravisor",
			"Tagline": "Process supervision and workflow automation",
			"Palette": "desert",
			"Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"frame-ultravisor-filled-light\">\n\t\t\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\" fill=\"#cc8821\"/>\n\t\t<g clip-path=\"url(#frame-ultravisor-filled-light)\"><path d=\"M 48.00,12.00 L 79.18,30.00 L 79.18,66.00 L 48.00,84.00 L 16.82,66.00 L 16.82,30.00 Z\" fill=\"rgba(255,255,255,0.18)\"/>\n\t\t\t\t\t<circle cx=\"48\" cy=\"48\" r=\"24\" fill=\"#5a9ec0\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"56\" font-weight=\"600\"\n\t\t\tfill=\"#ffffff\" letter-spacing=\"-1\">U</text>\n\t</svg>",
			"IconType": "svg",
			"Favicon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"fav-ultravisor-light\">\n\t\t\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\" fill=\"#cc8821\"/>\n\t\t<g clip-path=\"url(#fav-ultravisor-light)\"><path d=\"M 48.00,12.00 L 79.18,30.00 L 79.18,66.00 L 48.00,84.00 L 16.82,66.00 L 16.82,30.00 Z\" fill=\"rgba(255,255,255,0.22)\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"60\" font-weight=\"800\"\n\t\t\tfill=\"#ffffff\" letter-spacing=\"-1\">U</text>\n\t</svg>",
			"FaviconDark": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"fav-ultravisor-dark\">\n\t\t\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 2 48\n\t\t\tA 46 46 0 1 0 94 48\n\t\t\tA 46 46 0 1 0 2 48 Z\" fill=\"#e0b169\"/>\n\t\t<g clip-path=\"url(#fav-ultravisor-dark)\"><path d=\"M 48.00,12.00 L 79.18,30.00 L 79.18,66.00 L 48.00,84.00 L 16.82,66.00 L 16.82,30.00 Z\" fill=\"rgba(255,255,255,0.22)\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"60\" font-weight=\"800\"\n\t\t\tfill=\"#101418\" letter-spacing=\"-1\">U</text>\n\t</svg>",
			"Colors": {
				"Primary": "#cc8821",
				"Secondary": "#5a9ec0",
				"PrimaryLight": "#cc8821",
				"PrimaryDark": "#e0b169",
				"SecondaryLight": "#5a9ec0",
				"SecondaryDark": "#a0c4d5"
			}
		}
	}
}

},{}],241:[function(require,module,exports){
module.exports={
	"Name": "Ultravisor Web Interface",
	"Hash": "Ultravisor",

	"MainViewportViewIdentifier": "Ultravisor-Layout",

	"AutoSolveAfterInitialize": true,
	"AutoRenderMainViewportViewAfterInitialize": false,
	"AutoRenderViewsAfterInitialize": false,

	"pict_configuration":
		{
			"Product": "Ultravisor-Pict-Application"
		}
}

},{}],242:[function(require,module,exports){
const libPictApplication = require('pict-application');
const libPictRouter = require('pict-router');
const libPictSectionForm = require('pict-section-form');
const libPictSectionContent = require('pict-section-content');
const libPictSectionTheme = require('pict-section-theme');
const libUltravisorBrand = require('./Ultravisor-Brand.js');

// Views
const libViewLayout = require('./views/PictView-Ultravisor-Layout.js');
const libViewTopBarNav = require('./views/PictView-Ultravisor-TopBar-Nav.js');
const libViewTopBarUser = require('./views/PictView-Ultravisor-TopBar-User.js');
const libViewSidebar = require('./views/PictView-Ultravisor-Sidebar.js');
const libViewSettingsPanel = require('./views/PictView-Ultravisor-SettingsPanel.js');
const libViewBottomBar = require('./views/PictView-Ultravisor-BottomBar.js');
const libViewDashboard = require('./views/PictView-Ultravisor-Dashboard.js');
const libViewOperationList = require('./views/PictView-Ultravisor-OperationList.js');
const libViewOperationEdit = require('./views/PictView-Ultravisor-OperationEdit.js');
const libViewSchedule = require('./views/PictView-Ultravisor-Schedule.js');
const libViewManifestList = require('./views/PictView-Ultravisor-ManifestList.js');
const libViewManifestDetail = require('./views/PictView-Ultravisor-ManifestDetail.js');
const libViewTimingView = require('./views/PictView-Ultravisor-TimingView.js');
const libViewFlowEditor = require('./views/PictView-Ultravisor-FlowEditor.js');
const libViewPendingInput = require('./views/PictView-Ultravisor-PendingInput.js');
const libViewDocumentation = require('./views/PictView-Ultravisor-Documentation.js');
const libViewBeaconList = require('./views/PictView-Ultravisor-BeaconList.js');
const libViewTimeline = require('./views/PictView-Ultravisor-Timeline.js');
const libProviderTimelineStream = require('./providers/Provider-Timeline-Stream.js');
const libViewCapabilityHeatMap = require('./views/PictView-Ultravisor-CapabilityHeatMap.js');
const libViewThroughput = require('./views/PictView-Ultravisor-Throughput.js');
const libViewConstellation = require('./views/PictView-Ultravisor-Constellation.js');
const libViewReachabilityMap = require('./views/PictView-Ultravisor-ReachabilityMap.js');
const libViewOperationDescriptionEditor = require('./views/PictView-Ultravisor-OperationDescriptionEditor.js');
const libViewFleet = require('./views/PictView-Ultravisor-Fleet.js');
const libViewLogin = require('./views/PictView-Ultravisor-Login.js');
const libViewUserManagement = require('./views/PictView-Ultravisor-UserManagement.js');
const libPictSectionModal = require('pict-section-modal');
const libPictSectionUserManagement = require('pict-section-usermanagement');
const libPictSectionLogin = require('pict-section-login');

class UltravisorApplication extends libPictApplication
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Skip premature route resolution during addRoute(); the Layout view
		// calls resolve() explicitly after the DOM is ready.
		this.pict.settings.RouterSkipRouteResolveOnAdd = true;

		// Add the router provider with routes
		this.pict.addProvider('PictRouter', require('./providers/PictRouter-Ultravisor-Configuration.json'), libPictRouter);

		// Add the layout view (the shell that contains topbar, sidebar, bottombar,
		// settings panel, and the workspace center).
		this.pict.addView('Ultravisor-Layout', libViewLayout.default_configuration, libViewLayout);

		// Bottom bar (existing status view) — used as the StatusView slot below.
		this.pict.addView('Ultravisor-BottomBar', libViewBottomBar.default_configuration, libViewBottomBar);

		// Theme-TopBar / Theme-BottomBar slot views must be registered BEFORE
		// the Theme-Section provider — _bootstrap looks them up by hash.
		this.pict.addView('Ultravisor-TopBar-Nav',  libViewTopBarNav.default_configuration,  libViewTopBarNav);
		this.pict.addView('Ultravisor-TopBar-User', libViewTopBarUser.default_configuration, libViewTopBarUser);
		this.pict.addView('Ultravisor-Sidebar',     libViewSidebar.default_configuration,    libViewSidebar);
		this.pict.addView('Ultravisor-SettingsPanel', libViewSettingsPanel.default_configuration, libViewSettingsPanel);

		// Add content views
		this.pict.addView('Ultravisor-Dashboard', libViewDashboard.default_configuration, libViewDashboard);
		this.pict.addView('Ultravisor-OperationList', libViewOperationList.default_configuration, libViewOperationList);
		this.pict.addView('Ultravisor-OperationEdit', libViewOperationEdit.default_configuration, libViewOperationEdit);
		this.pict.addView('Ultravisor-Schedule', libViewSchedule.default_configuration, libViewSchedule);
		this.pict.addView('Ultravisor-ManifestList', libViewManifestList.default_configuration, libViewManifestList);
		this.pict.addView('Ultravisor-ManifestDetail', libViewManifestDetail.default_configuration, libViewManifestDetail);
		this.pict.addView('Ultravisor-TimingView', libViewTimingView.default_configuration, libViewTimingView);
		this.pict.addView('Ultravisor-FlowEditor', libViewFlowEditor.default_configuration, libViewFlowEditor);
		this.pict.addView('Ultravisor-PendingInput', libViewPendingInput.default_configuration, libViewPendingInput);
		this.pict.addView('Ultravisor-Documentation', libViewDocumentation.default_configuration, libViewDocumentation);
		this.pict.addView('Ultravisor-BeaconList', libViewBeaconList.default_configuration, libViewBeaconList);

		// Phase 6 — three-band timeline (the spine). Provider owns the
		// `/Timeline` long-poll cycle and reconciles into AppData.Timeline.*;
		// view observes AppData and paints via Canvas + SVG.
		this.pict.addProvider('Timeline-Stream', libProviderTimelineStream.default_configuration, libProviderTimelineStream);
		this.pict.addView('Ultravisor-Timeline', libViewTimeline.default_configuration, libViewTimeline);

		// Phase 7 — complementary timeline views. Each is standalone (own
		// fetch loop on the same /Timeline endpoint) and shares the spine's
		// URL contract via webinterface/source/views/timeline/url-state.js.
		this.pict.addView('Ultravisor-CapabilityHeatMap', libViewCapabilityHeatMap.default_configuration, libViewCapabilityHeatMap);
		this.pict.addView('Ultravisor-Throughput', libViewThroughput.default_configuration, libViewThroughput);
		this.pict.addView('Ultravisor-Constellation', libViewConstellation.default_configuration, libViewConstellation);
		this.pict.addView('Ultravisor-ReachabilityMap', libViewReachabilityMap.default_configuration, libViewReachabilityMap);
		this.pict.addView('Ultravisor-OperationDescriptionEditor', libViewOperationDescriptionEditor.default_configuration, libViewOperationDescriptionEditor);
		this.pict.addView('Ultravisor-Fleet', libViewFleet.default_configuration, libViewFleet);
		this.pict.addView('Ultravisor-Login', libViewLogin.default_configuration, libViewLogin);
		this.pict.addView('Ultravisor-UserManagement', libViewUserManagement.default_configuration, libViewUserManagement);

		// Modal/toast notification system (replaces browser alert/confirm).
		// Two registrations: 'Modal' is the legacy hash existing call sites
		// use; 'Pict-Section-Modal' is what pict-section-usermanagement's
		// confirm/toast hooks look up. Both addView calls produce
		// independent instances of the same section, which is fine because
		// the modal section is stateless across constructions.
		// 'Pict-Section-Modal' also exposes the shell() + addPanel() API
		// the Layout view consumes to build its panels.
		this.pict.addView('Modal', {}, libPictSectionModal);
		this.pict.addView('Pict-Section-Modal', {}, libPictSectionModal);

		// Theme-Section — registers the topbar/bottombar chrome, the
		// theme catalog, persistence, and brand. ApplyDefault is the
		// shared ecosystem identity; the six ultravisor-* palettes in
		// pict-section-theme/source/themes/ are pickable from the
		// settings panel.
		this.pict.addProvider('Theme-Section',
		{
			ApplyDefault: 'retold-default',
			DefaultMode:  'system',
			DefaultScale: 1.0,
			Brand:        libUltravisorBrand,
			Views: ['Picker', 'ModeToggle', 'ScaleSelect', 'BrandMark', 'TopBar', 'BottomBar'],
			ViewOptions:
			{
				TopBar:    { NavView: 'Ultravisor-TopBar-Nav', UserView: 'Ultravisor-TopBar-User', Height: 56 },
				BottomBar: { StatusView: 'Ultravisor-BottomBar', Height: 28 }
			}
		}, libPictSectionTheme);

		// pict-section-usermanagement — install() registers the provider
		// + the CRUD views (CurrentUser, UserList, UserEdit,
		// PasswordChange).  We deliberately exclude its Login view
		// because Ultravisor uses pict-section-login (registered below)
		// for the actual sign-in flow.  Default browser fetch() is the
		// transport, hitting orator-authentication's /1.0/Authenticate
		// + the auth-beacon /Users routes mounted by ultravisor's API
		// server.  The CRUD views only function when the connected
		// auth-beacon's provider implements user management — the boot
		// gate hides their UI entry points when SupportsUserManagement
		// is false but the views are always registered so deep links
		// don't crash.
		let tmpSelf = this;
		libPictSectionUserManagement.install(this.pict,
		{
			ProviderOptions: { BaseURL: '/1.0/' },
			Views: ['CurrentUser', 'UserList', 'UserEdit', 'PasswordChange'],
			ViewOptions:
			{
				CurrentUser: { OnLogout: () => tmpSelf._afterLogout() }
			}
		});

		// pict-section-login — the dedicated login flow.  Renders into
		// `#Pict-Login-Container` (PictView-Ultravisor-Login paints that
		// mount point inside the content panel).  Hooks fire after the
		// section calls the underlying endpoints:
		//   onLoginSuccess  → re-render topbar + bounce to /Home
		//   onLogout        → re-render topbar + bounce back to /Login
		//   onSessionChecked → used by _bootGate to decide initial route
		// CheckSessionOnLoad is left at its default (true) so a stale
		// cookie is validated automatically on first render.
		this.pict.addView('Pict-Section-Login',
		{
			LoginEndpoint:        '/1.0/Authenticate',
			LogoutEndpoint:       '/1.0/Deauthenticate',
			CheckSessionEndpoint: '/1.0/CheckSession',
			CheckSessionOnLoad:   true,
			ShowOAuthProviders:   false
		}, libPictSectionLogin);
		// Wire the section's overridable hooks to host-side flow.  The
		// section's class methods are inherited; we monkey-patch the
		// instance so consumers don't need a subclass file just to
		// connect three handlers.
		let tmpLogin = this.pict.views['Pict-Section-Login'];
		if (tmpLogin)
		{
			tmpLogin.onLoginSuccess   = (pSession) => tmpSelf._afterLogin(pSession);
			tmpLogin.onLogout         = ()         => tmpSelf._afterLogout();
			tmpLogin.onSessionChecked = (pSession) => tmpSelf._afterSessionChecked(pSession);
		}

		// Register pict-section-form service types so Form panels can use them
		this.pict.addServiceType('PictFormMetacontroller', libPictSectionForm.PictFormMetacontroller);

		// Register pict-section-content service types so Markdown panels can render content
		this.pict.addServiceType('PictContentProvider', libPictSectionContent.PictContentProvider);

		// Register the Ultravisor card settings panel for per-field mode toggles (Constant/Address/Default)
		const libUltravisorCardSettingsPanel = require('./panels/Ultravisor-CardSettingsPanel.js');
		this.pict.addServiceType('PictFlowCardPropertiesPanel-UltravisorSettings', libUltravisorCardSettingsPanel);
	}

	onAfterInitializeAsync(fCallback)
	{
		// Initialize application state. Theme/mode/scale persistence is
		// owned by pict-section-theme — no theme keys live in AppData.
		this.pict.AppData.Ultravisor =
		{
			APIBaseURL: '',
			ServerStatus: { Status: 'Unknown', ScheduleEntries: 0, ScheduleRunning: false },
			// Auth-mode metadata populated by _bootGate() from /status.
			// Mode: 'promiscuous' | 'authenticated'
			// SupportsUserManagement: true → in-app user CRUD UI visible
			// SessionChecked: flips true after the section's first
			// checkSession() resolves; views that gate on auth state
			// (TopBar-User badge, Sidebar) should not paint user info
			// until this is true to avoid a flash of "anonymous".
			Auth:
			{
				Mode: 'promiscuous',
				SupportsUserManagement: false,
				SessionChecked: false,
				Authenticated: false
			},
			NodeTemplates: {},
			NodeTemplateList: [],
			TaskTypes: [],
			Operations: {},
			OperationList: [],
			Schedule: [],
			Manifests: [],
			PendingInputs: [],
			OperationLibrary: [],
			Beacons: [],
			WorkItems: [],
			BeaconCapabilities: {},
			AffinityBindings: [],
			ReachabilityMatrix: [],
			ReachabilityBeacons: [],
			ReachabilityHub: null,
			CurrentEditOperation: null,
			CurrentRoute: this._readHashRoute(),
			Flows: {},
			OperationDescriptionSegments: [{ Content: '' }],
			DebugMode: false
		};

		// Load task type definitions + auth-mode status BEFORE rendering
		// the layout.  The layout render triggers route resolution (via
		// PictRouter.resolve()), and we need AuthMode in AppData before
		// then so the gate logic + user-menu visibility paint correctly
		// on first render.  Both fetches are independent — fan them out
		// in parallel via a tiny join.
		let tmpSuper = super.onAfterInitializeAsync.bind(this);
		let tmpJoinPending = 2;
		let tmpJoinErr = null;
		let fJoin = (pErr) =>
		{
			if (pErr && !tmpJoinErr) { tmpJoinErr = pErr; }
			if (--tmpJoinPending > 0) { return; }
			if (tmpJoinErr)
			{
				this.pict.log.warn('Boot precondition failed; continuing with defaults: ' + tmpJoinErr.message);
			}
			this.pict.views['Ultravisor-Layout'].render();
			// If the auth-beacon says we need a real login, force-show
			// the Login view immediately.  pict-section-login's
			// CheckSessionOnLoad will then validate any stored cookie
			// and either bounce us to /Home (via _afterSessionChecked)
			// or keep us on /Login.
			if (this.pict.AppData.Ultravisor.Auth.Mode === 'authenticated')
			{
				this.navigateTo('/Login');
			}
			return tmpSuper(fCallback);
		};
		this._loadAuthStatus(fJoin.bind(this));
		this.loadTaskTypes(
			function (pError)
			{
				if (pError)
				{
					this.pict.log.warn('Failed to load task types during init; flow editor will have no cards.');
				}
				// Both legs of the parallel boot done?  fJoin() renders
				// the layout once both /status + /TaskTypes have come
				// back, so route resolution doesn't kick off until auth
				// state is in AppData.
				return fJoin.call(this, null);
			}.bind(this));
	}

	/**
	 * Fetch /status and stash auth-mode + user-management capability in
	 * AppData.  Used by the boot path to decide whether to send the
	 * user to /Login on first load.  Non-fatal: a /status failure leaves
	 * the AppData defaults (promiscuous, no user mgmt) which means the
	 * UI behaves like an offline lab rig rather than 401-ing the whole
	 * app.
	 */
	_loadAuthStatus(fCallback)
	{
		let tmpURL = `${this.pict.AppData.Ultravisor.APIBaseURL}/status`;
		fetch(tmpURL, { credentials: 'include' })
			.then((pResp) => pResp.ok ? pResp.json() : Promise.reject(new Error('HTTP ' + pResp.status)))
			.then((pBody) =>
			{
				this.pict.AppData.Ultravisor.ServerStatus = pBody || {};
				this.pict.AppData.Ultravisor.Auth.Mode =
					(pBody && pBody.AuthMode === 'authenticated') ? 'authenticated' : 'promiscuous';
				this.pict.AppData.Ultravisor.Auth.SupportsUserManagement =
					!!(pBody && pBody.SupportsUserManagement);
				fCallback(null);
			})
			.catch((pErr) => fCallback(pErr));
	}

	/**
	 * True when the connected mesh requires a real login and this browser
	 * session has not provided one yet — i.e. an auth-beacon is advertising
	 * the Authentication capability ('authenticated' mode) and the session
	 * check has not (yet) confirmed a logged-in user.
	 *
	 * While this holds the UI is locked to the login screen: the top-bar
	 * navigation is emptied, the sidebar shows a sign-in prompt, the
	 * settings gear is hidden, every content route collapses to
	 * Ultravisor-Login, and navigation / deep-links are redirected to
	 * /Login.  The API server independently 401s session-gated routes, so
	 * this is the UI half of a defense-in-depth gate, not the only line of
	 * defense.
	 *
	 * Fail-closed: before the first session check resolves (Authenticated
	 * still false) the app is treated as locked, so a signed-out reload
	 * never flashes the full UI.  Promiscuous mode (no auth-beacon) never
	 * locks.
	 */
	isLoginRequired()
	{
		let tmpAuth = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.Auth) || {};
		return (tmpAuth.Mode === 'authenticated') && !tmpAuth.Authenticated;
	}

	navigateTo(pRoute)
	{
		// Auth gate: while signed out in authenticated mode every navigation
		// collapses to the login route.  _afterLogin() and
		// _afterSessionChecked() flip Authenticated true *before* their
		// navigateTo('/Home') calls, so a successful sign-in is not trapped
		// here.
		if (this.isLoginRequired())
		{
			pRoute = '/Login';
		}
		this.pict.AppData.Ultravisor.CurrentRoute = pRoute;
		this.pict.providers.PictRouter.navigate(pRoute);
		this.renderTopBar();
		this.renderSidebar();
	}

	/**
	 * Called when the URL hash changes (back/forward/manual edit). Keeps
	 * AppData.Ultravisor.CurrentRoute in sync and re-renders the topbar
	 * + sidebar so active-tab highlighting and sidebar context match.
	 */
	onRouteChanged()
	{
		let tmpRoute = this._readHashRoute();
		// Auth gate: a hand-edited hash or a pasted deep-link reaches the
		// router directly, bypassing navigateTo().  If we are locked and the
		// URL points anywhere but /Login, bounce it back so the address bar
		// cannot disagree with the locked content panel.
		if (this.isLoginRequired() && tmpRoute !== '/Login')
		{
			return this.navigateTo('/Login');
		}
		this.pict.AppData.Ultravisor.CurrentRoute = tmpRoute;
		this.renderTopBar();
		this.renderSidebar();
	}

	_readHashRoute()
	{
		if (typeof window === 'undefined' || !window.location || !window.location.hash) { return '/Home'; }
		let tmpHash = window.location.hash;
		if (tmpHash.charAt(0) === '#') { tmpHash = tmpHash.slice(1); }
		if (!tmpHash || tmpHash === '/') { return '/Home'; }
		return tmpHash;
	}

	renderTopBar()
	{
		let tmpNav  = this.pict.views['Ultravisor-TopBar-Nav'];
		let tmpUser = this.pict.views['Ultravisor-TopBar-User'];
		if (tmpNav)  { tmpNav.render(); }
		if (tmpUser) { tmpUser.render(); }
	}

	renderSidebar()
	{
		let tmpSidebar = this.pict.views['Ultravisor-Sidebar'];
		if (tmpSidebar) { tmpSidebar.render(); }
	}

	/**
	 * Hook fired by pict-section-login after a successful sign-in.
	 * Re-render the topbar so the CurrentUser badge appears, then
	 * bounce to the dashboard.  We deliberately drop the pre-login
	 * route here — the user can re-navigate after seeing /Home, and
	 * remembering deep-links across a fresh authentication is a
	 * surprisingly tricky UX in the face of expired routes.
	 */
	_afterLogin(pSessionData)
	{
		this.pict.AppData.Ultravisor.Auth.Authenticated = true;
		this.pict.AppData.Ultravisor.Auth.SessionChecked = true;
		this.renderTopBar();
		this.navigateTo('/Home');
	}

	/**
	 * Hook fired by pict-section-login (logout button on its status
	 * card) and by pict-section-usermanagement's CurrentUser view.
	 * Drop back to /Login so it's obvious the session is gone.
	 */
	_afterLogout()
	{
		this.pict.AppData.Ultravisor.Auth.Authenticated = false;
		this.renderTopBar();
		this.navigateTo('/Login');
	}

	/**
	 * Hook fired by pict-section-login after its initial session check
	 * resolves.  Three cases:
	 *   - pSessionData.LoggedIn === true  → already authenticated; if
	 *     we landed on /Login as part of the boot gate, bounce to /Home
	 *   - pSessionData.LoggedIn === false → cookie invalid/expired; stay
	 *     on /Login so the user can sign in
	 *   - pSessionData === null           → server unreachable; the
	 *     session-check endpoint flaked.  Leave the user where they are;
	 *     gated routes will 401 on their own and the gate stays armed.
	 */
	_afterSessionChecked(pSessionData)
	{
		this.pict.AppData.Ultravisor.Auth.SessionChecked = true;
		let tmpLoggedIn = !!(pSessionData && pSessionData.LoggedIn);
		this.pict.AppData.Ultravisor.Auth.Authenticated = tmpLoggedIn;
		this.renderTopBar();
		// Only redirect away from /Login when we were force-bounced there
		// by the boot gate.  A user explicitly opening /Login while
		// already signed in is rare but valid — leave them alone.
		if (tmpLoggedIn
			&& this.pict.AppData.Ultravisor.Auth.Mode === 'authenticated'
			&& this._readHashRoute() === '/Login')
		{
			this.navigateTo('/Home');
		}
	}

	showView(pViewIdentifier)
	{
		// Auth gate: while a login is required the content panel may only
		// show the login screen — every other view collapses to
		// Ultravisor-Login so the application cannot be operated while
		// signed out (see isLoginRequired()).
		if (this.isLoginRequired())
		{
			pViewIdentifier = 'Ultravisor-Login';
		}

		if (pViewIdentifier in this.pict.views)
		{
			this.pict.views[pViewIdentifier].render();
		}
		else
		{
			this.pict.log.warn(`View [${pViewIdentifier}] not found; falling back to dashboard.`);
			this.pict.views['Ultravisor-Dashboard'].render();
		}
	}

	// --- API Helper ---
	apiCall(pMethod, pPath, pBody, fCallback)
	{
		let tmpURL = `${this.pict.AppData.Ultravisor.APIBaseURL}${pPath}`;
		let tmpOptions = { method: pMethod, headers: { 'Content-Type': 'application/json' } };

		if (pBody)
		{
			tmpOptions.body = JSON.stringify(pBody);
		}

		fetch(tmpURL, tmpOptions)
			.then(
				function (pResponse)
				{
					return pResponse.json();
				})
			.then(
				function (pData)
				{
					// Server responded — clear disconnected state if it was set
					if (this.pict.AppData.Ultravisor.ServerStatus.StatusClass === 'error')
					{
						this._setConnectionState(true);
					}

					if (typeof fCallback === 'function')
					{
						fCallback(null, pData);
					}
				}.bind(this))
			.catch(
				function (pError)
				{
					this.pict.log.error(`API call failed: ${pMethod} ${pPath}`, pError);

					// Network error — mark as disconnected
					this._setConnectionState(false);

					if (typeof fCallback === 'function')
					{
						fCallback(pError);
					}
				}.bind(this));
	}

	/**
	 * Update the connection state and show/hide the disconnected banner.
	 *
	 * @param {boolean} pConnected - true if the server is reachable
	 */
	_setConnectionState(pConnected)
	{
		let tmpStatus = this.pict.AppData.Ultravisor.ServerStatus;

		if (!pConnected)
		{
			if (tmpStatus.StatusClass !== 'error')
			{
				tmpStatus.StatusClass = 'error';
				tmpStatus.StatusText = 'Disconnected';

				// Update status indicator in the TopBar-User slot.
				let tmpContent = this.pict.parseTemplateByHash('Ultravisor-TopBar-Status-Template', {}, null, this.pict);
				this.pict.ContentAssignment.assignContent('#Ultravisor-TopBar-StatusArea', tmpContent);

				// Show a prominent banner in the content area.
				let tmpContentContainer = document.getElementById('Ultravisor-Content-Container');
				if (tmpContentContainer)
				{
					tmpContentContainer.innerHTML = '<div class="ultravisor-disconnected-banner">'
						+ '<div class="ultravisor-disconnected-banner-icon">&#x26A0;</div>'
						+ '<h2>Server Unreachable</h2>'
						+ '<p>The Ultravisor server is not responding. Make sure it is running and refresh the page.</p>'
						+ '</div>';
				}
			}
		}
		else
		{
			if (tmpStatus.StatusClass === 'error')
			{
				tmpStatus.StatusClass = 'connected';
				tmpStatus.StatusText = tmpStatus.Status || 'Connected';

				let tmpContent = this.pict.parseTemplateByHash('Ultravisor-TopBar-Status-Template', {}, null, this.pict);
				this.pict.ContentAssignment.assignContent('#Ultravisor-TopBar-StatusArea', tmpContent);

				let tmpBanner = document.querySelector('.ultravisor-disconnected-banner');
				if (tmpBanner)
				{
					tmpBanner.remove();
				}
			}
		}
	}

	// --- Status ---
	loadStatus(fCallback)
	{
		this.apiCall('GET', '/status', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.ServerStatus = pData;
					// Mirror auth mode + user-mgmt capability into the
					// dedicated Auth state slot so polling refreshes
					// keep nav visibility in sync with the server (an
					// auth-beacon hot-attach/detach mid-session flips
					// SupportsUserManagement without a UI reload).
					this.pict.AppData.Ultravisor.Auth.Mode =
						(pData.AuthMode === 'authenticated') ? 'authenticated' : 'promiscuous';
					this.pict.AppData.Ultravisor.Auth.SupportsUserManagement =
						!!pData.SupportsUserManagement;
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Node Templates ---
	loadNodeTemplates(fCallback)
	{
		this.apiCall('GET', '/NodeTemplate', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.NodeTemplateList = Array.isArray(pData) ? pData : [];
					let tmpTemplates = {};
					for (let i = 0; i < this.pict.AppData.Ultravisor.NodeTemplateList.length; i++)
					{
						let tmpTemplate = this.pict.AppData.Ultravisor.NodeTemplateList[i];
						tmpTemplates[tmpTemplate.Hash] = tmpTemplate;
					}
					this.pict.AppData.Ultravisor.NodeTemplates = tmpTemplates;
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	saveNodeTemplate(pTemplateData, fCallback)
	{
		this.apiCall('POST', '/NodeTemplate', pTemplateData,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	deleteNodeTemplate(pHash, fCallback)
	{
		this.apiCall('DELETE', `/NodeTemplate/${encodeURIComponent(pHash)}`, null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Task Types ---
	loadTaskTypes(fCallback)
	{
		this.apiCall('GET', '/TaskType', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.TaskTypes = Array.isArray(pData) ? pData : [];
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Operations ---
	loadOperations(fCallback)
	{
		this.apiCall('GET', '/Operation', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.OperationList = Array.isArray(pData) ? pData : [];
					let tmpOperations = {};
					for (let i = 0; i < this.pict.AppData.Ultravisor.OperationList.length; i++)
					{
						let tmpOp = this.pict.AppData.Ultravisor.OperationList[i];
						tmpOperations[tmpOp.Hash] = tmpOp;
					}
					this.pict.AppData.Ultravisor.Operations = tmpOperations;
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	saveOperation(pOperationData, fCallback)
	{
		this.apiCall('POST', '/Operation', pOperationData,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	deleteOperation(pHash, fCallback)
	{
		this.apiCall('DELETE', `/Operation/${encodeURIComponent(pHash)}`, null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	executeOperation(pHash, pRunMode, fCallback)
	{
		if (typeof pRunMode === 'function')
		{
			fCallback = pRunMode;
			pRunMode = null;
		}

		let tmpRunMode = pRunMode || (this.pict.AppData.Ultravisor.DebugMode ? 'debug' : 'standard');
		let tmpURL = `/Operation/${encodeURIComponent(pHash)}/Execute?RunMode=${encodeURIComponent(tmpRunMode)}`;

		this.apiCall('GET', tmpURL, null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	executeOperationAsync(pHash, pRunMode, fCallback)
	{
		if (typeof pRunMode === 'function')
		{
			fCallback = pRunMode;
			pRunMode = null;
		}

		let tmpRunMode = pRunMode || (this.pict.AppData.Ultravisor.DebugMode ? 'debug' : 'standard');

		this.apiCall('POST',
			`/Operation/${encodeURIComponent(pHash)}/Execute/Async`,
			{ RunMode: tmpRunMode },
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Schedule ---
	loadSchedule(fCallback)
	{
		this.apiCall('GET', '/Schedule', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.Schedule = Array.isArray(pData) ? pData : [];
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	scheduleOperation(pHash, pScheduleType, pParameters, fCallback)
	{
		this.apiCall('POST', '/Schedule/Operation',
			{ Hash: pHash, ScheduleType: pScheduleType, Parameters: pParameters },
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	removeScheduleEntry(pGUID, fCallback)
	{
		this.apiCall('DELETE', `/Schedule/${encodeURIComponent(pGUID)}`, null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	startSchedule(fCallback)
	{
		this.apiCall('GET', '/Schedule/Start', null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	stopSchedule(fCallback)
	{
		this.apiCall('GET', '/Schedule/Stop', null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	startScheduleEntry(pGUID, fCallback)
	{
		this.apiCall('GET', `/Schedule/Start/${encodeURIComponent(pGUID)}`, null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	stopScheduleEntry(pGUID, fCallback)
	{
		this.apiCall('GET', `/Schedule/Stop/${encodeURIComponent(pGUID)}`, null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Manifests ---
	loadManifests(fCallback)
	{
		this.apiCall('GET', '/Manifest', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.Manifests = Array.isArray(pData) ? pData : [];
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	loadManifest(pRunHash, fCallback)
	{
		this.apiCall('GET', `/Manifest/${encodeURIComponent(pRunHash)}`, null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Pending Inputs ---
	loadPendingInputs(fCallback)
	{
		this.apiCall('GET', '/PendingInput', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.PendingInputs = Array.isArray(pData) ? pData : [];
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	submitPendingInput(pRunHash, pNodeHash, pValue, fCallback)
	{
		this.apiCall('POST', `/PendingInput/${encodeURIComponent(pRunHash)}`,
			{ NodeHash: pNodeHash, Value: pValue },
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	forceErrorPendingInput(pRunHash, pNodeHash, fCallback)
	{
		this.apiCall('POST', `/PendingInput/${encodeURIComponent(pRunHash)}/ForceError`,
			{ NodeHash: pNodeHash },
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Abandon ---
	abandonRun(pRunHash, fCallback)
	{
		this.apiCall('POST', `/Manifest/${encodeURIComponent(pRunHash)}/Abandon`, {},
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	abandonStaleRuns(fCallback)
	{
		this.apiCall('POST', '/Manifest/AbandonStale', {},
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Retry ---
	// Retries a Stalled or Failed run from its last failed/stalled node.
	// All upstream node outputs are preserved; only the failed node and
	// its downstream branch re-run.
	retryRun(pRunHash, fCallback)
	{
		this.apiCall('POST', `/Operation/${encodeURIComponent(pRunHash)}/Retry`, {},
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Beacons ---
	loadBeacons(fCallback)
	{
		this.apiCall('GET', '/Beacon', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.Beacons = Array.isArray(pData) ? pData : [];
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	loadBeacon(pBeaconID, fCallback)
	{
		this.apiCall('GET', `/Beacon/${encodeURIComponent(pBeaconID)}`, null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	deregisterBeacon(pBeaconID, fCallback)
	{
		this.apiCall('DELETE', `/Beacon/${encodeURIComponent(pBeaconID)}`, null,
			function (pError, pData)
			{
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	loadWorkItems(fCallback)
	{
		this.apiCall('GET', '/Beacon/Work', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.WorkItems = Array.isArray(pData) ? pData : [];
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	loadBeaconCapabilities(fCallback)
	{
		this.apiCall('GET', '/Beacon/Capabilities', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.BeaconCapabilities = pData || {};
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	loadAffinityBindings(fCallback)
	{
		this.apiCall('GET', '/Beacon/Affinity', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.AffinityBindings = Array.isArray(pData) ? pData : [];
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// Accepts both shapes: legacy bare-array (Matrix only) and the
	// envelope { Matrix, Beacons, Hub } added in UV 1.0.34.
	_storeReachabilityResponse(pData)
	{
		if (Array.isArray(pData))
		{
			this.pict.AppData.Ultravisor.ReachabilityMatrix = pData;
			this.pict.AppData.Ultravisor.ReachabilityBeacons = [];
			this.pict.AppData.Ultravisor.ReachabilityHub = null;
			return;
		}
		if (pData && typeof pData === 'object')
		{
			this.pict.AppData.Ultravisor.ReachabilityMatrix = Array.isArray(pData.Matrix) ? pData.Matrix : [];
			this.pict.AppData.Ultravisor.ReachabilityBeacons = Array.isArray(pData.Beacons) ? pData.Beacons : [];
			this.pict.AppData.Ultravisor.ReachabilityHub = pData.Hub || null;
			return;
		}
		this.pict.AppData.Ultravisor.ReachabilityMatrix = [];
		this.pict.AppData.Ultravisor.ReachabilityBeacons = [];
		this.pict.AppData.Ultravisor.ReachabilityHub = null;
	}

	loadReachabilityMatrix(fCallback)
	{
		this.apiCall('GET', '/Beacon/Reachability', null,
			function (pError, pData)
			{
				if (!pError) { this._storeReachabilityResponse(pData); }
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	probeReachability(fCallback)
	{
		this.apiCall('POST', '/Beacon/Reachability/Probe', null,
			function (pError, pData)
			{
				if (!pError) { this._storeReachabilityResponse(pData); }
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	// --- Operation Library ---
	loadOperationLibrary(fCallback)
	{
		this.apiCall('GET', '/OperationLibrary', null,
			function (pError, pData)
			{
				if (!pError && pData)
				{
					this.pict.AppData.Ultravisor.OperationLibrary = Array.isArray(pData) ? pData : [];
				}
				if (typeof fCallback === 'function')
				{
					fCallback(pError, pData);
				}
			}.bind(this));
	}

	importLibraryOperation(pFileName, fCallback)
	{
		this.apiCall('GET', `/OperationLibrary/${encodeURIComponent(pFileName)}`, null,
			function (pError, pData)
			{
				if (pError)
				{
					if (typeof fCallback === 'function')
					{
						fCallback(pError);
					}
					return;
				}

				// Strip library metadata, keep operation-relevant fields
				let tmpOperationData =
				{
					Name: pData.Name || '',
					Description: pData.Description || '',
					Graph: pData.Graph || { Nodes: [], Connections: [], ViewState: {} }
				};

				if (pData.SavedLayouts)
				{
					tmpOperationData.SavedLayouts = pData.SavedLayouts;
				}
				if (pData.InitialGlobalState)
				{
					tmpOperationData.InitialGlobalState = pData.InitialGlobalState;
				}
				if (pData.InitialOperationState)
				{
					tmpOperationData.InitialOperationState = pData.InitialOperationState;
				}

				// Save as a new operation (no Hash => auto-generated)
				this.saveOperation(tmpOperationData, fCallback);
			}.bind(this));
	}

	importOperationFromJSON(pOperationJSON, fCallback)
	{
		if (typeof (pOperationJSON) !== 'object' || pOperationJSON === null)
		{
			if (typeof fCallback === 'function')
			{
				fCallback(new Error('Invalid operation JSON.'));
			}
			return;
		}

		// Strip identifiers so a fresh hash is auto-generated on import
		let tmpOperationData =
		{
			Name: pOperationJSON.Name || 'Imported Operation',
			Description: pOperationJSON.Description || '',
			Graph: pOperationJSON.Graph || { Nodes: [], Connections: [], ViewState: {} }
		};

		if (pOperationJSON.SavedLayouts)
		{
			tmpOperationData.SavedLayouts = pOperationJSON.SavedLayouts;
		}
		if (pOperationJSON.InitialGlobalState)
		{
			tmpOperationData.InitialGlobalState = pOperationJSON.InitialGlobalState;
		}
		if (pOperationJSON.InitialOperationState)
		{
			tmpOperationData.InitialOperationState = pOperationJSON.InitialOperationState;
		}

		// Save as a new operation (no Hash => auto-generated)
		this.saveOperation(tmpOperationData, fCallback);
	}

	exportOperation(pHash, fCallback)
	{
		this.apiCall('GET', `/Operation/${encodeURIComponent(pHash)}/Export`, null,
			function (pError, pData)
			{
				if (pError)
				{
					if (typeof fCallback === 'function')
					{
						fCallback(pError);
					}
					return;
				}

				// Trigger a browser download of the JSON
				let tmpFileName = (pData.Name || pData.Hash || 'operation').replace(/[^a-zA-Z0-9_-]/g, '_') + '.json';
				let tmpBlob = new Blob([JSON.stringify(pData, null, '\t')], { type: 'application/json' });
				let tmpLink = document.createElement('a');
				tmpLink.href = URL.createObjectURL(tmpBlob);
				tmpLink.download = tmpFileName;
				tmpLink.click();
				URL.revokeObjectURL(tmpLink.href);

				if (typeof fCallback === 'function')
				{
					fCallback(null, pData);
				}
			}.bind(this));
	}

	// --- Edit helpers ---

	/**
	 * Populate CurrentEditOperation and Flows.Current from a loaded operation.
	 * Does not navigate — caller decides whether to navigate or render directly.
	 */
	_setCurrentEditOperation(pHash)
	{
		if (pHash && this.pict.AppData.Ultravisor.Operations[pHash])
		{
			let tmpOp = JSON.parse(JSON.stringify(this.pict.AppData.Ultravisor.Operations[pHash]));
			this.pict.AppData.Ultravisor.CurrentEditOperation = tmpOp;

			// Load the operation's graph into the FlowEditor data
			if (tmpOp.Graph)
			{
				this.pict.AppData.Ultravisor.Flows.Current = JSON.parse(JSON.stringify(tmpOp.Graph));
			}
		}
		else
		{
			this.pict.AppData.Ultravisor.CurrentEditOperation =
			{
				Hash: '',
				Name: '',
				Description: '',
				Graph: { Nodes: [], Connections: [], ViewState: {} }
			};
			this.pict.AppData.Ultravisor.Flows.Current =
			{
				Nodes: [],
				Connections: [],
				ViewState: { PanX: 0, PanY: 0, Zoom: 1, SelectedNodeHash: null, SelectedConnectionHash: null }
			};
		}
	}

	/**
	 * Show the Manifest Detail view for a specific run hash.
	 * Called from the /Manifests/detail/:runHash route.
	 */
	showManifestDetail(pRunHash)
	{
		if (this.isLoginRequired()) { return this.showView('Ultravisor-Login'); }
		if (this.pict.views['Ultravisor-ManifestDetail'])
		{
			this.pict.views['Ultravisor-ManifestDetail'].setRunHash(decodeURIComponent(pRunHash));
			this.pict.views['Ultravisor-ManifestDetail'].render();
		}
	}

	/**
	 * Show the Manifest List with a pre-set status filter.
	 * Called from the /Manifests/:filter and /PendingInput routes.
	 */
	showManifestsFiltered(pFilter)
	{
		if (this.isLoginRequired()) { return this.showView('Ultravisor-Login'); }
		if (this.pict.views['Ultravisor-ManifestList'])
		{
			this.pict.views['Ultravisor-ManifestList'].setFilterFromRoute(pFilter || 'all');
			this.pict.views['Ultravisor-ManifestList'].render();
		}
	}

	/**
	 * Watch a running execution in the flow editor.
	 * Loads the operation, navigates to the FlowEditor, and starts
	 * monitoring the given RunHash without starting a new execution.
	 */
	watchExecution(pRunHash, pOperationHash)
	{
		if (!pRunHash || !pOperationHash)
		{
			return;
		}

		let tmpSelf = this;

		// Ensure operations and task types are loaded
		let tmpNeedOperations = (this.pict.AppData.Ultravisor.OperationList.length < 1);
		let tmpNeedTaskTypes = (this.pict.AppData.Ultravisor.TaskTypes.length < 1);

		let tmpPending = 0;

		function onReady()
		{
			tmpPending--;
			if (tmpPending > 0) return;

			tmpSelf._setCurrentEditOperation(pOperationHash);
			tmpSelf.pict.views['Ultravisor-FlowEditor'].render();

			// After render, attach to the running execution
			setTimeout(function ()
			{
				tmpSelf.pict.views['Ultravisor-FlowEditor'].watchExecution(pRunHash);
			}, 100);
		}

		if (tmpNeedOperations)
		{
			tmpPending++;
			this.loadOperations(function () { onReady(); });
		}
		if (tmpNeedTaskTypes)
		{
			tmpPending++;
			this.loadTaskTypes(function () { onReady(); });
		}

		if (!tmpNeedOperations && !tmpNeedTaskTypes)
		{
			tmpPending = 1;
			onReady();
		}
	}

	/**
	 * Called from the Operations list UI to edit an operation.  Navigates to the
	 * parameterized FlowEditor route so the URL reflects the operation hash.
	 */
	editOperation(pHash)
	{
		this._setCurrentEditOperation(pHash);

		if (pHash)
		{
			this.navigateTo(`/FlowEditor/${encodeURIComponent(pHash)}`);
		}
		else
		{
			this.navigateTo('/FlowEditor');
		}
	}

	/**
	 * Route handler for `/FlowEditor/:hash`.  On a cold page load both the
	 * Operations map and TaskTypes may be empty, so we load them first.
	 * TaskTypes must be available before the FlowEditor renders so that
	 * _buildFlowCardNodeTypes() can generate card configs with all ports.
	 */
	editOperationFromRoute(pHash)
	{
		if (this.isLoginRequired()) { return this.showView('Ultravisor-Login'); }
		let tmpHash = decodeURIComponent(pHash);

		let tmpNeedOperations = (this.pict.AppData.Ultravisor.OperationList.length < 1);
		let tmpNeedTaskTypes = (this.pict.AppData.Ultravisor.TaskTypes.length < 1);

		// Hot navigation — everything already loaded
		if (!tmpNeedOperations && !tmpNeedTaskTypes)
		{
			this._setCurrentEditOperation(tmpHash);
			this.pict.views['Ultravisor-FlowEditor'].render();
			return;
		}

		// Cold reload — load whatever is missing, then render
		let tmpPending = 0;
		let tmpSelf = this;

		function onLoaded()
		{
			tmpPending--;
			if (tmpPending > 0)
			{
				return;
			}
			tmpSelf._setCurrentEditOperation(tmpHash);
			tmpSelf.pict.views['Ultravisor-FlowEditor'].render();
		}

		if (tmpNeedOperations)
		{
			tmpPending++;
			this.loadOperations(
				function (pError)
				{
					if (pError)
					{
						this.pict.log.warn(`Failed to load operations for route /FlowEditor/${tmpHash}`);
					}
					onLoaded();
				}.bind(this));
		}

		if (tmpNeedTaskTypes)
		{
			tmpPending++;
			this.loadTaskTypes(
				function (pError)
				{
					if (pError)
					{
						this.pict.log.warn('Failed to load task types for FlowEditor route.');
					}
					onLoaded();
				}.bind(this));
		}
	}
}

module.exports = UltravisorApplication;

module.exports.default_configuration = require('./Pict-Application-Ultravisor-Configuration.json');

},{"./Pict-Application-Ultravisor-Configuration.json":241,"./Ultravisor-Brand.js":243,"./panels/Ultravisor-CardSettingsPanel.js":251,"./providers/PictRouter-Ultravisor-Configuration.json":252,"./providers/Provider-Timeline-Stream.js":253,"./views/PictView-Ultravisor-BeaconList.js":254,"./views/PictView-Ultravisor-BottomBar.js":255,"./views/PictView-Ultravisor-CapabilityHeatMap.js":256,"./views/PictView-Ultravisor-Constellation.js":257,"./views/PictView-Ultravisor-Dashboard.js":258,"./views/PictView-Ultravisor-Documentation.js":259,"./views/PictView-Ultravisor-Fleet.js":260,"./views/PictView-Ultravisor-FlowEditor.js":261,"./views/PictView-Ultravisor-Layout.js":262,"./views/PictView-Ultravisor-Login.js":263,"./views/PictView-Ultravisor-ManifestDetail.js":264,"./views/PictView-Ultravisor-ManifestList.js":265,"./views/PictView-Ultravisor-OperationDescriptionEditor.js":266,"./views/PictView-Ultravisor-OperationEdit.js":267,"./views/PictView-Ultravisor-OperationList.js":268,"./views/PictView-Ultravisor-PendingInput.js":269,"./views/PictView-Ultravisor-ReachabilityMap.js":270,"./views/PictView-Ultravisor-Schedule.js":271,"./views/PictView-Ultravisor-SettingsPanel.js":272,"./views/PictView-Ultravisor-Sidebar.js":273,"./views/PictView-Ultravisor-Throughput.js":274,"./views/PictView-Ultravisor-Timeline.js":275,"./views/PictView-Ultravisor-TimingView.js":276,"./views/PictView-Ultravisor-TopBar-Nav.js":277,"./views/PictView-Ultravisor-TopBar-User.js":278,"./views/PictView-Ultravisor-UserManagement.js":279,"pict-application":7,"pict-router":20,"pict-section-content":25,"pict-section-form":64,"pict-section-login":132,"pict-section-modal":153,"pict-section-theme":164,"pict-section-usermanagement":230}],243:[function(require,module,exports){
/**
 * Ultravisor-Brand — the application's wordmark / signature.
 *
 * Passed to pict-section-theme as the `Brand` block on the Theme-Section
 * provider. Drives:
 *   - The Theme-Brand-Mark view in the topbar (icon + name)
 *   - --brand-color-* CSS variables that themes / app CSS reference
 *   - The Favicon / FaviconDark SVGs available via libThemeBrand
 *
 * The brand is precomputed at build time. Source of truth lives in
 * `Retold-Modules-Manifest.json` under this module's `Branding.Palette`
 * field; the `pict-section-theme-brand` CLI generates the deterministic
 * logo + colors and writes them into our `package.json` under
 * `retold.brand`. This file then just hands that block to Theme-Section.
 *
 * To change the look:
 *
 *   1. Edit the Branding block in Retold-Modules-Manifest.json (palette,
 *      DisplayName, Tagline).
 *   2. Run `npm run brand` to regenerate package.json + favicon files.
 *   3. Run `npm run build` to rebuild the bundle.
 *
 * Curated palette keys: mix, default, desert, ocean, forest, synthwave,
 * twilight, cosmos, carnival.
 */

// Path: source/ → up 1 to webinterface/.
const tmpPackage = require('../package.json');

if (!tmpPackage.retold || !tmpPackage.retold.brand)
{
	throw new Error('ultravisor-webinterface: package.json is missing retold.brand — '
		+ 'run `npm run brand` (which calls pict-section-theme-brand) before building');
}

module.exports = tmpPackage.retold.brand;

},{"../package.json":240}],244:[function(require,module,exports){
/**
 * Ultravisor Timing Utilities
 *
 * Shared constants and helper functions for timing visualization,
 * used by both TimingView and ManifestList views.
 */

// ── Category color palette for timing bar charts ──────────────────────
const CategoryColors =
{
	'Core': { bar: 'linear-gradient(90deg, #5c6bc0, #7986cb)', text: '#9fa8da' },
	'File I/O': { bar: 'linear-gradient(90deg, #00897b, #26a69a)', text: '#80cbc4' },
	'Control': { bar: 'linear-gradient(90deg, #f9a825, #fdd835)', text: '#fff59d' },
	'REST': { bar: 'linear-gradient(90deg, #e65100, #ff6d00)', text: '#ffab91' },
	'Meadow': { bar: 'linear-gradient(90deg, #6a1b9a, #8e24aa)', text: '#ce93d8' },
	'Pipeline': { bar: 'linear-gradient(90deg, #00838f, #0097a7)', text: '#80deea' },
	'Data': { bar: 'linear-gradient(90deg, #4e342e, #6d4c41)', text: '#bcaaa4' },
	'Interaction': { bar: 'linear-gradient(90deg, #1565c0, #1e88e5)', text: '#90caf9' },
	'Uncategorized': { bar: 'linear-gradient(90deg, #37474f, #546e7a)', text: '#90a4ae' }
};

/**
 * Format milliseconds into a human-readable duration string.
 *
 * @param {number} pMs - Duration in milliseconds
 * @returns {string} Formatted duration (e.g. "42ms", "3s 210ms", "2m 15s")
 */
function formatMs(pMs)
{
	if (typeof pMs !== 'number' || pMs <= 0)
	{
		return '0ms';
	}
	if (pMs < 1000)
	{
		return Math.round(pMs) + 'ms';
	}
	if (pMs < 60000)
	{
		let tmpSeconds = Math.floor(pMs / 1000);
		let tmpMs = Math.round(pMs % 1000);
		return tmpSeconds + 's ' + tmpMs + 'ms';
	}
	let tmpMinutes = Math.floor(pMs / 60000);
	let tmpSeconds = Math.floor((pMs % 60000) / 1000);
	return tmpMinutes + 'm ' + tmpSeconds + 's';
}

/**
 * Compute total ElapsedMs for a TaskManifest entry by summing its Executions.
 *
 * @param {object} pTaskManifest - A task manifest entry with Executions array
 * @returns {number} Total elapsed time in milliseconds
 */
function computeTaskElapsedMs(pTaskManifest)
{
	let tmpTotal = 0;

	if (pTaskManifest.Executions && pTaskManifest.Executions.length > 0)
	{
		for (let i = 0; i < pTaskManifest.Executions.length; i++)
		{
			tmpTotal += (pTaskManifest.Executions[i].ElapsedMs || 0);
		}
	}

	return tmpTotal;
}

/**
 * Determine the overall status for a task from its Executions array.
 *
 * @param {object} pTaskManifest - A task manifest entry with Executions array
 * @returns {string} Status string (e.g. "Complete", "Error", "Running", "Unknown")
 */
function computeTaskStatus(pTaskManifest)
{
	if (!pTaskManifest.Executions || pTaskManifest.Executions.length === 0)
	{
		return 'Unknown';
	}

	let tmpLastExec = pTaskManifest.Executions[pTaskManifest.Executions.length - 1];
	return tmpLastExec.Status || 'Unknown';
}

/**
 * Escape HTML special characters for safe insertion into markup.
 *
 * @param {*} pValue - Value to escape
 * @returns {string} Escaped string
 */
function escapeHTML(pValue)
{
	if (!pValue) return '';
	return String(pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

module.exports = { CategoryColors, formatMs, computeTaskElapsedMs, computeTaskStatus, escapeHTML };

},{}],245:[function(require,module,exports){
// Auto-generated by scripts/generate-card-help.js — do not edit manually.
// Source markdown files are in docs/card-help/
module.exports = {
	"beacon-dispatch": "<h1>Beacon Dispatch</h1><p>Dispatches a work item to a remote Beacon worker node. The task pauses until the Beacon completes execution and reports results back.</p><h2>Settings</h2><ul><li><b>RemoteCapability</b> — Required capability on the Beacon (e.g. <code>Shell</code>, <code>FileSystem</code>, <code>LLM</code>).</li><li><b>RemoteAction</b> — Specific action within the capability (e.g. <code>Execute</code>, <code>Read</code>).</li><li><b>Command</b> — Shell command to execute on the Beacon (when using Shell capability).</li><li><b>Parameters</b> — Command-line parameters for the shell command.</li><li><b>AffinityKey</b> — Worker affinity routing key. Requests with the same key are routed to the same Beacon.</li><li><b>TimeoutMs</b> — Work item timeout in milliseconds (default <code>300000</code>).</li><li><b>InputData</b> — JSON data to pass to the Beacon worker.</li><li><b>Destination</b> — State address to write results to on completion.</li></ul><h2>Outputs</h2><ul><li><b>StdOut</b> — Standard output from the Beacon execution.</li><li><b>Result</b> — Result data from the Beacon.</li><li><b>ExitCode</b> — Exit code of the remote command.</li><li><b>BeaconID</b> — ID of the Beacon that executed the work.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires when the Beacon finishes.</li><li><b>Error</b> — Fires on failure or timeout.</li></ul><h2>Tips</h2><p>Beacon Dispatch is the low-level card for sending arbitrary work to remote workers. Use AffinityKey to ensure related work items run on the same Beacon instance. For common patterns, prefer the specialized cards (LLM Chat Completion, Content Read File, etc.) which use Beacon Dispatch internally with appropriate defaults.</p>",
	"command": "<h1>Command</h1><p>Executes a shell command on the server and captures its output.</p><h2>Settings</h2><ul><li><b>Command</b> — The shell command to execute (e.g. <code>ls</code>, <code>git</code>, <code>python3</code>).</li><li><b>Parameters</b> — Command-line arguments as a single string.</li><li><b>Description</b> — Human-readable description of what this command does (for documentation only).</li><li><b>WorkingDirectory</b> — Working directory for the command.</li><li><b>TimeoutMs</b> — Command timeout in milliseconds (default <code>300000</code> — 5 minutes).</li><li><b>Environment</b> — JSON object of environment variables to set for the command.</li></ul><h2>Outputs</h2><ul><li><b>StdOut</b> — Standard output from the command.</li><li><b>StdErr</b> — Standard error output from the command.</li><li><b>ExitCode</b> — Exit code (0 typically indicates success).</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires when the command finishes.</li><li><b>Error</b> — Fires if the command fails to start or times out.</li></ul><h2>Tips</h2><p>Use an <b>If Conditional</b> on ExitCode to handle success vs failure. Both Command and Parameters support Pict template expressions, so you can build dynamic commands from state values. Set Environment to inject secrets or configuration without hardcoding them.</p>",
	"comprehension-intersect": "<h1>Comprehension Intersect</h1><p>Intersects two arrays by matching records on a common field, similar to an SQL inner join.</p><h2>Settings</h2><ul><li><b>SourceAddressA</b> — State address of the first array.</li><li><b>SourceAddressB</b> — State address of the second array.</li><li><b>MatchField</b> — Field name to match records on. Records from both arrays with the same value in this field are merged.</li><li><b>Destination</b> — State address to store the intersected results.</li><li><b>JoinType</b> — Join type (default <code>inner</code>). Inner join returns only records that match in both arrays.</li></ul><h2>Outputs</h2><ul><li><b>Result</b> — Array of merged record objects.</li><li><b>MatchCount</b> — Number of matched records.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after intersection.</li></ul><h2>Tips</h2><p>Use Comprehension Intersect to combine data from two different sources — for example, joining a list of user IDs from one API with user details from another. The matched records are merged into single objects containing fields from both sources.</p>",
	"content-create-folder": "<h1>Content Create Folder</h1><p>Creates a folder in the content directory on a remote Content System beacon.</p><h2>Settings</h2><ul><li><b>Path</b> — Relative folder path to create.</li><li><b>AffinityKey</b> — Worker affinity key to route to a specific beacon.</li><li><b>TimeoutMs</b> — Timeout in milliseconds (default <code>300000</code>).</li></ul><h2>Outputs</h2><ul><li><b>StdOut</b> — Status message from the beacon.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after the folder is created.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>Tips</h2><p>Use Content Create Folder before <b>Content Save File</b> to ensure the target directory structure exists. The operation is idempotent — creating a folder that already exists succeeds without error.</p>",
	"content-list-files": "<h1>Content List Files</h1><p>Lists files in a directory on a remote Content System beacon.</p><h2>Settings</h2><ul><li><b>Path</b> — Relative directory path within the content directory. Leave empty for the root.</li><li><b>Pattern</b> — Glob pattern filter (e.g. <code><i>.md</code>, <code></i>.json</code>).</li><li><b>Recursive</b> — When <code>true</code>, lists files in subdirectories.</li><li><b>AffinityKey</b> — Worker affinity key to route to a specific beacon.</li><li><b>TimeoutMs</b> — Timeout in milliseconds (default <code>300000</code>).</li></ul><h2>Outputs</h2><ul><li><b>Files</b> — JSON array of file entries.</li><li><b>StdOut</b> — Status message from the beacon.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after listing.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>Tips</h2><p>Use Content List Files to discover available content on a beacon before processing. Combine with <b>Split Execute</b> to iterate over the file list and read or transform each file.</p>",
	"content-read-file": "<h1>Content Read File</h1><p>Reads a markdown or content file from a remote Content System beacon.</p><h2>Settings</h2><ul><li><b>FilePath</b> — Relative path within the content directory on the beacon.</li><li><b>Destination</b> — State address to store the file content.</li><li><b>AffinityKey</b> — Worker affinity key to route to a specific beacon.</li><li><b>TimeoutMs</b> — Timeout in milliseconds (default <code>300000</code>).</li></ul><h2>Outputs</h2><ul><li><b>Content</b> — The file content as a string.</li><li><b>StdOut</b> — Status message from the beacon.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after a successful read.</li><li><b>Error</b> — Fires if the file is not found or the beacon is unreachable.</li></ul><h2>Tips</h2><p>Content System cards operate on remote Beacon workers, not the local file system. Use AffinityKey to ensure reads and writes go to the same beacon instance. For local file operations, use <b>Read File</b> instead.</p>",
	"content-save-file": "<h1>Content Save File</h1><p>Saves content to a file on a remote Content System beacon.</p><h2>Settings</h2><ul><li><b>FilePath</b> — Relative path within the content directory.</li><li><b>Content</b> — The file content to write. Supports Pict template expressions.</li><li><b>AffinityKey</b> — Worker affinity key to route to a specific beacon.</li><li><b>TimeoutMs</b> — Timeout in milliseconds (default <code>300000</code>).</li></ul><h2>Outputs</h2><ul><li><b>FilePath</b> — Path of the saved file.</li><li><b>StdOut</b> — Status message from the beacon.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after a successful save.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>Tips</h2><p>Use Content Save File to publish generated content (reports, processed data, rendered templates) to a Content System. Pair with <b>Content Read File</b> to read-modify-write content files on a beacon.</p>",
	"copy-file": "<h1>Copy File</h1><p>Copies a file from a source path to a target path.</p><h2>Settings</h2><ul><li><b>Source</b> — Source file path.</li><li><b>TargetFile</b> — Destination file path.</li><li><b>Overwrite</b> — Allow overwriting an existing target file (default <code>true</code>).</li></ul><h2>Outputs</h2><ul><li><b>FileLocation</b> — The target path as specified.</li><li><b>FileName</b> — The target file name only.</li><li><b>FilePath</b> — The fully resolved absolute target path.</li><li><b>BytesCopied</b> — Size of the copied file in bytes.</li></ul><h2>Events</h2><ul><li><b>Done</b> — Fires on successful copy.</li><li><b>Error</b> — Fires if the source is missing or the target cannot be written.</li></ul><h2>Tips</h2><p>Set Overwrite to <code>false</code> to protect existing files from accidental replacement. Both Source and TargetFile support Pict template expressions for dynamic paths.</p>",
	"csv-transform": "<h1>CSV Transform</h1><p>Transforms an array of parsed CSV records by applying field mappings, filters, and output field selection.</p><h2>Settings</h2><ul><li><b>SourceAddress</b> — State address of the records array to transform.</li><li><b>Destination</b> — State address to store the transformed records.</li><li><b>Delimiter</b> — Delimiter for re-serialization (default <code>,</code>).</li><li><b>FieldMapping</b> — JSON array of mapping objects with <code>From</code>, <code>To</code>, and optional <code>Template</code> properties for field renaming and transformation.</li><li><b>FilterExpression</b> — An expression to filter rows. Only rows where the expression evaluates to true are included.</li><li><b>OutputFields</b> — JSON array of field names to include in the output. Omit to include all fields.</li></ul><h2>Outputs</h2><ul><li><b>Records</b> — The transformed records array.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after transformation.</li></ul><h2>Tips</h2><p>Use FieldMapping to rename columns, compute derived fields with templates, or restructure data. Combine with FilterExpression to extract subsets of records in a single step.</p>",
	"end": "<h1>End</h1><p>Termination point for the workflow. When execution reaches the End card, the operation completes.</p><h2>Events</h2><ul><li><b>In</b> — Receives the final event from the flow. Accepts up to 5 incoming connections.</li></ul><h2>Tips</h2><p>A flow can have multiple End cards to handle different completion paths (e.g. success vs error). The End card signals that execution is complete and the operation's results are ready. Place End cards at the right side of your flow diagram.</p>",
	"error-message": "<h1>Error Message</h1><p>Logs an error, warning, info, or debug message to the execution log. Use this card to emit diagnostic information during flow execution without halting the workflow.</p><h2>Settings</h2><ul><li><b>MessageTemplate</b> — The message text to log. Supports Pict template expressions for including state values (default: \"An error occurred.\").</li><li><b>Level</b> — Log level: <code>error</code>, <code>warning</code>, <code>info</code>, or <code>debug</code> (default <code>error</code>).</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after the message is logged. Execution continues normally.</li></ul><h2>Tips</h2><p>Error Message does not stop the flow — it only records a log entry. Place it on error branches to capture diagnostic context when failures occur. Use the <code>info</code> level for progress markers and <code>debug</code> for development-time tracing.</p>",
	"expression-solver": "<h1>Expression Solver</h1><p>Evaluates a mathematical or logical expression using the Fable ExpressionParser and stores the result in state.</p><h2>Settings</h2><ul><li><b>Expression</b> — The expression to evaluate. Can reference state values by address.</li><li><b>Destination</b> — State address to store the evaluation result.</li></ul><h2>Outputs</h2><ul><li><b>Result</b> — The computed result as a string.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after evaluation.</li><li><b>Error</b> — Fires on parse or evaluation failure.</li></ul><h2>Tips</h2><p>Use Expression Solver for arithmetic calculations, string length checks, or combining multiple state values into a computed result. The expression language supports standard math operators, comparisons, and common functions.</p>",
	"get-json": "<h1>Get JSON</h1><p>Performs an HTTP GET request and parses the response body as JSON.</p><h2>Settings</h2><ul><li><b>URL</b> — The URL to request. Supports Pict template expressions for dynamic URLs.</li><li><b>Headers</b> — JSON string of additional request headers (e.g. <code>{\"Authorization\": \"Bearer ...\"}</code>).</li><li><b>Destination</b> — State address to store the parsed response data.</li><li><b>TimeoutMs</b> — Request timeout in milliseconds (default <code>30000</code>).</li></ul><h2>Outputs</h2><ul><li><b>Data</b> — The parsed JSON response object.</li><li><b>StatusCode</b> — HTTP response status code.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires on a successful response.</li><li><b>Error</b> — Fires on network failure, timeout, or non-2xx status.</li></ul><h2>Tips</h2><p>For APIs requiring authentication, use <b>Set Values</b> to build the Headers JSON from stored credentials before connecting to the Headers setting input. Use the StatusCode output with an <b>If Conditional</b> to handle different HTTP response codes.</p>",
	"get-text": "<h1>Get Text</h1><p>Performs an HTTP GET request and returns the response body as plain text.</p><h2>Settings</h2><ul><li><b>URL</b> — The URL to request.</li><li><b>Destination</b> — State address to store the response text.</li><li><b>Headers</b> — JSON string of additional request headers.</li><li><b>TimeoutMs</b> — Request timeout in milliseconds (default <code>30000</code>).</li></ul><h2>Outputs</h2><ul><li><b>Data</b> — The response body as a string.</li><li><b>StatusCode</b> — HTTP response status code.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires on a successful response.</li><li><b>Error</b> — Fires on network failure or timeout.</li></ul><h2>Tips</h2><p>Use Get Text for non-JSON responses: HTML pages, CSV downloads, plain text APIs, or XML feeds. Pipe the output into <b>Parse CSV</b> for CSV data or <b>Replace String</b> for text processing.</p>",
	"histogram": "<h1>Histogram</h1><p>Computes a frequency distribution over a specific field in a dataset array.</p><h2>Settings</h2><ul><li><b>SourceAddress</b> — State address of the data array to analyze.</li><li><b>Field</b> — Field name to compute frequencies for (default <code>score</code>).</li><li><b>Bins</b> — Number of bins for numeric data (default <code>5</code>).</li><li><b>Destination</b> — State address to store the statistics object.</li><li><b>SortBy</b> — Sort frequency results by <code>count</code> or <code>key</code>.</li></ul><h2>Outputs</h2><ul><li><b>Stats</b> — An object containing the frequency distribution, bin boundaries, and summary statistics.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after computation.</li></ul><h2>Tips</h2><p>Use Histogram after parsing or loading a dataset to get a quick statistical overview. Combine with <b>Template String</b> to generate a text-based report of the distribution.</p>",
	"if-conditional": "<h1>If Conditional</h1><p>Evaluates a condition and branches execution to the True or False output. This is the primary decision-making card in a flow.</p><h2>Settings</h2><ul><li><b>DataAddress</b> — State address of the value to test.</li><li><b>CompareValue</b> — Value to compare against.</li><li><b>Operator</b> — Comparison operator: <code>==</code>, <code>!=</code>, <code>></code>, <code><</code>, <code>>=</code>, <code><=</code>, <code>contains</code>, <code>startsWith</code>, <code>endsWith</code>. Default <code>==</code>.</li><li><b>Expression</b> — A full expression string. When set, DataAddress/CompareValue/Operator are ignored and the expression is evaluated directly.</li></ul><h2>Outputs</h2><ul><li><b>Result</b> — Boolean result of the evaluation.</li></ul><h2>Events</h2><ul><li><b>True</b> — Fires when the condition is true.</li><li><b>False</b> — Fires when the condition is false.</li></ul><h2>Tips</h2><p>Use Expression for complex conditions that combine multiple state values. For simple equality checks, DataAddress + CompareValue + Operator is more readable. The False output is positioned at the bottom of the card for visual clarity in flow diagrams.</p>",
	"launch-operation": "<h1>Launch Operation</h1><p>Executes a child operation by its hash, with isolated operation state. This enables modular flow composition by calling one operation from within another.</p><h2>Settings</h2><ul><li><b>OperationHash</b> — The hash identifier of the operation to launch.</li><li><b>InputData</b> — JSON data to pass as input to the child operation.</li><li><b>TimeoutMs</b> — Maximum execution time in milliseconds. Set to <code>0</code> for unlimited.</li><li><b>InheritGlobalState</b> — When <code>true</code> (default), copies the parent's GlobalState into the child operation.</li></ul><h2>Outputs</h2><ul><li><b>Result</b> — The result data returned by the child operation.</li><li><b>Status</b> — Final status of the child operation.</li><li><b>ElapsedMs</b> — Execution time of the child operation in milliseconds.</li></ul><h2>Events</h2><ul><li><b>Completed</b> — Fires when the child operation finishes.</li><li><b>Error</b> — Fires if the child operation fails or times out.</li></ul><h2>Tips</h2><p>Use Launch Operation to break complex workflows into reusable sub-operations. The child operation runs with its own isolated state, so it cannot accidentally modify the parent's local state. Use InheritGlobalState to share configuration and credentials.</p>",
	"list-files": "<h1>List Files</h1><p>Lists files in a directory with optional glob pattern filtering.</p><h2>Settings</h2><ul><li><b>Folder</b> — Directory path to list.</li><li><b>Pattern</b> — Glob pattern filter (e.g. <code><i>.txt</code>, <code></i>.json</code>). Default <code>*</code> matches all files.</li><li><b>Destination</b> — State address to store the resulting file list.</li><li><b>Recursive</b> — When <code>true</code>, includes files in subdirectories.</li><li><b>IncludeDirectories</b> — When <code>true</code>, includes directory entries in the results.</li></ul><h2>Outputs</h2><ul><li><b>Files</b> — Array of file name strings matching the pattern.</li><li><b>FileCount</b> — Number of entries found.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after listing is complete.</li><li><b>Error</b> — Fires if the directory cannot be read.</li></ul><h2>Tips</h2><p>Use with <b>Split Execute</b> to iterate over the file list and process each file individually. Combine Recursive mode with a specific Pattern to find files deep in a directory tree.</p>",
	"llm-chat-completion": "<h1>LLM Chat Completion</h1><p>Sends messages to a large language model and returns the completion. Supports multi-turn conversation history with persistence across operation runs.</p><h2>Settings</h2><ul><li><b>SystemPrompt</b> — System prompt text that sets the LLM's behavior and context.</li><li><b>UserPrompt</b> — User prompt text for the current turn.</li><li><b>Messages</b> — JSON array of message objects <code>[{role, content}]</code> for direct control over the conversation. Overrides SystemPrompt/UserPrompt when set.</li><li><b>Model</b> — Override the default model name.</li><li><b>Temperature</b> — Sampling temperature (0–2). Lower values are more deterministic.</li><li><b>MaxTokens</b> — Maximum tokens to generate (default <code>4096</code>).</li><li><b>TopP</b> — Nucleus sampling parameter.</li><li><b>StopSequences</b> — JSON array of sequences that stop generation.</li><li><b>ResponseFormat</b> — Set to <code>json_object</code> to force JSON output.</li><li><b>InputAddress</b> — State address to read additional context data from (appended to UserPrompt).</li><li><b>Destination</b> — State address to write the completion text to.</li></ul><h2>Conversation History</h2><ul><li><b>ConversationAddress</b> — State address to store message history for multi-turn conversations.</li><li><b>AppendToConversation</b> — Append this exchange to history (default <code>true</code> when ConversationAddress is set).</li><li><b>ConversationMaxMessages</b> — Sliding window: maximum non-system messages to keep.</li><li><b>ConversationMaxTokens</b> — Token budget for history (approximate, trims oldest messages).</li><li><b>PersistConversation</b> — Copy conversation history to GlobalState for cross-operation persistence.</li><li><b>ConversationPersistAddress</b> — GlobalState address for persistence.</li></ul><h2>Dispatch</h2><ul><li><b>AffinityKey</b> — Route to a specific Beacon worker for consistent model access.</li><li><b>TimeoutMs</b> — Timeout in milliseconds (default <code>120000</code>).</li></ul><h2>Outputs</h2><ul><li><b>Content</b> — The LLM's response text.</li><li><b>Model</b> — Model that generated the response.</li><li><b>PromptTokens</b> / <b>CompletionTokens</b> / <b>TotalTokens</b> — Token usage statistics.</li><li><b>FinishReason</b> — Why the completion ended (<code>stop</code>, <code>length</code>, etc.).</li><li><b>BeaconID</b> — ID of the Beacon worker that executed the request.</li></ul><h2>Tips</h2><p>Use ConversationAddress with PersistConversation to build chatbots that maintain context across multiple operation runs. Set ResponseFormat to <code>json_object</code> when you need structured output that downstream cards can parse. Use Temperature <code>0</code> for deterministic, reproducible results.</p>",
	"llm-embedding": "<h1>LLM Embedding</h1><p>Generates vector embeddings for text input using an LLM provider. Dispatches the work to a Beacon with LLM capability.</p><h2>Settings</h2><ul><li><b>Text</b> — The text to embed. Supports Pict template expressions.</li><li><b>Model</b> — Override the default embedding model.</li><li><b>Dimensions</b> — Requested embedding dimensions (model-dependent).</li><li><b>InputAddress</b> — State address to read text from (alternative to Text setting).</li><li><b>Destination</b> — State address to write the embedding vector to.</li><li><b>AffinityKey</b> — Route to a specific Beacon worker.</li><li><b>TimeoutMs</b> — Timeout in milliseconds (default <code>60000</code>).</li></ul><h2>Outputs</h2><ul><li><b>Embedding</b> — JSON array of floating-point numbers representing the embedding vector.</li><li><b>Dimensions</b> — Number of dimensions in the embedding.</li><li><b>Model</b> — Model used for embedding.</li><li><b>BeaconID</b> — ID of the Beacon that executed the work.</li></ul><h2>Tips</h2><p>Use embeddings for semantic search, clustering, or similarity comparisons. Store embeddings in a database via <b>Meadow Create</b> for later retrieval. Combine with <b>Expression Solver</b> or downstream processing to compute cosine similarity between vectors.</p>",
	"llm-tool-use": "<h1>LLM Tool Use</h1><p>Sends messages to a large language model with tool (function) definitions, enabling the LLM to request tool calls that your flow can execute.</p><h2>Settings</h2><ul><li><b>SystemPrompt</b> — System prompt text.</li><li><b>UserPrompt</b> — User prompt text.</li><li><b>Messages</b> — JSON array of messages for direct conversation control.</li><li><b>Tools</b> — JSON array of tool definitions describing available functions the LLM can call.</li><li><b>Model</b> — Override model name.</li><li><b>ToolChoice</b> — <code>auto</code> (LLM decides), <code>none</code> (no tools), or a specific tool name (default <code>auto</code>).</li><li><b>Temperature</b> — Sampling temperature.</li><li><b>MaxTokens</b> — Maximum tokens to generate.</li><li><b>ConversationAddress</b> — State address for multi-turn history.</li><li><b>AppendToConversation</b> — Append this exchange to history.</li><li><b>InputAddress</b> — State address to read context data from.</li><li><b>Destination</b> — State address to write completion content.</li><li><b>AffinityKey</b> — Route to a specific Beacon worker.</li><li><b>TimeoutMs</b> — Timeout in milliseconds (default <code>120000</code>).</li></ul><h2>Outputs</h2><ul><li><b>Content</b> — The LLM's text response (may be empty if tool calls were made).</li><li><b>ToolCalls</b> — JSON array of tool call objects with function names and arguments.</li><li><b>Model</b> — Model that generated the response.</li><li><b>FinishReason</b> — <code>stop</code> for normal completion, <code>tool_calls</code> when tools were invoked.</li><li><b>PromptTokens</b> / <b>CompletionTokens</b> — Token usage.</li><li><b>BeaconID</b> — Beacon worker ID.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires when the LLM responds.</li><li><b>ToolCall</b> — Fires when the LLM requests a tool call.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>Tips</h2><p>Use the ToolCall event to route tool invocations to the appropriate processing cards, then feed results back for another LLM turn. This enables agent-style workflows where the LLM can gather information and take actions through your defined tools.</p>",
	"meadow-count": "<h1>Meadow Count</h1><p>Counts records for an entity via a Meadow REST API endpoint, with optional filtering.</p><h2>Settings</h2><ul><li><b>Entity</b> — Entity (table) name.</li><li><b>Endpoint</b> — Base URL of the Meadow API server.</li><li><b>Destination</b> — State address to store the count value.</li><li><b>Headers</b> — JSON string of request headers for authentication.</li><li><b>Filter</b> — Meadow filter expression to count only matching records.</li></ul><h2>Outputs</h2><ul><li><b>Count</b> — Number of records matching the criteria.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after the count is retrieved.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>Tips</h2><p>Use Meadow Count before <b>Meadow Reads</b> to check the result set size, or to report progress statistics. It is much faster than reading all records when you only need the total.</p>",
	"meadow-create": "<h1>Meadow Create</h1><p>Creates a new record via a Meadow REST API endpoint.</p><h2>Settings</h2><ul><li><b>Entity</b> — Entity (table) name.</li><li><b>Endpoint</b> — Base URL of the Meadow API server.</li><li><b>DataAddress</b> — State address of the object containing the record data to create.</li><li><b>Headers</b> — JSON string of request headers for authentication.</li><li><b>Destination</b> — State address to store the created record (includes server-generated fields like ID).</li></ul><h2>Outputs</h2><ul><li><b>Created</b> — The newly created record object with its assigned ID.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after the record is created.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>Tips</h2><p>Build the record data with <b>Set Values</b> or <b>Template String</b> before passing it to Meadow Create. The created record output includes the server-assigned ID, which you can use in subsequent steps.</p>",
	"meadow-delete": "<h1>Meadow Delete</h1><p>Deletes a record by its ID via a Meadow REST API endpoint.</p><h2>Settings</h2><ul><li><b>Entity</b> — Entity (table) name.</li><li><b>Endpoint</b> — Base URL of the Meadow API server.</li><li><b>RecordID</b> — The ID of the record to delete.</li><li><b>Headers</b> — JSON string of request headers for authentication.</li></ul><h2>Events</h2><ul><li><b>Done</b> — Fires after the record is deleted.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>Tips</h2><p>Meadow Delete is permanent — consider adding a <b>Value Input</b> confirmation step before deleting records in user-facing workflows. Build the RecordID dynamically with template expressions when deleting records identified by earlier processing steps.</p>",
	"meadow-read": "<h1>Meadow Read</h1><p>Reads a single record by its ID from a Meadow REST API endpoint.</p><h2>Settings</h2><ul><li><b>Entity</b> — Entity (table) name to query.</li><li><b>Endpoint</b> — Base URL of the Meadow API server.</li><li><b>RecordID</b> — The ID of the record to retrieve.</li><li><b>Destination</b> — State address to store the retrieved record.</li><li><b>Headers</b> — JSON string of additional request headers for authentication.</li></ul><h2>Outputs</h2><ul><li><b>Record</b> — The retrieved record object.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after the record is retrieved.</li><li><b>Error</b> — Fires if the record is not found or the request fails.</li></ul><h2>Tips</h2><p>Use <b>Set Values</b> or <b>Template String</b> to build the RecordID dynamically from other state values. Pair with <b>Meadow Update</b> to read-modify-write a record.</p>",
	"meadow-reads": "<h1>Meadow Reads</h1><p>Reads multiple records from a Meadow REST API endpoint, with optional filtering and pagination.</p><h2>Settings</h2><ul><li><b>Entity</b> — Entity (table) name to query.</li><li><b>Endpoint</b> — Base URL of the Meadow API server.</li><li><b>Filter</b> — Meadow filter expression to narrow the result set (e.g. <code>FBV~IDUser~EQ~42~0~</code>).</li><li><b>Destination</b> — State address to store the records array.</li><li><b>Headers</b> — JSON string of request headers for authentication.</li><li><b>PageSize</b> — Number of records per page (default <code>100</code>).</li><li><b>PageNumber</b> — Zero-based page number (default <code>0</code>).</li></ul><h2>Outputs</h2><ul><li><b>Records</b> — Array of retrieved record objects.</li><li><b>RecordCount</b> — Number of records returned.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after records are retrieved.</li><li><b>Error</b> — Fires on request failure.</li></ul><h2>Tips</h2><p>Use the Meadow filter expression to limit results server-side for better performance. Combine with <b>Split Execute</b> to process each record individually, or with <b>Comprehension Intersect</b> to join data from two entities.</p>",
	"meadow-update": "<h1>Meadow Update</h1><p>Updates an existing record via a Meadow REST API endpoint.</p><h2>Settings</h2><ul><li><b>Entity</b> — Entity (table) name.</li><li><b>Endpoint</b> — Base URL of the Meadow API server.</li><li><b>DataAddress</b> — State address of the record data to update. Must include the record's ID field.</li><li><b>Headers</b> — JSON string of request headers for authentication.</li><li><b>Destination</b> — State address to store the updated record.</li></ul><h2>Outputs</h2><ul><li><b>Updated</b> — The updated record object.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after the update.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>Tips</h2><p>Use <b>Meadow Read</b> first to load the current record, modify the fields you need with <b>Set Values</b>, then pass the modified object to Meadow Update. The data object must include the record's primary key field.</p>",
	"parse-csv": "<h1>Parse CSV</h1><p>Parses CSV text into an array of records (objects with field names as keys).</p><h2>Settings</h2><ul><li><b>SourceAddress</b> — State address containing the CSV text to parse.</li><li><b>Delimiter</b> — Column delimiter character (default <code>,</code>).</li><li><b>HasHeaders</b> — When <code>true</code>, the first row provides field names. When <code>false</code>, fields are indexed numerically.</li><li><b>Destination</b> — State address to store the parsed records array.</li><li><b>QuoteCharacter</b> — Character used to quote fields that contain the delimiter (default <code>\"</code>).</li><li><b>TrimFields</b> — Trim leading/trailing whitespace from field values.</li><li><b>SkipEmptyLines</b> — Skip blank lines in the input.</li></ul><h2>Outputs</h2><ul><li><b>Records</b> — Array of parsed row objects.</li><li><b>ColumnCount</b> — Number of columns detected.</li><li><b>Headers</b> — Array of header names from the first row.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after parsing.</li></ul><h2>Tips</h2><p>Chain <b>Read File</b> → <b>Parse CSV</b> → <b>CSV Transform</b> for a complete data import pipeline. Use TrimFields and SkipEmptyLines to handle messy real-world CSV exports cleanly.</p>",
	"read-file-buffered": "<h1>Read File Buffered</h1><p>Reads a file in chunks up to a maximum buffer size, splitting on a preferred character boundary. Ideal for processing large files that should not be loaded entirely into memory.</p><h2>Settings</h2><ul><li><b>FilePath</b> — Path to the file to read.</li><li><b>Encoding</b> — Character encoding (default <code>utf8</code>).</li><li><b>MaxBufferSize</b> — Maximum bytes per chunk (default <code>65536</code>).</li><li><b>SplitCharacter</b> — Preferred character to split on (default newline). The chunk is trimmed to the last occurrence of this character within the buffer so records are not broken mid-line.</li><li><b>ByteOffset</b> — Byte offset to start reading from. Use <code>0</code> for the first chunk and feed the output ByteOffset back for continuation.</li></ul><h2>Outputs</h2><ul><li><b>FileContent</b> — Content of the current chunk.</li><li><b>BytesRead</b> — Bytes in this chunk.</li><li><b>ByteOffset</b> — Updated byte offset for the next read.</li><li><b>IsComplete</b> — <code>true</code> when the entire file has been read.</li><li><b>FileName</b> — Base name of the file.</li><li><b>TotalFileSize</b> — Total size of the file in bytes.</li></ul><h2>Events</h2><ul><li><b>ReadComplete</b> — Fires when a chunk is read successfully.</li><li><b>Error</b> — Fires on read failure.</li></ul><h2>Tips</h2><p>Wire the ByteOffset output back to the ByteOffset setting input and use an <b>If Conditional</b> on IsComplete to create a read loop. This pattern lets you process files of any size line-by-line or paragraph-by-paragraph.</p>",
	"read-file": "<h1>Read File</h1><p>Reads a file from the local file system into operation state.</p><h2>Settings</h2><ul><li><b>FilePath</b> — Path to the file to read. Supports Pict template expressions for dynamic paths.</li><li><b>Encoding</b> — Character encoding (default <code>utf8</code>). Use <code>binary</code> for non-text files.</li><li><b>MaxBytes</b> — Maximum bytes to read. Set to <code>0</code> for unlimited.</li></ul><h2>Outputs</h2><ul><li><b>FileContent</b> — The full text content of the file.</li><li><b>BytesRead</b> — Number of bytes that were read.</li><li><b>FileName</b> — The base name of the file (no directory).</li></ul><h2>Events</h2><ul><li><b>ReadComplete</b> — Fires after a successful read.</li><li><b>Error</b> — Fires if the file cannot be found or read.</li></ul><h2>Tips</h2><p>For very large files, use <b>Read File Buffered</b> instead to process content in chunks. Use MaxBytes as a safety limit to avoid loading unexpectedly large files into memory.</p>",
	"read-json": "<h1>Read JSON</h1><p>Reads a JSON file from disk, parses it, and stores the resulting object in operation state.</p><h2>Settings</h2><ul><li><b>FilePath</b> — Path to the JSON file.</li><li><b>Destination</b> — State address to store the parsed data. If empty, data is stored at the default output address.</li></ul><h2>Outputs</h2><ul><li><b>Data</b> — The parsed JSON object or array.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after successful read and parse.</li><li><b>Error</b> — Fires if the file is missing or contains invalid JSON.</li></ul><h2>Tips</h2><p>Pair with <b>Write JSON</b> to round-trip configuration or intermediate data. Use the Destination setting to place the parsed data at a specific location in your operation state for downstream tasks.</p>",
	"replace-string": "<h1>Replace String</h1><p>Replaces all occurrences of a search string within the input text.</p><h2>Settings</h2><ul><li><b>InputString</b> — The source text to search within. Supports Pict template expressions.</li><li><b>SearchString</b> — The text or pattern to find.</li><li><b>ReplaceString</b> — The replacement text (empty string to delete matches).</li><li><b>UseRegex</b> — When <code>true</code>, treats SearchString as a regular expression.</li><li><b>CaseSensitive</b> — Case-sensitive matching (default <code>true</code>).</li></ul><h2>Outputs</h2><ul><li><b>ReplacedString</b> — The result after all replacements.</li><li><b>ReplacementCount</b> — Number of replacements made.</li></ul><h2>Events</h2><ul><li><b>ReplaceComplete</b> — Fires after replacement.</li><li><b>Error</b> — Fires on failure (e.g. invalid regex).</li></ul><h2>Tips</h2><p>Enable UseRegex for advanced pattern matching such as removing HTML tags, normalizing whitespace, or extracting structured tokens. Use ReplacementCount to verify that expected substitutions occurred.</p>",
	"rest-request": "<h1>REST Request</h1><p>Performs a fully configurable HTTP request with support for any method, custom content types, request bodies, retries, and timeout control.</p><h2>Settings</h2><ul><li><b>URL</b> — The URL to request.</li><li><b>Method</b> — HTTP method: <code>GET</code>, <code>POST</code>, <code>PUT</code>, <code>DELETE</code>, <code>PATCH</code>, etc. (default <code>GET</code>).</li><li><b>ContentType</b> — Content-Type header value (default <code>application/json</code>).</li><li><b>Headers</b> — JSON string of additional request headers.</li><li><b>Body</b> — Request body as a JSON string or raw text.</li><li><b>Destination</b> — State address to store the response.</li><li><b>Retries</b> — Number of retries on failure (default <code>0</code>).</li><li><b>TimeoutMs</b> — Request timeout in milliseconds (default <code>30000</code>).</li><li><b>RetryDelayMs</b> — Delay between retry attempts in milliseconds (default <code>1000</code>).</li></ul><h2>Outputs</h2><ul><li><b>Response</b> — The response data.</li><li><b>StatusCode</b> — HTTP response status code.</li><li><b>ResponseHeaders</b> — JSON string of response headers.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires on success.</li><li><b>Error</b> — Fires on failure after all retries are exhausted.</li></ul><h2>Tips</h2><p>REST Request is the most flexible HTTP card. Use it for DELETE operations, form-encoded POST bodies, XML APIs, or any case where Get JSON / Send JSON are too restrictive. The Retries setting with RetryDelayMs provides built-in resilience for flaky endpoints.</p>",
	"send-json": "<h1>Send JSON</h1><p>Sends JSON data to a URL via HTTP POST or PUT.</p><h2>Settings</h2><ul><li><b>URL</b> — The URL to send data to.</li><li><b>Method</b> — HTTP method: <code>POST</code> or <code>PUT</code> (default <code>POST</code>).</li><li><b>DataAddress</b> — State address of the object to send as the request body.</li><li><b>Headers</b> — JSON string of additional request headers.</li><li><b>Destination</b> — State address to store the response data.</li><li><b>TimeoutMs</b> — Request timeout in milliseconds (default <code>30000</code>).</li></ul><h2>Outputs</h2><ul><li><b>Response</b> — The parsed response data.</li><li><b>StatusCode</b> — HTTP response status code.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires on success.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>Tips</h2><p>Use Send JSON for creating or updating resources via REST APIs. For more control over the request (custom Content-Type, DELETE method, retries), use <b>REST Request</b> instead.</p>",
	"set-values": "<h1>Set Values</h1><p>Sets one or more values in operation state at specified addresses. This is the primary card for initializing variables, copying data between state locations, and injecting literal values.</p><h2>Settings</h2><ul><li><b>Mappings</b> — An array of mapping objects. Each mapping has a <code>To</code> address (where to write) and either a <code>Value</code> (literal) or <code>From</code> address (copy from state).</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after all mappings are applied.</li><li><b>Error</b> — Fires if a mapping fails.</li></ul><h2>Tips</h2><p>Use Set Values at the start of a flow to initialize default values before branching logic. Mappings are applied in order, so later entries can reference values set by earlier ones within the same card.</p>",
	"split-execute": "<h1>Split Execute</h1><p>Splits a string by a delimiter and processes each token through a sub-graph, acting as a loop iterator within the flow.</p><h2>Settings</h2><ul><li><b>InputString</b> — The string to split. Supports Pict template expressions.</li><li><b>SplitDelimiter</b> — Delimiter to split on (default newline <code>\\n</code>).</li><li><b>SkipEmpty</b> — When <code>true</code>, skips empty tokens after splitting.</li><li><b>TrimTokens</b> — When <code>true</code>, trims whitespace from each token.</li></ul><h2>Outputs</h2><ul><li><b>CurrentToken</b> — The current token being processed.</li><li><b>TokenIndex</b> — Zero-based index of the current token.</li><li><b>TokenCount</b> — Total number of tokens.</li><li><b>CompletedCount</b> — Number of tokens processed so far.</li></ul><h2>Events</h2><ul><li><b>TokenDataSent</b> — Fires for each token, sending it through the sub-graph.</li><li><b>CompletedAllSubtasks</b> — Fires after all tokens have been processed.</li><li><b>Error</b> — Fires on failure.</li></ul><h2>How It Works</h2><ol><li>The input string is split into tokens by the delimiter.</li><li>For each token, <b>TokenDataSent</b> fires with the token data in state.</li><li>Connect the downstream processing graph to TokenDataSent.</li><li>Wire the end of your processing graph back to the <b>StepComplete</b> event input to advance to the next token.</li><li>After all tokens are processed, <b>CompletedAllSubtasks</b> fires.</li></ol><h2>Tips</h2><p>Split Execute is the primary looping mechanism in Ultravisor flows. Use it with <b>List Files</b> output to process each file, or with newline-delimited text to process line-by-line.</p>",
	"start": "<h1>Start</h1><p>Entry point for the workflow. Every operation flow begins with a Start card.</p><h2>Events</h2><ul><li><b>Out</b> — Fires when the operation begins execution. Connect this to the first processing card in your flow.</li></ul><h2>Tips</h2><p>Each flow should have exactly one Start card. The Start card has no settings — it simply fires its Out event when the operation is triggered. Place it at the left side of your flow diagram for a clean left-to-right layout.</p>",
	"string-appender": "<h1>String Appender</h1><p>Appends a string to an existing value at a specified state address. Useful for building up output incrementally across loop iterations or multiple steps.</p><h2>Settings</h2><ul><li><b>InputString</b> — The text to append. Supports Pict template expressions.</li><li><b>OutputAddress</b> — State address of the string to append to.</li><li><b>AppendNewline</b> — When <code>true</code>, appends a newline character after the input string.</li><li><b>Separator</b> — String inserted between the existing content and new content. Overrides AppendNewline when set.</li></ul><h2>Outputs</h2><ul><li><b>AppendedString</b> — The full accumulated string after appending.</li></ul><h2>Events</h2><ul><li><b>Completed</b> — Fires after the append.</li></ul><h2>Tips</h2><p>Combine with <b>Split Execute</b> to build a report line by line. Use AppendNewline for log-style output or Separator for CSV-style concatenation with a custom delimiter.</p>",
	"template-string": "<h1>Template String</h1><p>Processes a Pict template string against the current operation state, resolving expressions like <code>{~D:Record.Name~}</code> into their runtime values.</p><h2>Settings</h2><ul><li><b>Template</b> — A Pict template string containing <code>{~D:...~}</code> expressions that reference state addresses.</li><li><b>Destination</b> — State address to store the rendered result. If empty, the result is available at the default output.</li></ul><h2>Outputs</h2><ul><li><b>Result</b> — The fully rendered template output.</li></ul><h2>Events</h2><ul><li><b>Complete</b> — Fires after rendering.</li><li><b>Error</b> — Fires if template parsing fails.</li></ul><h2>Tips</h2><p>Template String is the workhorse for building dynamic URLs, file paths, messages, and prompts. Any Pict template expression is supported, including conditionals and joins. Chain multiple Template String cards to build complex content from intermediate values.</p>",
	"value-input": "<h1>Value Input</h1><p>Pauses flow execution and prompts the user for input. The flow resumes when the user provides a value or cancels.</p><h2>Settings</h2><ul><li><b>PromptMessage</b> — The message displayed to the user (default: \"Please provide a value:\").</li><li><b>OutputAddress</b> — State address where the user's input will be stored.</li><li><b>InputType</b> — Type of input control: <code>text</code>, <code>number</code>, <code>boolean</code>, or <code>select</code> (default <code>text</code>).</li><li><b>DefaultValue</b> — Pre-filled default value.</li><li><b>Options</b> — JSON array of allowed values when InputType is <code>select</code>.</li></ul><h2>Outputs</h2><ul><li><b>InputValue</b> — The value provided by the user.</li></ul><h2>Events</h2><ul><li><b>ValueInputComplete</b> — Fires when the user submits a value.</li><li><b>Cancelled</b> — Fires if the user cancels without providing input.</li></ul><h2>Tips</h2><p>Use Value Input for human-in-the-loop workflows: approval gates, manual data entry, or parameter selection at runtime. Wire the Cancelled output to an appropriate fallback path. Use <code>select</code> InputType with Options for constrained choices.</p>",
	"write-file": "<h1>Write File</h1><p>Writes text content to a file on disk.</p><h2>Settings</h2><ul><li><b>FilePath</b> — Path to the output file. Intermediate directories are created automatically.</li><li><b>Content</b> — The text content to write. Supports Pict template expressions.</li><li><b>Encoding</b> — Character encoding (default <code>utf8</code>).</li><li><b>Append</b> — When <code>true</code>, appends to an existing file instead of overwriting it.</li><li><b>LineEnding</b> — Force a line ending style: <code>lf</code>, <code>crlf</code>, or leave empty for no conversion.</li></ul><h2>Outputs</h2><ul><li><b>FileLocation</b> — The path as specified (may be relative).</li><li><b>FileName</b> — The base file name only.</li><li><b>FilePath</b> — The fully resolved absolute path.</li><li><b>BytesWritten</b> — Number of bytes written.</li></ul><h2>Events</h2><ul><li><b>WriteComplete</b> — Fires on success.</li><li><b>Error</b> — Fires on write failure.</li></ul><h2>Tips</h2><p>Use Append mode with a <b>String Appender</b> to build log files or accumulate output across loop iterations.</p>",
	"write-json": "<h1>Write JSON</h1><p>Serializes a state object to JSON and writes it to a file on disk.</p><h2>Settings</h2><ul><li><b>FilePath</b> — Path to the output JSON file.</li><li><b>DataAddress</b> — State address of the data to serialize. If empty, uses the full operation state.</li><li><b>PrettyFormat</b> — Pretty-print with indentation (default <code>true</code>).</li><li><b>IndentType</b> — Indent character: <code>tab</code> or <code>space</code> (default <code>tab</code>).</li><li><b>IndentCount</b> — Number of indent characters per level (default <code>1</code>).</li><li><b>SortKeys</b> — Alphabetically sort object keys for deterministic output.</li></ul><h2>Outputs</h2><ul><li><b>FileLocation</b> — The path as specified.</li><li><b>FileName</b> — The base file name only.</li><li><b>FilePath</b> — The fully resolved absolute path.</li><li><b>BytesWritten</b> — Number of bytes written.</li></ul><h2>Events</h2><ul><li><b>Done</b> — Fires on success.</li><li><b>Error</b> — Fires on write failure.</li></ul><h2>Tips</h2><p>Enable SortKeys for config files that will be compared across versions or stored in version control.</p>"
};

},{}],246:[function(require,module,exports){
/**
 * Built-in card configurations for Ultravisor.
 *
 * Task-matched cards are generated at runtime from definitions fetched via the
 * `/TaskType` API endpoint.  The `generateCardConfigs()` function converts an
 * array of Definition objects into PictFlowCard constructor options using the
 * CardConfigGenerator, applies per-card visual overrides, and appends the two
 * flow-marker cards (Start / End) which have no backend task type.
 *
 * Visual overrides and flow-marker configs are the only data defined here;
 * task definitions live in standalone JSON files consumed by both server and
 * client.
 */

const generateCardConfig = require('./Ultravisor-CardConfigGenerator.js');

// Card help content generated from docs/card-help/ markdown files.
// Falls back to an empty map if the module has not been generated yet.
let _CardHelpContent = {};
try
{
	_CardHelpContent = require('../card-help-content.js');
}
catch (pError)
{
	// No card help content available — Help tabs will not appear.
}


// ═══════════════════════════════════════════════════════════════════════
//  VISUAL OVERRIDES per card hash
//  These preserve the hand-crafted styling from the original card files.
// ═══════════════════════════════════════════════════════════════════════

const _CardOverrides =
{
	// ── Interaction ─────────────────────────────────────────────
	'error-message':
	{
		Width: 220
	},
	'value-input':
	{
		// Amber palette instead of default Interaction red
		TitleBarColor: '#f57f17',
		BodyStyle: { fill: '#fffde7', stroke: '#f57f17' },
		Width: 220
	},

	// ── Control ────────────────────────────────────────────────
	'if-conditional':
	{
		// False branch goes to bottom for visual branching
		Outputs:
		[
			{ Name: 'True', Side: 'right-bottom', PortType: 'event-out' },
			{ Name: 'False', Side: 'bottom', PortType: 'event-out' },
			{ Name: 'Result', Side: 'right-top', PortType: 'value' }
		]
	},
	'split-execute':
	{
		// Teal palette to distinguish from other Control cards
		TitleBarColor: '#00695c',
		BodyStyle: { fill: '#e0f2f1', stroke: '#00695c' },
		// Custom output positions for the two event paths
		Outputs:
		[
			{ Name: 'TokenDataSent', Side: 'right-bottom', PortType: 'event-out' },
			{ Name: 'CompletedAllSubtasks', Side: 'right-bottom', PortType: 'event-out' },
			{ Name: 'Error', Side: 'bottom', PortType: 'error' },
			{ Name: 'CurrentToken', Side: 'right-top', PortType: 'value' },
			{ Name: 'TokenIndex', Side: 'right-top', PortType: 'value' },
			{ Name: 'TokenCount', Side: 'right-top', PortType: 'value' },
			{ Name: 'CompletedCount', Side: 'right-top', PortType: 'value' }
		]
	}
};


// ═══════════════════════════════════════════════════════════════════════
//  FLOW MARKER CONFIGS (no backend task type)
// ═══════════════════════════════════════════════════════════════════════

const _FlowMarkerConfigs =
[
	// ── Start ──────────────────────────────────────────────────
	{
		Title: 'Start',
		Code: 'start',
		Description: 'Entry point for the workflow.',
		Category: 'Flow Control',
		Capability: 'Flow Control',
		Action: 'Begin',
		Tier: 'Engine',
		TitleBarColor: '#455a64',
		BodyStyle: { fill: '#eceff1', stroke: '#455a64' },
		Width: 140,
		Height: 80,
		Inputs: [],
		Outputs:
		[
			{ Name: 'Out', Side: 'right-bottom', PortType: 'event-out' }
		]
	},
	// ── End ────────────────────────────────────────────────────
	{
		Title: 'End',
		Code: 'end',
		Description: 'Termination point for the workflow.',
		Category: 'Flow Control',
		Capability: 'Flow Control',
		Action: 'End',
		Tier: 'Engine',
		TitleBarColor: '#455a64',
		BodyStyle: { fill: '#eceff1', stroke: '#455a64' },
		Width: 140,
		Height: 80,
		Inputs:
		[
			{ Name: 'In', Side: 'left-bottom', PortType: 'event-in', MinimumInputCount: 1, MaximumInputCount: 5 }
		],
		Outputs: []
	}
];


// ═══════════════════════════════════════════════════════════════════════
//  PUBLIC API
// ═══════════════════════════════════════════════════════════════════════

/**
 * Convert an array of task type Definition objects (from the `/TaskType` API)
 * into PictFlowCard constructor configs, applying visual overrides and
 * appending the Start / End flow markers.
 *
 * @param {Array} pDefinitions - Task type definitions fetched from the server.
 * @returns {Array} Ready-to-use PictFlowCard config objects.
 */
function generateCardConfigs(pDefinitions)
{
	let tmpConfigs = [];

	for (let i = 0; i < pDefinitions.length; i++)
	{
		let tmpOverrides = _CardOverrides[pDefinitions[i].Hash] || null;
		let tmpCardConfig = generateCardConfig(pDefinitions[i], tmpOverrides);

		if (tmpCardConfig)
		{
			// Inject help content if available for this card code
			if (_CardHelpContent[tmpCardConfig.Code])
			{
				tmpCardConfig.Help = _CardHelpContent[tmpCardConfig.Code];
			}
			tmpConfigs.push(tmpCardConfig);
		}
	}

	// Append the 2 flow marker cards with help content
	for (let i = 0; i < _FlowMarkerConfigs.length; i++)
	{
		let tmpMarkerConfig = Object.assign({}, _FlowMarkerConfigs[i]);
		if (_CardHelpContent[tmpMarkerConfig.Code])
		{
			tmpMarkerConfig.Help = _CardHelpContent[tmpMarkerConfig.Code];
		}
		tmpConfigs.push(tmpMarkerConfig);
	}

	return tmpConfigs;
}

module.exports = { generateCardConfigs, CardOverrides: _CardOverrides, FlowMarkerConfigs: _FlowMarkerConfigs };

},{"../card-help-content.js":245,"./Ultravisor-CardConfigGenerator.js":247}],247:[function(require,module,exports){
/**
 * Ultravisor Card Config Generator
 *
 * Converts a task type Definition object into a PictFlowCard config object.
 * This allows any task type — built-in or user-defined — to automatically
 * produce a matching flow card without writing a class file.
 *
 * Usage:
 *   const generateCardConfig = require('./Ultravisor-CardConfigGenerator.js');
 *   let cardConfig = generateCardConfig(taskDefinition, { Width: 220 });
 *   // cardConfig can be passed directly to `new PictFlowCard(fable, cardConfig)`
 */

// ── Category color palette ────────────────────────────────────────────
// Maps lowercase category names to title bar / body style colors.
// Matches the palette established by the existing hand-crafted card files.
const _CategoryColors =
{
	'flow control': { TitleBarColor: '#78909c', BodyStyle: { fill: '#eceff1', stroke: '#78909c' } },
	'core':         { TitleBarColor: '#ab47bc', BodyStyle: { fill: '#f3e5f5', stroke: '#ab47bc' } },
	'control':      { TitleBarColor: '#ab47bc', BodyStyle: { fill: '#f3e5f5', stroke: '#ab47bc' } },
	'interaction':  { TitleBarColor: '#ef5350', BodyStyle: { fill: '#ffebee', stroke: '#ef5350' } },
	'data':         { TitleBarColor: '#ff9800', BodyStyle: { fill: '#fff3e0', stroke: '#ff9800' } },
	'file i/o':     { TitleBarColor: '#42a5f5', BodyStyle: { fill: '#eaf2f8', stroke: '#42a5f5' } },
	'file-io':      { TitleBarColor: '#42a5f5', BodyStyle: { fill: '#eaf2f8', stroke: '#42a5f5' } },
	'rest':         { TitleBarColor: '#29b6f6', BodyStyle: { fill: '#e1f5fe', stroke: '#29b6f6' } },
	'meadow':       { TitleBarColor: '#66bb6a', BodyStyle: { fill: '#e8f5e9', stroke: '#66bb6a' } },
	'pipeline':     { TitleBarColor: '#ec407a', BodyStyle: { fill: '#fce4ec', stroke: '#ec407a' } },
	'llm':          { TitleBarColor: '#26a69a', BodyStyle: { fill: '#e0f7fa', stroke: '#26a69a' } },
	'extension':    { TitleBarColor: '#9c6afe', BodyStyle: { fill: '#ede9fe', stroke: '#9c6afe' } },
	'content-system': { TitleBarColor: '#42a5f5', BodyStyle: { fill: '#e3f2fd', stroke: '#42a5f5' } }
};

// ── Capability color palette ─────────────────────────────────────────
// Maps lowercase Capability names to colors.  Used as a fallback when
// Category does not have a specific color (e.g. for future task types).
const _CapabilityColors =
{
	'flow control':      { TitleBarColor: '#78909c', BodyStyle: { fill: '#eceff1', stroke: '#78909c' } },
	'data transform':    { TitleBarColor: '#ff9800', BodyStyle: { fill: '#fff3e0', stroke: '#ff9800' } },
	'file system':       { TitleBarColor: '#42a5f5', BodyStyle: { fill: '#eaf2f8', stroke: '#42a5f5' } },
	'shell':             { TitleBarColor: '#ab47bc', BodyStyle: { fill: '#f3e5f5', stroke: '#ab47bc' } },
	'http client':       { TitleBarColor: '#29b6f6', BodyStyle: { fill: '#e1f5fe', stroke: '#29b6f6' } },
	'meadow api':        { TitleBarColor: '#66bb6a', BodyStyle: { fill: '#e8f5e9', stroke: '#66bb6a' } },
	'user interaction':  { TitleBarColor: '#ef5350', BodyStyle: { fill: '#ffebee', stroke: '#ef5350' } },
	'llm':               { TitleBarColor: '#26a69a', BodyStyle: { fill: '#e0f7fa', stroke: '#26a69a' } },
	'extension':         { TitleBarColor: '#9c6afe', BodyStyle: { fill: '#ede9fe', stroke: '#9c6afe' } },
	'contentsystem':     { TitleBarColor: '#42a5f5', BodyStyle: { fill: '#e3f2fd', stroke: '#42a5f5' } }
};

// Default colors for unknown categories
const _DefaultColors =
{
	TitleBarColor: '#37474f',
	BodyStyle: { fill: '#eceff1', stroke: '#37474f' }
};

// ── DataType → PictForm InputType mapping ─────────────────────────────
const _DataTypeInputMap =
{
	'String': 'Text',
	'Number': 'Text',
	'Boolean': 'Option',
	'Array': 'TextArea',
	'Object': 'TextArea'
};


// ── Helpers ───────────────────────────────────────────────────────────

/**
 * Capitalize the first letter of each word in a category string.
 */
function _titleCase(pString)
{
	if (!pString || typeof(pString) !== 'string')
	{
		return 'General';
	}
	return pString.replace(/\b\w/g, function (pChar) { return pChar.toUpperCase(); });
}

/**
 * Get colors for a category (case-insensitive lookup).
 */
function _getColorsForCategory(pCategory)
{
	if (!pCategory || typeof(pCategory) !== 'string')
	{
		return _DefaultColors;
	}

	let tmpKey = pCategory.toLowerCase().trim();

	if (_CategoryColors[tmpKey])
	{
		return _CategoryColors[tmpKey];
	}

	return _DefaultColors;
}

// ── Zone geometry lookup tables (mirrors PictProvider-Flow-Geometry) ──
const _SideToEdge =
{
	'left-top': 'left', 'left': 'left', 'left-bottom': 'left',
	'right-top': 'right', 'right': 'right', 'right-bottom': 'right',
	'top-left': 'top', 'top': 'top', 'top-right': 'top',
	'bottom-left': 'bottom', 'bottom': 'bottom', 'bottom-right': 'bottom'
};

/**
 * Calculate card dimensions from port arrays.
 *
 * Uses the same adaptive zone sizing as PictProvider-Flow-Geometry:
 * sums the space needed by all occupied zones on each left/right edge.
 * This produces compact cards whose height scales linearly with total
 * port count rather than being inflated by fixed 1/3 zone fractions.
 *
 * @param {Array} pInputs - Input port objects with Side, Direction
 * @param {Array} pOutputs - Output port objects with Side, Direction
 * @returns {{Width: number, Height: number}}
 */
function _calculateDimensions(pInputs, pOutputs)
{
	let tmpTitleBarHeight = 22;
	let tmpMinSpacing = 16;
	let tmpBottomPad = 16;
	let tmpWidth = 180;
	let tmpHeight = 80;

	let tmpAllPorts = (pInputs || []).concat(pOutputs || []);

	// Count ports per zone
	let tmpCountBySide = {};
	for (let i = 0; i < tmpAllPorts.length; i++)
	{
		let tmpSide = tmpAllPorts[i].Side || (tmpAllPorts[i].Direction === 'input' ? 'left' : 'right');
		if (!tmpCountBySide[tmpSide])
		{
			tmpCountBySide[tmpSide] = 0;
		}
		tmpCountBySide[tmpSide]++;
	}

	// Sum space needed per edge across all zones.
	// Each zone needs minSpacing * (count + 1) pixels.
	let tmpSpacePerEdge = {};
	for (let tmpSide in tmpCountBySide)
	{
		let tmpCount = tmpCountBySide[tmpSide];
		let tmpEdge = _SideToEdge[tmpSide] || 'right';

		if (tmpEdge !== 'left' && tmpEdge !== 'right')
		{
			continue;
		}

		let tmpZoneSpace = tmpMinSpacing * (tmpCount + 1);

		if (!tmpSpacePerEdge[tmpEdge])
		{
			tmpSpacePerEdge[tmpEdge] = 0;
		}
		tmpSpacePerEdge[tmpEdge] += tmpZoneSpace;
	}

	// Height = titleBar + bottomPad + max edge space
	for (let tmpEdge in tmpSpacePerEdge)
	{
		let tmpRequired = tmpTitleBarHeight + tmpBottomPad + tmpSpacePerEdge[tmpEdge];
		tmpHeight = Math.max(tmpHeight, Math.ceil(tmpRequired));
	}

	// Adjust width for many ports
	let tmpMaxPorts = Math.max((pInputs || []).length, (pOutputs || []).length);
	if (tmpMaxPorts >= 4)
	{
		tmpWidth = Math.max(tmpWidth, 220);
	}
	else if (tmpMaxPorts >= 3)
	{
		tmpWidth = Math.max(tmpWidth, 200);
	}

	return { Width: tmpWidth, Height: tmpHeight };
}

/**
 * Build a PropertiesPanel configuration from SettingsInputs.
 *
 * Uses the UltravisorSettings panel type which provides per-field
 * mode toggles (Constant / Address / Default) and type-appropriate
 * editors driven by the task definition schema.
 */
function _buildPropertiesPanel(pDefinition)
{
	let tmpSettings = pDefinition.SettingsInputs;

	if (!Array.isArray(tmpSettings) || tmpSettings.length === 0)
	{
		return null;
	}

	let tmpDefaults = pDefinition.DefaultSettings || {};

	// Account for mode-toggle fields (slightly taller per row) plus port summary sections below
	let tmpPortSummaryHeight = 0;
	if (Array.isArray(pDefinition.EventInputs) && pDefinition.EventInputs.length > 0)
	{
		tmpPortSummaryHeight += 30 + (pDefinition.EventInputs.length * 20);
	}
	if (Array.isArray(pDefinition.EventOutputs) && pDefinition.EventOutputs.length > 0)
	{
		tmpPortSummaryHeight += 30 + (pDefinition.EventOutputs.length * 20);
	}
	if (Array.isArray(pDefinition.StateOutputs) && pDefinition.StateOutputs.length > 0)
	{
		tmpPortSummaryHeight += 30 + (pDefinition.StateOutputs.length * 20);
	}
	let tmpPanelHeight = 160 + (tmpSettings.length * 65) + tmpPortSummaryHeight;

	return {
		PanelType: 'UltravisorSettings',
		DefaultWidth: 380,
		DefaultHeight: Math.min(tmpPanelHeight, 550),
		Title: (pDefinition.Name || pDefinition.Hash) + ' Settings',
		Configuration:
		{
			Schema: tmpSettings,
			Defaults: tmpDefaults
		}
	};
}


// ═══════════════════════════════════════════════════════════════════════
//  MAIN GENERATOR FUNCTION
// ═══════════════════════════════════════════════════════════════════════

/**
 * Generate a PictFlowCard config object from a task type Definition.
 *
 * The returned object can be passed directly to `new PictFlowCard(fable, config)`
 * to create a card instance ready for the flow editor palette.
 *
 * @param {object} pTaskDefinition - Task type definition with Hash, Name,
 *        Description, Category, EventInputs, EventOutputs, SettingsInputs,
 *        StateOutputs, DefaultSettings.
 * @param {object} [pOverrides] - Optional overrides merged on top of the
 *        generated config. Use for custom colors, sizes, port adjustments, etc.
 * @returns {object|null} PictFlowCard constructor options, or null on failure.
 */
function generateCardConfigFromTaskDefinition(pTaskDefinition, pOverrides)
{
	if (!pTaskDefinition || !pTaskDefinition.Hash)
	{
		return null;
	}

	let tmpDef = pTaskDefinition;
	let tmpCategory = tmpDef.Category || 'general';
	let tmpColors = _getColorsForCategory(tmpCategory);

	// Fallback to Capability-based colors when Category has no specific color
	if (tmpColors === _DefaultColors && tmpDef.Capability)
	{
		let tmpCapKey = tmpDef.Capability.toLowerCase().trim();
		if (_CapabilityColors[tmpCapKey])
		{
			tmpColors = _CapabilityColors[tmpCapKey];
		}
	}

	// ── Build input ports ──────────────────────────────────────────
	let tmpInputs = [];

	// Event inputs → left-bottom, event-in
	if (Array.isArray(tmpDef.EventInputs))
	{
		for (let i = 0; i < tmpDef.EventInputs.length; i++)
		{
			tmpInputs.push(
			{
				Name: tmpDef.EventInputs[i].Name,
				Side: 'left-bottom',
				PortType: 'event-in',
				MinimumInputCount: 0,
				MaximumInputCount: 1
			});
		}
	}

	// Settings inputs → left-top, setting
	if (Array.isArray(tmpDef.SettingsInputs))
	{
		for (let i = 0; i < tmpDef.SettingsInputs.length; i++)
		{
			tmpInputs.push(
			{
				Name: tmpDef.SettingsInputs[i].Name,
				Side: 'left-top',
				PortType: 'setting',
				MinimumInputCount: 0,
				MaximumInputCount: 1
			});
		}
	}

	// ── Build output ports ─────────────────────────────────────────
	let tmpOutputs = [];

	// Event outputs → right-bottom for normal, bottom for errors
	if (Array.isArray(tmpDef.EventOutputs))
	{
		for (let i = 0; i < tmpDef.EventOutputs.length; i++)
		{
			let tmpEvt = tmpDef.EventOutputs[i];

			if (tmpEvt.IsError)
			{
				tmpOutputs.push(
				{
					Name: tmpEvt.Name,
					Side: 'bottom',
					PortType: 'error'
				});
			}
			else
			{
				tmpOutputs.push(
				{
					Name: tmpEvt.Name,
					Side: 'right-bottom',
					PortType: 'event-out'
				});
			}
		}
	}

	// State outputs → right-top, value
	if (Array.isArray(tmpDef.StateOutputs))
	{
		for (let i = 0; i < tmpDef.StateOutputs.length; i++)
		{
			let tmpStateOut =
			{
				Name: tmpDef.StateOutputs[i].Name,
				Side: 'right-top',
				PortType: 'value'
			};
			if (tmpDef.StateOutputs[i].DataType)
			{
				tmpStateOut.DataType = tmpDef.StateOutputs[i].DataType;
			}
			tmpOutputs.push(tmpStateOut);
		}
	}

	// ── Calculate dimensions ───────────────────────────────────────
	let tmpDimensions = _calculateDimensions(tmpInputs, tmpOutputs);

	// ── Build PropertiesPanel ──────────────────────────────────────
	let tmpPropertiesPanel = _buildPropertiesPanel(tmpDef);

	// ── Assemble the card config ───────────────────────────────────
	let tmpConfig =
	{
		Title: tmpDef.Name || tmpDef.Hash,
		Code: tmpDef.Hash,
		Description: tmpDef.Description || '',
		Category: _titleCase(tmpCategory),
		TitleBarColor: tmpColors.TitleBarColor,
		BodyStyle: { fill: tmpColors.BodyStyle.fill, stroke: tmpColors.BodyStyle.stroke },
		Width: tmpDimensions.Width,
		Height: tmpDimensions.Height,
		Inputs: tmpInputs,
		Outputs: tmpOutputs
	};

	if (tmpPropertiesPanel)
	{
		tmpConfig.PropertiesPanel = tmpPropertiesPanel;
	}

	// ── Apply overrides ────────────────────────────────────────────
	if (pOverrides && typeof(pOverrides) === 'object')
	{
		let tmpKeys = Object.keys(pOverrides);

		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];

			// Deep merge for known objects; shallow replace for everything else
			if (tmpKey === 'BodyStyle' && typeof(pOverrides.BodyStyle) === 'object')
			{
				tmpConfig.BodyStyle = Object.assign({}, tmpConfig.BodyStyle, pOverrides.BodyStyle);
			}
			else if (tmpKey === 'PropertiesPanel' && typeof(pOverrides.PropertiesPanel) === 'object')
			{
				if (tmpConfig.PropertiesPanel)
				{
					tmpConfig.PropertiesPanel = Object.assign({}, tmpConfig.PropertiesPanel, pOverrides.PropertiesPanel);
				}
				else
				{
					tmpConfig.PropertiesPanel = pOverrides.PropertiesPanel;
				}
			}
			else
			{
				tmpConfig[tmpKey] = pOverrides[tmpKey];
			}
		}
	}

	// ── Ensure dimensions accommodate final port layout ───────────
	// Overrides may have replaced Inputs/Outputs, so recompute the
	// minimum dimensions and grow if needed (never shrink).
	let tmpFinalDimensions = _calculateDimensions(tmpConfig.Inputs, tmpConfig.Outputs);
	tmpConfig.Width = Math.max(tmpConfig.Width || 180, tmpFinalDimensions.Width);
	tmpConfig.Height = Math.max(tmpConfig.Height || 80, tmpFinalDimensions.Height);

	return tmpConfig;
}

module.exports = generateCardConfigFromTaskDefinition;
module.exports.CategoryColors = _CategoryColors;
module.exports.CapabilityColors = _CapabilityColors;
module.exports.DefaultColors = _DefaultColors;

},{}],248:[function(require,module,exports){
/**
 * Example Flow: Config File Processor
 *
 * Demonstrates a file-based config processing pipeline using the new engine task types:
 *   Start -> Read File (config template) -> If Conditional (has placeholder?)
 *     -> True:  Replace String (fill in value) -> Write File (output config) -> End
 *     -> False: Error Message (missing placeholder) -> End
 *
 * Shows branching, error handling, and file I/O with the event-driven execution engine.
 */
module.exports =
{
	Nodes:
	[
		// ── Entry ────────────────────────────────────────────────
		{
			Hash: 'cfg-start',
			Type: 'start',
			X: 50,
			Y: 200,
			Width: 140,
			Height: 80,
			Title: 'Start',
			Ports:
			[
				{ Hash: 'cfg-start-out', Direction: 'output', Side: 'right', Label: 'Out' }
			],
			Data: {}
		},
		// ── Read the config template ─────────────────────────────
		{
			Hash: 'cfg-read',
			Type: 'read-file',
			X: 270,
			Y: 180,
			Width: 200,
			Height: 80,
			Title: 'Read Config Template',
			Ports:
			[
				{ Hash: 'cfg-read-in', Direction: 'input', Side: 'left', Label: 'BeginRead' },
				{ Hash: 'cfg-read-done', Direction: 'output', Side: 'right', Label: 'ReadComplete' },
				{ Hash: 'cfg-read-err', Direction: 'output', Side: 'bottom', Label: 'Error' }
			],
			Data: { FilePath: 'config.template.json', Encoding: 'utf8' }
		},
		// ── Check if placeholder exists in the content ───────────
		{
			Hash: 'cfg-check',
			Type: 'if-conditional',
			X: 550,
			Y: 160,
			Width: 220,
			Height: 100,
			Title: 'Has Placeholder?',
			Ports:
			[
				{ Hash: 'cfg-check-in', Direction: 'input', Side: 'left', Label: 'Evaluate' },
				{ Hash: 'cfg-check-true', Direction: 'output', Side: 'right', Label: 'True' },
				{ Hash: 'cfg-check-false', Direction: 'output', Side: 'bottom', Label: 'False' }
			],
			Data: { DataAddress: 'TaskOutput.cfg-read.FileContent', CompareValue: '{{API_KEY}}', Operator: 'contains' }
		},
		// ── Replace the placeholder with the real value ──────────
		{
			Hash: 'cfg-replace',
			Type: 'replace-string',
			X: 850,
			Y: 140,
			Width: 220,
			Height: 80,
			Title: 'Fill In API Key',
			Ports:
			[
				{ Hash: 'cfg-replace-in', Direction: 'input', Side: 'left', Label: 'Replace' },
				{ Hash: 'cfg-replace-done', Direction: 'output', Side: 'right', Label: 'ReplaceComplete' },
				{ Hash: 'cfg-replace-err', Direction: 'output', Side: 'bottom', Label: 'Error' }
			],
			Data: { InputString: '{~D:Record.TaskOutput.cfg-read.FileContent~}', SearchString: '{{API_KEY}}', ReplaceString: 'sk-live-abc123def456' }
		},
		// ── Write the processed config ──────────────────────────
		{
			Hash: 'cfg-write',
			Type: 'write-file',
			X: 1150,
			Y: 140,
			Width: 200,
			Height: 80,
			Title: 'Write Config',
			Ports:
			[
				{ Hash: 'cfg-write-in', Direction: 'input', Side: 'left', Label: 'BeginWrite' },
				{ Hash: 'cfg-write-done', Direction: 'output', Side: 'right', Label: 'WriteComplete' },
				{ Hash: 'cfg-write-err', Direction: 'output', Side: 'bottom', Label: 'Error' }
			],
			Data: { FilePath: 'config.json', Content: '{~D:Record.TaskOutput.cfg-replace.ReplacedString~}', Encoding: 'utf8' }
		},
		// ── Error: placeholder not found ─────────────────────────
		{
			Hash: 'cfg-error',
			Type: 'error-message',
			X: 850,
			Y: 340,
			Width: 220,
			Height: 80,
			Title: 'Missing Placeholder',
			Ports:
			[
				{ Hash: 'cfg-error-in', Direction: 'input', Side: 'left', Label: 'Trigger' },
				{ Hash: 'cfg-error-done', Direction: 'output', Side: 'right', Label: 'Complete' }
			],
			Data: { MessageTemplate: 'Config template does not contain the {{API_KEY}} placeholder' }
		},
		// ── Exit ─────────────────────────────────────────────────
		{
			Hash: 'cfg-end',
			Type: 'end',
			X: 1430,
			Y: 220,
			Width: 140,
			Height: 80,
			Title: 'End',
			Ports:
			[
				{ Hash: 'cfg-end-in', Direction: 'input', Side: 'left', Label: 'In' }
			],
			Data: {}
		}
	],
	Connections:
	[
		// Start -> Read Config Template
		{
			Hash: 'cfg-c1',
			SourceNodeHash: 'cfg-start',
			SourcePortHash: 'cfg-start-out',
			TargetNodeHash: 'cfg-read',
			TargetPortHash: 'cfg-read-in',
			Data: {}
		},
		// Read Config Template -> Has Placeholder?
		{
			Hash: 'cfg-c2',
			SourceNodeHash: 'cfg-read',
			SourcePortHash: 'cfg-read-done',
			TargetNodeHash: 'cfg-check',
			TargetPortHash: 'cfg-check-in',
			Data: {}
		},
		// Has Placeholder? (True) -> Fill In API Key
		{
			Hash: 'cfg-c3',
			SourceNodeHash: 'cfg-check',
			SourcePortHash: 'cfg-check-true',
			TargetNodeHash: 'cfg-replace',
			TargetPortHash: 'cfg-replace-in',
			Data: {}
		},
		// Fill In API Key -> Write Config
		{
			Hash: 'cfg-c4',
			SourceNodeHash: 'cfg-replace',
			SourcePortHash: 'cfg-replace-done',
			TargetNodeHash: 'cfg-write',
			TargetPortHash: 'cfg-write-in',
			Data: {}
		},
		// Write Config -> End
		{
			Hash: 'cfg-c5',
			SourceNodeHash: 'cfg-write',
			SourcePortHash: 'cfg-write-done',
			TargetNodeHash: 'cfg-end',
			TargetPortHash: 'cfg-end-in',
			Data: {}
		},
		// Has Placeholder? (False) -> Missing Placeholder
		{
			Hash: 'cfg-c6',
			SourceNodeHash: 'cfg-check',
			SourcePortHash: 'cfg-check-false',
			TargetNodeHash: 'cfg-error',
			TargetPortHash: 'cfg-error-in',
			Data: {}
		},
		// Missing Placeholder -> End
		{
			Hash: 'cfg-c7',
			SourceNodeHash: 'cfg-error',
			SourcePortHash: 'cfg-error-done',
			TargetNodeHash: 'cfg-end',
			TargetPortHash: 'cfg-end-in',
			Data: {}
		},
		// Read Config Template error -> End
		{
			Hash: 'cfg-c8',
			SourceNodeHash: 'cfg-read',
			SourcePortHash: 'cfg-read-err',
			TargetNodeHash: 'cfg-end',
			TargetPortHash: 'cfg-end-in',
			Data: {}
		},
		// Fill In API Key error -> End
		{
			Hash: 'cfg-c9',
			SourceNodeHash: 'cfg-replace',
			SourcePortHash: 'cfg-replace-err',
			TargetNodeHash: 'cfg-end',
			TargetPortHash: 'cfg-end-in',
			Data: {}
		},
		// Write Config error -> End
		{
			Hash: 'cfg-c10',
			SourceNodeHash: 'cfg-write',
			SourcePortHash: 'cfg-write-err',
			TargetNodeHash: 'cfg-end',
			TargetPortHash: 'cfg-end-in',
			Data: {}
		}
	],
	ViewState:
	{
		PanX: 0,
		PanY: 0,
		Zoom: 1,
		SelectedNodeHash: null,
		SelectedConnectionHash: null
	}
};

},{}],249:[function(require,module,exports){
/**
 * Example Flow: File Processor (Search & Replace)
 *
 * Demonstrates a complete file processing pipeline with user input, looping,
 * and error handling:
 *
 *   Start
 *     -> Value Input (ask user for file path, stores to Operation.InputFilePath)
 *     -> Read File (loads the file at the user-provided path)
 *         -> [Error] -> Error Message -> End
 *     -> Split Execute (split file into lines)
 *         -> [per line] Replace String ("John" -> "Jane")
 *         -> String Appender (accumulate into Operation.OutputFileContents)
 *         -> [loop back: Append Completed -> Split StepComplete]
 *     -> [all lines done] Write File (save to original path + ".ultracopy")
 *     -> End
 *
 * This example showcases:
 *   - Value input pausing execution for user interaction
 *   - State connections (data flow between task settings/outputs)
 *   - The split-execute looping pattern with StepComplete feedback
 *   - Error branching
 *   - Pict template expressions for dynamic file paths
 */
module.exports =
{
	Nodes:
	[
		// ── Start ────────────────────────────────────────────────
		{
			Hash: 'fp-start',
			Type: 'start',
			X: 50,
			Y: 200,
			Width: 140,
			Height: 80,
			Title: 'Start',
			Ports:
			[
				{ Hash: 'fp-start-out', Direction: 'output', Side: 'right', Label: 'Out' }
			],
			Data: {}
		},
		// ── Ask user for file path ───────────────────────────────
		{
			Hash: 'fp-input',
			Type: 'value-input',
			X: 280,
			Y: 180,
			Width: 220,
			Height: 100,
			Title: 'Enter File Path',
			Ports:
			[
				{ Hash: 'fp-input-req', Direction: 'input', Side: 'left-bottom', Label: 'RequestInput' },
				{ Hash: 'fp-input-done', Direction: 'output', Side: 'right', Label: 'ValueInputComplete' },
				{ Hash: 'fp-input-filepath', Direction: 'output', Side: 'right-top', Label: 'InputFilePath' }
			],
			Data: { PromptMessage: 'Enter a file path and name', OutputAddress: 'Operation.InputFilePath' }
		},
		// ── Load the file ────────────────────────────────────────
		{
			Hash: 'fp-read',
			Type: 'read-file',
			X: 590,
			Y: 180,
			Width: 200,
			Height: 100,
			Title: 'Load File',
			Ports:
			[
				{ Hash: 'fp-read-begin', Direction: 'input', Side: 'left-bottom', Label: 'BeginRead' },
				{ Hash: 'fp-read-filepath', Direction: 'input', Side: 'left-top', Label: 'FilePath' },
				{ Hash: 'fp-read-done', Direction: 'output', Side: 'right', Label: 'ReadComplete' },
				{ Hash: 'fp-read-content', Direction: 'output', Side: 'right-top', Label: 'FileContent' },
				{ Hash: 'fp-read-err', Direction: 'output', Side: 'bottom', Label: 'Error' }
			],
			Data: { FilePath: '{~D:Record.Operation.InputFilePath~}', Encoding: 'utf8' }
		},
		// ── Error handler for file read ──────────────────────────
		{
			Hash: 'fp-error',
			Type: 'error-message',
			X: 590,
			Y: 420,
			Width: 220,
			Height: 80,
			Title: 'Read Error',
			Ports:
			[
				{ Hash: 'fp-error-in', Direction: 'input', Side: 'left-bottom', Label: 'Trigger' },
				{ Hash: 'fp-error-done', Direction: 'output', Side: 'right', Label: 'Complete' }
			],
			Data: { MessageTemplate: 'Failed to read file: {~D:Record.Operation.InputFilePath~}' }
		},
		// ── Split file into lines ────────────────────────────────
		{
			Hash: 'fp-split',
			Type: 'split-execute',
			X: 890,
			Y: 160,
			Width: 240,
			Height: 120,
			Title: 'Split Lines',
			Ports:
			[
				{ Hash: 'fp-split-begin', Direction: 'input', Side: 'left-bottom', Label: 'PerformSplit' },
				{ Hash: 'fp-split-step', Direction: 'input', Side: 'left-bottom', Label: 'StepComplete' },
				{ Hash: 'fp-split-inputstr', Direction: 'input', Side: 'left-top', Label: 'InputString' },
				{ Hash: 'fp-split-token', Direction: 'output', Side: 'right', Label: 'TokenDataSent' },
				{ Hash: 'fp-split-alldone', Direction: 'output', Side: 'right-bottom', Label: 'CompletedAllSubtasks' }
			],
			Data: { InputString: '{~D:Record.TaskOutput.fp-read.FileContent~}', SplitDelimiter: '\n' }
		},
		// ── Replace "John" with "Jane" in each line ──────────────
		{
			Hash: 'fp-replace',
			Type: 'replace-string',
			X: 1230,
			Y: 160,
			Width: 220,
			Height: 100,
			Title: 'Replace John with Jane',
			Ports:
			[
				{ Hash: 'fp-replace-in', Direction: 'input', Side: 'left-bottom', Label: 'Replace' },
				{ Hash: 'fp-replace-done', Direction: 'output', Side: 'right', Label: 'ReplaceComplete' },
				{ Hash: 'fp-replace-result', Direction: 'output', Side: 'right-top', Label: 'ReplacedString' }
			],
			Data: { InputString: '{~D:Record.TaskOutput.fp-split.CurrentToken~}', SearchString: 'John', ReplaceString: 'Jane' }
		},
		// ── Append each processed line to output ─────────────────
		{
			Hash: 'fp-append',
			Type: 'string-appender',
			X: 1540,
			Y: 160,
			Width: 220,
			Height: 100,
			Title: 'Append Line',
			Ports:
			[
				{ Hash: 'fp-append-in', Direction: 'input', Side: 'left-bottom', Label: 'Append' },
				{ Hash: 'fp-append-inputstr', Direction: 'input', Side: 'left-top', Label: 'InputString' },
				{ Hash: 'fp-append-done', Direction: 'output', Side: 'right', Label: 'Completed' }
			],
			Data: { InputString: '{~D:Record.TaskOutput.fp-replace.ReplacedString~}', OutputAddress: 'Operation.OutputFileContents', AppendNewline: true }
		},
		// ── Write the processed file ─────────────────────────────
		{
			Hash: 'fp-write',
			Type: 'write-file',
			X: 1230,
			Y: 420,
			Width: 220,
			Height: 80,
			Title: 'Save File',
			Ports:
			[
				{ Hash: 'fp-write-begin', Direction: 'input', Side: 'left-bottom', Label: 'BeginWrite' },
				{ Hash: 'fp-write-done', Direction: 'output', Side: 'right', Label: 'WriteComplete' },
				{ Hash: 'fp-write-err', Direction: 'output', Side: 'bottom', Label: 'Error' }
			],
			Data: { FilePath: '{~D:Record.Operation.InputFilePath~}.ultracopy', Content: '{~D:Record.Operation.OutputFileContents~}', Encoding: 'utf8' }
		},
		// ── End ──────────────────────────────────────────────────
		{
			Hash: 'fp-end',
			Type: 'end',
			X: 1540,
			Y: 420,
			Width: 140,
			Height: 80,
			Title: 'End',
			Ports:
			[
				{ Hash: 'fp-end-in', Direction: 'input', Side: 'left-bottom', Label: 'In' }
			],
			Data: {}
		}
	],
	Connections:
	[
		// ── Event connections (execution flow) ───────────────────

		// Start -> Enter File Path (step 22)
		{
			Hash: 'fp-ev1',
			SourceNodeHash: 'fp-start',
			SourcePortHash: 'fp-start-out',
			TargetNodeHash: 'fp-input',
			TargetPortHash: 'fp-input-req',
			Data: {}
		},
		// Enter File Path -> Load File (step 23)
		{
			Hash: 'fp-ev2',
			SourceNodeHash: 'fp-input',
			SourcePortHash: 'fp-input-done',
			TargetNodeHash: 'fp-read',
			TargetPortHash: 'fp-read-begin',
			Data: {}
		},
		// Load File ReadComplete -> Split Lines PerformSplit (step 24)
		{
			Hash: 'fp-ev3',
			SourceNodeHash: 'fp-read',
			SourcePortHash: 'fp-read-done',
			TargetNodeHash: 'fp-split',
			TargetPortHash: 'fp-split-begin',
			Data: {}
		},
		// Load File Error -> Read Error (step 10)
		{
			Hash: 'fp-ev4',
			SourceNodeHash: 'fp-read',
			SourcePortHash: 'fp-read-err',
			TargetNodeHash: 'fp-error',
			TargetPortHash: 'fp-error-in',
			Data: {}
		},
		// Read Error -> End
		{
			Hash: 'fp-ev5',
			SourceNodeHash: 'fp-error',
			SourcePortHash: 'fp-error-done',
			TargetNodeHash: 'fp-end',
			TargetPortHash: 'fp-end-in',
			Data: {}
		},
		// Split Lines TokenDataSent -> Replace (step 25)
		{
			Hash: 'fp-ev6',
			SourceNodeHash: 'fp-split',
			SourcePortHash: 'fp-split-token',
			TargetNodeHash: 'fp-replace',
			TargetPortHash: 'fp-replace-in',
			Data: {}
		},
		// Replace ReplaceComplete -> Append (step 26)
		{
			Hash: 'fp-ev7',
			SourceNodeHash: 'fp-replace',
			SourcePortHash: 'fp-replace-done',
			TargetNodeHash: 'fp-append',
			TargetPortHash: 'fp-append-in',
			Data: {}
		},
		// Append Completed -> Split StepComplete (loop back for next token)
		{
			Hash: 'fp-ev8',
			SourceNodeHash: 'fp-append',
			SourcePortHash: 'fp-append-done',
			TargetNodeHash: 'fp-split',
			TargetPortHash: 'fp-split-step',
			Data: {}
		},
		// Split Lines CompletedAllSubtasks -> Save File
		{
			Hash: 'fp-ev9',
			SourceNodeHash: 'fp-split',
			SourcePortHash: 'fp-split-alldone',
			TargetNodeHash: 'fp-write',
			TargetPortHash: 'fp-write-begin',
			Data: {}
		},
		// Save File WriteComplete -> End (step 21)
		{
			Hash: 'fp-ev10',
			SourceNodeHash: 'fp-write',
			SourcePortHash: 'fp-write-done',
			TargetNodeHash: 'fp-end',
			TargetPortHash: 'fp-end-in',
			Data: {}
		},

		// ── State connections (data flow) ────────────────────────

		// Enter File Path OutputAddress -> Load File FilePath (step 8)
		{
			Hash: 'fp-st1',
			SourceNodeHash: 'fp-input',
			SourcePortHash: 'fp-input-filepath',
			TargetNodeHash: 'fp-read',
			TargetPortHash: 'fp-read-filepath',
			Data: {}
		},
		// Load File FileContent -> Split Lines InputString (step 13)
		{
			Hash: 'fp-st2',
			SourceNodeHash: 'fp-read',
			SourcePortHash: 'fp-read-content',
			TargetNodeHash: 'fp-split',
			TargetPortHash: 'fp-split-inputstr',
			Data: {}
		},
		// Replace ReplacedString -> Append InputString (step 15)
		{
			Hash: 'fp-st3',
			SourceNodeHash: 'fp-replace',
			SourcePortHash: 'fp-replace-result',
			TargetNodeHash: 'fp-append',
			TargetPortHash: 'fp-append-inputstr',
			Data: {}
		}
	],
	ViewState:
	{
		PanX: 0,
		PanY: 0,
		Zoom: 1,
		SelectedNodeHash: null,
		SelectedConnectionHash: null
	}
};

},{}],250:[function(require,module,exports){
/**
 * Example Flow: Template Processor
 *
 * Demonstrates a multi-step text processing pipeline using the new engine task types:
 *   Start -> Set Values (initialize project metadata)
 *         -> Read File (template)
 *         -> Replace String (project name)
 *         -> Replace String (version)
 *         -> If Conditional (check for remaining placeholders)
 *           -> True:  Error Message (warn about unresolved placeholders) -> End
 *           -> False: String Appender (add header comment) -> Write File (output) -> End
 *
 * Shows chained string operations, state management, and conditional validation.
 */
module.exports =
{
	Nodes:
	[
		// ── Entry ────────────────────────────────────────────────
		{
			Hash: 'tpl-start',
			Type: 'start',
			X: 50,
			Y: 220,
			Width: 140,
			Height: 80,
			Title: 'Start',
			Ports:
			[
				{ Hash: 'tpl-start-out', Direction: 'output', Side: 'right', Label: 'Out' }
			],
			Data: {}
		},
		// ── Initialize project metadata ─────────────────────────
		{
			Hash: 'tpl-setvals',
			Type: 'set-values',
			X: 270,
			Y: 200,
			Width: 200,
			Height: 80,
			Title: 'Set Project Info',
			Ports:
			[
				{ Hash: 'tpl-sv-in', Direction: 'input', Side: 'left', Label: 'Execute' },
				{ Hash: 'tpl-sv-out', Direction: 'output', Side: 'right', Label: 'Complete' }
			],
			Data:
			{
				Mappings:
				[
					{ Address: 'Operation.ProjectName', Value: 'Retold' },
					{ Address: 'Operation.Version', Value: '3.0.0' },
					{ Address: 'Operation.Author', Value: 'Steven Velozo' }
				]
			}
		},
		// ── Read the template file ──────────────────────────────
		{
			Hash: 'tpl-read',
			Type: 'read-file',
			X: 550,
			Y: 200,
			Width: 200,
			Height: 80,
			Title: 'Read Template',
			Ports:
			[
				{ Hash: 'tpl-read-in', Direction: 'input', Side: 'left', Label: 'BeginRead' },
				{ Hash: 'tpl-read-done', Direction: 'output', Side: 'right', Label: 'ReadComplete' },
				{ Hash: 'tpl-read-err', Direction: 'output', Side: 'bottom', Label: 'Error' }
			],
			Data: { FilePath: 'readme.template.md', Encoding: 'utf8' }
		},
		// ── Replace project name placeholder ────────────────────
		{
			Hash: 'tpl-replace-name',
			Type: 'replace-string',
			X: 830,
			Y: 180,
			Width: 220,
			Height: 80,
			Title: 'Set Project Name',
			Ports:
			[
				{ Hash: 'tpl-rn-in', Direction: 'input', Side: 'left', Label: 'Replace' },
				{ Hash: 'tpl-rn-done', Direction: 'output', Side: 'right', Label: 'ReplaceComplete' },
				{ Hash: 'tpl-rn-err', Direction: 'output', Side: 'bottom', Label: 'Error' }
			],
			Data: { InputString: '{~D:Record.TaskOutput.tpl-read.FileContent~}', SearchString: '${PROJECT_NAME}', ReplaceString: '{~D:Record.Operation.ProjectName~}' }
		},
		// ── Replace version placeholder ─────────────────────────
		{
			Hash: 'tpl-replace-ver',
			Type: 'replace-string',
			X: 1130,
			Y: 180,
			Width: 220,
			Height: 80,
			Title: 'Set Version',
			Ports:
			[
				{ Hash: 'tpl-rv-in', Direction: 'input', Side: 'left', Label: 'Replace' },
				{ Hash: 'tpl-rv-done', Direction: 'output', Side: 'right', Label: 'ReplaceComplete' },
				{ Hash: 'tpl-rv-err', Direction: 'output', Side: 'bottom', Label: 'Error' }
			],
			Data: { InputString: '{~D:Record.TaskOutput.tpl-replace-name.ReplacedString~}', SearchString: '${VERSION}', ReplaceString: '{~D:Record.Operation.Version~}' }
		},
		// ── Check for remaining unresolved placeholders ─────────
		{
			Hash: 'tpl-validate',
			Type: 'if-conditional',
			X: 1430,
			Y: 160,
			Width: 240,
			Height: 100,
			Title: 'Unresolved Placeholders?',
			Ports:
			[
				{ Hash: 'tpl-val-in', Direction: 'input', Side: 'left', Label: 'Evaluate' },
				{ Hash: 'tpl-val-true', Direction: 'output', Side: 'bottom', Label: 'True' },
				{ Hash: 'tpl-val-false', Direction: 'output', Side: 'right', Label: 'False' }
			],
			Data: { DataAddress: 'TaskOutput.tpl-replace-ver.ReplacedString', CompareValue: '${', Operator: 'contains' }
		},
		// ── Error: unresolved placeholders remain ────────────────
		{
			Hash: 'tpl-warn',
			Type: 'error-message',
			X: 1430,
			Y: 380,
			Width: 240,
			Height: 80,
			Title: 'Warn: Unresolved',
			Ports:
			[
				{ Hash: 'tpl-warn-in', Direction: 'input', Side: 'left', Label: 'Trigger' },
				{ Hash: 'tpl-warn-done', Direction: 'output', Side: 'right', Label: 'Complete' }
			],
			Data: { MessageTemplate: 'Warning: Template still contains unresolved ${...} placeholders after processing' }
		},
		// ── Prepend a generated-by header comment ───────────────
		{
			Hash: 'tpl-header',
			Type: 'string-appender',
			X: 1750,
			Y: 160,
			Width: 220,
			Height: 80,
			Title: 'Add Header',
			Ports:
			[
				{ Hash: 'tpl-hdr-in', Direction: 'input', Side: 'left', Label: 'Append' },
				{ Hash: 'tpl-hdr-done', Direction: 'output', Side: 'right', Label: 'Completed' }
			],
			Data: { InputString: '{~D:Record.TaskOutput.tpl-replace-ver.ReplacedString~}', OutputAddress: 'Operation.FinalContent' }
		},
		// ── Write the processed output ──────────────────────────
		{
			Hash: 'tpl-write',
			Type: 'write-file',
			X: 2050,
			Y: 160,
			Width: 200,
			Height: 80,
			Title: 'Write Output',
			Ports:
			[
				{ Hash: 'tpl-write-in', Direction: 'input', Side: 'left', Label: 'BeginWrite' },
				{ Hash: 'tpl-write-done', Direction: 'output', Side: 'right', Label: 'WriteComplete' },
				{ Hash: 'tpl-write-err', Direction: 'output', Side: 'bottom', Label: 'Error' }
			],
			Data: { FilePath: 'README.md', Content: '{~D:Record.Operation.FinalContent~}', Encoding: 'utf8' }
		},
		// ── Exit ─────────────────────────────────────────────────
		{
			Hash: 'tpl-end',
			Type: 'end',
			X: 2330,
			Y: 260,
			Width: 140,
			Height: 80,
			Title: 'End',
			Ports:
			[
				{ Hash: 'tpl-end-in', Direction: 'input', Side: 'left', Label: 'In' }
			],
			Data: {}
		}
	],
	Connections:
	[
		// Start -> Set Project Info
		{
			Hash: 'tpl-c1',
			SourceNodeHash: 'tpl-start',
			SourcePortHash: 'tpl-start-out',
			TargetNodeHash: 'tpl-setvals',
			TargetPortHash: 'tpl-sv-in',
			Data: {}
		},
		// Set Project Info -> Read Template
		{
			Hash: 'tpl-c2',
			SourceNodeHash: 'tpl-setvals',
			SourcePortHash: 'tpl-sv-out',
			TargetNodeHash: 'tpl-read',
			TargetPortHash: 'tpl-read-in',
			Data: {}
		},
		// Read Template -> Set Project Name
		{
			Hash: 'tpl-c3',
			SourceNodeHash: 'tpl-read',
			SourcePortHash: 'tpl-read-done',
			TargetNodeHash: 'tpl-replace-name',
			TargetPortHash: 'tpl-rn-in',
			Data: {}
		},
		// Set Project Name -> Set Version
		{
			Hash: 'tpl-c4',
			SourceNodeHash: 'tpl-replace-name',
			SourcePortHash: 'tpl-rn-done',
			TargetNodeHash: 'tpl-replace-ver',
			TargetPortHash: 'tpl-rv-in',
			Data: {}
		},
		// Set Version -> Unresolved Placeholders?
		{
			Hash: 'tpl-c5',
			SourceNodeHash: 'tpl-replace-ver',
			SourcePortHash: 'tpl-rv-done',
			TargetNodeHash: 'tpl-validate',
			TargetPortHash: 'tpl-val-in',
			Data: {}
		},
		// Unresolved Placeholders? (True) -> Warn
		{
			Hash: 'tpl-c6',
			SourceNodeHash: 'tpl-validate',
			SourcePortHash: 'tpl-val-true',
			TargetNodeHash: 'tpl-warn',
			TargetPortHash: 'tpl-warn-in',
			Data: {}
		},
		// Warn -> End
		{
			Hash: 'tpl-c7',
			SourceNodeHash: 'tpl-warn',
			SourcePortHash: 'tpl-warn-done',
			TargetNodeHash: 'tpl-end',
			TargetPortHash: 'tpl-end-in',
			Data: {}
		},
		// Unresolved Placeholders? (False) -> Add Header
		{
			Hash: 'tpl-c8',
			SourceNodeHash: 'tpl-validate',
			SourcePortHash: 'tpl-val-false',
			TargetNodeHash: 'tpl-header',
			TargetPortHash: 'tpl-hdr-in',
			Data: {}
		},
		// Add Header -> Write Output
		{
			Hash: 'tpl-c9',
			SourceNodeHash: 'tpl-header',
			SourcePortHash: 'tpl-hdr-done',
			TargetNodeHash: 'tpl-write',
			TargetPortHash: 'tpl-write-in',
			Data: {}
		},
		// Write Output -> End
		{
			Hash: 'tpl-c10',
			SourceNodeHash: 'tpl-write',
			SourcePortHash: 'tpl-write-done',
			TargetNodeHash: 'tpl-end',
			TargetPortHash: 'tpl-end-in',
			Data: {}
		},
		// Read Template error -> End
		{
			Hash: 'tpl-c11',
			SourceNodeHash: 'tpl-read',
			SourcePortHash: 'tpl-read-err',
			TargetNodeHash: 'tpl-end',
			TargetPortHash: 'tpl-end-in',
			Data: {}
		},
		// Set Project Name error -> End
		{
			Hash: 'tpl-c12',
			SourceNodeHash: 'tpl-replace-name',
			SourcePortHash: 'tpl-rn-err',
			TargetNodeHash: 'tpl-end',
			TargetPortHash: 'tpl-end-in',
			Data: {}
		},
		// Set Version error -> End
		{
			Hash: 'tpl-c13',
			SourceNodeHash: 'tpl-replace-ver',
			SourcePortHash: 'tpl-rv-err',
			TargetNodeHash: 'tpl-end',
			TargetPortHash: 'tpl-end-in',
			Data: {}
		},
		// Write Output error -> End
		{
			Hash: 'tpl-c14',
			SourceNodeHash: 'tpl-write',
			SourcePortHash: 'tpl-write-err',
			TargetNodeHash: 'tpl-end',
			TargetPortHash: 'tpl-end-in',
			Data: {}
		}
	],
	ViewState:
	{
		PanX: 0,
		PanY: 0,
		Zoom: 1,
		SelectedNodeHash: null,
		SelectedConnectionHash: null
	}
};

},{}],251:[function(require,module,exports){
const libPictFlowCardPropertiesPanel = require('pict-section-flow/source/PictFlowCardPropertiesPanel.js');
const libPictSectionObjectEditor = require('pict-section-objecteditor');

/**
 * Ultravisor Card Settings Panel
 *
 * A custom properties panel for Ultravisor flow cards that provides
 * per-field mode toggles: Constant, Address, or Default.
 *
 * - Constant: a literal value edited with a type-appropriate input
 * - Address:  a Manyfest address expression resolved at execution time
 * - Default:  use the task type's default value (field omitted from Data)
 *
 * Each field has a single toggle button to the left of the input that
 * cycles through modes on click.  Values are remembered per-mode so
 * switching away and back restores what was there before.
 *
 * The panel reads the task definition schema (SettingsInputs + DefaultSettings)
 * from the panel Configuration, and stores mode metadata in the node's
 * Data._FieldModes object alongside the actual field values.
 *
 * Panel type identifier: 'UltravisorSettings'
 * Service type: 'PictFlowCardPropertiesPanel-UltravisorSettings'
 */

// Mode cycle order
const _ModeCycle = ['constant', 'address', 'default'];

// Mode display labels (shown in italic on the toggle button)
const _ModeLabels =
{
	'constant': 'C',
	'address': 'A',
	'default': 'D'
};

// Mode tooltip text
const _ModeTitles =
{
	'constant': 'Constant',
	'address': 'Address',
	'default': 'Default'
};


class UltravisorCardSettingsPanel extends libPictFlowCardPropertiesPanel
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'PictFlowCardPropertiesPanel-UltravisorSettings';

		// Schema from the task definition
		this._Schema = (this._Configuration && Array.isArray(this._Configuration.Schema))
			? this._Configuration.Schema
			: [];
		this._Defaults = (this._Configuration && typeof(this._Configuration.Defaults) === 'object')
			? this._Configuration.Defaults
			: {};

		// Per-field state: { fieldName: { mode, constantValue, addressValue, dataType, defaultValue } }
		this._FieldStates = {};

		// Active ObjectEditor view instances keyed by field name
		this._ObjectEditors = {};

		// Track whether CSS has been injected
		this._CSSInjected = false;
	}

	// ====================================================================
	// Render
	// ====================================================================

	/**
	 * Render the settings panel into the provided container.
	 *
	 * @param {HTMLElement} pContainer - The DOM element to render into
	 * @param {Object} pNodeData - The node data object (has .Data property)
	 */
	render(pContainer, pNodeData)
	{
		super.render(pContainer, pNodeData);

		this._injectCSS();
		this._initializeFieldStates(pNodeData);

		let tmpHTML = '<div class="uv-settings-panel">';

		for (let i = 0; i < this._Schema.length; i++)
		{
			let tmpSetting = this._Schema[i];
			let tmpFieldName = tmpSetting.Name;
			let tmpState = this._FieldStates[tmpFieldName];

			if (!tmpState)
			{
				continue;
			}

			tmpHTML += this._renderField(tmpSetting, tmpState);
		}

		tmpHTML += '</div>';
		pContainer.innerHTML = tmpHTML;

		this._wireEventListeners(pContainer);
	}

	// ====================================================================
	// Field State Initialization
	// ====================================================================

	/**
	 * Initialize _FieldStates from the node's Data and _FieldModes.
	 *
	 * Each field stores separate constantValue and addressValue so that
	 * switching modes preserves what was entered in each.
	 *
	 * Backward compatibility: when _FieldModes is absent, infer modes:
	 *   - string value containing '{~' → address
	 *   - value present → constant
	 *   - value absent → default
	 *
	 * @param {Object} pNodeData
	 */
	_initializeFieldStates(pNodeData)
	{
		this._FieldStates = {};

		let tmpData = (pNodeData && pNodeData.Data && typeof(pNodeData.Data) === 'object')
			? pNodeData.Data
			: {};
		let tmpFieldModes = (tmpData._FieldModes && typeof(tmpData._FieldModes) === 'object')
			? tmpData._FieldModes
			: null;

		for (let i = 0; i < this._Schema.length; i++)
		{
			let tmpSetting = this._Schema[i];
			let tmpFieldName = tmpSetting.Name;
			let tmpDataType = tmpSetting.DataType || 'String';
			let tmpDefault = (this._Defaults.hasOwnProperty(tmpFieldName))
				? this._Defaults[tmpFieldName]
				: '';

			let tmpMode = 'default';
			let tmpConstantValue = tmpDefault;
			let tmpAddressValue = '';

			if (tmpFieldModes && tmpFieldModes.hasOwnProperty(tmpFieldName))
			{
				// Explicit mode from _FieldModes
				tmpMode = tmpFieldModes[tmpFieldName];

				if (tmpMode === 'address')
				{
					tmpAddressValue = this._extractAddressFromTemplate(tmpData[tmpFieldName]);
				}
				else if (tmpMode === 'constant')
				{
					tmpConstantValue = tmpData.hasOwnProperty(tmpFieldName) ? tmpData[tmpFieldName] : tmpDefault;
				}
				// mode === 'default' → constantValue stays at schema default
			}
			else
			{
				// Infer mode from existing data (backward compatibility)
				if (tmpData.hasOwnProperty(tmpFieldName))
				{
					let tmpExistingValue = tmpData[tmpFieldName];

					if (typeof(tmpExistingValue) === 'string' && tmpExistingValue.indexOf('{~') >= 0)
					{
						tmpMode = 'address';
						tmpAddressValue = this._extractAddressFromTemplate(tmpExistingValue);
					}
					else
					{
						tmpMode = 'constant';
						tmpConstantValue = tmpExistingValue;
					}
				}
				// else: absent → default
			}

			this._FieldStates[tmpFieldName] =
			{
				mode: tmpMode,
				constantValue: tmpConstantValue,
				addressValue: tmpAddressValue,
				dataType: tmpDataType,
				defaultValue: tmpDefault
			};
		}
	}

	// ====================================================================
	// HTML Generation
	// ====================================================================

	/**
	 * Render a single field row: label + [toggle | editor] + description.
	 *
	 * Layout:
	 *   FieldName*
	 *   [C] [ input______________________ ]
	 *   description text
	 *
	 * @param {Object} pSetting - The SettingsInput definition
	 * @param {Object} pState - The field's current state from _FieldStates
	 * @returns {string} HTML string
	 */
	_renderField(pSetting, pState)
	{
		let tmpFieldName = pSetting.Name;
		let tmpRequired = pSetting.Required ? '<span class="uv-settings-field-required">*</span>' : '';
		let tmpDescription = pSetting.Description
			? '<div class="uv-settings-field-description">' + this._escapeHTML(pSetting.Description) + '</div>'
			: '';
		let tmpAttrName = this._escapeAttr(tmpFieldName);

		let tmpEditorHTML = this._renderFieldEditor(tmpFieldName, pState);

		let tmpModeClass = 'uv-mode-' + pState.mode;
		let tmpLabel = _ModeLabels[pState.mode] || 'C';
		let tmpTitle = _ModeTitles[pState.mode] || '';

		return '<div class="uv-settings-field" data-field-name="' + tmpAttrName + '">'
			+ '<div class="uv-settings-field-label">' + this._escapeHTML(tmpFieldName) + tmpRequired + '</div>'
			+ '<div class="uv-settings-field-row">'
			+ '<button class="uv-mode-toggle ' + tmpModeClass + '" data-field="' + tmpAttrName + '" title="' + this._escapeAttr(tmpTitle) + '">' + tmpLabel + '</button>'
			+ '<div class="uv-settings-field-editor" data-field="' + tmpAttrName + '">'
			+ tmpEditorHTML
			+ '</div>'
			+ '</div>'
			+ tmpDescription
			+ '</div>';
	}

	/**
	 * Render the editor widget for a field based on its current mode.
	 *
	 * @param {string} pFieldName
	 * @param {Object} pState
	 * @returns {string} HTML string
	 */
	_renderFieldEditor(pFieldName, pState)
	{
		let tmpAttrName = this._escapeAttr(pFieldName);

		switch (pState.mode)
		{
			case 'constant':
				return this._renderConstantEditor(tmpAttrName, pState);

			case 'address':
				return this._renderAddressEditor(tmpAttrName, pState);

			case 'default':
				return this._renderDefaultDisplay(pState);

			default:
				return '';
		}
	}

	/**
	 * Render a type-appropriate constant value editor.
	 */
	_renderConstantEditor(pAttrName, pState)
	{
		let tmpValue = pState.constantValue;

		switch (pState.dataType)
		{
			case 'Boolean':
			{
				let tmpChecked = (tmpValue === true || tmpValue === 'true') ? ' checked' : '';
				return '<label class="uv-settings-checkbox">'
					+ '<input type="checkbox" class="uv-settings-input-bool" data-field="' + pAttrName + '"' + tmpChecked + '>'
					+ '<span>Enabled</span>'
					+ '</label>';
			}

			case 'Number':
			{
				let tmpNumVal = (tmpValue !== undefined && tmpValue !== null && tmpValue !== '') ? tmpValue : '';
				return '<input type="number" class="uv-settings-input" data-field="' + pAttrName + '" value="' + this._escapeAttr(String(tmpNumVal)) + '">';
			}

			case 'Array':
			case 'Object':
			{
				let tmpEditorId = 'uv-objecteditor-' + pAttrName;
				return '<div class="uv-objecteditor-container" id="' + tmpEditorId + '" data-field="' + pAttrName + '"></div>';
			}

			default: // String
			{
				let tmpStrVal = (tmpValue !== undefined && tmpValue !== null) ? String(tmpValue) : '';
				return '<input type="text" class="uv-settings-input" data-field="' + pAttrName + '" value="' + this._escapeAttr(tmpStrVal) + '">';
			}
		}
	}

	/**
	 * Render the address mode editor: text input with placeholder.
	 */
	_renderAddressEditor(pAttrName, pState)
	{
		let tmpAddress = (typeof(pState.addressValue) === 'string') ? pState.addressValue : '';

		return '<input type="text" class="uv-settings-input uv-settings-address-input" data-field="' + pAttrName + '" value="' + this._escapeAttr(tmpAddress) + '" placeholder="e.g. Operation.InputFilePath">';
	}

	/**
	 * Render the default mode display: read-only showing the schema default.
	 */
	_renderDefaultDisplay(pState)
	{
		let tmpDefaultStr = '';

		if (pState.defaultValue === undefined || pState.defaultValue === null || pState.defaultValue === '')
		{
			tmpDefaultStr = 'default: empty';
		}
		else if (typeof(pState.defaultValue) === 'object')
		{
			tmpDefaultStr = 'default: ' + JSON.stringify(pState.defaultValue);
		}
		else
		{
			tmpDefaultStr = 'default: ' + String(pState.defaultValue);
		}

		return '<div class="uv-settings-default-display">' + this._escapeHTML(tmpDefaultStr) + '</div>';
	}

	// ====================================================================
	// Event Handling
	// ====================================================================

	/**
	 * Wire up event listeners on the rendered panel DOM.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_wireEventListeners(pContainer)
	{
		let tmpSelf = this;

		// Mode toggle buttons — use pointerup instead of click to avoid
		// SVG foreignObject event routing issues in Safari
		let tmpToggles = pContainer.querySelectorAll('.uv-mode-toggle');
		for (let i = 0; i < tmpToggles.length; i++)
		{
			tmpToggles[i].addEventListener('pointerdown', function (pEvent)
			{
				pEvent.stopPropagation();
				pEvent.preventDefault();
			});
			tmpToggles[i].addEventListener('pointerup', function (pEvent)
			{
				pEvent.stopPropagation();
				pEvent.preventDefault();

				let tmpFieldName = this.getAttribute('data-field');
				tmpSelf._cycleFieldMode(pContainer, tmpFieldName);
			});
		}

		// Instantiate ObjectEditors for Array/Object fields
		this._initObjectEditors(pContainer);

		// Wire input listeners for all existing editors
		this._wireInputListeners(pContainer);

		// Prevent pointer events from propagating to the SVG layer
		this._wirePointerIsolation(pContainer);
	}

	/**
	 * Stop pointer events on interactive elements from reaching the SVG canvas.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_wirePointerIsolation(pContainer)
	{
		let tmpElements = pContainer.querySelectorAll('input, textarea, button, select');
		for (let i = 0; i < tmpElements.length; i++)
		{
			tmpElements[i].addEventListener('pointerdown', function (pEvent)
			{
				pEvent.stopPropagation();
			});
		}
	}

	/**
	 * Initialize ObjectEditor views for Array/Object fields.
	 * Stores the field value into AppData and points the ObjectEditor at it.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_initObjectEditors(pContainer)
	{
		// Clean up any previously instantiated editors
		this._destroyObjectEditors();

		let tmpContainers = pContainer.querySelectorAll('.uv-objecteditor-container');

		for (let i = 0; i < tmpContainers.length; i++)
		{
			let tmpDiv = tmpContainers[i];
			let tmpFieldName = tmpDiv.getAttribute('data-field');
			let tmpState = this._FieldStates[tmpFieldName];

			if (!tmpState)
			{
				continue;
			}

			// Ensure the AppData staging area exists
			if (!this.fable.AppData._UVSettingsEditors)
			{
				this.fable.AppData._UVSettingsEditors = {};
			}

			// Parse string values into objects for the editor
			let tmpValue = tmpState.constantValue;
			if (typeof(tmpValue) === 'string' && tmpValue.trim().length > 0)
			{
				try
				{
					tmpValue = JSON.parse(tmpValue);
				}
				catch (pError)
				{
					// Keep as-is; editor will show null
					tmpValue = (tmpState.dataType === 'Array') ? [] : {};
				}
			}
			if (tmpValue === undefined || tmpValue === null || tmpValue === '')
			{
				tmpValue = (tmpState.dataType === 'Array') ? [] : {};
			}

			let tmpAppDataKey = 'OE_' + tmpFieldName;
			this.fable.AppData._UVSettingsEditors[tmpAppDataKey] = tmpValue;

			let tmpViewHash = 'UVObjEditor-' + tmpFieldName + '-' + Date.now();

			let tmpEditorView = this.fable.addView(
				tmpViewHash,
				{
					ViewIdentifier: tmpViewHash,
					AutoRender: false,
					ObjectDataAddress: 'AppData._UVSettingsEditors.' + tmpAppDataKey,
					Editable: true,
					InitialExpandDepth: 2
				},
				libPictSectionObjectEditor
			);

			// addView does not call initialize(), so node type renderers are
			// not set up yet.  Calling initialize() triggers onBeforeInitialize()
			// which registers node type service providers and creates the
			// _NodeRenderers map that renderTree() depends on.
			tmpEditorView.initialize();

			// SVG foreignObject workaround: document.querySelectorAll can't find
			// elements inside foreignObject, so we bypass the normal render() path
			// and inject the tree container directly via DOM, then override
			// _getTreeElement to return a direct DOM reference.
			let tmpTreeId = 'ObjectEditor-Tree-' + tmpViewHash;
			tmpDiv.innerHTML = '<div class="pict-objecteditor" id="' + tmpTreeId + '"></div>';

			let tmpTreeElement = tmpDiv.querySelector('.pict-objecteditor');
			tmpEditorView._getTreeElement = function () { return tmpTreeElement; };

			this._ObjectEditors[tmpFieldName] = tmpViewHash;

			// Inject the ObjectEditor's CSS into the DOM
			this.fable.CSSMap.injectCSS();

			// Trigger initial expand and tree render
			tmpEditorView.onAfterInitialRender();
			tmpEditorView.renderTree();
		}
	}

	/**
	 * Destroy all active ObjectEditor instances and clean up AppData.
	 */
	_destroyObjectEditors()
	{
		let tmpFieldNames = Object.keys(this._ObjectEditors);

		for (let i = 0; i < tmpFieldNames.length; i++)
		{
			let tmpViewHash = this._ObjectEditors[tmpFieldNames[i]];

			if (this.fable.views[tmpViewHash])
			{
				// PictView does not have a destroy() method; just remove
				// the view from the service map so it can be garbage collected.
				delete this.fable.views[tmpViewHash];
			}
		}

		this._ObjectEditors = {};

		// Clean up AppData staging area
		if (this.fable.AppData._UVSettingsEditors)
		{
			delete this.fable.AppData._UVSettingsEditors;
		}
	}

	/**
	 * Attach change/input listeners to editor elements so field state
	 * is kept up to date as the user types.
	 *
	 * @param {HTMLElement} pContainer
	 */
	_wireInputListeners(pContainer)
	{
		let tmpSelf = this;

		// Text and number inputs
		let tmpTextInputs = pContainer.querySelectorAll('.uv-settings-input');
		for (let i = 0; i < tmpTextInputs.length; i++)
		{
			tmpTextInputs[i].addEventListener('input', function ()
			{
				let tmpFieldName = this.getAttribute('data-field');
				let tmpState = tmpSelf._FieldStates[tmpFieldName];

				if (!tmpState)
				{
					return;
				}

				if (tmpState.mode === 'address')
				{
					tmpState.addressValue = this.value;
				}
				else if (tmpState.dataType === 'Number')
				{
					tmpState.constantValue = this.value === '' ? '' : Number(this.value);
				}
				else
				{
					tmpState.constantValue = this.value;
				}
			});
		}

		// Checkbox inputs
		let tmpCheckboxes = pContainer.querySelectorAll('.uv-settings-input-bool');
		for (let i = 0; i < tmpCheckboxes.length; i++)
		{
			tmpCheckboxes[i].addEventListener('change', function ()
			{
				let tmpFieldName = this.getAttribute('data-field');
				let tmpState = tmpSelf._FieldStates[tmpFieldName];

				if (tmpState)
				{
					tmpState.constantValue = this.checked;
				}
			});
		}

		// (Array/Object fields use modal editor — no inline listeners needed)
	}

	/**
	 * Cycle a field to the next mode (constant → address → default → constant)
	 * and re-render just that field's editor + toggle button.
	 *
	 * @param {HTMLElement} pContainer
	 * @param {string} pFieldName
	 */
	_cycleFieldMode(pContainer, pFieldName)
	{
		let tmpState = this._FieldStates[pFieldName];

		if (!tmpState)
		{
			return;
		}

		// Find next mode in cycle
		let tmpCurrentIndex = _ModeCycle.indexOf(tmpState.mode);
		let tmpNextIndex = (tmpCurrentIndex + 1) % _ModeCycle.length;
		let tmpNewMode = _ModeCycle[tmpNextIndex];

		tmpState.mode = tmpNewMode;

		// Update the toggle button
		let tmpFieldContainer = pContainer.querySelector('.uv-settings-field[data-field-name="' + pFieldName + '"]');

		if (!tmpFieldContainer)
		{
			return;
		}

		let tmpToggle = tmpFieldContainer.querySelector('.uv-mode-toggle');
		if (tmpToggle)
		{
			// Update CSS class
			tmpToggle.className = 'uv-mode-toggle uv-mode-' + tmpNewMode;
			// Update label
			tmpToggle.textContent = _ModeLabels[tmpNewMode] || 'C';
			// Update tooltip
			tmpToggle.title = _ModeTitles[tmpNewMode] || '';
		}

		// If leaving constant mode for an Array/Object field, save the editor value back
		if (tmpState.mode !== 'constant' && (tmpState.dataType === 'Array' || tmpState.dataType === 'Object'))
		{
			let tmpAppDataKey = 'OE_' + pFieldName;
			if (this.fable.AppData._UVSettingsEditors && this.fable.AppData._UVSettingsEditors.hasOwnProperty(tmpAppDataKey))
			{
				tmpState.constantValue = this.fable.AppData._UVSettingsEditors[tmpAppDataKey];
			}
			// Remove the editor for this field
			if (this._ObjectEditors[pFieldName])
			{
				let tmpViewHash = this._ObjectEditors[pFieldName];
				if (this.fable.views[tmpViewHash])
				{
					delete this.fable.views[tmpViewHash];
				}
				delete this._ObjectEditors[pFieldName];
			}
		}

		// Re-render the editor area
		let tmpEditorContainer = tmpFieldContainer.querySelector('.uv-settings-field-editor');
		if (tmpEditorContainer)
		{
			tmpEditorContainer.innerHTML = this._renderFieldEditor(pFieldName, tmpState);

			// Re-wire listeners on new elements
			this._wireInputListeners(tmpEditorContainer);
			this._wirePointerIsolation(tmpEditorContainer);

			// If entering constant mode for Array/Object, init the ObjectEditor
			if (tmpState.mode === 'constant' && (tmpState.dataType === 'Array' || tmpState.dataType === 'Object'))
			{
				this._initObjectEditors(pContainer);
			}
		}
	}

	// ====================================================================
	// Marshal
	// ====================================================================

	/**
	 * Marshal data from the panel UI back into the node's Data object.
	 *
	 * @param {Object} pNodeData
	 */
	marshalFromPanel(pNodeData)
	{
		if (!pNodeData || !this._FieldStates)
		{
			return;
		}

		if (!pNodeData.Data)
		{
			pNodeData.Data = {};
		}

		let tmpFieldModes = {};
		let tmpHasNonDefault = false;

		let tmpFieldNames = Object.keys(this._FieldStates);

		for (let i = 0; i < tmpFieldNames.length; i++)
		{
			let tmpFieldName = tmpFieldNames[i];
			let tmpState = this._FieldStates[tmpFieldName];

			switch (tmpState.mode)
			{
				case 'constant':
				{
					let tmpValue = tmpState.constantValue;

					// For Array/Object fields, read live data from the ObjectEditor's AppData address
					if (tmpState.dataType === 'Array' || tmpState.dataType === 'Object')
					{
						let tmpAppDataKey = 'OE_' + tmpFieldName;
						if (this.fable.AppData._UVSettingsEditors && this.fable.AppData._UVSettingsEditors.hasOwnProperty(tmpAppDataKey))
						{
							tmpValue = this.fable.AppData._UVSettingsEditors[tmpAppDataKey];
						}
						else if (typeof(tmpValue) === 'string')
						{
							// Fallback: parse JSON string
							let tmpTrimmed = tmpValue.trim();
							if (tmpTrimmed.length > 0)
							{
								try
								{
									tmpValue = JSON.parse(tmpTrimmed);
								}
								catch (pParseError)
								{
									// Keep as raw string
								}
							}
						}
					}

					pNodeData.Data[tmpFieldName] = tmpValue;
					tmpFieldModes[tmpFieldName] = 'constant';
					tmpHasNonDefault = true;
					break;
				}

				case 'address':
				{
					let tmpAddress = (typeof(tmpState.addressValue) === 'string') ? tmpState.addressValue.trim() : '';
					pNodeData.Data[tmpFieldName] = this._buildTemplateFromAddress(tmpAddress);
					tmpFieldModes[tmpFieldName] = 'address';
					tmpHasNonDefault = true;
					break;
				}

				case 'default':
				{
					// Remove the field so the task falls back to its built-in default
					delete pNodeData.Data[tmpFieldName];
					// Not added to _FieldModes — absent means 'default'
					break;
				}
			}
		}

		// Store _FieldModes metadata if any field is non-default
		if (tmpHasNonDefault)
		{
			pNodeData.Data._FieldModes = tmpFieldModes;
		}
		else
		{
			delete pNodeData.Data._FieldModes;
		}
	}

	// ====================================================================
	// Destroy
	// ====================================================================

	destroy()
	{
		this._destroyObjectEditors();
		this._Schema = null;
		this._Defaults = null;
		this._FieldStates = null;
		super.destroy();
	}

	// ====================================================================
	// Address Utilities
	// ====================================================================

	/**
	 * Extract a bare Manyfest address from a Pict template expression.
	 *
	 * '{~D:Record.Operation.InputFilePath~}' → 'Operation.InputFilePath'
	 *
	 * @param {*} pTemplateString
	 * @returns {string}
	 */
	_extractAddressFromTemplate(pTemplateString)
	{
		if (typeof(pTemplateString) !== 'string')
		{
			return '';
		}

		let tmpMatch = pTemplateString.match(/\{~D:Record\.(.+?)~\}/);
		return tmpMatch ? tmpMatch[1] : '';
	}

	/**
	 * Build a Pict template expression from a bare Manyfest address.
	 *
	 * 'Operation.InputFilePath' → '{~D:Record.Operation.InputFilePath~}'
	 *
	 * @param {string} pAddress
	 * @returns {string}
	 */
	_buildTemplateFromAddress(pAddress)
	{
		if (!pAddress || typeof(pAddress) !== 'string')
		{
			return '';
		}

		return '{~D:Record.' + pAddress + '~}';
	}

	// ====================================================================
	// Escape Utilities
	// ====================================================================

	_escapeHTML(pString)
	{
		if (typeof(pString) !== 'string')
		{
			return '';
		}

		return pString
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	_escapeAttr(pString)
	{
		if (typeof(pString) !== 'string')
		{
			return '';
		}

		return pString
			.replace(/&/g, '&amp;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	// ====================================================================
	// CSS Injection
	// ====================================================================

	_injectCSS()
	{
		if (this._CSSInjected)
		{
			return;
		}

		// Use the CSSMap service (same pattern as PictProvider-Flow-CSS)
		if (this.fable && this.fable.CSSMap)
		{
			this.fable.CSSMap.addCSS('UltravisorCardSettingsPanel', UltravisorCardSettingsPanel.CSS, 600, 'UltravisorCardSettingsPanel');
			this.fable.CSSMap.injectCSS();
			this._CSSInjected = true;
		}
		else
		{
			this.log.warn('UltravisorCardSettingsPanel: CSSMap not available; CSS not registered.');
		}
	}
}

// ========================================================================
// Static CSS
// ========================================================================

UltravisorCardSettingsPanel.CSS = [
'/* ── Ultravisor Card Settings Panel ───────────────────────────────── */',

'.uv-settings-panel {',
'	padding: 8px 10px;',
'}',

'/* Field container */',
'.uv-settings-field {',
'	margin-bottom: 10px;',
'	padding-bottom: 8px;',
'	border-bottom: 1px solid var(--pf-panel-titlebar-border, #343c44);',
'}',
'.uv-settings-field:last-child {',
'	border-bottom: none;',
'	margin-bottom: 0;',
'}',

'/* Field label */',
'.uv-settings-field-label {',
'	font-weight: 600;',
'	font-size: 0.82em;',
'	color: var(--pf-panel-text, #c8d0d8);',
'	margin-bottom: 4px;',
'}',
'.uv-settings-field-required {',
'	color: #c44e4e;',
'	margin-left: 1px;',
'	font-weight: 700;',
'}',

'/* Input row: toggle button + editor side by side */',
'.uv-settings-field-row {',
'	display: flex;',
'	align-items: flex-start;',
'	gap: 5px;',
'}',

'/* ── Mode toggle: single cycling button ─────────────────────────── */',
'.uv-mode-toggle {',
'	flex-shrink: 0;',
'	width: 22px;',
'	height: 24px;',
'	border: 1px solid var(--pf-panel-titlebar-border, #3a4450);',
'	background: var(--pf-panel-bg, #1e2228);',
'	color: #607080;',
'	font-size: 0.72em;',
'	font-style: italic;',
'	font-weight: 700;',
'	cursor: pointer;',
'	border-radius: 3px;',
'	padding: 0;',
'	line-height: 24px;',
'	text-align: center;',
'	margin-top: 1px;',
'}',
'/* Mode-specific toggle colors (no :hover — causes compositor desync in SVG foreignObject) */',
'.uv-mode-toggle.uv-mode-constant {',
'	border-color: #5ab88a60;',
'	color: #5ab88a;',
'	background: #1a2820;',
'}',
'.uv-mode-toggle.uv-mode-address {',
'	border-color: #d4884a60;',
'	color: #d4884a;',
'	background: #2a1e14;',
'}',
'.uv-mode-toggle.uv-mode-default {',
'	border-color: var(--pf-panel-titlebar-border, #3a4450);',
'	color: #607080;',
'	background: var(--pf-panel-bg, #1e2228);',
'}',

'/* ── Editor area ────────────────────────────────────────────────── */',
'.uv-settings-field-editor {',
'	flex: 1;',
'	min-width: 0;',
'}',
'.uv-settings-input {',
'	width: 100%;',
'	box-sizing: border-box;',
'	padding: 4px 8px;',
'	height: 26px;',
'	border: 1px solid var(--pf-panel-titlebar-border, #343c44);',
'	background: var(--pf-panel-input-bg, #181c22);',
'	color: var(--pf-panel-text, #b8c4cc);',
'	border-radius: 3px;',
'	font-size: 0.82em;',
'	font-family: inherit;',
'}',
'.uv-settings-input:focus {',
'	border-color: #5a9ecb;',
'	outline: none;',
'}',
'/* ── ObjectEditor container (dark theme overrides) ──────────────── */',
'.uv-objecteditor-container {',
'	overflow: visible;',
'}',
'.uv-objecteditor-container .pict-objecteditor {',
'	background: var(--pf-panel-input-bg, #181c22);',
'	border-color: var(--pf-panel-titlebar-border, #343c44);',
'	color: var(--pf-panel-text, #b8c4cc);',
'	font-size: 12px;',
'	overflow: visible;',
'}',
'.uv-objecteditor-container .pict-oe-row:hover {',
'	background: #252a32;',
'}',
'.uv-objecteditor-container .pict-oe-key { color: #d4884a; }',
'.uv-objecteditor-container .pict-oe-value-string { color: #5ab88a; }',
'.uv-objecteditor-container .pict-oe-value-string::before,',
'.uv-objecteditor-container .pict-oe-value-string::after { color: #3a7a5a; }',
'.uv-objecteditor-container .pict-oe-value-number { color: #5a9ecb; }',
'.uv-objecteditor-container .pict-oe-value-boolean { color: #d4884a; }',
'.uv-objecteditor-container .pict-oe-value-null { color: #506070; }',
'.uv-objecteditor-container .pict-oe-summary { color: #506070; }',
'.uv-objecteditor-container .pict-oe-separator { color: #506070; }',
'.uv-objecteditor-container .pict-oe-toggle { color: #607080; }',
'.uv-objecteditor-container .pict-oe-toggle:hover { background: #2a3040; color: #b8c4cc; }',
'.uv-objecteditor-container .pict-oe-type-badge { background: #252a32; color: #607080; }',
'.uv-objecteditor-container .pict-oe-action-btn { background: #252a32; border-color: #343c44; color: #607080; }',
'.uv-objecteditor-container .pict-oe-action-btn:hover { background: #2a3040; border-color: #4a5460; color: #b8c4cc; }',
'.uv-objecteditor-container .pict-oe-action-remove { background: #2a1a1a; border-color: #4a2020; color: #c44e4e; }',
'.uv-objecteditor-container .pict-oe-action-remove:hover { background: #3a2020; }',
'.uv-objecteditor-container .pict-oe-action-add { background: #1a2a1a; border-color: #204a20; color: #5ab88a; }',
'.uv-objecteditor-container .pict-oe-action-add:hover { background: #203a20; }',
'.uv-objecteditor-container .pict-oe-value-input { background: #181c22; border-color: #5a9ecb; color: #b8c4cc; }',
'.uv-objecteditor-container .pict-oe-key-input { background: #181c22; border-color: #d4884a; color: #d4884a; }',
'.uv-objecteditor-container .pict-oe-empty { color: #506070; }',
'.uv-settings-checkbox {',
'	display: flex;',
'	align-items: center;',
'	gap: 6px;',
'	height: 24px;',
'	color: var(--pf-panel-text, #b8c4cc);',
'	font-size: 0.82em;',
'	cursor: pointer;',
'}',
'.uv-settings-checkbox input[type="checkbox"] {',
'	accent-color: #5ab88a;',
'}',

'/* Address mode styling */',
'.uv-settings-address-input {',
'	border-color: #d4884a40;',
'	font-style: italic;',
'}',
'.uv-settings-address-input:focus {',
'	border-color: #d4884a;',
'}',

'/* Default mode */',
'.uv-settings-default-display {',
'	padding: 4px 8px;',
'	height: 24px;',
'	line-height: 16px;',
'	background: transparent;',
'	border: 1px dashed var(--pf-panel-titlebar-border, #343c44);',
'	border-radius: 3px;',
'	color: var(--pf-text-tertiary, #506878);',
'	font-size: 0.78em;',
'	font-style: italic;',
'}',

'/* Description */',
'.uv-settings-field-description {',
'	font-size: 0.68em;',
'	color: var(--pf-text-tertiary, #506070);',
'	margin-top: 3px;',
'	padding-left: 27px;',
'	line-height: 1.3;',
'}'
].join('\n');

module.exports = UltravisorCardSettingsPanel;

module.exports.default_configuration = Object.assign(
	{},
	libPictFlowCardPropertiesPanel.default_configuration,
	{
		PanelType: 'UltravisorSettings',
		Configuration:
		{
			Schema: [],
			Defaults: {}
		}
	}
);

},{"pict-section-flow/source/PictFlowCardPropertiesPanel.js":30,"pict-section-objecteditor":155}],252:[function(require,module,exports){
module.exports={
	"ProviderIdentifier": "Pict-Router",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"Routes":
	[
		{
			"path": "/Home",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Dashboard`)~}"
		},
		{
			"path": "/Operations",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-OperationList`)~}"
		},
		{
			"path": "/OperationEdit",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-OperationEdit`)~}"
		},
		{
			"path": "/Schedule",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Schedule`)~}"
		},
		{
			"path": "/Manifests/detail/:runHash",
			"template": "{~LV:Pict.PictApplication.showManifestDetail(Record.data.runHash)~}"
		},
		{
			"path": "/Manifests/:filter",
			"template": "{~LV:Pict.PictApplication.showManifestsFiltered(Record.data.filter)~}"
		},
		{
			"path": "/Manifests",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-ManifestList`)~}"
		},
		{
			"path": "/PendingInput",
			"template": "{~LV:Pict.PictApplication.showManifestsFiltered(`waiting`)~}"
		},
		{
			"path": "/Beacons",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-BeaconList`)~}"
		},
		{
			"path": "/Timeline",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Timeline`)~}"
		},
		{
			"path": "/Capabilities",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-CapabilityHeatMap`)~}"
		},
		{
			"path": "/Throughput",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Throughput`)~}"
		},
		{
			"path": "/Constellation",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Constellation`)~}"
		},
		{
			"path": "/Fleet",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Fleet`)~}"
		},
		{
			"path": "/Timing",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-TimingView`)~}"
		},
		{
			"path": "/FlowEditor/:hash",
			"template": "{~LV:Pict.PictApplication.editOperationFromRoute(Record.data.hash)~}"
		},
		{
			"path": "/FlowEditor",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-FlowEditor`)~}"
		},
		{
			"path": "/Docs",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Documentation`)~}"
		},
		{
			"path": "/Login",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Login`)~}"
		},
		{
			"path": "/Users",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-UserManagement`)~}"
		}
	]
}

},{}],253:[function(require,module,exports){
/**
 * Provider-Timeline-Stream
 *
 * Owns the `/Timeline` long-poll cycle and reconciles the response into
 * AppData.Timeline.Stream. Views observe AppData and re-render; the
 * provider does not touch the DOM.
 *
 * Public API:
 *   startLive(pView)       — open the long-poll cycle in live mode.
 *                            pView is the subscriber that wants render
 *                            callbacks (see _notify).
 *   pauseToReplay(pFromIso, pToIso)
 *                          — stop live cycle, do one fixed-window fetch.
 *   resumeLive()           — return to live mode (re-resolves now-relative
 *                            from/to).
 *   refresh()              — force a single fetch in current mode.
 *   stop()                 — stop everything (called when leaving the view).
 *
 * AppData written:
 *   AppData.Timeline.Window  = { FromIso, ToIso, Mode, Bucket }
 *   AppData.Timeline.Stream  = { Past, Present, Future, Buckets, Cursor, More, Now, FetchedAt }
 *   AppData.Timeline.Status  = 'idle' | 'loading' | 'error' | 'stale'
 *   AppData.Timeline.Error   = string | null
 *
 * Mode logic:
 *   - 'live': uses relative from/to (e.g. 'now-2m', 'now+30s'); long-
 *     polls with waitMs=15000; on each response (event arrived OR
 *     timeout), recomputes the URL with fresh now-relative values and
 *     re-issues. Window slides automatically.
 *   - 'replay': uses fixed ISO from/to; one fetch with waitMs=0; no loop.
 *
 * Stale-cursor 410: the endpoint returns 410 Gone when the requested
 * `since` aged out of the ring. The provider switches to no-cursor
 * fetch so the response carries the freshest available state, toasts
 * the user, and resumes long-poll.
 *
 * Phase 5 endpoint contract: GET /Timeline?from=&to=&waitMs=&bucket=&capability=&runHash=&futureLimit=
 */

const libPictProvider = require('pict-provider');

const _ProviderConfiguration =
{
	ProviderIdentifier: 'Timeline-Stream',
	AutoInitialize:     true,
	AutoInitializeOrdinal: 100,

	// Long-poll wait window. The endpoint clamps to 60000; 15000 keeps
	// connection turnover frequent enough to recover quickly from a UV
	// restart while not pegging the server with reconnects.
	LongPollWaitMs: 15000,

	// Minimum interval between live-mode fetches. The /Timeline endpoint
	// returns immediately when the window has any content (which is
	// "always" against an active fleet), so without this throttle the
	// fetch loop hot-spins. 750ms gives near-real-time updates without
	// flooding the server.
	MinLiveFetchIntervalMs: 750,

	// Default relative window for live mode. The view can override per
	// page load via the URL `from` / `to` query params; this is the
	// fallback when nothing is specified.
	DefaultLiveFrom: 'now-2m',
	DefaultLiveTo:   'now+30s',

	// Default future projection limit per capability. The endpoint caps
	// to 256; 32 is a reasonable default that keeps the view from
	// rendering ETA-unknown ghosts deeper than is useful.
	DefaultFutureLimit: 32
};

class TimelineStreamProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._View = null;            // current subscriber view (for re-render notify)
		this._Mode = 'idle';          // 'live' | 'replay' | 'idle'
		this._AbortController = null; // for canceling in-flight fetch on mode switch
		this._LoopActive = false;
		this._FetchSerial = 0;        // monotonic, used to ignore stale responses
		this._LastFetchAt = 0;        // ms epoch of last successful fetch (for min-interval throttle)
		this._NextFetchTimer = null;  // setTimeout handle for delayed re-fetch

		// Initialize AppData branch.
		if (!this.pict.AppData.Timeline)
		{
			this.pict.AppData.Timeline = {};
		}
		this.pict.AppData.Timeline.Window =
		{
			FromIso: this.options.DefaultLiveFrom,
			ToIso:   this.options.DefaultLiveTo,
			Mode:    'live',
			Bucket:  'auto'
		};
		this.pict.AppData.Timeline.Stream =
		{
			Past: [], Present: [], Future: [], Buckets: null,
			Cursor: '', More: false, Now: null, FetchedAt: null
		};
		this.pict.AppData.Timeline.Status = 'idle';
		this.pict.AppData.Timeline.Error  = null;

		// Single-element-array conditional slots for live/replay
		// indicator (per modules/pict/CLAUDE.md).
		this.pict.AppData.Timeline.LiveSlot      = [{}];   // populated when live
		this.pict.AppData.Timeline.ReplaySlot    = [];     // populated when replay
		this.pict.AppData.Timeline.EmptySlot     = [];     // populated when no events
		this.pict.AppData.Timeline.FocusSlot     = [];     // populated when non-runHash focus
		this.pict.AppData.Timeline.WaterfallSlot = [];     // populated when runHash focus
	}

	// ====================================================================
	// Public API
	// ====================================================================

	startLive(pView)
	{
		this._View = pView || this._View;
		this._Mode = 'live';
		this.pict.AppData.Timeline.Window.Mode = 'live';
		this._setSlots('live');
		this._LoopActive = true;
		this._fetchOnce();
	}

	pauseToReplay(pFromIso, pToIso)
	{
		this._Mode = 'replay';
		this._LoopActive = false;
		this._abortInFlight();
		this.pict.AppData.Timeline.Window.Mode    = 'replay';
		this.pict.AppData.Timeline.Window.FromIso = pFromIso || this.pict.AppData.Timeline.Window.FromIso;
		this.pict.AppData.Timeline.Window.ToIso   = pToIso   || this.pict.AppData.Timeline.Window.ToIso;
		this._setSlots('replay');
		this._fetchOnce();
	}

	resumeLive()
	{
		this._abortInFlight();
		this.pict.AppData.Timeline.Window.FromIso = this.options.DefaultLiveFrom;
		this.pict.AppData.Timeline.Window.ToIso   = this.options.DefaultLiveTo;
		this.startLive(this._View);
	}

	refresh()
	{
		this._fetchOnce();
	}

	stop()
	{
		this._Mode = 'idle';
		this._LoopActive = false;
		this._abortInFlight();
	}

	setView(pView)
	{
		this._View = pView;
	}

	setBucket(pBucket)
	{
		this.pict.AppData.Timeline.Window.Bucket = pBucket || 'auto';
		this._fetchOnce();
	}

	// ====================================================================
	// Internals
	// ====================================================================

	_setSlots(pMode)
	{
		// Per modules/pict/CLAUDE.md: conditionals via single-element-array
		// driving {~TS:~}. Empty array → nothing rendered; one entry →
		// the corresponding template fragment renders once.
		if (pMode === 'live')
		{
			this.pict.AppData.Timeline.LiveSlot   = [{}];
			this.pict.AppData.Timeline.ReplaySlot = [];
		}
		else if (pMode === 'replay')
		{
			this.pict.AppData.Timeline.LiveSlot   = [];
			this.pict.AppData.Timeline.ReplaySlot = [{}];
		}
		else
		{
			this.pict.AppData.Timeline.LiveSlot   = [];
			this.pict.AppData.Timeline.ReplaySlot = [];
		}
	}

	_abortInFlight()
	{
		if (this._AbortController)
		{
			try { this._AbortController.abort(); }
			catch (pErr) { /* best effort */ }
			this._AbortController = null;
		}
		if (this._NextFetchTimer)
		{
			clearTimeout(this._NextFetchTimer);
			this._NextFetchTimer = null;
		}
	}

	// Throttled fetch scheduler — never fires more than once per
	// MinLiveFetchIntervalMs in live mode.
	_scheduleNextLiveFetch()
	{
		if (this._NextFetchTimer) return;
		let tmpElapsed = Date.now() - this._LastFetchAt;
		let tmpDelay = Math.max(0, this.options.MinLiveFetchIntervalMs - tmpElapsed);
		this._NextFetchTimer = setTimeout(function ()
		{
			this._NextFetchTimer = null;
			if (this._Mode === 'live' && this._LoopActive)
			{
				this._fetchOnce();
			}
		}.bind(this), tmpDelay);
	}

	_buildURL()
	{
		let tmpW = this.pict.AppData.Timeline.Window;
		let tmpBase = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.APIBaseURL) || '';
		let tmpParams = [];
		tmpParams.push('from=' + encodeURIComponent(tmpW.FromIso));
		tmpParams.push('to=' + encodeURIComponent(tmpW.ToIso));
		tmpParams.push('bucket=' + encodeURIComponent(tmpW.Bucket || 'auto'));
		tmpParams.push('futureLimit=' + this.options.DefaultFutureLimit);
		if (this._Mode === 'live')
		{
			tmpParams.push('waitMs=' + this.options.LongPollWaitMs);
			let tmpCursor = this.pict.AppData.Timeline.Stream.Cursor || '';
			if (tmpCursor)
			{
				tmpParams.push('cursor=' + encodeURIComponent(tmpCursor));
			}
		}
		else
		{
			tmpParams.push('waitMs=0');
		}
		return tmpBase + '/Timeline?' + tmpParams.join('&');
	}

	_fetchOnce()
	{
		this._abortInFlight();
		let tmpController = (typeof AbortController !== 'undefined') ? new AbortController() : null;
		this._AbortController = tmpController;

		let tmpURL = this._buildURL();
		this.pict.AppData.Timeline.Status = 'loading';
		this.pict.AppData.Timeline.Error = null;

		let tmpSerial = ++this._FetchSerial;

		fetch(tmpURL, { signal: tmpController ? tmpController.signal : undefined })
			.then(function (pResponse)
			{
				if (pResponse.status === 410)
				{
					return pResponse.json().then(function (pBody)
					{
						return { _stale: true, body: pBody, status: 410 };
					});
				}
				if (!pResponse.ok)
				{
					throw new Error('HTTP ' + pResponse.status);
				}
				return pResponse.json().then(function (pBody)
				{
					return { _stale: false, body: pBody, status: pResponse.status };
				});
			})
			.then(function (pPayload)
			{
				// Ignore stale responses from before a mode switch.
				if (tmpSerial !== this._FetchSerial) { return; }

				if (pPayload._stale)
				{
					this._handleStaleCursor(pPayload.body);
					return;
				}

				this._reconcile(pPayload.body);

				// If still in live mode, fire next long-poll cycle.
				if (this._Mode === 'live' && this._LoopActive)
				{
					// Throttle: the endpoint returns immediately when
					// the window has any content (typical against an
					// active fleet), so without a min-interval we'd
					// hot-loop. Queue the next fetch on a debounced
					// timer rather than firing immediately.
					this._scheduleNextLiveFetch();
				}
			}.bind(this))
			.catch(function (pError)
			{
				if (pError && pError.name === 'AbortError') { return; }
				if (tmpSerial !== this._FetchSerial) { return; }
				this.pict.log.warn('Timeline-Stream: fetch failed: ' + pError.message);
				this.pict.AppData.Timeline.Status = 'error';
				this.pict.AppData.Timeline.Error = pError.message || 'fetch failed';
				this._notify();

				// Back off on error in live mode — retry in 5s rather
				// than hot-looping against a broken UV.
				if (this._Mode === 'live' && this._LoopActive)
				{
					setTimeout(function ()
					{
						if (this._Mode === 'live' && this._LoopActive)
						{
							this._fetchOnce();
						}
					}.bind(this), 5000);
				}
			}.bind(this));
	}

	_reconcile(pBody)
	{
		this._LastFetchAt = Date.now();
		// pBody shape: { From, To, Now, Past[], Present[], Future[], Buckets, Cursor, More }
		let tmpStream = this.pict.AppData.Timeline.Stream;
		tmpStream.Past    = Array.isArray(pBody.Past)    ? pBody.Past    : [];
		tmpStream.Present = Array.isArray(pBody.Present) ? pBody.Present : [];
		tmpStream.Future  = Array.isArray(pBody.Future)  ? pBody.Future  : [];
		tmpStream.Buckets = Array.isArray(pBody.Buckets) ? pBody.Buckets : null;
		tmpStream.Cursor  = pBody.Cursor || '';
		tmpStream.More    = !!pBody.More;
		tmpStream.Now     = pBody.Now || new Date().toISOString();
		tmpStream.FetchedAt = new Date().toISOString();

		// In live mode, the server's resolved From/To may have shifted
		// — store the resolved values so the renderer's X-axis math is
		// correct.
		if (pBody.From) { this.pict.AppData.Timeline.Window.FromIso = pBody.From; }
		if (pBody.To)   { this.pict.AppData.Timeline.Window.ToIso   = pBody.To; }

		// Empty-state slot for the template (single-element-array trick).
		let tmpAnyContent =
			tmpStream.Past.length > 0
			|| tmpStream.Present.length > 0
			|| tmpStream.Future.length > 0
			|| (tmpStream.Buckets && tmpStream.Buckets.length > 0);
		this.pict.AppData.Timeline.EmptySlot = tmpAnyContent ? [] : [{}];

		// Capability + Beacon row index (computed here, not in the
		// view's render — keeps the view's onAfterRender simpler and
		// the data shape testable).
		this._indexCapabilityRows();
		this._indexBeaconRows();

		this.pict.AppData.Timeline.Status = 'idle';
		this._notify();
	}

	_handleStaleCursor(pBody)
	{
		// Cursor aged out of the ring buffer. Drop the cursor and
		// re-fetch with an empty cursor so the response carries the
		// freshest available state. Toast the user.
		this.pict.AppData.Timeline.Stream.Cursor = '';
		let tmpReason = (pBody && pBody.Hint) || 'history-too-old';
		try
		{
			let tmpModal = this.pict.views['Pict-Section-Modal']
				|| this.pict.views['Modal'];
			if (tmpModal && typeof tmpModal.toast === 'function')
			{
				tmpModal.toast('Timeline cursor scrolled past the buffer; re-snapping to current state.',
					{ type: 'info', duration: 4000 });
			}
		}
		catch (pErr) { /* best effort */ }
		this.pict.log.info('Timeline-Stream: cursor stale (' + tmpReason + '); refetching');
		// Immediate retry without cursor.
		this._fetchOnce();
	}

	_indexCapabilityRows()
	{
		// Build the unique sorted list of capabilities seen in the
		// current window. The renderer uses this to lay out the middle
		// band's swimlanes.
		let tmpSet = new Set();
		let tmpStream = this.pict.AppData.Timeline.Stream;
		let tmpAdd = function (pRecords)
		{
			for (let i = 0; i < pRecords.length; i++)
			{
				let tmpC = pRecords[i] && pRecords[i].Capability;
				if (tmpC) { tmpSet.add(tmpC); }
			}
		};
		tmpAdd(tmpStream.Past);
		tmpAdd(tmpStream.Present);
		tmpAdd(tmpStream.Future);
		let tmpArr = Array.from(tmpSet).sort();
		this.pict.AppData.Timeline.CapabilityRows = tmpArr.map(function (pC)
		{
			return { Capability: pC };
		});
	}

	_indexBeaconRows()
	{
		// Build the unique sorted list of beacon IDs seen handling work
		// in the current window.
		let tmpSet = new Set();
		let tmpStream = this.pict.AppData.Timeline.Stream;
		let tmpAdd = function (pRecords)
		{
			for (let i = 0; i < pRecords.length; i++)
			{
				let tmpB = pRecords[i] && pRecords[i].BeaconID;
				if (tmpB) { tmpSet.add(tmpB); }
			}
		};
		tmpAdd(tmpStream.Past);
		tmpAdd(tmpStream.Present);
		let tmpArr = Array.from(tmpSet).sort();
		this.pict.AppData.Timeline.BeaconRows = tmpArr.map(function (pB)
		{
			// Strip the long suffix for display, keep BeaconID intact
			// for click-to-focus identity.
			let tmpShort = pB.length > 18 ? pB.slice(0, 18) + '…' : pB;
			return { BeaconID: pB, Display: tmpShort };
		});
	}

	_notify()
	{
		// View calls back into provider for `setView`, but the
		// provider doesn't directly call render() — it dispatches a
		// custom event that views listen for via onAfterRender state
		// observation, OR (simpler) the view's onAfterRender installs
		// a setInterval to read AppData. We pick the latter pattern
		// (per Pict idioms in BeaconList): the provider just updates
		// AppData; the view re-reads AppData on its own ticker.
		//
		// Held here as a hook in case we want to drive imperative
		// canvas redraws explicitly later. For now, no-op.
		if (this._View && typeof this._View.onTimelineUpdated === 'function')
		{
			try { this._View.onTimelineUpdated(); }
			catch (pErr) { this.pict.log.warn('Timeline-Stream: view notify threw: ' + pErr.message); }
		}
	}
}

module.exports = TimelineStreamProvider;
module.exports.default_configuration = _ProviderConfiguration;

},{"pict-provider":19}],254:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-BeaconList",

	DefaultRenderable: "Ultravisor-BeaconList-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-beaconlist {
			padding: 2em;
			max-width: 1400px;
			margin: 0 auto;
		}
		.ultravisor-beaconlist-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1.5em;
			padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-beaconlist-header h1 {
			margin: 0;
			font-size: 2em;
			font-weight: 300;
			color: var(--uv-text);
		}

		/* Summary bar */
		.ultravisor-beacon-summary {
			display: flex;
			gap: 1em;
			margin-bottom: 1.5em;
		}
		.ultravisor-beacon-summary-card {
			display: flex;
			align-items: center;
			gap: 0.5em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			padding: 0.6em 1.2em;
		}
		.ultravisor-beacon-summary-count {
			font-size: 1.5em;
			font-weight: 700;
			color: var(--uv-text);
		}
		.ultravisor-beacon-summary-label {
			font-size: 0.8em;
			color: var(--uv-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.5px;
		}
		.ultravisor-beacon-summary-card.online .ultravisor-beacon-summary-count {
			color: var(--uv-success);
		}
		.ultravisor-beacon-summary-card.busy .ultravisor-beacon-summary-count {
			color: var(--uv-info);
		}
		.ultravisor-beacon-summary-card.offline .ultravisor-beacon-summary-count {
			color: var(--uv-text-tertiary);
		}

		/* Beacon table */
		.ultravisor-beacon-table {
			width: 100%;
			border-collapse: collapse;
		}
		.ultravisor-beacon-table th {
			background-color: var(--uv-bg-surface);
			text-align: left;
			padding: 0.6em 0.75em;
			font-size: 0.8em;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			color: var(--uv-text-secondary);
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-beacon-table td {
			padding: 0.6em 0.75em;
			border-bottom: 1px solid var(--uv-border-subtle);
			font-size: 0.9em;
		}
		.ultravisor-beacon-table tr:hover td {
			background-color: var(--uv-table-row-hover);
		}

		/* Status badge */
		.ultravisor-beacon-status {
			display: inline-flex;
			align-items: center;
			gap: 0.4em;
			padding: 0.15em 0.6em;
			border-radius: 3px;
			font-size: 0.8em;
			font-weight: 600;
		}
		.ultravisor-beacon-status-dot {
			width: 7px;
			height: 7px;
			border-radius: 50%;
			display: inline-block;
		}
		.ultravisor-beacon-status.online {
			background-color: #1b5e20;
			color: #a5d6a7;
		}
		.ultravisor-beacon-status.online .ultravisor-beacon-status-dot {
			background-color: #66bb6a;
		}
		.ultravisor-beacon-status.busy {
			background-color: #0d47a1;
			color: #90caf9;
		}
		.ultravisor-beacon-status.busy .ultravisor-beacon-status-dot {
			background-color: #42a5f5;
		}
		.ultravisor-beacon-status.offline {
			background-color: #424242;
			color: #9e9e9e;
		}
		.ultravisor-beacon-status.offline .ultravisor-beacon-status-dot {
			background-color: #757575;
		}

		/* Capability tags */
		.ultravisor-beacon-cap-tag {
			display: inline-block;
			padding: 0.1em 0.5em;
			border-radius: 10px;
			font-size: 0.75em;
			font-weight: 600;
			background-color: var(--uv-bg-elevated);
			color: var(--uv-brand);
			border: 1px solid var(--uv-border-subtle);
			margin-right: 0.3em;
			margin-bottom: 0.2em;
		}

		/* Detail panel */
		.ultravisor-beacon-detail {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			padding: 1.5em;
			margin-top: 1em;
			display: none;
		}
		.ultravisor-beacon-detail.visible {
			display: block;
		}
		.ultravisor-beacon-detail h3 {
			margin: 0 0 0.75em 0;
			color: var(--uv-text-secondary);
			font-weight: 400;
		}
		.ultravisor-beacon-detail-grid {
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			gap: 1em;
			margin-bottom: 1em;
		}
		.ultravisor-beacon-detail-field {
			background: var(--uv-bg-base);
			border-radius: 4px;
			padding: 0.6em 0.8em;
		}
		.ultravisor-beacon-detail-field-label {
			font-size: 0.7em;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			color: var(--uv-text-tertiary);
			margin-bottom: 0.2em;
		}
		.ultravisor-beacon-detail-field-value {
			font-size: 0.9em;
			color: var(--uv-text);
			word-break: break-all;
		}
		.ultravisor-beacon-detail-field-value code {
			color: var(--uv-brand);
			font-size: 0.85em;
		}

		/* Section headers */
		.ultravisor-beacon-section {
			margin-top: 2em;
		}
		.ultravisor-beacon-section-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1em;
			padding-bottom: 0.5em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-beacon-section-header h2 {
			margin: 0;
			font-size: 1.4em;
			font-weight: 300;
			color: var(--uv-text);
		}

		/* Work item status */
		.ultravisor-workitem-status {
			display: inline-block;
			padding: 0.15em 0.5em;
			border-radius: 3px;
			font-size: 0.8em;
			font-weight: 600;
		}
		.ultravisor-workitem-status.pending {
			background-color: #e65100;
			color: #ffe0b2;
		}
		.ultravisor-workitem-status.assigned {
			background-color: #4527a0;
			color: #d1c4e9;
		}
		.ultravisor-workitem-status.running {
			background-color: var(--uv-info);
			color: var(--uv-text-heading);
		}
		.ultravisor-workitem-status.complete {
			background-color: #2e7d32;
			color: #c8e6c9;
		}
		.ultravisor-workitem-status.error {
			background-color: #c62828;
			color: #ffcdd2;
		}
		.ultravisor-workitem-status.timeout {
			background-color: #f57f17;
			color: #fff9c4;
		}

		/* Progress bar */
		.ultravisor-workitem-progress {
			display: flex;
			align-items: center;
			gap: 0.5em;
		}
		.ultravisor-workitem-progress-bar {
			width: 60px;
			height: 6px;
			background-color: var(--uv-bg-base);
			border-radius: 3px;
			overflow: hidden;
		}
		.ultravisor-workitem-progress-fill {
			height: 100%;
			background-color: var(--uv-brand);
			border-radius: 3px;
			transition: width 0.3s;
		}
		.ultravisor-workitem-progress-text {
			font-size: 0.75em;
			color: var(--uv-text-secondary);
		}

		/* Empty state */
		.ultravisor-beacon-empty {
			text-align: center;
			padding: 3em;
			color: var(--uv-text-tertiary);
			font-size: 0.95em;
		}

		/* Auto-refresh indicator */
		.ultravisor-beacon-refresh-indicator {
			font-size: 0.75em;
			color: var(--uv-text-tertiary);
			display: flex;
			align-items: center;
			gap: 0.4em;
		}
		.ultravisor-beacon-refresh-dot {
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background-color: var(--uv-success);
			animation: ultravisor-pulse 2s ease-in-out infinite;
		}
		@keyframes ultravisor-pulse {
			0%, 100% { opacity: 1; }
			50% { opacity: 0.3; }
		}

		/* Queue snapshot — live counters + per-capability table.
		   Mirrors ultravisor-lab's Queue Lab tab so cross-checking
		   the same UV from both UIs is a glance comparison. */
		.uv-queue-snap-tag {
			margin-left: auto;
			font-size: 0.75em;
			color: var(--uv-text-tertiary);
			font-weight: 400;
		}
		.uv-queue-snap-buckets {
			display: grid;
			grid-template-columns: repeat(5, 1fr);
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			overflow: hidden;
		}
		.uv-queue-snap-bucket {
			padding: 1em;
			text-align: center;
			border-right: 1px solid var(--uv-border-subtle);
		}
		.uv-queue-snap-bucket:last-child { border-right: none; }
		.uv-queue-snap-bucket .uv-queue-snap-value {
			font-size: 1.8em;
			font-weight: 600;
			color: var(--uv-text);
		}
		.uv-queue-snap-bucket .uv-queue-snap-label {
			font-size: 0.7em;
			color: var(--uv-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.5px;
			margin-top: 0.3em;
		}
		.uv-queue-snap-bucket.bucket-upcoming   .uv-queue-snap-value { color: #e65100; }
		.uv-queue-snap-bucket.bucket-inprogress .uv-queue-snap-value { color: var(--uv-info); }
		.uv-queue-snap-bucket.bucket-stalled    .uv-queue-snap-value { color: #f57f17; }
		.uv-queue-snap-bucket.bucket-completed  .uv-queue-snap-value { color: var(--uv-success); }
		.uv-queue-snap-bucket.bucket-errored    .uv-queue-snap-value { color: var(--uv-error, #c62828); }

		.uv-queue-snap-bycap {
			margin-top: 0.75em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			overflow: hidden;
		}
		.uv-queue-snap-bycap table { width: 100%; border-collapse: collapse; font-size: 0.85em; }
		.uv-queue-snap-bycap th, .uv-queue-snap-bycap td {
			padding: 0.5em 1em;
			text-align: left;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.uv-queue-snap-bycap th {
			color: var(--uv-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.5px;
			font-size: 0.7em;
			font-weight: 600;
			background: var(--uv-bg-base);
		}
		.uv-queue-snap-bycap tr:last-child td { border-bottom: none; }
		.uv-queue-snap-bycap .uv-queue-snap-empty {
			padding: 1em;
			text-align: center;
			color: var(--uv-text-tertiary);
			font-size: 0.85em;
		}
		.uv-queue-snap-source {
			margin-left: 0.6em;
			font-size: 0.65em;
			color: var(--uv-text-tertiary);
			font-weight: 400;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			padding: 0.1em 0.5em;
			border-radius: 3px;
			background: var(--uv-bg-base);
		}
		.uv-queue-snap-source.live { color: var(--uv-success); }
		.uv-queue-snap-source.stale { color: var(--uv-text-tertiary); }
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-BeaconList-Template",
			Template: /*html*/`
<div class="ultravisor-beaconlist">
	<div class="ultravisor-beaconlist-header">
		<h1>Beacons</h1>
		<div style="display:flex; align-items:center; gap:1em;">
			<div class="ultravisor-beacon-refresh-indicator">
				<span class="ultravisor-beacon-refresh-dot"></span>
				<span>Auto-refresh</span>
			</div>
			<button class="ultravisor-btn ultravisor-btn-secondary" onclick="{~P~}.views['Ultravisor-BeaconList'].refreshAll()">Refresh</button>
		</div>
	</div>
	<div id="Ultravisor-BeaconList-Summary"></div>
	<div id="Ultravisor-BeaconList-Body"></div>
	<div id="Ultravisor-BeaconList-Detail"></div>
	<div class="ultravisor-beacon-section">
		<div class="ultravisor-beacon-section-header">
			<h2>Reachability Map</h2>
			<button class="ultravisor-btn ultravisor-btn-secondary" onclick="{~P~}.views['Ultravisor-BeaconList'].probeAll()">Probe All</button>
		</div>
		<div id="Ultravisor-BeaconList-ReachabilityMap"></div>
	</div>
	<div class="ultravisor-beacon-section" id="Ultravisor-BeaconList-QueueSnapshot-Section">
		<div class="ultravisor-beacon-section-header">
			<h2>Queue Snapshot <span id="Ultravisor-BeaconList-QueueSnapshot-Source" class="uv-queue-snap-source stale">REST</span></h2>
			<span id="Ultravisor-BeaconList-QueueSnapshot-Tag" class="uv-queue-snap-tag">no data yet</span>
		</div>
		<div id="Ultravisor-BeaconList-QueueSnapshot"></div>
	</div>
	<div class="ultravisor-beacon-section" id="Ultravisor-BeaconList-WorkQueue-Section">
		<div class="ultravisor-beacon-section-header">
			<h2>Work Queue</h2>
		</div>
		<div id="Ultravisor-BeaconList-WorkQueue"></div>
	</div>
	<div class="ultravisor-beacon-section" id="Ultravisor-BeaconList-Affinity-Section">
		<div class="ultravisor-beacon-section-header">
			<h2>Affinity Bindings</h2>
		</div>
		<div id="Ultravisor-BeaconList-Affinity"></div>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-BeaconList-Content",
			TemplateHash: "Ultravisor-BeaconList-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorBeaconListView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._refreshTimer = null;
		this._QueueWS = null;
		this._QueueLastEventGUID = null;
		this._QueueSummary = null;  // last-known {Buckets, ByCapability, At}
	}

	onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord)
	{
		// Stop auto-refresh when leaving this view
		if (this._refreshTimer)
		{
			clearInterval(this._refreshTimer);
			this._refreshTimer = null;
		}
		this._closeQueueSocket();

		return super.onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.refreshAll();

		// Start auto-refresh every 10 seconds
		if (this._refreshTimer)
		{
			clearInterval(this._refreshTimer);
		}
		this._refreshTimer = setInterval(
			function ()
			{
				this._silentRefresh();
			}.bind(this), 10000);

		// Open the queue.* WebSocket so the snapshot card stays live.
		// This is intentionally narrow: it only consumes queue.summary
		// envelopes -- enough to spot inconsistencies between this UV
		// and any external dashboard (e.g. the lab's Queue Lab tab).
		this._openQueueSocket();
		this.renderQueueSnapshot();

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_openQueueSocket()
	{
		this._closeQueueSocket();

		let tmpProtocol = (window.location.protocol === 'https:') ? 'wss:' : 'ws:';
		let tmpHost = window.location.host;
		let tmpBaseURL = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.APIBaseURL) || '';
		if (tmpBaseURL)
		{
			try
			{
				let tmpURL = new URL(tmpBaseURL);
				tmpHost = tmpURL.host;
				tmpProtocol = (tmpURL.protocol === 'https:') ? 'wss:' : 'ws:';
			}
			catch (pError) { /* fall back to page location */ }
		}

		let tmpWSURL = tmpProtocol + '//' + tmpHost;
		let tmpWS;
		try { tmpWS = new WebSocket(tmpWSURL); }
		catch (pError)
		{
			this.pict.log.warn('BeaconList: queue WebSocket failed to open: ' + pError.message);
			return;
		}
		this._QueueWS = tmpWS;

		tmpWS.onopen = function ()
		{
			tmpWS.send(JSON.stringify({ Action: 'QueueSubscribe', LastEventGUID: this._QueueLastEventGUID }));
		}.bind(this);

		tmpWS.onmessage = function (pEvent)
		{
			let tmpEnvelope;
			try { tmpEnvelope = JSON.parse(pEvent.data); }
			catch (pError) { return; }
			if (!tmpEnvelope || typeof tmpEnvelope !== 'object') { return; }
			if (tmpEnvelope.EventGUID) { this._QueueLastEventGUID = tmpEnvelope.EventGUID; }
			if (tmpEnvelope.Topic === 'queue.summary')
			{
				this._QueueSummary = tmpEnvelope.Payload || null;
				this.renderQueueSnapshot();
			}
			else if (tmpEnvelope.Topic === 'queue.reset')
			{
				// History gap -- mark snapshot as stale until a fresh
				// summary lands.  The next queue.summary will overwrite.
				this._QueueSummary = null;
				this.renderQueueSnapshot();
			}
		}.bind(this);

		tmpWS.onerror = function ()
		{
			this.pict.log.warn('BeaconList: queue WebSocket error');
		}.bind(this);

		tmpWS.onclose = function ()
		{
			if (this._QueueWS === tmpWS) { this._QueueWS = null; }
		}.bind(this);
	}

	_closeQueueSocket()
	{
		if (!this._QueueWS) { return; }
		let tmpWS = this._QueueWS;
		this._QueueWS = null;
		try { tmpWS.send(JSON.stringify({ Action: 'QueueUnsubscribe' })); } catch (pError) { /* best effort */ }
		try { tmpWS.close(); } catch (pError) { /* best effort */ }
	}

	renderQueueSnapshot()
	{
		// Source label: shows whether the card is reading live WS frames
		// or has only the initial REST-poll baseline.  Operators glancing
		// between this UV and any external dashboard (lab Queue Lab tab,
		// for instance) can confirm which one is fresher when numbers
		// disagree.
		let tmpSourceEl = document.getElementById('Ultravisor-BeaconList-QueueSnapshot-Source');
		let tmpTagEl    = document.getElementById('Ultravisor-BeaconList-QueueSnapshot-Tag');
		let tmpHasWS    = !!this._QueueWS && this._QueueWS.readyState === WebSocket.OPEN;
		if (tmpSourceEl)
		{
			tmpSourceEl.textContent = tmpHasWS ? 'LIVE (queue.summary)' : 'REST';
			tmpSourceEl.className = 'uv-queue-snap-source ' + (tmpHasWS ? 'live' : 'stale');
		}

		let tmpSummary = this._QueueSummary;
		// Fall back to a REST-derived snapshot computed from WorkItems
		// when no WS frame has landed yet.  Counts won't match the
		// scheduler's per-bucket logic exactly (the WS path includes
		// items that landed in persistence after this list was fetched),
		// but they're close enough to confirm the section is wired.
		if (!tmpSummary)
		{
			tmpSummary = this._summaryFromWorkItems();
		}

		let tmpAt = tmpSummary && tmpSummary.At ? tmpSummary.At : null;
		if (tmpTagEl)
		{
			tmpTagEl.textContent = tmpAt
				? ('updated ' + this._plainRelativeTime(tmpAt))
				: 'no data yet';
		}

		let tmpBuckets = (tmpSummary && tmpSummary.Buckets)
			|| { Upcoming: 0, InProgress: 0, Stalled: 0, Completed: 0, Errored: 0 };
		let tmpByCap = (tmpSummary && Array.isArray(tmpSummary.ByCapability))
			? tmpSummary.ByCapability
			: [];

		let tmpHTML = '<div class="uv-queue-snap-buckets">';
		let tmpBucketCells =
		[
			{ key: 'Upcoming',   label: 'Upcoming',    cls: 'bucket-upcoming' },
			{ key: 'InProgress', label: 'In Progress', cls: 'bucket-inprogress' },
			{ key: 'Stalled',    label: 'Stalled',     cls: 'bucket-stalled' },
			{ key: 'Completed',  label: 'Completed',   cls: 'bucket-completed' },
			{ key: 'Errored',    label: 'Errored',     cls: 'bucket-errored' }
		];
		for (let i = 0; i < tmpBucketCells.length; i++)
		{
			let tmpCell = tmpBucketCells[i];
			tmpHTML += '<div class="uv-queue-snap-bucket ' + tmpCell.cls + '">';
			tmpHTML += '<div class="uv-queue-snap-value">' + (tmpBuckets[tmpCell.key] || 0) + '</div>';
			tmpHTML += '<div class="uv-queue-snap-label">' + tmpCell.label + '</div>';
			tmpHTML += '</div>';
		}
		tmpHTML += '</div>';

		tmpHTML += '<div class="uv-queue-snap-bycap">';
		if (tmpByCap.length === 0)
		{
			tmpHTML += '<div class="uv-queue-snap-empty">No capabilities currently in flight.</div>';
		}
		else
		{
			tmpHTML += '<table>';
			tmpHTML += '<thead><tr><th>Capability</th><th>Action</th><th>Queued</th><th>Running</th><th>Stalled</th></tr></thead>';
			tmpHTML += '<tbody>';
			for (let i = 0; i < tmpByCap.length; i++)
			{
				let tmpRow = tmpByCap[i];
				tmpHTML += '<tr>';
				tmpHTML += '<td>' + this._escapeHTML(tmpRow.Capability || '') + '</td>';
				tmpHTML += '<td>' + this._escapeHTML(tmpRow.Action || '') + '</td>';
				tmpHTML += '<td>' + (tmpRow.Queued || 0) + '</td>';
				tmpHTML += '<td>' + (tmpRow.Running || 0) + '</td>';
				tmpHTML += '<td>' + (tmpRow.Stalled || 0) + '</td>';
				tmpHTML += '</tr>';
			}
			tmpHTML += '</tbody></table>';
		}
		tmpHTML += '</div>';

		this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-QueueSnapshot', tmpHTML);
	}

	_plainRelativeTime(pISO)
	{
		// Plain-text variant of _formatRelativeTime -- the queue snapshot
		// tag uses textContent (no HTML), so we keep this plain to avoid
		// double-escaping the <span title> wrapper the original returns.
		if (!pISO) { return ''; }
		let tmpDelta = Math.max(0, Date.now() - Date.parse(pISO));
		if (tmpDelta < 1500)  { return 'just now'; }
		if (tmpDelta < 60000) { return Math.round(tmpDelta / 1000) + 's ago'; }
		return Math.round(tmpDelta / 60000) + 'm ago';
	}

	_summaryFromWorkItems()
	{
		let tmpItems = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.WorkItems) || [];
		if (tmpItems.length === 0) { return null; }
		let tmpBuckets = { Upcoming: 0, InProgress: 0, Stalled: 0, Completed: 0, Errored: 0 };
		let tmpByCapMap = new Map();
		for (let i = 0; i < tmpItems.length; i++)
		{
			let tmpItem = tmpItems[i];
			let tmpStatus = (tmpItem.Status || '').toLowerCase();
			if (tmpStatus === 'pending' || tmpStatus === 'assigned') { tmpBuckets.Upcoming++; }
			else if (tmpStatus === 'running' || tmpStatus === 'dispatched') { tmpBuckets.InProgress++; }
			else if (tmpStatus === 'complete') { tmpBuckets.Completed++; }
			else if (tmpStatus === 'error' || tmpStatus === 'timeout' || tmpStatus === 'failed') { tmpBuckets.Errored++; }

			let tmpKey = (tmpItem.Capability || '') + '' + (tmpItem.Action || '');
			let tmpRow = tmpByCapMap.get(tmpKey);
			if (!tmpRow)
			{
				tmpRow = { Capability: tmpItem.Capability || '', Action: tmpItem.Action || '', Queued: 0, Running: 0, Stalled: 0 };
				tmpByCapMap.set(tmpKey, tmpRow);
			}
			if (tmpStatus === 'pending' || tmpStatus === 'assigned') { tmpRow.Queued++; }
			else if (tmpStatus === 'running' || tmpStatus === 'dispatched') { tmpRow.Running++; }
		}
		return {
			At: new Date().toISOString(),
			Buckets: tmpBuckets,
			ByCapability: Array.from(tmpByCapMap.values()).filter((pR) => pR.Queued > 0 || pR.Running > 0 || pR.Stalled > 0)
		};
	}

	refreshAll()
	{
		let tmpPendingCalls = 4;
		let tmpDone = function ()
		{
			tmpPendingCalls--;
			if (tmpPendingCalls <= 0)
			{
				this.renderBeaconSummary();
				this.renderBeaconTable();
				this.renderReachabilityMap();
				this.renderWorkQueue();
				this.renderAffinityTable();
				this.renderQueueSnapshot();
			}
		}.bind(this);

		this.pict.PictApplication.loadBeacons(tmpDone);
		this.pict.PictApplication.loadWorkItems(tmpDone);
		this.pict.PictApplication.loadAffinityBindings(tmpDone);
		this.pict.PictApplication.loadReachabilityMatrix(tmpDone);
	}

	_silentRefresh()
	{
		// Same as refreshAll but doesn't clear the detail panel
		let tmpPendingCalls = 4;
		let tmpDone = function ()
		{
			tmpPendingCalls--;
			if (tmpPendingCalls <= 0)
			{
				this.renderBeaconSummary();
				this.renderBeaconTable();
				this.renderReachabilityMap();
				this.renderWorkQueue();
				this.renderAffinityTable();
				this.renderQueueSnapshot();
			}
		}.bind(this);

		this.pict.PictApplication.loadBeacons(tmpDone);
		this.pict.PictApplication.loadWorkItems(tmpDone);
		this.pict.PictApplication.loadAffinityBindings(tmpDone);
		this.pict.PictApplication.loadReachabilityMatrix(tmpDone);
	}

	renderBeaconSummary()
	{
		let tmpBeacons = this.pict.AppData.Ultravisor.Beacons || [];
		let tmpOnline = 0;
		let tmpBusy = 0;
		let tmpOffline = 0;

		for (let i = 0; i < tmpBeacons.length; i++)
		{
			let tmpStatus = (tmpBeacons[i].Status || '').toLowerCase();
			if (tmpStatus === 'online')
			{
				tmpOnline++;
			}
			else if (tmpStatus === 'busy')
			{
				tmpBusy++;
			}
			else
			{
				tmpOffline++;
			}
		}

		let tmpHTML = '<div class="ultravisor-beacon-summary">';
		tmpHTML += '<div class="ultravisor-beacon-summary-card"><div class="ultravisor-beacon-summary-count">' + tmpBeacons.length + '</div><div class="ultravisor-beacon-summary-label">Total</div></div>';
		tmpHTML += '<div class="ultravisor-beacon-summary-card online"><div class="ultravisor-beacon-summary-count">' + tmpOnline + '</div><div class="ultravisor-beacon-summary-label">Online</div></div>';
		tmpHTML += '<div class="ultravisor-beacon-summary-card busy"><div class="ultravisor-beacon-summary-count">' + tmpBusy + '</div><div class="ultravisor-beacon-summary-label">Busy</div></div>';
		tmpHTML += '<div class="ultravisor-beacon-summary-card offline"><div class="ultravisor-beacon-summary-count">' + tmpOffline + '</div><div class="ultravisor-beacon-summary-label">Offline</div></div>';
		tmpHTML += '</div>';

		this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-Summary', tmpHTML);
	}

	renderBeaconTable()
	{
		let tmpBeacons = this.pict.AppData.Ultravisor.Beacons || [];
		let tmpViewRef = "_Pict.views['Ultravisor-BeaconList']";

		if (tmpBeacons.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-Body',
				'<div class="ultravisor-beacon-empty">No beacons connected. Start a beacon-enabled application to see it appear here.</div>');
			return;
		}

		let tmpHTML = '<table class="ultravisor-beacon-table">';
		tmpHTML += '<thead><tr>';
		tmpHTML += '<th>Name</th>';
		tmpHTML += '<th>Status</th>';
		tmpHTML += '<th>Capabilities</th>';
		tmpHTML += '<th>Work Items</th>';
		tmpHTML += '<th>Last Heartbeat</th>';
		tmpHTML += '<th>Registered</th>';
		tmpHTML += '<th>Actions</th>';
		tmpHTML += '</tr></thead>';
		tmpHTML += '<tbody>';

		for (let i = 0; i < tmpBeacons.length; i++)
		{
			let tmpBeacon = tmpBeacons[i];
			let tmpStatusClass = (tmpBeacon.Status || 'offline').toLowerCase();
			if (tmpStatusClass !== 'online' && tmpStatusClass !== 'busy' && tmpStatusClass !== 'offline')
			{
				tmpStatusClass = 'offline';
			}
			let tmpEscID = this._escapeAttr(tmpBeacon.BeaconID || '');

			// Capability tags
			let tmpCaps = tmpBeacon.Capabilities || [];
			let tmpCapsHTML = '';
			for (let c = 0; c < tmpCaps.length; c++)
			{
				tmpCapsHTML += '<span class="ultravisor-beacon-cap-tag">' + this._escapeHTML(tmpCaps[c]) + '</span>';
			}
			if (tmpCaps.length === 0)
			{
				tmpCapsHTML = '<span style="color:var(--uv-text-tertiary);">none</span>';
			}

			// Work item count
			let tmpWorkCount = (tmpBeacon.CurrentWorkItems || []).length;

			tmpHTML += '<tr>';
			tmpHTML += '<td><strong>' + this._escapeHTML(tmpBeacon.Name || tmpBeacon.BeaconID || '') + '</strong></td>';
			tmpHTML += '<td><span class="ultravisor-beacon-status ' + tmpStatusClass + '"><span class="ultravisor-beacon-status-dot"></span>' + this._escapeHTML(tmpBeacon.Status || 'Offline') + '</span></td>';
			tmpHTML += '<td>' + tmpCapsHTML + '</td>';
			tmpHTML += '<td>' + tmpWorkCount + ' / ' + (tmpBeacon.MaxConcurrent || 1) + '</td>';
			tmpHTML += '<td>' + this._formatRelativeTime(tmpBeacon.LastHeartbeat) + '</td>';
			tmpHTML += '<td>' + this._formatRelativeTime(tmpBeacon.RegisteredAt) + '</td>';
			tmpHTML += '<td>';
			tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-edit" onclick="' + tmpViewRef + '.showBeaconDetail(\'' + tmpEscID + '\')">Details</button> ';
			tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-danger" onclick="' + tmpViewRef + '.deregisterBeacon(\'' + tmpEscID + '\')">Deregister</button>';
			tmpHTML += '</td>';
			tmpHTML += '</tr>';
		}

		tmpHTML += '</tbody></table>';
		this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-Body', tmpHTML);
	}

	showBeaconDetail(pBeaconID)
	{
		this.pict.PictApplication.loadBeacon(pBeaconID,
			function (pError, pBeacon)
			{
				if (pError || !pBeacon)
				{
					this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-Detail',
						'<div class="ultravisor-beacon-detail visible"><p style="color:var(--uv-error);">Error loading beacon details.</p></div>');
					return;
				}

				let tmpHTML = '<div class="ultravisor-beacon-detail visible">';
				tmpHTML += '<h3>Beacon: ' + this._escapeHTML(pBeacon.Name || pBeacon.BeaconID || '') + '</h3>';

				// Detail grid
				tmpHTML += '<div class="ultravisor-beacon-detail-grid">';
				tmpHTML += this._renderDetailField('Beacon ID', '<code>' + this._escapeHTML(pBeacon.BeaconID || '') + '</code>');
				tmpHTML += this._renderDetailField('Name', this._escapeHTML(pBeacon.Name || ''));
				tmpHTML += this._renderDetailField('Status', this._escapeHTML(pBeacon.Status || 'Unknown'));
				tmpHTML += this._renderDetailField('Max Concurrent', String(pBeacon.MaxConcurrent || 1));
				tmpHTML += this._renderDetailField('Session ID', '<code>' + this._escapeHTML(pBeacon.SessionID || 'none') + '</code>');
				tmpHTML += this._renderDetailField('Registered', this._escapeHTML(pBeacon.RegisteredAt || ''));
				tmpHTML += this._renderDetailField('Last Heartbeat', this._escapeHTML(pBeacon.LastHeartbeat || '') + ' (' + this._formatRelativeTime(pBeacon.LastHeartbeat) + ')');
				tmpHTML += '</div>';

				// Capabilities
				let tmpCaps = pBeacon.Capabilities || [];
				if (tmpCaps.length > 0)
				{
					tmpHTML += '<h3>Capabilities</h3>';
					tmpHTML += '<div style="margin-bottom:1em;">';
					for (let c = 0; c < tmpCaps.length; c++)
					{
						tmpHTML += '<span class="ultravisor-beacon-cap-tag" style="font-size:0.85em;">' + this._escapeHTML(tmpCaps[c]) + '</span>';
					}
					tmpHTML += '</div>';
				}

				// Current work items
				let tmpWorkItems = pBeacon.CurrentWorkItems || [];
				if (tmpWorkItems.length > 0)
				{
					tmpHTML += '<h3>Current Work Items</h3>';
					tmpHTML += '<div style="font-family:monospace; font-size:0.85em; color:var(--uv-text-secondary);">';
					for (let w = 0; w < tmpWorkItems.length; w++)
					{
						tmpHTML += '<div>' + this._escapeHTML(tmpWorkItems[w]) + '</div>';
					}
					tmpHTML += '</div>';
				}

				// Tags
				let tmpTags = pBeacon.Tags || {};
				let tmpTagKeys = Object.keys(tmpTags);
				if (tmpTagKeys.length > 0)
				{
					tmpHTML += '<h3>Tags</h3>';
					tmpHTML += '<div class="ultravisor-beacon-detail-grid">';
					for (let t = 0; t < tmpTagKeys.length; t++)
					{
						tmpHTML += this._renderDetailField(this._escapeHTML(tmpTagKeys[t]), this._escapeHTML(String(tmpTags[tmpTagKeys[t]])));
					}
					tmpHTML += '</div>';
				}

				tmpHTML += '</div>';
				this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-Detail', tmpHTML);
			}.bind(this));
	}

	deregisterBeacon(pBeaconID)
	{
		this.pict.views.Modal.confirm('Deregister beacon ' + pBeaconID + '? Any assigned work items will be released.', { confirmLabel: 'Deregister', dangerous: true }).then(
			function (pConfirmed)
			{
				if (pConfirmed)
				{
					this.pict.PictApplication.deregisterBeacon(pBeaconID,
						function (pError)
						{
							if (pError)
							{
								this.pict.log.error('Failed to deregister beacon: ' + pBeaconID, pError);
							}
							// Clear detail panel and refresh
							this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-Detail', '');
							this.refreshAll();
						}.bind(this));
				}
			}.bind(this));
	}

	renderReachabilityMap()
	{
		let tmpMapView = this.pict.views['Ultravisor-ReachabilityMap'];
		if (tmpMapView)
		{
			// render() injects the template; onAfterRender calls renderMap()
			tmpMapView.render();
		}
	}

	probeAll()
	{
		this.pict.PictApplication.probeReachability(
			function ()
			{
				let tmpMapView = this.pict.views['Ultravisor-ReachabilityMap'];
				if (tmpMapView)
				{
					tmpMapView.renderMap();
				}
			}.bind(this));
	}

	renderWorkQueue()
	{
		let tmpWorkItems = this.pict.AppData.Ultravisor.WorkItems || [];

		if (tmpWorkItems.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-WorkQueue',
				'<div class="ultravisor-beacon-empty" style="padding:1.5em;">No work items in the queue.</div>');
			return;
		}

		let tmpHTML = '<table class="ultravisor-beacon-table">';
		tmpHTML += '<thead><tr>';
		tmpHTML += '<th>Hash</th>';
		tmpHTML += '<th>Status</th>';
		tmpHTML += '<th>Capability</th>';
		tmpHTML += '<th>Action</th>';
		tmpHTML += '<th>Beacon</th>';
		tmpHTML += '<th>Progress</th>';
		tmpHTML += '<th>Created</th>';
		tmpHTML += '<th>Completed</th>';
		tmpHTML += '</tr></thead>';
		tmpHTML += '<tbody>';

		for (let i = 0; i < tmpWorkItems.length; i++)
		{
			let tmpItem = tmpWorkItems[i];
			let tmpStatusClass = (tmpItem.Status || '').toLowerCase();
			if (['pending', 'assigned', 'running', 'complete', 'error', 'timeout'].indexOf(tmpStatusClass) === -1)
			{
				tmpStatusClass = '';
			}

			// Progress
			let tmpProgressHTML = '';
			let tmpProgress = tmpItem.Progress || {};
			if (tmpItem.Status === 'Running' && typeof tmpProgress.Percent === 'number')
			{
				tmpProgressHTML = '<div class="ultravisor-workitem-progress">';
				tmpProgressHTML += '<div class="ultravisor-workitem-progress-bar"><div class="ultravisor-workitem-progress-fill" style="width:' + Math.min(tmpProgress.Percent, 100) + '%;"></div></div>';
				tmpProgressHTML += '<span class="ultravisor-workitem-progress-text">' + Math.round(tmpProgress.Percent) + '%</span>';
				tmpProgressHTML += '</div>';
			}
			else if (tmpProgress.Message)
			{
				tmpProgressHTML = '<span class="ultravisor-workitem-progress-text">' + this._escapeHTML(tmpProgress.Message) + '</span>';
			}

			tmpHTML += '<tr>';
			tmpHTML += '<td><code style="font-size:0.75em;">' + this._escapeHTML((tmpItem.WorkItemHash || '').substring(0, 20)) + '</code></td>';
			tmpHTML += '<td><span class="ultravisor-workitem-status ' + tmpStatusClass + '">' + this._escapeHTML(tmpItem.Status || '') + '</span></td>';
			tmpHTML += '<td>' + this._escapeHTML(tmpItem.Capability || '') + '</td>';
			tmpHTML += '<td>' + this._escapeHTML(tmpItem.Action || '') + '</td>';
			tmpHTML += '<td>' + this._escapeHTML(tmpItem.AssignedBeaconID ? tmpItem.AssignedBeaconID.substring(0, 15) : 'unassigned') + '</td>';
			tmpHTML += '<td>' + tmpProgressHTML + '</td>';
			tmpHTML += '<td>' + this._formatRelativeTime(tmpItem.CreatedAt) + '</td>';
			tmpHTML += '<td>' + (tmpItem.CompletedAt ? this._formatRelativeTime(tmpItem.CompletedAt) : '') + '</td>';
			tmpHTML += '</tr>';
		}

		tmpHTML += '</tbody></table>';
		this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-WorkQueue', tmpHTML);
	}

	renderAffinityTable()
	{
		let tmpBindings = this.pict.AppData.Ultravisor.AffinityBindings || [];

		if (tmpBindings.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-Affinity',
				'<div class="ultravisor-beacon-empty" style="padding:1.5em;">No active affinity bindings.</div>');
			return;
		}

		let tmpHTML = '<table class="ultravisor-beacon-table">';
		tmpHTML += '<thead><tr>';
		tmpHTML += '<th>Affinity Key</th>';
		tmpHTML += '<th>Beacon</th>';
		tmpHTML += '<th>Run Hash</th>';
		tmpHTML += '<th>Created</th>';
		tmpHTML += '<th>Expires</th>';
		tmpHTML += '</tr></thead>';
		tmpHTML += '<tbody>';

		for (let i = 0; i < tmpBindings.length; i++)
		{
			let tmpBinding = tmpBindings[i];
			tmpHTML += '<tr>';
			tmpHTML += '<td><code>' + this._escapeHTML(tmpBinding.AffinityKey || '') + '</code></td>';
			tmpHTML += '<td>' + this._escapeHTML(tmpBinding.BeaconID || '') + '</td>';
			tmpHTML += '<td><code style="font-size:0.8em;">' + this._escapeHTML(tmpBinding.RunHash || '') + '</code></td>';
			tmpHTML += '<td>' + this._formatRelativeTime(tmpBinding.CreatedAt) + '</td>';
			tmpHTML += '<td>' + this._formatRelativeTime(tmpBinding.ExpiresAt) + '</td>';
			tmpHTML += '</tr>';
		}

		tmpHTML += '</tbody></table>';
		this.pict.ContentAssignment.assignContent('#Ultravisor-BeaconList-Affinity', tmpHTML);
	}

	// --- Helpers ---

	_renderDetailField(pLabel, pValue)
	{
		return '<div class="ultravisor-beacon-detail-field">'
			+ '<div class="ultravisor-beacon-detail-field-label">' + pLabel + '</div>'
			+ '<div class="ultravisor-beacon-detail-field-value">' + pValue + '</div>'
			+ '</div>';
	}

	_formatRelativeTime(pISO)
	{
		if (!pISO)
		{
			return '<span style="color:var(--uv-text-tertiary);">—</span>';
		}

		let tmpDate;
		try
		{
			tmpDate = new Date(pISO);
		}
		catch (pError)
		{
			return this._escapeHTML(String(pISO));
		}

		if (isNaN(tmpDate.getTime()))
		{
			return this._escapeHTML(String(pISO));
		}

		let tmpNow = Date.now();
		let tmpDiffMs = tmpNow - tmpDate.getTime();
		let tmpFuture = tmpDiffMs < 0;
		let tmpAbsDiff = Math.abs(tmpDiffMs);

		let tmpSeconds = Math.floor(tmpAbsDiff / 1000);
		let tmpMinutes = Math.floor(tmpSeconds / 60);
		let tmpHours = Math.floor(tmpMinutes / 60);
		let tmpDays = Math.floor(tmpHours / 24);

		let tmpText;
		if (tmpSeconds < 10)
		{
			tmpText = 'just now';
		}
		else if (tmpSeconds < 60)
		{
			tmpText = tmpSeconds + 's ago';
		}
		else if (tmpMinutes < 60)
		{
			tmpText = tmpMinutes + 'm ago';
		}
		else if (tmpHours < 24)
		{
			tmpText = tmpHours + 'h ago';
		}
		else
		{
			tmpText = tmpDays + 'd ago';
		}

		if (tmpFuture && tmpText !== 'just now')
		{
			tmpText = 'in ' + tmpText.replace(' ago', '');
		}

		return '<span title="' + this._escapeAttr(pISO) + '">' + tmpText + '</span>';
	}

	_escapeHTML(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	_escapeAttr(pString)
	{
		if (typeof pString !== 'string')
		{
			return '';
		}
		return pString
			.replace(/&/g, '&amp;')
			.replace(/'/g, '&#39;')
			.replace(/"/g, '&quot;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;');
	}
}

module.exports = UltravisorBeaconListView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],255:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-BottomBar",

	DefaultRenderable: "Ultravisor-BottomBar-Content",
	DefaultDestinationAddress: "#Ultravisor-BottomBar-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-bottombar {
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: var(--uv-bg-elevated);
			color: var(--uv-text-tertiary);
			padding: 0.75em 1.5em;
			font-size: 0.8em;
			border-top: 1px solid var(--uv-topbar-hover);
		}
		.ultravisor-bottombar a {
			color: var(--uv-link);
			text-decoration: none;
		}
		.ultravisor-bottombar a:hover {
			color: var(--uv-link-hover);
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-BottomBar-Template",
			Template: /*html*/`
<div class="ultravisor-bottombar">
	Ultravisor Task Server &middot; Retold
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-BottomBar-Content",
			TemplateHash: "Ultravisor-BottomBar-Template",
			DestinationAddress: "#Ultravisor-BottomBar-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorBottomBarView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}
}

module.exports = UltravisorBottomBarView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],256:[function(require,module,exports){
/**
 * PictView-Ultravisor-CapabilityHeatMap
 *
 * Phase 7 / capability heat map — answers "where is the queue piling up?"
 * Y axis = capability rows, X axis = time, cell intensity = active workers
 * in that bucket / capacity. Reuses the bucketed `/Timeline` endpoint and
 * the Pict + Canvas pattern from the spine.
 *
 * Standalone view at `/Capabilities`. URL state shares the spine's
 * `?from=&to=` contract via `views/timeline/url-state.js`.
 */

const libPictView = require('pict-view');
const libRenderHeatMap = require('./timeline/render-heatmap.js');
const libURLState = require('./timeline/url-state.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Ultravisor-CapabilityHeatMap',

	DefaultRenderable: 'Ultravisor-CapabilityHeatMap-Content',
	DefaultDestinationAddress: '#Ultravisor-Content-Container',

	AutoRender: false,

	CSS: /*css*/`
		.uv-heatmap {
			padding: 1.5em;
			max-width: 1800px;
			margin: 0 auto;
		}
		.uv-heatmap-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1em;
			padding-bottom: 0.75em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.uv-heatmap-header h1 {
			margin: 0;
			font-size: 1.6em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.uv-heatmap-windows {
			display: flex;
			align-items: center;
			gap: 0.4em;
			font-size: 0.85em;
		}
		.uv-heatmap-windows button {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			color: var(--uv-text-secondary);
			padding: 0.3em 0.7em;
			border-radius: 4px;
			cursor: pointer;
			font-size: 0.85em;
		}
		.uv-heatmap-windows button:hover {
			border-color: var(--uv-brand);
			color: var(--uv-text);
		}
		.uv-heatmap-windows button.active {
			background: var(--uv-brand);
			border-color: var(--uv-brand);
			color: var(--uv-text-on-brand, #fff);
		}
		.uv-heatmap-canvas-wrap {
			width: 100%;
			height: 540px;
			background: var(--uv-bg-base);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 6px;
			position: relative;
		}
		.uv-heatmap-canvas {
			position: absolute;
			top: 0; left: 0;
			width: 100%;
			height: 100%;
		}
		.uv-heatmap-windowinfo {
			margin-top: 0.5em;
			font-size: 0.78em;
			color: var(--uv-text-secondary);
			font-family: monospace;
			text-align: right;
		}
		.uv-heatmap-help {
			margin-top: 1em;
			padding: 0.75em 1em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			font-size: 0.78em;
			color: var(--uv-text-secondary);
			line-height: 1.55;
		}
		.uv-heatmap-loading {
			text-align: center;
			padding: 1em;
			color: var(--uv-text-tertiary);
			font-size: 0.85em;
		}
	`,

	Templates:
	[
		{
			Hash: 'Ultravisor-CapabilityHeatMap-Template',
			Template: /*html*/`
<div class="uv-heatmap">
	<div class="uv-heatmap-header">
		<h1>Capability Heat Map</h1>
		<div class="uv-heatmap-windows">
			{~TS:Ultravisor-HeatMap-WindowButton-Template:AppData.HeatMap.WindowButtons~}
		</div>
	</div>
	<div class="uv-heatmap-canvas-wrap">
		<canvas class="uv-heatmap-canvas" id="Ultravisor-HeatMap-Canvas"></canvas>
	</div>
	<div class="uv-heatmap-windowinfo">{~D:AppData.HeatMap.Window.FromIso~} → {~D:AppData.HeatMap.Window.ToIso~} · {~D:AppData.HeatMap.BucketCount~} buckets · {~D:AppData.HeatMap.CapabilityCount~} rows</div>
	<div class="uv-heatmap-help">
		Each row is a capability; each cell is one bucket. Cell color blends from <strong>cool</strong> (idle) through <strong>amber</strong> (saturated) to <strong>red</strong> (oversubscribed). Capacity = sum of <code>MaxConcurrent</code> across alive beacons advertising the capability. Switch windows above; live mode polls every 3s.
	</div>
</div>
`
		},
		{
			Hash: 'Ultravisor-HeatMap-WindowButton-Template',
			Template: /*html*/`
<button class="{~D:Record.ActiveClass~}" onclick="{~P~}.views['Ultravisor-CapabilityHeatMap'].selectWindow('{~D:Record.Key~}')">{~D:Record.Label~}</button>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Ultravisor-CapabilityHeatMap-Content',
			TemplateHash:   'Ultravisor-CapabilityHeatMap-Template',
			DestinationAddress: '#Ultravisor-Content-Container',
			RenderMethod:   'replace'
		}
	]
};

const WINDOW_PRESETS =
[
	{ Key: '5m',  Label: '5m',  FromIso: 'now-5m',  ToIso: 'now',    PollMs: 3000 },
	{ Key: '15m', Label: '15m', FromIso: 'now-15m', ToIso: 'now',    PollMs: 5000 },
	{ Key: '1h',  Label: '1h',  FromIso: 'now-1h',  ToIso: 'now',    PollMs: 10000 },
	{ Key: '6h',  Label: '6h',  FromIso: 'now-6h',  ToIso: 'now',    PollMs: 30000 },
	{ Key: '24h', Label: '24h', FromIso: 'now-24h', ToIso: 'now',    PollMs: 60000 }
];

class UltravisorCapabilityHeatMapView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._PollHandle = null;
		this._FetchInFlight = null;
		this._RedrawScheduled = false;
		this._ResizeListener = null;
		this._CurrentWindowKey = '15m';
	}

	onBeforeRender(pRenderable, pAddress, pRecord)
	{
		this.pict.AppData.HeatMap = this.pict.AppData.HeatMap || {};
		// Default to URL state if present, else 15m preset.
		let tmpURLState = libURLState.read();
		let tmpPreset = WINDOW_PRESETS[1]; // 15m
		// If the URL has explicit From/To different from any preset key
		// in `bucket` query, treat it as a custom range — use 15m polling.
		// (We don't change the preset list to honor arbitrary windows;
		// that's the spine view's job.)
		this._CurrentWindowKey = (tmpURLState && tmpURLState.HeatMapWindow) || '15m';
		for (let i = 0; i < WINDOW_PRESETS.length; i++)
		{
			if (WINDOW_PRESETS[i].Key === this._CurrentWindowKey) { tmpPreset = WINDOW_PRESETS[i]; break; }
		}
		this.pict.AppData.HeatMap.Window =
		{
			FromIso: tmpPreset.FromIso,
			ToIso:   tmpPreset.ToIso,
			Bucket:  'auto',
			PollMs:  tmpPreset.PollMs
		};
		this.pict.AppData.HeatMap.Buckets = this.pict.AppData.HeatMap.Buckets || [];
		this.pict.AppData.HeatMap.Capabilities = this.pict.AppData.HeatMap.Capabilities || [];
		this.pict.AppData.HeatMap.Capacities = this.pict.AppData.HeatMap.Capacities || {};
		this.pict.AppData.HeatMap.BucketCount = (this.pict.AppData.HeatMap.Buckets || []).length;
		this.pict.AppData.HeatMap.CapabilityCount = (this.pict.AppData.HeatMap.Capabilities || []).length;
		this.pict.AppData.HeatMap.WindowButtons = WINDOW_PRESETS.map(function (pP, pIx)
		{
			return {
				Key:         pP.Key,
				Label:       pP.Label,
				ActiveClass: (pP.Key === (this._CurrentWindowKey || '15m')) ? 'active' : ''
			};
		}.bind(this));
		// Don't _stopPoll() here — see Throughput's notes; Pict renders
		// the view several times during mount, and aborting the prior
		// onAfterRender's in-flight fetch every time stalls the loop.
		return super.onBeforeRender(pRenderable, pAddress, pRecord);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._installResizeListener();
		this._fetchOnce();
		this._scheduleNextPoll();
		this._scheduleRedraw();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	selectWindow(pKey)
	{
		this._CurrentWindowKey = pKey || '15m';
		// re-render via lifecycle (sets new window + restarts poll)
		this.render();
	}

	// ====================================================================
	// Fetch
	// ====================================================================

	_fetchOnce()
	{
		this._abortInFlight();
		let tmpAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
		this._FetchInFlight = tmpAbort;
		let tmpBase = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.APIBaseURL) || '';
		let tmpW = this.pict.AppData.HeatMap.Window;
		let tmpURL = tmpBase
			+ '/Timeline?from=' + encodeURIComponent(tmpW.FromIso)
			+ '&to=' + encodeURIComponent(tmpW.ToIso)
			+ '&bucket=auto&futureLimit=0&waitMs=0';
		let tmpSelf = this;

		// Capacities come from /Beacon which gives MaxConcurrent + Status.
		// We fetch in parallel and combine.
		let tmpFetchTimeline = fetch(tmpURL, { signal: tmpAbort ? tmpAbort.signal : undefined })
			.then(function (pResp) { return pResp.ok ? pResp.json() : null; });
		let tmpFetchBeacons = fetch(tmpBase + '/Beacon', { signal: tmpAbort ? tmpAbort.signal : undefined })
			.then(function (pResp) { return pResp.ok ? pResp.json() : null; });

		Promise.all([tmpFetchTimeline, tmpFetchBeacons])
			.then(function (pAll)
			{
				if (tmpSelf._FetchInFlight !== tmpAbort) return; // a newer fetch took over
				tmpSelf._reconcile(pAll[0], pAll[1]);
				tmpSelf._FetchInFlight = null;
			})
			.catch(function (pErr)
			{
				if (pErr && pErr.name === 'AbortError') return;
				if (tmpSelf._FetchInFlight !== tmpAbort) return;
				tmpSelf.pict.log.warn('HeatMap fetch failed: ' + pErr.message);
				tmpSelf._FetchInFlight = null;
			});
	}

	_reconcile(pTimelineBody, pBeaconsBody)
	{
		let tmpBuckets = (pTimelineBody && Array.isArray(pTimelineBody.Buckets))
			? pTimelineBody.Buckets : [];
		this.pict.AppData.HeatMap.Buckets = tmpBuckets;

		// Capabilities: union across all buckets' ByCapability keys, sorted.
		let tmpCapSet = new Set();
		for (let i = 0; i < tmpBuckets.length; i++)
		{
			let tmpByCap = tmpBuckets[i].ByCapability || {};
			for (let tmpK in tmpByCap)
			{
				if (Object.prototype.hasOwnProperty.call(tmpByCap, tmpK)) { tmpCapSet.add(tmpK); }
			}
		}
		let tmpCaps = Array.from(tmpCapSet).sort();
		this.pict.AppData.HeatMap.Capabilities = tmpCaps;

		// Capacities: sum MaxConcurrent across alive beacons advertising
		// the capability. "Alive" = Status === 'Online'.
		let tmpCapacities = {};
		let tmpBeacons = Array.isArray(pBeaconsBody) ? pBeaconsBody : [];
		for (let i = 0; i < tmpBeacons.length; i++)
		{
			let tmpB = tmpBeacons[i];
			if (!tmpB) continue;
			let tmpAlive = tmpB.Status === 'Online' || tmpB.Liveness === 'Alive';
			if (!tmpAlive) continue;
			let tmpMC = Number.isFinite(tmpB.MaxConcurrent) ? tmpB.MaxConcurrent : 1;
			let tmpBCap = Array.isArray(tmpB.Capabilities) ? tmpB.Capabilities : [];
			for (let j = 0; j < tmpBCap.length; j++)
			{
				let tmpC = tmpBCap[j];
				if (!tmpCapacities[tmpC]) { tmpCapacities[tmpC] = { Capacity: 0, ActiveMax: 0 }; }
				tmpCapacities[tmpC].Capacity += tmpMC;
			}
		}
		this.pict.AppData.HeatMap.Capacities = tmpCapacities;
		this.pict.AppData.HeatMap.BucketCount = tmpBuckets.length;
		this.pict.AppData.HeatMap.CapabilityCount = tmpCaps.length;

		// Mirror the resolved server window so the chrome shows what we
		// actually fetched (in live mode the server resolves now-Xm vs.
		// our clock).
		if (pTimelineBody && pTimelineBody.From) { this.pict.AppData.HeatMap.Window.FromIso = pTimelineBody.From; }
		if (pTimelineBody && pTimelineBody.To)   { this.pict.AppData.HeatMap.Window.ToIso   = pTimelineBody.To; }
		this._updateWindowInfo();
		this._scheduleRedraw();
	}

	_updateWindowInfo()
	{
		// Update only the windowinfo span and bucketcount/capabilitycount
		// without a full re-render (which would tear down the canvas).
		let tmpHTML = this.pict.AppData.HeatMap.Window.FromIso + ' → ' + this.pict.AppData.HeatMap.Window.ToIso
			+ ' · ' + this.pict.AppData.HeatMap.BucketCount + ' buckets · '
			+ this.pict.AppData.HeatMap.CapabilityCount + ' rows';
		try
		{
			let tmpEl = this.pict.ContentAssignment.getElement('.uv-heatmap-windowinfo');
			if (tmpEl)
			{
				let tmpNode = tmpEl[0] || tmpEl;
				if (tmpNode) { tmpNode.textContent = tmpHTML; }
			}
		}
		catch (pErr) { /* best effort */ }
	}

	// ====================================================================
	// Polling
	// ====================================================================

	_scheduleNextPoll()
	{
		// Clear only the timer; not the in-flight fetch — see Throughput
		// for the abort-cascade bug this avoids.
		if (this._PollHandle) { clearTimeout(this._PollHandle); this._PollHandle = null; }
		let tmpPollMs = (this.pict.AppData.HeatMap.Window && this.pict.AppData.HeatMap.Window.PollMs) || 5000;
		this._PollHandle = setTimeout(function ()
		{
			this._PollHandle = null;
			this._fetchOnce();
			this._scheduleNextPoll();
		}.bind(this), tmpPollMs);
	}

	_stopPoll()
	{
		if (this._PollHandle) { clearTimeout(this._PollHandle); this._PollHandle = null; }
		this._abortInFlight();
	}

	_abortInFlight()
	{
		if (this._FetchInFlight)
		{
			try { this._FetchInFlight.abort(); }
			catch (pErr) { /* ignore */ }
			this._FetchInFlight = null;
		}
	}

	// ====================================================================
	// Render
	// ====================================================================

	_installResizeListener()
	{
		if (this._ResizeListener) return;
		let fResize = function () { this._scheduleRedraw(); }.bind(this);
		window.addEventListener('resize', fResize);
		this._ResizeListener = fResize;
	}

	_scheduleRedraw()
	{
		if (this._RedrawScheduled) return;
		this._RedrawScheduled = true;
		let tmpFn = function ()
		{
			this._RedrawScheduled = false;
			this._draw();
		}.bind(this);
		if (typeof window !== 'undefined' && window.requestAnimationFrame)
		{
			window.requestAnimationFrame(tmpFn);
		}
		else
		{
			setTimeout(tmpFn, 16);
		}
	}

	_draw()
	{
		let tmpCanvas = _resolveCanvas(this.pict, '#Ultravisor-HeatMap-Canvas');
		if (!tmpCanvas)
		{
			// View was replaced (user navigated elsewhere) — stop the
			// poll loop so we don't leak fetches.
			this._stopPoll();
			return;
		}
		try
		{
			libRenderHeatMap.drawHeatMap(tmpCanvas,
			{
				Window:       this.pict.AppData.HeatMap.Window,
				Buckets:      this.pict.AppData.HeatMap.Buckets,
				Capabilities: this.pict.AppData.HeatMap.Capabilities,
				Capacities:   this.pict.AppData.HeatMap.Capacities
			});
		}
		catch (pErr)
		{
			this.pict.log.warn('HeatMap draw failed: ' + pErr.message);
		}
	}
}

function _resolveCanvas(pPict, pSelector)
{
	let tmpEl = pPict.ContentAssignment.getElement(pSelector);
	if (!tmpEl) return null;
	if (Array.isArray(tmpEl) && tmpEl.length === 0) return null;
	let tmpNode = tmpEl[0] || tmpEl;
	if (!tmpNode || typeof tmpNode.getContext !== 'function') return null;
	return tmpNode;
}

module.exports = UltravisorCapabilityHeatMapView;
module.exports.default_configuration = _ViewConfiguration;

},{"./timeline/render-heatmap.js":283,"./timeline/url-state.js":286,"pict-view":239}],257:[function(require,module,exports){
/**
 * PictView-Ultravisor-Constellation
 *
 * Phase 7 / beacon constellation — answers "is the fleet healthy?"
 * Each beacon a node, color = liveness, halo when handling work, edges
 * connect beacons sharing a primary capability. Polls Observer/Snapshot
 * for the structural graph and `/Timeline?from=now-30s&to=now&bucket=raw`
 * for the live activity overlay.
 *
 * Standalone view at `/Constellation`.
 */

const libPictView = require('pict-view');
const libRenderConstellation = require('./timeline/render-constellation.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Ultravisor-Constellation',

	DefaultRenderable: 'Ultravisor-Constellation-Content',
	DefaultDestinationAddress: '#Ultravisor-Content-Container',

	AutoRender: false,

	CSS: /*css*/`
		.uv-constellation {
			padding: 1.5em;
			max-width: 1800px;
			margin: 0 auto;
		}
		.uv-constellation-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1em;
			padding-bottom: 0.75em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.uv-constellation-header h1 {
			margin: 0;
			font-size: 1.6em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.uv-constellation-stats {
			font-size: 0.85em;
			color: var(--uv-text-secondary);
			font-family: monospace;
		}
		.uv-constellation-stats strong {
			color: var(--uv-text);
			font-weight: 600;
		}
		.uv-constellation-canvas-wrap {
			position: relative;
			width: 100%;
			height: 620px;
			background: var(--uv-bg-base);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 6px;
		}
		.uv-constellation-canvas {
			position: absolute;
			top: 0; left: 0;
			width: 100%;
			height: 100%;
			cursor: crosshair;
		}
		.uv-constellation-detail {
			margin-top: 1em;
			padding: 0.85em 1em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 6px;
		}
		.uv-constellation-detail-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 0.4em;
			padding-bottom: 0.4em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.uv-constellation-detail-header h3 {
			margin: 0;
			font-size: 1em;
			font-weight: 600;
			color: var(--uv-text);
		}
		.uv-constellation-detail-close {
			background: none;
			border: none;
			color: var(--uv-text-secondary);
			cursor: pointer;
			font-size: 1.2em;
			padding: 0 0.4em;
		}
		.uv-constellation-detail pre {
			margin: 0;
			font-size: 0.78em;
			color: var(--uv-text);
			white-space: pre-wrap;
			word-break: break-all;
			max-height: 280px;
			overflow: auto;
		}
		.uv-constellation-help {
			margin-top: 1em;
			padding: 0.75em 1em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			font-size: 0.78em;
			color: var(--uv-text-secondary);
			line-height: 1.55;
		}
	`,

	Templates:
	[
		{
			Hash: 'Ultravisor-Constellation-Template',
			Template: /*html*/`
<div class="uv-constellation">
	<div class="uv-constellation-header">
		<h1>Beacon Constellation</h1>
		<div class="uv-constellation-stats" id="Ultravisor-Constellation-Stats">
			<span>beacons: <strong>0</strong></span>
		</div>
	</div>
	<div class="uv-constellation-canvas-wrap">
		<canvas class="uv-constellation-canvas" id="Ultravisor-Constellation-Canvas"></canvas>
	</div>
	<div id="Ultravisor-Constellation-Detail-Slot">
		{~TS:Ultravisor-Constellation-Detail-Template:AppData.Constellation.DetailSlot~}
	</div>
	<div class="uv-constellation-help">
		Each node is a beacon; <strong>color</strong> = liveness, <strong>size</strong> = recent throughput, <strong>halo</strong> = handling work right now. Edges connect beacons that share a primary capability. Click a node for its current snapshot.
	</div>
</div>
`
		},
		{
			Hash: 'Ultravisor-Constellation-Detail-Template',
			Template: /*html*/`
<div class="uv-constellation-detail">
	<div class="uv-constellation-detail-header">
		<h3>{~D:Record.Title~}</h3>
		<button class="uv-constellation-detail-close" onclick="{~P~}.views['Ultravisor-Constellation'].onCloseDetail()" title="Close">×</button>
	</div>
	<pre>{~D:Record.JSON~}</pre>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Ultravisor-Constellation-Content',
			TemplateHash:   'Ultravisor-Constellation-Template',
			DestinationAddress: '#Ultravisor-Content-Container',
			RenderMethod:   'replace'
		}
	]
};

const POLL_MS = 2500;

class UltravisorConstellationView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._PollHandle = null;
		this._FetchInFlight = null;
		this._RedrawScheduled = false;
		this._ResizeListener = null;
		this._ClickListener = null;
		this._AnimationLoop = null;
		this._RenderState = { Beacons: [], RecentActivity: {}, HitTestables: [], Now: null };
	}

	onBeforeRender(pRenderable, pAddress, pRecord)
	{
		this.pict.AppData.Constellation = this.pict.AppData.Constellation || {};
		this.pict.AppData.Constellation.DetailSlot = this.pict.AppData.Constellation.DetailSlot || [];
		// Don't _stopPoll() here — see Throughput's notes.
		return super.onBeforeRender(pRenderable, pAddress, pRecord);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._installResizeListener();
		this._installClickListener();
		this._fetchOnce();
		this._scheduleNextPoll();
		this._scheduleRedraw();
		// Keep the pulse animation running; we redraw at ~10fps just for
		// the halo. Cheap with ~10 beacons.
		this._startAnimationLoop();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	onCloseDetail()
	{
		this.pict.AppData.Constellation.DetailSlot = [];
		this.render();
	}

	// ====================================================================
	// Fetch
	// ====================================================================

	_fetchOnce()
	{
		this._abortInFlight();
		let tmpAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
		this._FetchInFlight = tmpAbort;
		let tmpBase = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.APIBaseURL) || '';
		let tmpFetchSnap = fetch(tmpBase + '/Observer/Snapshot', { signal: tmpAbort ? tmpAbort.signal : undefined })
			.then(function (pResp) { return pResp.ok ? pResp.json() : null; });
		let tmpFetchActivity = fetch(tmpBase + '/Timeline?from=now-30s&to=now&bucket=raw&waitMs=0&futureLimit=0',
				{ signal: tmpAbort ? tmpAbort.signal : undefined })
			.then(function (pResp) { return pResp.ok ? pResp.json() : null; });
		let tmpSelf = this;
		Promise.all([tmpFetchSnap, tmpFetchActivity])
			.then(function (pAll)
			{
				if (tmpSelf._FetchInFlight !== tmpAbort) return;
				tmpSelf._reconcile(pAll[0], pAll[1]);
				tmpSelf._FetchInFlight = null;
			})
			.catch(function (pErr)
			{
				if (pErr && pErr.name === 'AbortError') return;
				if (tmpSelf._FetchInFlight !== tmpAbort) return;
				tmpSelf.pict.log.warn('Constellation fetch failed: ' + pErr.message);
				tmpSelf._FetchInFlight = null;
			});
	}

	_reconcile(pSnapshot, pActivityBody)
	{
		let tmpBeaconsMap = (pSnapshot && pSnapshot.Beacons) || {};
		let tmpBeacons = [];
		// Snapshot.Beacons is keyed by beacon id; flatten preserving order.
		let tmpKeys = Object.keys(tmpBeaconsMap).sort();
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpB = tmpBeaconsMap[tmpKeys[i]];
			if (tmpB) { tmpBeacons.push(tmpB); }
		}

		// Recent activity tally from /Timeline raw past+present.
		let tmpAll = []
			.concat((pActivityBody && Array.isArray(pActivityBody.Past)) ? pActivityBody.Past : [])
			.concat((pActivityBody && Array.isArray(pActivityBody.Present)) ? pActivityBody.Present : []);
		let tmpActivity = {};
		for (let i = 0; i < tmpAll.length; i++)
		{
			let tmpBid = tmpAll[i].BeaconID;
			if (!tmpBid) continue;
			tmpActivity[tmpBid] = (tmpActivity[tmpBid] || 0) + 1;
		}

		this._RenderState.Beacons = tmpBeacons;
		this._RenderState.RecentActivity = tmpActivity;
		this._RenderState.Now = (pActivityBody && pActivityBody.Now) || (new Date()).toISOString();
		this._updateStatsLine(tmpBeacons);
		this._scheduleRedraw();
	}

	_updateStatsLine(pBeacons)
	{
		let tmpAlive = 0, tmpInDoubt = 0, tmpQuar = 0, tmpDefunct = 0;
		for (let i = 0; i < pBeacons.length; i++)
		{
			let tmpL = pBeacons[i].Liveness || 'Unknown';
			if (tmpL === 'Alive') tmpAlive++;
			else if (tmpL === 'In-Doubt' || tmpL === 'InDoubt') tmpInDoubt++;
			else if (tmpL === 'Quarantined') tmpQuar++;
			else if (tmpL === 'Defunct') tmpDefunct++;
		}
		let tmpHTML = '<span>beacons: <strong>' + pBeacons.length + '</strong></span>'
			+ '<span style="margin-left:0.75em">alive: <strong>' + tmpAlive + '</strong></span>'
			+ '<span style="margin-left:0.5em">in-doubt: <strong>' + tmpInDoubt + '</strong></span>'
			+ '<span style="margin-left:0.5em">quarantined: <strong>' + tmpQuar + '</strong></span>'
			+ '<span style="margin-left:0.5em">defunct: <strong>' + tmpDefunct + '</strong></span>';
		try { this.pict.ContentAssignment.assignContent('#Ultravisor-Constellation-Stats', tmpHTML); }
		catch (pErr) { /* best effort */ }
	}

	// ====================================================================
	// Polling + animation
	// ====================================================================

	_scheduleNextPoll()
	{
		// Clear only the timer; not the in-flight fetch.
		if (this._PollHandle) { clearTimeout(this._PollHandle); this._PollHandle = null; }
		this._PollHandle = setTimeout(function ()
		{
			this._PollHandle = null;
			this._fetchOnce();
			this._scheduleNextPoll();
		}.bind(this), POLL_MS);
	}

	_stopPoll()
	{
		if (this._PollHandle) { clearTimeout(this._PollHandle); this._PollHandle = null; }
		this._abortInFlight();
		if (this._AnimationLoop)
		{
			clearInterval(this._AnimationLoop);
			this._AnimationLoop = null;
		}
	}

	_abortInFlight()
	{
		if (this._FetchInFlight)
		{
			try { this._FetchInFlight.abort(); }
			catch (pErr) { /* ignore */ }
			this._FetchInFlight = null;
		}
	}

	_startAnimationLoop()
	{
		if (this._AnimationLoop) return;
		this._AnimationLoop = setInterval(function ()
		{
			// Only redraw if there's at least one working beacon (the halo
			// is the only thing that actually animates).
			let tmpAnyWorking = false;
			let tmpBeacons = this._RenderState.Beacons || [];
			for (let i = 0; i < tmpBeacons.length; i++)
			{
				if (Array.isArray(tmpBeacons[i].CurrentWorkItems)
					&& tmpBeacons[i].CurrentWorkItems.length > 0)
				{
					tmpAnyWorking = true; break;
				}
			}
			if (tmpAnyWorking) { this._scheduleRedraw(); }
		}.bind(this), 100);
	}

	// ====================================================================
	// Click & resize
	// ====================================================================

	_installResizeListener()
	{
		if (this._ResizeListener) return;
		let fResize = function () { this._scheduleRedraw(); }.bind(this);
		window.addEventListener('resize', fResize);
		this._ResizeListener = fResize;
	}

	_installClickListener()
	{
		let tmpEl = this.pict.ContentAssignment.getElement('#Ultravisor-Constellation-Canvas');
		if (!tmpEl) return;
		let tmpCanvas = tmpEl[0] || tmpEl;
		if (!tmpCanvas) return;
		let fClick = function (pEvent)
		{
			let tmpRect = tmpCanvas.getBoundingClientRect();
			let tmpX = pEvent.clientX - tmpRect.left;
			let tmpY = pEvent.clientY - tmpRect.top;
			let tmpHit = libRenderConstellation.hitTest(tmpX, tmpY, this._RenderState);
			if (!tmpHit) return;
			// Find the matching beacon in our last render state.
			let tmpBeacons = this._RenderState.Beacons || [];
			let tmpFound = null;
			for (let i = 0; i < tmpBeacons.length; i++)
			{
				if (tmpBeacons[i].BeaconID === tmpHit) { tmpFound = tmpBeacons[i]; break; }
			}
			if (!tmpFound) return;
			let tmpJSON = '';
			try { tmpJSON = JSON.stringify(tmpFound, null, 2); }
			catch (pErr) { tmpJSON = '(unable to serialize)'; }
			this.pict.AppData.Constellation.DetailSlot =
			[{
				Title: tmpFound.Name || tmpFound.BeaconID,
				JSON:  tmpJSON
			}];
			this.render();
		}.bind(this);
		tmpCanvas.addEventListener('click', fClick);
		this._ClickListener = { node: tmpCanvas, fn: fClick };
	}

	_scheduleRedraw()
	{
		if (this._RedrawScheduled) return;
		this._RedrawScheduled = true;
		let tmpFn = function ()
		{
			this._RedrawScheduled = false;
			this._draw();
		}.bind(this);
		if (typeof window !== 'undefined' && window.requestAnimationFrame) { window.requestAnimationFrame(tmpFn); }
		else { setTimeout(tmpFn, 16); }
	}

	_draw()
	{
		let tmpCanvas = _resolveCanvas(this.pict, '#Ultravisor-Constellation-Canvas');
		if (!tmpCanvas)
		{
			this._stopPoll();
			return;
		}
		try
		{
			libRenderConstellation.drawConstellation(tmpCanvas, this._RenderState);
		}
		catch (pErr)
		{
			this.pict.log.warn('Constellation draw failed: ' + pErr.message);
		}
	}
}

function _resolveCanvas(pPict, pSelector)
{
	let tmpEl = pPict.ContentAssignment.getElement(pSelector);
	if (!tmpEl) return null;
	if (Array.isArray(tmpEl) && tmpEl.length === 0) return null;
	let tmpNode = tmpEl[0] || tmpEl;
	if (!tmpNode || typeof tmpNode.getContext !== 'function') return null;
	return tmpNode;
}

module.exports = UltravisorConstellationView;
module.exports.default_configuration = _ViewConfiguration;

},{"./timeline/render-constellation.js":282,"pict-view":239}],258:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-Dashboard",

	DefaultRenderable: "Ultravisor-Dashboard-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-dashboard {
			padding: 2em;
			max-width: 1200px;
			margin: 0 auto;
		}
		.ultravisor-dashboard-header {
			margin: 0 0 1.5em 0;
			padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-dashboard-header h1 {
			margin: 0 0 0.25em 0;
			font-size: 2em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.ultravisor-dashboard-header p {
			margin: 0;
			color: var(--uv-text-secondary);
			font-size: 1.1em;
		}
		.ultravisor-dashboard-cards {
			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
			gap: 1.25em;
			margin-bottom: 2em;
		}
		.ultravisor-stat-card {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			padding: 1.25em;
			transition: border-color 0.2s;
		}
		.ultravisor-stat-card:hover {
			border-color: var(--uv-brand);
		}
		.ultravisor-stat-card-label {
			font-size: 0.8em;
			color: var(--uv-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.05em;
			margin-bottom: 0.5em;
		}
		.ultravisor-stat-card-value {
			font-size: 2em;
			font-weight: 600;
			color: var(--uv-brand);
		}
		.ultravisor-stat-card-value.running {
			color: var(--uv-success);
		}
		.ultravisor-stat-card-value.stopped {
			color: var(--uv-error);
		}
		.ultravisor-dashboard-actions {
			display: flex;
			gap: 0.75em;
			margin-top: 1.5em;
		}
		.ultravisor-btn {
			padding: 0.6em 1.25em;
			border-radius: 4px;
			font-size: 0.9em;
			cursor: pointer;
			border: none;
			transition: background-color 0.15s;
		}
		.ultravisor-btn-primary {
			background-color: var(--uv-brand);
			color: var(--uv-bg-elevated);
			font-weight: 600;
		}
		.ultravisor-btn-primary:hover {
			background-color: var(--uv-brand-hover);
		}
		.ultravisor-btn-danger {
			background-color: var(--uv-error);
			color: var(--theme-color-background-panel, #fff);
			font-weight: 600;
		}
		.ultravisor-btn-danger:hover {
			background-color: #e53935;
		}
		.ultravisor-btn-secondary {
			background-color: var(--uv-btn-secondary-bg);
			color: var(--uv-text);
		}
		.ultravisor-btn-secondary:hover {
			background-color: var(--uv-btn-secondary-bg);
		}
		.ultravisor-btn-execute {
			background-color: #1a3a2a;
			color: #5ab88a;
			border: 1px solid #2a5040;
			font-weight: 600;
		}
		.ultravisor-btn-execute:hover {
			background-color: #204530;
			border-color: #3a6050;
		}
		.ultravisor-btn-sm.ultravisor-btn-execute {
			background-color: #1a3a2a;
			color: #5ab88a;
			border: 1px solid #2a5040;
		}
		.ultravisor-btn-sm.ultravisor-btn-execute:hover {
			background-color: #204530;
		}
		.ultravisor-dashboard-section-title {
			font-size: 1.1em;
			font-weight: 600;
			color: var(--uv-text-secondary);
			margin: 2em 0 1em 0;
			padding-bottom: 0.5em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-Dashboard-Template",
			Template: /*html*/`
<div class="ultravisor-dashboard">
	<div class="ultravisor-dashboard-header">
		<h1>Dashboard</h1>
	</div>
	<div class="ultravisor-dashboard-cards" id="Ultravisor-Dashboard-Cards"></div>
	<div class="ultravisor-dashboard-section-title">Schedule Control</div>
	<div class="ultravisor-dashboard-actions" id="Ultravisor-Dashboard-Actions"></div>
</div>
`
		},
		{
			Hash: "Ultravisor-Dashboard-Cards-Template",
			Template: /*html*/`
<div class="ultravisor-stat-card">
	<div class="ultravisor-stat-card-label">Server Status</div>
	<div class="ultravisor-stat-card-value" id="Ultravisor-Dashboard-StatusValue">{~D:AppData.Ultravisor.ServerStatus.Status~}</div>
</div>
<div class="ultravisor-stat-card">
	<div class="ultravisor-stat-card-label">Templates</div>
	<div class="ultravisor-stat-card-value" id="Ultravisor-Dashboard-TemplateCount">--</div>
</div>
<div class="ultravisor-stat-card">
	<div class="ultravisor-stat-card-label">Operations</div>
	<div class="ultravisor-stat-card-value" id="Ultravisor-Dashboard-OperationCount">--</div>
</div>
<div class="ultravisor-stat-card">
	<div class="ultravisor-stat-card-label">Schedule Entries</div>
	<div class="ultravisor-stat-card-value">{~D:AppData.Ultravisor.ServerStatus.ScheduleEntries~}</div>
</div>
<div class="ultravisor-stat-card">
	<div class="ultravisor-stat-card-label">Schedule Running</div>
	<div class="ultravisor-stat-card-value" id="Ultravisor-Dashboard-ScheduleRunning">--</div>
</div>
`
		},
		{
			Hash: "Ultravisor-Dashboard-Actions-Template",
			Template: /*html*/`
<button class="ultravisor-btn ultravisor-btn-primary" onclick="{~P~}.PictApplication.startSchedule(function(){ {~P~}.PictApplication.showView('Ultravisor-Dashboard'); })">Start Schedule</button>
<button class="ultravisor-btn ultravisor-btn-danger" onclick="{~P~}.PictApplication.stopSchedule(function(){ {~P~}.PictApplication.showView('Ultravisor-Dashboard'); })">Stop Schedule</button>
<button class="ultravisor-btn ultravisor-btn-secondary" onclick="{~P~}.PictApplication.showView('Ultravisor-Dashboard')">Refresh</button>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-Dashboard-Content",
			TemplateHash: "Ultravisor-Dashboard-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorDashboardView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpApp = this.pict.PictApplication;

		// Load status, tasks, operations, and schedule counts
		tmpApp.loadStatus(
			function ()
			{
				let tmpCardsHTML = this.pict.parseTemplateByHash('Ultravisor-Dashboard-Cards-Template', {}, null, this.pict);
				this.pict.ContentAssignment.assignContent('#Ultravisor-Dashboard-Cards', tmpCardsHTML);

				let tmpActionsHTML = this.pict.parseTemplateByHash('Ultravisor-Dashboard-Actions-Template', {}, null, this.pict);
				this.pict.ContentAssignment.assignContent('#Ultravisor-Dashboard-Actions', tmpActionsHTML);

				// Update schedule running indicator
				let tmpRunning = this.pict.AppData.Ultravisor.ServerStatus.ScheduleRunning;
				let tmpRunEl = document.getElementById('Ultravisor-Dashboard-ScheduleRunning');
				if (tmpRunEl)
				{
					tmpRunEl.textContent = tmpRunning ? 'Yes' : 'No';
					tmpRunEl.className = 'ultravisor-stat-card-value ' + (tmpRunning ? 'running' : 'stopped');
				}

				// Load template count
				tmpApp.loadNodeTemplates(
					function ()
					{
						let tmpCountEl = document.getElementById('Ultravisor-Dashboard-TemplateCount');
						if (tmpCountEl)
						{
							tmpCountEl.textContent = this.pict.AppData.Ultravisor.NodeTemplateList.length;
						}
					}.bind(this));

				// Load operation count
				tmpApp.loadOperations(
					function ()
					{
						let tmpCountEl = document.getElementById('Ultravisor-Dashboard-OperationCount');
						if (tmpCountEl)
						{
							tmpCountEl.textContent = this.pict.AppData.Ultravisor.OperationList.length;
						}
					}.bind(this));

			}.bind(this));

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}
}

module.exports = UltravisorDashboardView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],259:[function(require,module,exports){
const libPictView = require('pict-view');
const libDocuserveProvider = require('pict-docuserve/source/providers/Pict-Provider-Docuserve-Documentation.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-Documentation",

	DefaultRenderable: "Ultravisor-Documentation-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-docs {
			display: flex;
			height: calc(100vh - 56px - 39px);
			min-height: 400px;
			overflow: hidden;
		}
		.ultravisor-docs-sidebar {
			flex-shrink: 0;
			width: 260px;
			background-color: var(--uv-bg-surface);
			border-right: 1px solid var(--uv-border-subtle);
			overflow-y: auto;
			display: flex;
			flex-direction: column;
		}
		.ultravisor-docs-sidebar-search {
			padding: 0.75em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-docs-sidebar-search input {
			width: 100%;
			padding: 0.4em 0.6em;
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			background: var(--uv-bg-elevated);
			color: var(--uv-text);
			font-size: 0.85em;
			outline: none;
			box-sizing: border-box;
		}
		.ultravisor-docs-sidebar-search input:focus {
			border-color: var(--uv-brand);
		}
		.ultravisor-docs-sidebar-search input::placeholder {
			color: var(--uv-text-tertiary);
		}
		.ultravisor-docs-search-results {
			margin-top: 0.5em;
		}
		.ultravisor-docs-search-results a {
			display: block;
			padding: 0.35em 0.5em;
			color: var(--uv-text-secondary);
			text-decoration: none;
			font-size: 0.8em;
			border-radius: 3px;
			cursor: pointer;
		}
		.ultravisor-docs-search-results a:hover {
			background-color: var(--uv-topbar-hover);
			color: var(--theme-color-background-panel, #fff);
		}
		.ultravisor-docs-search-result-title {
			font-weight: 600;
			color: var(--uv-text);
		}
		.ultravisor-docs-search-results a:hover .ultravisor-docs-search-result-title {
			color: var(--theme-color-background-panel, #fff);
		}
		.ultravisor-docs-search-result-meta {
			font-size: 0.9em;
			color: var(--uv-text-tertiary);
		}
		.ultravisor-docs-sidebar-nav {
			flex: 1;
			overflow-y: auto;
			padding: 0.5em 0;
		}
		.ultravisor-docs-sidebar-home {
			padding: 0.5em 1em;
		}
		.ultravisor-docs-sidebar-home a {
			color: var(--uv-link);
			text-decoration: none;
			font-weight: 600;
			font-size: 0.85em;
			cursor: pointer;
		}
		.ultravisor-docs-sidebar-home a:hover {
			color: var(--uv-link-hover);
		}
		.ultravisor-docs-sidebar-group {
			margin-top: 0.25em;
		}
		.ultravisor-docs-group-title {
			display: block;
			padding: 0.5em 1em;
			font-weight: 600;
			font-size: 0.8em;
			color: var(--uv-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.04em;
			cursor: pointer;
			text-decoration: none;
			transition: background-color 0.15s, color 0.15s;
		}
		.ultravisor-docs-group-title:hover {
			color: var(--uv-link);
			background-color: #1a2744;
		}
		.ultravisor-docs-group-title.active {
			color: var(--uv-link);
			background-color: var(--uv-bg-elevated);
		}
		.ultravisor-docs-module-list {
			list-style: none;
			margin: 0;
			padding: 0;
		}
		.ultravisor-docs-module-list a {
			display: block;
			padding: 0.3em 1em 0.3em 1.75em;
			color: var(--uv-text-secondary);
			text-decoration: none;
			font-size: 0.85em;
			cursor: pointer;
			transition: background-color 0.15s, color 0.15s;
		}
		.ultravisor-docs-module-list a:hover {
			background-color: #1a2744;
			color: var(--theme-color-background-panel, #fff);
		}
		.ultravisor-docs-module-list a.active {
			color: var(--uv-link);
			font-weight: 600;
			background-color: var(--uv-bg-elevated);
		}
		.ultravisor-docs-module-list .no-docs {
			display: block;
			padding: 0.3em 1em 0.3em 1.75em;
			color: var(--uv-btn-secondary-bg);
			font-size: 0.85em;
		}
		.ultravisor-docs-content {
			flex: 1;
			min-width: 0;
			overflow-y: auto;
			background-color: var(--uv-bg-base);
		}
		.ultravisor-docs-body {
			padding: 2em 3em;
			max-width: 900px;
			margin: 0 auto;
		}
		.ultravisor-docs-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 200px;
			color: var(--uv-text-tertiary);
			font-size: 1em;
		}
		/* Markdown content styling for dark theme */
		.ultravisor-docs-body h1 {
			font-size: 2em;
			color: var(--uv-text);
			border-bottom: 1px solid var(--uv-border-subtle);
			padding-bottom: 0.3em;
			margin-top: 0;
			font-weight: 300;
		}
		.ultravisor-docs-body h2 {
			font-size: 1.5em;
			color: var(--uv-text);
			border-bottom: 1px solid #1e3a5f;
			padding-bottom: 0.25em;
			margin-top: 1.5em;
			font-weight: 400;
		}
		.ultravisor-docs-body h3 {
			font-size: 1.25em;
			color: var(--uv-text);
			margin-top: 1.25em;
		}
		.ultravisor-docs-body h4,
		.ultravisor-docs-body h5,
		.ultravisor-docs-body h6 {
			color: var(--uv-text-secondary);
			margin-top: 1em;
		}
		.ultravisor-docs-body p {
			line-height: 1.7;
			color: var(--uv-text-secondary);
			margin: 0.75em 0;
		}
		.ultravisor-docs-body a {
			color: var(--uv-link);
			text-decoration: none;
		}
		.ultravisor-docs-body a:hover {
			text-decoration: underline;
			color: var(--uv-link-hover);
		}
		.ultravisor-docs-body pre {
			background: #0d1b2a;
			color: var(--uv-text);
			padding: 1.25em;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: 0.9em;
			border: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-docs-body code {
			background: #0d1b2a;
			padding: 0.15em 0.4em;
			border-radius: 3px;
			font-size: 0.9em;
			color: var(--uv-brand);
		}
		.ultravisor-docs-body pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
		}
		.ultravisor-docs-body .pict-content-code-wrap {
			position: relative;
			font-family: 'SFMono-Regular', 'SF Mono', 'Menlo', 'Consolas', monospace;
			font-size: 14px;
			line-height: 1.5;
			border-radius: 6px;
			overflow: auto;
			margin: 1em 0;
			background: #0d1b2a;
			border: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-docs-body .pict-content-code-wrap .pict-content-code-line-numbers {
			position: absolute;
			top: 0;
			left: 0;
			width: 40px;
			padding: 1.25em 0;
			text-align: right;
			background: #0a1525;
			border-right: 1px solid var(--uv-border-subtle);
			color: var(--uv-btn-secondary-bg);
			font-size: 13px;
			line-height: 1.5;
			user-select: none;
			pointer-events: none;
			box-sizing: border-box;
		}
		.ultravisor-docs-body .pict-content-code-wrap .pict-content-code-line-numbers span {
			display: block;
			padding: 0 8px 0 0;
		}
		.ultravisor-docs-body .pict-content-code-wrap pre {
			margin: 0;
			background: #0d1b2a;
			color: var(--uv-text);
			padding: 1.25em 1.25em 1.25em 52px;
			border-radius: 6px;
			overflow-x: auto;
			line-height: 1.5;
			font-size: inherit;
			border: none;
		}
		.ultravisor-docs-body .pict-content-code-wrap pre code {
			background: none;
			padding: 0;
			color: inherit;
			font-size: inherit;
			font-family: inherit;
		}
		.ultravisor-docs-body .pict-content-code-wrap .keyword { color: #C678DD; }
		.ultravisor-docs-body .pict-content-code-wrap .string { color: #98C379; }
		.ultravisor-docs-body .pict-content-code-wrap .number { color: #D19A66; }
		.ultravisor-docs-body .pict-content-code-wrap .comment { color: #546e7a; font-style: italic; }
		.ultravisor-docs-body .pict-content-code-wrap .operator { color: #56B6C2; }
		.ultravisor-docs-body .pict-content-code-wrap .punctuation { color: var(--uv-text); }
		.ultravisor-docs-body .pict-content-code-wrap .function-name { color: #61AFEF; }
		.ultravisor-docs-body .pict-content-code-wrap .property { color: #E06C75; }
		.ultravisor-docs-body .pict-content-code-wrap .tag { color: #E06C75; }
		.ultravisor-docs-body .pict-content-code-wrap .attr-name { color: #D19A66; }
		.ultravisor-docs-body .pict-content-code-wrap .attr-value { color: #98C379; }
		.ultravisor-docs-body blockquote {
			border-left: 4px solid var(--uv-brand);
			margin: 1em 0;
			padding: 0.5em 1em;
			background: var(--uv-bg-surface);
			color: var(--uv-text-secondary);
		}
		.ultravisor-docs-body blockquote p {
			margin: 0.25em 0;
		}
		.ultravisor-docs-body ul,
		.ultravisor-docs-body ol {
			padding-left: 2em;
			line-height: 1.8;
		}
		.ultravisor-docs-body li {
			margin: 0.25em 0;
			color: var(--uv-text-secondary);
		}
		.ultravisor-docs-body hr {
			border: none;
			border-top: 1px solid var(--uv-border-subtle);
			margin: 2em 0;
		}
		.ultravisor-docs-body table {
			width: 100%;
			border-collapse: collapse;
			margin: 1em 0;
		}
		.ultravisor-docs-body table th {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			padding: 0.6em 0.8em;
			text-align: left;
			font-weight: 600;
			color: var(--uv-text);
		}
		.ultravisor-docs-body table td {
			border: 1px solid var(--uv-border-subtle);
			padding: 0.5em 0.8em;
			color: var(--uv-text-secondary);
		}
		.ultravisor-docs-body table tr:nth-child(even) {
			background: var(--uv-bg-surface);
		}
		.ultravisor-docs-body img {
			max-width: 100%;
			height: auto;
		}
		.ultravisor-docs-body strong {
			color: var(--uv-text);
		}
		.ultravisor-docs-not-found {
			text-align: center;
			padding: 3em 1em;
			color: var(--uv-text-tertiary);
		}
		.ultravisor-docs-not-found h2 {
			color: var(--uv-text-secondary);
			font-size: 1.5em;
			border-bottom: none;
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-Documentation-Template",
			Template: /*html*/`
<div class="ultravisor-docs">
	<div class="ultravisor-docs-sidebar">
		<div class="ultravisor-docs-sidebar-search" id="Ultravisor-Docs-Search-Container" style="display:none;">
			<input type="text" placeholder="Search docs..." id="Ultravisor-Docs-Search-Input">
			<div id="Ultravisor-Docs-Search-Results" class="ultravisor-docs-search-results"></div>
		</div>
		<div class="ultravisor-docs-sidebar-nav" id="Ultravisor-Docs-Sidebar-Nav">
			<div class="ultravisor-docs-loading">Loading...</div>
		</div>
	</div>
	<div class="ultravisor-docs-content">
		<div id="Ultravisor-Docs-Content-Body" class="ultravisor-docs-body">
			<div class="ultravisor-docs-loading">Loading documentation...</div>
		</div>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-Documentation-Content",
			TemplateHash: "Ultravisor-Documentation-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorDocumentationView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._Initialized = false;
		this._SearchDebounceTimer = null;
	}

	/**
	 * Initialize the Docuserve provider and AppData state if not already done.
	 *
	 * @param {Function} fCallback - Called once initialization is complete
	 */
	_ensureInitialized(fCallback)
	{
		if (this._Initialized)
		{
			return fCallback();
		}

		// Initialize docuserve application state
		if (!this.pict.AppData.Docuserve)
		{
			this.pict.AppData.Docuserve =
			{
				CatalogLoaded: false,
				Catalog: null,
				CoverLoaded: false,
				Cover: null,
				SidebarLoaded: false,
				SidebarGroups: [],
				TopBarLoaded: false,
				TopBar: null,
				ErrorPageLoaded: false,
				ErrorPageHTML: null,
				KeywordIndexLoaded: false,
				KeywordDocumentCount: 0,
				CurrentGroup: '',
				CurrentModule: '',
				CurrentPath: '',
				SidebarVisible: true,
				DocsBaseURL: 'docs/',
				CatalogURL: 'docs/retold-catalog.json'
			};
		}

		// Register the docuserve documentation provider if not already done
		if (!this.pict.providers['Docuserve-Documentation'])
		{
			this.pict.addProvider('Docuserve-Documentation', libDocuserveProvider.default_configuration, libDocuserveProvider);
		}

		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];

		// Load catalog and optional files
		tmpDocProvider.loadCatalog(
			function ()
			{
				this._Initialized = true;
				return fCallback();
			}.bind(this));
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this._ensureInitialized(
			function ()
			{
				this._renderSidebar();

				// Set up search input
				let tmpSearchContainer = document.getElementById('Ultravisor-Docs-Search-Container');
				if (tmpSearchContainer && this.pict.AppData.Docuserve.KeywordIndexLoaded)
				{
					tmpSearchContainer.style.display = '';

					let tmpInput = document.getElementById('Ultravisor-Docs-Search-Input');
					if (tmpInput)
					{
						tmpInput.addEventListener('input',
							function ()
							{
								if (this._SearchDebounceTimer)
								{
									clearTimeout(this._SearchDebounceTimer);
								}
								this._SearchDebounceTimer = setTimeout(
									function ()
									{
										this._performSearch(tmpInput.value);
									}.bind(this), 250);
							}.bind(this));
					}
				}

				// Load the current page or default to the cover/overview
				let tmpCurrentPath = this.pict.AppData.Docuserve.CurrentPath;
				if (tmpCurrentPath)
				{
					this.navigateToPage(tmpCurrentPath);
				}
				else
				{
					// Show the overview page by default
					this.navigateToPage('overview');
				}
			}.bind(this));

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Render the sidebar navigation from the parsed SidebarGroups data.
	 */
	_renderSidebar()
	{
		let tmpGroups = this.pict.AppData.Docuserve.SidebarGroups;
		let tmpCurrentPath = this.pict.AppData.Docuserve.CurrentPath;

		let tmpHTML = '';

		// Home link
		tmpHTML += '<div class="ultravisor-docs-sidebar-home">';
		tmpHTML += '<a onclick="_Pict.views[\'Ultravisor-Documentation\'].navigateToPage(\'overview\')">Documentation</a>';
		tmpHTML += '</div>';

		if (!tmpGroups || tmpGroups.length < 1)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-Docs-Sidebar-Nav', tmpHTML);
			return;
		}

		for (let i = 0; i < tmpGroups.length; i++)
		{
			let tmpGroup = tmpGroups[i];
			tmpHTML += '<div class="ultravisor-docs-sidebar-group">';

			// Group title
			let tmpGroupActive = '';
			if (tmpGroup.Modules && tmpGroup.Modules.length > 0)
			{
				// Check if any child module is active
				for (let k = 0; k < tmpGroup.Modules.length; k++)
				{
					if (tmpGroup.Modules[k].Route && this._isRouteActive(tmpGroup.Modules[k].Route))
					{
						tmpGroupActive = ' active';
						break;
					}
				}
			}

			// Determine group click action
			let tmpGroupClickPath = this._extractPagePath(tmpGroup.Route);
			if (tmpGroupClickPath)
			{
				tmpHTML += '<a class="ultravisor-docs-group-title' + tmpGroupActive + '" onclick="_Pict.views[\'Ultravisor-Documentation\'].navigateToPage(\'' + this._escapeAttr(tmpGroupClickPath) + '\')">' + this._escapeHTML(tmpGroup.Name) + '</a>';
			}
			else
			{
				tmpHTML += '<div class="ultravisor-docs-group-title' + tmpGroupActive + '">' + this._escapeHTML(tmpGroup.Name) + '</div>';
			}

			// Module list
			if (tmpGroup.Modules && tmpGroup.Modules.length > 0)
			{
				tmpHTML += '<ul class="ultravisor-docs-module-list">';

				for (let j = 0; j < tmpGroup.Modules.length; j++)
				{
					let tmpModule = tmpGroup.Modules[j];

					if (tmpModule.HasDocs && tmpModule.Route)
					{
						let tmpModulePath = this._extractPagePath(tmpModule.Route);
						let tmpActiveClass = this._isRouteActive(tmpModule.Route) ? ' class="active"' : '';

						if (tmpModulePath)
						{
							tmpHTML += '<li><a' + tmpActiveClass + ' onclick="_Pict.views[\'Ultravisor-Documentation\'].navigateToPage(\'' + this._escapeAttr(tmpModulePath) + '\')">' + this._escapeHTML(tmpModule.Name) + '</a></li>';
						}
						else
						{
							tmpHTML += '<li><a' + tmpActiveClass + '>' + this._escapeHTML(tmpModule.Name) + '</a></li>';
						}
					}
					else
					{
						tmpHTML += '<li><span class="no-docs">' + this._escapeHTML(tmpModule.Name) + '</span></li>';
					}
				}

				tmpHTML += '</ul>';
			}

			tmpHTML += '</div>';
		}

		this.pict.ContentAssignment.assignContent('#Ultravisor-Docs-Sidebar-Nav', tmpHTML);
	}

	/**
	 * Navigate to a documentation page by path.
	 *
	 * @param {string} pPath - The page path (e.g. 'overview', 'features/tasks')
	 */
	navigateToPage(pPath)
	{
		if (!pPath)
		{
			return;
		}

		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
		if (!tmpDocProvider)
		{
			return;
		}

		// Update current path
		this.pict.AppData.Docuserve.CurrentPath = pPath;

		// Show loading
		this.pict.ContentAssignment.assignContent('#Ultravisor-Docs-Content-Body',
			'<div class="ultravisor-docs-loading">Loading documentation...</div>');

		// Re-render sidebar to update active states
		this._renderSidebar();

		// Ensure the path has a .md extension
		let tmpFilePath = pPath;
		if (!tmpFilePath.match(/\.md$/))
		{
			tmpFilePath = tmpFilePath + '.md';
		}

		// Fetch the local document
		tmpDocProvider.fetchLocalDocument(tmpFilePath,
			function (pError, pHTML)
			{
				if (pError || !pHTML)
				{
					// Check if this is a network error (server down) vs a missing document
					if (pError && typeof(pError) === 'object' && pError.message && pError.message.match(/fetch|network|failed/i))
					{
						this.pict.PictApplication._setConnectionState(false);
					}
					else
					{
						this.pict.ContentAssignment.assignContent('#Ultravisor-Docs-Content-Body',
							'<div class="ultravisor-docs-not-found"><h2>Page Not Found</h2><p>The document <code>' + this._escapeHTML(pPath) + '</code> could not be loaded.</p></div>');
					}
					return;
				}

				this.pict.ContentAssignment.assignContent('#Ultravisor-Docs-Content-Body', pHTML);

				// Scroll content to top
				let tmpContentEl = document.querySelector('.ultravisor-docs-content');
				if (tmpContentEl)
				{
					tmpContentEl.scrollTop = 0;
				}

				// Intercept internal links to route through our navigation
				this._interceptLinks();
			}.bind(this));
	}

	/**
	 * Intercept links within the rendered content that point to local docs.
	 */
	_interceptLinks()
	{
		let tmpContentBody = document.getElementById('Ultravisor-Docs-Content-Body');
		if (!tmpContentBody)
		{
			return;
		}

		let tmpLinks = tmpContentBody.querySelectorAll('a[href]');
		for (let i = 0; i < tmpLinks.length; i++)
		{
			let tmpLink = tmpLinks[i];
			let tmpHref = tmpLink.getAttribute('href');

			// Skip external links
			if (tmpHref.match(/^https?:\/\//) || tmpHref.match(/^mailto:/))
			{
				tmpLink.setAttribute('target', '_blank');
				tmpLink.setAttribute('rel', 'noopener');
				continue;
			}

			// Handle hash links from docuserve link resolver
			if (tmpHref.match(/^#\/page\//))
			{
				let tmpPagePath = tmpHref.replace(/^#\/page\//, '');
				tmpLink.setAttribute('href', 'javascript:void(0)');
				tmpLink.setAttribute('onclick', '_Pict.views[\'Ultravisor-Documentation\'].navigateToPage(\'' + this._escapeAttr(tmpPagePath) + '\')');
				continue;
			}

			// Handle relative .md links
			if (tmpHref.match(/\.md$/))
			{
				let tmpPagePath = tmpHref.replace(/^\.\//, '').replace(/\.md$/, '');

				// If the current page is in a subdirectory, resolve relative paths
				let tmpCurrentPath = this.pict.AppData.Docuserve.CurrentPath || '';
				let tmpCurrentDir = '';
				let tmpDirParts = tmpCurrentPath.split('/');
				if (tmpDirParts.length > 1)
				{
					tmpDirParts.pop();
					tmpCurrentDir = tmpDirParts.join('/') + '/';
				}

				if (!tmpPagePath.includes('/') && tmpCurrentDir)
				{
					tmpPagePath = tmpCurrentDir + tmpPagePath;
				}

				tmpLink.setAttribute('href', 'javascript:void(0)');
				tmpLink.setAttribute('onclick', '_Pict.views[\'Ultravisor-Documentation\'].navigateToPage(\'' + this._escapeAttr(tmpPagePath) + '\')');
			}
		}
	}

	/**
	 * Perform a sidebar search using the docuserve provider.
	 *
	 * @param {string} pQuery - The search query
	 */
	_performSearch(pQuery)
	{
		let tmpResultsEl = document.getElementById('Ultravisor-Docs-Search-Results');
		if (!tmpResultsEl)
		{
			return;
		}

		if (!pQuery || !pQuery.trim())
		{
			tmpResultsEl.innerHTML = '';
			return;
		}

		let tmpDocProvider = this.pict.providers['Docuserve-Documentation'];
		let tmpResults = tmpDocProvider.search(pQuery);

		if (tmpResults.length === 0)
		{
			tmpResultsEl.innerHTML = '<div style="padding: 0.35em 0.5em; font-size: 0.8em; color:var(--uv-text-tertiary);">No results found.</div>';
			return;
		}

		let tmpMaxResults = 8;
		let tmpHTML = '';

		for (let i = 0; i < tmpResults.length && i < tmpMaxResults; i++)
		{
			let tmpResult = tmpResults[i];
			let tmpPagePath = tmpResult.Key || '';
			let tmpMeta = '';

			if (tmpResult.Group && tmpResult.Module)
			{
				tmpMeta = tmpResult.Group + ' / ' + tmpResult.Module;
			}

			tmpHTML += '<a onclick="_Pict.views[\'Ultravisor-Documentation\'].navigateToPage(\'' + this._escapeAttr(tmpPagePath) + '\')">';
			tmpHTML += '<div class="ultravisor-docs-search-result-title">' + this._escapeHTML(tmpResult.Title) + '</div>';
			if (tmpMeta)
			{
				tmpHTML += '<div class="ultravisor-docs-search-result-meta">' + this._escapeHTML(tmpMeta) + '</div>';
			}
			tmpHTML += '</a>';
		}

		tmpResultsEl.innerHTML = tmpHTML;
	}

	/**
	 * Extract the page path from a hash route for internal navigation.
	 *
	 * @param {string} pRoute - A hash route (e.g. '#/page/overview', '#/doc/group/module')
	 * @returns {string} The extracted page path or empty string
	 */
	_extractPagePath(pRoute)
	{
		if (!pRoute)
		{
			return '';
		}

		// #/page/something
		let tmpPageMatch = pRoute.match(/^#\/page\/(.+)/);
		if (tmpPageMatch)
		{
			return tmpPageMatch[1];
		}

		// #/Home
		if (pRoute === '#/Home')
		{
			return 'overview';
		}

		return '';
	}

	/**
	 * Check whether a route matches the current navigation state.
	 *
	 * @param {string} pRoute - The hash route to check
	 * @returns {boolean} True if the route is active
	 */
	_isRouteActive(pRoute)
	{
		let tmpCurrentPath = this.pict.AppData.Docuserve.CurrentPath || '';
		let tmpRoutePath = this._extractPagePath(pRoute);

		if (!tmpRoutePath || !tmpCurrentPath)
		{
			return false;
		}

		return tmpCurrentPath === tmpRoutePath;
	}

	/**
	 * Escape HTML special characters.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	_escapeHTML(pText)
	{
		if (!pText)
		{
			return '';
		}
		return String(pText).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	/**
	 * Escape a string for use in an HTML attribute.
	 *
	 * @param {string} pText - The text to escape
	 * @returns {string} The escaped text
	 */
	_escapeAttr(pText)
	{
		if (!pText)
		{
			return '';
		}
		return String(pText).replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;');
	}
}

module.exports = UltravisorDocumentationView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-docuserve/source/providers/Pict-Provider-Docuserve-Documentation.js":11,"pict-view":239}],260:[function(require,module,exports){
/**
 * Ultravisor admin — Fleet view.
 *
 * Beacons × Models grid showing installation state per (beacon, model)
 * with operator actions: Install / Uninstall / Enable / Disable. Polls
 * /Fleet every 5s for live progress updates.
 *
 * Backend contract:
 *   GET  /Fleet                                       — full snapshot
 *   POST /Fleet/Install     { BeaconID, ModelKey }
 *   POST /Fleet/Uninstall   { BeaconID, ModelKey }
 *   POST /Fleet/Enable      { BeaconID, ModelKey }
 *   POST /Fleet/Disable     { BeaconID, ModelKey }
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Ultravisor-Fleet',
	DefaultRenderable: 'Ultravisor-Fleet-Content',
	DefaultDestinationAddress: '#Ultravisor-Content-Container',
	AutoRender: false,

	CSS: /*css*/`
		.uv-fleet { padding: 2em; max-width: 1600px; margin: 0 auto; }
		.uv-fleet-header {
			display: flex; justify-content: space-between; align-items: center;
			margin-bottom: 1.5em; padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.uv-fleet-header h1 {
			margin: 0; font-size: 2em; font-weight: 300; color: var(--uv-text);
		}
		.uv-fleet-summary {
			display: flex; gap: 1em; margin-bottom: 1.5em;
		}
		.uv-fleet-summary-card {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			padding: 0.7em 1.2em;
		}
		.uv-fleet-summary-count {
			font-size: 1.5em; font-weight: 700; color: var(--uv-text);
		}
		.uv-fleet-summary-label {
			font-size: 0.75em; text-transform: uppercase;
			letter-spacing: 0.5px; color: var(--uv-text-secondary);
		}
		.uv-fleet-grid-wrap {
			overflow-x: auto;
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			background: var(--uv-bg-surface);
		}
		table.uv-fleet-grid {
			border-collapse: collapse; min-width: 100%;
		}
		.uv-fleet-grid th, .uv-fleet-grid td {
			padding: 0.5em 0.7em;
			border-bottom: 1px solid var(--uv-border-subtle);
			border-right: 1px solid var(--uv-border-subtle);
			vertical-align: middle;
			font-size: 0.85em;
			white-space: nowrap;
		}
		.uv-fleet-grid th.uv-fleet-modelhead {
			writing-mode: vertical-lr;
			transform: rotate(180deg);
			min-height: 8em;
			text-align: left;
			background: var(--uv-bg-base);
			color: var(--uv-text-secondary);
			font-weight: 600;
		}
		.uv-fleet-grid th.uv-fleet-beaconhead {
			background: var(--uv-bg-base);
			color: var(--uv-text-secondary);
			text-align: left;
			min-width: 200px;
		}
		.uv-fleet-grid th.uv-fleet-corner { background: var(--uv-bg-base); }

		.uv-fleet-cell {
			text-align: center; min-width: 6em;
		}
		.uv-fleet-cell.installed-enabled  { background: rgba(102, 187, 106, 0.18); }
		.uv-fleet-cell.installed-disabled { background: rgba(255, 213, 79, 0.12); }
		.uv-fleet-cell.installing         { background: rgba(66, 165, 245, 0.18); }
		.uv-fleet-cell.error              { background: rgba(229, 57, 53, 0.18); }
		.uv-fleet-cell.queued             { background: rgba(189, 189, 189, 0.12); }

		.uv-fleet-cell-status {
			display: inline-block; padding: 0.1em 0.5em;
			border-radius: 999px; font-size: 0.7em; font-weight: 600;
			letter-spacing: 0.5px; text-transform: uppercase;
		}
		.uv-fleet-cell-actions {
			display: flex; gap: 0.3em; justify-content: center;
			margin-top: 0.3em;
		}
		.uv-fleet-cell-btn {
			background: transparent; border: 1px solid var(--uv-border-subtle);
			color: var(--uv-text); padding: 0.15em 0.5em;
			border-radius: 4px; font-size: 0.7em; cursor: pointer;
		}
		.uv-fleet-cell-btn:hover { background: var(--uv-bg-base); }
		.uv-fleet-cell-btn.primary {
			background: var(--uv-brand);
			color: var(--uv-text-heading);
			border-color: transparent;
		}
		.uv-fleet-progress {
			width: 80px; height: 4px;
			background: var(--uv-bg-base); border-radius: 2px;
			margin: 0.3em auto; overflow: hidden;
		}
		.uv-fleet-progress-fill {
			height: 100%; background: var(--uv-info);
			transition: width 0.3s;
		}
		.uv-fleet-runtime-row {
			background: var(--uv-bg-surface);
			border-top: 2px solid var(--uv-border-subtle);
			font-style: italic;
		}
		.uv-fleet-empty {
			text-align: center; padding: 3em;
			color: var(--uv-text-tertiary); font-size: 0.95em;
		}
		.uv-fleet-tag {
			display: inline-block;
			background: var(--uv-bg-base);
			border: 1px solid var(--uv-border-subtle);
			padding: 0.05em 0.4em;
			border-radius: 3px;
			font-size: 0.7em;
			color: var(--uv-text-secondary);
			margin-left: 0.4em;
		}
		.uv-fleet-refresh {
			font-size: 0.75em; color: var(--uv-text-tertiary);
			display: flex; align-items: center; gap: 0.4em;
		}
	`,

	Templates:
	[
		{
			Hash: 'Ultravisor-Fleet-Template',
			Template: /*html*/`
<div class="uv-fleet">
	<div class="uv-fleet-header">
		<h1>Fleet</h1>
		<div style="display:flex;align-items:center;gap:1em;">
			<div class="uv-fleet-refresh">
				<span style="width:6px;height:6px;border-radius:50%;background:var(--uv-success);display:inline-block;"></span>
				<span>Auto-refresh 5s</span>
			</div>
			<button class="ultravisor-btn ultravisor-btn-secondary" onclick="{~P~}.views['Ultravisor-Fleet'].refresh()">Refresh</button>
		</div>
	</div>
	<div id="Ultravisor-Fleet-Summary"></div>
	<div id="Ultravisor-Fleet-Body"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Ultravisor-Fleet-Content',
			TemplateHash: 'Ultravisor-Fleet-Template',
			DestinationAddress: '#Ultravisor-Content-Container',
			RenderMethod: 'replace'
		}
	]
};

class UltravisorFleetView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._refreshTimer = null;
		this._snapshot = null;
	}

	onBeforeRender(pRenderable, pDest, pRecord)
	{
		if (this._refreshTimer)
		{
			clearInterval(this._refreshTimer);
			this._refreshTimer = null;
		}
		return super.onBeforeRender(pRenderable, pDest, pRecord);
	}

	onAfterRender(pRenderable, pDest, pRecord, pContent)
	{
		this.refresh();
		this._refreshTimer = setInterval(this._silentRefresh.bind(this), 5000);
		return super.onAfterRender(pRenderable, pDest, pRecord, pContent);
	}

	refresh()
	{
		this.pict.PictApplication.apiCall('GET', '/Fleet', null, (pErr, pData) =>
		{
			if (pErr || !pData)
			{
				this.pict.log.warn('Fleet refresh failed: ' + (pErr ? pErr.message : 'no data'));
				return;
			}
			this._snapshot = pData;
			this._renderSummary();
			this._renderBody();
		});
	}

	_silentRefresh()
	{
		this.pict.PictApplication.apiCall('GET', '/Fleet', null, (pErr, pData) =>
		{
			if (pErr || !pData) return;
			this._snapshot = pData;
			this._renderSummary();
			this._renderBody();
		});
	}

	_renderSummary()
	{
		let tmpEl = document.getElementById('Ultravisor-Fleet-Summary');
		if (!tmpEl) return;
		let tmpSnap = this._snapshot || {};
		let tmpBeacons = tmpSnap.Beacons || [];
		let tmpModels = tmpSnap.AvailableModels || [];
		let tmpInstall = tmpSnap.ModelInstallations || [];
		let tmpInstalled = tmpInstall.filter(i => i.Status === 'installed').length;
		let tmpEnabled  = tmpInstall.filter(i => i.EnabledForDispatch && i.Status === 'installed').length;
		let tmpInstalling = tmpInstall.filter(i => i.Status === 'installing' || i.Status === 'queued').length;
		let tmpErrored = tmpInstall.filter(i => i.Status === 'error').length;
		let tmpOnline = tmpBeacons.filter(b => b.Status === 'Online' || b.Status === 'Busy').length;

		tmpEl.innerHTML = `
			<div class="uv-fleet-summary">
				<div class="uv-fleet-summary-card">
					<div class="uv-fleet-summary-count">${tmpBeacons.length}</div>
					<div class="uv-fleet-summary-label">Beacons (${tmpOnline} online)</div>
				</div>
				<div class="uv-fleet-summary-card">
					<div class="uv-fleet-summary-count">${tmpModels.length}</div>
					<div class="uv-fleet-summary-label">Available Models</div>
				</div>
				<div class="uv-fleet-summary-card">
					<div class="uv-fleet-summary-count" style="color:var(--uv-success);">${tmpEnabled}</div>
					<div class="uv-fleet-summary-label">Enabled Installations</div>
				</div>
				<div class="uv-fleet-summary-card">
					<div class="uv-fleet-summary-count">${tmpInstalled - tmpEnabled}</div>
					<div class="uv-fleet-summary-label">Disabled / Inactive</div>
				</div>
				<div class="uv-fleet-summary-card">
					<div class="uv-fleet-summary-count" style="color:var(--uv-info);">${tmpInstalling}</div>
					<div class="uv-fleet-summary-label">Installing</div>
				</div>
				<div class="uv-fleet-summary-card">
					<div class="uv-fleet-summary-count" style="color:#ef5350;">${tmpErrored}</div>
					<div class="uv-fleet-summary-label">Errors</div>
				</div>
			</div>`;
	}

	_renderBody()
	{
		let tmpEl = document.getElementById('Ultravisor-Fleet-Body');
		if (!tmpEl) return;
		let tmpSnap = this._snapshot || {};
		let tmpBeacons = tmpSnap.Beacons || [];
		let tmpModels = tmpSnap.AvailableModels || [];
		let tmpInst = tmpSnap.ModelInstallations || [];
		let tmpRuntimes = tmpSnap.RuntimeInstallations || [];
		let tmpRegRuntimes = tmpSnap.RegisteredRuntimes || [];

		if (tmpBeacons.length === 0)
		{
			tmpEl.innerHTML = `<div class="uv-fleet-empty">No beacons registered yet.<br/>Start a worker against this hub and reload.</div>`;
			return;
		}
		if (tmpModels.length === 0)
		{
			tmpEl.innerHTML = `<div class="uv-fleet-empty">No model catalog registered.<br/>Make sure the hub's app (e.g. retold-labs) called <code>FleetManager.registerModelCatalog()</code> at startup.</div>`;
			return;
		}

		// Index installations by (BeaconID, ModelKey).
		let tmpByCell = {};
		for (let tmpI of tmpInst)
		{
			tmpByCell[tmpI.BeaconID + '|' + tmpI.ModelKey] = tmpI;
		}
		// Index runtime installs by BeaconID for the runtime row.
		let tmpRuntimeByBeacon = {};
		for (let tmpR of tmpRuntimes)
		{
			tmpRuntimeByBeacon[tmpR.BeaconID] = tmpRuntimeByBeacon[tmpR.BeaconID] || [];
			tmpRuntimeByBeacon[tmpR.BeaconID].push(tmpR);
		}

		// Sort: beacons by name; models by name.
		let tmpSortedBeacons = tmpBeacons.slice().sort((a, b) =>
			(a.Name || '').localeCompare(b.Name || ''));
		let tmpSortedModels = tmpModels.slice().sort((a, b) =>
			(a.DisplayName || a.ModelName || '').localeCompare(b.DisplayName || b.ModelName || ''));

		let tmpHtml = '<div class="uv-fleet-grid-wrap"><table class="uv-fleet-grid"><thead><tr>';
		tmpHtml += '<th class="uv-fleet-corner">Beacon \u00d7 Model</th>';
		for (let tmpM of tmpSortedModels)
		{
			let tmpName = this._escape(tmpM.DisplayName || tmpM.ModelName);
			tmpHtml += `<th class="uv-fleet-modelhead" title="${tmpName}">${tmpName}</th>`;
		}
		tmpHtml += '</tr></thead><tbody>';

		for (let tmpB of tmpSortedBeacons)
		{
			let tmpStatus = (tmpB.Status || 'unknown').toLowerCase();
			let tmpRuntimeBadges = '';
			let tmpBcnRuntimes = tmpRuntimeByBeacon[tmpB.BeaconID] || [];
			for (let tmpR of tmpBcnRuntimes)
			{
				let tmpClass = tmpR.Status === 'installed' ? 'installed-enabled'
					: tmpR.Status === 'pushing' ? 'installing'
					: tmpR.Status === 'error' ? 'error' : 'queued';
				tmpRuntimeBadges += `<span class="uv-fleet-tag" title="runtime: ${tmpR.RuntimeName} status: ${tmpR.Status}">${tmpR.RuntimeName}: ${tmpR.Status}</span>`;
			}
			tmpHtml += '<tr>';
			tmpHtml += `<th class="uv-fleet-beaconhead">
				<div><strong>${this._escape(tmpB.Name || tmpB.BeaconID)}</strong></div>
				<div style="font-size:0.75em;color:var(--uv-text-secondary);">${tmpStatus} \u00b7 ${(tmpB.Capabilities || []).length} caps</div>
				<div>${tmpRuntimeBadges}</div>
			</th>`;
			for (let tmpM of tmpSortedModels)
			{
				let tmpKey = tmpB.BeaconID + '|' + tmpM.ModelKey;
				let tmpInstRow = tmpByCell[tmpKey];
				tmpHtml += this._renderCell(tmpB, tmpM, tmpInstRow);
			}
			tmpHtml += '</tr>';
		}
		tmpHtml += '</tbody></table></div>';

		// Registered runtime metadata footer
		if (tmpRegRuntimes.length > 0)
		{
			tmpHtml += '<div style="margin-top:1em;font-size:0.8em;color:var(--uv-text-secondary);">';
			tmpHtml += 'Registered runtimes: ';
			tmpHtml += tmpRegRuntimes.map(r => `<span class="uv-fleet-tag">${this._escape(r.Name)}</span>`).join('');
			tmpHtml += '</div>';
		}

		tmpEl.innerHTML = tmpHtml;
	}

	_renderCell(pBeacon, pModel, pInst)
	{
		// No installation row → uninstalled state with Install button.
		if (!pInst)
		{
			return `<td class="uv-fleet-cell">
				<button class="uv-fleet-cell-btn primary"
					onclick="{~P~}.views['Ultravisor-Fleet'].install('${pBeacon.BeaconID}', '${this._jsAttr(pModel.ModelKey)}')">Install</button>
			</td>`.replace('{~P~}', 'Pict');
		}
		let tmpClass = 'queued';
		let tmpStatusLabel = pInst.Status;
		if (pInst.Status === 'installed' && pInst.EnabledForDispatch) { tmpClass = 'installed-enabled'; tmpStatusLabel = 'enabled'; }
		else if (pInst.Status === 'installed') { tmpClass = 'installed-disabled'; tmpStatusLabel = 'disabled'; }
		else if (pInst.Status === 'installing' || pInst.Status === 'queued') { tmpClass = 'installing'; }
		else if (pInst.Status === 'error') { tmpClass = 'error'; }

		let tmpProgress = '';
		if (pInst.Status === 'installing' && pInst.PushTotalBytes > 0)
		{
			let tmpPct = Math.min(100, Math.round(100 * (pInst.PushProgressBytes || 0) / pInst.PushTotalBytes));
			tmpProgress = `<div class="uv-fleet-progress"><div class="uv-fleet-progress-fill" style="width:${tmpPct}%"></div></div>
				<div style="font-size:0.7em;color:var(--uv-text-secondary);">${tmpPct}%</div>`;
		}

		let tmpButtons = '';
		let tmpBcn = pBeacon.BeaconID;
		let tmpKey = this._jsAttr(pInst.ModelKey);
		if (pInst.Status === 'installed')
		{
			if (pInst.EnabledForDispatch)
			{
				tmpButtons += `<button class="uv-fleet-cell-btn" onclick="Pict.views['Ultravisor-Fleet'].disable('${tmpBcn}','${tmpKey}')">Disable</button>`;
			}
			else
			{
				tmpButtons += `<button class="uv-fleet-cell-btn primary" onclick="Pict.views['Ultravisor-Fleet'].enable('${tmpBcn}','${tmpKey}')">Enable</button>`;
			}
			tmpButtons += `<button class="uv-fleet-cell-btn" onclick="Pict.views['Ultravisor-Fleet'].uninstall('${tmpBcn}','${tmpKey}')">Uninstall</button>`;
		}
		else if (pInst.Status === 'error')
		{
			tmpButtons += `<button class="uv-fleet-cell-btn primary" onclick="Pict.views['Ultravisor-Fleet'].install('${tmpBcn}','${tmpKey}')">Retry</button>`;
		}

		let tmpSourceTag = (pInst.Source && pInst.Source !== 'operator')
			? `<span class="uv-fleet-tag" title="auto-discovered from worker inventory">${this._escape(pInst.Source)}</span>` : '';

		return `<td class="uv-fleet-cell ${tmpClass}" title="${this._escape(pInst.LastError || '')}">
			<span class="uv-fleet-cell-status">${this._escape(tmpStatusLabel)}</span> ${tmpSourceTag}
			${tmpProgress}
			<div class="uv-fleet-cell-actions">${tmpButtons}</div>
		</td>`;
	}

	// ── Operator actions ────────────────────────────────────────

	install(pBeaconID, pModelKey)
	{
		this.pict.PictApplication.apiCall('POST', '/Fleet/Install',
			{ BeaconID: pBeaconID, ModelKey: pModelKey, EnableAfterInstall: false },
			(pErr, pResp) =>
			{
				if (pErr) { window.alert('Install failed: ' + pErr.message); return; }
				this.refresh();
			});
	}

	uninstall(pBeaconID, pModelKey)
	{
		if (!window.confirm('Uninstall ' + pModelKey + ' from beacon? Files on the worker will be deleted.')) return;
		this.pict.PictApplication.apiCall('POST', '/Fleet/Uninstall',
			{ BeaconID: pBeaconID, ModelKey: pModelKey },
			(pErr, pResp) =>
			{
				if (pErr) { window.alert('Uninstall failed: ' + pErr.message); return; }
				this.refresh();
			});
	}

	enable(pBeaconID, pModelKey)
	{
		this.pict.PictApplication.apiCall('POST', '/Fleet/Enable',
			{ BeaconID: pBeaconID, ModelKey: pModelKey },
			(pErr, pResp) =>
			{
				if (pErr) { window.alert('Enable failed: ' + pErr.message); return; }
				this.refresh();
			});
	}

	disable(pBeaconID, pModelKey)
	{
		this.pict.PictApplication.apiCall('POST', '/Fleet/Disable',
			{ BeaconID: pBeaconID, ModelKey: pModelKey },
			(pErr, pResp) =>
			{
				if (pErr) { window.alert('Disable failed: ' + pErr.message); return; }
				this.refresh();
			});
	}

	// ── Helpers ──────────────────────────────────────────────────

	_escape(pStr)
	{
		if (pStr == null) return '';
		return String(pStr).replace(/[&<>"']/g, (c) => ({
			'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
		})[c]);
	}

	_jsAttr(pStr)
	{
		// Single-quote-safe + slash-escape so it survives interpolation
		// into an onclick="..." attribute.
		return String(pStr || '').replace(/['\\]/g, '\\$&');
	}
}

UltravisorFleetView.default_configuration = _ViewConfiguration;
module.exports = UltravisorFleetView;

},{"pict-view":239}],261:[function(require,module,exports){
const libPictView = require('pict-view');
const libPictSectionFlow = require('pict-section-flow');
const libPictFlowCard = require('pict-section-flow').PictFlowCard;

// Card config generator — converts task definitions into PictFlowCard configs
const libBuiltInCardConfigs = require('../cards/Ultravisor-BuiltIn-CardConfigs.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-FlowEditor",

	DefaultRenderable: "Ultravisor-FlowEditor-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-floweditor {
			padding: 0.75em;
			display: flex;
			flex-direction: column;
			flex: 1;
			height: calc(100vh - 56px - 39px - 0.75em);
			min-height: 400px;
			box-sizing: border-box;
		}
		.ultravisor-floweditor-header {
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 0.75em;
			padding-bottom: 0.75em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-floweditor-header h1 {
			margin: 0;
			font-size: 1.8em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.ultravisor-flow-actions {
			display: flex;
			gap: 0.5em;
			align-items: center;
			flex-wrap: wrap;
		}
		.ultravisor-flow-meta {
			flex-shrink: 0;
			display: flex;
			flex-wrap: wrap;
			gap: 0.5em 0.75em;
			align-items: center;
			padding-bottom: 0.5em;
			border-bottom: 2px solid var(--uv-border-subtle);
			margin-bottom: 0.5em;
		}
		.ultravisor-flow-meta-left {
			display: flex;
			align-items: center;
			gap: 0.5em;
			flex: 1;
			min-width: 200px;
		}
		.ultravisor-flow-meta label {
			font-size: 0.8em;
			font-weight: 600;
			color: var(--uv-text-secondary);
			text-transform: uppercase;
			white-space: nowrap;
		}
		.ultravisor-flow-meta input {
			flex: 1;
			min-width: 120px;
		}
		.ultravisor-flow-meta-hash {
			font-size: 0.8em;
			color: var(--uv-text-tertiary);
			font-family: monospace;
		}

		/* Flow / Information tab switcher — right-aligned in meta row */
		.ultravisor-floweditor-tabs {
			display: flex;
			gap: 0;
			margin-left: auto;
		}
		.ultravisor-floweditor-tab {
			padding: 0.4em 0.75em;
			cursor: pointer;
			font-size: 0.8em;
			font-weight: 600;
			color: var(--uv-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.05em;
			border-bottom: 2px solid transparent;
			margin-bottom: -2px;
			transition: color 0.15s, border-color 0.15s;
			user-select: none;
		}
		.ultravisor-floweditor-tab:hover {
			color: var(--uv-text);
		}
		.ultravisor-floweditor-tab.active {
			color: var(--uv-brand);
			border-bottom-color: var(--uv-brand);
		}
		@media (max-width: 600px) {
			.ultravisor-floweditor-tabs {
				margin-left: 0;
				justify-content: flex-end;
				width: 100%;
			}
		}

		/* Information tab content */
		.ultravisor-floweditor-info {
			flex: 1;
			min-height: 0;
			display: flex;
			flex-direction: column;
			overflow-y: auto;
			padding: 1em 0;
		}
		.ultravisor-floweditor-info-section {
			margin-bottom: 1.5em;
		}
		.ultravisor-floweditor-info-section h3 {
			font-size: 0.85em;
			font-weight: 600;
			color: var(--uv-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.05em;
			margin: 0 0 0.75em 0;
		}
		.ultravisor-floweditor-audit {
			display: grid;
			grid-template-columns: auto 1fr;
			gap: 0.35em 1em;
			font-size: 0.85em;
		}
		.ultravisor-floweditor-audit dt {
			color: var(--uv-text-secondary);
			font-weight: 600;
		}
		.ultravisor-floweditor-audit dd {
			margin: 0;
			color: var(--uv-text);
		}
		#Ultravisor-FlowEditor-DescriptionEditor {
			flex: 1;
			min-height: 300px;
		}
		#Ultravisor-FlowEditor-DescriptionEditor .cm-editor {
			height: 100%;
			min-height: 250px;
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
		}
		#Ultravisor-FlowEditor-DescriptionEditor .cm-scroller {
			overflow: auto;
		}
		.ultravisor-btn-execute {
			background-color: #1a3a2a;
			color: #5ab88a;
			border: 1px solid #2a5040;
		}
		.ultravisor-btn-execute:hover {
			background-color: #204530;
			border-color: #3a6050;
		}
		.ultravisor-btn-sm.ultravisor-btn-execute {
			background-color: #1a3a2a;
			color: #5ab88a;
			border: 1px solid #2a5040;
		}
		.ultravisor-btn-sm.ultravisor-btn-execute:hover {
			background-color: #204530;
		}
		#Ultravisor-FlowEditor-Container {
			flex: 1;
			min-height: 0;
		}

		/* Visual Execution Mode — Node States */
		.uv-exec-idle .pict-flow-node-body {
			opacity: 0.5;
		}
		.uv-exec-executing .pict-flow-node-body {
			stroke: #5a9ecb !important;
			stroke-width: 2.5 !important;
		}
		.uv-exec-executing {
			animation: uv-exec-pulse 1.2s ease-in-out infinite;
		}
		@keyframes uv-exec-pulse {
			0%, 100% { filter: drop-shadow(0 0 3px rgba(90, 158, 203, 0.6)); }
			50% { filter: drop-shadow(0 0 12px rgba(90, 158, 203, 0.9)); }
		}
		.uv-exec-complete .pict-flow-node-body {
			stroke: #5ab88a !important;
			stroke-width: 2 !important;
		}
		.uv-exec-complete .pict-flow-node-title-bar,
		.uv-exec-complete .pict-flow-node-title-bar-bottom {
			fill: #2a5040 !important;
		}
		.uv-exec-error .pict-flow-node-body {
			stroke: #c44e4e !important;
			stroke-width: 2.5 !important;
		}
		.uv-exec-error .pict-flow-node-title-bar,
		.uv-exec-error .pict-flow-node-title-bar-bottom {
			fill: #4a2020 !important;
		}
		.uv-exec-waiting .pict-flow-node-body {
			stroke: #d4884a !important;
			stroke-width: 2 !important;
			stroke-dasharray: 4 2;
		}
		/* Stalled: amber pulse to distinguish "stuck" from running's
		 * blue pulse.  Only fires when the scheduler's stall detection
		 * has flipped the node's beacon work item to Stalled. */
		.uv-exec-stalled .pict-flow-node-body {
			stroke: var(--theme-color-status-warning, #b45309) !important;
			stroke-width: 2.5 !important;
		}
		.uv-exec-stalled {
			animation: uv-exec-stalled-pulse 1.6s ease-in-out infinite;
		}
		@keyframes uv-exec-stalled-pulse {
			0%, 100% { filter: drop-shadow(0 0 3px rgba(180, 83, 9, 0.5)); }
			50% { filter: drop-shadow(0 0 12px rgba(180, 83, 9, 0.85)); }
		}

		/* Execution status bar */
		.ultravisor-floweditor-execution-status {
			flex-shrink: 0;
			display: flex;
			align-items: center;
			gap: 1em;
			padding: 0.5em 0.75em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			margin-bottom: 0.5em;
			font-size: 0.85em;
			color: var(--uv-text-secondary);
		}
		.uv-exec-status-badge {
			display: inline-block;
			padding: 0.15em 0.5em;
			border-radius: 3px;
			font-size: 0.85em;
			font-weight: 600;
		}
		.uv-exec-status-badge.running,
		.uv-exec-status-badge.inprogress {
			background-color: #1a3a5a;
			color: #5a9ecb;
		}
		.uv-exec-status-badge.complete {
			background-color: #1a3a2a;
			color: #5ab88a;
		}
		.uv-exec-status-badge.error,
		.uv-exec-status-badge.failed {
			background-color: #3a1a1a;
			color: #c44e4e;
		}
		.uv-exec-status-badge.waiting,
		.uv-exec-status-badge.waitingforinput {
			background-color: #3a2a1a;
			color: #d4884a;
		}
		.uv-exec-status-badge.stalled {
			background-color: #3a2a10;
			color: #d18a3a;
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-FlowEditor-Template",
			Template: /*html*/`
<div class="ultravisor-floweditor">
	<div class="ultravisor-floweditor-header">
		<h1 id="Ultravisor-FlowEditor-Title">Flow Editor</h1>
		<div class="ultravisor-flow-actions">
			<button class="ultravisor-btn ultravisor-btn-primary" onclick="{~P~}.views['Ultravisor-FlowEditor'].saveOperation()">Save Operation</button>
			<button class="ultravisor-btn ultravisor-btn-execute" id="Ultravisor-FlowEditor-ExecuteBtn" onclick="{~P~}.views['Ultravisor-FlowEditor'].startVisualExecution()">Execute</button>
			<button class="ultravisor-btn ultravisor-btn-delete" id="Ultravisor-FlowEditor-StopBtn" onclick="{~P~}.views['Ultravisor-FlowEditor'].stopVisualExecution()" style="display:none">Stop</button>
		</div>
	</div>
	<div id="Ultravisor-FlowEditor-ExecStatus" class="ultravisor-floweditor-execution-status" style="display:none"></div>
	<div class="ultravisor-flow-meta">
		<div class="ultravisor-flow-meta-left">
			<span id="Ultravisor-FlowEditor-HashDisplay" class="ultravisor-flow-meta-hash"></span>
			<label>Name</label>
			<input type="text" id="Ultravisor-FlowEditor-Name" placeholder="Operation name...">
		</div>
		<div class="ultravisor-floweditor-tabs">
			<div class="ultravisor-floweditor-tab active" id="Ultravisor-FlowEditor-TabFlow" onclick="{~P~}.views['Ultravisor-FlowEditor'].switchTab('flow')">Flow</div>
			<div class="ultravisor-floweditor-tab" id="Ultravisor-FlowEditor-TabInfo" onclick="{~P~}.views['Ultravisor-FlowEditor'].switchTab('info')">Information</div>
		</div>
	</div>
	<div id="Ultravisor-FlowEditor-Container"></div>
	<div id="Ultravisor-FlowEditor-InfoPanel" class="ultravisor-floweditor-info" style="display:none">
		<div class="ultravisor-floweditor-info-section">
			<h3>Description</h3>
			<div id="Ultravisor-FlowEditor-DescriptionEditor"></div>
		</div>
		<div class="ultravisor-floweditor-info-section">
			<h3>Operation Details</h3>
			<dl id="Ultravisor-FlowEditor-AuditInfo" class="ultravisor-floweditor-audit"></dl>
		</div>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-FlowEditor-Content",
			TemplateHash: "Ultravisor-FlowEditor-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorFlowEditorView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._FlowView = null;

		// Visual execution mode state
		this._ExecutionRunHash = null;
		this._ExecutionWebSocket = null;
		this._ExecutionPollingTimer = null;
		this._ExecutionNodeStates = {};
		this._ExecutionCompletedCount = 0;
		this._ExecutionErrorCount = 0;
		this._IsExecuting = false;
	}

	/**
	 * Build a map of FlowCard node type configurations keyed by hash.
	 * These are passed as NodeTypes in the FlowView options so they
	 * are available from the moment the NodeTypeProvider is created,
	 * before the toolbar renders.
	 *
	 * @param {Array} [pAdditionalCardConfigs] - Optional extra card configs to register.
	 */
	_buildFlowCardNodeTypes(pAdditionalCardConfigs)
	{
		let tmpNodeTypes = {};

		// Generate card configs from API-fetched task type definitions
		let tmpDefinitions = this.pict.AppData.Ultravisor.TaskTypes || [];
		let tmpCardConfigs = libBuiltInCardConfigs.generateCardConfigs(tmpDefinitions);

		for (let i = 0; i < tmpCardConfigs.length; i++)
		{
			let tmpCard = new libPictFlowCard(this.fable, tmpCardConfigs[i], `FlowCard-${i}`);
			let tmpConfig = tmpCard.getNodeTypeConfiguration();
			// Ultravisor flow cards render port labels outside the node
			// boundary to avoid overlapping body content
			tmpConfig.PortLabelsOutside = true;
			tmpNodeTypes[tmpConfig.Hash] = tmpConfig;
		}

		// Register any additional cards (e.g. user-defined or plugin cards)
		if (Array.isArray(pAdditionalCardConfigs))
		{
			for (let i = 0; i < pAdditionalCardConfigs.length; i++)
			{
				let tmpCard = new libPictFlowCard(this.fable, pAdditionalCardConfigs[i], `FlowCard-Extra-${i}`);
				let tmpConfig = tmpCard.getNodeTypeConfiguration();
				tmpConfig.PortLabelsOutside = true;
				tmpNodeTypes[tmpConfig.Hash] = tmpConfig;
			}
		}

		return tmpNodeTypes;
	}

	/**
	 * Reconcile node ports with current node type definitions.
	 *
	 * Saved operations store each node's Ports array at save time.  When a
	 * task definition gains new ports (e.g. setting ports added after the
	 * definitions moved to JSON), existing saved nodes lack those ports.
	 *
	 * This method compares each node's Ports to its node type's DefaultPorts
	 * and appends any missing ports so they appear in the editor.
	 *
	 * @param {Array} pNodes - The Nodes array from the flow data.
	 */
	_reconcileNodePorts(pNodes)
	{
		if (!Array.isArray(pNodes) || !this._FlowView)
		{
			return;
		}

		let tmpNodeTypes = this._FlowView.options.NodeTypes;

		for (let i = 0; i < pNodes.length; i++)
		{
			let tmpNode = pNodes[i];
			let tmpNodeType = tmpNodeTypes[tmpNode.Type];

			if (!tmpNodeType || !Array.isArray(tmpNodeType.DefaultPorts) || !Array.isArray(tmpNode.Ports))
			{
				continue;
			}

			for (let j = 0; j < tmpNodeType.DefaultPorts.length; j++)
			{
				let tmpDefaultPort = tmpNodeType.DefaultPorts[j];

				// Check if the node already has a port with the same label and direction
				let tmpExists = false;
				for (let k = 0; k < tmpNode.Ports.length; k++)
				{
					if (tmpNode.Ports[k].Label === tmpDefaultPort.Label && tmpNode.Ports[k].Direction === tmpDefaultPort.Direction)
					{
						tmpExists = true;
						break;
					}
				}

				if (!tmpExists)
				{
					// Generate a hash for the new port: {nodeHash}-{portLabel}
					let tmpPortHash = `${tmpNode.Hash}-${tmpDefaultPort.Label}`;
					tmpNode.Ports.push(
					{
						Hash: tmpPortHash,
						Direction: tmpDefaultPort.Direction,
						Side: tmpDefaultPort.Side,
						Label: tmpDefaultPort.Label,
						PortType: tmpDefaultPort.PortType,
						MinimumInputCount: tmpDefaultPort.MinimumInputCount || 0,
						MaximumInputCount: tmpDefaultPort.MaximumInputCount || 1
					});
				}
			}

			// Flag orphaned ports — saved ports whose Label+Direction
			// no longer match any DefaultPort in the current server definition.
			for (let k = 0; k < tmpNode.Ports.length; k++)
			{
				let tmpPort = tmpNode.Ports[k];
				let tmpMatchFound = false;
				for (let j = 0; j < tmpNodeType.DefaultPorts.length; j++)
				{
					if (tmpNodeType.DefaultPorts[j].Label === tmpPort.Label && tmpNodeType.DefaultPorts[j].Direction === tmpPort.Direction)
					{
						tmpMatchFound = true;
						break;
					}
				}
				if (!tmpMatchFound)
				{
					tmpPort.Orphaned = true;
				}
			}
		}
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		// Populate the metadata fields from CurrentEditOperation
		let tmpOp = this.pict.AppData.Ultravisor.CurrentEditOperation;
		if (tmpOp)
		{
			let tmpTitleEl = document.getElementById('Ultravisor-FlowEditor-Title');
			if (tmpTitleEl)
			{
				tmpTitleEl.textContent = tmpOp.Hash ? ('Flow Editor: ' + (tmpOp.Name || tmpOp.Hash)) : 'Flow Editor: New Operation';
			}

			let tmpHashEl = document.getElementById('Ultravisor-FlowEditor-HashDisplay');
			if (tmpHashEl && tmpOp.Hash)
			{
				tmpHashEl.textContent = tmpOp.Hash;
			}

			let tmpNameEl = document.getElementById('Ultravisor-FlowEditor-Name');
			if (tmpNameEl)
			{
				tmpNameEl.value = tmpOp.Name || '';
			}

			// Load description into the markdown editor's data address
			this.pict.AppData.Ultravisor.OperationDescriptionSegments = [
				{ Content: tmpOp.Description || '' }
			];
		}

		// Create and render the flow section view into its container
		if (!this._FlowView)
		{
			this._FlowView = this.pict.addView('Ultravisor-FlowDiagram',
				{
					ViewIdentifier: 'Ultravisor-FlowDiagram',

					DefaultRenderable: 'Flow-Container',
					DefaultDestinationAddress: '#Ultravisor-FlowEditor-Container',

					AutoRender: false,

					FlowDataAddress: 'AppData.Ultravisor.Flows.Current',

					TargetElementAddress: '#Flow-SVG-Container',

					EnableToolbar: true,
					EnableAddNode: false,
					IncludeDefaultNodeTypes: false,
					EnablePanning: true,
					EnableZooming: true,
					EnableNodeDragging: true,
					EnableConnectionCreation: true,
					EnableGridSnap: false,
					GridSnapSize: 20,

					MinZoom: 0.1,
					MaxZoom: 5.0,
					ZoomStep: 0.1,

					DefaultNodeType: 'default',
					DefaultNodeWidth: 180,
					DefaultNodeHeight: 80,

					// Pre-register FlowCard node types so they are available
					// when the NodeTypeProvider is created, before toolbar renders
					NodeTypes: this._buildFlowCardNodeTypes(),

					Renderables:
					[
						{
							RenderableHash: 'Flow-Container',
							TemplateHash: 'Flow-Container-Template',
							DestinationAddress: '#Ultravisor-FlowEditor-Container',
							RenderMethod: 'replace'
						}
					]
				},
				libPictSectionFlow
			);
		}

		// Initialize default empty flow if none exists
		if (!this.pict.AppData.Ultravisor.Flows.Current)
		{
			this.pict.AppData.Ultravisor.Flows.Current =
			{
				Nodes: [],
				Connections: [],
				ViewState: { PanX: 0, PanY: 0, Zoom: 1, SelectedNodeHash: null, SelectedConnectionHash: null }
			};
		}

		// Reconcile node ports with current node type definitions.
		// Saved operations may lack ports that were added after the operation
		// was created (e.g. setting ports added when definitions moved to JSON).
		this._reconcileNodePorts(this.pict.AppData.Ultravisor.Flows.Current.Nodes);

		// Reset the flow view's render state so it re-initializes SVG elements
		// when re-rendered (e.g. after navigating away and back)
		this._FlowView.initialRenderComplete = false;
		this._FlowView.render();

		// Register and apply the desert theme to match Ultravisor's UI.
		// Must happen after render() since the ThemeProvider is created during init.
		this._registerDesertTheme();

		// Re-inject CSS after the flow view creates its dynamic styles
		this.pict.CSSMap.injectCSS();

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Register a custom "desert" flow theme that harmonizes with
	 * Ultravisor's Desert Dusk color scheme.
	 */
	_registerDesertTheme()
	{
		if (!this._FlowView || !this._FlowView._ThemeProvider)
		{
			return;
		}

		this._FlowView._ThemeProvider.registerTheme('desert',
		{
			Key: 'desert',
			Label: 'Desert Dusk',
			CSSVariables:
			{
				// Canvas — muted turquoise tint, lighter than cards so they stand out
				'--pf-canvas-bg': '#304040',
				'--pf-grid-stroke': '#384848',

				// Nodes
				'--pf-node-body-fill': '#1e1a16',
				'--pf-node-body-stroke': '#3a3028',
				'--pf-node-body-stroke-width': '1',
				'--pf-node-body-radius': '3px',
				'--pf-node-shadow': 'drop-shadow(0 1px 3px rgba(0, 0, 0, 0.30))',
				'--pf-node-shadow-hover': 'drop-shadow(0 2px 6px rgba(0, 0, 0, 0.40))',
				'--pf-node-shadow-selected': 'drop-shadow(0 2px 8px rgba(196, 149, 106, 0.30))',
				'--pf-node-shadow-dragging': 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.50))',
				'--pf-node-title-fill': '#d8c8a8',
				'--pf-node-title-size': '11.5px',
				'--pf-node-title-weight': '600',
				'--pf-node-type-label-fill': '#706050',
				'--pf-node-selected-stroke': '#c4956a',

				// Ports — keep the 5-type semantic colors, adjusted for dark bg
				'--pf-port-input-fill': '#5a9ecb',
				'--pf-port-output-fill': '#5ab88a',
				'--pf-port-stroke': '#252018',
				'--pf-port-event-in-fill': '#5a9ecb',
				'--pf-port-event-out-fill': '#5ab88a',
				'--pf-port-setting-fill': '#d4884a',
				'--pf-port-value-fill': '#d4b040',
				'--pf-port-error-fill': '#c44e4e',

				// Port labels
				'--pf-port-label-bg': 'rgba(30, 26, 22, 0.85)',
				'--pf-port-label-text': '#c8b8a0',

				// Connections
				'--pf-connection-stroke': '#706050',
				'--pf-connection-selected-stroke': '#c4956a',
				'--pf-connection-event-in-stroke': '#5a9ecb',
				'--pf-connection-event-out-stroke': '#5ab88a',
				'--pf-connection-setting-stroke': '#d4884a',
				'--pf-connection-value-stroke': '#d4b040',
				'--pf-connection-error-stroke': '#c44e4e',

				// Panels — cooler tone to contrast with warm node bodies
				'--pf-panel-bg': '#1e2228',
				'--pf-panel-border': '#343c44',
				'--pf-panel-radius': '6px',
				'--pf-panel-shadow': '0 4px 12px rgba(0,0,0,0.35), 0 1px 3px rgba(0,0,0,0.25)',
				'--pf-panel-titlebar-bg': '#262e36',
				'--pf-panel-titlebar-border': '#343c44',
				'--pf-panel-title-color': '#c8d0d8'
			},
			AdditionalCSS: `
				.pict-flow-container {
					border: 1px solid #3a3028;
					border-radius: 6px;
				}
				.pict-flow-toolbar {
					background-color: #252018;
					border-bottom-color: #3a3028;
				}
				.pict-flow-toolbar-btn {
					background-color: #302818;
					border-color: #3a3028;
					color: #c8b8a0;
				}
				.pict-flow-toolbar-btn:hover {
					background-color: #3a3028;
					color: #d8c8a8;
				}
				.pict-flow-toolbar-btn.active {
					background-color: #4a3828;
					border-color: #c4956a;
					color: #d8c8a8;
				}
				.pict-flow-toolbar-dropdown {
					background-color: #252018;
					border-color: #3a3028;
					color: #c8b8a0;
				}
				.pict-flow-toolbar-dropdown-menu {
					background-color: #252018;
					border-color: #3a3028;
				}
				.pict-flow-toolbar-dropdown-item {
					color: #c8b8a0;
				}
				.pict-flow-toolbar-dropdown-item:hover {
					background-color: #3a3028;
					color: #d8c8a8;
				}
				.pict-flow-node-title-icon {
					filter: brightness(0.8) sepia(0.3) !important;
				}
				/* Info panel styles — cooler blue-gray tone */
				.pict-flow-info-panel {
					color: #b8c4cc;
				}
				.pict-flow-info-panel-header {
					color: #c8d0d8;
				}
				.pict-flow-info-panel-description {
					color: #808c94;
				}
				.pict-flow-info-panel-section-title {
					color: #7088a0;
					border-bottom-color: #343c44;
				}
				.pict-flow-info-panel-badge.category {
					background: #2a3038;
					color: #8090a0;
				}
				.pict-flow-info-panel-badge.code {
					background: #1e2830;
					color: #5a9ecb;
				}
				.pict-flow-info-panel-port {
					color: #b8c4cc;
					background-color: #242c34;
					border-color: #343c44;
				}
				.pict-flow-info-panel-port-constraint {
					color: #708090;
				}
				/* Node properties editor in panels */
				.pict-flow-panel-node-props {
					border-top-color: #343c44;
				}
				.pict-flow-panel-node-props-header {
					background: #262e36;
				}
				.pict-flow-panel-node-props-header:hover {
					background: #2e3640;
				}
				.pict-flow-panel-node-props-title {
					color: #7088a0;
				}
				.pict-flow-panel-node-props-chevron {
					color: #607080;
				}
				.pict-flow-panel-close-btn {
					color: #708090;
				}
				.pict-flow-panel-close-btn:hover {
					color: #c44e4e;
					background-color: rgba(196, 78, 78, 0.12);
				}
				/* Form panel styles — force all text in panels to be readable */
				.pict-flow-panel-body,
				.pict-flow-panel-body * {
					color: #b8c4cc;
				}
				.pict-flow-panel-body h2,
				.pict-flow-panel-body h3 {
					color: #c8d0d8;
				}
				.pict-flow-panel-body label,
				.pict-flow-panel-body .pict-form label {
					color: #90a0b0 !important;
				}
				.pict-flow-panel-body span,
				.pict-flow-panel-body .pict-form span {
					color: #90a0b0;
				}
				.pict-flow-panel-body input,
				.pict-flow-panel-body textarea,
				.pict-flow-panel-body select,
				.pict-flow-panel-body .pict-form input,
				.pict-flow-panel-body .pict-form textarea,
				.pict-flow-panel-body .pict-form select {
					background-color: #181c22 !important;
					border-color: #343c44 !important;
					color: #b8c4cc !important;
				}
				.pict-flow-panel-body input:focus,
				.pict-flow-panel-body textarea:focus,
				.pict-flow-panel-body select:focus,
				.pict-flow-panel-body .pict-form input:focus,
				.pict-flow-panel-body .pict-form textarea:focus,
				.pict-flow-panel-body .pict-form select:focus {
					border-color: #5a9ecb !important;
				}
				/* Port summary in panels */
				.pict-flow-port-summary {
					border-top-color: #343c44;
				}
				/* Override per-card light-mode body fills with dark theme fill.
				   SVG fill="" is a presentation attribute; CSS overrides it. */
				.pict-flow-node-body {
					fill: #1e1a16;
					stroke: #3a3028;
				}
				/* Override built-in start/end/halt/decision body colors (specificity 0,2,0
				   matches the base CSS rules so this later stylesheet wins). */
				.pict-flow-node-start .pict-flow-node-body {
					fill: #182018;
					stroke: #2a4030;
					stroke-width: 1.5;
				}
				.pict-flow-node-end .pict-flow-node-body {
					fill: #161e20;
					stroke: #2a3840;
					stroke-width: 1.5;
				}
				.pict-flow-node-halt .pict-flow-node-body {
					fill: #201414;
					stroke: #4a2020;
					stroke-width: 1.5;
				}
				.pict-flow-node-decision .pict-flow-node-body {
					fill: #1e1a12;
					stroke: #4a3820;
					stroke-width: 1.5;
				}
				/* Desert title bar: warm muted base for all nodes.
				   CSS overrides the SVG fill="" presentation attribute. */
				.pict-flow-node-title-bar,
				.pict-flow-node-title-bar-bottom {
					fill: #3a3028;
				}
				/* Distinct title bars for special node types */
				.pict-flow-node-start .pict-flow-node-title-bar,
				.pict-flow-node-start .pict-flow-node-title-bar-bottom {
					fill: #2a4030;
				}
				.pict-flow-node-end .pict-flow-node-title-bar,
				.pict-flow-node-end .pict-flow-node-title-bar-bottom {
					fill: #2a3840;
				}
				.pict-flow-node-halt .pict-flow-node-title-bar,
				.pict-flow-node-halt .pict-flow-node-title-bar-bottom {
					fill: #4a2020;
				}
				.pict-flow-node-decision .pict-flow-node-title-bar,
				.pict-flow-node-decision .pict-flow-node-title-bar-bottom {
					fill: #4a3820;
				}
			`,
			NodeBodyMode: 'rect',
			BracketConfig: null,
			ConnectionConfig:
			{
				StrokeDashArray: null,
				StrokeWidth: 2,
				ArrowheadStyle: 'triangle'
			},
			NoiseConfig:
			{
				Enabled: false,
				DefaultLevel: 0,
				MaxJitterPx: 0,
				AffectsNodes: false,
				AffectsConnections: false
			},
			ShapeOverrides:
			{
				'arrowhead-connection': { Fill: '#706050' },
				'arrowhead-connection-selected': { Fill: '#c4956a' }
			}
		});

		this._FlowView.setTheme('desert');
	}

	loadExample(pExampleName)
	{
		let tmpFlowData = null;

		if (pExampleName === 'CSVPipeline')
		{
			tmpFlowData = require('../data/ExampleFlow-CSVPipeline.js');
		}
		else if (pExampleName === 'MeadowPipeline')
		{
			tmpFlowData = require('../data/ExampleFlow-MeadowPipeline.js');
		}
		else if (pExampleName === 'FileProcessor')
		{
			tmpFlowData = require('../data/ExampleFlow-FileProcessor.js');
		}

		if (tmpFlowData)
		{
			this.pict.AppData.Ultravisor.Flows.Current = JSON.parse(JSON.stringify(tmpFlowData));
			if (this._FlowView)
			{
				this._FlowView.setFlowData(this.pict.AppData.Ultravisor.Flows.Current);
				// Zoom to fit after a brief delay to allow the DOM to update
				let tmpFlowView = this._FlowView;
				setTimeout(function()
				{
					if (tmpFlowView._ViewportManager)
					{
						tmpFlowView._ViewportManager.zoomToFit();
					}
				}, 100);
			}
		}
	}

	saveOperation()
	{
		if (!this._FlowView)
		{
			return;
		}

		let tmpFlowData = this._FlowView.getFlowData();
		if (!tmpFlowData || !tmpFlowData.Nodes || tmpFlowData.Nodes.length === 0)
		{
			this.pict.views.Modal.toast('No flow data to save. Add some nodes first.', { type: 'warning' });
			return;
		}

		// Read the metadata from the form fields
		let tmpName = document.getElementById('Ultravisor-FlowEditor-Name').value.trim();

		// Get description from the markdown editor
		let tmpDescEditor = this.pict.views['Ultravisor-OperationDescriptionEditor'];
		let tmpDescription = '';
		if (tmpDescEditor && typeof tmpDescEditor.getAllContent === 'function')
		{
			tmpDescription = tmpDescEditor.getAllContent('');
		}
		else
		{
			// Fallback: read from the data address
			let tmpSegments = this.pict.AppData.Ultravisor.OperationDescriptionSegments;
			if (Array.isArray(tmpSegments) && tmpSegments.length > 0)
			{
				tmpDescription = tmpSegments[0].Content || '';
			}
		}

		if (!tmpName)
		{
			this.pict.views.Modal.toast('Please enter an operation name.', { type: 'warning' });
			return;
		}

		// Build the operation data with the graph
		let tmpOpData =
		{
			Name: tmpName,
			Description: tmpDescription,
			Graph:
			{
				Nodes: tmpFlowData.Nodes,
				Connections: tmpFlowData.Connections,
				ViewState: tmpFlowData.ViewState || {}
			}
		};

		// Include Hash if editing an existing operation
		let tmpOp = this.pict.AppData.Ultravisor.CurrentEditOperation;
		if (tmpOp && tmpOp.Hash)
		{
			tmpOpData.Hash = tmpOp.Hash;
		}

		this.pict.PictApplication.saveOperation(tmpOpData,
			function (pError, pData)
			{
				if (pError)
				{
					this.pict.views.Modal.toast('Error saving operation: ' + pError.message, { type: 'error' });
					return;
				}

				// Update the current edit operation with the saved data
				if (pData && pData.Hash)
				{
					if (!this.pict.AppData.Ultravisor.CurrentEditOperation)
					{
						this.pict.AppData.Ultravisor.CurrentEditOperation = {};
					}
					this.pict.AppData.Ultravisor.CurrentEditOperation.Hash = pData.Hash;
					this.pict.AppData.Ultravisor.CurrentEditOperation.Name = tmpName;
					this.pict.AppData.Ultravisor.CurrentEditOperation.Description = tmpDescription;

					let tmpHashEl = document.getElementById('Ultravisor-FlowEditor-HashDisplay');
					if (tmpHashEl)
					{
						tmpHashEl.textContent = pData.Hash;
					}
				}

				this.pict.views.Modal.toast('Operation saved.', { type: 'success' });
			}.bind(this));
	}

	// ====================================================================
	// ── Tab Switching ──

	switchTab(pTab)
	{
		let tmpFlowContainer = document.getElementById('Ultravisor-FlowEditor-Container');
		let tmpInfoPanel = document.getElementById('Ultravisor-FlowEditor-InfoPanel');
		let tmpFlowTab = document.getElementById('Ultravisor-FlowEditor-TabFlow');
		let tmpInfoTab = document.getElementById('Ultravisor-FlowEditor-TabInfo');

		if (pTab === 'info')
		{
			if (tmpFlowContainer) { tmpFlowContainer.style.display = 'none'; }
			if (tmpInfoPanel) { tmpInfoPanel.style.display = 'flex'; }
			if (tmpFlowTab) { tmpFlowTab.classList.remove('active'); }
			if (tmpInfoTab) { tmpInfoTab.classList.add('active'); }

			// Render the markdown editor into the info panel
			let tmpDescEditor = this.pict.views['Ultravisor-OperationDescriptionEditor'];
			if (tmpDescEditor)
			{
				tmpDescEditor.render();
			}

			// Render audit info
			this._renderAuditInfo();
		}
		else
		{
			if (tmpFlowContainer) { tmpFlowContainer.style.display = ''; }
			if (tmpInfoPanel) { tmpInfoPanel.style.display = 'none'; }
			if (tmpFlowTab) { tmpFlowTab.classList.add('active'); }
			if (tmpInfoTab) { tmpInfoTab.classList.remove('active'); }
		}
	}

	_renderAuditInfo()
	{
		let tmpAuditEl = document.getElementById('Ultravisor-FlowEditor-AuditInfo');
		if (!tmpAuditEl) return;

		let tmpOp = this.pict.AppData.Ultravisor.CurrentEditOperation;
		if (!tmpOp)
		{
			tmpAuditEl.innerHTML = '<dt>Status</dt><dd>No operation loaded</dd>';
			return;
		}

		let tmpHTML = '';

		tmpHTML += '<dt>Operation Hash</dt>';
		tmpHTML += '<dd><code>' + (tmpOp.Hash || 'Unsaved') + '</code></dd>';

		if (tmpOp.CreatedAt)
		{
			tmpHTML += '<dt>Created</dt>';
			tmpHTML += '<dd>' + this.fable.Dates.dayJS(tmpOp.CreatedAt).format('YYYY-MM-DD HH:mm:ss') + '</dd>';
		}

		if (tmpOp.UpdatedAt)
		{
			tmpHTML += '<dt>Last Modified</dt>';
			tmpHTML += '<dd>' + this.fable.Dates.dayJS(tmpOp.UpdatedAt).format('YYYY-MM-DD HH:mm:ss') + '</dd>';
		}

		let tmpNodeCount = (tmpOp.Graph && tmpOp.Graph.Nodes) ? tmpOp.Graph.Nodes.length : 0;
		let tmpConnectionCount = (tmpOp.Graph && tmpOp.Graph.Connections) ? tmpOp.Graph.Connections.length : 0;
		tmpHTML += '<dt>Nodes</dt><dd>' + tmpNodeCount + '</dd>';
		tmpHTML += '<dt>Connections</dt><dd>' + tmpConnectionCount + '</dd>';

		tmpAuditEl.innerHTML = tmpHTML;
	}

	// Visual Execution Mode
	// ====================================================================

	/**
	 * Start visual execution of the current operation.
	 * Triggers async execution on the server and opens a WebSocket
	 * connection to receive real-time execution events.
	 */
	startVisualExecution()
	{
		let tmpOp = this.pict.AppData.Ultravisor.CurrentEditOperation;

		if (!tmpOp || !tmpOp.Hash)
		{
			this.pict.views.Modal.toast('Please save the operation before executing.', { type: 'warning' });
			return;
		}

		if (this._IsExecuting)
		{
			return;
		}

		this._IsExecuting = true;
		this._ExecutionNodeStates = {};
		this._ExecutionStartTime = Date.now();
		this._ExecutionCompletedCount = 0;
		this._ExecutionErrorCount = 0;

		// Update button visibility
		let tmpExecBtn = document.getElementById('Ultravisor-FlowEditor-ExecuteBtn');
		let tmpStopBtn = document.getElementById('Ultravisor-FlowEditor-StopBtn');
		if (tmpExecBtn) { tmpExecBtn.style.display = 'none'; }
		if (tmpStopBtn) { tmpStopBtn.style.display = 'inline-block'; }

		// Initialize all nodes to idle visual state
		if (this._FlowView && this._FlowView._NodesLayer)
		{
			let tmpNodes = this.pict.AppData.Ultravisor.Flows.Current.Nodes || [];
			for (let i = 0; i < tmpNodes.length; i++)
			{
				this._applyNodeVisualState(tmpNodes[i].Hash, 'idle');
			}
		}

		// Show execution status bar
		this._updateExecutionStatusBar('Running', 0, 0, 0);

		// Start async execution
		let tmpRunMode = this.pict.AppData.Ultravisor.DebugMode ? 'debug' : 'standard';
		this.pict.PictApplication.executeOperationAsync(tmpOp.Hash, tmpRunMode,
			function (pError, pData)
			{
				if (pError)
				{
					this._finishExecution('Error', 'Failed to start execution: ' + pError.message);
					return;
				}

				this._ExecutionRunHash = pData.RunHash;

				// Connect WebSocket for real-time events
				this._connectExecutionWebSocket(pData.RunHash);
			}.bind(this));
	}

	/**
	 * Watch an already-running execution in the flow editor.
	 * Attaches to an existing run without starting a new one.
	 *
	 * @param {string} pRunHash - The execution run hash to watch.
	 */
	watchExecution(pRunHash)
	{
		if (this._IsExecuting)
		{
			return;
		}

		if (!pRunHash)
		{
			return;
		}

		this._IsExecuting = true;
		this._ExecutionRunHash = pRunHash;
		this._ExecutionNodeStates = {};
		this._ExecutionStartTime = Date.now();
		this._ExecutionCompletedCount = 0;
		this._ExecutionErrorCount = 0;

		// Update button visibility
		let tmpExecBtn = document.getElementById('Ultravisor-FlowEditor-ExecuteBtn');
		let tmpStopBtn = document.getElementById('Ultravisor-FlowEditor-StopBtn');
		if (tmpExecBtn) { tmpExecBtn.style.display = 'none'; }
		if (tmpStopBtn) { tmpStopBtn.style.display = 'inline-block'; }

		// Initialize all nodes to idle visual state
		if (this._FlowView && this._FlowView._NodesLayer)
		{
			let tmpNodes = this.pict.AppData.Ultravisor.Flows.Current.Nodes || [];
			for (let i = 0; i < tmpNodes.length; i++)
			{
				this._applyNodeVisualState(tmpNodes[i].Hash, 'idle');
			}
		}

		// Show execution status bar
		this._updateExecutionStatusBar('Watching', 0, 0, 0);

		// Connect WebSocket for real-time events (same as startVisualExecution
		// but we skip the executeOperationAsync call — the run is already going)
		this._connectExecutionWebSocket(pRunHash);
	}

	/**
	 * Open a WebSocket connection and subscribe to execution events
	 * for the given RunHash.
	 *
	 * @param {string} pRunHash - The execution run hash to subscribe to.
	 */
	_connectExecutionWebSocket(pRunHash)
	{
		// Build WebSocket URL from the current page location
		let tmpProtocol = (window.location.protocol === 'https:') ? 'wss:' : 'ws:';
		let tmpHost = window.location.host;
		let tmpBaseURL = this.pict.AppData.Ultravisor.APIBaseURL;

		// If APIBaseURL is set (e.g. "http://localhost:54321"), extract host from it
		if (tmpBaseURL)
		{
			try
			{
				let tmpURL = new URL(tmpBaseURL);
				tmpHost = tmpURL.host;
				tmpProtocol = (tmpURL.protocol === 'https:') ? 'wss:' : 'ws:';
			}
			catch (pError)
			{
				// Fall back to page location
			}
		}

		let tmpWSURL = tmpProtocol + '//' + tmpHost;

		try
		{
			this._ExecutionWebSocket = new WebSocket(tmpWSURL);
		}
		catch (pError)
		{
			this.pict.log.warn('FlowEditor: WebSocket connection failed, falling back to polling.');
			this._fallbackToPolling();
			return;
		}

		this._ExecutionWebSocket.onopen = function ()
		{
			// Subscribe to execution events for this run
			this._ExecutionWebSocket.send(JSON.stringify({
				Action: 'Subscribe',
				RunHash: pRunHash
			}));
		}.bind(this);

		this._ExecutionWebSocket.onmessage = function (pEvent)
		{
			this._handleExecutionEvent(pEvent.data);
		}.bind(this);

		this._ExecutionWebSocket.onerror = function ()
		{
			this.pict.log.warn('FlowEditor: WebSocket error, falling back to polling.');
			this._ExecutionWebSocket = null;
			this._fallbackToPolling();
		}.bind(this);

		this._ExecutionWebSocket.onclose = function ()
		{
			this._ExecutionWebSocket = null;
		}.bind(this);
	}

	/**
	 * Handle an incoming WebSocket execution event message.
	 *
	 * @param {string} pMessageData - The raw message string.
	 */
	_handleExecutionEvent(pMessageData)
	{
		let tmpMessage;
		try
		{
			tmpMessage = JSON.parse(pMessageData);
		}
		catch (pError)
		{
			return;
		}

		let tmpEventType = tmpMessage.EventType;
		let tmpData = tmpMessage.Data || {};

		if (tmpEventType === 'TaskStart')
		{
			this._applyNodeVisualState(tmpData.NodeHash, 'executing');
		}
		else if (tmpEventType === 'TaskComplete')
		{
			this._applyNodeVisualState(tmpData.NodeHash, 'complete');
			this._ExecutionCompletedCount++;
		}
		else if (tmpEventType === 'TaskError')
		{
			this._applyNodeVisualState(tmpData.NodeHash, 'error');
			this._ExecutionErrorCount++;
		}
		else if (tmpEventType === 'ExecutionComplete')
		{
			this._finishExecution(tmpData.Status);
		}

		// Update status bar with current elapsed time
		let tmpElapsedMs = tmpData.ElapsedMs || (Date.now() - this._ExecutionStartTime);
		let tmpStatus = (tmpEventType === 'ExecutionComplete') ? tmpData.Status : 'Running';
		this._updateExecutionStatusBar(tmpStatus, this._ExecutionCompletedCount, this._ExecutionErrorCount, tmpElapsedMs);
	}

	/**
	 * Fall back to polling if WebSocket connection fails.
	 */
	_fallbackToPolling()
	{
		if (!this._ExecutionRunHash || !this._IsExecuting)
		{
			return;
		}

		this._ExecutionPollingTimer = setInterval(
			this._pollExecutionStatus.bind(this), 500);
	}

	/**
	 * Poll the manifest endpoint for execution progress (fallback mode).
	 */
	_pollExecutionStatus()
	{
		if (!this._ExecutionRunHash)
		{
			return;
		}

		this.pict.PictApplication.loadManifest(this._ExecutionRunHash,
			function (pError, pData)
			{
				if (pError)
				{
					this._finishExecution('Error', 'Lost connection to server.');
					return;
				}

				if (!pData)
				{
					return;
				}

				let tmpCompletedCount = 0;
				let tmpErrorCount = 0;
				let tmpTaskManifests = pData.TaskManifests || {};
				let tmpNodeHashes = Object.keys(tmpTaskManifests);

				for (let i = 0; i < tmpNodeHashes.length; i++)
				{
					let tmpNodeHash = tmpNodeHashes[i];
					let tmpManifest = tmpTaskManifests[tmpNodeHash];
					let tmpExecState = 'idle';

					if (tmpManifest.Executions && tmpManifest.Executions.length > 0)
					{
						let tmpLatest = tmpManifest.Executions[tmpManifest.Executions.length - 1];

						// Accept legacy 'Running' alongside the canonical
						// 'In Progress' that UV 1.0.34+ emits.
						if (tmpLatest.Status === 'Running' || tmpLatest.Status === 'In Progress')
						{
							tmpExecState = 'executing';
						}
						else if (tmpLatest.Status === 'Complete')
						{
							tmpExecState = 'complete';
							tmpCompletedCount++;
						}
						else if (tmpLatest.Status === 'Error')
						{
							tmpExecState = 'error';
							tmpErrorCount++;
						}
						else if (tmpLatest.Status === 'Stalled')
						{
							tmpExecState = 'stalled';
							tmpErrorCount++;
						}
					}

					if (pData.WaitingTasks && pData.WaitingTasks[tmpNodeHash])
					{
						tmpExecState = 'waiting';
					}

					if (this._ExecutionNodeStates[tmpNodeHash] !== tmpExecState)
					{
						this._applyNodeVisualState(tmpNodeHash, tmpExecState);
					}
				}

				let tmpElapsedMs = pData.ElapsedMs || (Date.now() - this._ExecutionStartTime);
				this._updateExecutionStatusBar(pData.Status, tmpCompletedCount, tmpErrorCount, tmpElapsedMs);

				if (pData.Status === 'Complete' || pData.Status === 'Error'
					|| pData.Status === 'Failed' || pData.Status === 'Stalled'
					|| pData.Status === 'WaitingForInput' || pData.Status === 'Waiting')
				{
					this._finishExecution(pData.Status);
				}
			}.bind(this));
	}

	/**
	 * Apply a visual execution state to a node's SVG group element.
	 *
	 * @param {string} pNodeHash - The node hash.
	 * @param {string} pState - One of: 'idle', 'executing', 'complete', 'error', 'waiting'.
	 */
	_applyNodeVisualState(pNodeHash, pState)
	{
		this._ExecutionNodeStates[pNodeHash] = pState;

		if (!this._FlowView || !this._FlowView._NodesLayer)
		{
			return;
		}

		let tmpNodeGroup = this._FlowView._NodesLayer.querySelector('[data-node-hash="' + pNodeHash + '"]');

		if (!tmpNodeGroup)
		{
			return;
		}

		// Remove all execution state classes
		tmpNodeGroup.classList.remove('uv-exec-idle', 'uv-exec-executing', 'uv-exec-complete', 'uv-exec-error', 'uv-exec-waiting', 'uv-exec-stalled');

		// Add the new state class
		tmpNodeGroup.classList.add('uv-exec-' + pState);
	}

	/**
	 * Update the execution status bar with current progress.
	 */
	_updateExecutionStatusBar(pStatus, pCompletedCount, pErrorCount, pElapsedMs)
	{
		let tmpStatusEl = document.getElementById('Ultravisor-FlowEditor-ExecStatus');
		if (!tmpStatusEl)
		{
			return;
		}

		tmpStatusEl.style.display = 'flex';

		let tmpStatusClass = (pStatus || 'running').toLowerCase().replace(/\s/g, '');
		let tmpElapsedSec = ((pElapsedMs || 0) / 1000).toFixed(1);
		let tmpHTML = '<span class="uv-exec-status-badge ' + tmpStatusClass + '">' + (pStatus || 'Running') + '</span>';
		tmpHTML += '<span>' + tmpElapsedSec + 's elapsed</span>';

		if (pCompletedCount > 0)
		{
			tmpHTML += '<span>' + pCompletedCount + ' completed</span>';
		}
		if (pErrorCount > 0)
		{
			tmpHTML += '<span style="color:#c44e4e">' + pErrorCount + ' error' + (pErrorCount !== 1 ? 's' : '') + '</span>';
		}

		tmpStatusEl.innerHTML = tmpHTML;
	}

	/**
	 * Finish execution — close WebSocket/polling and update UI.
	 *
	 * @param {string} pFinalStatus - The final status ('Complete', 'Error', 'WaitingForInput').
	 * @param {string} [pMessage] - Optional message to append to status bar.
	 */
	_finishExecution(pFinalStatus, pMessage)
	{
		// Close WebSocket if open
		if (this._ExecutionWebSocket)
		{
			this._ExecutionWebSocket.onclose = null;
			this._ExecutionWebSocket.close();
			this._ExecutionWebSocket = null;
		}

		// Clear polling timer if in fallback mode
		if (this._ExecutionPollingTimer)
		{
			clearInterval(this._ExecutionPollingTimer);
			this._ExecutionPollingTimer = null;
		}

		this._IsExecuting = false;
		this._ExecutionRunHash = null;

		// Restore button visibility
		let tmpExecBtn = document.getElementById('Ultravisor-FlowEditor-ExecuteBtn');
		let tmpStopBtn = document.getElementById('Ultravisor-FlowEditor-StopBtn');
		if (tmpExecBtn) { tmpExecBtn.style.display = 'inline-block'; }
		if (tmpStopBtn) { tmpStopBtn.style.display = 'none'; }

		// Update status bar with final state
		if (pMessage)
		{
			let tmpStatusEl = document.getElementById('Ultravisor-FlowEditor-ExecStatus');
			if (tmpStatusEl)
			{
				tmpStatusEl.innerHTML += '<span style="color:#c44e4e">' + pMessage + '</span>';
			}
		}
	}

	/**
	 * Stop visual execution and clear all execution visuals.
	 */
	stopVisualExecution()
	{
		this._finishExecution('Stopped');
		this._clearExecutionVisuals();
	}

	/**
	 * Clear all execution visual indicators from nodes.
	 */
	_clearExecutionVisuals()
	{
		if (this._FlowView && this._FlowView._NodesLayer)
		{
			let tmpNodeGroups = this._FlowView._NodesLayer.querySelectorAll('[data-node-hash]');
			for (let i = 0; i < tmpNodeGroups.length; i++)
			{
				tmpNodeGroups[i].classList.remove('uv-exec-idle', 'uv-exec-executing', 'uv-exec-complete', 'uv-exec-error', 'uv-exec-waiting', 'uv-exec-stalled');
			}
		}

		this._ExecutionNodeStates = {};

		let tmpStatusEl = document.getElementById('Ultravisor-FlowEditor-ExecStatus');
		if (tmpStatusEl)
		{
			tmpStatusEl.style.display = 'none';
		}
	}
}

module.exports = UltravisorFlowEditorView;

module.exports.default_configuration = _ViewConfiguration;

},{"../cards/Ultravisor-BuiltIn-CardConfigs.js":246,"../data/ExampleFlow-CSVPipeline.js":248,"../data/ExampleFlow-FileProcessor.js":249,"../data/ExampleFlow-MeadowPipeline.js":250,"pict-section-flow":28,"pict-view":239}],262:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Ultravisor-Layout — application chrome.
 *
 * Built on pict-section-modal's shell() API. This view owns the shell;
 * everything else (TopBar, Sidebar, Settings panel, BottomBar, content
 * center) lives in panels managed by the shell.
 *
 * Panel layout:
 *
 *   ┌──────────────────────────────────────────────────────────────┐
 *   │ #Theme-TopBar  (top, fixed, 56px) — BrandMark + Nav + User   │
 *   ├────────┬─────────────────────────────────────────────────────┤
 *   │ #Ult-  │ #Ultravisor-Content-Container                       │
 *   │ Side-  │ (center — current section view renders here)        │
 *   │ bar-   │                                                     │
 *   │ Host   │                                                     │
 *   │ (left, │                                                     │
 *   │ resiz, │                                                     │
 *   │ tabs)  │                                                     │
 *   ├────────┴─────────────────────────────────────────────────────┤
 *   │ #Theme-BottomBar (bottom, fixed, 28px) — StatusBar slot      │
 *   └──────────────────────────────────────────────────────────────┘
 *
 * Plus #Ultravisor-Settings-Panel — a Hidden panel that overlays from
 * the right when the gear button in the user slot toggles it. No edge
 * affordance: Hidden + Collapsed means no chrome until reveal. The
 * gear is the only way in.
 */

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-Layout",

	DefaultRenderable: "Ultravisor-Layout-Shell",
	DefaultDestinationAddress: "#Ultravisor-Application-Container",

	AutoRender: false,

	CSS: /*css*/`
		/* height: 100% (not 100vh) so Theme-Scale's CSS zoom on <html>
		   doesn't push panels off-screen — vh units render against the
		   un-zoomed viewport. */
		html, body { height: 100%; margin: 0; padding: 0; }
		body
		{
			background: var(--theme-color-background-primary, #1a1714);
			color: var(--theme-color-text-primary, #c8b8a0);
			font-family: var(--theme-typography-family-sans, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif);
		}
		#Ultravisor-Application-Container
		{
			height: 100%;
			min-height: 0;
			overflow: hidden;
		}

		.pict-modal-shell-host   { height: 100%; }
		.pict-modal-shell        { background: var(--theme-color-background-primary, #1a1714); }
		.pict-modal-shell-panel  { background: var(--theme-color-background-panel,    #252018); }
		.pict-modal-shell-center { background: var(--theme-color-background-primary,  #1a1714); }

		#Ultravisor-Content-Container
		{
			height: 100%;
			min-height: 0;
			overflow-y: auto;
			background: var(--theme-color-background-primary, #1a1714);
			color: var(--theme-color-text-primary, #c8b8a0);
		}
		#Ultravisor-Settings-Panel
		{
			height: 100%;
			min-height: 0;
			overflow-y: auto;
			background: var(--theme-color-background-panel, #252018);
			color: var(--theme-color-text-primary, #c8b8a0);
			border-left: 1px solid var(--theme-color-border-default, #3a3028);
		}

		/* Server disconnected banner — written into #Ultravisor-Content-Container
		   by the application's _setConnectionState() helper when the API
		   becomes unreachable. */
		.ultravisor-disconnected-banner
		{
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 4em 2em;
			text-align: center;
			color: var(--theme-color-text-muted, #8a7f72);
		}
		.ultravisor-disconnected-banner-icon
		{
			font-size: 3em;
			margin-bottom: 0.4em;
			opacity: 0.5;
		}
		.ultravisor-disconnected-banner h2
		{
			margin: 0 0 0.5em 0;
			font-weight: 400;
			font-size: 1.4em;
			color: var(--theme-color-text-primary, #c8d0d8);
		}
		.ultravisor-disconnected-banner p
		{
			margin: 0 0 0.3em 0;
			font-size: 0.9em;
			max-width: 420px;
			line-height: 1.5;
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-Layout-Shell-Template",
			Template: /*html*/`
<div id="Ultravisor-Layout-Mount" style="height:100%"></div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-Layout-Shell",
			TemplateHash: "Ultravisor-Layout-Shell-Template",
			DestinationAddress: "#Ultravisor-Application-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorLayoutView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._shell = null;
		this._shellPanelsBuilt = false;
		this._hashListenerWired = false;
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		if (!this._shellPanelsBuilt)
		{
			this._buildShell();
			this._shellPanelsBuilt = true;
		}

		this._wireHashChangeListener();

		// Resolve the current route so the matching content view renders.
		if (this.pict.providers.PictRouter)
		{
			this.pict.providers.PictRouter.resolve();
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_buildShell()
	{
		let tmpModalSection = this.pict.views['Pict-Section-Modal'];
		if (!tmpModalSection || typeof tmpModalSection.shell !== 'function')
		{
			this.pict.log.warn('Ultravisor-Layout: pict-section-modal.shell not available');
			return;
		}

		let tmpMount = document.getElementById('Ultravisor-Layout-Mount');
		if (!tmpMount)
		{
			this.pict.log.warn('Ultravisor-Layout: #Ultravisor-Layout-Mount not in DOM yet');
			return;
		}

		this._shell = tmpModalSection.shell(tmpMount, { PersistenceKey: 'ultravisor-shell' });

		// Top — Theme chrome (BrandMark + Nav slot + User slot).
		this._shell.addPanel(
		{
			Hash: 'topbar',
			Side: 'top',
			Mode: 'fixed',
			Size: 56,
			ContentDestinationId: 'Theme-TopBar',
			ContentView: 'Theme-TopBar'
		});

		// Left — section-context sidebar (resizable, responsive drawer below 900px).
		this._shell.addPanel(
		{
			Hash: 'sidebar',
			Side: 'left',
			Mode: 'resizable',
			Size: 260,
			MinSize: 180,
			MaxSize: 480,
			Collapsed: false,
			Title: 'Context',
			ContentDestinationId: 'Ultravisor-Sidebar-Host',
			ContentView: 'Ultravisor-Sidebar',
			ResponsiveDrawer: 900
		});

		// Bottom — Theme BottomBar wraps the host's StatusView slot.
		this._shell.addPanel(
		{
			Hash: 'statusbar',
			Side: 'bottom',
			Mode: 'fixed',
			Size: 28,
			ContentDestinationId: 'Theme-BottomBar',
			ContentView: 'Theme-BottomBar'
		});

		// Right (overlay, Hidden) — settings panel. The gear in TopBar-User
		// toggles it; no edge affordance until then.
		this._shell.addPanel(
		{
			Hash: 'settings',
			Side: 'right',
			Mode: 'resizable',
			Position: 'overlay',
			Size: 360,
			MinSize: 280,
			MaxSize: 540,
			Hidden: true,
			Collapsed: true,
			ContentDestinationId: 'Ultravisor-Settings-Panel',
			ContentView: 'Ultravisor-SettingsPanel'
		});

		// Center — current section's content view renders into this destination.
		this._shell.center({ ContentDestinationId: 'Ultravisor-Content-Container' });
	}

	// ─────────────────────────────────────────────
	//  Panel accessors — referenced by slot views (gear button) and the app.
	// ─────────────────────────────────────────────

	getSidebarPanel()  { return this._shell ? this._shell.getPanel('sidebar')  : null; }
	getSettingsPanel() { return this._shell ? this._shell.getPanel('settings') : null; }

	toggleSidebar()
	{
		let tmpPanel = this.getSidebarPanel();
		if (tmpPanel) { tmpPanel.toggle(); }
	}

	toggleSettingsPanel()
	{
		let tmpPanel = this.getSettingsPanel();
		if (tmpPanel) { tmpPanel.toggle(); }
	}

	// ─────────────────────────────────────────────
	//  Route sync — keep AppData.Ultravisor.CurrentRoute fresh on
	//  back/forward and any direct hash mutation so the topbar tabs
	//  + sidebar re-render with the right active state.
	// ─────────────────────────────────────────────

	_wireHashChangeListener()
	{
		if (this._hashListenerWired) { return; }
		this._hashListenerWired = true;
		let tmpSelf = this;
		window.addEventListener('hashchange', () =>
		{
			if (tmpSelf.pict.PictApplication && typeof tmpSelf.pict.PictApplication.onRouteChanged === 'function')
			{
				tmpSelf.pict.PictApplication.onRouteChanged();
			}
		});
	}
}

module.exports = UltravisorLayoutView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],263:[function(require,module,exports){
/**
 * PictView-Ultravisor-Login
 *
 * Thin host wrapper around `pict-section-login`. The section view
 * renders into `#Pict-Login-Container`; this view just paints the
 * mount point inside ultravisor's main content panel and delegates
 * to the section's render.
 *
 * The section view ships its own theme-neutral CSS, so this wrapper
 * only contributes layout chrome (centered card on the page).
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Ultravisor-Login',
	AutoInitialize: true,
	AutoRender: false,

	DefaultRenderable: 'Ultravisor-Login-Content',
	DefaultDestinationAddress: '#Ultravisor-Content-Container',

	Templates:
	[
		{
			Hash: 'Ultravisor-Login-Template',
			Template: /*html*/`
<div class="ultravisor-login-page">
	<div id="Pict-Login-Container"></div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Ultravisor-Login-Content',
			TemplateHash: 'Ultravisor-Login-Template',
			DestinationAddress: '#Ultravisor-Content-Container',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
		.ultravisor-login-page {
			min-height: calc(100vh - 56px);
			display: flex; align-items: center; justify-content: center;
			padding: 32px 16px;
		}
	`
};

class UltravisorLoginView extends libPictView
{
	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		// Render the pict-section-login view into the mount point we
		// just painted.  The section tracks its own destination via
		// DefaultDestinationAddress: '#Pict-Login-Container', so a plain
		// render() call is enough.
		let tmpInner = this.pict && this.pict.views && this.pict.views['Pict-Section-Login'];
		if (tmpInner) tmpInner.render();
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}
}

module.exports = UltravisorLoginView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],264:[function(require,module,exports){
const libPictView = require('pict-view');

const libTimingUtils = require('../Ultravisor-TimingUtils.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-ManifestDetail",

	DefaultRenderable: "Ultravisor-ManifestDetail-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-manifestdetail {
			padding: 2em;
			max-width: 1400px;
			margin: 0 auto;
		}
		.ultravisor-manifestdetail-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1.5em;
			padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-manifestdetail-header h1 {
			margin: 0;
			font-size: 2em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.ultravisor-manifestdetail-meta {
			display: grid;
			grid-template-columns: auto 1fr;
			gap: 0.4em 1.5em;
			margin-bottom: 1.5em;
			font-size: 0.95em;
		}
		.ultravisor-manifestdetail-meta dt {
			font-weight: 600;
			color: var(--uv-text-secondary);
		}
		.ultravisor-manifestdetail-meta dd {
			margin: 0;
		}
		.ultravisor-manifestdetail-section {
			margin-bottom: 1.5em;
		}
		.ultravisor-manifestdetail-section h3 {
			margin: 0 0 0.75em 0;
			color: var(--uv-text-secondary);
			font-size: 1.1em;
		}
		.ultravisor-manifestdetail-output {
			background: #0d1117;
			color: #c9d1d9;
			border-radius: 4px;
			padding: 0.75em;
			font-family: monospace;
			font-size: 0.85em;
			white-space: pre-wrap;
			word-break: break-all;
			max-height: 300px;
			overflow-y: auto;
		}
		.ultravisor-manifestdetail-task {
			background: var(--uv-bg-base);
			border-radius: 4px;
			padding: 0.75em;
			margin-bottom: 0.5em;
		}
		.ultravisor-manifestdetail-task-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 0.5em;
		}
		.ultravisor-manifestdetail-task-header code {
			color: var(--uv-brand);
		}

		/* Action bar for live runs */
		.ultravisor-manifestdetail-actions {
			display: flex;
			gap: 0.5em;
			margin-bottom: 1.5em;
			padding: 0.75em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 6px;
			align-items: center;
		}
		.ultravisor-manifestdetail-actions-label {
			font-size: 0.85em;
			font-weight: 600;
			color: var(--uv-text-secondary);
			margin-right: 0.5em;
		}

		/* Waiting tasks inline */
		.ultravisor-manifestdetail-waiting {
			margin-bottom: 1.5em;
		}
		.ultravisor-manifestdetail-waiting-task {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 6px;
			padding: 0.75em;
			margin-bottom: 0.5em;
		}
		.ultravisor-manifestdetail-beacon-status {
			display: flex;
			align-items: center;
			gap: 0.5em;
		}
		.ultravisor-manifestdetail-waiting-indicator {
			display: inline-block;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: var(--uv-info);
			animation: uv-detail-waiting-pulse 1.5s ease-in-out infinite;
			flex-shrink: 0;
		}
		@keyframes uv-detail-waiting-pulse {
			0%, 100% { opacity: 1; transform: scale(1); }
			50% { opacity: 0.4; transform: scale(0.7); }
		}
		.ultravisor-manifestdetail-prompt {
			color: var(--uv-text-secondary);
			font-size: 0.9em;
		}
		.ultravisor-manifestdetail-input-prompt {
			color: #d4884a;
			font-size: 0.9em;
			margin-bottom: 0.5em;
		}
		.ultravisor-manifestdetail-input-form {
			display: flex;
			gap: 0.5em;
			align-items: center;
		}
		.ultravisor-manifestdetail-input-form input {
			flex: 1;
			min-width: 150px;
		}
		.ultravisor-manifestdetail-input-submit {
			padding: 0.4em 0.8em;
			background: #3a2a1a;
			color: #d4884a;
			border: 1px solid #5a3a1a;
			border-radius: 4px;
			cursor: pointer;
			font-weight: 600;
		}
		.ultravisor-manifestdetail-force-error {
			padding: 0.4em 0.8em;
			background: #3a1a1a;
			color: #c44e4e;
			border: 1px solid #5a2a2a;
			border-radius: 4px;
			cursor: pointer;
			font-size: 0.85em;
			margin-top: 0.5em;
		}
		.ultravisor-manifestdetail-force-error:hover {
			background: #4a2020;
		}
		.ultravisor-manifestdetail-result {
			margin-top: 0.5em;
			padding: 0.4em 0.6em;
			border-radius: 3px;
			font-size: 0.85em;
		}
		.ultravisor-manifestdetail-result.success {
			background: #1a3a1a;
			color: #5ab88a;
		}
		.ultravisor-manifestdetail-result.error {
			background: #3a1a1a;
			color: #c44e4e;
		}
		.ultravisor-manifestdetail-elapsed-hint {
			font-size: 0.75em;
			color: var(--uv-text-tertiary);
			margin-top: 0.25em;
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-ManifestDetail-Template",
			Template: /*html*/`
<div class="ultravisor-manifestdetail">
	<div class="ultravisor-manifestdetail-header">
		<h1>Manifest Detail</h1>
		<button class="ultravisor-btn ultravisor-btn-secondary" onclick="{~P~}.PictApplication.navigateTo('/Manifests')">Back to List</button>
	</div>
	<div id="Ultravisor-ManifestDetail-Body"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-ManifestDetail-Content",
			TemplateHash: "Ultravisor-ManifestDetail-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorManifestDetailView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._CurrentRunHash = null;
	}

	/**
	 * Set the run hash to display (called before render from route handler).
	 */
	setRunHash(pRunHash)
	{
		this._CurrentRunHash = pRunHash;
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		if (this._CurrentRunHash)
		{
			this._loadAndRenderDetail(this._CurrentRunHash);
		}
		else
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-ManifestDetail-Body',
				'<div class="ultravisor-empty-message">No manifest selected.</div>');
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_loadAndRenderDetail(pRunHash)
	{
		this.pict.PictApplication.loadManifest(pRunHash,
			function (pError, pManifest)
			{
				if (pError || !pManifest)
				{
					this.pict.ContentAssignment.assignContent('#Ultravisor-ManifestDetail-Body',
						'<p style="color:var(--uv-error);">Error loading manifest details.</p>');
					return;
				}

				let tmpHTML = '';

				// ── Header meta ──
				let tmpOperationName = pManifest.OperationName || pManifest.OperationHash || '';
				let tmpStarted = pManifest.StartTime
					? this.fable.Dates.dayJS(pManifest.StartTime).format('YYYY-MM-DD HH:mm:ss')
					: '';
				let tmpCompleted = pManifest.StopTime
					? this.fable.Dates.dayJS(pManifest.StopTime).format('YYYY-MM-DD HH:mm:ss')
					: '';

				let tmpElapsedMs = pManifest.ElapsedMs;
				if (tmpElapsedMs == null && pManifest.StartTime && pManifest.StopTime)
				{
					tmpElapsedMs = new Date(pManifest.StopTime).getTime() - new Date(pManifest.StartTime).getTime();
				}
				let tmpElapsed = '';
				if (tmpElapsedMs != null && tmpElapsedMs >= 0)
				{
					tmpElapsed = (tmpElapsedMs === 0) ? '< 1ms' : libTimingUtils.formatMs(tmpElapsedMs);
				}

				tmpHTML += '<dl class="ultravisor-manifestdetail-meta">';
				tmpHTML += '<dt>Operation</dt><dd>' + libTimingUtils.escapeHTML(tmpOperationName) + '</dd>';
				tmpHTML += '<dt>Run Hash</dt><dd><code style="font-size:0.85em;">' + libTimingUtils.escapeHTML(pManifest.Hash || '') + '</code></dd>';
				tmpHTML += '<dt>Status</dt><dd><span class="ultravisor-manifest-status ' + this._normalizeStatusKey(pManifest.Status) + '">' + libTimingUtils.escapeHTML(pManifest.Status || '') + '</span></dd>';
				tmpHTML += '<dt>Elapsed</dt><dd>' + tmpElapsed + '</dd>';
				tmpHTML += '<dt>Started</dt><dd>' + libTimingUtils.escapeHTML(tmpStarted) + '</dd>';
				tmpHTML += '<dt>Completed</dt><dd>' + libTimingUtils.escapeHTML(tmpCompleted) + '</dd>';
				if (pManifest.RunMode)
				{
					tmpHTML += '<dt>Run Mode</dt><dd>' + libTimingUtils.escapeHTML(pManifest.RunMode) + '</dd>';
				}
				tmpHTML += '</dl>';

				// ── Action bar ──
				let tmpStatusKey = this._normalizeStatusKey(pManifest.Status);
				let tmpIsLive = pManifest.Live || false;
				let tmpIsWaiting = (tmpStatusKey === 'waiting');
				let tmpIsRunning = (tmpStatusKey === 'running');
				let tmpIsRetryable = (tmpStatusKey === 'stalled' || tmpStatusKey === 'failed');

				if ((tmpIsLive && (tmpIsRunning || tmpIsWaiting)) || tmpIsRetryable)
				{
					let tmpEscHash = (pManifest.Hash || '').replace(/'/g, "\\'");
					let tmpEscOpHash = (pManifest.OperationHash || '').replace(/'/g, "\\'");
					let tmpGlobalRef = '_Pict';
					let tmpViewRef = tmpGlobalRef + ".views['Ultravisor-ManifestDetail']";

					tmpHTML += '<div class="ultravisor-manifestdetail-actions">';
					tmpHTML += '<span class="ultravisor-manifestdetail-actions-label">Actions:</span>';
					if (tmpIsLive && (tmpIsRunning || tmpIsWaiting))
					{
						tmpHTML += '<button class="ultravisor-btn ultravisor-btn-execute" onclick="' + tmpGlobalRef + '.PictApplication.watchExecution(\'' + tmpEscHash + '\', \'' + tmpEscOpHash + '\')">Watch in Flow Editor</button>';
					}
					if (tmpIsRetryable)
					{
						tmpHTML += '<button class="ultravisor-btn ultravisor-btn-execute" onclick="' + tmpViewRef + '.retryRun(\'' + tmpEscHash + '\')">Retry</button>';
					}
					tmpHTML += '</div>';
				}

				// ── Waiting Tasks (for live Waiting runs) ──
				if (tmpIsLive && tmpIsWaiting && pManifest.WaitingTasks)
				{
					let tmpWaitingNodeHashes = Object.keys(pManifest.WaitingTasks);
					if (tmpWaitingNodeHashes.length > 0)
					{
						tmpHTML += this._renderWaitingTasks(pManifest);
					}
				}

				// ── Operation Output ──
				if (pManifest.Output && Object.keys(pManifest.Output).length > 0)
				{
					tmpHTML += '<div class="ultravisor-manifestdetail-section">';
					tmpHTML += '<h3>Output</h3>';
					tmpHTML += '<div class="ultravisor-manifestdetail-output">' + libTimingUtils.escapeHTML(JSON.stringify(pManifest.Output, null, '\t')) + '</div>';
					tmpHTML += '</div>';
				}

				// ── Debug State ──
				if (pManifest.OperationState && Object.keys(pManifest.OperationState).length > 0)
				{
					tmpHTML += '<div class="ultravisor-manifestdetail-section">';
					tmpHTML += '<h3>Operation State</h3>';
					tmpHTML += '<div class="ultravisor-manifestdetail-output">' + libTimingUtils.escapeHTML(JSON.stringify(pManifest.OperationState, null, '\t')) + '</div>';
					tmpHTML += '</div>';
				}
				if (pManifest.GlobalState && Object.keys(pManifest.GlobalState).length > 0)
				{
					tmpHTML += '<div class="ultravisor-manifestdetail-section">';
					tmpHTML += '<h3>Global State</h3>';
					tmpHTML += '<div class="ultravisor-manifestdetail-output">' + libTimingUtils.escapeHTML(JSON.stringify(pManifest.GlobalState, null, '\t')) + '</div>';
					tmpHTML += '</div>';
				}

				// ── Task Outputs ──
				if (pManifest.TaskOutputs && Object.keys(pManifest.TaskOutputs).length > 0)
				{
					tmpHTML += '<div class="ultravisor-manifestdetail-section">';
					tmpHTML += '<h3>Task Outputs</h3>';
					tmpHTML += '<div class="ultravisor-manifestdetail-output">' + libTimingUtils.escapeHTML(JSON.stringify(pManifest.TaskOutputs, null, '\t')) + '</div>';
					tmpHTML += '</div>';
				}

				// ── Task Manifests ──
				if (pManifest.TaskManifests && Object.keys(pManifest.TaskManifests).length > 0)
				{
					tmpHTML += '<div class="ultravisor-manifestdetail-section">';
					tmpHTML += '<h3>Task Manifests</h3>';
					let tmpNodeHashes = Object.keys(pManifest.TaskManifests);
					for (let i = 0; i < tmpNodeHashes.length; i++)
					{
						let tmpNodeHash = tmpNodeHashes[i];
						let tmpTaskManifest = pManifest.TaskManifests[tmpNodeHash];
						tmpHTML += '<div class="ultravisor-manifestdetail-task">';
						tmpHTML += '<div class="ultravisor-manifestdetail-task-header">';
						tmpHTML += '<code>' + libTimingUtils.escapeHTML(tmpNodeHash) + '</code>';
						tmpHTML += '<span class="ultravisor-manifest-status ' + this._normalizeStatusKey(tmpTaskManifest.Status) + '">' + libTimingUtils.escapeHTML(tmpTaskManifest.Status || '') + '</span>';
						tmpHTML += '</div>';
						if (tmpTaskManifest.Output)
						{
							tmpHTML += '<div class="ultravisor-manifestdetail-output">' + libTimingUtils.escapeHTML(JSON.stringify(tmpTaskManifest.Output, null, '\t')) + '</div>';
						}
						tmpHTML += '</div>';
					}
					tmpHTML += '</div>';
				}

				// ── Errors ──
				if (pManifest.Errors && pManifest.Errors.length > 0)
				{
					tmpHTML += '<div class="ultravisor-manifestdetail-section">';
					tmpHTML += '<h3 style="color:var(--uv-error);">Errors</h3>';
					tmpHTML += '<div class="ultravisor-manifestdetail-output" style="border: 1px solid var(--uv-error);">' + libTimingUtils.escapeHTML(pManifest.Errors.join('\n')) + '</div>';
					tmpHTML += '</div>';
				}

				// ── Log ──
				if (pManifest.Log && pManifest.Log.length > 0)
				{
					tmpHTML += '<div class="ultravisor-manifestdetail-section">';
					tmpHTML += '<h3>Log</h3>';
					tmpHTML += '<div class="ultravisor-manifestdetail-output">' + libTimingUtils.escapeHTML(pManifest.Log.join('\n')) + '</div>';
					tmpHTML += '</div>';
				}

				// ── Timing Analysis ──
				let tmpHasTimingData = (pManifest.TimingSummary &&
					(pManifest.TimingSummary.ByCategory || pManifest.TimingSummary.ByTaskType)) ||
					(pManifest.TaskManifests && Object.keys(pManifest.TaskManifests).length > 0);

				if (tmpHasTimingData)
				{
					tmpHTML += '<div class="ultravisor-manifestdetail-section">';
					tmpHTML += '<h3>Timing Analysis</h3>';
					tmpHTML += this._renderTaskTimeline(pManifest);
					if (pManifest.TimingSummary && pManifest.TimingSummary.ByCategory)
					{
						tmpHTML += this._renderCategoryHistogram(pManifest.TimingSummary.ByCategory);
					}
					if (pManifest.TimingSummary && pManifest.TimingSummary.ByTaskType)
					{
						tmpHTML += this._renderTaskTypeHistogram(pManifest.TimingSummary.ByTaskType);
					}
					tmpHTML += '</div>';
				}

				this.pict.ContentAssignment.assignContent('#Ultravisor-ManifestDetail-Body', tmpHTML);
			}.bind(this));
	}

	// ── Waiting Task Actions ─────────────────────────────────────────────

	_isBeaconTask(pTask)
	{
		return (pTask.ResumeEventName && pTask.ResumeEventName !== 'ValueInputComplete');
	}

	// Map any Status string (legacy Pending/Running/WaitingForInput or
	// canonical Queued/In Progress/Waiting/Stalled/Failed) to a stable
	// CSS-class-friendly key.  Same logic as ManifestList's helper —
	// keep them in sync if you change one.
	_normalizeStatusKey(pStatus)
	{
		let tmpRaw = (pStatus || '').toLowerCase().replace(/\s+/g, '');
		switch (tmpRaw)
		{
			case 'pending':
			case 'queued':
				return 'queued';
			case 'running':
			case 'inprogress':
				return 'running';
			case 'waitingforinput':
			case 'waiting':
				return 'waiting';
			case 'complete':
			case 'completed':
				return 'complete';
			case 'error':         return 'error';
			case 'failed':        return 'failed';
			case 'stalled':       return 'stalled';
			case 'abandoned':     return 'abandoned';
			case 'retrying':      return 'running';
			default:              return tmpRaw;
		}
	}

	// ── Retry action ──
	// Re-dispatches the failed/stalled node.  Briefly polls the
	// manifest for ~12s after the API call so the user sees the
	// state progress (Stalled → Waiting → Complete) without having
	// to manually refresh.
	retryRun(pRunHash)
	{
		this.pict.views.Modal.confirm('Retry this run from its failed/stalled node? Upstream node outputs are preserved; only the stuck node and its downstream branch re-run.', { confirmLabel: 'Retry' }).then(
			function (pConfirmed)
			{
				if (!pConfirmed) return;
				this.pict.PictApplication.retryRun(pRunHash,
					function (pError, pData)
					{
						if (pError)
						{
							this.pict.views.Modal.toast('Failed to retry run: ' + (pError.message || 'Unknown error'), { type: 'error' });
							return;
						}
						this.pict.views.Modal.toast('Run re-dispatched.', { type: 'success' });
						this._pollAfterRetry(pRunHash);
					}.bind(this));
			}.bind(this));
	}

	// Reload the manifest every second for ~12 seconds after a retry,
	// stopping early on a terminal status that's *different* from the
	// pre-retry status (the engine takes a tick or two to transition
	// out of the original Stalled/Failed; we don't want to give up
	// before that transition lands).
	_pollAfterRetry(pRunHash)
	{
		let tmpTicks = 0;
		let tmpMaxTicks = 12;
		let tmpInitialStatusKey = null;
		let tmpInterval = setInterval(function ()
		{
			tmpTicks++;
			this.pict.PictApplication.loadManifest(pRunHash,
				function (pError, pManifest)
				{
					if (!pError && pManifest)
					{
						this._loadAndRenderDetail(pRunHash);
						let tmpKey = this._normalizeStatusKey(pManifest.Status);
						if (tmpInitialStatusKey === null) { tmpInitialStatusKey = tmpKey; }
						let tmpIsTerminal = (tmpKey === 'complete' || tmpKey === 'failed'
							|| tmpKey === 'stalled' || tmpKey === 'error'
							|| tmpKey === 'abandoned');
						if (tmpIsTerminal && tmpKey !== tmpInitialStatusKey)
						{
							clearInterval(tmpInterval);
						}
					}
					if (tmpTicks >= tmpMaxTicks)
					{
						clearInterval(tmpInterval);
					}
				}.bind(this));
		}.bind(this), 1000);
	}

	_formatElapsed(pTimestamp)
	{
		if (!pTimestamp) return '';
		let tmpMs = Date.now() - new Date(pTimestamp).getTime();
		if (tmpMs < 1000) return 'just now';
		if (tmpMs < 60000) return Math.floor(tmpMs / 1000) + 's ago';
		if (tmpMs < 3600000) return Math.floor(tmpMs / 60000) + 'm ' + Math.floor((tmpMs % 60000) / 1000) + 's ago';
		return Math.floor(tmpMs / 3600000) + 'h ' + Math.floor((tmpMs % 3600000) / 60000) + 'm ago';
	}

	_renderWaitingTasks(pManifest)
	{
		let tmpWaitingTasks = pManifest.WaitingTasks || {};
		let tmpNodeHashes = Object.keys(tmpWaitingTasks);
		let tmpRunHash = pManifest.Hash || '';
		let tmpEscRunHash = tmpRunHash.replace(/'/g, "\\'");
		let tmpViewRef = "_Pict.views['Ultravisor-ManifestDetail']";

		let tmpHTML = '<div class="ultravisor-manifestdetail-section ultravisor-manifestdetail-waiting">';
		tmpHTML += '<h3>Waiting Tasks</h3>';

		for (let j = 0; j < tmpNodeHashes.length; j++)
		{
			let tmpNodeHash = tmpNodeHashes[j];
			let tmpEscNodeHash = tmpNodeHash.replace(/'/g, "\\'");
			let tmpTask = tmpWaitingTasks[tmpNodeHash];
			let tmpResultId = 'detail-result-' + tmpRunHash.replace(/[^a-zA-Z0-9]/g, '') + '-' + tmpNodeHash.replace(/[^a-zA-Z0-9]/g, '');

			tmpHTML += '<div class="ultravisor-manifestdetail-waiting-task">';

			if (this._isBeaconTask(tmpTask))
			{
				tmpHTML += '<div class="ultravisor-manifestdetail-beacon-status">';
				tmpHTML += '<span class="ultravisor-manifestdetail-waiting-indicator"></span>';
				tmpHTML += '<span class="ultravisor-manifestdetail-prompt">' + libTimingUtils.escapeHTML(tmpTask.PromptMessage || 'Waiting for beacon to complete') + '</span>';
				tmpHTML += '</div>';
				if (tmpTask.Timestamp)
				{
					tmpHTML += '<div class="ultravisor-manifestdetail-elapsed-hint">Dispatched ' + libTimingUtils.escapeHTML(this._formatElapsed(tmpTask.Timestamp)) + '</div>';
				}
				tmpHTML += '<button class="ultravisor-manifestdetail-force-error" onclick="' + tmpViewRef + '.forceError(\'' + tmpEscRunHash + '\', \'' + tmpEscNodeHash + '\', \'' + tmpResultId + '\')">Force Error &amp; Stop Waiting</button>';
			}
			else
			{
				let tmpInputId = 'detail-input-' + tmpRunHash.replace(/[^a-zA-Z0-9]/g, '') + '-' + tmpNodeHash.replace(/[^a-zA-Z0-9]/g, '');

				tmpHTML += '<div class="ultravisor-manifestdetail-input-prompt">' + libTimingUtils.escapeHTML(tmpTask.PromptMessage || 'Enter a value') + '</div>';
				if (tmpTask.OutputAddress)
				{
					tmpHTML += '<div style="font-size:0.8em;color:var(--uv-text-tertiary);margin-bottom:0.5em;">Target: <code>' + libTimingUtils.escapeHTML(tmpTask.OutputAddress) + '</code></div>';
				}
				tmpHTML += '<div class="ultravisor-manifestdetail-input-form">';
				tmpHTML += '<input type="text" id="' + tmpInputId + '" placeholder="Enter value..." onkeydown="if(event.key===\'Enter\'){' + tmpViewRef + '.submitInput(\'' + tmpEscRunHash + '\', \'' + tmpEscNodeHash + '\', \'' + tmpInputId + '\', \'' + tmpResultId + '\');}" />';
				tmpHTML += '<button class="ultravisor-manifestdetail-input-submit" onclick="' + tmpViewRef + '.submitInput(\'' + tmpEscRunHash + '\', \'' + tmpEscNodeHash + '\', \'' + tmpInputId + '\', \'' + tmpResultId + '\')">Submit</button>';
				tmpHTML += '</div>';
			}

			tmpHTML += '<div id="' + tmpResultId + '"></div>';
			tmpHTML += '</div>';
		}

		tmpHTML += '</div>';
		return tmpHTML;
	}

	submitInput(pRunHash, pNodeHash, pInputId, pResultId)
	{
		let tmpInputEl = document.getElementById(pInputId);
		if (!tmpInputEl) return;

		let tmpValue = tmpInputEl.value;
		tmpInputEl.disabled = true;
		let tmpButton = tmpInputEl.parentElement.querySelector('.ultravisor-manifestdetail-input-submit');
		if (tmpButton)
		{
			tmpButton.disabled = true;
			tmpButton.textContent = 'Submitting...';
		}

		this.pict.PictApplication.submitPendingInput(pRunHash, pNodeHash, tmpValue,
			function (pError, pData)
			{
				if (pError || (pData && pData.Error))
				{
					let tmpMsg = (pError && pError.message) || (pData && pData.Error) || 'Request failed';
					this.pict.ContentAssignment.assignContent('#' + pResultId,
						'<div class="ultravisor-manifestdetail-result error">Error: ' + libTimingUtils.escapeHTML(tmpMsg) + '</div>');
					tmpInputEl.disabled = false;
					if (tmpButton) { tmpButton.disabled = false; tmpButton.textContent = 'Submit'; }
					return;
				}

				let tmpStatus = (pData && pData.Status) || 'Submitted';
				this.pict.ContentAssignment.assignContent('#' + pResultId,
					'<div class="ultravisor-manifestdetail-result success">Input submitted — status: ' + libTimingUtils.escapeHTML(tmpStatus) + '</div>');

				// Reload the detail after a brief delay
				setTimeout(function ()
				{
					this._loadAndRenderDetail(this._CurrentRunHash);
				}.bind(this), 1500);
			}.bind(this));
	}

	forceError(pRunHash, pNodeHash, pResultId)
	{
		this.pict.views.Modal.confirm('Force this task to error?\nThe operation will continue on the Error path.', { confirmLabel: 'Force Error', dangerous: true }).then(
			function (pConfirmed)
			{
				if (pConfirmed)
				{
					let tmpButtonEl = document.querySelector('#' + pResultId);
					let tmpForceBtn = tmpButtonEl ? tmpButtonEl.previousElementSibling : null;
					if (tmpForceBtn && tmpForceBtn.classList.contains('ultravisor-manifestdetail-force-error'))
					{
						tmpForceBtn.disabled = true;
						tmpForceBtn.textContent = 'Forcing error...';
					}

					this.pict.PictApplication.forceErrorPendingInput(pRunHash, pNodeHash,
						function (pError, pData)
						{
							if (pError || (pData && pData.Error))
							{
								let tmpMsg = (pError && pError.message) || (pData && pData.Error) || 'Request failed';
								this.pict.ContentAssignment.assignContent('#' + pResultId,
									'<div class="ultravisor-manifestdetail-result error">Error: ' + libTimingUtils.escapeHTML(tmpMsg) + '</div>');
								return;
							}

							let tmpStatus = (pData && pData.Status) || 'Errored';
							this.pict.ContentAssignment.assignContent('#' + pResultId,
								'<div class="ultravisor-manifestdetail-result error">Task force-errored — status: ' + libTimingUtils.escapeHTML(tmpStatus) + '</div>');

							// Reload the detail after a brief delay
							setTimeout(function ()
							{
								this._loadAndRenderDetail(this._CurrentRunHash);
							}.bind(this), 1500);
						}.bind(this));
				}
			}.bind(this));
	}

	// ── Timing Visualization Methods ─────────────────────────────────────
	// (moved from ManifestList — identical logic)

	_renderTaskTimeline(pManifest)
	{
		let tmpTaskResults = [];
		if (pManifest.TaskManifests && typeof pManifest.TaskManifests === 'object')
		{
			let tmpKeys = Object.keys(pManifest.TaskManifests);
			for (let k = 0; k < tmpKeys.length; k++)
			{
				let tmpEntry = pManifest.TaskManifests[tmpKeys[k]];
				tmpEntry._NodeHash = tmpKeys[k];
				tmpEntry._ComputedElapsedMs = libTimingUtils.computeTaskElapsedMs(tmpEntry);
				tmpEntry._ComputedStatus = libTimingUtils.computeTaskStatus(tmpEntry);
				tmpTaskResults.push(tmpEntry);
			}
		}

		if (tmpTaskResults.length === 0) return '';

		let tmpMaxTaskMs = 0;
		for (let i = 0; i < tmpTaskResults.length; i++)
		{
			if (tmpTaskResults[i]._ComputedElapsedMs > tmpMaxTaskMs)
			{
				tmpMaxTaskMs = tmpTaskResults[i]._ComputedElapsedMs;
			}
		}
		if (tmpMaxTaskMs <= 0) tmpMaxTaskMs = 1;

		let tmpHTML = '<div class="ultravisor-timing-card">';
		tmpHTML += '<div class="ultravisor-timing-chart">';
		tmpHTML += '<div class="ultravisor-timing-chart-title">Task Timeline</div>';

		for (let i = 0; i < tmpTaskResults.length; i++)
		{
			let tmpResult = tmpTaskResults[i];
			let tmpTaskMs = tmpResult._ComputedElapsedMs;
			let tmpTaskFormatted = libTimingUtils.formatMs(tmpTaskMs);
			let tmpTaskStatus = tmpResult._ComputedStatus.toLowerCase();
			let tmpBarClass = 'other';
			if (tmpTaskStatus === 'complete') tmpBarClass = 'complete';
			else if (tmpTaskStatus === 'error') tmpBarClass = 'error';
			else if (tmpTaskStatus === 'running') tmpBarClass = 'running';

			let tmpWidthPercent = Math.max((tmpTaskMs / tmpMaxTaskMs) * 100, 1);
			let tmpDisplayName = tmpResult.TaskTypeName || tmpResult._NodeHash || 'Task ' + (i + 1);

			let tmpRowData =
			{
				Label: libTimingUtils.escapeHTML(tmpDisplayName),
				LabelTitle: libTimingUtils.escapeHTML(tmpResult._NodeHash || ''),
				LabelStyle: '',
				BarClass: tmpBarClass,
				BarStyle: '',
				WidthPercent: tmpWidthPercent.toFixed(1),
				BarText: (tmpWidthPercent > 20) ? '<span class="ultravisor-timing-row-bar-text">' + libTimingUtils.escapeHTML(tmpDisplayName) + '</span>' : '',
				Duration: libTimingUtils.escapeHTML(tmpTaskFormatted),
				CountHTML: ''
			};
			tmpHTML += this.pict.parseTemplateByHash('Ultravisor-Timing-Row-Template', tmpRowData);
		}

		tmpHTML += '<div class="ultravisor-timing-axis"><div class="ultravisor-timing-axis-line">';
		for (let t = 0; t <= 5; t++)
		{
			tmpHTML += '<span class="ultravisor-timing-axis-tick">' + libTimingUtils.formatMs((tmpMaxTaskMs / 5) * t) + '</span>';
		}
		tmpHTML += '</div><div class="ultravisor-timing-axis-spacer"></div></div>';
		tmpHTML += '</div></div>';
		return tmpHTML;
	}

	_renderCategoryHistogram(pByCategory)
	{
		let tmpCategories = Object.keys(pByCategory);
		if (tmpCategories.length === 0) return '';

		tmpCategories.sort(function (pA, pB) { return (pByCategory[pB].TotalMs || 0) - (pByCategory[pA].TotalMs || 0); });
		let tmpMaxMs = pByCategory[tmpCategories[0]].TotalMs || 1;

		let tmpHTML = '<div class="ultravisor-timing-card"><div class="ultravisor-timing-chart">';
		tmpHTML += '<div class="ultravisor-timing-chart-title">Time by Category</div>';

		for (let i = 0; i < tmpCategories.length; i++)
		{
			let tmpCat = tmpCategories[i];
			let tmpData = pByCategory[tmpCat];
			let tmpMs = tmpData.TotalMs || 0;
			let tmpWidthPercent = Math.max((tmpMs / tmpMaxMs) * 100, 1);
			let tmpColors = libTimingUtils.CategoryColors[tmpCat] || libTimingUtils.CategoryColors['Uncategorized'];

			let tmpRowData =
			{
				Label: libTimingUtils.escapeHTML(tmpCat),
				LabelTitle: '',
				LabelStyle: 'color:' + tmpColors.text + ';',
				BarClass: '',
				BarStyle: ' background: ' + tmpColors.bar + ';',
				WidthPercent: tmpWidthPercent.toFixed(1),
				BarText: (tmpWidthPercent > 15) ? '<span class="ultravisor-timing-row-bar-text">' + libTimingUtils.formatMs(tmpMs) + '</span>' : '',
				Duration: libTimingUtils.formatMs(tmpMs),
				CountHTML: '<div class="ultravisor-timing-row-count">' + tmpData.Count + 'x</div>'
			};
			tmpHTML += this.pict.parseTemplateByHash('Ultravisor-Timing-Row-Template', tmpRowData);
		}

		tmpHTML += '</div></div>';
		return tmpHTML;
	}

	_renderTaskTypeHistogram(pByTaskType)
	{
		let tmpTypes = Object.keys(pByTaskType);
		if (tmpTypes.length === 0) return '';

		tmpTypes.sort(function (pA, pB) { return (pByTaskType[pB].TotalMs || 0) - (pByTaskType[pA].TotalMs || 0); });
		let tmpMaxMs = pByTaskType[tmpTypes[0]].TotalMs || 1;

		let tmpHTML = '<div class="ultravisor-timing-card"><div class="ultravisor-timing-chart">';
		tmpHTML += '<div class="ultravisor-timing-chart-title">Time by Task Type</div>';

		for (let i = 0; i < tmpTypes.length; i++)
		{
			let tmpType = tmpTypes[i];
			let tmpData = pByTaskType[tmpType];
			let tmpMs = tmpData.TotalMs || 0;
			let tmpWidthPercent = Math.max((tmpMs / tmpMaxMs) * 100, 1);
			let tmpCategory = tmpData.Category || 'Uncategorized';
			let tmpColors = libTimingUtils.CategoryColors[tmpCategory] || libTimingUtils.CategoryColors['Uncategorized'];
			let tmpDisplayName = tmpData.Name || tmpType;

			let tmpRowData =
			{
				Label: libTimingUtils.escapeHTML(tmpDisplayName),
				LabelTitle: libTimingUtils.escapeHTML(tmpType),
				LabelStyle: '',
				BarClass: '',
				BarStyle: ' background: ' + tmpColors.bar + ';',
				WidthPercent: tmpWidthPercent.toFixed(1),
				BarText: (tmpWidthPercent > 15) ? '<span class="ultravisor-timing-row-bar-text">' + libTimingUtils.formatMs(tmpMs) + '</span>' : '',
				Duration: libTimingUtils.formatMs(tmpMs),
				CountHTML: '<div class="ultravisor-timing-row-count">' + tmpData.Count + 'x</div>'
			};
			tmpHTML += this.pict.parseTemplateByHash('Ultravisor-Timing-Row-Template', tmpRowData);
		}

		tmpHTML += '</div></div>';
		return tmpHTML;
	}
}

module.exports = UltravisorManifestDetailView;

module.exports.default_configuration = _ViewConfiguration;

},{"../Ultravisor-TimingUtils.js":244,"pict-view":239}],265:[function(require,module,exports){
const libPictView = require('pict-view');

const libTimingUtils = require('../Ultravisor-TimingUtils.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-ManifestList",

	DefaultRenderable: "Ultravisor-ManifestList-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-manifestlist {
			padding: 2em;
			max-width: 1400px;
			margin: 0 auto;
		}
		.ultravisor-manifestlist-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1.5em;
			padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-manifestlist-header h1 {
			margin: 0;
			font-size: 2em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.ultravisor-manifest-table {
			width: 100%;
			border-collapse: collapse;
		}
		.ultravisor-manifest-table th {
			background-color: var(--uv-bg-surface);
		}
		.ultravisor-manifest-table tr:hover td {
			background-color: #1a2744;
		}
		.ultravisor-manifest-status {
			display: inline-block;
			padding: 0.15em 0.5em;
			border-radius: 3px;
			font-size: 0.8em;
			font-weight: 600;
		}
		.ultravisor-manifest-status.complete {
			background-color: #2e7d32;
			color: #c8e6c9;
		}
		.ultravisor-manifest-status.running,
		.ultravisor-manifest-status.inprogress {
			background-color: var(--uv-info);
			color: var(--uv-text-heading);
		}
		.ultravisor-manifest-status.error {
			background-color: #c62828;
			color: #ffcdd2;
		}
		.ultravisor-manifest-status.failed {
			background-color: #b71c1c;
			color: #ffcdd2;
		}
		.ultravisor-manifest-status.stalled {
			background-color: var(--theme-color-status-warning, #b45309);
			color: #fef3c7;
		}
		.ultravisor-manifest-status.waiting,
		.ultravisor-manifest-status.waitingforinput {
			background-color: var(--uv-warning);
			color: #fff9c4;
		}
		.ultravisor-manifest-status.beacon-waiting {
			background-color: #1a3a4a;
			color: #5a9ecb;
		}
		.ultravisor-manifest-status.abandoned {
			background-color: #3a3a3a;
			color: var(--theme-color-text-muted, #999);
		}

		/* Filter tabs */
		.ultravisor-manifest-filters {
			display: flex;
			gap: 0;
			margin-bottom: 1em;
			border-bottom: 2px solid var(--uv-border-subtle);
		}
		.ultravisor-manifest-filter-tab {
			padding: 0.5em 1em;
			cursor: pointer;
			font-size: 0.85em;
			font-weight: 600;
			color: var(--uv-text-secondary);
			border-bottom: 2px solid transparent;
			margin-bottom: -2px;
			transition: color 0.15s, border-color 0.15s;
			user-select: none;
		}
		.ultravisor-manifest-filter-tab:hover {
			color: var(--uv-text);
		}
		.ultravisor-manifest-filter-tab.active {
			color: var(--uv-brand);
			border-bottom-color: var(--uv-brand);
		}
		.ultravisor-manifest-filter-count {
			font-weight: 400;
			opacity: 0.7;
			margin-left: 0.3em;
		}

		/* Action buttons in rows */
		.ultravisor-manifest-actions {
			display: flex;
			gap: 0.35em;
			flex-wrap: wrap;
		}

		/* Inline awaiting detail row */
		.ultravisor-manifest-awaiting-row td {
			padding: 0 !important;
			border-top: none !important;
		}
		.ultravisor-manifest-awaiting-detail {
			padding: 0.75em 1em;
			background: var(--uv-bg-base);
		}
		.ultravisor-manifest-awaiting-task {
			background: var(--uv-bg-surface);
			border-radius: 4px;
			padding: 0.75em;
			margin-bottom: 0.5em;
		}
		.ultravisor-manifest-awaiting-task:last-child {
			margin-bottom: 0;
		}
		.ultravisor-manifest-beacon-status {
			display: flex;
			align-items: center;
			gap: 0.5em;
		}
		.ultravisor-manifest-waiting-indicator {
			display: inline-block;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: var(--uv-info);
			animation: uv-manifest-waiting-pulse 1.5s ease-in-out infinite;
			flex-shrink: 0;
		}
		@keyframes uv-manifest-waiting-pulse {
			0%, 100% { opacity: 1; transform: scale(1); }
			50% { opacity: 0.4; transform: scale(0.7); }
		}
		.ultravisor-manifest-beacon-prompt {
			color: var(--uv-text-secondary);
			font-size: 0.9em;
		}
		.ultravisor-manifest-input-prompt {
			color: #d4884a;
			font-size: 0.9em;
			margin-bottom: 0.5em;
		}
		.ultravisor-manifest-input-address {
			font-size: 0.8em;
			color: var(--uv-text-tertiary);
			margin-bottom: 0.5em;
		}
		.ultravisor-manifest-input-form {
			display: flex;
			gap: 0.5em;
			align-items: center;
		}
		.ultravisor-manifest-input-form input {
			flex: 1;
			min-width: 150px;
		}
		.ultravisor-manifest-input-submit {
			padding: 0.4em 0.8em;
			background: #3a2a1a;
			color: #d4884a;
			border: 1px solid #5a3a1a;
			border-radius: 4px;
			cursor: pointer;
			font-weight: 600;
			font-size: 0.85em;
		}
		.ultravisor-manifest-input-submit:hover {
			background: #4a3a2a;
		}
		.ultravisor-manifest-force-error {
			padding: 0.35em 0.7em;
			background: #3a1a1a;
			color: #c44e4e;
			border: 1px solid #5a2a2a;
			border-radius: 4px;
			cursor: pointer;
			font-size: 0.8em;
			margin-top: 0.5em;
		}
		.ultravisor-manifest-force-error:hover {
			background: #4a2020;
		}
		.ultravisor-manifest-elapsed-hint {
			font-size: 0.75em;
			color: var(--uv-text-tertiary);
			margin-top: 0.25em;
		}
		.ultravisor-manifest-result {
			margin-top: 0.5em;
			padding: 0.4em 0.6em;
			border-radius: 3px;
			font-size: 0.85em;
		}
		.ultravisor-manifest-result.success {
			background: #1a3a1a;
			color: #5ab88a;
		}
		.ultravisor-manifest-result.error {
			background: #3a1a1a;
			color: #c44e4e;
		}

	`,

	Templates:
	[
		{
			Hash: "Ultravisor-ManifestList-Template",
			Template: /*html*/`
<div class="ultravisor-manifestlist">
	<div class="ultravisor-manifestlist-header">
		<h1>Execution Manifests</h1>
		<button class="ultravisor-btn ultravisor-btn-secondary" onclick="{~P~}.PictApplication.showView('Ultravisor-ManifestList')">Refresh</button>
		<button class="ultravisor-btn ultravisor-btn-delete" onclick="{~P~}.views['Ultravisor-ManifestList'].clearStaleRuns()" style="font-size:0.8em;">Clear Stale</button>
	</div>
	<div id="Ultravisor-ManifestList-Filters"></div>
	<div id="Ultravisor-ManifestList-Body"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-ManifestList-Content",
			TemplateHash: "Ultravisor-ManifestList-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorManifestListView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._CurrentFilter = 'all';
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.PictApplication.loadManifests(
			function ()
			{
				this.renderManifestTable();
			}.bind(this));

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Set the active filter and re-render the table.
	 * Called from filter tabs and from route navigation.
	 */
	setFilter(pFilter)
	{
		this._CurrentFilter = pFilter || 'all';
		this.renderManifestTable();
	}

	/**
	 * Set filter from a route parameter (e.g. /Manifests/waiting).
	 */
	setFilterFromRoute(pFilter)
	{
		this._CurrentFilter = pFilter || 'all';
	}

	// ── Filter Helpers ──

	// Normalize a Status string to a lowercased canonical bucket key.
	// Accepts both legacy (Pending/Running/WaitingForInput) and the
	// canonical 7-state enum (Queued/In Progress/Waiting/Stalled/Failed)
	// emitted by UV 1.0.34+.  Returns one of:
	//   'running' | 'waiting' | 'complete' | 'error' | 'failed'
	//   | 'stalled' | 'abandoned' | 'queued' | ''
	_normalizeStatusKey(pStatus)
	{
		let tmpRaw = (pStatus || '').toLowerCase().replace(/\s+/g, '');
		switch (tmpRaw)
		{
			case 'pending':
			case 'queued':
				return 'queued';
			case 'running':
			case 'inprogress':
				return 'running';
			case 'waitingforinput':
			case 'waiting':
				return 'waiting';
			case 'complete':
			case 'completed':
				return 'complete';
			case 'error':
				return 'error';
			case 'failed':
				return 'failed';
			case 'stalled':
				return 'stalled';
			case 'abandoned':
				return 'abandoned';
			default:
				return tmpRaw;
		}
	}

	_matchesFilter(pStatus)
	{
		if (this._CurrentFilter === 'all') return true;
		let tmpKey = this._normalizeStatusKey(pStatus);
		switch (this._CurrentFilter)
		{
			case 'running': return tmpKey === 'running';
			case 'waiting': return tmpKey === 'waiting';
			case 'complete': return tmpKey === 'complete';
			case 'error': return tmpKey === 'error' || tmpKey === 'failed';
			case 'stalled': return tmpKey === 'stalled';
			case 'abandoned': return tmpKey === 'abandoned';
			default: return true;
		}
	}

	_countByFilter(pManifests, pFilter)
	{
		if (pFilter === 'all') return pManifests.length;
		let tmpCount = 0;
		for (let i = 0; i < pManifests.length; i++)
		{
			let tmpKey = this._normalizeStatusKey(pManifests[i].Status);
			switch (pFilter)
			{
				case 'running': if (tmpKey === 'running') tmpCount++; break;
				case 'waiting': if (tmpKey === 'waiting') tmpCount++; break;
				case 'complete': if (tmpKey === 'complete') tmpCount++; break;
				case 'error': if (tmpKey === 'error' || tmpKey === 'failed') tmpCount++; break;
				case 'stalled': if (tmpKey === 'stalled') tmpCount++; break;
				case 'abandoned': if (tmpKey === 'abandoned') tmpCount++; break;
			}
		}
		return tmpCount;
	}

	_isBeaconTask(pTask)
	{
		if (pTask.ResumeEventName && pTask.ResumeEventName !== 'ValueInputComplete')
		{
			return true;
		}
		return false;
	}

	_formatElapsed(pTimestamp)
	{
		if (!pTimestamp) return '';
		let tmpElapsedMs = Date.now() - new Date(pTimestamp).getTime();
		if (tmpElapsedMs < 1000) return 'just now';
		if (tmpElapsedMs < 60000) return Math.floor(tmpElapsedMs / 1000) + 's ago';
		if (tmpElapsedMs < 3600000) return Math.floor(tmpElapsedMs / 60000) + 'm ' + Math.floor((tmpElapsedMs % 60000) / 1000) + 's ago';
		return Math.floor(tmpElapsedMs / 3600000) + 'h ' + Math.floor((tmpElapsedMs % 3600000) / 60000) + 'm ago';
	}

	// ── Table Rendering ──

	renderManifestTable()
	{
		let tmpManifests = this.pict.AppData.Ultravisor.Manifests;
		let tmpGlobalRef = '_Pict';
		let tmpViewRef = tmpGlobalRef + ".views['Ultravisor-ManifestList']";

		// Render filter tabs
		this._renderFilterTabs(tmpManifests || [], tmpViewRef);

		if (!tmpManifests || tmpManifests.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-ManifestList-Body',
				'<div class="ultravisor-empty-message">No execution manifests recorded yet. Execute a task or operation to see results here.</div>');
			return;
		}

		// Sort newest first by StartTime
		tmpManifests.sort(function (pA, pB)
		{
			let tmpTimeA = pA.StartTime ? new Date(pA.StartTime).getTime() : 0;
			let tmpTimeB = pB.StartTime ? new Date(pB.StartTime).getTime() : 0;
			return tmpTimeB - tmpTimeA;
		});

		let tmpHTML = '<table class="ultravisor-manifest-table">';
		tmpHTML += '<thead><tr><th>Operation</th><th>Status</th><th>Elapsed</th><th>Started</th><th>Completed</th><th>Actions</th></tr></thead>';
		tmpHTML += '<tbody>';

		let tmpRowCount = 0;

		for (let i = 0; i < tmpManifests.length; i++)
		{
			let tmpManifest = tmpManifests[i];
			let tmpStatus = tmpManifest.Status || 'Unknown';

			// Apply filter
			if (!this._matchesFilter(tmpStatus))
			{
				continue;
			}

			tmpRowCount++;
			let tmpRunHash = tmpManifest.Hash || '';
			let tmpEscHash = tmpRunHash.replace(/'/g, "\\'");
			let tmpEscOpHash = (tmpManifest.OperationHash || '').replace(/'/g, "\\'");
			// Normalize legacy + canonical Status names to a stable CSS
			// class name. Phase 2 added 'stalled' and 'failed' on top of
			// the previous set; Pending/Running/WaitingForInput legacy
			// strings still arrive from older persisted manifests.
			let tmpStatusClass = this._normalizeStatusKey(tmpStatus);
			let tmpKnownClasses = ['complete', 'running', 'queued', 'error',
				'failed', 'stalled', 'waiting', 'waitingforinput', 'abandoned'];
			if (tmpKnownClasses.indexOf(tmpStatusClass) < 0)
			{
				tmpStatusClass = '';
			}

			// Format elapsed time — compute from timestamps if ElapsedMs is missing
			let tmpElapsedMs = tmpManifest.ElapsedMs;
			if (tmpElapsedMs == null && tmpManifest.StartTime && tmpManifest.StopTime)
			{
				tmpElapsedMs = new Date(tmpManifest.StopTime).getTime() - new Date(tmpManifest.StartTime).getTime();
			}
			let tmpElapsed = '';
			if (tmpElapsedMs != null && tmpElapsedMs >= 0)
			{
				tmpElapsed = (tmpElapsedMs === 0) ? '< 1ms' : libTimingUtils.formatMs(tmpElapsedMs);
			}

			// Format timestamps with dayJS
			let tmpStarted = tmpManifest.StartTime
				? this.fable.Dates.dayJS(tmpManifest.StartTime).format('YYYY-MM-DD HH:mm:ss')
				: '';
			let tmpCompleted = tmpManifest.StopTime
				? this.fable.Dates.dayJS(tmpManifest.StopTime).format('YYYY-MM-DD HH:mm:ss')
				: '';

			// Show operation name when available, fall back to hash
			let tmpOperationLabel = tmpManifest.OperationName || tmpManifest.OperationHash || '';

			// Determine status display.
			// Friendly labels: surface 'In Progress' instead of the
			// raw 'Running' that older persisted manifests still
			// carry, and 'Stalled' as its own pill.
			let tmpStatusLabel = tmpStatus;
			if (tmpStatusClass === 'running') { tmpStatusLabel = 'In Progress'; }
			else if (tmpStatusClass === 'queued') { tmpStatusLabel = 'Queued'; }
			else if (tmpStatusClass === 'waiting' || tmpStatusClass === 'waitingforinput') { tmpStatusLabel = 'Waiting'; }
			else if (tmpStatusClass === 'failed') { tmpStatusLabel = 'Failed'; }
			else if (tmpStatusClass === 'stalled') { tmpStatusLabel = 'Stalled'; }
			let tmpIsLive = tmpManifest.Live || false;
			let tmpIsWaiting = (tmpStatusClass === 'waitingforinput' || tmpStatusClass === 'waiting');
			let tmpIsRunning = (tmpStatusClass === 'running');

			if (tmpIsWaiting)
			{
				// Check if all tasks are beacon tasks
				let tmpWaitingTasks = tmpManifest.WaitingTasks || {};
				let tmpNodeHashes = Object.keys(tmpWaitingTasks);
				let tmpAllBeacon = tmpNodeHashes.length > 0;
				for (let k = 0; k < tmpNodeHashes.length; k++)
				{
					if (!this._isBeaconTask(tmpWaitingTasks[tmpNodeHashes[k]]))
					{
						tmpAllBeacon = false;
						break;
					}
				}
				if (tmpAllBeacon)
				{
					tmpStatusLabel = 'Waiting for Beacon';
					tmpStatusClass = 'beacon-waiting';
				}
				else
				{
					tmpStatusLabel = 'Waiting for Input';
					tmpStatusClass = 'waitingforinput';
				}
			}

			tmpHTML += '<tr>';
			tmpHTML += '<td>' + libTimingUtils.escapeHTML(tmpOperationLabel) + '</td>';
			tmpHTML += '<td><span class="ultravisor-manifest-status ' + tmpStatusClass + '">' + libTimingUtils.escapeHTML(tmpStatusLabel) + '</span></td>';
			tmpHTML += '<td>' + tmpElapsed + '</td>';
			tmpHTML += '<td>' + libTimingUtils.escapeHTML(tmpStarted) + '</td>';
			tmpHTML += '<td>' + libTimingUtils.escapeHTML(tmpCompleted) + '</td>';

			// Actions column
			tmpHTML += '<td><div class="ultravisor-manifest-actions">';

			// Watch button — only for live (in-memory) running/waiting operations
			if (tmpIsLive && (tmpIsRunning || tmpIsWaiting))
			{
				tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-execute" onclick="' + tmpGlobalRef + '.PictApplication.watchExecution(\'' + tmpEscHash + '\', \'' + tmpEscOpHash + '\')">Watch</button>';
			}

			// Awaiting expand button — only for live waiting operations with tasks
			if (tmpIsLive && tmpIsWaiting && tmpManifest.WaitingTasks && Object.keys(tmpManifest.WaitingTasks).length > 0)
			{
				tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-secondary" onclick="' + tmpViewRef + '.toggleAwaitingDetail(\'' + tmpEscHash + '\')">Awaiting</button>';
			}

			// Abandon button for non-terminal statuses (Stalled and
			// Failed are terminal too — no point in abandoning them).
			if (tmpStatusClass !== 'complete' && tmpStatusClass !== 'abandoned'
				&& tmpStatusClass !== 'failed' && tmpStatusClass !== 'stalled')
			{
				tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-delete" onclick="' + tmpViewRef + '.abandonRun(\'' + tmpEscHash + '\')">Abandon</button>';
			}

			// Retry button for Stalled and Failed runs.  Re-dispatches the
			// stuck node only — upstream outputs are preserved.  No effect
			// on Complete / Abandoned (nothing to retry) or active runs
			// (engine rejects retry while In Progress / Waiting).
			if (tmpStatusClass === 'stalled' || tmpStatusClass === 'failed')
			{
				tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-execute" onclick="' + tmpViewRef + '.retryRun(\'' + tmpEscHash + '\')">Retry</button>';
			}

			tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-edit" onclick="' + tmpGlobalRef + '.PictApplication.navigateTo(\'/Manifests/detail/' + tmpEscHash + '\')">Details</button>';
			tmpHTML += '</div></td>';
			tmpHTML += '</tr>';

			// Inline awaiting detail row (hidden by default, live runs only)
			if (tmpIsLive && tmpIsWaiting && tmpManifest.WaitingTasks && Object.keys(tmpManifest.WaitingTasks).length > 0)
			{
				tmpHTML += '<tr class="ultravisor-manifest-awaiting-row" id="awaiting-row-' + tmpRunHash + '" style="display:none">';
				tmpHTML += '<td colspan="6">';
				tmpHTML += this._renderAwaitingDetail(tmpManifest, tmpViewRef);
				tmpHTML += '</td></tr>';
			}
		}

		if (tmpRowCount === 0)
		{
			tmpHTML += '<tr><td colspan="6" style="text-align:center;color:var(--uv-text-secondary);padding:2em;">No manifests match this filter.</td></tr>';
		}

		tmpHTML += '</tbody></table>';
		this.pict.ContentAssignment.assignContent('#Ultravisor-ManifestList-Body', tmpHTML);
	}

	_renderFilterTabs(pManifests, pViewRef)
	{
		let tmpFilters = ['all', 'running', 'waiting', 'stalled', 'complete', 'error', 'abandoned'];
		let tmpLabels = { all: 'All', running: 'In Progress', waiting: 'Waiting', stalled: 'Stalled', complete: 'Complete', error: 'Error', abandoned: 'Abandoned' };

		let tmpHTML = '<div class="ultravisor-manifest-filters">';
		for (let i = 0; i < tmpFilters.length; i++)
		{
			let tmpFilter = tmpFilters[i];
			let tmpCount = this._countByFilter(pManifests, tmpFilter);
			let tmpActiveClass = (this._CurrentFilter === tmpFilter) ? ' active' : '';
			tmpHTML += '<div class="ultravisor-manifest-filter-tab' + tmpActiveClass + '" onclick="' + pViewRef + '.setFilter(\'' + tmpFilter + '\')">';
			tmpHTML += tmpLabels[tmpFilter];
			tmpHTML += '<span class="ultravisor-manifest-filter-count">(' + tmpCount + ')</span>';
			tmpHTML += '</div>';
		}
		tmpHTML += '</div>';

		this.pict.ContentAssignment.assignContent('#Ultravisor-ManifestList-Filters', tmpHTML);
	}

	// ── Retry Action ──

	retryRun(pRunHash)
	{
		this.pict.views.Modal.confirm('Retry this run from its failed/stalled node? Upstream node outputs are preserved; only the stuck node and its downstream branch re-run.', { confirmLabel: 'Retry' }).then(
			function (pConfirmed)
			{
				if (!pConfirmed) return;
				this.pict.PictApplication.retryRun(pRunHash,
					function (pError, pData)
					{
						if (pError)
						{
							this.pict.views.Modal.toast('Failed to retry run: ' + (pError.message || 'Unknown error'), { type: 'error' });
							return;
						}
						this.pict.views.Modal.toast('Run re-dispatched.', { type: 'success' });
						this._pollAfterRetry(pRunHash);
					}.bind(this));
			}.bind(this));
	}

	// Reload the manifest list every second for ~12 seconds after a
	// retry so the user sees state progress (Stalled → Waiting →
	// Complete).  Stops early when the targeted run reaches a NEW
	// terminal state (the engine takes a tick or two to transition
	// out of the pre-retry Stalled, so we record that as the baseline
	// and only stop on a *changed* terminal status).
	_pollAfterRetry(pRunHash)
	{
		let tmpTicks = 0;
		let tmpMaxTicks = 12;
		let tmpInitialStatusKey = null;
		let tmpInterval = setInterval(function ()
		{
			tmpTicks++;
			this.pict.PictApplication.loadManifests(
				function ()
				{
					this.renderManifestTable();
					let tmpManifests = this.pict.AppData.Ultravisor.Manifests || [];
					let tmpRow = null;
					for (let i = 0; i < tmpManifests.length; i++)
					{
						if (tmpManifests[i].Hash === pRunHash) { tmpRow = tmpManifests[i]; break; }
					}
					if (tmpRow)
					{
						let tmpKey = this._normalizeStatusKey(tmpRow.Status);
						if (tmpInitialStatusKey === null) { tmpInitialStatusKey = tmpKey; }
						let tmpIsTerminal = (tmpKey === 'complete' || tmpKey === 'failed'
							|| tmpKey === 'stalled' || tmpKey === 'error'
							|| tmpKey === 'abandoned');
						if (tmpIsTerminal && tmpKey !== tmpInitialStatusKey)
						{
							clearInterval(tmpInterval);
						}
					}
					if (tmpTicks >= tmpMaxTicks)
					{
						clearInterval(tmpInterval);
					}
				}.bind(this));
		}.bind(this), 1000);
	}

	// ── Abandon Actions ──

	abandonRun(pRunHash)
	{
		this.pict.views.Modal.confirm('Abandon this run? It will be marked as Abandoned and cannot be resumed.', { confirmLabel: 'Abandon', dangerous: true }).then(
			function (pConfirmed)
			{
				if (pConfirmed)
				{
					this.pict.PictApplication.abandonRun(pRunHash,
						function (pError, pData)
						{
							if (pError)
							{
								this.pict.views.Modal.toast('Failed to abandon run: ' + (pError.message || 'Unknown error'), { type: 'error' });
								return;
							}
							this.pict.views.Modal.toast('Run abandoned.', { type: 'success' });
							this.pict.PictApplication.loadManifests(
								function ()
								{
									this.renderManifestTable();
								}.bind(this));
						}.bind(this));
				}
			}.bind(this));
	}

	clearStaleRuns()
	{
		this.pict.views.Modal.confirm('Abandon all stale runs (non-live Waiting/Running)? This cannot be undone.', { confirmLabel: 'Clear All', dangerous: true }).then(
			function (pConfirmed)
			{
				if (pConfirmed)
				{
					this.pict.PictApplication.abandonStaleRuns(
						function (pError, pData)
						{
							if (pError)
							{
								this.pict.views.Modal.toast('Failed to clear stale runs: ' + (pError.message || 'Unknown error'), { type: 'error' });
								return;
							}
							let tmpCount = (pData && pData.AbandonedCount) || 0;
							this.pict.views.Modal.toast('Abandoned ' + tmpCount + ' stale run(s).', { type: 'success' });
							this.pict.PictApplication.loadManifests(
								function ()
								{
									this.renderManifestTable();
								}.bind(this));
						}.bind(this));
				}
			}.bind(this));
	}

	// ── Inline Awaiting ──

	_renderAwaitingDetail(pManifest, pViewRef)
	{
		let tmpWaitingTasks = pManifest.WaitingTasks || {};
		let tmpNodeHashes = Object.keys(tmpWaitingTasks);
		let tmpRunHash = pManifest.Hash || '';
		let tmpEscRunHash = tmpRunHash.replace(/'/g, "\\'");

		let tmpHTML = '<div class="ultravisor-manifest-awaiting-detail">';

		for (let j = 0; j < tmpNodeHashes.length; j++)
		{
			let tmpNodeHash = tmpNodeHashes[j];
			let tmpEscNodeHash = tmpNodeHash.replace(/'/g, "\\'");
			let tmpTask = tmpWaitingTasks[tmpNodeHash];
			let tmpResultId = 'manifest-result-' + tmpRunHash.replace(/[^a-zA-Z0-9]/g, '') + '-' + tmpNodeHash.replace(/[^a-zA-Z0-9]/g, '');

			tmpHTML += '<div class="ultravisor-manifest-awaiting-task">';

			if (this._isBeaconTask(tmpTask))
			{
				// Beacon task: waiting indicator + force error
				tmpHTML += '<div class="ultravisor-manifest-beacon-status">';
				tmpHTML += '<span class="ultravisor-manifest-waiting-indicator"></span>';
				tmpHTML += '<span class="ultravisor-manifest-beacon-prompt">' + libTimingUtils.escapeHTML(tmpTask.PromptMessage || 'Waiting for beacon to complete') + '</span>';
				tmpHTML += '</div>';
				if (tmpTask.Timestamp)
				{
					tmpHTML += '<div class="ultravisor-manifest-elapsed-hint">Dispatched ' + libTimingUtils.escapeHTML(this._formatElapsed(tmpTask.Timestamp)) + '</div>';
				}
				tmpHTML += '<button class="ultravisor-manifest-force-error" onclick="' + pViewRef + '.forceError(\'' + tmpEscRunHash + '\', \'' + tmpEscNodeHash + '\', \'' + tmpResultId + '\')">Force Error</button>';
			}
			else
			{
				// Value-input task: prompt + input + submit
				let tmpInputId = 'manifest-input-' + tmpRunHash.replace(/[^a-zA-Z0-9]/g, '') + '-' + tmpNodeHash.replace(/[^a-zA-Z0-9]/g, '');

				tmpHTML += '<div class="ultravisor-manifest-input-prompt">' + libTimingUtils.escapeHTML(tmpTask.PromptMessage || 'Enter a value') + '</div>';
				if (tmpTask.OutputAddress)
				{
					tmpHTML += '<div class="ultravisor-manifest-input-address">Target: <code>' + libTimingUtils.escapeHTML(tmpTask.OutputAddress) + '</code></div>';
				}
				tmpHTML += '<div class="ultravisor-manifest-input-form">';
				tmpHTML += '<input type="text" id="' + tmpInputId + '" placeholder="Enter value..." onkeydown="if(event.key===\'Enter\'){' + pViewRef + '.submitInput(\'' + tmpEscRunHash + '\', \'' + tmpEscNodeHash + '\', \'' + tmpInputId + '\', \'' + tmpResultId + '\');}" />';
				tmpHTML += '<button class="ultravisor-manifest-input-submit" onclick="' + pViewRef + '.submitInput(\'' + tmpEscRunHash + '\', \'' + tmpEscNodeHash + '\', \'' + tmpInputId + '\', \'' + tmpResultId + '\')">Submit</button>';
				tmpHTML += '</div>';
			}

			tmpHTML += '<div id="' + tmpResultId + '"></div>';
			tmpHTML += '</div>';
		}

		tmpHTML += '</div>';
		return tmpHTML;
	}

	toggleAwaitingDetail(pRunHash)
	{
		let tmpRow = document.getElementById('awaiting-row-' + pRunHash);
		if (tmpRow)
		{
			tmpRow.style.display = (tmpRow.style.display === 'none') ? '' : 'none';
		}
	}

	submitInput(pRunHash, pNodeHash, pInputId, pResultId)
	{
		let tmpInputEl = document.getElementById(pInputId);
		if (!tmpInputEl) return;

		let tmpValue = tmpInputEl.value;
		tmpInputEl.disabled = true;
		let tmpButton = tmpInputEl.parentElement.querySelector('.ultravisor-manifest-input-submit');
		if (tmpButton)
		{
			tmpButton.disabled = true;
			tmpButton.textContent = 'Submitting...';
		}

		this.pict.PictApplication.submitPendingInput(pRunHash, pNodeHash, tmpValue,
			function (pError, pData)
			{
				if (pError || (pData && pData.Error))
				{
					let tmpMsg = (pError && pError.message) || (pData && pData.Error) || 'Request failed';
					this.pict.ContentAssignment.assignContent('#' + pResultId,
						'<div class="ultravisor-manifest-result error">Error: ' + libTimingUtils.escapeHTML(tmpMsg) + '</div>');
					tmpInputEl.disabled = false;
					if (tmpButton) { tmpButton.disabled = false; tmpButton.textContent = 'Submit'; }
					return;
				}

				let tmpStatus = (pData && pData.Status) || 'Submitted';
				this.pict.ContentAssignment.assignContent('#' + pResultId,
					'<div class="ultravisor-manifest-result success">Input submitted — status: ' + libTimingUtils.escapeHTML(tmpStatus) + '</div>');

				setTimeout(function ()
				{
					this.pict.PictApplication.loadManifests(function () { this.renderManifestTable(); }.bind(this));
				}.bind(this), 1500);
			}.bind(this));
	}

	forceError(pRunHash, pNodeHash, pResultId)
	{
		this.pict.views.Modal.confirm('Force this task to error?\nThe operation will continue on the Error path.', { confirmLabel: 'Force Error', dangerous: true }).then(
			function (pConfirmed)
			{
				if (pConfirmed)
				{
					this._doForceError(pRunHash, pNodeHash, pResultId);
				}
			}.bind(this));
	}

	_doForceError(pRunHash, pNodeHash, pResultId)
	{
		this.pict.PictApplication.forceErrorPendingInput(pRunHash, pNodeHash,
			function (pError, pData)
			{
				if (pError || (pData && pData.Error))
				{
					let tmpMsg = (pError && pError.message) || (pData && pData.Error) || 'Request failed';
					this.pict.ContentAssignment.assignContent('#' + pResultId,
						'<div class="ultravisor-manifest-result error">Error: ' + libTimingUtils.escapeHTML(tmpMsg) + '</div>');
					return;
				}

				let tmpStatus = (pData && pData.Status) || 'Errored';
				this.pict.ContentAssignment.assignContent('#' + pResultId,
					'<div class="ultravisor-manifest-result error">Task force-errored — status: ' + libTimingUtils.escapeHTML(tmpStatus) + '</div>');

				setTimeout(function ()
				{
					this.pict.PictApplication.loadManifests(function () { this.renderManifestTable(); }.bind(this));
				}.bind(this), 1500);
			}.bind(this));
	}

}

module.exports = UltravisorManifestListView;

module.exports.default_configuration = _ViewConfiguration;

},{"../Ultravisor-TimingUtils.js":244,"pict-view":239}],266:[function(require,module,exports){
/**
 * Ultravisor Operation Description Editor
 *
 * A pict-section-markdowneditor subclass for editing the operation
 * description in the Flow Editor's Information tab.
 *
 * Content is stored in AppData.Ultravisor.OperationDescriptionSegments
 * as a single-segment array: [{ Content: '...' }].
 */

const libPictSectionMarkdownEditor = require('pict-section-markdowneditor');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-OperationDescriptionEditor",

	DefaultRenderable: "MarkdownEditor-Wrap",
	TargetElementAddress: "#Ultravisor-FlowEditor-DescriptionEditor",

	ContentDataAddress: "AppData.Ultravisor.OperationDescriptionSegments",

	ReadOnly: false,
	EnableRichPreview: true,
	DefaultPreviewMode: "off",

	AutoRender: false,

	Renderables:
	[
		{
			RenderableHash: "MarkdownEditor-Wrap",
			TemplateHash: "MarkdownEditor-Container",
			DestinationAddress: "#Ultravisor-FlowEditor-DescriptionEditor"
		}
	]
};

class UltravisorOperationDescriptionEditor extends libPictSectionMarkdownEditor
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	customConfigureExtensions(pExtensions, pSegmentIndex)
	{
		// Enable line wrapping for description text
		if (this._codeMirrorModules && this._codeMirrorModules.EditorView)
		{
			pExtensions.push(this._codeMirrorModules.EditorView.lineWrapping);
		}
		return pExtensions;
	}

	onContentChange(pSegmentIndex, pContent)
	{
		// Auto-sync to operation data on every change
		let tmpOp = this.pict.AppData.Ultravisor.CurrentEditOperation;
		if (tmpOp)
		{
			tmpOp.Description = pContent;
		}
	}
}

module.exports = UltravisorOperationDescriptionEditor;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-section-markdowneditor":143}],267:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-OperationEdit",

	DefaultRenderable: "Ultravisor-OperationEdit-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-operationedit {
			padding: 2em;
			max-width: 800px;
			margin: 0 auto;
		}
		.ultravisor-operationedit-header {
			margin-bottom: 1.5em;
			padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-operationedit-header h1 {
			margin: 0;
			font-size: 2em;
			font-weight: 300;
			color: var(--uv-text);
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-OperationEdit-Template",
			Template: /*html*/`
<div class="ultravisor-operationedit">
	<div class="ultravisor-operationedit-header">
		<h1 id="Ultravisor-OperationEdit-Title">New Operation</h1>
	</div>
	<div id="Ultravisor-OperationEdit-Form"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-OperationEdit-Content",
			TemplateHash: "Ultravisor-OperationEdit-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorOperationEditView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		let tmpOp = this.pict.AppData.Ultravisor.CurrentEditOperation;
		if (!tmpOp)
		{
			tmpOp =
			{
				Hash: '', Name: '', Description: '',
				Graph: { Nodes: [], Connections: [], ViewState: {} }
			};
			this.pict.AppData.Ultravisor.CurrentEditOperation = tmpOp;
		}

		let tmpIsNew = !tmpOp.Hash;
		let tmpTitleEl = document.getElementById('Ultravisor-OperationEdit-Title');
		if (tmpTitleEl)
		{
			tmpTitleEl.textContent = tmpIsNew ? 'New Operation' : ('Edit Operation: ' + (tmpOp.Name || tmpOp.Hash));
		}

		this.renderForm();

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	escapeAttr(pValue)
	{
		if (!pValue) return '';
		return String(pValue).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	escapeHTML(pValue)
	{
		if (!pValue) return '';
		return String(pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	renderForm()
	{
		let tmpOp = this.pict.AppData.Ultravisor.CurrentEditOperation;
		let tmpIsNew = !tmpOp.Hash;
		let tmpGlobalRef = '_Pict';
		let tmpViewRef = tmpGlobalRef + ".views['Ultravisor-OperationEdit']";

		let tmpNodeCount = (tmpOp.Graph && tmpOp.Graph.Nodes) ? tmpOp.Graph.Nodes.length : 0;

		let tmpHTML = '';

		if (!tmpIsNew)
		{
			tmpHTML += '<div class="ultravisor-form-group"><label>Hash</label>';
			tmpHTML += '<input type="text" id="Ultravisor-OperationEdit-Hash" value="' + this.escapeAttr(tmpOp.Hash) + '" readonly></div>';
		}

		tmpHTML += '<div class="ultravisor-form-group"><label>Name</label>';
		tmpHTML += '<input type="text" id="Ultravisor-OperationEdit-Name" value="' + this.escapeAttr(tmpOp.Name || '') + '"></div>';

		tmpHTML += '<div class="ultravisor-form-group"><label>Description</label>';
		tmpHTML += '<textarea id="Ultravisor-OperationEdit-Description">' + this.escapeHTML(tmpOp.Description || '') + '</textarea></div>';

		if (!tmpIsNew)
		{
			tmpHTML += '<div class="ultravisor-form-group"><label>Graph</label>';
			tmpHTML += '<p style="color:var(--uv-text-secondary);">' + tmpNodeCount + ' node' + (tmpNodeCount !== 1 ? 's' : '') + ' in graph. Use the Flow Editor to modify the operation graph.</p>';
			tmpHTML += '</div>';
		}

		tmpHTML += '<div class="ultravisor-form-actions">';
		tmpHTML += '<button class="ultravisor-btn ultravisor-btn-primary" onclick="' + tmpViewRef + '.saveOperation()">Save Metadata</button>';
		tmpHTML += '<button class="ultravisor-btn ultravisor-btn-primary" onclick="' + tmpViewRef + '.openFlowEditor()">Open in Flow Editor</button>';
		tmpHTML += '<button class="ultravisor-btn ultravisor-btn-secondary" onclick="' + tmpGlobalRef + '.PictApplication.navigateTo(\'/Operations\')">Cancel</button>';
		tmpHTML += '</div>';

		this.pict.ContentAssignment.assignContent('#Ultravisor-OperationEdit-Form', tmpHTML);
	}

	openFlowEditor()
	{
		// Sync form values back to the model before navigating
		let tmpOp = this.pict.AppData.Ultravisor.CurrentEditOperation;
		tmpOp.Name = document.getElementById('Ultravisor-OperationEdit-Name').value.trim();
		tmpOp.Description = document.getElementById('Ultravisor-OperationEdit-Description').value.trim();

		// Load the graph into FlowEditor data
		if (tmpOp.Graph)
		{
			this.pict.AppData.Ultravisor.Flows.Current = JSON.parse(JSON.stringify(tmpOp.Graph));
		}

		this.pict.PictApplication.navigateTo('/FlowEditor');
	}

	saveOperation()
	{
		let tmpOp = this.pict.AppData.Ultravisor.CurrentEditOperation;

		let tmpOpData =
		{
			Name: document.getElementById('Ultravisor-OperationEdit-Name').value.trim(),
			Description: document.getElementById('Ultravisor-OperationEdit-Description').value.trim(),
			Graph: tmpOp.Graph || { Nodes: [], Connections: [], ViewState: {} }
		};

		let tmpHashEl = document.getElementById('Ultravisor-OperationEdit-Hash');
		if (tmpHashEl)
		{
			tmpOpData.Hash = tmpHashEl.value.trim();
		}

		this.pict.PictApplication.saveOperation(tmpOpData,
			function (pError)
			{
				if (pError)
				{
					this.pict.views.Modal.toast('Error saving operation: ' + pError.message, { type: 'error' });
					return;
				}
				this.pict.PictApplication.navigateTo('/Operations');
			}.bind(this));
	}
}

module.exports = UltravisorOperationEditView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],268:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-OperationList",

	DefaultRenderable: "Ultravisor-OperationList-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-operationlist {
			padding: 2em;
			max-width: 1400px;
			margin: 0 auto;
		}
		.ultravisor-operationlist-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1.5em;
			padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-operationlist-header h1 {
			margin: 0;
			font-size: 2em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.ultravisor-operation-table {
			width: 100%;
			border-collapse: collapse;
		}
		.ultravisor-operation-table th {
			background-color: var(--uv-bg-surface);
		}
		.ultravisor-operation-table tr:hover td {
			background-color: #1a2744;
		}
		.ultravisor-operation-node-count {
			display: inline-block;
			padding: 0.15em 0.5em;
			border-radius: 3px;
			font-size: 0.8em;
			font-weight: 600;
			background-color: #2e7d32;
			color: #c8e6c9;
		}
		.ultravisor-library-dropdown {
			background-color: var(--uv-bg-base);
			color: var(--uv-text);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			padding: 0.4em 0.6em;
			font-size: 0.9em;
			margin-right: 0.5em;
			cursor: pointer;
		}
		.ultravisor-library-dropdown:hover {
			border-color: #4a4a7a;
		}
		.ultravisor-library-dropdown option {
			background-color: var(--uv-bg-base);
			color: var(--uv-text);
		}
		.ultravisor-operationlist-header-actions {
			display: flex;
			align-items: center;
			gap: 0.5em;
		}
		.ultravisor-import-success {
			color: var(--uv-success);
			font-size: 0.9em;
			padding: 0.5em 0;
		}
		.ultravisor-dropzone {
			border: 2px dashed var(--uv-border-subtle);
			border-radius: 6px;
			padding: 1.5em 2em;
			text-align: center;
			color: var(--uv-text-secondary);
			cursor: pointer;
			transition: border-color 0.2s, background-color 0.2s;
			margin-bottom: 1.5em;
		}
		.ultravisor-dropzone:hover {
			border-color: var(--uv-brand);
		}
		.ultravisor-dropzone-active {
			border-color: var(--uv-brand);
			background-color: rgba(99, 102, 241, 0.08);
			color: var(--uv-text);
		}
		.ultravisor-dropzone-label {
			font-size: 0.95em;
		}
		.ultravisor-dropzone-options {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 0.5em;
			margin-top: 0.75em;
			font-size: 0.85em;
		}
		.ultravisor-dropzone-options label {
			cursor: pointer;
			color: var(--uv-text-secondary);
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-OperationList-Template",
			Template: /*html*/`
<div class="ultravisor-operationlist">
	<div class="ultravisor-operationlist-header">
		<h1>Operations</h1>
		<div class="ultravisor-operationlist-header-actions">
			<select id="Ultravisor-LibraryDropdown" class="ultravisor-library-dropdown" onchange="{~P~}.views['Ultravisor-OperationList'].onLibraryDropdownChange()">
				<option value="">From Library...</option>
			</select>
			<button id="Ultravisor-LibraryAddBtn" class="ultravisor-btn ultravisor-btn-primary" onclick="{~P~}.views['Ultravisor-OperationList'].importSelectedLibraryOp()" style="display:none">Add</button>
			<button class="ultravisor-btn ultravisor-btn-primary" onclick="{~P~}.PictApplication.editOperation()">New Operation</button>
		</div>
	</div>
	<div id="Ultravisor-OperationList-Dropzone" class="ultravisor-dropzone">
		<div class="ultravisor-dropzone-label">Drop workflow JSON here or click to browse</div>
		<input type="file" id="Ultravisor-OperationList-FileInput" accept=".json" style="display:none" />
		<div class="ultravisor-dropzone-options">
			<input type="checkbox" id="Ultravisor-ImportRunImmediately" />
			<label for="Ultravisor-ImportRunImmediately">Run immediately after import</label>
		</div>
	</div>
	<div id="Ultravisor-OperationList-Body"></div>
	<div id="Ultravisor-OperationList-Result"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-OperationList-Content",
			TemplateHash: "Ultravisor-OperationList-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorOperationListView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.PictApplication.loadOperations(
			function ()
			{
				this.renderOperationTable();
			}.bind(this));

		this.pict.PictApplication.loadOperationLibrary(
			function ()
			{
				this.populateLibraryDropdown();
			}.bind(this));

		this.wireDropZone();

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	wireDropZone()
	{
		let tmpDropZone = document.getElementById('Ultravisor-OperationList-Dropzone');
		let tmpFileInput = document.getElementById('Ultravisor-OperationList-FileInput');

		if (!tmpDropZone || !tmpFileInput)
		{
			return;
		}

		tmpDropZone.addEventListener('dragover', function (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			tmpDropZone.classList.add('ultravisor-dropzone-active');
		});

		tmpDropZone.addEventListener('dragleave', function (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			tmpDropZone.classList.remove('ultravisor-dropzone-active');
		});

		tmpDropZone.addEventListener('drop', function (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
			tmpDropZone.classList.remove('ultravisor-dropzone-active');

			if (pEvent.dataTransfer && pEvent.dataTransfer.files && pEvent.dataTransfer.files.length > 0)
			{
				this.handleImportFile(pEvent.dataTransfer.files[0]);
			}
		}.bind(this));

		tmpDropZone.addEventListener('click', function (pEvent)
		{
			if (pEvent.target.tagName !== 'INPUT')
			{
				tmpFileInput.click();
			}
		});

		tmpFileInput.addEventListener('change', function (pEvent)
		{
			if (pEvent.target.files && pEvent.target.files.length > 0)
			{
				this.handleImportFile(pEvent.target.files[0]);
				pEvent.target.value = '';
			}
		}.bind(this));
	}

	handleImportFile(pFile)
	{
		if (!pFile || !pFile.name.endsWith('.json'))
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
				'<div class="ultravisor-task-result-panel"><p style="color:var(--uv-error);">Please drop a .json file.</p></div>');
			return;
		}

		let tmpReader = new FileReader();
		let tmpSelf = this;

		tmpReader.onload = function (pEvent)
		{
			let tmpParsed;
			try
			{
				tmpParsed = JSON.parse(pEvent.target.result);
			}
			catch (pParseError)
			{
				tmpSelf.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
					'<div class="ultravisor-task-result-panel"><p style="color:var(--uv-error);">Invalid JSON: ' + tmpSelf.escapeHTML(pParseError.message) + '</p></div>');
				return;
			}

			if (!tmpParsed.Graph && !tmpParsed.Nodes)
			{
				tmpSelf.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
					'<div class="ultravisor-task-result-panel"><p style="color:var(--uv-error);">JSON does not appear to be a valid operation (no Graph or Nodes found).</p></div>');
				return;
			}

			// If the JSON has Nodes/Connections at the top level (like example flows), wrap in Graph
			if (!tmpParsed.Graph && tmpParsed.Nodes)
			{
				tmpParsed = {
					Name: tmpParsed.Name || pFile.name.replace(/\.json$/, ''),
					Description: tmpParsed.Description || '',
					Graph: {
						Nodes: tmpParsed.Nodes,
						Connections: tmpParsed.Connections || [],
						ViewState: tmpParsed.ViewState || {}
					}
				};
			}

			tmpSelf.processImportedOperation(tmpParsed, pFile.name);
		};

		tmpReader.readAsText(pFile);
	}

	processImportedOperation(pOperationJSON, pFileName)
	{
		this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
			'<div class="ultravisor-import-success">Importing ' + this.escapeHTML(pFileName) + '...</div>');

		this.pict.PictApplication.importOperationFromJSON(pOperationJSON,
			function (pError, pData)
			{
				if (pError)
				{
					this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
						'<div class="ultravisor-task-result-panel"><p style="color:var(--uv-error);">Import error: ' + this.escapeHTML(pError.message) + '</p></div>');
					return;
				}

				let tmpHash = pData.Hash || '';
				let tmpRunCheckbox = document.getElementById('Ultravisor-ImportRunImmediately');
				let tmpRunImmediately = tmpRunCheckbox && tmpRunCheckbox.checked;

				// Reload the table
				this.pict.PictApplication.loadOperations(
					function ()
					{
						this.renderOperationTable();

						if (tmpRunImmediately)
						{
							this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
								'<div class="ultravisor-import-success">Imported as ' + this.escapeHTML(tmpHash) + ' — running...</div>');
							this.runOperation(tmpHash);
						}
						else
						{
							this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
								'<div class="ultravisor-import-success">Imported as ' + this.escapeHTML(tmpHash) + '</div>');
						}
					}.bind(this));
			}.bind(this));
	}

	renderOperationTable()
	{
		let tmpOpList = this.pict.AppData.Ultravisor.OperationList;
		let tmpGlobalRef = '_Pict';

		if (!tmpOpList || tmpOpList.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Body',
				'<div class="ultravisor-empty-message">No operations defined. Click "New Operation" to create one.</div>');
			return;
		}

		let tmpHTML = '<table class="ultravisor-operation-table">';
		tmpHTML += '<thead><tr><th>Hash</th><th>Name</th><th>Nodes</th><th>Actions</th></tr></thead>';
		tmpHTML += '<tbody>';

		for (let i = 0; i < tmpOpList.length; i++)
		{
			let tmpOp = tmpOpList[i];
			let tmpHash = tmpOp.Hash || '';
			let tmpName = tmpOp.Name || tmpHash;
			let tmpNodeCount = (tmpOp.Graph && tmpOp.Graph.Nodes) ? tmpOp.Graph.Nodes.length : 0;
			let tmpEscHash = tmpHash.replace(/'/g, "\\'");

			tmpHTML += '<tr>';
			tmpHTML += '<td><code>' + this.escapeHTML(tmpHash) + '</code></td>';
			tmpHTML += '<td>' + this.escapeHTML(tmpName) + '</td>';
			tmpHTML += '<td><span class="ultravisor-operation-node-count">' + tmpNodeCount + ' node' + (tmpNodeCount !== 1 ? 's' : '') + '</span></td>';
			tmpHTML += '<td><div class="ultravisor-task-actions">';
			tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-execute" onclick="' + tmpGlobalRef + '.views[\'Ultravisor-OperationList\'].runOperation(\'' + tmpEscHash + '\')">Run</button>';
			tmpHTML += '<button class="ultravisor-btn-sm" style="background-color:#00695c;color:#e0f2f1;" onclick="' + tmpGlobalRef + '.views[\'Ultravisor-OperationList\'].runOperation(\'' + tmpEscHash + '\', \'debug\')">Debug</button>';
			tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-edit" onclick="' + tmpGlobalRef + '.PictApplication.editOperation(\'' + tmpEscHash + '\')">Edit</button>';
			tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-delete" onclick="' + tmpGlobalRef + '.views[\'Ultravisor-OperationList\'].confirmDeleteOperation(\'' + tmpEscHash + '\')">Delete</button>';
			tmpHTML += '<button class="ultravisor-btn-sm" style="background-color:var(--uv-info);color:#bbdefb;" onclick="' + tmpGlobalRef + '.views[\'Ultravisor-OperationList\'].exportOperation(\'' + tmpEscHash + '\')">Export</button>';
			tmpHTML += '</div></td>';
			tmpHTML += '</tr>';
		}

		tmpHTML += '</tbody></table>';
		this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Body', tmpHTML);
	}

	runOperation(pHash, pRunMode)
	{
		let tmpModeLabel = pRunMode === 'debug' ? ' (debug)' : '';
		this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
			'<div class="ultravisor-task-result-panel"><h3>Running operation ' + this.escapeHTML(pHash) + tmpModeLabel + '...</h3></div>');

		this.pict.PictApplication.executeOperation(pHash, pRunMode || null,
			function (pError, pData)
			{
				if (pError)
				{
					this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
						'<div class="ultravisor-task-result-panel"><h3>Error</h3><p style="color:var(--uv-error);">' + this.escapeHTML(pError.message) + '</p></div>');
					return;
				}

				let tmpHTML = '<div class="ultravisor-task-result-panel">';
				tmpHTML += '<h3>Operation Result: ' + this.escapeHTML(pHash) + '</h3>';
				tmpHTML += '<p><strong>Status:</strong> <span class="ultravisor-manifest-status ' + (pData.Status || '').toLowerCase() + '">' + this.escapeHTML(pData.Status || '') + '</span>';
				if (pData.RunMode)
				{
					tmpHTML += ' &middot; <strong>Mode:</strong> ' + this.escapeHTML(pData.RunMode);
				}
				tmpHTML += '</p>';
				tmpHTML += '<p><strong>Start:</strong> ' + this.escapeHTML(pData.StartTime || '') + ' &middot; <strong>Stop:</strong> ' + this.escapeHTML(pData.StopTime || '') + '</p>';
				tmpHTML += '<p><strong>Elapsed:</strong> ' + (pData.ElapsedMs || 0) + 'ms</p>';

				if (pData.Output && Object.keys(pData.Output).length > 0)
				{
					tmpHTML += '<h4 style="color:var(--uv-text-secondary); margin:0.75em 0 0.25em 0;">Output</h4>';
					tmpHTML += '<div class="ultravisor-task-result-output">' + this.escapeHTML(JSON.stringify(pData.Output, null, 2)) + '</div>';
				}

				if (pData.TaskOutputs)
				{
					tmpHTML += '<h4 style="color:var(--uv-text-secondary); margin:0.75em 0 0.25em 0;">Task Outputs</h4>';
					tmpHTML += '<div class="ultravisor-task-result-output">' + this.escapeHTML(JSON.stringify(pData.TaskOutputs, null, 2)) + '</div>';
				}

				if (pData.Log && pData.Log.length > 0)
				{
					tmpHTML += '<h4 style="color:var(--uv-text-secondary); margin:0.75em 0 0.25em 0;">Log</h4>';
					tmpHTML += '<div class="ultravisor-task-result-output">' + this.escapeHTML(pData.Log.join('\n')) + '</div>';
				}

				tmpHTML += '</div>';
				this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result', tmpHTML);
			}.bind(this));
	}

	populateLibraryDropdown()
	{
		let tmpDropdown = document.getElementById('Ultravisor-LibraryDropdown');
		if (!tmpDropdown)
		{
			return;
		}

		let tmpLibrary = this.pict.AppData.Ultravisor.OperationLibrary;
		let tmpHTML = '<option value="">From Library...</option>';

		for (let i = 0; i < tmpLibrary.length; i++)
		{
			let tmpItem = tmpLibrary[i];
			let tmpLabel = this.escapeHTML(tmpItem.Name || tmpItem.FileName);
			tmpLabel += ' (' + (tmpItem.NodeCount || 0) + ' nodes)';
			tmpHTML += '<option value="' + this.escapeHTML(tmpItem.FileName) + '">' + tmpLabel + '</option>';
		}

		tmpDropdown.innerHTML = tmpHTML;
	}

	onLibraryDropdownChange()
	{
		let tmpDropdown = document.getElementById('Ultravisor-LibraryDropdown');
		let tmpAddBtn = document.getElementById('Ultravisor-LibraryAddBtn');

		if (tmpDropdown && tmpAddBtn)
		{
			tmpAddBtn.style.display = tmpDropdown.value ? 'inline-block' : 'none';
		}
	}

	importSelectedLibraryOp()
	{
		let tmpDropdown = document.getElementById('Ultravisor-LibraryDropdown');
		if (!tmpDropdown || !tmpDropdown.value)
		{
			return;
		}

		let tmpFileName = tmpDropdown.value;

		this.pict.PictApplication.importLibraryOperation(tmpFileName,
			function (pError, pData)
			{
				if (pError)
				{
					this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
						'<div class="ultravisor-task-result-panel"><p style="color:var(--uv-error);">Error importing: ' + this.escapeHTML(pError.message) + '</p></div>');
					return;
				}

				this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
					'<div class="ultravisor-import-success">Operation imported as ' + this.escapeHTML(pData.Hash) + '</div>');

				// Reset dropdown
				let tmpDd = document.getElementById('Ultravisor-LibraryDropdown');
				if (tmpDd) { tmpDd.value = ''; }
				let tmpBtn = document.getElementById('Ultravisor-LibraryAddBtn');
				if (tmpBtn) { tmpBtn.style.display = 'none'; }

				// Reload the table
				this.pict.PictApplication.loadOperations(
					function ()
					{
						this.renderOperationTable();
					}.bind(this));
			}.bind(this));
	}

	exportOperation(pHash)
	{
		this.pict.PictApplication.exportOperation(pHash,
			function (pError)
			{
				if (pError)
				{
					this.pict.ContentAssignment.assignContent('#Ultravisor-OperationList-Result',
						'<div class="ultravisor-task-result-panel"><p style="color:var(--uv-error);">Export error: ' + this.escapeHTML(pError.message) + '</p></div>');
				}
			}.bind(this));
	}

	confirmDeleteOperation(pHash)
	{
		this.pict.views.Modal.confirm('Delete operation ' + pHash + '?', { confirmLabel: 'Delete', dangerous: true }).then(
			function (pConfirmed)
			{
				if (pConfirmed)
				{
					this.pict.PictApplication.deleteOperation(pHash,
						function ()
						{
							this.pict.PictApplication.showView('Ultravisor-OperationList');
						}.bind(this));
				}
			}.bind(this));
	}

	escapeHTML(pValue)
	{
		if (!pValue) return '';
		return String(pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
}

module.exports = UltravisorOperationListView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],269:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-PendingInput",

	DefaultRenderable: "Ultravisor-PendingInput-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-pendinginput {
			padding: 2em;
			max-width: 1200px;
			margin: 0 auto;
		}
		.ultravisor-pendinginput-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1.5em;
			padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-pendinginput-header h1 {
			margin: 0;
			font-size: 2em;
			font-weight: 300;
			color: var(--uv-text);
		}

		/* --- Card: shared base --- */
		.ultravisor-pendinginput-card {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-warning);
			border-radius: 8px;
			padding: 1.5em;
			margin-bottom: 1em;
		}
		.ultravisor-pendinginput-card.beacon {
			border-color: #5a9ecb;
		}
		.ultravisor-pendinginput-card-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1em;
		}
		.ultravisor-pendinginput-card-header h3 {
			margin: 0;
			color: var(--uv-text);
			font-weight: 500;
		}
		.ultravisor-pendinginput-meta {
			color: var(--uv-text-secondary);
			font-size: 0.85em;
			margin-bottom: 1em;
		}
		.ultravisor-pendinginput-meta code {
			color: var(--uv-brand);
			font-size: 0.9em;
		}
		.ultravisor-pendinginput-task {
			background: var(--uv-bg-base);
			border-radius: 4px;
			padding: 1em;
			margin-bottom: 0.75em;
		}
		.ultravisor-pendinginput-prompt {
			color: #fff9c4;
			font-size: 1.1em;
			margin-bottom: 0.75em;
		}
		.ultravisor-pendinginput-address {
			color: var(--uv-text-secondary);
			font-size: 0.8em;
			margin-bottom: 0.75em;
		}

		/* --- Value-input form --- */
		.ultravisor-pendinginput-form {
			display: flex;
			gap: 0.75em;
			align-items: center;
		}
		.ultravisor-pendinginput-form input[type="text"] {
			flex: 1;
			padding: 0.5em 0.75em;
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			background: #0d1117;
			color: var(--uv-text);
			font-size: 1em;
			font-family: monospace;
		}
		.ultravisor-pendinginput-form input[type="text"]:focus {
			outline: none;
			border-color: var(--uv-warning);
		}
		.ultravisor-pendinginput-submit {
			padding: 0.5em 1.25em;
			background-color: var(--uv-warning);
			color: var(--uv-bg-base);
			border: none;
			border-radius: 4px;
			font-weight: 600;
			cursor: pointer;
			font-size: 0.95em;
		}
		.ultravisor-pendinginput-submit:hover {
			background-color: #ff8f00;
		}
		.ultravisor-pendinginput-submit:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}

		/* --- Beacon waiting state --- */
		.ultravisor-pendinginput-beacon-status {
			display: flex;
			align-items: center;
			gap: 0.75em;
			margin-bottom: 0.75em;
		}
		.ultravisor-pendinginput-beacon-prompt {
			color: #90caf9;
			font-size: 1.1em;
		}
		.ultravisor-pendinginput-waiting-indicator {
			display: inline-block;
			width: 10px;
			height: 10px;
			border-radius: 50%;
			background: #5a9ecb;
			animation: uv-pending-pulse 1.5s ease-in-out infinite;
			flex-shrink: 0;
		}
		@keyframes uv-pending-pulse {
			0%, 100% { opacity: 0.4; transform: scale(0.8); }
			50% { opacity: 1; transform: scale(1.2); }
		}
		.ultravisor-pendinginput-elapsed {
			color: var(--uv-text-tertiary);
			font-size: 0.8em;
		}
		.ultravisor-pendinginput-beacon-actions {
			display: flex;
			align-items: center;
			gap: 0.75em;
			margin-top: 0.5em;
		}
		.ultravisor-pendinginput-force-error {
			padding: 0.4em 1em;
			background-color: #3a1a1a;
			color: #c44e4e;
			border: 1px solid #5a2020;
			border-radius: 4px;
			font-size: 0.85em;
			cursor: pointer;
			font-weight: 500;
		}
		.ultravisor-pendinginput-force-error:hover {
			background-color: #4a2020;
			border-color: #7a3030;
		}
		.ultravisor-pendinginput-force-error:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}

		/* --- Result feedback --- */
		.ultravisor-pendinginput-result {
			margin-top: 0.75em;
			padding: 0.5em 0.75em;
			border-radius: 4px;
			font-size: 0.85em;
		}
		.ultravisor-pendinginput-result.success {
			background: #1b5e20;
			color: #c8e6c9;
		}
		.ultravisor-pendinginput-result.error {
			background: #b71c1c;
			color: #ffcdd2;
		}

		/* --- Status badge variants --- */
		.ultravisor-manifest-status.beacon-waiting {
			background-color: #1a2a3a;
			color: #5a9ecb;
			border: 1px solid #2a4a6a;
			padding: 0.2em 0.6em;
			border-radius: 4px;
			font-size: 0.8em;
			font-weight: 600;
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-PendingInput-Template",
			Template: /*html*/`
<div class="ultravisor-pendinginput">
	<div class="ultravisor-pendinginput-header">
		<h1>Awaiting</h1>
		<button class="ultravisor-btn ultravisor-btn-secondary" onclick="{~P~}.PictApplication.showView('Ultravisor-PendingInput')">Refresh</button>
	</div>
	<div id="Ultravisor-PendingInput-Body"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-PendingInput-Content",
			TemplateHash: "Ultravisor-PendingInput-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorPendingInputView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.PictApplication.loadPendingInputs(
			function ()
			{
				this.renderPendingInputs();
			}.bind(this));

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	/**
	 * Determine if a waiting task is a beacon-dispatch task
	 * (as opposed to a value-input task).
	 */
	_isBeaconTask(pTask)
	{
		// Beacon-dispatch tasks set ResumeEventName to 'Complete'
		// and have an empty OutputAddress.
		if (pTask.ResumeEventName && pTask.ResumeEventName !== 'ValueInputComplete')
		{
			return true;
		}
		return false;
	}

	/**
	 * Format elapsed time since a timestamp.
	 */
	_formatElapsed(pTimestamp)
	{
		if (!pTimestamp) return '';
		let tmpStart = new Date(pTimestamp).getTime();
		let tmpElapsedMs = Date.now() - tmpStart;

		if (tmpElapsedMs < 1000) return 'just now';
		if (tmpElapsedMs < 60000) return Math.floor(tmpElapsedMs / 1000) + 's ago';
		if (tmpElapsedMs < 3600000) return Math.floor(tmpElapsedMs / 60000) + 'm ' + Math.floor((tmpElapsedMs % 60000) / 1000) + 's ago';
		return Math.floor(tmpElapsedMs / 3600000) + 'h ' + Math.floor((tmpElapsedMs % 3600000) / 60000) + 'm ago';
	}

	renderPendingInputs()
	{
		let tmpPendingInputs = this.pict.AppData.Ultravisor.PendingInputs;
		let tmpGlobalRef = '_Pict';
		let tmpViewRef = tmpGlobalRef + ".views['Ultravisor-PendingInput']";

		if (!tmpPendingInputs || tmpPendingInputs.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-PendingInput-Body',
				'<div class="ultravisor-empty-message">No operations awaiting input or beacon completion.</div>');
			return;
		}

		let tmpHTML = '';

		for (let i = 0; i < tmpPendingInputs.length; i++)
		{
			let tmpPending = tmpPendingInputs[i];
			let tmpRunHash = tmpPending.RunHash || '';
			let tmpEscRunHash = tmpRunHash.replace(/'/g, "\\'");

			// Check if this operation has any beacon tasks
			let tmpWaitingTasks = tmpPending.WaitingTasks || {};
			let tmpNodeHashes = Object.keys(tmpWaitingTasks);
			let tmpHasBeaconTask = false;
			for (let k = 0; k < tmpNodeHashes.length; k++)
			{
				if (this._isBeaconTask(tmpWaitingTasks[tmpNodeHashes[k]]))
				{
					tmpHasBeaconTask = true;
					break;
				}
			}

			tmpHTML += '<div class="ultravisor-pendinginput-card' + (tmpHasBeaconTask ? ' beacon' : '') + '">';
			tmpHTML += '<div class="ultravisor-pendinginput-card-header">';
			tmpHTML += '<h3>' + this.escapeHTML(tmpPending.OperationName || tmpPending.OperationHash || 'Unknown') + '</h3>';

			// Determine the status badge
			let tmpAllBeacon = true;
			let tmpAllInput = true;
			for (let k = 0; k < tmpNodeHashes.length; k++)
			{
				if (this._isBeaconTask(tmpWaitingTasks[tmpNodeHashes[k]]))
				{
					tmpAllInput = false;
				}
				else
				{
					tmpAllBeacon = false;
				}
			}
			if (tmpAllBeacon)
			{
				tmpHTML += '<span class="ultravisor-manifest-status beacon-waiting">Waiting for Beacon</span>';
			}
			else if (tmpAllInput)
			{
				tmpHTML += '<span class="ultravisor-manifest-status waiting">Waiting for Input</span>';
			}
			else
			{
				tmpHTML += '<span class="ultravisor-manifest-status waiting">Waiting</span>';
			}

			tmpHTML += '</div>';
			tmpHTML += '<div class="ultravisor-pendinginput-meta">';
			tmpHTML += 'Operation: <code>' + this.escapeHTML(tmpPending.OperationHash || '') + '</code>';
			tmpHTML += ' &middot; Run: <code>' + this.escapeHTML(tmpRunHash) + '</code>';
			if (tmpPending.StartTime)
			{
				tmpHTML += ' &middot; Started: ' + this.escapeHTML(tmpPending.StartTime);
			}
			tmpHTML += '</div>';

			// Render each waiting task
			for (let j = 0; j < tmpNodeHashes.length; j++)
			{
				let tmpNodeHash = tmpNodeHashes[j];
				let tmpEscNodeHash = tmpNodeHash.replace(/'/g, "\\'");
				let tmpTask = tmpWaitingTasks[tmpNodeHash];
				let tmpResultId = 'pending-result-' + tmpRunHash + '-' + tmpNodeHash;

				if (this._isBeaconTask(tmpTask))
				{
					// ── Beacon task: show waiting indicator + force error button ──
					tmpHTML += '<div class="ultravisor-pendinginput-task">';
					tmpHTML += '<div class="ultravisor-pendinginput-beacon-status">';
					tmpHTML += '<span class="ultravisor-pendinginput-waiting-indicator"></span>';
					tmpHTML += '<span class="ultravisor-pendinginput-beacon-prompt">' + this.escapeHTML(tmpTask.PromptMessage || 'Waiting for beacon to complete') + '</span>';
					tmpHTML += '</div>';
					if (tmpTask.Timestamp)
					{
						tmpHTML += '<div class="ultravisor-pendinginput-elapsed">Dispatched ' + this.escapeHTML(this._formatElapsed(tmpTask.Timestamp)) + '</div>';
					}
					tmpHTML += '<div class="ultravisor-pendinginput-beacon-actions">';
					tmpHTML += '<button class="ultravisor-pendinginput-force-error" onclick="' + tmpViewRef + '.forceError(\'' + tmpEscRunHash + '\', \'' + tmpEscNodeHash + '\', \'' + tmpResultId + '\')">Force Error</button>';
					tmpHTML += '</div>';
					tmpHTML += '<div id="' + tmpResultId + '"></div>';
					tmpHTML += '</div>';
				}
				else
				{
					// ── Value-input task: show text input + submit button ──
					let tmpInputId = 'pending-input-' + tmpRunHash + '-' + tmpNodeHash;

					tmpHTML += '<div class="ultravisor-pendinginput-task">';
					tmpHTML += '<div class="ultravisor-pendinginput-prompt">' + this.escapeHTML(tmpTask.PromptMessage || 'Enter a value') + '</div>';
					if (tmpTask.OutputAddress)
					{
						tmpHTML += '<div class="ultravisor-pendinginput-address">Target: <code>' + this.escapeHTML(tmpTask.OutputAddress) + '</code></div>';
					}
					tmpHTML += '<div class="ultravisor-pendinginput-form">';
					tmpHTML += '<input type="text" id="' + tmpInputId + '" placeholder="Enter value..." onkeydown="if(event.key===\'Enter\'){' + tmpViewRef + '.submitInput(\'' + tmpEscRunHash + '\', \'' + tmpEscNodeHash + '\', \'' + tmpInputId + '\', \'' + tmpResultId + '\');}" />';
					tmpHTML += '<button class="ultravisor-pendinginput-submit" onclick="' + tmpViewRef + '.submitInput(\'' + tmpEscRunHash + '\', \'' + tmpEscNodeHash + '\', \'' + tmpInputId + '\', \'' + tmpResultId + '\')">Submit</button>';
					tmpHTML += '</div>';
					tmpHTML += '<div id="' + tmpResultId + '"></div>';
					tmpHTML += '</div>';
				}
			}

			tmpHTML += '</div>';
		}

		this.pict.ContentAssignment.assignContent('#Ultravisor-PendingInput-Body', tmpHTML);
	}

	submitInput(pRunHash, pNodeHash, pInputId, pResultId)
	{
		let tmpInputEl = document.getElementById(pInputId);
		if (!tmpInputEl)
		{
			return;
		}

		let tmpValue = tmpInputEl.value;

		// Disable the input and button while submitting
		tmpInputEl.disabled = true;
		let tmpButton = tmpInputEl.parentElement.querySelector('.ultravisor-pendinginput-submit');
		if (tmpButton)
		{
			tmpButton.disabled = true;
			tmpButton.textContent = 'Submitting...';
		}

		this.pict.PictApplication.submitPendingInput(pRunHash, pNodeHash, tmpValue,
			function (pError, pData)
			{
				if (pError)
				{
					this.pict.ContentAssignment.assignContent('#' + pResultId,
						'<div class="ultravisor-pendinginput-result error">Error: ' + this.escapeHTML(pError.message || 'Request failed') + '</div>');
					// Re-enable
					tmpInputEl.disabled = false;
					if (tmpButton)
					{
						tmpButton.disabled = false;
						tmpButton.textContent = 'Submit';
					}
					return;
				}

				if (pData && pData.Error)
				{
					this.pict.ContentAssignment.assignContent('#' + pResultId,
						'<div class="ultravisor-pendinginput-result error">Error: ' + this.escapeHTML(pData.Error) + '</div>');
					tmpInputEl.disabled = false;
					if (tmpButton)
					{
						tmpButton.disabled = false;
						tmpButton.textContent = 'Submit';
					}
					return;
				}

				let tmpStatus = (pData && pData.Status) || 'Submitted';
				this.pict.ContentAssignment.assignContent('#' + pResultId,
					'<div class="ultravisor-pendinginput-result success">Input submitted — operation status: ' + this.escapeHTML(tmpStatus) + '</div>');

				// Refresh the list after a brief delay so the user sees the success message
				setTimeout(
					function ()
					{
						this.pict.PictApplication.loadPendingInputs(
							function ()
							{
								this.renderPendingInputs();
							}.bind(this));
					}.bind(this), 1500);
			}.bind(this));
	}

	forceError(pRunHash, pNodeHash, pResultId)
	{
		this.pict.views.Modal.confirm('Force this task to error?\nThe operation will continue on the Error path.', { confirmLabel: 'Force Error', dangerous: true }).then(
			function (pConfirmed)
			{
				if (pConfirmed)
				{
					// Disable the button while processing
					let tmpResultEl = document.getElementById(pResultId);
					let tmpButtonEl = tmpResultEl ? tmpResultEl.previousElementSibling.querySelector('.ultravisor-pendinginput-force-error') : null;
					if (tmpButtonEl)
					{
						tmpButtonEl.disabled = true;
						tmpButtonEl.textContent = 'Forcing error...';
					}

					this.pict.PictApplication.forceErrorPendingInput(pRunHash, pNodeHash,
						function (pError, pData)
						{
							if (pError)
							{
								this.pict.ContentAssignment.assignContent('#' + pResultId,
									'<div class="ultravisor-pendinginput-result error">Error: ' + this.escapeHTML(pError.message || 'Request failed') + '</div>');
								if (tmpButtonEl)
								{
									tmpButtonEl.disabled = false;
									tmpButtonEl.textContent = 'Force Error';
								}
								return;
							}

							if (pData && pData.Error)
							{
								this.pict.ContentAssignment.assignContent('#' + pResultId,
									'<div class="ultravisor-pendinginput-result error">Error: ' + this.escapeHTML(pData.Error) + '</div>');
								if (tmpButtonEl)
								{
									tmpButtonEl.disabled = false;
									tmpButtonEl.textContent = 'Force Error';
								}
								return;
							}

							let tmpStatus = (pData && pData.Status) || 'Errored';
							this.pict.ContentAssignment.assignContent('#' + pResultId,
								'<div class="ultravisor-pendinginput-result error">Task force-errored — operation status: ' + this.escapeHTML(tmpStatus) + '</div>');

							// Refresh the list after a brief delay
							setTimeout(
								function ()
								{
									this.pict.PictApplication.loadPendingInputs(
										function ()
										{
											this.renderPendingInputs();
										}.bind(this));
								}.bind(this), 1500);
						}.bind(this));
				}
			}.bind(this));
	}

	escapeHTML(pValue)
	{
		if (!pValue) return '';
		return String(pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
}

module.exports = UltravisorPendingInputView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],270:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-ReachabilityMap",

	DefaultRenderable: "Ultravisor-ReachabilityMap-Content",
	DefaultDestinationAddress: "#Ultravisor-BeaconList-ReachabilityMap",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-reachability-map {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			padding: 1.5em;
			position: relative;
		}
		.ultravisor-reachability-map svg {
			width: 100%;
			height: 460px;
			display: block;
		}
		.ultravisor-reachability-map-empty {
			text-align: center;
			padding: 3em;
			color: var(--uv-text-tertiary);
			font-size: 0.95em;
		}

		/* Legend */
		.ultravisor-reachability-legend {
			display: flex;
			flex-wrap: wrap;
			gap: 1.2em;
			margin-top: 1em;
			padding-top: 0.75em;
			border-top: 1px solid var(--uv-border-subtle);
			font-size: 0.8em;
			color: var(--uv-text-secondary);
		}
		.ultravisor-reachability-legend-item {
			display: flex;
			align-items: center;
			gap: 0.4em;
		}
		.ultravisor-reachability-legend-line {
			width: 24px;
			height: 3px;
			border-radius: 1px;
		}
		.ultravisor-reachability-legend-line.ws {
			background-color: #5a9ecb;
		}
		.ultravisor-reachability-legend-line.direct {
			background-color: #66bb6a;
		}
		.ultravisor-reachability-legend-line.unreachable {
			background: repeating-linear-gradient(
				90deg,
				#ef5350 0px, #ef5350 4px,
				transparent 4px, transparent 8px
			);
		}
		.ultravisor-reachability-legend-line.untested {
			background: repeating-linear-gradient(
				90deg,
				#9e9e9e 0px, #9e9e9e 2px,
				transparent 2px, transparent 6px
			);
		}
		.ultravisor-reachability-legend-marker {
			width: 16px;
			height: 16px;
			border-radius: 50%;
			border: 2px dashed var(--theme-color-status-warning, #b45309);
			background: transparent;
		}

		/* Tooltip */
		.ultravisor-reachability-tooltip {
			position: absolute;
			background: var(--uv-bg-elevated);
			border: 1px solid var(--uv-border);
			border-radius: 6px;
			padding: 0.5em 0.75em;
			font-size: 0.8em;
			color: var(--uv-text);
			pointer-events: none;
			display: none;
			z-index: 10;
			white-space: nowrap;
			box-shadow: 0 2px 8px rgba(0,0,0,0.3);
		}
		.ultravisor-reachability-tooltip.visible {
			display: block;
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-ReachabilityMap-Template",
			Template: /*html*/`
<div class="ultravisor-reachability-map">
	<div id="Ultravisor-ReachabilityMap-Canvas"></div>
	<div id="Ultravisor-ReachabilityMap-Tooltip" class="ultravisor-reachability-tooltip"></div>
	<div class="ultravisor-reachability-legend">
		<div class="ultravisor-reachability-legend-item">
			<div class="ultravisor-reachability-legend-line ws"></div>
			<span>WebSocket (beacon ↔ UV)</span>
		</div>
		<div class="ultravisor-reachability-legend-item">
			<div class="ultravisor-reachability-legend-line direct"></div>
			<span>Direct (probed)</span>
		</div>
		<div class="ultravisor-reachability-legend-item">
			<div class="ultravisor-reachability-legend-line unreachable"></div>
			<span>Unreachable (probe failed)</span>
		</div>
		<div class="ultravisor-reachability-legend-item">
			<div class="ultravisor-reachability-legend-line untested"></div>
			<span>Untested</span>
		</div>
		<div class="ultravisor-reachability-legend-item">
			<div class="ultravisor-reachability-legend-marker"></div>
			<span>No HTTP listener (broker-only)</span>
		</div>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-ReachabilityMap-Content",
			TemplateHash: "Ultravisor-ReachabilityMap-Template",
			DestinationAddress: "#Ultravisor-BeaconList-ReachabilityMap",
			RenderMethod: "replace"
		}
	]
};

class UltravisorReachabilityMapView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.renderMap();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	renderMap()
	{
		// Prefer the connectivity-rich Beacons from the envelope; fall
		// back to the bare Beacons list if the envelope wasn't populated
		// (e.g. legacy server, race during initial load).
		let tmpReachBeacons = this.pict.AppData.Ultravisor.ReachabilityBeacons || [];
		let tmpFallbackBeacons = this.pict.AppData.Ultravisor.Beacons || [];
		let tmpBeacons = (tmpReachBeacons.length > 0) ? tmpReachBeacons : tmpFallbackBeacons.map(function (pB)
		{
			// Synthesize the envelope shape from a bare beacon so the
			// renderer doesn't have to branch.  HasListener is best-
			// effort from BindAddresses; WSConnected is approximated
			// from Status==='Online'.
			return {
				BeaconID:      pB.BeaconID,
				Name:          pB.Name,
				Status:        pB.Status,
				HasListener:   Array.isArray(pB.BindAddresses) && pB.BindAddresses.length > 0,
				WSConnected:   (pB.Status || '').toLowerCase() === 'online',
				BindAddresses: pB.BindAddresses || [],
				HostID:        pB.HostID || ''
			};
		});

		let tmpMatrix = this.pict.AppData.Ultravisor.ReachabilityMatrix || [];
		let tmpHub = this.pict.AppData.Ultravisor.ReachabilityHub
			|| { HostID: 'ultravisor', Name: 'Ultravisor' };

		if (tmpBeacons.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-ReachabilityMap-Canvas',
				'<div class="ultravisor-reachability-map-empty">No beacons registered yet.</div>');
			return;
		}

		// Build a lookup for matrix entries: "src::tgt" → entry
		let tmpLookup = {};
		for (let i = 0; i < tmpMatrix.length; i++)
		{
			let tmpEntry = tmpMatrix[i];
			tmpLookup[tmpEntry.SourceBeaconID + '::' + tmpEntry.TargetBeaconID] = tmpEntry;
		}

		// Layout: beacons on a ring, Ultravisor hub in center
		let tmpWidth = 600;
		let tmpHeight = 440;
		let tmpCenterX = tmpWidth / 2;
		let tmpCenterY = tmpHeight / 2;
		let tmpRadius = Math.min(tmpWidth, tmpHeight) * 0.36;
		let tmpNodeRadius = 30;
		let tmpHubRadius = 28;

		// Calculate beacon positions on the ring
		let tmpPositions = [];
		for (let i = 0; i < tmpBeacons.length; i++)
		{
			let tmpAngle = (2 * Math.PI * i / tmpBeacons.length) - (Math.PI / 2);
			tmpPositions.push({
				x: tmpCenterX + tmpRadius * Math.cos(tmpAngle),
				y: tmpCenterY + tmpRadius * Math.sin(tmpAngle)
			});
		}

		let tmpViewRef = "_Pict.views['Ultravisor-ReachabilityMap']";
		let tmpSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + tmpWidth + ' ' + tmpHeight + '">';

		// ── Layer 1: beacon ↔ UV WebSocket lines ──
		// Drawn first so direct lines render on top.  These are
		// bidirectional by nature (the WS carries both push from UV
		// to beacon and beacon → UV registration/heartbeats), so a
		// single solid line communicates the channel.
		for (let i = 0; i < tmpBeacons.length; i++)
		{
			let tmpB = tmpBeacons[i];
			if (!tmpB.WSConnected) continue;
			let tmpEdgeStart = this._edgePoint(tmpCenterX, tmpCenterY, tmpPositions[i].x, tmpPositions[i].y, tmpHubRadius);
			let tmpEdgeEnd = this._edgePoint(tmpPositions[i].x, tmpPositions[i].y, tmpCenterX, tmpCenterY, tmpNodeRadius);
			let tmpTooltip = this._escapeAttr(tmpB.Name + ' ↔ ' + tmpHub.Name + ' | WebSocket | bidirectional');
			tmpSVG += '<line x1="' + tmpEdgeStart.x + '" y1="' + tmpEdgeStart.y + '"'
				+ ' x2="' + tmpEdgeEnd.x + '" y2="' + tmpEdgeEnd.y + '"'
				+ ' stroke="#5a9ecb" stroke-width="2.25" stroke-linecap="round"'
				+ ' opacity="0.9" style="cursor:pointer;"'
				+ ' onmousemove="' + tmpViewRef + '.showTooltip(event, \'' + tmpTooltip + '\')"'
				+ ' onmouseleave="' + tmpViewRef + '.hideTooltip()"'
				+ '/>';
		}

		// ── Layer 2: beacon ↔ beacon direct connectivity lines ──
		// Only drawn for pairs where BOTH beacons advertise an HTTP
		// listener.  When either beacon is no-listener, the absence
		// of a line is the signal — we draw a circle treatment on
		// that beacon (Layer 4) so the user can see why no edges
		// fan out from it.
		for (let i = 0; i < tmpBeacons.length; i++)
		{
			for (let j = i + 1; j < tmpBeacons.length; j++)
			{
				let tmpA = tmpBeacons[i];
				let tmpB = tmpBeacons[j];
				if (!tmpA.HasListener || !tmpB.HasListener) continue;

				let tmpAB = tmpLookup[tmpA.BeaconID + '::' + tmpB.BeaconID];
				let tmpBA = tmpLookup[tmpB.BeaconID + '::' + tmpA.BeaconID];
				let tmpStatus = this._combinedStatus(tmpAB, tmpBA);
				if (tmpStatus === 'no-listener') continue;  // belt-and-suspenders

				let tmpLineColor = '#9e9e9e';
				let tmpDashArray = '3,5';
				let tmpStrokeWidth = 1.5;
				if (tmpStatus === 'reachable')
				{
					tmpLineColor = '#66bb6a';
					tmpDashArray = '';
					tmpStrokeWidth = 2;
				}
				else if (tmpStatus === 'unreachable')
				{
					tmpLineColor = '#ef5350';
					tmpDashArray = '6,4';
				}

				let tmpLatency = this._bestLatency(tmpAB, tmpBA);
				let tmpLastProbe = this._latestProbe(tmpAB, tmpBA);
				let tmpEdgeA = this._edgePoint(tmpPositions[i].x, tmpPositions[i].y, tmpPositions[j].x, tmpPositions[j].y, tmpNodeRadius);
				let tmpEdgeB = this._edgePoint(tmpPositions[j].x, tmpPositions[j].y, tmpPositions[i].x, tmpPositions[i].y, tmpNodeRadius);

				let tmpTooltipData = this._escapeAttr(tmpA.Name) + ' ↔ ' + this._escapeAttr(tmpB.Name)
					+ ' | direct: ' + tmpStatus;
				if (tmpLatency !== null) { tmpTooltipData += ' | ' + tmpLatency + 'ms'; }
				if (tmpLastProbe) { tmpTooltipData += ' | ' + tmpLastProbe; }

				tmpSVG += '<line x1="' + tmpEdgeA.x + '" y1="' + tmpEdgeA.y + '"'
					+ ' x2="' + tmpEdgeB.x + '" y2="' + tmpEdgeB.y + '"'
					+ ' stroke="' + tmpLineColor + '" stroke-width="' + tmpStrokeWidth + '"'
					+ (tmpDashArray ? ' stroke-dasharray="' + tmpDashArray + '"' : '')
					+ ' style="cursor:pointer;"'
					+ ' onmousemove="' + tmpViewRef + '.showTooltip(event, \'' + this._escapeAttr(tmpTooltipData) + '\')"'
					+ ' onmouseleave="' + tmpViewRef + '.hideTooltip()"'
					+ '/>';
			}
		}

		// ── Layer 3: Ultravisor hub circle ──
		tmpSVG += '<circle cx="' + tmpCenterX + '" cy="' + tmpCenterY + '" r="' + tmpHubRadius + '"'
			+ ' fill="var(--uv-bg-elevated)" stroke="var(--uv-brand)" stroke-width="2.5"'
			+ ' style="cursor:pointer;"'
			+ ' onmousemove="' + tmpViewRef + '.showTooltip(event, \''
			+ this._escapeAttr(tmpHub.Name + ' | hub | ' + tmpBeacons.filter(function (pB) { return pB.WSConnected; }).length + ' connected') + '\')"'
			+ ' onmouseleave="' + tmpViewRef + '.hideTooltip()"/>';
		tmpSVG += '<text x="' + tmpCenterX + '" y="' + (tmpCenterY + 5) + '"'
			+ ' text-anchor="middle" fill="var(--uv-brand)" font-size="11" font-weight="700"'
			+ ' style="pointer-events:none;">UV</text>';

		// ── Layer 4: beacon nodes (with no-listener treatment) ──
		for (let i = 0; i < tmpBeacons.length; i++)
		{
			let tmpBeacon = tmpBeacons[i];
			let tmpX = tmpPositions[i].x;
			let tmpY = tmpPositions[i].y;
			let tmpIsOnline = (tmpBeacon.Status || '').toLowerCase() === 'online';
			let tmpFill = tmpIsOnline ? 'var(--uv-bg-elevated)' : 'var(--uv-bg-base)';
			let tmpStroke = tmpIsOnline ? 'var(--uv-success)' : 'var(--uv-text-tertiary)';
			let tmpTextColor = tmpIsOnline ? 'var(--uv-text)' : 'var(--uv-text-tertiary)';
			let tmpOpacity = tmpIsOnline ? '1' : '0.5';

			// no-listener treatment: amber dashed border on the inside,
			// keeping the green online ring outside.  Communicates "this
			// beacon is alive but offers no direct HTTP transport — its
			// only edges are the WS line to UV."
			let tmpNoListener = tmpIsOnline && !tmpBeacon.HasListener;

			let tmpTooltipParts = [tmpBeacon.Name || tmpBeacon.BeaconID || '?'];
			tmpTooltipParts.push(tmpBeacon.Status || 'unknown');
			tmpTooltipParts.push(tmpBeacon.HasListener ? 'has HTTP listener' : 'no HTTP listener (broker-only)');
			tmpTooltipParts.push(tmpBeacon.WSConnected ? 'WS connected' : 'WS disconnected');
			let tmpTooltip = this._escapeAttr(tmpTooltipParts.join(' | '));

			tmpSVG += '<g opacity="' + tmpOpacity + '"'
				+ ' onmousemove="' + tmpViewRef + '.showTooltip(event, \'' + tmpTooltip + '\')"'
				+ ' onmouseleave="' + tmpViewRef + '.hideTooltip()"'
				+ ' style="cursor:pointer;">';
			tmpSVG += '<circle cx="' + tmpX + '" cy="' + tmpY + '" r="' + tmpNodeRadius + '"'
				+ ' fill="' + tmpFill + '" stroke="' + tmpStroke + '" stroke-width="2"/>';
			if (tmpNoListener)
			{
				tmpSVG += '<circle cx="' + tmpX + '" cy="' + tmpY + '" r="' + (tmpNodeRadius - 5) + '"'
					+ ' fill="none" stroke="#b45309" stroke-width="1.5" stroke-dasharray="3,3"/>';
			}

			// Beacon name (truncated)
			let tmpDisplayName = tmpBeacon.Name || tmpBeacon.BeaconID || '?';
			if (tmpDisplayName.length > 11)
			{
				tmpDisplayName = tmpDisplayName.substring(0, 10) + '…';
			}
			tmpSVG += '<text x="' + tmpX + '" y="' + (tmpY + 3) + '"'
				+ ' text-anchor="middle" fill="' + tmpTextColor + '"'
				+ ' font-size="9" font-weight="500" style="pointer-events:none;">'
				+ this._escapeHTML(tmpDisplayName) + '</text>';

			// Online status dot (top-right)
			let tmpDotColor = tmpIsOnline ? '#66bb6a' : '#757575';
			tmpSVG += '<circle cx="' + (tmpX + tmpNodeRadius - 4) + '" cy="' + (tmpY - tmpNodeRadius + 4) + '"'
				+ ' r="4" fill="' + tmpDotColor + '"/>';

			tmpSVG += '</g>';
		}

		tmpSVG += '</svg>';
		this.pict.ContentAssignment.assignContent('#Ultravisor-ReachabilityMap-Canvas', tmpSVG);
	}

	// ── Geometry helpers ──

	// Move a line endpoint from a node centre to its border so the line
	// stops at the circle edge instead of vanishing under the node.
	_edgePoint(pFromX, pFromY, pToX, pToY, pRadius)
	{
		let tmpDX = pToX - pFromX;
		let tmpDY = pToY - pFromY;
		let tmpDist = Math.sqrt(tmpDX * tmpDX + tmpDY * tmpDY) || 1;
		return {
			x: pFromX + (tmpDX / tmpDist) * pRadius,
			y: pFromY + (tmpDY / tmpDist) * pRadius
		};
	}

	// ── Status Helpers ──

	_combinedStatus(pEntryAB, pEntryBA)
	{
		let tmpStatusA = pEntryAB ? pEntryAB.Status : 'untested';
		let tmpStatusB = pEntryBA ? pEntryBA.Status : 'untested';

		// 'reachable' wins (any working direction implies path exists)
		if (tmpStatusA === 'reachable' || tmpStatusB === 'reachable') return 'reachable';
		// 'no-listener' is structural — propagate when either side reports it.
		if (tmpStatusA === 'no-listener' || tmpStatusB === 'no-listener') return 'no-listener';
		if (tmpStatusA === 'unreachable' || tmpStatusB === 'unreachable') return 'unreachable';
		return 'untested';
	}

	_bestLatency(pEntryAB, pEntryBA)
	{
		let tmpA = pEntryAB && pEntryAB.ProbeLatencyMs !== null ? pEntryAB.ProbeLatencyMs : null;
		let tmpB = pEntryBA && pEntryBA.ProbeLatencyMs !== null ? pEntryBA.ProbeLatencyMs : null;
		if (tmpA !== null && tmpB !== null) return Math.min(tmpA, tmpB);
		return tmpA !== null ? tmpA : tmpB;
	}

	_latestProbe(pEntryAB, pEntryBA)
	{
		let tmpA = pEntryAB ? pEntryAB.LastProbeAt : null;
		let tmpB = pEntryBA ? pEntryBA.LastProbeAt : null;
		if (tmpA && tmpB) return new Date(tmpA) > new Date(tmpB) ? tmpA : tmpB;
		return tmpA || tmpB || null;
	}

	// ── Tooltip ──

	showTooltip(pEvent, pText)
	{
		let tmpTooltip = document.getElementById('Ultravisor-ReachabilityMap-Tooltip');
		if (!tmpTooltip) return;
		tmpTooltip.textContent = pText;
		tmpTooltip.classList.add('visible');
		let tmpContainer = tmpTooltip.parentElement;
		if (tmpContainer)
		{
			let tmpRect = tmpContainer.getBoundingClientRect();
			tmpTooltip.style.left = (pEvent.clientX - tmpRect.left + 12) + 'px';
			tmpTooltip.style.top = (pEvent.clientY - tmpRect.top - 8) + 'px';
		}
	}

	hideTooltip()
	{
		let tmpTooltip = document.getElementById('Ultravisor-ReachabilityMap-Tooltip');
		if (tmpTooltip) { tmpTooltip.classList.remove('visible'); }
	}

	// ── Helpers ──

	_escapeHTML(pString)
	{
		if (typeof pString !== 'string') return '';
		return pString
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	_escapeAttr(pString)
	{
		if (typeof pString !== 'string') return '';
		return pString
			.replace(/&/g, '&amp;')
			.replace(/'/g, '&#39;')
			.replace(/"/g, '&quot;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;');
	}
}

module.exports = UltravisorReachabilityMapView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],271:[function(require,module,exports){
const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-Schedule",

	DefaultRenderable: "Ultravisor-Schedule-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-schedule {
			padding: 2em;
			max-width: 1400px;
			margin: 0 auto;
		}
		.ultravisor-schedule-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1.5em;
			padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-schedule-header h1 {
			margin: 0;
			font-size: 2em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.ultravisor-schedule-controls {
			display: flex;
			gap: 0.5em;
		}
		.ultravisor-schedule-table {
			width: 100%;
			border-collapse: collapse;
			margin-bottom: 2em;
		}
		.ultravisor-schedule-table th {
			background-color: var(--uv-bg-surface);
		}
		.ultravisor-schedule-table tr:hover td {
			background-color: var(--uv-table-row-hover);
		}
		.ultravisor-schedule-active {
			display: inline-block;
			padding: 0.1em 0.5em;
			border-radius: 3px;
			font-size: 0.8em;
			font-weight: 600;
		}
		.ultravisor-schedule-active.yes {
			background-color: var(--uv-success);
			color: var(--uv-btn-primary-text);
		}
		.ultravisor-schedule-active.no {
			background-color: var(--uv-bg-elevated);
			color: var(--uv-text-tertiary);
		}
		.ultravisor-schedule-add-section {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			padding: 1.5em;
			margin-top: 1em;
		}
		.ultravisor-schedule-add-section h3 {
			margin: 0 0 1em 0;
			font-size: 1.1em;
			font-weight: 600;
			color: var(--uv-text-secondary);
		}
		.ultravisor-schedule-add-form {
			display: flex;
			flex-wrap: wrap;
			gap: 0.75em;
			align-items: flex-end;
		}
		.ultravisor-schedule-add-form .ultravisor-form-group {
			margin-bottom: 0;
		}
		.ultravisor-schedule-add-form .ultravisor-form-group label {
			display: block;
			margin-bottom: 0.35em;
			font-size: 0.8em;
			font-weight: 600;
			color: var(--uv-text-secondary);
			text-transform: uppercase;
			letter-spacing: 0.03em;
		}

		/* Crontab builder */
		.ultravisor-cron-builder {
			margin-top: 0.75em;
			padding: 1em;
			background: var(--uv-bg-base);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 6px;
		}
		.ultravisor-cron-presets {
			display: flex;
			gap: 0.4em;
			flex-wrap: wrap;
			margin-bottom: 0.75em;
		}
		.ultravisor-cron-preset-btn {
			background: var(--uv-btn-secondary-bg);
			color: var(--uv-btn-secondary-text);
			border: 1px solid var(--uv-border);
			border-radius: 4px;
			padding: 0.3em 0.7em;
			font-size: 0.78em;
			cursor: pointer;
			transition: background-color 0.15s, border-color 0.15s;
		}
		.ultravisor-cron-preset-btn:hover {
			border-color: var(--uv-brand);
			color: var(--uv-text-heading);
		}
		.ultravisor-cron-preset-btn.active {
			background: var(--uv-brand);
			color: var(--uv-btn-primary-text);
			border-color: var(--uv-brand);
		}
		.ultravisor-cron-fields {
			display: flex;
			gap: 0.5em;
			align-items: flex-end;
			margin-bottom: 0.5em;
		}
		.ultravisor-cron-field {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 5em;
		}
		.ultravisor-cron-field label {
			font-size: 0.7em;
			font-weight: 600;
			color: var(--uv-text-tertiary);
			text-transform: uppercase;
			letter-spacing: 0.05em;
			margin-bottom: 0.3em;
		}
		.ultravisor-cron-field input {
			width: 100%;
			text-align: center;
			font-family: monospace;
			font-size: 0.95em;
			padding: 0.35em 0.25em;
			background: var(--uv-bg-input);
			color: var(--uv-text);
			border: 1px solid var(--uv-border);
			border-radius: 4px;
		}
		.ultravisor-cron-field input:focus {
			outline: none;
			border-color: var(--uv-border-focus);
		}
		.ultravisor-cron-field input:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}
		.ultravisor-cron-preview {
			display: flex;
			align-items: center;
			gap: 0.75em;
			margin-top: 0.5em;
			font-size: 0.85em;
			flex-wrap: wrap;
		}
		.ultravisor-cron-preview code {
			color: var(--uv-brand);
			font-size: 1.05em;
			background: var(--uv-bg-code);
			padding: 0.15em 0.5em;
			border-radius: 3px;
		}
		.ultravisor-cron-description {
			color: var(--uv-text-secondary);
			font-style: italic;
		}
		.ultravisor-cron-raw-toggle {
			background: none;
			border: none;
			color: var(--uv-link);
			font-size: 0.8em;
			cursor: pointer;
			padding: 0;
			text-decoration: underline;
		}
		.ultravisor-cron-raw-toggle:hover {
			color: var(--uv-link-hover);
		}
		.ultravisor-cron-raw-input {
			margin-top: 0.5em;
		}
		.ultravisor-cron-raw-input input {
			font-family: monospace;
			font-size: 0.95em;
			padding: 0.35em 0.5em;
			background: var(--uv-bg-input);
			color: var(--uv-text);
			border: 1px solid var(--uv-border);
			border-radius: 4px;
			width: 14em;
		}
		.ultravisor-cron-raw-input input:focus {
			outline: none;
			border-color: var(--uv-border-focus);
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-Schedule-Template",
			Template: /*html*/`
<div class="ultravisor-schedule">
	<div class="ultravisor-schedule-header">
		<h1>Schedule</h1>
		<div class="ultravisor-schedule-controls">
			<button class="ultravisor-btn ultravisor-btn-primary" onclick="{~P~}.PictApplication.startSchedule(function(){ {~P~}.PictApplication.showView('Ultravisor-Schedule'); })">Start All</button>
			<button class="ultravisor-btn ultravisor-btn-danger" onclick="{~P~}.PictApplication.stopSchedule(function(){ {~P~}.PictApplication.showView('Ultravisor-Schedule'); })">Stop All</button>
			<button class="ultravisor-btn ultravisor-btn-secondary" onclick="{~P~}.PictApplication.showView('Ultravisor-Schedule')">Refresh</button>
		</div>
	</div>
	<div id="Ultravisor-Schedule-Body"></div>
	<div id="Ultravisor-Schedule-AddForms"></div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-Schedule-Content",
			TemplateHash: "Ultravisor-Schedule-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorScheduleView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._rawMode = false;
		this._activePreset = '';
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		// Load operations first (for the dropdown), then the schedule
		this.pict.PictApplication.loadOperations(
			function ()
			{
				this.pict.PictApplication.loadSchedule(
					function ()
					{
						this.renderScheduleTable();
						this.renderAddForms();
					}.bind(this));
			}.bind(this));

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	renderScheduleTable()
	{
		let tmpSchedule = this.pict.AppData.Ultravisor.Schedule;
		let tmpGlobalRef = '_Pict';
		let tmpOperations = this.pict.AppData.Ultravisor.Operations || {};

		if (!tmpSchedule || tmpSchedule.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-Schedule-Body',
				'<div class="ultravisor-empty-message">No schedule entries. Use the form below to add operations to the schedule.</div>');
			return;
		}

		let tmpHTML = '<table class="ultravisor-schedule-table">';
		tmpHTML += '<thead><tr><th>GUID</th><th>Type</th><th>Target</th><th>Cron</th><th>Active</th><th>Actions</th></tr></thead>';
		tmpHTML += '<tbody>';

		for (let i = 0; i < tmpSchedule.length; i++)
		{
			let tmpEntry = tmpSchedule[i];
			let tmpGUID = tmpEntry.GUID || '';
			let tmpEscGUID = tmpGUID.replace(/'/g, "\\'");
			let tmpActive = tmpEntry.Active ? 'yes' : 'no';

			// Show operation name if available
			let tmpTargetLabel = this.escapeHTML(tmpEntry.TargetHash || '');
			let tmpOp = tmpOperations[tmpEntry.TargetHash];
			if (tmpOp && tmpOp.Name)
			{
				tmpTargetLabel = this.escapeHTML(tmpOp.Name) + ' <code style="font-size:0.8em;">' + this.escapeHTML(tmpEntry.TargetHash) + '</code>';
			}

			tmpHTML += '<tr>';
			tmpHTML += '<td><code style="font-size:0.8em;">' + this.escapeHTML(tmpGUID) + '</code></td>';
			tmpHTML += '<td>' + this.escapeHTML(tmpEntry.TargetType || '') + '</td>';
			tmpHTML += '<td>' + tmpTargetLabel + '</td>';
			tmpHTML += '<td><code>' + this.escapeHTML(tmpEntry.CronExpression || tmpEntry.Parameters || '') + '</code></td>';
			tmpHTML += '<td><span class="ultravisor-schedule-active ' + tmpActive + '">' + (tmpEntry.Active ? 'Active' : 'Inactive') + '</span></td>';
			tmpHTML += '<td style="white-space:nowrap;">';
			if (tmpEntry.Active)
			{
				tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-secondary" onclick="' + tmpGlobalRef + '.PictApplication.stopScheduleEntry(\'' + tmpEscGUID + '\', function(){ ' + tmpGlobalRef + '.PictApplication.showView(\'Ultravisor-Schedule\'); })">Stop</button> ';
			}
			else
			{
				tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-primary" onclick="' + tmpGlobalRef + '.PictApplication.startScheduleEntry(\'' + tmpEscGUID + '\', function(){ ' + tmpGlobalRef + '.PictApplication.showView(\'Ultravisor-Schedule\'); })">Start</button> ';
			}
			tmpHTML += '<button class="ultravisor-btn-sm ultravisor-btn-delete" onclick="' + tmpGlobalRef + '.views[\'Ultravisor-Schedule\'].confirmRemoveEntry(\'' + tmpEscGUID + '\')">Remove</button>';
			tmpHTML += '</td>';
			tmpHTML += '</tr>';
		}

		tmpHTML += '</tbody></table>';
		this.pict.ContentAssignment.assignContent('#Ultravisor-Schedule-Body', tmpHTML);
	}

	renderAddForms()
	{
		let tmpViewRef = "_Pict.views['Ultravisor-Schedule']";
		let tmpOperations = this.pict.AppData.Ultravisor.OperationList || [];

		let tmpHTML = '';

		// Schedule an operation
		tmpHTML += '<div class="ultravisor-schedule-add-section">';
		tmpHTML += '<h3>Schedule an Operation</h3>';
		tmpHTML += '<div class="ultravisor-schedule-add-form">';

		// Operation dropdown
		tmpHTML += '<div class="ultravisor-form-group"><label>Operation</label>';
		tmpHTML += '<select id="Ultravisor-Schedule-OperationHash">';
		tmpHTML += '<option value="">Select an operation...</option>';
		for (let i = 0; i < tmpOperations.length; i++)
		{
			let tmpOp = tmpOperations[i];
			let tmpName = this.escapeHTML(tmpOp.Name || tmpOp.Hash);
			let tmpHash = this.escapeHTML(tmpOp.Hash);
			tmpHTML += '<option value="' + tmpHash + '">' + tmpName + ' (' + tmpHash + ')</option>';
		}
		tmpHTML += '</select></div>';

		// Schedule type
		tmpHTML += '<div class="ultravisor-form-group"><label>Schedule Type</label>';
		tmpHTML += '<select id="Ultravisor-Schedule-OperationScheduleType" onchange="' + tmpViewRef + '.onScheduleTypeChange()">';
		tmpHTML += '<option value="cron">Cron</option>';
		tmpHTML += '<option value="daily">Daily</option>';
		tmpHTML += '<option value="hourly">Hourly</option>';
		tmpHTML += '</select></div>';

		// Add button
		tmpHTML += '<button class="ultravisor-btn ultravisor-btn-primary" onclick="' + tmpViewRef + '.addOperationSchedule()">Add</button>';

		tmpHTML += '</div>';

		// Cron builder
		tmpHTML += this._renderCronBuilder(tmpViewRef);

		tmpHTML += '</div>';

		this.pict.ContentAssignment.assignContent('#Ultravisor-Schedule-AddForms', tmpHTML);

		// Initialize the preview
		this._updateCronExpression();
	}

	_renderCronBuilder(pViewRef)
	{
		let tmpHTML = '';

		tmpHTML += '<div class="ultravisor-cron-builder" id="Ultravisor-Cron-Builder">';

		// Preset buttons
		tmpHTML += '<div class="ultravisor-cron-presets">';
		tmpHTML += '<button class="ultravisor-cron-preset-btn" onclick="' + pViewRef + '.applyCronPreset(\'every-minute\')">Every Minute</button>';
		tmpHTML += '<button class="ultravisor-cron-preset-btn" onclick="' + pViewRef + '.applyCronPreset(\'hourly\')">Hourly</button>';
		tmpHTML += '<button class="ultravisor-cron-preset-btn" onclick="' + pViewRef + '.applyCronPreset(\'daily\')">Daily</button>';
		tmpHTML += '<button class="ultravisor-cron-preset-btn" onclick="' + pViewRef + '.applyCronPreset(\'weekly\')">Weekly</button>';
		tmpHTML += '<button class="ultravisor-cron-preset-btn" onclick="' + pViewRef + '.applyCronPreset(\'monthly\')">Monthly</button>';
		tmpHTML += '<button class="ultravisor-cron-preset-btn" onclick="' + pViewRef + '.applyCronPreset(\'every-6h\')">Every 6 Hours</button>';
		tmpHTML += '<button class="ultravisor-cron-preset-btn" onclick="' + pViewRef + '.applyCronPreset(\'every-15m\')">Every 15 Min</button>';
		tmpHTML += '</div>';

		// 5 cron fields
		tmpHTML += '<div class="ultravisor-cron-fields">';

		let tmpFields = [
			{ id: 'Minute', label: 'Minute', placeholder: '0-59' },
			{ id: 'Hour', label: 'Hour', placeholder: '0-23' },
			{ id: 'DayOfMonth', label: 'Day', placeholder: '1-31' },
			{ id: 'Month', label: 'Month', placeholder: '1-12' },
			{ id: 'Weekday', label: 'Wkday', placeholder: '0-6' }
		];

		for (let i = 0; i < tmpFields.length; i++)
		{
			let tmpField = tmpFields[i];
			tmpHTML += '<div class="ultravisor-cron-field">';
			tmpHTML += '<label>' + tmpField.label + '</label>';
			tmpHTML += '<input type="text" id="Ultravisor-Cron-' + tmpField.id + '" value="*" placeholder="' + tmpField.placeholder + '" oninput="' + pViewRef + '._updateCronExpression()">';
			tmpHTML += '</div>';
		}

		tmpHTML += '</div>';

		// Preview
		tmpHTML += '<div class="ultravisor-cron-preview">';
		tmpHTML += '<code id="Ultravisor-Cron-Expression">* * * * *</code>';
		tmpHTML += '<span class="ultravisor-cron-description" id="Ultravisor-Cron-Description">Every minute</span>';
		tmpHTML += '<button class="ultravisor-cron-raw-toggle" onclick="' + pViewRef + '.toggleRawMode()">edit raw</button>';
		tmpHTML += '</div>';

		// Hidden raw input
		tmpHTML += '<div class="ultravisor-cron-raw-input" id="Ultravisor-Cron-RawWrap" style="display:none;">';
		tmpHTML += '<input type="text" id="Ultravisor-Cron-RawInput" value="* * * * *" placeholder="min hour day month weekday" oninput="' + pViewRef + '._onRawInput()">';
		tmpHTML += '</div>';

		// Hidden field for the final expression value
		tmpHTML += '<input type="hidden" id="Ultravisor-Schedule-OperationParameters" value="* * * * *">';

		tmpHTML += '</div>';

		return tmpHTML;
	}

	applyCronPreset(pPreset)
	{
		let tmpPresets = {
			'every-minute': { m: '*', h: '*', d: '*', mo: '*', w: '*' },
			'hourly':       { m: '0', h: '*', d: '*', mo: '*', w: '*' },
			'daily':        { m: '0', h: '0', d: '*', mo: '*', w: '*' },
			'weekly':       { m: '0', h: '0', d: '*', mo: '*', w: '0' },
			'monthly':      { m: '0', h: '0', d: '1', mo: '*', w: '*' },
			'every-6h':     { m: '0', h: '*/6', d: '*', mo: '*', w: '*' },
			'every-15m':    { m: '*/15', h: '*', d: '*', mo: '*', w: '*' }
		};

		let tmpPreset = tmpPresets[pPreset];
		if (!tmpPreset)
		{
			return;
		}

		this._activePreset = pPreset;

		document.getElementById('Ultravisor-Cron-Minute').value = tmpPreset.m;
		document.getElementById('Ultravisor-Cron-Hour').value = tmpPreset.h;
		document.getElementById('Ultravisor-Cron-DayOfMonth').value = tmpPreset.d;
		document.getElementById('Ultravisor-Cron-Month').value = tmpPreset.mo;
		document.getElementById('Ultravisor-Cron-Weekday').value = tmpPreset.w;

		this._updateCronExpression();

		// Highlight active preset button
		let tmpButtons = document.querySelectorAll('.ultravisor-cron-preset-btn');
		for (let i = 0; i < tmpButtons.length; i++)
		{
			tmpButtons[i].classList.remove('active');
		}
		// Find the button that matches this preset by text content
		let tmpPresetLabels = {
			'every-minute': 'Every Minute',
			'hourly': 'Hourly',
			'daily': 'Daily',
			'weekly': 'Weekly',
			'monthly': 'Monthly',
			'every-6h': 'Every 6 Hours',
			'every-15m': 'Every 15 Min'
		};
		let tmpLabel = tmpPresetLabels[pPreset];
		for (let i = 0; i < tmpButtons.length; i++)
		{
			if (tmpButtons[i].textContent === tmpLabel)
			{
				tmpButtons[i].classList.add('active');
				break;
			}
		}
	}

	onScheduleTypeChange()
	{
		let tmpType = document.getElementById('Ultravisor-Schedule-OperationScheduleType').value;
		let tmpBuilder = document.getElementById('Ultravisor-Cron-Builder');

		if (!tmpBuilder)
		{
			return;
		}

		let tmpFields = tmpBuilder.querySelectorAll('.ultravisor-cron-field input');

		if (tmpType === 'daily')
		{
			this.applyCronPreset('daily');
			for (let i = 0; i < tmpFields.length; i++)
			{
				tmpFields[i].disabled = true;
			}
		}
		else if (tmpType === 'hourly')
		{
			this.applyCronPreset('hourly');
			for (let i = 0; i < tmpFields.length; i++)
			{
				tmpFields[i].disabled = true;
			}
		}
		else
		{
			for (let i = 0; i < tmpFields.length; i++)
			{
				tmpFields[i].disabled = false;
			}
		}
	}

	_updateCronExpression()
	{
		let tmpMinute = (document.getElementById('Ultravisor-Cron-Minute') || {}).value || '*';
		let tmpHour = (document.getElementById('Ultravisor-Cron-Hour') || {}).value || '*';
		let tmpDay = (document.getElementById('Ultravisor-Cron-DayOfMonth') || {}).value || '*';
		let tmpMonth = (document.getElementById('Ultravisor-Cron-Month') || {}).value || '*';
		let tmpWeekday = (document.getElementById('Ultravisor-Cron-Weekday') || {}).value || '*';

		let tmpExpression = tmpMinute + ' ' + tmpHour + ' ' + tmpDay + ' ' + tmpMonth + ' ' + tmpWeekday;

		// Update preview elements
		let tmpExprElem = document.getElementById('Ultravisor-Cron-Expression');
		if (tmpExprElem)
		{
			tmpExprElem.textContent = tmpExpression;
		}

		let tmpDescElem = document.getElementById('Ultravisor-Cron-Description');
		if (tmpDescElem)
		{
			tmpDescElem.textContent = this._describeCron(tmpExpression);
		}

		// Update hidden parameter field
		let tmpParamElem = document.getElementById('Ultravisor-Schedule-OperationParameters');
		if (tmpParamElem)
		{
			tmpParamElem.value = tmpExpression;
		}

		// Update raw input if visible
		let tmpRawInput = document.getElementById('Ultravisor-Cron-RawInput');
		if (tmpRawInput && !tmpRawInput.matches(':focus'))
		{
			tmpRawInput.value = tmpExpression;
		}

		// Clear active preset highlight when user edits manually
		this._activePreset = '';
		let tmpButtons = document.querySelectorAll('.ultravisor-cron-preset-btn');
		for (let i = 0; i < tmpButtons.length; i++)
		{
			tmpButtons[i].classList.remove('active');
		}
	}

	_onRawInput()
	{
		let tmpRawInput = document.getElementById('Ultravisor-Cron-RawInput');
		if (!tmpRawInput)
		{
			return;
		}

		let tmpParts = tmpRawInput.value.trim().split(/\s+/);
		if (tmpParts.length >= 5)
		{
			document.getElementById('Ultravisor-Cron-Minute').value = tmpParts[0];
			document.getElementById('Ultravisor-Cron-Hour').value = tmpParts[1];
			document.getElementById('Ultravisor-Cron-DayOfMonth').value = tmpParts[2];
			document.getElementById('Ultravisor-Cron-Month').value = tmpParts[3];
			document.getElementById('Ultravisor-Cron-Weekday').value = tmpParts[4];
		}

		let tmpExpression = tmpRawInput.value.trim();

		let tmpExprElem = document.getElementById('Ultravisor-Cron-Expression');
		if (tmpExprElem)
		{
			tmpExprElem.textContent = tmpExpression;
		}

		let tmpDescElem = document.getElementById('Ultravisor-Cron-Description');
		if (tmpDescElem)
		{
			tmpDescElem.textContent = this._describeCron(tmpExpression);
		}

		let tmpParamElem = document.getElementById('Ultravisor-Schedule-OperationParameters');
		if (tmpParamElem)
		{
			tmpParamElem.value = tmpExpression;
		}
	}

	toggleRawMode()
	{
		this._rawMode = !this._rawMode;

		let tmpRawWrap = document.getElementById('Ultravisor-Cron-RawWrap');
		let tmpToggle = document.querySelector('.ultravisor-cron-raw-toggle');

		if (tmpRawWrap)
		{
			tmpRawWrap.style.display = this._rawMode ? 'block' : 'none';
		}
		if (tmpToggle)
		{
			tmpToggle.textContent = this._rawMode ? 'use builder' : 'edit raw';
		}
	}

	_describeCron(pExpression)
	{
		let tmpParts = pExpression.trim().split(/\s+/);
		if (tmpParts.length < 5)
		{
			return pExpression;
		}

		let tmpMin = tmpParts[0];
		let tmpHour = tmpParts[1];
		let tmpDay = tmpParts[2];
		let tmpMonth = tmpParts[3];
		let tmpWeekday = tmpParts[4];

		let tmpDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

		// Every minute
		if (tmpMin === '*' && tmpHour === '*' && tmpDay === '*' && tmpMonth === '*' && tmpWeekday === '*')
		{
			return 'Every minute';
		}

		// Every N minutes
		let tmpMinStep = tmpMin.match(/^\*\/(\d+)$/);
		if (tmpMinStep && tmpHour === '*' && tmpDay === '*' && tmpMonth === '*' && tmpWeekday === '*')
		{
			return 'Every ' + tmpMinStep[1] + ' minutes';
		}

		// Every hour at :MM
		if (tmpMin !== '*' && tmpHour === '*' && tmpDay === '*' && tmpMonth === '*' && tmpWeekday === '*')
		{
			return 'Every hour at :' + tmpMin.padStart(2, '0');
		}

		// Every N hours
		let tmpHourStep = tmpHour.match(/^\*\/(\d+)$/);
		if (tmpMin !== '*' && tmpHourStep && tmpDay === '*' && tmpMonth === '*' && tmpWeekday === '*')
		{
			return 'Every ' + tmpHourStep[1] + ' hours';
		}

		// Daily at specific time
		if (tmpMin !== '*' && tmpHour !== '*' && tmpDay === '*' && tmpMonth === '*' && tmpWeekday === '*')
		{
			return 'Daily at ' + tmpHour.padStart(2, '0') + ':' + tmpMin.padStart(2, '0');
		}

		// Weekly on specific day
		if (tmpMin !== '*' && tmpHour !== '*' && tmpDay === '*' && tmpMonth === '*' && tmpWeekday !== '*')
		{
			let tmpDayName = tmpDayNames[parseInt(tmpWeekday)] || 'day ' + tmpWeekday;
			return 'Weekly on ' + tmpDayName + ' at ' + tmpHour.padStart(2, '0') + ':' + tmpMin.padStart(2, '0');
		}

		// Monthly on specific day
		if (tmpMin !== '*' && tmpHour !== '*' && tmpDay !== '*' && tmpMonth === '*' && tmpWeekday === '*')
		{
			let tmpSuffix = 'th';
			let tmpDayNum = parseInt(tmpDay);
			if (tmpDayNum === 1 || tmpDayNum === 21 || tmpDayNum === 31) tmpSuffix = 'st';
			else if (tmpDayNum === 2 || tmpDayNum === 22) tmpSuffix = 'nd';
			else if (tmpDayNum === 3 || tmpDayNum === 23) tmpSuffix = 'rd';
			return 'Monthly on the ' + tmpDay + tmpSuffix + ' at ' + tmpHour.padStart(2, '0') + ':' + tmpMin.padStart(2, '0');
		}

		// Fallback
		return pExpression;
	}

	addOperationSchedule()
	{
		let tmpHash = document.getElementById('Ultravisor-Schedule-OperationHash').value.trim();
		let tmpType = document.getElementById('Ultravisor-Schedule-OperationScheduleType').value;
		let tmpParams = document.getElementById('Ultravisor-Schedule-OperationParameters').value.trim();

		if (!tmpHash)
		{
			this.pict.views.Modal.toast('Please select an operation.', { type: 'warning' });
			return;
		}

		this.pict.PictApplication.scheduleOperation(tmpHash, tmpType, tmpParams,
			function (pError)
			{
				if (pError)
				{
					this.pict.views.Modal.toast('Error scheduling operation: ' + pError.message, { type: 'error' });
					return;
				}
				this.pict.PictApplication.showView('Ultravisor-Schedule');
			}.bind(this));
	}

	confirmRemoveEntry(pGUID)
	{
		this.pict.views.Modal.confirm('Remove schedule entry?', { confirmLabel: 'Remove', dangerous: true }).then(
			function (pConfirmed)
			{
				if (pConfirmed)
				{
					this.pict.PictApplication.removeScheduleEntry(pGUID,
						function ()
						{
							this.pict.PictApplication.showView('Ultravisor-Schedule');
						}.bind(this));
				}
			}.bind(this));
	}

	escapeHTML(pValue)
	{
		if (!pValue) return '';
		return String(pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}
}

module.exports = UltravisorScheduleView;

module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],272:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Ultravisor-SettingsPanel — content of the hidden right-side settings
 * panel managed by the shell. The panel itself is built in
 * Layout._buildShell() with Hidden:true; the gear button in TopBar-User
 * toggles its visibility. This view just renders the panel's interior.
 *
 * Sections:
 *   - Appearance — pict-section-theme controls (Picker / ModeToggle /
 *                  ScaleSelect) mounted via Theme-Section.mount() on
 *                  every render.
 *   - Run Mode — Debug Mode toggle (writes to AppData.Ultravisor.DebugMode).
 *
 * Theme state is owned by pict-section-theme (its own localStorage
 * scope). No app-managed theme keys.
 */

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-SettingsPanel",

	DefaultRenderable: "Ultravisor-SettingsPanel-Display",
	DefaultDestinationAddress: "#Ultravisor-Settings-Panel",

	AutoRender: false,

	CSS: /*css*/`
		#Ultravisor-Settings-Panel .uv-settings-body
		{
			padding: 14px 16px 24px;
			font-size: 0.85rem;
			color: var(--theme-color-text-primary, #c8b8a0);
			background: var(--theme-color-background-panel, var(--theme-color-background-secondary, #252018));
			height: 100%;
			box-sizing: border-box;
			overflow-y: auto;
		}
		.uv-settings-section { margin-bottom: 18px; }
		.uv-settings-label
		{
			font-size: 0.72rem;
			font-weight: 700;
			text-transform: uppercase;
			letter-spacing: 0.6px;
			color: var(--theme-color-text-muted, #8a7f72);
			margin-bottom: 8px;
		}
		.uv-settings-row
		{
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 6px 0;
			min-height: 28px;
		}
		.uv-settings-checkbox-label
		{
			font-size: 0.85rem;
			color: var(--theme-color-text-primary, #c8b8a0);
		}
		.uv-settings-checkbox
		{
			width: 16px;
			height: 16px;
			cursor: pointer;
			accent-color: var(--theme-color-brand-primary, #c4956a);
		}
		.uv-settings-divider
		{
			height: 1px;
			background: var(--theme-color-border-light, #302818);
			margin: 12px 0;
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-SettingsPanel-Template",
			Template: /*html*/`
<div class="uv-settings-body">
	<div class="uv-settings-section">
		<div class="uv-settings-label">Appearance</div>
		<div id="Ultravisor-Settings-Theme"></div>
	</div>
	<div class="uv-settings-divider"></div>
	<div class="uv-settings-section">
		<div class="uv-settings-label">Run Mode</div>
		<div class="uv-settings-row">
			<label class="uv-settings-checkbox-label" for="Ultravisor-Setting-DebugMode">Debug Mode</label>
			<input id="Ultravisor-Setting-DebugMode" type="checkbox" class="uv-settings-checkbox"
				onchange="{~P~}.views['Ultravisor-SettingsPanel'].toggleDebugMode(this.checked)" />
		</div>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-SettingsPanel-Display",
			TemplateHash: "Ultravisor-SettingsPanel-Template",
			DestinationAddress: "#Ultravisor-Settings-Panel",
			RenderMethod: "replace"
		}
	]
};

class UltravisorSettingsPanelView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Mount theme controls on EVERY render — the template re-render erases
		// the previously-mounted destination divs.
		let tmpThemeProvider = this.pict.providers && this.pict.providers['Theme-Section'];
		if (tmpThemeProvider && typeof tmpThemeProvider.mount === 'function')
		{
			tmpThemeProvider.mount(
			{
				Container: '#Ultravisor-Settings-Theme',
				Views: ['Picker', 'ModeToggle', 'ScaleSelect']
			});
		}

		// Sync DebugMode checkbox from AppData.
		let tmpCheckbox = document.getElementById('Ultravisor-Setting-DebugMode');
		if (tmpCheckbox)
		{
			tmpCheckbox.checked = !!(this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.DebugMode);
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	toggleDebugMode(pChecked)
	{
		if (!this.pict.AppData.Ultravisor) { this.pict.AppData.Ultravisor = {}; }
		this.pict.AppData.Ultravisor.DebugMode = !!pChecked;
	}
}

module.exports = UltravisorSettingsPanelView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],273:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Ultravisor-Sidebar — content view rendered into the shell's left panel.
 *
 * Route-aware:
 *   - When CurrentRoute is a dashboard route (/Dashboards or any of the
 *     7 dashboard sub-routes), shows the dashboard list as a vertical menu.
 *   - For other routes, shows a placeholder section-context container with
 *     the section name and an empty slot for per-section content (operations
 *     list, beacon list, manifest list, ...) that lands in follow-ups.
 */

const DASHBOARD_LIST =
[
	{ Hash: 'Timeline',          Label: 'Timeline',            Route: '/Timeline' },
	{ Hash: 'Throughput',        Label: 'Throughput',          Route: '/Throughput' },
	{ Hash: 'Capabilities',      Label: 'Capabilities',        Route: '/Capabilities' },
	{ Hash: 'Constellation',     Label: 'Constellation',       Route: '/Constellation' },
	{ Hash: 'ReachabilityMap',   Label: 'Reachability Map',    Route: '/ReachabilityMap' },
	{ Hash: 'Timing',            Label: 'Timing',              Route: '/Timing' },
	{ Hash: 'CapabilityHeatMap', Label: 'Capability Heat Map', Route: '/CapabilityHeatMap' }
];

const DASHBOARD_ROUTES = ['/Dashboards'].concat(DASHBOARD_LIST.map(d => d.Route));

const SECTION_LABELS =
{
	'/Home':       'Dashboard',
	'/Operations': 'Operations',
	'/Schedule':   'Schedule',
	'/Manifests':  'Manifests',
	'/Beacons':    'Beacons',
	'/Fleet':      'Fleet',
	'/Users':      'Users',
	'/Docs':       'Documentation',
	'/FlowEditor': 'Flow Editor',
	'/Login':      'Sign In'
};

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-Sidebar",

	DefaultRenderable: "Ultravisor-Sidebar-Display",
	DefaultDestinationAddress: "#Ultravisor-Sidebar-Host",

	AutoRender: false,

	CSS: /*css*/`
		.uv-sidebar
		{
			display: flex;
			flex-direction: column;
			height: 100%;
			min-height: 0;
			background: var(--theme-color-background-panel, var(--theme-color-background-secondary, #252018));
			color: var(--theme-color-text-primary, #c8b8a0);
			overflow: hidden;
		}
		.uv-sidebar-header
		{
			padding: 12px 14px 8px;
			font-size: 0.7em;
			text-transform: uppercase;
			letter-spacing: 1.2px;
			color: var(--theme-color-text-muted, #8a7f72);
			border-bottom: 1px solid var(--theme-color-border-light, #302818);
		}
		.uv-sidebar-section-title
		{
			padding: 14px 16px 6px;
			font-size: 0.95em;
			font-weight: 600;
			color: var(--theme-color-text-secondary, var(--theme-color-text-primary, #d8c8a8));
		}
		.uv-sidebar-list
		{
			display: flex;
			flex-direction: column;
			padding: 4px 0;
			overflow-y: auto;
			min-height: 0;
		}
		.uv-sidebar-item
		{
			padding: 8px 16px;
			cursor: pointer;
			color: var(--theme-color-text-primary, #c8b8a0);
			font-size: 0.88em;
			border-left: 3px solid transparent;
			transition: background-color 0.12s, border-color 0.12s, color 0.12s;
		}
		.uv-sidebar-item:hover
		{
			background: var(--theme-color-background-hover, rgba(255, 255, 255, 0.04));
			color: var(--theme-color-text-secondary, var(--theme-color-text-primary, #d8c8a8));
		}
		.uv-sidebar-item.active
		{
			background: var(--theme-color-background-selected, var(--theme-color-background-hover, rgba(255, 255, 255, 0.08)));
			color: var(--theme-color-brand-primary, var(--theme-color-text-primary, #c4956a));
			border-left-color: var(--theme-color-brand-primary, #c4956a);
			font-weight: 600;
		}
		.uv-sidebar-placeholder
		{
			padding: 16px;
			color: var(--theme-color-text-muted, #907860);
			font-size: 0.82em;
			font-style: italic;
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-Sidebar-Template",
			Template: /*html*/`
<div class="uv-sidebar">
	<div class="uv-sidebar-header">{~D:AppData.Ultravisor.Sidebar.HeaderLabel~}</div>
	{~TS:Ultravisor-Sidebar-LockedBlock:AppData.Ultravisor.Sidebar.LockedBlock~}
	{~TS:Ultravisor-Sidebar-DashboardListBlock:AppData.Ultravisor.Sidebar.DashboardListBlock~}
	{~TS:Ultravisor-Sidebar-SectionContextBlock:AppData.Ultravisor.Sidebar.SectionContextBlock~}
</div>`
		},
		{
			Hash: "Ultravisor-Sidebar-LockedBlock",
			Template: /*html*/`
<div class="uv-sidebar-placeholder">Sign in to access Ultravisor.</div>`
		},
		{
			Hash: "Ultravisor-Sidebar-DashboardListBlock",
			Template: /*html*/`
<div class="uv-sidebar-section-title">All Dashboards</div>
<div class="uv-sidebar-list">{~TS:Ultravisor-Sidebar-DashboardRow:Record.Items~}</div>`
		},
		{
			Hash: "Ultravisor-Sidebar-DashboardRow",
			Template: /*html*/`<a class="uv-sidebar-item{~D:Record.ActiveClass~}" onclick="{~P~}.PictApplication.navigateTo('{~D:Record.Route~}')">{~D:Record.Label~}</a>`
		},
		{
			Hash: "Ultravisor-Sidebar-SectionContextBlock",
			Template: /*html*/`
<div class="uv-sidebar-section-title">{~D:Record.SectionLabel~}</div>
<div class="uv-sidebar-list" id="Ultravisor-Sidebar-Slot">{~TS:Ultravisor-Sidebar-Item:Record.Items~}</div>
{~TS:Ultravisor-Sidebar-EmptySlot:Record.EmptyItems~}`
		},
		{
			Hash: "Ultravisor-Sidebar-Item",
			Template: /*html*/`<a class="uv-sidebar-item{~D:Record.ActiveClass~}" onclick="{~P~}.PictApplication.navigateTo('{~D:Record.Route~}')">{~D:Record.Label~}</a>`
		},
		{
			Hash: "Ultravisor-Sidebar-EmptySlot",
			Template: /*html*/`<div class="uv-sidebar-placeholder">No items yet for this section.</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-Sidebar-Display",
			TemplateHash: "Ultravisor-Sidebar-Template",
			DestinationAddress: "#Ultravisor-Sidebar-Host",
			RenderMethod: "replace"
		}
	]
};

class UltravisorSidebarView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord)
	{
		let tmpRoute = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.CurrentRoute) || '/Home';

		if (!this.pict.AppData.Ultravisor) { this.pict.AppData.Ultravisor = {}; }
		if (!this.pict.AppData.Ultravisor.Sidebar) { this.pict.AppData.Ultravisor.Sidebar = {}; }
		let tmpSidebar = this.pict.AppData.Ultravisor.Sidebar;

		// Auth gate: while signed out in authenticated mode the sidebar
		// offers no navigation — just a sign-in prompt.  Clearing the
		// dashboard + section blocks and showing the locked block keeps the
		// context panel from exposing any of the application surface.
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.isLoginRequired === 'function' && tmpApp.isLoginRequired())
		{
			tmpSidebar.HeaderLabel = 'Sign In';
			tmpSidebar.LockedBlock = [{}];
			tmpSidebar.DashboardListBlock = [];
			tmpSidebar.SectionContextBlock = [];
			return super.onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord);
		}
		tmpSidebar.LockedBlock = [];

		let tmpIsDashboardRoute = this._isDashboardRoute(tmpRoute);

		if (tmpIsDashboardRoute)
		{
			tmpSidebar.HeaderLabel = 'Dashboards';

			let tmpItems = [];
			for (let i = 0; i < DASHBOARD_LIST.length; i++)
			{
				let tmpDash = DASHBOARD_LIST[i];
				tmpItems.push(
				{
					Label:       tmpDash.Label,
					Route:       tmpDash.Route,
					ActiveClass: (tmpRoute === tmpDash.Route) ? ' active' : ''
				});
			}

			tmpSidebar.DashboardListBlock = [{ Items: tmpItems }];
			tmpSidebar.SectionContextBlock = [];
		}
		else
		{
			tmpSidebar.HeaderLabel = 'Context';

			let tmpSlot = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.SidebarSlot)
				? this.pict.AppData.Ultravisor.SidebarSlot : [];

			tmpSidebar.DashboardListBlock = [];
			tmpSidebar.SectionContextBlock =
			[{
				SectionLabel: this._sectionLabel(tmpRoute),
				Items:        Array.isArray(tmpSlot) ? tmpSlot : [],
				EmptyItems:   (Array.isArray(tmpSlot) && tmpSlot.length > 0) ? [] : [{}]
			}];
		}

		return super.onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_isDashboardRoute(pRoute)
	{
		for (let i = 0; i < DASHBOARD_ROUTES.length; i++)
		{
			if (pRoute === DASHBOARD_ROUTES[i] || pRoute.indexOf(DASHBOARD_ROUTES[i] + '/') === 0)
			{
				return true;
			}
		}
		return false;
	}

	_sectionLabel(pRoute)
	{
		let tmpKeys = Object.keys(SECTION_LABELS);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpKey = tmpKeys[i];
			if (pRoute === tmpKey || pRoute.indexOf(tmpKey + '/') === 0)
			{
				return SECTION_LABELS[tmpKey];
			}
		}
		return 'Ultravisor';
	}
}

module.exports = UltravisorSidebarView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],274:[function(require,module,exports){
/**
 * PictView-Ultravisor-Throughput
 *
 * Phase 7 / throughput chart — answers "are we keeping up with demand?"
 * Stacked-area chart of completions per bucket by terminal status.
 * Vertical bands mark windows where Admission.Denied events fired.
 *
 * Standalone view at `/Throughput`. Same window-preset pattern as the
 * heat map; same `/Timeline?bucket=auto` data source.
 */

const libPictView = require('pict-view');
const libRenderThroughput = require('./timeline/render-throughput.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Ultravisor-Throughput',

	DefaultRenderable: 'Ultravisor-Throughput-Content',
	DefaultDestinationAddress: '#Ultravisor-Content-Container',

	AutoRender: false,

	CSS: /*css*/`
		.uv-throughput {
			padding: 1.5em;
			max-width: 1800px;
			margin: 0 auto;
		}
		.uv-throughput-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1em;
			padding-bottom: 0.75em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.uv-throughput-header h1 {
			margin: 0;
			font-size: 1.6em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.uv-throughput-windows {
			display: flex;
			align-items: center;
			gap: 0.4em;
		}
		.uv-throughput-windows button {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			color: var(--uv-text-secondary);
			padding: 0.3em 0.7em;
			border-radius: 4px;
			cursor: pointer;
			font-size: 0.85em;
		}
		.uv-throughput-windows button:hover { border-color: var(--uv-brand); color: var(--uv-text); }
		.uv-throughput-windows button.active {
			background: var(--uv-brand);
			border-color: var(--uv-brand);
			color: var(--uv-text-on-brand, #fff);
		}
		.uv-throughput-canvas-wrap {
			width: 100%;
			height: 460px;
			background: var(--uv-bg-base);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 6px;
			position: relative;
		}
		.uv-throughput-canvas {
			position: absolute;
			top: 0; left: 0;
			width: 100%;
			height: 100%;
		}
		.uv-throughput-stats {
			display: flex;
			gap: 1.25em;
			margin-top: 0.6em;
			font-size: 0.78em;
			color: var(--uv-text-secondary);
			font-family: monospace;
		}
		.uv-throughput-stats strong { color: var(--uv-text); font-weight: 600; }
		.uv-throughput-help {
			margin-top: 1em;
			padding: 0.75em 1em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			font-size: 0.78em;
			color: var(--uv-text-secondary);
			line-height: 1.55;
		}
	`,

	Templates:
	[
		{
			Hash: 'Ultravisor-Throughput-Template',
			Template: /*html*/`
<div class="uv-throughput">
	<div class="uv-throughput-header">
		<h1>Throughput</h1>
		<div class="uv-throughput-windows">
			{~TS:Ultravisor-Throughput-WindowButton-Template:AppData.Throughput.WindowButtons~}
		</div>
	</div>
	<div class="uv-throughput-canvas-wrap">
		<canvas class="uv-throughput-canvas" id="Ultravisor-Throughput-Canvas"></canvas>
	</div>
	<div class="uv-throughput-stats" id="Ultravisor-Throughput-Stats">
		<span>completions: <strong>{~D:AppData.Throughput.Stats.Complete~}</strong></span>
		<span>failed: <strong>{~D:AppData.Throughput.Stats.Failed~}</strong></span>
		<span>stalled: <strong>{~D:AppData.Throughput.Stats.Stalled~}</strong></span>
		<span>canceled: <strong>{~D:AppData.Throughput.Stats.Canceled~}</strong></span>
		<span>denials: <strong>{~D:AppData.Throughput.Stats.Denied~}</strong></span>
	</div>
	<div class="uv-throughput-help">
		Stacked area is operations finishing per bucket; the vertical red strips mark buckets where <code>Admission.Denied</code> fired (queue too deep). The amber dashed line is the <em>now</em> marker.
	</div>
</div>
`
		},
		{
			Hash: 'Ultravisor-Throughput-WindowButton-Template',
			Template: /*html*/`
<button class="{~D:Record.ActiveClass~}" onclick="{~P~}.views['Ultravisor-Throughput'].selectWindow('{~D:Record.Key~}')">{~D:Record.Label~}</button>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Ultravisor-Throughput-Content',
			TemplateHash:   'Ultravisor-Throughput-Template',
			DestinationAddress: '#Ultravisor-Content-Container',
			RenderMethod:   'replace'
		}
	]
};

const WINDOW_PRESETS =
[
	{ Key: '5m',  Label: '5m',  FromIso: 'now-5m',  ToIso: 'now', PollMs: 3000 },
	{ Key: '15m', Label: '15m', FromIso: 'now-15m', ToIso: 'now', PollMs: 5000 },
	{ Key: '1h',  Label: '1h',  FromIso: 'now-1h',  ToIso: 'now', PollMs: 10000 },
	{ Key: '6h',  Label: '6h',  FromIso: 'now-6h',  ToIso: 'now', PollMs: 30000 },
	{ Key: '24h', Label: '24h', FromIso: 'now-24h', ToIso: 'now', PollMs: 60000 }
];

class UltravisorThroughputView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._PollHandle = null;
		this._FetchInFlight = null;
		this._RedrawScheduled = false;
		this._ResizeListener = null;
		this._CurrentWindowKey = '15m';
	}

	onBeforeRender(pRenderable, pAddress, pRecord)
	{
		this.pict.AppData.Throughput = this.pict.AppData.Throughput || {};
		let tmpKey = this._CurrentWindowKey || '15m';
		let tmpPreset = WINDOW_PRESETS[1];
		for (let i = 0; i < WINDOW_PRESETS.length; i++)
		{
			if (WINDOW_PRESETS[i].Key === tmpKey) { tmpPreset = WINDOW_PRESETS[i]; break; }
		}
		this.pict.AppData.Throughput.Window =
		{
			FromIso: tmpPreset.FromIso,
			ToIso:   tmpPreset.ToIso,
			PollMs:  tmpPreset.PollMs
		};
		this.pict.AppData.Throughput.Buckets = this.pict.AppData.Throughput.Buckets || [];
		this.pict.AppData.Throughput.Now     = this.pict.AppData.Throughput.Now || null;
		this.pict.AppData.Throughput.Stats   = this.pict.AppData.Throughput.Stats || {
			Complete: 0, Failed: 0, Stalled: 0, Canceled: 0, Denied: 0
		};
		this.pict.AppData.Throughput.WindowButtons = WINDOW_PRESETS.map(function (pP)
		{
			return {
				Key:         pP.Key,
				Label:       pP.Label,
				ActiveClass: (pP.Key === tmpKey) ? 'active' : ''
			};
		});
		// Don't _stopPoll() here — Pict re-renders the view several times
		// during initial mount, and aborting in onBeforeRender cascades
		// every onAfterRender fetch. _fetchOnce already aborts its own
		// prior in-flight controller, so per-render de-duping happens
		// without the cross-render churn.
		return super.onBeforeRender(pRenderable, pAddress, pRecord);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._installResizeListener();
		this._fetchOnce();
		this._scheduleNextPoll();
		this._scheduleRedraw();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	selectWindow(pKey)
	{
		this._CurrentWindowKey = pKey || '15m';
		this.render();
	}

	_fetchOnce()
	{
		this._abortInFlight();
		let tmpAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
		this._FetchInFlight = tmpAbort;
		let tmpBase = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.APIBaseURL) || '';
		let tmpW = this.pict.AppData.Throughput.Window;
		let tmpURL = tmpBase
			+ '/Timeline?from=' + encodeURIComponent(tmpW.FromIso)
			+ '&to=' + encodeURIComponent(tmpW.ToIso)
			+ '&bucket=auto&futureLimit=0&waitMs=0';
		let tmpSelf = this;
		fetch(tmpURL, { signal: tmpAbort ? tmpAbort.signal : undefined })
			.then(function (pResp) { return pResp.ok ? pResp.json() : null; })
			.then(function (pBody)
			{
				if (tmpSelf._FetchInFlight !== tmpAbort) return;
				if (pBody) { tmpSelf._reconcile(pBody); }
				tmpSelf._FetchInFlight = null;
			})
			.catch(function (pErr)
			{
				if (pErr && pErr.name === 'AbortError') return;
				if (tmpSelf._FetchInFlight !== tmpAbort) return;
				tmpSelf.pict.log.warn('Throughput fetch failed: ' + pErr.message);
				tmpSelf._FetchInFlight = null;
			});
	}

	_reconcile(pBody)
	{
		let tmpBuckets = Array.isArray(pBody.Buckets) ? pBody.Buckets : [];
		this.pict.AppData.Throughput.Buckets = tmpBuckets;
		this.pict.AppData.Throughput.Now = pBody.Now || null;
		if (pBody.From) { this.pict.AppData.Throughput.Window.FromIso = pBody.From; }
		if (pBody.To)   { this.pict.AppData.Throughput.Window.ToIso   = pBody.To; }
		// Aggregate stats.
		let tmpStats = { Complete: 0, Failed: 0, Stalled: 0, Canceled: 0, Denied: 0 };
		for (let i = 0; i < tmpBuckets.length; i++)
		{
			let tmpT = tmpBuckets[i].ByEventType || {};
			let tmpS = tmpBuckets[i].ByStatus || {};
			tmpStats.Complete += (tmpT.Completed || 0) + (tmpT['Execution.ExecutionComplete'] || 0) + (tmpS.Complete || 0);
			tmpStats.Failed   += (tmpT.Failed     || 0) + (tmpS.Failed   || 0);
			tmpStats.Stalled  += (tmpT.Stalled    || 0) + (tmpT['Workitem.Stranded'] || 0) + (tmpS.Stalled || 0);
			tmpStats.Canceled += (tmpT.Canceled   || 0) + (tmpS.Canceled || 0) + (tmpS.Abandoned || 0);
			tmpStats.Denied   += (tmpT['Admission.Denied'] || 0) + (tmpT['admission.denied'] || 0);
		}
		this.pict.AppData.Throughput.Stats = tmpStats;
		this._updateStatsLine();
		this._scheduleRedraw();
	}

	_updateStatsLine()
	{
		let tmpS = this.pict.AppData.Throughput.Stats || {};
		let tmpHTML = '<span>completions: <strong>' + (tmpS.Complete || 0) + '</strong></span>'
			+ '<span>failed: <strong>' + (tmpS.Failed || 0) + '</strong></span>'
			+ '<span>stalled: <strong>' + (tmpS.Stalled || 0) + '</strong></span>'
			+ '<span>canceled: <strong>' + (tmpS.Canceled || 0) + '</strong></span>'
			+ '<span>denials: <strong>' + (tmpS.Denied || 0) + '</strong></span>';
		try { this.pict.ContentAssignment.assignContent('#Ultravisor-Throughput-Stats', tmpHTML); }
		catch (pErr) { /* best effort */ }
	}

	_scheduleNextPoll()
	{
		// Clear only the timer; do NOT abort the in-flight fetch (the
		// caller may have just kicked one off and is calling us to queue
		// the *next* fetch — aborting here would kill that fetch).
		if (this._PollHandle) { clearTimeout(this._PollHandle); this._PollHandle = null; }
		let tmpPollMs = (this.pict.AppData.Throughput.Window && this.pict.AppData.Throughput.Window.PollMs) || 5000;
		this._PollHandle = setTimeout(function ()
		{
			this._PollHandle = null;
			this._fetchOnce();
			this._scheduleNextPoll();
		}.bind(this), tmpPollMs);
	}

	_stopPoll()
	{
		if (this._PollHandle) { clearTimeout(this._PollHandle); this._PollHandle = null; }
		this._abortInFlight();
	}

	_abortInFlight()
	{
		if (this._FetchInFlight)
		{
			try { this._FetchInFlight.abort(); }
			catch (pErr) { /* ignore */ }
			this._FetchInFlight = null;
		}
	}

	_installResizeListener()
	{
		if (this._ResizeListener) return;
		let fResize = function () { this._scheduleRedraw(); }.bind(this);
		window.addEventListener('resize', fResize);
		this._ResizeListener = fResize;
	}

	_scheduleRedraw()
	{
		if (this._RedrawScheduled) return;
		this._RedrawScheduled = true;
		let tmpFn = function ()
		{
			this._RedrawScheduled = false;
			this._draw();
		}.bind(this);
		if (typeof window !== 'undefined' && window.requestAnimationFrame) { window.requestAnimationFrame(tmpFn); }
		else { setTimeout(tmpFn, 16); }
	}

	_draw()
	{
		let tmpCanvas = _resolveCanvas(this.pict, '#Ultravisor-Throughput-Canvas');
		if (!tmpCanvas)
		{
			this._stopPoll();
			return;
		}
		try
		{
			libRenderThroughput.drawThroughput(tmpCanvas,
			{
				Window:  this.pict.AppData.Throughput.Window,
				Buckets: this.pict.AppData.Throughput.Buckets,
				Now:     this.pict.AppData.Throughput.Now
			});
		}
		catch (pErr)
		{
			this.pict.log.warn('Throughput draw failed: ' + pErr.message);
		}
	}
}

function _resolveCanvas(pPict, pSelector)
{
	let tmpEl = pPict.ContentAssignment.getElement(pSelector);
	if (!tmpEl) return null;
	if (Array.isArray(tmpEl) && tmpEl.length === 0) return null;
	let tmpNode = tmpEl[0] || tmpEl;
	if (!tmpNode || typeof tmpNode.getContext !== 'function') return null;
	return tmpNode;
}

module.exports = UltravisorThroughputView;
module.exports.default_configuration = _ViewConfiguration;

},{"./timeline/render-throughput.js":284,"pict-view":239}],275:[function(require,module,exports){
/**
 * PictView-Ultravisor-Timeline
 *
 * Phase 6 / Spine view — three-band timeline of past + present + future
 * events. Templates own the chrome (title, mode toggle, scrub bar,
 * drawer). Canvas + SVG own the bulk render via render-bands.js.
 *
 * Per modules/pict/CLAUDE.md:
 *   - CSS in this config's CSS property
 *   - Templates declared, iteration via {~TS:~}, conditionals via
 *     single-element-array trick driving {~TS:~}
 *   - State in pict.AppData.Timeline.* (provider owns writes)
 *   - No HTML in AppData; no _buildXxxxHTML helpers
 *   - DOM access via pict.ContentAssignment
 *   - Lifecycle hooks only — never overrides render()
 *   - Modal toast for stale-cursor recovery (handled in the provider)
 */

const libPictView = require('pict-view');
const libRenderBands = require('./timeline/render-bands.js');
const libRenderWaterfall = require('./timeline/render-waterfall.js');
const libRenderAnomalyRibbon = require('./timeline/render-anomaly-ribbon.js');
const libURLState = require('./timeline/url-state.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Ultravisor-Timeline',

	DefaultRenderable: 'Ultravisor-Timeline-Content',
	DefaultDestinationAddress: '#Ultravisor-Content-Container',

	AutoRender: false,

	CSS: /*css*/`
		.uv-timeline {
			padding: 1.5em;
			max-width: 1800px;
			margin: 0 auto;
		}
		.uv-timeline-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1em;
			padding-bottom: 0.75em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.uv-timeline-header h1 {
			margin: 0;
			font-size: 1.6em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.uv-timeline-header-actions {
			display: flex;
			align-items: center;
			gap: 0.75em;
		}
		.uv-timeline-mode-indicator {
			display: inline-flex;
			align-items: center;
			gap: 0.4em;
			font-size: 0.8em;
			text-transform: uppercase;
			letter-spacing: 0.5px;
			font-weight: 600;
			padding: 0.25em 0.7em;
			border-radius: 4px;
		}
		.uv-timeline-mode-indicator.live {
			color: var(--uv-success);
			background: rgba(16, 185, 129, 0.10);
		}
		.uv-timeline-mode-indicator.replay {
			color: var(--uv-text-secondary);
			background: var(--uv-bg-surface);
		}
		.uv-timeline-mode-indicator .uv-timeline-pulse {
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: var(--uv-success);
			animation: uv-timeline-pulse 1.6s ease-in-out infinite;
		}
		@keyframes uv-timeline-pulse {
			0%, 100% { opacity: 1; transform: scale(1); }
			50% { opacity: 0.45; transform: scale(0.85); }
		}
		.uv-timeline-button {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			color: var(--uv-text);
			padding: 0.4em 1em;
			font-size: 0.85em;
			border-radius: 4px;
			cursor: pointer;
		}
		.uv-timeline-button:hover {
			border-color: var(--uv-brand);
		}
		.uv-timeline-button.primary {
			background: var(--uv-brand);
			color: var(--uv-text-on-brand, #fff);
			border-color: var(--uv-brand);
		}
		.uv-timeline-windowinfo {
			font-size: 0.8em;
			color: var(--uv-text-secondary);
			font-family: monospace;
		}
		.uv-timeline-canvas-wrap {
			position: relative;
			width: 100%;
			height: 540px;
			background: var(--uv-bg-base);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 6px;
			overflow: hidden;
		}
		.uv-timeline-canvas {
			position: absolute;
			top: 0; left: 0;
			width: 100%;
			height: 100%;
			cursor: crosshair;
		}
		.uv-timeline-svg-overlay {
			position: absolute;
			top: 0; left: 0;
			width: 100%;
			height: 100%;
			pointer-events: none;
		}
		.uv-timeline-empty {
			position: absolute;
			top: 50%; left: 50%;
			transform: translate(-50%, -50%);
			color: var(--uv-text-tertiary);
			font-size: 0.95em;
			text-align: center;
		}
		.uv-timeline-scrubber {
			margin-top: 0.75em;
			height: 28px;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			cursor: pointer;
			position: relative;
		}
		.uv-timeline-scrubber-track {
			position: absolute;
			top: 50%; left: 0; right: 0;
			height: 2px;
			background: var(--uv-border-subtle);
			transform: translateY(-50%);
		}
		.uv-timeline-scrubber-window {
			position: absolute;
			top: 0; bottom: 0;
			background: rgba(245, 158, 11, 0.18);
			border-left: 1px solid var(--uv-warning);
			border-right: 1px solid var(--uv-warning);
		}
		.uv-timeline-drawer {
			margin-top: 1em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 6px;
			padding: 1em;
		}
		.uv-timeline-drawer-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 0.5em;
			padding-bottom: 0.5em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.uv-timeline-drawer-header h3 {
			margin: 0;
			font-size: 1em;
			font-weight: 600;
			color: var(--uv-text);
		}
		.uv-timeline-drawer-close {
			background: none;
			border: none;
			color: var(--uv-text-secondary);
			cursor: pointer;
			font-size: 1.2em;
			padding: 0 0.4em;
		}
		.uv-timeline-drawer pre {
			margin: 0;
			font-size: 0.78em;
			color: var(--uv-text);
			white-space: pre-wrap;
			word-break: break-all;
			max-height: 320px;
			overflow: auto;
		}
		.uv-timeline-waterfall-meta {
			display: flex;
			gap: 1.25em;
			font-size: 0.78em;
			color: var(--uv-text-secondary);
			margin-bottom: 0.5em;
		}
		.uv-timeline-waterfall-meta strong {
			color: var(--uv-text);
			font-weight: 600;
		}
		.uv-timeline-waterfall-canvas-wrap {
			width: 100%;
			background: var(--uv-bg-base);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			overflow-x: auto;
			overflow-y: hidden;
		}
		.uv-timeline-waterfall-canvas {
			display: block;
			width: 100%;
			height: 200px;
		}
		.uv-timeline-waterfall-loading {
			padding: 1em;
			color: var(--uv-text-tertiary);
			font-size: 0.85em;
			text-align: center;
		}
		.uv-timeline-stats {
			margin-top: 0.5em;
			display: flex;
			gap: 1em;
			font-size: 0.8em;
			color: var(--uv-text-secondary);
		}
		.uv-timeline-stats span { font-family: monospace; }
		.uv-timeline-help {
			margin-top: 1em;
			padding: 0.75em 1em;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 4px;
			font-size: 0.78em;
			color: var(--uv-text-secondary);
			line-height: 1.55;
		}
		.uv-timeline-help kbd {
			background: var(--uv-bg-base);
			border: 1px solid var(--uv-border-subtle);
			padding: 0.05em 0.4em;
			border-radius: 3px;
			font-family: monospace;
		}
		.uv-timeline-anomaly-wrap {
			margin-top: 0.5em;
			height: 14px;
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 3px;
			cursor: pointer;
			position: relative;
		}
		.uv-timeline-anomaly-canvas {
			position: absolute;
			top: 0; left: 0;
			width: 100%;
			height: 100%;
		}
		.uv-timeline-anomaly-tooltip {
			position: absolute;
			pointer-events: none;
			background: var(--uv-bg-base);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 3px;
			padding: 0.3em 0.55em;
			font-size: 0.72em;
			color: var(--uv-text);
			font-family: monospace;
			white-space: nowrap;
			z-index: 10;
			box-shadow: 0 2px 8px var(--uv-shadow);
		}
	`,

	Templates:
	[
		{
			Hash: 'Ultravisor-Timeline-Template',
			Template: /*html*/`
<div class="uv-timeline">
	<div class="uv-timeline-header">
		<h1>Timeline</h1>
		<div class="uv-timeline-header-actions">
			{~TS:Ultravisor-Timeline-LiveIndicator-Template:AppData.Timeline.LiveSlot~}
			{~TS:Ultravisor-Timeline-ReplayIndicator-Template:AppData.Timeline.ReplaySlot~}
			<span class="uv-timeline-windowinfo">{~D:AppData.Timeline.Window.FromIso~} → {~D:AppData.Timeline.Window.ToIso~}</span>
			<button class="uv-timeline-button" onclick="{~P~}.views['Ultravisor-Timeline'].onLiveClicked()">Live</button>
			<button class="uv-timeline-button" onclick="{~P~}.views['Ultravisor-Timeline'].onResetZoomClicked()">Reset</button>
		</div>
	</div>
	<div class="uv-timeline-canvas-wrap" id="Ultravisor-Timeline-CanvasWrap">
		<canvas class="uv-timeline-canvas" id="Ultravisor-Timeline-Canvas"></canvas>
		<svg class="uv-timeline-svg-overlay" id="Ultravisor-Timeline-SVG"></svg>
		{~TS:Ultravisor-Timeline-EmptyState-Template:AppData.Timeline.EmptySlot~}
	</div>
	<div class="uv-timeline-scrubber" id="Ultravisor-Timeline-Scrubber">
		<div class="uv-timeline-scrubber-track"></div>
		<div class="uv-timeline-scrubber-window" id="Ultravisor-Timeline-Scrubber-Window"></div>
	</div>
	<div class="uv-timeline-stats" id="Ultravisor-Timeline-Stats">
		<span>past: 0</span>
		<span>present: 0</span>
		<span>future: 0</span>
	</div>
	<div class="uv-timeline-anomaly-wrap" id="Ultravisor-Timeline-Anomaly-Wrap">
		<canvas class="uv-timeline-anomaly-canvas" id="Ultravisor-Timeline-Anomaly-Canvas"></canvas>
	</div>
	<div class="uv-timeline-help">
		<strong>Mouse wheel</strong> zoom in/out · <strong>Click</strong> a bar to focus · <strong>Drag the scrubber</strong> to seek · Press <kbd>Live</kbd> to follow now · <strong>Click</strong> an anomaly tick to jump
	</div>
	<div id="Ultravisor-Timeline-Drawer-Slot">
		{~TS:Ultravisor-Timeline-Drawer-Template:AppData.Timeline.FocusSlot~}
		{~TS:Ultravisor-Timeline-Waterfall-Template:AppData.Timeline.WaterfallSlot~}
	</div>
</div>
`
		},
		{
			Hash: 'Ultravisor-Timeline-LiveIndicator-Template',
			Template: /*html*/`
<span class="uv-timeline-mode-indicator live"><span class="uv-timeline-pulse"></span>Live</span>
`
		},
		{
			Hash: 'Ultravisor-Timeline-ReplayIndicator-Template',
			Template: /*html*/`
<span class="uv-timeline-mode-indicator replay">Replay</span>
`
		},
		{
			Hash: 'Ultravisor-Timeline-EmptyState-Template',
			Template: /*html*/`
<div class="uv-timeline-empty">No events in this window. Try widening with the scrubber, or wait for activity.</div>
`
		},
		{
			Hash: 'Ultravisor-Timeline-Drawer-Template',
			Template: /*html*/`
<div class="uv-timeline-drawer">
	<div class="uv-timeline-drawer-header">
		<h3>{~D:Record.Title~}</h3>
		<button class="uv-timeline-drawer-close" onclick="{~P~}.views['Ultravisor-Timeline'].onCloseFocus()" title="Close">×</button>
	</div>
	<pre>{~D:Record.JSON~}</pre>
</div>
`
		},
		{
			Hash: 'Ultravisor-Timeline-Waterfall-Template',
			Template: /*html*/`
<div class="uv-timeline-drawer">
	<div class="uv-timeline-drawer-header">
		<h3>Run waterfall · {~D:Record.RunHash~}</h3>
		<button class="uv-timeline-drawer-close" onclick="{~P~}.views['Ultravisor-Timeline'].onCloseFocus()" title="Close">×</button>
	</div>
	<div class="uv-timeline-waterfall-meta">
		<span><strong>{~D:Record.OperationName~}</strong></span>
		<span>tasks: {~D:Record.TaskCount~}</span>
		<span>events: {~D:Record.EventCount~}</span>
		<span>span: {~D:Record.SpanLabel~}</span>
		<span>{~D:Record.StatusLabel~}</span>
	</div>
	<div class="uv-timeline-waterfall-canvas-wrap">
		<canvas class="uv-timeline-waterfall-canvas" id="Ultravisor-Timeline-Waterfall-Canvas"></canvas>
	</div>
</div>
`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Ultravisor-Timeline-Content',
			TemplateHash:   'Ultravisor-Timeline-Template',
			DestinationAddress: '#Ultravisor-Content-Container',
			RenderMethod:   'replace'
		}
	]
};

class UltravisorTimelineView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._RedrawScheduled = false;
		this._ResizeListener = null;
		this._WheelListener = null;
		this._ClickListener = null;
		this._ScrubMouseDown = null;  // { startX, startFromMs, startToMs }
		this._ScrubListenersAttached = false;

		// Waterfall fetch state — keyed by RunHash. Cached so that
		// flipping focus on/off the same run doesn't re-fetch.
		this._WaterfallByRunHash = {};
		this._WaterfallFetchInFlight = null;

		// Anomaly ribbon: fetch the bucketed anomaly summary on a slower
		// cadence than the spine (10s) since baselines move slowly.
		this._AnomalyState = { Window: { FromIso: null, ToIso: null }, Anomalies: [], HitBoxes: [] };
		this._AnomalyPollHandle = null;
		this._AnomalyFetchInFlight = null;
		this._AnomalyClickListener = null;
		this._AnomalyHoverListener = null;
		this._AnomalyTooltipNode = null;
	}

	// ====================================================================
	// Lifecycle
	// ====================================================================

	onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord)
	{
		// Sync URL → AppData.Timeline.Window. The provider's startLive
		// reads from AppData.Timeline.Window.
		let tmpURLState = libURLState.read();
		this.pict.AppData.Timeline = this.pict.AppData.Timeline || {};
		let tmpW = this.pict.AppData.Timeline.Window || {};
		tmpW.FromIso = tmpURLState.FromIso;
		tmpW.ToIso   = tmpURLState.ToIso;
		tmpW.Mode    = tmpURLState.Mode;
		tmpW.Bucket  = tmpURLState.Bucket;
		this.pict.AppData.Timeline.Window = tmpW;
		this.pict.AppData.Timeline.Focus = tmpURLState.Focus;
		this._syncFocusSlot();

		// Stop any in-flight provider work — we'll restart based on
		// the new URL state in onAfterRender.
		let tmpProvider = this._provider();
		if (tmpProvider) { tmpProvider.stop(); }

		// URL deep-link to a focused run: kick the waterfall fetch so
		// the drawer fills in on first paint, not on next click.
		if (tmpURLState.Focus && tmpURLState.Focus.Kind === 'runHash')
		{
			this._ensureWaterfallData(tmpURLState.Focus.Hash);
		}

		return super.onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		// Wire interaction listeners (idempotent — bound to current
		// canvas which gets recreated on each render).
		this._installCanvasListeners();
		this._installScrubberListeners();
		this._installResizeListener();
		this._installKeyboardListener();

		// Kick the provider per current Window.Mode.
		let tmpProvider = this._provider();
		if (tmpProvider)
		{
			tmpProvider.setView(this);
			let tmpMode = (this.pict.AppData.Timeline.Window && this.pict.AppData.Timeline.Window.Mode) || 'live';
			if (tmpMode === 'replay')
			{
				tmpProvider.pauseToReplay(
					this.pict.AppData.Timeline.Window.FromIso,
					this.pict.AppData.Timeline.Window.ToIso);
			}
			else
			{
				tmpProvider.startLive(this);
			}
		}

		// First paint with whatever's currently in AppData (often empty
		// the first frame; provider's first response triggers a redraw).
		this._scheduleRedraw();

		// Anomaly ribbon — independent fetch loop on a slower cadence.
		this._installAnomalyListeners();
		this._fetchAnomaliesOnce();
		this._scheduleNextAnomalyPoll();

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	// Provider hook — called whenever the provider has fresh data.
	onTimelineUpdated()
	{
		this._scheduleRedraw();
	}

	// ====================================================================
	// User-facing actions (called from template onclick handlers)
	// ====================================================================

	onLiveClicked()
	{
		this.pict.AppData.Timeline.Window.FromIso = 'now-2m';
		this.pict.AppData.Timeline.Window.ToIso   = 'now+30s';
		this.pict.AppData.Timeline.Window.Mode    = 'live';
		this._writeURL();
		let tmpProvider = this._provider();
		if (tmpProvider) { tmpProvider.resumeLive(); }
		// Re-render top bar indicator.
		this.render();
	}

	onResetZoomClicked()
	{
		this.onLiveClicked();
	}

	onCloseFocus()
	{
		this.pict.AppData.Timeline.Focus = null;
		this._syncFocusSlot();
		this._writeURL();
		this.render();
	}

	// ====================================================================
	// Interaction listeners
	// ====================================================================

	_installCanvasListeners()
	{
		let tmpCanvasEl = this.pict.ContentAssignment.getElement('#Ultravisor-Timeline-Canvas');
		if (!tmpCanvasEl) return;
		let tmpCanvas = tmpCanvasEl[0] || tmpCanvasEl;
		if (!tmpCanvas || !tmpCanvas.addEventListener) return;

		// Wheel = zoom centered on cursor X.
		let fWheel = function (pEvent)
		{
			pEvent.preventDefault();
			this._handleWheel(pEvent, tmpCanvas);
		}.bind(this);
		tmpCanvas.addEventListener('wheel', fWheel, { passive: false });
		this._WheelListener = { node: tmpCanvas, fn: fWheel };

		// Click = focus.
		let fClick = function (pEvent)
		{
			this._handleClick(pEvent, tmpCanvas);
		}.bind(this);
		tmpCanvas.addEventListener('click', fClick);
		this._ClickListener = { node: tmpCanvas, fn: fClick };
	}

	_installScrubberListeners()
	{
		// No attachment guard — onAfterRender rebuilds the DOM, so the
		// scrubber node from the prior render is gone and we need to
		// re-bind to the new one. The previous listener is GC'd with
		// the orphan DOM node.
		let tmpScrubEl = this.pict.ContentAssignment.getElement('#Ultravisor-Timeline-Scrubber');
		if (!tmpScrubEl) return;
		let tmpScrub = tmpScrubEl[0] || tmpScrubEl;
		if (!tmpScrub) return;

		let fMouseDown = function (pEvent)
		{
			this._handleScrubMouseDown(pEvent, tmpScrub);
		}.bind(this);
		tmpScrub.addEventListener('mousedown', fMouseDown);
	}

	_installResizeListener()
	{
		if (this._ResizeListener) return;
		let fResize = function () { this._scheduleRedraw(); }.bind(this);
		window.addEventListener('resize', fResize);
		this._ResizeListener = fResize;
	}

	_installKeyboardListener()
	{
		// Keyboard nav (arrow keys, Esc) only meaningful when the view
		// is active. Bound to document; the listener checks whether
		// the timeline is the visible content.
		// Skipping for v1; reset/Live button covers the common case.
	}

	_handleWheel(pEvent, pCanvas)
	{
		let tmpRect = pCanvas.getBoundingClientRect();
		let tmpFrac = (pEvent.clientX - tmpRect.left) / tmpRect.width;
		if (tmpFrac < 0) tmpFrac = 0;
		if (tmpFrac > 1) tmpFrac = 1;
		let tmpFromMs = Date.parse(this.pict.AppData.Timeline.Stream.Now) || Date.now();
		// Resolve current absolute window (server's resolved values
		// land in Stream.From/To via the reconcile path).
		let tmpAbsFrom = libURLState.resolveTime(this.pict.AppData.Timeline.Window.FromIso, tmpFromMs);
		let tmpAbsTo   = libURLState.resolveTime(this.pict.AppData.Timeline.Window.ToIso,   tmpFromMs);
		let tmpFromMsAbs = Date.parse(tmpAbsFrom) || (tmpFromMs - 120000);
		let tmpToMsAbs   = Date.parse(tmpAbsTo)   || (tmpFromMs + 30000);
		let tmpSpan = tmpToMsAbs - tmpFromMsAbs;
		let tmpFactor = pEvent.deltaY > 0 ? 1.25 : 0.8;
		let tmpNewSpan = Math.max(2000, Math.min(30 * 86400 * 1000, tmpSpan * tmpFactor));
		let tmpAnchorMs = tmpFromMsAbs + tmpFrac * tmpSpan;
		let tmpNewFrom  = tmpAnchorMs - tmpFrac * tmpNewSpan;
		let tmpNewTo    = tmpAnchorMs + (1 - tmpFrac) * tmpNewSpan;

		// Switch to replay (zoomed away from live).
		this.pict.AppData.Timeline.Window.Mode = 'replay';
		this.pict.AppData.Timeline.Window.FromIso = new Date(tmpNewFrom).toISOString();
		this.pict.AppData.Timeline.Window.ToIso   = new Date(tmpNewTo).toISOString();
		this._writeURL();
		let tmpProvider = this._provider();
		if (tmpProvider)
		{
			tmpProvider.pauseToReplay(
				this.pict.AppData.Timeline.Window.FromIso,
				this.pict.AppData.Timeline.Window.ToIso);
		}
		this._scheduleRedraw();
	}

	_handleClick(pEvent, pCanvas)
	{
		let tmpRect = pCanvas.getBoundingClientRect();
		let tmpX = pEvent.clientX - tmpRect.left;
		let tmpY = pEvent.clientY - tmpRect.top;
		let tmpHit = libRenderBands.hitTest(tmpX, tmpY, this._buildState(), pCanvas);
		if (!tmpHit) { return; }
		let tmpFocus = null;
		if (tmpHit.RunHash) { tmpFocus = { Kind: 'runHash', Hash: tmpHit.RunHash }; }
		else if (tmpHit.BeaconID) { tmpFocus = { Kind: 'beacon', Hash: tmpHit.BeaconID }; }
		else if (tmpHit.Capability) { tmpFocus = { Kind: 'capability', Hash: tmpHit.Capability }; }
		this.pict.AppData.Timeline.Focus = tmpFocus;
		// Stash the matched record so the drawer template can render
		// it without needing a separate fetch.
		this.pict.AppData.Timeline.FocusedRecord = tmpHit;
		this._syncFocusSlot();
		this._writeURL();
		if (tmpFocus && tmpFocus.Kind === 'runHash')
		{
			this._ensureWaterfallData(tmpFocus.Hash);
		}
		this.render();
	}

	// Scrubber interactions:
	//   - Click without drag → jump that fraction of the retention window
	//     and recenter on it (preserves current span).
	//   - Drag → pan the visible window left/right.
	//
	// Window placement model: scrubber represents "now-30min" → "now"
	// (default retention). The brush highlights the current visible
	// window; dragging it shifts From/To equally.
	_handleScrubMouseDown(pEvent, pScrub)
	{
		pEvent.preventDefault();
		let tmpRect = pScrub.getBoundingClientRect();
		let tmpRetentionMs = 30 * 60 * 1000;
		let tmpNowMs = Date.now();
		let tmpScrubStartMs = tmpNowMs - tmpRetentionMs;

		// Resolve the current window to absolute ms so we can shift it
		// without losing span on every drag tick.
		let tmpW = this.pict.AppData.Timeline.Window || {};
		let tmpAbsFrom = libURLState.resolveTime(tmpW.FromIso, tmpNowMs);
		let tmpAbsTo   = libURLState.resolveTime(tmpW.ToIso,   tmpNowMs);
		let tmpStartFromMs = Date.parse(tmpAbsFrom) || (tmpNowMs - 120000);
		let tmpStartToMs   = Date.parse(tmpAbsTo)   || (tmpNowMs + 30000);
		let tmpSpanMs = Math.max(1000, tmpStartToMs - tmpStartFromMs);

		let tmpDownX = pEvent.clientX;
		let tmpScrubWidth = tmpRect.width;
		let tmpDragged = false;

		let fOnMouseMove = function (pMoveEvent)
		{
			let tmpDx = pMoveEvent.clientX - tmpDownX;
			if (Math.abs(tmpDx) >= 3) { tmpDragged = true; }
			if (!tmpDragged) return;
			let tmpDeltaFrac = tmpDx / tmpScrubWidth;
			let tmpDeltaMs = tmpDeltaFrac * tmpRetentionMs;
			let tmpFrom = tmpStartFromMs + tmpDeltaMs;
			let tmpTo   = tmpStartToMs   + tmpDeltaMs;
			// Don't let the window run past now (snap to "now-span" max).
			if (tmpTo > tmpNowMs + 30000)
			{
				let tmpAdjust = tmpTo - (tmpNowMs + 30000);
				tmpFrom -= tmpAdjust;
				tmpTo   -= tmpAdjust;
			}
			this._applyReplayWindow(new Date(tmpFrom).toISOString(),
				new Date(tmpTo).toISOString(), false /* don't refetch on every pixel */);
		}.bind(this);

		let fOnMouseUp = function ()
		{
			document.removeEventListener('mousemove', fOnMouseMove);
			document.removeEventListener('mouseup', fOnMouseUp);
			if (tmpDragged)
			{
				// Drag ended: do one final fetch with the settled window.
				let tmpProvider = this._provider();
				if (tmpProvider)
				{
					tmpProvider.pauseToReplay(
						this.pict.AppData.Timeline.Window.FromIso,
						this.pict.AppData.Timeline.Window.ToIso);
				}
				this._writeURL();
			}
			else
			{
				// Pure click → jump-to-fraction, recentering the visible
				// span on the click position.
				let tmpFrac = (pEvent.clientX - tmpRect.left) / tmpScrubWidth;
				if (tmpFrac < 0) tmpFrac = 0;
				if (tmpFrac > 1) tmpFrac = 1;
				let tmpCenter = tmpScrubStartMs + tmpFrac * tmpRetentionMs;
				let tmpFrom = tmpCenter - tmpSpanMs / 2;
				let tmpTo   = tmpCenter + tmpSpanMs / 2;
				this._applyReplayWindow(new Date(tmpFrom).toISOString(),
					new Date(tmpTo).toISOString(), true /* refetch immediately */);
				this._writeURL();
			}
		}.bind(this);

		document.addEventListener('mousemove', fOnMouseMove);
		document.addEventListener('mouseup', fOnMouseUp);
	}

	// Common path for scrub-induced window changes. Updates AppData
	// + scrubber overlay + (optionally) kicks the provider. We don't
	// call this.render() here — that would tear down the very mouse
	// listener we're inside of, leaving the user stuck mid-drag.
	_applyReplayWindow(pFromIso, pToIso, pRefetch)
	{
		this.pict.AppData.Timeline.Window.Mode = 'replay';
		this.pict.AppData.Timeline.Window.FromIso = pFromIso;
		this.pict.AppData.Timeline.Window.ToIso   = pToIso;
		this._setReplayIndicator();
		this._updateScrubberWindow();
		this._scheduleRedraw();
		if (pRefetch)
		{
			let tmpProvider = this._provider();
			if (tmpProvider)
			{
				tmpProvider.pauseToReplay(pFromIso, pToIso);
			}
		}
	}

	// Imperatively swap the LIVE indicator for the REPLAY indicator
	// without a full re-render (which would tear down listeners). The
	// template's single-element-array slots are templates that picked
	// their state at render time; once rendered, they're static DOM.
	_setReplayIndicator()
	{
		try
		{
			let tmpHeader = this.pict.ContentAssignment.getElement('.uv-timeline-header-actions');
			let tmpNode = tmpHeader && (tmpHeader[0] || tmpHeader);
			if (!tmpNode) return;
			let tmpLive = tmpNode.querySelector('.uv-timeline-mode-indicator.live');
			if (tmpLive) { tmpLive.style.display = 'none'; }
			let tmpReplay = tmpNode.querySelector('.uv-timeline-mode-indicator.replay');
			if (tmpReplay)
			{
				tmpReplay.style.display = '';
			}
			else
			{
				// First switch to replay since render — splice in a fresh
				// REPLAY badge after the (now hidden) LIVE one.
				let tmpBadge = document.createElement('span');
				tmpBadge.className = 'uv-timeline-mode-indicator replay';
				tmpBadge.textContent = 'REPLAY';
				if (tmpLive && tmpLive.parentNode)
				{
					tmpLive.parentNode.insertBefore(tmpBadge, tmpLive.nextSibling);
				}
				else
				{
					tmpNode.insertBefore(tmpBadge, tmpNode.firstChild);
				}
			}
		}
		catch (pErr) { /* best effort */ }
	}

	// ====================================================================
	// Helpers
	// ====================================================================

	_provider()
	{
		return this.pict.providers && this.pict.providers['Timeline-Stream'];
	}

	_buildState()
	{
		// Compose the state shape render-bands.js expects.
		let tmpT = this.pict.AppData.Timeline || {};
		return {
			Window:         tmpT.Window || {},
			Stream:         tmpT.Stream || { Past: [], Present: [], Future: [], Buckets: null, Now: null },
			CapabilityRows: tmpT.CapabilityRows || [],
			BeaconRows:     tmpT.BeaconRows || [],
			Focus:          tmpT.Focus || null
		};
	}

	_scheduleRedraw()
	{
		if (this._RedrawScheduled) return;
		this._RedrawScheduled = true;
		let tmpFn = function ()
		{
			this._RedrawScheduled = false;
			this._draw();
		}.bind(this);
		if (typeof window !== 'undefined' && window.requestAnimationFrame)
		{
			window.requestAnimationFrame(tmpFn);
		}
		else
		{
			setTimeout(tmpFn, 16);
		}
	}

	_draw()
	{
		let tmpCanvas = _resolveCanvas(this.pict, '#Ultravisor-Timeline-Canvas');
		if (!tmpCanvas)
		{
			// Spine view's been replaced (user navigated to /Throughput
			// etc.) — stop the provider's poll cycle and our anomaly
			// loop so we don't burn fetches.
			let tmpProvider = this._provider();
			if (tmpProvider) { tmpProvider.stop(); }
			if (this._AnomalyPollHandle)
			{
				clearTimeout(this._AnomalyPollHandle);
				this._AnomalyPollHandle = null;
			}
			return;
		}
		let tmpSVGEl = this.pict.ContentAssignment.getElement('#Ultravisor-Timeline-SVG');
		let tmpSVG = tmpSVGEl && tmpSVGEl.length !== 0 ? (tmpSVGEl[0] || tmpSVGEl) : null;
		try
		{
			libRenderBands.drawTimeline(tmpCanvas, tmpSVG, this._buildState());
		}
		catch (pErr)
		{
			this.pict.log.warn('Timeline view: draw failed: ' + pErr.message);
		}
		this._updateScrubberWindow();
		this._updateChrome();
		this._drawWaterfallIfFocused();
		this._drawAnomalyRibbon();
	}

	// Update the parts of the chrome that change on every fetch:
	// stats line, windowinfo span, mode indicator. Bypasses a full
	// template re-render (which would tear down canvas listeners and
	// any in-progress drawer state).
	_updateChrome()
	{
		let tmpStream = (this.pict.AppData.Timeline && this.pict.AppData.Timeline.Stream) || {};
		let tmpPast    = (tmpStream.Past    || []).length;
		let tmpPresent = (tmpStream.Present || []).length;
		let tmpFuture  = (tmpStream.Future  || []).length;
		let tmpStatsHTML = '<span>past: ' + tmpPast + '</span>'
			+ '<span>present: ' + tmpPresent + '</span>'
			+ '<span>future: ' + tmpFuture + '</span>';
		try { this.pict.ContentAssignment.assignContent('#Ultravisor-Timeline-Stats', tmpStatsHTML); }
		catch (pErr) { /* element may have been torn down */ }
	}

	_updateScrubberWindow()
	{
		// Show the current window as a highlighted band on the scrubber.
		let tmpEl = this.pict.ContentAssignment.getElement('#Ultravisor-Timeline-Scrubber-Window');
		if (!tmpEl) return;
		let tmpNode = tmpEl[0] || tmpEl;
		if (!tmpNode || !tmpNode.style) return;
		let tmpNow = Date.now();
		let tmpRetentionMs = 30 * 60 * 1000;
		let tmpStart = tmpNow - tmpRetentionMs;
		let tmpFrom = Date.parse(libURLState.resolveTime(this.pict.AppData.Timeline.Window.FromIso, tmpNow));
		let tmpTo   = Date.parse(libURLState.resolveTime(this.pict.AppData.Timeline.Window.ToIso, tmpNow));
		if (!Number.isFinite(tmpFrom) || !Number.isFinite(tmpTo))
		{
			tmpNode.style.display = 'none';
			return;
		}
		let tmpFracFrom = Math.max(0, Math.min(1, (tmpFrom - tmpStart) / tmpRetentionMs));
		let tmpFracTo   = Math.max(0, Math.min(1, (tmpTo   - tmpStart) / tmpRetentionMs));
		tmpNode.style.display = 'block';
		tmpNode.style.left  = (tmpFracFrom * 100) + '%';
		tmpNode.style.width = ((tmpFracTo - tmpFracFrom) * 100) + '%';
	}

	_writeURL()
	{
		libURLState.write({
			FromIso: this.pict.AppData.Timeline.Window.FromIso,
			ToIso:   this.pict.AppData.Timeline.Window.ToIso,
			Mode:    this.pict.AppData.Timeline.Window.Mode,
			Bucket:  this.pict.AppData.Timeline.Window.Bucket,
			Focus:   this.pict.AppData.Timeline.Focus
		});
	}

	_syncFocusSlot()
	{
		// Drawer slot dispatch by Focus.Kind:
		//   - 'runHash' → waterfall slot (canvas painted in onAfterRender)
		//   - everything else (or no focus) → JSON dump slot
		// Both slots use the single-element-array conditional pattern; only
		// one is populated at a time.
		let tmpFocus = this.pict.AppData.Timeline.Focus;
		let tmpRecord = this.pict.AppData.Timeline.FocusedRecord;
		this.pict.AppData.Timeline.FocusSlot = [];
		this.pict.AppData.Timeline.WaterfallSlot = [];

		if (!tmpFocus) { return; }

		if (tmpFocus.Kind === 'runHash')
		{
			// The waterfall fetch fills in metadata; show a placeholder
			// row until the response arrives.
			let tmpCached = this._WaterfallByRunHash[tmpFocus.Hash];
			let tmpMeta = tmpCached
				? this._waterfallMetaFromCache(tmpCached, tmpFocus.Hash)
				: { RunHash: tmpFocus.Hash, OperationName: '(loading…)', TaskCount: 0,
					EventCount: 0, SpanLabel: '—', StatusLabel: '' };
			this.pict.AppData.Timeline.WaterfallSlot = [tmpMeta];
			return;
		}

		if (tmpRecord)
		{
			let tmpTitle = tmpFocus.Kind + ': ' + tmpFocus.Hash;
			let tmpJSON = '';
			try { tmpJSON = JSON.stringify(tmpRecord, null, 2); }
			catch (pErr) { tmpJSON = '(unable to serialize)'; }
			this.pict.AppData.Timeline.FocusSlot = [{ Title: tmpTitle, JSON: tmpJSON }];
		}
	}

	_waterfallMetaFromCache(pCached, pRunHash)
	{
		let tmpTasks = libRenderWaterfall.buildTaskRows(
			{ Records: pCached.Records || [] });
		let tmpFromMs = null, tmpToMs = null;
		for (let i = 0; i < tmpTasks.length; i++)
		{
			if (tmpFromMs === null || tmpTasks[i].At    < tmpFromMs) tmpFromMs = tmpTasks[i].At;
			if (tmpToMs   === null || tmpTasks[i].EndAt > tmpToMs)   tmpToMs   = tmpTasks[i].EndAt;
		}
		let tmpSpanMs = (tmpFromMs !== null && tmpToMs !== null) ? (tmpToMs - tmpFromMs) : 0;
		// Find a terminal status hint from the run-level records.
		let tmpStatus = '';
		let tmpRecs = pCached.Records || [];
		for (let i = tmpRecs.length - 1; i >= 0; i--)
		{
			let tmpET = tmpRecs[i] && tmpRecs[i].EventType;
			if (tmpET === 'Run.Completed') { tmpStatus = 'Complete'; break; }
			if (tmpET === 'Run.Failed') { tmpStatus = 'Failed'; break; }
			if (tmpET === 'Run.Stalled') { tmpStatus = 'Stalled'; break; }
			if (tmpET === 'Run.Canceled' || tmpET === 'Run.Abandoned') { tmpStatus = 'Canceled'; break; }
		}
		if (!tmpStatus && tmpTasks.length > 0)
		{
			// Fall back to "Running" if any task is still open-ended.
			let tmpAnyOpen = false;
			for (let i = 0; i < tmpTasks.length; i++)
			{
				if (tmpTasks[i].EndAt <= tmpTasks[i].At) { tmpAnyOpen = true; break; }
			}
			tmpStatus = tmpAnyOpen ? 'Running' : 'Complete';
		}
		return {
			RunHash:       pRunHash,
			OperationName: (pCached.Operation && (pCached.Operation.Name || pCached.Operation.Hash)) || '(unknown operation)',
			TaskCount:     tmpTasks.length,
			EventCount:    tmpRecs.length,
			SpanLabel:     tmpSpanMs > 0 ? _formatDurationLabel(tmpSpanMs) : '—',
			StatusLabel:   tmpStatus ? ('status: ' + tmpStatus) : ''
		};
	}

	_ensureWaterfallData(pRunHash)
	{
		if (!pRunHash) return;
		if (this._WaterfallByRunHash[pRunHash]
			&& (Date.now() - this._WaterfallByRunHash[pRunHash].FetchedAt) < 4000)
		{
			return;
		}
		// Abort any prior in-flight fetch (different run, or stale).
		if (this._WaterfallFetchInFlight && this._WaterfallFetchInFlight.RunHash !== pRunHash)
		{
			try { this._WaterfallFetchInFlight.Abort.abort(); }
			catch (pErr) { /* best effort */ }
			this._WaterfallFetchInFlight = null;
		}

		let tmpBase = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.APIBaseURL) || '';
		let tmpAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
		this._WaterfallFetchInFlight = { RunHash: pRunHash, Abort: tmpAbort };
		let tmpURL = tmpBase
			+ '/Timeline?from=now-2h&to=now%2B30s&bucket=raw&waitMs=0&runHash='
			+ encodeURIComponent(pRunHash);
		let tmpSelf = this;

		fetch(tmpURL, { signal: tmpAbort ? tmpAbort.signal : undefined })
			.then(function (pResp) { return pResp.ok ? pResp.json() : null; })
			.then(function (pBody)
			{
				if (!pBody) return null;
				let tmpAll = []
					.concat(Array.isArray(pBody.Past) ? pBody.Past : [])
					.concat(Array.isArray(pBody.Present) ? pBody.Present : [])
					.concat(Array.isArray(pBody.Future) ? pBody.Future : []);
				// Pick up the operation hash from any record that has one.
				let tmpOpHash = '';
				for (let i = 0; i < tmpAll.length; i++)
				{
					if (tmpAll[i].OperationHash) { tmpOpHash = tmpAll[i].OperationHash; break; }
				}
				if (!tmpOpHash)
				{
					tmpSelf._WaterfallByRunHash[pRunHash] =
					{
						RunHash:   pRunHash,
						Records:   tmpAll,
						Operation: null,
						FetchedAt: Date.now()
					};
					tmpSelf._afterWaterfallFetch(pRunHash);
					return null;
				}
				return fetch(tmpBase + '/Operation/' + encodeURIComponent(tmpOpHash))
					.then(function (pOpResp) { return pOpResp.ok ? pOpResp.json() : null; })
					.then(function (pOp)
					{
						tmpSelf._WaterfallByRunHash[pRunHash] =
						{
							RunHash:   pRunHash,
							Records:   tmpAll,
							Operation: pOp,
							FetchedAt: Date.now()
						};
						tmpSelf._afterWaterfallFetch(pRunHash);
						return null;
					});
			})
			.catch(function (pErr)
			{
				if (pErr && pErr.name === 'AbortError') return;
				tmpSelf.pict.log.warn('Timeline waterfall fetch failed: ' + (pErr && pErr.message));
			})
			.then(function ()
			{
				if (tmpSelf._WaterfallFetchInFlight
					&& tmpSelf._WaterfallFetchInFlight.RunHash === pRunHash)
				{
					tmpSelf._WaterfallFetchInFlight = null;
				}
			});
	}

	_afterWaterfallFetch(pRunHash)
	{
		// Only act if this run is still the focused run.
		let tmpFocus = this.pict.AppData.Timeline.Focus;
		if (!tmpFocus || tmpFocus.Kind !== 'runHash' || tmpFocus.Hash !== pRunHash) return;
		this._syncFocusSlot();
		// Re-render the drawer slot so the meta + canvas template
		// receives the populated record. Easier than surgical
		// assignContent to multiple spans.
		this.render();
	}

	_drawWaterfallIfFocused()
	{
		let tmpFocus = this.pict.AppData.Timeline.Focus;
		if (!tmpFocus || tmpFocus.Kind !== 'runHash') return;
		let tmpCached = this._WaterfallByRunHash[tmpFocus.Hash];
		if (!tmpCached) return;
		let tmpCanvas = _resolveCanvas(this.pict, '#Ultravisor-Timeline-Waterfall-Canvas');
		if (!tmpCanvas) return;
		try
		{
			libRenderWaterfall.drawWaterfall(tmpCanvas,
			{
				RunHash:   tmpFocus.Hash,
				Records:   tmpCached.Records || [],
				Operation: tmpCached.Operation || null,
				Now:       (this.pict.AppData.Timeline.Stream && this.pict.AppData.Timeline.Stream.Now) || null
			});
		}
		catch (pErr)
		{
			this.pict.log.warn('Timeline waterfall draw failed: ' + pErr.message);
		}
	}

	// ====================================================================
	// Anomaly ribbon
	// ====================================================================

	_fetchAnomaliesOnce()
	{
		if (this._AnomalyFetchInFlight)
		{
			try { this._AnomalyFetchInFlight.abort(); }
			catch (pErr) { /* ignore */ }
			this._AnomalyFetchInFlight = null;
		}
		let tmpAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
		this._AnomalyFetchInFlight = tmpAbort;
		let tmpBase = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.APIBaseURL) || '';
		let tmpW = this.pict.AppData.Timeline.Window || {};
		let tmpURL = tmpBase
			+ '/Timeline/Anomalies?from=' + encodeURIComponent(tmpW.FromIso || 'now-15m')
			+ '&to=' + encodeURIComponent(tmpW.ToIso || 'now');
		let tmpSelf = this;
		fetch(tmpURL, { signal: tmpAbort ? tmpAbort.signal : undefined })
			.then(function (pResp) { return pResp.ok ? pResp.json() : null; })
			.then(function (pBody)
			{
				if (tmpSelf._AnomalyFetchInFlight !== tmpAbort) return;
				if (pBody)
				{
					tmpSelf._AnomalyState.Window = { FromIso: pBody.From, ToIso: pBody.To };
					tmpSelf._AnomalyState.Anomalies = Array.isArray(pBody.Anomalies) ? pBody.Anomalies : [];
				}
				tmpSelf._AnomalyFetchInFlight = null;
				tmpSelf._scheduleRedraw();
			})
			.catch(function (pErr)
			{
				if (pErr && pErr.name === 'AbortError') return;
				if (tmpSelf._AnomalyFetchInFlight !== tmpAbort) return;
				tmpSelf._AnomalyFetchInFlight = null;
				// Quiet — anomaly ribbon is non-essential; don't spam logs.
			});
	}

	_scheduleNextAnomalyPoll()
	{
		if (this._AnomalyPollHandle) { clearTimeout(this._AnomalyPollHandle); }
		this._AnomalyPollHandle = setTimeout(function ()
		{
			this._AnomalyPollHandle = null;
			this._fetchAnomaliesOnce();
			this._scheduleNextAnomalyPoll();
		}.bind(this), 10000);
	}

	_drawAnomalyRibbon()
	{
		let tmpCanvas = _resolveCanvas(this.pict, '#Ultravisor-Timeline-Anomaly-Canvas');
		if (!tmpCanvas) return;
		// Sync the ribbon's window to the current spine window so ticks
		// land at the right X positions even if the spine has slid.
		let tmpW = this.pict.AppData.Timeline.Window || {};
		// The ribbon draws inside its own canvas (full width), with the
		// spine's left padding so labels align with the bands above. The
		// spine's render-bands.js uses PADDING_LEFT=140, PADDING_RIGHT=16.
		let tmpDrawState = {
			Window:    { FromIso: tmpW.FromIso, ToIso: tmpW.ToIso },
			Anomalies: this._AnomalyState.Anomalies,
			PadLeft:   140,
			PadRight:  16
		};
		try
		{
			libRenderAnomalyRibbon.drawAnomalyRibbon(tmpCanvas, tmpDrawState);
			this._AnomalyState.HitBoxes = tmpDrawState.HitBoxes || [];
		}
		catch (pErr)
		{
			this.pict.log.warn('Anomaly ribbon draw failed: ' + pErr.message);
		}
	}

	_installAnomalyListeners()
	{
		let tmpWrapEl = this.pict.ContentAssignment.getElement('#Ultravisor-Timeline-Anomaly-Wrap');
		if (!tmpWrapEl) return;
		let tmpWrap = tmpWrapEl[0] || tmpWrapEl;
		if (!tmpWrap || !tmpWrap.addEventListener) return;
		let tmpCanvasEl = this.pict.ContentAssignment.getElement('#Ultravisor-Timeline-Anomaly-Canvas');
		if (!tmpCanvasEl) return;
		let tmpCanvas = tmpCanvasEl[0] || tmpCanvasEl;
		if (!tmpCanvas) return;

		// Click → jump the spine to the anomaly's window.
		let fClick = function (pEvent)
		{
			let tmpRect = tmpCanvas.getBoundingClientRect();
			let tmpX = pEvent.clientX - tmpRect.left;
			let tmpHit = libRenderAnomalyRibbon.hitTest(tmpX,
				{ HitBoxes: this._AnomalyState.HitBoxes });
			if (!tmpHit) return;
			let tmpAtMs = Date.parse(tmpHit.At);
			let tmpDur = tmpHit.DurationMs || 60000;
			if (!Number.isFinite(tmpAtMs)) return;
			let tmpFrom = new Date(tmpAtMs - tmpDur).toISOString();
			let tmpTo   = new Date(tmpAtMs + tmpDur * 2).toISOString();
			this.pict.AppData.Timeline.Window.Mode    = 'replay';
			this.pict.AppData.Timeline.Window.FromIso = tmpFrom;
			this.pict.AppData.Timeline.Window.ToIso   = tmpTo;
			this._writeURL();
			let tmpProvider = this._provider();
			if (tmpProvider) { tmpProvider.pauseToReplay(tmpFrom, tmpTo); }
			this.render();
		}.bind(this);
		tmpCanvas.addEventListener('click', fClick);
		this._AnomalyClickListener = { node: tmpCanvas, fn: fClick };

		// Hover → tooltip.
		let fMove = function (pEvent)
		{
			let tmpRect = tmpCanvas.getBoundingClientRect();
			let tmpX = pEvent.clientX - tmpRect.left;
			let tmpHit = libRenderAnomalyRibbon.hitTest(tmpX,
				{ HitBoxes: this._AnomalyState.HitBoxes });
			this._showAnomalyTooltip(tmpHit, pEvent.clientX, pEvent.clientY);
		}.bind(this);
		let fLeave = function () { this._showAnomalyTooltip(null, 0, 0); }.bind(this);
		tmpCanvas.addEventListener('mousemove', fMove);
		tmpCanvas.addEventListener('mouseleave', fLeave);
		this._AnomalyHoverListener = { node: tmpCanvas, mv: fMove, lv: fLeave };
	}

	_showAnomalyTooltip(pAnomaly, pX, pY)
	{
		let tmpWrapEl = this.pict.ContentAssignment.getElement('#Ultravisor-Timeline-Anomaly-Wrap');
		if (!tmpWrapEl) return;
		let tmpWrap = tmpWrapEl[0] || tmpWrapEl;
		if (!tmpWrap) return;
		if (!pAnomaly)
		{
			if (this._AnomalyTooltipNode && this._AnomalyTooltipNode.parentNode)
			{
				this._AnomalyTooltipNode.parentNode.removeChild(this._AnomalyTooltipNode);
				this._AnomalyTooltipNode = null;
			}
			return;
		}
		if (!this._AnomalyTooltipNode)
		{
			this._AnomalyTooltipNode = document.createElement('div');
			this._AnomalyTooltipNode.className = 'uv-timeline-anomaly-tooltip';
			document.body.appendChild(this._AnomalyTooltipNode);
		}
		let tmpAtLabel = pAnomaly.At ? pAnomaly.At.slice(11, 19) : '?';
		this._AnomalyTooltipNode.textContent =
			pAnomaly.EventType + ' · ' + tmpAtLabel
			+ ' · obs ' + pAnomaly.Observed + ' / threshold ' + pAnomaly.Baseline;
		this._AnomalyTooltipNode.style.left = (pX + 12) + 'px';
		this._AnomalyTooltipNode.style.top  = (pY - 28) + 'px';
	}
}

function _formatDurationLabel(pMs)
{
	if (!Number.isFinite(pMs) || pMs < 0) return '0ms';
	if (pMs < 1000) return pMs + 'ms';
	if (pMs < 60000) return (pMs / 1000).toFixed(1) + 's';
	let tmpMin = Math.floor(pMs / 60000);
	let tmpSec = Math.floor((pMs - tmpMin * 60000) / 1000);
	return tmpMin + 'm' + (tmpSec < 10 ? '0' : '') + tmpSec + 's';
}

// ContentAssignment.getElement returns [] (truthy empty array) when the
// element isn't in the DOM. This helper collapses the result to a real
// canvas DOM node or null, so callers can early-out cleanly when the
// view's been replaced by navigation.
function _resolveCanvas(pPict, pSelector)
{
	let tmpEl = pPict.ContentAssignment.getElement(pSelector);
	if (!tmpEl) return null;
	if (Array.isArray(tmpEl) && tmpEl.length === 0) return null;
	let tmpNode = tmpEl[0] || tmpEl;
	if (!tmpNode || typeof tmpNode.getContext !== 'function') return null;
	return tmpNode;
}

module.exports = UltravisorTimelineView;
module.exports.default_configuration = _ViewConfiguration;

},{"./timeline/render-anomaly-ribbon.js":280,"./timeline/render-bands.js":281,"./timeline/render-waterfall.js":285,"./timeline/url-state.js":286,"pict-view":239}],276:[function(require,module,exports){
const libPictView = require('pict-view');

const libTimingUtils = require('../Ultravisor-TimingUtils.js');

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-TimingView",

	DefaultRenderable: "Ultravisor-TimingView-Content",
	DefaultDestinationAddress: "#Ultravisor-Content-Container",

	AutoRender: false,

	CSS: /*css*/`
		.ultravisor-timing {
			padding: 2em;
			max-width: 1200px;
			margin: 0 auto;
		}
		.ultravisor-timing-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1.5em;
			padding-bottom: 1em;
			border-bottom: 1px solid var(--uv-border-subtle);
		}
		.ultravisor-timing-header h1 {
			margin: 0;
			font-size: 2em;
			font-weight: 300;
			color: var(--uv-text);
		}
		.ultravisor-timing-selector {
			margin-bottom: 1.5em;
		}
		.ultravisor-timing-selector select {
			width: 100%;
			max-width: 600px;
			padding: 0.6em 0.75em;
		}
		.ultravisor-timing-card {
			background: var(--uv-bg-surface);
			border: 1px solid var(--uv-border-subtle);
			border-radius: 8px;
			padding: 1.5em;
			margin-bottom: 1.5em;
		}
		.ultravisor-timing-summary {
			display: flex;
			flex-wrap: wrap;
			gap: 2em;
			margin-bottom: 1em;
		}
		.ultravisor-timing-stat {
			display: flex;
			flex-direction: column;
		}
		.ultravisor-timing-stat-label {
			font-size: 0.75em;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			color: var(--uv-text-secondary);
			margin-bottom: 0.25em;
		}
		.ultravisor-timing-stat-value {
			font-size: 1.2em;
			font-weight: 600;
			color: var(--uv-text);
		}
		.ultravisor-timing-stat-value.complete {
			color: var(--uv-success);
		}
		.ultravisor-timing-stat-value.error {
			color: var(--uv-error);
		}
		.ultravisor-timing-chart {
			margin-top: 1.5em;
		}
		.ultravisor-timing-chart-title {
			font-size: 0.85em;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			color: var(--uv-text-secondary);
			margin-bottom: 1em;
		}
		.ultravisor-timing-row {
			display: flex;
			align-items: center;
			margin-bottom: 0.6em;
		}
		.ultravisor-timing-row-label {
			width: 180px;
			flex-shrink: 0;
			font-size: 0.85em;
			color: var(--uv-text-secondary);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			padding-right: 1em;
		}
		.ultravisor-timing-row-bar-container {
			flex: 1;
			height: 28px;
			background: var(--uv-bg-base);
			border-radius: 4px;
			position: relative;
			overflow: hidden;
		}
		.ultravisor-timing-row-bar {
			height: 100%;
			border-radius: 4px;
			min-width: 2px;
			transition: width 0.4s ease;
			display: flex;
			align-items: center;
			padding-left: 0.5em;
		}
		.ultravisor-timing-row-bar.complete {
			background: linear-gradient(90deg, #2e7d32, #43a047);
		}
		.ultravisor-timing-row-bar.error {
			background: linear-gradient(90deg, #c62828, #e53935);
		}
		.ultravisor-timing-row-bar.running {
			background: linear-gradient(90deg, var(--uv-info), #1e88e5);
		}
		.ultravisor-timing-row-bar.other {
			background: linear-gradient(90deg, var(--uv-btn-secondary-bg), #546e7a);
		}
		.ultravisor-timing-row-bar-text {
			font-size: 0.75em;
			color: var(--theme-color-background-panel, #fff);
			white-space: nowrap;
			text-shadow: 0 1px 2px var(--uv-shadow-heavy);
		}
		.ultravisor-timing-row-duration {
			width: 120px;
			flex-shrink: 0;
			font-size: 0.8em;
			color: var(--uv-text-secondary);
			text-align: right;
			padding-left: 0.75em;
			font-family: monospace;
		}
		.ultravisor-timing-row-count {
			width: 60px;
			flex-shrink: 0;
			font-size: 0.75em;
			color: var(--uv-text-secondary);
			text-align: right;
			padding-left: 0.5em;
		}
		.ultravisor-timing-axis {
			display: flex;
			align-items: center;
			margin-top: 0.5em;
			padding-left: 180px;
		}
		.ultravisor-timing-axis-line {
			flex: 1;
			display: flex;
			justify-content: space-between;
			border-top: 1px solid var(--uv-border);
			padding-top: 0.35em;
		}
		.ultravisor-timing-axis-tick {
			font-size: 0.7em;
			color: var(--uv-text-tertiary);
			font-family: monospace;
		}
		.ultravisor-timing-axis-spacer {
			width: 120px;
			flex-shrink: 0;
		}
		.ultravisor-timing-empty {
			text-align: center;
			padding: 3em;
			color: var(--uv-text-tertiary);
			font-style: italic;
		}
		.ultravisor-timing-verbosity-controls {
			display: flex;
			gap: 0.5em;
			margin-bottom: 1em;
		}
		.ultravisor-timing-verbosity-btn {
			padding: 0.35em 0.75em;
			border: 1px solid var(--uv-border);
			border-radius: 4px;
			background: transparent;
			color: var(--uv-text-secondary);
			font-size: 0.8em;
			cursor: pointer;
		}
		.ultravisor-timing-verbosity-btn.active {
			background: #1e3a5f;
			border-color: #42a5f5;
			color: #90caf9;
		}
		.ultravisor-timing-eventlog-table {
			width: 100%;
			border-collapse: collapse;
			font-size: 0.8em;
		}
		.ultravisor-timing-eventlog-table th {
			text-align: left;
			padding: 0.5em 0.75em;
			background: #0d1b2a;
			color: var(--uv-text-secondary);
			border-bottom: 1px solid var(--uv-border-subtle);
			font-weight: 600;
			text-transform: uppercase;
			font-size: 0.85em;
			letter-spacing: 0.05em;
		}
		.ultravisor-timing-eventlog-table td {
			padding: 0.4em 0.75em;
			border-bottom: 1px solid var(--uv-bg-base);
			color: var(--uv-text-secondary);
			font-family: monospace;
		}
		.ultravisor-timing-eventlog-table tr:hover td {
			background: #1a2744;
		}
		.ultravisor-timing-eventlog-v0 { color: var(--uv-text); }
		.ultravisor-timing-eventlog-v1 { color: var(--uv-text-secondary); }
		.ultravisor-timing-eventlog-v2 { color: #546e7a; }
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-TimingView-Template",
			Template: /*html*/`
<div class="ultravisor-timing">
	<div class="ultravisor-timing-header">
		<h1>Timing</h1>
		<button class="ultravisor-btn ultravisor-btn-secondary" onclick="{~P~}.PictApplication.showView('Ultravisor-TimingView')">Refresh</button>
	</div>
	<div class="ultravisor-timing-selector" id="Ultravisor-Timing-Selector"></div>
	<div id="Ultravisor-Timing-Detail"></div>
</div>
`
		},
		{
			Hash: "Ultravisor-Timing-Row-Template",
			Template: /*html*/`<div class="ultravisor-timing-row"><div class="ultravisor-timing-row-label" title="{~D:Record.LabelTitle~}" style="{~D:Record.LabelStyle~}">{~D:Record.Label~}</div><div class="ultravisor-timing-row-bar-container"><div class="ultravisor-timing-row-bar {~D:Record.BarClass~}" style="width: {~D:Record.WidthPercent~}%;{~D:Record.BarStyle~}">{~D:Record.BarText~}</div></div><div class="ultravisor-timing-row-duration">{~D:Record.Duration~}</div>{~D:Record.CountHTML~}</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-TimingView-Content",
			TemplateHash: "Ultravisor-TimingView-Template",
			DestinationAddress: "#Ultravisor-Content-Container",
			RenderMethod: "replace"
		}
	]
};

class UltravisorTimingView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this._currentVerbosity = 0;
		this._currentManifest = null;
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.PictApplication.loadManifests(
			function ()
			{
				this.renderManifestSelector();
			}.bind(this));

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	renderManifestSelector()
	{
		let tmpManifests = this.pict.AppData.Ultravisor.Manifests;
		let tmpViewRef = "_Pict.views['Ultravisor-TimingView']";

		if (!tmpManifests || tmpManifests.length === 0)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-Timing-Selector',
				'<div class="ultravisor-timing-empty">No execution manifests recorded yet. Execute an operation to see timing data here.</div>');
			return;
		}

		let tmpHTML = '<select id="Ultravisor-Timing-Select" onchange="' + tmpViewRef + '.onSelectManifest(this.value)">';
		tmpHTML += '<option value="">-- Select an execution to visualize --</option>';

		for (let i = tmpManifests.length - 1; i >= 0; i--)
		{
			let tmpManifest = tmpManifests[i];
			let tmpRunHash = tmpManifest.Hash || '';
			let tmpLabel = (tmpManifest.OperationHash || tmpRunHash);
			let tmpStatus = tmpManifest.Status || 'Unknown';
			let tmpTime = tmpManifest.StartTime ? tmpManifest.StartTime.replace('T', ' ').replace(/\.\d+Z$/, '') : '';
			tmpHTML += '<option value="' + libTimingUtils.escapeHTML(tmpRunHash) + '">' + libTimingUtils.escapeHTML(tmpLabel) + ' [' + tmpStatus + '] ' + tmpTime + '</option>';
		}

		tmpHTML += '</select>';
		this.pict.ContentAssignment.assignContent('#Ultravisor-Timing-Selector', tmpHTML);
	}

	onSelectManifest(pRunHash)
	{
		if (!pRunHash)
		{
			this.pict.ContentAssignment.assignContent('#Ultravisor-Timing-Detail', '');
			return;
		}

		this.pict.PictApplication.loadManifest(pRunHash,
			function (pError, pManifest)
			{
				if (pError || !pManifest)
				{
					this.pict.ContentAssignment.assignContent('#Ultravisor-Timing-Detail',
						'<div class="ultravisor-timing-card"><p style="color:var(--uv-error);">Error loading manifest details.</p></div>');
					return;
				}

				this._currentManifest = pManifest;
				this._currentVerbosity = 0;
				this.renderTimingVisualization(pManifest);
			}.bind(this));
	}

	renderTimingVisualization(pManifest)
	{
		// Convert TaskManifests object to an array for visualization
		let tmpTaskResults = [];
		if (pManifest.TaskManifests && typeof pManifest.TaskManifests === 'object')
		{
			let tmpKeys = Object.keys(pManifest.TaskManifests);
			for (let k = 0; k < tmpKeys.length; k++)
			{
				let tmpEntry = pManifest.TaskManifests[tmpKeys[k]];
				tmpEntry._NodeHash = tmpKeys[k];
				tmpEntry._ComputedElapsedMs = libTimingUtils.computeTaskElapsedMs(tmpEntry);
				tmpEntry._ComputedStatus = libTimingUtils.computeTaskStatus(tmpEntry);
				tmpTaskResults.push(tmpEntry);
			}
		}

		let tmpOperationElapsedMs = pManifest.ElapsedMs || 0;
		let tmpOperationElapsedFormatted = libTimingUtils.formatMs(tmpOperationElapsedMs);
		let tmpAverageTaskMs = 0;
		let tmpStatus = (pManifest.Status || 'Unknown').toLowerCase();
		let tmpStatusClass = (tmpStatus === 'complete' || tmpStatus === 'error' || tmpStatus === 'running') ? tmpStatus : '';

		// If no operation-level ElapsedMs, compute from task results
		if (tmpOperationElapsedMs <= 0 && tmpTaskResults.length > 0)
		{
			for (let i = 0; i < tmpTaskResults.length; i++)
			{
				tmpOperationElapsedMs += tmpTaskResults[i]._ComputedElapsedMs;
			}
			tmpOperationElapsedFormatted = libTimingUtils.formatMs(tmpOperationElapsedMs);
		}

		// Compute average
		if (tmpTaskResults.length > 0 && tmpOperationElapsedMs > 0)
		{
			tmpAverageTaskMs = tmpOperationElapsedMs / tmpTaskResults.length;
		}

		// Find the max task duration for bar scaling
		let tmpMaxTaskMs = 0;
		for (let i = 0; i < tmpTaskResults.length; i++)
		{
			let tmpMs = tmpTaskResults[i]._ComputedElapsedMs;
			if (tmpMs > tmpMaxTaskMs)
			{
				tmpMaxTaskMs = tmpMs;
			}
		}
		if (tmpMaxTaskMs <= 0)
		{
			tmpMaxTaskMs = 1;
		}

		let tmpHTML = '';

		// ---- Summary Card ----
		tmpHTML += '<div class="ultravisor-timing-card">';
		tmpHTML += '<div class="ultravisor-timing-summary">';
		tmpHTML += '<div class="ultravisor-timing-stat"><span class="ultravisor-timing-stat-label">Operation</span><span class="ultravisor-timing-stat-value">' + libTimingUtils.escapeHTML(pManifest.OperationHash || '') + '</span></div>';
		tmpHTML += '<div class="ultravisor-timing-stat"><span class="ultravisor-timing-stat-label">Status</span><span class="ultravisor-timing-stat-value ' + tmpStatusClass + '">' + libTimingUtils.escapeHTML(pManifest.Status || 'Unknown') + '</span></div>';
		tmpHTML += '<div class="ultravisor-timing-stat"><span class="ultravisor-timing-stat-label">Total Time</span><span class="ultravisor-timing-stat-value">' + libTimingUtils.escapeHTML(tmpOperationElapsedFormatted) + '</span></div>';
		tmpHTML += '<div class="ultravisor-timing-stat"><span class="ultravisor-timing-stat-label">Tasks</span><span class="ultravisor-timing-stat-value">' + tmpTaskResults.length + '</span></div>';
		tmpHTML += '<div class="ultravisor-timing-stat"><span class="ultravisor-timing-stat-label">Avg per Task</span><span class="ultravisor-timing-stat-value">' + libTimingUtils.formatMs(tmpAverageTaskMs) + '</span></div>';
		tmpHTML += '</div>';

		// ---- Task Timeline ----
		if (tmpTaskResults.length === 0)
		{
			tmpHTML += '<div class="ultravisor-timing-empty">No task results in this manifest.</div>';
		}
		else
		{
			tmpHTML += '<div class="ultravisor-timing-chart">';
			tmpHTML += '<div class="ultravisor-timing-chart-title">Task Timeline</div>';

			for (let i = 0; i < tmpTaskResults.length; i++)
			{
				let tmpResult = tmpTaskResults[i];
				let tmpTaskMs = tmpResult._ComputedElapsedMs;
				let tmpTaskFormatted = libTimingUtils.formatMs(tmpTaskMs);
				let tmpTaskStatus = tmpResult._ComputedStatus.toLowerCase();
				let tmpBarClass = 'other';
				if (tmpTaskStatus === 'complete')
				{
					tmpBarClass = 'complete';
				}
				else if (tmpTaskStatus === 'error')
				{
					tmpBarClass = 'error';
				}
				else if (tmpTaskStatus === 'running')
				{
					tmpBarClass = 'running';
				}

				let tmpWidthPercent = (tmpMaxTaskMs > 0) ? Math.max((tmpTaskMs / tmpMaxTaskMs) * 100, 1) : 1;
				let tmpNodeHash = tmpResult._NodeHash || '';
				let tmpDisplayName = tmpResult.TaskTypeName || tmpResult._NodeHash || 'Task ' + (i + 1);

				let tmpRowData =
				{
					Label: libTimingUtils.escapeHTML(tmpDisplayName),
					LabelTitle: libTimingUtils.escapeHTML(tmpNodeHash),
					LabelStyle: '',
					BarClass: tmpBarClass,
					BarStyle: '',
					WidthPercent: tmpWidthPercent.toFixed(1),
					BarText: (tmpWidthPercent > 20) ? '<span class="ultravisor-timing-row-bar-text">' + libTimingUtils.escapeHTML(tmpDisplayName) + '</span>' : '',
					Duration: libTimingUtils.escapeHTML(tmpTaskFormatted),
					CountHTML: ''
				};
				tmpHTML += this.pict.parseTemplateByHash('Ultravisor-Timing-Row-Template', tmpRowData);
			}

			// Time axis
			tmpHTML += '<div class="ultravisor-timing-axis">';
			tmpHTML += '<div class="ultravisor-timing-axis-line">';
			let tmpTickCount = 5;
			for (let t = 0; t <= tmpTickCount; t++)
			{
				let tmpTickMs = (tmpMaxTaskMs / tmpTickCount) * t;
				tmpHTML += '<span class="ultravisor-timing-axis-tick">' + libTimingUtils.formatMs(tmpTickMs) + '</span>';
			}
			tmpHTML += '</div>';
			tmpHTML += '<div class="ultravisor-timing-axis-spacer"></div>';
			tmpHTML += '</div>';

			tmpHTML += '</div>';
		}

		tmpHTML += '</div>';

		// ---- Category Histogram ----
		if (pManifest.TimingSummary && pManifest.TimingSummary.ByCategory)
		{
			tmpHTML += this._renderCategoryHistogram(pManifest.TimingSummary.ByCategory);
		}

		// ---- Task Type Histogram ----
		if (pManifest.TimingSummary && pManifest.TimingSummary.ByTaskType)
		{
			tmpHTML += this._renderTaskTypeHistogram(pManifest.TimingSummary.ByTaskType);
		}

		// ---- Event Log Panel ----
		if (pManifest.EventLog && pManifest.EventLog.length > 0)
		{
			tmpHTML += this._renderEventLogPanel(pManifest);
		}

		this.pict.ContentAssignment.assignContent('#Ultravisor-Timing-Detail', tmpHTML);
	}

	_renderCategoryHistogram(pByCategory)
	{
		let tmpCategories = Object.keys(pByCategory);
		if (tmpCategories.length === 0)
		{
			return '';
		}

		// Sort by TotalMs descending
		tmpCategories.sort(function (pA, pB)
		{
			return (pByCategory[pB].TotalMs || 0) - (pByCategory[pA].TotalMs || 0);
		});

		let tmpMaxMs = pByCategory[tmpCategories[0]].TotalMs || 1;

		let tmpHTML = '<div class="ultravisor-timing-card">';
		tmpHTML += '<div class="ultravisor-timing-chart">';
		tmpHTML += '<div class="ultravisor-timing-chart-title">Time by Category</div>';

		for (let i = 0; i < tmpCategories.length; i++)
		{
			let tmpCat = tmpCategories[i];
			let tmpData = pByCategory[tmpCat];
			let tmpMs = tmpData.TotalMs || 0;
			let tmpWidthPercent = Math.max((tmpMs / tmpMaxMs) * 100, 1);
			let tmpColors = libTimingUtils.CategoryColors[tmpCat] || libTimingUtils.CategoryColors['Uncategorized'];

			let tmpRowData =
			{
				Label: libTimingUtils.escapeHTML(tmpCat),
				LabelTitle: '',
				LabelStyle: 'color:' + tmpColors.text + ';',
				BarClass: '',
				BarStyle: ' background: ' + tmpColors.bar + ';',
				WidthPercent: tmpWidthPercent.toFixed(1),
				BarText: (tmpWidthPercent > 15) ? '<span class="ultravisor-timing-row-bar-text">' + libTimingUtils.formatMs(tmpMs) + '</span>' : '',
				Duration: libTimingUtils.formatMs(tmpMs),
				CountHTML: '<div class="ultravisor-timing-row-count">' + tmpData.Count + 'x</div>'
			};
			tmpHTML += this.pict.parseTemplateByHash('Ultravisor-Timing-Row-Template', tmpRowData);
		}

		tmpHTML += '</div>';
		tmpHTML += '</div>';
		return tmpHTML;
	}

	_renderTaskTypeHistogram(pByTaskType)
	{
		let tmpTypes = Object.keys(pByTaskType);
		if (tmpTypes.length === 0)
		{
			return '';
		}

		// Sort by TotalMs descending
		tmpTypes.sort(function (pA, pB)
		{
			return (pByTaskType[pB].TotalMs || 0) - (pByTaskType[pA].TotalMs || 0);
		});

		let tmpMaxMs = pByTaskType[tmpTypes[0]].TotalMs || 1;

		let tmpHTML = '<div class="ultravisor-timing-card">';
		tmpHTML += '<div class="ultravisor-timing-chart">';
		tmpHTML += '<div class="ultravisor-timing-chart-title">Time by Task Type</div>';

		for (let i = 0; i < tmpTypes.length; i++)
		{
			let tmpType = tmpTypes[i];
			let tmpData = pByTaskType[tmpType];
			let tmpMs = tmpData.TotalMs || 0;
			let tmpWidthPercent = Math.max((tmpMs / tmpMaxMs) * 100, 1);
			let tmpCategory = tmpData.Category || 'Uncategorized';
			let tmpColors = libTimingUtils.CategoryColors[tmpCategory] || libTimingUtils.CategoryColors['Uncategorized'];
			let tmpDisplayName = tmpData.Name || tmpType;

			let tmpRowData =
			{
				Label: libTimingUtils.escapeHTML(tmpDisplayName),
				LabelTitle: libTimingUtils.escapeHTML(tmpType),
				LabelStyle: '',
				BarClass: '',
				BarStyle: ' background: ' + tmpColors.bar + ';',
				WidthPercent: tmpWidthPercent.toFixed(1),
				BarText: (tmpWidthPercent > 15) ? '<span class="ultravisor-timing-row-bar-text">' + libTimingUtils.formatMs(tmpMs) + '</span>' : '',
				Duration: libTimingUtils.formatMs(tmpMs),
				CountHTML: '<div class="ultravisor-timing-row-count">' + tmpData.Count + 'x</div>'
			};
			tmpHTML += this.pict.parseTemplateByHash('Ultravisor-Timing-Row-Template', tmpRowData);
		}

		tmpHTML += '</div>';
		tmpHTML += '</div>';
		return tmpHTML;
	}

	_renderEventLogPanel(pManifest)
	{
		let tmpViewRef = "_Pict.views['Ultravisor-TimingView']";

		let tmpHTML = '<div class="ultravisor-timing-card">';
		tmpHTML += '<div class="ultravisor-timing-chart">';
		tmpHTML += '<div class="ultravisor-timing-chart-title">Event Log</div>';

		// Verbosity toggle buttons
		tmpHTML += '<div class="ultravisor-timing-verbosity-controls">';
		tmpHTML += '<button class="ultravisor-timing-verbosity-btn' + (this._currentVerbosity === 0 ? ' active' : '') + '" onclick="' + tmpViewRef + '.setVerbosity(0)">Normal</button>';
		tmpHTML += '<button class="ultravisor-timing-verbosity-btn' + (this._currentVerbosity === 1 ? ' active' : '') + '" onclick="' + tmpViewRef + '.setVerbosity(1)">Verbose</button>';
		tmpHTML += '<button class="ultravisor-timing-verbosity-btn' + (this._currentVerbosity === 2 ? ' active' : '') + '" onclick="' + tmpViewRef + '.setVerbosity(2)">Ultra-verbose</button>';
		tmpHTML += '</div>';

		tmpHTML += '<div id="Ultravisor-Timing-EventLog-Body">';
		tmpHTML += this._renderEventLogTable(pManifest.EventLog, pManifest.StartTime);
		tmpHTML += '</div>';

		tmpHTML += '</div>';
		tmpHTML += '</div>';
		return tmpHTML;
	}

	_renderEventLogTable(pEventLog, pOperationStartTime)
	{
		let tmpStartMs = pOperationStartTime ? new Date(pOperationStartTime).getTime() : 0;
		let tmpMaxVerbosity = this._currentVerbosity;

		let tmpHTML = '<table class="ultravisor-timing-eventlog-table">';
		tmpHTML += '<thead><tr><th>Time</th><th>Node</th><th>Event</th><th>Message</th></tr></thead>';
		tmpHTML += '<tbody>';

		let tmpVisibleCount = 0;

		for (let i = 0; i < pEventLog.length; i++)
		{
			let tmpEvent = pEventLog[i];

			if (tmpEvent.Verbosity > tmpMaxVerbosity)
			{
				continue;
			}

			tmpVisibleCount++;
			let tmpRelativeMs = (tmpEvent.TimestampMs && tmpStartMs) ? (tmpEvent.TimestampMs - tmpStartMs) : 0;
			let tmpVerbClass = 'ultravisor-timing-eventlog-v' + (tmpEvent.Verbosity || 0);

			tmpHTML += '<tr class="' + tmpVerbClass + '">';
			tmpHTML += '<td>+' + libTimingUtils.formatMs(tmpRelativeMs) + '</td>';
			tmpHTML += '<td>' + libTimingUtils.escapeHTML(tmpEvent.NodeHash || '-') + '</td>';
			tmpHTML += '<td>' + libTimingUtils.escapeHTML(tmpEvent.EventName || '') + '</td>';
			tmpHTML += '<td>' + libTimingUtils.escapeHTML(tmpEvent.Message || '') + '</td>';
			tmpHTML += '</tr>';
		}

		if (tmpVisibleCount === 0)
		{
			tmpHTML += '<tr><td colspan="4" style="text-align:center; color:var(--uv-text-tertiary); font-style:italic;">No events at this verbosity level.</td></tr>';
		}

		tmpHTML += '</tbody></table>';
		return tmpHTML;
	}

	setVerbosity(pLevel)
	{
		this._currentVerbosity = pLevel;

		if (this._currentManifest && this._currentManifest.EventLog)
		{
			// Re-render the event log table only
			let tmpTableHTML = this._renderEventLogTable(this._currentManifest.EventLog, this._currentManifest.StartTime);
			this.pict.ContentAssignment.assignContent('#Ultravisor-Timing-EventLog-Body', tmpTableHTML);

			// Update button active states
			let tmpViewRef = "_Pict.views['Ultravisor-TimingView']";
			let tmpBtnHTML = '';
			tmpBtnHTML += '<button class="ultravisor-timing-verbosity-btn' + (pLevel === 0 ? ' active' : '') + '" onclick="' + tmpViewRef + '.setVerbosity(0)">Normal</button>';
			tmpBtnHTML += '<button class="ultravisor-timing-verbosity-btn' + (pLevel === 1 ? ' active' : '') + '" onclick="' + tmpViewRef + '.setVerbosity(1)">Verbose</button>';
			tmpBtnHTML += '<button class="ultravisor-timing-verbosity-btn' + (pLevel === 2 ? ' active' : '') + '" onclick="' + tmpViewRef + '.setVerbosity(2)">Ultra-verbose</button>';

			let tmpControlsEl = document.querySelector('.ultravisor-timing-verbosity-controls');
			if (tmpControlsEl)
			{
				tmpControlsEl.innerHTML = tmpBtnHTML;
			}
		}
	}
}

module.exports = UltravisorTimingView;

module.exports.default_configuration = _ViewConfiguration;

},{"../Ultravisor-TimingUtils.js":244,"pict-view":239}],277:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Ultravisor-TopBar-Nav — slot view rendered into Theme-TopBar's NavView
 * slot. Hosts a slimmed primary-navigation strip (8 entries). The seven
 * dashboard-style views (Timeline, Throughput, Capabilities, Constellation,
 * ReachabilityMap, TimingView, CapabilityHeatMap) collapse behind a
 * single 'Dashboards' entry; the full list lives in the sidebar when
 * a dashboard route is active.
 *
 * Active highlight comes from AppData.Ultravisor.CurrentRoute, which the
 * application keeps in sync with navigateTo() and the hashchange event.
 */

const DASHBOARD_ROUTES = ['/Dashboards', '/Timeline', '/Throughput', '/Capabilities', '/Constellation', '/ReachabilityMap', '/Timing', '/CapabilityHeatMap'];

const PRIMARY_TABS =
[
	{ Hash: 'Home',        Label: 'Home',       Route: '/Home' },
	{ Hash: 'Operations',  Label: 'Operations', Route: '/Operations' },
	{ Hash: 'Schedule',    Label: 'Schedule',   Route: '/Schedule' },
	{ Hash: 'Manifests',   Label: 'Manifests',  Route: '/Manifests' },
	{ Hash: 'Beacons',     Label: 'Beacons',    Route: '/Beacons' },
	{ Hash: 'Dashboards',  Label: 'Dashboards', Route: '/Dashboards' },
	{ Hash: 'Fleet',       Label: 'Fleet',      Route: '/Fleet' },
	{ Hash: 'Users',       Label: 'Users',      Route: '/Users' },
	{ Hash: 'Docs',        Label: 'Docs',       Route: '/Docs' }
];

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-TopBar-Nav",

	DefaultRenderable: "Ultravisor-TopBar-Nav-Display",
	DefaultDestinationAddress: "#Theme-TopBar-Nav",

	AutoRender: false,

	CSS: /*css*/`
		.uv-nav
		{
			display: flex;
			align-items: center;
			height: 100%;
			gap: 0.15em;
			padding: 0 12px;
			min-width: 0;
			overflow-x: auto;
			scrollbar-width: thin;
		}
		.uv-nav-tab
		{
			color: var(--theme-color-text-on-brand, var(--theme-color-text-secondary, #c8b8a0));
			text-decoration: none;
			padding: 0.45em 0.7em;
			border-radius: 4px;
			font-size: 0.85em;
			transition: background-color 0.15s, color 0.15s;
			cursor: pointer;
			white-space: nowrap;
		}
		.uv-nav-tab:hover
		{
			background-color: var(--theme-color-background-hover, rgba(255, 255, 255, 0.06));
			color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #d8c8a8));
		}
		.uv-nav-tab.active
		{
			background-color: var(--theme-color-background-hover, rgba(255, 255, 255, 0.10));
			color: var(--theme-color-brand-primary, var(--theme-color-text-on-brand, #c4956a));
			font-weight: 600;
		}
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-TopBar-Nav-Template",
			Template: /*html*/`
<div class="uv-nav">{~TS:Ultravisor-TopBar-Nav-Tab:AppData.Ultravisor.TopBarNav.Tabs~}</div>`
		},
		{
			Hash: "Ultravisor-TopBar-Nav-Tab",
			Template: /*html*/`<a class="uv-nav-tab{~D:Record.ActiveClass~}" onclick="{~P~}.PictApplication.navigateTo('{~D:Record.Route~}')">{~D:Record.Label~}</a>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-TopBar-Nav-Display",
			TemplateHash: "Ultravisor-TopBar-Nav-Template",
			DestinationAddress: "#Theme-TopBar-Nav",
			RenderMethod: "replace"
		}
	]
};

class UltravisorTopBarNavView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord)
	{
		if (!this.pict.AppData.Ultravisor) { this.pict.AppData.Ultravisor = {}; }
		if (!this.pict.AppData.Ultravisor.TopBarNav) { this.pict.AppData.Ultravisor.TopBarNav = {}; }

		// Auth gate: while signed out in authenticated mode the primary
		// navigation is hidden entirely — signing in is the only available
		// action.  An empty Tabs array paints an empty nav strip.
		let tmpApp = this.pict.PictApplication;
		if (tmpApp && typeof tmpApp.isLoginRequired === 'function' && tmpApp.isLoginRequired())
		{
			this.pict.AppData.Ultravisor.TopBarNav.Tabs = [];
			return super.onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord);
		}

		let tmpRoute = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.CurrentRoute) || '';
		let tmpActiveHash = this._activeTabHash(tmpRoute);

		// Hide the Users tab when the connected auth backend doesn't
		// support user management (no auth-beacon, or beacon advertises
		// UserManagement: external).  Deep links to /Users still work
		// — the views are always registered — but the entry point is
		// removed so the nav doesn't lie about what's available.
		let tmpAuth = (this.pict.AppData.Ultravisor && this.pict.AppData.Ultravisor.Auth) || {};
		let tmpSupportsUM = !!tmpAuth.SupportsUserManagement;

		let tmpTabs = [];
		for (let i = 0; i < PRIMARY_TABS.length; i++)
		{
			let tmpTab = PRIMARY_TABS[i];
			if (tmpTab.Hash === 'Users' && !tmpSupportsUM) { continue; }
			tmpTabs.push(
			{
				Hash:        tmpTab.Hash,
				Label:       tmpTab.Label,
				Route:       tmpTab.Route,
				ActiveClass: (tmpTab.Hash === tmpActiveHash) ? ' active' : ''
			});
		}

		if (!this.pict.AppData.Ultravisor) { this.pict.AppData.Ultravisor = {}; }
		if (!this.pict.AppData.Ultravisor.TopBarNav) { this.pict.AppData.Ultravisor.TopBarNav = {}; }
		this.pict.AppData.Ultravisor.TopBarNav.Tabs = tmpTabs;

		return super.onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}

	_activeTabHash(pRoute)
	{
		if (!pRoute) { return 'Home'; }
		for (let i = 0; i < DASHBOARD_ROUTES.length; i++)
		{
			if (pRoute === DASHBOARD_ROUTES[i] || pRoute.indexOf(DASHBOARD_ROUTES[i] + '/') === 0)
			{
				return 'Dashboards';
			}
		}
		// Match by leading-segment so /Manifests/detail/:hash still highlights Manifests.
		for (let i = 0; i < PRIMARY_TABS.length; i++)
		{
			let tmpTab = PRIMARY_TABS[i];
			if (pRoute === tmpTab.Route || pRoute.indexOf(tmpTab.Route + '/') === 0)
			{
				return tmpTab.Hash;
			}
		}
		return '';
	}
}

module.exports = UltravisorTopBarNavView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],278:[function(require,module,exports){
const libPictView = require('pict-view');

/**
 * Ultravisor-TopBar-User — slot view rendered into Theme-TopBar's UserView
 * slot. Hosts the server-status dot + label, the auth-mode badge
 * (promiscuous/authenticated), the pict-section-usermanagement
 * CurrentUser badge, and a gear button that toggles the hidden settings
 * panel.
 */

const _ViewConfiguration =
{
	ViewIdentifier: "Ultravisor-TopBar-User",

	DefaultRenderable: "Ultravisor-TopBar-User-Display",
	DefaultDestinationAddress: "#Theme-TopBar-User",

	AutoRender: false,

	CSS: /*css*/`
		.uv-user
		{
			display: flex;
			align-items: center;
			height: 100%;
			gap: 0.75em;
			padding: 0 12px;
			color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #c8b8a0));
			font-size: 0.85em;
		}
		.uv-user-status
		{
			display: flex;
			align-items: center;
			gap: 0.5em;
			font-size: 0.8em;
		}
		.uv-status-dot
		{
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background-color: var(--theme-color-text-muted, #706050);
			display: inline-block;
		}
		.uv-status-dot.connected { background-color: var(--theme-color-status-success, #8a9a5a); }
		.uv-status-dot.error     { background-color: var(--theme-color-status-error,   #b04050); }

		.uv-authmode-badge
		{
			display: inline-flex;
			align-items: center;
			padding: 2px 8px;
			border-radius: 10px;
			font-size: 0.7em;
			font-weight: 700;
			letter-spacing: 0.5px;
			text-transform: uppercase;
		}
		.uv-authmode-badge.promiscuous
		{
			background-color: var(--theme-color-status-warning, rgba(245, 158, 11, 0.18));
			color: var(--theme-color-text-on-brand, var(--theme-color-status-warning, #f59e0b));
			border: 1px solid var(--theme-color-status-warning, rgba(245, 158, 11, 0.35));
			opacity: 0.85;
		}
		.uv-authmode-badge.authenticated
		{
			background-color: var(--theme-color-status-success, rgba(34, 197, 94, 0.16));
			color: var(--theme-color-text-on-brand, var(--theme-color-status-success, #34d399));
			border: 1px solid var(--theme-color-status-success, rgba(34, 197, 94, 0.32));
			opacity: 0.85;
		}

		.uv-user-btn
		{
			height: 30px;
			padding: 0 10px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			background: transparent;
			color: var(--theme-color-text-on-brand, var(--theme-color-text-secondary, #c8b8a0));
			border: 1px solid var(--theme-color-border-default, #3a3028);
			border-radius: 4px;
			cursor: pointer;
			font-size: 0.8em;
			box-sizing: border-box;
		}
		.uv-user-btn:hover
		{
			color: var(--theme-color-text-on-brand, var(--theme-color-text-primary, #d8c8a8));
			border-color: var(--theme-color-brand-primary, var(--theme-color-border-strong, #4a4038));
			background: var(--theme-color-background-hover, rgba(255, 255, 255, 0.05));
		}
		.uv-user-btn-gear { padding: 0 8px; }
		.uv-user-btn-gear .pict-icon { font-size: 1.25em; }
	`,

	Templates:
	[
		{
			Hash: "Ultravisor-TopBar-User-Template",
			Template: /*html*/`
<div class="uv-user">
	<!-- pict-section-usermanagement's CurrentUser badge -->
	<span id="PictUM-CurrentUser"></span>
	<div class="uv-user-status" id="Ultravisor-TopBar-StatusArea"></div>
	{~TS:Ultravisor-TopBar-User-Gear:AppData.Ultravisor.TopBarUser.GearItems~}
</div>
`
		},
		{
			Hash: "Ultravisor-TopBar-User-Gear",
			Template: /*html*/`<button class="uv-user-btn uv-user-btn-gear"
		onclick="{~P~}.views['Ultravisor-Layout'].toggleSettingsPanel()"
		title="Settings" aria-label="Settings">{~I:Settings~}</button>`
		},
		{
			Hash: "Ultravisor-TopBar-Status-Template",
			Template: /*html*/`<span class="uv-status-dot {~D:AppData.Ultravisor.ServerStatus.StatusClass~}"></span><span>{~D:AppData.Ultravisor.ServerStatus.StatusText~}</span><span class="uv-authmode-badge {~D:AppData.Ultravisor.ServerStatus.AuthMode~}" title="{~D:AppData.Ultravisor.ServerStatus.AuthTooltip~}">{~D:AppData.Ultravisor.ServerStatus.AuthMode~}</span>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: "Ultravisor-TopBar-User-Display",
			TemplateHash: "Ultravisor-TopBar-User-Template",
			DestinationAddress: "#Theme-TopBar-User",
			RenderMethod: "replace"
		}
	]
};

class UltravisorTopBarUserView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord)
	{
		if (!this.pict.AppData.Ultravisor) { this.pict.AppData.Ultravisor = {}; }
		if (!this.pict.AppData.Ultravisor.TopBarUser) { this.pict.AppData.Ultravisor.TopBarUser = {}; }

		// Auth gate: hide the settings gear while signed out in
		// authenticated mode so the login screen is the only thing the UI
		// exposes.  An empty GearItems array renders no button.
		let tmpApp = this.pict.PictApplication;
		let tmpLoginRequired = !!(tmpApp && typeof tmpApp.isLoginRequired === 'function' && tmpApp.isLoginRequired());
		this.pict.AppData.Ultravisor.TopBarUser.GearItems = tmpLoginRequired ? [] : [{}];

		return super.onBeforeRender(pRenderable, pRenderDestinationAddress, pRecord);
	}

	onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();

		this.pict.PictApplication.loadStatus(
			function (pError)
			{
				let tmpStatus = this.pict.AppData.Ultravisor.ServerStatus;
				if (!pError)
				{
					tmpStatus.StatusClass = 'connected';
					tmpStatus.StatusText = tmpStatus.Status || 'Connected';
				}
				tmpStatus.AuthMode = (tmpStatus.AuthEnabled === true) ? 'authenticated' : 'promiscuous';
				tmpStatus.AuthTooltip = (tmpStatus.AuthEnabled === true)
					? 'An auth-beacon is connected; session-gated routes require a valid login.'
					: 'No auth-beacon connected; session-gated routes accept anonymous sessions.';
				let tmpContent = this.pict.parseTemplateByHash('Ultravisor-TopBar-Status-Template', {}, null, this.pict);
				this.pict.ContentAssignment.assignContent('#Ultravisor-TopBar-StatusArea', tmpContent);
			}.bind(this));

		let tmpCurrentUserView = this.pict.views['PictUM-CurrentUser'];
		if (tmpCurrentUserView)
		{
			let tmpProvider = this.pict.providers['Pict-UserManagement-Provider'];
			if (tmpProvider && !this._didInitialSessionCheck)
			{
				this._didInitialSessionCheck = true;
				tmpProvider.checkSession(() => tmpCurrentUserView.render());
			}
			else
			{
				tmpCurrentUserView.render();
			}
		}

		return super.onAfterRender(pRenderable, pRenderDestinationAddress, pRecord, pContent);
	}
}

module.exports = UltravisorTopBarUserView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],279:[function(require,module,exports){
/**
 * PictView-Ultravisor-UserManagement
 *
 * Hosts the user-management surface inside ultravisor's main content
 * panel. Composes three section views:
 *
 *   - PictUM-UserList         (admin: search/list/edit/delete users)
 *   - PictUM-UserEdit         (admin: create/edit user form)
 *   - PictUM-PasswordChange   (any session: self change-password)
 *
 * The section's CurrentUser badge is rendered in the TopBar, not here
 * — the page itself doesn't need its own session indicator.
 *
 * Sub-tabs (Users | Change my password) keep the admin and self
 * surfaces separate. A non-admin landing on /Users sees only the
 * password tab; the admin tab self-hides via the section's 401/403
 * error path.
 */

const libPictView = require('pict-view');

const _ViewConfiguration =
{
	ViewIdentifier: 'Ultravisor-UserManagement',
	AutoInitialize: true,
	AutoRender: false,

	DefaultRenderable: 'Ultravisor-UserManagement-Content',
	DefaultDestinationAddress: '#Ultravisor-Content-Container',

	Templates:
	[
		{
			Hash: 'Ultravisor-UserManagement-Template',
			Template: /*html*/`
<div class="ultravisor-um-page">
	<div class="ultravisor-um-tabs">
		<button type="button" class="ultravisor-um-tab" id="UV-UM-Tab-Users"
			onclick="{~P~}.views['Ultravisor-UserManagement'].switchTab('users')">Users</button>
		<button type="button" class="ultravisor-um-tab" id="UV-UM-Tab-Pwd"
			onclick="{~P~}.views['Ultravisor-UserManagement'].switchTab('change-password')">Change my password</button>
	</div>
	<div class="ultravisor-um-content">
		<div id="UV-UM-Pane-Users">
			<div id="PictUM-UserList"></div>
			<div id="PictUM-UserEdit" style="margin-top: 16px;"></div>
		</div>
		<div id="UV-UM-Pane-Pwd" style="display:none;">
			<div id="PictUM-PasswordChange"></div>
		</div>
	</div>
</div>`
		}
	],

	Renderables:
	[
		{
			RenderableHash: 'Ultravisor-UserManagement-Content',
			TemplateHash: 'Ultravisor-UserManagement-Template',
			DestinationAddress: '#Ultravisor-Content-Container',
			RenderMethod: 'replace'
		}
	],

	CSS: /*css*/`
		.ultravisor-um-page { padding: 24px; }
		.ultravisor-um-tabs {
			display: flex; gap: 4px; margin-bottom: 16px;
			border-bottom: 1px solid var(--uv-border, #2a2a2a);
		}
		.ultravisor-um-tab {
			background: transparent; border: 0; cursor: pointer;
			padding: 10px 18px; color: var(--uv-text-tertiary, #888);
			font-size: 14px; font-weight: 500;
			border-bottom: 2px solid transparent;
		}
		.ultravisor-um-tab:hover { color: var(--uv-text, #ddd); }
		.ultravisor-um-tab-active {
			color: var(--uv-text, #ddd);
			border-bottom-color: var(--uv-brand, #2563eb);
		}
	`
};

class UltravisorUserManagementView extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._activeTab = 'users';
	}

	switchTab(pTab)
	{
		this._activeTab = pTab;
		this._refreshTabState();
		// Render the section view that's now visible. Other panes stay
		// in the DOM (display:none) so their form state survives toggles.
		let tmpProvider = this._provider();
		if (pTab === 'users' && tmpProvider) { tmpProvider.loadUsers(); }
		this._renderChildren();
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this._refreshTabState();
		// Kick a load so the list paints on first arrival; the section's
		// UserList itself doesn't auto-fetch.
		let tmpProvider = this._provider();
		if (this._activeTab === 'users' && tmpProvider)
		{
			tmpProvider.loadUsers(() => this._renderChildren());
		}
		this._renderChildren();
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender
			? super.onAfterRender(pRenderable, pAddress, pRecord, pContent)
			: undefined;
	}

	_refreshTabState()
	{
		let tmpUsersTab = document.getElementById('UV-UM-Tab-Users');
		let tmpPwdTab = document.getElementById('UV-UM-Tab-Pwd');
		let tmpUsersPane = document.getElementById('UV-UM-Pane-Users');
		let tmpPwdPane = document.getElementById('UV-UM-Pane-Pwd');
		if (tmpUsersTab)
		{
			tmpUsersTab.className = 'ultravisor-um-tab' + (this._activeTab === 'users' ? ' ultravisor-um-tab-active' : '');
		}
		if (tmpPwdTab)
		{
			tmpPwdTab.className = 'ultravisor-um-tab' + (this._activeTab === 'change-password' ? ' ultravisor-um-tab-active' : '');
		}
		if (tmpUsersPane) tmpUsersPane.style.display = (this._activeTab === 'users') ? '' : 'none';
		if (tmpPwdPane) tmpPwdPane.style.display = (this._activeTab === 'change-password') ? '' : 'none';
	}

	_renderChildren()
	{
		// Render section views into their mount points. Each view tracks
		// its own destination — calling render() is enough.
		let tmpList = this.pict.views['PictUM-UserList'];
		let tmpEdit = this.pict.views['PictUM-UserEdit'];
		let tmpPwd = this.pict.views['PictUM-PasswordChange'];
		if (tmpList) tmpList.render();
		if (tmpEdit) tmpEdit.render();
		if (tmpPwd) tmpPwd.render();
	}

	_provider()
	{
		return this.pict.providers && this.pict.providers['Pict-UserManagement-Provider'];
	}
}

module.exports = UltravisorUserManagementView;
module.exports.default_configuration = _ViewConfiguration;

},{"pict-view":239}],280:[function(require,module,exports){
/**
 * render-anomaly-ribbon.js
 *
 * Renders the anomaly ribbon — a thin band, time-aligned to the spine's
 * X-axis, with red/amber tick marks where anomaly buckets fired.
 *
 * State:
 *   {
 *     Window: { FromIso, ToIso },     // identical to the spine's window
 *     Anomalies: [{ At, DurationMs, EventType, Observed, Baseline, Score }],
 *     PadLeft: number,                // matches the spine's PADDING_LEFT
 *     PadRight: number                // matches the spine's PADDING_RIGHT
 *   }
 *
 * Output also writes hit boxes to pState.HitBoxes = [{ x0, x1, anomaly }]
 * for the parent view's hover/click handlers.
 */

function drawAnomalyRibbon(pCanvas, pState)
{
	if (!pCanvas || !pState) return;
	let tmpCtx = pCanvas.getContext('2d');
	if (!tmpCtx) return;
	let tmpDPR = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
	let tmpW = pCanvas.clientWidth || 800;
	let tmpH = pCanvas.clientHeight || 14;
	if (pCanvas.width !== tmpW * tmpDPR) { pCanvas.width = tmpW * tmpDPR; }
	if (pCanvas.height !== tmpH * tmpDPR) { pCanvas.height = tmpH * tmpDPR; }
	tmpCtx.setTransform(tmpDPR, 0, 0, tmpDPR, 0, 0);
	tmpCtx.clearRect(0, 0, tmpW, tmpH);

	// Track outline matching the spine's plot inset.
	let tmpPadL = Number.isFinite(pState.PadLeft) ? pState.PadLeft : 140;
	let tmpPadR = Number.isFinite(pState.PadRight) ? pState.PadRight : 16;
	let tmpX0 = tmpPadL;
	let tmpX1 = tmpW - tmpPadR;
	let tmpTrackY = 1;
	let tmpTrackH = tmpH - 2;
	tmpCtx.fillStyle = 'rgba(180, 180, 180, 0.05)';
	tmpCtx.fillRect(tmpX0, tmpTrackY, Math.max(0, tmpX1 - tmpX0), tmpTrackH);

	// Label.
	tmpCtx.fillStyle = 'rgba(180, 180, 180, 0.55)';
	tmpCtx.font = '600 9px -apple-system, sans-serif';
	tmpCtx.textBaseline = 'middle';
	tmpCtx.textAlign = 'right';
	tmpCtx.fillText('ANOMALY', tmpPadL - 8, tmpH / 2);

	pState.HitBoxes = [];

	let tmpFromMs = Date.parse(pState.Window.FromIso);
	let tmpToMs   = Date.parse(pState.Window.ToIso);
	if (!Number.isFinite(tmpFromMs) || !Number.isFinite(tmpToMs) || tmpToMs <= tmpFromMs) return;

	let tmpAnomalies = Array.isArray(pState.Anomalies) ? pState.Anomalies : [];
	if (tmpAnomalies.length === 0)
	{
		tmpCtx.textAlign = 'left';
		tmpCtx.fillStyle = 'rgba(120, 120, 120, 0.45)';
		tmpCtx.font = '9px -apple-system, sans-serif';
		tmpCtx.fillText('no anomalies in this window', tmpPadL + 6, tmpH / 2);
		return;
	}

	let tmpWidth = tmpX1 - tmpX0;
	for (let i = 0; i < tmpAnomalies.length; i++)
	{
		let tmpA = tmpAnomalies[i];
		let tmpAt = Date.parse(tmpA.At);
		if (!Number.isFinite(tmpAt)) continue;
		let tmpDur = tmpA.DurationMs || 1000;
		let tmpFrac0 = (tmpAt - tmpFromMs) / (tmpToMs - tmpFromMs);
		let tmpFrac1 = ((tmpAt + tmpDur) - tmpFromMs) / (tmpToMs - tmpFromMs);
		if (tmpFrac1 < 0 || tmpFrac0 > 1) continue;
		if (tmpFrac0 < 0) tmpFrac0 = 0;
		if (tmpFrac1 > 1) tmpFrac1 = 1;
		let tmpBoxX0 = tmpX0 + tmpFrac0 * tmpWidth;
		let tmpBoxX1 = tmpX0 + tmpFrac1 * tmpWidth;
		if (tmpBoxX1 - tmpBoxX0 < 2) tmpBoxX1 = tmpBoxX0 + 2;

		let tmpColor = _scoreColor(tmpA.Score, tmpA.EventType);
		tmpCtx.fillStyle = tmpColor;
		tmpCtx.fillRect(tmpBoxX0, tmpTrackY, tmpBoxX1 - tmpBoxX0, tmpTrackH);

		pState.HitBoxes.push({
			X0: tmpBoxX0,
			X1: tmpBoxX1,
			Anomaly: tmpA
		});
	}
}

function _scoreColor(pScore, pEventType)
{
	let tmpScore = Number.isFinite(pScore) ? pScore : 1;
	if (pEventType === 'Admission.Denied')
	{
		return 'rgba(220, 38, 38, ' + Math.min(0.95, 0.4 + tmpScore * 0.18) + ')';
	}
	if (pEventType === 'Failed')
	{
		return 'rgba(239, 68, 68, ' + Math.min(0.95, 0.35 + tmpScore * 0.16) + ')';
	}
	// Stalled
	return 'rgba(249, 115, 22, ' + Math.min(0.95, 0.32 + tmpScore * 0.16) + ')';
}

function hitTest(pX, pState)
{
	let tmpHB = (pState && pState.HitBoxes) || [];
	for (let i = 0; i < tmpHB.length; i++)
	{
		if (pX >= tmpHB[i].X0 - 2 && pX <= tmpHB[i].X1 + 2)
		{
			return tmpHB[i].Anomaly;
		}
	}
	return null;
}

module.exports =
{
	drawAnomalyRibbon: drawAnomalyRibbon,
	hitTest:           hitTest
};

},{}],281:[function(require,module,exports){
/**
 * render-bands.js
 *
 * Pure render functions for the timeline view. Imperative Canvas + SVG
 * draw — Pict's escape hatch for high-density visualization, called
 * from PictView-Ultravisor-Timeline's onAfterRender. No Pict coupling
 * here; takes a state object and DOM nodes, paints them.
 *
 * Layout:
 *   ┌────────────────────────┐
 *   │ Top: stacked area      │  ← queue counts over time (bucketed)
 *   ├────────────────────────┤
 *   │ Middle: capability     │  ← one row per capability (utilization)
 *   │ swimlanes              │
 *   ├────────────────────────┤
 *   │ Bottom: beacon         │  ← one row per beacon, blocks per work item
 *   │ swimlanes              │
 *   └────────────────────────┘
 *
 * State shape (from AppData.Timeline):
 *   {
 *     Window: { FromIso, ToIso, Mode, Bucket },
 *     Stream: { Past, Present, Future, Buckets, Now, ... },
 *     CapabilityRows: [{ Capability }, ...],
 *     BeaconRows: [{ BeaconID, Display }, ...],
 *     Focus: { Kind, Hash } | null
 *   }
 */

// Status → color (CSS variables resolved at runtime against the page).
const STATUS_COLORS =
{
	'Pending':      { fill: '#3b82f6', stroke: '#2563eb' }, // blue
	'Queued':       { fill: '#3b82f6', stroke: '#2563eb' },
	'Assigned':     { fill: '#6366f1', stroke: '#4338ca' }, // indigo
	'Dispatched':   { fill: '#f59e0b', stroke: '#d97706' }, // amber
	'Running':      { fill: '#f59e0b', stroke: '#d97706' },
	'Complete':     { fill: '#10b981', stroke: '#059669' }, // green
	'Failed':       { fill: '#ef4444', stroke: '#dc2626' }, // red
	'Error':        { fill: '#ef4444', stroke: '#dc2626' },
	'Stalled':      { fill: '#f97316', stroke: '#ea580c' }, // orange
	'Canceled':     { fill: '#9ca3af', stroke: '#6b7280' }, // gray
	'Abandoned':    { fill: '#9ca3af', stroke: '#6b7280' }
};

const DEFAULT_COLOR = { fill: '#6b7280', stroke: '#4b5563' };

// Layout constants. The view's CSS sets the canvas size; these are the
// internal pixel offsets.
const PADDING_LEFT  = 140;  // room for row labels (capability/beacon)
const PADDING_RIGHT = 16;
const PADDING_TOP   = 24;   // room for time-axis labels
const PADDING_BOT   = 8;
const TOP_BAND_HEIGHT_RATIO = 0.30;
const MIDDLE_BAND_HEIGHT_RATIO = 0.30;
const BOTTOM_BAND_HEIGHT_RATIO = 0.40;
const BAND_GAP = 8;
const ROW_HEIGHT_MIN = 14;

// Public entry point. Pulls all the data out of `pState`, paints the
// canvas, updates the SVG overlay (cursor + focus rect).
function drawTimeline(pCanvas, pSVG, pState)
{
	if (!pCanvas || !pState) return;
	let tmpCtx = pCanvas.getContext('2d');
	if (!tmpCtx) return;

	// Match canvas backing-store size to its CSS size to avoid blur on
	// HiDPI displays. The CSS sizes the element; we set width/height
	// to match * devicePixelRatio.
	let tmpDPR = window.devicePixelRatio || 1;
	let tmpCSSWidth = pCanvas.clientWidth || 800;
	let tmpCSSHeight = pCanvas.clientHeight || 400;
	if (pCanvas.width !== tmpCSSWidth * tmpDPR) { pCanvas.width = tmpCSSWidth * tmpDPR; }
	if (pCanvas.height !== tmpCSSHeight * tmpDPR) { pCanvas.height = tmpCSSHeight * tmpDPR; }
	tmpCtx.setTransform(tmpDPR, 0, 0, tmpDPR, 0, 0);

	// Clear.
	tmpCtx.clearRect(0, 0, tmpCSSWidth, tmpCSSHeight);

	let tmpFromMs = Date.parse(pState.Window.FromIso) || (Date.now() - 120000);
	let tmpToMs   = Date.parse(pState.Window.ToIso)   || (Date.now() + 30000);
	if (tmpToMs <= tmpFromMs) { tmpToMs = tmpFromMs + 1; }
	let tmpNowMs  = Date.parse(pState.Stream.Now) || Date.now();

	let tmpPlot = {
		x0: PADDING_LEFT,
		x1: tmpCSSWidth - PADDING_RIGHT,
		y0: PADDING_TOP,
		y1: tmpCSSHeight - PADDING_BOT,
		fromMs: tmpFromMs,
		toMs:   tmpToMs,
		nowMs:  tmpNowMs,
		dpr:    tmpDPR
	};
	tmpPlot.width  = tmpPlot.x1 - tmpPlot.x0;
	tmpPlot.height = tmpPlot.y1 - tmpPlot.y0;

	// Band Y ranges.
	let tmpBandH = tmpPlot.height - 2 * BAND_GAP;
	let tmpTopH  = Math.max(60, tmpBandH * TOP_BAND_HEIGHT_RATIO);
	let tmpMidH  = Math.max(60, tmpBandH * MIDDLE_BAND_HEIGHT_RATIO);
	let tmpBotH  = Math.max(60, tmpBandH - tmpTopH - tmpMidH);

	let tmpTopY  = tmpPlot.y0;
	let tmpMidY  = tmpTopY + tmpTopH + BAND_GAP;
	let tmpBotY  = tmpMidY + tmpMidH + BAND_GAP;

	// X-axis ticks + future shading.
	_drawTimeAxis(tmpCtx, tmpPlot, tmpCSSWidth, tmpCSSHeight);
	_drawFutureShade(tmpCtx, tmpPlot, tmpTopY, tmpBotY + tmpBotH);

	// Top band — stacked area of queue counts (from Buckets, or
	// computed from raw if no buckets).
	_drawTopBand(tmpCtx, tmpPlot, tmpTopY, tmpTopH, pState);

	// Middle band — capability swimlanes.
	_drawCapabilityBand(tmpCtx, tmpPlot, tmpMidY, tmpMidH, pState);

	// Bottom band — beacon swimlanes.
	_drawBeaconBand(tmpCtx, tmpPlot, tmpBotY, tmpBotH, pState);

	// Now-line marker.
	_drawNowLine(tmpCtx, tmpPlot, tmpTopY, tmpBotY + tmpBotH);

	// Update SVG overlay (cursor + focus rect). We keep these in SVG
	// for crisp lines and easy DOM-driven hover.
	if (pSVG)
	{
		_updateSVGOverlay(pSVG, pState, tmpPlot, tmpCSSWidth, tmpCSSHeight);
	}
}

// ─────────────────────────────────────────────────────────────────────
// Time axis + shading
// ─────────────────────────────────────────────────────────────────────

function _drawTimeAxis(pCtx, pPlot, pWidth, pHeight)
{
	// Pick a tick interval that yields ~6-10 ticks across the visible
	// span. Reasonable steps in seconds.
	let tmpSpanMs = pPlot.toMs - pPlot.fromMs;
	let tmpSteps = [1, 5, 10, 30, 60, 300, 600, 1800, 3600, 21600, 86400];
	let tmpStep = tmpSteps[0] * 1000;
	for (let i = 0; i < tmpSteps.length; i++)
	{
		if (tmpSpanMs / (tmpSteps[i] * 1000) <= 10)
		{
			tmpStep = tmpSteps[i] * 1000;
			break;
		}
		tmpStep = tmpSteps[i] * 1000;
	}

	pCtx.fillStyle = 'rgba(180, 180, 180, 0.7)';
	pCtx.font = '11px -apple-system, BlinkMacSystemFont, sans-serif';
	pCtx.textBaseline = 'top';
	pCtx.textAlign = 'center';
	pCtx.strokeStyle = 'rgba(180, 180, 180, 0.15)';
	pCtx.lineWidth = 1;

	let tmpStart = Math.ceil(pPlot.fromMs / tmpStep) * tmpStep;
	for (let t = tmpStart; t < pPlot.toMs; t += tmpStep)
	{
		let tmpX = _timeToX(t, pPlot);
		pCtx.beginPath();
		pCtx.moveTo(tmpX, pPlot.y0);
		pCtx.lineTo(tmpX, pPlot.y1);
		pCtx.stroke();
		pCtx.fillText(_formatTime(t, tmpStep), tmpX, 4);
	}
}

function _drawFutureShade(pCtx, pPlot, pYTop, pYBot)
{
	if (pPlot.nowMs >= pPlot.toMs) return;
	if (pPlot.nowMs <= pPlot.fromMs) return;
	let tmpX = _timeToX(pPlot.nowMs, pPlot);
	pCtx.fillStyle = 'rgba(120, 130, 160, 0.06)';
	pCtx.fillRect(tmpX, pYTop, pPlot.x1 - tmpX, pYBot - pYTop);
}

function _drawNowLine(pCtx, pPlot, pYTop, pYBot)
{
	if (pPlot.nowMs < pPlot.fromMs || pPlot.nowMs > pPlot.toMs) return;
	let tmpX = _timeToX(pPlot.nowMs, pPlot);
	pCtx.strokeStyle = 'rgba(245, 158, 11, 0.7)';
	pCtx.lineWidth = 1.5;
	pCtx.setLineDash([4, 3]);
	pCtx.beginPath();
	pCtx.moveTo(tmpX, pYTop);
	pCtx.lineTo(tmpX, pYBot);
	pCtx.stroke();
	pCtx.setLineDash([]);
}

// ─────────────────────────────────────────────────────────────────────
// Top band — stacked area of queue-state counts over time
// ─────────────────────────────────────────────────────────────────────

function _drawTopBand(pCtx, pPlot, pY, pH, pState)
{
	_drawBandLabel(pCtx, 'Queue', pPlot.x0, pY);

	let tmpBuckets = pState.Stream.Buckets;
	let tmpRecords = pState.Stream.Past || [];

	// If we have buckets, use them; otherwise bucket raw records here
	// to a width-derived bucket size.
	let tmpBucketed = tmpBuckets;
	if (!tmpBucketed || tmpBucketed.length === 0)
	{
		tmpBucketed = _clientBucket(tmpRecords, pPlot, 60); // ~60 buckets target
	}
	if (tmpBucketed.length === 0)
	{
		// Empty — draw a baseline.
		pCtx.strokeStyle = 'rgba(180, 180, 180, 0.2)';
		pCtx.lineWidth = 1;
		pCtx.beginPath();
		pCtx.moveTo(pPlot.x0, pY + pH - 1);
		pCtx.lineTo(pPlot.x1, pY + pH - 1);
		pCtx.stroke();
		return;
	}

	// Build stack data: per bucket, count by terminal/active status.
	const tmpStackOrder = ['Pending', 'Dispatched', 'Running', 'Complete', 'Failed', 'Stalled'];
	let tmpStackByBucket = tmpBucketed.map(function (pB)
	{
		let tmpRow = {};
		let tmpStatuses = pB.ByStatus || {};
		let tmpTypes = pB.ByEventType || {};
		// Some columns come through ByEventType (e.g. Enqueued maps to
		// Pending in the queue-state sense). Fold both into stack rows.
		tmpRow.Pending    = (tmpTypes.Enqueued    || 0);
		tmpRow.Dispatched = (tmpTypes.Dispatched  || 0) + (tmpStatuses.Dispatched || 0);
		tmpRow.Running    = (tmpStatuses.Running  || 0);
		tmpRow.Complete   = (tmpTypes.Completed   || 0) + (tmpTypes['Execution.ExecutionComplete'] || 0);
		tmpRow.Failed     = (tmpTypes.Failed      || 0);
		tmpRow.Stalled    = (tmpTypes.Stalled     || 0) + (tmpTypes['Workitem.Stranded'] || 0);
		tmpRow.At = pB.At;
		return tmpRow;
	});

	// Find max stacked total.
	let tmpMax = 1;
	for (let i = 0; i < tmpStackByBucket.length; i++)
	{
		let tmpSum = 0;
		for (let j = 0; j < tmpStackOrder.length; j++)
		{
			tmpSum += tmpStackByBucket[i][tmpStackOrder[j]] || 0;
		}
		if (tmpSum > tmpMax) tmpMax = tmpSum;
	}

	// Stack each bucket as a column of segments. Per-bucket DurationMs
	// (carried in the server response and in _clientBucket output)
	// drives column width — using consecutive bucket spacing breaks
	// when the server omits empty buckets (which it does), so a 1s
	// bucket sitting next to a 6s gap would render 6s wide.
	for (let i = 0; i < tmpBucketed.length; i++)
	{
		let tmpRow = tmpStackByBucket[i];
		let tmpBucketStartMs = Date.parse(tmpRow.At);
		if (!Number.isFinite(tmpBucketStartMs)) continue;
		let tmpBucketDur = tmpBucketed[i].DurationMs || 1000;
		let tmpColWidth = (tmpBucketDur / (pPlot.toMs - pPlot.fromMs)) * pPlot.width;
		if (tmpColWidth < 1) tmpColWidth = 1;
		// Inset 1px on each side so columns visually separate even
		// when adjacent buckets touch — turns "stacked area" into
		// "stacked column chart" without server changes.
		let tmpInset = (tmpColWidth > 4) ? 1 : 0;
		let tmpX = _timeToX(tmpBucketStartMs, pPlot) + tmpInset;
		let tmpDrawW = Math.max(1, tmpColWidth - 2 * tmpInset);
		let tmpYAccum = pY + pH;
		for (let j = 0; j < tmpStackOrder.length; j++)
		{
			let tmpKey = tmpStackOrder[j];
			let tmpVal = tmpRow[tmpKey] || 0;
			if (tmpVal === 0) continue;
			let tmpSegH = (tmpVal / tmpMax) * pH;
			let tmpColor = _statusColor(tmpKey);
			pCtx.fillStyle = tmpColor.fill;
			pCtx.fillRect(tmpX, tmpYAccum - tmpSegH, tmpDrawW, tmpSegH);
			tmpYAccum -= tmpSegH;
		}
	}

	// Y-axis label (max count).
	pCtx.fillStyle = 'rgba(180, 180, 180, 0.6)';
	pCtx.font = '10px monospace';
	pCtx.textBaseline = 'top';
	pCtx.textAlign = 'left';
	pCtx.fillText('max ' + tmpMax, pPlot.x0 + 4, pY + 2);
}

// Bucket raw records client-side when the endpoint returned raw mode.
//
// Bucket boundaries are anchored to ABSOLUTE epoch time (snapped to the
// nearest "nice" interval at or below the target bucket size), NOT to
// pPlot.fromMs. Anchoring to fromMs causes the same record to land in
// different buckets every time the window slides, which makes the
// histogram visibly hop around mid-drag. Absolute-time anchoring means
// records keep their bucket through any pan / zoom — the histogram
// just slides along with the time axis.
function _clientBucket(pRecords, pPlot, pTargetCount)
{
	if (!pRecords || pRecords.length === 0) return [];
	let tmpRawBucketMs = (pPlot.toMs - pPlot.fromMs) / pTargetCount;
	if (tmpRawBucketMs <= 0) tmpRawBucketMs = 1000;
	let tmpBucketMs = _snapBucketSize(tmpRawBucketMs);
	let tmpBuckets = new Map();
	for (let i = 0; i < pRecords.length; i++)
	{
		let tmpAt = Date.parse(pRecords[i].At);
		if (!Number.isFinite(tmpAt)) continue;
		// Snap to absolute epoch boundary, not to fromMs.
		let tmpStart = Math.floor(tmpAt / tmpBucketMs) * tmpBucketMs;
		let tmpKey = String(tmpStart);
		if (!tmpBuckets.has(tmpKey))
		{
			tmpBuckets.set(tmpKey, {
				At: new Date(tmpStart).toISOString(),
				DurationMs: tmpBucketMs,
				Count: 0, ByEventType: {}, ByCapability: {}, ByStatus: {}
			});
		}
		let tmpB = tmpBuckets.get(tmpKey);
		tmpB.Count++;
		let tmpET = pRecords[i].EventType || 'Unknown';
		let tmpC  = pRecords[i].Capability;
		let tmpS  = pRecords[i].Status;
		tmpB.ByEventType[tmpET] = (tmpB.ByEventType[tmpET] || 0) + 1;
		if (tmpC) { tmpB.ByCapability[tmpC] = (tmpB.ByCapability[tmpC] || 0) + 1; }
		if (tmpS) { tmpB.ByStatus[tmpS] = (tmpB.ByStatus[tmpS] || 0) + 1; }
	}
	let tmpOut = [];
	tmpBuckets.forEach(function (pB) { tmpOut.push(pB); });
	tmpOut.sort(function (pA, pB) { return pA.At < pB.At ? -1 : pA.At > pB.At ? 1 : 0; });
	return tmpOut;
}

// Snap a raw target bucket size (ms) DOWN to the largest "nice"
// step at or below it. Nice = something a clock displays cleanly
// (multiples of 1s, 5s, 10s, 30s, 1m, 5m, 10m, 30m, 1h, 6h, 1d).
// Snapping down means the visualization is at least as detailed as
// requested; snapping at all means bucket boundaries land on
// human-readable times.
function _snapBucketSize(pRawMs)
{
	const STEPS_MS =
	[
		1000,           // 1s
		5000,           // 5s
		10000,          // 10s
		30000,          // 30s
		60000,          // 1m
		300000,         // 5m
		600000,         // 10m
		1800000,        // 30m
		3600000,        // 1h
		21600000,       // 6h
		86400000        // 1d
	];
	let tmpPick = STEPS_MS[0];
	for (let i = 0; i < STEPS_MS.length; i++)
	{
		if (STEPS_MS[i] <= pRawMs) { tmpPick = STEPS_MS[i]; }
		else { break; }
	}
	return tmpPick;
}

// ─────────────────────────────────────────────────────────────────────
// Middle band — capability swimlanes
// ─────────────────────────────────────────────────────────────────────

function _drawCapabilityBand(pCtx, pPlot, pY, pH, pState)
{
	_drawBandLabel(pCtx, 'Capability', pPlot.x0, pY);
	let tmpRows = pState.CapabilityRows || [];
	if (tmpRows.length === 0)
	{
		_drawBandEmpty(pCtx, pPlot, pY, pH, '(no capability activity)');
		return;
	}
	// Build a BeaconID → Capability lookup from any record that
	// carries both. Many envelope projections (queue.completed in
	// particular) only carry BeaconID, not Capability, so without
	// this lookup the capability band would render empty even when
	// the beacon band is busy. The two are by definition isomorphic
	// for the duration of a work item.
	let tmpBeaconCap = _buildBeaconCapabilityIndex(pState);
	let tmpRowH = Math.max(ROW_HEIGHT_MIN, Math.floor(pH / tmpRows.length));
	for (let i = 0; i < tmpRows.length; i++)
	{
		let tmpY = pY + i * tmpRowH;
		_drawRowLabel(pCtx, tmpRows[i].Capability, pPlot.x0, tmpY, tmpRowH);
		_drawRowSeparator(pCtx, pPlot, tmpY + tmpRowH);
		_drawCapabilityRow(pCtx, pPlot, tmpY, tmpRowH, tmpRows[i].Capability, pState, tmpBeaconCap);
	}
}

function _buildBeaconCapabilityIndex(pState)
{
	let tmpIdx = new Map();
	let fScan = function (pRecords)
	{
		for (let i = 0; i < pRecords.length; i++)
		{
			let tmpR = pRecords[i];
			if (!tmpR || !tmpR.BeaconID || !tmpR.Capability) continue;
			tmpIdx.set(tmpR.BeaconID, tmpR.Capability);
		}
	};
	fScan(pState.Stream.Past || []);
	fScan(pState.Stream.Present || []);
	fScan(pState.Stream.Future || []);
	return tmpIdx;
}

function _drawCapabilityRow(pCtx, pPlot, pY, pH, pCapability, pState, pBeaconCap)
{
	let tmpStream = pState.Stream;

	// Past — render only records that represent ACTUAL OCCUPANCY:
	// terminal events (Completed/Failed/Stalled/Canceled) carry a
	// DurationMs; render their actual span as [At - DurationMs, At].
	// Skip point events (Enqueued, Dispatched without duration) — they
	// don't represent the beacon being busy, just notifications about
	// state changes, and they render as 1px slivers that drown the band.
	//
	// For records missing Capability (queue.completed envelopes are a
	// common offender), fall back to the BeaconID → Capability index
	// the band built above.
	let tmpPast = tmpStream.Past || [];
	for (let i = 0; i < tmpPast.length; i++)
	{
		let tmpR = tmpPast[i];
		if (!tmpR) continue;
		let tmpCap = tmpR.Capability || (pBeaconCap && tmpR.BeaconID ? pBeaconCap.get(tmpR.BeaconID) : '');
		if (tmpCap !== pCapability) continue;
		if (!(tmpR.DurationMs > 0)) continue;
		let tmpEndMs = Date.parse(tmpR.At);
		if (!Number.isFinite(tmpEndMs)) continue;
		let tmpStartMs = tmpEndMs - tmpR.DurationMs;
		let tmpX0 = _timeToX(tmpStartMs, pPlot);
		let tmpX1 = Math.max(tmpX0 + 2, _timeToX(tmpEndMs, pPlot));
		let tmpColor = _statusColor(tmpR.Status || tmpR.EventType);
		pCtx.fillStyle = _withAlpha(tmpColor.fill, 0.65);
		pCtx.fillRect(tmpX0, pY + 2, tmpX1 - tmpX0, pH - 4);
	}

	// Present — open-ended spans from DispatchedAt through "now".
	let tmpPresent = tmpStream.Present || [];
	for (let i = 0; i < tmpPresent.length; i++)
	{
		let tmpR = tmpPresent[i];
		if (!tmpR || tmpR.Capability !== pCapability) continue;
		let tmpAt    = Date.parse(tmpR.At);
		let tmpEndAt = Date.parse(tmpR.EndAt) || tmpAt;
		if (!Number.isFinite(tmpAt)) continue;
		let tmpX0 = _timeToX(tmpAt, pPlot);
		let tmpX1 = Math.max(tmpX0 + 2, _timeToX(tmpEndAt, pPlot));
		let tmpColor = _statusColor(tmpR.Status || 'Running');
		pCtx.fillStyle = _withAlpha(tmpColor.fill, 0.95);
		pCtx.fillRect(tmpX0, pY + 2, tmpX1 - tmpX0, pH - 4);
	}

	// Future predictions. Filter to this capability and cap to a
	// small number — server gives us up to 32 per capability (1s
	// stagger × 32 = a 48s wall of solid color in a 30s window).
	// 6 visible predictions is enough to convey "queue is deep here."
	let tmpFutureForCap = [];
	let tmpFuture = tmpStream.Future || [];
	for (let i = 0; i < tmpFuture.length; i++)
	{
		if (tmpFuture[i] && tmpFuture[i].Capability === pCapability)
		{
			tmpFutureForCap.push(tmpFuture[i]);
		}
	}
	const FUTURE_RENDER_CAP = 6;
	let tmpFutureRender = tmpFutureForCap.slice(0, FUTURE_RENDER_CAP);
	for (let i = 0; i < tmpFutureRender.length; i++)
	{
		let tmpR = tmpFutureRender[i];
		let tmpAt = Date.parse(tmpR.PredictedAtIso || tmpR.At);
		if (!Number.isFinite(tmpAt)) continue;
		let tmpDur = Number.isFinite(tmpR.DurationMs) ? tmpR.DurationMs : 1000;
		let tmpX0 = _timeToX(tmpAt, pPlot);
		let tmpX1 = Math.max(tmpX0 + 2, _timeToX(tmpAt + tmpDur, pPlot));
		let tmpConf = Number.isFinite(tmpR.PredictionConfidence) ? tmpR.PredictionConfidence : 0;
		// Hard alpha cap at 0.18 — predictions are advisory, not facts.
		// Without this, sequential predictions stack visually into a
		// solid block.
		let tmpAlpha = Math.max(0.05, Math.min(0.18, tmpConf * 0.18));
		let tmpColor = _statusColor('Dispatched');
		pCtx.fillStyle = _withAlpha(tmpColor.fill, tmpAlpha);
		// Inset 1px on each side and 4px vertically so each prediction
		// is visually distinct from its neighbors.
		let tmpDrawW = Math.max(1, (tmpX1 - tmpX0) - 2);
		pCtx.fillRect(tmpX0 + 1, pY + 4, tmpDrawW, pH - 8);
		// Dashed top border to mark this as predicted, not actual.
		pCtx.strokeStyle = _withAlpha(tmpColor.stroke, tmpAlpha * 2);
		pCtx.lineWidth = 0.5;
		pCtx.setLineDash([2, 2]);
		pCtx.strokeRect(tmpX0 + 1, pY + 4, tmpDrawW, pH - 8);
		pCtx.setLineDash([]);
	}

	// Tally text: "+N more queued" when we trimmed.
	if (tmpFutureForCap.length > FUTURE_RENDER_CAP)
	{
		let tmpExtra = tmpFutureForCap.length - FUTURE_RENDER_CAP;
		pCtx.fillStyle = 'rgba(180, 180, 180, 0.55)';
		pCtx.font = '10px monospace';
		pCtx.textBaseline = 'middle';
		pCtx.textAlign = 'left';
		pCtx.fillText('+' + tmpExtra + ' queued', pPlot.x1 - 78, pY + pH / 2);
	}
}

// ─────────────────────────────────────────────────────────────────────
// Bottom band — beacon swimlanes
// ─────────────────────────────────────────────────────────────────────

function _drawBeaconBand(pCtx, pPlot, pY, pH, pState)
{
	_drawBandLabel(pCtx, 'Beacon', pPlot.x0, pY);
	let tmpRows = pState.BeaconRows || [];
	if (tmpRows.length === 0)
	{
		_drawBandEmpty(pCtx, pPlot, pY, pH, '(no beacon activity)');
		return;
	}
	let tmpRowH = Math.max(ROW_HEIGHT_MIN, Math.floor(pH / tmpRows.length));
	for (let i = 0; i < tmpRows.length; i++)
	{
		let tmpY = pY + i * tmpRowH;
		_drawRowLabel(pCtx, tmpRows[i].Display, pPlot.x0, tmpY, tmpRowH);
		_drawRowSeparator(pCtx, pPlot, tmpY + tmpRowH);
		_drawBeaconRow(pCtx, pPlot, tmpY, tmpRowH, tmpRows[i].BeaconID, pState);
	}
}

function _drawBeaconRow(pCtx, pPlot, pY, pH, pBeaconID, pState)
{
	let tmpStream = pState.Stream;

	// Past — beacon work-item occupancy. Same shape as the capability
	// band: terminal events with DurationMs > 0 render as their actual
	// running span [At - DurationMs, At]; point events (Enqueued,
	// Dispatched-without-duration) are skipped. Without this filter,
	// every state-change event renders as a 1px sliver and the band
	// turns into noise.
	let tmpPast = tmpStream.Past || [];
	for (let i = 0; i < tmpPast.length; i++)
	{
		let tmpR = tmpPast[i];
		if (!tmpR || tmpR.BeaconID !== pBeaconID) continue;
		if (!(tmpR.DurationMs > 0)) continue;
		let tmpEndMs = Date.parse(tmpR.At);
		if (!Number.isFinite(tmpEndMs)) continue;
		let tmpStartMs = tmpEndMs - tmpR.DurationMs;
		let tmpX0 = _timeToX(tmpStartMs, pPlot);
		let tmpX1 = Math.max(tmpX0 + 3, _timeToX(tmpEndMs, pPlot));
		let tmpColor = _statusColor(tmpR.Status || tmpR.EventType);
		pCtx.fillStyle = _withAlpha(tmpColor.fill, 0.75);
		pCtx.fillRect(tmpX0, pY + 2, tmpX1 - tmpX0, pH - 4);
		pCtx.strokeStyle = _withAlpha(tmpColor.stroke, 0.85);
		pCtx.lineWidth = 0.5;
		pCtx.strokeRect(tmpX0, pY + 2, tmpX1 - tmpX0, pH - 4);
	}

	// Present — open-ended spans (DispatchedAt → now) for in-flight items.
	let tmpPresent = tmpStream.Present || [];
	for (let i = 0; i < tmpPresent.length; i++)
	{
		let tmpR = tmpPresent[i];
		if (!tmpR || tmpR.BeaconID !== pBeaconID) continue;
		let tmpAt    = Date.parse(tmpR.At);
		let tmpEndAt = Date.parse(tmpR.EndAt) || tmpAt;
		if (!Number.isFinite(tmpAt)) continue;
		let tmpX0 = _timeToX(tmpAt, pPlot);
		let tmpX1 = Math.max(tmpX0 + 3, _timeToX(tmpEndAt, pPlot));
		let tmpColor = _statusColor(tmpR.Status || 'Running');
		pCtx.fillStyle = _withAlpha(tmpColor.fill, 1.0);
		pCtx.fillRect(tmpX0, pY + 2, tmpX1 - tmpX0, pH - 4);
		pCtx.strokeStyle = _withAlpha(tmpColor.stroke, 1.0);
		pCtx.lineWidth = 0.5;
		pCtx.strokeRect(tmpX0, pY + 2, tmpX1 - tmpX0, pH - 4);
	}
}

// ─────────────────────────────────────────────────────────────────────
// SVG overlay — focus rect + (later) hover tooltip
// ─────────────────────────────────────────────────────────────────────

function _updateSVGOverlay(pSVG, pState, pPlot, pCSSWidth, pCSSHeight)
{
	pSVG.setAttribute('width',  pCSSWidth);
	pSVG.setAttribute('height', pCSSHeight);
	pSVG.setAttribute('viewBox', '0 0 ' + pCSSWidth + ' ' + pCSSHeight);

	// Focus rectangle (when AppData.Timeline.Focus is set).
	let tmpFocusRect = pSVG.querySelector('[data-role="focus-rect"]');
	if (!tmpFocusRect)
	{
		tmpFocusRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
		tmpFocusRect.setAttribute('data-role', 'focus-rect');
		tmpFocusRect.setAttribute('fill', 'none');
		tmpFocusRect.setAttribute('stroke', '#fbbf24');
		tmpFocusRect.setAttribute('stroke-width', '2');
		tmpFocusRect.setAttribute('rx', '3');
		tmpFocusRect.setAttribute('pointer-events', 'none');
		pSVG.appendChild(tmpFocusRect);
	}
	if (pState.Focus && pState.Focus.Hash)
	{
		// Geometry resolution depends on what kind of focus and where
		// the matching record landed. Stage 1: just hide it; Pillar 4
		// wires the click-to-focus selector and computes the rect.
		tmpFocusRect.setAttribute('display', 'none');
	}
	else
	{
		tmpFocusRect.setAttribute('display', 'none');
	}
}

// ─────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────

function _timeToX(pTimeMs, pPlot)
{
	let tmpFrac = (pTimeMs - pPlot.fromMs) / (pPlot.toMs - pPlot.fromMs);
	if (tmpFrac < 0) tmpFrac = 0;
	if (tmpFrac > 1) tmpFrac = 1;
	return pPlot.x0 + tmpFrac * pPlot.width;
}

function _statusColor(pStatusOrType)
{
	if (!pStatusOrType) return DEFAULT_COLOR;
	return STATUS_COLORS[pStatusOrType] || DEFAULT_COLOR;
}

function _withAlpha(pHex, pAlpha)
{
	// Convert "#RRGGBB" to "rgba(r,g,b,a)". Falls through if not hex.
	if (typeof pHex !== 'string' || pHex.charAt(0) !== '#' || pHex.length !== 7) { return pHex; }
	let tmpR = parseInt(pHex.slice(1, 3), 16);
	let tmpG = parseInt(pHex.slice(3, 5), 16);
	let tmpB = parseInt(pHex.slice(5, 7), 16);
	return 'rgba(' + tmpR + ',' + tmpG + ',' + tmpB + ',' + pAlpha + ')';
}

function _drawBandLabel(pCtx, pLabel, pX, pY)
{
	pCtx.fillStyle = 'rgba(200, 200, 200, 0.5)';
	pCtx.font = '600 10px -apple-system, sans-serif';
	pCtx.textBaseline = 'top';
	pCtx.textAlign = 'left';
	pCtx.fillText(pLabel.toUpperCase(), 8, pY + 2);
}

function _drawBandEmpty(pCtx, pPlot, pY, pH, pMsg)
{
	pCtx.fillStyle = 'rgba(150, 150, 150, 0.4)';
	pCtx.font = '11px -apple-system, sans-serif';
	pCtx.textBaseline = 'middle';
	pCtx.textAlign = 'center';
	pCtx.fillText(pMsg, (pPlot.x0 + pPlot.x1) / 2, pY + pH / 2);
}

function _drawRowLabel(pCtx, pLabel, pXLeft, pY, pH)
{
	pCtx.fillStyle = 'rgba(200, 200, 200, 0.75)';
	pCtx.font = '11px -apple-system, sans-serif';
	pCtx.textBaseline = 'middle';
	pCtx.textAlign = 'right';
	pCtx.fillText(pLabel, pXLeft - 8, pY + pH / 2);
}

function _drawRowSeparator(pCtx, pPlot, pY)
{
	pCtx.strokeStyle = 'rgba(180, 180, 180, 0.08)';
	pCtx.lineWidth = 1;
	pCtx.beginPath();
	pCtx.moveTo(pPlot.x0, pY);
	pCtx.lineTo(pPlot.x1, pY);
	pCtx.stroke();
}

function _formatTime(pMs, pStepMs)
{
	let tmpD = new Date(pMs);
	if (pStepMs >= 86400000) // ≥1d
	{
		return tmpD.toISOString().slice(5, 10);  // MM-DD
	}
	if (pStepMs >= 3600000)  // ≥1h
	{
		return tmpD.toISOString().slice(11, 16); // HH:MM
	}
	if (pStepMs >= 60000)    // ≥1m
	{
		return tmpD.toISOString().slice(11, 16); // HH:MM
	}
	return tmpD.toISOString().slice(11, 19);     // HH:MM:SS
}

// ─────────────────────────────────────────────────────────────────────
// Hit-test: given a click at (pX, pY) on the canvas, return the
// nearest record (or null). Used by Pillar 4 click-to-focus.
// ─────────────────────────────────────────────────────────────────────

function hitTest(pX, pY, pState, pCanvas)
{
	if (!pCanvas) return null;
	let tmpFromMs = Date.parse(pState.Window.FromIso) || (Date.now() - 120000);
	let tmpToMs   = Date.parse(pState.Window.ToIso)   || (Date.now() + 30000);
	let tmpPlot = {
		x0: PADDING_LEFT,
		x1: pCanvas.clientWidth - PADDING_RIGHT,
		y0: PADDING_TOP,
		y1: pCanvas.clientHeight - PADDING_BOT,
		fromMs: tmpFromMs, toMs: tmpToMs
	};
	tmpPlot.width = tmpPlot.x1 - tmpPlot.x0;

	if (pX < tmpPlot.x0 || pX > tmpPlot.x1) return null;
	let tmpFrac = (pX - tmpPlot.x0) / tmpPlot.width;
	let tmpAtMs = tmpFromMs + tmpFrac * (tmpToMs - tmpFromMs);

	// Find the closest record by At within ±2% of the window.
	let tmpTolerance = 0.02 * (tmpToMs - tmpFromMs);
	let tmpAll = []
		.concat(pState.Stream.Past || [])
		.concat(pState.Stream.Present || [])
		.concat(pState.Stream.Future || []);
	let tmpBest = null;
	let tmpBestDist = Infinity;
	for (let i = 0; i < tmpAll.length; i++)
	{
		let tmpRecAt = Date.parse(tmpAll[i].At);
		if (!Number.isFinite(tmpRecAt)) continue;
		let tmpDist = Math.abs(tmpRecAt - tmpAtMs);
		if (tmpDist < tmpBestDist && tmpDist <= tmpTolerance)
		{
			tmpBestDist = tmpDist;
			tmpBest = tmpAll[i];
		}
	}
	return tmpBest;
}

module.exports =
{
	drawTimeline: drawTimeline,
	hitTest:      hitTest
};

},{}],282:[function(require,module,exports){
/**
 * render-constellation.js
 *
 * Renders the beacon constellation: each beacon a node, color = liveness,
 * size = recent throughput, edges connect beacons sharing a capability.
 * v1 layout is a deterministic ring, grouped by capability — robust and
 * legible up to ~50 beacons. Force-directed placement is a future
 * upgrade.
 *
 * State:
 *   {
 *     Beacons: [{ BeaconID, Name, Capabilities[], MaxConcurrent, Liveness,
 *                 LivenessReason, LastHeartbeatAt, CurrentWorkItems[] }],
 *     RecentActivity: { BeaconID: count },  // last 30s of work events
 *     Now: ISO string
 *   }
 *
 * Output is also placed into pState.HitTestables = [{ x, y, r, BeaconID }]
 * so the host view can map clicks to beacon IDs without re-doing the
 * layout.
 */

const LIVENESS_COLORS =
{
	Alive:          { fill: '#10b981', stroke: '#059669' },
	'In-Doubt':     { fill: '#f59e0b', stroke: '#d97706' },
	InDoubt:        { fill: '#f59e0b', stroke: '#d97706' },
	Quarantined:    { fill: '#f97316', stroke: '#ea580c' },
	Defunct:        { fill: '#9ca3af', stroke: '#6b7280' },
	Unknown:        { fill: '#6b7280', stroke: '#4b5563' }
};
const DEFAULT_COLOR = LIVENESS_COLORS.Unknown;

const PADDING = 60;
const NODE_RADIUS_BASE = 14;
const NODE_RADIUS_MAX  = 28;

function drawConstellation(pCanvas, pState)
{
	if (!pCanvas || !pState) return;
	let tmpCtx = pCanvas.getContext('2d');
	if (!tmpCtx) return;
	let tmpDPR = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
	let tmpW = pCanvas.clientWidth || 800;
	let tmpH = pCanvas.clientHeight || 600;
	if (pCanvas.width !== tmpW * tmpDPR) { pCanvas.width = tmpW * tmpDPR; }
	if (pCanvas.height !== tmpH * tmpDPR) { pCanvas.height = tmpH * tmpDPR; }
	tmpCtx.setTransform(tmpDPR, 0, 0, tmpDPR, 0, 0);
	tmpCtx.clearRect(0, 0, tmpW, tmpH);

	let tmpBeacons = Array.isArray(pState.Beacons) ? pState.Beacons : [];
	pState.HitTestables = [];
	if (tmpBeacons.length === 0)
	{
		_drawEmpty(tmpCtx, tmpW, tmpH, '(no beacons connected)');
		return;
	}

	// Layout: group by primary capability, then place in a ring.
	let tmpNodes = _layoutNodes(tmpBeacons, tmpW, tmpH, pState.RecentActivity || {});

	// Edges: connect any two nodes sharing at least one capability. Light
	// gray, thin. For readability cap the count: only draw the edge if at
	// least one of the endpoints has fewer than 8 connections so far.
	let tmpEdgeCount = {};
	for (let i = 0; i < tmpNodes.length; i++) { tmpEdgeCount[tmpNodes[i].BeaconID] = 0; }
	tmpCtx.strokeStyle = 'rgba(180, 180, 180, 0.13)';
	tmpCtx.lineWidth = 0.75;
	for (let i = 0; i < tmpNodes.length; i++)
	{
		for (let j = i + 1; j < tmpNodes.length; j++)
		{
			let tmpA = tmpNodes[i];
			let tmpB = tmpNodes[j];
			if (!_sharesCapability(tmpA, tmpB)) continue;
			if (tmpEdgeCount[tmpA.BeaconID] >= 8 && tmpEdgeCount[tmpB.BeaconID] >= 8) continue;
			tmpEdgeCount[tmpA.BeaconID]++;
			tmpEdgeCount[tmpB.BeaconID]++;
			tmpCtx.beginPath();
			tmpCtx.moveTo(tmpA.X, tmpA.Y);
			tmpCtx.lineTo(tmpB.X, tmpB.Y);
			tmpCtx.stroke();
		}
	}

	// Nodes.
	for (let i = 0; i < tmpNodes.length; i++)
	{
		let tmpN = tmpNodes[i];
		let tmpColor = LIVENESS_COLORS[tmpN.Liveness] || DEFAULT_COLOR;
		// Pulse ring when handling work — additive halo.
		if (tmpN.Working)
		{
			let tmpPulse = 0.6 + 0.4 * Math.sin(Date.now() / 350);
			tmpCtx.beginPath();
			tmpCtx.arc(tmpN.X, tmpN.Y, tmpN.R + 6 + tmpPulse * 4, 0, Math.PI * 2);
			tmpCtx.fillStyle = _withAlpha(tmpColor.fill, 0.08 + tmpPulse * 0.10);
			tmpCtx.fill();
		}
		// Body.
		tmpCtx.beginPath();
		tmpCtx.arc(tmpN.X, tmpN.Y, tmpN.R, 0, Math.PI * 2);
		tmpCtx.fillStyle = tmpColor.fill;
		tmpCtx.fill();
		tmpCtx.strokeStyle = tmpColor.stroke;
		tmpCtx.lineWidth = 1.5;
		tmpCtx.stroke();

		// Label.
		tmpCtx.fillStyle = 'rgba(220, 220, 220, 0.92)';
		tmpCtx.font = '11px -apple-system, sans-serif';
		tmpCtx.textBaseline = 'top';
		tmpCtx.textAlign = 'center';
		let tmpDisplay = tmpN.Name || _shortHash(tmpN.BeaconID);
		tmpCtx.fillText(tmpDisplay, tmpN.X, tmpN.Y + tmpN.R + 4);

		// Capability hint below label.
		if (tmpN.PrimaryCapability)
		{
			tmpCtx.fillStyle = 'rgba(160, 160, 160, 0.65)';
			tmpCtx.font = '9px monospace';
			tmpCtx.fillText(tmpN.PrimaryCapability, tmpN.X, tmpN.Y + tmpN.R + 18);
		}

		// Push to hit-testables.
		pState.HitTestables.push({ X: tmpN.X, Y: tmpN.Y, R: tmpN.R, BeaconID: tmpN.BeaconID });
	}

	// Legend (bottom-left).
	_drawLegend(tmpCtx, tmpW, tmpH);
}

function _layoutNodes(pBeacons, pW, pH, pActivity)
{
	let tmpCount = pBeacons.length;
	let tmpCx = pW / 2;
	let tmpCy = pH / 2 - 20;
	let tmpRadius = Math.max(80, Math.min(pW, pH) / 2 - PADDING);

	// Group by primary capability so similar nodes cluster.
	let tmpSorted = pBeacons.slice().sort(function (pA, pB)
	{
		let tmpKa = (pA.Capabilities && pA.Capabilities[0]) || '';
		let tmpKb = (pB.Capabilities && pB.Capabilities[0]) || '';
		if (tmpKa !== tmpKb) return tmpKa < tmpKb ? -1 : 1;
		return pA.BeaconID < pB.BeaconID ? -1 : pA.BeaconID > pB.BeaconID ? 1 : 0;
	});

	// Find the activity peak so node size is normalized.
	let tmpPeak = 1;
	for (let tmpK in pActivity)
	{
		if (pActivity[tmpK] > tmpPeak) tmpPeak = pActivity[tmpK];
	}

	let tmpOut = [];
	for (let i = 0; i < tmpSorted.length; i++)
	{
		let tmpB = tmpSorted[i];
		let tmpAngle = (i / tmpCount) * Math.PI * 2 - Math.PI / 2;
		let tmpAct = pActivity[tmpB.BeaconID] || 0;
		let tmpRSize = NODE_RADIUS_BASE + (NODE_RADIUS_MAX - NODE_RADIUS_BASE) * (tmpAct / tmpPeak);
		// Inner-ring offset varies slightly so beacons in the same capability
		// don't overlap when there are many of them.
		let tmpRadiusOffset = (i % 2) * 18;
		tmpOut.push({
			BeaconID:          tmpB.BeaconID,
			Name:              tmpB.Name || tmpB.BeaconID,
			PrimaryCapability: (tmpB.Capabilities && tmpB.Capabilities[0]) || '',
			Liveness:          tmpB.Liveness || 'Unknown',
			Working:           Array.isArray(tmpB.CurrentWorkItems) && tmpB.CurrentWorkItems.length > 0,
			RecentActivity:    tmpAct,
			MaxConcurrent:     tmpB.MaxConcurrent || 0,
			X:                 tmpCx + Math.cos(tmpAngle) * (tmpRadius - tmpRadiusOffset),
			Y:                 tmpCy + Math.sin(tmpAngle) * (tmpRadius - tmpRadiusOffset),
			R:                 tmpRSize
		});
	}
	return tmpOut;
}

function _sharesCapability(pA, pB)
{
	if (!pA || !pB) return false;
	let tmpA = (pA.PrimaryCapability ? [pA.PrimaryCapability] : []);
	let tmpB = (pB.PrimaryCapability ? [pB.PrimaryCapability] : []);
	for (let i = 0; i < tmpA.length; i++)
	{
		if (tmpB.indexOf(tmpA[i]) >= 0) return true;
	}
	return false;
}

function _drawLegend(pCtx, pW, pH)
{
	let tmpY = pH - 16;
	pCtx.font = '10px -apple-system, sans-serif';
	pCtx.textBaseline = 'middle';
	pCtx.textAlign = 'left';
	let tmpEntries = [
		{ Label: 'Alive',       Color: LIVENESS_COLORS.Alive.fill },
		{ Label: 'In-Doubt',    Color: LIVENESS_COLORS['In-Doubt'].fill },
		{ Label: 'Quarantined', Color: LIVENESS_COLORS.Quarantined.fill },
		{ Label: 'Defunct',     Color: LIVENESS_COLORS.Defunct.fill }
	];
	let tmpX = 16;
	for (let i = 0; i < tmpEntries.length; i++)
	{
		pCtx.fillStyle = tmpEntries[i].Color;
		pCtx.beginPath();
		pCtx.arc(tmpX, tmpY, 5, 0, Math.PI * 2);
		pCtx.fill();
		pCtx.fillStyle = 'rgba(220, 220, 220, 0.8)';
		pCtx.fillText(tmpEntries[i].Label, tmpX + 10, tmpY);
		tmpX += 16 + pCtx.measureText(tmpEntries[i].Label).width + 12;
	}
	// Working halo example.
	pCtx.beginPath();
	pCtx.arc(tmpX + 8, tmpY, 8, 0, Math.PI * 2);
	pCtx.fillStyle = 'rgba(16, 185, 129, 0.18)';
	pCtx.fill();
	pCtx.beginPath();
	pCtx.arc(tmpX + 8, tmpY, 4, 0, Math.PI * 2);
	pCtx.fillStyle = LIVENESS_COLORS.Alive.fill;
	pCtx.fill();
	pCtx.fillStyle = 'rgba(220, 220, 220, 0.8)';
	pCtx.fillText('handling work (pulse)', tmpX + 20, tmpY);
}

function _drawEmpty(pCtx, pW, pH, pMsg)
{
	pCtx.fillStyle = 'rgba(150, 150, 150, 0.55)';
	pCtx.font = '12px -apple-system, sans-serif';
	pCtx.textAlign = 'center';
	pCtx.textBaseline = 'middle';
	pCtx.fillText(pMsg, pW / 2, pH / 2);
}

function _withAlpha(pHex, pAlpha)
{
	if (typeof pHex !== 'string' || pHex.charAt(0) !== '#' || pHex.length !== 7) { return pHex; }
	let tmpR = parseInt(pHex.slice(1, 3), 16);
	let tmpG = parseInt(pHex.slice(3, 5), 16);
	let tmpB = parseInt(pHex.slice(5, 7), 16);
	return 'rgba(' + tmpR + ',' + tmpG + ',' + tmpB + ',' + pAlpha + ')';
}

function _shortHash(pStr)
{
	if (!pStr) return '';
	if (pStr.length <= 22) return pStr;
	return pStr.slice(0, 10) + '…' + pStr.slice(-8);
}

function hitTest(pX, pY, pState)
{
	let tmpHits = (pState && pState.HitTestables) || [];
	for (let i = 0; i < tmpHits.length; i++)
	{
		let tmpH = tmpHits[i];
		let tmpDx = pX - tmpH.X;
		let tmpDy = pY - tmpH.Y;
		if (tmpDx * tmpDx + tmpDy * tmpDy <= (tmpH.R + 4) * (tmpH.R + 4))
		{
			return tmpH.BeaconID;
		}
	}
	return null;
}

module.exports =
{
	drawConstellation: drawConstellation,
	hitTest:           hitTest
};

},{}],283:[function(require,module,exports){
/**
 * render-heatmap.js
 *
 * Imperative canvas renderer for the capability heat map view. Pure
 * function — given a state object + canvas DOM node, paints the grid.
 *
 * State shape:
 *   {
 *     Window: { FromIso, ToIso },
 *     Buckets: [{ At, DurationMs, ByCapability: { Loader: N, ... } }],
 *     Capacities: { Loader: { ActiveMax, Capacity }, ... },
 *     Capabilities: [Loader, DI, ...] // ordered, one row each
 *   }
 *
 * Each cell color is graded from idle (transparent) → saturated (full
 * `--uv-warning`). The intensity = active workers in the bucket /
 * capacity for that capability. > 1.0 (oversubscribed) gets a red
 * accent.
 */

const PADDING_LEFT  = 160;
const PADDING_RIGHT = 24;
const PADDING_TOP   = 36;
const PADDING_BOT   = 28;
const ROW_HEIGHT_MIN = 18;
const ROW_GAP = 1;

function drawHeatMap(pCanvas, pState)
{
	if (!pCanvas || !pState) return;
	let tmpCtx = pCanvas.getContext('2d');
	if (!tmpCtx) return;

	let tmpDPR = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
	let tmpCSSWidth = pCanvas.clientWidth || 800;
	let tmpCSSHeight = pCanvas.clientHeight || 400;
	if (pCanvas.width !== tmpCSSWidth * tmpDPR) { pCanvas.width = tmpCSSWidth * tmpDPR; }
	if (pCanvas.height !== tmpCSSHeight * tmpDPR) { pCanvas.height = tmpCSSHeight * tmpDPR; }
	tmpCtx.setTransform(tmpDPR, 0, 0, tmpDPR, 0, 0);
	tmpCtx.clearRect(0, 0, tmpCSSWidth, tmpCSSHeight);

	let tmpFromMs = Date.parse(pState.Window.FromIso) || (Date.now() - 60 * 60 * 1000);
	let tmpToMs   = Date.parse(pState.Window.ToIso)   || Date.now();
	if (tmpToMs <= tmpFromMs) tmpToMs = tmpFromMs + 1;

	let tmpCaps = Array.isArray(pState.Capabilities) ? pState.Capabilities.slice() : [];
	if (tmpCaps.length === 0)
	{
		_drawEmpty(tmpCtx, tmpCSSWidth, tmpCSSHeight, '(no capability activity in this window)');
		_drawTimeAxis(tmpCtx, { fromMs: tmpFromMs, toMs: tmpToMs, x0: PADDING_LEFT, x1: tmpCSSWidth - PADDING_RIGHT, y0: PADDING_TOP, y1: tmpCSSHeight - PADDING_BOT });
		return;
	}

	let tmpRowH = Math.max(ROW_HEIGHT_MIN,
		Math.floor((tmpCSSHeight - PADDING_TOP - PADDING_BOT) / tmpCaps.length) - ROW_GAP);

	let tmpPlot = {
		x0: PADDING_LEFT,
		x1: tmpCSSWidth - PADDING_RIGHT,
		y0: PADDING_TOP,
		y1: tmpCSSHeight - PADDING_BOT,
		fromMs: tmpFromMs,
		toMs:   tmpToMs
	};
	tmpPlot.width = tmpPlot.x1 - tmpPlot.x0;

	_drawTimeAxis(tmpCtx, tmpPlot);

	// Compute peak across ALL cells; use it as the saturation reference
	// when capacity is unknown for that capability.
	let tmpBuckets = Array.isArray(pState.Buckets) ? pState.Buckets : [];
	let tmpGlobalPeak = 1;
	for (let i = 0; i < tmpBuckets.length; i++)
	{
		let tmpByCap = tmpBuckets[i].ByCapability || {};
		for (let j = 0; j < tmpCaps.length; j++)
		{
			let tmpV = tmpByCap[tmpCaps[j]] || 0;
			if (tmpV > tmpGlobalPeak) { tmpGlobalPeak = tmpV; }
		}
	}

	// Draw rows.
	for (let i = 0; i < tmpCaps.length; i++)
	{
		let tmpY = tmpPlot.y0 + i * (tmpRowH + ROW_GAP);
		let tmpCap = tmpCaps[i];
		_drawRow(tmpCtx, tmpPlot, tmpY, tmpRowH, tmpCap, tmpBuckets, pState.Capacities, tmpGlobalPeak);
	}

	// Legend.
	_drawLegend(tmpCtx, tmpCSSWidth, tmpCSSHeight, tmpGlobalPeak);
}

function _drawRow(pCtx, pPlot, pY, pH, pCapability, pBuckets, pCapacities, pGlobalPeak)
{
	// Row label.
	pCtx.fillStyle = 'rgba(220, 220, 220, 0.85)';
	pCtx.font = '11px -apple-system, sans-serif';
	pCtx.textBaseline = 'middle';
	pCtx.textAlign = 'right';
	pCtx.fillText(pCapability, pPlot.x0 - 10, pY + pH / 2);

	// Capacity label (small, dimmer) below the cap name.
	let tmpCap = (pCapacities && pCapacities[pCapability]) || null;
	let tmpCapLabel = tmpCap && tmpCap.Capacity > 0 ? ('cap ' + tmpCap.Capacity) : 'cap ?';
	pCtx.fillStyle = 'rgba(160, 160, 160, 0.5)';
	pCtx.font = '9px monospace';
	pCtx.fillText(tmpCapLabel, pPlot.x0 - 10, pY + pH / 2 + 8);

	// Track outline.
	pCtx.fillStyle = 'rgba(180, 180, 180, 0.04)';
	pCtx.fillRect(pPlot.x0, pY, pPlot.width, pH);

	// Cells.
	for (let i = 0; i < pBuckets.length; i++)
	{
		let tmpB = pBuckets[i];
		let tmpAtMs = Date.parse(tmpB.At);
		if (!Number.isFinite(tmpAtMs)) continue;
		let tmpDur = tmpB.DurationMs || 1000;
		let tmpEndMs = tmpAtMs + tmpDur;
		if (tmpEndMs < pPlot.fromMs || tmpAtMs > pPlot.toMs) continue;
		let tmpX0 = _timeToX(tmpAtMs, pPlot);
		let tmpX1 = _timeToX(tmpEndMs, pPlot);
		if (tmpX1 - tmpX0 < 1) tmpX1 = tmpX0 + 1;
		let tmpVal = (tmpB.ByCapability && tmpB.ByCapability[pCapability]) || 0;
		if (tmpVal === 0) continue;

		let tmpCapacity = tmpCap && tmpCap.Capacity > 0 ? tmpCap.Capacity : pGlobalPeak;
		let tmpUtil = tmpCapacity > 0 ? tmpVal / tmpCapacity : 0;
		if (tmpUtil > 1.5) tmpUtil = 1.5;
		// Color ramp: 0 → blue (cool), 0.5 → amber (warm), >1 → red.
		pCtx.fillStyle = _utilToColor(tmpUtil);
		pCtx.fillRect(tmpX0, pY + 1, tmpX1 - tmpX0, pH - 2);
	}
}

function _utilToColor(pUtil)
{
	// 0..0.5  blue → amber
	// 0.5..1  amber → red-orange
	// >1      red, intense
	let tmpA = Math.min(0.92, 0.18 + pUtil * 0.5);
	if (pUtil < 0.5)
	{
		// 59,130,246 (blue) → 245,158,11 (amber)
		let tmpT = pUtil / 0.5;
		let tmpR = Math.round(59  + (245 - 59 ) * tmpT);
		let tmpG = Math.round(130 + (158 - 130) * tmpT);
		let tmpB = Math.round(246 + (11  - 246) * tmpT);
		return 'rgba(' + tmpR + ',' + tmpG + ',' + tmpB + ',' + tmpA + ')';
	}
	if (pUtil <= 1)
	{
		// amber → red-orange (239,68,68)
		let tmpT = (pUtil - 0.5) / 0.5;
		let tmpR = Math.round(245 + (239 - 245) * tmpT);
		let tmpG = Math.round(158 + (68  - 158) * tmpT);
		let tmpB = Math.round(11  + (68  - 11)  * tmpT);
		return 'rgba(' + tmpR + ',' + tmpG + ',' + tmpB + ',' + tmpA + ')';
	}
	// Oversubscribed — saturated red.
	return 'rgba(220, 38, 38, ' + Math.min(1, 0.85 + (pUtil - 1) * 0.1) + ')';
}

function _drawTimeAxis(pCtx, pPlot)
{
	let tmpSpan = pPlot.toMs - pPlot.fromMs;
	let tmpSteps = [1, 5, 30, 60, 300, 600, 1800, 3600, 21600, 86400];
	let tmpStep = tmpSteps[0] * 1000;
	for (let i = 0; i < tmpSteps.length; i++)
	{
		if (tmpSpan / (tmpSteps[i] * 1000) <= 10)
		{
			tmpStep = tmpSteps[i] * 1000;
			break;
		}
		tmpStep = tmpSteps[i] * 1000;
	}
	pCtx.fillStyle = 'rgba(180, 180, 180, 0.7)';
	pCtx.font = '11px -apple-system, sans-serif';
	pCtx.textBaseline = 'top';
	pCtx.textAlign = 'center';
	pCtx.strokeStyle = 'rgba(180, 180, 180, 0.10)';
	pCtx.lineWidth = 1;
	let tmpStart = Math.ceil(pPlot.fromMs / tmpStep) * tmpStep;
	for (let t = tmpStart; t < pPlot.toMs; t += tmpStep)
	{
		let tmpX = _timeToX(t, pPlot);
		pCtx.beginPath();
		pCtx.moveTo(tmpX, pPlot.y0);
		pCtx.lineTo(tmpX, pPlot.y1);
		pCtx.stroke();
		pCtx.fillText(_formatTime(t, tmpStep), tmpX, 8);
	}
}

function _drawLegend(pCtx, pW, pH, pPeak)
{
	let tmpY = pH - 20;
	pCtx.fillStyle = 'rgba(180, 180, 180, 0.6)';
	pCtx.font = '10px -apple-system, sans-serif';
	pCtx.textBaseline = 'middle';
	pCtx.textAlign = 'left';
	pCtx.fillText('idle', PADDING_LEFT, tmpY);
	let tmpLegendX = PADDING_LEFT + 30;
	let tmpLegendW = 220;
	for (let i = 0; i < tmpLegendW; i++)
	{
		let tmpUtil = i / tmpLegendW * 1.4;
		pCtx.fillStyle = _utilToColor(tmpUtil);
		pCtx.fillRect(tmpLegendX + i, tmpY - 6, 1, 12);
	}
	pCtx.fillStyle = 'rgba(180, 180, 180, 0.6)';
	pCtx.fillText('saturated · oversubscribed', tmpLegendX + tmpLegendW + 8, tmpY);
	if (pPeak > 1)
	{
		pCtx.textAlign = 'right';
		pCtx.fillText('peak: ' + pPeak + ' active', pW - PADDING_RIGHT, tmpY);
	}
}

function _drawEmpty(pCtx, pW, pH, pMsg)
{
	pCtx.fillStyle = 'rgba(150, 150, 150, 0.55)';
	pCtx.font = '12px -apple-system, sans-serif';
	pCtx.textAlign = 'center';
	pCtx.textBaseline = 'middle';
	pCtx.fillText(pMsg, pW / 2, pH / 2);
}

function _timeToX(pMs, pPlot)
{
	let tmpFrac = (pMs - pPlot.fromMs) / (pPlot.toMs - pPlot.fromMs);
	if (tmpFrac < 0) tmpFrac = 0;
	if (tmpFrac > 1) tmpFrac = 1;
	return pPlot.x0 + tmpFrac * pPlot.width;
}

function _formatTime(pMs, pStepMs)
{
	let tmpD = new Date(pMs);
	if (pStepMs >= 86400000) return tmpD.toISOString().slice(5, 10);
	if (pStepMs >= 3600000)  return tmpD.toISOString().slice(11, 16);
	if (pStepMs >= 60000)    return tmpD.toISOString().slice(11, 16);
	return tmpD.toISOString().slice(11, 19);
}

module.exports =
{
	drawHeatMap: drawHeatMap
};

},{}],284:[function(require,module,exports){
/**
 * render-throughput.js
 *
 * Renders the throughput chart: stacked-area of completion counts per
 * bucket by terminal status, plus a vertical-band marker for backpressure
 * windows where Admission.Denied events fired.
 *
 * State:
 *   {
 *     Window: { FromIso, ToIso },
 *     Buckets: [{ At, DurationMs, ByEventType, ByStatus }],
 *     Now: ISO string
 *   }
 *
 * Stack order (bottom→top): Complete, Failed, Stalled, Canceled.
 * Admission denials render as red vertical strips behind the stack.
 */

const STACK_KEYS = ['Complete', 'Failed', 'Stalled', 'Canceled'];
const STACK_COLORS =
{
	Complete: 'rgba(16, 185, 129, 0.85)',
	Failed:   'rgba(239,  68,  68, 0.85)',
	Stalled:  'rgba(249, 115,  22, 0.85)',
	Canceled: 'rgba(156, 163, 175, 0.85)'
};

const PADDING_LEFT  = 60;
const PADDING_RIGHT = 16;
const PADDING_TOP   = 40;
const PADDING_BOT   = 40;

function drawThroughput(pCanvas, pState)
{
	if (!pCanvas || !pState) return;
	let tmpCtx = pCanvas.getContext('2d');
	if (!tmpCtx) return;
	let tmpDPR = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
	let tmpW = pCanvas.clientWidth || 800;
	let tmpH = pCanvas.clientHeight || 360;
	if (pCanvas.width !== tmpW * tmpDPR) { pCanvas.width = tmpW * tmpDPR; }
	if (pCanvas.height !== tmpH * tmpDPR) { pCanvas.height = tmpH * tmpDPR; }
	tmpCtx.setTransform(tmpDPR, 0, 0, tmpDPR, 0, 0);
	tmpCtx.clearRect(0, 0, tmpW, tmpH);

	let tmpFromMs = Date.parse(pState.Window.FromIso) || (Date.now() - 60 * 60 * 1000);
	let tmpToMs   = Date.parse(pState.Window.ToIso)   || Date.now();
	if (tmpToMs <= tmpFromMs) tmpToMs = tmpFromMs + 1;
	let tmpBuckets = Array.isArray(pState.Buckets) ? pState.Buckets : [];

	let tmpPlot = {
		x0: PADDING_LEFT,
		x1: tmpW - PADDING_RIGHT,
		y0: PADDING_TOP,
		y1: tmpH - PADDING_BOT,
		fromMs: tmpFromMs,
		toMs:   tmpToMs
	};
	tmpPlot.width  = tmpPlot.x1 - tmpPlot.x0;
	tmpPlot.height = tmpPlot.y1 - tmpPlot.y0;

	if (tmpBuckets.length === 0)
	{
		_drawTimeAxis(tmpCtx, tmpPlot);
		_drawEmpty(tmpCtx, tmpW, tmpH, '(no events in this window)');
		return;
	}

	let tmpStacks = tmpBuckets.map(_bucketToStack);
	let tmpPeak = 0;
	for (let i = 0; i < tmpStacks.length; i++)
	{
		let tmpSum = 0;
		for (let j = 0; j < STACK_KEYS.length; j++) { tmpSum += tmpStacks[i][STACK_KEYS[j]] || 0; }
		if (tmpSum > tmpPeak) tmpPeak = tmpSum;
	}
	if (tmpPeak === 0) tmpPeak = 1;

	// Pre-extract bucket positions.
	let tmpBucketDurMs = (tmpBuckets[0] && tmpBuckets[0].DurationMs) || 60000;

	// Draw admission-denial vertical strips first (so they're behind the stack).
	for (let i = 0; i < tmpBuckets.length; i++)
	{
		let tmpDenied = (tmpBuckets[i].ByEventType && (
			(tmpBuckets[i].ByEventType['Admission.Denied'] || 0)
			+ (tmpBuckets[i].ByEventType['admission.denied'] || 0)
		)) || 0;
		if (tmpDenied <= 0) continue;
		let tmpAt = Date.parse(tmpBuckets[i].At);
		if (!Number.isFinite(tmpAt)) continue;
		let tmpX0 = _timeToX(tmpAt, tmpPlot);
		let tmpX1 = _timeToX(tmpAt + tmpBucketDurMs, tmpPlot);
		tmpCtx.fillStyle = 'rgba(239, 68, 68, 0.18)';
		tmpCtx.fillRect(tmpX0, tmpPlot.y0, Math.max(2, tmpX1 - tmpX0), tmpPlot.height);
	}

	// Stacked-area paint, key by key (bottom→top).
	// For each key, build a polygon: bottom = stack-below cumulative, top = + this key.
	let tmpCumBottom = new Array(tmpBuckets.length).fill(0);
	for (let k = 0; k < STACK_KEYS.length; k++)
	{
		let tmpKey = STACK_KEYS[k];
		tmpCtx.beginPath();
		// Move to the leftmost point along the bottom.
		for (let i = 0; i < tmpBuckets.length; i++)
		{
			let tmpAt = Date.parse(tmpBuckets[i].At);
			if (!Number.isFinite(tmpAt)) continue;
			let tmpX = _timeToX(tmpAt + tmpBucketDurMs / 2, tmpPlot);
			let tmpYBottom = _valueToY(tmpCumBottom[i], tmpPeak, tmpPlot);
			if (i === 0) { tmpCtx.moveTo(tmpX, tmpYBottom); }
			else         { tmpCtx.lineTo(tmpX, tmpYBottom); }
		}
		// Walk back along the top.
		for (let i = tmpBuckets.length - 1; i >= 0; i--)
		{
			let tmpAt = Date.parse(tmpBuckets[i].At);
			if (!Number.isFinite(tmpAt)) continue;
			let tmpX = _timeToX(tmpAt + tmpBucketDurMs / 2, tmpPlot);
			let tmpVal = tmpStacks[i][tmpKey] || 0;
			let tmpYTop = _valueToY(tmpCumBottom[i] + tmpVal, tmpPeak, tmpPlot);
			tmpCtx.lineTo(tmpX, tmpYTop);
		}
		tmpCtx.closePath();
		tmpCtx.fillStyle = STACK_COLORS[tmpKey];
		tmpCtx.fill();
		// Update cumulative bottom for the next key.
		for (let i = 0; i < tmpBuckets.length; i++) { tmpCumBottom[i] += (tmpStacks[i][tmpKey] || 0); }
	}

	_drawTimeAxis(tmpCtx, tmpPlot);
	_drawYAxis(tmpCtx, tmpPlot, tmpPeak, _bucketLabel(tmpBucketDurMs));
	_drawLegend(tmpCtx, tmpW, tmpPlot);
	_drawNowLine(tmpCtx, tmpPlot, Date.parse(pState.Now) || Date.now());
}

function _bucketToStack(pBucket)
{
	let tmpTypes = pBucket.ByEventType || {};
	let tmpStatus = pBucket.ByStatus || {};
	return {
		Complete: (tmpTypes.Completed   || 0)
				+ (tmpTypes['Execution.ExecutionComplete'] || 0)
				+ (tmpStatus.Complete   || 0),
		Failed:   (tmpTypes.Failed       || 0)
				+ (tmpStatus.Failed     || 0),
		Stalled:  (tmpTypes.Stalled      || 0)
				+ (tmpTypes['Workitem.Stranded'] || 0)
				+ (tmpStatus.Stalled    || 0),
		Canceled: (tmpTypes.Canceled     || 0)
				+ (tmpStatus.Canceled   || 0)
				+ (tmpStatus.Abandoned  || 0)
	};
}

function _bucketLabel(pMs)
{
	if (pMs < 1000) return 'per ' + pMs + 'ms';
	if (pMs < 60000) return 'per ' + (pMs / 1000) + 's';
	if (pMs < 3600000) return 'per ' + (pMs / 60000) + 'min';
	return 'per ' + (pMs / 3600000) + 'h';
}

function _drawTimeAxis(pCtx, pPlot)
{
	pCtx.strokeStyle = 'rgba(180, 180, 180, 0.20)';
	pCtx.lineWidth = 1;
	pCtx.beginPath();
	pCtx.moveTo(pPlot.x0, pPlot.y1);
	pCtx.lineTo(pPlot.x1, pPlot.y1);
	pCtx.stroke();
	let tmpSpan = pPlot.toMs - pPlot.fromMs;
	let tmpSteps = [1, 5, 30, 60, 300, 600, 1800, 3600, 21600, 86400];
	let tmpStep = tmpSteps[0] * 1000;
	for (let i = 0; i < tmpSteps.length; i++)
	{
		if (tmpSpan / (tmpSteps[i] * 1000) <= 10)
		{
			tmpStep = tmpSteps[i] * 1000;
			break;
		}
		tmpStep = tmpSteps[i] * 1000;
	}
	pCtx.fillStyle = 'rgba(180, 180, 180, 0.65)';
	pCtx.font = '10px -apple-system, sans-serif';
	pCtx.textBaseline = 'top';
	pCtx.textAlign = 'center';
	let tmpStart = Math.ceil(pPlot.fromMs / tmpStep) * tmpStep;
	for (let t = tmpStart; t < pPlot.toMs; t += tmpStep)
	{
		let tmpX = _timeToX(t, pPlot);
		pCtx.beginPath();
		pCtx.strokeStyle = 'rgba(180, 180, 180, 0.10)';
		pCtx.moveTo(tmpX, pPlot.y0);
		pCtx.lineTo(tmpX, pPlot.y1);
		pCtx.stroke();
		pCtx.fillStyle = 'rgba(180, 180, 180, 0.65)';
		pCtx.fillText(_formatTime(t, tmpStep), tmpX, pPlot.y1 + 6);
	}
}

function _drawYAxis(pCtx, pPlot, pPeak, pUnitLabel)
{
	let tmpTickCount = 5;
	pCtx.fillStyle = 'rgba(180, 180, 180, 0.65)';
	pCtx.font = '10px monospace';
	pCtx.textBaseline = 'middle';
	pCtx.textAlign = 'right';
	pCtx.strokeStyle = 'rgba(180, 180, 180, 0.10)';
	for (let i = 0; i <= tmpTickCount; i++)
	{
		let tmpVal = (pPeak * i) / tmpTickCount;
		let tmpY = _valueToY(tmpVal, pPeak, pPlot);
		pCtx.beginPath();
		pCtx.moveTo(pPlot.x0, tmpY);
		pCtx.lineTo(pPlot.x1, tmpY);
		pCtx.stroke();
		pCtx.fillText(_formatCount(tmpVal), pPlot.x0 - 6, tmpY);
	}
	// Unit label at the very top.
	pCtx.textAlign = 'left';
	pCtx.textBaseline = 'top';
	pCtx.fillStyle = 'rgba(180, 180, 180, 0.55)';
	pCtx.font = '10px -apple-system, sans-serif';
	pCtx.fillText(pUnitLabel, pPlot.x0, 6);
}

function _drawLegend(pCtx, pW, pPlot)
{
	let tmpY = 8;
	let tmpX = pW - PADDING_RIGHT;
	pCtx.font = '11px -apple-system, sans-serif';
	pCtx.textBaseline = 'top';
	pCtx.textAlign = 'right';
	for (let i = STACK_KEYS.length - 1; i >= 0; i--)
	{
		let tmpKey = STACK_KEYS[i];
		pCtx.fillStyle = STACK_COLORS[tmpKey];
		pCtx.fillRect(tmpX - 12, tmpY + 2, 10, 10);
		pCtx.fillStyle = 'rgba(220, 220, 220, 0.85)';
		pCtx.fillText(tmpKey, tmpX - 18, tmpY + 1);
		tmpX -= 80;
	}
	// Admission denial swatch.
	pCtx.fillStyle = 'rgba(239, 68, 68, 0.30)';
	pCtx.fillRect(tmpX - 12, tmpY + 2, 10, 10);
	pCtx.fillStyle = 'rgba(220, 220, 220, 0.85)';
	pCtx.fillText('Admission denied', tmpX - 18, tmpY + 1);
}

function _drawNowLine(pCtx, pPlot, pNowMs)
{
	if (pNowMs < pPlot.fromMs || pNowMs > pPlot.toMs) return;
	let tmpX = _timeToX(pNowMs, pPlot);
	pCtx.strokeStyle = 'rgba(245, 158, 11, 0.7)';
	pCtx.lineWidth = 1.5;
	pCtx.setLineDash([4, 3]);
	pCtx.beginPath();
	pCtx.moveTo(tmpX, pPlot.y0);
	pCtx.lineTo(tmpX, pPlot.y1);
	pCtx.stroke();
	pCtx.setLineDash([]);
}

function _drawEmpty(pCtx, pW, pH, pMsg)
{
	pCtx.fillStyle = 'rgba(150, 150, 150, 0.55)';
	pCtx.font = '12px -apple-system, sans-serif';
	pCtx.textAlign = 'center';
	pCtx.textBaseline = 'middle';
	pCtx.fillText(pMsg, pW / 2, pH / 2);
}

function _timeToX(pMs, pPlot)
{
	let tmpFrac = (pMs - pPlot.fromMs) / (pPlot.toMs - pPlot.fromMs);
	if (tmpFrac < 0) tmpFrac = 0;
	if (tmpFrac > 1) tmpFrac = 1;
	return pPlot.x0 + tmpFrac * pPlot.width;
}

function _valueToY(pVal, pPeak, pPlot)
{
	let tmpFrac = pPeak > 0 ? pVal / pPeak : 0;
	if (tmpFrac < 0) tmpFrac = 0;
	if (tmpFrac > 1) tmpFrac = 1;
	return pPlot.y1 - tmpFrac * pPlot.height;
}

function _formatTime(pMs, pStepMs)
{
	let tmpD = new Date(pMs);
	if (pStepMs >= 86400000) return tmpD.toISOString().slice(5, 10);
	if (pStepMs >= 3600000)  return tmpD.toISOString().slice(11, 16);
	if (pStepMs >= 60000)    return tmpD.toISOString().slice(11, 16);
	return tmpD.toISOString().slice(11, 19);
}

function _formatCount(pVal)
{
	if (pVal >= 1000) return (pVal / 1000).toFixed(1) + 'k';
	if (pVal === Math.floor(pVal)) return String(pVal);
	return pVal.toFixed(1);
}

module.exports =
{
	drawThroughput: drawThroughput
};

},{}],285:[function(require,module,exports){
/**
 * render-waterfall.js
 *
 * Renders a distributed-trace-style waterfall for a single RunHash.
 * Pure render module — Pict-imperative escape hatch, called from
 * PictView-Ultravisor-Timeline's onAfterRender when Focus.Kind === 'runHash'.
 *
 * Inputs (per drawTimeline()'s pState argument):
 *   {
 *       RunHash,
 *       Records: TimelineRecord[],   // /Timeline?runHash=<hash>&bucket=raw
 *       Operation: { Hash, Name, Graph: { Nodes[], Connections[] } } | null,
 *       Now: ISO string
 *   }
 *
 * Layout (left→right):
 *
 *   ┌───────────────────────────────────────────────────────────────┐
 *   │ HEADER  RunHash · Operation Name · status · ΔMs               │
 *   ├───────────────────────────────────────────────────────────────┤
 *   │ task-A  ████████░░░░░░  (Loader)             1240 ms          │
 *   │ task-B  ░░░░██████░░░░  (DI)                  640 ms          │
 *   │ task-C  ░░░░░░██████░░  (Validator)           480 ms          │
 *   └───────────────────────────────────────────────────────────────┘
 *
 * Critical path: longest dependency chain through the graph. Bars on
 * the critical path render with a brighter outline.
 *
 * Bar color = terminal status (Complete/Failed/Stalled). Active bars
 * (no EndAt yet) render with the "Running" amber, fading right edge.
 */

const STATUS_COLORS =
{
	'Pending':      { fill: '#3b82f6', stroke: '#2563eb' },
	'Queued':       { fill: '#3b82f6', stroke: '#2563eb' },
	'Assigned':     { fill: '#6366f1', stroke: '#4338ca' },
	'Dispatched':   { fill: '#f59e0b', stroke: '#d97706' },
	'Running':      { fill: '#f59e0b', stroke: '#d97706' },
	'Complete':     { fill: '#10b981', stroke: '#059669' },
	'Failed':       { fill: '#ef4444', stroke: '#dc2626' },
	'Error':        { fill: '#ef4444', stroke: '#dc2626' },
	'Stalled':      { fill: '#f97316', stroke: '#ea580c' },
	'Canceled':     { fill: '#9ca3af', stroke: '#6b7280' },
	'Abandoned':    { fill: '#9ca3af', stroke: '#6b7280' }
};
const DEFAULT_COLOR = { fill: '#6b7280', stroke: '#4b5563' };

const PADDING_LEFT  = 200;   // room for task labels
const PADDING_RIGHT = 110;   // room for duration labels
const PADDING_TOP   = 36;    // room for time-axis ticks
const PADDING_BOT   = 8;
const ROW_HEIGHT    = 22;
const ROW_GAP       = 2;

// Public entry point.
function drawWaterfall(pCanvas, pState)
{
	if (!pCanvas || !pState) return;
	let tmpCtx = pCanvas.getContext('2d');
	if (!tmpCtx) return;

	let tmpDPR = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
	let tmpCSSWidth  = pCanvas.clientWidth || 800;

	// Compute task rows from the records first — we need the count to size
	// the canvas, since the parent container is height:auto.
	let tmpTasks = _buildTaskRows(pState);
	let tmpRowCount = Math.max(1, tmpTasks.length);
	let tmpCSSHeight = PADDING_TOP + PADDING_BOT + tmpRowCount * (ROW_HEIGHT + ROW_GAP);

	// Pict's content-box CSS sizes the element; resize the backing store
	// to match * DPR.
	pCanvas.style.height = tmpCSSHeight + 'px';
	if (pCanvas.width !== tmpCSSWidth * tmpDPR) { pCanvas.width = tmpCSSWidth * tmpDPR; }
	if (pCanvas.height !== tmpCSSHeight * tmpDPR) { pCanvas.height = tmpCSSHeight * tmpDPR; }
	tmpCtx.setTransform(tmpDPR, 0, 0, tmpDPR, 0, 0);
	tmpCtx.clearRect(0, 0, tmpCSSWidth, tmpCSSHeight);

	if (tmpTasks.length === 0)
	{
		_drawEmpty(tmpCtx, tmpCSSWidth, tmpCSSHeight);
		return;
	}

	let tmpFromMs = tmpTasks[0].At;
	let tmpToMs = tmpTasks[0].EndAt;
	for (let i = 0; i < tmpTasks.length; i++)
	{
		if (tmpTasks[i].At < tmpFromMs) tmpFromMs = tmpTasks[i].At;
		if (tmpTasks[i].EndAt > tmpToMs) tmpToMs = tmpTasks[i].EndAt;
	}
	// Guard against a zero-width run (single instantaneous event).
	if (tmpToMs - tmpFromMs < 1) { tmpToMs = tmpFromMs + 1; }
	// Pad the right edge by 5% so the rightmost bar isn't pinned to the
	// boundary.
	tmpToMs = tmpFromMs + Math.ceil((tmpToMs - tmpFromMs) * 1.05);

	let tmpPlot = {
		x0: PADDING_LEFT,
		x1: tmpCSSWidth - PADDING_RIGHT,
		y0: PADDING_TOP,
		y1: tmpCSSHeight - PADDING_BOT,
		fromMs: tmpFromMs,
		toMs:   tmpToMs
	};
	tmpPlot.width = tmpPlot.x1 - tmpPlot.x0;

	_drawTimeAxis(tmpCtx, tmpPlot, tmpCSSWidth);

	// Compute critical path through the operation graph (or by
	// dependency-by-overlap if no graph is available).
	let tmpCriticalSet = _computeCriticalPath(tmpTasks, pState.Operation);

	for (let i = 0; i < tmpTasks.length; i++)
	{
		let tmpY = tmpPlot.y0 + i * (ROW_HEIGHT + ROW_GAP);
		_drawTaskRow(tmpCtx, tmpPlot, tmpY, tmpTasks[i], tmpCriticalSet, tmpCSSWidth);
	}
}

// ─────────────────────────────────────────────────────────────────────
// Task row construction
// ─────────────────────────────────────────────────────────────────────

function _buildTaskRows(pState)
{
	// Group records by WorkItemHash (each task = one work item).
	// For each group, pick At = min, EndAt = max, Capability + Status from
	// the latest record. Records without WorkItemHash are skipped (e.g.
	// Run.Started, Run.Completed envelopes that span the whole run).
	let tmpRecords = (pState && pState.Records) || [];
	let tmpGroups = new Map();

	for (let i = 0; i < tmpRecords.length; i++)
	{
		let tmpR = tmpRecords[i];
		if (!tmpR || !tmpR.WorkItemHash) continue;
		let tmpKey = tmpR.WorkItemHash;
		let tmpAt    = Date.parse(tmpR.At);
		let tmpEndAt = Date.parse(tmpR.EndAt);
		if (!Number.isFinite(tmpAt)) continue;
		if (!Number.isFinite(tmpEndAt)) tmpEndAt = tmpAt;

		let tmpExisting = tmpGroups.get(tmpKey);
		if (!tmpExisting)
		{
			tmpExisting =
			{
				WorkItemHash: tmpKey,
				NodeHash:    tmpR.NodeHash || _deriveNodeHash(tmpR),
				Capability:  tmpR.Capability || '',
				BeaconID:    tmpR.BeaconID || '',
				Status:      '',
				At:          tmpAt,
				EndAt:       tmpEndAt,
				LastRecord:  tmpR,
				LastAt:      tmpAt
			};
			tmpGroups.set(tmpKey, tmpExisting);
		}
		else
		{
			if (tmpAt    < tmpExisting.At)    tmpExisting.At    = tmpAt;
			if (tmpEndAt > tmpExisting.EndAt) tmpExisting.EndAt = tmpEndAt;
		}
		// Capture the freshest non-empty fields.
		if (tmpAt >= tmpExisting.LastAt)
		{
			tmpExisting.LastAt = tmpAt;
			tmpExisting.LastRecord = tmpR;
			if (tmpR.Status) { tmpExisting.Status = tmpR.Status; }
			if (tmpR.Capability) { tmpExisting.Capability = tmpR.Capability; }
			if (tmpR.BeaconID) { tmpExisting.BeaconID = tmpR.BeaconID; }
		}
	}

	let tmpRows = Array.from(tmpGroups.values());
	tmpRows.sort(function (pA, pB) { return pA.At - pB.At; });
	for (let i = 0; i < tmpRows.length; i++)
	{
		tmpRows[i].DurationMs = tmpRows[i].EndAt - tmpRows[i].At;
	}
	return tmpRows;
}

// Some Phase 5 envelopes carry NodeHash inside the raw payload but the
// projector flattens it as part of WorkItemHash. We try a few fallbacks
// to surface a useful per-row label.
function _deriveNodeHash(pRecord)
{
	if (pRecord.NodeHash) return pRecord.NodeHash;
	if (pRecord.WorkItemHash)
	{
		// Common shape: <runHash>::<nodeHash>
		let tmpIdx = pRecord.WorkItemHash.indexOf('::');
		if (tmpIdx >= 0) return pRecord.WorkItemHash.slice(tmpIdx + 2);
	}
	return pRecord.WorkItemHash || '';
}

// ─────────────────────────────────────────────────────────────────────
// Critical path
// ─────────────────────────────────────────────────────────────────────

function _computeCriticalPath(pTasks, pOperation)
{
	// If we have an operation graph, use it to find the longest dependency
	// chain by total duration. Otherwise, fall back to the longest "chain
	// by time overlap" heuristic — a task whose EndAt is followed by a
	// task whose At is within 50ms is considered the predecessor.
	let tmpOut = new Set();
	if (pTasks.length === 0) return tmpOut;

	let tmpByNode = new Map();
	for (let i = 0; i < pTasks.length; i++)
	{
		let tmpKey = pTasks[i].NodeHash || pTasks[i].WorkItemHash;
		if (!tmpByNode.has(tmpKey)) { tmpByNode.set(tmpKey, pTasks[i]); }
	}

	// Build a successor map.
	let tmpSuccs = new Map();
	let tmpPreds = new Map();
	let tmpHasGraph = pOperation && pOperation.Graph
		&& Array.isArray(pOperation.Graph.Connections)
		&& pOperation.Graph.Connections.length > 0;

	if (tmpHasGraph)
	{
		let tmpConns = pOperation.Graph.Connections;
		for (let i = 0; i < tmpConns.length; i++)
		{
			let tmpC = tmpConns[i];
			if (!tmpC || !tmpC.SourceNodeHash || !tmpC.TargetNodeHash) continue;
			let tmpFrom = tmpC.SourceNodeHash;
			let tmpTo   = tmpC.TargetNodeHash;
			if (!tmpSuccs.has(tmpFrom)) { tmpSuccs.set(tmpFrom, []); }
			tmpSuccs.get(tmpFrom).push(tmpTo);
			if (!tmpPreds.has(tmpTo)) { tmpPreds.set(tmpTo, []); }
			tmpPreds.get(tmpTo).push(tmpFrom);
		}
	}
	else
	{
		// Heuristic: a task's predecessor is the latest task that ends
		// at or before its At, within 200ms.
		let tmpSorted = pTasks.slice().sort(function (pA, pB) { return pA.At - pB.At; });
		for (let i = 1; i < tmpSorted.length; i++)
		{
			let tmpThis = tmpSorted[i];
			for (let j = i - 1; j >= 0; j--)
			{
				let tmpPrev = tmpSorted[j];
				if (tmpPrev.EndAt <= tmpThis.At + 200)
				{
					let tmpThisKey = tmpThis.NodeHash || tmpThis.WorkItemHash;
					let tmpPrevKey = tmpPrev.NodeHash || tmpPrev.WorkItemHash;
					if (!tmpPreds.has(tmpThisKey)) { tmpPreds.set(tmpThisKey, []); }
					tmpPreds.get(tmpThisKey).push(tmpPrevKey);
					if (!tmpSuccs.has(tmpPrevKey)) { tmpSuccs.set(tmpPrevKey, []); }
					tmpSuccs.get(tmpPrevKey).push(tmpThisKey);
					break;
				}
			}
		}
	}

	// Longest path by accumulated duration ending at each task.
	let tmpDist = new Map();
	let tmpFrom = new Map();
	let tmpVisited = new Map();

	let fLongest = function (pKey)
	{
		if (tmpDist.has(pKey)) return tmpDist.get(pKey);
		if (tmpVisited.get(pKey)) return 0; // cycle guard
		tmpVisited.set(pKey, true);
		let tmpTask = tmpByNode.get(pKey);
		let tmpDur = tmpTask ? tmpTask.DurationMs : 0;
		let tmpPredList = tmpPreds.get(pKey) || [];
		let tmpBest = 0;
		let tmpBestPred = null;
		for (let i = 0; i < tmpPredList.length; i++)
		{
			let tmpD = fLongest(tmpPredList[i]);
			if (tmpD > tmpBest) { tmpBest = tmpD; tmpBestPred = tmpPredList[i]; }
		}
		let tmpTotal = tmpBest + tmpDur;
		tmpDist.set(pKey, tmpTotal);
		if (tmpBestPred) { tmpFrom.set(pKey, tmpBestPred); }
		return tmpTotal;
	};

	let tmpEnd = null;
	let tmpEndDist = -1;
	for (let i = 0; i < pTasks.length; i++)
	{
		let tmpKey = pTasks[i].NodeHash || pTasks[i].WorkItemHash;
		let tmpD = fLongest(tmpKey);
		if (tmpD > tmpEndDist) { tmpEndDist = tmpD; tmpEnd = tmpKey; }
	}

	// Walk back from end through tmpFrom to mark the critical chain.
	let tmpCursor = tmpEnd;
	let tmpGuard = pTasks.length + 5;
	while (tmpCursor && tmpGuard-- > 0)
	{
		tmpOut.add(tmpCursor);
		tmpCursor = tmpFrom.get(tmpCursor);
	}
	return tmpOut;
}

// ─────────────────────────────────────────────────────────────────────
// Drawing
// ─────────────────────────────────────────────────────────────────────

function _drawTimeAxis(pCtx, pPlot, pCSSWidth)
{
	let tmpSpan = pPlot.toMs - pPlot.fromMs;
	let tmpSteps = [10, 50, 100, 250, 500, 1000, 2000, 5000, 10000, 30000, 60000, 300000, 1800000];
	let tmpStep = tmpSteps[0];
	for (let i = 0; i < tmpSteps.length; i++)
	{
		if (tmpSpan / tmpSteps[i] <= 8)
		{
			tmpStep = tmpSteps[i];
			break;
		}
		tmpStep = tmpSteps[i];
	}
	pCtx.fillStyle = 'rgba(180, 180, 180, 0.7)';
	pCtx.font = '10px -apple-system, BlinkMacSystemFont, sans-serif';
	pCtx.textBaseline = 'top';
	pCtx.textAlign = 'center';
	pCtx.strokeStyle = 'rgba(180, 180, 180, 0.10)';
	pCtx.lineWidth = 1;
	for (let t = 0; t <= tmpSpan; t += tmpStep)
	{
		let tmpX = pPlot.x0 + (t / tmpSpan) * pPlot.width;
		pCtx.beginPath();
		pCtx.moveTo(tmpX, pPlot.y0);
		pCtx.lineTo(tmpX, pPlot.y1);
		pCtx.stroke();
		pCtx.fillText(_formatDuration(t), tmpX, 4);
	}
	// Header line — runHash + start time.
	pCtx.fillStyle = 'rgba(200, 200, 200, 0.6)';
	pCtx.font = '600 11px -apple-system, sans-serif';
	pCtx.textAlign = 'left';
	let tmpStartLabel = new Date(pPlot.fromMs).toISOString().slice(11, 19) + ' UTC';
	pCtx.fillText('t₀ = ' + tmpStartLabel, 8, 4);
	pCtx.textAlign = 'right';
	pCtx.fillText('Δ = ' + _formatDuration(tmpSpan), pCSSWidth - 8, 4);
}

function _drawTaskRow(pCtx, pPlot, pY, pTask, pCriticalSet, pCSSWidth)
{
	let tmpKey = pTask.NodeHash || pTask.WorkItemHash;
	let tmpIsCritical = pCriticalSet.has(tmpKey);

	// Row bg banded for legibility.
	pCtx.fillStyle = tmpIsCritical ? 'rgba(251, 191, 36, 0.06)' : 'rgba(180, 180, 180, 0.025)';
	pCtx.fillRect(0, pY, pCSSWidth, ROW_HEIGHT);

	// Label (node hash, capability hint).
	pCtx.fillStyle = 'rgba(220, 220, 220, 0.92)';
	pCtx.font = '11px -apple-system, sans-serif';
	pCtx.textBaseline = 'middle';
	pCtx.textAlign = 'left';
	let tmpLabel = pTask.NodeHash || _shortHash(pTask.WorkItemHash);
	if (tmpLabel.length > 22) { tmpLabel = tmpLabel.slice(0, 21) + '…'; }
	pCtx.fillText(tmpLabel, 8, pY + ROW_HEIGHT / 2);

	pCtx.fillStyle = 'rgba(160, 160, 160, 0.7)';
	pCtx.font = '10px -apple-system, sans-serif';
	let tmpCapLabel = pTask.Capability || '—';
	pCtx.fillText(tmpCapLabel, 8 + 130, pY + ROW_HEIGHT / 2);

	// Bar.
	let tmpX0 = _msToX(pTask.At, pPlot);
	let tmpX1 = _msToX(pTask.EndAt, pPlot);
	if (tmpX1 - tmpX0 < 2) { tmpX1 = tmpX0 + 2; }
	let tmpColor = _statusColor(pTask.Status || (pTask.LastRecord && pTask.LastRecord.EventType));
	pCtx.fillStyle = tmpColor.fill;
	pCtx.fillRect(tmpX0, pY + 3, tmpX1 - tmpX0, ROW_HEIGHT - 6);
	pCtx.strokeStyle = tmpIsCritical ? '#fbbf24' : tmpColor.stroke;
	pCtx.lineWidth = tmpIsCritical ? 1.5 : 0.75;
	pCtx.strokeRect(tmpX0, pY + 3, tmpX1 - tmpX0, ROW_HEIGHT - 6);

	// Duration label after the bar.
	pCtx.fillStyle = 'rgba(200, 200, 200, 0.75)';
	pCtx.font = '600 10px monospace';
	pCtx.textAlign = 'left';
	pCtx.fillText(_formatDuration(pTask.DurationMs), Math.min(tmpX1 + 6, pPlot.x1 + 4), pY + ROW_HEIGHT / 2);
}

function _drawEmpty(pCtx, pW, pH)
{
	pCtx.fillStyle = 'rgba(150, 150, 150, 0.55)';
	pCtx.font = '12px -apple-system, sans-serif';
	pCtx.textAlign = 'center';
	pCtx.textBaseline = 'middle';
	pCtx.fillText('No work-item events for this run yet.', pW / 2, pH / 2);
}

// ─────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────

function _msToX(pMs, pPlot)
{
	let tmpFrac = (pMs - pPlot.fromMs) / (pPlot.toMs - pPlot.fromMs);
	if (tmpFrac < 0) tmpFrac = 0;
	if (tmpFrac > 1) tmpFrac = 1;
	return pPlot.x0 + tmpFrac * pPlot.width;
}

function _statusColor(pStatusOrType)
{
	if (!pStatusOrType) return DEFAULT_COLOR;
	return STATUS_COLORS[pStatusOrType] || DEFAULT_COLOR;
}

function _formatDuration(pMs)
{
	if (!Number.isFinite(pMs) || pMs < 0) return '0ms';
	if (pMs < 1000)   return pMs + 'ms';
	if (pMs < 60000)  return (pMs / 1000).toFixed(1) + 's';
	let tmpMin = Math.floor(pMs / 60000);
	let tmpSec = Math.floor((pMs - tmpMin * 60000) / 1000);
	return tmpMin + 'm' + (tmpSec < 10 ? '0' : '') + tmpSec + 's';
}

function _shortHash(pStr)
{
	if (!pStr) return '';
	if (pStr.length <= 24) return pStr;
	return pStr.slice(0, 8) + '…' + pStr.slice(-8);
}

module.exports =
{
	drawWaterfall: drawWaterfall,
	buildTaskRows: _buildTaskRows
};

},{}],286:[function(require,module,exports){
/**
 * url-state.js
 *
 * Read / write the timeline view's URL params. Pict's PictRouter
 * handles route paths but not query strings, so we parse window.location
 * directly. Resolves relative time specs (now, now-2m, now+30s) against
 * the user's clock; the server resolves the same form against its own
 * clock, and a minor skew shows up in the response's `Now` field.
 *
 * Recognized params:
 *   from      ISO or relative   (default: 'now-2m')
 *   to        ISO or relative   (default: 'now+30s')
 *   mode      'live' | 'replay' (default: 'live')
 *   focus     'runHash:abc' / 'capability:Loader' / 'beacon:bcn-xyz' / null
 *   bucket    'auto' | 'raw' | '<duration>' (default: 'auto')
 */

function read()
{
	let tmpParams = {};
	let tmpQuery = (typeof window !== 'undefined' && window.location.search) || '';
	if (tmpQuery.charAt(0) === '?') { tmpQuery = tmpQuery.slice(1); }
	let tmpPairs = tmpQuery.split('&');
	for (let i = 0; i < tmpPairs.length; i++)
	{
		if (!tmpPairs[i]) continue;
		let tmpEq = tmpPairs[i].indexOf('=');
		let tmpK, tmpV;
		if (tmpEq < 0) { tmpK = tmpPairs[i]; tmpV = ''; }
		else { tmpK = tmpPairs[i].slice(0, tmpEq); tmpV = tmpPairs[i].slice(tmpEq + 1); }
		try { tmpK = decodeURIComponent(tmpK); } catch (pErr) { /* leave raw */ }
		try { tmpV = decodeURIComponent(tmpV); } catch (pErr) { /* leave raw */ }
		tmpParams[tmpK] = tmpV;
	}

	let tmpState =
	{
		FromIso: tmpParams.from   || 'now-2m',
		ToIso:   tmpParams.to     || 'now+30s',
		Mode:    tmpParams.mode   || 'live',
		Bucket:  tmpParams.bucket || 'auto',
		Focus:   null
	};

	if (tmpParams.focus)
	{
		let tmpColon = tmpParams.focus.indexOf(':');
		if (tmpColon > 0)
		{
			tmpState.Focus =
			{
				Kind: tmpParams.focus.slice(0, tmpColon),
				Hash: tmpParams.focus.slice(tmpColon + 1)
			};
		}
	}

	// Light validation.
	if (tmpState.Mode !== 'live' && tmpState.Mode !== 'replay')
	{
		tmpState.Mode = 'live';
	}

	return tmpState;
}

function write(pState)
{
	if (typeof window === 'undefined') return;
	let tmpParams = [];
	if (pState.FromIso) tmpParams.push('from=' + encodeURIComponent(pState.FromIso));
	if (pState.ToIso)   tmpParams.push('to=' + encodeURIComponent(pState.ToIso));
	if (pState.Mode)    tmpParams.push('mode=' + encodeURIComponent(pState.Mode));
	if (pState.Bucket && pState.Bucket !== 'auto') tmpParams.push('bucket=' + encodeURIComponent(pState.Bucket));
	if (pState.Focus && pState.Focus.Kind && pState.Focus.Hash)
	{
		tmpParams.push('focus=' + encodeURIComponent(pState.Focus.Kind + ':' + pState.Focus.Hash));
	}
	let tmpHash = window.location.hash || '';
	let tmpNewURL = window.location.pathname + (tmpParams.length > 0 ? ('?' + tmpParams.join('&')) : '') + tmpHash;
	try
	{
		window.history.replaceState({}, '', tmpNewURL);
	}
	catch (pErr) { /* best effort */ }
}

// Resolve "now", "now-2m", "now+30s", "now-1h", "now-7d", or an ISO
// string. Mirrors the server's _resolveRelativeTime so the client can
// match what the endpoint will pick.
function resolveTime(pSpec, pNowMs)
{
	if (!pSpec) return null;
	let tmpStr = String(pSpec).trim();
	let tmpNow = (typeof pNowMs === 'number') ? pNowMs : Date.now();
	if (tmpStr === 'now') return new Date(tmpNow).toISOString();
	let tmpMatch = tmpStr.match(/^now\s*([+-])\s*(\d+)\s*([smhd])?$/i);
	if (tmpMatch)
	{
		let tmpSign = tmpMatch[1] === '-' ? -1 : 1;
		let tmpVal = parseInt(tmpMatch[2], 10);
		let tmpUnit = (tmpMatch[3] || 's').toLowerCase();
		let tmpMul = tmpUnit === 'd' ? 86400000
			: tmpUnit === 'h' ? 3600000
			: tmpUnit === 'm' ? 60000
			: 1000;
		return new Date(tmpNow + tmpSign * tmpVal * tmpMul).toISOString();
	}
	let tmpParsed = Date.parse(tmpStr);
	if (Number.isFinite(tmpParsed)) return new Date(tmpParsed).toISOString();
	return null;
}

module.exports =
{
	read:        read,
	write:       write,
	resolveTime: resolveTime
};

},{}]},{},[242])(242)
});

